angular.module("APP_MODEL_CONFIG", [])
.constant("APP_CONFIG", {
  "apiBuildUrl": "http://adp:3003",
  "apiPrefix": "/api",
  "resourcePrefix": "/api",
  "showClsCsrInUserMenu": true,
  "removeTestAttributes": false,
  "debug": true,
  "allowPerformanceMonitor": false,
  "serverBaseUrl": "https://sherpa-dev3.411labs.net",
  "appSuffix": "",
  "apiUrl": "https://sherpa-dev3.411labs.net/api",
  "resourceUrl": "https://sherpa-dev3.411labs.net/api",
  "inactivityLogoutPollingInterval": 5000,
  "inactivityLogoutNotificationAppearsFromSessionEnd": 300000,
  "inactivityLogoutFePingInterval": 1100000,
  "isInactivityLogoutEnabled": true,
  "dataExportInstantDownloadTimeout": 3000,
  "hideErrorMessagesAfterLogoutIn": 5000,
  "jwtAccessTokenRefreshBeforeExpire": 30000,
  "loginCaptchaEnabled": false,
  "signupCaptchaEnabled": false,
  "reCaptchaKey": "6LfnYi4dAAAAAH1HjMu_qDJ8qTxwVVW6tJp2kmyB",
  "googleApiKey": "AIzaSyDJotQYsFwrmY_mSLyEPiKNcquY3ghk0ts",
  "mapboxToken": "pk.eyJ1IjoiY3JhZnR1cyIsImEiOiJjbGZ1MHZ6eHUwNjhoM3NucmZ5bDA4MmZoIn0.ae56lBWXOR1JwE8vJCrWfA",
  "publishedEndpointPrefix": "/embed"
});
;// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read http://bit.ly/CRA-PWA.

function serviceWorkerManager() {
  var workerPath = '';

  var isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );

  /**
   *
   * @param {Object} config
   * @callback {Object} config.onUpdate
   * @callback {Object} config.onSuccess
   */
  function register(config) {
    if ('serviceWorker' in navigator) {
      // The URL constructor is available in all browsers that support SW.
      var publicUrl = new URL(workerPath, window.location);

      if (publicUrl.origin !== window.location.origin) {
        // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
      }

      window.addEventListener('load', function () {
        var swUrl = workerPath + '/service-worker.js';

        if (isLocalhost) {
          // This is running on localhost. Let's check if a service worker still exists or not.
          _checkValidServiceWorker(swUrl, config);

          // Add some additional logging to localhost, pointing developers to the
          // service worker/PWA documentation.
          navigator.serviceWorker.ready.then(function () {
            console.log(
              'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit http://bit.ly/CRA-PWA'
            );
          });
        } else {
          // Is not localhost. Just register service worker
          _registerValidSW(swUrl, config);
        }
      });
    }
  }

  function unregister() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(function (registration) {
        registration.unregister();
      });
    }
  }

  /**
   *
   * @param {string} swUrl
   * @param {Object} config
   * @callback {Object} config.onUpdate
   * @callback {Object} config.onSuccess
   */
  function _registerValidSW(swUrl, config) {
    navigator.serviceWorker
      .register(swUrl)
      .then(function (registration) {
        registration.onupdatefound = function () {
          var installingWorker = registration.installing;

          installingWorker.onstatechange = function () {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the updated precached content has been fetched,
                // but the previous service worker will still serve the older
                // content until all client tabs are closed.
                console.log(
                  'New content is available and will be used when all ' +
                  'tabs for this page are closed. See http://bit.ly/CRA-PWA.'
                );

                // Execute callback
                if (config && config.onUpdate) {
                  config.onUpdate(registration);
                }
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.');

                // Execute callback
                if (config && config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }

          };
        }
      })
      .catch(function (error) {
        console.error('Error during service worker registration:', error);
      });
  }

  /**
   *
   * @param {string} swUrl
   * @param {Object} config
   * @callback {Object} config.onUpdate
   * @callback {Object} config.onSuccess
   */
  function _checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
      .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (
          response.status === 404 ||
          response.headers.get('content-type').indexOf('javascript') === -1
        ) {
          console.log(
            'Service worker file not found.'
          );

          // No service worker found. Probably a different app. Reload the page.
          // fires only, when there is SW already registered
          navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister().then(function () {
              window.location.reload();
            });
          });
        } else {
          // Service worker found. Proceed as normal.
          _registerValidSW(swUrl, config);
        }
      })
      .catch(function () {
        console.log(
          'No internet connection found. App is running in offline mode.'
        );
      });
  }


  return {
    register: register,
    unregister: unregister
  };
}

var sw = serviceWorkerManager();

if (false) {
  sw.register();
} else {
  sw.unregister();
}
;'use strict';



var appConfig = window.appConfig || {};

appConfig.menu_speed = 200;

appConfig.smartSkin = "smart-style-0";

appConfig.skins = [
    {name: "smart-style-0",
        logo: "http://via.placeholder.com/140x35",
        class: "btn btn-block btn-xs txt-color-white margin-right-5",
        style: "background-color:#4E463F;",
        label: "Smart Default"},

    {name: "smart-style-1",
        logo: "assets/img/logo-white.png",
        class: "btn btn-block btn-xs txt-color-white",
        style: "background:#3A4558;",
        label: "Dark Elegance"},

    {name: "smart-style-2",
        logo: "assets/img/logo-blue.png",
        class: "btn btn-xs btn-block txt-color-darken margin-top-5",
        style: "background:#fff;",
        label: "Ultra Light"},

    {name: "smart-style-3",
        logo: "assets/img/logo-pale.png",
        class: "btn btn-xs btn-block txt-color-white margin-top-5",
        style: "background:#f78c40",
        label: "Google Skin"},

    {name: "smart-style-4",
        logo: "assets/img/logo-pale.png",
        class: "btn btn-xs btn-block txt-color-white margin-top-5",
        style: "background: #bbc0cf; border: 1px solid #59779E; color: #17273D !important;",
        label: "PixelSmash"},

    {name: "smart-style-5",
        logo: "assets/img/logo-pale.png",
        class: "btn btn-xs btn-block txt-color-white margin-top-5",
        style: "background: rgba(153, 179, 204, 0.2); border: 1px solid rgba(121, 161, 221, 0.8); color: #17273D !important;",
        label: "Glass"},

    {name: "smart-style-6",
        logo: "assets/img/logo-pale.png",
        class: "btn btn-xs btn-block txt-color-white margin-top-5",
        style: "background: #2196F3; border: 1px solid rgba(121, 161, 221, 0.8); color: #FFF !important;",
        beta: true,
        label: "MaterialDesign"
    }


];



appConfig.sound_path = "/assets/sound/";
appConfig.sound_on = true;


/*
* DEBUGGING MODE
* debugState = true; will spit all debuging message inside browser console.
* The colors are best displayed in chrome browser.
*/


appConfig.debugState = false;
appConfig.debugStyle = 'font-weight: bold; color: #00f;';
appConfig.debugStyle_green = 'font-weight: bold; font-style:italic; color: #46C246;';
appConfig.debugStyle_red = 'font-weight: bold; color: #ed1c24;';
appConfig.debugStyle_warning = 'background-color:yellow';
appConfig.debugStyle_success = 'background-color:green; font-weight:bold; color:#fff;';
appConfig.debugStyle_error = 'background-color:#ed1c24; font-weight:bold; color:#fff;';


appConfig.voice_command = true;
appConfig.voice_command_auto = false;

/*
 *  Sets the language to the default 'en-US'. (supports over 50 languages
 *  by google)
 *
 *  Afrikaans         ['af-ZA']
 *  Bahasa Indonesia  ['id-ID']
 *  Bahasa Melayu     ['ms-MY']
 *  CatalГ            ['ca-ES']
 *  ДЊeЕЎtina         ['cs-CZ']
 *  Deutsch           ['de-DE']
 *  English           ['en-AU', 'Australia']
 *                    ['en-CA', 'Canada']
 *                    ['en-IN', 'India']
 *                    ['en-NZ', 'New Zealand']
 *                    ['en-ZA', 'South Africa']
 *                    ['en-GB', 'United Kingdom']
 *                    ['en-US', 'United States']
 *  EspaГ±ol          ['es-AR', 'Argentina']
 *                    ['es-BO', 'Bolivia']
 *                    ['es-CL', 'Chile']
 *                    ['es-CO', 'Colombia']
 *                    ['es-CR', 'Costa Rica']
 *                    ['es-EC', 'Ecuador']
 *                    ['es-SV', 'El Salvador']
 *                    ['es-ES', 'EspaГ±a']
 *                    ['es-US', 'Estados Unidos']
 *                    ['es-GT', 'Guatemala']
 *                    ['es-HN', 'Honduras']
 *                    ['es-MX', 'MГ©xico']
 *                    ['es-NI', 'Nicaragua']
 *                    ['es-PA', 'PanamГЎ']
 *                    ['es-PY', 'Paraguay']
 *                    ['es-PE', 'PerГє']
 *                    ['es-PR', 'Puerto Rico']
 *                    ['es-DO', 'RepГєblica Dominicana']
 *                    ['es-UY', 'Uruguay']
 *                    ['es-VE', 'Venezuela']
 *  Euskara           ['eu-ES']
 *  FranГ§ais         ['fr-FR']
 *  Galego            ['gl-ES']
 *  Hrvatski          ['hr_HR']
 *  IsiZulu           ['zu-ZA']
 *  ГЌslenska         ['is-IS']
 *  Italiano          ['it-IT', 'Italia']
 *                    ['it-CH', 'Svizzera']
 *  Magyar            ['hu-HU']
 *  Nederlands        ['nl-NL']
 *  Norsk bokmГҐl     ['nb-NO']
 *  Polski            ['pl-PL']
 *  PortuguГЄs        ['pt-BR', 'Brasil']
 *                    ['pt-PT', 'Portugal']
 *  RomГўnДѓ          ['ro-RO']
 *  SlovenДЌina       ['sk-SK']
 *  Suomi             ['fi-FI']
 *  Svenska           ['sv-SE']
 *  TГјrkГ§e          ['tr-TR']
 *  Р±СЉР»РіР°СЂСЃРєРё['bg-BG']
 *  PСѓСЃСЃРєРёР№     ['ru-RU']
 *  РЎСЂРїСЃРєРё      ['sr-RS']
 *  н•њкµ­м–ґ         ['ko-KR']
 *  дё­ж–‡            ['cmn-Hans-CN', 'ж™®йЂљиЇќ (дё­е›Ѕе¤§й™†)']
 *                    ['cmn-Hans-HK', 'ж™®йЂљиЇќ (й¦™жёЇ)']
 *                    ['cmn-Hant-TW', 'дё­ж–‡ (еЏ°зЃЈ)']
 *                    ['yue-Hant-HK', 'зІµиЄћ (й¦™жёЇ)']
 *  ж—Ґжњ¬иЄћ         ['ja-JP']
 *  Lingua latД«na    ['la']
 */
appConfig.voice_command_lang = 'en-US';
/*
 *  Use localstorage to remember on/off (best used with HTML Version)
 */
appConfig.voice_localStorage = false;
/*
 * Voice Commands
 * Defines all voice command variables and functions
 */
if (appConfig.voice_command) {

     	appConfig.commands = {

        'show dashboard' : function() { window.location.hash = "dashboard" },
        'show inbox' : function() {  window.location.hash = "inbox/" },
        'show graphs' : function() {  window.location.hash = "graphs/flot" },
        'show flotchart' : function() { window.location.hash = "graphs/flot" },
        'show morris chart' : function() { window.location.hash = "graphs/morris" },
        'show inline chart' : function() { window.location.hash = "graphs/inline-charts" },
        'show dygraphs' : function() { window.location.hash = "graphs/dygraphs" },
        'show tables' : function() { window.location.hash = "tables/table" },
        'show data table' : function() { window.location.hash = "tables/datatable" },
        'show jquery grid' : function() { window.location.hash = "tables/jqgrid" },
        'show form' : function() { window.location.hash = "forms/form-elements" },
        'show form layouts' : function() { window.location.hash = "forms/form-templates" },
        'show form validation' : function() { window.location.hash = "forms/validation" },
        'show form elements' : function() { window.location.hash = "forms/bootstrap-forms" },
        'show form plugins' : function() { window.location.hash = "forms/plugins" },
        'show form wizards' : function() { window.location.hash = "forms/wizards" },
        'show bootstrap editor' : function() { window.location.hash = "forms/other-editors" },
        'show dropzone' : function() { window.location.hash = "forms/dropzone" },
        'show image cropping' : function() { window.location.hash = "forms/image-editor" },
        'show general elements' : function() { window.location.hash = "ui/general-elements" },
        'show buttons' : function() { window.location.hash = "ui/buttons" },
        'show fontawesome' : function() { window.location.hash = "ui/icons/fa" },
        'show glyph icons' : function() { window.location.hash = "ui/icons/glyph" },
        'show flags' : function() { window.location.hash = "ui/icons/flags" },
        'show grid' : function() { window.location.hash = "ui/grid" },
        'show tree view' : function() { window.location.hash = "ui/treeview" },
        'show nestable lists' : function() { window.location.hash = "ui/nestable-list" },
        'show jquery U I' : function() { window.location.hash = "ui/jqui" },
        'show typography' : function() { window.location.hash = "ui/typography" },
        'show calendar' : function() { window.location.hash = "calendar" },
        'show widgets' : function() { window.location.hash = "widgets" },
        'show gallery' : function() { window.location.hash = "gallery" },
        'show maps' : function() { window.location.hash = "gmap-xml" },
        'go back' :  function() { history.back(1); },
        'scroll up' : function () { $('html, body').animate({ scrollTop: 0 }, 100); },
        'scroll down' : function () { $('html, body').animate({ scrollTop: $(document).height() }, 100);},
        'hide navigation' : function() {
            if ($( ":root" ).hasClass("container") && !$( ":root" ).hasClass("menu-on-top")){
                $('span.minifyme').trigger("click");
            } else {
                $('#hide-menu > span > a').trigger("click");
            }
        },
        'show navigation' : function() {
            if ($( ":root" ).hasClass("container") && !$( ":root" ).hasClass("menu-on-top")){
                $('span.minifyme').trigger("click");
            } else {
                $('#hide-menu > span > a').trigger("click");
            }
        },
        'mute' : function() {
            appConfig.sound_on = false;
            toastr.success("All sounds have been muted!", "MUTE");
        },
        'sound on' : function() {
            appConfig.sound_on = true;
            $.speechApp.playConfirmation();
            toastr.success("All sounds have been turned on!","UNMUTE");
        },
        'stop' : function() {
            smartSpeechRecognition.abort();
            $( ":root" ).removeClass("voice-command-active");
            toastr.success(
              "Your voice commands has been successfully turned off. Click on the <i class='fa fa-microphone fa-lg fa-fw'></i> icon to turn it back on.",
              "VOICE COMMAND OFF"
            );
            if ($('#speech-btn .popover').is(':visible')) {
                $('#speech-btn .popover').fadeOut(250);
            }
        },
        'help' : function() {

            $('#voiceModal').removeData('modal').modal( { remote: "app/adp-layout/partials/voice-commands.tpl.html", show: true } );
            if ($('#speech-btn .popover').is(':visible')) {
                $('#speech-btn .popover').fadeOut(250);
            }

        },
        'got it' : function() {
            $('#voiceModal').modal('hide');
        },
        'logout' : function() {
            $.speechApp.stop();
            window.location = $('#logout > span > a').attr("href");
        }
    };
}

appConfig.apiRootUrl = 'api';

window.appConfig = appConfig;

/*
* END APP.appConfig
*/
;;(function (window) {
  window.adpRenderLib = {
    getTemplate: getTemplate,
    getElementById: getElementById,
    getInterface: getInterface,
    getAppConfig: getAppConfig,
    fetch: makeRequest
  };

  /**
   * @description
   * Return compiled by lodash html template string.
   *
   * @param {String} template - ejs template
   * @param {Object} templateData
   *
   * @return {String} - compiled html string
   */
  function getTemplate(template, templateData) {
    return ejs.render(template, templateData);
  }

  /**
   * @return application interface config
   */
  function getInterface() {
    return window.adpAppStore.appInterface();
  }

  /**
   * @return application interface config
   */
  function getAppConfig() {
    return angular.injector(['APP_MODEL_CONFIG']).get('APP_CONFIG');
  }

  /**
   ** @description
   * Wrapper function for window.fetch
   *
   * @param {String} endpoint
   * @return {Promise}
   */
  function makeRequest(endpoint) {
    var appConfig = getAppConfig();
    var requestUrl = [appConfig.apiUrl, endpoint].join('/');
    var interfaceConfig = this.getInterface();
    var token = window.localStorage.getItem(interfaceConfig.name + '.token');
    var config = {
      headers: {},
      credentials : 'include'
    };

    if (token) {
      config.headers.Authorization = 'JWT ' + token;
    }

    return fetch(requestUrl, config);
  }

  /**
   * @description
   * Get element by id. Return adpElement instance.
   *
   * @param {String} id is not a selector, id hash will throw error
   * @return {Element}
   */
  function getElementById(id) {
    return adpElement.fn.init(id)
  }

  /**
   * @description
   * Represents DOM element. Provides fluid API to manipulate with DOM elements.
   *
   * @constructor
   * @param {String} id is not a selector, id hash will throw error
   */
  function adpElement(id) {
    this.el = document.getElementById(id);
  }

  adpElement.fn = adpElement.prototype = {
    constructor: adpElement,

    /**
     * @description
     * The real initialization of adpElement.
     *
     * @param {String} id is not a selector, id hash will throw error
     */
    init: function (id) {
      if (!id) {
        return this;
      }

      return new this.constructor(id);
    },

    /**
     * @description
     * Set text to element of adpElement instance.
     *
     * @param value
     * @return {adpElement}
     */
    setValue: function (value) {
      this.el.innerText = value;
      return this;
    }
  }
})(window);
;window.lsService = (function () {
  var PREFIX = 'ls';
  var itemName = function (n) {
    return [PREFIX, n].join('.');
  };

  function _set(n, v) {
    try {
      localStorage.setItem(itemName(n), v);
    } catch (e) {}
  }

  function _remove(n) {
    try {
      localStorage.removeItem(itemName(n));
    } catch (e) {}
  }

  function _get(n) {
    try {
      return localStorage.getItem(itemName(n));
    } catch(e) {
      return null;
    }
  }

  function setUserData(data) {
    _set('expTime', data.expiresIn);
    setUser(data.user);
    _set('token', data.token);
  }

  function setUser(user) {
    _set('user', JSON.stringify(user));
  }

  function removeUserData() {
    _remove('expTime');
    _remove('user');
    _remove('token');
  }

  function setGuestUserData() {
    var data = {
      user: {'login': 'Guest', isGuest: true},
      // must be empty
      token: '',
      expTime: ''
    };

    setUserData(data);
  }

  function isGuest() {
    var user = getUser();

    if (_.isNull(user)) {
      return true;
    }

    return Boolean(user.isGuest);
  }

  function getUser() {
    try {
      return JSON.parse(_get('user'));
    } catch (e) {
      setGuestUserData();
      return JSON.parse(_get('user'));
    }
  }

  function getToken() {
    return _get('token');
  }

  function getTokenExpire() {
    return _get('expTime');
  }

  function clear() {
    try {
    localStorage.clear();
    } catch(e) {}
  }

  return {
    setUserData,
    removeUserData,
    setGuestUserData,
    getUser,
    setUser,
    getToken,
    getTokenExpire,
    isGuest,
    clear,
    getByKey: _get,
    setByKey: _set,
  };
})();
;var appDb = (function () {
  var db = {};

  function getStore() {
    var storeName = 'ADP-APP-DB';
    return new idbKeyval.Store(storeName);
  }

  db.login = {
    name: 'login',
    get: function () {
      return idbKeyval.get(this.name, getStore())
        .then(function (result) {
          return result || {};
        });
    },

    set: function (data) {
      return idbKeyval.set(this.name, data, getStore())
        .then(function () {
          return data;
        })
    }
  };

  db.schema = {
    get: function (name) {
      return idbKeyval.get(name, getStore())
        .then(function (result) {
          return result || {};
        });
    },

    set: function (name, data) {
      return idbKeyval.set(name, data, getStore());
    }
  };

  return db;
})();;;(function (window) {
  'use strict';

  {
    window.lodash = window._;
    dayjs.extend(window.dayjs_plugin_isSameOrAfter);
    dayjs.extend(window.dayjs_plugin_isSameOrBefore);
    dayjs.extend(window.dayjs_plugin_customParseFormat);
    dayjs.extend(window.dayjs_plugin_relativeTime);
  }

  {
    const langTools = ace.require('ace/ext/language_tools');
    const { textCompleter } = langTools;
    const QueryAutoCompleter = window.MongodbAceAutocompleter;
    const queryAutoCompleter = new QueryAutoCompleter('3.6.0', textCompleter, []);

    langTools.addCompleter(queryAutoCompleter);
  }
  _.memoize.Cache = window.WeakMap;

  var $http = angular.injector(['ng']).get('$http');
  var APP_CONFIG = getAppConfig();

  document.addEventListener('DOMContentLoaded', initApp);

  function createAppStore() {
    var store = {
      'SCHEMAS': {},
      'INTERFACE': {},
      'MEDIA_TYPES': {},
      'DEFAULT_STATE': {},
      'MENU_ITEMS': {}
    };

    function _getOrSet(key, value) {
      if (value) {
        return store[key] = value;
      } else {
        return store[key];
      }
    }

    function setStore(data) {
      _getOrSet('SCHEMAS', data.models);
      _getOrSet('INTERFACE', data.interface);
      _getOrSet('MIME_TYPES', data.mimeTypes);
      _getOrSet('METASCHEMA', data.metaschema);
    }

    return {
      appModel: function (value) {
        return _getOrSet('SCHEMAS', value);
      },
      appInterface: function (value) {
        return _getOrSet('INTERFACE', value);
      },
      mimeTypes: function (value) {
        return _getOrSet('MIME_TYPES', value);
      },
      menuItems: function (value) {
        return _getOrSet('MENU_ITEMS', value);
      },
      defaultState: function (value) {
        return _getOrSet('DEFAULT_STATE', value);
      },
      metaschema: function (value) {
        return _getOrSet('METASCHEMA', value);
      },
      setStore: setStore
    }
  }

  function initApp() {
    window.adpAppStore = createAppStore();

    getModel()
      .then(function (appModel) {
        window.adpAppStore.setStore(appModel);

        setTheme(appModel);
        $('[adp-app-page-loader]').remove();
        angular.bootstrap(document, ['app']);
      })
      .catch(e => {
        console.log(e);
      });
  }

  function setTheme(appModel) {
    const devextremeTheme = _.get(appModel, 'interface.devextremeTheme');

    try {
      DevExpress.ui.themes.current(devextremeTheme);
    } catch (e) {
      console.error('Error while setting dx theme, switching back to default :', e);
      DevExpress.ui.themes.current('generic.light');
    }
  }

  function getAppConfig() {
    return angular.injector(['ng', 'APP_MODEL_CONFIG']).get('APP_CONFIG');
  }

  function request(options) {
    var token = lsService.getToken();
    var endpoint = [APP_CONFIG.apiUrl, options.endpoint].join('/');

    var req = {
      method: 'GET',
      url: endpoint,
      withCredentials: true
    };

    if (token) {
      req.headers = { 'Authorization': 'JWT ' + token };
    }

    return $http(req);
  }

  function getModel() {
    var endpoint = lsService.isGuest() ? 'build-app-model' : 'app-model';

    return request({endpoint: endpoint})
      .then(function (res) {
        if (res.data.success) {
          return res.data.data;
        } else {
          throw new Error('App init error, while getting app model');
        }
      })
      .catch(function (error) {
        if (error.status === 401) {
          lsService.removeUserData();
          lsService.setGuestUserData();

          return getModel();
        } else {
          console.log('Unexpected error on model fetch.', error);
        }
      });
  }
})(window);
;(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash")) : factory(root["lodash"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, (__WEBPACK_EXTERNAL_MODULE__773__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 438:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _ = __webpack_require__(773);
module.exports = function (appLib) {
  return {
    guidedTourList: function guidedTourList() {
      var guidedTour = appLib.appModel.interface.guidedTour;
      return _.reduce(guidedTour, function (acc, _ref, key) {
        var fullName = _ref.fullName;
        acc[key] = fullName;
        return acc;
      }, {});
    }
  };
};

/***/ }),

/***/ 332:
/***/ ((module) => {

module.exports = function () {
  var m = {};
  m.guidedTourAction = function () {
    var injector = angular.element(document).injector();
    var AdpGuidedTourService = injector.get('AdpGuidedTourService');
    var $location = injector.get('$location');
    var currentUrl = $location.path();
    AdpGuidedTourService.createAndStart(currentUrl);
  };
  return m;
};

/***/ }),

/***/ 247:
/***/ ((module) => {

module.exports = function () {
  var m = {
    guidedTourDisabledHelper: function guidedTourDisabledHelper() {
      var injector = angular.element(document).injector();
      var AdpGuidedTourService = injector.get('AdpGuidedTourService');
      var $state = injector.get('$state');
      var hasTour = AdpGuidedTourService.checkTourExistForPage($state.current);
      return !hasTour;
    }
  };
  return m;
};

/***/ }),

/***/ 308:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.d5 = void 0;
const options_1 = __webpack_require__(602);
const utils_1 = __webpack_require__(53);
// Most commonly used digit grouping base.
const DIGIT_GROUPING_BASE = 1000;
/**
 * Generator that divides a number until a decimal value is found.
 *
 * The denominator is defined by the numerical digit grouping base,
 * or interval. The most commonly-used digit group interval is 1000.
 *
 * e.g. 1,000,000 is grouped in multiples of 1000.
 */
function* divider(value) {
    // Create a mutable copy of the base.
    let denominator = DIGIT_GROUPING_BASE;
    while (true) {
        const result = value / denominator;
        if (result < 1) {
            // End of operation. We can't divide the value any further.
            return;
        }
        yield result;
        // The denominator is increased every iteration by multiplying
        // the base by itself, until a decimal value remains.
        denominator *= DIGIT_GROUPING_BASE;
    }
}
/**
 * millify converts long numbers to human-readable strings.
 */
function millify(value, options) {
    var _a, _b;
    // Override default options with options supplied by user.
    const opts = options
        ? { ...options_1.defaultOptions, ...options }
        : options_1.defaultOptions;
    if (!Array.isArray(opts.units) || !opts.units.length) {
        throw new Error("Option `units` must be a non-empty array");
    }
    // If the input value is invalid, then return the value in string form.
    // Originally this threw an error, but was changed to return a graceful fallback.
    let val;
    try {
        val = utils_1.parseValue(value);
    }
    catch (e) {
        if (e instanceof Error) {
            console.warn(`WARN: ${e.message} (millify)`);
        }
        // Invalid values will be converted to string as per `String()`.
        return String(value);
    }
    // Add a minus sign (-) prefix if it's a negative number.
    const prefix = val < 0 ? "-" : "";
    // Work only with positive values for simplicity's sake.
    val = Math.abs(val);
    // Keep dividing the input value by the digit grouping base
    // until the decimal and the unit index is deciphered.
    let unitIndex = 0;
    for (const result of divider(val)) {
        val = result;
        unitIndex += 1;
    }
    // Return the original number if the number is too large to have
    // a corresponding unit. Returning anything else is ambiguous.
    const unitIndexOutOfRange = unitIndex >= opts.units.length;
    if (unitIndexOutOfRange) {
        // At this point we don't know what to do with the input value,
        // so we return it as is, without localizing the string.
        return value.toString();
    }
    // Round decimal up to desired precision.
    let rounded = utils_1.roundTo(val, opts.precision);
    // Fixes an edge case bug that outputs certain numbers as 1000K instead of 1M.
    // The rounded value needs another iteration in the divider cycle.
    for (const result of divider(rounded)) {
        rounded = result;
        unitIndex += 1;
    }
    // Calculate the unit suffix and make it lowercase (if needed).
    const unit = (_a = opts.units[unitIndex]) !== null && _a !== void 0 ? _a : "";
    const suffix = opts.lowercase ? unit.toLowerCase() : unit;
    // Add a space between number and abbreviation.
    const space = opts.space ? " " : "";
    // Format the number according to the desired locale.
    const formatted = rounded.toLocaleString((_b = opts.locales) !== null && _b !== void 0 ? _b : utils_1.getLocales(), {
        // toLocaleString needs the explicit fraction digits.
        minimumFractionDigits: utils_1.getFractionDigits(rounded),
    });
    return `${prefix}${formatted}${space}${suffix}`;
}
exports.d5 = millify;
__webpack_unused_export__ = millify;


/***/ }),

/***/ 602:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultOptions = void 0;
/**
 * Default options for Millify.
 */
exports.defaultOptions = {
    lowercase: false,
    precision: 1,
    space: false,
    units: [
        "",
        "K",
        "M",
        "B",
        "T",
        "P",
        "E", // Quintillion
    ],
};


/***/ }),

/***/ 53:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getLocales = exports.getFractionDigits = exports.roundTo = exports.parseValue = void 0;
/**
 * parseValue ensures the value is a number and within accepted range.
 */
function parseValue(value) {
    const val = parseFloat(value === null || value === void 0 ? void 0 : value.toString());
    if (isNaN(val)) {
        throw new Error(`Input value is not a number`);
    }
    if (val > Number.MAX_SAFE_INTEGER || val < Number.MIN_SAFE_INTEGER) {
        throw new RangeError("Input value is outside of safe integer range");
    }
    return val;
}
exports.parseValue = parseValue;
/**
 * Rounds a number [value] up to a specified [precision].
 */
function roundTo(value, precision) {
    if (!Number.isFinite(value)) {
        throw new Error("Input value is not a finite number");
    }
    if (!Number.isInteger(precision) || precision < 0) {
        throw new Error("Precision is not a positive integer");
    }
    if (Number.isInteger(value)) {
        return value;
    }
    return parseFloat(value.toFixed(precision));
}
exports.roundTo = roundTo;
/**
 * Returns the number of digits after the decimal.
 */
function getFractionDigits(num) {
    var _a;
    if (Number.isInteger(num)) {
        return 0;
    }
    const decimalPart = num.toString().split(".")[1];
    return (_a = decimalPart === null || decimalPart === void 0 ? void 0 : decimalPart.length) !== null && _a !== void 0 ? _a : 0;
}
exports.getFractionDigits = getFractionDigits;
/**
 * Returns the default browser locales.
 */
function getLocales() {
    var _a;
    if (typeof navigator === "undefined") {
        return [];
    }
    return Array.from((_a = navigator.languages) !== null && _a !== void 0 ? _a : []);
}
exports.getLocales = getLocales;


/***/ }),

/***/ 773:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__773__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

;// CONCATENATED MODULE: ../message-template/helpers/generic-util.js
/* harmony default export */ const generic_util = (function () {
  var m = {
    addTemplateButtons: function addTemplateButtons(_ref) {
      var _ref$templateTitle = _ref.templateTitle,
        templateTitle = _ref$templateTitle === void 0 ? 'Report' : _ref$templateTitle,
        templateUrl = _ref.templateUrl,
        container = _ref.container;
      var _this$generateTemplat = this.generateTemplateButtons({
          templateTitle: templateTitle,
          templateUrl: templateUrl
        }),
        sandwich = _this$generateTemplat.sandwich,
        buttons = _this$generateTemplat.buttons;
      $(container).empty().append(sandwich).append(buttons);
    },
    generateTemplateButtons: function generateTemplateButtons(_ref2) {
      var _ref2$templateTitle = _ref2.templateTitle,
        templateTitle = _ref2$templateTitle === void 0 ? 'Report' : _ref2$templateTitle,
        templateUrl = _ref2.templateUrl;
      var injector = angular.element(document).injector();
      var $http = injector.get('$http');
      var spec = {
        pdf: {
          handler: templatePdfGenerator,
          icon: 'fa fa-file-pdf-o',
          label: 'Save as PDF'
        },
        print: {
          handler: printTemplate,
          icon: 'fa fa-print',
          label: 'Print'
        },
        mail: {
          href: getMailHref,
          icon: 'fa fa-envelope-o',
          label: 'Send link via e-mail'
        }
      };
      var sandwich = $("<div class='adp-sandwich-icon'><i class='fa fa-bars'></i></div>");
      var buttons = _.map(spec, function (_ref3, name) {
        var handler = _ref3.handler,
          href = _ref3.href,
          icon = _ref3.icon,
          label = _ref3.label;
        var $elem = $("<a class='adp-tmpl-button'>").append("<i class='".concat(icon, "'></i>")).attr('title', label);
        if (handler) {
          var clickHandler = function clickHandler() {
            return $http.get(templateUrl).then(function (_ref4) {
              var data = _ref4.data;
              return handler({
                templateText: data,
                templateTitle: templateTitle
              });
            }).catch(function (e) {
              console.log('ERROR loading template:', e.message || e);
            });
          };
          $elem.click(clickHandler);
        }
        if (href) {
          $elem.attr('href', href({
            templateTitle: templateTitle,
            templateUrl: templateUrl
          }));
        }
        return $elem;
      });
      return {
        sandwich: sandwich,
        buttons: buttons
      };
      function templatePdfGenerator(_ref5) {
        var templateText = _ref5.templateText,
          templateTitle = _ref5.templateTitle;
        var AdpClientCommonHelper = injector.get('AdpClientCommonHelper');
        var _injector$get = injector.get('APP_CONFIG'),
          resourceUrl = _injector$get.resourceUrl;
        return AdpClientCommonHelper.loadVendors([{
          url: "".concat(resourceUrl, "/public/js/lib/pdf-generator/index.js"),
          probe: function probe() {
            return typeof window.jsPDF !== 'undefined';
          }
        }]).then(function () {
          try {
            var doc = new window.jsPDF('p', 'pt', 'a4');
            var fileName = templateTitle.replaceAll(/[^\w\-_.]/g, '_');
            var onPdfReady = function onPdfReady(pdfDoc) {
              pdfDoc.save(fileName);
            };
            var html = "<div style='width:150mm'>".concat(templateText, "</div>");
            doc.html(html, {
              callback: onPdfReady,
              filename: fileName,
              x: 10,
              y: 10
            });
          } catch (e) {
            console.error('PDF generator failed:', e.message || e);
          }
        });
      }
      function printTemplate(_ref6) {
        var templateText = _ref6.templateText,
          templateTitle = _ref6.templateTitle;
        var AdpPrintHelper = injector.get('AdpPrintHelper');
        return AdpPrintHelper.print({
          html: templateText,
          title: templateTitle
        });
      }
      function getMailHref(_ref7) {
        var templateTitle = _ref7.templateTitle,
          templateUrl = _ref7.templateUrl;
        return "mailto:?body=".concat(encodeURIComponent(templateUrl), "&subject=").concat(encodeURIComponent(templateTitle));
      }
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(773);
;// CONCATENATED MODULE: ./model/helpers/lists.js


/* harmony default export */ const lists = (function (appLib) {
  var m = {};
  m.outputsDataFieldTypes = {
    number: 'Number',
    string: 'String',
    boolean: 'Boolean'
  };
  m.datasetsFieldTypes = function () {
    var types = external_lodash_.get(appLib, 'appModel.metaschema.type.list', []);
    return external_lodash_(types).map(function (type) {
      return [type, type];
    }).sortBy([function (x) {
      return x[0];
    }]).fromPairs().value();
  };
  m.externalCommandTypes = {
    shellCommand: 'Shell Command',
    backendCommand: 'Backend Command',
    exportData: 'Export Data',
    referenceCommand: 'Reference Command',
    compoundCommand: 'Compound Command'
  };
  m.devextremeTheme = {
    'generic.light': {
      label: 'Light',
      group: 'Generic'
    },
    'generic.dark': {
      label: 'Dark',
      group: 'Generic'
    },
    'generic.carmine': {
      label: 'Carmine',
      group: 'Generic'
    },
    'generic.contrast': {
      label: 'Contrast',
      group: 'Generic'
    },
    'generic.darkmoon': {
      label: 'Dark Moon',
      group: 'Generic'
    },
    'generic.softblue': {
      label: 'Soft Blue',
      group: 'Generic'
    },
    'generic.darkviolet': {
      label: 'Dark Violet',
      group: 'Generic'
    },
    'generic.greenmist': {
      label: 'Green Mist',
      group: 'Generic'
    },
    'generic.light.compact': {
      label: 'Light Compact',
      group: 'Generic Compact'
    },
    'generic.dark.compact': {
      label: 'Dark Compact',
      group: 'Generic Compact'
    },
    'generic.carmine.compact': {
      label: 'Carmine Compact',
      group: 'Generic Compact'
    },
    'generic.contrast.compact': {
      label: 'Contrast Compact',
      group: 'Generic Compact'
    },
    'generic.darkmoon.compact': {
      label: 'Dark Moon Compact',
      group: 'Generic Compact'
    },
    'generic.darkviolet.compact': {
      label: 'Dark Violet Compact',
      group: 'Generic Compact'
    },
    'generic.greenmist.compact': {
      label: 'Green Mist Compact',
      group: 'Generic Compact'
    },
    'generic.softblue.compact': {
      label: 'Soft Blue Compact',
      group: 'Generic Compact'
    },
    'material.blue.light': {
      label: 'Blue Light',
      group: 'Material Design'
    },
    'material.blue.dark': {
      label: 'Blue Dark',
      group: 'Material Design'
    },
    'material.lime.light': {
      label: 'Lime Light',
      group: 'Material Design'
    },
    'material.lime.dark': {
      label: 'Lime Dark',
      group: 'Material Design'
    },
    'material.orange.light': {
      label: 'Orange Light',
      group: 'Material Design'
    },
    'material.orange.dark': {
      label: 'Orange Dark',
      group: 'Material Design'
    },
    'material.purple.light': {
      label: 'Purple Light',
      group: 'Material Design'
    },
    'material.purple.dark': {
      label: 'Purple Dark',
      group: 'Material Design'
    },
    'material.teal.light': {
      label: 'Teal Light',
      group: 'Material Design'
    },
    'material.teal.dark': {
      label: 'Teal Dark',
      group: 'Material Design'
    },
    'material.blue.light.compact': {
      label: 'Blue Light Compact',
      group: 'Material Design Compact'
    },
    'material.blue.dark.compact': {
      label: 'Blue Dark Compact',
      group: 'Material Design Compact'
    },
    'material.lime.light.compact': {
      label: 'Lime Light Compact',
      group: 'Material Design Compact'
    },
    'material.lime.dark.compact': {
      label: 'Lime Dark Compact',
      group: 'Material Design Compact'
    },
    'material.orange.light.compact': {
      label: 'Orange Light Compact',
      group: 'Material Design Compact'
    },
    'material.orange.dark.compact': {
      label: 'Orange dark Compact',
      group: 'Material Design Compact'
    },
    'material.purple.light.compact': {
      label: 'Purple Light Compact',
      group: 'Material Design Compact'
    },
    'material.purple.dark.compact': {
      label: 'Purple dark Compact',
      group: 'Material Design Compact'
    },
    'material.teal.light.compact': {
      label: 'Teal Light Compact',
      group: 'Material Design Compact'
    },
    'material.teal.dark.compact': {
      label: 'Teal dark Compact',
      group: 'Material Design Compact'
    }
  };
  m.themeCombinedStyles = {
    light: 'Light',
    dark: 'Dark'
  };
  m.themeSkin = {
    'smart-style-0': 'Style 0',
    'smart-style-1': 'Style 1',
    'smart-style-2': 'Style 2',
    'smart-style-3': 'Style 3',
    'smart-style-4': 'Style 4',
    'smart-style-5': 'Style 5',
    'smart-style-6': 'Style 6'
  };
  m.aceTheme = {
    chrome: {
      label: 'Chrome',
      group: 'Light'
    },
    github: {
      label: 'GitHub',
      group: 'Light'
    },
    ambiance: {
      label: 'Ambiance',
      group: 'Dark'
    },
    chaos: {
      label: 'Chaos',
      group: 'Dark'
    },
    terminal: {
      label: 'Terminal',
      group: 'Dark'
    }
  };
  m.ckeditorTheme = {
    bootstrapck: 'BootstrapCK4',
    n1theme: 'N1Theme',
    minimalist: 'Minimalist',
    moono: 'Moono',
    'moono-dark': 'Moono Dark',
    'moono-lisa': 'Moono Lisa',
    office2013: 'Office 2013',
    prestige: 'Prestige'
  };
  m.scrollbarTheme = {
    light: 'Light',
    dark: 'Dark'
  };
  m.googleMapsTheme = {
    light: 'Light',
    dark: 'Dark'
  };
  m.sourceModelNames = function () {
    var fullNameAndSchemaName = [];
    external_lodash_.each(appLib.appModel.models, function (schema, schemaName) {
      if (!schemaName.startsWith(appLib.butil.dataset.datasetPrefix)) {
        var fullName = schema.fullName || schemaName;
        fullNameAndSchemaName.push([fullName, schemaName]);
      }
    });
    fullNameAndSchemaName.sort(function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 1),
        fullName1 = _ref3[0];
      var _ref4 = _slicedToArray(_ref2, 1),
        fullName2 = _ref4[0];
      return fullName1.toLowerCase() < fullName2.toLowerCase() ? -1 : 1;
    });
    var modelNamesList = {};
    external_lodash_.each(fullNameAndSchemaName, function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        fullName = _ref6[0],
        schemaName = _ref6[1];
      modelNamesList[schemaName] = fullName;
    });
    return modelNamesList;
  };
  return m;
});
;// CONCATENATED MODULE: ../aggregation-pipeline/helpers/lists.js
/* harmony default export */ const helpers_lists = (function () {
  var m = {
    stages: {
      $addFields: 'Add Fields',
      $bucket: 'Bucket',
      $bucketAuto: 'Bucket Auto',
      $collStats: 'Coll Stats',
      $comment: 'Comment',
      $count: 'Count',
      $customStage: 'Custom Stage',
      $densify: 'Densify',
      $facet: 'Facet',
      $fill: 'Fill',
      $geoNear: 'Geo Near',
      $graphLookup: 'Graph Lookup',
      $group: 'Group',
      $limit: 'Limit',
      $lookup: 'Lookup',
      $match: 'Match',
      $matchByConfig: 'Match Configurator',
      $project: 'Project',
      $redact: 'Redact',
      $replaceWith: 'Replace With',
      $sample: 'Sample',
      $set: 'Set',
      $setWindowFields: 'Set Window Fields',
      $skip: 'Skip',
      $sort: 'Sort',
      $sortByCount: 'Sort By Count',
      $unionWith: 'Union With',
      $unset: 'Unset',
      $unwind: 'Unwind'
    },
    densifyTimeUnits: {
      millisecond: 'Millisecond',
      second: 'Second',
      minute: 'Minute',
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      quarter: 'Quarter',
      year: 'Year'
    },
    mongoAccumOperators: {
      $addToSet: '$addToSet',
      $avg: '$avg',
      $bottom: '$bottom',
      $bottomN: '$bottomN',
      $count: '$count',
      $first: '$first',
      $firstN: '$firstN',
      $last: '$last',
      $lastN: '$lastN',
      $max: '$max',
      $maxN: '$maxN',
      $mergeObjects: '$mergeObjects',
      $min: '$min',
      $push: '$push',
      $stdDevPop: '$stdDevPop',
      $stdDevSamp: '$stdDevSamp',
      $sum: '$sum',
      $top: '$top',
      $topN: '$topN'
    },
    matchFieldTypes: {
      Number: 'Number',
      String: 'String',
      Boolean: 'Boolean',
      DateTime: 'Date'
    },
    matchStringOperations: {
      any: 'Any',
      contains: 'Contains',
      equal: 'Equal',
      starts_with: 'Starts with',
      ends_with: 'Ends with',
      matches: 'Matches regular expression',
      is_blank: 'Is blank',
      does_not_contain: 'Does not contain',
      not_equal: 'Not Equal',
      does_not_start_with: 'Does not start with',
      does_not_end_with: 'Does not end with',
      does_not_match: 'Does not match RE',
      is_not_blank: 'Is not blank'
    },
    fieldPresentationType: {
      Number: 'Number',
      String: 'String',
      Boolean: 'Boolean',
      Date: 'Date',
      Array: 'Array',
      Object: 'Object'
    },
    fieldPresentationFilterType: {
      Number: 'Number',
      String: 'String',
      Boolean: 'Boolean',
      Date: 'Date',
      NoFilter: 'No Filter',
      List: 'List',
      Checkbox: 'Checkbox',
      Other: 'Other'
    },
    fieldPresentationRenderAs: {
      action: 'Action',
      array_count: 'Array Count',
      as_is: 'As Is',
      attachments: 'Attachments',
      campaign_action: 'Campaign Action',
      checkbox: 'Checkbox',
      content_versions: 'Content Versions',
      custom_view_action: 'Custom View Action',
      cv_estimates: 'Cv Estimates',
      data_export_filename: 'Data Export Filename',
      date_and_time: 'Date And Time',
      des_activity: 'Des Activity',
      des_actor: 'Des Actor',
      des_object: 'Des Object',
      des_object_type: 'Des Object Type',
      dump: 'Dump',
      edit_only: 'Edit Only',
      favorite: 'Favorite',
      filter_specification: 'Filter Specification',
      html_text: 'Html Text',
      inviter: 'Inviter',
      jive_user_emails: 'Jive User Emails',
      jive_user_primary_email: 'Jive User Primary Email',
      jive_user_tags: 'Jive User Tags',
      jive_user_thumbnail: 'Jive User Thumbnail',
      join_addresses: 'Join Addresses',
      join_values: 'Join Values',
      linked: 'Linked',
      linked_to_jive_html: 'Linked To Jive Html',
      list: 'List',
      log_details: 'Log Details',
      log_subject: 'Log Subject',
      mixed: 'Mixed',
      object_id: 'Object Id',
      outcome_notes: 'Outcome Notes',
      people: 'People',
      person: 'Person',
      persons: 'Persons',
      place: 'Place',
      place_members: 'Place Members',
      preview: 'Preview',
      profile: 'Profile',
      profile_images: 'Profile Images',
      simple_mixed: 'Simple Mixed',
      string_array: 'String Array',
      user_action: 'User Action',
      versions: 'Versions',
      wrapped_text: 'Wrapped Text',
      yes_no: 'Yes No',
      yes_no_flag: 'Yes No Flag'
    },
    aggregationPipelineFields: function aggregationPipelineFields() {
      return {
        test: 'Test',
        '[newField]': '[New Field]'
      };
    },
    aggregationPipelineFieldsWithNew: function aggregationPipelineFieldsWithNew() {
      var ret = m.aggregationPipelineFields();
      ret['[newField]'] = '[New Field]';
      return ret;
    },
    externalCommandTypes: {
      runAggregationPipelines: 'Run Views'
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/lists.js
/* harmony default export */ const widget_helpers_lists = (function () {
  var m = {};
  m.widgetTypes = {};
  m.leafletMapTileLayers = function (_ref) {
    var appLib = _ref.appLib,
      _ = _ref._;
    return _.mapValues(_.get(appLib, 'appModel.interface.widgets.leafletMap.parameters.tileLayers', {}), 'fullName');
  };
  m.leafletMapGeoJsonLayers = function (_ref2) {
    var appLib = _ref2.appLib,
      _ = _ref2._;
    return _.mapValues(_.get(appLib, 'appModel.interface.widgets.leafletMap.parameters.geoJsonLayers', {}), 'fullName');
  };
  m.timelapseRangeMode = {
    fixedRange: 'Fixed Range Size',
    fixedFrom: 'Fixed "From"',
    fixedTo: 'Fixed "To"'
  };
  m.timelapseLoopMode = {
    once: 'Once',
    loop: 'Loop',
    bounce: 'Bounce'
  };
  m.timelapseStartDirection = {
    forward: 'Forward',
    backward: 'Backward'
  };
  m.sliderStepsDateTime = {
    second: 'Seconds',
    minute: 'Minutes',
    hour: 'Hours',
    day: 'Days',
    week: 'Weeks',
    month: 'Months',
    year: 'Years'
  };
  m.sliderStepsTime = {
    second: 'Seconds',
    minute: 'Minutes',
    hour: 'Hours'
  };
  m.fontFamilies = {
    'Arial,Helvetica Neue,Helvetica, sans-serif': 'Arial (sans-serif)',
    'Arial Black,Arial,sans-serif': 'Arial Black (sans-serif)',
    'Baskerville,Baskerville Old Face,Garamond,Times New Roman,serif': 'Baskerville (serif)',
    'Bradley Hand,cursive': 'Bradley Hand (cursive)',
    'Brush Script MT,cursive': 'Brush Script MT (cursive)',
    'Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif': 'Calibri (sans-serif)',
    'Comic Sans MS,cursive': 'Comic Sans MS (cursive)',
    'Consolas,monaco,monospace': 'Consolas (monospace)',
    'Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace': 'Courier New (monospace)',
    'Garamond,Baskerville,Baskerville Old Face,Hoefler Text,Times New Roman,serif': 'Garamond (serif)',
    'Georgia,Times,Times New Roman,serif': 'Georgia (serif)',
    'Gill Sans,Gill Sans MT,Calibri,sans-serif': 'Gill Sans (sans-serif)',
    'Helvetica Neue,Helvetica,Arial,sans-serif': 'Helvetica (sans-serif)',
    'Impact,Charcoal,Helvetica Inserat,Bitstream Vera Sans Bold,Arial Black,sans serif': 'Impact (sans-serif)',
    'Lucida,Lucida Sans Typewriter,Lucida Typewriter,Courier New,Courier,monospace': 'Lucida (monospace)',
    'Luminari,fantasy': 'Luminari (fantasy)',
    'Monaco,monospace': 'Monaco (monospace)',
    'Palatino,Palatino Linotype,Palatino LT STD,Book Antiqua,Georgia,serif': 'Palatino (serif)',
    'Rockwell,Courier Bold,Courier,Georgia, Times,Times New Roman,serif': 'Rockwell (serif)',
    'Tahoma,Verdana,Segoe,sans-serif': 'Tahoma (sans-serif)',
    'Times New Roman,serif': 'Times New Roman (serif)',
    'Trebuchet MS,Lucida Grande,Lucida Sans Unicode,Lucida Sans,sans-serif': 'Trebuchet MS (sans-serif)',
    'Verdana,Geneva,sans-serif': 'Verdana (sans-serif)'
  };
  m.aggregationCommands = {
    avg: 'Average',
    min: 'Minimum',
    max: 'Maximum',
    sum: 'Sum',
    count: 'Count',
    first: 'First',
    last: 'Last',
    custom: 'Custom expression'
  };
  m.echartsPosition = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bottom',
    inside: 'inside',
    insideLeft: 'insideLeft',
    insideRight: 'insideRight',
    insideTop: 'insideTop',
    insideBottom: 'insideBottom',
    insideTopLeft: 'insideTopLeft',
    insideBottomLeft: 'insideBottomLeft',
    insideTopRight: 'insideTopRight',
    insideBottomRight: 'insideBottomRight'
  };
  m.echartsThemes = {
    'adp-azul': 'ADP Azul',
    'adp-blue': 'ADP Blue',
    'adp-dark': 'ADP Dark',
    'adp-dark-bold': 'ADP Dark Bold',
    'adp-dark-digerati': 'ADP Dark Digerati',
    'adp-forest': 'ADP Forest',
    'adp-fresh-cut': 'ADP Fresh Cut',
    'adp-infographic': 'ADP Infographic',
    'adp-shine': 'ADP Shine',
    azul: 'Azul',
    'bee-inspired': 'Bee inspired',
    blue: 'Blue',
    caravan: 'Caravan',
    carp: 'Carp',
    cool: 'Cool',
    dark: 'Dark',
    'dark-blue': 'Dark blue',
    'dark-bold': 'Dark bold',
    'dark-digerati': 'Dark digerati',
    'dark-fresh-cut': 'Dark fresh cut',
    'dark-mushroom': 'Dark mushroom',
    eduardo: 'Eduardo',
    forest: 'Forest',
    'fresh-cut': 'Fresh cut',
    fruit: 'Fruit',
    gray: 'Gray',
    green: 'Green',
    helianthus: 'Helianthus',
    infographic: 'Infographic',
    inspired: 'Inspired',
    light: 'Light',
    jazz: 'Jazz',
    london: 'London',
    macarons: 'Macarons',
    macarons2: 'Macarons2',
    mint: 'Mint',
    red: 'Red',
    'red-velvet': 'Red velvet',
    roma: 'Roma',
    royal: 'Royal',
    sakura: 'Sakura',
    shine: 'Shine',
    'tech-blue': 'Tech blue',
    vintage: 'Vintage'
  };
  m.markerPatternTypes = {
    hiro: 'HIRO (no QR)',
    'QRout-LetterA': 'Letter A inside QR',
    'QRout-LetterG': 'Letter G inside QR',
    'QRout-LetterL': 'Letter L inside QR',
    'QRout-LetterN': 'Letter N inside QR',
    'QRout-LetterR': 'Letter R inside QR',
    'QRout-WWBBWWBBBWWWBWBB': 'Type 1(4x4) inside QR',
    'QRout-BWWWBWWBWWWWWWBW': 'Type 2 inside QR',
    'QRout-BWWBWBWWWWWBWWBW': 'Type 5 inside QR',
    'QRout-BWBWWBWWWWWWBWWW': 'Type 9 inside QR',
    'QRout-BWBWBBBWWWBBWWBW': 'Type 11a inside QR',
    LetterA: 'Letter A (no QR)',
    LetterG: 'Letter G (no QR)',
    LetterL: 'Letter L (no QR)',
    LetterN: 'Letter N (no QR)',
    LetterR: 'Letter R (no QR)',
    WWQQWWQQBWWWBWBB: 'Legacy type (with QR)',
    BWWWBWWBQQWWQQBW: 'Type 2 (with QR)',
    BWWBWBWWQQWBQQBW: 'Type 5 (with QR)',
    BWBWWBQQWWQQBWWW: 'Type 9 (with QR)',
    BWBWBBBWQQBBQQBW: 'Type 11a (with QR)'
  };
  m.layerControlPositions = {
    topleft: 'Top left',
    topright: 'Top right',
    bottomleft: 'Bottom left',
    bottomright: 'Bottom right'
  };
  return m;
});
;// CONCATENATED MODULE: ../3d-globe/helpers/lists.js
/* harmony default export */ const _3d_globe_helpers_lists = (function () {
  var m = {};
  m.globeGeoJsonLayers = function (_ref) {
    var appLib = _ref.appLib,
      _ = _ref._;
    return _.mapValues(_.get(appLib, 'appModel.interface.widgets.globe.parameters.geoJsonLayers', {}), 'fullName');
  };
  m.globeSurfaceTextures = function (_ref2) {
    var appLib = _ref2.appLib,
      _ = _ref2._;
    return _.mapValues(_.get(appLib, 'appModel.interface.widgets.globe.parameters.surfaceTextures', {}), 'fullName');
  };
  return m;
});
;// CONCATENATED MODULE: ../ar-anything/helpers/lists.js
/* harmony default export */ const ar_anything_helpers_lists = (function () {
  var m = {};
  m.arAnythingStaticLayerTypes = {
    uploadedFile: 'Uploaded File',
    staticUrl: 'Static URL'
  };
  return m;
});
// EXTERNAL MODULE: ../guided-tour/helpers/lists.js
var guided_tour_helpers_lists = __webpack_require__(438);
;// CONCATENATED MODULE: ../data-pull/helpers/lists.js
/* harmony default export */ const data_pull_helpers_lists = (function () {
  var m = {};
  m.externalCommandTypes = {
    runDataProcessors: 'Run Data Processors'
  };
  return m;
});
;// CONCATENATED MODULE: ../marketplace-server/helpers/lists.js
/* harmony default export */ const marketplace_server_helpers_lists = (function () {
  var m = {};
  m.licenseDurations = {
    week: '1 week',
    month: '1 month',
    year: '1 year',
    lifetime: 'Unlimited(lifetime)'
  };
  m.paymentMethodTypes = {
    creditCard: 'Credit Card'
  };
  return m;
});
;// CONCATENATED MODULE: ../topomap/helpers/lists.js
/* harmony default export */ const topomap_helpers_lists = (function () {
  var m = {};
  m.topomapGeoJsonLayers = function (_ref) {
    var appLib = _ref.appLib,
      _ = _ref._;
    return _.mapValues(_.get(appLib, 'appModel.interface.widgets.topomap.parameters.geoJsonLayers', {}), 'fullName');
  };
  m.topomapSurfaceTextures = function (_ref2) {
    var appLib = _ref2.appLib,
      _ = _ref2._;
    return _.mapValues(_.get(appLib, 'appModel.interface.widgets.topomap.parameters.surfaceTextures', {}), 'fullName');
  };
  return m;
});
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ./node_modules/millify/dist/millify.js
var millify = __webpack_require__(308);
;// CONCATENATED MODULE: ./model/helpers/util.js

function getFeModule(_list) {
  var list = external_lodash_.isString(_list) ? [_list] : _list;
  var obj = {};
  var injector = angular.element(document).injector();
  external_lodash_.each(list, function (name) {
    obj[name] = injector.get(name);
  });
  return obj;
}
;// CONCATENATED MODULE: ./model/helpers/renderers_utils.js

function renderChart(args, options, renderOptions) {
  var _getFeModule = getFeModule(['AdpCodeLoadHelper']),
    AdpCodeLoadHelper = _getFeModule.AdpCodeLoadHelper;
  var renderer = function renderer(_ref) {
    var chartEl = _ref.chartEl,
      options = _ref.options,
      path = _ref.path;
    var chart = window.echarts.init(chartEl.find('div')[0]);
    $(window).on('resize.echarts.' + path, _.throttle(function () {
      return chart.resize();
    }, 40));
    $(chartEl).one('remove', function () {
      return $(window).off('resize.echarts.' + path);
    });
    chart.setOption(options);
    chart.resize();
    chartEl.closest('.adp-datagrid-cell-container-custom-render').css({
      overflow: ''
    });
  };
  var tpl = "<div style=\"height: ".concat(renderOptions.height, "; display: flex;\">\n      <div style=\"width: 100%; margin: 0; max-width: ").concat(renderOptions.width, "; height: ").concat(renderOptions.height, ";\"></div>\n  </div>");
  var chartEl = $(tpl);
  AdpCodeLoadHelper.loadVendorGroup('echarts').then(function () {
    setTimeout(function () {
      return renderer({
        chartEl: chartEl,
        options: options,
        path: args.path
      });
    }, 100);
  });
  return chartEl;
}
function getBarChartData(rawData) {
  if (_.isEmpty(rawData)) {
    return;
  }
  var dataToProcess = _.isPlainObject(rawData) ? [rawData] : rawData;
  var labels = _.chain(dataToProcess).map(function (r) {
    return _.keys(r);
  }).flatten().uniq().value();
  var data = _.map(dataToProcess, function (dataRow) {
    return _.map(labels, function (label) {
      var value = dataRow[label];
      return _.isNil(value) ? null : value;
    });
  });
  return {
    labels: labels,
    data: data
  };
}
function renderColumnBarChart(_ref2, _ref3) {
  var _ref2$minMode = _ref2.minMode,
    minMode = _ref2$minMode === void 0 ? true : _ref2$minMode,
    _ref2$barMode = _ref2.barMode,
    barMode = _ref2$barMode === void 0 ? true : _ref2$barMode;
  var labels = _ref3.labels,
    data = _ref3.data;
  var options = {
    tooltip: {},
    grid: {
      containLabel: true,
      left: '2%',
      top: 10,
      right: '2%',
      bottom: 10
    },
    xAxis: {
      type: barMode ? 'value' : 'category'
    },
    yAxis: {
      type: barMode ? 'category' : 'value'
    },
    axisTick: {
      show: true
    },
    series: _.map(data, function (dataRow, index) {
      return {
        name: "bar ".concat(index),
        type: 'bar',
        stack: 'one',
        data: dataRow
      };
    })
  };
  var labelTarget = barMode ? options.xAxis : options.yAxis;
  labelTarget.data = labels;
  var renderOptions = {
    width: '100%',
    height: '400px'
  };
  if (minMode) {
    _.merge(options, {
      legend: {
        show: false
      },
      grid: {
        containLabel: true,
        left: -15,
        top: 5,
        right: 5,
        bottom: -15
      },
      tooltip: {
        appendToBody: true
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      }
    });
    _.merge(renderOptions, {
      width: '100%',
      height: '45px'
    });
  }
  return renderChart(this, options, renderOptions);
}
function renderers_utils_barChart() {
  if (!this.data) {
    return '<div>No data to display</div>';
  }
  var data = getBarChartData(this.data);
  var renderingOptions = {
    minMode: this.action === 'view',
    barMode: true
  };
  return renderColumnBarChart.call(this, renderingOptions, data);
}
function renderers_utils_columnChart() {
  if (!this.data) {
    return '<div>No data to display</div>';
  }
  var data = getBarChartData(this.data);
  var renderingOptions = {
    minMode: this.action === 'view',
    barMode: false
  };
  return renderColumnBarChart.call(this, renderingOptions, data);
}
function renderers_utils_pieChart() {
  if (!this.data) {
    return '<div>No data to display</div>';
  }
  var minMode = this.action === 'view';
  var options = {
    tooltip: {
      extraCssText: 'max-width: 300px;   white-space: normal;  word-wrap: break-word;',
      textStyle: {}
    },
    grid: {
      left: '2%',
      top: 0,
      right: '2%',
      bottom: 0
    },
    series: [{
      name: 'Series 1',
      type: 'pie',
      radius: '90%',
      label: {
        show: false,
        position: 'center'
      },
      data: _.map(this.data, function (value, name) {
        return {
          name: name,
          value: value
        };
      })
    }]
  };
  var renderOptions = {
    width: '100%',
    height: '400px'
  };
  if (minMode) {
    _.merge(options, {
      tooltip: {
        appendToBody: true
      },
      grid: {
        containLabel: true,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      },
      axisTick: {
        show: false
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      }
    });
    _.merge(renderOptions, {
      width: '100%',
      height: '45px'
    });
  }
  return renderChart(this, options, renderOptions);
}
;// CONCATENATED MODULE: ./model/helpers/renderers.js


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const renderers = (function () {
  function getBjrCommandYAML() {
    var _getFeModule = getFeModule(['HtmlCellRenderer', 'AdpUnifiedArgs']),
      HtmlCellRenderer = _getFeModule.HtmlCellRenderer,
      AdpUnifiedArgs = _getFeModule.AdpUnifiedArgs;
    var commandArgs = AdpUnifiedArgs.getHelperParams({
      path: this.row.type,
      formData: this.row,
      action: this.action,
      schema: this.modelSchema
    });
    return HtmlCellRenderer(commandArgs);
  }
  function formatWithDevExpress(args, formatName) {
    var feModules = getFeModule(['GRID_FORMAT', formatName, 'FormattersHelper']);
    var _$values = _.values(feModules),
      _$values2 = _slicedToArray(_$values, 3),
      GRID_FORMAT = _$values2[0],
      DX_FORMAT_NAME = _$values2[1],
      FormattersHelper = _$values2[2];
    if (_.isNil(args.data)) {
      return GRID_FORMAT.EMPTY_VALUE;
    }
    var format = _.get(args, 'fieldSchema.parameters.format') || DX_FORMAT_NAME;
    var formattedValue = DevExpress.localization.formatNumber(args.data, format);
    if (FormattersHelper.asText(args) || args.data >= 0) {
      return formattedValue;
    }
    return "<span class=text-danger>".concat(formattedValue, "</span>");
  }
  var m = {
    asIs: function asIs(data) {
      return data;
    },
    googleSearch: function googleSearch(data, type, row, meta) {
      var template = '<a href="https://google.com?q=<%= data %>"><%= data %></a>';
      var templateData = {
        data: data,
        row: row,
        type: type,
        meta: meta
      };
      return adpRenderLib.getTemplate(template, templateData);
    },
    link: function link() {
      var asText = _.get(this, 'params.asText', false);
      var data = this.data;
      if (!data) {
        var _getFeModule2 = getFeModule(['GRID_FORMAT']),
          EMPTY_VALUE = _getFeModule2.GRID_FORMAT.EMPTY_VALUE;
        return EMPTY_VALUE;
      }
      if (asText) {
        return data;
      }
      return adpRenderLib.getTemplate('<a href="<%= data %>" target="_blank"><%= data %></a>', this);
    },
    percent: function percent() {
      return formatWithDevExpress(this, 'DX_PERCENT_FORMAT');
    },
    commandSpecification: function commandSpecification() {
      var selectedCommand = this.row.type;
      var render = window.appModelHelpers.Renderers[selectedCommand] || getBjrCommandYAML;
      return render.call(this);
    },
    backendCommand: getBjrCommandYAML,
    shellCommand: getBjrCommandYAML,
    exportData: getBjrCommandYAML,
    referenceCommand: getBjrCommandYAML,
    compoundCommand: getBjrCommandYAML,
    roundedLargeNumber: function roundedLargeNumber() {
      return this.data ? (0,millify/* millify */.d5)(this.data, {
        precision: 1
      }) : '-';
    },
    usaNumberFormat: function usaNumberFormat() {
      return this.data ? new Intl.NumberFormat('en-US').format(this.data) : '-';
    },
    currency: function currency() {
      return formatWithDevExpress(this, 'DX_ACCOUNTING_FORMAT');
    },
    imageUrl: function imageUrl() {
      var _getFeModule3 = getFeModule(['GRID_FORMAT']),
        GRID_FORMAT = _getFeModule3.GRID_FORMAT;
      if (!this.data) {
        return GRID_FORMAT.EMPTY_VALUE;
      }
      return "\n        <div style=\"padding: 10px 5px 9px 5px;\">\n          <a href=\"".concat(this.data, "\" target=\"_blank\">\n            <img src=\"").concat(this.data, "\" style=\"max-width: 150px; max-height: 32px;\">\n          </a>\n        </div> \n        ");
    },
    color: function color() {
      var data = this.data;
      var _getFeModule4 = getFeModule(['GRID_FORMAT', 'FormattersHelper']),
        EMPTY_VALUE = _getFeModule4.GRID_FORMAT.EMPTY_VALUE,
        FormattersHelper = _getFeModule4.FormattersHelper;
      if (_.isNil(data)) {
        return EMPTY_VALUE;
      }
      if (FormattersHelper.asText(this)) {
        return data;
      }
      var tpl = "<div class=\"adp-color-preview\">\n        <span class=\"adp-color-preview-box\" style=\"background-color: ".concat(data, "\"></span><span>").concat(data, "</span>\n      </div>");
      return $(tpl);
    },
    arrayOfString: function arrayOfString() {
      var data = this.data;
      var _getFeModule5 = getFeModule(['GRID_FORMAT', 'FormattersHelper']),
        EMPTY_VALUE = _getFeModule5.GRID_FORMAT.EMPTY_VALUE;
      if (_.isNil(data) || _.isEmpty(data)) {
        return EMPTY_VALUE;
      }
      return "<div class=\"adp-datagrid-cell-container\">".concat(data.join(', '), "</div>");
    },
    arrayOfEmails: function arrayOfEmails() {
      var data = this.data;
      var _getFeModule6 = getFeModule(['GRID_FORMAT', 'FormattersHelper']),
        EMPTY_VALUE = _getFeModule6.GRID_FORMAT.EMPTY_VALUE;
      if (_.isNil(data) || _.isEmpty(data)) {
        return EMPTY_VALUE;
      }
      var $listRoot = $('<div class="adp-datagrid-cell-container">');
      var replaceEmailString = function replaceEmailString(rawEmailString) {
        var emailRegex = /<?([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)>?/gi;
        return rawEmailString.trim().replace('mailto:', '').replace(emailRegex, "<<a class=\"dx-tag-link\" href=\"mailto:$1\">$1</a>>");
      };
      var listItems = _.map(data, replaceEmailString).join(', ');
      $listRoot.append(listItems);
      return $listRoot;
    },
    barChart: function barChart() {
      return renderers_utils_barChart.call(this);
    },
    pieChart: function pieChart() {
      return renderers_utils_pieChart.call(this);
    },
    columnChart: function columnChart() {
      return renderers_utils_columnChart.call(this);
    },
    rating: function rating() {
      var _getFeModule7 = getFeModule(['GRID_FORMAT', 'ADP_STAR_RATING_STYLING']),
        EMPTY_VALUE = _getFeModule7.GRID_FORMAT.EMPTY_VALUE,
        ADP_STAR_RATING_STYLING = _getFeModule7.ADP_STAR_RATING_STYLING;
      var data = this.data;
      var isNumeric = ['Number', 'Double', 'Int32', 'Int64', 'Rating'].includes(this.fieldSchema.type);
      if (_.isNil(data) || !isNumeric) {
        return EMPTY_VALUE;
      }
      var numberOfStars = this.fieldSchema.parameters.numberOfStars;
      return $('<div class="adp-rating-renderer">').starRating(_objectSpread(_objectSpread({}, ADP_STAR_RATING_STYLING), {}, {
        totalStars: numberOfStars,
        initialRating: data,
        readOnly: true,
        starSize: 16
      }));
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/renderers.js
/* harmony default export */ const helpers_renderers = (function () {
  var m = {};
  m.gradient = function () {
    var row = this.row;
    var injector = angular.element(document).injector();
    var AdpGradientService = injector.get('AdpGradientService');
    return AdpGradientService.getGradientHtml(row);
  };
  m.iconPreview = function () {
    var html = _.get(this, "row.iconPreviewHtml", '');
    return $('<span>').html(html);
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/custom_actions.js
function runByRecordId(_ref) {
  var confirmMessage = _ref.confirmMessage,
    successMessageFunc = _ref.successMessageFunc,
    redirectUrl = _ref.redirectUrl,
    commandUrl = _ref.commandUrl;
  var injector = angular.element(document).injector();
  var adpClientCommonHelper = injector.get('AdpClientCommonHelper');
  return adpClientCommonHelper.runByRecordId.call(this, {
    confirmMessage: confirmMessage,
    successMessageFunc: successMessageFunc,
    redirectUrl: redirectUrl,
    commandUrl: commandUrl
  });
}
function _runDataProcessor(redirectUrl) {
  var ignoreDisabledState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _this$row = this.row,
    name = _this$row.name,
    disabled = _this$row.disabled;
  var injector = angular.element(document).injector();
  var adpNotificationService = injector.get('AdpNotificationService');
  if (!ignoreDisabledState && disabled) {
    adpNotificationService.notifyError('Unable to run disabled processor here. Please use Apply&Run on Update form.');
    return;
  }
  var confirmMessage = "Are you sure to run '".concat(name, "' data processor?");
  var successMessageFunc = function successMessageFunc(response) {
    return "Background job #".concat(response.data.jobId, " running '").concat(name, "' processor has been scheduled");
  };
  return runByRecordId.call(this, {
    confirmMessage: confirmMessage,
    successMessageFunc: successMessageFunc,
    redirectUrl: redirectUrl
  });
}
function _runExternalCommand(redirectUrl) {
  var name = _.get(this, 'row.name');
  var confirmMessage = "Are you sure to run '".concat(name, "' command?");
  var successMessageFunc = function successMessageFunc(response) {
    return "Background job #".concat(response.data.jobId, " running '").concat(name, "' command has been scheduled");
  };
  var injector = angular.element(document).injector();
  var AdpCommandRunner = injector.get('AdpCommandRunner');
  return AdpCommandRunner.runExternalCommand.call(this, {
    confirmMessage: confirmMessage,
    successMessageFunc: successMessageFunc,
    redirectUrl: redirectUrl
  });
}
function applyAndRun(args, formHooks, actionName, runRoutine) {
  var _this = this;
  var injector = angular.element(document).injector();
  var AdpFormActions = injector.get('AdpFormActions');
  var redirectUrl = _.get(this, "modelSchema.actions.fields.".concat(actionName, ".action.redirectUrl"), '');
  return AdpFormActions.apply.call(this, args, formHooks).then(function () {
    return runRoutine.call(_this, [redirectUrl]);
  });
}
function _downloadFile(fileItem) {
  var injector = angular.element(document).injector();
  var adpMediaTypeHelper = injector.get('AdpMediaTypeHelper');
  adpMediaTypeHelper.downloadWithSaveDialog(fileItem);
}
/* harmony default export */ const custom_actions = (function () {
  var m = {
    deleteBackgroundJob: function deleteBackgroundJob() {
      var _this2 = this;
      var injector = angular.element(document).injector();
      var GraphqlRequest = injector.get('GraphqlRequest');
      var adpModalService = injector.get('AdpModalService');
      var adpNotificationService = injector.get('AdpNotificationService');
      var adpErrorHelper = injector.get('ErrorHelpers');
      function deleteJob(_ref2) {
        var id = _ref2.id,
          queueName = _ref2.queueName;
        return GraphqlRequest({
          name: 'backgroundJobsDeleteOne',
          query: "mutation m($filter: BackgroundJobIdInput!) {\n            backgroundJobsDeleteOne (filter: $filter) { deletedCount }\n          }",
          variables: {
            filter: {
              jobId: id,
              queueName: queueName
            }
          }
        });
      }
      return adpModalService.confirm({
        message: 'Are you sure that you want to delete this job?'
      }).then(function () {
        return deleteJob(_this2.row);
      }).then(function () {
        adpNotificationService.notifySuccess('Background job successfully deleted');
        var gridEl = $('[dx-data-grid]');
        gridEl.length && gridEl.dxDataGrid('instance').refresh();
      }).catch(function (err) {
        return adpErrorHelper.handleError(err);
      });
    },
    redirectToBpmRunner: function redirectToBpmRunner() {
      var confirmMessage = 'Are you sure to run this ruleset against configured dataset?';
      var successMessage = function successMessage(response) {
        return "Background job #".concat(response.data.jobId, " running this ruleset has been scheduled");
      };
      return runByRecordId.call(this, {
        confirmMessage: confirmMessage,
        successMessage: successMessage
      });
    },
    runExternalCommand: function runExternalCommand() {
      return _runExternalCommand.call(this);
    },
    stopDataProcessorBackgroundJob: function stopDataProcessorBackgroundJob() {
      var _$get = _.get(this, 'row', {}),
        name = _$get.name,
        id = _$get.id;
      var confirmMessage = "Are you sure to stop '".concat(name, "' job?");
      var successMessageFunc = function successMessageFunc(response) {
        return response.message;
      };
      return runByRecordId.call(this, {
        confirmMessage: confirmMessage,
        successMessageFunc: successMessageFunc,
        commandUrl: "/stopDataProcessorBackgroundJob/".concat(id)
      });
    },
    stopAggregationPipelineBackgroundJob: function stopAggregationPipelineBackgroundJob() {
      var _$get2 = _.get(this, 'row', {}),
        name = _$get2.name,
        id = _$get2.id;
      var confirmMessage = "Are you sure to stop '".concat(name, "' job?");
      var successMessageFunc = function successMessageFunc(response) {
        return response.message;
      };
      return runByRecordId.call(this, {
        confirmMessage: confirmMessage,
        successMessageFunc: successMessageFunc,
        commandUrl: "/stopAggregationPipelineBackgroundJob/".concat(id)
      });
    },
    downloadFile: function downloadFile() {
      if (this.row.exportType !== 'db') {
        var fileId = _.get(this.row, 'file._id');
        var fileItem = {
          id: fileId
        };
        _downloadFile(fileItem);
      }
    },
    downloadFromExportsCollection: function downloadFromExportsCollection() {
      if (this.row.exportType === 'db') {
        return;
      }
      _downloadFile({
        id: this.row.file._id
      });
    },
    downloadFromFilesCollection: function downloadFromFilesCollection() {
      _downloadFile({
        id: this.row._id
      });
    },
    runDataProcessor: function runDataProcessor() {
      return _runDataProcessor.call(this, null, false);
    },
    clearDataProcessorCache: function clearDataProcessorCache() {
      var name = _.get(this, 'row.name');
      var confirmMessage = "Are you sure to clear cache for '".concat(name, "' data processor?");
      var successMessageFunc = function successMessageFunc(response) {
        return response.message;
      };
      return runByRecordId.call(this, {
        confirmMessage: confirmMessage,
        successMessageFunc: successMessageFunc,
        redirectUrl: null
      });
    },
    applyAndRunDataProcessor: function applyAndRunDataProcessor(args, formHooks, actionName) {
      return applyAndRun.call(this, args, formHooks, actionName, _runDataProcessor);
    },
    applyAndRunExternalCommand: function applyAndRunExternalCommand(args, formHooks, actionName) {
      return applyAndRun.call(this, args, formHooks, actionName, _runExternalCommand);
    },
    deleteAllRecords: function deleteAllRecords() {
      var injector = angular.element(document).injector();
      var adpModalService = injector.get('AdpModalService');
      var adpNotificationService = injector.get('AdpNotificationService');
      var $http = injector.get('$http');
      var appConfig = injector.get('APP_CONFIG');
      var adpErrorHelper = injector.get('ErrorHelpers');
      var ServerError = injector.get('ServerError');
      var confirmText = 'This operation can lead to critical consequences and cannot be undone. Are you sure?';
      var promptTitle = 'Are you totally sure to proceed?';
      var promptText = 'This action cannot be undone and all records in this collection will be irreversibly deleted. \nPlease type in the name of the COLLECTION to confirm.';
      var _this$modelSchema = this.modelSchema,
        collectionName = _this$modelSchema.collectionName,
        schemaName = _this$modelSchema.schemaName;
      return adpModalService.confirm({
        message: confirmText
      }).then(function () {
        return adpModalService.prompt({
          title: promptTitle,
          text: promptText,
          saveButtonText: 'Yes, delete all records'
        });
      }).then(function (res) {
        if (res !== collectionName) {
          adpNotificationService.notifyError('Incorrect schema name is entered');
          throw Error();
        }
        var url = "".concat(appConfig.apiUrl, "/deleteAllRecords");
        var body = {
          modelName: schemaName
        };
        return $http.post(url, body);
      }).then(function (_ref3) {
        var data = _ref3.data;
        if (!data.success) {
          throw new ServerError(data.message);
        }
        adpNotificationService.notifySuccess('Collection is cleared');
        var gridEl = $('[dx-data-grid]');
        gridEl.length && gridEl.dxDataGrid('instance').refresh();
      }).catch(function (err) {
        return err && adpErrorHelper.handleError(err);
      });
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/custom_actions.js
/* harmony default export */ const helpers_custom_actions = (function () {
  function openDatasetTab(id) {
    var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var url = id ? "/datasets/".concat(id).concat(urlParams ? '?' + urlParams : '') : '';
    url && window.open(url, '_blank');
  }
  function handleDataSourceAction(context, $event, ulrParamsBuilderFn) {
    var dataLayers = _.get(context, 'widgetDatasource');
    var isOnlyDefaultLayer = _.size(dataLayers) === 1 && _.keys(dataLayers)[0] === 'default';
    if (isOnlyDefaultLayer) {
      var id = _.get(dataLayers, 'default.datasetId');
      var urlParams = ulrParamsBuilderFn('default');
      openDatasetTab(id, urlParams);
    } else {
      var actionButtonElement = $($event.currentTarget);
      var contextMenuComponent;
      try {
        contextMenuComponent = actionButtonElement.next().dxContextMenu('instance');
      } catch (e) {}
      if (!contextMenuComponent) {
        var dataSource = _.map(dataLayers, function (_ref, dataLayerId) {
          var name = _ref.name,
            datasetId = _ref.datasetId;
          return {
            icon: 'tableproperties',
            text: name,
            dataLayerId: dataLayerId,
            id: datasetId
          };
        });
        var menuOptions = {
          dataSource: dataSource,
          position: {
            my: 'top right',
            at: 'bottom right'
          },
          target: actionButtonElement,
          onInitialized: function onInitialized(e) {
            setTimeout(function () {
              return e.component.show();
            }, 200);
          },
          onItemClick: function onItemClick(event) {
            var _event$itemData = event.itemData,
              id = _event$itemData.id,
              dataLayerId = _event$itemData.dataLayerId;
            if (id) {
              var _urlParams = ulrParamsBuilderFn(dataLayerId);
              openDatasetTab(id, _urlParams);
            }
          }
        };
        $('<div>').insertAfter(actionButtonElement).dxContextMenu(menuOptions);
      } else {
        contextMenuComponent.show();
      }
    }
  }
  var m = {
    widgetDatasource: function widgetDatasource(context, $event) {
      var ulrParamsBuilderFn = function ulrParamsBuilderFn() {
        return 'noLsFilter=true';
      };
      handleDataSourceAction(this, $event, ulrParamsBuilderFn);
    },
    showWidgetInfo: function showWidgetInfo(context, $event) {
      var $actionButtonElement = $($event.currentTarget);
      var infoContent = _.get(this, 'row.widgetRow.description');
      var width = _.get(this, 'fieldSchema.action.parameters.width', 300);
      var maxHeight = _.get(this, 'fieldSchema.action.parameters.height', 400);
      var $popover = $('<div>').insertAfter($actionButtonElement);
      var container = this.row.board ? 'div.adp-dashboard-wrapper' : 'div.adp-single-widget';
      $actionButtonElement.css({
        pointerEvents: 'none'
      });
      _.defer(function () {
        $popover.html(infoContent).dxPopover({
          container: container,
          target: $actionButtonElement,
          position: {
            my: 'bottom center',
            at: 'top center',
            collision: 'fit flip'
          },
          visible: true,
          width: width,
          maxHeight: maxHeight,
          onHidden: function onHidden() {
            $popover.remove();
            $actionButtonElement.css({
              pointerEvents: 'auto'
            });
          }
        });
      });
    },
    filteredDataset: function filteredDataset(context, $event) {
      var filterGetter = _.get(this, 'row.widgetScope.getFilterForDatalayer');
      if (!filterGetter) {
        console.warn('No filterGetter is implemented in widget');
        return;
      }
      var ulrParamsBuilderFn = function ulrParamsBuilderFn(dataLayerId) {
        var dxFilter = filterGetter(dataLayerId);
        var filterEncoded = encodeURIComponent(encodeURIComponent(JSON.stringify({
          filterBuilder: dxFilter
        })));
        return "noLsFilter=true&customOpt=".concat(filterEncoded);
      };
      handleDataSourceAction(this, $event, ulrParamsBuilderFn);
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../payment-plans/helpers/custom_actions.js
/* harmony default export */ const payment_plans_helpers_custom_actions = (function () {
  var m = {
    closeAndResultPassBy: function closeAndResultPassBy(args, formHooks) {
      formHooks.onComplete && formHooks.onComplete(args);
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./node_modules/@vvo/tzdb/raw-time-zones.json
const raw_time_zones_namespaceObject = /*#__PURE__*/JSON.parse('[{"name":"Pacific/Niue","alternativeName":"Niue Time","group":["Pacific/Niue"],"continentCode":"OC","continentName":"Oceania","countryName":"Niue","countryCode":"NU","mainCities":["Alofi"],"rawOffsetInMinutes":-660,"abbreviation":"NUT","rawFormat":"-11:00 Niue Time - Alofi"},{"name":"Pacific/Midway","alternativeName":"Samoa Time","group":["Pacific/Midway"],"continentCode":"OC","continentName":"Oceania","countryName":"United States Minor Outlying Islands","countryCode":"UM","mainCities":["Midway"],"rawOffsetInMinutes":-660,"abbreviation":"SST","rawFormat":"-11:00 Samoa Time - Midway"},{"name":"Pacific/Pago_Pago","alternativeName":"Samoa Time","group":["Pacific/Pago_Pago","US/Samoa","Pacific/Samoa","Pacific/Midway"],"continentCode":"OC","continentName":"Oceania","countryName":"American Samoa","countryCode":"AS","mainCities":["Pago Pago"],"rawOffsetInMinutes":-660,"abbreviation":"SST","rawFormat":"-11:00 Samoa Time - Pago Pago"},{"name":"Pacific/Rarotonga","alternativeName":"Cook Islands Time","group":["Pacific/Rarotonga"],"continentCode":"OC","continentName":"Oceania","countryName":"Cook Islands","countryCode":"CK","mainCities":["Avarua"],"rawOffsetInMinutes":-600,"abbreviation":"CKT","rawFormat":"-10:00 Cook Islands Time - Avarua"},{"name":"America/Adak","alternativeName":"Hawaii-Aleutian Time","group":["America/Adak","US/Aleutian","America/Atka"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Adak"],"rawOffsetInMinutes":-600,"abbreviation":"HAST","rawFormat":"-10:00 Hawaii-Aleutian Time - Adak"},{"name":"Pacific/Honolulu","alternativeName":"Hawaii-Aleutian Time","group":["Pacific/Honolulu","US/Hawaii","Pacific/Johnston"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Honolulu","East Honolulu","Pearl City","Hilo"],"rawOffsetInMinutes":-600,"abbreviation":"HAST","rawFormat":"-10:00 Hawaii-Aleutian Time - Honolulu, East Honolulu, Pearl City, Hilo"},{"name":"Pacific/Tahiti","alternativeName":"Tahiti Time","group":["Pacific/Tahiti"],"continentCode":"OC","continentName":"Oceania","countryName":"French Polynesia","countryCode":"PF","mainCities":["Faaa","Papeete","Punaauia"],"rawOffsetInMinutes":-600,"abbreviation":"TAHT","rawFormat":"-10:00 Tahiti Time - Faaa, Papeete, Punaauia"},{"name":"Pacific/Marquesas","alternativeName":"Marquesas Time","group":["Pacific/Marquesas"],"continentCode":"OC","continentName":"Oceania","countryName":"French Polynesia","countryCode":"PF","mainCities":["Marquesas"],"rawOffsetInMinutes":-570,"abbreviation":"MART","rawFormat":"-09:30 Marquesas Time - Marquesas"},{"name":"America/Anchorage","alternativeName":"Alaska Time","group":["America/Anchorage","America/Juneau","America/Metlakatla","America/Nome","America/Sitka","America/Yakutat","US/Alaska"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Anchorage","Juneau","Fairbanks","Eagle River"],"rawOffsetInMinutes":-540,"abbreviation":"AKST","rawFormat":"-09:00 Alaska Time - Anchorage, Juneau, Fairbanks, Eagle River"},{"name":"Pacific/Gambier","alternativeName":"Gambier Time","group":["Pacific/Gambier"],"continentCode":"OC","continentName":"Oceania","countryName":"French Polynesia","countryCode":"PF","mainCities":["Gambier"],"rawOffsetInMinutes":-540,"abbreviation":"GAMT","rawFormat":"-09:00 Gambier Time - Gambier"},{"name":"America/Los_Angeles","alternativeName":"Pacific Time","group":["America/Los_Angeles","US/Pacific"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Los Angeles","San Diego","San Jose","San Francisco"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pacific Time - Los Angeles, San Diego, San Jose, San Francisco"},{"name":"America/Tijuana","alternativeName":"Pacific Time","group":["America/Tijuana","Mexico/BajaNorte","America/Ensenada","America/Santa_Isabel"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Tijuana","Mexicali","Ensenada","Rosarito"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pacific Time - Tijuana, Mexicali, Ensenada, Rosarito"},{"name":"America/Vancouver","alternativeName":"Pacific Time","group":["America/Vancouver","Canada/Pacific"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Vancouver","Surrey","Okanagan","Victoria"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pacific Time - Vancouver, Surrey, Okanagan, Victoria"},{"name":"Pacific/Pitcairn","alternativeName":"Pitcairn Time","group":["Pacific/Pitcairn"],"continentCode":"OC","continentName":"Oceania","countryName":"Pitcairn","countryCode":"PN","mainCities":["Adamstown"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pitcairn Time - Adamstown"},{"name":"America/Hermosillo","alternativeName":"Mexican Pacific Time","group":["America/Hermosillo","America/Mazatlan","Mexico/BajaSur"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Hermosillo","Culiacán","Ciudad Obregón","Mazatlán"],"rawOffsetInMinutes":-420,"abbreviation":"GMT-7","rawFormat":"-07:00 Mexican Pacific Time - Hermosillo, Culiacán, Ciudad Obregón, Mazatlán"},{"name":"America/Edmonton","alternativeName":"Mountain Time","group":["America/Cambridge_Bay","America/Edmonton","America/Inuvik","America/Yellowknife","Canada/Mountain"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Calgary","Edmonton","Red Deer","Sherwood Park"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Calgary, Edmonton, Red Deer, Sherwood Park"},{"name":"America/Ciudad_Juarez","alternativeName":"Mountain Time","group":["America/Ciudad_Juarez"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Ciudad Juárez"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Ciudad Juárez"},{"name":"America/Denver","alternativeName":"Mountain Time","group":["America/Boise","America/Denver","Navajo","US/Mountain","America/Shiprock"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Denver","El Paso","Albuquerque","Colorado Springs"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Denver, El Paso, Albuquerque, Colorado Springs"},{"name":"America/Phoenix","alternativeName":"Mountain Time","group":["America/Phoenix","US/Arizona","America/Creston"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Phoenix","Tucson","Mesa","Chandler"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Phoenix, Tucson, Mesa, Chandler"},{"name":"America/Whitehorse","alternativeName":"Yukon Time","group":["America/Creston","America/Dawson","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","Canada/Yukon"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Whitehorse","Fort St. John","Creston","Dawson"],"rawOffsetInMinutes":-420,"abbreviation":"YT","rawFormat":"-07:00 Yukon Time - Whitehorse, Fort St. John, Creston, Dawson"},{"name":"America/Belize","alternativeName":"Central Time","group":["America/Belize"],"continentCode":"NA","continentName":"North America","countryName":"Belize","countryCode":"BZ","mainCities":["Belize City","San Ignacio","San Pedro","Orange Walk"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Belize City, San Ignacio, San Pedro, Orange Walk"},{"name":"America/Chicago","alternativeName":"Central Time","group":["America/Chicago","America/Indiana/Knox","America/Indiana/Tell_City","America/Menominee","America/North_Dakota/Beulah","America/North_Dakota/Center","America/North_Dakota/New_Salem","US/Central","US/Indiana-Starke","America/Knox_IN"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Chicago","Houston","San Antonio","Dallas"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Chicago, Houston, San Antonio, Dallas"},{"name":"America/Guatemala","alternativeName":"Central Time","group":["America/Guatemala"],"continentCode":"NA","continentName":"North America","countryName":"Guatemala","countryCode":"GT","mainCities":["Guatemala City","Villa Nueva","Mixco","Cobán"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Guatemala City, Villa Nueva, Mixco, Cobán"},{"name":"America/Managua","alternativeName":"Central Time","group":["America/Managua"],"continentCode":"NA","continentName":"North America","countryName":"Nicaragua","countryCode":"NI","mainCities":["Managua","León","Masaya","Chinandega"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Managua, León, Masaya, Chinandega"},{"name":"America/Mexico_City","alternativeName":"Central Time","group":["America/Bahia_Banderas","America/Chihuahua","America/Merida","America/Mexico_City","America/Monterrey","Mexico/General"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Mexico City","Iztapalapa","León de los Aldama","Puebla"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Mexico City, Iztapalapa, León de los Aldama, Puebla"},{"name":"America/Matamoros","alternativeName":"Central Time","group":["America/Matamoros","America/Ojinaga"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Reynosa","Heroica Matamoros","Nuevo Laredo","Piedras Negras"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras"},{"name":"America/Costa_Rica","alternativeName":"Central Time","group":["America/Costa_Rica"],"continentCode":"NA","continentName":"North America","countryName":"Costa Rica","countryCode":"CR","mainCities":["San José","Limón","San Francisco","Alajuela"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - San José, Limón, San Francisco, Alajuela"},{"name":"America/El_Salvador","alternativeName":"Central Time","group":["America/El_Salvador"],"continentCode":"NA","continentName":"North America","countryName":"El Salvador","countryCode":"SV","mainCities":["San Salvador","Soyapango","San Miguel","Santa Ana"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - San Salvador, Soyapango, San Miguel, Santa Ana"},{"name":"America/Regina","alternativeName":"Central Time","group":["America/Regina","America/Swift_Current","Canada/Saskatchewan"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Saskatoon","Regina","Prince Albert","Moose Jaw"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Saskatoon, Regina, Prince Albert, Moose Jaw"},{"name":"America/Tegucigalpa","alternativeName":"Central Time","group":["America/Tegucigalpa"],"continentCode":"NA","continentName":"North America","countryName":"Honduras","countryCode":"HN","mainCities":["Tegucigalpa","San Pedro Sula","La Ceiba","Choloma"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Tegucigalpa, San Pedro Sula, La Ceiba, Choloma"},{"name":"America/Winnipeg","alternativeName":"Central Time","group":["America/Rankin_Inlet","America/Resolute","America/Winnipeg","Canada/Central","America/Rainy_River"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Winnipeg","Brandon","Steinbach","Kenora"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Winnipeg, Brandon, Steinbach, Kenora"},{"name":"Pacific/Easter","alternativeName":"Easter Island Time","group":["Pacific/Easter","Chile/EasterIsland"],"continentCode":"SA","continentName":"South America","countryName":"Chile","countryCode":"CL","mainCities":["Easter"],"rawOffsetInMinutes":-360,"abbreviation":"EAST","rawFormat":"-06:00 Easter Island Time - Easter"},{"name":"Pacific/Galapagos","alternativeName":"Galapagos Time","group":["Pacific/Galapagos"],"continentCode":"SA","continentName":"South America","countryName":"Ecuador","countryCode":"EC","mainCities":["Galapagos"],"rawOffsetInMinutes":-360,"abbreviation":"GALT","rawFormat":"-06:00 Galapagos Time - Galapagos"},{"name":"America/Rio_Branco","alternativeName":"Acre Time","group":["America/Eirunepe","America/Rio_Branco","Brazil/Acre","America/Porto_Acre"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["Rio Branco","Cruzeiro do Sul","Senador Guiomard","Sena Madureira"],"rawOffsetInMinutes":-300,"abbreviation":"ACT","rawFormat":"-05:00 Acre Time - Rio Branco, Cruzeiro do Sul, Senador Guiomard, Sena Madureira"},{"name":"America/Bogota","alternativeName":"Colombia Time","group":["America/Bogota"],"continentCode":"SA","continentName":"South America","countryName":"Colombia","countryCode":"CO","mainCities":["Bogotá","Cali","Medellín","Barranquilla"],"rawOffsetInMinutes":-300,"abbreviation":"COT","rawFormat":"-05:00 Colombia Time - Bogotá, Cali, Medellín, Barranquilla"},{"name":"America/Havana","alternativeName":"Cuba Time","group":["America/Havana","Cuba"],"continentCode":"NA","continentName":"North America","countryName":"Cuba","countryCode":"CU","mainCities":["Havana","Santiago de Cuba","Camagüey","Holguín"],"rawOffsetInMinutes":-300,"abbreviation":"CST","rawFormat":"-05:00 Cuba Time - Havana, Santiago de Cuba, Camagüey, Holguín"},{"name":"America/Atikokan","alternativeName":"Eastern Time","group":["America/Atikokan"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Atikokan"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Atikokan"},{"name":"America/Cancun","alternativeName":"Eastern Time","group":["America/Cancun"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Cancún","Chetumal","Playa del Carmen","Cozumel"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Cancún, Chetumal, Playa del Carmen, Cozumel"},{"name":"America/Grand_Turk","alternativeName":"Eastern Time","group":["America/Grand_Turk"],"continentCode":"NA","continentName":"North America","countryName":"Turks and Caicos Islands","countryCode":"TC","mainCities":["Cockburn Town"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Cockburn Town"},{"name":"America/Cayman","alternativeName":"Eastern Time","group":["America/Cayman"],"continentCode":"NA","continentName":"North America","countryName":"Cayman Islands","countryCode":"KY","mainCities":["George Town","West Bay"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - George Town, West Bay"},{"name":"America/Jamaica","alternativeName":"Eastern Time","group":["America/Jamaica","Jamaica"],"continentCode":"NA","continentName":"North America","countryName":"Jamaica","countryCode":"JM","mainCities":["Kingston","New Kingston","Spanish Town","Portmore"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Kingston, New Kingston, Spanish Town, Portmore"},{"name":"America/Nassau","alternativeName":"Eastern Time","group":["America/Nassau"],"continentCode":"NA","continentName":"North America","countryName":"Bahamas","countryCode":"BS","mainCities":["Nassau","Lucaya","Freeport"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Nassau, Lucaya, Freeport"},{"name":"America/New_York","alternativeName":"Eastern Time","group":["America/Detroit","America/Indiana/Indianapolis","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Indiana/Vincennes","America/Indiana/Winamac","America/Kentucky/Louisville","America/Kentucky/Monticello","America/New_York","US/Michigan","US/East-Indiana","America/Indianapolis","America/Fort_Wayne","America/Louisville","US/Eastern"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["New York City","Brooklyn","Queens","Philadelphia"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - New York City, Brooklyn, Queens, Philadelphia"},{"name":"America/Panama","alternativeName":"Eastern Time","group":["America/Panama","America/Atikokan","America/Cayman","America/Coral_Harbour"],"continentCode":"NA","continentName":"North America","countryName":"Panama","countryCode":"PA","mainCities":["Panamá","San Miguelito","Juan Díaz","David"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Panamá, San Miguelito, Juan Díaz, David"},{"name":"America/Port-au-Prince","alternativeName":"Eastern Time","group":["America/Port-au-Prince"],"continentCode":"NA","continentName":"North America","countryName":"Haiti","countryCode":"HT","mainCities":["Port-au-Prince","Carrefour","Delmas 73","Port-de-Paix"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Port-au-Prince, Carrefour, Delmas 73, Port-de-Paix"},{"name":"America/Toronto","alternativeName":"Eastern Time","group":["America/Iqaluit","America/Toronto","America/Pangnirtung","Canada/Eastern","America/Nassau","America/Montreal","America/Nipigon","America/Thunder_Bay"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Toronto","Montréal","Ottawa","Mississauga"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Toronto, Montréal, Ottawa, Mississauga"},{"name":"America/Guayaquil","alternativeName":"Ecuador Time","group":["America/Guayaquil"],"continentCode":"SA","continentName":"South America","countryName":"Ecuador","countryCode":"EC","mainCities":["Quito","Guayaquil","Cuenca","Santo Domingo de los Colorados"],"rawOffsetInMinutes":-300,"abbreviation":"ECT","rawFormat":"-05:00 Ecuador Time - Quito, Guayaquil, Cuenca, Santo Domingo de los Colorados"},{"name":"America/Lima","alternativeName":"Peru Time","group":["America/Lima"],"continentCode":"SA","continentName":"South America","countryName":"Peru","countryCode":"PE","mainCities":["Lima","Callao","Arequipa","Trujillo"],"rawOffsetInMinutes":-300,"abbreviation":"PET","rawFormat":"-05:00 Peru Time - Lima, Callao, Arequipa, Trujillo"},{"name":"America/Manaus","alternativeName":"Amazon Time","group":["America/Boa_Vista","America/Campo_Grande","America/Cuiaba","America/Manaus","America/Porto_Velho","Brazil/West"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["Manaus","Campo Grande","Cuiabá","Porto Velho"],"rawOffsetInMinutes":-240,"abbreviation":"AMT","rawFormat":"-04:00 Amazon Time - Manaus, Campo Grande, Cuiabá, Porto Velho"},{"name":"America/St_Kitts","alternativeName":"Atlantic Time","group":["America/St_Kitts"],"continentCode":"NA","continentName":"North America","countryName":"Saint Kitts and Nevis","countryCode":"KN","mainCities":["Basseterre"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Basseterre"},{"name":"America/Blanc-Sablon","alternativeName":"Atlantic Time","group":["America/Blanc-Sablon"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Blanc-Sablon"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Blanc-Sablon"},{"name":"America/Montserrat","alternativeName":"Atlantic Time","group":["America/Montserrat"],"continentCode":"NA","continentName":"North America","countryName":"Montserrat","countryCode":"MS","mainCities":["Brades","Plymouth"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Brades, Plymouth"},{"name":"America/Barbados","alternativeName":"Atlantic Time","group":["America/Barbados"],"continentCode":"NA","continentName":"North America","countryName":"Barbados","countryCode":"BB","mainCities":["Bridgetown"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Bridgetown"},{"name":"America/St_Lucia","alternativeName":"Atlantic Time","group":["America/St_Lucia"],"continentCode":"NA","continentName":"North America","countryName":"Saint Lucia","countryCode":"LC","mainCities":["Castries"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Castries"},{"name":"America/Port_of_Spain","alternativeName":"Atlantic Time","group":["America/Port_of_Spain"],"continentCode":"NA","continentName":"North America","countryName":"Trinidad and Tobago","countryCode":"TT","mainCities":["Chaguanas","Mon Repos","San Fernando","Port of Spain"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Chaguanas, Mon Repos, San Fernando, Port of Spain"},{"name":"America/Martinique","alternativeName":"Atlantic Time","group":["America/Martinique"],"continentCode":"NA","continentName":"North America","countryName":"Martinique","countryCode":"MQ","mainCities":["Fort-de-France","Le Lamentin","Le Robert","Sainte-Marie"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie"},{"name":"America/St_Barthelemy","alternativeName":"Atlantic Time","group":["America/St_Barthelemy"],"continentCode":"NA","continentName":"North America","countryName":"Saint Barthelemy","countryCode":"BL","mainCities":["Gustavia"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Gustavia"},{"name":"America/Halifax","alternativeName":"Atlantic Time","group":["America/Glace_Bay","America/Goose_Bay","America/Halifax","America/Moncton","Canada/Atlantic"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Halifax","Moncton","Sydney","Dartmouth"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Halifax, Moncton, Sydney, Dartmouth"},{"name":"Atlantic/Bermuda","alternativeName":"Atlantic Time","group":["Atlantic/Bermuda"],"continentCode":"NA","continentName":"North America","countryName":"Bermuda","countryCode":"BM","mainCities":["Hamilton"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Hamilton"},{"name":"America/St_Vincent","alternativeName":"Atlantic Time","group":["America/St_Vincent"],"continentCode":"NA","continentName":"North America","countryName":"Saint Vincent and the Grenadines","countryCode":"VC","mainCities":["Kingstown"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Kingstown"},{"name":"America/Kralendijk","alternativeName":"Atlantic Time","group":["America/Kralendijk"],"continentCode":"NA","continentName":"North America","countryName":"Bonaire, Saint Eustatius and Saba ","countryCode":"BQ","mainCities":["Kralendijk"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Kralendijk"},{"name":"America/Guadeloupe","alternativeName":"Atlantic Time","group":["America/Guadeloupe"],"continentCode":"NA","continentName":"North America","countryName":"Guadeloupe","countryCode":"GP","mainCities":["Les Abymes","Baie-Mahault","Le Gosier","Petit-Bourg"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg"},{"name":"America/Marigot","alternativeName":"Atlantic Time","group":["America/Marigot"],"continentCode":"NA","continentName":"North America","countryName":"Saint Martin","countryCode":"MF","mainCities":["Marigot"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Marigot"},{"name":"America/Aruba","alternativeName":"Atlantic Time","group":["America/Aruba"],"continentCode":"NA","continentName":"North America","countryName":"Aruba","countryCode":"AW","mainCities":["Oranjestad","Tanki Leendert","San Nicolas"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Oranjestad, Tanki Leendert, San Nicolas"},{"name":"America/Lower_Princes","alternativeName":"Atlantic Time","group":["America/Lower_Princes"],"continentCode":"NA","continentName":"North America","countryName":"Sint Maarten","countryCode":"SX","mainCities":["Philipsburg"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Philipsburg"},{"name":"America/Tortola","alternativeName":"Atlantic Time","group":["America/Tortola"],"continentCode":"NA","continentName":"North America","countryName":"British Virgin Islands","countryCode":"VG","mainCities":["Road Town"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Road Town"},{"name":"America/Dominica","alternativeName":"Atlantic Time","group":["America/Dominica"],"continentCode":"NA","continentName":"North America","countryName":"Dominica","countryCode":"DM","mainCities":["Roseau"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Roseau"},{"name":"America/St_Thomas","alternativeName":"Atlantic Time","group":["America/St_Thomas"],"continentCode":"NA","continentName":"North America","countryName":"U.S. Virgin Islands","countryCode":"VI","mainCities":["Saint Croix","Charlotte Amalie"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Saint Croix, Charlotte Amalie"},{"name":"America/Grenada","alternativeName":"Atlantic Time","group":["America/Grenada"],"continentCode":"NA","continentName":"North America","countryName":"Grenada","countryCode":"GD","mainCities":["Saint George\'s"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Saint George\'s"},{"name":"America/Antigua","alternativeName":"Atlantic Time","group":["America/Antigua"],"continentCode":"NA","continentName":"North America","countryName":"Antigua and Barbuda","countryCode":"AG","mainCities":["Saint John’s"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Saint John’s"},{"name":"America/Puerto_Rico","alternativeName":"Atlantic Time","group":["America/Puerto_Rico","America/Virgin","America/Anguilla","America/Antigua","America/Aruba","America/Blanc-Sablon","America/Curacao","America/Dominica","America/Grenada","America/Guadeloupe","America/Kralendijk","America/Lower_Princes","America/Marigot","America/Montserrat","America/Port_of_Spain","America/St_Barthelemy","America/St_Kitts","America/St_Lucia","America/St_Thomas","America/St_Vincent","America/Tortola"],"continentCode":"NA","continentName":"North America","countryName":"Puerto Rico","countryCode":"PR","mainCities":["San Juan","Bayamón","Carolina","Ponce"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - San Juan, Bayamón, Carolina, Ponce"},{"name":"America/Santo_Domingo","alternativeName":"Atlantic Time","group":["America/Santo_Domingo"],"continentCode":"NA","continentName":"North America","countryName":"Dominican Republic","countryCode":"DO","mainCities":["Santo Domingo","Santiago de los Caballeros","Santo Domingo Oeste","Santo Domingo Este"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este"},{"name":"America/Anguilla","alternativeName":"Atlantic Time","group":["America/Anguilla"],"continentCode":"NA","continentName":"North America","countryName":"Anguilla","countryCode":"AI","mainCities":["The Valley"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - The Valley"},{"name":"America/Thule","alternativeName":"Atlantic Time","group":["America/Thule"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Thule"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Thule"},{"name":"America/Curacao","alternativeName":"Atlantic Time","group":["America/Curacao"],"continentCode":"NA","continentName":"North America","countryName":"Curacao","countryCode":"CW","mainCities":["Willemstad"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Willemstad"},{"name":"America/La_Paz","alternativeName":"Bolivia Time","group":["America/La_Paz"],"continentCode":"SA","continentName":"South America","countryName":"Bolivia","countryCode":"BO","mainCities":["La Paz","Santa Cruz de la Sierra","Cochabamba","Sucre"],"rawOffsetInMinutes":-240,"abbreviation":"BOT","rawFormat":"-04:00 Bolivia Time - La Paz, Santa Cruz de la Sierra, Cochabamba, Sucre"},{"name":"America/Santiago","alternativeName":"Chile Time","group":["America/Santiago","Chile/Continental"],"continentCode":"SA","continentName":"South America","countryName":"Chile","countryCode":"CL","mainCities":["Santiago","Puente Alto","Antofagasta","Viña del Mar"],"rawOffsetInMinutes":-240,"abbreviation":"CLT","rawFormat":"-04:00 Chile Time - Santiago, Puente Alto, Antofagasta, Viña del Mar"},{"name":"America/Guyana","alternativeName":"Guyana Time","group":["America/Guyana"],"continentCode":"SA","continentName":"South America","countryName":"Guyana","countryCode":"GY","mainCities":["Georgetown","Linden","New Amsterdam"],"rawOffsetInMinutes":-240,"abbreviation":"GYT","rawFormat":"-04:00 Guyana Time - Georgetown, Linden, New Amsterdam"},{"name":"America/Asuncion","alternativeName":"Paraguay Time","group":["America/Asuncion"],"continentCode":"SA","continentName":"South America","countryName":"Paraguay","countryCode":"PY","mainCities":["Asunción","Ciudad del Este","San Lorenzo","Capiatá"],"rawOffsetInMinutes":-240,"abbreviation":"PYT","rawFormat":"-04:00 Paraguay Time - Asunción, Ciudad del Este, San Lorenzo, Capiatá"},{"name":"America/Caracas","alternativeName":"Venezuela Time","group":["America/Caracas"],"continentCode":"SA","continentName":"South America","countryName":"Venezuela","countryCode":"VE","mainCities":["Caracas","Maracaibo","Maracay","Valencia"],"rawOffsetInMinutes":-240,"abbreviation":"VET","rawFormat":"-04:00 Venezuela Time - Caracas, Maracaibo, Maracay, Valencia"},{"name":"America/St_Johns","alternativeName":"Newfoundland Time","group":["America/St_Johns","Canada/Newfoundland"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["St. John\'s","Mount Pearl","Corner Brook","Conception Bay South"],"rawOffsetInMinutes":-210,"abbreviation":"NST","rawFormat":"-03:30 Newfoundland Time - St. John\'s, Mount Pearl, Corner Brook, Conception Bay South"},{"name":"America/Argentina/Buenos_Aires","alternativeName":"Argentina Time","group":["America/Argentina/Buenos_Aires","America/Argentina/Catamarca","America/Argentina/Cordoba","America/Argentina/Jujuy","America/Argentina/La_Rioja","America/Argentina/Mendoza","America/Argentina/Rio_Gallegos","America/Argentina/Salta","America/Argentina/San_Juan","America/Argentina/San_Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Buenos_Aires","America/Catamarca","America/Argentina/ComodRivadavia","America/Cordoba","America/Rosario","America/Jujuy","America/Mendoza"],"continentCode":"SA","continentName":"South America","countryName":"Argentina","countryCode":"AR","mainCities":["Buenos Aires","Córdoba","Rosario","Mar del Plata"],"rawOffsetInMinutes":-180,"abbreviation":"ART","rawFormat":"-03:00 Argentina Time - Buenos Aires, Córdoba, Rosario, Mar del Plata"},{"name":"America/Sao_Paulo","alternativeName":"Brasilia Time","group":["America/Araguaina","America/Bahia","America/Belem","America/Fortaleza","America/Maceio","America/Recife","America/Santarem","America/Sao_Paulo","Brazil/East"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["São Paulo","Rio de Janeiro","Belo Horizonte","Salvador"],"rawOffsetInMinutes":-180,"abbreviation":"BRT","rawFormat":"-03:00 Brasilia Time - São Paulo, Rio de Janeiro, Belo Horizonte, Salvador"},{"name":"Antarctica/Palmer","alternativeName":"Chile Time","group":["Antarctica/Palmer","Antarctica/Rothera"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Palmer","Rothera"],"rawOffsetInMinutes":-180,"abbreviation":"CLT","rawFormat":"-03:00 Chile Time - Palmer, Rothera"},{"name":"America/Punta_Arenas","alternativeName":"Chile Time","group":["America/Punta_Arenas"],"continentCode":"SA","continentName":"South America","countryName":"Chile","countryCode":"CL","mainCities":["Punta Arenas","Puerto Natales"],"rawOffsetInMinutes":-180,"abbreviation":"CLT","rawFormat":"-03:00 Chile Time - Punta Arenas, Puerto Natales"},{"name":"Atlantic/Stanley","alternativeName":"Falkland Islands Time","group":["Atlantic/Stanley"],"continentCode":"SA","continentName":"South America","countryName":"Falkland Islands","countryCode":"FK","mainCities":["Stanley"],"rawOffsetInMinutes":-180,"abbreviation":"FKST","rawFormat":"-03:00 Falkland Islands Time - Stanley"},{"name":"America/Cayenne","alternativeName":"French Guiana Time","group":["America/Cayenne"],"continentCode":"SA","continentName":"South America","countryName":"French Guiana","countryCode":"GF","mainCities":["Cayenne","Matoury","Saint-Laurent-du-Maroni","Kourou"],"rawOffsetInMinutes":-180,"abbreviation":"GFT","rawFormat":"-03:00 French Guiana Time - Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou"},{"name":"America/Miquelon","alternativeName":"St. Pierre & Miquelon Time","group":["America/Miquelon"],"continentCode":"NA","continentName":"North America","countryName":"Saint Pierre and Miquelon","countryCode":"PM","mainCities":["Saint-Pierre"],"rawOffsetInMinutes":-180,"abbreviation":"PM","rawFormat":"-03:00 St. Pierre & Miquelon Time - Saint-Pierre"},{"name":"America/Paramaribo","alternativeName":"Suriname Time","group":["America/Paramaribo"],"continentCode":"SA","continentName":"South America","countryName":"Suriname","countryCode":"SR","mainCities":["Paramaribo","Lelydorp"],"rawOffsetInMinutes":-180,"abbreviation":"SRT","rawFormat":"-03:00 Suriname Time - Paramaribo, Lelydorp"},{"name":"America/Montevideo","alternativeName":"Uruguay Time","group":["America/Montevideo"],"continentCode":"SA","continentName":"South America","countryName":"Uruguay","countryCode":"UY","mainCities":["Montevideo","Salto","Paysandú","Las Piedras"],"rawOffsetInMinutes":-180,"abbreviation":"UYT","rawFormat":"-03:00 Uruguay Time - Montevideo, Salto, Paysandú, Las Piedras"},{"name":"America/Noronha","alternativeName":"Fernando de Noronha Time","group":["America/Noronha","Brazil/DeNoronha"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["Noronha"],"rawOffsetInMinutes":-120,"abbreviation":"FNT","rawFormat":"-02:00 Fernando de Noronha Time - Noronha"},{"name":"Atlantic/South_Georgia","alternativeName":"South Georgia Time","group":["Atlantic/South_Georgia"],"continentCode":"AN","continentName":"Antarctica","countryName":"South Georgia and the South Sandwich Islands","countryCode":"GS","mainCities":["Grytviken"],"rawOffsetInMinutes":-120,"abbreviation":"GST","rawFormat":"-02:00 South Georgia Time - Grytviken"},{"name":"America/Nuuk","alternativeName":"West Greenland Time","group":["America/Nuuk","America/Godthab"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Nuuk"],"rawOffsetInMinutes":-120,"abbreviation":"WGT","rawFormat":"-02:00 West Greenland Time - Nuuk"},{"name":"Atlantic/Azores","alternativeName":"Azores Time","group":["Atlantic/Azores"],"continentCode":"EU","continentName":"Europe","countryName":"Portugal","countryCode":"PT","mainCities":["Ponta Delgada"],"rawOffsetInMinutes":-60,"abbreviation":"AZOT","rawFormat":"-01:00 Azores Time - Ponta Delgada"},{"name":"Atlantic/Cape_Verde","alternativeName":"Cape Verde Time","group":["Atlantic/Cape_Verde"],"continentCode":"AF","continentName":"Africa","countryName":"Cabo Verde","countryCode":"CV","mainCities":["Praia","Mindelo","Espargos","Assomada"],"rawOffsetInMinutes":-60,"abbreviation":"CVT","rawFormat":"-01:00 Cape Verde Time - Praia, Mindelo, Espargos, Assomada"},{"name":"America/Scoresbysund","alternativeName":"East Greenland Time","group":["America/Scoresbysund"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Scoresbysund"],"rawOffsetInMinutes":-60,"abbreviation":"EGT","rawFormat":"-01:00 East Greenland Time - Scoresbysund"},{"name":"Africa/Abidjan","alternativeName":"Greenwich Mean Time","group":["Africa/Abidjan","Iceland","Africa/Accra","Africa/Bamako","Africa/Banjul","Africa/Conakry","Africa/Dakar","Africa/Freetown","Africa/Lome","Africa/Nouakchott","Africa/Ouagadougou","Atlantic/Reykjavik","Atlantic/St_Helena","Africa/Timbuktu"],"continentCode":"AF","continentName":"Africa","countryName":"Ivory Coast","countryCode":"CI","mainCities":["Abidjan","Abobo","Bouaké","Korhogo"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Abidjan, Abobo, Bouaké, Korhogo"},{"name":"Africa/Bamako","alternativeName":"Greenwich Mean Time","group":["Africa/Bamako"],"continentCode":"AF","continentName":"Africa","countryName":"Mali","countryCode":"ML","mainCities":["Bamako","Ségou","Sikasso","Mopti"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Bamako, Ségou, Sikasso, Mopti"},{"name":"Africa/Bissau","alternativeName":"Greenwich Mean Time","group":["Africa/Bissau"],"continentCode":"AF","continentName":"Africa","countryName":"Guinea-Bissau","countryCode":"GW","mainCities":["Bissau","Gabú","Bafatá"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Bissau, Gabú, Bafatá"},{"name":"Africa/Conakry","alternativeName":"Greenwich Mean Time","group":["Africa/Conakry"],"continentCode":"AF","continentName":"Africa","countryName":"Guinea","countryCode":"GN","mainCities":["Conakry","Camayenne","Nzérékoré","Kankan"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Conakry, Camayenne, Nzérékoré, Kankan"},{"name":"Africa/Dakar","alternativeName":"Greenwich Mean Time","group":["Africa/Dakar"],"continentCode":"AF","continentName":"Africa","countryName":"Senegal","countryCode":"SN","mainCities":["Dakar","Pikine","Touba","Thiès"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Dakar, Pikine, Touba, Thiès"},{"name":"America/Danmarkshavn","alternativeName":"Greenwich Mean Time","group":["America/Danmarkshavn"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Danmarkshavn"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Danmarkshavn"},{"name":"Europe/Isle_of_Man","alternativeName":"Greenwich Mean Time","group":["Europe/Isle_of_Man"],"continentCode":"EU","continentName":"Europe","countryName":"Isle of Man","countryCode":"IM","mainCities":["Douglas"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Douglas"},{"name":"Europe/Dublin","alternativeName":"Greenwich Mean Time","group":["Europe/Dublin","Eire"],"continentCode":"EU","continentName":"Europe","countryName":"Ireland","countryCode":"IE","mainCities":["Dublin","South Dublin","Cork","Limerick"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Dublin, South Dublin, Cork, Limerick"},{"name":"Africa/Freetown","alternativeName":"Greenwich Mean Time","group":["Africa/Freetown"],"continentCode":"AF","continentName":"Africa","countryName":"Sierra Leone","countryCode":"SL","mainCities":["Freetown","Bo","Kenema","Koidu"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Freetown, Bo, Kenema, Koidu"},{"name":"Atlantic/St_Helena","alternativeName":"Greenwich Mean Time","group":["Atlantic/St_Helena"],"continentCode":"AF","continentName":"Africa","countryName":"Saint Helena","countryCode":"SH","mainCities":["Jamestown"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Jamestown"},{"name":"Africa/Accra","alternativeName":"Greenwich Mean Time","group":["Africa/Accra"],"continentCode":"AF","continentName":"Africa","countryName":"Ghana","countryCode":"GH","mainCities":["Kumasi","Accra","Tamale","Takoradi"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Kumasi, Accra, Tamale, Takoradi"},{"name":"Africa/Lome","alternativeName":"Greenwich Mean Time","group":["Africa/Lome"],"continentCode":"AF","continentName":"Africa","countryName":"Togo","countryCode":"TG","mainCities":["Lomé","Sokodé","Kara","Atakpamé"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Lomé, Sokodé, Kara, Atakpamé"},{"name":"Europe/London","alternativeName":"Greenwich Mean Time","group":["Europe/London","GB","GB-Eire","Europe/Guernsey","Europe/Isle_of_Man","Europe/Jersey","Europe/Belfast"],"continentCode":"EU","continentName":"Europe","countryName":"United Kingdom","countryCode":"GB","mainCities":["London","Birmingham","Liverpool","Glasgow"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - London, Birmingham, Liverpool, Glasgow"},{"name":"Africa/Monrovia","alternativeName":"Greenwich Mean Time","group":["Africa/Monrovia"],"continentCode":"AF","continentName":"Africa","countryName":"Liberia","countryCode":"LR","mainCities":["Monrovia","Gbarnga","Buchanan","Kakata"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Monrovia, Gbarnga, Buchanan, Kakata"},{"name":"Africa/Nouakchott","alternativeName":"Greenwich Mean Time","group":["Africa/Nouakchott"],"continentCode":"AF","continentName":"Africa","countryName":"Mauritania","countryCode":"MR","mainCities":["Nouakchott","Nouadhibou","Dar Naim","Néma"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Nouakchott, Nouadhibou, Dar Naim, Néma"},{"name":"Africa/Ouagadougou","alternativeName":"Greenwich Mean Time","group":["Africa/Ouagadougou"],"continentCode":"AF","continentName":"Africa","countryName":"Burkina Faso","countryCode":"BF","mainCities":["Ouagadougou","Bobo-Dioulasso","Koudougou","Saaba"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Ouagadougou, Bobo-Dioulasso, Koudougou, Saaba"},{"name":"Atlantic/Reykjavik","alternativeName":"Greenwich Mean Time","group":["Atlantic/Reykjavik","Iceland"],"continentCode":"EU","continentName":"Europe","countryName":"Iceland","countryCode":"IS","mainCities":["Reykjavík","Kópavogur","Hafnarfjörður","Reykjanesbær"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Reykjavík, Kópavogur, Hafnarfjörður, Reykjanesbær"},{"name":"Europe/Jersey","alternativeName":"Greenwich Mean Time","group":["Europe/Jersey"],"continentCode":"EU","continentName":"Europe","countryName":"Jersey","countryCode":"JE","mainCities":["Saint Helier"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Saint Helier"},{"name":"Europe/Guernsey","alternativeName":"Greenwich Mean Time","group":["Europe/Guernsey"],"continentCode":"EU","continentName":"Europe","countryName":"Guernsey","countryCode":"GG","mainCities":["Saint Peter Port"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Saint Peter Port"},{"name":"Africa/Banjul","alternativeName":"Greenwich Mean Time","group":["Africa/Banjul"],"continentCode":"AF","continentName":"Africa","countryName":"Gambia","countryCode":"GM","mainCities":["Serekunda","Brikama","Bununka Kunda","Sukuta"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Serekunda, Brikama, Bununka Kunda, Sukuta"},{"name":"Africa/Sao_Tome","alternativeName":"Greenwich Mean Time","group":["Africa/Sao_Tome"],"continentCode":"AF","continentName":"Africa","countryName":"Sao Tome and Principe","countryCode":"ST","mainCities":["São Tomé"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - São Tomé"},{"name":"Antarctica/Troll","alternativeName":"Greenwich Mean Time","group":["Antarctica/Troll"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Troll"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Troll"},{"name":"Africa/Casablanca","alternativeName":"Western European Time","group":["Africa/Casablanca"],"continentCode":"AF","continentName":"Africa","countryName":"Morocco","countryCode":"MA","mainCities":["Casablanca","Rabat","Fès","Sale"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Casablanca, Rabat, Fès, Sale"},{"name":"Africa/El_Aaiun","alternativeName":"Western European Time","group":["Africa/El_Aaiun"],"continentCode":"AF","continentName":"Africa","countryName":"Western Sahara","countryCode":"EH","mainCities":["Laayoune","Dakhla","Boujdour"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Laayoune, Dakhla, Boujdour"},{"name":"Atlantic/Canary","alternativeName":"Western European Time","group":["Atlantic/Canary"],"continentCode":"EU","continentName":"Europe","countryName":"Spain","countryCode":"ES","mainCities":["Las Palmas de Gran Canaria","Santa Cruz de Tenerife","La Laguna","Telde"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde"},{"name":"Europe/Lisbon","alternativeName":"Western European Time","group":["Atlantic/Madeira","Europe/Lisbon","Portugal"],"continentCode":"EU","continentName":"Europe","countryName":"Portugal","countryCode":"PT","mainCities":["Lisbon","Porto","Amadora","Braga"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Lisbon, Porto, Amadora, Braga"},{"name":"Atlantic/Faroe","alternativeName":"Western European Time","group":["Atlantic/Faroe","Atlantic/Faeroe"],"continentCode":"EU","continentName":"Europe","countryName":"Faroe Islands","countryCode":"FO","mainCities":["Tórshavn"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Tórshavn"},{"name":"Africa/Windhoek","alternativeName":"Central Africa Time","group":["Africa/Windhoek"],"continentCode":"AF","continentName":"Africa","countryName":"Namibia","countryCode":"NA","mainCities":["Windhoek","Rundu","Walvis Bay","Oshakati"],"rawOffsetInMinutes":60,"abbreviation":"CAT","rawFormat":"+01:00 Central Africa Time - Windhoek, Rundu, Walvis Bay, Oshakati"},{"name":"Africa/Algiers","alternativeName":"Central European Time","group":["Africa/Algiers"],"continentCode":"AF","continentName":"Africa","countryName":"Algeria","countryCode":"DZ","mainCities":["Algiers","Oran","Constantine","Annaba"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Algiers, Oran, Constantine, Annaba"},{"name":"Europe/Amsterdam","alternativeName":"Central European Time","group":["Europe/Amsterdam"],"continentCode":"EU","continentName":"Europe","countryName":"The Netherlands","countryCode":"NL","mainCities":["Amsterdam","Rotterdam","The Hague","Utrecht"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Amsterdam, Rotterdam, The Hague, Utrecht"},{"name":"Europe/Andorra","alternativeName":"Central European Time","group":["Europe/Andorra"],"continentCode":"EU","continentName":"Europe","countryName":"Andorra","countryCode":"AD","mainCities":["Andorra la Vella","les Escaldes"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Andorra la Vella, les Escaldes"},{"name":"Europe/Belgrade","alternativeName":"Central European Time","group":["Europe/Belgrade","Europe/Ljubljana","Europe/Podgorica","Europe/Sarajevo","Europe/Skopje","Europe/Zagreb"],"continentCode":"EU","continentName":"Europe","countryName":"Serbia","countryCode":"RS","mainCities":["Belgrade","Niš","Novi Sad","Zemun"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Belgrade, Niš, Novi Sad, Zemun"},{"name":"Europe/Berlin","alternativeName":"Central European Time","group":["Europe/Berlin","Europe/Busingen","Arctic/Longyearbyen","Europe/Copenhagen","Europe/Oslo","Europe/Stockholm","Atlantic/Jan_Mayen"],"continentCode":"EU","continentName":"Europe","countryName":"Germany","countryCode":"DE","mainCities":["Berlin","Hamburg","Munich","Köln"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Berlin, Hamburg, Munich, Köln"},{"name":"Europe/Bratislava","alternativeName":"Central European Time","group":["Europe/Bratislava"],"continentCode":"EU","continentName":"Europe","countryName":"Slovakia","countryCode":"SK","mainCities":["Bratislava","Košice","Nitra","Prešov"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Bratislava, Košice, Nitra, Prešov"},{"name":"Europe/Brussels","alternativeName":"Central European Time","group":["Europe/Brussels","Europe/Amsterdam","Europe/Luxembourg"],"continentCode":"EU","continentName":"Europe","countryName":"Belgium","countryCode":"BE","mainCities":["Brussels","Antwerpen","Gent","Charleroi"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Brussels, Antwerpen, Gent, Charleroi"},{"name":"Europe/Budapest","alternativeName":"Central European Time","group":["Europe/Budapest"],"continentCode":"EU","continentName":"Europe","countryName":"Hungary","countryCode":"HU","mainCities":["Budapest","Debrecen","Szeged","Miskolc"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Budapest, Debrecen, Szeged, Miskolc"},{"name":"Europe/Copenhagen","alternativeName":"Central European Time","group":["Europe/Copenhagen"],"continentCode":"EU","continentName":"Europe","countryName":"Denmark","countryCode":"DK","mainCities":["Copenhagen","Århus","Odense","Aalborg"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Copenhagen, Århus, Odense, Aalborg"},{"name":"Europe/Gibraltar","alternativeName":"Central European Time","group":["Europe/Gibraltar"],"continentCode":"EU","continentName":"Europe","countryName":"Gibraltar","countryCode":"GI","mainCities":["Gibraltar"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Gibraltar"},{"name":"Europe/Ljubljana","alternativeName":"Central European Time","group":["Europe/Ljubljana"],"continentCode":"EU","continentName":"Europe","countryName":"Slovenia","countryCode":"SI","mainCities":["Ljubljana","Maribor","Kranj","Celje"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Ljubljana, Maribor, Kranj, Celje"},{"name":"Arctic/Longyearbyen","alternativeName":"Central European Time","group":["Arctic/Longyearbyen"],"continentCode":"EU","continentName":"Europe","countryName":"Svalbard and Jan Mayen","countryCode":"SJ","mainCities":["Longyearbyen"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Longyearbyen"},{"name":"Europe/Luxembourg","alternativeName":"Central European Time","group":["Europe/Luxembourg"],"continentCode":"EU","continentName":"Europe","countryName":"Luxembourg","countryCode":"LU","mainCities":["Luxembourg","Esch-sur-Alzette","Dudelange"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Luxembourg, Esch-sur-Alzette, Dudelange"},{"name":"Europe/Madrid","alternativeName":"Central European Time","group":["Africa/Ceuta","Europe/Madrid"],"continentCode":"EU","continentName":"Europe","countryName":"Spain","countryCode":"ES","mainCities":["Madrid","Barcelona","Valencia","Sevilla"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Madrid, Barcelona, Valencia, Sevilla"},{"name":"Europe/Monaco","alternativeName":"Central European Time","group":["Europe/Monaco"],"continentCode":"EU","continentName":"Europe","countryName":"Monaco","countryCode":"MC","mainCities":["Monaco","Monte-Carlo"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Monaco, Monte-Carlo"},{"name":"Europe/Oslo","alternativeName":"Central European Time","group":["Europe/Oslo","Atlantic/Jan_Mayen"],"continentCode":"EU","continentName":"Europe","countryName":"Norway","countryCode":"NO","mainCities":["Oslo","Bergen","Trondheim","Stavanger"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Oslo, Bergen, Trondheim, Stavanger"},{"name":"Europe/Paris","alternativeName":"Central European Time","group":["Europe/Paris","Europe/Monaco"],"continentCode":"EU","continentName":"Europe","countryName":"France","countryCode":"FR","mainCities":["Paris","Marseille","Lyon","Toulouse"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Paris, Marseille, Lyon, Toulouse"},{"name":"Europe/Podgorica","alternativeName":"Central European Time","group":["Europe/Podgorica"],"continentCode":"EU","continentName":"Europe","countryName":"Montenegro","countryCode":"ME","mainCities":["Podgorica","Nikšić","Herceg Novi","Pljevlja"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Podgorica, Nikšić, Herceg Novi, Pljevlja"},{"name":"Europe/Prague","alternativeName":"Central European Time","group":["Europe/Prague","Europe/Bratislava"],"continentCode":"EU","continentName":"Europe","countryName":"Czechia","countryCode":"CZ","mainCities":["Prague","Brno","Ostrava","Pilsen"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Prague, Brno, Ostrava, Pilsen"},{"name":"Europe/Rome","alternativeName":"Central European Time","group":["Europe/Rome","Europe/San_Marino","Europe/Vatican"],"continentCode":"EU","continentName":"Europe","countryName":"Italy","countryCode":"IT","mainCities":["Rome","Milan","Naples","Turin"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Rome, Milan, Naples, Turin"},{"name":"Europe/San_Marino","alternativeName":"Central European Time","group":["Europe/San_Marino"],"continentCode":"EU","continentName":"Europe","countryName":"San Marino","countryCode":"SM","mainCities":["San Marino"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - San Marino"},{"name":"Europe/Malta","alternativeName":"Central European Time","group":["Europe/Malta"],"continentCode":"EU","continentName":"Europe","countryName":"Malta","countryCode":"MT","mainCities":["San Pawl il-Baħar","Birkirkara","Mosta","Sliema"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - San Pawl il-Baħar, Birkirkara, Mosta, Sliema"},{"name":"Europe/Sarajevo","alternativeName":"Central European Time","group":["Europe/Sarajevo"],"continentCode":"EU","continentName":"Europe","countryName":"Bosnia and Herzegovina","countryCode":"BA","mainCities":["Sarajevo","Banja Luka","Zenica","Tuzla"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Sarajevo, Banja Luka, Zenica, Tuzla"},{"name":"Europe/Skopje","alternativeName":"Central European Time","group":["Europe/Skopje"],"continentCode":"EU","continentName":"Europe","countryName":"North Macedonia","countryCode":"MK","mainCities":["Skopje","Kumanovo","Prilep","Bitola"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Skopje, Kumanovo, Prilep, Bitola"},{"name":"Europe/Stockholm","alternativeName":"Central European Time","group":["Europe/Stockholm"],"continentCode":"EU","continentName":"Europe","countryName":"Sweden","countryCode":"SE","mainCities":["Stockholm","Göteborg","Malmö","Uppsala"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Stockholm, Göteborg, Malmö, Uppsala"},{"name":"Europe/Tirane","alternativeName":"Central European Time","group":["Europe/Tirane"],"continentCode":"EU","continentName":"Europe","countryName":"Albania","countryCode":"AL","mainCities":["Tirana","Durrës","Elbasan","Vlorë"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Tirana, Durrës, Elbasan, Vlorë"},{"name":"Africa/Tunis","alternativeName":"Central European Time","group":["Africa/Tunis"],"continentCode":"AF","continentName":"Africa","countryName":"Tunisia","countryCode":"TN","mainCities":["Tunis","Sfax","Sousse","Kairouan"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Tunis, Sfax, Sousse, Kairouan"},{"name":"Europe/Vaduz","alternativeName":"Central European Time","group":["Europe/Vaduz"],"continentCode":"EU","continentName":"Europe","countryName":"Liechtenstein","countryCode":"LI","mainCities":["Vaduz"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Vaduz"},{"name":"Europe/Vatican","alternativeName":"Central European Time","group":["Europe/Vatican"],"continentCode":"EU","continentName":"Europe","countryName":"Vatican","countryCode":"VA","mainCities":["Vatican City"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Vatican City"},{"name":"Europe/Vienna","alternativeName":"Central European Time","group":["Europe/Vienna"],"continentCode":"EU","continentName":"Europe","countryName":"Austria","countryCode":"AT","mainCities":["Vienna","Graz","Linz","Favoriten"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Vienna, Graz, Linz, Favoriten"},{"name":"Europe/Warsaw","alternativeName":"Central European Time","group":["Europe/Warsaw","Poland"],"continentCode":"EU","continentName":"Europe","countryName":"Poland","countryCode":"PL","mainCities":["Warsaw","Łódź","Kraków","Wrocław"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Warsaw, Łódź, Kraków, Wrocław"},{"name":"Europe/Zagreb","alternativeName":"Central European Time","group":["Europe/Zagreb"],"continentCode":"EU","continentName":"Europe","countryName":"Croatia","countryCode":"HR","mainCities":["Zagreb","Split","Rijeka","Osijek"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Zagreb, Split, Rijeka, Osijek"},{"name":"Europe/Zurich","alternativeName":"Central European Time","group":["Europe/Zurich","Europe/Busingen","Europe/Vaduz"],"continentCode":"EU","continentName":"Europe","countryName":"Switzerland","countryCode":"CH","mainCities":["Zürich","Genève","Basel","Lausanne"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Zürich, Genève, Basel, Lausanne"},{"name":"Africa/Bangui","alternativeName":"West Africa Time","group":["Africa/Bangui"],"continentCode":"AF","continentName":"Africa","countryName":"Central African Republic","countryCode":"CF","mainCities":["Bangui","Bimbo","Bégoua","Carnot"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Bangui, Bimbo, Bégoua, Carnot"},{"name":"Africa/Malabo","alternativeName":"West Africa Time","group":["Africa/Malabo"],"continentCode":"AF","continentName":"Africa","countryName":"Equatorial Guinea","countryCode":"GQ","mainCities":["Bata","Malabo","Ebebiyin"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Bata, Malabo, Ebebiyin"},{"name":"Africa/Brazzaville","alternativeName":"West Africa Time","group":["Africa/Brazzaville"],"continentCode":"AF","continentName":"Africa","countryName":"Republic of the Congo","countryCode":"CG","mainCities":["Brazzaville","Pointe-Noire","Dolisie","Nkayi"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Brazzaville, Pointe-Noire, Dolisie, Nkayi"},{"name":"Africa/Porto-Novo","alternativeName":"West Africa Time","group":["Africa/Porto-Novo"],"continentCode":"AF","continentName":"Africa","countryName":"Benin","countryCode":"BJ","mainCities":["Cotonou","Abomey-Calavi","Porto-Novo","Parakou"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Cotonou, Abomey-Calavi, Porto-Novo, Parakou"},{"name":"Africa/Douala","alternativeName":"West Africa Time","group":["Africa/Douala"],"continentCode":"AF","continentName":"Africa","countryName":"Cameroon","countryCode":"CM","mainCities":["Douala","Yaoundé","Bamenda","Bafoussam"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Douala, Yaoundé, Bamenda, Bafoussam"},{"name":"Africa/Kinshasa","alternativeName":"West Africa Time","group":["Africa/Kinshasa"],"continentCode":"AF","continentName":"Africa","countryName":"Democratic Republic of the Congo","countryCode":"CD","mainCities":["Kinshasa","Kikwit","Masina","Mbandaka"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Kinshasa, Kikwit, Masina, Mbandaka"},{"name":"Africa/Lagos","alternativeName":"West Africa Time","group":["Africa/Lagos","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Africa/Kinshasa","Africa/Libreville","Africa/Luanda","Africa/Malabo","Africa/Niamey","Africa/Porto-Novo"],"continentCode":"AF","continentName":"Africa","countryName":"Nigeria","countryCode":"NG","mainCities":["Lagos","Kano","Ibadan","Port Harcourt"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Lagos, Kano, Ibadan, Port Harcourt"},{"name":"Africa/Libreville","alternativeName":"West Africa Time","group":["Africa/Libreville"],"continentCode":"AF","continentName":"Africa","countryName":"Gabon","countryCode":"GA","mainCities":["Libreville","Port-Gentil","Franceville","Owendo"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Libreville, Port-Gentil, Franceville, Owendo"},{"name":"Africa/Luanda","alternativeName":"West Africa Time","group":["Africa/Luanda"],"continentCode":"AF","continentName":"Africa","countryName":"Angola","countryCode":"AO","mainCities":["Luanda","Lubango","Huambo","Benguela"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Luanda, Lubango, Huambo, Benguela"},{"name":"Africa/Ndjamena","alternativeName":"West Africa Time","group":["Africa/Ndjamena"],"continentCode":"AF","continentName":"Africa","countryName":"Chad","countryCode":"TD","mainCities":["N\'Djamena","Moundou","Abéché","Sarh"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - N\'Djamena, Moundou, Abéché, Sarh"},{"name":"Africa/Niamey","alternativeName":"West Africa Time","group":["Africa/Niamey"],"continentCode":"AF","continentName":"Africa","countryName":"Niger","countryCode":"NE","mainCities":["Niamey","Zinder","Maradi","Agadez"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Niamey, Zinder, Maradi, Agadez"},{"name":"Africa/Bujumbura","alternativeName":"Central Africa Time","group":["Africa/Bujumbura"],"continentCode":"AF","continentName":"Africa","countryName":"Burundi","countryCode":"BI","mainCities":["Bujumbura","Gitega","Ngozi","Rumonge"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Bujumbura, Gitega, Ngozi, Rumonge"},{"name":"Africa/Gaborone","alternativeName":"Central Africa Time","group":["Africa/Gaborone"],"continentCode":"AF","continentName":"Africa","countryName":"Botswana","countryCode":"BW","mainCities":["Gaborone","Francistown","Mogoditshane","Maun"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Gaborone, Francistown, Mogoditshane, Maun"},{"name":"Africa/Harare","alternativeName":"Central Africa Time","group":["Africa/Harare"],"continentCode":"AF","continentName":"Africa","countryName":"Zimbabwe","countryCode":"ZW","mainCities":["Harare","Bulawayo","Chitungwiza","Mutare"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Harare, Bulawayo, Chitungwiza, Mutare"},{"name":"Africa/Juba","alternativeName":"Central Africa Time","group":["Africa/Juba"],"continentCode":"AF","continentName":"Africa","countryName":"South Sudan","countryCode":"SS","mainCities":["Juba","Winejok","Yei","Malakal"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Juba, Winejok, Yei, Malakal"},{"name":"Africa/Khartoum","alternativeName":"Central Africa Time","group":["Africa/Khartoum"],"continentCode":"AF","continentName":"Africa","countryName":"Sudan","countryCode":"SD","mainCities":["Khartoum","Omdurman","Nyala","Port Sudan"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Khartoum, Omdurman, Nyala, Port Sudan"},{"name":"Africa/Kigali","alternativeName":"Central Africa Time","group":["Africa/Kigali"],"continentCode":"AF","continentName":"Africa","countryName":"Rwanda","countryCode":"RW","mainCities":["Kigali","Gisenyi","Butare","Gitarama"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Kigali, Gisenyi, Butare, Gitarama"},{"name":"Africa/Blantyre","alternativeName":"Central Africa Time","group":["Africa/Blantyre"],"continentCode":"AF","continentName":"Africa","countryName":"Malawi","countryCode":"MW","mainCities":["Lilongwe","Blantyre","Mzuzu","Zomba"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Lilongwe, Blantyre, Mzuzu, Zomba"},{"name":"Africa/Lubumbashi","alternativeName":"Central Africa Time","group":["Africa/Lubumbashi"],"continentCode":"AF","continentName":"Africa","countryName":"Democratic Republic of the Congo","countryCode":"CD","mainCities":["Lubumbashi","Mbuji-Mayi","Kananga","Kisangani"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Lubumbashi, Mbuji-Mayi, Kananga, Kisangani"},{"name":"Africa/Lusaka","alternativeName":"Central Africa Time","group":["Africa/Lusaka"],"continentCode":"AF","continentName":"Africa","countryName":"Zambia","countryCode":"ZM","mainCities":["Lusaka","Ndola","Kitwe","Chipata"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Lusaka, Ndola, Kitwe, Chipata"},{"name":"Africa/Maputo","alternativeName":"Central Africa Time","group":["Africa/Maputo","Africa/Blantyre","Africa/Bujumbura","Africa/Gaborone","Africa/Harare","Africa/Kigali","Africa/Lubumbashi","Africa/Lusaka"],"continentCode":"AF","continentName":"Africa","countryName":"Mozambique","countryCode":"MZ","mainCities":["Maputo","Matola","Nampula","Beira"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Maputo, Matola, Nampula, Beira"},{"name":"Europe/Athens","alternativeName":"Eastern European Time","group":["Europe/Athens"],"continentCode":"EU","continentName":"Europe","countryName":"Greece","countryCode":"GR","mainCities":["Athens","Thessaloníki","Pátra","Piraeus"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Athens, Thessaloníki, Pátra, Piraeus"},{"name":"Asia/Beirut","alternativeName":"Eastern European Time","group":["Asia/Beirut"],"continentCode":"AS","continentName":"Asia","countryName":"Lebanon","countryCode":"LB","mainCities":["Beirut","Ra’s Bayrūt","Tripoli","Sidon"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Beirut, Ra’s Bayrūt, Tripoli, Sidon"},{"name":"Europe/Bucharest","alternativeName":"Eastern European Time","group":["Europe/Bucharest"],"continentCode":"EU","continentName":"Europe","countryName":"Romania","countryCode":"RO","mainCities":["Bucharest","Sector 3","Iaşi","Sector 6"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Bucharest, Sector 3, Iaşi, Sector 6"},{"name":"Africa/Cairo","alternativeName":"Eastern European Time","group":["Africa/Cairo","Egypt"],"continentCode":"AF","continentName":"Africa","countryName":"Egypt","countryCode":"EG","mainCities":["Cairo","Alexandria","Giza","Shubrā al Khaymah"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Cairo, Alexandria, Giza, Shubrā al Khaymah"},{"name":"Europe/Chisinau","alternativeName":"Eastern European Time","group":["Europe/Chisinau","Europe/Tiraspol"],"continentCode":"EU","continentName":"Europe","countryName":"Moldova","countryCode":"MD","mainCities":["Chisinau","Tiraspol","Bălţi","Bender"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Chisinau, Tiraspol, Bălţi, Bender"},{"name":"Asia/Hebron","alternativeName":"Eastern European Time","group":["Asia/Gaza","Asia/Hebron"],"continentCode":"AS","continentName":"Asia","countryName":"Palestinian Territory","countryCode":"PS","mainCities":["East Jerusalem","Gaza","Khān Yūnis","Jabālyā"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - East Jerusalem, Gaza, Khān Yūnis, Jabālyā"},{"name":"Europe/Helsinki","alternativeName":"Eastern European Time","group":["Europe/Helsinki","Europe/Mariehamn"],"continentCode":"EU","continentName":"Europe","countryName":"Finland","countryCode":"FI","mainCities":["Helsinki","Espoo","Tampere","Oulu"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Helsinki, Espoo, Tampere, Oulu"},{"name":"Europe/Kaliningrad","alternativeName":"Eastern European Time","group":["Europe/Kaliningrad"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Kaliningrad","Chernyakhovsk","Sovetsk","Baltiysk"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk"},{"name":"Europe/Kyiv","alternativeName":"Eastern European Time","group":["Europe/Kyiv","Europe/Uzhgorod","Europe/Zaporozhye","Europe/Kiev"],"continentCode":"EU","continentName":"Europe","countryName":"Ukraine","countryCode":"UA","mainCities":["Kyiv","Kharkiv","Odesa","Dnipro"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Kyiv, Kharkiv, Odesa, Dnipro"},{"name":"Europe/Mariehamn","alternativeName":"Eastern European Time","group":["Europe/Mariehamn"],"continentCode":"EU","continentName":"Europe","countryName":"Aland Islands","countryCode":"AX","mainCities":["Mariehamn"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Mariehamn"},{"name":"Asia/Nicosia","alternativeName":"Eastern European Time","group":["Asia/Famagusta","Asia/Nicosia","Europe/Nicosia"],"continentCode":"EU","continentName":"Europe","countryName":"Cyprus","countryCode":"CY","mainCities":["Nicosia","Limassol","Larnaca","Stróvolos"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Nicosia, Limassol, Larnaca, Stróvolos"},{"name":"Europe/Riga","alternativeName":"Eastern European Time","group":["Europe/Riga"],"continentCode":"EU","continentName":"Europe","countryName":"Latvia","countryCode":"LV","mainCities":["Riga","Daugavpils","Liepāja","Jelgava"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Riga, Daugavpils, Liepāja, Jelgava"},{"name":"Europe/Sofia","alternativeName":"Eastern European Time","group":["Europe/Sofia"],"continentCode":"EU","continentName":"Europe","countryName":"Bulgaria","countryCode":"BG","mainCities":["Sofia","Plovdiv","Varna","Burgas"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Sofia, Plovdiv, Varna, Burgas"},{"name":"Europe/Tallinn","alternativeName":"Eastern European Time","group":["Europe/Tallinn"],"continentCode":"EU","continentName":"Europe","countryName":"Estonia","countryCode":"EE","mainCities":["Tallinn","Tartu","Narva","Pärnu"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Tallinn, Tartu, Narva, Pärnu"},{"name":"Africa/Tripoli","alternativeName":"Eastern European Time","group":["Africa/Tripoli","Libya"],"continentCode":"AF","continentName":"Africa","countryName":"Libya","countryCode":"LY","mainCities":["Tripoli","Benghazi","Misratah","Zliten"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Tripoli, Benghazi, Misratah, Zliten"},{"name":"Europe/Vilnius","alternativeName":"Eastern European Time","group":["Europe/Vilnius"],"continentCode":"EU","continentName":"Europe","countryName":"Lithuania","countryCode":"LT","mainCities":["Vilnius","Kaunas","Klaipėda","Šiauliai"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Vilnius, Kaunas, Klaipėda, Šiauliai"},{"name":"Asia/Jerusalem","alternativeName":"Israel Time","group":["Asia/Jerusalem","Israel","Asia/Tel_Aviv"],"continentCode":"AS","continentName":"Asia","countryName":"Israel","countryCode":"IL","mainCities":["Jerusalem","Tel Aviv","West Jerusalem","Haifa"],"rawOffsetInMinutes":120,"abbreviation":"IST","rawFormat":"+02:00 Israel Time - Jerusalem, Tel Aviv, West Jerusalem, Haifa"},{"name":"Africa/Johannesburg","alternativeName":"South Africa Time","group":["Africa/Johannesburg","Africa/Maseru","Africa/Mbabane"],"continentCode":"AF","continentName":"Africa","countryName":"South Africa","countryCode":"ZA","mainCities":["Johannesburg","Cape Town","Durban","Soweto"],"rawOffsetInMinutes":120,"abbreviation":"SAST","rawFormat":"+02:00 South Africa Time - Johannesburg, Cape Town, Durban, Soweto"},{"name":"Africa/Mbabane","alternativeName":"South Africa Time","group":["Africa/Mbabane"],"continentCode":"AF","continentName":"Africa","countryName":"Eswatini","countryCode":"SZ","mainCities":["Manzini","Mbabane","Lobamba"],"rawOffsetInMinutes":120,"abbreviation":"SAST","rawFormat":"+02:00 South Africa Time - Manzini, Mbabane, Lobamba"},{"name":"Africa/Maseru","alternativeName":"South Africa Time","group":["Africa/Maseru"],"continentCode":"AF","continentName":"Africa","countryName":"Lesotho","countryCode":"LS","mainCities":["Maseru","Maputsoe","Mohale\'s Hoek","Mafeteng"],"rawOffsetInMinutes":120,"abbreviation":"SAST","rawFormat":"+02:00 South Africa Time - Maseru, Maputsoe, Mohale\'s Hoek, Mafeteng"},{"name":"Asia/Kuwait","alternativeName":"Arabian Time","group":["Asia/Kuwait"],"continentCode":"AS","continentName":"Asia","countryName":"Kuwait","countryCode":"KW","mainCities":["Al Aḩmadī","Ḩawallī","As Sālimīyah","Şabāḩ as Sālim"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Al Aḩmadī, Ḩawallī, As Sālimīyah, Şabāḩ as Sālim"},{"name":"Asia/Bahrain","alternativeName":"Arabian Time","group":["Asia/Bahrain"],"continentCode":"AS","continentName":"Asia","countryName":"Bahrain","countryCode":"BH","mainCities":["Ar Rifā‘","Manama","Al Muharraq","Dār Kulayb"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Ar Rifā‘, Manama, Al Muharraq, Dār Kulayb"},{"name":"Asia/Baghdad","alternativeName":"Arabian Time","group":["Asia/Baghdad"],"continentCode":"AS","continentName":"Asia","countryName":"Iraq","countryCode":"IQ","mainCities":["Baghdad","Al Mawşil al Jadīdah","Al Başrah al Qadīmah","Mosul"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Baghdad, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul"},{"name":"Asia/Qatar","alternativeName":"Arabian Time","group":["Asia/Qatar","Asia/Bahrain"],"continentCode":"AS","continentName":"Asia","countryName":"Qatar","countryCode":"QA","mainCities":["Doha","Ar Rayyān","Umm Şalāl Muḩammad","Al Wakrah"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Doha, Ar Rayyān, Umm Şalāl Muḩammad, Al Wakrah"},{"name":"Asia/Riyadh","alternativeName":"Arabian Time","group":["Asia/Riyadh","Antarctica/Syowa","Asia/Aden","Asia/Kuwait"],"continentCode":"AS","continentName":"Asia","countryName":"Saudi Arabia","countryCode":"SA","mainCities":["Jeddah","Riyadh","Mecca","Medina"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Jeddah, Riyadh, Mecca, Medina"},{"name":"Asia/Aden","alternativeName":"Arabian Time","group":["Asia/Aden"],"continentCode":"AS","continentName":"Asia","countryName":"Yemen","countryCode":"YE","mainCities":["Sanaa","Aden","Al Ḩudaydah","Taiz"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Sanaa, Aden, Al Ḩudaydah, Taiz"},{"name":"Asia/Amman","alternativeName":"Asia/Amman","group":["Asia/Amman"],"continentCode":"AS","continentName":"Asia","countryName":"Jordan","countryCode":"JO","mainCities":["Amman","Zarqa","Irbid","Russeifa"],"rawOffsetInMinutes":180,"abbreviation":"GMT+3","rawFormat":"+03:00 Asia/Amman - Amman, Zarqa, Irbid, Russeifa"},{"name":"Asia/Damascus","alternativeName":"Asia/Damascus","group":["Asia/Damascus"],"continentCode":"AS","continentName":"Asia","countryName":"Syria","countryCode":"SY","mainCities":["Aleppo","Damascus","Homs","Latakia"],"rawOffsetInMinutes":180,"abbreviation":"GMT+3","rawFormat":"+03:00 Asia/Damascus - Aleppo, Damascus, Homs, Latakia"},{"name":"Africa/Addis_Ababa","alternativeName":"East Africa Time","group":["Africa/Addis_Ababa"],"continentCode":"AF","continentName":"Africa","countryName":"Ethiopia","countryCode":"ET","mainCities":["Addis Ababa","Jijiga","Gonder","Mek\'ele"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Addis Ababa, Jijiga, Gonder, Mek\'ele"},{"name":"Indian/Antananarivo","alternativeName":"East Africa Time","group":["Indian/Antananarivo"],"continentCode":"AF","continentName":"Africa","countryName":"Madagascar","countryCode":"MG","mainCities":["Antananarivo","Toamasina","Antsirabe","Mahajanga"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Antananarivo, Toamasina, Antsirabe, Mahajanga"},{"name":"Africa/Asmara","alternativeName":"East Africa Time","group":["Africa/Asmara"],"continentCode":"AF","continentName":"Africa","countryName":"Eritrea","countryCode":"ER","mainCities":["Asmara","Keren","Himora","Massawa"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Asmara, Keren, Himora, Massawa"},{"name":"Africa/Dar_es_Salaam","alternativeName":"East Africa Time","group":["Africa/Dar_es_Salaam"],"continentCode":"AF","continentName":"Africa","countryName":"Tanzania","countryCode":"TZ","mainCities":["Dar es Salaam","Mwanza","Arusha","Mbeya"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Dar es Salaam, Mwanza, Arusha, Mbeya"},{"name":"Africa/Djibouti","alternativeName":"East Africa Time","group":["Africa/Djibouti"],"continentCode":"AF","continentName":"Africa","countryName":"Djibouti","countryCode":"DJ","mainCities":["Djibouti","Ali Sabih","Dikhil","Tadjoura"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Djibouti, Ali Sabih, Dikhil, Tadjoura"},{"name":"Africa/Kampala","alternativeName":"East Africa Time","group":["Africa/Kampala"],"continentCode":"AF","continentName":"Africa","countryName":"Uganda","countryCode":"UG","mainCities":["Kampala","Gulu","Lira","Mbarara"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Kampala, Gulu, Lira, Mbarara"},{"name":"Indian/Mayotte","alternativeName":"East Africa Time","group":["Indian/Mayotte"],"continentCode":"AF","continentName":"Africa","countryName":"Mayotte","countryCode":"YT","mainCities":["Mamoudzou","Koungou","Dzaoudzi"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Mamoudzou, Koungou, Dzaoudzi"},{"name":"Africa/Mogadishu","alternativeName":"East Africa Time","group":["Africa/Mogadishu"],"continentCode":"AF","continentName":"Africa","countryName":"Somalia","countryCode":"SO","mainCities":["Mogadishu","Borama","Hargeysa","Berbera"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Mogadishu, Borama, Hargeysa, Berbera"},{"name":"Indian/Comoro","alternativeName":"East Africa Time","group":["Indian/Comoro"],"continentCode":"AF","continentName":"Africa","countryName":"Comoros","countryCode":"KM","mainCities":["Moroni","Moutsamoudou","Fomboni"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Moroni, Moutsamoudou, Fomboni"},{"name":"Africa/Nairobi","alternativeName":"East Africa Time","group":["Africa/Nairobi","Africa/Addis_Ababa","Africa/Asmara","Africa/Dar_es_Salaam","Africa/Djibouti","Africa/Kampala","Africa/Mogadishu","Indian/Antananarivo","Indian/Comoro","Indian/Mayotte","Africa/Asmera"],"continentCode":"AF","continentName":"Africa","countryName":"Kenya","countryCode":"KE","mainCities":["Nairobi","Kakamega","Mombasa","Nakuru"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Nairobi, Kakamega, Mombasa, Nakuru"},{"name":"Europe/Minsk","alternativeName":"Moscow Time","group":["Europe/Minsk"],"continentCode":"EU","continentName":"Europe","countryName":"Belarus","countryCode":"BY","mainCities":["Minsk","Homyel\'","Hrodna","Mahilyow"],"rawOffsetInMinutes":180,"abbreviation":"MSK","rawFormat":"+03:00 Moscow Time - Minsk, Homyel\', Hrodna, Mahilyow"},{"name":"Europe/Moscow","alternativeName":"Moscow Time","group":["Europe/Kirov","Europe/Moscow","Europe/Volgograd","W-SU"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Moscow","Saint Petersburg","Nizhniy Novgorod","Kazan"],"rawOffsetInMinutes":180,"abbreviation":"MSK","rawFormat":"+03:00 Moscow Time - Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan"},{"name":"Europe/Simferopol","alternativeName":"Moscow Time","group":["Europe/Simferopol"],"continentCode":"EU","continentName":"Europe","countryName":"Ukraine","countryCode":"UA","mainCities":["Sevastopol","Simferopol","Kerch","Yevpatoriya"],"rawOffsetInMinutes":180,"abbreviation":"MSK","rawFormat":"+03:00 Moscow Time - Sevastopol, Simferopol, Kerch, Yevpatoriya"},{"name":"Antarctica/Syowa","alternativeName":"Syowa Time","group":["Antarctica/Syowa"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Syowa"],"rawOffsetInMinutes":180,"abbreviation":"SYOT","rawFormat":"+03:00 Syowa Time - Syowa"},{"name":"Europe/Istanbul","alternativeName":"Turkey Time","group":["Europe/Istanbul","Turkey","Asia/Istanbul"],"continentCode":"AS","continentName":"Asia","countryName":"Turkey","countryCode":"TR","mainCities":["Istanbul","Ankara","Bursa","İzmir"],"rawOffsetInMinutes":180,"abbreviation":"TRT","rawFormat":"+03:00 Turkey Time - Istanbul, Ankara, Bursa, İzmir"},{"name":"Asia/Tehran","alternativeName":"Iran Time","group":["Asia/Tehran","Iran"],"continentCode":"AS","continentName":"Asia","countryName":"Iran","countryCode":"IR","mainCities":["Tehran","Mashhad","Isfahan","Karaj"],"rawOffsetInMinutes":210,"abbreviation":"IRST","rawFormat":"+03:30 Iran Time - Tehran, Mashhad, Isfahan, Karaj"},{"name":"Asia/Yerevan","alternativeName":"Armenia Time","group":["Asia/Yerevan"],"continentCode":"AS","continentName":"Asia","countryName":"Armenia","countryCode":"AM","mainCities":["Yerevan","Gyumri","Vanadzor","Vagharshapat"],"rawOffsetInMinutes":240,"abbreviation":"AMT","rawFormat":"+04:00 Armenia Time - Yerevan, Gyumri, Vanadzor, Vagharshapat"},{"name":"Asia/Baku","alternativeName":"Azerbaijan Time","group":["Asia/Baku"],"continentCode":"AS","continentName":"Asia","countryName":"Azerbaijan","countryCode":"AZ","mainCities":["Baku","Sumqayıt","Ganja","Lankaran"],"rawOffsetInMinutes":240,"abbreviation":"AZT","rawFormat":"+04:00 Azerbaijan Time - Baku, Sumqayıt, Ganja, Lankaran"},{"name":"Asia/Tbilisi","alternativeName":"Georgia Time","group":["Asia/Tbilisi"],"continentCode":"AS","continentName":"Asia","countryName":"Georgia","countryCode":"GE","mainCities":["Tbilisi","Batumi","Kutaisi","Rustavi"],"rawOffsetInMinutes":240,"abbreviation":"GET","rawFormat":"+04:00 Georgia Time - Tbilisi, Batumi, Kutaisi, Rustavi"},{"name":"Asia/Dubai","alternativeName":"Gulf Time","group":["Asia/Dubai","Asia/Muscat","Indian/Mahe","Indian/Reunion"],"continentCode":"AS","continentName":"Asia","countryName":"United Arab Emirates","countryCode":"AE","mainCities":["Dubai","Abu Dhabi","Sharjah","Al Ain City"],"rawOffsetInMinutes":240,"abbreviation":"GST","rawFormat":"+04:00 Gulf Time - Dubai, Abu Dhabi, Sharjah, Al Ain City"},{"name":"Asia/Muscat","alternativeName":"Gulf Time","group":["Asia/Muscat"],"continentCode":"AS","continentName":"Asia","countryName":"Oman","countryCode":"OM","mainCities":["Muscat","Seeb","Bawshar","‘Ibrī"],"rawOffsetInMinutes":240,"abbreviation":"GST","rawFormat":"+04:00 Gulf Time - Muscat, Seeb, Bawshar, ‘Ibrī"},{"name":"Indian/Mauritius","alternativeName":"Mauritius Time","group":["Indian/Mauritius"],"continentCode":"AF","continentName":"Africa","countryName":"Mauritius","countryCode":"MU","mainCities":["Port Louis","Vacoas","Beau Bassin-Rose Hill","Curepipe"],"rawOffsetInMinutes":240,"abbreviation":"MUT","rawFormat":"+04:00 Mauritius Time - Port Louis, Vacoas, Beau Bassin-Rose Hill, Curepipe"},{"name":"Indian/Reunion","alternativeName":"Réunion Time","group":["Indian/Reunion"],"continentCode":"AF","continentName":"Africa","countryName":"Reunion","countryCode":"RE","mainCities":["Saint-Denis","Saint-Paul","Le Tampon","Saint-Pierre"],"rawOffsetInMinutes":240,"abbreviation":"RET","rawFormat":"+04:00 Réunion Time - Saint-Denis, Saint-Paul, Le Tampon, Saint-Pierre"},{"name":"Europe/Samara","alternativeName":"Samara Time","group":["Europe/Astrakhan","Europe/Samara","Europe/Saratov","Europe/Ulyanovsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Samara","Saratov","Tolyatti","Izhevsk"],"rawOffsetInMinutes":240,"abbreviation":"SAMT","rawFormat":"+04:00 Samara Time - Samara, Saratov, Tolyatti, Izhevsk"},{"name":"Indian/Mahe","alternativeName":"Seychelles Time","group":["Indian/Mahe"],"continentCode":"AF","continentName":"Africa","countryName":"Seychelles","countryCode":"SC","mainCities":["Victoria"],"rawOffsetInMinutes":240,"abbreviation":"SCT","rawFormat":"+04:00 Seychelles Time - Victoria"},{"name":"Asia/Kabul","alternativeName":"Afghanistan Time","group":["Asia/Kabul"],"continentCode":"AS","continentName":"Asia","countryName":"Afghanistan","countryCode":"AF","mainCities":["Kabul","Herāt","Mazār-e Sharīf","Kandahār"],"rawOffsetInMinutes":270,"abbreviation":"AFT","rawFormat":"+04:30 Afghanistan Time - Kabul, Herāt, Mazār-e Sharīf, Kandahār"},{"name":"Indian/Kerguelen","alternativeName":"French Southern & Antarctic Time","group":["Indian/Kerguelen"],"continentCode":"AN","continentName":"Antarctica","countryName":"French Southern Territories","countryCode":"TF","mainCities":["Port-aux-Français"],"rawOffsetInMinutes":300,"abbreviation":"FSAT","rawFormat":"+05:00 French Southern & Antarctic Time - Port-aux-Français"},{"name":"Indian/Maldives","alternativeName":"Maldives Time","group":["Indian/Maldives","Indian/Kerguelen"],"continentCode":"AS","continentName":"Asia","countryName":"Maldives","countryCode":"MV","mainCities":["Male"],"rawOffsetInMinutes":300,"abbreviation":"MVT","rawFormat":"+05:00 Maldives Time - Male"},{"name":"Antarctica/Mawson","alternativeName":"Mawson Time","group":["Antarctica/Mawson"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Mawson"],"rawOffsetInMinutes":300,"abbreviation":"MAWT","rawFormat":"+05:00 Mawson Time - Mawson"},{"name":"Asia/Karachi","alternativeName":"Pakistan Time","group":["Asia/Karachi"],"continentCode":"AS","continentName":"Asia","countryName":"Pakistan","countryCode":"PK","mainCities":["Karachi","Lahore","Faisalabad","Rawalpindi"],"rawOffsetInMinutes":300,"abbreviation":"PKT","rawFormat":"+05:00 Pakistan Time - Karachi, Lahore, Faisalabad, Rawalpindi"},{"name":"Asia/Dushanbe","alternativeName":"Tajikistan Time","group":["Asia/Dushanbe"],"continentCode":"AS","continentName":"Asia","countryName":"Tajikistan","countryCode":"TJ","mainCities":["Dushanbe","Isfara","Istaravshan","Kŭlob"],"rawOffsetInMinutes":300,"abbreviation":"TJT","rawFormat":"+05:00 Tajikistan Time - Dushanbe, Isfara, Istaravshan, Kŭlob"},{"name":"Asia/Ashgabat","alternativeName":"Turkmenistan Time","group":["Asia/Ashgabat","Asia/Ashkhabad"],"continentCode":"AS","continentName":"Asia","countryName":"Turkmenistan","countryCode":"TM","mainCities":["Ashgabat","Türkmenabat","Daşoguz","Mary"],"rawOffsetInMinutes":300,"abbreviation":"TMT","rawFormat":"+05:00 Turkmenistan Time - Ashgabat, Türkmenabat, Daşoguz, Mary"},{"name":"Asia/Tashkent","alternativeName":"Uzbekistan Time","group":["Asia/Samarkand","Asia/Tashkent"],"continentCode":"AS","continentName":"Asia","countryName":"Uzbekistan","countryCode":"UZ","mainCities":["Tashkent","Namangan","Samarkand","Andijon"],"rawOffsetInMinutes":300,"abbreviation":"UZT","rawFormat":"+05:00 Uzbekistan Time - Tashkent, Namangan, Samarkand, Andijon"},{"name":"Asia/Aqtobe","alternativeName":"West Kazakhstan Time","group":["Asia/Aqtau","Asia/Aqtobe","Asia/Atyrau","Asia/Oral","Asia/Qyzylorda"],"continentCode":"AS","continentName":"Asia","countryName":"Kazakhstan","countryCode":"KZ","mainCities":["Aktobe","Kyzylorda","Oral","Atyrau"],"rawOffsetInMinutes":300,"abbreviation":"AQTT","rawFormat":"+05:00 West Kazakhstan Time - Aktobe, Kyzylorda, Oral, Atyrau"},{"name":"Asia/Yekaterinburg","alternativeName":"Yekaterinburg Time","group":["Asia/Yekaterinburg"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Yekaterinburg","Chelyabinsk","Ufa","Perm"],"rawOffsetInMinutes":300,"abbreviation":"YEKT","rawFormat":"+05:00 Yekaterinburg Time - Yekaterinburg, Chelyabinsk, Ufa, Perm"},{"name":"Asia/Colombo","alternativeName":"India Time","group":["Asia/Colombo"],"continentCode":"AS","continentName":"Asia","countryName":"Sri Lanka","countryCode":"LK","mainCities":["Colombo","Dehiwala-Mount Lavinia","Maharagama","Jaffna"],"rawOffsetInMinutes":330,"abbreviation":"IST","rawFormat":"+05:30 India Time - Colombo, Dehiwala-Mount Lavinia, Maharagama, Jaffna"},{"name":"Asia/Kolkata","alternativeName":"India Time","group":["Asia/Kolkata","Asia/Calcutta"],"continentCode":"AS","continentName":"Asia","countryName":"India","countryCode":"IN","mainCities":["Mumbai","Delhi","Bengaluru","Hyderābād"],"rawOffsetInMinutes":330,"abbreviation":"IST","rawFormat":"+05:30 India Time - Mumbai, Delhi, Bengaluru, Hyderābād"},{"name":"Asia/Kathmandu","alternativeName":"Nepal Time","group":["Asia/Kathmandu","Asia/Katmandu"],"continentCode":"AS","continentName":"Asia","countryName":"Nepal","countryCode":"NP","mainCities":["Kathmandu","Bharatpur","Pātan","Birgañj"],"rawOffsetInMinutes":345,"abbreviation":"NPT","rawFormat":"+05:45 Nepal Time - Kathmandu, Bharatpur, Pātan, Birgañj"},{"name":"Asia/Dhaka","alternativeName":"Bangladesh Time","group":["Asia/Dhaka","Asia/Dacca"],"continentCode":"AS","continentName":"Asia","countryName":"Bangladesh","countryCode":"BD","mainCities":["Dhaka","Chattogram","Khulna","Rangpur"],"rawOffsetInMinutes":360,"abbreviation":"BST","rawFormat":"+06:00 Bangladesh Time - Dhaka, Chattogram, Khulna, Rangpur"},{"name":"Asia/Thimphu","alternativeName":"Bhutan Time","group":["Asia/Thimphu","Asia/Thimbu"],"continentCode":"AS","continentName":"Asia","countryName":"Bhutan","countryCode":"BT","mainCities":["Thimphu","Phuntsholing","Tsirang","Punākha"],"rawOffsetInMinutes":360,"abbreviation":"BTT","rawFormat":"+06:00 Bhutan Time - Thimphu, Phuntsholing, Tsirang, Punākha"},{"name":"Asia/Urumqi","alternativeName":"China Time","group":["Asia/Urumqi","Asia/Kashgar"],"continentCode":"AS","continentName":"Asia","countryName":"China","countryCode":"CN","mainCities":["Ürümqi","Shihezi","Korla","Aksu"],"rawOffsetInMinutes":360,"abbreviation":"CST","rawFormat":"+06:00 China Time - Ürümqi, Shihezi, Korla, Aksu"},{"name":"Asia/Almaty","alternativeName":"East Kazakhstan Time","group":["Asia/Almaty","Asia/Qostanay"],"continentCode":"AS","continentName":"Asia","countryName":"Kazakhstan","countryCode":"KZ","mainCities":["Almaty","Shymkent","Karagandy","Taraz"],"rawOffsetInMinutes":360,"abbreviation":"ALMT","rawFormat":"+06:00 East Kazakhstan Time - Almaty, Shymkent, Karagandy, Taraz"},{"name":"Indian/Chagos","alternativeName":"Indian Ocean Time","group":["Indian/Chagos"],"continentCode":"AS","continentName":"Asia","countryName":"British Indian Ocean Territory","countryCode":"IO","mainCities":["Chagos"],"rawOffsetInMinutes":360,"abbreviation":"IOT","rawFormat":"+06:00 Indian Ocean Time - Chagos"},{"name":"Asia/Bishkek","alternativeName":"Kyrgyzstan Time","group":["Asia/Bishkek"],"continentCode":"AS","continentName":"Asia","countryName":"Kyrgyzstan","countryCode":"KG","mainCities":["Bishkek","Osh","Jalal-Abad","Karakol"],"rawOffsetInMinutes":360,"abbreviation":"KGT","rawFormat":"+06:00 Kyrgyzstan Time - Bishkek, Osh, Jalal-Abad, Karakol"},{"name":"Asia/Omsk","alternativeName":"Omsk Time","group":["Asia/Omsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Omsk","Tara","Kalachinsk"],"rawOffsetInMinutes":360,"abbreviation":"OMST","rawFormat":"+06:00 Omsk Time - Omsk, Tara, Kalachinsk"},{"name":"Antarctica/Vostok","alternativeName":"Vostok Time","group":["Antarctica/Vostok"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Vostok"],"rawOffsetInMinutes":360,"abbreviation":"VOST","rawFormat":"+06:00 Vostok Time - Vostok"},{"name":"Indian/Cocos","alternativeName":"Cocos Islands Time","group":["Indian/Cocos"],"continentCode":"AS","continentName":"Asia","countryName":"Cocos Islands","countryCode":"CC","mainCities":["West Island"],"rawOffsetInMinutes":390,"abbreviation":"CCT","rawFormat":"+06:30 Cocos Islands Time - West Island"},{"name":"Asia/Yangon","alternativeName":"Myanmar Time","group":["Asia/Yangon","Indian/Cocos","Asia/Rangoon"],"continentCode":"AS","continentName":"Asia","countryName":"Myanmar","countryCode":"MM","mainCities":["Yangon","Mandalay","Nay Pyi Taw","Mawlamyine"],"rawOffsetInMinutes":390,"abbreviation":"MMT","rawFormat":"+06:30 Myanmar Time - Yangon, Mandalay, Nay Pyi Taw, Mawlamyine"},{"name":"Indian/Christmas","alternativeName":"Christmas Island Time","group":["Indian/Christmas"],"continentCode":"OC","continentName":"Oceania","countryName":"Christmas Island","countryCode":"CX","mainCities":["Flying Fish Cove"],"rawOffsetInMinutes":420,"abbreviation":"CXT","rawFormat":"+07:00 Christmas Island Time - Flying Fish Cove"},{"name":"Antarctica/Davis","alternativeName":"Davis Time","group":["Antarctica/Davis"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Davis"],"rawOffsetInMinutes":420,"abbreviation":"DAVT","rawFormat":"+07:00 Davis Time - Davis"},{"name":"Asia/Hovd","alternativeName":"Hovd Time","group":["Asia/Hovd"],"continentCode":"AS","continentName":"Asia","countryName":"Mongolia","countryCode":"MN","mainCities":["Ulaangom","Khovd","Ölgii","Altai"],"rawOffsetInMinutes":420,"abbreviation":"HOVT","rawFormat":"+07:00 Hovd Time - Ulaangom, Khovd, Ölgii, Altai"},{"name":"Asia/Bangkok","alternativeName":"Indochina Time","group":["Asia/Bangkok","Asia/Phnom_Penh","Asia/Vientiane","Indian/Christmas"],"continentCode":"AS","continentName":"Asia","countryName":"Thailand","countryCode":"TH","mainCities":["Bangkok","Samut Prakan","Mueang Nonthaburi","Chon Buri"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Bangkok, Samut Prakan, Mueang Nonthaburi, Chon Buri"},{"name":"Asia/Ho_Chi_Minh","alternativeName":"Indochina Time","group":["Asia/Ho_Chi_Minh","Asia/Saigon"],"continentCode":"AS","continentName":"Asia","countryName":"Vietnam","countryCode":"VN","mainCities":["Ho Chi Minh City","Da Nang","Biên Hòa","Cần Thơ"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Ho Chi Minh City, Da Nang, Biên Hòa, Cần Thơ"},{"name":"Asia/Phnom_Penh","alternativeName":"Indochina Time","group":["Asia/Phnom_Penh"],"continentCode":"AS","continentName":"Asia","countryName":"Cambodia","countryCode":"KH","mainCities":["Phnom Penh","Takeo","Siem Reap","Battambang"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Phnom Penh, Takeo, Siem Reap, Battambang"},{"name":"Asia/Vientiane","alternativeName":"Indochina Time","group":["Asia/Vientiane"],"continentCode":"AS","continentName":"Asia","countryName":"Laos","countryCode":"LA","mainCities":["Vientiane","Savannakhet","Pakse","Thakhèk"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Vientiane, Savannakhet, Pakse, Thakhèk"},{"name":"Asia/Novosibirsk","alternativeName":"Novosibirsk Time","group":["Asia/Barnaul","Asia/Krasnoyarsk","Asia/Novokuznetsk","Asia/Novosibirsk","Asia/Tomsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Novosibirsk","Krasnoyarsk","Barnaul","Tomsk"],"rawOffsetInMinutes":420,"abbreviation":"NOVT","rawFormat":"+07:00 Novosibirsk Time - Novosibirsk, Krasnoyarsk, Barnaul, Tomsk"},{"name":"Asia/Jakarta","alternativeName":"Western Indonesia Time","group":["Asia/Jakarta","Asia/Pontianak"],"continentCode":"AS","continentName":"Asia","countryName":"Indonesia","countryCode":"ID","mainCities":["Jakarta","Surabaya","Bekasi","Bandung"],"rawOffsetInMinutes":420,"abbreviation":"WIB","rawFormat":"+07:00 Western Indonesia Time - Jakarta, Surabaya, Bekasi, Bandung"},{"name":"Australia/Perth","alternativeName":"Australian Western Time","group":["Australia/Perth","Australia/West"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Perth","Mandurah","Bunbury","Baldivis"],"rawOffsetInMinutes":480,"abbreviation":"AWST","rawFormat":"+08:00 Australian Western Time - Perth, Mandurah, Bunbury, Baldivis"},{"name":"Asia/Brunei","alternativeName":"Brunei Darussalam Time","group":["Asia/Brunei"],"continentCode":"AS","continentName":"Asia","countryName":"Brunei","countryCode":"BN","mainCities":["Bandar Seri Begawan","Kuala Belait","Seria","Tutong"],"rawOffsetInMinutes":480,"abbreviation":"BNT","rawFormat":"+08:00 Brunei Darussalam Time - Bandar Seri Begawan, Kuala Belait, Seria, Tutong"},{"name":"Asia/Makassar","alternativeName":"Central Indonesia Time","group":["Asia/Makassar","Asia/Ujung_Pandang"],"continentCode":"AS","continentName":"Asia","countryName":"Indonesia","countryCode":"ID","mainCities":["Makassar","Samarinda","Denpasar","Balikpapan"],"rawOffsetInMinutes":480,"abbreviation":"WITA","rawFormat":"+08:00 Central Indonesia Time - Makassar, Samarinda, Denpasar, Balikpapan"},{"name":"Asia/Macau","alternativeName":"China Time","group":["Asia/Macau","Asia/Macao"],"continentCode":"AS","continentName":"Asia","countryName":"Macao","countryCode":"MO","mainCities":["Macau","Taipa"],"rawOffsetInMinutes":480,"abbreviation":"CST","rawFormat":"+08:00 China Time - Macau, Taipa"},{"name":"Asia/Shanghai","alternativeName":"China Time","group":["Asia/Shanghai","PRC","Asia/Chongqing","Asia/Harbin","Asia/Chungking"],"continentCode":"AS","continentName":"Asia","countryName":"China","countryCode":"CN","mainCities":["Shanghai","Beijing","Shenzhen","Guangzhou"],"rawOffsetInMinutes":480,"abbreviation":"CST","rawFormat":"+08:00 China Time - Shanghai, Beijing, Shenzhen, Guangzhou"},{"name":"Asia/Hong_Kong","alternativeName":"Hong Kong Time","group":["Asia/Hong_Kong","Hongkong"],"continentCode":"AS","continentName":"Asia","countryName":"Hong Kong","countryCode":"HK","mainCities":["Hong Kong","Kowloon","Victoria","Tuen Mun"],"rawOffsetInMinutes":480,"abbreviation":"HKT","rawFormat":"+08:00 Hong Kong Time - Hong Kong, Kowloon, Victoria, Tuen Mun"},{"name":"Asia/Irkutsk","alternativeName":"Irkutsk Time","group":["Asia/Irkutsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Irkutsk","Ulan-Ude","Bratsk","Angarsk"],"rawOffsetInMinutes":480,"abbreviation":"IRKT","rawFormat":"+08:00 Irkutsk Time - Irkutsk, Ulan-Ude, Bratsk, Angarsk"},{"name":"Asia/Kuala_Lumpur","alternativeName":"Malaysia Time","group":["Asia/Kuala_Lumpur","Asia/Kuching","Asia/Brunei"],"continentCode":"AS","continentName":"Asia","countryName":"Malaysia","countryCode":"MY","mainCities":["Kuala Lumpur","Petaling Jaya","Klang","Johor Bahru"],"rawOffsetInMinutes":480,"abbreviation":"MYT","rawFormat":"+08:00 Malaysia Time - Kuala Lumpur, Petaling Jaya, Klang, Johor Bahru"},{"name":"Asia/Manila","alternativeName":"Philippine Time","group":["Asia/Manila"],"continentCode":"AS","continentName":"Asia","countryName":"Philippines","countryCode":"PH","mainCities":["Quezon City","Davao","Manila","Caloocan City"],"rawOffsetInMinutes":480,"abbreviation":"PHT","rawFormat":"+08:00 Philippine Time - Quezon City, Davao, Manila, Caloocan City"},{"name":"Asia/Singapore","alternativeName":"Singapore Time","group":["Asia/Singapore","Singapore","Asia/Kuala_Lumpur"],"continentCode":"AS","continentName":"Asia","countryName":"Singapore","countryCode":"SG","mainCities":["Singapore","Jurong Town","Woodlands","Punggol"],"rawOffsetInMinutes":480,"abbreviation":"SGT","rawFormat":"+08:00 Singapore Time - Singapore, Jurong Town, Woodlands, Punggol"},{"name":"Asia/Taipei","alternativeName":"Taipei Time","group":["Asia/Taipei","ROC"],"continentCode":"AS","continentName":"Asia","countryName":"Taiwan","countryCode":"TW","mainCities":["Taipei","Kaohsiung","Taichung","Tainan"],"rawOffsetInMinutes":480,"abbreviation":"TWT","rawFormat":"+08:00 Taipei Time - Taipei, Kaohsiung, Taichung, Tainan"},{"name":"Asia/Ulaanbaatar","alternativeName":"Ulaanbaatar Time","group":["Asia/Choibalsan","Asia/Ulaanbaatar","Asia/Ulan_Bator"],"continentCode":"AS","continentName":"Asia","countryName":"Mongolia","countryCode":"MN","mainCities":["Ulan Bator","Erdenet","Darhan","Mörön"],"rawOffsetInMinutes":480,"abbreviation":"ULAT","rawFormat":"+08:00 Ulaanbaatar Time - Ulan Bator, Erdenet, Darhan, Mörön"},{"name":"Australia/Eucla","alternativeName":"Australian Central Western Time","group":["Australia/Eucla"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Eucla"],"rawOffsetInMinutes":525,"abbreviation":"ACWST","rawFormat":"+08:45 Australian Central Western Time - Eucla"},{"name":"Asia/Dili","alternativeName":"East Timor Time","group":["Asia/Dili"],"continentCode":"OC","continentName":"Oceania","countryName":"Timor Leste","countryCode":"TL","mainCities":["Dili","Maliana","Suai","Likisá"],"rawOffsetInMinutes":540,"abbreviation":"TLT","rawFormat":"+09:00 East Timor Time - Dili, Maliana, Suai, Likisá"},{"name":"Asia/Jayapura","alternativeName":"Eastern Indonesia Time","group":["Asia/Jayapura"],"continentCode":"AS","continentName":"Asia","countryName":"Indonesia","countryCode":"ID","mainCities":["Jayapura","Ambon","Sorong","Ternate"],"rawOffsetInMinutes":540,"abbreviation":"WIT","rawFormat":"+09:00 Eastern Indonesia Time - Jayapura, Ambon, Sorong, Ternate"},{"name":"Asia/Tokyo","alternativeName":"Japan Time","group":["Asia/Tokyo","Japan"],"continentCode":"AS","continentName":"Asia","countryName":"Japan","countryCode":"JP","mainCities":["Tokyo","Yokohama","Osaka","Nagoya"],"rawOffsetInMinutes":540,"abbreviation":"JST","rawFormat":"+09:00 Japan Time - Tokyo, Yokohama, Osaka, Nagoya"},{"name":"Asia/Pyongyang","alternativeName":"Korean Time","group":["Asia/Pyongyang"],"continentCode":"AS","continentName":"Asia","countryName":"North Korea","countryCode":"KP","mainCities":["Pyongyang","Hamhŭng","Namp’o","Sunch’ŏn"],"rawOffsetInMinutes":540,"abbreviation":"KST","rawFormat":"+09:00 Korean Time - Pyongyang, Hamhŭng, Namp’o, Sunch’ŏn"},{"name":"Asia/Seoul","alternativeName":"Korean Time","group":["Asia/Seoul","ROK"],"continentCode":"AS","continentName":"Asia","countryName":"South Korea","countryCode":"KR","mainCities":["Seoul","Busan","Incheon","Daegu"],"rawOffsetInMinutes":540,"abbreviation":"KST","rawFormat":"+09:00 Korean Time - Seoul, Busan, Incheon, Daegu"},{"name":"Pacific/Palau","alternativeName":"Palau Time","group":["Pacific/Palau"],"continentCode":"OC","continentName":"Oceania","countryName":"Palau","countryCode":"PW","mainCities":["Ngerulmud"],"rawOffsetInMinutes":540,"abbreviation":"PWT","rawFormat":"+09:00 Palau Time - Ngerulmud"},{"name":"Asia/Chita","alternativeName":"Yakutsk Time","group":["Asia/Chita","Asia/Khandyga","Asia/Yakutsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Chita","Yakutsk","Blagoveshchensk","Belogorsk"],"rawOffsetInMinutes":540,"abbreviation":"YAKT","rawFormat":"+09:00 Yakutsk Time - Chita, Yakutsk, Blagoveshchensk, Belogorsk"},{"name":"Australia/Adelaide","alternativeName":"Australian Central Time","group":["Australia/Adelaide","Australia/Broken_Hill","Australia/South","Australia/Yancowinna"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Adelaide","Adelaide Hills","Mount Gambier","Morphett Vale"],"rawOffsetInMinutes":570,"abbreviation":"ACST","rawFormat":"+09:30 Australian Central Time - Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale"},{"name":"Australia/Darwin","alternativeName":"Australian Central Time","group":["Australia/Darwin","Australia/North"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Darwin","Alice Springs","Palmerston"],"rawOffsetInMinutes":570,"abbreviation":"ACST","rawFormat":"+09:30 Australian Central Time - Darwin, Alice Springs, Palmerston"},{"name":"Australia/Brisbane","alternativeName":"Australian Eastern Time","group":["Australia/Brisbane","Australia/Lindeman","Australia/Queensland"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Brisbane","Gold Coast","Logan City","Townsville"],"rawOffsetInMinutes":600,"abbreviation":"AEST","rawFormat":"+10:00 Australian Eastern Time - Brisbane, Gold Coast, Logan City, Townsville"},{"name":"Australia/Sydney","alternativeName":"Australian Eastern Time","group":["Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Tasmania","Australia/Currie","Australia/Victoria","Australia/ACT","Australia/NSW","Australia/Canberra"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Sydney","Melbourne","Canberra","Newcastle"],"rawOffsetInMinutes":600,"abbreviation":"AEST","rawFormat":"+10:00 Australian Eastern Time - Sydney, Melbourne, Canberra, Newcastle"},{"name":"Pacific/Guam","alternativeName":"Chamorro Time","group":["Pacific/Guam","Pacific/Saipan"],"continentCode":"OC","continentName":"Oceania","countryName":"Guam","countryCode":"GU","mainCities":["Dededo Village","Yigo Village","Tamuning-Tumon-Harmon Village","Tamuning"],"rawOffsetInMinutes":600,"abbreviation":"ChST","rawFormat":"+10:00 Chamorro Time - Dededo Village, Yigo Village, Tamuning-Tumon-Harmon Village, Tamuning"},{"name":"Pacific/Saipan","alternativeName":"Chamorro Time","group":["Pacific/Saipan"],"continentCode":"OC","continentName":"Oceania","countryName":"Northern Mariana Islands","countryCode":"MP","mainCities":["Saipan"],"rawOffsetInMinutes":600,"abbreviation":"ChST","rawFormat":"+10:00 Chamorro Time - Saipan"},{"name":"Pacific/Chuuk","alternativeName":"Chuuk Time","group":["Pacific/Chuuk","Pacific/Truk","Pacific/Yap"],"continentCode":"OC","continentName":"Oceania","countryName":"Micronesia","countryCode":"FM","mainCities":["Chuuk"],"rawOffsetInMinutes":600,"abbreviation":"CHUT","rawFormat":"+10:00 Chuuk Time - Chuuk"},{"name":"Antarctica/DumontDUrville","alternativeName":"Dumont-d’Urville Time","group":["Antarctica/DumontDUrville"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["DumontDUrville"],"rawOffsetInMinutes":600,"abbreviation":"DDUT","rawFormat":"+10:00 Dumont-d’Urville Time - DumontDUrville"},{"name":"Pacific/Port_Moresby","alternativeName":"Papua New Guinea Time","group":["Pacific/Port_Moresby","Antarctica/DumontDUrville","Pacific/Chuuk","Pacific/Yap","Pacific/Truk"],"continentCode":"OC","continentName":"Oceania","countryName":"Papua New Guinea","countryCode":"PG","mainCities":["Port Moresby","Lae","Mount Hagen","Popondetta"],"rawOffsetInMinutes":600,"abbreviation":"PGT","rawFormat":"+10:00 Papua New Guinea Time - Port Moresby, Lae, Mount Hagen, Popondetta"},{"name":"Asia/Vladivostok","alternativeName":"Vladivostok Time","group":["Asia/Ust-Nera","Asia/Vladivostok"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Khabarovsk","Vladivostok","Khabarovsk Vtoroy","Komsomolsk-on-Amur"],"rawOffsetInMinutes":600,"abbreviation":"VLAT","rawFormat":"+10:00 Vladivostok Time - Khabarovsk, Vladivostok, Khabarovsk Vtoroy, Komsomolsk-on-Amur"},{"name":"Australia/Lord_Howe","alternativeName":"Lord Howe Time","group":["Australia/Lord_Howe","Australia/LHI"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Lord Howe"],"rawOffsetInMinutes":630,"abbreviation":"LHST","rawFormat":"+10:30 Lord Howe Time - Lord Howe"},{"name":"Pacific/Bougainville","alternativeName":"Bougainville Time","group":["Pacific/Bougainville"],"continentCode":"OC","continentName":"Oceania","countryName":"Papua New Guinea","countryCode":"PG","mainCities":["Arawa"],"rawOffsetInMinutes":660,"abbreviation":"BST","rawFormat":"+11:00 Bougainville Time - Arawa"},{"name":"Antarctica/Casey","alternativeName":"Casey Time","group":["Antarctica/Casey"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Casey"],"rawOffsetInMinutes":660,"abbreviation":"CAST","rawFormat":"+11:00 Casey Time - Casey"},{"name":"Pacific/Kosrae","alternativeName":"Kosrae Time","group":["Pacific/Kosrae","Pacific/Pohnpei"],"continentCode":"OC","continentName":"Oceania","countryName":"Micronesia","countryCode":"FM","mainCities":["Kosrae","Palikir - National Government Center"],"rawOffsetInMinutes":660,"abbreviation":"KOST","rawFormat":"+11:00 Kosrae Time - Kosrae, Palikir - National Government Center"},{"name":"Pacific/Noumea","alternativeName":"New Caledonia Time","group":["Pacific/Noumea"],"continentCode":"OC","continentName":"Oceania","countryName":"New Caledonia","countryCode":"NC","mainCities":["Nouméa","Mont-Dore","Dumbéa"],"rawOffsetInMinutes":660,"abbreviation":"NCT","rawFormat":"+11:00 New Caledonia Time - Nouméa, Mont-Dore, Dumbéa"},{"name":"Pacific/Norfolk","alternativeName":"Norfolk Island Time","group":["Pacific/Norfolk"],"continentCode":"OC","continentName":"Oceania","countryName":"Norfolk Island","countryCode":"NF","mainCities":["Kingston"],"rawOffsetInMinutes":660,"abbreviation":"NFT","rawFormat":"+11:00 Norfolk Island Time - Kingston"},{"name":"Asia/Sakhalin","alternativeName":"Sakhalin Time","group":["Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Yuzhno-Sakhalinsk","Magadan","Korsakov","Kholmsk"],"rawOffsetInMinutes":660,"abbreviation":"SAKT","rawFormat":"+11:00 Sakhalin Time - Yuzhno-Sakhalinsk, Magadan, Korsakov, Kholmsk"},{"name":"Pacific/Guadalcanal","alternativeName":"Solomon Islands Time","group":["Pacific/Guadalcanal","Pacific/Pohnpei","Pacific/Ponape"],"continentCode":"OC","continentName":"Oceania","countryName":"Solomon Islands","countryCode":"SB","mainCities":["Honiara"],"rawOffsetInMinutes":660,"abbreviation":"SBT","rawFormat":"+11:00 Solomon Islands Time - Honiara"},{"name":"Pacific/Efate","alternativeName":"Vanuatu Time","group":["Pacific/Efate"],"continentCode":"OC","continentName":"Oceania","countryName":"Vanuatu","countryCode":"VU","mainCities":["Port-Vila"],"rawOffsetInMinutes":660,"abbreviation":"VUT","rawFormat":"+11:00 Vanuatu Time - Port-Vila"},{"name":"Pacific/Fiji","alternativeName":"Fiji Time","group":["Pacific/Fiji"],"continentCode":"OC","continentName":"Oceania","countryName":"Fiji","countryCode":"FJ","mainCities":["Nasinu","Suva","Lautoka","Nadi"],"rawOffsetInMinutes":720,"abbreviation":"FJT","rawFormat":"+12:00 Fiji Time - Nasinu, Suva, Lautoka, Nadi"},{"name":"Pacific/Tarawa","alternativeName":"Gilbert Islands Time","group":["Pacific/Tarawa","Pacific/Funafuti","Pacific/Majuro","Pacific/Wake","Pacific/Wallis"],"continentCode":"OC","continentName":"Oceania","countryName":"Kiribati","countryCode":"KI","mainCities":["Tarawa"],"rawOffsetInMinutes":720,"abbreviation":"GILT","rawFormat":"+12:00 Gilbert Islands Time - Tarawa"},{"name":"Pacific/Majuro","alternativeName":"Marshall Islands Time","group":["Pacific/Kwajalein","Pacific/Majuro","Kwajalein"],"continentCode":"OC","continentName":"Oceania","countryName":"Marshall Islands","countryCode":"MH","mainCities":["Majuro","Kwajalein","RMI Capitol"],"rawOffsetInMinutes":720,"abbreviation":"MHT","rawFormat":"+12:00 Marshall Islands Time - Majuro, Kwajalein, RMI Capitol"},{"name":"Pacific/Nauru","alternativeName":"Nauru Time","group":["Pacific/Nauru"],"continentCode":"OC","continentName":"Oceania","countryName":"Nauru","countryCode":"NR","mainCities":["Yaren"],"rawOffsetInMinutes":720,"abbreviation":"NRT","rawFormat":"+12:00 Nauru Time - Yaren"},{"name":"Pacific/Auckland","alternativeName":"New Zealand Time","group":["Pacific/Auckland","NZ","Antarctica/McMurdo","Antarctica/South_Pole"],"continentCode":"OC","continentName":"Oceania","countryName":"New Zealand","countryCode":"NZ","mainCities":["Auckland","Wellington","Christchurch","Manukau City"],"rawOffsetInMinutes":720,"abbreviation":"NZST","rawFormat":"+12:00 New Zealand Time - Auckland, Wellington, Christchurch, Manukau City"},{"name":"Antarctica/McMurdo","alternativeName":"New Zealand Time","group":["Antarctica/McMurdo"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["McMurdo"],"rawOffsetInMinutes":720,"abbreviation":"NZST","rawFormat":"+12:00 New Zealand Time - McMurdo"},{"name":"Asia/Kamchatka","alternativeName":"Petropavlovsk-Kamchatski Time","group":["Asia/Anadyr","Asia/Kamchatka"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Petropavlovsk-Kamchatsky","Yelizovo","Vilyuchinsk","Anadyr"],"rawOffsetInMinutes":720,"abbreviation":"PETT","rawFormat":"+12:00 Petropavlovsk-Kamchatski Time - Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Anadyr"},{"name":"Pacific/Funafuti","alternativeName":"Tuvalu Time","group":["Pacific/Funafuti"],"continentCode":"OC","continentName":"Oceania","countryName":"Tuvalu","countryCode":"TV","mainCities":["Funafuti"],"rawOffsetInMinutes":720,"abbreviation":"TVT","rawFormat":"+12:00 Tuvalu Time - Funafuti"},{"name":"Pacific/Wake","alternativeName":"Wake Island Time","group":["Pacific/Wake"],"continentCode":"OC","continentName":"Oceania","countryName":"United States Minor Outlying Islands","countryCode":"UM","mainCities":["Wake"],"rawOffsetInMinutes":720,"abbreviation":"WAKT","rawFormat":"+12:00 Wake Island Time - Wake"},{"name":"Pacific/Wallis","alternativeName":"Wallis & Futuna Time","group":["Pacific/Wallis"],"continentCode":"OC","continentName":"Oceania","countryName":"Wallis and Futuna","countryCode":"WF","mainCities":["Mata-Utu"],"rawOffsetInMinutes":720,"abbreviation":"WFT","rawFormat":"+12:00 Wallis & Futuna Time - Mata-Utu"},{"name":"Pacific/Chatham","alternativeName":"Chatham Time","group":["Pacific/Chatham","NZ-CHAT"],"continentCode":"OC","continentName":"Oceania","countryName":"New Zealand","countryCode":"NZ","mainCities":["Chatham"],"rawOffsetInMinutes":765,"abbreviation":"CHAST","rawFormat":"+12:45 Chatham Time - Chatham"},{"name":"Pacific/Apia","alternativeName":"Apia Time","group":["Pacific/Apia"],"continentCode":"OC","continentName":"Oceania","countryName":"Samoa","countryCode":"WS","mainCities":["Apia"],"rawOffsetInMinutes":780,"abbreviation":"WST","rawFormat":"+13:00 Apia Time - Apia"},{"name":"Pacific/Kanton","alternativeName":"Phoenix Islands Time","group":["Pacific/Kanton","Pacific/Enderbury"],"continentCode":"OC","continentName":"Oceania","countryName":"Kiribati","countryCode":"KI","mainCities":["Kanton"],"rawOffsetInMinutes":780,"abbreviation":"PHOT","rawFormat":"+13:00 Phoenix Islands Time - Kanton"},{"name":"Pacific/Fakaofo","alternativeName":"Tokelau Time","group":["Pacific/Fakaofo"],"continentCode":"OC","continentName":"Oceania","countryName":"Tokelau","countryCode":"TK","mainCities":["Fakaofo"],"rawOffsetInMinutes":780,"abbreviation":"TKT","rawFormat":"+13:00 Tokelau Time - Fakaofo"},{"name":"Pacific/Tongatapu","alternativeName":"Tonga Time","group":["Pacific/Tongatapu"],"continentCode":"OC","continentName":"Oceania","countryName":"Tonga","countryCode":"TO","mainCities":["Nuku‘alofa"],"rawOffsetInMinutes":780,"abbreviation":"TOT","rawFormat":"+13:00 Tonga Time - Nuku‘alofa"},{"name":"Pacific/Kiritimati","alternativeName":"Line Islands Time","group":["Pacific/Kiritimati"],"continentCode":"OC","continentName":"Oceania","countryName":"Kiribati","countryCode":"KI","mainCities":["Kiritimati"],"rawOffsetInMinutes":840,"abbreviation":"LINT","rawFormat":"+14:00 Line Islands Time - Kiritimati"}]');
;// CONCATENATED MODULE: ./model/helpers/form_renderers_util.js
var createBooleanControl = function createBooleanControl(args, onChange) {
  var tpl = "<div field-name=\"".concat(args.fieldSchema.fieldName, "\"></div>");
  var control = $(tpl).dxSwitch({
    value: _.isNil(args.data) ? undefined : args.data,
    onValueChanged: function onValueChanged(e) {
      if (e.component.skipOnValueChanged) {
        e.component.skipOnValueChanged = false;
        return;
      }
      if (e.component.setUndefinedNextTime) {
        e.component.setUndefinedNextTime = false;
        e.component.skipOnValueChanged = true;
        e.component.option('value', undefined);
        _.set(args.row, args.fieldSchema.fieldName, false);
        return;
      }
      if (e.value === false) {
        e.component.setUndefinedNextTime = true;
        _.set(args.row, args.fieldSchema.fieldName, false);
      }
    }
  });
  return control;
};
var setValuesToControl = function setValuesToControl(values) {
  var set = function set(entry) {
    var el = $("[field-name=\"".concat(entry[0], "\"]"));
    var instance = el.dxCheckBox('instance');
    instance.setUndefinedNextTime = false;
    instance.option('value', entry[1]);
  };
  Object.entries(values).forEach(set);
};
;// CONCATENATED MODULE: ./model/helpers/form_renderers.js



/* harmony default export */ function form_renderers() {
  var m = {
    asIs: function asIs(data) {
      return data;
    },
    starMaskfunction: function starMaskfunction() {
      return '********';
    },
    twoFactorAdminFormControl: function twoFactorAdminFormControl() {
      var renderModule = 'AdpTwoFactorConfigControl';
      var injector = angular.element(document).injector();
      if (injector.has(renderModule)) {
        var adpTwoFactorConfigControlService = injector.get(renderModule);
        return adpTwoFactorConfigControlService.apply(this);
      }
      return 'No TwoFactor field control module found';
    },
    deleteMyAccount: function deleteMyAccount() {
      var renderModule = 'AdpDeleteMyAccount';
      var injector = angular.element(document).injector();
      if (injector.has(renderModule)) {
        var AdpDeleteMyAccount = injector.get(renderModule);
        return AdpDeleteMyAccount.apply(this);
      }
      return 'No field control module found';
    },
    SSOItem: function SSOItem() {
      var _this = this;
      var ssoItemTemplate = function ssoItemTemplate(_ref, idx) {
        var enabled = _ref.enabled,
          identityProvider = _ref.identityProvider,
          nameID = _ref.nameID;
        var enabledClass = enabled ? 'fa-toggle-on' : 'fa-toggle-off';
        return "<div class=\"adp-sso-control-item\" data-item-index=\"".concat(idx, "\">\n          <button type=\"button\" class=\"adp-sso-control-btn adp-sso-control-btn-enabled\">\n            <i class=\"btn-enabled fa ").concat(enabledClass, "\"></i>\n          </button>\n          \n          <button type=\"button\" class=\"adp-sso-control-btn adp-sso-control-btn-remove\"> \n            <i class=\"btn-remove fa fa-trash\"></i>\n          </button>\n          \n          <div class=\"adp-sso-control-item-text\">\n            <strong>Provider:</strong> ").concat(identityProvider.label, " - ").concat(nameID, "\n          </div>\n        </div>");
      };
      var ssoArrayEl = $("<div class=\"adp-sso-control\">\n          <div class=\"adp-sso-control-item-list\"></div>\n          <button type=\"button\" class=\"btn-add-sso btn btn-default\">\n            Add new \"Add Single Sign-On\"\n          </button>\n        </div>");
      var getListContents = function getListContents() {
        var ssoItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var li = $('<div class="adp-sso-control-item-list"></div>');
        _.each(ssoItems, function (ssoItem, idx) {
          li.append(ssoItemTemplate(ssoItem, idx));
        });
        return li;
      };
      var setListContent = function setListContent(ssoItems) {
        var listEl = getListContents(ssoItems);
        ssoArrayEl.find('.adp-sso-control-item-list').replaceWith(listEl);
      };
      var getItemIndex = function getItemIndex(el) {
        var ssoItemEl = $(el).closest('.adp-sso-control-item');
        return ssoItemEl.data('itemIndex');
      };
      ssoArrayEl.on('click', function (e) {
        var classList = e.target.classList;
        var _getFeModule = getFeModule(['adpSsoService']),
          adpSsoService = _getFeModule.adpSsoService;
        e.preventDefault();
        if (classList.contains('btn-add-sso')) {
          return adpSsoService.addSSO(_this);
        }
        if (classList.contains('btn-enabled')) {
          var itemIndex = getItemIndex(e.target);
          return adpSsoService.toggleSsoStatus(_this.data, itemIndex).then(function (success) {
            return success && setListContent(_this.data);
          });
        }
        if (classList.contains('btn-remove')) {
          var _itemIndex = getItemIndex(e.target);
          return adpSsoService.removeSsoItem(_this.data, _itemIndex).then(function (success) {
            return success && setListContent(_this.data);
          });
        }
      });
      setListContent(this.data);
      return ssoArrayEl;
    },
    userSettingsFixedHeader: function userSettingsFixedHeader() {
      return createBooleanControl(this, function (val) {
        if (val === false) {
          setValuesToControl({
            fixedNavigation: false,
            fixedRibbon: false
          });
        }
      });
    },
    userSettingsFixedNavigation: function userSettingsFixedNavigation() {
      return createBooleanControl(this, function (val) {
        if (val) {
          setValuesToControl({
            fixedWidth: false,
            fixedHeader: true
          });
        } else if (val === false) {
          setValuesToControl({
            fixedRibbon: false
          });
        }
      });
    },
    userSettingsFixedRibbon: function userSettingsFixedRibbon() {
      return createBooleanControl(this, function (val) {
        if (val) {
          setValuesToControl({
            fixedHeader: true,
            fixedNavigation: true,
            fixedWidth: false
          });
        }
      });
    },
    userSettingsFixedWidth: function userSettingsFixedWidth() {
      return createBooleanControl(this, function (val) {
        if (val) {
          setValuesToControl({
            fixedRibbon: false,
            fixedNavigation: false
          });
        }
      });
    },
    timeZoneControl: function timeZoneControl() {
      var _this2 = this;
      var fe = getFeModule(['AdpTime']);
      var $container = $('<div>');
      var $autodetected = $('<div>');
      var clientAutoDetectText = '<Autodetect>';
      var serverAutoDetectText = '<Server time zone>';
      var selectedOption = findSelectedOption(this.data) || clientAutoDetectText;
      var $select = $('<select>').on('change', function (e) {
        return changeValue(e.target.value);
      });
      var addOptions = [{
        name: clientAutoDetectText
      }, {
        name: serverAutoDetectText
      }];
      var setRowValue = function setRowValue(obj) {
        return _.set(_this2.row, _this2.path, obj);
      };
      var sortedTimeZones = _.sortBy(raw_time_zones_namespaceObject, ['name']);
      _.each(_.union(addOptions, sortedTimeZones), function (option) {
        return $select.append($('<option>').text(option.name));
      });
      $select.val(selectedOption);
      changeValue(selectedOption);
      return $container.append($select).append($autodetected);
      function changeValue(optionString) {
        var object = {};
        var autoDetected = '';
        if (optionString === clientAutoDetectText) {
          autoDetected = fe.AdpTime.guessTimeZone();
          object.value = autoDetected;
          object.isClient = true;
        } else if (optionString === serverAutoDetectText) {
          object.value = autoDetected;
          object.isServer = true;
        } else {
          object.value = optionString;
        }
        $autodetected.text(autoDetected);
        setRowValue(object);
      }
      function findSelectedOption(dataObj) {
        var stringValue = dataObj === null || dataObj === void 0 ? void 0 : dataObj.value;
        if (!stringValue || dataObj.isClient) {
          return clientAutoDetectText;
        }
        if (dataObj.isServer) {
          return serverAutoDetectText;
        }
        var timeZone = raw_time_zones_namespaceObject.find(function (tz) {
          return stringValue === tz.name || tz.group.includes(stringValue);
        });
        return timeZone ? timeZone.name : '';
      }
    },
    contactSupportBugInfo: function contactSupportBugInfo() {
      var browserInformation = _.pick(window.navigator, ['cookieEnabled', 'userAgent']);
      var systemInformation = {
        screenResolution: {
          height: window.screen.height,
          width: window.screen.width
        },
        windowSize: {
          height: window.outerHeight,
          width: window.outerWidth
        },
        devicePixelRatio: window.devicePixelRatio
      };
      var _window$lsService$get = window.lsService.getUser(),
        login = _window$lsService$get.login,
        id = _window$lsService$get.id;
      var userInformation = {
        login: login,
        _id: id,
        page: window.location.href
      };
      var bugInfo = {
        browserInformation: browserInformation,
        systemInformation: systemInformation,
        userInformation: userInformation
      };
      _.set(this, 'row.bugInfo', bugInfo);
      _.set(this, 'data', bugInfo);
      var bugInfoHtml = function bugInfoHtml() {
        return "\n          <ul class=\"adp-bug-report-list\">\n            <li>\n              Browser information:\n              \n              <ul class=\"adp-bug-report-list\">\n                <li>\n                  <a \n                    href=\"https://www.w3schools.com/JSREF/prop_nav_cookieenabled.asp\"\n                    target=\"_blank\"\n                  >\n                    cookieEnabled\n                  </a>\n                </li>\n                <li>\n                  <a \n                    href=\"https://www.w3schools.com/JSREF/prop_nav_useragent.asp\"\n                    target=\"_blank\"\n                  >\n                    userAgent\n                  </a>\n                </li>\n              </ul>\n            </li>\n            <li>\n              System information:\n              \n              <ul class=\"adp-bug-report-list\">\n                <li>Screen Resolution</li>\n                <li>Widow size</li>\n                <li>Device pixel ratio</li>\n              </ul>\n            </li>\n            \n            <li>\n              User information:\n              <ul class=\"adp-bug-report-list\">\n                <li>User Name (i.e. login)</li>\n                <li>User ID (i.e. _id of the current user)</li>\n                <li>The URL of the page the user is currently on</li>\n              </ul>\n            </li>\n          </ul>";
      };
      return bugInfoHtml();
    },
    includeDashboard: function includeDashboard() {
      var context = this;
      var parameters = _.get(context, 'fieldSchema.formRender.parameters');
      var dashboardId = parameters.dashboardId;
      if (!dashboardId) {
        return '<span>No dashboard ID parameter found</span>';
      }
      return "<adp-dashboard-viewer dashboard-id=\"".concat(dashboardId, "\" show-header=\"\"></adp-dashboard-viewer>");
    },
    includeIframe: function includeIframe() {
      var context = this;
      var parameters = _.get(context, 'fieldSchema.formRender.parameters');
      var iframeUrlTemplate = parameters.iframeUrlTemplate,
        _parameters$height = parameters.height,
        height = _parameters$height === void 0 ? '70vh' : _parameters$height;
      var iframeUrl = '';
      var message = '';
      if (!iframeUrlTemplate) {
        message = "No URL template parameter found";
      } else {
        try {
          iframeUrl = ejs.render(iframeUrlTemplate, {}, {
            context: context
          });
        } catch (e) {
          message = "URL template parameter error: ".concat(e.message || e);
        }
      }
      if (message) {
        return "<span>".concat(message, "</span>");
      }
      return "<iframe style=\"border:0; width:100%; height:".concat(height, "\" src=\"").concat(iframeUrl, "\"></iframe>");
    },
    includeDashboardIframe: function includeDashboardIframe() {
      var context = this;
      var parameters = _.get(context, 'fieldSchema.formRender.parameters');
      var sharedDashboardId = parameters.sharedDashboardId,
        urlParameters = parameters.urlParameters,
        frameId = parameters.frameId;
      var filters = _.get(urlParameters, 'filter');
      var _parameters$height2 = parameters.height,
        height = _parameters$height2 === void 0 ? '70vh' : _parameters$height2;
      var queryParams = '';
      var message = '';
      if (_.isNumber(height)) {
        height = "".concat(height, "px");
      }
      if (!_.isEmpty(filters)) {
        try {
          var renderedFilters = _.mapValues(filters, function (cond) {
            var condString = _.isString(cond) ? cond : JSON.stringify(cond);
            return ejs.render(condString, {}, {
              context: context
            });
          });
          var filtersString = _.map(renderedFilters, function (filterString, filterName) {
            return "".concat(filterName, "=").concat(filterString.replace('&', '\\&'));
          }).join('&');
          queryParams = "?filter=".concat(encodeURIComponent(filtersString));
        } catch (e) {
          message = "URL template parameter error: ".concat(e.message || e);
        }
      }
      if (message) {
        return "<span>".concat(message, "</span>");
      }
      var iframeUrl = "/dashboard-frameless/".concat(sharedDashboardId).concat(queryParams);
      return "<iframe \n            style=\"border:0; width:100%; height:".concat(height, "\"  \n            src=\"").concat(iframeUrl, "\" \n            id=\"").concat(frameId || "adp-frame".concat(sharedDashboardId), "\"\n            ></iframe>");
    },
    includeWidgetIframe: function includeWidgetIframe() {
      var context = this;
      var parameters = _.get(context, 'fieldSchema.formRender.parameters');
      var sharedWidgetId = parameters.sharedWidgetId,
        _parameters$height3 = parameters.height,
        height = _parameters$height3 === void 0 ? '70vh' : _parameters$height3,
        urlParameters = parameters.urlParameters,
        frameId = parameters.frameId;
      var queryParams = '';
      var message = '';
      if (!_.isEmpty(urlParameters)) {
        try {
          var renderedParams = _.mapValues(urlParameters, function (param) {
            var paramString = _.isString(param) ? param : JSON.stringify(param);
            return ejs.render(paramString, {}, {
              context: context
            });
          });
          queryParams = _.map(renderedParams, function (paramString, paramName) {
            return "".concat(paramName, "=").concat(encodeURIComponent(paramString));
          }).join('&');
        } catch (e) {
          message = "URL template parameter error: ".concat(e.message || e);
        }
      }
      if (message) {
        return "<span>".concat(message, "</span>");
      }
      var iframeUrl = "/widget-frameless/".concat(sharedWidgetId).concat(queryParams ? '?' : '').concat(queryParams);
      return "<iframe \n            style=\"border:0; width:100%; height:".concat(height, "\"  \n            src=\"").concat(iframeUrl, "\" \n            id=\"").concat(frameId || "adp-frame".concat(sharedWidgetId), "\"\n            ></iframe>");
    }
  };
  m.includeDashboard.asTemplate = true;
  m.includeIframe.asTemplate = true;
  return m;
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function arrayWithHoles_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function iterableToArrayLimit_iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function arrayLikeToArray_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function unsupportedIterableToArray_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray_arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function nonIterableRest_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function slicedToArray_slicedToArray(arr, i) {
  return arrayWithHoles_arrayWithHoles(arr) || iterableToArrayLimit_iterableToArrayLimit(arr, i) || unsupportedIterableToArray_unsupportedIterableToArray(arr, i) || nonIterableRest_nonIterableRest();
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive_toPrimitive(t, r) {
  if ("object" != typeof_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey_toPropertyKey(t) {
  var i = toPrimitive_toPrimitive(t, "string");
  return "symbol" == typeof_typeof(i) ? i : String(i);
}
;// CONCATENATED MODULE: ../widget/node_modules/@babel/runtime/helpers/esm/defineProperty.js

function defineProperty_defineProperty(obj, key, value) {
  key = toPropertyKey_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../widget/helpers/form_renderers.js


function form_renderers_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function form_renderers_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? form_renderers_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : form_renderers_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* harmony default export */ function helpers_form_renderers() {
  function createMarkerCanvas(cfg, assets) {
    if (isMarkerInsideQr(cfg.markerType)) {
      return generateQRout(cfg, assets);
    }
    return generateLegacyTypes(cfg, assets);
  }
  function calculateMarkerDimensions(cfg, assets) {
    var frameRatio = cfg.frameRatio,
      pictureSize = cfg.pictureSize,
      _cfg$paddingSize = cfg.paddingSize,
      paddingSize = _cfg$paddingSize === void 0 ? 0 : _cfg$paddingSize,
      _cfg$bgColor = cfg.bgColor,
      bgColor = _cfg$bgColor === void 0 ? '#F0F0F0' : _cfg$bgColor;
    var canvasSize = pictureSize + paddingSize * 2;
    var frameSize = frameRatio * pictureSize / 2;
    var centralFieldSize = pictureSize - frameSize * 2;
    var sSize = centralFieldSize / 4;
    var qrImage = assets.qrImage,
      qrCellsCount = assets.qrCellsCount;
    return {
      frameSize: frameSize,
      sSize: sSize,
      paddingSize: paddingSize,
      centralFieldSize: centralFieldSize,
      qrImage: qrImage,
      qrCellsCount: qrCellsCount,
      canvasSize: canvasSize,
      pictureSize: pictureSize,
      bgColor: bgColor
    };
  }
  function generateQRout(cfg, assets) {
    var markerType = cfg.markerType;
    var dimensions = calculateMarkerDimensions(cfg, assets);
    var paddingSize = dimensions.paddingSize,
      pictureSize = dimensions.pictureSize,
      qrImage = dimensions.qrImage,
      qrCellsCount = dimensions.qrCellsCount;
    var _createCanvas = createCanvas(dimensions),
      canvas = _createCanvas.canvas,
      ctx = _createCanvas.ctx;
    if (qrImage) {
      ctx.drawImage(qrImage, paddingSize, paddingSize, pictureSize, pictureSize);
    } else {
      ctx.fillStyle = '#FFFF00';
      ctx.fillRect(paddingSize, paddingSize, pictureSize, pictureSize);
    }
    var innerCfg = form_renderers_objectSpread(form_renderers_objectSpread({}, cfg), {}, {
      markerType: getLegacyMarkerType(markerType),
      paddingSize: pictureSize / 8
    });
    var innerCanvas = generateLegacyTypes(innerCfg, assets);
    var minCentralShare = 33;
    var centralShareInDots = Math.ceil(minCentralShare * qrCellsCount / 100);
    var qrDotSize = pictureSize / qrCellsCount;
    var centralSize = centralShareInDots * qrDotSize;
    var tl = paddingSize + Math.round((pictureSize - centralSize) / qrDotSize / 2) * qrDotSize;
    ctx.drawImage(innerCanvas, tl, tl, centralSize, centralSize);
    return canvas;
  }
  function generateLegacyTypes(cfg, assets) {
    var markerType = cfg.markerType;
    var dimensions = calculateMarkerDimensions(cfg, assets);
    if (markerType === 'hiro') {
      return generateHiro(dimensions);
    }
    if (markerType.match(/^Letter/)) {
      return generateLetter(dimensions, markerType);
    }
    if (markerType.match(/^[BWQ]+$/)) {
      return generate4x4(dimensions, markerType);
    }
  }
  function createCanvas(_ref) {
    var canvasSize = _ref.canvasSize;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    canvas.width = canvasSize;
    canvas.height = canvasSize;
    return {
      canvas: canvas,
      ctx: ctx
    };
  }
  function generateBlackFrame(dimensions) {
    var frameSize = dimensions.frameSize,
      paddingSize = dimensions.paddingSize,
      pictureSize = dimensions.pictureSize,
      bgColor = dimensions.bgColor,
      canvasSize = dimensions.canvasSize,
      centralFieldSize = dimensions.centralFieldSize;
    var _createCanvas2 = createCanvas(dimensions),
      canvas = _createCanvas2.canvas,
      ctx = _createCanvas2.ctx;
    if (paddingSize) {
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvasSize, canvasSize);
    }
    if (frameSize) {
      ctx.fillStyle = 'black';
      ctx.fillRect(paddingSize, paddingSize, pictureSize, pictureSize);
    }
    ctx.fillStyle = bgColor;
    ctx.fillRect(frameSize + paddingSize, frameSize + paddingSize, centralFieldSize, centralFieldSize);
    ctx.fillStyle = 'black';
    return {
      ctx: ctx,
      canvas: canvas
    };
  }
  function generateHiro(dimensions) {
    var frameSize = dimensions.frameSize,
      sSize = dimensions.sSize,
      paddingSize = dimensions.paddingSize;
    var _generateBlackFrame = generateBlackFrame(dimensions),
      canvas = _generateBlackFrame.canvas,
      ctx = _generateBlackFrame.ctx;
    ctx.font = "".concat(Math.floor(sSize * 2), "px Arial");
    var x = frameSize + paddingSize + sSize * 0.05;
    var y = frameSize + paddingSize + sSize * 3.9;
    ctx.fillText('Hiro', x, y);
    return canvas;
  }
  function generateLetter(dimensions, markerType) {
    var markerLetter = markerType.substring(6, 7);
    var frameSize = dimensions.frameSize,
      sSize = dimensions.sSize,
      paddingSize = dimensions.paddingSize,
      centralFieldSize = dimensions.centralFieldSize;
    var _generateBlackFrame2 = generateBlackFrame(dimensions),
      canvas = _generateBlackFrame2.canvas,
      ctx = _generateBlackFrame2.ctx;
    ctx.font = "".concat(Math.floor(centralFieldSize), "px Arial Black");
    var x = frameSize + paddingSize + sSize * 2;
    var y = frameSize + paddingSize + centralFieldSize - (centralFieldSize - ctx.measureText(markerLetter).actualBoundingBoxAscent) / 2;
    ctx.textAlign = 'center';
    ctx.fillText(markerLetter, x, y);
    return canvas;
  }
  function generate4x4(dimensions, markerType) {
    var markerFields = markerType.split('');
    var frameSize = dimensions.frameSize,
      sSize = dimensions.sSize,
      paddingSize = dimensions.paddingSize,
      qrImage = dimensions.qrImage;
    var _generateBlackFrame3 = generateBlackFrame(dimensions),
      canvas = _generateBlackFrame3.canvas,
      ctx = _generateBlackFrame3.ctx;
    external_lodash_.each(markerFields, function (color, i) {
      var x = frameSize + paddingSize + sSize * (i % 4);
      var y = frameSize + paddingSize + sSize * Math.floor(i / 4);
      if (color === 'Q') {
        if (qrImage) {
          ctx.drawImage(qrImage, x, y, sSize * 2, sSize * 2);
        } else {
          ctx.fillStyle = '#888888';
          ctx.fillRect(x, y, sSize * 2, sSize * 2);
        }
        markerFields[i + 1] = '-';
        markerFields[i + 4] = '-';
        markerFields[i + 5] = '-';
      }
      if (color === 'B') {
        ctx.fillRect(x, y, sSize, sSize);
      }
    });
    return canvas;
  }
  function makeNewImage(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.addEventListener('load', function () {
        return resolve(img);
      });
      img.addEventListener('error', function () {
        return resolve();
      });
      img.src = src;
    });
  }
  function prepareMarkerAssets(context) {
    var INTERFACE = window.adpAppStore.appInterface();
    var logoPath = external_lodash_.get(INTERFACE, 'app.logo.large');
    var logoUrl = "".concat(context.config.resourceUrl).concat(logoPath);
    var logoPromise = makeNewImage(logoUrl);
    var qrPromise = generateQrCode(context);
    return Promise.all([logoPromise, qrPromise]).then(function (_ref2) {
      var _ref3 = slicedToArray_slicedToArray(_ref2, 2),
        logoImage = _ref3[0],
        qrData = _ref3[1];
      return form_renderers_objectSpread({
        logoImage: logoImage
      }, qrData);
    });
  }
  function generateQrCode(context) {
    var injector = angular.element(document).injector();
    var APP_CONFIG = injector.get('APP_CONFIG');
    var AdpClientCommonHelper = injector.get('AdpClientCommonHelper');
    var customQrUrl = external_lodash_.get(context, 'parentData.customQrUrl');
    var customQrUrlPath = external_lodash_.get(context, 'parentData.customQrUrlPath');
    var markerType = getMarkerType(context);
    var qrCellSize = isMarkerInsideQr(markerType) ? 15 : 5;
    var url;
    if (customQrUrl && customQrUrlPath) {
      url = customQrUrlPath;
    } else {
      var hostUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(APP_CONFIG.appSuffix);
      var id = context.row.sharedWidgetId;
      url = "".concat(hostUrl).concat(APP_CONFIG.publishedEndpointPrefix, "/w/").concat(id);
    }
    if (!window.qrcode) {
      var qrVendorCodeUrl = "".concat(APP_CONFIG.resourceUrl, "/public/js/lib/qr-generator/index.js");
      return AdpClientCommonHelper.loadScript(qrVendorCodeUrl).then(function () {
        return buildQr(url, qrCellSize);
      });
    }
    return buildQr(url, qrCellSize);
  }
  function buildQr(url, qrCellSize) {
    var opts = {
      margin: 0,
      scale: qrCellSize,
      errorCorrectionLevel: 'H'
    };
    var qrObject = window.qrcode.create(url, opts);
    var qrCellsCount = external_lodash_.get(qrObject, 'modules.size');
    return window.qrcode.toDataURL(url, opts).then(function (dataUrl) {
      return makeNewImage(dataUrl);
    }).then(function (qrImage) {
      return {
        qrImage: qrImage,
        qrCellSize: qrCellSize,
        qrCellsCount: qrCellsCount
      };
    });
  }
  function getMarkerType(context) {
    return external_lodash_.get(context.row, "".concat(context.path, "Type")) || 'hiro';
  }
  function isMarkerInsideQr(markerType) {
    return external_lodash_.startsWith(markerType, 'QRout-');
  }
  function getLegacyMarkerType(markerType) {
    if (isMarkerInsideQr(markerType)) {
      return markerType.substring(6);
    }
    return markerType;
  }
  var m = {
    arMarkerGenerator: function arMarkerGenerator() {
      var _this = this;
      var markerType = getMarkerType(this);
      var cfg = external_lodash_.defaults({}, external_lodash_.get(this, 'fieldSchema.formRender.parameters'), {
        pictureSize: 128,
        downloadSize: 500,
        frameRatio: 0.5,
        marginTop: 0,
        markerType: markerType
      });
      var pictureSize = cfg.pictureSize,
        downloadSize = cfg.downloadSize,
        marginTop = cfg.marginTop;
      var injector = angular.element(document).injector();
      var AdpArMarkerService = injector.get('AdpArMarkerService');
      var AdpClientCommonHelper = injector.get('AdpClientCommonHelper');
      var mimeType = 'image/png';
      var $el = $('<div class="adp-ar-marker-generator">').css({
        height: pictureSize
      });
      var $download = $('<div class="btn btn-primary">').text('Download marker file').click(function () {
        return downloadMarker(_this);
      });
      var assets;
      prepareMarkerAssets(this).then(function (markerAssets) {
        assets = markerAssets;
        var canvas = createMarkerCanvas(cfg, assets);
        $(canvas).addClass('preview').css({
          width: pictureSize,
          height: pictureSize,
          marginTop: marginTop
        });
        $el.append($download).append(canvas);
      }).catch(function (e) {
        return console.error('Error while preparing marker assets', e.message || e);
      });
      return $el;
      function downloadMarker(context) {
        var canvas = createMarkerCanvas(form_renderers_objectSpread(form_renderers_objectSpread({}, cfg), {}, {
          pictureSize: downloadSize,
          paddingSize: downloadSize / 6
        }), assets);
        var widgetName = external_lodash_.get(context, 'row.name') || 'untitled';
        var fileName = "".concat(widgetName.replaceAll(/[^\w]/g, '_'), "_marker");
        canvas.toBlob(function (blob) {
          return AdpClientCommonHelper.downloadFile({
            blob: blob,
            mimeType: mimeType,
            fileName: fileName
          });
        }, mimeType);
      }
    },
    localTimeControl: function localTimeControl() {
      var _this2 = this;
      var $container = $('<div>');
      var numberBoxConfig = {
        value: this.data,
        onValueChanged: function onValueChanged(e) {
          return external_lodash_.set(_this2.row, _this2.path, e.value);
        },
        mask: 'Hh:M0:M0',
        maskRules: {
          H: function H(char) {
            return char >= 0 && char <= 2;
          },
          h: function h(char, index, fullStr) {
            var i = parseInt(char, 10);
            if (fullStr[0] === '2') return i >= 0 && i <= 3;
            return i >= 0 && i <= 9;
          },
          M: function M(char) {
            return char >= 0 && char <= 5;
          }
        }
      };
      return $container.dxTextBox(numberBoxConfig);
    }
  };
  return m;
}
;// CONCATENATED MODULE: ../message-template/helpers/form_renderers.js
/* harmony default export */ function message_template_helpers_form_renderers() {
  var loadedTemplatesStore = {};
  var m = {
    includeTemplateIframe: function includeTemplateIframe() {
      var context = this;
      var parameters = _.get(context, 'fieldSchema.formRender.parameters');
      var sharedTemplateId = parameters.sharedTemplateId,
        _parameters$templateT = parameters.templateTitle,
        templateTitle = _parameters$templateT === void 0 ? '' : _parameters$templateT,
        urlParameters = parameters.urlParameters,
        frameId = parameters.frameId;
      var _parameters$height = parameters.height,
        height = _parameters$height === void 0 ? '70vh' : _parameters$height;
      var queryParams = '';
      var message = '';
      if (_.isNumber(height)) {
        height = "".concat(height, "px");
      }
      if (!_.isEmpty(urlParameters)) {
        try {
          var renderedParams = _.mapValues(urlParameters, function (param) {
            var paramString = _.isString(param) ? param : JSON.stringify(param);
            return ejs.render(paramString, {}, {
              context: context
            });
          });
          queryParams = '?' + _.map(renderedParams, function (paramString, paramName) {
            return "".concat(paramName, "=").concat(encodeURIComponent(paramString));
          }).join('&');
        } catch (e) {
          message = "URL template parameter error: ".concat(e.message || e);
        }
      }
      if (message) {
        return "<span>".concat(message, "</span>");
      }
      var templateUrl = "".concat(this.config.resourceUrl, "/t/").concat(sharedTemplateId).concat(queryParams);
      var helper = _.get(window, 'appModelHelpers.GenericUtil.generateTemplateButtons');
      var _helper = helper({
          templateTitle: templateTitle,
          templateUrl: templateUrl
        }),
        sandwich = _helper.sandwich,
        buttons = _helper.buttons;
      var iframeHtml = "<iframe \n            style='border:0; width:100%; height:".concat(height, "'  \n            src='").concat(templateUrl, "' \n            id='").concat(frameId || 'adp-frame' + sharedTemplateId, "'\n            ></iframe>");
      var buttonsBlock = $('<div class="adp-tmpl-buttons-box">').append(sandwich).append(buttons);
      return $('<span>').append(iframeHtml).append(buttonsBlock);
    },
    includeTemplate: function includeTemplate() {
      var context = this;
      var injector = angular.element(document).injector();
      var $http = injector.get('$http');
      var APP_CONFIG = injector.get('APP_CONFIG');
      var $container = $('<div class="adp-template-container">');
      var parameters = _.get(context, 'fieldSchema.formRender.parameters');
      var templateId = parameters.templateId,
        _parameters$reloadOnU = parameters.reloadOnUpdate,
        reloadOnUpdate = _parameters$reloadOnU === void 0 ? true : _parameters$reloadOnU;
      loadTemplate().then(renderTemplate).then(setContents).catch(function (e) {
        var msg = "'Template failed: ".concat(e.message || e);
        $container.text(msg);
        console.error(msg);
      });
      return $container;
      function loadTemplate() {
        if (!reloadOnUpdate) {
          var lastTemplate = templateStoreGetSet();
          if (!_.isNil(lastTemplate)) {
            return Promise.resolve(lastTemplate);
          }
        }
        startLoader();
        var templateFetchUrl = "".concat(APP_CONFIG.resourceUrl, "/t/").concat(templateId);
        return $http.get(templateFetchUrl).then(function (result) {
          var _result$data = result.data,
            success = _result$data.success,
            message = _result$data.message,
            data = _result$data.data;
          if (!success) {
            throw new Error(message);
          }
          var html = _.get(data, 'html');
          if (!reloadOnUpdate) {
            templateStoreGetSet(html);
          }
          return html;
        });
      }
      function renderTemplate(template) {
        var text;
        try {
          text = ejs.render(template, {}, {
            context: context
          });
        } catch (e) {
          text = e.message || e;
        }
        return text;
      }
      function setContents(html) {
        $container.empty();
        $container.append(html);
      }
      function startLoader() {
        $container.empty();
        $container.append('<div style="display: flex; justify-content: center;"><i class="fa fa-gear fa-4x"></i></div>');
      }
      function templateStoreGetSet(value) {
        var key = context.row._id + context.path;
        if (value !== undefined) {
          loadedTemplatesStore[key] = value;
        }
        return loadedTemplatesStore[key];
      }
    }
  };
  return m;
}
;// CONCATENATED MODULE: ./model/helpers/label_renderers.js


/* harmony default export */ const label_renderers = (function () {
  var m = {};
  m.avatarUrl = function () {
    var fe = getFeModule(['APP_CONFIG', '$rootScope', 'AdpMediaTypeHelper']);
    return getAvatar(fe.$rootScope.avatar);
    function getAvatar(fileItem) {
      var DEFAULT_AVATAR = "".concat(fe.APP_CONFIG.appSuffix, "/assets/img/profile.jpg");
      if (external_lodash_.isEmpty(fileItem)) {
        return Promise.resolve(DEFAULT_AVATAR);
      }
      var fnName = fileItem.cropped ? 'getCroppedImgLink' : 'getThumbImgLink';
      return fe.AdpMediaTypeHelper[fnName](fileItem).catch(function () {
        return DEFAULT_AVATAR;
      });
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/header_renderers.js
/* harmony default export */ const header_renderers = (function () {
  var m = {
    schemaField: function schemaField(args) {
      var name = _.get(args, "fieldData[".concat(args.index, "][$key]")) || '[undefined name]';
      var type = _.get(args, "fieldData[".concat(args.index, "].type")) || '[undefined type]';
      var valueFlagsMap = {
        width: function width(fieldVal) {
          if (_.isNumber(fieldVal)) {
            return "width: ".concat(fieldVal, "px");
          }
          if (!fieldVal || !fieldVal.match(/^((([1-9][0-9]?|100)%)|(([1-9]\d{0,3})(px|)))$/)) {
            return '';
          }
          var valStr = fieldVal.match(/^\d+$/) ? "".concat(fieldVal, "px") : fieldVal;
          return "width: ".concat(valStr);
        },
        render: function render(fieldVal) {
          return fieldVal ? "render: ".concat(fieldVal) : '';
        }
      };
      var booleanFlagsMap = {
        visible: 'parameters.visible',
        sorting: 'parameters.allowSorting',
        filter: 'parameters.allowFiltering',
        searchable: 'parameters.allowSearch',
        ICE: 'parameters.enableInCellEditing'
      };
      var flags = [];
      _.forEach(booleanFlagsMap, function (fieldPath, placeholderName) {
        var fieldVal = _.get(args, "fieldData[".concat(args.index, "].").concat(fieldPath));
        if (fieldVal) {
          flags.push(placeholderName);
        }
      });
      _.forEach(valueFlagsMap, function (helper, fieldName) {
        var fieldVal = _.get(args, "fieldData[".concat(args.index, "].").concat(fieldName));
        var formattedValue = helper(fieldVal);
        if (fieldVal) {
          flags.push(formattedValue);
        }
      });
      var flagsString = _.isEmpty(flags) ? '' : "(".concat(_.compact(flags).join(', '), ")");
      return "\n        <div style=\"white-space: nowrap; text-overflow: ellipsis; overflow: hidden\">\n          ".concat(name, ": ").concat(type, " ").concat(flagsString, "\n        </div>\n      ");
    },
    nginxWhitelistItem: function nginxWhitelistItem() {
      var arrayItemData = _.pickBy(_.get(this.row, this.path), _.identity);
      var _arrayItemData$ip = arrayItemData.ip,
        ip = _arrayItemData$ip === void 0 ? '&lt;ipAddress&gt;' : _arrayItemData$ip,
        _arrayItemData$descri = arrayItemData.description,
        description = _arrayItemData$descri === void 0 ? '&lt;description&gt;' : _arrayItemData$descri;
      return "".concat(ip, "; # ").concat(description);
    },
    indexes: function indexes() {
      var _ref = this.data[this.index] || {},
        keys = _ref.keys,
        options = _ref.options;
      var keysArray = _.reduce(keys, function (result, _ref2) {
        var _key = _ref2._key,
          _value = _ref2._value;
        _key && _value && result.push("".concat(_key, ": ").concat(_value == '1' ? 'asc' : 'desc'));
        return result;
      }, []);
      var optionsArray = _.reduce(options, function (result, val, key) {
        val && result.push(key);
        return result;
      }, []);
      var keysPart = _.isEmpty(keysArray) ? '[undefined index]' : keysArray.join(', ');
      var optionsPart = _.isEmpty(optionsArray) ? '' : "(".concat(optionsArray.join(', '), ")");
      return "".concat(keysPart, " ").concat(optionsPart);
    },
    compoundCommand: function compoundCommand() {
      var compoundCommandType = _.get(this.data, [this.index, 'type']);
      if (!compoundCommandType) {
        return _.escape('<type of the command> (<arguments>)');
      }
      var combineTypeAndList = function combineTypeAndList(typeName, listOfLookups) {
        var list = _.map(listOfLookups, 'label').join(', ');
        return _.compact([typeName, list]).join(': ');
      };
      var templatesByType = {
        shellCommand: function shellCommand(_ref3) {
          var command = _ref3.command;
          if (!command) {
            return '<command>';
          }
          return command;
        },
        backendCommand: function backendCommand(_ref4) {
          var code = _ref4.code;
          if (!code) {
            return '<code>';
          }
          return code;
        },
        exportData: function exportData(_ref5) {
          var exportType = _ref5.exportType;
          if (!exportType) {
            return '<exportType>';
          }
          return exportType;
        },
        referenceCommand: function referenceCommand(_ref6) {
          var type = _ref6.type,
            _ref6$commands = _ref6.commands,
            commands = _ref6$commands === void 0 ? [] : _ref6$commands;
          if (!type) {
            return '<executionType>';
          }
          return combineTypeAndList(type, commands);
        },
        runAggregationPipelines: function runAggregationPipelines(_ref7) {
          var type = _ref7.type,
            _ref7$tags = _ref7.tags,
            tags = _ref7$tags === void 0 ? [] : _ref7$tags,
            _ref7$aggregationPipe = _ref7.aggregationPipelines,
            aggregationPipelines = _ref7$aggregationPipe === void 0 ? [] : _ref7$aggregationPipe;
          if (!type) {
            return '<viewsType>';
          }
          var tagsOrViews = type === 'tags' ? tags : aggregationPipelines;
          var typeName = type === 'tags' ? 'tags' : 'views';
          return combineTypeAndList(typeName, tagsOrViews);
        },
        runDataProcessors: function runDataProcessors(_ref8) {
          var type = _ref8.type,
            _ref8$tags = _ref8.tags,
            tags = _ref8$tags === void 0 ? [] : _ref8$tags,
            _ref8$dataProcessors = _ref8.dataProcessors,
            dataProcessors = _ref8$dataProcessors === void 0 ? [] : _ref8$dataProcessors;
          if (!type) {
            return '<viewsType>';
          }
          var tagsOrViews = type === 'tags' ? tags : dataProcessors;
          var typeName = type === 'tags' ? 'tags' : 'dataProcessors';
          return combineTypeAndList(typeName, tagsOrViews);
        },
        compoundCommand: function compoundCommand(_ref9) {
          var type = _ref9.type,
            _ref9$commands = _ref9.commands,
            commands = _ref9$commands === void 0 ? [] : _ref9$commands;
          if (!type) {
            return '<commandType>';
          }
          var commandsList = _.map(commands, 'type').join(', ');
          return _.compact([type, commandsList]).join(': ');
        }
      };
      var templateHelper = templatesByType[compoundCommandType];
      var commandArgs = templateHelper(_.get(this.data, [this.index, compoundCommandType]));
      var finalType = compoundCommandType ? _.startCase(compoundCommandType) : '<type>';
      return "<div class=\"adp-compound-command-header\">".concat(_.escape("".concat(finalType, "  (").concat(commandArgs, ")")), "</div>");
    },
    adpAcl: function adpAcl() {
      var _ref10 = this.data[this.index] || {},
        action = _ref10.action,
        byRole = _ref10.byRole;
      if (!action) {
        return "New ADP ACL";
      }
      var allowedRoleNames = _.map(byRole === null || byRole === void 0 ? void 0 : byRole.allow, function (el) {
        return el.label;
      });
      var deniedRoleNames = _.map(byRole === null || byRole === void 0 ? void 0 : byRole.deny, function (el) {
        return el.label;
      });
      var rolesPart = [];
      if (allowedRoleNames.length) {
        rolesPart.push("Allow: ".concat(allowedRoleNames.join(', ')));
      }
      if (deniedRoleNames.length) {
        rolesPart.push("Deny: ".concat(deniedRoleNames.join(', ')));
      }
      return "[".concat(_.startCase(action), "] ").concat(rolesPart.join(' | '));
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/header_renderers.js
/* harmony default export */ const helpers_header_renderers = (function () {
  var m = {
    tabbedTabHeader: function tabbedTabHeader() {
      var title = _.get(this, "data[".concat(this.index, "].title")) || '';
      var selected = !!_.get(this, "data[".concat(this.index, "].selected"));
      var hidden = !!_.get(this, "data[".concat(this.index, "].hidden"));
      var widgetType = _.get(this, "data[".concat(this.index, "].widget.data.type")) || '';
      var widgetTitle = _.get(this, "data[".concat(this.index, "].widget.label")) || '';
      var widgetInfo = "".concat(widgetTitle).concat(widgetType ? ', ' + widgetType : '');
      return [title, widgetInfo ? "(".concat(widgetInfo, ")") : '', selected ? '(default)' : '', hidden ? '(hidden)' : ''].join('');
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../ar-anything/helpers/header_renderers.js
/* harmony default export */ const ar_anything_helpers_header_renderers = (function () {
  var m = {
    arLayerFormHeader: function arLayerFormHeader() {
      var bindingType = _.get(this, "row.arAnything.type");
      var item = _.get(this, ["data", this.index]) || {};
      var type = item.type;
      var bindInfo = '';
      var meshInfo = '';
      if (bindingType === 'location') {
        bindInfo = "Location: ".concat(_.get(item, 'locationParameters.location.label', 'N/A'));
      } else if (bindingType === 'marker') {
        var pattern = _.get(item, "marker.markerPatternType");
        if (pattern === 'hiro') {
          bindInfo = "HIRO marker";
        } else {
          var letter = pattern.includes("Letter") ? pattern.substring(pattern.indexOf("Letter") + 6, 1) : '';
          if (_.startsWith(pattern, 'QRout')) {
            bindInfo = "QR code with ".concat(letter ? "letter \"".concat(letter, "\"") : "pattern", " inside");
          } else if (letter) {
            bindInfo = "Letter \"".concat(letter, "\"");
          } else {
            bindInfo = 'Pattern with QR';
          }
        }
      }
      if (type === 'uploadedFile') {
        meshInfo = "Uploaded file ".concat(_.get(item, "uploadedFile.meshFile[0].name", 'n/a'));
      } else if (type === 'staticUrl') {
        meshInfo = "URL: ".concat(_.get(item, "staticUrl.meshUrl", 'n/a'));
      } else {
        meshInfo = 'Files from dataset';
      }
      return "".concat(meshInfo, ", ").concat(bindInfo);
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/lookup_label_renderers.js
/* harmony default export */ const lookup_label_renderers = (function () {
  var m = {};
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/lookup_label_renderers.js
/* harmony default export */ const helpers_lookup_label_renderers = (function () {
  var m = {
    gradientLookupRenderer: function gradientLookupRenderer() {
      var _this$lookup = this.lookup,
        label = _this$lookup.label,
        data = _this$lookup.data;
      var injector = angular.element(document).injector();
      var AdpGradientService = injector.get('AdpGradientService');
      var gradientStrip = AdpGradientService.getGradientHtml(data.row);
      return "<div class=\"adp-gradient-with-name\"><div class=\"adp-gradient-label\">".concat(label, "</div>").concat(gradientStrip, "</div>");
    },
    iconLabelRenderer: function iconLabelRenderer() {
      var html = _.get(this, 'lookup.data.iconPreviewHtml');
      var label = _.get(this, 'lookup.label');
      return "<div style=\"display:flex;align-items:center\">".concat(html, "&nbsp;").concat(label, "</div>");
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/dx_summary.js
/* harmony default export */ const dx_summary = (function () {
  var m = {};
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/dx_data_sources.js
/* harmony default export */ const dx_data_sources = (function () {
  var m = {};
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/dx_calculate_filter_expression.js
/* harmony default export */ const dx_calculate_filter_expression = (function () {
  var m = {};
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/menu_actions.js


/* harmony default export */ function menu_actions() {
  var _this = this;
  var m = {};
  var openFormModal = function openFormModal(schemaName) {
    var record = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _getFeModule = getFeModule(['AdpUnifiedArgs', 'AdpGeneratorModalService', 'AdpSchemaService']),
      AdpUnifiedArgs = _getFeModule.AdpUnifiedArgs,
      AdpGeneratorModalService = _getFeModule.AdpGeneratorModalService,
      AdpSchemaService = _getFeModule.AdpSchemaService;
    var args = AdpUnifiedArgs.getHelperParamsWithConfig({
      path: '',
      action: 'create',
      formData: record,
      schema: AdpSchemaService.getSchemaByName(schemaName)
    });
    return AdpGeneratorModalService.formModal({
      args: args
    });
  };
  m.updateTrinoSchema = function () {
    var fe = getFeModule(['$http', 'APP_CONFIG', 'ErrorHelpers', 'AdpNotificationService']);
    var apiUrl = fe.APP_CONFIG.apiUrl;
    var handleError = fe.ErrorHelpers.handleError;
    var _fe$AdpNotificationSe = fe.AdpNotificationService,
      notifySuccess = _fe$AdpNotificationSe.notifySuccess,
      notifyError = _fe$AdpNotificationSe.notifyError;
    fe.$http.post("".concat(apiUrl, "/update-trino-schema")).then(function (_ref) {
      var data = _ref.data;
      if (data.success) {
        return notifySuccess("Successfully updated Trino schemas");
      }
      notifyError(data.message || 'Unable to update Trino schemas');
    }).catch(function (error) {
      return handleError(error, 'Unable to update Trino schemas');
    });
  };
  m.userLogout = function () {
    var fe = getFeModule(['AdpModalService', 'AdpSessionService']);
    var options = {
      message: 'Are you sure you want to logout?',
      actionType: 'confirm-logout'
    };
    fe.AdpModalService.confirm(options).then(fe.AdpSessionService.doLogout);
  };
  m.resetUi = function () {
    var fe = getFeModule(['AdpModalService']);
    var options = {
      message: 'This will reset your current frontend setting to default and logout you from the system. Are you sure you want to proceed?',
      actionType: 'confirm-ui-reset'
    };
    fe.AdpModalService.confirm(options).then(function () {
      lsService.clear();
      window.location.reload(true);
    });
  };
  m.toggleFullscreen = function () {
    var fe = getFeModule(['$rootScope']);
    fe.$rootScope.isFullscreen = !fe.$rootScope.isFullscreen;
  };
  m.smtpTestDialog = function () {
    var fe = getFeModule(['AdpSmtpTest']);
    return fe.AdpSmtpTest.openSettingsForm(_this);
  };
  m.contactCustomerSupportDialog = function () {
    openFormModal('_contactCustomerSupport');
  };
  m.nginxWhitelistDialog = function () {
    var _getFeModule2 = getFeModule(['GraphqlCollectionQuery', 'AdpSchemaService', 'ErrorHelpers']),
      AdpSchemaService = _getFeModule2.AdpSchemaService,
      GraphqlCollectionQuery = _getFeModule2.GraphqlCollectionQuery,
      ErrorHelpers = _getFeModule2.ErrorHelpers;
    var nginxWhitelistSchemaName = '_nginxWhitelist';
    var schema = AdpSchemaService.getSchemaByName(nginxWhitelistSchemaName);
    GraphqlCollectionQuery(schema).then(function (data) {
      var record = data.items[0] || {
        ips: [{}]
      };
      return openFormModal(nginxWhitelistSchemaName, record);
    }).catch(function (e) {
      return ErrorHelpers.handleError(e, "Unknown error trying get data for \"".concat(nginxWhitelistSchemaName, "\""));
    });
  };
  m.passwordRequirementsDialog = function () {
    var fe = getFeModule(['AdpPasswordRequirements']);
    return fe.AdpPasswordRequirements.openSettingsForm(_this);
  };
  m.runSystemCommand = function () {
    var injector = angular.element(document).injector();
    var AdpCommandRunner = injector.get('AdpCommandRunner');
    var name = external_lodash_.get(this, 'fieldSchema.fullName');
    var confirmMessage = "Are you sure to run '".concat(name, "' command?");
    var successMessageFunc = function successMessageFunc(response) {
      return "Background job #".concat(response.data.jobId, " running '").concat(name, "' command has been scheduled");
    };
    var commandId = external_lodash_.get(this, 'fieldSchema.action.parameters._id') || '';
    var commandUrl = "/runExternalCommand/".concat(commandId);
    return AdpCommandRunner.runExternalCommand.call(this, {
      confirmMessage: confirmMessage,
      successMessageFunc: successMessageFunc,
      commandUrl: commandUrl
    });
  };
  return m;
}
;// CONCATENATED MODULE: ../aggregation-pipeline/helpers/menu_actions.js

/* harmony default export */ function helpers_menu_actions() {
  var m = {};
  m.runPipelineMenuAction = function () {
    var injector = angular.element(document).injector();
    var aggregationPipelineActions = injector.get('AggregationPipelineActions');
    var pipelineId = external_lodash_.get(this, 'fieldSchema.action.parameters._id') || '';
    var name = external_lodash_.get(this, 'fieldSchema.fullName') || '';
    var context = {
      row: {
        _id: pipelineId,
        name: name
      }
    };
    return aggregationPipelineActions.runPipeline.call(context);
  };
  return m;
}
// EXTERNAL MODULE: ../guided-tour/helpers/menu_actions.js
var guided_tour_helpers_menu_actions = __webpack_require__(332);
;// CONCATENATED MODULE: ../data-pull/helpers/menu_actions.js

/* harmony default export */ function data_pull_helpers_menu_actions() {
  var m = {};
  m.runDataProcessor = function () {
    var injector = angular.element(document).injector();
    var AdpClientCommonHelper = injector.get('AdpClientCommonHelper');
    var AdpModalFormService = injector.get('AdpModalFormService');
    var menuItemName = external_lodash_.get(this, 'fieldSchema.fullName', '');
    var confirmMessage = "Are you sure to run '".concat(menuItemName, "' data processor?");
    var successMessageFunc = function successMessageFunc(response) {
      return "Background job #".concat(response.data.jobId, " running '").concat(menuItemName, "' processor has been scheduled");
    };
    var commandId = external_lodash_.get(this, 'fieldSchema.action.parameters._id') || '';
    var commandUrl = "/runDataProcessor/".concat(commandId);
    var extraButtonText = 'Edit data processor';
    var extraButtonCb = function extraButtonCb() {
      var params = {
        schemaName: 'dataProcessors',
        recordId: commandId,
        action: 'update'
      };
      AdpModalFormService.openForm(params);
    };
    return AdpClientCommonHelper.runByRecordId.call(this, {
      confirmMessage: confirmMessage,
      successMessageFunc: successMessageFunc,
      commandUrl: commandUrl,
      extraButtonText: extraButtonText,
      extraButtonCb: extraButtonCb
    });
  };
  return m;
}
;// CONCATENATED MODULE: ./model/helpers/menu_renderers.js


/* harmony default export */ function menu_renderers() {
  function _urlAsMenuDiv(imageUrl) {
    return "<div class=\"adp-main-menu-image-area\" style=\"background-image: url(".concat(imageUrl, ")\"></div>");
  }
  var m = {
    datasetsCustomMenuItems: function datasetsCustomMenuItems() {
      var _getFeModule = getFeModule(['GraphqlCollectionQuery', 'AdpSchemaService', 'ErrorHelpers']),
        GraphqlCollectionQuery = _getFeModule.GraphqlCollectionQuery,
        AdpSchemaService = _getFeModule.AdpSchemaService,
        ErrorHelpers = _getFeModule.ErrorHelpers;
      var _$get = external_lodash_.get(this, 'fieldSchema.render.parameters', {}),
        modelName = _$get.modelName,
        itemLinkUrl = _$get.itemLinkUrl,
        itemParamsTemplate = _$get.itemParamsTemplate,
        action = _$get.action,
        actionParamsTemplate = _$get.actionParamsTemplate,
        externalLink = _$get.externalLink;
      var external = !!externalLink;
      var modelSchema = AdpSchemaService.getSchemaByName(modelName);
      var gqlParams = {
        filter: [['favorite', '=', true]],
        skip: 0
      };
      return GraphqlCollectionQuery(modelSchema, gqlParams).then(function (_ref) {
        var items = _ref.items;
        return _createMenuSchema(items);
      }).catch(function (error) {
        ErrorHelpers.handleError(error, 'Unknown error while loading list of grid views');
        throw error;
      });
      function _createMenuSchema(dataRows) {
        if (external_lodash_.isEmpty(dataRows)) {
          return null;
        }
        var menuSchema = {};
        external_lodash_.each(dataRows, function (dataItem) {
          var name = dataItem.name;
          var namesHierarchy = name.split('/');
          var path = [];
          while (namesHierarchy.length) {
            var word = external_lodash_.trim(namesHierarchy.shift());
            path.push(word.replaceAll(/\W/g, '_'));
            var isTreeLeaf = !namesHierarchy.length;
            var menuPath = path.join('.fields.');
            if (isTreeLeaf) {
              var menuItem = _getMenuItem(dataItem);
              external_lodash_.setWith(menuSchema, menuPath, menuItem, Object);
            }
            external_lodash_.setWith(menuSchema, "".concat(menuPath, ".fullName"), word, Object);
          }
        });
        return _setItemTypesAndSort(menuSchema);
      }
      function _getMenuItem(dataItem) {
        var menuItem = {
          external: external
        };
        if (itemLinkUrl) {
          menuItem.link = _resolveLinkTmpl(itemLinkUrl, dataItem);
          if (!external) {
            _addParameters(menuItem, 'linkParams', itemParamsTemplate, dataItem);
          }
        }
        if (action) {
          menuItem.action = external_lodash_.cloneDeep(action);
          _addParameters(menuItem, 'action.parameters', actionParamsTemplate, dataItem);
        }
        return menuItem;
      }
      function _resolveLinkTmpl(tmpl, data) {
        return tmpl.replace(/:(\w+)/, function (match, p1) {
          return data[p1];
        });
      }
      function _addParameters(menuItem, paramsPath, template, dataItem) {
        if (paramsPath) {
          var parameters = template ? _resolveEjsTemplate(template, dataItem) : {
            _id: dataItem._id
          };
          external_lodash_.set(menuItem, paramsPath, parameters);
        }
        return menuItem;
      }
      function _resolveEjsTemplate(template, dataItem) {
        try {
          var context = {
            row: dataItem,
            _: lodash
          };
          var json = ejs.render(template, dataItem, {
            context: context
          });
          return JSON5.parse(json);
        } catch (e) {
          console.error('Error resolving template:', template, e.message);
          return {};
        }
      }
      function _setItemTypesAndSort(menuSchema) {
        external_lodash_.each(menuSchema, function (menuItem) {
          if (menuItem.fields) {
            menuItem.type = 'MenuGroup';
            menuItem.fields = _setItemTypesAndSort(menuItem.fields);
          } else {
            menuItem.type = 'MenuItem';
          }
        });
        return external_lodash_.chain(menuSchema).toPairs().sortBy(function (item) {
          return item[1].fullName;
        }).fromPairs().value();
      }
    },
    userHelloMenuItem: function userHelloMenuItem() {
      var user = lsService.getUser();
      return "Hello ".concat(user.login, "!");
    },
    logoMenuItem: function logoMenuItem() {
      var imageUrl = this.config.resourceUrl + external_lodash_.get(this, 'fieldSchema.render.params.url');
      return _urlAsMenuDiv(imageUrl);
    },
    avatarMenuItem: function avatarMenuItem() {
      var fe = getFeModule(['APP_CONFIG', '$rootScope', 'AdpMediaTypeHelper']);
      var DEFAULT_AVATAR_URL = "".concat(fe.APP_CONFIG.appSuffix, "/assets/img/profile.jpg");
      var fileItem = fe.$rootScope.avatar;
      if (external_lodash_.isEmpty(fileItem)) {
        return _urlAsMenuDiv(DEFAULT_AVATAR_URL);
      }
      var avatarUrl = fe.AdpMediaTypeHelper.getPermanentThumbnailLink(fileItem, 'S');
      return _urlAsMenuDiv(avatarUrl);
    },
    searchMenuItem: function searchMenuItem() {
      var injector = angular.element(document).injector();
      var $state = injector.get('$state');
      var redirectState = external_lodash_.get(this, 'fieldSchema.render.params.redirectState');
      var redirectTmpl = external_lodash_.get(this, 'fieldSchema.render.params.redirectParams', {});
      var $searchBlock = $("<div class=\"menu-search-area\"/>");
      var $input = $('<input class="search-text" placeholder="Search"/>');
      var $button = $('<div class="btn btn-small btn-primary search-button">Go</div>');
      $input.on('keypress', onKeyPress);
      $button.click(onSearch);
      $searchBlock.append($input);
      $searchBlock.append($button);
      return $searchBlock;
      function onSearch() {
        var data = external_lodash_.trim($('.search-text', $searchBlock).val());
        if (!data) {
          return;
        }
        var redirectParams;
        try {
          var tmpl = JSON.stringify(redirectTmpl);
          var context = {
            data: data
          };
          redirectParams = JSON.parse(ejs.render(tmpl, {
            context: context
          }));
        } catch (e) {
          console.error('Menu search redirect params render error', e);
        }
        $state.go(redirectState, redirectParams);
      }
      function onKeyPress(e) {
        if (e.code === 'Enter') {
          onSearch();
        }
      }
    }
  };
  return m;
}
// EXTERNAL MODULE: ../guided-tour/helpers/menu_renderers.js
var helpers_menu_renderers = __webpack_require__(247);
;// CONCATENATED MODULE: ../marketplace-server/helpers/menu_renderers.js
/* harmony default export */ const marketplace_server_helpers_menu_renderers = (function () {
  var m = {};
  var cartCollectionName = '_carts';
  m.marketplaceCart = function () {
    var injector = angular.element(document).injector();
    var GraphqlRequest = injector.get('GraphqlRequest');
    var $cart = $('<span>').text('Cart');
    var queryName = cartCollectionName + 'Dx';
    var query = "query q {".concat(queryName, " { count } }");
    GraphqlRequest({
      name: queryName,
      query: query,
      variables: {}
    }).then(function (_ref) {
      var count = _ref.count;
      count && $cart.append("<span class=\"adp-cart-items-count\">".concat(count, "</span>"));
    }).catch(function (e) {
      return console.error(e.message || e.statusText || 'Unknown loading error');
    });
    return $cart;
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/frontend_lists.js
/* harmony default export */ const frontend_lists = (function () {
  var m = {
    indexValues: function indexValues() {
      return {
        1: 'Ascending',
        '-1': 'Descending'
      };
    },
    indexKeys: function indexKeys() {
      var _this$row;
      var fields = ((_this$row = this.row) === null || _this$row === void 0 || (_this$row = _this$row.scheme) === null || _this$row === void 0 ? void 0 : _this$row.fields) || [];
      var excludedTypes = ['FromSeparator', 'Blank', 'Group', 'StaticHtml'];
      var filteredFields = fields.filter(function (_ref) {
        var $key = _ref.$key,
          type = _ref.type;
        return $key && !excludedTypes.includes(type);
      });
      return filteredFields.reduce(function (acc, _ref2) {
        var $key = _ref2.$key,
          type = _ref2.type;
        if (type === 'LookupObjectID' || type === 'LookupObjectID[]') {
          acc["".concat($key, "._id")] = "".concat($key, "._id");
          acc["".concat($key, ".table")] = "".concat($key, ".table");
        }
        acc[$key] = $key;
        return acc;
      }, {});
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/typeof.js
function esm_typeof_typeof(o) {
  "@babel/helpers - typeof";

  return esm_typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, esm_typeof_typeof(o);
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function esm_toPrimitive_toPrimitive(t, r) {
  if ("object" != esm_typeof_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != esm_typeof_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function esm_toPropertyKey_toPropertyKey(t) {
  var i = esm_toPrimitive_toPrimitive(t, "string");
  return "symbol" == esm_typeof_typeof(i) ? i : String(i);
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/defineProperty.js

function esm_defineProperty_defineProperty(obj, key, value) {
  key = esm_toPropertyKey_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../aggregation-pipeline/helpers/frontend_lists.js

function frontend_lists_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function frontend_lists_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? frontend_lists_ownKeys(Object(t), !0).forEach(function (r) { esm_defineProperty_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : frontend_lists_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* harmony default export */ const helpers_frontend_lists = (function () {
  var NEW_FIELD_NAME = '[newField]';
  var NEW_FIELD_LABEL = '[ New Field ]';
  var m = {
    mongoAccumOperators: function mongoAccumOperators() {
      return {
        $addToSet: '$addToSet',
        $avg: '$avg',
        $count: '$count',
        $first: '$first',
        $last: '$last',
        $max: '$max',
        $mergeObjects: '$mergeObjects',
        $min: '$min',
        $push: '$push',
        $stdDevPop: '$stdDevPop',
        $stdDevSamp: '$stdDevSamp',
        $sum: '$sum'
      };
    },
    bucketAutoGranularity: function bucketAutoGranularity() {
      return {
        R5: 'R5',
        R10: 'R10',
        R20: 'R20',
        R40: 'R40',
        R80: 'R80',
        '1-2-5': '1-2-5',
        E6: 'E6',
        E12: 'E12',
        E24: 'E24',
        E48: 'E48',
        E96: 'E96',
        E192: 'E192',
        POWERSOF2: 'POWERSOF2'
      };
    },
    aggregationPipelineFields: function aggregationPipelineFields() {
      var list = getFields(this).then(fieldsToList);
      return paginationWrapper(this, list);
    },
    aggregationPipelineFieldsWithNew: function aggregationPipelineFieldsWithNew() {
      var listPromise = getFields(this).then(function (fields) {
        fields.push({
          order: -1,
          name: NEW_FIELD_NAME,
          fullName: NEW_FIELD_LABEL
        });
        return fieldsToList(fields);
      });
      return paginationWrapper(this, listPromise);
    },
    aggregationPipelineStageFieldsList: function aggregationPipelineStageFieldsList() {
      var alteredContext = external_lodash_.clone(this);
      var stageIndex = external_lodash_.get(this, 'customData.aggregationPipelineStage');
      alteredContext.indexes = [stageIndex];
      return getFields(alteredContext);
    },
    aggregationPipelineAllStagesFields: function aggregationPipelineAllStagesFields() {
      var context = this;
      return getDatasetsInvolved(context).then(function (datasetInfo) {
        var stages = getStages(context);
        return external_lodash_.map(stages, function (stage, index) {
          return fieldsForStage(context, index, datasetInfo);
        });
      });
    },
    datasetFieldsList: function datasetFieldsList() {
      var context = this;
      return getDatasetInfoByIdParam(context).then(function (list) {
        return external_lodash_.mapValues(list, function (item) {
          return item.fullName;
        });
      });
    },
    datasetFieldsNameList: function datasetFieldsNameList() {
      var context = this;
      return getDatasetInfoByIdParam(context).then(function (list) {
        return external_lodash_.mapValues(list, function (item, name) {
          return name;
        });
      });
    }
  };
  function getDatasetInfoByIdParam(context) {
    var id = function () {
      var idTemplate = external_lodash_.get(context, 'fieldSchema.list.params.id');
      try {
        return ejs.render(idTemplate, {
          context: context
        });
      } catch (e) {
        console.log('Error trying to eval ejs string for list params for args: ', context);
      }
    }();
    return getDatasetInfo([id]).then(function (res) {
      return res[id] || {};
    });
  }
  function paginationWrapper(context, listPromise) {
    var loadOptions = context.loadOptions;
    return listPromise.then(function (list) {
      if (external_lodash_.isNil(loadOptions)) {
        return list;
      }
      var _loadOptions$skip = loadOptions.skip,
        start = _loadOptions$skip === void 0 ? 0 : _loadOptions$skip,
        _loadOptions$take = loadOptions.take,
        take = _loadOptions$take === void 0 ? 1000 : _loadOptions$take;
      var keys = external_lodash_.slice(external_lodash_.keys(list), start, start + take);
      return external_lodash_.pick(list, keys);
    });
  }
  function getDatasetInfo(ids) {
    var validIds = external_lodash_.compact(ids);
    if (!validIds.length) {
      return Promise.resolve({});
    }
    var injector = angular.element(document).injector();
    var $http = injector.get('$http');
    var _injector$get = injector.get('APP_CONFIG'),
      apiUrl = _injector$get.apiUrl;
    var body = {
      ids: validIds
    };
    return $http.post("".concat(apiUrl, "/datasetInfo"), body, {
      cache: true
    }).then(function (_ref) {
      var data = _ref.data;
      if (data.success) {
        return data.data;
      }
      data && data.error && console.log(data.error);
      return {};
    });
  }
  function getFields(context) {
    var currentStage = external_lodash_.get(context, 'indexes[0]');
    return getDatasetsInvolved(context).then(function (datasetInfo) {
      return fieldsForStage(context, currentStage, datasetInfo);
    });
  }
  function getDatasetsInvolved(context) {
    var stages = getStages(context);
    var defaultStageLimit = stages.length - 1;
    var currentStage = external_lodash_.get(context, 'indexes[0]', defaultStageLimit);
    var ids = [];
    var sourceDatasetId = getSourceDatasetId(context);
    sourceDatasetId && ids.push(sourceDatasetId);
    for (var stageIndex = 0; stageIndex < currentStage; stageIndex++) {
      var stageType = external_lodash_.get(stages, [stageIndex, 'type'], '').substring(1);
      if (['lookup', 'graphLookup'].includes(stageType)) {
        ids.push(external_lodash_.get(stages, [stageIndex, stageType, 'from', '_id']));
      }
      if (stageType === 'unionWith') {
        ids.push(external_lodash_.get(stages, [stageIndex, stageType, 'coll', '_id']));
      }
    }
    return getDatasetInfo(ids);
  }
  function handleTransformStageFields(_ref2) {
    var currentFields = _ref2.currentFields,
      stage = _ref2.stage,
      origin = _ref2.origin;
    var type = external_lodash_.get(stage, 'transformStageFields.type');
    if (type === 'addsFields') {
      external_lodash_.each(stage.transformStageFields.fieldSpecs, function (f) {
        var fieldName = f._key;
        var fieldType = f._value || 'String';
        if (fieldName && fieldType) {
          currentFields.push({
            name: fieldName,
            type: fieldType,
            origin: origin
          });
        }
      });
      return currentFields;
    }
    if (type === 'setFields') {
      var newFields = [];
      external_lodash_.each(stage.transformStageFields.fieldSpecs, function (f) {
        var fieldName = f._key;
        var fieldType = f._value || 'String';
        if (fieldName && fieldType) {
          newFields.push({
            name: fieldName,
            type: fieldType,
            origin: origin
          });
        }
      });
      return newFields;
    }
    if (type === 'removesFields') {
      var _stage$transformStage = stage.transformStageFields.fieldsToRemove,
        fieldsToRemove = _stage$transformStage === void 0 ? [] : _stage$transformStage;
      external_lodash_.remove(currentFields, function (f) {
        return fieldsToRemove.includes(f.name);
      });
      return currentFields;
    }
    return currentFields;
  }
  function getSourceDatasetId(context) {
    var source = context.row.source;
    if ((source === null || source === void 0 ? void 0 : source.type) === 'dataset') {
      var _source$dataset;
      return source === null || source === void 0 || (_source$dataset = source.dataset) === null || _source$dataset === void 0 ? void 0 : _source$dataset._id;
    }
    return false;
  }
  function fieldsForStage(context, currentStage, datasetInfo) {
    var _window$adpAppStore$a, _context$row;
    var stages = getStages(context);
    var stageFieldListGenerators = {
      project: projectFieldsTransform,
      group: groupByFieldsTransform,
      lookup: lookupFieldsTransform,
      graphLookup: lookupFieldsTransform,
      unwind: unwindFieldsTransform,
      collStats: collStatsFieldsTransform,
      set: setFieldsTransform,
      unset: unsetFieldsTransform,
      bucket: bucketFieldsTransform,
      bucketAuto: bucketAutoFieldsTransform,
      geoNear: geoNearFieldsTransform,
      count: countFieldsTransform,
      redact: redactFieldsTransform,
      customStage: customStageFieldsTransform,
      replaceWith: replaceWithFieldsTransform,
      unionWith: unionWithFieldsTransform,
      addFields: addFieldsFieldsTransform,
      facet: facetFieldsTransform,
      fill: fillFieldsTransform,
      setWindowFields: setWindowFieldsTransform
    };
    var sourceDatasetId = getSourceDatasetId(context);
    var sourceSchema = sourceDatasetId ? datasetInfo[sourceDatasetId] : (_window$adpAppStore$a = window.adpAppStore.appModel()[(_context$row = context.row) === null || _context$row === void 0 || (_context$row = _context$row.source) === null || _context$row === void 0 ? void 0 : _context$row.modelName]) === null || _window$adpAppStore$a === void 0 ? void 0 : _window$adpAppStore$a.fields;
    if (!sourceSchema) {
      return;
    }
    var allFields = external_lodash_.map(sourceSchema, function (field, name) {
      return frontend_lists_objectSpread(frontend_lists_objectSpread({}, field), {}, {
        name: name,
        origin: 'initial dataset'
      });
    });
    for (var stageIndex = 0; stageIndex < currentStage; stageIndex++) {
      var stageEnabled = external_lodash_.get(stages, [stageIndex, 'enabled']);
      if (!stageEnabled) {
        continue;
      }
      var stageType = external_lodash_.get(stages, [stageIndex, 'type'], '').substring(1);
      var stageFieldListGenerator = stageFieldListGenerators[stageType];
      if (stageFieldListGenerator) {
        var stage = external_lodash_.get(stages, [stageIndex, stageType]);
        allFields = stageFieldListGenerator({
          currentFields: allFields,
          stageType: stageType,
          stage: stage,
          stageIndex: stageIndex
        });
      }
    }
    return allFields;
    function projectFieldsTransform(_ref3) {
      var currentFields = _ref3.currentFields,
        stage = _ref3.stage,
        stageIndex = _ref3.stageIndex;
      var origin = "added by Project #".concat(stageIndex);
      var errorWrongInclude = 'Include is found after exclude directive.';
      var errorWrongExclude = 'Exclude is found after include directive.';
      var result = [];
      var mode;
      var idIsProcessed = false;
      var idFilter = function idFilter(pf) {
        return pf.name === '_id';
      };
      var fieldsWithoutId = external_lodash_.filter(currentFields, function (pf) {
        return pf.name !== '_id';
      });
      try {
        external_lodash_.each(stage.fields, function (field) {
          var exclude = !field.display;
          if (field.fieldName === NEW_FIELD_NAME) {
            if (mode === 'exclude') {
              throw errorWrongInclude;
            }
            mode = 'include';
            result.push({
              name: field.fieldNewName,
              origin: origin
            });
            return;
          }
          if (field.fieldName === '_id') {
            external_lodash_.remove(result, idFilter);
            if (!exclude) {
              result.push({
                name: '_id',
                origin: origin
              });
            }
            idIsProcessed = true;
            return;
          }
          if (exclude) {
            if (mode === 'include') {
              throw errorWrongExclude;
            }
            if (!mode) {
              result = external_lodash_.union(result, fieldsWithoutId);
              mode = 'exclude';
            }
          }
          var fieldFilter = function fieldFilter(f) {
            return f.name === field.fieldName;
          };
          if (mode === 'exclude') {
            if (!exclude) {
              throw errorWrongInclude;
            }
            external_lodash_.remove(result, fieldFilter);
          } else {
            var fld = external_lodash_.find(fieldsWithoutId, fieldFilter);
            fld && result.push(fld);
            mode = 'include';
          }
        });
        if (!mode) {
          result = external_lodash_.union(result, fieldsWithoutId);
        }
        if (!idIsProcessed) {
          var idField = external_lodash_.find(currentFields, idFilter);
          idField && result.unshift(idField);
        }
      } catch (e) {
        console.error('$project stage error:', e.message || e, '');
        return [];
      }
      return result;
    }
    function collStatsFieldsTransform(_ref4) {
      var stage = _ref4.stage,
        stageIndex = _ref4.stageIndex;
      var fields = [];
      var origin = "from Coll Stats #".concat(stageIndex);
      fields.push({
        name: 'ns',
        origin: origin,
        type: 'String'
      });
      fields.push({
        name: 'host',
        origin: origin,
        type: 'String'
      });
      fields.push({
        name: 'localTime',
        origin: origin,
        type: 'String'
      });
      stage.includeLatencyStats && fields.push({
        name: 'latencyStats',
        origin: origin,
        type: 'Mixed'
      });
      stage.includeStorageStats && fields.push({
        name: 'storageStats',
        origin: origin,
        type: 'Mixed'
      });
      stage.includeCount && fields.push({
        name: 'count',
        origin: origin,
        type: 'Mixed'
      });
      stage.includeQueryExecStats && fields.push({
        name: 'queryExecStats',
        origin: origin,
        type: 'Mixed'
      });
      return fields;
    }
    function setFieldsTransform(_ref5) {
      var currentFields = _ref5.currentFields,
        stage = _ref5.stage,
        stageIndex = _ref5.stageIndex;
      var origin = "from Set #".concat(stageIndex);
      var fieldsToAdd = stage.fields || [];
      external_lodash_.each(fieldsToAdd, function (f) {
        var field = currentFields.find(function (curField) {
          return curField.name === f.fieldName;
        });
        if (field) {
          field.origin = origin;
        } else {
          currentFields.push({
            name: f.fieldName,
            origin: origin,
            type: 'Mixed'
          });
        }
      });
      return currentFields;
    }
    function unsetFieldsTransform(_ref6) {
      var currentFields = _ref6.currentFields,
        stage = _ref6.stage;
      var fieldsToUnset = stage.fields || [];
      external_lodash_.remove(currentFields, function (f) {
        return fieldsToUnset.includes(f.name);
      });
      return currentFields;
    }
    function bucketFieldsTransform(_ref7) {
      var stage = _ref7.stage,
        stageIndex = _ref7.stageIndex;
      var fields = [];
      var origin = "from Bucket #".concat(stageIndex);
      fields.push({
        name: '_id',
        origin: origin,
        type: 'String'
      });
      if (external_lodash_.isEmpty(stage.output)) {
        fields.push({
          name: 'count',
          origin: origin
        });
      } else {
        external_lodash_.each(stage.output, function (f) {
          fields.push({
            name: f.fieldName,
            origin: origin
          });
        });
      }
      return fields;
    }
    function bucketAutoFieldsTransform(_ref8) {
      var stage = _ref8.stage,
        stageIndex = _ref8.stageIndex;
      var fields = [];
      var origin = "from BucketAuto #".concat(stageIndex);
      fields.push({
        name: '_id.min',
        origin: origin
      });
      fields.push({
        name: '_id.max',
        origin: origin
      });
      if (external_lodash_.isEmpty(stage.output)) {
        fields.push({
          name: 'count',
          origin: origin
        });
      } else {
        external_lodash_.each(stage.output, function (f) {
          fields.push({
            name: f.fieldName,
            origin: origin
          });
        });
      }
      return fields;
    }
    function geoNearFieldsTransform(_ref9) {
      var currentFields = _ref9.currentFields,
        stage = _ref9.stage,
        stageIndex = _ref9.stageIndex;
      var distanceField = stage.distanceField,
        includeLocs = stage.includeLocs;
      var origin = "from GeoNear #".concat(stageIndex);
      if (distanceField) {
        var distanceFieldSpec;
        var pathParts = distanceField.split('.');
        if (pathParts.length > 1) {
          distanceFieldSpec = {
            name: pathParts[0],
            origin: origin,
            type: 'Mixed'
          };
        } else {
          distanceFieldSpec = {
            name: distanceField,
            origin: origin,
            type: 'Number'
          };
        }
        external_lodash_.remove(currentFields, function (f) {
          return f.name === distanceFieldSpec.name;
        });
        currentFields.push(distanceFieldSpec);
      }
      if (includeLocs) {
        var includeLocsFieldSpec = {
          name: includeLocs.split('.')[0],
          origin: origin,
          type: 'Mixed'
        };
        external_lodash_.remove(currentFields, function (f) {
          return f.name === includeLocsFieldSpec.name;
        });
        currentFields.push(includeLocsFieldSpec);
      }
      return currentFields;
    }
    function countFieldsTransform(_ref10) {
      var stage = _ref10.stage,
        stageIndex = _ref10.stageIndex;
      return [{
        name: stage.outputFieldName,
        origin: "from Count #".concat(stageIndex)
      }];
    }
    function redactFieldsTransform(_ref11) {
      var currentFields = _ref11.currentFields;
      return currentFields;
    }
    function customStageFieldsTransform(_ref12) {
      var currentFields = _ref12.currentFields,
        stage = _ref12.stage,
        stageIndex = _ref12.stageIndex;
      var origin = "from CustomStage #".concat(stageIndex);
      return handleTransformStageFields({
        currentFields: currentFields,
        stage: stage,
        origin: origin
      });
    }
    function replaceWithFieldsTransform(_ref13) {
      var currentFields = _ref13.currentFields,
        stage = _ref13.stage,
        stageIndex = _ref13.stageIndex;
      var origin = "from ReplaceWith #".concat(stageIndex);
      return handleTransformStageFields({
        currentFields: currentFields,
        stage: stage,
        origin: origin
      });
    }
    function unionWithFieldsTransform(_ref14) {
      var currentFields = _ref14.currentFields,
        stage = _ref14.stage,
        stageIndex = _ref14.stageIndex;
      var origin = "from UnionWith #".concat(stageIndex);
      var unionTableId = external_lodash_.get(stage, 'coll._id');
      var unionDatasetFields = external_lodash_.get(datasetInfo, unionTableId);
      if (!unionDatasetFields) {
        return currentFields;
      }
      var allFieldNames = external_lodash_.map(currentFields, function (f) {
        return f.name;
      });
      external_lodash_.each(unionDatasetFields, function (_ref15, name) {
        var type = _ref15.type;
        if (!allFieldNames.includes(name)) {
          currentFields.push({
            name: name,
            type: type,
            origin: origin
          });
        }
      });
      return currentFields;
    }
    function groupByFieldsTransform(_ref16) {
      var stage = _ref16.stage,
        stageIndex = _ref16.stageIndex;
      var fields = [];
      var origin = "from Group #".concat(stageIndex);
      var _id = external_lodash_(stage.groupBy).filter(function (f) {
        return f.fieldName;
      }).map(function (field) {
        var name = field.fieldName === NEW_FIELD_NAME ? field.newName : field.fieldName;
        return {
          name: name,
          origin: origin
        };
      }).value();
      if (!external_lodash_.isEmpty(_id)) {
        fields.push({
          name: '_id',
          type: 'Mixed',
          origin: origin
        });
      }
      external_lodash_.each(stage.fields, function (x) {
        fields.push({
          name: x.fieldName,
          origin: "from accumulator on Group #".concat(stageIndex)
        });
      });
      return fields;
    }
    function lookupFieldsTransform(_ref17) {
      var currentFields = _ref17.currentFields,
        stage = _ref17.stage,
        stageType = _ref17.stageType,
        stageIndex = _ref17.stageIndex;
      var joinAsField = stage.as;
      if (!joinAsField) {
        return currentFields;
      }
      var origin = "from ".concat(external_lodash_.startCase(stageType), " #").concat(stageIndex);
      var joinedTableId = external_lodash_.get(stage, 'from._id');
      var joinedDatasetFields = external_lodash_.get(datasetInfo, joinedTableId);
      if (!joinedDatasetFields) {
        return currentFields;
      }
      var joinedFields = external_lodash_.map(joinedDatasetFields, function (_field, key) {
        var field = external_lodash_.clone(_field);
        field.name = key;
        field.origin = origin;
        return field;
      });
      var targetField = external_lodash_.find(currentFields, function (x) {
        return x.name === joinAsField;
      });
      if (!targetField) {
        targetField = {
          origin: origin,
          name: joinAsField
        };
        currentFields.push(targetField);
      }
      targetField.type = 'Mixed';
      targetField.joinedFields = joinedFields;
      return currentFields;
    }
    function unwindFieldsTransform(_ref18) {
      var currentFields = _ref18.currentFields,
        stage = _ref18.stage,
        stageIndex = _ref18.stageIndex;
      var unwindPath = external_lodash_.get(stage, 'path');
      var unwindField = external_lodash_.find(currentFields, function (x) {
        return x.name === unwindPath;
      });
      if (!unwindField) {
        return currentFields;
      }
      var fields = currentFields;
      if (unwindField.joinedFields) {
        var newFields = external_lodash_.map(unwindField.joinedFields, function (val) {
          val.name = "".concat(unwindPath, ".").concat(val.name);
          return val;
        });
        fields = external_lodash_.concat(currentFields, newFields);
      }
      var includeIndex = external_lodash_.get(stage, 'includeArrayIndex');
      if (includeIndex) {
        fields.push({
          name: includeIndex,
          fullName: "".concat(unwindPath, " index"),
          origin: "from Unwind #".concat(stageIndex)
        });
      }
      return fields;
    }
    function addFieldsFieldsTransform(_ref19) {
      var currentFields = _ref19.currentFields,
        stage = _ref19.stage,
        stageIndex = _ref19.stageIndex;
      var origin = "from addFields #".concat(stageIndex);
      var fields = external_lodash_.get(stage, 'fields');
      var allFieldNames = external_lodash_.map(currentFields, function (f) {
        return f.name;
      });
      external_lodash_.each(fields, function (_ref20) {
        var name = _ref20.fieldName;
        if (!allFieldNames.includes(name)) {
          currentFields.push({
            name: name,
            origin: origin
          });
        }
      });
      return currentFields;
    }
    function facetFieldsTransform(_ref21) {
      var currentFields = _ref21.currentFields,
        stage = _ref21.stage,
        stageIndex = _ref21.stageIndex;
      var origin = "from facet #".concat(stageIndex);
      var outputs = external_lodash_.get(stage, 'outputFields');
      var allFieldNames = external_lodash_.map(currentFields, function (f) {
        return f.name;
      });
      external_lodash_.each(outputs, function (_ref22) {
        var name = _ref22.name;
        if (!allFieldNames.includes(name)) {
          currentFields.push({
            name: name,
            origin: origin
          });
        }
      });
      return currentFields;
    }
    function fillFieldsTransform(_ref23) {
      var currentFields = _ref23.currentFields,
        stage = _ref23.stage,
        stageIndex = _ref23.stageIndex;
      var origin = "from fill #".concat(stageIndex);
      var outputs = external_lodash_.get(stage, 'output');
      var allFieldNames = external_lodash_.map(currentFields, function (f) {
        return f.name;
      });
      external_lodash_.each(outputs, function (_ref24) {
        var name = _ref24.fieldName;
        if (!allFieldNames.includes(name)) {
          currentFields.push({
            name: name,
            origin: origin
          });
        }
      });
      return currentFields;
    }
    function setWindowFieldsTransform(_ref25) {
      var currentFields = _ref25.currentFields,
        stage = _ref25.stage,
        stageIndex = _ref25.stageIndex;
      var origin = "from setWindowFields #".concat(stageIndex);
      var outputs = external_lodash_.get(stage, 'output');
      var allFieldNames = external_lodash_.map(currentFields, function (f) {
        return f.name;
      });
      external_lodash_.each(outputs, function (_ref26) {
        var name = _ref26.fieldName;
        if (!allFieldNames.includes(name)) {
          currentFields.push({
            name: name,
            origin: origin
          });
        }
      });
      return currentFields;
    }
  }
  function fieldsToList(fields) {
    var sorted = external_lodash_.sortBy(fields, ['order', 'name']);
    var list = {};
    external_lodash_.each(sorted, function (_ref27) {
      var name = _ref27.name,
        origin = _ref27.origin;
      var label = name === NEW_FIELD_NAME ? NEW_FIELD_LABEL : name;
      list[name] = external_lodash_.compact([label, origin && "(".concat(origin, ")")]).join(' ');
    });
    return list;
  }
  function getStages(context) {
    return external_lodash_.get(context, 'row.stages', []);
  }
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/constants.js
var CLICK_VALUES_PATH = '_clickValues';
var MAPPED_FIELDS_PATH = '_mappedFields';
var NEW_FIELD_NAME = '[new field]';
var FULL_TEXT_SEARCH_PARAM_NAME = '[fts]';
var FULL_TEXT_SEARCH_PARAM_LABEL = '[Full text search]';
var TYPE_CLASSES = {
  Number: ['Number', 'Number[]', 'Double', 'Int32', 'Int64', 'Currency'],
  String: ['String', 'Email', 'Phone', 'Url', 'Text', 'Color', 'Barcode', 'Decimal128', 'Html', 'CronExpression', 'Color'],
  StringList: ['List', 'List[]', 'String[]'],
  DateTime: ['DateTime', 'Date', 'Time'],
  Boolean: ['Boolean', 'TriStateBoolean'],
  Location: ['Location'],
  File: ['File'],
  Image: ['Image'],
  ObjectID: ['ObjectID', 'LookupObjectID', 'LookupObjectID[]']
};
var SLIDER_COMPATIBLE_TYPE_CLASSES = {
  DateTimeRange: ['DateTime'],
  TimeRange: ['DateTime'],
  NumberRange: ['Number'],
  DiscreteRange: ['Number', 'String', 'Boolean'],
  DateTimeSlider: ['DateTime'],
  NumberSlider: ['Number'],
  NumberInput: ['Number'],
  StringFilter: ['String'],
  StringFilterForLists: ['String', 'StringList', 'ObjectId'],
  ListSelect: ['Number', 'String', 'StringList', 'Boolean'],
  ListMultiSelect: ['Number', 'String', 'StringList', 'Boolean'],
  ListMultiSelectDropdown: ['Number', 'String', 'StringList', 'Boolean'],
  LookupList: ['Number', 'String', 'StringList', 'ObjectID'],
  TimelapseDateTime: ['DateTime'],
  TimelapseNumber: ['Number'],
  TimelapseList: ['Number', 'String', 'Boolean'],
  Location: ['Location'],
  Switch: ['Number', 'String', 'Boolean']
};
var SLIDER_LABELS = {
  DateTimeRange: 'DateTime range',
  TimeRange: 'Time range',
  NumberRange: 'Number range',
  DiscreteRange: 'Discrete range',
  DateTimeSlider: 'DateTime slider',
  NumberSlider: 'Number slider',
  NumberInput: 'Number filter',
  StringFilter: 'String filter',
  StringFilterForLists: 'String filter (compatible with lists)',
  ListSelect: 'List select',
  ListMultiSelect: 'List multi select checkboxes',
  ListMultiSelectDropdown: 'List multi select dropdown',
  LookupList: 'Lookup list select',
  TimelapseDateTime: 'Timelapse for DateTime',
  TimelapseNumber: 'Timelapse for Number',
  TimelapseList: 'Timelapse for List',
  ResetAll: 'Reset all',
  Group: 'Group start',
  GroupEnd: 'Group end',
  StaticHtml: 'Static HTML',
  Location: 'Location',
  LoadPresets: 'Save/Load state',
  Code: 'Custom code',
  Switch: 'Boolean switch'
};
;// CONCATENATED MODULE: ../widget/helpers/frontend_lists.js

function helpers_frontend_lists_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function helpers_frontend_lists_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? helpers_frontend_lists_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : helpers_frontend_lists_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* harmony default export */ const widget_helpers_frontend_lists = (function () {
  var m = {
    sliderControllerTypes: function sliderControllerTypes() {
      var list = _.chain(SLIDER_LABELS).toPairs().sortBy([function (item) {
        return item[1];
      }]).fromPairs().value();
      return Promise.resolve(list);
    },
    controlLinksByType: function controlLinksByType() {
      var linksInterface = _.get(this, 'customData.linksInterface');
      if (!linksInterface) {
        return Promise.resolve({});
      }
      var compatibleFieldTypes = getCompatibleTypes(this);
      var allLinks = linksInterface.getLinks();
      var list = {};
      if (!_.isEmpty(compatibleFieldTypes)) {
        _.each(allLinks, function (link) {
          var typeClass = getTypeClass(link.paramSchema.type);
          var isLinkTypeCompatible = _.indexOf(compatibleFieldTypes, typeClass) >= 0;
          if (isLinkTypeCompatible) {
            list[link.linkId] = link.label;
          }
        });
      }
      return Promise.resolve(list);
      function getCompatibleTypes(context) {
        var isCompatibleWithAllTypes = _.get(context, 'fieldSchema.list.advanced.supportsAllTypes');
        if (isCompatibleWithAllTypes) {
          return _.map(TYPE_CLASSES, function (group) {
            return group[0];
          });
        }
        var forcedFieldType = _.get(context, 'fieldSchema.list.advanced.fieldType');
        if (forcedFieldType) {
          return [forcedFieldType];
        }
        var forcedFieldTypePath = _.get(context, 'fieldSchema.list.advanced.fieldTypePath');
        var forcedTypeFromPath = forcedFieldTypePath && _.get(context, forcedFieldTypePath);
        if (forcedTypeFromPath) {
          return [forcedTypeFromPath];
        }
        var forcedControlType = _.get(context, 'fieldSchema.list.advanced.controlType');
        var controlType = forcedControlType || _.get(context, 'parentData.controlType');
        return SLIDER_COMPATIBLE_TYPE_CLASSES[controlType];
      }
      function getTypeClass(type) {
        var typeClass = _.findKey(TYPE_CLASSES, function (grp) {
          return grp.indexOf(type) >= 0;
        });
        return typeClass || type;
      }
    },
    datasetFields: function datasetFields() {
      var _this = this;
      var injector = angular.element(document).injector();
      var $http = injector.get('$http');
      var AdpNotificationService = injector.get('AdpNotificationService');
      var _injector$get = injector.get('APP_CONFIG'),
        apiUrl = _injector$get.apiUrl;
      var queryParams = function () {
        var _$get = _.get(_this, 'fieldSchema.list'),
          params = _$get.params;
        var urlPart = '';
        try {
          urlPart = ejs.render(params, {
            context: _this
          });
        } catch (e) {
          console.log('Error trying to eval ejs string for list params for args: ', _this);
        }
        return urlPart;
      }();
      var clickValueTypePath = "row.".concat(this.path, "Type");
      var addSeriaOption = _.get(this, 'fieldSchema.list.addSeriaOption') && _.get(this, clickValueTypePath) === 'String';
      var url = "".concat(apiUrl, "/datasetFieldsInfo?").concat(queryParams);
      return $http.get(url, {
        cache: true
      }).then(function (res) {
        if (!res || !res.data) {
          throw 'Bad server answer';
        }
        var _res$data = res.data,
          _res$data$data = _res$data.data,
          data = _res$data$data === void 0 ? {} : _res$data$data,
          success = _res$data.success,
          message = _res$data.message;
        if (success === false) {
          throw message;
        }
        return data;
      }).then(function (fieldsInfo) {
        var list = _.mapValues(fieldsInfo, function (item) {
          return item.name;
        });
        if (!addSeriaOption) {
          return list;
        }
        return helpers_frontend_lists_objectSpread({
          '[useFieldName]': '[ Use Clicked Data Label ]'
        }, list);
      }).catch(function (e) {
        AdpNotificationService.notifyError(e.message || e);
      });
    },
    subsetOfTheList: function subsetOfTheList() {
      var _$get2 = _.get(this, 'fieldSchema.list'),
        masterFieldPath = _$get2.masterFieldPath;
      var pathWithoutLast = this.path.split('.').slice(0, -1).join('.');
      var fullListPath = "".concat(pathWithoutLast, ".").concat(masterFieldPath);
      var fullList = _.get(this.row, fullListPath) || [];
      var list = _(fullList).map(function (item) {
        return [item, _.startCase(item)];
      }).fromPairs().value();
      return Promise.resolve(list);
    },
    geoJsonFeatures: function geoJsonFeatures() {
      var widgetType = _.get(this, 'row.type');
      var geoJson = _.get(this, "parentData.geoJson");
      if (!geoJson) {
        return Promise.resolve({
          '': 'Select geoJson layer first'
        });
      }
      var appInterface = window.adpAppStore.appInterface();
      var features = _.get(appInterface, "widgets.".concat(widgetType, ".parameters.geoJsonLayers.").concat(geoJson, ".features"));
      return Promise.resolve(features);
    },
    clickValueMappingTypes: function clickValueMappingTypes() {
      var itemPath = this.path.split('.').slice(0, -1).join('.');
      var sourceType = _.get(this.row, "".concat(itemPath, ".clickValueType"));
      var destType = _.get(this.row, "".concat(itemPath, ".type"));
      var transformations = [['one2one', 'Map one to one', ['String', 'Number']], ['range', 'Map with ranges', ['Number', 'DateTime']], ['regexp', 'Map by regexp', ['String']], ['jsCode', 'Map by JS', ['String', 'Number', 'DateTime']]];
      var pairs = _.chain(transformations).filter(function (line) {
        return line[2].indexOf(sourceType) >= 0;
      }).map(function (line) {
        return line.slice(0, 2);
      }).value();
      if (sourceType === destType) {
        pairs.unshift(['asIs', 'Value as is']);
      }
      return Promise.resolve(_.fromPairs(pairs));
    },
    periodNames: function periodNames() {
      var itemPath = this.path.split('.').slice(0, -1).join('.');
      var timeOnly = _.get(this.row, "".concat(itemPath, ".timeOnly"));
      var time = {
        second: 'Seconds',
        minute: 'Minutes',
        hour: 'Hours'
      };
      var date = {
        day: 'Days',
        week: 'Weeks',
        month: 'Months',
        year: 'Years'
      };
      if (timeOnly) {
        return Promise.resolve(time);
      }
      return Promise.resolve(_.assign({}, time, date));
    },
    datetimeFormats: function datetimeFormats() {
      var itemPath = this.path.split('.').slice(0, -1).join('.');
      var timeOnly = _.get(this.row, "".concat(itemPath, ".timeOnly"));
      var thisYear = new Date().getFullYear();
      var thisMonth = new Date().getMonth();
      var thisMonthName = dayjs().format('MMMM');
      var thisQuarterName = "Q".concat(Math.floor(thisMonth / 4) + 1);
      var thisDay = new Date().getDay();
      var time = {
        shortTime: "Time, short (8:45 PM)",
        longTime: "Time, long (8:45:34 PM)"
      };
      var date = {
        shortDateShortTime: "Date & time, short (".concat(thisDay, "/").concat(thisMonth, "/").concat(thisYear, ", 8:45 PM)"),
        longDateLongTime: "Date & time, long (Thursday, ".concat(thisMonthName, " ").concat(thisDay, ", ").concat(thisYear, ", 8:45:34 PM)"),
        dayOfWeek: "Day of week (Friday)",
        shortDate: "Date, short (".concat(thisMonth, "/").concat(thisDay, "/").concat(thisYear, ")"),
        longDate: "Date, long (Thursday, ".concat(thisMonthName, " ").concat(thisDay, ", ").concat(thisYear, ")"),
        monthAndDay: "Month & Date (".concat(thisMonthName, " ").concat(thisDay, ")"),
        month: "Month (".concat(thisMonthName, ")"),
        monthAndYear: "Month & year (".concat(thisMonthName, " ").concat(thisYear, ")"),
        quarter: "Quarter (".concat(thisQuarterName, ")"),
        quarterAndYear: "Quarter & year (".concat(thisQuarterName, " ").concat(thisYear, ")"),
        year: "Year (".concat(thisYear, ")")
      };
      if (timeOnly) {
        return Promise.resolve(time);
      }
      return Promise.resolve(_.assign({}, time, date));
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../data-intake/helpers/frontend_lists.js
/* harmony default export */ const data_intake_helpers_frontend_lists = (function () {
  var m = {
    dataIntakeResponseTypeList: function dataIntakeResponseTypeList() {
      var _this$row;
      var type = (_this$row = this.row) === null || _this$row === void 0 ? void 0 : _this$row.type;
      if (type === 'httpGet' || type === 'httpPost') {
        return {
          pixel: '1x1 Pixel',
          text: 'Text',
          code: 'Custom code'
        };
      }
      return {
        text: 'Text',
        code: 'Custom code'
      };
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/on_value_changed.js
/* harmony default export */ const on_value_changed = (function () {
  return {
    applyCombinedStyle: function applyCombinedStyle() {
      var _this = this;
      var combinedStyleValue = this.data;
      var rootPath = this.path.split('.').slice(0, -1).join('.');
      var combinedStyle = _.get(window, "appModelHelpers.Theme.".concat(combinedStyleValue)) || {};
      var fieldNames = ['skin', 'devextremeTheme', 'echartsTheme', 'echartsDecal', 'ckeditorTheme', 'aceTheme', 'scrollbarTheme', 'googleMapsTheme'];
      _.each(fieldNames, function (fieldName) {
        var val = combinedStyle[fieldName];
        var path = rootPath ? "".concat(rootPath, ".").concat(fieldName) : fieldName;
        _this.set(path, val);
      });
    }
  };
});
;// CONCATENATED MODULE: ../aggregation-pipeline/helpers/on_value_changed.js

/* harmony default export */ const helpers_on_value_changed = (function () {
  return {
    matchByConfigFieldNameChange: function matchByConfigFieldNameChange() {
      var _this = this;
      var args = this;
      var fieldName = external_lodash_.get(this.row, this.path);
      var typePath = this.path.split('.').slice(0, -1).join('.').concat('.fieldType');
      if (!fieldName) {
        this.set(typePath, null);
        return;
      }
      var fn = external_lodash_.get(window.appModelHelpers, 'FrontendLists.aggregationPipelineStageFieldsList');
      external_lodash_.set(args, 'customData.aggregationPipelineStage', this.indexes[0]);
      return fn.call(args).then(function (stageFields) {
        var fieldRecord = external_lodash_.find(stageFields, function (field) {
          return field.name === fieldName;
        });
        var type = external_lodash_.get(fieldRecord, 'type', null);
        var baseType = external_lodash_.includes(['Number', 'String', 'Boolean', 'DateTime'], type) ? type : null;
        _this.set(typePath, baseType);
      });
    }
  };
});
;// CONCATENATED MODULE: ../widget/helpers/helpers_util.js
var genRandomId = function genRandomId(context, args) {
  var _args$charset = args.charset,
    charset = _args$charset === void 0 ? '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ' : _args$charset,
    _args$length = args.length,
    length = _args$length === void 0 ? 8 : _args$length;
  var val = '';
  for (var i = 0; i < length; ++i) {
    val += charset[Math.floor(Math.random() * charset.length)];
  }
  return val;
};
;// CONCATENATED MODULE: ../widget/helpers/on_value_changed.js


/* harmony default export */ const widget_helpers_on_value_changed = (function () {
  return {
    generateRandomPublishId: function generateRandomPublishId() {
      var args = external_lodash_.get(this, 'fieldSchema.events.arguments', {});
      var canBeShared = external_lodash_.get(this.row, this.path);
      var path = args.path || this.path;
      var idValue = external_lodash_.get(this.row, path);
      if (idValue || !canBeShared) {
        return;
      }
      this.set(path, genRandomId(this, args));
    },
    emulateRadioSelect: function emulateRadioSelect() {
      var _this = this;
      var listFieldName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'listItems';
      if (!this.data) {
        return;
      }
      var path = this.path.split('.').slice(0, -2).join('.').concat('.', listFieldName);
      var list = external_lodash_.get(this.row, path, []);
      external_lodash_.each(list, function (item, index) {
        if (index !== _this.index) {
          _this.set(path + '.' + index + '.selected', false);
        }
      });
    }
  };
});
;// CONCATENATED MODULE: ../marketplace-server/helpers/on_value_changed.js

/* harmony default export */ const marketplace_server_helpers_on_value_changed = (function () {
  return {
    addToCartLicenseDurationChange: function addToCartLicenseDurationChange() {
      var licenseId = external_lodash_.get(this.row, this.path);
      var licenseItem = external_lodash_.find(this.row.licenceDurations, function (item) {
        return item.licenseDuration === licenseId;
      });
      var price = external_lodash_.get(licenseItem, 'price');
      this.set('price', price);
    }
  };
});
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function esm_arrayLikeToArray_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return esm_arrayLikeToArray_arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function esm_unsupportedIterableToArray_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return esm_arrayLikeToArray_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return esm_arrayLikeToArray_arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || esm_unsupportedIterableToArray_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function esm_arrayWithHoles_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function esm_iterableToArrayLimit_iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function esm_nonIterableRest_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../aggregation-pipeline/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function esm_slicedToArray_slicedToArray(arr, i) {
  return esm_arrayWithHoles_arrayWithHoles(arr) || esm_iterableToArrayLimit_iterableToArrayLimit(arr, i) || esm_unsupportedIterableToArray_unsupportedIterableToArray(arr, i) || esm_nonIterableRest_nonIterableRest();
}
;// CONCATENATED MODULE: ../aggregation-pipeline/helpers/form_events.js



/* harmony default export */ const form_events = (function () {
  var previewButtonSelector = '.adp-cv-preview-button';
  var m = {
    onCvFormRender: updateCounter,
    onFormUpdate: external_lodash_.debounce(updateCounter, 1000)
  };
  function updateCounter() {
    var args = this;
    var currentSnapshot = JSON.stringify(clearUnrelatedAttributes(args.row));
    if (args.$aggregationPipelineRowSnapshot !== currentSnapshot) {
      args.$aggregationPipelineRowSnapshot = currentSnapshot;
      clearMissingFields(args);
      if (!isSnapshotValid(args.row)) {
        return;
      }
      toggleCounterLoading(true);
      loadCounterValue(args.row).then(function (_ref) {
        var _ref2 = esm_slicedToArray_slicedToArray(_ref, 2),
          count = _ref2[0],
          message = _ref2[1];
        displayCounter(count, message);
        toggleCounterLoading(false);
      });
    }
  }
  function clearUnrelatedAttributes(json) {
    var res = external_lodash_.pick(json, ['stages', 'source']);
    res.stages = external_lodash_.filter(res.stages, function (stage) {
      return stage.type;
    });
    res.stages = external_lodash_.map(res.stages, function (stage) {
      return external_lodash_.omit(stage, ['color', 'comment']);
    });
    return res;
  }
  function isSnapshotValid(row) {
    var source = row.source;
    if (!(source !== null && source !== void 0 && source.type)) {
      return false;
    }
    if (source.type === 'dataset' && !source.dataset) {
      return false;
    }
    if (source.type === 'model' && !source.modelName) {
      return false;
    }
    var isStageInvalidFns = {
      addFields: function addFields(_ref3) {
        var fields = _ref3.fields;
        return external_lodash_.isEmpty(fields) || external_lodash_.find(fields, function (f) {
          return !f.fieldName || !f.expression;
        });
      },
      bucket: function bucket(_ref4) {
        var groupBy = _ref4.groupBy,
          boundaries = _ref4.boundaries;
        return !groupBy || external_lodash_.isEmpty(boundaries);
      },
      bucketAuto: function bucketAuto(_ref5) {
        var groupBy = _ref5.groupBy,
          buckets = _ref5.buckets;
        return !groupBy || !buckets;
      },
      count: function count(_ref6) {
        var outputFieldName = _ref6.outputFieldName;
        return !outputFieldName;
      },
      customStage: function customStage(_ref7) {
        var expression = _ref7.expression;
        return !expression;
      },
      densify: function densify(_ref8) {
        var field = _ref8.field,
          rangeStep = _ref8.rangeStep,
          rangeBounds = _ref8.rangeBounds;
        return !field || !rangeStep || !rangeBounds;
      },
      facet: function facet(_ref9) {
        var outputFields = _ref9.outputFields;
        return external_lodash_.isEmpty(outputFields) || external_lodash_.find(outputFields, function (f) {
          return !f.name || !f.pipeline;
        });
      },
      fill: function fill(_ref10) {
        var output = _ref10.output;
        return external_lodash_.isEmpty(output) || external_lodash_.find(output, function (f) {
          return !f.fieldName || !(f.value || f.method);
        });
      },
      geoNear: function geoNear(_ref11) {
        var distanceField = _ref11.distanceField;
        return !distanceField;
      },
      graphLookup: function graphLookup(_ref12) {
        var from = _ref12.from,
          startWith = _ref12.startWith,
          connectFromField = _ref12.connectFromField,
          connectToField = _ref12.connectToField,
          as = _ref12.as;
        return !external_lodash_.get(from, '_id') || !startWith || !connectFromField || !connectToField || !as;
      },
      limit: function limit(_ref13) {
        var number = _ref13.number;
        return external_lodash_.isNil(number);
      },
      lookup: function lookup(_ref14) {
        var from = _ref14.from,
          localField = _ref14.localField,
          foreignField = _ref14.foreignField,
          as = _ref14.as;
        return !external_lodash_.get(from, '_id') || !localField || !foreignField || !as;
      },
      match: function match(_ref15) {
        var fields = _ref15.fields;
        return external_lodash_.isEmpty(fields);
      },
      matchByConfig: function matchByConfig(_ref16) {
        var fields = _ref16.fields;
        return external_lodash_.isEmpty(fields);
      },
      project: function project(_ref17) {
        var fields = _ref17.fields;
        return external_lodash_.isEmpty(fields);
      },
      redact: function redact(stageData) {
        return !stageData.if || !stageData.then || !stageData.else;
      },
      replaceWith: function replaceWith(_ref18) {
        var expression = _ref18.expression;
        return !expression;
      },
      sample: function sample(_ref19) {
        var size = _ref19.size;
        return external_lodash_.isNil(size);
      },
      set: function set(_ref20) {
        var fields = _ref20.fields;
        return external_lodash_.isEmpty(fields);
      },
      unionWith: function unionWith(_ref21) {
        var coll = _ref21.coll,
          pipeline = _ref21.pipeline;
        return !external_lodash_.get(coll, '_id') || !pipeline;
      },
      setWindowFields: function setWindowFields(_ref22) {
        var output = _ref22.output;
        return external_lodash_.isEmpty(output) || external_lodash_.find(output, function (f) {
          return !f.fieldName || !f.operatorOrWindow;
        });
      },
      skip: function skip(_ref23) {
        var number = _ref23.number;
        return external_lodash_.isNil(number);
      },
      sort: function sort(_ref24) {
        var fields = _ref24.fields;
        return external_lodash_.isEmpty(fields);
      },
      sortByCount: function sortByCount(_ref25) {
        var expression = _ref25.expression;
        return !expression;
      },
      unset: function unset(_ref26) {
        var fields = _ref26.fields;
        return external_lodash_.isEmpty(fields);
      },
      unwind: function unwind(_ref27) {
        var path = _ref27.path;
        return !path;
      }
    };
    var invalidStage = external_lodash_.find(row.stages, function (stage) {
      var enabled = stage.enabled;
      var type = stage.type;
      if (!enabled || !type) {
        return false;
      }
      type = type.substring(1);
      var isInvalidFn = isStageInvalidFns[type];
      return isInvalidFn && isInvalidFn(stage[type]);
    });
    return !invalidStage;
  }
  function clearMissingFields(args) {
    var fn = external_lodash_.get(window.appModelHelpers, 'FrontendLists.aggregationPipelineAllStagesFields');
    var errors = 0;
    return fn.call(args).then(function (stagesFields) {
      var stages = external_lodash_.get(args, 'row.stages', []);
      external_lodash_.each(stages, function (stage, index) {
        cleanStage(stage, stagesFields[index]);
        if (errors) {
          return false;
        }
      });
    });
    function cleanStage(stageRow, availableFields) {
      var type = external_lodash_.get(stageRow, 'type');
      if (!type) {
        return false;
      }
      var stageType = type.substring(1);
      var stageTypeSchema = external_lodash_.get(args, "appSchema._aggregationPipelines.fields.stages.fields.".concat(stageType));
      if (!stageRow.enabled) {
        return false;
      }
      return cleanByPath(stageType, stageRow, stageTypeSchema, external_lodash_.map(availableFields, function (f) {
        return f.name;
      }));
    }
    function cleanByPath(path, stageRow, schema, availableFields) {
      var listName = external_lodash_.get(schema, 'list.name', '');
      var isFieldsList = listName.substring(0, 25) === 'aggregationPipelineFields';
      var value = external_lodash_.get(stageRow, path);
      var isValArray = external_lodash_.isArray(value);
      if (isValArray) {
        external_lodash_.each(value, function (item, index) {
          cleanByPath(path + (path ? '.' : '') + index, stageRow, schema, availableFields);
        });
        return;
      }
      if (isFieldsList) {
        var isValid = external_lodash_.isNil(value) || value === '[newField]' || external_lodash_.includes(availableFields, value);
        if (!isValid) {
          var lastPath = path.split('.').pop() * 1;
          if (!external_lodash_.isNaN(lastPath)) {
            var arrPath = external_lodash_.dropRight(path.split('.')).join('.');
            var arr = external_lodash_.get(stageRow, arrPath);
            arr.splice(lastPath, 1);
            external_lodash_.set(stageRow, arrPath, arr);
          } else {
            external_lodash_.unset(stageRow, path);
          }
          errors++;
          return true;
        }
        return;
      }
      if (schema.fields) {
        external_lodash_.each(schema.fields, function (sch, key) {
          return cleanByPath(path + (path ? '.' : '') + key, stageRow, sch, availableFields);
        });
      }
    }
  }
  function loadCounterValue(row) {
    var injector = angular.element(document).injector();
    var $http = injector.get('$http');
    var _injector$get = injector.get('APP_CONFIG'),
      apiUrl = _injector$get.apiUrl;
    var url = "".concat(apiUrl, "/aggregation-pipeline-count");
    return $http.post(url, {
      data: row
    }).then(function (_ref28) {
      var data = _ref28.data;
      if (!data.success) {
        return [0, data.message];
      }
      return [data.count, ''];
    }).catch(function (e) {
      return [0, e.message || e.statusText || 'Unknown loading error'];
    });
  }
  function displayCounter(count, error) {
    var buttonsContainerSelector = ".adp-model-_aggregationPipelines-form-modal footer.adp-action-b-container";
    var errorBoxClass = 'adp-cv-counter-error-box';
    var errorBoxSelector = ".".concat(errorBoxClass);
    var buttonText = 'Preview';
    var $errBox = $(errorBoxSelector);
    $(previewButtonSelector).prop('disabled', !!error);
    if (error) {
      if (!$errBox.length) {
        $errBox = $("<div class='".concat(errorBoxClass, "'></div>"));
        $(buttonsContainerSelector).prepend($errBox);
      }
      $errBox.text("Preview error: ".concat(error));
    } else {
      $errBox.remove();
      buttonText += " ".concat(count ? "".concat(count, " record").concat(count > 1 ? 's' : '') : 'empty set');
    }
    $(_toConsumableArray($("".concat(previewButtonSelector, ">span"))).filter(function (el) {
      return $(el).text();
    })).text(buttonText);
  }
  function toggleCounterLoading(isLoading) {
    if (isLoading) {
      $(previewButtonSelector).append('<div class="fa fa-gear fa-spin"/>');
    } else {
      $("".concat(previewButtonSelector, " .fa-spin")).remove();
    }
  }
  return m;
});
;// CONCATENATED MODULE: ../widget/helpers/form_events.js

/* harmony default export */ const helpers_form_events = (function () {
  var m = {
    onWidgetFormRender: function onWidgetFormRender() {
      if (this.action === 'clone') {
        external_lodash_.set(this, 'row.sharedWidgetId', '');
      }
    }
  };
  return m;
});
;// CONCATENATED MODULE: ../dashboard/helpers/form_events.js

/* harmony default export */ const dashboard_helpers_form_events = (function () {
  var m = {
    onDashboardFormRender: function onDashboardFormRender() {
      if (this.action === 'clone') {
        external_lodash_.set(this, 'row.sharedDashboardId', '');
      }
    }
  };
  return m;
});
;// CONCATENATED MODULE: ./model/helpers/account.js
/* harmony default export */ const account = (function () {
  return {};
});
;// CONCATENATED MODULE: ./model/helpers/theme.js
/* harmony default export */ const theme = (function () {
  return {
    light: {
      skin: 'smart-style-6',
      devextremeTheme: 'generic.light.compact',
      echartsTheme: 'azul',
      echartsDecal: false,
      ckeditorTheme: 'moono-lisa',
      aceTheme: 'github',
      scrollbarTheme: 'light',
      googleMapsTheme: 'light'
    },
    dark: {
      skin: 'smart-style-5',
      devextremeTheme: 'generic.dark.compact',
      echartsTheme: 'azul',
      echartsDecal: false,
      ckeditorTheme: 'prestige',
      aceTheme: 'ambiance',
      scrollbarTheme: 'dark',
      googleMapsTheme: 'dark'
    }
  };
});
;// CONCATENATED MODULE: ./model/public/js/app-model-code.js
window.appModelHelpers = {};
window.appModelHelpers['GenericUtil'] = {};

Object.assign(window.appModelHelpers['GenericUtil'], generic_util());
window.appModelHelpers['Lists'] = {};

Object.assign(window.appModelHelpers['Lists'], lists());

Object.assign(window.appModelHelpers['Lists'], helpers_lists());

Object.assign(window.appModelHelpers['Lists'], widget_helpers_lists());

Object.assign(window.appModelHelpers['Lists'], _3d_globe_helpers_lists());

Object.assign(window.appModelHelpers['Lists'], ar_anything_helpers_lists());

Object.assign(window.appModelHelpers['Lists'], guided_tour_helpers_lists());

Object.assign(window.appModelHelpers['Lists'], data_pull_helpers_lists());

Object.assign(window.appModelHelpers['Lists'], marketplace_server_helpers_lists());

Object.assign(window.appModelHelpers['Lists'], topomap_helpers_lists());
window.appModelHelpers['Renderers'] = {};

Object.assign(window.appModelHelpers['Renderers'], renderers());

Object.assign(window.appModelHelpers['Renderers'], helpers_renderers());
window.appModelHelpers['CustomActions'] = {};

Object.assign(window.appModelHelpers['CustomActions'], custom_actions());

Object.assign(window.appModelHelpers['CustomActions'], helpers_custom_actions());

Object.assign(window.appModelHelpers['CustomActions'], payment_plans_helpers_custom_actions());
window.appModelHelpers['FormRenderers'] = {};

Object.assign(window.appModelHelpers['FormRenderers'], form_renderers());

Object.assign(window.appModelHelpers['FormRenderers'], helpers_form_renderers());

Object.assign(window.appModelHelpers['FormRenderers'], message_template_helpers_form_renderers());
window.appModelHelpers['LabelRenderers'] = {};

Object.assign(window.appModelHelpers['LabelRenderers'], label_renderers());
window.appModelHelpers['HeaderRenderers'] = {};

Object.assign(window.appModelHelpers['HeaderRenderers'], header_renderers());

Object.assign(window.appModelHelpers['HeaderRenderers'], helpers_header_renderers());

Object.assign(window.appModelHelpers['HeaderRenderers'], ar_anything_helpers_header_renderers());
window.appModelHelpers['LookupLabelRenderers'] = {};

Object.assign(window.appModelHelpers['LookupLabelRenderers'], lookup_label_renderers());

Object.assign(window.appModelHelpers['LookupLabelRenderers'], helpers_lookup_label_renderers());
window.appModelHelpers['DxSummaryCalculators'] = {};

Object.assign(window.appModelHelpers['DxSummaryCalculators'], dx_summary());
window.appModelHelpers['DxDataSources'] = {};

Object.assign(window.appModelHelpers['DxDataSources'], dx_data_sources());
window.appModelHelpers['DxCalculateFilterExpression'] = {};

Object.assign(window.appModelHelpers['DxCalculateFilterExpression'], dx_calculate_filter_expression());
window.appModelHelpers['MenuActions'] = {};

Object.assign(window.appModelHelpers['MenuActions'], menu_actions());

Object.assign(window.appModelHelpers['MenuActions'], helpers_menu_actions());

Object.assign(window.appModelHelpers['MenuActions'], guided_tour_helpers_menu_actions());

Object.assign(window.appModelHelpers['MenuActions'], data_pull_helpers_menu_actions());
window.appModelHelpers['MenuRenderers'] = {};

Object.assign(window.appModelHelpers['MenuRenderers'], menu_renderers());

Object.assign(window.appModelHelpers['MenuRenderers'], helpers_menu_renderers());

Object.assign(window.appModelHelpers['MenuRenderers'], marketplace_server_helpers_menu_renderers());
window.appModelHelpers['FrontendLists'] = {};

Object.assign(window.appModelHelpers['FrontendLists'], frontend_lists());

Object.assign(window.appModelHelpers['FrontendLists'], helpers_frontend_lists());

Object.assign(window.appModelHelpers['FrontendLists'], widget_helpers_frontend_lists());

Object.assign(window.appModelHelpers['FrontendLists'], data_intake_helpers_frontend_lists());
window.appModelHelpers['OnValueChanged'] = {};

Object.assign(window.appModelHelpers['OnValueChanged'], on_value_changed());

Object.assign(window.appModelHelpers['OnValueChanged'], helpers_on_value_changed());

Object.assign(window.appModelHelpers['OnValueChanged'], widget_helpers_on_value_changed());

Object.assign(window.appModelHelpers['OnValueChanged'], marketplace_server_helpers_on_value_changed());
window.appModelHelpers['FormEvents'] = {};

Object.assign(window.appModelHelpers['FormEvents'], form_events());

Object.assign(window.appModelHelpers['FormEvents'], helpers_form_events());

Object.assign(window.appModelHelpers['FormEvents'], dashboard_helpers_form_events());
window.appModelHelpers['Account'] = {};

Object.assign(window.appModelHelpers['Account'], account());
window.appModelHelpers['Theme'] = {};

Object.assign(window.appModelHelpers['Theme'], theme());
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});;(function() {
  angular.module('app.adpClientCommon', []).factory('AdpClientCommonHelper', AdpClientCommonFactory);

  /** @ngInject */
  function AdpClientCommonFactory(
    APP_CONFIG,
    $http,
    AdpIconsHelper,
    AdpGeneratorModalService,
    AdpNotificationService,
    AdpUnifiedArgs,
    AdpModalService,
    AdpSchemaService,
    GraphqlCollectionQuery,
    ErrorHelpers,
    ResponseError
  ) {
    function loadScript(src) {
      return new Promise((resolve, reject) => {
        $.getScript(src)
          .done(resolve)
          .fail(() => {
            reject(new ResponseError(`Failed to load ${src}`));
          });
      });
    }

    function loadCss(src) {
      const linkTag = document.createElement('link');
      linkTag.setAttribute('rel', 'stylesheet');
      linkTag.setAttribute('type', 'text/css');
      linkTag.setAttribute('href', src);
      document.getElementsByTagName('head')[0].appendChild(linkTag);
    }

    function loadVendors(spec) {
      const groupedSpec = groupSyncSpecs(spec);

      return new Promise((resolveAfterAll) => {
        const loadVendors = () => {
          _.each(groupedSpec, (spec) => {
            const { isLoaded, load, probe, loadStarted, name } = spec;
            if (!isLoaded) {
              const probeResult = !probe || probe();
              if (probeResult) {
                spec.isLoaded = probeResult;
                return;
              }
              if (!loadStarted) {
                load();
                spec.loadStarted = Date.now();
              } else {
                if (Date.now() - spec.loadStarted > 15000) {
                  console.error(`${name} loading failure(takes too long)`);
                  spec.isLoaded = true;
                }
              }
              return false; // Cancel cycle on this iteration
            }
          });

          const waitForSpec = _.find(groupedSpec, (spec) => !spec.isLoaded);
          if (waitForSpec) {
            setTimeout(loadVendors, 150);
            return;
          }
          resolveAfterAll();
        };
        loadVendors();
      });

      function groupSyncSpecs(spec) {
        const groups = [];
        let asyncGroup = [];
        spec.forEach(lib => {
          if (lib.sync) {
            if (!_.isEmpty(asyncGroup)) {
              groups.push(transformAsyncGroup(asyncGroup));
              asyncGroup = [];
            }
            groups.push(transformSyncLoad(lib));
          } else {
            asyncGroup.push(lib);
          }
        });

        if (!_.isEmpty(asyncGroup)) {
          groups.push(transformAsyncGroup(asyncGroup));
        }

        return groups;

        function transformAsyncGroup(asyncGroup) {
          const group = {
            isLoaded: false,
            name: _.map(asyncGroup, ({ url }) => _.last(url.split("/")))
              .join(" & "),
            probe: () => _.every(asyncGroup, ({ probe }) => !probe || probe()),
            load: () => {
              if (!group.loadingStarted) {
                group.loadingStarted = Date.now();
                _.each(asyncGroup, ({ url }) => loadScript(url));
              }
            }
          };

          return group;
        }

        function transformSyncLoad(lib) {
          const load = () => loadScript(lib.url);
          return {
            isLoaded: false,
            name: _.last(lib.url.split("/")),
            load,
            ...lib
          };
        }
      }
    }

    function awaitFor(probeFn, interval = 150) {
      if (!probeFn) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const checkProbe = () => {
          const probeResult = probeFn();
          if (!probeResult) {
            setTimeout(checkProbe, interval);
            return;
          }
          resolve(probeResult);
        };
        checkProbe();
      });
    }

    function getMenuItemTemplate(options) {
      return function(item, num, $elem) {
        if (options.icon) {
          var iconHtml = AdpIconsHelper.getIconHtml(options.icon, { className: 'dx-icon' });
          $elem.append(iconHtml);
        }

        if (options.title) {
          var $title = $('<span>').text(options.title);
          $elem.append($title);
        }

        if (options.description) {
          $elem.attr('title', options.description);
        }

        if (options.className) {
          $elem.addClass(options.className);
        }

        return $elem;
      };
    }

    function highlightToolbarButton(component, condition) {
      var SELECTED_TOOLBAR_MENU = 'adp-toolbar-highlighted';

      if (!condition) {
        component.resetOption('cssClass');
      } else {
        var css = component.option('cssClass');
        css = css.replace(SELECTED_TOOLBAR_MENU, '') + ' ' + SELECTED_TOOLBAR_MENU;
        component.option('cssClass', css);
      }

      component.element()
        .toggleClass(SELECTED_TOOLBAR_MENU, !!condition);
    }

    function repaintToolbar(gridComponent) {
      gridComponent._views?.headerPanel?._toolbar?.repaint();
    }

    function openEnvironmentUpdateDialogWithData(formSchema, data, dataTransformer) {
      var booleaned = _stringsToBooleans(data, formSchema);
      var transformed = _.isFunction(dataTransformer) ? dataTransformer(booleaned, data) : booleaned
      var modalOptions = {
        args: AdpUnifiedArgs.getHelperParamsWithConfig({
          path: '',
          action: 'update',
          formData: transformed,
          schema: formSchema
        })
      };

      return AdpGeneratorModalService
        .formModal(modalOptions)
        .then(function(res) {
          return res;
        });
    }

    function openEnvironmentUpdateDialog(formSchema, dataTransformer) {
      return _loadEnvironment()
        .then(fullData =>
          openEnvironmentUpdateDialogWithData(formSchema, _filterVisibleBySchema(fullData, formSchema), dataTransformer))
        .catch((error) => ErrorHelpers.handleError(error));
    }

    function downloadFile(params) {
      const fileName = params.fileName || `${ params.filePrefix || 'downloaded' }_${ new Date().getTime() }`;
      const blob = params.blob || new Blob([params.buffer], { type: params.mimeType || 'text/plain' });

      if (window.navigator.msSaveOrOpenBlob) {
        // IE11
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);

        window.setTimeout(() => {
          // Just to make sure no special effects occurs
          document.body.removeChild(a);
        }, 5000);
      }

      return new $.Deferred().resolve();
    }

    function runByRecordId({
                             confirmMessage,
                             successMessageFunc,
                             errorMessageFunc,
                             redirectUrl,
                             commandUrl,
                             extraButtonText,
                             extraButtonCb
                           }) {
      const errorFunc = errorMessageFunc || ((response) => response.message);
      return AdpModalService
        .confirm({ message: confirmMessage, extraButtonText, extraButtonCb })
        .then(() => {
          let cmdUrl = commandUrl;
          if (!cmdUrl) {
            const { action } = this;
            const redirect = redirectUrl || _.get(this, `modelSchema.actions.fields.${action}.action.redirectUrl`, '');
            cmdUrl = `${redirect}/${this.row._id}`;
          }
          const url = `${APP_CONFIG.apiUrl}${cmdUrl}`;

          return $http.get(url);
        })
        .then(({ data }) => {
          if (data.success) {
            return AdpNotificationService.notifySuccess(successMessageFunc(data));
          }
          AdpNotificationService.notifyError(errorFunc(data));
        })
        .catch((error) => ErrorHelpers.handleError(error));
    }

    function _loadEnvironment() {
      var envSchema = AdpSchemaService.getSchemaByName('_environment');
      var params = {
        filter: [],
        skip: 0,
        take: 1
      };

      return GraphqlCollectionQuery(envSchema, params)
        .then(result => _.get(result, "items[0]"))
    }

    function _filterVisibleBySchema(row, schema) {
      return _.pick(row,
        _.map(
          _.filter(schema.fields, function(val) {
            return val.showInForm;
          }),
          function(val) {
            return val.fieldName
          }));
    }

    function _stringsToBooleans(row, schema) {
      var res = {};

      _.each(row, function(val, key) {
        var type = _.get(schema, ['fields', key, 'type']);

        res[key] = type === 'Boolean' ? val === 'true' : val
      })

      return res;
    }

    return {
      loadScript,
      loadCss,
      loadVendors,
      awaitFor,
      getMenuItemTemplate,
      highlightToolbarButton,
      repaintToolbar,
      openEnvironmentUpdateDialog,
      openEnvironmentUpdateDialogWithData,
      downloadFile,
      runByRecordId,
    };
  }
})();
;(function () {
  angular
    .module('app.adpCommandRunner', [])
    .factory('AdpCommandRunner', AdpCommandRunner);

  /** @ngInject */
  function AdpCommandRunner(
    APP_CONFIG,
    $http,
    AdpGeneratorModalService,
    AdpNotificationService,
    AdpModalService,
    ErrorHelpers
  ) {
    return { runExternalCommand };

    function runExternalCommand({ confirmMessage, successMessageFunc, errorMessageFunc, redirectUrl, commandUrl }) {
      const errorFunc = errorMessageFunc || ((response) => response.message);

      return callCommandModal({ message: confirmMessage, args: this })
        .then((modalRow) => {
          let cmdUrl = commandUrl;
          if (!cmdUrl) {
            const { action } = this;
            const redirect = redirectUrl || _.get(this, `modelSchema.actions.fields.${action}.action.redirectUrl`, '');
            cmdUrl = `${redirect}/${this.row._id}`;
          }
          const url = `${APP_CONFIG.apiUrl}${cmdUrl}`;
          const params = !!modalRow?.parameters ? { parameters: modalRow.parameters } : {};
          return $http.post(url, params);
        })
        .then(({ data }) => {
          if (data.success) {
            return AdpNotificationService.notifySuccess(successMessageFunc(data));
          }
          AdpNotificationService.notifyError(errorFunc(data));
        })
        .catch((error) => ErrorHelpers.handleError(error));
    }

    function callCommandModal(options) {
      return AdpModalService.createModal(
        'adpCommandRunnerModal',
        { actionType: 'runCommand', windowClass: 'adp-vertically-centered', ...options }
      ).result;
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpContactSupport', [])
    .factory('AdpContactSupport', AdpContactSupport);

  /** @ngInject */
  function AdpContactSupport(
    APP_CONFIG,
    $http,
    AdpNotificationService,
    ServerError,
    ErrorHelpers
  ) {
    return {
      send(args, formHooks) {
        var url = APP_CONFIG.apiUrl + '/send-contact-support-email';

        return $http.post(url, args.row)
          .then(function (res) {
            if (!res.data.success) {
              throw new ServerError(res.data.message);
            }

            AdpNotificationService.notifySuccess(res.data.message);
            formHooks.onComplete && formHooks.onComplete(args, res);
          })
          .catch(err => ErrorHelpers.handleError(err, 'Unknown error sending "Customer Support" request'));
      }
    }
  }
})();
;(function () {
  angular.module('app.adpDataExport', []);
})();
;(function () {
  angular.module('app.adpDataImport', [])
    .factory('AdpDataImport', AdpDataImport);

  /** @ngInject */
  function AdpDataImport(
    $rootScope,
    AdpClientCommonHelper,
    AdpModalService,
    ErrorHelpers,
  ) {
    return function (toolbarWidgetRegister) {
      const actionOptions = this.actionOptions;
      const schema = this.modelSchema;

      return toolbarWidgetRegister(() => ({
        widget: 'dxMenu',
        options: {
          dataSource: [{ template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions) }],
          cssClass: 'adp-toolbar-menu grid-view-menu',
          onItemClick: createImportDialog(schema)
        }
      }));
    };

    function createImportDialog(schema) {
      return function () {
        AdpModalService.readFile({
          title: 'Import data',
          readFile: false,
          validate: (file) => {
            if (!file.name.match(/\.(csv|json)$/i)) {
              return 'Only CSV/JSON files allowed';
            }
          }
        })
          .then((file) =>
            AdpModalService.createModal('adpDataImportModal', {
              windowClass: 'adp-vertically-centered',
              file,
              schema,
            }).result)
          .then(() => $rootScope.$broadcast('datasetSchemaUpdate'))
          .catch((err) => err && ErrorHelpers.handleError(err, 'Error while importing.'));
      };
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDatasetActions', [])
    .factory('AdpDatasetActions', AdpDatasetActions);

  /** @ngInject */
  function AdpDatasetActions(
    AdpClientCommonHelper,
    AdpUnifiedArgs,
    AdpGeneratorModalService,
    AdpSchemaService,
    GraphqlCollectionQuery,
    ErrorHelpers,
    $state,
    $rootScope
  ) {
    const datasetsSchemaName = 'datasets';
    return {
      editDatasetRecordToolbarAction
    };

    function editDatasetRecordToolbarAction(toolbarWidgetRegister) {
      const actionOptions = this.actionOptions;
      const datasetId = $state.params._id;//_.get(this, 'fieldSchema.action.params.datasetId');

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          options: {
            dataSource: [{ template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions) }],
            cssClass: 'adp-toolbar-menu edit-dataset-button',
            onItemClick: openEditDatasetForm(gridComponent, datasetId)
          }
        };
      });
    }

    function openEditDatasetForm(gridComponent, datasetId) {
      return function () {
        const datasetsSchema = AdpSchemaService.getSchemaByName(datasetsSchemaName);

        return GraphqlCollectionQuery(datasetsSchema, { filter: ['_id', '=', datasetId] })
          .then(result => {
            const formData = _.get(result, "items[0]");
            const modalOptions = {
              args: AdpUnifiedArgs.getHelperParamsWithConfig({
                path: '',
                action: 'update',
                formData,
                schema: datasetsSchema
              })
            };
            return AdpGeneratorModalService.formModal(modalOptions)
          })
          .then(res => {
            if (!res) {
              return;
            }

            $rootScope.$broadcast('datasetSchemaUpdate');
          })
          .catch(error => {
            ErrorHelpers.handleError(error, 'Unknown error while loading dataset');
            throw error;
          });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDeleteMyAccount', [])
    .factory('AdpDeleteMyAccount', AdpDeleteMyAccount);

  /** @ngInject */
  function AdpDeleteMyAccount(
    AdpNotificationService,
    AdpModalService,
    AdpSessionService,
    ErrorHelpers,
    ServerError,
    APP_CONFIG,
    $http
  ) {
    return function () {
      var $container = $('<div>');
      var $primaryButton = $('<div>')
        .addClass('btn mfa-primary adp-action-b-primary')
        .text('Delete my account with all personal data')
        .click(deleteMyAccount);

      $container.append($primaryButton);

      return $container;

      function deleteMyAccount() {
        return AdpModalService
          .confirm({ message: 'This operation can lead to critical consequences and cannot be undone. Are you sure?' })
          .then(function() {
            var title = 'Are you totally sure you want to delete your account?';
            var text = 'This action cannot be undone. Your account will be deleted and you will be logged off. \nPlease type the EMAIL of your account to confirm and press \'Yes\'.';
            return AdpModalService.prompt({ title, text, saveButtonText: 'Yes, delete my account' });
          })
          .then(function(email) {
            const url = `${APP_CONFIG.apiUrl}/account/delete`;
            const body = { email };
            return $http.post(url, body);
          })
          .then(({ data }) => {
            if (!data.success) {
              throw new ServerError(data.message);
            }

            return AdpSessionService.doLogout();
          })
          .catch((error) => ErrorHelpers.handleError(error));
      }
    }
  }
})();
;(function () {
  angular.module('app.adpEmbedCodeModal', []).factory('AdpEmbedCodeModal', AdpEmbedCodeModal);

  /** @ngInject */
  function AdpEmbedCodeModal(AdpModalService) {
    return function () {
      const { row } = this;

      if (!row.canBeShared) {
        return AdpModalService.alert({ title: 'This widget cannot be shared' });
      }

      const { action } = this;
      const { entityName = 'Item', idFieldName, embedTypePrefix } = _.get(
        this,
        `modelSchema.actions.fields.${action}.action.params`
      );
      const id = row[idFieldName];
      const params = { id, entityName, embedTypePrefix };

      return AdpModalService.createModal('adpEmbedCodeModalComponent', params).result;
    };
  }
})();
;(function () {
  angular.module('app.adpFilterBuilder', []);
})();
;(function() {
  angular.module('app.adpForceGraph', []);
})();
;;(function () {
  angular.module('app.adpFormActions', [])
    .factory('AdpFormActions', function (
      GraphqlCollectionMutator,
      AdpNotificationService,
      AdpFormDataUtils,
      AdpFormService,
      ActionMessages,
      $timeout,
      AdpMenuService,
      ACTIONS,
      AdpModalService,
      AdpCopyPasteActionService,
      AdpRtcActions,
      AdpGuessSchema,
      ErrorHelpers,
      AdpApplyDataset,
      GraphqlCollectionQuery,
      AdpVcsActionService
    ) {
      return {
        submit: doSubmit,

        apply(args) {
          return callSubmit(args)
            .then(function (responseData) {
              notifySuccess(args);

              const shouldChangeActionToUpdate = _.includes([ACTIONS.CREATE, ACTIONS.CLONE, ACTIONS.CLONE_DATASET], args.action);
              if (shouldChangeActionToUpdate) {
                args.row._id = responseData._id;
                args.action = ACTIONS.UPDATE;
              }

              return responseData;
            });
        },

        applyDataset(args, formHooks) {
          return callSubmit(args)
            .then(resp => AdpApplyDataset(args, resp, formHooks.triggerEvent));
        },

        cancel(args, formHooks) {
          formHooks.onCancel && formHooks.onCancel(args);
        },

        submitAndReload: function (args, formHooks) {
          return doSubmit(args, formHooks)
            .then(function (respData) {
              AdpNotificationService.notifySuccess('Reloading page');
              $timeout(function () {
                window.location.reload()
              }, 1000);

              return respData;
            });
        },

        submitAndUpdateMenu: function(args, formHooks) {
          return doSubmit(args, formHooks)
            .then(function (respData) {
              const cur = args.row;
              const prev = args.parentData;
              const influenceAttribute = _.get(args, 'fieldSchema.actions.fields.submit.action.params.favoriteAttrName', 'favorite');
              const currentFieldVal = _.get(cur, influenceAttribute );
              const previousFieldVal = _.get(prev, influenceAttribute );

              const toUpdateMenu = (currentFieldVal && prev.name !== cur.name) || (currentFieldVal !== previousFieldVal)

              if (toUpdateMenu) {
                AdpMenuService.generateMenu();
              }

              return respData;
            });
        },

        copyPaste(args, formHooks, { triggerEvent }) {
          return AdpCopyPasteActionService.callAction(args)
            .then(() => {
              triggerEvent('afterCopyPasteAction');
              AdpNotificationService.notifySuccess('Form data successfully updated.');
            });
        },

        vcs(args, formHooks, { triggerEvent }) {
          return AdpVcsActionService.callAction(args)
            .then(() => {
              triggerEvent('afterCopyPasteAction');
            });
        },

        guessSchema(args, formHooks, { triggerEvent }) {
          return AdpGuessSchema(args, triggerEvent)
            .catch(err => ErrorHelpers.handleError(err, 'Error while printing'))
        },

        directUploadFile(args, formHooks) {
          updateFileDataBeforeUpload(args);

          return doSubmit(args, formHooks);
        },

        applyDirectUploadFile(args, { triggerEvent }) {
          updateFileDataBeforeUpload(args);

          return callSubmit(args)
            .then((responseData) => {
              notifySuccess(args);

              return GraphqlCollectionQuery(args.modelSchema, { filter: ['_id', '=', responseData._id] })
                .then(result => _.get(result, 'items[0]'))
                .then(record => {
                  _.assign(args.row, record);
                  triggerEvent('afterCopyPasteAction');

                  return responseData;
                });
            });
        }
      };

      function doSubmit(args, formHooks) {
        return callSubmit(args)
          .then(function (respData) {
            formHooks.onComplete && formHooks.onComplete(args, respData);
            notifySuccess(args);

            return respData;
          });
      }

      function callSubmit(args) {
        var resultArgs = args;
        resultArgs = AdpFormService.addDefaultValuesForInvisibleFields(resultArgs);
        resultArgs = AdpFormDataUtils.transformDataBeforeSending(resultArgs);

        if (args.action === 'cloneDataSet') {
          _.unset(resultArgs, 'row.collectionName');
        }

        var additionalMutationArgs = args.mutationArgs || [];
        var allMutationArgs = _.concat([args.modelSchema, resultArgs.row], additionalMutationArgs);
        var result = GraphqlCollectionMutator[args.action].apply(null, allMutationArgs);
        AdpRtcActions.addInfoAboutRecordMutation(args.action, args.modelSchema, resultArgs.row);

        return result;
      }

      function notifySuccess(args) {
        var message = ActionMessages[args.action](args.modelSchema);

        AdpNotificationService.notifySuccess(message);
      }

      function updateFileDataBeforeUpload(args) {
        const file = _.get(args, 'row.file');
        const fieldsMap = {
          id: '_id',
          cropped: 'cropped',
          name: 'originalName',
          size: 'size',
          type: 'mimeType',
        };

        _.forEach(fieldsMap, (targetField, sourceField) => {
          args.row[targetField] = _.get(file, [0, sourceField]);
        });
        args.action = 'update';
      }
    });
})();
;(function() {
  angular.module('app.adpGlobe', []);
})();
;(function () {
  angular.module('app.adpGridColumnChooser', []).factory('AdpGridColumnChooser', AdpGridColumnChooser);

  /** @ngInject */
  function AdpGridColumnChooser(AdpClientCommonHelper) {
    return function (toolbarWidgetRegister) {
      const { actionOptions } = this;
      _.set(this, 'gridOptions.columnChooser.enabled', true);

      // Disabling default columnChooser is not an option as some functionality will be broken.
      // Default button is filtered out from toolbar.
      return toolbarWidgetRegister((gridComponent) => {
        return {
          widget: 'dxMenu',
          options: {
            dataSource: [{ template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions) }],
            cssClass: 'adp-toolbar-menu column-chooser-menu',
            onItemClick() {
              gridComponent.showColumnChooser();
            },
          },
        };
      });
    };
  }
})();
;(function () {
  angular.module('app.adpGridControlActions', [])
    .factory('AdpGridControlActions', GridControlsActions);

  /** @ngInject */
  function GridControlsActions(
    AdpClientCommonHelper,
    AdpSchemaService,
    GraphqlCollectionQuery,
    GridOptionsHelpers,
    ActionsHandlers
  ) {
    return {
      edit: editAction,
      create: createAction,
    };

    function editAction(data, gridInstance) {
      var schema = getSchemaByName(this.row.$meta_table);
      var dataToUpdate = _.cloneDeep(data);
      _.unset(dataToUpdate, '_table');
      _.unset(dataToUpdate, '_tableLabel');
      _.unset(dataToUpdate, '$meta_table');

      return ActionsHandlers.update(schema, dataToUpdate, gridInstance)
        .then(function () {
          GridOptionsHelpers.refreshGrid(gridInstance);
        });
    }

    function createAction(toolbarWidgetRegister) {
      var actionOptions = this.actionOptions;
      var isDisabled = _.get(actionOptions, 'params.disabled', false);

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          disabled: isDisabled,
          options: {
            cssClass: 'create-grid-control',
            dataSource: createDataSourceForCreateActionMenu(actionOptions),
            showSubmenuMode: {
              name: 'onClick',
              delay: {show: 0, hide: 0}
            },
            onItemClick: function onItemClick(e) {
              var schemaName = e.itemData.schemaName;
              if (!schemaName) {
                return;
              }
              var schema = getSchemaByName(schemaName);
              var createDataGetter = _.get(actionOptions, 'params.createDataGetter');
              var createData = _.isFunction(createDataGetter) ? createDataGetter(schemaName) : {}

              ActionsHandlers.create(schema, createData, gridComponent)
                .then(function () {
                  GridOptionsHelpers.refreshGrid(gridComponent);
                });

              AdpClientCommonHelper.repaintToolbar(gridComponent);
            }
          }
        };
      });
    }

    function createDataSourceForCreateActionMenu(actionOptions) {
      var className = 'btn page-action btn-primary';
      var tableNames = _.keys(actionOptions.table);
      var buttonText = tableNames.length === 1 ? 'Create "' + _.startCase(tableNames[0]) + '"' : 'Create record';
      var isDisabled = _.get(actionOptions, 'params.disabled', false);

      var dataSource = [
        {
          template: '<button type="button" class="' + className + '">' + buttonText + '</button>',
          disabled: isDisabled
        }
      ];

      if (tableNames.length === 1) {
        dataSource[0].schemaName = tableNames[0];
      } else {
        dataSource[0].items = _.map(actionOptions.table, function (table, name) {
          return {
            text: 'Create "' + _.startCase(name) + '"',
            schemaName: name
          };
        });
      }

      return dataSource;
    }

    function getSchemaByName(name) {
      var APP_MODEL = window.adpAppStore.appModel();
      return _.cloneDeep(APP_MODEL[name]);
    }
  }
})();
;(function () {
  angular.module('app.adpGridPrint', []).factory('AdpGridPrint', GridPrint);

  /** @ngInject */
  function GridPrint(
    AdpClientCommonHelper,
    GridOptionsHelpers,
    GraphqlCollectionQuery,
    PrintTableBuilder,
    AdpNotificationService,
    AdpGeneratorModalService,
    AdpPrintHelper,
    GridSchema,
    ErrorHelpers
  ) {
    return function (toolbarWidgetRegister) {
      const schema = this.modelSchema;
      const actionOptions = this.actionOptions;

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          options: {
            dataSource: [{ template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions) }],
            cssClass: 'adp-toolbar-menu grid-view-menu',
            onItemClick: function () {
              printAction(schema, GridOptionsHelpers.getLoadOptions(gridComponent));
              AdpClientCommonHelper.repaintToolbar(gridComponent);
            },
          },
        };
      });
    };

    function printAction(schema, loadOptions) {
      const schemaForRequest = GridSchema.getSchemaForVisibleColumns(schema);
      const loadedId = 'loader' + Math.round( Math.random() * 100000);

      AdpGeneratorModalService.showLoader(loadedId);

      GraphqlCollectionQuery(schemaForRequest, loadOptions)
        .then(function (response) {
          if (!response.items.length) {
            return AdpNotificationService.notifyError('There is no records to print');
          }
          const html = PrintTableBuilder.build(schemaForRequest, response.items);
          const title = schema.fullName;
          return AdpPrintHelper.print({html, title});
        })
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Error while printing');
        })
        .finally(function(){
          AdpGeneratorModalService.hideLoader(loadedId);
        });
    }
  }
})();
;(function () {
  angular.module('app.adpGridQuickFilter', []).factory('AdpGridQuickFilter', AdpGridQuickFilter);

  /** @ngInject */
  function AdpGridQuickFilter(AdpClientCommonHelper, AdpSchemaService, GraphqlCollectionQuery, ErrorHelpers) {
    var storeSchema = AdpSchemaService.getSchemaByName('quickFilters');

    return function (toolbarWidgetRegister) {
      var schema = this.modelSchema;
      var actionOptions = this.actionOptions;
      var customGridOptions = this.customGridOptions;

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          options: createMenu(schema, gridComponent, customGridOptions, actionOptions),
        };
      });
    };

    function createMenu(schema, gridComponent, customGridOptions, actionOptions) {
      var menuActions = {
        reset: doReset,
        apply: doApply,
      };
      var menuComponent = null;
      var cachedList = null;

      return {
        dataSource: getMenuDataSource(),
        displayExpr: 'name',
        cssClass: 'adp-toolbar-menu grid-view-menu',
        hint: 'Quick filters',
        onInitialized: onInit,
        onItemClick: onItemClick,
      };

      function onInit(e) {
        menuComponent = e.component;
        customGridOptions.setHandler('change', 'quickFilterId', onFilterIdChange);
        AdpClientCommonHelper.highlightToolbarButton(menuComponent, customGridOptions.value('quickFilterId'))
      }

      function onFilterIdChange() {
        updateMenu(cachedList);
      }

      function doApply(itemData) {
        setUserData(itemData._id);
      }

      function doReset() {
        setUserData();
      }

      function setUserData(val) {
        var store = gridComponent.getDataSource();

        updateMenu(cachedList);
        customGridOptions.value('quickFilterId', val || '');

        store.reload();
      }

      function doLoadList() {
        return loadFilters(schema).then(function (list) {
          cachedList = list;
          updateMenu(list);
        });
      }

      function updateMenu(list) {
        menuComponent.option({
          dataSource: getMenuDataSource(list),
        });

        AdpClientCommonHelper.highlightToolbarButton(menuComponent, customGridOptions.value('quickFilterId'))
      }

      function onItemClick(e) {
        var action = e.itemData.action;

        if (action && menuActions[action]) {
          menuActions[action](e.itemData);
        } else {
          if (!cachedList) {
            doLoadList().then(function(){
            $(e.element)
              .find('.dx-menu-item')
              .eq(0)
              .trigger('dxclick');
            });
          }
        }

        return true;
      }

      function getMenuDataSource(cachedList) {
        var menuItems = cachedList
          ? _.map(cachedList, function (item) {
              return {
                name: item.name,
                _id: item._id,
                icon: customGridOptions.value('quickFilterId') === item._id ? 'check' : 'none',
                action: 'apply',
              };
            })
          : [];

        if (menuItems.length) {
          menuItems.push({
            template: function () {
              return $("<span class='menu-separator'>");
            },
            disabled: true,
          });
        }

        menuItems.push({
          name: 'None',
          icon: customGridOptions.value('quickFilterId') ? 'none' : 'check',
          action: 'reset',
        });

        return [
          {
            template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions),
            items: menuItems,
          },
        ];
      }
    }

    function loadFilters(schema) {
      var params = {
        filter: [],
        skip: 0,
        take: 1000,
      };

      return GraphqlCollectionQuery(storeSchema, params)
        .then(function (result) {
          return _.filter(result.items, getForModelName(schema.schemaName));
        })
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error while loading quick filters list');
          throw error;
        });
    }

    function getForModelName(modelName) {
      return function (row) {
        var models = row.model;
        var regexpMode = !models.match(/^[\w,]+$/);

        if (regexpMode) {
          try {
            return modelName.match(new RegExp(models));
          } catch (e) {
            return false;
          }
        } else {
          return _.indexOf(models.split(','), modelName) >= 0;
        }
      };
    }
  }
})();
;(function () {
  angular.module('app.adpGridRowActions', [])
    .factory('AdpGridRowActions', AdpGridRowActions);

  /** @ngInject */
  function AdpGridRowActions(
    APP_CONFIG,
    ErrorHelpers,
    ServerError,
    $http,
    AdpModalService
  ) {
    return {
      viewRawAction,
    };

    function viewRawAction() {
      const { schemaName } = this.modelSchema;
      const id = this.row._id;
      const url = `${APP_CONFIG.apiUrl}/getRawRecord/${schemaName}/${id}`;

      $http.get(url)
        .then(result => {
          const { success, data, message } = result.data;
          if (!success) {
            throw new ServerError(message);
          }
          const params = {schemaName, data};
          AdpModalService.createModal('adpRawRecordView', params)
            .result
            .catch(_.noop);
        })
        .catch(e => {
          if (e) {
            ErrorHelpers.handleError(e, 'Error while loading raw data.');
          }
        });
    }
  }
})();
;(function () {
  angular.module('app.adpGridViewManager', []).factory('AdpGridViewManager', AdpGridViewManager);

  /** @ngInject */
  function AdpGridViewManager(AdpClientCommonHelper, AdpGridViewManagerService) {
    return function (toolbarWidgetRegister) {
      var schema = this.modelSchema;
      var actionOptions = this.actionOptions;
      var customGridOptions = this.customGridOptions;

      toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          options: AdpGridViewManagerService.createMenuOptions(schema, gridComponent, customGridOptions, actionOptions),
        };
      });
    };
  }
})();
;(function () {
  function getStateUrl(url, suffix) {
    return suffix ? suffix + url : url;
  }

  angular
    .module('app.adpGridstack', [])
    /** @ngInject * */
    .config(($stateProvider, APP_CONFIG) => {
      const embedUrl = `${APP_CONFIG.publishedEndpointPrefix}/d/:sharedDashboardId?filter`;
      $stateProvider.state('gridstackEmbedded', {
        url: getStateUrl(embedUrl, APP_CONFIG.appSuffix),
        params: {
          sharedDashboardId: null,
        },
        views: {
          root: {
            templateUrl: 'client-modules/adp-gridstack/adp-gs-embed/adp-gs-embed.html',
            controller: 'AdpGsEmbedController as vm',
          },
        },
        data: {
          // 'guest' strategy causes redirect to home page from embedding widget\dashboard if neighbour tab is logged.
          // Current solution is to keep redirectStrategy empty, but this looks like side-effect & possibly should be fixed withing 'FE-for-embed' version
          // redirectStrategy: 'guest'
        },
      });
      const clearDashboardUrl = `/dashboard-frameless/:sharedDashboardId?filter`;
      $stateProvider.state('dashboardOnlyOnPage', {
        url: getStateUrl(clearDashboardUrl, APP_CONFIG.appSuffix),
        params: {
          sharedDashboardId: null,
        },
        views: {
          root: {
            templateUrl: 'client-modules/adp-gridstack/adp-gs-frameless/adp-gs-frameless.html',
            controller: 'AdpGsViewController as vm',
          },
        },
        data: {
          redirectStrategy: 'user',
        },
      });
    });
})();
;;(function () {
  'use strict';

  var tourScriptReady;

  angular
    .module('app.adpGuidedTour', [])
    .run(function (APP_CONFIG) {
      var resourceUrl = APP_CONFIG.resourceUrl + '/public/js/lib/tour.js';

      tourScriptReady = $.getScript(resourceUrl)
        .catch(function (err) {
          console.log('Error loading library for guided tour: ', err);
        });
    })
    .run(function ($transitions, AdpGuidedTourService, $rootScope, $location) {
      var startTour = function () {
        tourScriptReady
          .then(function () {
            var currentUrl = $location.path();
            if (!AdpGuidedTourService.tourEnabledForUrl(currentUrl)) {
              return;
            }
            var currentTour = AdpGuidedTourService.createAndStart(currentUrl);

            var disposeEvent = $rootScope.$on('$locationChangeStart', function () {
              currentTour && currentTour.cancel();
              disposeEvent();
            });
          })
          .catch(function (err) {
            console.log(err);
          });
      }

      $transitions.onSuccess({ to: AdpGuidedTourService.checkTourExistForPage }, startTour);
    })
})();
;(function () {
  'use strict';

  angular.module('app.adpMarketplaceCart', [])
})();
;(function () {
  'use strict';

  angular.module('app.adpMarketplaceServerActions', [])
})();
;(function () {
  'use strict';

  angular.module('app.adpNginxWhiteList', [])
    .factory('AdpNginxWhiteList', AdpNginxWhiteList);

  /** @ngInject */
  function AdpNginxWhiteList(
    APP_CONFIG,
    $http,
    AdpNotificationService,
    ServerError,
    ErrorHelpers
  ) {
    return {
      saveNginxWhiteList(args, formHooks) {
        const url = APP_CONFIG.apiUrl + '/save-nginx-white-list';
        const recordToSave = _.pick(args.row, ['ips', '_id'])

        return $http.post(url, recordToSave)
          .then((res) => {
            if (!res.data.success) {
              throw new ServerError(res.data.message);
            }

            AdpNotificationService.notifySuccess(res.data.message);
            formHooks.onComplete && formHooks.onComplete(args, res);
          })
          .catch(err => ErrorHelpers.handleError(err, 'Unknown error saving "Nginx Whitelist" request'));
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpPasswordRequirements', [])
    .factory('AdpPasswordRequirements', AdpPasswordRequirements);

  /** @ngInject */
  function AdpPasswordRequirements(
    APP_CONFIG,
    $http,
    AdpClientCommonHelper,
    AdpNotificationService,
    AdpSchemaService
  ) {
    var formSchema = AdpSchemaService.getSchemaByName('_passwordRequirements');

    function openSettingsForm() {
      return AdpClientCommonHelper.openEnvironmentUpdateDialog(formSchema);
    }

    function saveSettings(args) {
      var url = APP_CONFIG.apiUrl + '/save-password-requirements';

      _serverRequest(url, args.row, 'Saving password requirements...');
    }

    function _serverRequest(url, body, message) {
      var toast = AdpNotificationService.notifyInfo(message);

      return $http.post(url, body)
        .then(function (res) {
          if (!res.data.success) {
            throw new Error(res.data.message);
          }
          AdpNotificationService.notifySuccess(res.data.message, '', { replace: toast });
        })
        .catch(function (err) {
          AdpNotificationService.notifyError(err.message || err, '', { replace: toast });
        })
    }


    return {
      openSettingsForm: openSettingsForm,
      saveSettings: saveSettings
    }
  }
})();
;(function () {
  angular.module('app.adpPaymentPlans', []).run(initPaymentPlansApi);

  /** @ngInject * */
  function initPaymentPlansApi(AdpPaymentPlansService) {
    _.set(window, 'adpApi.listPaymentPlans', AdpPaymentPlansService.listPlans);
  }
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpProfile', [])
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(
    ACTIONS,
    GraphqlCollectionQuery,
    ErrorHelpers,
    AdpUnifiedArgs,
    $rootScope
  ) {
    var vm = this;
    vm.formOptions = {
      schemaActionsStrategy: {
        onComplete: afterFormUpdate,
        onCancel: afterFormUpdate,
      },
      disableFullscreen: true,
    };

    vm.editing = false;
    vm.loading = true;

    (function init() {
      setTemplateMethods();

      vm.userSchema = getUserSchema();
      vm.userID = lsService.getUser().id;

      getPageData(vm.userID, vm.userSchema);
    })();

    function getUserSchema() {
      var APP_MODEL = window.adpAppStore.appModel();
      return _.clone(_.get(APP_MODEL, 'users'));
    }

    function afterFormUpdate() {
      getPageData(vm.userID, vm.userSchema)
        .then(updateAvatar)
        .then(vm.cancelEditMode);
    }

    function getPageData(userID, schema) {
      return GraphqlCollectionQuery(schema, { filter: ['_id', '=', userID] })
        .then(function (data) {
          return _.get(data, 'items[0]', {});
        })
        .then(updatePageParams)
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error trying to data for query params');
        });
    }

    function updatePageParams(data) {
      vm.formParams = _.get(vm.userSchema, 'parameters', {});
      vm.args = getArgs(data);
      vm.loading = false;

      return data;
    }

    function updateAvatar(data) {
      var avatar = _.get(data, 'avatar.0', {});
      var user = lsService.getUser();
      var newUser = _.assign({}, user, { avatar: avatar });
      lsService.setUser(newUser);

      _.set($rootScope, 'avatar', avatar);
    }

    function getArgs(data) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: ACTIONS.UPDATE,
        formData: data || {},
        schema: vm.userSchema,
      });
    }

    function setTemplateMethods() {
      vm.enterEditMode = function () {
        vm.editArgs = _.cloneDeep(vm.args);
        vm.editing = true;
      };

      vm.cancelEditMode = function () {
        vm.editArgs = null;
        vm.editing = false;
      };

      vm.showButton = function(actionToShow) {
        var hasPermission = _.hasIn(vm.args.modelSchema, 'actions.fields.' + actionToShow);
        if (!hasPermission) {
          return false;
        }

        return vm.args.action === actionToShow;
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpRolesPermissionsEditor', [])
    .controller('AdpRolesPermissionsEditor', RolesPermissionsEditor);

  /** @ngInject */
  function RolesPermissionsEditor(
    APP_CONFIG,
    AdpSchemaService,
    ActionsHandlers,
    AdpNotificationService,
    GridActionsTemplate,
    ActionsHelpers,
    GraphqlCollectionQuery,
    GraphqlCollectionMutator,
    ErrorHelpers
  ) {
    const vm = this;
    const rolesSchema = AdpSchemaService.getSchemaByName('roles');
    const INTERFACE = window.adpAppStore.appInterface();
    const allPermissions = _.get(INTERFACE, 'app.permissions', {});
    const permissions = _.pickBy(allPermissions, perm => perm.group !== 'Access');
    let sortingMode = -1;
    let gridComponent;

    vm.isSaving = false;
    vm.apiUrl = APP_CONFIG.apiUrl;

    vm.$onInit = function () {
      loadRoles()
        .then(transformLoadedRoles)
        .then(function (roles) {
          const options = getGridOptions(roles);

          $('#rp-grid-container').dxDataGrid(options);

          vm.onSave = getSaveHandler(roles);
          vm.createRole = function () {
            ActionsHandlers.create(rolesSchema, null, gridComponent).then(reloadRoles);
          }
        })
    }

    function onPermissionChange(role, permissionName, operationAdd, roles) {
      role.isChanged = true;
      role.permObj[permissionName] = operationAdd;
      const store = gridComponent.getDataSource().store();
      return store.update(permissionName, makePermissionRow(permissionName, roles));
    }

    function getSaveHandler(roles) {
      return function () {
        const rolesToSave = _.filter(roles, role=>role.isChanged);

        if (!rolesToSave.length) {
          AdpNotificationService.notifySuccess('Nothing to be saved');
          return;
        }

        const promises = _.map(rolesToSave, function (role) {
          const permissions = _.transform(
            _.omit(role.permObj, ['accessAsGuest', 'accessAsUser']),
            (acc, val, key) => {
              val && acc.push(key)
            }, [])
          const record = {
            _id: role._id,
            permissions,
          };

          return GraphqlCollectionMutator
            .update(rolesSchema, record, ['permissions'])
            .then(() => {
              role.isChanged = false
            });
        });

        vm.isSaving = true;

        return Promise.all(promises)
          .then(function () {
            AdpNotificationService.notifySuccess('All changes are saved successfully');
          })
          .catch(function (error) {
            ErrorHelpers.handleError(error, 'Unknown error while saving roles');
            throw error;
          })
          .finally(function () {
            vm.isSaving = false;
          })
      }
    }

    function getColumnsOptions(roles) {
      const columns = _.map(roles, (role, index)=> getRoleColumnOptions(roles, index));

      columns.unshift(getGroupColumnOptions());
      columns.unshift(getPermissionsColumnOptions());

      return columns;
    }

    function getSortingClickHeader(component, colIndex, title) {
      return $('<div/>')
        .text(title)
        .click(
          function () {
            if (colIndex) {
              return
            }

            sortingMode = (sortingMode + 1) % 4;

            const nameOrder = sortingMode % 2 ? 'desc' : 'asc';
            const groupOrder = sortingMode > 1 ? 'desc' : 'asc';

            component.columnOption(0, {
              sortOrder: nameOrder,
              sortIndex: 0
            });

            component.columnOption(1, {
              sortOrder: groupOrder,
              sortIndex: 1
            });
          }
        );
    }

    function getDropdownContainer() {
      return $('<div/>')
        .addClass('rp-role-actions-dropdown-container');
    }

    function getDataSource(roles) {
      const rows = _.map(permissions, (permission, name) => makePermissionRow(name, roles));
      return {
        store:{
          type:"array",
          key:"name",
          data: rows,
        }
      }
    }

    function makePermissionRow(permissionName, roles){
      const permission = permissions[permissionName];
      const row = {
        name: permissionName,
        title: permission.description || makeNaturalName(permissionName),
        group: permission.group || 'Other'
      };

      _.each(roles, (role, index) => {
        row[getDataFieldName(index)] = !!role.permObj[permissionName];
      });

      return row;
    }

    function getGridOptions(roles) {
      return {
        dataSource: getDataSource(roles),
        columns: getColumnsOptions(roles),
        hoverStateEnabled: true,
        filterRow: {
          visible: true
        },
        paging: {
          enabled: false
        },
        stateStoring: {
          enabled: true
        },
        sorting: {
          mode: 'none'
        },
        grouping: {
          autoExpandAll: false
        },
        onInitialized: function (event) {
          gridComponent = event.component;
          gridComponent.refresh = reloadRoles; // Dirty hack to update dataGrid after (role altering) form actions
        }
      };
    }

    function getPermissionsColumnOptions() {
      return {
        cssClass: 'perm-name perm-td',
        caption: '',
        fixed: true,
        dataField: 'title',
        width: 220,
        sortIndex: 0,
        filterOperations: ['contains', 'endswith', '='],
        headerCellTemplate: function (container, headerCellInfo) {
          container.append(getSortingClickHeader(headerCellInfo.component, 0, 'Permissions'));
        }
      }
    }

    function getGroupColumnOptions() {
      return {
        dataField: 'group',
        groupIndex: 0,
        sortIndex: 1,
        groupCellTemplate: function ($cellElement, event) {
          $('<strong>')
            .text(event.value)
            .appendTo($cellElement);
        }
      }
    }

    function getRoleColumnOptions(roles, index) {
      const role = roles[index];
      const roleName = role.name;
      const rolesActions = ActionsHelpers.pickTableActions(rolesSchema);

      return {
        cssClass: 'perm-td',
        caption: makeNaturalName(roleName),
        dataField: getDataFieldName(index),
        cellTemplate: function (container, cellInfo) {
          const permName = cellInfo.data.name;

          container.append($('<input type=\'checkbox\'/>')
            .attr('checked', cellInfo.value)
            .attr('title', 'Permission \'' + permName + '\' to Role \'' + roleName + '\'')
            .click(e=> onPermissionChange(role, permName, e.currentTarget.checked, roles))
          );
        },
        headerCellTemplate: function (container, headerCellInfo) {
          const actionPermissionsForRecord = role._actions;
          const rolePermittedActions = _.pickBy(rolesActions, (actionItem, name) => _.get(actionPermissionsForRecord, name, false));

          container.append(getSortingClickHeader(headerCellInfo.component, index + 1, makeNaturalName(roleName)));

          if (ActionsHelpers.actionsIsEmpty(rolePermittedActions)) {
            return;
          }
          const row = roleToRecord(role);
          const $actionsDropdown = GridActionsTemplate(rolePermittedActions, row, rolesSchema, { gridComponent });

          $actionsDropdown.find('.dx-menu')
            .click(function (e) {
              e.stopPropagation();
              e.stopImmediatePropagation();
            });

          const $actionsDropdownContainer = getDropdownContainer();

          $actionsDropdownContainer.append($actionsDropdown)
            .click(function (e) {
              e.stopPropagation();
              e.stopImmediatePropagation();
            });

          container.parent()
            .append($actionsDropdownContainer);

        }
      }
    }

    function refreshGridOptions(roles) {
      gridComponent.option({
        dataSource: getDataSource(roles),
        columns: getColumnsOptions(roles)
      })
    }

    function reloadRoles() {
      return loadRoles()
        .then(transformLoadedRoles)
        .then(function (roles) {
          vm.onSave = getSaveHandler(roles);
          refreshGridOptions(roles);
        });
    }

    function loadRoles() {
      const params = {
        skip: 0,
        take: 100000
      };

      return GraphqlCollectionQuery(rolesSchema, params)
        .then(function (result) {
          return result.items;
        })
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error while loading roles');
          throw error;
        });
    }

    function transformLoadedRoles(roles) {
      const editableRoles = _.filter(roles, (role) =>role._actions.update);
      return _.map(editableRoles, expandRole);
    }

    function expandRole(role) {
      role.isChanged = false;
      role.permObj = _.reduce(role.permissions, function (acc, x) {
        acc[x] = true;
        return acc;
      }, {});

      return role;
    }

    function roleToRecord(role) { // === unExpandRole()
      return _.omit(role, ['isChanged', 'permObj']);
    }

    function getDataFieldName(num) {
      return 'r' + num;
    }

    function makeNaturalName(name) {
      return _.startCase(name);
    }
  }

// TODO: Please add code adding new custom action handler here
})();
;(function () {
  'use strict';

  angular.module('app.adpRtcActions', [])
    .factory('AdpRtcActions', AdpRtcActions);

  /** @ngInject */
  function AdpRtcActions(
    AdpClientCommonHelper,
    AdpModalService,
    $interval
  ) {
    var gridChangeNotificationShownFlag = false;
    var mongoDbChangeToMessages = {
      // This data has changed. Do you want to _reload this view_?
      recorddeleted:  'Record on this page is removed by another user',
      recordupdated:  'Record on this page is updated by another user',
      recordchanged:  'Record on this page is changed by another user',
      recordcreated:  'New record has been added to this collection by another user',
      // collectionCreated: "Collection created",   //Yet not useful - only collection-related events are processed
      // collectionDeleted: "Collection removed",
    }

    function doRegisterGridDbChangeNotification() {
      var minPause = _.get(this, 'fieldSchema.action.params.minTimeBetweenReloads', 1000);
      var getGridComponent = _.bind(function () { return _.get(this, 'customGridOptions.gridComponent') }, this);

      this.notificationFn = _.debounce(gridChangeNotification, minPause);

      return getReloadNotificationProcessor(this.notificationFn, getGridComponent, this.modelSchema, this.fieldSchema);
    }

    function doRegisterGridDbChangeAutoreload() {
      var minPause = _.get(this, 'fieldSchema.action.params.minTimeBetweenReloads', 1000);
      var maxPause = _.get(this, 'fieldSchema.action.params.maxTimeBetweenReloads', -1);
      var bindedReloader = _.bind(function () {
        var gridComponent = _.get(this, 'customGridOptions.gridComponent');
        gridComponent && gridComponent.refresh();
      }, this);
      var reloaderFn = _.debounce(bindedReloader, minPause);

      if (maxPause > 0) {
        this.autoReloadInterval = $interval(reloaderFn, maxPause);
      }

      return getAutoReloadProcessor(reloaderFn, this.modelSchema, this.fieldSchema);
    }

      doRegisterGridDbChangeNotification.onUnsubscribe =
      // Optional method. To be called at the moment RTC processor is unregistered (normally on dxGrid's dispose).
      // Supported for "rtc" actions only.
      function () {
        this.notificationFn && this.notificationFn.cancel();
      }
      doRegisterGridDbChangeAutoreload.onUnsubscribe =
      // Optional method. To be called at the moment RTC processor is unregistered (normally on dxGrid's dispose).
      // Supported for "rtc" actions only.
      function () {
        this.autoReloadInterval &&  $interval.cancel(this.autoReloadInterval);
      }


    function getAutoReloadProcessor(reloaderFn, schema, action) {
      return function (data) {
        if (isMessageAppliable(schema, data, action)) {
          reloaderFn();
        }
        return true;
      }
    }

    function getReloadNotificationProcessor(notificationFn, getGridComponent, schema, action) {
      return function (data) {
        if (!gridChangeNotificationShownFlag && isMessageAppliable(schema, data, action)) {
          var gridComponent = getGridComponent();
          if (isNotificationRequired(data, gridComponent)) {
            notificationFn(data, gridComponent);
          }
        }
        return true;
      }
    }

    function isNotificationRequired(data, gridComponent) {
      if (gridComponent === undefined) {
        return false;
      }

      var changeType = _.get(data, 'data.change');
      if (changeType === 'recordcreated') {
        return true;
      }

      var alteredRecordId = _.get(data, 'data._id');
      if (alteredRecordId === undefined ) {
        return true; // If _id is undefined this probably means collection is altered by CV, for example, so no particulat record is known, but we need to reload.
      }
      var visibleRows = gridComponent.getVisibleRows();
      var isAlteredRecordVisible = _.find(visibleRows, function (row) {
        return row.rowType === 'data' && row.data._id === alteredRecordId;
      })
      return isAlteredRecordVisible;
    }

    function gridChangeNotification(data, gridComponent) {
      const changeType = _.get(data, 'data.change');
      const message = mongoDbChangeToMessages[changeType] || changeType;

      AdpModalService.createModal('AdpDbChangeNotificationModal', {
        message,
        windowClass: 'adp-dialog-change-notification',
        backdropClass: 'adp-hide-backdrop',
        timeOut: 0,
        preventDuplicates: true
      }).result.then(function () {
          gridComponent && gridComponent.refresh();
          gridChangeNotificationShownFlag = false;
        })
        .catch(function () {
          gridChangeNotificationShownFlag = false;
        });

      gridChangeNotificationShownFlag = true;
    }

    function isMessageAppliable(schema, data, action)   {
      var type = _.get(data, 'type');
      var currentSchemaName = _.get(schema, 'schemaName');
      if (type === 'backgroundJobs' && currentSchemaName === 'backgroundJobs') {
        return true;
      }
      if (type !== 'database') {
        return false;
      }

      var messageData = _.get(data, 'data', {});
      var messageSchemaName = messageData.schemaName;
      var messageChangeType = messageData.change;

      var isCurrentSchema = messageSchemaName === currentSchemaName;
      if (isCurrentSchema) {
        var key = getMutatedRecordsInfoKey(messageChangeType, currentSchemaName, messageData._id);
        var isMutatedFromThisTab = key && mutatedRecordsInfo[key];
        if (isMutatedFromThisTab) {
          delete mutatedRecordsInfo[key];
          return false;
        }
        return true;
      }

      var actionChangeType = _.get(action, 'action.params.changeType');
      if (!_.isUndefined(actionChangeType)) {
        var isCollectionRelatedChange = messageChangeType.startsWith('collection')

        if (_.isString(actionChangeType)) {
          actionChangeType = [actionChangeType];
        }

        return _.indexOf(actionChangeType, messageChangeType)>=0 && (isCollectionRelatedChange || isCurrentSchema)
      }

      return false;
    }

    var CHANGED_RECORD_CLEAR_TIMEOUT = 10000;
    // Used for skipping notification for a record that was mutated on current tab
    var mutatedRecordsInfo = {};
    var recordChangeTypes = ['recorddeleted', 'recordupdated', 'recordcreated', 'recordchanged'];
    function getMutatedRecordsInfoKey (messageChangeType, schemaName, rowId) {
      if (!recordChangeTypes.includes(messageChangeType)) {
        return;
      }
      // on create row._id is empty for client, it's available only when server creates it
      var rowId = messageChangeType === 'recordcreated' ? '' : rowId;
      return `${messageChangeType}${schemaName}${rowId}`;
    }
    function addInfoAboutRecordMutation(action, modelSchema, row) {
      const messageChangeType = `record${action}d`;
      var key = getMutatedRecordsInfoKey(messageChangeType, modelSchema.schemaName, row._id);
      mutatedRecordsInfo[key] = true;

      setTimeout(function () { delete mutatedRecordsInfo[key]; }, CHANGED_RECORD_CLEAR_TIMEOUT);
    }

    return {
      gridDbChangeNotification: doRegisterGridDbChangeNotification,
      gridDbChangeAutoreload: doRegisterGridDbChangeAutoreload,
      addInfoAboutRecordMutation: addInfoAboutRecordMutation
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpSmtpTest', [])
    .factory('AdpSmtpTest', AdpSmtpTest);

  /** @ngInject */
  function AdpSmtpTest(
    APP_CONFIG,
    $http,
    AdpNotificationService,
    AdpClientCommonHelper,
    AdpSchemaService
  ) {
    var formSchema = AdpSchemaService.getSchemaByName('_smtpConfiguration');

    function openSettingsForm() {
      var url = APP_CONFIG.apiUrl + '/email-settings';

      $http.get(url)
        .then(function (res) {
          if (!res.data.success) {
            throw new Error(res.data.message);
          }
          return AdpClientCommonHelper.openEnvironmentUpdateDialogWithData(formSchema, res.data.data, transformLoaded);
        })
        .catch(function (err) {
          AdpNotificationService.notifyError(err.message || err, 'SMTP config load error');
        })
    }

    function transformLoaded(row, fullEnv) {
      if (!row.EMAIL_SERVICE) {
        row.EMAIL_SERVICE = 'otherService';
      }

      return row;
    }

    function prepareEmailParams(row) {
      if (row.EMAIL_SERVICE === 'otherService') {
        delete row.EMAIL_SERVICE;
      }

      return row;
    }

    function sendTestEmail(args) {
      var url = APP_CONFIG.apiUrl + '/send-test-email';
      var body = prepareEmailParams(_.clone(args.row));

      return _serverRequest(url, body, "Sending test message...");
    }

    function saveSettings(args, formHooks) {
      var url = APP_CONFIG.apiUrl + '/save-email-settings';
      var body = prepareEmailParams(_.omit(args.row, 'sendTo'));

      _serverRequest(url, body)
        .then(function(){
          formHooks.onCancel && formHooks.onCancel(args);
        })
    }

    function _serverRequest(url, body, message) {
      var toast = message ? AdpNotificationService.notifyInfo(message) : null;

      return $http.post(url, body)
        .then(function (res) {
          if (!res.data.success) {
            throw new Error(res.data.message);
          }
          AdpNotificationService.notifySuccess(res.data.message, '', {replace: toast});
        })
        .catch(function (err) {
          AdpNotificationService.notifyError(err.message || err, 'SMTP test error', {replace: toast});
        })
    }

    return {
      openSettingsForm: openSettingsForm,
      sendTestEmail: sendTestEmail,
      saveSettings: saveSettings,
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpSso', [])
    .factory('adpSsoService', adpSsoService);

  /** @ngInject */
  function adpSsoService(
    APP_CONFIG,
    $http,
    AdpNotificationService,
    AdpFormActions,
    AdpUnifiedArgs,
    AdpModalService,
    ServerError
  ) {
    return {
      addSSO,
      setupSSO,
      toggleSsoStatus,
      removeSsoItem,
    }

    function addSSO(profileArgs) {
      return AdpModalService.createModal('adp-add-sso-modal', { args: profileArgs }).result;
    }

    function setupSSO(identityProvider, profileArgs) {
      const { label }= identityProvider;

      const provider = findProvider(label);
      const urlToAddProvider = getSSOUrl(provider);

      if (!urlToAddProvider) {
        AdpNotificationService.notifyError('Invalid "Identity Provider" configuration');
        return;
      }

      const warningMessage =
        'WARNING! All current changes to the profile will be saved and you will be redirected to the Identity Provider configuration page';

      AdpModalService.confirm({ message: warningMessage, okButtonText: 'OK' })
        .then(() => {
          profileArgs.row.sso = profileArgs.row.sso || [];
          return AdpFormActions.submit(profileArgs)
            .then(({ errors })  => {
              if (errors) {
                const messagesString = errors.map(({ message }) => message).join('<br/>');
                throw new ServerError(messagesString);
              }
            })
        })
        .then(() => $http.get(urlToAddProvider))
        .then((resp) => {
          const { data = {}, status } = resp;
          if (status === 200 && data.success === true) {
            const externalUrlToAddProvider = data.url;
            window.location = externalUrlToAddProvider;
            return;
          }

          const errorMessage = data.message || 'Unable to add Identity Provider';
          AdpNotificationService.notifyError(errorMessage);
        })
        .catch((error) => {
          error && console.log(error);
          const message = error instanceof ServerError ? error.message : 'Unable to add Identity Provider';
          AdpNotificationService.notifyError(message);
        });
    }

    function findProvider(fullNameToSearch) {
      const INTERFACE = window.adpAppStore.appInterface();
      const providers = _.get(INTERFACE, 'app.auth.identityProviders') || [];

      return _.find(providers, ({ fullName }) => fullName === fullNameToSearch);
    }

    function getSSOUrl(provider) {
      const idpId = _.get(provider, 'idpId');
      if (!idpId) {
        return null;
      }

      return `${APP_CONFIG.apiUrl}/sso/add/${idpId}`;
    }

    function toggleSsoStatus(items, index) {
      const ssoItem = items[index];
      const newEnabledValue = !ssoItem.enabled;
      const toggleAction = newEnabledValue ? 'enable' : 'disable';
      const ssoItemId = ssoItem._id;
      const url = `${APP_CONFIG.apiUrl}/sso/${toggleAction}/${ssoItemId}`;

      return $http.post(url)
          .then((resp) => {
            const { data = {}, status } = resp;
            if (status === 200 && data.success === true) {
              ssoItem.enabled = newEnabledValue;
              return true;
            }
            const errorMessage = data.message || `Unable to ${toggleAction} Identity Provider`;
            AdpNotificationService.notifyError(errorMessage);
          })
          .catch((error) => {
            error && console.log(error);
            AdpNotificationService.notifyError(`Unable to ${toggleAction} Identity Provider`);
          });
    }

    function removeSsoItem(items, index) {
      const ssoItem = items[index];
      const ssoItemId = ssoItem._id;
      const url = `${APP_CONFIG.apiUrl}/sso/remove/${ssoItemId}`;

      return $http.post(url)
          .then((resp) => {
            const { data = {}, status } = resp;
            if (status === 200 && data.success === true) {
              items.splice(index, 1);
              return true;
            }
            const errorMessage = data.message || `Unable to remove Identity Provider`;
            AdpNotificationService.notifyError(errorMessage);
          })
          .catch((error) => {
            error && console.log(error);
            AdpNotificationService.notifyError(`Unable to remove Identity Provider`);
          });
    }
  }
})();
;(function () {
  angular.module('app.adpSyntheticGenerate', []).factory('AdpSyntheticGenerate', AdpSyntheticGenerate);

  /** @ngInject */
  function AdpSyntheticGenerate(
    AdpNotificationService,
    AdpClientCommonHelper,
    AdpModalService,
    AdpSocketIoService,
    APP_CONFIG,
    $http
  ) {
    return function (toolbarWidgetRegister) {
      var schema = this.modelSchema;
      var actionOptions = this.actionOptions;

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          options: {
            dataSource: [{ template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions) }],
            cssClass: 'adp-toolbar-menu grid-view-menu',
            onItemClick: function () {
              doOpenGenerator(schema);
              AdpClientCommonHelper.repaintToolbar(gridComponent);
            },
          },
        };
      });
    };

    function doOpenGenerator(schema) {
      AdpModalService.createModal('adpGenModal', {
        schema: schema,
      }).result.then(function (res) {
        var body = {
          args: {
            batchName: res.batchName,
            count: res.recordsNum,
            schemaName: schema.schemaName,
          },
        };

        $http.post(APP_CONFIG.apiUrl + '/scgRun', body).then(function (res) {
          if (!res.data.success) {
            AdpNotificationService.notifyError(res.data.message, 'Generation job failed');
          }
        });
      });
    }
  }
})();
;(function () {
  angular.module('app.adpTableActions', [])
    .factory('AdpTableActions', function (
      ActionsHandlers,
      AdpMenuService
    ) {
      return {
        deleteAndUpdateMenu: function (data, gridInstance) {
          const context = this;
          const paramsMockup = { gridInstance };
          const { row } = context;
          const favAttrName = _.get(context, 'fieldSchema.actions.fields.submit.action.params.favoriteAttrName', 'favorite')
          const toUpdateMenu = row[favAttrName];

          return ActionsHandlers.delete(context.modelSchema, row, paramsMockup)
            .then(() => {
              if (toUpdateMenu) {
                AdpMenuService.generateMenu();
              }
            });
        }
      };
    });
})();
;(function() {
  angular.module('app.adpTopomap', []);
})();
;(function () {
  'use strict';

  angular.module('app.adpTwoFactorConfigControl', [])
    .factory('AdpTwoFactorConfigControl', AdpTwoFactorConfigControl);

  /** @ngInject */
  function AdpTwoFactorConfigControl(
    AdpNotificationService,
    AdpTwoFactorHelper,
    AdpModalService
  ) {
    return function () {
      var context = this;
      var isTwoFactorActive = this.data;
      var $container = $('<div>');
      var fieldName = _.get(context, 'fieldSchema.fieldName');
      var isRegisterForm = _.get(context, 'fieldSchema.formRenderer.renderMode') === 'register';
      var featureName = '2FA';
      var currentUser = lsService.getUser();
      var isEnableAllowed = isRegisterForm || (currentUser.login === this.row.login);
      var userSsoProviders = this.row.sso;

      generateControl(isTwoFactorActive, userSsoProviders);

      return $container;

      function generateControl(isTwoFactorActive, userSsoProviders) {
        let $primaryButton = $('<div>').addClass('btn mfa-primary');
        let $statusText;
        let $backupButton;

        if (!isRegisterForm) {
          $statusText = $('<div>').text(featureName + ' ' + getEnableDisableLabel(isTwoFactorActive));
          $primaryButton = $('<div>').addClass('adp-action-b-primary');
        }

        if (isTwoFactorActive) {
          $backupButton = $('<div>')
            .addClass('btn adp-action-b-secondary')
            .text(featureName + ' backup codes');

          const appInterface = window.adpAppStore.appInterface();
          const providers = _.get(appInterface, 'app.auth.identityProviders') || [];
          const localMfaRequired = _.get(appInterface, "app.auth.requireMfa");

          const ssoProvidersMfaRequired = _.find(userSsoProviders,  userSsoProvider  => {
            if (!userSsoProvider.enabled) {
              return false;
            }
            const provider = providers.find((p) => {
              const providerId = p._id;
              const userProviderId = _.get(userSsoProvider, 'identityProvider._id');
              return providerId && userProviderId && providerId.toString() === userProviderId.toString();
            });
            if (!provider) {
              return false;
            }
            return provider.mfaEnabled && provider.mfaRequired;
          });
          const mfaRequired =  localMfaRequired || ssoProvidersMfaRequired;

          if (isRegisterForm || mfaRequired) {
            if (isEnableAllowed) {
              $primaryButton.text('Re-initialize ' + featureName).click(enableTwoFactor);
            } else {
              $primaryButton = null;
            }
          } else {
            $primaryButton.text('Disable ' + featureName).click(disableTwoFactor);
          }

          if (isRegisterForm) {
            $backupButton.click(showAboutBackupImportance);
          } else {
            $backupButton.addClass('adp-action-b-secondary').click(showBackupTokens);
          }
        } else {
          if (isEnableAllowed) {
            $primaryButton.text('Enable ' + featureName).click(enableTwoFactor);
          } else {
            $primaryButton = null;
          }
        }

        _.reduce([$statusText, ' ', $primaryButton, ' ', $backupButton],
          function ($container, $elem) {
            $elem && $container.append($elem)

            return $container;
          }, $container.empty());
      }

      function setTwoFactorFieldsData(isTwoFactorActive) {
        var notification = featureName + ' ' + getEnableDisableLabel(isTwoFactorActive);

        AdpNotificationService.notifySuccess(notification);

        generateControl(isTwoFactorActive);
        setTwoFactorBackupFieldsData(null, null);

        context.parentData[fieldName] = isTwoFactorActive;
      }

      function setTwoFactorBackupFieldsData(counter, used) {
          context.parentData[AdpTwoFactorHelper.const.BACKUP_COUNTER_FIELD_NAME] = counter;
          context.parentData[AdpTwoFactorHelper.const.BACKUP_USED_FIELD_NAME] = used;
      }

      function enableTwoFactor() {
        var login = isRegisterForm ? context.row.login : lsService.getUser().login;

        AdpModalService.createModal('adpTwoFactorConfigControlDialogComponent', {isRegisterForm:isRegisterForm, login: login})
          .result
          .then(function (res) {
            res && setTwoFactorFieldsData(true);
          })
          .catch(function () {
          });
      }

      function disableTwoFactor() {
        var message = AdpTwoFactorHelper.const.CONFIRM_DISABLE_MSG.replace('%label%', featureName.toLowerCase())

        AdpModalService.confirm({message: message})
          .then(function () {
            return AdpTwoFactorHelper.request(null, AdpTwoFactorHelper.url.disableTwoFactor, {method: 'post'})
          })
          .then(function () {
            setTwoFactorFieldsData(false);
          })
          .catch(function () {
          });
      }

      function showBackupTokens() {
        AdpModalService.createModal('adpTwoFactorBackupTokensDialogComponent', {
          counter: context.parentData[AdpTwoFactorHelper.const.BACKUP_COUNTER_FIELD_NAME],
          used: context.parentData[AdpTwoFactorHelper.const.BACKUP_USED_FIELD_NAME]
        })
          .result
          .then(function (res) {
            res && setTwoFactorBackupFieldsData(res.counter, res.used);
          })
          .catch(function () {
          });
      }

      function showAboutBackupImportance() {
        AdpModalService.alert({
          message: AdpTwoFactorHelper.const.BACKUP_CODES_IMPORTANCE_MSG,
          sizeSmall: true,
        })
      }

      function getEnableDisableLabel(enable) {
         return AdpTwoFactorHelper.const[enable ? 'IS_ENABLED' : 'IS_DISABLED'];
      }
    }
  }
})();
;(function () {
  angular.module('app.aggregationPipeline', []);
})();
;(function() {
  'use strict';

  // from core
  // exposes app model to the interface, loads data if necessary
  angular.module('app.default', [])
    .run(function ($transitions, $location, $timeout) { // handles customizable home page
    var defaultState = window.adpAppStore.defaultState();

    var homeState = {
      name: 'app.home',
      url: '/home',
    };
    $transitions.onEnter({ entering: homeState.name }, function (state) {
      if (homeState.url !== defaultState.url) {
        // $timeout allows to run redirect after transition aborted
        $timeout(function () {
          $location.path(defaultState.url);
          $location.replace();
        });
      }
    });
  }).controller('DefaultController', DefaultController);

  /** @ngInject */
  function DefaultController( // this implements custom page linked to datatables rows vial link action
    $state,
    APP_CONFIG,
    $http,
    $location // ideally I'd like to use $routeParams, but angular-route.js doesn't seem to be loaded
  ) {
    var vm = this;
    vm.data = $state.current.data;
    vm.loading = false;
    vm.APP_CONFIG = APP_CONFIG;
    vm.INTERFACE = window.adpAppStore.appInterface();

    var pathParts = $location.$$path.split('/');
    if (pathParts[2] && !APP_CONFIG.appSuffix) {
      var id = pathParts[2];
      vm.data.id = id;
      vm.loading = true;
      getPageData().then(onSuccess);
    }

    function getPageData() {
      var params = {
        method: vm.data.parameters.dataLinkMethod,
        url: APP_CONFIG.apiUrl + vm.data.parameters.dataLink.replace(/:id/g, id),
      };
      return $http(params);
    }

    function onSuccess(response) {
      vm.loading = false;
      vm.data = _.merge(vm.data, response.data);
    }
  }
})();
;(function () {
  'use strict';

  function getStateUrl(url, suffix) {
    return !!suffix ? suffix + url : url;
  }

  angular
    .module('app.adpWidgets', [])
    /** @ngInject **/
    .config(function ($stateProvider, APP_CONFIG) {
      const url = APP_CONFIG.publishedEndpointPrefix + '/w/:sharedWidgetId';
      $stateProvider.state('widgetEmbedded', {
        url: getStateUrl(url, APP_CONFIG.appSuffix),
        params: {
          sharedWidgetId: null,
        },
        views: {
          root: {
            templateUrl: 'client-modules/adp-widgets/adp-widget-embed.html',
            controller: 'AdpWidgetEmbedController as vm',
          },
        },
        data: {
          // 'guest' strategy causes redirect to home page from embedding widget\dashboard if neighbour tab is logged.
          // Current solution is to keep redirectStrategy empty, but this looks like side-effect & possibly should be fixed withing 'FE-for-embed' version
          // redirectStrategy: 'guest'
        },
      });

      const clearWidgetUrl = `/widget-frameless/:sharedWidgetId`;
      $stateProvider.state('widgetOnlyOnPage', {
        url: getStateUrl(clearWidgetUrl, APP_CONFIG.appSuffix),
        params: {
          sharedWidgetId: null,
          showHeader: 'never',
        },
        views: {
          root: {
            templateUrl: 'client-modules/adp-widgets/adp-widget-frameless.html',
            controller: 'AdpSingleWidgetController as vm',
          },
        },
        data: {
          redirectStrategy: 'user',
        },
      });
    });
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport').factory('GridExportGenerators', GridExportGenerators);

  /** @ngInject */
  function GridExportGenerators(ClientError) {
    var XML_INDENT = 2;

    function xlsxGenerator(wb){
      return wb.xlsx.writeBuffer();
    }

    function csvGenerator(wb){
      return wb.csv.writeBuffer();
    }

    function jsonGenerator(wb) {
      return Promise.resolve(JSON.stringify(workbookToJson(wb), null, 4));
    }

    function xmlGenerator(wb) {
      var obj = { rows: workbookToJson(wb) };

      return Promise.resolve('<?xml version="1.0" encoding="utf-8">' + objToXml(obj, 0) + '\n</xml>');
    }

    function workbookToJson(workbook) {
      var stack = [{ __items: [] }];
      var cursor = stack[0];

      workbook.eachSheet(function (sheet) {
        // Required as sheets are listed with random offset internally.

        if (!sheet.rowCount) {
          throw new ClientError('At least one row is required');
        }

        if (!sheet._rows[0].cellCount) {
          throw new ClientError('At least one visible column is required');
        }

        sheet._rows.forEach(function (row) {
          var cell = row._cells[0]._schemaCell;
          var rowType = cell.rowType;

          if (rowType !== 'header') {
            if (rowType === 'group') {
              while (stack.length > cell.column.groupIndex + 1) {
                var top = stack.pop();
                cursor = stack[stack.length - 1];
                cursor.__items.push(top);
              }
              var group = {};
              group[cell.column.dataField] = cell.value;
              group.__items = [];
              stack.push(group);
              cursor = group;
            } else {
              cursor.__items.push(rowToObj(row));
            }
          }
        });

        cursor = stack.pop();

        while (stack.length > 0) {
          var top = stack.pop();

          top.__items.push(cursor);
          cursor = top;
        }
      });

      return cursor.__items;
    }

    function rowToObj(row) {
      var obj = {};

      row.eachCell({ includeEmpty: true }, function (cell) {
        var schemaCell = cell._schemaCell;
        var field = schemaCell.column.dataField;
        var value = schemaCell.value;

        if (field && value !== null) {
          obj[field] = value;
        }
      });

      var rowId = row.getCell(1)._schemaCell.data._id;

      if (rowId) {
        obj._id = rowId;
      }

      return obj;
    }

    function objToXml(obj, ind) {
      var xml = '';

      if (typeof obj == 'string' || typeof obj == 'number') {
        return obj;
      }

      _.each(obj, function (item, key) {
        xml += '\n' + indent(ind) + '<' + key + '>';

        if (item instanceof Array) {
          // xml += "\n" + indent(ind);
          item.forEach(function (elem) {
            //   xml += "<item>" + objToXml(new Object(elem)) + "</item>";
            xml += '\n' + indent(ind + XML_INDENT) + '<item>' + objToXml(elem, ind + XML_INDENT * 2) + '</item>';
          });

          if (item.length) {
            xml += '\n' + indent(ind);
          }
        } else if (typeof item == 'object') {
          //   xml += objToXml(new Object(item));
          xml += objToXml(item, ind + XML_INDENT) + '\n' + indent(ind);
        } else {
          xml += item;
        }

        xml += '</' + key + '>'; //\n" + indent(ind);
      });

      return xml; //.replace(/<\/?[0-9]{1,}>/g, '');
    }

    function indent(num) {
      return _.repeat(' ', num);
    }

    return {
      xlsxGenerator: xlsxGenerator,
      csvGenerator:csvGenerator,
      jsonGenerator: jsonGenerator,
      xmlGenerator: xmlGenerator,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport')
    .factory('GridExportHelpers', GridExportHelpers);

  /** @ngInject */
  function GridExportHelpers(
    APP_CONFIG,
    AdpSchemaService,
    GraphqlHelper
  ) {
    var PREF_TYPE_LS_KEY = 'gridPrefExportFormat';

    function gridVisibleColumns(grid) {
      return _.compact(
        _.map(grid.getVisibleColumns(), function (row) {
          return row.allowExporting && row.dataField;
        })
      );
    }

    function gridFilterCondition(params) {
      var hasRowSelection = params.configParams.rowsToExport === 'selected';
      var filter = [];

      if (hasRowSelection) {
        var selectedRows = params.grid.getSelectedRowKeys();

        if (selectedRows.length) {
          _.each(selectedRows, function (row) {
            filter.push(['_id', '=', row._id]);
            filter.push('or');
          });
          filter.pop();
        }
      } else {
        var buildFilter = params.customGridOptions && _.clone(params.customGridOptions.value('filterBuilder'));

        filter = GraphqlHelper.combineFilters(params.schema, params.grid.getCombinedFilter(), buildFilter);
      }

      return filter || [];
    }

    function setPrefType(val) {
      localStorage.setItem(PREF_TYPE_LS_KEY, val);
    }

    function getPrefType() {
      return localStorage.getItem(PREF_TYPE_LS_KEY);
    }

    function getExportFormats() {
      var exportsSchema = AdpSchemaService.getSchemaByName('_exports');

      return exportsSchema.fields.exportType.list;
    }

    return {
      getExportFormats: getExportFormats,
      getPrefType: getPrefType,
      setPrefType: setPrefType,
      gridFilterCondition: gridFilterCondition,
      gridVisibleColumns: gridVisibleColumns
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport').factory('AdpDataExport', AdpDataExport);

  /** @ngInject */
  function AdpDataExport(
    AdpClientCommonHelper,
    AdpModalService,
    ErrorHelpers,
    GridExportHelpers
  ) {
    return function (toolbarWidgetRegister) {
      var gridOptions = this.gridOptions;
      var actionOptions = this.actionOptions;
      var schema = this.modelSchema;
      var customGridOptions = this.customGridOptions;

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: 'dxMenu',
          options: {
            dataSource: [{ template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions) }],
            cssClass: 'adp-toolbar-menu grid-view-menu',
            onItemClick: createExportDialog(gridComponent, schema, customGridOptions),
          },
        };
      });
    };

    function createExportDialog(gridComponent, schema, customGridOptions) {
      return function () {
        exportConfigModal(gridComponent, schema)
          .then(function(configParams) {
            GridExportHelpers.setPrefType(configParams.format);

            return exportStatusModal({
              schema: schema,
              grid: gridComponent,
              configParams: configParams,
              customGridOptions: customGridOptions
          });
          })
          .catch(function (e) {
            if (e) {
              ErrorHelpers.handleError(e, 'Error while exporting.');
            }
          });
        AdpClientCommonHelper.repaintToolbar(gridComponent);
      };
    }

    function exportConfigModal(gridComponent, schema) {
      return AdpModalService.createModal('adpExportConfigModal', {
        schema: schema,
        grid: gridComponent,
        preferredType: GridExportHelpers.getPrefType(),
      }).result;
    }

    function exportStatusModal(params) {
      return AdpModalService.createModal('adpExportStatusModal', params).result;
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport').component('adpExportConfigModal', {
    template:
      '<adp-form ' +
      '  args="vm.args"' +
      '  form-options="vm.formOptions">' +
      '    <form-header>' +
      '        <h2 class="semi-bold">{{vm.data.name}}</h2>' +
      '    </form-header>' +

      '    <form-footer>' +
      '      <footer class="adp-action-b-container" adp-handle-hot-keys="form">' +
      '        <button' +
      '                class="adp-action-b-secondary"' +
      '                type="button"' +
      '                adp-hot-key="Escape"' +
      '                ng-click="vm.cancel()">' +
      '            Cancel' +
      '        </button>' +
      '        <button' +
      '                type="submit"' +
      '                class="adp-action-b-primary">' +
      '            Export' +
      '        </button>' +
            '</footer>' +
      '    </form-footer>' +
      '</adp-form>',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpExportConfigModalController',
    controllerAs: 'vm',
  });
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport').controller('AdpExportConfigModalController', AdpExportConfigModalController);

  /** @ngInject */
  function AdpExportConfigModalController(
    GridExportHelpers,
    AdpUnifiedArgs,
    $q
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.options = vm.resolve.options;

      var schema = vm.options.schema;
      var grid = vm.options.grid;
      var selectionMultiple = _.get(schema, 'parameters.selection.mode', '');
      var selectedRowsCount = selectionMultiple === 'multiple' ? grid.getSelectedRowKeys().length : 0;
      var totalRowsCount = grid.totalCount();
      var columns = GridExportHelpers.gridVisibleColumns(grid);
      var defaultName = 'Export from ' + (schema.fullName || schema.schemaName);
      var defaultDescription = 'Columns: ' + columns.join(',') + ';\nCreated: ' + new Date().toString();

      vm.data = {
        rowsToExport: selectedRowsCount > 0 ? 'selected' : 'all',
        format: vm.options.preferredType || 'xlsx',
        name: defaultName,
        description: defaultDescription,
      };

      var rowsToExportOptions = {
        all: 'Export all rows (' + totalRowsCount + ')',
      };

      if (selectedRowsCount > 0) {
        rowsToExportOptions.selected = 'Export selected rows only (' + selectedRowsCount + ')';
      }

      vm.schema = {
        type: 'Schema',
        fields: {
          rowsToExport: {
            type: 'String',
            description: 'Which rows to export',
            fullName: 'Rows to export',
            fieldName: 'rowsToExport',
            list: { values:rowsToExportOptions },
            default: 'all',
            showFormLabel: true,
            showInForm: true,
            required: true,
            permissions: { view: true, create: true, update: true },
          },
          format: {
            type: 'String',
            fieldName: 'format',
            fullName: 'Export into',
            list: GridExportHelpers.getExportFormats(),
            showFormLabel: true,
            showInForm: true,
            required: true,
            permissions: { view: true, create: true, update: true },
          },
          name: {
            type: 'String',
            fieldName: 'name',
            fullName: 'Name',
            default: defaultName,
            show: "this.row.format=='db'",
            showFormLabel: true,
            showInForm: true,
            required: "this.row.format=='db'",
            permissions: { view: true, create: true, update: true },
          },
          description: {
            type: 'Text',
            fieldName: 'description',
            fullName: 'Description',
            default: defaultDescription,
            show: "this.row.format=='db'",
            showFormLabel: true,
            showInForm: true,
            permissions: { view: true, create: true, update: true },
          },
        },
      };

      vm.args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: 'export',
        schema: vm.schema,
        formData: vm.data,
      });

      vm.cancel = function () {
        return vm.dismiss({ confirmed: false });
      };

      vm.formOptions = {
        localActionsStrategy: {
          submit: function (args) {
            return $q.resolve()
              .then(function () {
                vm.close({ $value: args.row });
              });
          },
        },
        disableFullscreen: true,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport')
    .component('adpExportStatusModal', {
      template:
        '<form name="form"' +
        '      class="smart-form client-form export-status">' +
        '    <header class="smart-form-header">' +
        '        <h2 class="semi-bold">Export' +
        '            <span ng-if="vm.status === \'start\'" class="">has started...</span>' +
        '            <span ng-if="vm.status === \'long\'" class="">takes too long...</span>' +
        '            <span ng-if="vm.status === \'finish\'" class="">is finished</span>' +
        '            <span ng-if="vm.status === \'error\'" class="">is failed</span>' +
        '        </div>' +
        '</h2>' +
        '    </header>' +
        '    <fieldset>' +
        '        <div class="col col-12">' +
        '            <div ng-if="vm.status === \'start\'" class=""><i class="fa fa-circle-o-notch fa-4x fa-spin"></i></div>' +
          '            <div ng-if="vm.status === \'finish\'" class="">Successfully</div>' +
        '            <div><a ui-sref="app._exports">You can get export result here then its ready</a></div>' +
        '            <div ng-if="vm.status === \'error\'" class="">' +
        '               <div>{{ vm.errorMessage }}</div>' +
        '            </div>' +
        '        </div>' +
        '    </fieldset>' +
        '    <footer class="adp-action-b-container" adp-handle-hot-keys>' +
        '        <button class="adp-action-b-primary"' +
        '                type="button"' +
        '                ng-if="vm.downloadAllowed" ' +
        '                ng-click="vm.download()">' +
        '            Download export result' +
        '        </button>' +
        '        <button class="adp-action-b-primary"' +
        '                type="button"' +
        '                ng-if="vm.datasetAllowed" ' +
        '                ng-click="vm.goToDataset()">' +
        '            View result dataset' +
        '        </button>' +
        '        <button class="adp-action-b-primary"' +
        '                type="button"' +
        '                adp-hot-key="Enter"' +
        '                ng-click="vm.ok()">' +
        '            OK' +
        '        </button>' +
        '    </footer>' +
        '</form>',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpExportStatusModalController',
      controllerAs: 'vm'
    });
})();
;(function () {
  'use strict';

  angular.module('app.adpDataExport')
    .controller('AdpExportStatusModalController', AdpExportStatusModalController);

  /** @ngInject */
  function AdpExportStatusModalController(
    GridExportHelpers,
    AdpMediaTypeHelper,
    AdpSocketIoService,
    AdpNotificationService,
    AdpSchemaService,
    AdpTime,
    ErrorHelpers,
    GraphqlCollectionMutator,
    $timeout,
    $location,
    $state
  ) {
    var vm = this;
    var downloadPermission = true;
    var viewExportsPermission = true;
    var viewDatasetPermission = true;
    var exportFormat = null;
    var instantDownloadTimeout = _.get(window.adpAppStore.appInterface(), 'app.dataExportInstantDownloadTimeout', 3000);
    var longRunTimer;

    vm.$onInit = function () {
      var exportsSchema = AdpSchemaService.getSchemaByName('_exports');

      vm.options = vm.resolve.options;// options contains {schema, grid: gridComponent, configParams, customGridOptions }
      vm.status = 'start';
      vm.datasetAllowed = false;
      vm.downloadAllowed = false;
      vm.showResultsCollection = false;

      viewDatasetPermission = _.hasIn(exportsSchema.actions, 'fields.view');

      exportFormat = vm.options.configParams.format;

      vm.ok = function () {
        return vm.dismiss({confirmed: false});
      };

      vm.download = doDownload;
      vm.goToDataset = goToDataset;

      var exportMutationParams = getExportParams(vm.options);

      return GraphqlCollectionMutator.create(exportsSchema, exportMutationParams)
        .then(function (data) {
          longRunTimer = $timeout(onLongRunTimer, instantDownloadTimeout);

          _setSocketListener(exportFormat, data._id);
        })
        .catch(function (error) {
          var message = _.isArray(error.message) ? error.message.join(',') : (error.message || 'Unknown error');

          vm.status = 'error';
          vm.errorMessage = message;

          ErrorHelpers.handleError(error, 'Unknown error, while trying to export dataset');
          throw error;
        });
    };

    function getExportParams(params) {
      return {
        name: params.configParams.name,
        description: params.configParams.description,
        exportSpecification: {
          modelName: params.schema.schemaName,
          filter: {
            dxQuery: JSON.stringify(GridExportHelpers.gridFilterCondition(params)),
          },
          projections: GridExportHelpers.gridVisibleColumns(params.grid),
          timezone: AdpTime.guessTimeZone(),
        },
        exportType: params.configParams.format,
      };
    }

    function onLongRunTimer() {
      if (vm.status === 'start') {
        vm.status = 'long';
        vm.showResultsCollection = viewExportsPermission;
      }
    }

    function doDownload() {
      var fileItem = { id: vm.resultItemId };
      AdpMediaTypeHelper.downloadWithSaveDialog(fileItem);

      doDialogClose();
    }

    function goToDataset() {
      $state.go('app.datasetsId', getDatasetsPageParams());
    }

    function getDatasetUrl() {
      return $state.href('app.datasetsId', getDatasetsPageParams());
    }

    function getDatasetsPageParams() {
      return { _id: vm.resultItemId };
    }

    function getFileUrl() {
      var fileItem = {
        id: vm.resultItemId,
      }

      return AdpMediaTypeHelper.getDownLoadLink(fileItem);
    }

    function getResultMessage(resultUrl) {
      // todo: fix
      return 'Export completed. <br><a target="_blank" href="' + resultUrl + '">Get result here</a>';
    }

    function doDialogClose() {
      $timeout.cancel(longRunTimer);

      vm.dismiss({confirmed: false});
    }

    function _socketIoListenerFunc(data) {
      if (exportFormat === 'db') {
        _socketProcessorDbType(data);
      } else {
        _socketProcessorFileType(data);
      }
    }

    function _socketProcessorFileType(data) {
      if (data.type === 'exportDataToFile' && data.data.status === 'completed') {
        vm.resultItemId = data.data.fileId ;

        if (vm.status === 'start') {
          doDownload();
        } else {
          vm.status = 'finish';
          vm.showResultsCollection = false;
          vm.downloadAllowed = downloadPermission;
        }

        getFileUrl().then(function(url){
          var completeMessage = getResultMessage(url);

          AdpNotificationService.notifySuccess(completeMessage);
        })


        _removeSocketListener();
      }
    }

    function _socketProcessorDbType(data) {
      if (data.type === 'exportDataToDb' && data.data.status === 'completed') {
        vm.resultItemId = data.data.datasetId ;

        vm.status = 'finish';
        vm.showResultsCollection = false;
        vm.datasetAllowed = viewDatasetPermission;

        var completeMessage = getResultMessage(getDatasetUrl());
        AdpNotificationService.notifySuccess(completeMessage);

        _removeSocketListener();
      }
    }

    function _setSocketListener(exportFormat, recordId) {
      AdpSocketIoService.registerMessageProcessor(_socketIoListenerFunc, {id: recordId});
    }

    function _removeSocketListener() {
      AdpSocketIoService.unRegisterMessageProcessor(_socketIoListenerFunc);
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpDataImport').component('adpDataImportModal', {
    templateUrl: "client-modules/adp-data-import/adp-data-import-modal.html",
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controllerAs: 'vm',
    controller: "AdpDataImportModalController",
  });
})();
;(function () {
    'use strict';

    angular.module('app.adpDataImport')
      .controller('AdpDataImportModalController', AdpDataImportModalController);

    /** @ngInject */
    function AdpDataImportModalController(
      GraphqlCollectionMutator,
      ErrorHelpers,
      ResponseError,
      AdpFileUploaderService
    ) {
      const vm = this;
      const uploader = AdpFileUploaderService.createStandalone();
      vm.currentProcess = '';
      vm.errors = [];
      vm.$onInit = function () {
        const { file, schema } = vm.resolve.options;
        vm.schema = schema;

        uploader.addToQueue(file);
        uploader.onSuccessItem = function (item, response) {
          vm.currentProcess = '';
          if (!response.success) {
            vm.errors.push({message:`File upload error: ${response.message}`});
          } else {
            vm.uploadedFile = response.data[0];
            requestImportAndShowResult(false);
          }
        };
        uploader.onErrorItem = function (item, response) {
          vm.currentProcess = '';
          vm.errors.push({ message: `File upload error: ${response || 'Unknown error'}`});
        };
        vm.currentProcess = 'Uploading file to the server';
        uploader.uploadAll();
      };

      vm.onClose = function () {
        uploader.cancelAll()
        uploader.destroy();
        vm.close({ $value: {} });
      };

      vm.onProceed = function () {
        requestImportAndShowResult(true);
      }

      function errorToString(error) {
        if (typeof error === 'object') {
          return _.map(error, (v, k) => `'${k}': ${errorToString(v)}`).join('; ');
        } else {
          return error;
        }
      }

      function requestImportAndShowResult(proceedWithForceImport = false) {
        vm.currentProcess = 'Parsing file data';
        return GraphqlCollectionMutator.importDataSet(vm.schema, vm.uploadedFile, proceedWithForceImport)
          .then((response) => {
            const overallErrors = _.get(response, 'errors.overall', '');
            const proceedMessage = 'File contains invalid column names:';
            const indexOfProceedMessage = overallErrors.indexOf(proceedMessage);
            const proceedRequired = indexOfProceedMessage !== -1;
            const invalidColumnNames = proceedRequired ? overallErrors.substring(indexOfProceedMessage + proceedMessage.length + 1) : '';
            vm.currentProcess = '';
            vm.errors = proceedRequired ? [] : processErrors(response.errors);
            vm.rowsCount = response.importedRowsNumber;
            vm.invalidColumnNames = invalidColumnNames;
            vm.proceedRequired = proceedRequired;
            vm.success = !vm.errors.length && !vm.proceedRequired;
          })
      }

      function processErrors(responseErrors = []) {
        const errors = [];
        _.each(responseErrors, (err, key) => {
          if (key === 'overall') {
            errors.unshift({ item: ``, message: errorToString(err) });
          } else {
            errors.push({ item: `Item ${(parseInt(key) + 1)}`, message: errorToString(err) });
          }
        });
        return errors;
      }
    }
  }
)();
;(function () {
  'use strict';

  angular.module('app.adpEmbedCodeModal').component('adpEmbedCodeModalComponent', {
    templateUrl: 'client-modules/adp-embed-code-modal/adp-embed-code-modal.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpEmbedCodeModalController',
    controllerAs: 'vm',
  });
})();
;(function () {
  'use strict';

  angular.module('app.adpEmbedCodeModal').controller('AdpEmbedCodeModalController', AdpEmbedCodeModalController);

  /** @ngInject */
  function AdpEmbedCodeModalController(APP_CONFIG, AdpNotificationService) {
    const vm = this;

    vm.$onInit = function () {
      const hasClipboardApi = navigator && navigator.clipboard;
      const { entityName, embedTypePrefix, id } = vm.resolve.options;
      const hostUrl = `${window.location.protocol}//${window.location.host}${APP_CONFIG.appSuffix}`;
      vm.embedUrl = `${hostUrl}${APP_CONFIG.publishedEndpointPrefix}${embedTypePrefix}/${id}`;
      vm.entityName = entityName;

      if (hasClipboardApi) {
        $('#adp-clipboard-copy').dxButton({
          icon: 'copy',
          onClick: () => {
            const text = $('.adp-widget-embed-code-block pre').text();
            navigator.clipboard.writeText(text);
            AdpNotificationService.notifySuccess('Copied into clipboard');
          },
        });
      }
    };
  }
})();
;(function () {
  "use strict";

  angular.module("app.adpFilterBuilder")
         .component("adpFilterBuilder",
           {
             template:
               "<form name=\"form\"" +
               "      class=\"smart-form client-form filter-builder\">" +
               "    <header class=\"smart-form-header\">" +
               "        <h2 class=\"semi-bold\">Filter Builder</h2>" +
               "    </header>" +
               "    <fieldset>" +
               "        <div class=\"col col-12\">" +
               "            <div class=\"filter-builder-container\"></div>" +
               "        </div>" +
               "    </fieldset>" +
               "    <footer class=\"adp-action-b-container\" adp-handle-hot-keys='form'>" +
               "        <button class=\"adp-action-b-secondary\"" +
               "                type=\"button\"" +
               "                adp-hot-key=\"Escape\"" +
               "                ng-click=\"vm.exit()\">Close</button>" +
               "        <button class=\"adp-action-b-tertiary\"" +
               "                type=\"button\"" +
               "                ng-click=\"vm.clear()\">Clear filter</button>" +
               "        <button class=\"adp-action-b-primary\"" +
               "                type=\"button\"" +
               "                ng-click=\"vm.save()\">Apply filter</button>" +
               "    </footer>" +
               "</form>",
             bindings: {
               resolve: "<",
               close: "&",
               dismiss: "&",
             },
             controller: "AdpFilterBuilderController",
             controllerAs: "vm",
           });
})();
;(function () {
    "use strict";

    angular.module("app.adpFilterBuilder").controller("AdpFilterBuilderController", AdpFilterBuilderController);

    var DX_FB_GROUP_CLASS = ".dx-filterbuilder-group";
    var DX_FB_GROUP_ITEM_CLASS = DX_FB_GROUP_CLASS + "-item";
    var DX_FB_GROUP_CONTENT_CLASS = DX_FB_GROUP_CLASS + "-content";

    var valueTypeEditors = {
      default: {
        title: "Regular value",
      },
      relativeDate: {
        supports: ["DateTime", "Date"],
        title: "Relative date",
      },
      databaseField: {
        excludeOperations: ["contains", "notcontains"],
        title: "Database Field"
      },
      mongoExpression: {
        excludeOperations: ["between"],
        title: "Mongo expression"
      },
    }

    /** @ngInject */
    function AdpFilterBuilderController(
      $element,
      GridFilters,
      GridFiltersFactory,
      AdpUnifiedArgs,
      AdpModalService
    ) {
      var vm = this;
      var filterBuilder;

      vm.$onInit = doInit;
      vm.save = function () {
        vm.close({$value: filterBuilder && filterBuilder.getFilterExpression() || []});
      };
      vm.exit = function () {
        vm.close({$value: null});
      };
      vm.clear = onClear;

      function onClear() {
        var value = filterBuilder.option("value");

        if (value && value.length || filterBuilder._model.length > 1) {
          AdpModalService.confirm({message: "Are you sure to clear all conditions?", sizeSmall: true})
            .then(function () {
              filterBuilder.option('value', []);
              filterBuilder._model = ["and"];
            })
        }
      }

      function doInit() {
        vm.options = vm.resolve.options;
        vm.grid = vm.options.grid;
        vm.schema = vm.options.schema;

        initFilterBuilder();
      }

      function initFilterBuilder() {
        var firstCall = true;
        var $container = $(".filter-builder-container", $element);
        var params = {
          fields: getFieldsConfiguration(vm.grid.option("columns"), vm.schema)
        };

        params.value = vm.options.value || [];
        /*[
          ["adpCreatedAt", "<", {type: "databaseField", value: "adpUpdatedAt"}],
          "or",
          ["name", "contains", {type: "default", value: "345"}],
          "or",
          [
            ["adpCreator", "=", {type: "mongoExpression", value: "66777"}],
            ["adpCreatedAt", "<>", {type: "relativeDate", value: "this midnight"}]
          ]
        ];*/

        params.onEditorPreparing = function (event) {
          var valueType = (event.value && event.value.type) || "default";
          var setVal = event.setValue;

          // TODO: dangerous assigment potentially can ruin smth, if value passed be reference.
          // TODO: Think about replacing whole 'event' with newly created
          event.value = event.value && event.value.value;

          event.setValue = function (_data, _type) {
            var type = _type || valueType;
            var data = _data;

            // TODO: find better way to avoid this: no more storing current valType into valueType var...
            if (type !== valueType) {
              data = event.value = '';
              valueType = type;

              initValueEditor(event, vm.schema, type);
            }

            setVal({type: type, value: data});
          }

          initValueEditor(event, vm.schema, valueType)
        }

        params.onInitialized = function (event) {
          filterBuilder = event.component;
        }

        params.onContentReady = function (event) {
          if (firstCall) {
            var builderRootGroup = $(">" + DX_FB_GROUP_CLASS, event.element);
            var filterValue = event.component.option("value");

            traverseMongoExpressionRows(builderRootGroup, filterValue);

            firstCall = false;
          }
        }

        $container.dxFilterBuilder && $container.dxFilterBuilder(params);
      }

      function getFieldsConfiguration(columns, schema) {
        var fields = _.map(
          columns,
          function (col) {
            var field = schema.fields[col.dataField];

            if (!field || !field.showInDatatable || !col.allowFiltering) {
              return null;
            }

            col.customizeText =
              function (a) {
                var typedValue = getFilterValue(a.value);

                if (typedValue.type === "default" ) {
                  var fieldName = col.dataField;
                  var formData = null;
                  var value = typedValue.value;

                  if (!_.isNil(value)) {
                    formData = {};
                    formData[fieldName] = value;
                  }

                  var args = AdpUnifiedArgs.getHelperParamsWithConfig({
                    path: fieldName,
                    formData: formData,
                    action: null,
                    schema: schema,
                  });

                  args.params = {asText:true};

                  return  GridFiltersFactory.formatValue({args: args});
                } else {
                  return "[" + valueTypeEditors[typedValue.type].title + "] "
                    + (typedValue.type === 'mongoExpression' ? '\n' : '')
                    + typedValue.value;
                }
             }

            return col;
          });

        return _.compact(fields);
      }

      function initValueEditor(event, schema, valueType) {
        var field = vm.schema.fields[event.dataField];
        var valueTypeSelector = getTypesSelector(field, event, valueType);
        var $el = event.editorElement;

        $el.empty();

        toggleMongoExpressionClass($el.closest(DX_FB_GROUP_ITEM_CLASS), valueType);

        setTypedFilterComponent(event, schema, valueType);

        $el.prepend(valueTypeSelector);
      }

      function setTypedFilterComponent(event, schema, valueType) {
        if (valueType === "default") {
          GridFilters.setFilterComponent(event, schema);
        } else {
          var options = {
            args: GridFilters.unifiedApproachArgs(event, schema),
            dataField: event.dataField,
            filterOperation: event.filterOperation,
            onValueChanged: function (filterOptions) {
              event.setValue(filterOptions.value);
            },
            closeEditor: event.closeEditor,
            parentType: event.parentType,
          };

          // force filter type to render special filter types like 'relative date' for example
          options.args.fieldSchema = _.cloneDeep(options.args.fieldSchema);
          options.args.fieldSchema.filter = valueType;

          event.cancel = true; // Cancels creating the default editor

          var filterComponent = GridFiltersFactory.create(options);

          filterComponent.getElement().appendTo(event.editorElement);
        }
      }

      function getTypesSelector(field, event, currentValue) {
        var $el = $("<div>").addClass("adp-type-value-selector");
        var $buttonEl = $("<div>");
        var $popupEl = $("<div>").addClass("adp-type-value-selector-menu-box");
        var initialText = "";
        var menuItems = [];

        _.each(valueTypeEditors, function (config, name) {
          if (_.isArray(config.supports) && config.supports.indexOf(field.type) < 0) {
            return;
          }

          if (_.isArray(config.excludeOperations) && config.excludeOperations.indexOf(event.filterOperation) >= 0) {
            return;
          }

          var item = {value: name, text: config.title || ""};

          if (name === currentValue) {
            initialText = item.text || "[no label]";
            item.selected = true;
          }

          menuItems.push(item);
        });

        if (menuItems.length) {
          $el.append($buttonEl);

          $buttonEl.text(initialText)
                   .addClass("adp-type-value-selector-button dx-filterbuilder-text");

          if (menuItems.length > 1) {
            $el.append($popupEl);

            $popupEl.append(
              $("<div>").dxTreeView({
                items: menuItems,
                onItemClick: function (menuEvent) {
                  event.setValue(event.value, menuEvent.itemData.value);
                  $buttonEl.text(menuEvent.itemData.text);

                  $popupEl.hide();
                  menuEvent.event.stopPropagation();
                },
              })
            )

            $buttonEl.click(function () {
              $popupEl.toggle();
            })
          }
        }

        return $el;
      }

      function getFilterValue(val) {
        var ret;
        if (_.isObject(val) && val.type) {
          return val;
        }

        try {
          ret = JSON.parse(val);
          if (!_.isObject(ret) || !ret.type) {
            ret = {type: "default", value: val}
          }
        } catch (e) {
          ret = {type: "default", value: val}
        }

        return ret;
      }

      function traverseMongoExpressionRows(element, expression) {
        if (!expression || !expression.length) {
          return;
        }

        if (expression[0] === "!") {
          traverseMongoExpressionRows(element, expression[1]);
        } else {
          if (_.isString(expression[0])) {
            var val = getFilterValue(expression[2]);

            toggleMongoExpressionClass($(DX_FB_GROUP_ITEM_CLASS, element), val.type);
          } else {
            var $rows = $(">" + DX_FB_GROUP_CONTENT_CLASS + ">" + DX_FB_GROUP_CLASS, element);
            var pointer = 0;

            _.each(expression, function (filterElement) {
              var $row = $rows[pointer];

              if (!_.isString(filterElement)) {
                traverseMongoExpressionRows($row, filterElement);
                pointer++;
              }
            })
          }
        }
      }

      function toggleMongoExpressionClass(elem, type) {
        $(elem).toggleClass("adp-filter-builder-mongo-expression", type === "mongoExpression");
      }
    }
  }
)();
;(function () {
  'use strict';

  angular.module('app.adpFilterBuilder').factory('AdpFilterBuilder', AdpFilterBuilder);

  /** @ngInject */
  function AdpFilterBuilder(
    AdpClientCommonHelper,
    AdpModalService
  ) {
    return function (toolbarWidgetRegister) {
      var schema = this.modelSchema;
      var actionOptions = this.actionOptions;
      var customOptions = this.customGridOptions;

      return toolbarWidgetRegister(function (gridComponent) {
        return {
          widget: "dxMenu",
          options: {
            dataSource: [{template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions)}],
            cssClass: "adp-toolbar-menu grid-view-menu",
            onItemClick: function (event) {
              AdpModalService
                .createModal("adpFilterBuilder", {
                  schema: schema,
                  grid: customOptions.gridComponent,
                  value: customOptions.value('filterBuilder'),
                }).result.then(function (res) {
                if (res) {
                  customOptions.value('filterBuilder', res.length ? res : null);
                }
                gridComponent.refresh();
              });

              AdpClientCommonHelper.repaintToolbar(gridComponent);
              return true;
            },
            onInitialized: function(event){
              highlightButton(event);

              customOptions.setOrReplaceHandler('change:filterBuilder', 'filterBuilder', function(){
                highlightButton(event);
              })
            }
          },
        };

        function highlightButton(event){
          var filterBuilder = customOptions.value('filterBuilder');
          var isHl = filterBuilder && filterBuilder.length;

          AdpClientCommonHelper.highlightToolbarButton(event.component, isHl);
        }
      })
    };
  }
})();
;(function () {
  angular.module('app.adpForceGraph').factory('ForceGraphLogic2d', forceGraphLogic2d);

  /** @ngInject */
  function forceGraphLogic2d(
    AdpForceGraphService, // this inject have to be as first argument, to be emulated in standalone export-templates
    AdpClientCommonHelper,
    APP_CONFIG
  ) {
    const constants = {
      SELECTION_LINK_WIDTH: 2,
      DEFAULT_NODE_SIZE: 5,
      DEFAULT_LINK_LABEL_SIZE: 5,
      DEFAULT_NODE_SHAPE: 'Sphere',
      DEFAULT_COLOR: 'gray',
      HIGHLIGHT_COLOR: 'magenta',
      SELECTED_COLOR: 'red',
      LINK_MAX_CURVATURE: 1,
      LINK_OPACITY: 0.5,
      DEFAULT_LINK_DISTANCE: 100,
      NODE_COMMON_OPACITY: 1,
      TAP_SPEED: 500, // Max time for screen touch to be considered as 'tap'
    };
    const memoizedInfo = _.memoize(
      AdpForceGraphService.getObjectTemplateRenderer('info', AdpForceGraphService.getDefaultObjectInfo)
    );
    const memoizedLabel = _.memoize(AdpForceGraphService.getObjectTemplateRenderer('label', (obj) => obj.n));
    const memoizedHoverLabel = _.memoize(AdpForceGraphService.getObjectTemplateRenderer('hoverLabel', () => ''));

    function mainLogic({
      containerElement,
      onInterfaceUpdate,
      $scope,
      $rootScope,
      $http,
      $sce,
      $document,
      AdpNotificationService,
      AdpFullscreenService,
      appConfig,
      tagBoxCreator,
      doLoadData,
      doLoadConfig,
      options = {},
    }) {
      const vm = this;
      const widgetId = _.get($scope, 'args.row._id');
      let forceGraph;
      let tagsFilterInstance = null;
      const scrollbars = {};
      const { apiUrl, resourceUrl } = appConfig;
      const keysConf = {
        r: { attr: 'labelLinks' },
        e: { attr: 'labelNodes' },
        m: { attr: 'showOptions' },
        d: { attr: 'showLegend' },
        x: { attr: 'fixDragged', action: 'resetFixDragged' },
        f: { action: 'toggleFullscreen' },
        s: { action: 'saveConfig' },
        l: { action: 'loadConfig' },
      };
      const configFieldsLimits = {
        hlColorize: { min: 0, max: 100 },
        hlDim: { min: 0, max: 100 },
        linkCurvature: { min: 0, max: 100 },
        linkDistance: { min: 1 },
        particleSize: {
          min: 1,
          max: 10,
          onChange(val, _vm) {
            if (val === '0') {
              _vm.state.config.showParticles = false;
            }
          },
        },
        arrowSize: {
          min: 1,
          max: 10,
          onChange(val, _vm) {
            if (val === '0') {
              _vm.state.config.showArrows = false;
            }
          },
        },
      };
      const state = {
        graphData: null,
        config: {
          showOptions: false,
          showLegend: false,
          showInfo: true,
          hlLabelNodes: true,
          hlLabelLinks: true,
          hlColorize: 75,
          hlDim: 50,
          labelLinks: false,
          labelNodes: false,
          showArrows: true,
          arrowSize: 1,
          showParticles: true,
          particleSize: 1,
          animCamera: false,
          fixDragged: false,
          linkCurvature: (constants.LINK_MAX_CURVATURE * 100) / 2,
          linkDistance: constants.DEFAULT_LINK_DISTANCE,
          nodeFilter: '',
          linkFilter: '',
          tagsFilter: [],
          highlightAdjacent: false,
        },
        isLoading: true,
        nothingIsMarked: true,
        apiUrl,
        legend: null,
        tags: null,
        canvasInFocus: false,
        cachedConfig: null,
        $container: $(containerElement),
        selectedNodes: [],
        templates: _.get(options, 'templates'),
      };
      const elementWithScrollbars = {
        config: 0,
        legend: 0,
        info: 0,
      };

      state.$box = $('.adp-fg-box', state.$container);

      vm.state = state;

      /* Methods, available from page interface, is put into vm.### */
      vm.doRefreshGraph = doRefreshGraph;
      vm.toggleConfig = () => {
        state.config.showOptions = !state.config.showOptions;
      };
      vm.toggleLegend = function (event, force) {
        if (_.isBoolean(force)) {
          state.config.showLegend = force;
        } else {
          state.config.showLegend = !state.config.showLegend;
        }

        scrollbars.config && scrollbars.config.recalculate();
        scrollbars.legend && scrollbars.legend.recalculate();

        event.stopPropagation();
      };
      vm.toggleInfo = function () {
        state.config.showInfo = !state.config.showInfo;
      };
      vm.toggleFullscreen = function () {
        $rootScope.isFullscreen = !$rootScope.isFullscreen;
      };
      vm.resetFixDragged = function () {
        if (!state.config.fixDragged) {
          _.each(state.graphData.nodes, (node) => {
            node.fx = undefined;
            node.fy = undefined;
          });
        }
        doRefreshGraph();
      };
      vm.saveConfig = function () {
        const { config } = state;
        state.cachedConfig = { ...config };

        return AdpForceGraphService.doSaveConfig(config, 'vis2d', widgetId);
      };
      vm.loadConfig = function () {
        return getConfig().then((conf) => {
          AdpNotificationService.notifySuccess('Config is restored');

          applyConfig(conf);
        });
      };
      vm.screenCapture = screenCapture;
      vm.exportAsHtml = () => {
        vm.exportingHtml = true;
        // eslint-disable-next-line promise/catch-or-return
        AdpForceGraphService.exportHtml({
          doLoadData,
          $http,
          state,
          templatePath: `${resourceUrl}/public/js/lib/export-2d.tmpl.html`,
        })
          .catch(_.noop)
          .finally(() => {
            vm.exportingHtml = false;
          });
      };
      vm.trustedHtml = (plainText) => $sce.trustAsHtml(plainText);
      vm.getInfoHtml = (obj) => $sce.trustAsHtml(memoizedInfo(obj, state));
      vm.navigationZoomIn = function () {
        const zoom = forceGraph.zoom();
        forceGraph.zoom(zoom * 1.1);
      };
      vm.navigationZoomOut = function () {
        const zoom = forceGraph.zoom();
        forceGraph.zoom(zoom * 0.9);
      };
      vm.navigationCenter = function () {
        forceGraph.zoomToFit(500, 50, nodeSelectionFilter);
      };
      vm.getTagNamesByIds = (ids) => AdpForceGraphService.getTagNamesByIds(ids, state);

      return AdpForceGraphService.prepareVisualisation({
        doLoadVendorCode: loadVendorCode,
        doLoadData,
        doLoadConfig,
        doInitGraph,
        applyConfig,
        state,
        options,
      })
        .then(() => {
          $document.on('keypress', AdpForceGraphService.getKeyPressHandler(vm, keysConf, doRefreshGraph));
        })
        .catch((e) => {
          const message = e.message || e;
          vm.errorMessage = message;
          AdpNotificationService.notifyError(message);
        });

      function nodeSelectionFilter(node) {
        const { config, selectedNodes } = state;

        if (node.isSelected) {
          return true;
        }

        // ToDo: will not work correct if only links are selected, as filtering is only over nodes, and selected links are just.. ignored
        if (selectedNodes.length) {
          if (config.nodeFilter) {
            return AdpForceGraphService.isNodeFiltered(node, config);
          }

          return false;
        }

        return true;
      }

      function doInitGraph() {
        const { dagMode } = options;
        const { config, $container } = state;
        const linkColorHandler = (link) => linkColor(link, state, constants);
        const onClickHandler = AdpForceGraphService.getGraphClickHandler(vm, doUpdateState);

        forceGraph = ForceGraph2d();

        forceGraph(state.$box[0])
          .onNodeClick(onClickHandler)
          .onLinkClick(onClickHandler)
          .linkDirectionalParticleColor((link) => AdpForceGraphService.linkParticleColor(link, constants))
          .linkDirectionalParticleSpeed(AdpForceGraphService.linkSpeed)
          .onBackgroundClick((e) => onClickHandler(null, e))
          .onNodeDragEnd((node) => AdpForceGraphService.onNodeDragEnd(node, config))
          .nodeVal('size')
          .linkWidth((link) => linkWidth(link, constants))
          .linkColor(linkColorHandler)
          .linkDirectionalArrowColor(linkColorHandler)
          .linkCurvature((link) => AdpForceGraphService.linkCurvature(link, config, constants))
          .nodeCanvasObject((node, ctx) => nodeGeometry(node, state, ctx))
          .linkCanvasObject((link, ctx, globalScale) => linkAddonGeometry(link, state, ctx, globalScale, config))
          .linkCanvasObjectMode(() => 'after')
          .nodeLabel((node) => nodeHoverLabel(node, state))
          .linkLabel((link) => nodeHoverLabel(link, state))
          .graphData(state.graphData);

        forceGraph.d3Force('link').distance((link) => linkDistance(link, config));

        if (dagMode) {
          forceGraph
            .dagMode(dagMode)
            .dagLevelDistance(100)
            .onDagError(() => {
              AdpForceGraphService.handleError(
                `Cycle is encountered. Correct hierarchy representation is not guaranteed`,
                'DAG Error'
              );
            });
        }

        $(window).on('resize', fitSize);
        state.$box.on('mouseenter', () => {
          state.canvasInFocus = true;
        });
        state.$box.on('mouseleave', () => {
          state.canvasInFocus = false;
        });

        if ($scope) {
          // this code should work only in Angular version, not standalone (exported)
          AdpFullscreenService.registerFullScreenElement($container[0]);

          if ($rootScope.isFullscreen) {
            AdpFullscreenService.forceFullscreen($container[0]);
          }

          $scope.$on('$destroy', () => {
            AdpFullscreenService.unregisterFullScreenElement($container[0]);
          });
        }

        const $tagBox = $('.adp-fg-tags-container', $container);
        if ($tagBox.length) {
          const params = AdpForceGraphService.getTagSelectorOptions(
            state,
            () => vm.doRefreshGraph(),
            (e) => {
              tagsFilterInstance = e.component;
            }
          );
          tagBoxCreator($tagBox, params);
        }

        vm.reloadGraphData = AdpForceGraphService.getDataReloader({ state, forceGraph, doLoadData });
        vm.doResize = fitSize;

        fitSize();

        AdpForceGraphService.initScrollBars(scrollbars, elementWithScrollbars, state.$container);
        doRefreshGraph();
      }

      function doUpdateState() {
        const { config, graphData } = state;

        AdpForceGraphService.updateNodesState(graphData, config);

        state.nothingIsMarked =
          !config.nodeFilter && !config.linkFilter && !state.selectedNodes.length && !config.tagsFilter.length;

        onInterfaceUpdate && onInterfaceUpdate(state);

        forceGraph.autoPauseRedraw(false);
        setTimeout(() => forceGraph.autoPauseRedraw(true), 500);
      }

      function doRefreshGraph() {
        const { config } = state;

        doUpdateState();
        AdpForceGraphService.doCheckConfigFields(vm, config, configFieldsLimits);

        const arrowLength = config.showArrows ? (link) => AdpForceGraphService.linkArrowSize(link, state.config) : 0;
        const particleSize = config.showParticles
          ? (link) => AdpForceGraphService.linkParticleSize(link, state.config)
          : 0;
        const particleCount = config.showParticles ? (link) => link.trf || 0 : 0;
        forceGraph
          .linkDirectionalArrowLength(arrowLength)
          .linkDirectionalParticleWidth(particleSize)
          .linkDirectionalParticles(particleCount);
      }

      function fitSize() {
        AdpForceGraphService.fitGraphSize(forceGraph, state.$container);
      }

      // ToDo: refactor config api
      function getConfig() {
        if (state.cachedConfig) {
          return Promise.resolve(state.cachedConfig);
        }
        return doLoadConfig();
      }

      function applyConfig(conf, omitRefresh) {
        const { config } = state;
        if (conf && _.values(conf).length) {
          const prevTagsFilter = config.tagsFilter;

          Object.assign(config, conf);

          if (!omitRefresh) {
            vm.resetFixDragged();

            doRefreshGraph();

            if (
              tagsFilterInstance &&
              _.intersection(prevTagsFilter, config.tagsFilter).length < config.tagsFilter.length
            ) {
              tagsFilterInstance.option('value', AdpForceGraphService.getTagsByFilterValue(config.tagsFilter, state));
            }
          }
        }
      }

      function screenCapture() {
        if (state.exportingImage) {
          return;
        }

        const $canvas = $('canvas', state.$box);

        if (!$canvas.length) {
          return;
        }

        state.exportingImage = true;

        $canvas[0].toBlob(getFile);

        function getFile(blob) {
          if (blob) {
            const fileName = AdpForceGraphService.genExportFileName('png');
            const mimeType = 'image/png';
            AdpForceGraphService.downloadFile({ blob, fileName, mimeType });
          } else {
            AdpForceGraphService.handleError('Seems like not enough memory', 'Export to PNG failed');
          }

          finalizeExport();
        }

        function finalizeExport() {
          state.exportingImage = false;
        }
      }
    }

    function linkColor(link, state, consts) {
      const { config } = state;
      const isMarked = AdpForceGraphService.isMarked(link);
      const opaqueColor = AdpForceGraphService.linkColor(link, config, consts);
      const opacity = state.nothingIsMarked || isMarked ? 1 : (100 - config.hlDim) / 100;
      // link.isGlow = isMarked;

      return AdpForceGraphService.setColorAlpha(opaqueColor, opacity);
    }

    function linkWidth(link) {
      return link.w || (link.isSelected ? constants.SELECTION_LINK_WIDTH : 1);
    }

    function linkDistance(link, config) {
      return ((link.dst || constants.DEFAULT_LINK_DISTANCE) * config.linkDistance) / 100;
    }

    const geometryCreators = {
      Box(ctx, x, y, size) {
        ctx.fillRect(x - size / 2, y - size / 2, size, size);
      },
      Tetrahedron(ctx, x, y, size) {
        const topOffset = size / 3;
        ctx.beginPath();
        ctx.moveTo(x - (3 * size) / 5, y + topOffset);
        ctx.lineTo(x, y - size + topOffset);
        ctx.lineTo(x + (3 * size) / 5, y + topOffset);
        ctx.fill();
      },
      Torus(ctx, x, y, size) {
        const r1 = size / 2;
        const r2 = size / 4;
        ctx.beginPath();
        ctx.moveTo(x + r1, y);
        ctx.arc(x, y, r1, 0, Math.PI * 2);
        ctx.lineTo(x + r2, y);
        ctx.arc(x, y, r2, Math.PI * 2, 0, true);
        ctx.fill();
      },
      Octahedron(ctx, x, y, size) {
        ctx.beginPath();
        ctx.moveTo(x - size / 2, y);
        ctx.lineTo(x, y - size / 2);
        ctx.lineTo(x + size / 2, y);
        ctx.lineTo(x, y + size / 2);
        ctx.fill();
      },
      Cone(ctx, x, y, size) {
        const topOffset = 0;
        ctx.beginPath();
        ctx.moveTo(x, y - size / 2 + topOffset);
        const a1 = (Math.PI * 50) / 180;
        const a2 = (Math.PI * 130) / 180;
        ctx.arc(x, y + topOffset, size, a1, a2);
        ctx.fill();
      },
      Sphere(ctx, x, y, size) {
        ctx.beginPath();
        ctx.arc(x, y, size / 2, 0, 2 * Math.PI, false);
        ctx.fill();
      },
      image(ctx, x, y, size, node, state) {
        const imageId = _.get(node, 'image.id');
        const cachedImage = _.get(state, ['imagesCatalog', imageId]);
        if (!cachedImage || cachedImage.then) {
          ctx.fillStyle = 'black';
          ctx.fillRect(x - size / 2, y - size / 2, size, size);
        } else {
          const { width, height } = cachedImage;
          let sx;
          let sy;
          if (width > height) {
            sx = size;
            sy = (height * size) / width;
          } else {
            sy = size;
            sx = (width * size) / height;
          }

          try {
            ctx.drawImage(cachedImage, x - sx / 2, y - sy / 2, sx, sy);
          } catch (e) {
            console.error(e);
          }
        }
      },
    };

    geometryCreators.TorusKnot = (ctx, x, y, size) => {
      geometryCreators.Torus(ctx, x - size / 4, y, (size * 2) / 3);
      geometryCreators.Torus(ctx, x + size / 4, y, (size * 2) / 3);
    };

    function renderNodeShape(node, color, ctx, state) {
      const { x, y, size, shp } = node;
      const renderFn = geometryCreators[shp] || geometryCreators[constants.DEFAULT_NODE_SHAPE];
      const objSize = size || constants.DEFAULT_NODE_SIZE;

      ctx.fillStyle = color;
      return renderFn(ctx, x, y, objSize, node, state);
    }

    function renderNodeLabel(node, color, ctx, state) {
      const { x, y, size } = node;
      const fontSize = (size || constants.DEFAULT_NODE_SIZE) * 0.75;
      const text = memoizedLabel(node, state);

      renderLabel(ctx, x + size / 2, y - size / 2, color, fontSize, text);
    }

    function renderLabel(ctx, x, y, color, size, text, align = 'left', verticalAlign = 'middle') {
      const lines = text.split('\n');
      const linesCount = lines.length;
      ctx.font = `${size}px Sans-Serif`;
      ctx.textAlign = align;
      ctx.textBaseline = verticalAlign;
      ctx.fillStyle = color;
      _.each(lines, (line, index) => {
        ctx.fillText(line, x, y - (linesCount - 1 - index) * size);
      });
    }

    function nodeHoverLabel(node, state) {
      return memoizedHoverLabel(node, state);
    }

    function nodeGeometry(node, state, ctx) {
      const { config } = state;
      const isMarked = AdpForceGraphService.isMarked(node);
      const opaqueColor = AdpForceGraphService.nodeColor(node, config, constants);

      const opacity =
        isMarked || state.nothingIsMarked
          ? constants.NODE_COMMON_OPACITY
          : constants.NODE_COMMON_OPACITY * (1 - config.hlDim / 100);
      const color = AdpForceGraphService.setColorAlpha(opaqueColor, opacity);

      renderNodeShape(node, color, ctx, state);

      const showNodeLabel = config.labelNodes || (config.hlLabelNodes && isMarked);

      if (showNodeLabel) {
        renderNodeLabel(node, color, ctx, state);
      }
    }

    function linkAddonGeometry(link, state, ctx, globalScale, config) {
      if (!link.n) {
        return null;
      }

      const isMarked = AdpForceGraphService.isMarked(link);
      const showLinkLabel = config.labelLinks || (config.hlLabelLinks && isMarked);

      if (!showLinkLabel) {
        return null;
      }

      const labelText = link.n;
      const color = linkColor(link, state, constants);
      const curvature = AdpForceGraphService.linkCurvature(link, config, constants);
      const vx = (link.target.x - link.source.x) / 2;
      const vy = (link.target.y - link.source.y) / 2;
      const x = link.source.x + vx + vy * curvature;
      const y = link.source.y + vy - vx * curvature;
      const size = link.fsize || 6;

      renderLabel(ctx, x, y, color, size, labelText, 'center');
    }

    function loadVendorCode() {
      const promises = [];

      if (!AdpForceGraphService.isCommonVendorLoaded()) {
        promises.push(AdpClientCommonHelper.loadScript(`${APP_CONFIG.resourceUrl}/public/js/lib/common.js`));
        promises.push(AdpClientCommonHelper.loadCss(`${APP_CONFIG.resourceUrl}/public/js/lib/css/common.css?v1`));
      }

      if (typeof ForceGraph2d === 'undefined') {
        promises.push(AdpClientCommonHelper.loadScript(`${APP_CONFIG.resourceUrl}/public/js/lib/force-graph-2d.js`));
      }

      return Promise.all(promises);
    }

    return {
      mainLogic,
      loadVendorCode,
    };
  }
})();
;(function () {
  angular.module('app.adpForceGraph').factory('ForceGraphLogic3d', forceGraphLogic3d);

  /** @ngInject */
  function forceGraphLogic3d(
    AdpForceGraphService, // this inject have to be as first argument, to be emulated in standalone export-templates
    AdpClientCommonHelper,
    APP_CONFIG
  ) {
    const constants = {
      SELECTION_LINK_WIDTH: 2,
      DEFAULT_NODE_SIZE: 5,
      DEFAULT_LINK_LABEL_SIZE: 5,
      DEFAULT_NODE_SHAPE: 'Sphere',
      DEFAULT_COLOR: 'white',
      HIGHLIGHT_COLOR: 'magenta',
      SELECTED_COLOR: 'orangered',
      LINK_MAX_CURVATURE: 1,
      LINK_OPACITY: 0.5,
      DEFAULT_LINK_DISTANCE: 100,
      NODE_COMMON_OPACITY: 1,
      CAMERA_ANIMATION_INTERVAL: 30, // Update camera pos every XXX mills, > 0 !!
      TAP_SPEED: 500, // Max time for screen touch to be considered as 'tap'
      CAMERA_FLY_INTERVAL: 500, // Time to move camera on buttons navigation
    };
    const memoizedInfo = _.memoize(
      AdpForceGraphService.getObjectTemplateRenderer('info', AdpForceGraphService.getDefaultObjectInfo)
    );
    const memoizedLabel = _.memoize(AdpForceGraphService.getObjectTemplateRenderer('label', (obj) => obj.n));
    const memoizedHoverLabel = _.memoize(AdpForceGraphService.getObjectTemplateRenderer('hoverLabel', () => ''));

    function mainLogic({
      containerElement,
      onInterfaceUpdate,
      $scope,
      $rootScope,
      $http,
      $sce,
      $document,
      AdpNotificationService,
      AdpFullscreenService,
      appConfig,
      tagBoxCreator,
      doLoadData,
      doLoadConfig,
      options = {},
    }) {
      const vm = this;
      const widgetId = _.get($scope, 'args.row._id');
      let forceGraph;
      let tagsFilterInstance = null;
      let touchData = {};
      const scrollbars = {};
      let selectiveGlowPass;
      const { apiUrl, resourceUrl } = appConfig;
      const keysConf = {
        r: { attr: 'labelLinks' },
        e: { attr: 'labelNodes' },
        o: { attr: 'animCamera', action: 'toggleCameraOrbit' },
        m: { attr: 'showOptions' },
        d: { attr: 'showLegend' },
        x: { attr: 'fixDragged', action: 'resetFixDragged' },
        f: { action: 'toggleFullscreen' },
        '+': { action: () => changeLinksDistance(1.1) },
        '-': { action: () => changeLinksDistance(0.9) },
        s: { action: 'saveConfig' },
        l: { action: 'loadConfig' },
      };
      const configFieldsLimits = {
        hlColorize: { min: 0, max: 100 },
        hlGlow: { min: 0, max: 100 },
        hlBrightness: { min: 0, max: 100 },
        hlDim: { min: 0, max: 100 },
        linkCurvature: { min: 0, max: 100 },
        linkDistance: { min: 1 },
        particleSize: {
          min: 1,
          max: 10,
          onChange(val, _vm) {
            if (val === '0') {
              _vm.state.config.showParticles = false;
            }
          },
        },
        arrowSize: {
          min: 1,
          max: 10,
          onChange(val, _vm) {
            if (val === '0') {
              _vm.state.config.showArrows = false;
            }
          },
        },
      };
      const state = {
        config: {
          showOptions: false,
          showLegend: false,
          showInfo: true,
          hlLabelNodes: true,
          hlLabelLinks: true,
          hlColorize: 50,
          hlBrightness: 75,
          hlGlow: 50,
          hlDim: 0,
          labelLinks: false,
          labelNodes: false,
          showArrows: true,
          arrowSize: 1,
          showParticles: true,
          particleSize: 1,
          animCamera: false,
          fixDragged: false,
          linkCurvature: (constants.LINK_MAX_CURVATURE * 100) / 2,
          linkDistance: constants.DEFAULT_LINK_DISTANCE,
          nodeFilter: '',
          linkFilter: '',
          tagsFilter: [],
          highlightAdjacent: false,
        },
        isLoading: true,
        nothingIsMarked: true,
        apiUrl,
        legend: null,
        tags: null,
        canvasInFocus: false,
        cachedConfig: null,
        $container: $(containerElement),
        selectedNodes: [],
        templates: _.get(options, 'templates'),
      };
      const elementWithScrollbars = {
        config: 0,
        legend: 0,
        info: 0,
      };
      vm.state = state;

      const keypressHandler = AdpForceGraphService.getKeyPressHandler(vm, keysConf, doRefreshGraph);
      state.$box = $('.adp-fg-box', state.$container);

      vm.doRefreshGraph = doRefreshGraph;
      vm.toggleConfig = function () {
        state.config.showOptions = !state.config.showOptions;
      };
      vm.toggleInfo = function () {
        state.config.showInfo = !state.config.showInfo;
      };
      vm.toggleLegend = function (event, force) {
        if (_.isBoolean(force)) {
          state.config.showLegend = force;
        } else {
          state.config.showLegend = !state.config.showLegend;
        }

        scrollbars.config && scrollbars.config.recalculate();
        scrollbars.legend && scrollbars.legend.recalculate();

        event.stopPropagation();
      };
      vm.toggleFullscreen = function () {
        $rootScope.isFullscreen = !$rootScope.isFullscreen;
      };
      vm.reheatSimulation = function () {
        forceGraph.numDimensions(3);
      };
      vm.resetFixDragged = function () {
        const { graphData, config } = state;
        if (!config.fixDragged) {
          _.each(graphData.nodes, (node) => {
            node.fx = undefined;
            node.fz = undefined;
            node.fy = undefined;
          });
        }
        doRefreshGraph();
      };
      vm.toggleCameraOrbit = () => toggleCameraOrbit(forceGraph, state);
      vm.saveConfig = function () {
        const { config } = state;
        state.cachedConfig = { ...config };

        return AdpForceGraphService.doSaveConfig(config, 'vis3d', widgetId);
      };
      vm.loadConfig = function () {
        return getConfig().then((conf) => {
          AdpNotificationService.notifySuccess('Config is restored');

          applyConfig(conf);
        });
      };
      // Not used yet.
      vm.activateVr = () => {
        vm.toggleFullscreen();
        doInitGraphVr();
      };
      vm.activateAr = () => {
        //   vm.toggleFullscreen();
        doInitGraphAr();
      };
      vm.screenCapture = screenCapture;
      vm.exportAsHtml = () => {
        vm.exportingHtml = true;
        // eslint-disable-next-line promise/catch-or-return
        AdpForceGraphService.exportHtml({
          doLoadData,
          $http,
          state,
          templatePath: `${resourceUrl}/public/js/lib/export-3d.tmpl.html`,
        })
          .catch(_.noop)
          .finally(() => {
            vm.exportingHtml = false;
          });
      };
      vm.trustedHtml = (plainText) => $sce.trustAsHtml(plainText);
      vm.getInfoHtml = (obj) => $sce.trustAsHtml(memoizedInfo(obj, state));
      vm.navigationZoomIn = () => moveCameraAlongDirection(true);
      vm.navigationZoomOut = () => moveCameraAlongDirection(false);
      vm.navigationCenter = () => sightOnCenter(forceGraph, state);
      vm.getTagNamesByIds = (ids) => AdpForceGraphService.getTagNamesByIds(ids, state);

      return AdpForceGraphService.prepareVisualisation({
        doLoadVendorCode: loadVendorCode,
        doLoadData,
        doLoadConfig,
        doInitGraph,
        applyConfig,
        state,
        options,
      })
        .then(() => unbindEvents)
        .catch(_.noop);

      function moveCameraAlongDirection(zoomIn) {
        const camera = forceGraph.camera();
        const controller = forceGraph.controls();
        const orbitRadius = camera.position.clone().sub(controller.target).length();
        const factor = 0.75 ** controller.zoomSpeed;
        const currentDirection = new Three.Vector3();
        let moveDistance;

        if (zoomIn) {
          moveDistance = orbitRadius - orbitRadius * factor;
        } else {
          moveDistance = orbitRadius - orbitRadius / factor;
        }

        if (
          orbitRadius + moveDistance < controller.minDistance ||
          orbitRadius + moveDistance > controller.maxDistance
        ) {
          return;
        }

        camera.getWorldDirection(currentDirection);
        currentDirection.normalize();

        const newPosition = camera.position.clone().addScaledVector(currentDirection, moveDistance);

        forceGraph.cameraPosition(newPosition, controller.target, constants.CAMERA_FLY_INTERVAL);
      }

      function doInitGraph() {
        if (options.visualisationMode === 'ar') {
          doInitGraphAr();
        } else {
          doInitGraph3D();
        }
        doInitPreparations();
      }

      function bindEvents() {
        !options.disableResize && $(window).on('resize', fitSize);
        state.$box.on('touchstart', onTouchStart);
        state.$box.on('touchend', onTouchEnd);
        state.$box.on('mouseenter', () => {
          state.canvasInFocus = true;
        });
        state.$box.on('mouseleave', () => {
          state.canvasInFocus = false;
        });
        $document.on('keypress', keypressHandler);
      }

      function unbindEvents() {
        $(window).off('resize', fitSize);
        state.$box.off('touchstart', onTouchStart);
        state.$box.off('touchend', onTouchEnd);
        state.$box.off('mouseenter');
        state.$box.off('mouseleave');
        $document.off('keypress', keypressHandler);
      }

      function doInitGraph3D() {
        const { config } = state;

        clearForceGraph();
        forceGraph = new ForceGraph3d();
        forceGraph(state.$box[0])
          .backgroundColor('rgba(0, 0, 0, 0)')
          // .lights([new Three.AmbientLight(0xcccccc, 1), new Three.DirectionalLight(0xffffff, 0.6)])
          .onNodeClick((node, e) => onGraphClick(e, node))
          .onLinkClick((link, e) => onGraphClick(e, link))
          // .nodePositionUpdate(positionUpdater)
          .onBackgroundClick(onGraphClick)
          .showNavInfo(false)
          .onNodeDragEnd((node) => AdpForceGraphService.onNodeDragEnd(node, config));

        applyCommonForceGraphMethods();

        if (!selectiveGlowPass) {
          selectiveGlowPass = new window.SelectiveGlowPass(
            forceGraph.scene(),
            forceGraph.camera(),
            forceGraph.renderer()
          );

          refreshGlowParams();
        }

        forceGraph.d3Force('link').distance((link) => linkDistance(link, config));

        vm.toggleCameraOrbit();

        unbindEvents();
        bindEvents();
        fitSize();
        setTimeout(doRefreshGraph, 0);
      }

      function doInitGraphVr() {
        clearForceGraph();
        forceGraph = new ForceGraphVr();
        forceGraph(state.$box[0]);

        applyCommonForceGraphMethods();

        vm.toggleCameraOrbit();

        bindEvents();

        fitSize();
        setTimeout(doRefreshGraph, 0);
      }

      function doInitGraphAr() {
        return new Promise((resolve) => {
          const { markerFileName, trackHover } = options;
          const markerAttrs = {
            smooth: true,
            'smooth-count': 7,
            'smooth-tolerance': 0.001,
            // 'smooth-threshold':10,
          };

          if (markerFileName) {
            // If no marker path provided AR.js is in default 'Hiro' marker mode
            markerAttrs.type = 'pattern';
            markerAttrs.url = markerFileName;
            console.log('====Marker file URL:', markerFileName);
          }

          clearForceGraph();
          forceGraph = ForceGraphAR({ markerAttrs })(state.$box[0]);

          if (trackHover) {
            const debouncedHoverHandler = _.debounce(onArGraphClick, 200);
            forceGraph.onNodeHover((node, e) => debouncedHoverHandler(e, node));
          }
          _.defer(() => {
            doRefreshGraph();
            resolve();
          });
          applyCommonForceGraphMethods();
          fitSize();
        });
      }

      function applyCommonForceGraphMethods() {
        const { dagMode } = options;
        const { config, graphData } = state;
        forceGraph
          .linkOpacity(constants.LINK_OPACITY)
          .linkDirectionalParticleColor((link) => AdpForceGraphService.linkParticleColor(link, constants))
          .linkDirectionalParticleResolution(8)
          .linkDirectionalArrowRelPos(0.7)
          .linkDirectionalParticleSpeed(AdpForceGraphService.linkSpeed)
          .linkWidth((link) => AdpForceGraphService.linkWidth(link, constants))
          .linkMaterial((link) => linkMaterial(link, config))
          .linkDirectionalArrowColor((link) => AdpForceGraphService.linkArrowColor(link, config, constants))
          .linkCurvature((link) => AdpForceGraphService.linkCurvature(link, config, constants))
          .linkCurveRotation(linkCurveRotation)
          .nodeThreeObject((node) => nodeGeometry(node, state))
          .nodeLabel((node) => nodeHoverLabel(node, state))
          .linkLabel((link) => nodeHoverLabel(link, state))
          .graphData(graphData);
        forceGraph.d3Force('link').distance((link) => linkDistance(link, config));

        if (dagMode) {
          forceGraph
            .dagMode(dagMode)
            .dagLevelDistance(100)
            .onDagError(() => {
              AdpForceGraphService.handleError(
                `Cycle is encountered. Correct hierarchy representation is not guaranteed`,
                'DAG Error'
              );
            });
        }
      }

      function clearForceGraph() {
        unbindEvents();
        if (forceGraph) {
          forceGraph.graphData({ nodes: [], links: [] });
          forceGraph = null;
          state.$box.empty();
        }
      }

      function doInitPreparations() {
        const { $container } = state;
        const $tagBox = $('.adp-fg-tags-container', $container);
        if ($tagBox.length) {
          const params = AdpForceGraphService.getTagSelectorOptions(
            state,
            () => vm.doRefreshGraph(),
            (e) => {
              tagsFilterInstance = e.component;
            }
          );
          tagBoxCreator($tagBox, params);
        }

        if ($scope) {
          // this code should work only in Angular version, not standalone (exported)
          AdpFullscreenService.registerFullScreenElement($container[0]);

          if ($rootScope.isFullscreen) {
            AdpFullscreenService.forceFullscreen($container[0]);
          }

          $scope.$on('$destroy', () => {
            AdpFullscreenService.unregisterFullScreenElement($container[0]);
            clearInterval(state.orbitInterval);
            clearInterval(state.imageFacingInterval);
          });
        }
        vm.doResize = fitSize;

        vm.reloadGraphData = AdpForceGraphService.getDataReloader({ state, forceGraph, doLoadData });
        AdpForceGraphService.initScrollBars(scrollbars, elementWithScrollbars, state.$container);
      }

      function doRefreshGraph() {
        const { config, graphData } = state;
        const showLinkLabels = config.labelLinks || config.hlLabelLinks;

        AdpForceGraphService.doCheckConfigFields(config, configFieldsLimits);
        AdpForceGraphService.updateNodesState(graphData, config);

        state.nothingIsMarked =
          !config.nodeFilter && !config.linkFilter && !state.selectedNodes.length && !config.tagsFilter.length;

        const linkObject = showLinkLabels ? (link) => linkSprite(link, state) : undefined;
        const arrowLength = config.showArrows ? (link) => AdpForceGraphService.linkArrowSize(link, state.config) : 0;
        const particleSize = config.showParticles
          ? (link) => AdpForceGraphService.linkParticleSize(link, state.config)
          : 0;
        const particleColor = config.showParticles ? (link) => link.trf || 0 : 0;
        forceGraph
          .linkThreeObjectExtend(showLinkLabels)
          .linkThreeObject(linkObject)
          .linkPositionUpdate(showLinkLabels ? linkCustomPositionUpdate : undefined)
          .linkDirectionalArrowLength(arrowLength)
          .linkDirectionalParticleWidth(particleSize)
          .linkDirectionalParticles(particleColor);

        onInterfaceUpdate && onInterfaceUpdate(state);

        refreshGlowParams();

        forceGraph.refresh();
      }

      function refreshGlowParams() {
        if (!selectiveGlowPass) {
          return;
        }

        if (state.config.hlGlow > 0 && !state.nothingIsMarked) {
          const currentPasses = forceGraph.postProcessingComposer().passes;

          if (currentPasses.length === 1) {
            forceGraph.postProcessingComposer().addPass(selectiveGlowPass);
          }

          updateBloomPass(extractBloomPass(selectiveGlowPass));
        } else {
          forceGraph.postProcessingComposer().passes.splice(1);
          forceGraph.postProcessingComposer().passes[0].renderToScreen = true;
        }
      }

      function updateBloomPass(bloomPass) {
        if (bloomPass) {
          bloomPass.threshold = 0.01;
          bloomPass.strength = state.config.hlGlow / 12;
          bloomPass.radius = state.config.hlGlow / 40;
        }
      }

      function fitSize() {
        if (options.disableResize) {
          return;
        }
        AdpForceGraphService.fitGraphSize(forceGraph, state.$container);
      }

      function onGraphClick(e, obj) {
        const { selectedNodes } = state;
        const shiftKey = e && e.shiftKey;
        if (shiftKey && obj) {
          if (obj.isSelected) {
            selectedNodes.splice(selectedNodes.indexOf(obj), 1);
          } else {
            selectedNodes.push(obj);
          }
          obj.isSelected = !obj.isSelected;
        } else {
          if (selectedNodes.length) {
            _.each(selectedNodes, (x) => {
              x.isSelected = false;
            });
          }
          if (obj) {
            state.selectedNodes = [obj];
            obj.isSelected = true;
          } else {
            state.selectedNodes = [];
          }
        }

        state.config.showInfo = true;

        doRefreshGraph();

        if (_.isFunction(vm.onSelectionChange)) {
          const selection = _.map(state.selectedNodes, (x) => ({ type: x.__type, clickValues: x._clickValues }));
          vm.onSelectionChange(selection);
        }
      }

      function onArGraphClick(e, obj) {
        const { selectedNodes } = state;
        if (selectedNodes.length) {
          _.each(selectedNodes, (x) => {
            x.isSelected = false;
            // x.__threeObj.material.color.set(x.bkColor);
            x.__threeObj.material = AdpForceGraphService.getLambertMaterial(x.bkColor, x.__threeObj.material.opacity);
          });
        }
        if (obj) {
          state.selectedNodes = [obj];

          // obj.__threeObj.material.map = state.selectTexture;
          obj.bkColor = obj.__threeObj.material.color.getHex();

          // obj.__threeObj.material.color.set('#ff1005');
          obj.__threeObj.material = AdpForceGraphService.getLambertMaterial('#ff3305', obj.__threeObj.material.opacity);

          obj.isSelected = true;
        } else {
          state.selectedNodes = [];
        }

        if (_.isFunction(vm.onSelectionChange)) {
          const selection = _.map(state.selectedNodes, (x) => ({ type: x.__type, clickValues: x._clickValues }));
          vm.onSelectionChange(selection);
        }
      }

      function onTouchStart(e) {
        const touch = e.originalEvent.touches[0];

        if (touch) {
          touchData = {
            startTime: new Date(),
            x: touch.pageX,
            y: touch.pageY,
          };
        }
      }

      function onTouchEnd(e) {
        if (new Date() - touchData.startTime <= constants.TAP_SPEED) {
          const offset = state.$box.offset();
          const raycaster = new Three.Raycaster();
          const camera = forceGraph.camera();
          const tapCoords = {
            x: ((touchData.x - offset.left) / forceGraph.width()) * 2 - 1,
            y: -((touchData.y - offset.top) / forceGraph.height()) * 2 + 1,
          };

          raycaster.camera = camera; // Required to keep raycaster stable
          raycaster.linePrecision = 1; // Lib's default
          raycaster.setFromCamera(tapCoords, camera);

          const intersects = _.find(
            raycaster.intersectObjects(forceGraph.scene().children, true),
            (_ref) => !!_ref.object.__graphObjType
          );

          onGraphClick(e, intersects ? intersects.object.__data : null);
        }
      }

      function getTagsByFilterValue(value) {
        return _.map(
          _.filter(vm.tags, (tag) => value.indexOf(tag.id) >= 0),
          (item) => item.text
        );
      }

      function changeLinksDistance(factor) {
        const { config } = state;
        config.linkDistance *= factor;
        config.linkDistance = Math.round(config.linkDistance);
        AdpForceGraphService.doCheckConfigFields(vm, config, configFieldsLimits);
        vm.reheatSimulation();
      }

      // ToDo: refactor config api
      function getConfig() {
        if (state.cachedConfig) {
          return Promise.resolve(state.cachedConfig);
        }
        return doLoadConfig();
      }

      function applyConfig(conf, omitRefresh) {
        const { config } = state;
        if (conf && _.values(conf).length) {
          const prevLinkDistance = config.linkDistance;
          const prevTagsFilter = config.tagsFilter;

          Object.assign(config, conf);

          if (omitRefresh) {
            return;
          }

          if (prevLinkDistance !== config.linkDistance) {
            vm.reheatSimulation();
          }

          vm.resetFixDragged();

          doRefreshGraph();
          vm.toggleCameraOrbit();

          if (
            tagsFilterInstance &&
            _.intersection(prevTagsFilter, config.tagsFilter).length < config.tagsFilter.length
          ) {
            tagsFilterInstance.option('value', getTagsByFilterValue(config.tagsFilter));
          }
        }
      }

      function screenCapture() {
        if (state.exportingImage) {
          return;
        }

        let renderer;
        let sx = forceGraph.width();
        let sy = forceGraph.height();
        const originalRatio = sx / sy;

        state.exportingImage = true;

        try {
          renderer = new Three.WebGLRenderer({ preserveDrawingBuffer: true });
          const gl = renderer.getContext();

          // Calculating maximum screenshot dimensions available.
          const maxRenderBufferSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);
          const [maxDimX, maxDimY] = gl.getParameter(gl.MAX_VIEWPORT_DIMS);

          // 2000 is practically discovered constant which is very close to a limit.  2048 is already too much!
          // However, for IE11 it should be less as 'out-of-memory' error throw is common for microsoft beast...
          const zoomFactor = renderer.domElement.msToBlob ? 1000 : 2000;
          const maximumFactor = Math.sqrt((maxRenderBufferSize * zoomFactor) / (sx * sy));
          sx *= maximumFactor;
          sy *= maximumFactor;

          if (sx > maxDimX) {
            sx = maxDimX;
            sy = sx / originalRatio;
          }

          if (sy > maxDimY) {
            sy = maxDimY;
            sx = sy * originalRatio;
          }

          renderer.setSize(sx, sy);

          const composer = new window.EffectComposer(renderer);
          const scene = forceGraph.scene();
          const camera = forceGraph.camera();

          const glowPass = new window.SelectiveGlowPass(scene, camera, renderer);

          updateBloomPass(extractBloomPass(glowPass));

          const sceneRenderPass = new window.RenderPass(scene, camera);
          sceneRenderPass.renderToScreen = false;
          glowPass.renderToScreen = false;

          composer.addPass(sceneRenderPass);
          composer.addPass(glowPass);

          composer.render();

          if (renderer.domElement.msToBlob) {
            // for IE
            getFile(renderer.domElement.msToBlob());
          } else {
            renderer.domElement.toBlob(getFile);
          }
        } catch (error) {
          AdpForceGraphService.handleError(`${error}. Reload page and try again.`, 'Export to PNG failed');

          finalizeExport();
        }

        function getFile(blob) {
          if (blob) {
            const fileName = AdpForceGraphService.genExportFileName('png');
            const mimeType = 'image/png';
            AdpForceGraphService.downloadFile({ blob, fileName, mimeType });
          } else {
            AdpForceGraphService.handleError('Seems like not enough memory', 'Export to PNG failed');
          }

          finalizeExport();
        }

        function finalizeExport() {
          state.exportingImage = false;
          renderer.dispose();
        }
      }
    }

    function extractBloomPass(selectiveGlowPass) {
      return _.get(selectiveGlowPass, 'bloomComposer.passes.1');
    }

    function linkDistance(link, config) {
      return ((link.dst || constants.DEFAULT_LINK_DISTANCE) * config.linkDistance) / 100;
    }

    function linkCurveRotation(link) {
      let angle = 0;

      if (link.linkTotal > 1) {
        angle = (2 * Math.PI * link.linkNumber) / link.linkTotal;
      }

      return angle;
    }

    function linkMaterial(link, config) {
      const isMarked = AdpForceGraphService.isMarked(link);
      const color = AdpForceGraphService.linkColor(link, config, constants);
      const width = AdpForceGraphService.linkWidth(link, constants);
      const opacity = config.nothingIsMarked || isMarked ? 1 : (100 - config.hlDim) / 100;
      const material = (width ? AdpForceGraphService.getLambertMaterial : getLineBasicMaterial)(color, opacity);

      link.isGlow = isMarked;

      return material;
    }

    function getLineBasicMaterial(color, opacity) {
      return new Three.LineBasicMaterial({
        color: Color(color).hex(),
        transparent: opacity < 1,
        opacity,
      });
    }

    function linkCustomPositionUpdate(sprite, p, link) {
      if (!sprite) {
        return;
      }

      let midPos;

      if (link.__curve) {
        const mid = link.__curve.v1;
        const midWeight = 1.3;
        midPos = {
          x: (p.start.x + p.end.x + mid.x * midWeight) / 3,
          y: (p.start.y + p.end.y + mid.y * midWeight) / 3,
          z: (p.start.z + p.end.z + mid.z * midWeight) / 3,
        };
      } else {
        midPos = {
          x: (p.start.x + p.end.x) / 2,
          y: (p.start.y + p.end.y) / 2,
          z: (p.start.z + p.end.z) / 2,
        };
      }

      Object.assign(sprite.position, midPos);
    }

    function linkSprite(link, state) {
      const { config } = state;
      if (!link.n || _.isUndefined(window.SpriteText)) {
        return null;
      }

      const isMarked = AdpForceGraphService.isMarked(link);
      const showLinkLabel = config.labelLinks || (config.hlLabelLinks && isMarked);

      if (!showLinkLabel) {
        return null;
      }

      const labelText = memoizedLabel(link, state);
      const sprite = new SpriteText(labelText);
      const linkOpacity = config.nothingIsMarked || isMarked ? 1 : (100 - config.hlDim) / 100;

      sprite.color = AdpForceGraphService.mixColors(link.col, 'white');
      sprite.material.opacity = linkOpacity;

      sprite.textHeight = link.fsize || constants.DEFAULT_LINK_LABEL_SIZE;

      return sprite;
    }
    //
    // function positionUpdater(threeObj, { x, y, z }, node) {
    //   // console.log('--PosUpd', threeObj, x, y, z, node);
    //   threeObj.position.set(x,y,z);
    //   return true;
    // }

    function nodeGeometry(node, state) {
      return AdpForceGraphService.node3dGeometry(node, state, constants, memoizedLabel);
    }

    function nodeHoverLabel(node, state) {
      return memoizedHoverLabel(node, state);
    }

    function sightOnCenter(forceGraph, state) {
      const camera = forceGraph.camera();
      const attention = getAttentionNodes(state);
      const { lookAtPoint } = attention;
      const boundingSphereRadius = attention.radius;
      const lookAtNewDirection = new Three.Vector3().subVectors(lookAtPoint, camera.position).normalize();
      const newCameraPosition = lookAtPoint.clone().addScaledVector(lookAtNewDirection, -3 * boundingSphereRadius);

      forceGraph.cameraPosition(newCameraPosition, lookAtPoint, constants.CAMERA_FLY_INTERVAL);

      return {
        lookAtPoint,
        cameraPosition: newCameraPosition,
      };
    }

    function getAttentionNodes(state) {
      const { config, selectedNodes, graphData } = state;
      const lookAtPoint = new Three.Vector3();
      const { nodes: allNodes } = graphData;
      const hasSelectedNodes = selectedNodes.length;
      let nodesToConsider = [];
      let radius = 0;

      if (hasSelectedNodes || config.nodeFilter || config.linkFilter) {
        const nodesToCheck = hasSelectedNodes ? selectedNodes : allNodes;
        let counter = 0;

        _.each(nodesToCheck, (obj) => {
          if (
            (AdpForceGraphService.isNode(obj) &&
              (!config.nodeFilter || AdpForceGraphService.isNodeFiltered(obj, config))) ||
            (AdpForceGraphService.isLink(obj) &&
              (!config.linkFilter || AdpForceGraphService.isLinkFiltered(obj, config)))
          ) {
            nodesToConsider.push(obj);

            _.each(pickNodePoints(obj), (p) => {
              lookAtPoint.add(p);
              counter++;
            });
          }
        });

        counter && lookAtPoint.divideScalar(counter);
      } else {
        nodesToConsider = allNodes;
      }

      _.each(nodesToConsider, function (obj) {
        const distance = Math.max.apply(
          this,
          _.map(pickNodePoints(obj), (p) => pointsDistance(p, lookAtPoint))
        );

        if (distance > radius) {
          radius = distance;
        }
      });

      return {
        radius: Math.max(70, radius),
        lookAtPoint,
      };
    }

    function pickNodePoints(obj) {
      if (AdpForceGraphService.isNode(obj)) {
        return obj.__threeObj ? [obj.__threeObj.position] : [];
      }
      if (AdpForceGraphService.isLink(obj)) {
        return obj.source.__threeObj ? [obj.source.__threeObj.position, obj.target.__threeObj.position] : [];
      }
      return [];
    }

    function pointsDistance(a, b) {
      return a.distanceTo(b);
    }

    function toggleCameraOrbit(forceGraph, state) {
      const camera = forceGraph.camera();

      forceGraph.enableNodeDrag(!state.config.animCamera);

      state.orbitInterval && clearInterval(state.orbitInterval);
      state.orbitInterval = null;

      if (state.config.animCamera) {
        const data = sightOnCenter(forceGraph, state);

        state.camOrbiter = new OrbitControls(camera, state.$box[0]);
        state.camOrbiter.autoRotateSpeed = 5; // default is 2.0
        state.camOrbiter.target = data.lookAtPoint;

        setTimeout(() => {
          state.camOrbiter.autoRotate = true;
        }, constants.CAMERA_FLY_INTERVAL);

        state.orbitInterval = setInterval(
          () => state.camOrbiter && state.camOrbiter.update(),
          constants.CAMERA_ANIMATION_INTERVAL
        );
      } else if (state.camOrbiter) {
        state.camOrbiter.dispose();
        state.camOrbiter = null;
      }
    }

    function loadVendorCode(mode) {
      const promises = [];

      if (mode === 'ar') {
        return Promise.resolve(); // AR mode runs with all vendors statically included, and AdpClientCommonHelper is not available
      }
      if (!AdpForceGraphService.isCommonVendorLoaded()) {
        promises.push(AdpClientCommonHelper.loadScript(`${APP_CONFIG.resourceUrl}/public/js/lib/common.js`));
        promises.push(AdpClientCommonHelper.loadCss(`${APP_CONFIG.resourceUrl}/public/js/lib/css/common.css?v1`));
      }

      if (typeof ForceGraph3d === 'undefined') {
        if (navigator && navigator.xr && !_.isFunction(navigator.xr.requestDevice)) {
          // This polyfill is to fix pure WebXR support in Chrome 79
          navigator.xr.requestDevice = function () {
            return new $.Deferred().resolve(null);
          };
        }
        promises.push(AdpClientCommonHelper.loadScript(`${APP_CONFIG.resourceUrl}/public/js/lib/force-graph-3d.js`));
      }

      return Promise.all(promises);
    }

    return {
      mainLogic,
      loadVendorCode,
    };
  }
})();
;(function () {
  angular
    .module('app.adpForceGraph')
    .controller('OntologyController', () => {})
    .directive('adpFullscreenListener', adpFullScreenListener);

  function adpFullScreenListener(AdpFullscreenService, $rootScope) {
    return {
      restrict: 'A',
      link(scope) {
        document.addEventListener('fullscreenchange', onFullScreenChange);
        document.addEventListener('mozfullscreenchange', onFullScreenChange);
        document.addEventListener('webkitfullscreenchange', onFullScreenChange);
        document.addEventListener('msfullscreenchange', onFullScreenChange);

        function onFullScreenChange() {
          $rootScope.isFullscreen = AdpFullscreenService.fullscreenEnabled();
          scope.$apply();
        }
      },
    };
  }
})();
;(function () {
  angular.module('app.adpForceGraph').factory('ForceGraphLogicVr', forceGraphLogicVr);

  /** @ngInject */
  function forceGraphLogicVr(
    AdpForceGraphService, // this inject have to be as first argument, to be emulated in standalone export-templates
    AdpClientCommonHelper,
    APP_CONFIG
  ) {
    const constants = {
      SELECTION_LINK_WIDTH: 2,
      DEFAULT_NODE_SIZE: 5,
      DEFAULT_LINK_LABEL_SIZE: 5,
      DEFAULT_NODE_SHAPE: 'Sphere',
      DEFAULT_COLOR: 'white',
      HIGHLIGHT_COLOR: 'magenta',
      SELECTED_COLOR: 'orangered',
      LINK_MAX_CURVATURE: 1,
      LINK_OPACITY: 0.5,
      DEFAULT_LINK_DISTANCE: 100,
      NODE_COMMON_OPACITY: 1,
      CAMERA_ANIMATION_INTERVAL: 30, // Update camera pos every XXX mills, > 0 !!
      TAP_SPEED: 500, // Max time for screen touch to be considered as 'tap'
      CAMERA_FLY_INTERVAL: 500, // Time to move camera on buttons navigation
    };

    function mainLogic({
      containerElement,
      onInterfaceUpdate,
      $scope,
      $rootScope,
      $document,
      appConfig,
      doLoadData,
      doLoadConfig,
      options = {},
    }) {
      const vm = this;
      let forceGraph;
      const { apiUrl } = appConfig;
      const keysConf = {
        r: { attr: 'labelLinks' },
        e: { attr: 'labelNodes' },
        '+': { action: () => changeLinksDistance(1.1) },
        '-': { action: () => changeLinksDistance(0.9) },
      };
      const configFieldsLimits = {
        linkCurvature: { min: 0, max: 100 },
        linkDistance: { min: 1 },
        particleSize: {
          min: 1,
          max: 10,
          onChange(val, _vm) {
            if (val === '0') {
              _vm.state.config.showParticles = false;
            }
          },
        },
        arrowSize: {
          min: 1,
          max: 10,
          onChange(val, _vm) {
            if (val === '0') {
              _vm.state.config.showArrows = false;
            }
          },
        },
      };
      const state = {
        config: {
          showOptions: false,
          showLegend: false,
          showInfo: true,
          hlLabelNodes: true,
          hlLabelLinks: true,
          hlColorize: 50,
          hlBrightness: 75,
          hlGlow: 50,
          hlDim: 0,
          labelLinks: false,
          labelNodes: false,
          showArrows: true,
          arrowSize: 1,
          showParticles: true,
          particleSize: 1,
          animCamera: false,
          fixDragged: false,
          linkCurvature: (constants.LINK_MAX_CURVATURE * 100) / 2,
          linkDistance: constants.DEFAULT_LINK_DISTANCE,
          nodeFilter: '',
          linkFilter: '',
          tagsFilter: [],
          highlightAdjacent: false,
        },
        isLoading: true,
        nothingIsMarked: true,
        apiUrl,
        legend: null,
        tags: null,
        canvasInFocus: false,
        cachedConfig: null,
        $container: $(containerElement),
        selectedNodes: [],
      };

      state.$box = $('.adp-fg-box', state.$container);

      vm.state = state;

      const keypressHandler = AdpForceGraphService.getKeyPressHandler(vm, keysConf, doRefreshGraph);

      vm.doRefreshGraph = doRefreshGraph;
      vm.toggleFullscreen = function () {
        $rootScope.isFullscreen = !$rootScope.isFullscreen;
      };
      vm.reheatSimulation = function () {
        forceGraph.numDimensions(3);
      };
      vm.resetFixDragged = function () {
        const { graphData, config } = state;
        if (!config.fixDragged) {
          _.each(graphData.nodes, (node) => {
            node.fx = undefined;
            node.fz = undefined;
            node.fy = undefined;
          });
        }
        doRefreshGraph();
      };
      vm.navigationZoomIn = () => moveCameraAlongDirection(true);
      vm.navigationZoomOut = () => moveCameraAlongDirection(false);
      vm.navigationCenter = () => sightOnCenter(forceGraph, state);
      vm.getTagNamesByIds = (ids) => AdpForceGraphService.getTagNamesByIds(ids, state);

      return AdpForceGraphService.prepareVisualisation({
        doLoadVendorCode: loadVendorCode,
        doLoadData,
        doLoadConfig,
        doInitGraph,
        applyConfig,
        state,
        options,
      })
        .then(() => unbindEvents)
        .catch(_.noop);

      function moveCameraAlongDirection(zoomIn) {
        const camera = forceGraph.camera();
        const controller = forceGraph.controls();
        const orbitRadius = camera.position.clone().sub(controller.target).length();
        const factor = 0.75 ** controller.zoomSpeed;
        const currentDirection = new Three.Vector3();
        let moveDistance;

        if (zoomIn) {
          moveDistance = orbitRadius - orbitRadius * factor;
        } else {
          moveDistance = orbitRadius - orbitRadius / factor;
        }

        if (
          orbitRadius + moveDistance < controller.minDistance ||
          orbitRadius + moveDistance > controller.maxDistance
        ) {
          return;
        }

        camera.getWorldDirection(currentDirection);
        currentDirection.normalize();

        const newPosition = camera.position.clone().addScaledVector(currentDirection, moveDistance);

        forceGraph.cameraPosition(newPosition, controller.target, constants.CAMERA_FLY_INTERVAL);
      }

      function doInitGraph() {
        const { config } = state;

        clearForceGraph();
        forceGraph = new ForceGraphVR();
        forceGraph(state.$box[0])
          .backgroundColor('rgba(0, 0, 0, 0)')
          .onNodeClick((node, e) => onGraphClick(e, node))
          .onLinkClick((link, e) => onGraphClick(e, link));

        applyCommonForceGraphMethods();

        forceGraph.d3Force('link').distance((link) => linkDistance(link, config));

        unbindEvents();
        bindEvents();
        fitSize();
        setTimeout(doRefreshGraph, 0);
        doInitPreparations();
      }

      function bindEvents() {
        !options.disableResize && $(window).on('resize', fitSize);
        // state.$box.on('touchstart', onTouchStart);
        // state.$box.on('touchend', onTouchEnd);
        state.$box.on('mouseenter', () => {
          state.canvasInFocus = true;
        });
        state.$box.on('mouseleave', () => {
          state.canvasInFocus = false;
        });
        $document.on('keypress', keypressHandler);
      }

      function unbindEvents() {
        $(window).off('resize', fitSize);
        // state.$box.off('touchstart', onTouchStart);
        // state.$box.off('touchend', onTouchEnd);
        state.$box.off('mouseenter');
        state.$box.off('mouseleave');
        $document.off('keypress', keypressHandler);
      }

      // function addClickHandlers() {
      //   // const markerEl = state.$box[0].querySelector('a-marker');
      //   // const markerEl = state.$box[0].querySelector('a-entity[forcegraph]');        //
      //   const markerEl = state.$box[0].querySelector('a-entity[raycaster]');
      //
      //   markerEl.setAttribute("emitevents", "true");
      //   markerEl.setAttribute("cursor", "rayOrigin: mouse");
      //   markerEl.addEventListener('click', (ev, target)=>{
      //     const intersectedElement = ev && ev.detail && ev.detail.intersectedEl;
      //
      //     console.log("---smth is intersected!!!", intersectedElement, ev);
      //   });
      // }

      // function fixRaycasterCamera(){
      //   const raycasterEl = state.$box[0].querySelector("a-entity[raycaster]");//.getAttribute('raycaster');
      //   const cameraEl = state.$box[0].querySelector("a-entity[camera]");//.getAttribute('camera');
      //
      //   //raycaster.camera = camera;
      //   console.log("=====", raycasterEl, cameraEl);
      // }

      function applyCommonForceGraphMethods() {
        const { dagMode } = options;
        const { config, graphData } = state;
        forceGraph
          .linkOpacity(constants.LINK_OPACITY)
          .linkDirectionalParticleColor((link) => AdpForceGraphService.linkParticleColor(link, constants))
          .linkDirectionalParticleResolution(8)
          .linkDirectionalArrowRelPos(0.7)
          .linkDirectionalParticleSpeed(AdpForceGraphService.linkSpeed)
          .linkWidth((link) => AdpForceGraphService.linkWidth(link, constants))
          .linkMaterial((link) => linkMaterial(link, config))
          .linkDirectionalArrowColor((link) => AdpForceGraphService.linkArrowColor(link, config, constants))
          .linkCurvature((link) => AdpForceGraphService.linkCurvature(link, config, constants))
          .linkCurveRotation(linkCurveRotation)
          .nodeThreeObject((node) => nodeGeometry(node, state))
          .graphData(graphData);
        forceGraph.d3Force('link').distance((link) => linkDistance(link, config));

        if (dagMode) {
          forceGraph
            .dagMode(dagMode)
            .dagLevelDistance(100)
            .onDagError(() => {
              AdpForceGraphService.handleError(
                `Cycle is encountered. Correct hierarchy representation is not guaranteed`,
                'DAG Error'
              );
            });
        }
      }

      function clearForceGraph() {
        unbindEvents();
        if (forceGraph) {
          forceGraph.graphData({ nodes: [], links: [] });
          forceGraph = null;
          state.$box.empty();
        }
      }

      function doInitPreparations() {
        // const { $container } = state;
        // const $tagBox = $('.adp-fg-tags-container', $container);
        // if ($tagBox.length) {
        //   const params = AdpForceGraphService.getTagSelectorOptions(
        //     state,
        //     () => vm.doRefreshGraph(),
        //     (e) => {
        //       tagsFilterInstance = e.component;
        //     }
        //   );
        //   tagBoxCreator($tagBox, params);
        // }

        if ($scope) {
          //   // this code should work only in Angular version, not standalone (exported)
          //   AdpFullscreenService.registerFullScreenElement($container[0]);
          //
          //   if ($rootScope.isFullscreen) {
          //     AdpFullscreenService.forceFullscreen($container[0]);
          //   }
          //
          $scope.$on('$destroy', () => {
            clearInterval(state.orbitInterval);
            clearInterval(state.imageFacingInterval);
          });
        }
        vm.doResize = fitSize;

        vm.reloadGraphData = AdpForceGraphService.getDataReloader({ state, forceGraph, doLoadData });
        // AdpForceGraphService.initScrollBars(scrollbars, elementWithScrollbars, state.$container);
      }

      function doRefreshGraph() {
        const { config, graphData } = state;
        const showLinkLabels = config.labelLinks || config.hlLabelLinks;

        // AdpForceGraphService.doCheckConfigFields(config, configFieldsLimits);
        AdpForceGraphService.updateNodesState(graphData, config);

        state.nothingIsMarked =
          !config.nodeFilter && !config.linkFilter && !state.selectedNodes.length && !config.tagsFilter.length;

        const linkObject = showLinkLabels ? (link) => linkSprite(link, config) : undefined;
        const arrowLength = config.showArrows ? (link) => AdpForceGraphService.linkArrowSize(link, state.config) : 0;
        const particleSize = config.showParticles
          ? (link) => AdpForceGraphService.linkParticleSize(link, state.config)
          : 0;
        const particleColor = config.showParticles ? (link) => link.trf || 0 : 0;
        forceGraph
          .linkThreeObjectExtend(showLinkLabels)
          .linkThreeObject(linkObject)
          .linkPositionUpdate(showLinkLabels ? linkCustomPositionUpdate : undefined)
          .linkDirectionalArrowLength(arrowLength)
          .linkDirectionalParticleWidth(particleSize)
          .linkDirectionalParticles(particleColor);

        onInterfaceUpdate && onInterfaceUpdate(state);

        // refreshGlowParams();

        forceGraph.refresh();
      }

      // function refreshGlowParams() {
      //   if (!selectiveGlowPass) {
      //     return;
      //   }
      //
      //   if (state.config.hlGlow > 0 && !state.nothingIsMarked) {
      //     const currentPasses = forceGraph.postProcessingComposer().passes;
      //
      //     if (currentPasses.length === 1) {
      //       forceGraph.postProcessingComposer().addPass(selectiveGlowPass);
      //     }
      //
      //     updateBloomPass(extractBloomPass(selectiveGlowPass));
      //   } else {
      //     forceGraph.postProcessingComposer().passes.splice(1);
      //     forceGraph.postProcessingComposer().passes[0].renderToScreen = true;
      //   }
      // }

      // function updateBloomPass(bloomPass) {
      //   if (bloomPass) {
      //     bloomPass.threshold = 0.01;
      //     bloomPass.strength = state.config.hlGlow / 12;
      //     bloomPass.radius = state.config.hlGlow / 40;
      //   }
      // }

      function fitSize() {
        if (options.disableResize) {
          return;
        }
        AdpForceGraphService.fitGraphSize(forceGraph, state.$container);
      }

      /*  function onGraphClick(e, obj) {
        const { selectedNodes } = state;
        const shiftKey = e && e.shiftKey;
        if (shiftKey && obj) {
          if (obj.isSelected) {
            selectedNodes.splice(selectedNodes.indexOf(obj), 1);
          } else {
            selectedNodes.push(obj);
          }
          obj.isSelected = !obj.isSelected;
        } else {
          if (selectedNodes.length) {
            _.each(selectedNodes, (x) => {
              x.isSelected = false;
            });
          }
          if (obj) {
            state.selectedNodes = [obj];
            obj.isSelected = true;
          } else {
            state.selectedNodes = [];
          }
        }

        state.config.showInfo = true;

        doRefreshGraph();

        if (_.isFunction(vm.onSelectionChange)) {
          const selection = _.map(state.selectedNodes, (x) => ({ type: x.__type, clickValues: x._clickValues }));
          vm.onSelectionChange(selection);
        }
      } */

      function onGraphClick(e, obj) {
        const { selectedNodes } = state;
        const smthAlreadySelected = selectedNodes.length;
        const clickedOnSelected = smthAlreadySelected && state.selectedNodes[0] === obj;
        if (smthAlreadySelected) {
          _.each(selectedNodes, (x) => {
            x.isSelected = false;
            x.__threeObj.material.color.set(x.bkColor);
          });
        }
        if (obj && !clickedOnSelected) {
          state.selectedNodes = [obj];

          obj.bkColor = obj.__threeObj.material.color.getHex();
          obj.__threeObj.material.color.set('#ff1005');
          obj.isSelected = true;
        } else {
          state.selectedNodes = [];
        }

        if (_.isFunction(vm.onSelectionChange)) {
          const selection = _.map(state.selectedNodes, (x) => ({
            type: x.__type,
            clickValues: x._clickValues,
            node: x,
          }));
          vm.onSelectionChange(selection);
        }
      }

      function changeLinksDistance(factor) {
        const { config } = state;
        config.linkDistance *= factor;
        config.linkDistance = Math.round(config.linkDistance);
        AdpForceGraphService.doCheckConfigFields(vm, config, configFieldsLimits);
        vm.reheatSimulation();
      }

      function applyConfig(conf, omitRefresh) {
        const { config } = state;
        if (conf && _.values(conf).length) {
          const prevLinkDistance = config.linkDistance;

          Object.assign(config, conf);

          if (omitRefresh) {
            return;
          }

          if (prevLinkDistance !== config.linkDistance) {
            vm.reheatSimulation();
          }

          vm.resetFixDragged();

          doRefreshGraph();
        }
      }
    }

    function linkDistance(link, config) {
      return ((link.dst || constants.DEFAULT_LINK_DISTANCE) * config.linkDistance) / 100;
    }

    function linkCurveRotation(link) {
      let angle = 0;

      if (link.linkTotal > 1) {
        angle = (2 * Math.PI * link.linkNumber) / link.linkTotal;
      }

      return angle;
    }

    function linkMaterial(link, config) {
      const isMarked = AdpForceGraphService.isMarked(link);
      const color = AdpForceGraphService.linkColor(link, config, constants);
      const width = AdpForceGraphService.linkWidth(link, constants);
      const opacity = config.nothingIsMarked || isMarked ? 1 : (100 - config.hlDim) / 100;
      const material = (width ? getLambertMaterial : getLineBasicMaterial)(color, opacity);

      link.isGlow = isMarked;

      return material;
    }

    function getLambertMaterial(color, opacity) {
      return new Three.MeshLambertMaterial({
        color: Color(color).hex(),
        transparent: opacity < 1,
        opacity,
      });
    }

    function getLineBasicMaterial(color, opacity) {
      return new Three.LineBasicMaterial({
        color: Color(color).hex(),
        transparent: opacity < 1,
        opacity,
      });
    }

    function linkCustomPositionUpdate(sprite, p, link) {
      if (!sprite) {
        return;
      }

      let midPos;

      if (link.__curve) {
        const mid = link.__curve.v1;
        const midWeight = 1.3;
        midPos = {
          x: (p.start.x + p.end.x + mid.x * midWeight) / 3,
          y: (p.start.y + p.end.y + mid.y * midWeight) / 3,
          z: (p.start.z + p.end.z + mid.z * midWeight) / 3,
        };
      } else {
        midPos = {
          x: (p.start.x + p.end.x) / 2,
          y: (p.start.y + p.end.y) / 2,
          z: (p.start.z + p.end.z) / 2,
        };
      }

      Object.assign(sprite.position, midPos);
    }

    function linkSprite(link, config) {
      if (!link.n || _.isUndefined(window.SpriteText)) {
        return null;
      }

      const isMarked = AdpForceGraphService.isMarked(link);
      const showLinkLabel = config.labelLinks || (config.hlLabelLinks && isMarked);

      if (!showLinkLabel) {
        return null;
      }

      const labelText = link.n;
      const sprite = new SpriteText(labelText);
      const linkOpacity = config.nothingIsMarked || isMarked ? 1 : (100 - config.hlDim) / 100;

      sprite.color = AdpForceGraphService.mixColors(link.col, 'white');
      sprite.material.opacity = linkOpacity;

      sprite.textHeight = link.fsize || constants.DEFAULT_LINK_LABEL_SIZE;

      return sprite;
    }

    function nodeGeometry(node, state) {
      return AdpForceGraphService.node3dGeometry(node, state, constants);
    }

    function sightOnCenter(forceGraph, state) {
      const camera = forceGraph.camera();
      const attention = getAttentionNodes(state);
      const { lookAtPoint } = attention;
      const boundingSphereRadius = attention.radius;
      const lookAtNewDirection = new Three.Vector3().subVectors(lookAtPoint, camera.position).normalize();
      const newCameraPosition = lookAtPoint.clone().addScaledVector(lookAtNewDirection, -3 * boundingSphereRadius);

      forceGraph.cameraPosition(newCameraPosition, lookAtPoint, constants.CAMERA_FLY_INTERVAL);

      return {
        lookAtPoint,
        cameraPosition: newCameraPosition,
      };
    }

    function getAttentionNodes(state) {
      const { config, selectedNodes, graphData } = state;
      const lookAtPoint = new Three.Vector3();
      const { nodes: allNodes } = graphData;
      const hasSelectedNodes = selectedNodes.length;
      let nodesToConsider = [];
      let radius = 0;

      if (hasSelectedNodes || config.nodeFilter || config.linkFilter) {
        const nodesToCheck = hasSelectedNodes ? selectedNodes : allNodes;
        let counter = 0;

        _.each(nodesToCheck, (obj) => {
          if (
            (AdpForceGraphService.isNode(obj) &&
              (!config.nodeFilter || AdpForceGraphService.isNodeFiltered(obj, config))) ||
            (AdpForceGraphService.isLink(obj) &&
              (!config.linkFilter || AdpForceGraphService.isLinkFiltered(obj, config)))
          ) {
            nodesToConsider.push(obj);

            _.each(pickNodePoints(obj), (p) => {
              lookAtPoint.add(p);
              counter++;
            });
          }
        });

        counter && lookAtPoint.divideScalar(counter);
      } else {
        nodesToConsider = allNodes;
      }

      _.each(nodesToConsider, function (obj) {
        const distance = Math.max.apply(
          this,
          _.map(pickNodePoints(obj), (p) => pointsDistance(p, lookAtPoint))
        );

        if (distance > radius) {
          radius = distance;
        }
      });

      return {
        radius: Math.max(70, radius),
        lookAtPoint,
      };
    }

    function pickNodePoints(obj) {
      if (AdpForceGraphService.isNode(obj)) {
        return obj.__threeObj ? [obj.__threeObj.position] : [];
      }
      if (AdpForceGraphService.isLink(obj)) {
        return obj.source.__threeObj ? [obj.source.__threeObj.position, obj.target.__threeObj.position] : [];
      }
      return [];
    }

    function pointsDistance(a, b) {
      return a.distanceTo(b);
    }

    function loadVendorCode() {
      const promises = [];

      if (!AdpForceGraphService.isCommonVendorLoaded()) {
        promises.push(AdpClientCommonHelper.loadScript(`${APP_CONFIG.resourceUrl}/public/js/lib/common.js`));
        promises.push(AdpClientCommonHelper.loadCss(`${APP_CONFIG.resourceUrl}/public/js/lib/css/common.css?v1`));
      }

      if (typeof ForceGraphVR === 'undefined') {
        // This polyfill is to fix pure WebXR support in Chrome 79

        if (navigator && navigator.xr && !_.isFunction(navigator.xr.requestDevice)) {
          navigator.xr.requestDevice = function () {
            return new $.Deferred().resolve(null);
          };
        }
        promises.push(
          AdpClientCommonHelper.loadScript(`${APP_CONFIG.resourceUrl}/public/js/lib/vendor/3d-force-graph-vr.min.js`)
        );
        promises.push(AdpClientCommonHelper.loadCss(`${APP_CONFIG.resourceUrl}/public/js/lib/css/fgVr.css?v1`));
      }

      return Promise.all(promises).then(() => {
        window.Three = window.THREE;
      });
    }

    return {
      mainLogic,
      loadVendorCode,
    };
  }
})();
;(function () {
  angular.module('app.adpForceGraph').factory('AdpForceGraphService', adpForceGraphService);

  function adpForceGraphService(
    APP_CONFIG,
    AdpSchemaService,
    GraphqlCollectionQuery,
    AdpNotificationService,
    AdpUnifiedArgs,
    AdpFormDataUtils,
    ErrorHelpers,
    GraphqlCollectionMutator
  ) {
    const materialCache = {};
    const geometryCache = {};

    function linkSpeed(link) {
      // 0.01 is default speed, 0.2 is very maximum (===5frames to travel whole link len for one particle)
      // link.spd varies from 1 to 100, by schema config
      return (link.pspd || 5) / 500;
    }

    function fitGraphSize(graph, $container) {
      setTimeout(() => {
        graph.width($container.width());
        graph.height($container.height());
      }, 0);
    }

    function linkParticleColor(link, constants) {
      return link.pcol || mixColors(link.col || constants.DEFAULT_COLOR, 0, 0, 0.65);
    }

    function mixColors(col1, col2, mix, bright) {
      const col = Color(col1);
      const mixture = col.mix(Color(col2), _.isUndefined(mix) ? 0.5 : mix);
      let res;
      let coof;

      if (_.isUndefined(bright) || bright === 0.5) {
        res = mixture;
      } else if (bright > 0.5) {
        coof = Math.min(1, bright - 0.5) * 2;
        res = mixture.hwb();
        res.color[1] += (100 - res.color[1]) * coof;
        res.color[2] -= res.color[2] * coof;
      } else {
        coof = Math.max(0, 0.5 - bright) * 2;
        res = mixture.hwb();
        res.color[1] -= res.color[1] * coof;
        res.color[2] += (100 - res.color[2]) * coof;
      }

      return res.hex();
    }

    function setColorAlpha(col, alpha) {
      return Color(col).alpha(alpha).rgb().string();
    }

    function prepareGraphData(inputData, buildDynamicLegend, mergeSimilarLegendItems) {
      const newLegend = { nodes: {}, links: {} };
      const types = {
        nodes: {
          styleAttrName: _.get(inputData, 'nodeStyleAttribute'),
          defaults: _.get(inputData, 'defaultStyles.node', {}),
          typedProcess(node) {
            node.__type = 'node';
            node.shp = node.shp || 'sphere';
          },
        },
        links: {
          styleAttrName: _.get(inputData, 'linkStyleAttribute'),
          defaults: _.get(inputData, 'defaultStyles.link', {}),
          typedProcess(link) {
            link.__type = 'link';
            if (!link.pw) {
              link.trf = 0;
            }
          },
        },
      };

      // 1.  Extracting styles in legend items
      _.each(types, (conf, type) => {
        const legendSection = _.get(inputData, `legend.${type}`, []);

        _.each(legendSection, (item) => {
          if (conf.styleAttrName) {
            const style = getStyle(item, conf.styleAttrName);

            Object.assign(item, { ...conf.defaults, ...style, ...item });

            if (!item.text) {
              item.text = item[conf.styleAttrName];
            }

            delete item[conf.styleAttrName];
          }
          updateLegendWithItem(newLegend[type], item, item.text, mergeSimilarLegendItems);
        });
      });

      // 2. Extracting styles in nodes and links and check if types are present in legend
      _.each(types, (conf, type) => {
        _.each(inputData[type] || [], (item) => {
          const style = getStyle(item, conf.styleAttrName);

          Object.assign(item, { ...conf.defaults, ...style, ...item });

          conf.typedProcess && conf.typedProcess(item);
          commonProcess(item);

          if (buildDynamicLegend) {
            updateLegendWithItem(
              newLegend[type],
              item,
              item[conf.styleAttrName] || (item.obj && item.obj.Acronym) || item.n,
              false
            );
          }
        });

        newLegend[type] = _.values(newLegend[type]).sort((a, b) => {
          if (!a.text) {
            return 1;
          }
          if (!b.text) {
            return -1;
          }
          return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1;
        });
      });

      inputData.legend = newLegend;

      return inputData;

      function commonProcess(obj) {
        obj.adpCreatedAt = obj.crtd;
        obj.adpUpdatedAt = obj.uptd;
        delete obj.crtd;
        delete obj.uptd;
      }

      function getStyle(object, styleAttrName) {
        if (styleAttrName) {
          return (
            _.find(
              inputData.styles || [],
              (val, key) => object[styleAttrName] && key && key.toLowerCase() === object[styleAttrName].toLowerCase()
            ) || {}
          );
        }
        return {};
      }

      function updateLegendWithItem(dictionary, item, itemLabel, mergeSimilarItemsLabels) {
        const legendKey = `${item.shp}___${item.w}___${item.col}`;

        if (dictionary[legendKey]) {
          if (mergeSimilarItemsLabels) {
            dictionary[legendKey].text = `${dictionary[legendKey].text}; ${itemLabel}`;
          }
        } else {
          dictionary[legendKey] = { ...item, text: itemLabel };
        }
      }
    }

    function downloadFile(params) {
      // ToDo: move into some  common module as it used not only here but (at least) by Dashboard export as well
      const fileName = params.fileName || `downloaded_${new Date().getTime()}`;
      const blob = params.blob || new Blob([params.buffer], { type: params.mimeType || 'text/plain' });

      if (window.navigator.msSaveOrOpenBlob) {
        // IE11
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);

        window.setTimeout(() => {
          // Just to make sure no special effects occurs
          document.body.removeChild(a);
        }, 5000);
      }

      return new $.Deferred().resolve();
    }

    function genExportFileName(ext) {
      return `export3d-${new Date().getTime()}.${ext}`;
    }

    function getPreselectedSubjects(data) {
      return _.union(getPreselected(data.nodes), getPreselected(data.links));

      function getPreselected(items) {
        return items ? _.filter(items, (item) => item.isSelected) : [];
      }
    }

    function prepareVisualisation({
      doLoadVendorCode,
      doLoadData,
      doLoadConfig,
      doInitGraph,
      applyConfig,
      state,
      options = {},
    }) {
      const { skipInitialDataLoad } = options;
      const loadData = skipInitialDataLoad ? loadEmptyData() : doLoadData();
      const loadConfig = doLoadConfig().catch((e) => {
        const message = `Config load error: ${e.message || e}`;
        throw new Error(message);
      });
      const visualisationMode = _.get(options, 'visualisationMode', '3d');
      const loadVendorCode = doLoadVendorCode(visualisationMode).catch((e) => {
        const message = `Visualisation module load error: ${e.message || e}`;
        throw new Error(message);
      });

      loadData.catch((e) => {
        const message = `Data load error: ${e.message || e}`;
        throw new Error(message);
      });

      return Promise.all([loadData, loadConfig, loadVendorCode])
        .then(([dataResponse, config]) => {
          const { data } = dataResponse;
          const graphData = _.pick(data, ['nodes', 'links']);
          state.visualisationMode = visualisationMode;
          state.graphData = graphData;
          state.selectedNodes = getPreselectedSubjects(graphData);
          state.legend = data.legend;
          state.tags = data.tags;
          _preloadNodeImages(state, graphData.nodes);
          applyConfig(config, true);
          if (graphData && graphData.nodes) {
            return doInitGraph();
          }
        })
        .then(() => {
          setTimeout(() => _initImageNodesFacingCamera(state), 3000);
        })
        .finally(() => {
          state.isLoading = false;
        })
        .catch((e) => {
          const message = e.message || e;
          state.errorMessage = message;
          AdpNotificationService.notifyError(message);
        });
    }

    function loadEmptyData() {
      const res = { data: { nodes: [], links: [] } };
      return Promise.resolve(res);
    }

    function getDataReloader({ state, forceGraph, doLoadData }) {
      return (loadParams) =>
        doLoadData(loadParams)
          .then(({ data, ignoreResponse }) => {
            if (ignoreResponse) {
              return;
            }
            const newData = _.pick(data, ['nodes', 'links']);
            state.legend = data.legend;
            state.tags = data.tags;
            state.lastLoadParams = loadParams;
            _applyDataDifference({ forceGraph, state, newData });
          })
          .catch((e) => {
            const message = e.message || e;
            state.errorMessage = message;
            AdpNotificationService.notifyError(message, 'Widget data reload');
          });
    }

    function _applyDataDifference({ forceGraph, state, newData }) {
      const prev = {};
      const next = {};

      _.each(['nodes', 'links'], (type) => {
        prev[type] = _objArrToHash(state.graphData[type]);
        next[type] = _objArrToHash(newData[type]);
      });

      let { nodes, links } = state.graphData;
      const changes = _calcDataChanges({ prev, next });
      const addNodes = _.values(_.get(changes, 'nodes.add', {}));
      const addLinks = _.values(_.get(changes, 'links.add', {}));
      const delNodes = _.get(changes, 'nodes.delete', {});
      const delLinks = _.get(changes, 'links.delete', {});

      const has = {
        an: addNodes.length,
        al: addLinks.length,
        dn: !_.isEmpty(delNodes),
        dl: !_.isEmpty(delLinks),
      };

      if (has.dl) {
        _.pull(links, ..._.values(delLinks));
      }

      if (has.dn) {
        _.pull(nodes, ..._.values(delNodes));
        links = _.filter(links, (link) => !delNodes[_nodeId(link.source)] && !delNodes[_nodeId(link.target)]);
      }

      if (has.an) {
        nodes = [...nodes, ...addNodes];
        _preloadNodeImages(state, addNodes);
      }

      if (has.al) {
        const newLinks = [];
        _.each(addLinks, (link) => {
          _.each(['source', 'target'], (tip) => {
            link[tip] = _.find(nodes, (x) => x.id === link[tip]);
          });
          if (link.source && link.target) {
            newLinks.push(link);
          }
        });
        links = [...links, ...newLinks];
      }

      if (has.an || has.al || has.dl || has.dn) {
        state.graphData = { nodes, links };
        forceGraph.graphData(state.graphData);
        _initImageNodesFacingCamera(state, forceGraph);
      }
    }

    function _preloadNodeImages(state, nodes) {
      const asImage = state.visualisationMode === '2d';
      const textureLoader = asImage || new Three.TextureLoader();
      if (!state.imagesCatalog) {
        state.imagesCatalog = {};
      }

      _.each(nodes, (node) => {
        if (node.shp !== 'image') {
          return;
        }
        const imageId = _.get(node, 'image.id');
        if (!imageId || state.imagesCatalog[imageId]) {
          return;
        }
        const linkId = _.get(node, 'image.linkId');
        const src = [APP_CONFIG.apiUrl, 'file', linkId].join('/');
        const promise = loadAsImageOrTexture(src);

        state.imagesCatalog[imageId] = promise
          .then((tex) => {
            state.imagesCatalog[imageId] = tex;
            return tex;
          })
          .catch((e) => {
            console.error('Texture loading error', e.message || e);
          });
      });

      function loadAsImageOrTexture(src) {
        if (asImage) {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.src = src;
          return Promise.resolve(img);
        }

        return new Promise((resolve) => {
          textureLoader.load(src, resolve);
        });
      }
    }

    function _initImageNodesFacingCamera() {
      /*    if (state.visualisationMode === '2d' || state.visualisationMode === '3d') {
        return;
      }
      const cameraEl = document.querySelector('a-entity[camera]');
      state.imageFacingInterval && clearInterval(state.imageFacingInterval);
      const nodes = _.get(state, 'graphData.nodes', []);
      const hasImageNodes = _.find(nodes, (n) => n.shp === 'image');

      if (hasImageNodes) {
        state.imageFacingInterval = setInterval(() => {
          const pos = cameraEl.getAttribute('position');
          _.each(nodes, (n) => {
            if (n.shp === 'image') {
              n.__threeObj.lookAt(pos);
            }
          });
        }, 200);
      } */
    }

    function _isEqualAttrs(obj1, obj2, attrs) {
      return _.isEqual(_.pick(obj1, attrs), _.pick(obj2, attrs));
    }

    function _objArrToHash(arr) {
      return _.fromPairs(_.map(arr, (item) => [_makeObjectUniqueId(item), item]));
    }

    function _makeObjectUniqueId(obj) {
      if (isNode(obj)) {
        return _nodeId(obj);
      }

      const sourceId = _.get(obj, 'source.id') || _.get(obj, 'source') || '_';
      const targetId = _.get(obj, 'target.id') || _.get(obj, 'target') || '_';

      return `${sourceId}${targetId}_${obj.linkNumber || 0}`;
    }

    function _nodeId(obj) {
      return `_${obj && obj.id}`;
    }

    function _calcDataChanges({ prev, next }) {
      const compareAttrs = {
        nodes: ['col', 'd', 'n', 'obj', 'shp', 'size', 'tags', 'image'],
        links: ['arSize', 'col', 'curv', 'd', 'dst', 'fsize', 'n', 'obj', 'pcol', 'pspd', 'pw', 'tags', 'trf', 'w'],
      };
      const changes = {};
      _.each(['nodes', 'links'], (type) => {
        const updates = {};
        _.each(next[type], (item, key) => {
          const prevItem = prev[type][key];
          if (!prevItem) {
            _.set(changes, [type, 'add', key], item);
          } else if (!_isEqualAttrs(prevItem, item, compareAttrs[type])) {
            _.set(updates, key, [prevItem, _.assign({}, prevItem, item)]);
          }

          delete prev[type][key];
        });

        if (!_.isEmpty(prev[type])) {
          _.set(changes, [type, 'delete'], prev[type]);
        }

        _.each(updates, (item, key) => {
          _.set(changes, [type, 'delete', key], item[0]);
          _.set(changes, [type, 'add', key], item[1]);

          if (type === 'nodes') {
            const nodeId = item[0].id;
            const relatedPrevLinks = _.filter(
              _.toPairs(prev.links),
              ([, link]) => link.source.id === nodeId || link.target.id === nodeId
            );
            const relatedNextLinks = _.filter(
              _.toPairs(next.links),
              ([, link]) => link.source === nodeId || link.target === nodeId
            );
            _.each(relatedPrevLinks, ([linkId, link]) => _.set(changes, ['links', 'delete', linkId], link));
            _.each(relatedNextLinks, ([linkId, link]) => _.set(changes, ['links', 'add', linkId], link));
          }
        });
      });

      return changes;
    }

    function exportHtml({ doLoadData, $http, state, templatePath }) {
      const { config } = state;
      return Promise.all([$http.get(`${templatePath}?${Date.now()}`), doLoadData(state.lastLoadParams)])
        .then(([templateResult, { data: graphRawData }]) => {
          const replacementsMap = {
            fg_data: graphRawData,
            fg_config: { ...config, showOptions: false },
            fg_templates: state.templates,
            fg_theme: 'light',
          };
          const templateBody = _.reduce(
            replacementsMap,
            (res, val, key) => {
              const regex = RegExp(`(window[.\\w\\s=]+)['"]__${key}__['"]`);
              const replacement = `$1${JSON.stringify(val)}`;
              return res.replace(regex, replacement);
            },
            templateResult.data
          );

          return downloadFile({
            mimeType: 'text/html',
            fileName: genExportFileName('html'),
            buffer: templateBody,
          });
        })
        .catch((e) => ErrorHelpers.handleError(e, 'Error while loading export template'));
    }

    function handleError(e, description) {
      AdpNotificationService.notifyError((description ? `${description}: ` : '') + (e.message || e));
    }

    function isNode(obj) {
      return obj.__type === 'node';
    }

    function isLink(obj) {
      return obj.__type === 'link';
    }

    function doSaveConfig(config, settingsPath, widgetId) {
      const schema = AdpSchemaService.getSchemaByName('_userSettings');
      const { configRecordId, ...configSettings } = config;
      const formData = {
        _id: configRecordId,
        [settingsPath]: {
          [`w${widgetId}`]: {
            config: configSettings,
          },
        },
      };
      const args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        schema,
        formData,
        action: null,
      });
      const data = AdpFormDataUtils.transformDataBeforeSending(args).row;
      const operation = configRecordId ? 'update' : 'create';
      const updatePath = `${settingsPath}.w${widgetId}.config`;

      return GraphqlCollectionMutator[operation](schema, data, [updatePath])
        .then(() => AdpNotificationService.notifySuccess('Visualization configuration has been saved'))
        .catch((e) => ErrorHelpers.handleError(e, 'Error while saving settings'));
    }

    function isNodeFiltered(node, config) {
      return _isObjectFiltered(node, config, 'node', ['n', 'Acronym']);
    }

    function isLinkFiltered(link, config) {
      return _isObjectFiltered(link, config, 'link', ['n']);
    }

    function _isObjectFiltered(obj, config, type, searchBy) {
      const filterVal = config[`${type}Filter`].toLowerCase();

      if (!filterVal) {
        return false;
      }

      return !!_.find(searchBy, (fieldName) => {
        const value = _.get(obj, fieldName);

        return value && value.toLowerCase().indexOf(filterVal) >= 0;
      });
    }

    function _isFilteredByTags(subj, config) {
      return !!_.intersection(subj.tags, config.tagsFilter).length;
      // return _.findIndex(subj.tags, tag => config.tagsFilter.indexOf(tag) >= 0) >= 0;
    }

    function onNodeDragEnd(node, config) {
      if (config.fixDragged) {
        node.fx = node.x;
        node.fy = node.y;
        node.fz = node.z;
      }
    }

    function linkParticleSize(link, config) {
      return (link.pw || 0) * config.particleSize;
    }

    function linkArrowSize(link, config) {
      return (link.arSize || 0) * config.arrowSize + (link.w || 0);
    }

    function linkColor(link, config, constants) {
      const brightness = (config.hlBrightness || 50) / 100;
      let colorizeColor;
      let color;

      if (link.isSelected || link.isFiltered) {
        colorizeColor = constants.SELECTED_COLOR;
      } else if (link.isLit) {
        colorizeColor = constants.HIGHLIGHT_COLOR;
      }

      if (colorizeColor) {
        color = mixColors(link.col, colorizeColor, config.hlColorize / 100, brightness);
      } else {
        color = link.col || constants.DEFAULT_COLOR;
      }

      return color;
    }

    function linkArrowColor(link, config, constants) {
      const marked = isMarked(link);
      const color = linkColor(link, config, constants);
      const opacity = config.nothingIsMarked || marked ? 1 : (100 - config.hlDim) / 100;

      if (opacity === 1) {
        return color;
      }
      return mixColors('black', color, opacity);
    }

    function linkCurvature(link, config, constants) {
      return ((_.isUndefined(link.curv) ? config.linkCurvature : link.curv) * constants.LINK_MAX_CURVATURE) / 100;
    }

    function linkWidth(link, constants) {
      return link.w || (link.isSelected ? constants.SELECTION_LINK_WIDTH : 0);
    }

    function updateNodesState(data, config) {
      _.each(data.nodes, (node) => {
        node.isFiltered = isNodeFiltered(node, config) || _isFilteredByTags(node, config);
        node.isLit = false;
      });

      _.each(data.links, (link) => {
        link.isFiltered = isLinkFiltered(link, config) || _isFilteredByTags(link, config);

        const toFiltered = link.source.isFiltered || link.target.isFiltered || link.isFiltered;
        const toSelected = link.source.isSelected || link.target.isSelected || link.isSelected;

        if (config.highlightAdjacent && (toFiltered || toSelected)) {
          link.isLit = !link.isFiltered;
          link.source.isLit = !link.source.isFiltered;
          link.target.isLit = !link.target.isFiltered;
        } else {
          link.isLit = false;
        }
      });
    }

    function nodeColor(node, config, constants) {
      const marked = isMarked(node);
      let color;

      if (marked) {
        let colorizeColor;
        if (node.isSelected || node.isFiltered) {
          colorizeColor = constants.SELECTED_COLOR;
        } else if (node.isLit) {
          colorizeColor = constants.HIGHLIGHT_COLOR;
        } else {
          colorizeColor = 'white';
        }

        const brightness = (config.hlBrightness || 50) / 100;

        color = mixColors(node.col, colorizeColor, config.hlColorize / 100, brightness);
      } else {
        color = (node.col || constants.DEFAULT_COLOR).toLowerCase();
      }

      return color;
    }

    function isCommonVendorLoaded() {
      // ToDo: add checking of CSS from common-styles
      return typeof SimpleBar !== 'undefined' && typeof Color !== 'undefined';
    }

    function initScrollBars(scrollbars, elementWithScrollbars, container) {
      let oneMoreTime = false;
      _.each(elementWithScrollbars, (attempts, key) => {
        if (!scrollbars[key]) {
          const elem = $(`.adp-fg-${key}-box`, container)[0];
          if (!elem) {
            if (elementWithScrollbars[key] < 5) {
              oneMoreTime = true;
              elementWithScrollbars[key]++;
            }
          } else {
            scrollbars[key] = new SimpleBar(elem);
          }
        }
      });

      if (oneMoreTime) {
        setTimeout(() => initScrollBars(scrollbars, elementWithScrollbars, container), 1000);
      }
    }

    function doCheckConfigFields(vm, config, configFieldsLimits) {
      _.each(configFieldsLimits, (obj, field) => {
        if (obj.onChange) {
          obj.onChange(config[field], vm);
        }
        if (!_.isUndefined(obj.min) && config[field] < obj.min) {
          config[field] = obj.min;
        }
        if (!_.isUndefined(obj.max) && config[field] > obj.max) {
          config[field] = obj.max;
        }
      });
    }

    function getTagNamesByIds(ids, state) {
      return _.join(
        _.reduce(
          state.tags,
          (stack, item) => {
            if (ids.indexOf(item.id) >= 0) {
              stack.push(item.text);
            }
            return stack;
          },
          []
        ),
        ', '
      );
    }

    function getTagsByFilterValue(value, state) {
      return _.map(
        _.filter(state.tags, (tag) => value.indexOf(tag.id) >= 0),
        (item) => item.text
      );
    }

    function getInitialLayersSelection(state) {
      return state.config.tagsFilter.length ? getTagsByFilterValue(state.config.tagsFilter, state) : [];
    }

    function getTagSelectorOptions(state, onValueChanged, onInitialized) {
      return {
        dataSource: _.map(state.tags, (item) => item.text),
        value: getInitialLayersSelection(state),
        maxDisplayedTags: 1,
        showSelectionControls: true,
        cssClass: 'adp-fg-tags-control',
        onValueChanged(e) {
          state.config.tagsFilter = _.map(e.value, (tag) => _.find(state.tags, ['text', tag]).id);
          onValueChanged && onValueChanged();
        },
        onOpened(e) {
          if (e.component._$list) {
            e.component._$list.addClass('adp-fg-tags-control');
            e.component._$list.closest('.dx-overlay-content').css('overflow', 'visible');

            const overlayWrapper = e.component._$list.closest('.dx-overlay-wrapper');

            if (overlayWrapper.length) {
              overlayWrapper.appendTo(e.element).css({
                left: 0,
                top: 0,
                transform: 'none',
              });
            }
          }
        },
        onInitialized,
      };
    }

    function getGraphClickHandler(vm, doRefreshGraph) {
      return function (obj, e) {
        const { state } = vm;
        const { selectedNodes } = state;
        if (e.shiftKey && obj) {
          if (obj.isSelected) {
            selectedNodes.splice(selectedNodes.indexOf(obj), 1);
          } else {
            selectedNodes.push(obj);
          }
          obj.isSelected = !obj.isSelected;
        } else {
          if (selectedNodes.length) {
            _.each(selectedNodes, (x) => {
              x.isSelected = false;
            });
          }
          if (obj) {
            state.selectedNodes = [obj];
            obj.isSelected = true;
          } else {
            state.selectedNodes = [];
          }
        }

        state.config.showInfo = true;

        doRefreshGraph && doRefreshGraph();

        if (_.isFunction(vm.onSelectionChange)) {
          const selection = _.map(state.selectedNodes, (x) => ({ type: x.__type, clickValues: x._clickValues }));
          vm.onSelectionChange(selection);
        }
      };
    }

    function getKeyPressHandler(vm, keysConf, doRefreshGraph) {
      const { state } = vm;
      const { config } = state;
      return (e) => {
        if (!state.canvasInFocus) {
          return;
        }

        _.each(keysConf, (one, key) => {
          if (e.keyCode === one.keyCode || e.key.toLowerCase() === key) {
            if (one.attr) {
              config[one.attr] = !config[one.attr];
            }

            if (_.isFunction(one.action)) {
              one.action();
            } else if (_.isFunction(vm[one.action])) {
              vm[one.action]();
            }

            e.stopPropagation();

            doRefreshGraph();
          }
        });
      };
    }

    function isMarked(obj) {
      return obj.isLit || obj.isFiltered || obj.isSelected;
    }

    const geometryCreators = {
      Box(size) {
        return new Three.BoxGeometry(size, size, size);
      },
      Tetrahedron(size) {
        return new Three.TetrahedronGeometry(size);
      },
      Torus(size) {
        return new Three.TorusGeometry(size, size * 0.4, 6, 12);
      },
      Octahedron(size) {
        return new Three.OctahedronGeometry(size);
      },
      Cone(size) {
        return new Three.ConeGeometry(size * 0.5, size, 12);
      },
      TorusKnot(size) {
        return new Three.TorusKnotGeometry(size * 0.6, size * 0.2, 48, 6);
      },
      Sphere(size) {
        return new Three.SphereGeometry(size, 16, 12);
      },
      image() {
        return null;
      },
    };

    function _geometryCreator(node, defaultShape) {
      const shape = geometryCreators[node.shp] ? node.shp : defaultShape;

      if (!geometryCache[shape]) {
        const geometryFn = geometryCreators[shape];

        if (!geometryFn) {
          return null;
        }

        geometryCache[shape] = geometryFn(1);
      }

      return geometryCache[shape];
    }

    function getLambertMaterial(color, opacity) {
      const cacheKey = `${color}_${opacity}`;
      if (!materialCache[cacheKey]) {
        materialCache[cacheKey] = new Three.MeshLambertMaterial({
          color: Color(color).hex(),
          transparent: opacity < 1,
          opacity,
        });
      }
      return materialCache[cacheKey];
    }

    function node3dGeometry(node, state, constants, memoizedLabel) {
      const { config } = state;
      const marked = isMarked(node);
      const scale = node.size || constants.DEFAULT_NODE_SIZE;
      const color = nodeColor(node, config, constants);
      const opacity =
        marked || state.nothingIsMarked
          ? constants.NODE_COMMON_OPACITY
          : constants.NODE_COMMON_OPACITY * (1 - config.hlDim / 100);
      let mesh;
      if (node.shp === 'image') {
        if (state.visualisationMode === '3d') {
          mesh = new Three.Sprite();
          mesh.material = new Three.SpriteMaterial();
        } else {
          mesh = new Three.Mesh(new Three.BoxGeometry(1, 1), new Three.MeshBasicMaterial());
        }
        const imageId = _.get(node, 'image.id');
        const texture = _.get(state, ['imagesCatalog', imageId]);

        if (texture.then) {
          texture.then((t) => setTexture(mesh, t)).catch(_.noop);
        } else {
          setTexture(mesh, texture);
        }
      } else {
        const geometry = _geometryCreator(node, state, constants.DEFAULT_NODE_SHAPE);
        if (!geometry) {
          return null;
        }

        const material = getLambertMaterial(color, opacity);
        geometry.renderOrder = 10;
        mesh = new Three.Mesh(geometry, material);
        mesh.scale.setScalar(scale);
      }

      mesh.renderOrder = 10;
      node.isGlow = marked;

      // Adding text sprite with label in few cases
      const showNodeLabel = config.labelNodes || (config.hlLabelNodes && marked);
      if (showNodeLabel && !_.isUndefined(window.SpriteText)) {
        const group = new Three.Group();
        const size = node.size || constants.DEFAULT_NODE_SIZE;
        const labelText = memoizedLabel(node, state);
        const labelLines = labelText.split('\n');
        const linesCount = labelLines.length;
        const sprite = new SpriteText(labelLines.join('\n'));

        sprite.color = mixColors(color, 'gray', 0.75);
        sprite.textHeight = size;
        sprite.strokeWidth = 0.5;
        sprite.strokeColor = '#050505';
        // sprite.position.x = size;
        sprite.position.y = size * (1 + linesCount / 2);
        sprite.material.opacity = opacity;
        sprite.material.depthWrite = false;
        sprite.renderOrder = 10;

        group.add(mesh);
        group.add(sprite);

        return group;
      }

      return mesh;

      function setTexture(m, tex) {
        m.material.map = tex;
        m.material.needsUpdate = true;
        const { width, height } = tex.image;
        if (width > height) {
          m.scale.set(scale, (scale * height) / width, 1);
        } else {
          m.scale.set((scale * width) / height, scale, 1);
        }
      }
    }

    function getObjectTemplateRenderer(templatePrefix, defaultGetter) {
      return (obj, state) => {
        const type = _.get(obj, '__type', 'node');
        const upcasedPrefix = templatePrefix.substring(0, 1).toUpperCase() + templatePrefix.substring(1);
        const template = _.get(state, `templates.${type}${upcasedPrefix}`);
        if (!template) {
          return defaultGetter(obj, state);
        }
        const mapped = _.get(obj, '_mapped', {});
        const context = { ...obj, mapped };

        return renderTemplate(context, template, `${_.startCase(type)} ${templatePrefix}`);
      };
    }

    function renderTemplate(context, template, label = 'Node') {
      const ejsContext = { ...context, _, dayjs };
      let result;

      try {
        result = ejs.render(template, ejsContext);
      } catch (e) {
        result = `${label} ejs error: ${e}. ${template}`;
      }

      return result;
    }

    function getDefaultObjectInfo(obj, state) {
      const tagNames = getTagNamesByIds(obj.tags, state);
      const tagsText = !_.isEmpty(obj.tags) ? `<p class="adp-fg-info-name-p"><b>Tags:</b> ${tagNames}</p>` : ``;
      const descText = !_.isEmpty(obj.d)
        ? `<p class="adp-fg-info-name-p"><b>Description: </b><span>${obj.d}</span></p>`
        : '';
      return [
        `<p class="adp-fg-info-name-p"><b>Name: </b>${obj.n}</p>`,
        tagsText,
        descText,
        `<p class="adp-fg-info-name-p"><b>Created at: </b>${obj.adpCreatedAt}</p>`,
        `<p class="adp-fg-info-name-p"><b>Updated at: </b>${obj.adpUpdatedAt}</p>`,
      ].join('');
    }

    return {
      linkSpeed,
      fitGraphSize,
      linkParticleColor,
      mixColors,
      setColorAlpha,
      prepareGraphData,
      downloadFile,
      genExportFileName,
      isLink,
      isNode,
      handleError,
      doSaveConfig,
      isNodeFiltered,
      isLinkFiltered,
      onNodeDragEnd,
      linkParticleSize,
      linkArrowSize,
      linkColor,
      linkArrowColor,
      linkCurvature,
      linkWidth,
      updateNodesState,
      isCommonVendorLoaded,
      nodeColor,
      initScrollBars,
      getTagNamesByIds,
      getTagsByFilterValue,
      getTagSelectorOptions,
      doCheckConfigFields,
      getGraphClickHandler,
      getKeyPressHandler,
      isMarked,
      prepareVisualisation,
      getDataReloader,
      exportHtml,
      getLambertMaterial,
      node3dGeometry,
      getDefaultObjectInfo,
      getObjectTemplateRenderer,
    };
  }
})();
;;(function () {
  angular.module('app.adpFormActions')
    .factory('AdpApplyDataset', AdpApplyDataset);

  function AdpApplyDataset(
    GraphqlCollectionQuery,
    ResponseError,
    ACTIONS,
    ObjectId,
    $timeout,
    AdpNotificationService
  ) {
    return (args, datasetData, triggerEvent) => {
      const { _id } = datasetData;
      return fetchDatasetById(args, _id)
        .then((datasetData) => {
          updateActionAndId(args, datasetData);
          updateFields(args, datasetData);

          // timeout required to create scheme.indexes as indexes data depends on scheme.fields
          return $timeout(() => {
            updateIndexes(args, datasetData);
            triggerEvent('afterCopyPasteAction');
            AdpNotificationService.notifySuccess('Form data updated from server');
          });
        });
    };

    function fetchDatasetById({ modelSchema }, _id) {
      return GraphqlCollectionQuery(modelSchema, { filter: ['_id', '=', _id] })
        .then((data) => {
          if (_.isNull(data)) {
            throw new ResponseError(ResponseError.RECORD_NOT_FOUND);
          }
          return data.items[0];
        })
    }

    function updateActionAndId(args, responseData) {
      const shouldChangeActionToUpdate = _.includes([ACTIONS.CREATE, ACTIONS.CLONE, ACTIONS.CLONE_DATASET], args.action);
      if (shouldChangeActionToUpdate) {
        args.row._id = responseData._id;
        args.action = ACTIONS.UPDATE;
      }
    }

    function updateFields(args, responseData) {
      const fieldsPath = 'scheme.fields';
      const fields = _.get(args.row, fieldsPath) || []
      fields.splice(0);
      _.set(args.row, fieldsPath, fields);


      _.each(_.get(responseData, fieldsPath), (field, $key) => {
        args.row.scheme.fields.push({ ...field, $key, _id: ObjectId() });
      });
    }

    function updateIndexes(args, responseData) {
      const indexesPath = 'scheme.indexes';
      const indexes = _.get(args.row, indexesPath) || []
      _.set(args.row, indexesPath, indexes);

      indexes.splice(0);

      _.each(_.get(responseData, indexesPath), (ind) => {
        indexes.push({ ...ind, _id: ObjectId() });
      });
    }
  }
})();
;;(function () {
  angular.module('app.adpFormActions')
    .factory('AdpFormActionHelpers', AdpFormActionHelpers);

  function AdpFormActionHelpers(
    AdpModalService,
    AdpNotificationService,
    AdpUnifiedArgs,
    AdpFormIteratorUtils
  ) {
    return {
      updateRecord(args, record) {
        const { _id, _actions, adpCreator, adpCreatedAt, adpDeletedAt, adpUpdatedAt, ...restRecord } = record;
        const compatibleWithSchemaRecordPart = getRecordPartThatMatchesSchema(args, restRecord);
        assignDataToRowInPlace(args, compatibleWithSchemaRecordPart);
      }
    }

    function getRecordPartThatMatchesSchema({ action, modelSchema }, formData) {
      const result = {};
      const mergeArgs = AdpUnifiedArgs.getHelperParams({
        action,
        formData,
        schema: modelSchema,
        path: '',
      });

      AdpFormIteratorUtils.traverseFormDataPostOrder(mergeArgs, ({ data, path }) => {
        !_.isNil(data) && _.set(result, path, data);
      });

      return result;
    }

    function assignDataToRowInPlace(args, source) {
      const target = args.row;
      const systemField = [
        '_id', '_actions', 'adpCreator', 'adpCreatedAt', 'adpUpdatedAt', 'adpDeletedAt', 'adpAcl'
      ];
      const isSystemField = (value) => _.includes(systemField, value);
      const isUpdate = args.row === 'update';
      _.forEach(target, (v, k) => {
        if (isUpdate && isSystemField(v)) {
          _.unset(target, k);
        }
      });

      _.forEach(source, (v, k) => {
        target[k] = source[k];
      });
    }
  }
})();
;;(function () {
  angular.module('app.adpFormActions')
    .factory('AdpGuessSchema', AdpGuessSchema);

  function AdpGuessSchema(
    AdpNotificationService,
    ErrorHelpers,
    ResponseError,
    $http,
    APP_CONFIG,
    ClientError,
    ObjectId,
    AdpFormService,
    AdpUnifiedArgs,
    $timeout
  ) {
    return async (args, triggerEvent) => {
      const datasetId = _.get(args, 'row._id');
      if (!datasetId) {
        throw new ClientError('Wrong Dataset ID');
      }
      const { apiUrl } = APP_CONFIG;
      const { data: { success, data: { fields } } }  = await $http.get(`${apiUrl}/guessDatasetSchema/${datasetId}`);

      if (!success) {
        throw new ResponseError('Unable to update form data');
      }

      return Promise.resolve()
        .then(() => {
          updateFormData(args, fields);
          triggerEvent('afterCopyPasteAction');
        });

      // return $timeout(() => {
      //   addIndexes(args, fields);
      //   triggerEvent('afterCopyPasteAction');
      //   AdpNotificationService.notifySuccess('Form data updated from server');
      // });
    }

    function updateFormData(args, fields) {
      const fieldsFormSchema = _.get(args, 'row.scheme.fields');
      const diff = getFieldsDiff(fields, fieldsFormSchema);

      const dataToSet = _.map(diff, (field, key) => {
        return { ..._.cloneDeep(field), $key: key, _id: ObjectId() };
      });

      fieldsFormSchema.push(...dataToSet);
    }

    function getFieldsDiff(fields, fieldsFormSchema) {
      const fieldNamesFromForm = _.map(fieldsFormSchema, ({ $key }) => $key);

      return _.chain(fields)
        .toPairs()
        .filter(([key]) => !_.includes(fieldNamesFromForm, key))
        .fromPairs()
        .value();
    }

    function getDefaultsForField(path, { modelSchema, row, action }) {
      const args = AdpUnifiedArgs.getHelperParams({
        path,
        formData: row,
        action,
        schema: modelSchema,
      });

      return AdpFormService.getDefaultsForFields(args);
    }

    function addIndexes(args, fields) {
      const uniqKeys = getFieldNamesNotInIndexes(args, fields);

      const indexesDefaults = getDefaultsForField('scheme.indexes', args);
      const resultIndexes = [];

      const fieldNamesWithoutIds = _.filter(uniqKeys, f => f.toLowerCase() !== 'id');
      _.forEach(fieldNamesWithoutIds, fieldName => {
        resultIndexes.push({
          ...indexesDefaults,
          keys: [{ _key: fieldName, _value: '1', _id: ObjectId() }],
          _id: ObjectId() });
      });

      const idFieldNames = _.filter(uniqKeys, f => f.toLowerCase() === 'id');
      _.forEach(idFieldNames, fieldName => {
        resultIndexes.push({
          options: { unique: true, },
          _id: ObjectId(),
          keys: [{ _key: fieldName, _value: '1', _id: ObjectId() }],
        });
      });

      const formIndexes = _.get(args, 'row.scheme.indexes');
      formIndexes.push(...resultIndexes);
    }

    function getFieldNamesNotInIndexes(args, fields) {
      const uniqueSchemaKeys = _.chain(args)
        .get('row.scheme.indexes')
        .map(({ keys = [] }) => keys.map(({ _key }) => _key))
        .flatten()
        .uniq()
        .value();

      const fieldsWithoutMetaOrId = _.omitBy(fields, ({ type }, fieldName) => {
        return type === 'Mixed' || fieldName === '_id';
      });
      const fieldNames = _.keys(fieldsWithoutMetaOrId);

      return _.filter(fieldNames, fieldName => !_.includes(uniqueSchemaKeys, fieldName));
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeHelper', AdpGlobeHelper);

  /** @ngInject */
  function AdpGlobeHelper(
    AdpWidgetsService
  ) {
    function loadData(_options = {}) {
      return AdpWidgetsService.fetchWidgetData(args, _options).then(({ data, messages }) => {
        const errorMessage = messages ? messages.join('</br>') : '';
        return { data, errorMessage };
      });
    }

    return {
      loadData,
    };
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeLogic', AdpGlobeLogic);

  /** @ngInject */
  function AdpGlobeLogic(AdpGlobeService) {
    return function ({ globe, args }) {
      return AdpGlobeService.createLayers({ globe, args }).then((layers) => {
        AdpGlobeService.handleGlobeSurface({layers, globe, args});

        const destroyCb = () => _.each(layers, (l) => _.isFunction(l.onDestroy) && l.onDestroy());

        return {
          destroyCb,
          updateLayerData,
          updateLayerParameters,
        };

        function updateLayerData({ dataLayerId, data }) {
          const layer = _.find(layers, (layer) => layer._id === dataLayerId);

          if (!layer) {
            return;
          }

          return AdpGlobeService.updateLayerData({ layer, data, globe, args });
        }

        function updateLayerParameters({ dataLayerId, selectionFilters }) {
          const layer = _.find(layers, (layer) => layer._id === dataLayerId);

          if (!layer) {
            return;
          }

          return AdpGlobeService.updateLayerData({ layer, selection: selectionFilters, globe, args });
        }
      });
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeService', AdpGlobeService);

  /** @ngInject */
  function AdpGlobeService(
    AdpGlobeTextureLayer,
    AdpGlobeCirclesLayer,
    AdpGlobeChoroplethLayer,
    AdpGlobeSatellitesLayer,
    AdpWidgetsService,
  ) {
    const layerModules = {
      texture: AdpGlobeTextureLayer,
      circles: AdpGlobeCirclesLayer,
      choropleth: AdpGlobeChoroplethLayer,
      satellites: AdpGlobeSatellitesLayer,
    };

    function createLayers({globe, args}) {
      const { row } = args;
      const layers = _.get(row, 'globe.layers', []);
      const activeLayers = _.filter(layers, (layer) => !layer.disabled);

      return Promise.all(_.map(activeLayers, async (layerRow, index) => {
        const { _id, type, name, wsUpdate, show, ...rowData } = layerRow;
        const { dataset, /*layerControlLinks,*/ ...typedRowData } = rowData[type];
        const row = _.clone(typedRowData);
        const datasetId = _.get(dataset, '_id');
        const layer = {
          _id,
          type,
          row,
          index,
          name,
          datasetId,
          show,
          opacity: 100,
          wsUpdate,
          cache: {},
        };

        const createFn = _getLayerMethod(type, 'create');
        if (createFn) {
          const createResult = createFn({ layer, globe, args });
          if (createResult?.then) {
            return createResult.then(()=>layer);
          }
        }

        return Promise.resolve(layer);
      }));
    }

    function updateLayerData({ layer, data, globe, args }) {
      const { type } = layer;
      const updateFn = _getLayerMethod(type, 'update');
      return updateFn && updateFn({ layer, data, globe, args });
    }

    function updateLayerParameters({ layer, selection, globe, args }) {
      const { type } = layer;
      const updateFn = _getLayerMethod(type, 'updateParameters');
      return updateFn && updateFn({ layer, selection, globe, args });
    }

    function layerOpacity({ layer, opacity, globe, args }) {
      const { type } = layer;
      const setOpacityFn = _getLayerMethod(type, 'setOpacity');
      return setOpacityFn && setOpacityFn({ layer, opacity, globe, args });
    }

    function _getLayerMethod(type, methodName) {
      const layerModule = layerModules[type];
      return layerModule && layerModule[methodName];
    }

    function handleGlobeSurface({layers, globe, args}) {
      const textureLayer = _.find(layers, (layer) => layer.type === 'texture');
      const isFromDataset = _.get(textureLayer, 'row.texture') === 'customFromDataset';

      if (textureLayer) {
        !isFromDataset && updateLayerData({ layer: textureLayer, globe, args });
      } else {
        globe.showGlobe(false);
      }

      globe.showAtmosphere(false);
      // globe.showGraticules(true);
      // globe.showGlobe(false);
    }

    function setSatSelection(selectionIds, widgetId, satLayer, editInterface) {
      const layerId = satLayer._id;
      const setLinkValue = _.get(editInterface, 'controlLinks.setLinkValue');
      if (!setLinkValue) {
        // if no link option we have to set satellite selection directly.
        // overwise selection will be set via linkChange, since we generate event with 'handleBySameWidget=true'
        satLayer.adpSatEngine.adjustParameters({ selectionIds });
        return;
      }
      const linkId = `${widgetId}_${layerId}_selectionIds`;
      const filterValue = _.isEmpty(selectionIds) ? ['empty'] : ['any', ...selectionIds];
      const eventData = {
        linkId,
        value: filterValue,
        sourceWidgetId: widgetId,
        sourceControlId: layerId,
        handleBySameWidget: true,
      };
      setLinkValue(eventData);

      const sliders = _.get(satLayer, 'row.sliders', []);
      _.each(sliders, (slider) => {
        const ids = _.get(slider, 'linkIds', []);
        if (AdpWidgetsService) {
          // in the case of pre-compiling of the code for AR iframe usage widget services are not assessable
          AdpWidgetsService.sendControlledLinksChangeEvents(filterValue, ids, widgetId, editInterface);
        }
      });
    }

    return {
      createLayers,
      updateLayerData,
      updateLayerParameters,
      layerOpacity,
      handleGlobeSurface,
      setSatSelection,
    };
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpGridPrint').factory('PrintTableBuilder', PrintTableBuilder);

  /** @ngInject */
  function PrintTableBuilder(HtmlCellRenderer, AdpUnifiedArgs) {
    return {
      build: build,
    };

    function build(schema, records) {
      var tableStyles = 'width: 100%; font-family: Helvetica, Arial, sans-serif;';
      return [
        buildTitle(schema.fullName),
        '<table border="1" cellspacing="0" cellpadding="3" style="' + tableStyles + '">',
        buildHeads(schema.fields),
        buildBody(schema, records),
        '</table>',
      ].join('');
    }

    function buildTitle(title) {
      return '<h1 style="font-size: 24px; margin: 10px 0;">' + title + '</h1>';
    }

    function buildHeads(fields) {
      var heads = '';
      forEachField(fields, function (field) {
        heads += '<td>' + field.fullName + '</td>';
      });

      return '<thead><tr>' + heads + '</tr></thead>';
    }

    function buildBody(schema, records) {
      var body = '';
      records.forEach(function (record) {
        var row = '<tr>';

        forEachField(schema.fields, function (field) {
          var args = getArgs(field, schema, record);
          row += '<td>' + HtmlCellRenderer(args) + '</td>';
        });

        body += row + '</tr>';
      });

      return body;
    }

    function forEachField(fields, cb) {
      _.keys(fields).forEach(function (key) {
        var field = fields[key];
        if (!_.get(field, 'showInDatatable')) {
          return;
        }

        cb(field);
      });
    }

    function getArgs(field, schema, recordData) {
      var args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: field.fieldName,
        formData: recordData,
        schema: schema,
        action: 'print',
      });

      args.params = { asText: true };

      return args;
    }
  }
})();
;(function() {
  "use strict";

  angular.module("app.adpGridPrint")
    .factory("AdpPrintHelper", AdpPrintHelper);

  /** @ngInject */
  function AdpPrintHelper(AdpBrowserService) {
    return {
      print
    };

    function print({ html, title }) {
      return new Promise(function(resolve) {
        const iframe = createIframe(title);
        window.document.body.appendChild(iframe);

        iframe.onload = function() {
          const iframeWindow = getIframeWindow(iframe);
          $(iframeWindow.document.body)
            .html(html);

          registerAfterPrintEvent(iframe);
          printIframeContent(iframe);

          resolve();
        };
      });
    }

    function createIframe(title) {
      const iframe = document.createElement("iframe");
      iframe.srcdoc = "<html><head><title>" + title + "</title>";

      const styleToHideIframe = "visibility: hidden; height: 0; width: 0; position: absolute;";
      iframe.setAttribute("style", styleToHideIframe);
      iframe.setAttribute("name", iframeName());
      iframe.setAttribute("id", iframeName());

      return iframe;
    }

    function getIframeWindow(iframe) {
      return iframe.contentWindow || iframe.contentDocument;
    }

    function iframeName() {
      return "print-iframe";
    }

    function printIframeContent(iframe) {
      iframe.focus();

      // If Edge or IE, try catch with execCommand
      if (AdpBrowserService.isEdge() || AdpBrowserService.isIE()) {
        try {
          iframe.contentWindow.document.execCommand("print", false, null);
        } catch (e) {
          iframe.contentWindow.print();
        }
      } else {
        iframe.contentWindow.print();
      }
    }

    function registerAfterPrintEvent(iframe) {
      let event = "mouseover";
      if (AdpBrowserService.isChrome() || AdpBrowserService.isFirefox()) {
        event = "focus";
      }

      const handler = function() {
        iframe.onload = null;
        iframe.remove();
        window.removeEventListener(event, handler);
      };

      window.addEventListener(event, handler);
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGridViewManager').component('adpGridViewManager', {
    template:
      '<form name="form"' +
      '      class="smart-form client-form grid-view-manager">' +
      '    <header class="smart-form-header">' +
      '        <h2 class="semi-bold">Grid View manager</h2>' +
      '    </header>' +
      '' +
      '    <fieldset>' +
      '        <div class="col col-12">' +
      '            <div class="gvm-items-list">' +
      '                <div ng-repeat="item in vm.savedList" class="gvm-list-item" data-item-id="{{item._id}}">' +
      "                    <div class='gvm-text'>{{ item.name }}</div>" +
      '                    <div class=\'gvm-delete\' ng-click="vm.delete($event)">' +
      '                        <i class="dx-icon dx-icon-trash"></i>' +
      '                    </div>' +
      '                </div>' +
      '            </div>' +
      '            <i ng-if="!vm.savedList || !vm.savedList.length">No saved states for this grid.</i>' +
      '        </div>' +
      '    </fieldset>' +
      '    <footer class="adp-action-b-container" adp-handle-hot-keys="form">' +
      '        <button class="adp-action-b-secondary"' +
      '                type="button"' +
      '                adp-hot-key="Escape"' +
      '                ng-click="vm.exit()">' +
      '            Close' +
      '        </button>' +
      '        <button class="adp-action-b-primary"' +
      '                type="button"' +
      '                adp-hot-key="Enter"' +
      '                ng-click="vm.save()">' +
      '            Save Current Grid View' +
      '        </button>' +
      '    </footer>' +
      '</form>',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpGridViewManagerController',
    controllerAs: 'vm',
  });
})();
;(function () {
  'use strict';

  angular.module('app.adpGridViewManager').controller('AdpGridViewManagerController', AdpGridViewManagerController);

  /** @ngInject */
  function AdpGridViewManagerController(
    AdpNotificationService,
    AdpModalService,
    AdpSchemaService,
    AdpGridViewManagerService,
    GraphqlCollectionMutator,
    ErrorHelpers
  ) {
    var vm = this;

    vm.storeSchema = AdpSchemaService.getSchemaByName('dxGridViews');

    vm.$onInit = doInit;
    vm.delete = doDeleteState;
    vm.save = doSaveState;
    vm.exit = function () {
      vm.close({ $value: { newList: vm.savedList } });
    };

    function doInit() {
      vm.options = vm.resolve.options;
      vm.savedList = vm.options.list;
    }

    function doSaveState() {
      AdpGridViewManagerService.saveView(vm.options.grid, vm.options.customGridOptions, vm.savedList, vm.options.schema)
        .then(function () {
          AdpNotificationService.notifySuccess('Grid view is saved');
          return AdpGridViewManagerService.loadViews(vm.options.schema);
        })
        .then(function (list) {
          vm.savedList = list;
        });
    }

    function doDeleteState($event) {
      var id = getClickedRecordId($event);

      if (id) {
        var record = getSavedItemById(id);

        deleteStateRecord(id, record.name).then(function () {
          AdpNotificationService.notifySuccess("Item '" + record.name + "' is removed successfully");
          removeFromSavedById(id);
        });
      }
    }

    function deleteStateRecord(id, name) {
      return AdpModalService.confirm({
        message: "Are you sure you want to delete '" + name + "' stored state?",
        sizeSmall: true,
      }).then(function () {
        return GraphqlCollectionMutator.delete(vm.storeSchema, { _id: id }).catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error while deleting saved state');
          throw error;
        });
      });
    }

    function getClickedRecordId(event) {
      return $(event.currentTarget).closest('.gvm-list-item').data('itemId');
    }

    function getSavedItemById(id) {
      return _.find(vm.savedList, function (item) {
        return item._id === id;
      });
    }

    function removeFromSavedById(id) {
      return (vm.savedList = _.filter(vm.savedList, function (item) {
        return item._id !== id;
      }));
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGridViewManager')
    .factory('AdpGridViewManagerService', AdpGridViewManagerService);

  /** @ngInject */
  function AdpGridViewManagerService(
    AdpClientCommonHelper,
    GridOptionsHelpers,
    AdpNotificationService,
    AdpModalService,
    AdpSchemaService,
    GridColumns,
    filterUrlMapper,
    GraphqlCollectionQuery,
    GraphqlCollectionMutator,
    ErrorHelpers
  ) {
    const storeSchema = AdpSchemaService.getSchemaByName('dxGridViews');

    return {
      loadViews,
      saveView,
      createMenuOptions
    };

    function createMenuOptions(schema, gridComponent, customGridOptions, actionOptions) {
      const menuActions = {
        doReset,
        doSave,
        doRestore,
        doOpenManager
      };
      let menuComponent = null;
      let cachedList = null;

      return {
        dataSource: getMenuDataSource(),
        displayExpr: 'name',
        cssClass: 'adp-toolbar-menu grid-view-menu',
        onInitialized,
        onItemClick
      };

      function onInitialized(e) {
        menuComponent = e.component;
        cachedList = null;
      }

      function doSave() {
        saveView(gridComponent, customGridOptions, cachedList, schema)
          .then(function () {
            AdpNotificationService.notifySuccess('Grid view is saved');
            return doLoadList();
          });
      }

      function doRestore(itemData) {
        const id = itemData._id;

        if (id) {
          const record = getSavedItemById(cachedList, id);

          setStateToGrid(gridComponent, record.state);
          AdpNotificationService.notifySuccess('Grid view is restored');
          customGridOptions.value(record.state._customOptions || {});

          filterUrlMapper(gridComponent, schema);
        }
      }

      function doReset() {
        return AdpModalService.confirm({
          message: 'Are you sure that you want to reset grid to default view?',
          sizeSmall: true
        })
          .then(function () {
            const options = _.cloneDeep(schema.parameters);

            GridColumns(options, schema, customGridOptions);
            gridComponent.state({ columns: options.columns });
            customGridOptions.value('quickFilterId', '');
            customGridOptions.value('filterBuilder', null);

            AdpNotificationService.notifySuccess('Grid view has been reset');
            filterUrlMapper(gridComponent, schema);
          });
      }

      function doOpenManager() {
        AdpModalService.createModal('adpGridViewManager', {
          list: cachedList,
          grid: gridComponent,
          customGridOptions,
          schema
        })
          .result
          .then(function (res) {
            cachedList = res.newList;
            updateMenu(cachedList);
          });
      }

      function doLoadList() {
        return loadViews(schema)
          .then((list) => {
            cachedList = list;
            updateMenu(list);
          });
      }

      function updateMenu(list) {
        menuComponent.option('dataSource', getMenuDataSource(list));
      }

      function getMenuDataSource(list) {
        const savedItems = !list ? [] : listToItems(list);

        return [
          {
            template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions),
            items: [...getFunctionalItems(), ...savedItems]
          }
        ];
      }

      function onItemClick(e) {
        const action = e.itemData.action;

        if (action && menuActions[action]) {
          menuActions[action](e.itemData);
        } else {
          if (!cachedList) {
            doLoadList()
              .then(function () {
                setTimeout(() => $(e.element)
                  .find('.dx-menu-item')
                  .eq(0)
                  .trigger('dxclick'), 200);
              });
          }
        }

        return true;
      }

      function getFunctionalItems() {
        return [
          {
            name: 'Reset View ...',
            icon: 'undo',
            action: 'doReset'
          },
          {
            name: 'Save Current Grid View ...',
            icon: 'save',
            action: 'doSave'
          },
          {
            name: 'Manage Grid Views ...',
            icon: 'detailslayout',
            disabled: !cachedList || !cachedList.length,
            action: 'doOpenManager'
          },
          {
            template: () => $('<span class=\'menu-separator\'>'),
            disabled: true
          }
        ]
      }

      function listToItems(list) {
        return _.map(list, item => ({
          ...item,
          action: 'doRestore'
        }));
      }
    }

    function loadViews(schema) {
      const params = {
        filter: [['model', '=', schema.schemaName]],
        skip: 0,
        take: 1000
      };

      return GraphqlCollectionQuery(storeSchema, params)
        .then(result => result.items)
        .catch((error) => {
          ErrorHelpers.handleError(error, 'Unknown error while loading list of grid views');
          throw error;
        });
    }

    function saveView(grid, customGridOptions, cachedList, schema) {
      const state = getStateFromGrid(grid);

      state._customOptions = customGridOptions.value();

      return AdpModalService.prompt({
        title: 'Save Grid View as:',
        sizeSmall: true,
        validate: function (value) {
          if (_.find(cachedList, item => item.name === value)) {
            return 'This name is already in use';
          }
          if (!value) {
            return 'Please enter record name';
          }
        }
      })
        .then(name => createRecord(state, name, schema));
    }

    function createRecord(gridState, name, schema) {
      const record = { model: schema.schemaName, state: gridState, name: name };

      return GraphqlCollectionMutator.create(storeSchema, record)
        .catch((error) => {
          ErrorHelpers.handleError(error, 'Unknown error while saving grid view');
          throw error;
        });
    }

    function getStateFromGrid(grid) {
      const state = grid.state();
      delete state.searchText;
      return state;
    }

    function setStateToGrid(grid, data) {
      return grid.state(data);
    }

    function getSavedItemById(list, id) {
      return _.find(list, item => item._id === id);
    }
  }
})();
;(function () {
  angular.module('app.adpGridstack').factory('AdpGsActions', AdpGsActions);

  /** @ngInject */
  function AdpGsActions(
    $timeout,
    AdpNotificationService,
    AdpGsService,
    AdpUnifiedArgs,
    ServerError,
    ErrorHelpers,
    AdpFormService,
    AdpWidgetsService,
    ActionMessages,
    ACTIONS,
    AdpModalService
  ) {
    const BTN_TXT_SAVED = 'The dashboard configuration has been saved!';

    return {
      exportDashboard,
      addNewWidget,
      linksReport,
      saveDashboard,
      editDashboard,
      submitTile,
      applyTile,
      cancelSubmitTile,
    };

    function exportDashboard() {
      let name = _.get(this, 'row.name');
      name = name ? `_${name.replaceAll(/[^\w]+/g, '')}` : ``;
      AdpWidgetsService.exportElementAsPng({
        selector: '#adp-dashboard-board',
        filePrefix: `dashboardExport${name}`,
      });
    }

    // Handles only PRESS on [add widget] button. DnD is handled by onDrop in controller
    function addNewWidget() {
      const { dashboardContext } = this;
      const defaultWidgetWidth = _.get(this, 'modelSchema.fields.tiles.fields.w.default', 1);
      const defaultWidgetHeight = _.get(this, 'modelSchema.fields.tiles.fields.h.default', 1);

      const position = { x: 0, y: 0, w: defaultWidgetWidth, h: defaultWidgetHeight };
      const grid = dashboardContext.boardLayers.getGrid();
      const newTileElement = grid.addWidget(
        '<div class="grid-stack-item"><div class="grid-stack-item-content"></div></div>',
        position
      );
      return AdpGsService.createEmptyGridTile(dashboardContext, newTileElement.gridstackNode).then(() =>
        dashboardContext.editInterface.onBoardChange()
      );
    }

    function editDashboard() {
      const { dashboardContext } = this;
      const { board, boardLayers } = dashboardContext;
      const dashboardId = board.data._id;
      const reloadSnap = _reloadDashboardSnapshot(board);
      const redrawSnap = _redrawAllWidgetsSnapshot(board);

      return AdpGsService.openDashboardFormDialog(dashboardId)
        .then((data) => {
          if (!data) {
            throw new Error('cancel');
          }

          board.data = data.args.row;

          const reloadDashboard = reloadSnap !== _reloadDashboardSnapshot(board);
          if (reloadDashboard) {
            _reloadDashboard(dashboardContext);
            return;
          }

          const redrawAllWidgets = redrawSnap !== _redrawAllWidgetsSnapshot(board);

          if (redrawAllWidgets) {
            _resetAllTiles(dashboardContext);
          }
          dashboardContext.boardLayers.setGridAutopack(board.data.autoPackWidgets);

          return AdpGsService.getDashboardStyle(dashboardContext.board);
        })
        .then((css) => {
          dashboardContext.containerCss = css.containerCss;
          dashboardContext.boardCss = css.boardCss;
          dashboardContext.bgCss = css.bgCss;
          dashboardContext.stretchBg = _.get(
            dashboardContext,
            'board.data.styling.dimensions.stretchBackgroundBeyondDashboard'
          );
          dashboardContext.boardClass = {
            'adp-gs-fits-height': _.get(board, 'data.rowHeightStrategy', 'square') !== 'square',
          };
          boardLayers.onWindowResize();
        })
        .catch((err) => {
          const msg = err.message || err;
          if (msg !== 'cancel') {
            ErrorHelpers.handleError(err, 'Dashboard form');
          }
        });
    }

    function linksReport() {
      const { editInterface } = this.dashboardContext;
      const { nodes, links } = editInterface.controlLinks.getLinksReport();
      return AdpModalService.createModal('adpGsDashboardMap', { nodes, links, windowClass: 'adp-big-screen-modal' })
        .result;
    }

    function saveDashboard() {
      const { dashboardContext, modelSchema, silent, widgetsToRefreshAfter } = this;
      const grid = dashboardContext.boardLayers.getGrid();
      // We prevent saving in singleColumn mode because it will ruin tiles layout (x,y,w,h of fields)
      if (grid.engine.column < 2) {
        return;
      }
      return AdpGsService.saveDashboard({
        schema: modelSchema,
        board: dashboardContext.board,
        widgetsToRefreshAfter,
      })
        .then(() => {
          if (silent) {
            $timeout(() => {
              dashboardContext.savingMessage = '';
            }, 1400);
            dashboardContext.savingMessage = BTN_TXT_SAVED;
          } else {
            AdpNotificationService.notifySuccess(BTN_TXT_SAVED);
          }
        })
        .catch((e) => ErrorHelpers.handleError(e, 'Dashboard save error'));
    }

    function submitTile(args, formHooks, ctx, scope) {
      const applyResult = applyTile.call(this, args, formHooks, ctx, scope);
      if (applyResult?.then) {
        return applyResult.then((respData) => {
          formHooks.onComplete && formHooks.onComplete(args, respData);
        });
      }
    }

    function applyTile(args, hooks, ctx, scope) {
      if (scope.form.$invalid) {
        AdpFormService.scrollToError(scope.form);
        return;
      }
      const { dashboardContext, customData, row } = this;
      const { tileId } = customData;
      const { board, boardLayers: layers, editInterface } = dashboardContext;

      return AdpFormService.handleFileUpload(scope)
        .then(() => AdpGsService.handleTileUpdate(layers, board, tileId, row, editInterface))
        .then(() => {
          const message = ActionMessages[ACTIONS.UPDATE](args.modelSchema);
          AdpNotificationService.notifySuccess(message);
          return editInterface.onBoardChange();
        });
    }

    function cancelSubmitTile(args, formHooks) {
      formHooks.onCancel && formHooks.onCancel(args);
      return Promise.resolve('');
    }

    function _redrawAllWidgetsSnapshot(board) {
      const snapshot = _.get(board.data, 'styling.tile');

      return JSON.stringify(snapshot);
    }

    function _reloadDashboardSnapshot(board) {
      const snapshot = _.get(board.data, 'styling.themes');

      return JSON.stringify(_.omitBy(snapshot, (x) => !x));
    }

    function _resetAllTiles(context) {
      _.each(context.board.tiles, (tile) => {
        AdpGsService.handleTileUpdate(context.boardLayers, context.board, tile.id, tile.data, context.editInterface);
      });
    }

    function _reloadDashboard() {
      window.location.reload();
    }
  }
})();
;(function () {
  angular.module('app.adpGridstack').controller('AdpGsEditorController', AdpGsEditorController);

  /** @ngInject */
  function AdpGsEditorController(
    AdpModalService,
    AdpGsService,
    AdpWidgetsService,
    AdpUnifiedArgs,
    ActionsHelpers,
    $element,
    $state,
    $timeout,
    AdpNotificationService,
    AdpFullscreenService,
    AdpGsControlLinksService,
    AdpSchemaService,
    AdpGsActions,
    ErrorHelpers,
    AdpCustomCss
  ) {
    const vm = this;
    const boardCondition = { _id: $state.params._id };
    const AUTOSAVE_PAUSE = 1500;
    const dashboardSchema = AdpSchemaService.getSchemaByName('_dashboards');

    vm.editInterface = {
      editTile: onTileEdit,
      editWidget: onWidgetEdit,
      delete: onTileRemove,
      togglePin: onTogglePin,
      toggleVisible: onToggleVisible,
      toggleMinimize: onTileMinimize,
      toggleMaximize: onTileMaximize,
      onBoardChange,
      getBoardData,
    };
    const invokeDashboardSave = (silent, widgetsToRefreshAfter) => {
      const context = { ...vm.boardArgs, silent, widgetsToRefreshAfter };
      AdpGsActions.saveDashboard.call(context);
    };
    const _debouncedSave = _.debounce(invokeDashboardSave, AUTOSAVE_PAUSE, { leading: true });

    AdpGsService.initializeDashboard(true, boardCondition, vm.editInterface, false)
      .then(onInitialize)
      .catch((e) => console.log('Failed to initialise dashboard', e));

    function onInitialize({ board, layers, css }) {
      vm.board = board;
      vm.boardCss = css.boardCss;
      vm.containerCss = css.containerCss;
      vm.bgCss = css.bgCss;
      vm.stretchBg = !!_.get(board, 'data.styling.dimensions.stretchBackgroundBeyondDashboard');
      vm.boardClass = {
        'adp-gs-fits-height': _.get(board, 'data.rowHeightStrategy', 'square') !== 'square',
      };
      vm.cssNames = _.get(css, 'styleOptions.cssNames', '');

      const args = AdpUnifiedArgs.getHelperParams({
        path: '',
        formData: board.data,
        schema: dashboardSchema,
      });

      args.dashboardContext = vm;

      vm.boardArgs = args;
      vm.boardLayers = layers;

      const themes = _.get(board, 'data.styling.themes');
      if (themes) {
        AdpGsService.setThemes(themes);
        $element.on('$destroy', () => AdpGsService.setThemes());
      }

      const { _id } = _.get(args, 'row');
      const dashboardCss = _.get(args, 'row.advanced.dashboardCss');
      const removeCssHandler = AdpCustomCss.setStyleElement(dashboardCss, _id, $element);

      AdpGsService.setTitle(board);
      $element.on('$destroy', () => {
        removeCssHandler();
        AdpGsService.cleanTitle();
      });

      gridLayerSetupEvents();
    }

    function gridLayerSetupEvents() {
      const grid = vm.boardLayers.getGrid();
      grid.on('resize', onGridTileResize);
      grid.on('change', onGridTileChange);
      grid.on('dropped', onNewDropped);

      $(window).on('resize', vm.boardLayers.onWindowResize);
      $element.on('$destroy', () => $(window).off('resize', vm.boardLayers.onWindowResize));

      setTimeout(() => {
        vm.boardLayers.onWindowResize();
        onBoardChange([]);
      }, 200);
    }

    function onBoardChange(widgetsToRefreshAfter) {
      _debouncedSave(true, widgetsToRefreshAfter);
    }

    function onTileEdit(id) {
      const tile = this.row;
      const formData = _.cloneDeep(tile.data);

      AdpGsService.openTileFormDialog('update', formData, id, vm).catch(ErrorHelpers.handleError);
    }

    function onTileRemove(id) {
      AdpModalService.confirm({ message: 'Are you sure to remove widget?' })
        .then(() => {
          const tile = AdpGsService.getTileById(vm.board, id);
          vm.boardLayers.removeTile(id);
          // ToDO: tiles in containers are not supported(but also not supposed to be deleted on moment of writing it)
          const index = _.findIndex(vm.board.tiles, tile);
          vm.board.tiles.splice(index, 1);

          onBoardChange();
        })
        .catch(() => {});
    }

    function onTileMinimize(id) {
      const tile = AdpGsService.getTileById(vm.board, id);
      vm.boardLayers.toggleMinimizeTile(tile);
      onBoardChange();
    }

    function onTileMaximize(id) {
      const tile = AdpGsService.getTileById(vm.board, id);
      vm.boardLayers.toggleMaximizeTile(tile);
    }

    function onWidgetEdit() {
      const context = this;
      return AdpGsService.editTileWidget(context, vm.editInterface)
        .then((success) => {
          if (!success) {
            throw 'cancel';
          }
          onBoardChange([this.row.widgetRow._id]);
        })
        .catch((err) => {
          if (err !== 'cancel') {
            ErrorHelpers.handleError(err, 'Widget form');
          }
        });
    }

    function onTogglePin(id) {
      const tile = AdpGsService.getTileById(vm.board, id);
      const tileData = tile.data;

      tileData.positionFixed = !tileData.positionFixed;

      vm.boardLayers.setFixed(id, tileData.positionFixed);

      onBoardChange();
    }

    function onToggleVisible(id) {
      const tile = AdpGsService.getTileById(vm.board, id);
      const tileData = tile.data;

      tileData.hidden = !tileData.hidden;

      onBoardChange();
    }

    function onGridTileResize(event, el) {
      const id = _.get(el, 'gridstackNode.id');
      const tile = _.find(vm.board.tiles, (t) => t.id === id);
      const scope = _.get(tile, '$scope');
      scope && scope.$broadcast('widgetTileResize');
    }

    function onGridTileChange(event, nodes) {
      const isEventsBubblesFromWidget = event.currentTarget !== event.target;
      if (isEventsBubblesFromWidget) {
        return;
      }
      _.each(nodes, (node) => {
        const tile = AdpGsService.getTileById(vm.board, node.id);
        const tileData = tile.data;
        tileData.x = node.x;
        tileData.y = node.y;
        if (tileData.h !== node.h || tileData.w !== node.w) {
          tileData.h = node.h;
          tileData.w = node.w;
        }
      });

      onBoardChange();
    }

    function onNewDropped(event, previousTile, newTile) {
      return AdpGsService.createEmptyGridTile(vm, newTile).then(onBoardChange);
    }

    function getBoardData() {
      return {
        board: vm.board,
        boardArgs: vm.boardArgs,
        boardLayers: vm.boardLayers,
      };
    }
  }
})();
;(function () {
  angular.module('app.adpGridstack').directive('adpGsHeader', adpGsHeader);

  function adpGsHeader($location, AdpIconsHelper, AdpFullscreenService, ActionsHelpers) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        mode: '@',
      },
      templateUrl: 'client-modules/adp-gridstack/adp-gs-header.html',
      link(scope, $element) {
        const actionTypeCbGetter = {
          link: getLinkCb,
          module: ActionsHelpers.getForModuleType,
          action: ActionsHelpers.getForHelperType,
        };
        scope.isTitleCollapsed = _.get(scope, 'args.dashboardHeaderOptions.isCollapsed', false);
        scope.isFullscreen = false;
        scope.actions = getActions(scope.mode);

        setTimeout(() => $('.adp-dashboard-action-addNewAtEditor', $element).attr('gs-w', 4).attr('gs-h', 4), 600);

        scope.execAction = function (action, name) {
          const actionType = _.get(action, 'action.type');
          const cbGetter = _.get(actionTypeCbGetter, actionType);
          if (!_.isFunction(cbGetter)) {
            console.log('== Action type is not supported for', name);
            return;
          }

          const cb = cbGetter(action);

          if (!cb) {
            console.log('== Action callback not found for', name);
            return;
          }

          const argsForAction = _.assign({}, scope.args, { action: name, fieldSchema: action });
          return cb.apply(argsForAction, [argsForAction]);
        };
        scope.toggleFullscreen = toggleFullscreen;
        scope.hasIcon = (action) => !_.isNil(action.icon);
        scope.getIcon = (icon) => _.get(AdpIconsHelper.getIconHtml(icon), '0.outerHTML', '');
        scope.hasFullName = (action) => !_.isNil(action.fullName);
        scope.getCSS = (action) => `adp-dashboard-header-control adp-dashboard-action-${action.actionName} 
        ${_.get(action, 'htmlAttributes.class', '')}`;
        scope.headerCollapseCb = () => {
          scope.isTitleCollapsed = !scope.isTitleCollapsed;
        };
        scope.fullNameGetter = (action) =>
          action.fullName.type === 'function' ? evalProperty(action, 'fullName.code', 'Action') : action.fullName;
        scope.visibleGetter = (action) =>
          _.isString(action.visible) ? evalProperty(action, 'visible', false) : action.visible || true;

        function getActions(position) {
          return _.chain(scope)
            .get('args.modelSchema.actions.fields')
            .pickBy((action) => ActionsHelpers.isActionAllowed(action, position))
            .entries()
            .orderBy(['[1].actionOrder'], ['asc'])
            .fromPairs()
            .value();
        }

        function getLinkCb() {
          return function () {
            const action = _.get(this, 'fieldSchema');
            const link = _.get(action, 'action.link', '');
            const dataRow = _.get(scope, 'args.row', {});
            const url = link.replace(/:([^/]+)/g, (match, p1) => _.get(dataRow, p1));

            $location.url(url);
          };
        }

        function toggleFullscreen() {
          scope.isFullscreen = true;

          if (scope.isFullscreen) {
            return AdpFullscreenService.toggleFullscreen($('.adp-dashboard-wrapper')[0]).then(onFullscreenExit);
          }
          return AdpFullscreenService.exitFullscreen().then(onFullscreenExit);
        }

        function onFullscreenExit() {
          const { dashboardContext } = scope.args;
          const tiles = _.get(dashboardContext, 'board.tiles', []);
          const expanded = _.find(tiles, (tile) => tile.isMaximized);
          if (expanded) {
            dashboardContext.boardLayers.toggleMaximizeTile(expanded);
          }
          scope.isFullscreen = false;
        }

        function evalProperty(action, propertyPath, defaultValue) {
          try {
            const fn = new Function(`return ${_.get(action, propertyPath)}`);
            return fn.call(scope.args);
          } catch (e) {
            console.error(`Error evaluating "${propertyPath}"`, e);
            if (_.isNil(defaultValue)) {
              return defaultValue;
            }
          }
        }
      },
    };
  }
})();
;(function () {
  angular.module('app.adpGridstack').controller('AdpGsViewController', AdpGsViewController);

  /** @ngInject */
  function AdpGsViewController(AdpGsService, $scope, $state, $element, AdpUnifiedArgs, AdpSchemaService, AdpCustomCss) {
    const vm = this;
    const dashboardSchema = AdpSchemaService.getSchemaByName('_dashboards');
    const editInterface = {
      toggleMinimize: onTileMinimize,
      toggleMaximize: onTileMaximize,
      getBoardData,
    };

    let boardCondition;
    if ($scope.dashboardId) {
      boardCondition = { _id: $scope.dashboardId };
    } else if ($state.params.sharedDashboardId) {
      boardCondition = { sharedDashboardId: $state.params.sharedDashboardId };
    } else {
      boardCondition = { _id: $state.params._id };
    }

    vm.board = null;

    AdpGsService.initializeDashboard(false, boardCondition, editInterface, false)
      .then(onInitialize)
      .catch((e) => {
        console.log('Failed to initialise dashboard', e);
      });

    function onInitialize({ board, layers, css }) {
      const args = AdpUnifiedArgs.getHelperParams({
        path: '',
        formData: board.data, // ToDo: make sure this is ok!
        schema: dashboardSchema,
      });
      vm.boardLayers = layers;
      vm.board = board;
      vm.boardCss = css.boardCss;
      vm.containerCss = css.containerCss;
      vm.bgCss = css.bgCss;
      vm.stretchBg = _.get(board, 'data.styling.dimensions.stretchBackgroundBeyondDashboard');
      vm.boardClass = {
        'adp-gs-fits-height': _.get(board, 'data.rowHeightStrategy', 'square') !== 'square',
      };
      vm.cssNames = _.get(css, 'styleOptions.cssNames', '');
      args.dashboardContext = vm;
      const showHeader = _.get(board, 'data.styling.header.show');

      if (showHeader !== 'hide') {
        _.set(args, 'dashboardHeaderOptions.isCollapsed', showHeader === 'collapsed');
        vm.boardArgs = args;
      }

      const themes = _.get(board, 'data.styling.themes');
      if (themes) {
        AdpGsService.setThemes(themes);
        $element.on('$destroy', () => AdpGsService.setThemes());
      }

      const { _id } = _.get(args, 'row');
      const dashboardCss = _.get(args, 'row.advanced.dashboardCss');
      const removeCssHandler = AdpCustomCss.setStyleElement(dashboardCss, _id, $element);
      $element.on('$destroy', () => {
        $(window).off('resize', vm.boardLayers.onWindowResize);
        removeCssHandler();
      });

      $(window).on('resize', vm.boardLayers.onWindowResize);

      setTimeout(vm.boardLayers.onWindowResize, 200);

      AdpGsService.setTitle(board);
      $scope.$on('$destroy', () => AdpGsService.cleanTitle());
    }

    function onTileMinimize(id) {
      vm.boardLayers.toggleMinimizeTile(vm.board.tiles.find((t) => t.id === id));
    }

    function onTileMaximize(id) {
      vm.boardLayers.toggleMaximizeTile(vm.board.tiles.find((t) => t.id === id));
    }

    // ToDO: reuse this from
    function getBoardData() {
      return {
        board: vm.board,
        boardArgs: vm.boardArgs,
        boardLayers: vm.boardLayers,
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .service('AdpGuidedTourData', function () {
      return {
        getGuidedTourData,
        setTourToLS,
        getTourUrls,
        getTourByUrl,
        $get() {
          return this;
        }
      };
      function getGuidedTourData() {
        const getFromInterface = () => {
          let { completedGuidedTours = [], guidedTour } = _.get(window.adpAppStore.appInterface(), 'mainMenu') || {};
          return { completedGuidedTours, guidedTour };
        }

        const parseJSON = (tour) => {
          const parsed = _.attempt(JSON.parse, tour);

          if (_.isError(parsed)) {
            console.error('Error parsing tour data from LS');
            return null;
          }

          return parsed;
        }

        if (window.lsService.isGuest()) {
          const tour = parseJSON(window.lsService.getByKey('guidedTours'));
          return tour === null ? getFromInterface() : tour;
        }

        return getFromInterface();
      }

      function setTourToLS(tourData) {
        return window.lsService.setByKey('guidedTours', JSON.stringify(tourData));
      }

     function getTourUrls() {
       const INTERFACE = window.adpAppStore.appInterface();
       return _.map(INTERFACE.guidedTour, 'where');
     }

      function getTourByUrl(url) {
        var INTERFACE = window.adpAppStore.appInterface();
        var interfaceGuidedTour = _.get(INTERFACE, 'guidedTour', {});

        var tourName = _.findKey(interfaceGuidedTour, ['where', url]);
        if (!tourName) {
          return;
        }

        return {
          tourName: tourName,
          tour: interfaceGuidedTour[tourName],
        };
      }
    });
})();

;;(function () {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .service('AdpGuidedTourProgress', function AdpGuidedTourProgress(
      AdpSchemaService,
      GraphqlCollectionMutator,
      GraphqlCollectionQuery,
      AdpModalService,
      AdpNotificationService,
      AdpGuidedTourData
    ) {
      function completeTour(tourName) {
        updateUserSettings({ tourName });
      }

      function cancelTour() {
        return AdpModalService.createModal('adpGuidedTourDialog', {
          windowClass: 'adp-guided-tour-backdrop'
        }).result
          .then(function (resp) {
            var result = {};
            if (resp === 'stopShowingTours') {
              result.guidedTour = false;
            } else {
              return resp;
            }

            return updateUserSettings(result)
              .then(() => resp);
          });
      }

      function updateUserSettings(newTourData) {
        if (window.lsService.isGuest()) {
          updateTourSettingsInLs(newTourData);
          return Promise.resolve();
        }

        var settingsSchema = AdpSchemaService.getSchemaByName('_userSettings');

        return GraphqlCollectionQuery(settingsSchema, {})
          .then(res => _.get(res, 'items[0]'))
          .then((oldTourData) => {
            const result = updateTourData(newTourData, oldTourData);

            return GraphqlCollectionMutator.update(settingsSchema, result)
              .then(() => {
                updateInterfaceValue(result.completedGuidedTours, 'mainMenu.completedGuidedTours');
                updateInterfaceValue(result.guidedTour, 'mainMenu.guidedTour');
              });
          })
          .then(() => AdpNotificationService.notifySuccess('Guided tour settings updated.'));
      }

      function updateTourSettingsInLs(newTourData) {
        const oldTourData = AdpGuidedTourData.getGuidedTourData();
        const result = updateTourData(newTourData, oldTourData);
        AdpGuidedTourData.setTourToLS(result);
      }

      function updateTourData(newTourData, oldTourData) {
        if (newTourData.tourName) {
          oldTourData.completedGuidedTours = oldTourData.completedGuidedTours || [];
          oldTourData.completedGuidedTours.push(newTourData.tourName);
          oldTourData.completedGuidedTours = _.uniq(oldTourData.completedGuidedTours);
        }

        if (newTourData.guidedTour === false) {
          oldTourData.guidedTour = newTourData.guidedTour;
        }

        return _.pickBy(oldTourData, _.negate(_.isNull));
      }

      function updateInterfaceValue(value, path) {
        const appInterface = window.adpAppStore.appInterface();
        _.set(appInterface, path, value);
      }

      return {
        completeTour,
        cancelTour,
      }
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .service('AdpGuidedTourService', function (
      $timeout,
      AdpGuidedTourUtil,
      AdpGuidedTourProgress,
      AdpGuidedTourData
    ) {
      return {
        createAndStart,
        tourEnabledForUrl,
        checkTourExistForPage,
        $get() {
          return this;
        }
      };

      function checkTourExistForPage(state) {
        const urls = AdpGuidedTourData.getTourUrls();
        const privatePortion = state.$$state();

        return _.some(urls, (url) => {
          const urlMatcher = privatePortion.url;
          return urlMatcher && urlMatcher.exec(url);
        });
      }

      function createAndStart(url) {
        const interfaceGuidedTourForPage = AdpGuidedTourData.getTourByUrl(url);
        const tourCfg = getTourConfig(interfaceGuidedTourForPage);
        const tourWidget = new window.Shepherd.Tour(tourCfg);

        $timeout(() => tourWidget.start(), 20);

        return tourWidget;
      }

      function getTourConfig({ tourName, tour }) {
        const cfg = {
          defaultStepOptions: {
            popperOptions: {
              modifiers: [{ name: 'offset', options: { offset: [0, 12] } }]
            }
          },
          useModalOverlay: true,
          exitOnEsc: false,
          steps: _.map(tour.steps, (step) => getStep(step, tourName)),
        };

        return cfg;
      }

      function getStep(step, tourName) {
        if (step.type === 'Modal') {
          return {
            text: step.content,
            attachTo: {
              element: step.target || null,
              on: step.position || 'auto',
            },
            buttons: generateButtons(step.buttons, tourName),
            scrollTo: !!step.scrollTo,
            showOn() {
              const targetSelector = this.attachTo.element;
              if (targetSelector === null) {
                return true;
              }

              const targetDefinedButNotFound = $(targetSelector).length > 0;
              if (!targetDefinedButNotFound) {
                return false;
              }

              return true;
            },
          }
        } else if (step.type === 'Click') {
          return {
            when: {
              show() {
                var self = this;
                $(step.target).click();
                var steps = self.getTour().steps;
                var currentIndex = _.findIndex(steps, ['id', self.id]);
                var nextStep = steps[currentIndex + 1];

                if (!nextStep) {
                  return;
                }

                AdpGuidedTourUtil.waitFor(() => {
                  var nextTarget = _.get(nextStep, 'options.attachTo.element');
                  return $(nextTarget).length > 0;
                })
                .then(function () {
                  self.getTour().next();
                })
                .catch(function (err) {
                  if (err === 'MAX_RETRIES') {
                    console.error('MAX_RETRIES reached waiting for element. Cant find element');
                  }
                  console.error(err);
                  self.getTour().next();
                });
              }
            }
          }
        } else {
          console.log('Unknown step type for tour: ', step);
          return {};
        }
      }

      function generateButtons(btnsCfgOriginal, tourName) {
        var tourBtns = {
          Next: {
            text: 'Next',
            action: function() {
              this.next();
            }
          },
          Back: {
            text: 'Back',
            secondary: true,
            action: function() {
              this.back();
            },
          },
          Done: {
            text: 'Done',
            action: function () {
              AdpGuidedTourProgress.completeTour(tourName);
              this.complete();
            }
          },
          Cancel: {
            text: 'Cancel',
            secondary: true,
            action: function () {
              var self = this;
              self.hide();

              AdpGuidedTourProgress.cancelTour(tourName)
                .then(function (result) {
                  if (_.isUndefined(result)) {
                    self.show();
                  } else {
                    self.cancel();
                  }
                });
            }
          }
        }

        if (!btnsCfgOriginal) {
          return [tourBtns.Cancel, tourBtns.Back, tourBtns.Next];
        }

        var btnsCfg = _.isString(btnsCfgOriginal) ? [btnsCfgOriginal] : btnsCfgOriginal;
        var btns = btnsCfg.map(btnName => tourBtns[btnName]);

        return [tourBtns.Cancel].concat(btns);
      }

      function tourEnabledForUrl(url) {
        const { guidedTour, completedGuidedTours } = AdpGuidedTourData.getGuidedTourData();

        if (!guidedTour) {
          return false;
        }

        const tour = AdpGuidedTourData.getTourByUrl(url);
        const tourName = (tour || {}).tourName;

        return !_.includes(completedGuidedTours, tourName);
      }
    });
})();

;;(function () {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .service('AdpGuidedTourUtil', function AdpGuidedTourUtil() {
      var MAX_RETRIES = 5;
      function waitFor(condition) {
        var timerCnt = 0;
        const waitForHelper = (resolve, reject) => {
          setTimeout(function () {
            if (condition()) {
              resolve();
              return;
            }

            if (timerCnt === MAX_RETRIES) {
              reject('MAX_RETRIES');
              return;
            }

            timerCnt++;
            waitForHelper(resolve, reject);
          }, 100);
        }

        return new Promise(waitForHelper);
      }

      return { waitFor };
    });
})();
;(function () {
  'use strict';

  angular.module('app.adpMarketplaceCart')
    .controller('AdpMarketplaceCartController', AdpMarketplaceCartController);

  function AdpMarketplaceCartController() {

  }
})();
;(function () {
  'use strict';

  angular.module('app.adpMarketplaceServerActions')
    .factory('AdpMarketplaceServerActions', AdpMarketplaceServerActions);

  function AdpMarketplaceServerActions(
    APP_CONFIG,
    $http,
    AdpNotificationService,
    AdpUnifiedArgs,
    AdpGeneratorModalService,
    AdpSchemaService,
    ErrorHelpers,
    ActionsHelpers,
    ServerError,
    AdpMenuService
  ) {
    function checkoutCart(toolbarWidgetRegister) {
      const { actionOptions, modelSchema, row, fieldSchema:actionItem } = this;
      const isDisabled = ActionsHelpers.evalDisabledAttr(actionItem, row, modelSchema);

      return toolbarWidgetRegister((gridComponent) => {
        return {
          name: 'createButton',
          widget: 'dxButton',
          template: `<button type="button" class="btn page-action btn-primary" ${isDisabled?'disabled':''}>${ actionOptions.title }</button>`,
          onClick: ()=>doCheckoutRequest(gridComponent),
        }
      })
    }

    function doCheckoutRequest(gridComponent) {
      const body = {};
      const url = `${ APP_CONFIG.apiUrl }/checkout`;
      $http
        .post(url, body)
        .then(({ data }) => {
          const { success, message } = data;
          if (!success) {
            throw new ServerError(message)
          }
          AdpNotificationService.notifySuccess(message);
          AdpMenuService.generateMenu();
          gridComponent.refresh();
        })
        .catch(ErrorHelpers.handleError)
    }

    function addToCart() {
      const context = this;
      const { _id, _marketplace } = context.row;
      const dialogSchema = AdpSchemaService.getSchemaByName('_addToCartDialog');
      // ToDo - get real duration names from lists helper
      const durationsList = _marketplace.licenseDurations.map(item => [item.licenseDuration, 'Name: ' + item.licenseDuration]);
      const dialogFormData = {
        price: _.get(_marketplace, 'licenseDurations.0.price', 0),
        autoRenew: true,
        licenseDuration: _.get(durationsList, '0.0'),
        licenceDurations: _marketplace.licenseDurations,
      };

      _.set(dialogSchema, 'fields.licenseDuration.list.values', _.fromPairs(durationsList));

      _openAddToCartDialog(dialogSchema, dialogFormData).then(
        dialogResult => {
          if (!dialogResult) {
            return;
          }
          const row = _.get(dialogResult, 'args.row', {});
          const { price, licenseDuration, autoRenew } = row;
          const table = _.get(context, 'modelSchema.collectionName');
          const item = { _id, table };
          const body = { item, licenseDuration, price, autoRenew: !!autoRenew };
          const url = `${ APP_CONFIG.apiUrl }/addToCart`;

          $http
            .post(url, body)
            .then(({ data }) => {
              const { success, message } = data;
              if (!success) {
                throw new ServerError(message)
              }
              AdpNotificationService.notifySuccess(message);
              AdpMenuService.generateMenu();
            })
            .catch(ErrorHelpers.handleError)
        }
      )
    }

    function addToCartRequest(args, formHooks) {
      formHooks.onComplete && formHooks.onComplete(args);
    }

    function _openAddToCartDialog(schema, formData) {
      const modalOptions = {
        args: AdpUnifiedArgs.getHelperParamsWithConfig({
          path: '',
          action: 'update',
          formData,
          schema,
        })
      };

      return AdpGeneratorModalService.formModal(modalOptions)
    }

    return {
      checkoutCart,
      addToCart,
      addToCartRequest,
    }
  }
})();
;(function () {
  angular.module('app.adpPaymentPlans').factory('AdpPaymentPlansActions', AdpPaymentPlansActions);

  /** @ngInject */
  function AdpPaymentPlansActions() {
    return {};
  }
})();
;(function () {
  angular.module('app.adpPaymentPlans').factory('AdpPaymentPlansService', AdpPaymentPlansService);

  /** @ngInject * */
  function AdpPaymentPlansService(AdpModalService) {
    function listPlans() {
      return AdpModalService.createModal('adpPaymentPlansModalComponent', {}).result;
    }

    return { listPlans };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpRtcActions')
    .component('adpDbChangeNotificationModal', {
      template: `
<div class="modal-body" adp-handle-hot-keys>
  {{vm.options.message}}
    <button
      class="adp-action-b-primary"
      type="button"
      adp-hot-key="Enter"
      ng-click="vm.confirm()">Reload data</button>
    <button
      class="adp-action-b-secondary"
      type="button"
      ng-click="vm.cancel()"
      adp-hot-key="Escape">Cancel</button>
</div>`,
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controllerAs: 'vm',
      controller:
        function () {
          const vm = this;

          vm.$onInit = function () {
            vm.options = vm.resolve.options;
          };

          vm.confirm = function () {
            vm.close({ confirmed: true });
          };

          vm.cancel = function () {
            vm.dismiss({ confirmed: false });
          };
        }
    });
})();
;(function () {
  'use strict';

  angular.module('app.adpSyntheticGenerate').component('adpGenModal', {
    template:
      '<adp-form ' +
      '        args="vm.args"' +
      '        form-options="vm.formOptions">' +
      '    <form-header><h2 class="semi-bold">{{ vm.formParams.title }}</h2></form-header>' +
      '    <form-footer>' +
      '      <footer class="adp-action-b-container" adp-handle-hot-keys="form">' +
      '        <button type="button" ng-click="vm.onCancel()" adp-hot-key="Escape" class="adp-action-b-secondary">Cancel</button>' +
      '        <button type="submit" class="adp-action-b-primary">{{ vm.formParams.btnText }}</button>' +
      '      </footer>' +
      '    </form-footer>' +
      '</adp-form>',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpGenModalController',
    controllerAs: 'vm',
  });
})();
;(function () {
  'use strict';

  angular.module('app.adpSyntheticGenerate').controller('AdpGenModalController', AdpGenModalController);

  /** @ngInject */
  function AdpGenModalController(
    AdpUnifiedArgs,
    $q
  ) {
    var vm = this;

    var fields = {
      recordsNum: {
        fieldName: 'recordsNum',
        type: 'Number',
        fullName: 'Number of records to be generated',
        validate: [{
          arguments: {
            limit: '1',
          },
          errorMessages: {
            default: 'Should be at least @limit',
          },
          validator: 'min',
        }],
        showInForm: true,
        permissions: { view: true, create: true, update: true },
      },
      batchName: {
        fieldName: 'batchName',
        type: 'String',
        fullName: 'Generation job name',
        required: true,
        showInForm: true,
        permissions: { view: true, create: true, update: true },
      },
    };

    vm.formParams = { btnText: 'Generate', title: 'Synthetic Content Generator' };

    vm.$onInit = function () {
      var schema = vm.resolve.options.schema;

      vm.args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: 'syntheticGenerate',
        schema: {
          type: 'Schema',
          schemaName: 'syntheticGenerate',
          fullName: 'syntheticGenerate',
          fields: fields,
        },
        formData: {
          recordsNum: 5,
          batchName: schema.fullName + ' generation at ' + dayjs().format('hh:mm MM/DD/YYYY'),
        },
      });

      vm.onCancel = function () {
        return vm.dismiss({ $value: 'cancel' });
      };

      vm.formOptions = {
        localActionsStrategy: {
          submit: function (args) {
            return $q.resolve()
              .then(function () {
                vm.close({ $value: args.row });
              });
          },
        },
        disableFullscreen: true,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapHelper', AdpTopomapHelper);

  /** @ngInject */
  function AdpTopomapHelper(
    AdpWidgetsService
  ) {
    function loadData(_options = {}) {
      return AdpWidgetsService.fetchWidgetData(args, _options).then(({ data, messages }) => {
        const errorMessage = messages ? messages.join('</br>') : '';
        return { data, errorMessage };
      });
    }

    return {
      loadData,
    };
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapLogic', AdpTopomapLogic);

  /** @ngInject */
  function AdpTopomapLogic(AdpTopomapService) {
    return function ({ topomap, args }) {
      return AdpTopomapService.createLayers({ topomap, args }).then((layers) => {
        AdpTopomapService.handleTopomapSurface({layers, topomap, args});

        const destroyCb = () => _.each(layers, (l) => _.isFunction(l.onDestroy) && l.onDestroy());

        return {
          destroyCb,
          updateLayerData,
          updateLayerSelection,
        };

        function updateLayerData({ dataLayerId, data }) {
          const layer = _.find(layers, (layer) => layer._id === dataLayerId);

          if (!layer) {
            return;
          }

          return AdpTopomapService.updateLayer({ layer, data, topomap, args });
        }

        function updateLayerSelection({ dataLayerId, selectionFilters }) {
          const layer = _.find(layers, (layer) => layer._id === dataLayerId);

          if (!layer) {
            return;
          }

          return AdpTopomapService.updateLayer({ layer, selection: selectionFilters, topomap, args });
        }
      });
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapService', AdpTopomapService);

  /** @ngInject */
  function AdpTopomapService(AdpTopomapBarsLayer) {
    const layerModules = {
      bars: AdpTopomapBarsLayer,
    };

    function createLayers({topo, args}) {
      const {row} = args;
      const layers = _.get(row, 'topomap.layers', []);
      const activeLayers = _.filter(layers, (layer) => !layer.disabled);

      return Promise.all(_.map(activeLayers, async (layerRow, index) => {
        const {_id, type, name, wsUpdate, show, ...rowData} = layerRow;
        const {dataset, ...typedRowData} = rowData[type] || {};
        const row = _.clone(typedRowData);
        const datasetId = _.get(dataset, '_id');
        const layer = {
          _id,
          type,
          row,
          index,
          name,
          datasetId,
          show,
          wsUpdate,
          cache: {},
          sceneGroup: new THREE.Group(),
        };

        const createFn = _getLayerMethod(type, 'create');
        if (createFn) {
          const createResult = createFn({layer, topo, args});
          if (createResult?.then) {
            return createResult.then(() => layer);
          }
        }

        return Promise.resolve(layer);
      }));
    }

    function updateLayer({layer, data, selection, topo, args}) {
      layer.data = data;
      return _redrawLayer({layer, selection, topo, args})
        .then(() => topo.render())
    }

    function _redrawLayer({layer, selection, topo, args}) {
      const {type, data} = layer;
      if (topo.terrainReady) {
        const updateFn = _getLayerMethod(type, 'update');
        if (updateFn) {
          return updateFn({layer, data, selection, topo, args});
        }
      }

      return Promise.resolve();
    }

    function _redrawLayers({topo, layers, selection, args}) {
      return Promise.all(_.map(layers, layer => {
        if (_.isEmpty(layer.data)) {
          return Promise.resolve();
        }
        return _redrawLayer({layer, topo, selection, args})
      }));
    }

    function updateSurface({selection, topo, layers, args}) {
      const lat = _.get(selection, 'center.1.lat');
      const lng = _.get(selection, 'center.1.lng');
      const zoom = _.get(selection, 'zoom.1');
      const radius = _.get(selection, 'center.1.far', 5000) / 1000;

      if (topo.lat !== lat || topo.lng !== lng || topo.radius !== radius || topo.zoom !== zoom) {
        topo.lat = lat;
        topo.lng = lng;
        topo.radius = radius;
        topo.zoom = zoom;

        const origin = [lat, lng];
        const terrainUpdateMarker = {};
        topo.terrainReady = false;
        topo.terrainUpdateMarker = terrainUpdateMarker;

        return topo.engine.getTerrainRgb(origin, radius, topo.zoom).then(terrain => {
          if (topo.terrainUpdateMarker !== terrainUpdateMarker) {
            return;
          }
          terrain.rotation.x = -Math.PI / 2;
          topo.terrainGroup.clear();
          topo.terrainGroup.add(terrain);
          topo.render();
          topo.terrainReady = true;
          return _redrawLayers({topo, layers, selection, args});
        })
          .then(() => topo.render());
      }

      return Promise.resolve();
    }

    function _getLayerMethod(type, methodName) {
      const layerModule = layerModules[type];
      return layerModule && layerModule[methodName];
    }

    function getSpinManager(toggleCb, timeout = 500) {
      let prevState = false;
      const items = {};
      const spinners = {};
      const channels = {}

      function updateSpinner() {
        const turnOn = !_.isEmpty(spinners);

        if (turnOn !== prevState) {
          toggleCb(turnOn);
          prevState = turnOn;
        }
      }

      function getSpinChannel(id) {
        return {
          on: () => toggle(true), off: () => toggle(false),
        }

        function toggle(turnOn) {
          const counter = _.get(items, [id, 'counter'], 0);
          const timer = _.get(items, [id, 'timer']);
          if (turnOn) {
            if (!timer) {
              const timer = setTimeout(() => _.set(spinners, id, true), timeout);
              _.set(items, id, {timer, counter: 1});
            } else {
              _.set(items, [id, 'counter'], counter + 1);
            }
          } else {
            if (counter > 1) {
              _.set(items, [id, 'counter'], counter - 1);
            } else {
              if (timer) {
                clearTimeout(timer);
                _.set(items, id, null);
              }

              delete spinners[id];
            }
          }
          updateSpinner();
        }
      }

      return (name) => {
        return channels[name] || (channels[name] = getSpinChannel(name));
      }
    }

    return {
      createLayers,
      updateLayer,
      updateSurface,
      getSpinManager,
    };
  }
})();

;(function () {
  angular.module('app.adpTopomap').controller('AdpWidgetTopomapController', AdpWidgetTopomapController);

  /** @ngInject */
  function AdpWidgetTopomapController(
    $scope,
    $element,
    $rootScope,
    $timeout,
    AdpWidgetsService,
    AdpTopomapService,
    AdpTopomapArTopFrame,
    AdpTopomapVr,
    AdpTopomap3d
  ) {
    const vm = this;
    const layersFilters = {};
    const spinManager = AdpTopomapService.getSpinManager(turnOn => {
      vm.isLoading = !!turnOn;
    }, 0);
    vm.isLoading = true;

    vm.$onInit = function () {
      const {args, interface: editInterface} = $scope;
      const widgetId = args.row._id;
      const options = {};

      initVisualizationLogic(args, options).then(({topo, layers, callbacks}) => {
        const destroyCb = () => {
          callbacks.onDestroy && callbacks.onDestroy();
          _.each(layers, (l) => _.isFunction(l.onDestroy) && l.onDestroy());
        }
        $element.on('$destroy', destroyCb);
        $scope.$on('widgetTileResize', _callIfFunction(callbacks.doResize));

        AdpWidgetsService.handleControlLinkChange({
          scope: $scope,
          widgetId,
          onLinkChange,
          onSelectLinkChange,
        });
        loadInitialLayersData($scope);

        const onDatasetUpdate = (changedDataLayers) =>
          _.each(changedDataLayers, (dataLayerId) => reloadData({dataLayerId, ...layersFilters[dataLayerId]}));
        AdpWidgetsService.handleDatasetUpdate({args, $element, onDatasetUpdate});
        AdpWidgetsService.touchLinksControlledByWidget(widgetId, editInterface);

        function onLinkChange(event) {
          const {dxFilter, virtualFilters, dataLayerId} = event;
          layersFilters[dataLayerId] = {filter: dxFilter, virtualFilters};

          return reloadData({dataLayerId, ...layersFilters[dataLayerId]});
        }

        function onSelectLinkChange(payload) {
          const {dataLayerId, selectionFilters: selection} = payload;
          if (dataLayerId === 'root') {
            return _updateSurface({selection});
          }
          const layer = _getLayerById(dataLayerId);
          if (layer) {
            spinManager(dataLayerId).on();
            const result = _updateLayer({layer, selection});
            if (result.then) {
              return result.finally(() => spinManager(dataLayerId).off());
            } else {
              spinManager(dataLayerId).off()
            }
          }
        }

        function reloadData(options = {}) {
          const {dataLayerId} = options;
          spinManager(dataLayerId).on()
          return AdpWidgetsService.fetchWidgetData(args, options)
            .then(({data, messages}) => {
              vm.errorMessage = messages ? messages.join('</br>') : '';
              const layer = _getLayerById(dataLayerId);
              return layer && _updateLayer({layer, data});
            })
            .finally(() => spinManager(dataLayerId).off());
        }

        function loadInitialLayersData($scope) {
          const {args, interface: editInterface} = $scope;
          const linksInterface = AdpWidgetsService.getControlLinksInterface(editInterface);
          const widgetId = _.get(args, 'row._id');
          const layerRows = _.get(args, 'row.topomap.layers', []).filter((layer) => !layer.disabled);
          const isRootControlled = linksInterface && linksInterface.isWidgetControlled(widgetId, 'root');

          if (!isRootControlled) {
            const initialLocation = {
              center: ['=', {
                lat: _.get(args, 'row.topomap.mapCenter.coordinates.1', 0),
                lng: _.get(args, 'row.topomap.mapCenter.coordinates.0', 0),
                far: _.get(args, 'row.topomap.mapSize', 5000),
              }],
              zoom: ['=', _.get(args, 'row.topomap.mapZoom', 4)],
            }

            _updateSurface({selection: initialLocation});
          }

          _.each(layerRows, (layer) => {
            const isLayerControlled = linksInterface && linksInterface.isWidgetControlled(widgetId, layer._id);
            if (!isLayerControlled) {
              reloadData({dataLayerId: layer._id});
            }
          });
        }

        function _updateSurface(params) {
          spinManager('surface').on();

          const promise = callbacks.updateSurface
            ? callbacks.updateSurface(params)
            : AdpTopomapService.updateSurface({...params, layers, topo, args});

          return promise.finally(() => spinManager('surface').off());
        }

        function _updateLayer(params) {
          if (callbacks.updateLayerData) {
            return callbacks.updateLayerData(params)
          }
          return AdpTopomapService.updateLayer({...params, topo, args});
        }

        function _getLayerById(id) {
          return _.find(layers, (layer) => layer._id === id);
        }
      });
    };

    function _callIfFunction(cb) {
      return () => _.isFunction(cb) && cb();
    }

    function initVisualizationLogic(args, options) {
      const modules = {
        ar: AdpTopomapArTopFrame,
        vr: AdpTopomapVr,
        '3d': AdpTopomap3d,
      };
      const module = modules[$scope.widgetType] || modules['3d'];

      return new Promise((resolve) => {
        $timeout(() => {
          module({
            $element,
            $scope,
            $rootScope,
            args,
            options,
            vm,
          }).then(resolve);
        });
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpTopomap')
    .directive('adpWidgetTopomap', widget);

  /** @ngInject */
  function widget(AdpCustomCss, $compile, AdpWidgetsService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        args: '<',
      },
      link: function(scope, element) {
        const widgetRow = _.get(scope, 'args.row') || {};
        const { _id } = widgetRow;
        const widgetType = _.get(widgetRow,'topomap.visualisationType');
        scope.widgetType = widgetType;
        const template = `<adp-topomap-${widgetType}/>`;
        const $res = $compile(template)(scope);
        const widgetCss = _.get(widgetRow, 'advanced.widgetCss');
        const removeCssHandler = AdpCustomCss.setStyleElement(widgetCss, _id, $res);
        element.on('$destroy', removeCssHandler);
        element
          .empty()
          .append($res)
          .removeClass()
          .addClass('adp-widget-container adp-widget-topomap adp-widget-topomap-' + widgetType);
      }
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTwoFactorConfigControl')
    .component('adpTwoFactorBackupTokensDialogComponent', {
      template:
        '<div class="modal-header">' +
        '  <h3 class="modal-title">Two-Factor Auth Backup Options</h3>' +
        '</div>' +
        '<div class="modal-body">' +
        '  <adp-page-loader loading="vm.loading"></adp-page-loader>' +
        '  <div ng-if="!vm.loading">' +
        '    <p ng-if="vm.codes.length">Please keep this codes in safe place and use them if you two-factor authentification device is not available.<br/>Each backup code can be used only once.</p>' +
        '    <div ng-if="vm.codes.length"' +
        '         class="adp-two-factor-backup-codes">' +
        '      <div ng-repeat="code in vm.codes track by $index"' +
        '           class="adp-two-factor-backup-codes-item" ' +
        '           ng-class="{used: code.used}">{{code.value}}</div>'+
        '    </div>' +
        '    <h3 ng-if="!vm.codes.length">No backup codes available</h3>' +
        '  </div>' +
        '</div>' +
        '<div class="modal-footer"  adp-handle-hot-keys>' +
        '  <button class="adp-action-b-secondary"' +
        '          ng-if="vm.codes && vm.codes.length"' +
        '          type="button"' +
        '          ng-click="vm.doDelete()">Delete backup codes</button>' +
        '  <button class="adp-action-b-tertiary"' +
        '          type="button"' +
        '          ng-click="vm.doGenerate()">Generate backup codes</button>' +
        '  <button class="adp-action-b-primary"' +
        '          adp-hot-key="Escape"' +
        '          type="button"' +
        '          ng-click="vm.doClose()">Close</button>' +
        '</div>',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpTwoFactorBackupTokensController',
      controllerAs: 'vm'
    });
})();
;(function () {
  'use strict';

  angular.module('app.adpTwoFactorConfigControl')
    .controller('AdpTwoFactorBackupTokensController', AdpTwoFactorBackupTokensController);

  /** @ngInject */
  function AdpTwoFactorBackupTokensController(
    AdpModalService,
    AdpTwoFactorHelper
  ) {
    var vm = this;

    vm.$onInit = doInit;
    vm.doGenerate = doGenerate;
    vm.doDelete = doDelete;
    vm.doClose = doClose;
    vm.loading = true;
    vm.codes = [];

    var counter;
    var used;

    function doInit() {
      counter = vm.resolve.options.counter;
      used = vm.resolve.options.used;

      AdpTwoFactorHelper.request(vm, AdpTwoFactorHelper.url.getBackupTokens)
        .then(
        function (data) {
          vm.codes = buildCodesList(data.codes, data.used);
        })
    }

    function doGenerate() {
      confirmReplaceExisting()
        .then(function () {
          return AdpTwoFactorHelper.request(vm, AdpTwoFactorHelper.url.getNewBackupTokens)

        })
        .then(
      function (data) {
        vm.codes = buildCodesList(data.codes, []);
        counter = data.counter;
        used = null;
      })
        .catch(function () {
        });
    }

    function confirmReplaceExisting() {
      var isUnusedCodesExists = vm.codes.length && (!used || vm.codes.length > used.length);

      if (isUnusedCodesExists) {
        return AdpModalService.confirm({
          message: AdpTwoFactorHelper.const.CONFIRM_REPLACE_MSG,
          okButtonText: AdpTwoFactorHelper.const.CONFIRM_REPLACE_BUTTON_LABEL,
        });
      }

      return Promise.resolve();
    }

    function doDelete() {
      AdpModalService.confirm({message: AdpTwoFactorHelper.const.CONFIRM_BACKUP_CLEAR_MSG})
        .then(function () {
          return AdpTwoFactorHelper.request(vm, AdpTwoFactorHelper.url.clearBackupTokens)
        })
        .then(function () {
          vm.codes = [];
          counter = null;
          used = null;
        })
        .catch(function () {
        });
    }

    function doClose(){
      vm.close({$value: {counter: counter, used: used}});
    }

    function buildCodesList(codes, used) {
      return _.map(codes || [], function (code, index) {
        return {value: code, used: used && used.indexOf(index) >= 0}
      })
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTwoFactorConfigControl')
    .component('adpTwoFactorConfigControlDialogComponent', {
      template: '<div class="smart-form client-form twoFactor-setup-dialog">' +
        '  <header class="smart-form-header">' +
        '    <h2 class="semi-bold">Two-Factor Auth Setup</h2>' +
        '  </header>' +
        '  ' +
        '  <adp-page-loader loading="vm.loading"></adp-page-loader>' +
        '  ' +
        '      <form name="form" novalidate ng-submit="vm.formSubmit(form)">' +
        '  <div class="row">' +
        '    <div class="col col-4 adp-two-factor-section">' +
        '      <div class="adp-two-factor-section-header">' +
        '        <span class="adp-big-number">1</span> Install' +
        '      </div>' +
        '      <p>Install two-factor authentication application on your mobile device.</p>' +
        '      <p>We recommend <b>Twilio Authy</b>' +
        '      (<a href="https://play.google.com/store/apps/details?id=com.authy.authy" target="_blank">Google Play</a>, ' +
        '      <a href="https://apps.apple.com/ru/app/twilio-authy/id494168017" target="_blank">Apple App Store</a>) ' +
        '      but you can use any analog as Google Authenticator, etc.</p>' +
        '    </div> ' +
        '    <div class="col col-4 adp-two-factor-section">' +
        '      <div class="adp-two-factor-section-header">' +
        '        <span class="adp-big-number">2</span> Add counter' +
        '      </div>' +
        '      <p>Scan following code with your auth application</p>' +
        '      <div class="text-center">' +
        '        <img src="{{vm.qrCodeDataUrl}}" id="adp-two-factor-qr-code" /><br />' +
        '        <p>No QR scanner available?</p>' +
        '        <p>Use this key for manual enter:</p>' +
        '        <div class="adp-two-factor-secret">' +
        '          <div ng-repeat="code in vm.secretDisplay track by $index">{{code}}</div>' +
        '        </div>' +
        '      </div>' +
        '    </div>' +
        '    <div class="col col-4 adp-two-factor-section">' +
        '      <div class="adp-two-factor-section-header">' +
        '        <span class="adp-big-number">3</span> Verify' +
        '      </div>' +
        '      <p>Please verify added counter by entering generated 6-digits code:</p>' +
        '      <br/>' +
        '      <adp-form-field-default' +
        '          args="vm.formArgs"' +
        '          form-context="vm.formContext"' +
        '          ng-attr-adp-qaid-field="twoFactorToken"' +
        '        ></adp-form-field-default>' +
        '      <div class="note-error col col-12 text-right" ng-if="vm.error">' +
        '        {{vm.error}}' +
        '      </div>' +
        '    </div>' +
        '  </div>' +
        '    <footer class="adp-action-b-container"  adp-handle-hot-keys>' +
        '      <button' +
        '          class="adp-action-b-secondary"' +
        '          type="button"' +
        '          adp-hot-key="Escape"' +
        '          ng-click="vm.close()">' +
        '          Cancel setup' +
        '      </button>' +
        '      <button' +
        '          class="btn btn-primary"' +
        '          type="submit">' +
        '          Set two-factor' +
        '      </button>' +
        '    </footer>' +
        '  </form>' +
        '</div>',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpTwoFactorConfigControlController',
      controllerAs: 'vm'
    });
})();
;(function () {
  'use strict';

  angular.module('app.adpTwoFactorConfigControl')
    .controller('AdpTwoFactorConfigControlController', AdpTwoFactorConfigControlController);

  /** @ngInject */
  function AdpTwoFactorConfigControlController(
    $scope,
    AdpAuthSchemas,
    AdpUnifiedArgs,
    AdpTwoFactorHelper
  ) {
    var vm = this;
    var isRegisterForm;

    vm.twoFactorArgs = AdpAuthSchemas.loginTwoFactorArgs();
    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit: function (args) {
          return doSetTwoFactor(args.row);
        }
      }
    };
    vm.formContext = {
      visibilityMap: {},
      requiredMap: {}
    };
    vm.formArgs = AdpUnifiedArgs.getHelperParams({
      path: 'twoFactorToken',
      schema: vm.twoFactorArgs.modelSchema,
      action: vm.twoFactorArgs.action,
      formData: vm.twoFactorArgs.row || {}
    })

    vm.$onInit = doInit;
    vm.save = doSetTwoFactor;
    vm.loading = true;
    vm.scp = $scope;
    vm.formSubmit = doSetTwoFactor;

    function doInit() {
      var login = vm.resolve.options.login;
      isRegisterForm = vm.resolve.options.isRegisterForm;

      AdpTwoFactorHelper.request(vm, AdpTwoFactorHelper.url.getTwoFactorSecret, {method:'post', body: {login: login}})
        .then(function(data){
          vm.secretDisplay = data.data.base32.replace(/(.{4}(?=.))/g, '$1 ').split(" ");
          vm.qrCodeDataUrl = data.data.qrCodeDataUrl;
        })
    }

    function doSetTwoFactor(form) {
      var twoFactorToken = form.twoFactorToken.$viewValue;

      vm.error = '';

      if (!twoFactorToken) {
        vm.error = 'Verification token is required';
        return;
      }

      if (!twoFactorToken || form.$invalid) {
        vm.error = 'Verification token has invalid format';
        return;
      }

      vm.loading = true;

      var data = { twoFactorToken: twoFactorToken };
      var url = isRegisterForm ? AdpTwoFactorHelper.url.verifyTwoFactorToken : AdpTwoFactorHelper.url.enableTwoFactor;

      AdpTwoFactorHelper.request(vm, url, { method: 'post', body: data})
        .then(function(){
          vm.close({$value: {status: true}});
        })
        .catch(function(){
        })
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTwoFactorConfigControl')
    .factory('AdpTwoFactorHelper', AdpTwoFactorHelper);

  function AdpTwoFactorHelper(
    $http,
    APP_CONFIG,
    AdpNotificationService
  ) {

    return {
      const: constants(),
      url: urls(),
      request: request
    }

    function constants() {
      return {
        SECRET_FIELD_NAME: 'twoFactorSecret',
        BACKUP_COUNTER_FIELD_NAME: 'twoFactorBackupCounter',
        BACKUP_USED_FIELD_NAME: 'twoFactorUsedCounters',
        IS_ENABLED: 'is enabled',
        IS_DISABLED: 'is disabled',
        CONFIRM_DISABLE_MSG: 'Are you sure to disable %label% for this user?',
        CONFIRM_BACKUP_CLEAR_MSG: 'Are you sure you want to delete the backup codes?',
        CONFIRM_REPLACE_MSG: 'WARNING: generating new codes will make all previously generated codes invalid',
        CONFIRM_REPLACE_BUTTON_LABEL: 'Generate new codes',
        BACKUP_CODES_IMPORTANCE_MSG: 'Backup codes are very important to secure your account and available on user profile page after registration. It\'s highly recommended to go to Menu --> Profile, generate and save backup codes in safe place',
      }
    }

    function urls() {
      return {
        getTwoFactorSecret: APP_CONFIG.apiUrl + '/getTwoFactorSecret',
        verifyTwoFactorToken: APP_CONFIG.apiUrl + '/verifyTwoFactorToken',
        enableTwoFactor: APP_CONFIG.apiUrl + '/enableTwoFactor',
        disableTwoFactor: APP_CONFIG.apiUrl + '/disableTwoFactor',
        getBackupTokens: APP_CONFIG.apiUrl + '/backupTokens',
        getNewBackupTokens: APP_CONFIG.apiUrl + '/newBackupTokens',
        clearBackupTokens: APP_CONFIG.apiUrl + '/clearBackupTokens'
      }
    }

    function request(vm, url, _params) {
      var params = _params || {};
      var method = params.method || 'get';
      var httpParams = [url];

      if (params.body) {
        httpParams.push(JSON.stringify(params.body));
      }

      return $http[method].apply(this, httpParams)
        .then(function (res) {
          if (!res.data.success) {
            throw new Error(res.data.message);
          } else {
            return res.data;
          }
        })
        .catch(function (err) {
          AdpNotificationService.notifyError((err.data && err.data.message) || err.message || err);
          throw new Error(err);
        })
        .finally(function () {
          if (vm) {
            vm.loading = false;
          }
        })
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').controller('AdpSingleWidgetController', AdpSingleWidgetController);

  /** @ngInject */
  function AdpSingleWidgetController(
    $state,
    $scope,
    $element,
    $http,
    $timeout,
    APP_CONFIG,
    ServerError,
    ErrorHelpers,
    AdpWidgetsService
  ) {
    const vm = this;
    const debouncedWindowResize = _.debounce(() => $scope.$broadcast('widgetTileResize'), 200);

    vm.actionsPos = 'single.view';
    vm.interface = { doRefreshWidget: doLoad };

    doLoad();

    $(window).on('resize', debouncedWindowResize);
    $element.on('$destroy', () => $(window).off('resize', debouncedWindowResize));

    function doLoad() {
      const url = APP_CONFIG.apiUrl + '/w/c';
      const showHeader = $state.params.showHeader;
      let body;
      if ($state.params.sharedWidgetId) {
        body = { sharedWidgetId: $state.params.sharedWidgetId };
      } else {
        body = { _id: $state.params.id };
      }

      vm.isLoading = true;

      $http
        .post(url, body)
        .then((result) => {
          const { data, success, message } = result.data;
          if (!success) {
            throw new ServerError(message);
          }

          _.set(data, 'isEmbedded', false);

          const title = _.get(data, 'widgetRow.name', '');
          setTitle(title);

          const { widgetRow, widgetConfiguration, widgetDatasource } = data;
          const INTERFACE = window.adpAppStore.appInterface();
          const appSchema = window.adpAppStore.appModel();
          const config = _.cloneDeep(APP_CONFIG);
          const { type: widgetType, styling } = widgetRow;
          const widgetSchema = _.get(INTERFACE, ['widgets', widgetType]);
          const board = { isEmbedded: false };
          const tiles = _.chain(data)
            .get('widgetConfiguration.tiles')
            .map((t) => AdpWidgetsService.tileFromRow(t, 'single.view', board, $scope))
            .value();
          if (showHeader) {
            _.set(styling, 'header.showTitle', showHeader);
          }

          vm.tile = {
            widgetSchema,
            widgetRow,
            widgetConfiguration,
            widgetDatasource,
            appSchema,
            config,
            position: 'single.view',
            data: {
              title,
              styling,
            },
            tiles,
          };
        })
        .catch((err) => ErrorHelpers.handleError(err, 'Widget error'))
        .finally(() => {
          vm.isLoading = false;
        });
    }

    function setTitle(title) {
      const INTERFACE = window.adpAppStore.appInterface();
      const defaultTitle = INTERFACE.app.title;

      $timeout(() => {
        $('html head title').text(`${title} | ${defaultTitle}`);
      });
    }
  }
})();
;(function () {
  angular.module('app.adpWidgets').factory('AdpWidgetActions', AdpWidgetActions);

  /** @ngInject */
  function AdpWidgetActions(
    $state,
    ErrorHelpers,
    AdpModalFormService,
    AdpSchemaService,
    GraphqlCollectionMutator,
    AdpUnifiedArgs,
    AdpGeneratorModalService,
    AdpWidgetsService,
    AdpWidgetContainerService,
    AdpFormActions
  ) {
    function editWidget() {
      const recordId = _.get(this, 'row.widgetRow._id');
      const linksInterface = _.get(this, 'customOptions.widgetInterface.controlLinks');

      AdpModalFormService.openForm({
        schemaName: '_widgets',
        action: 'update',
        recordId,
        customData: { linksInterface },
      })
        .then((data) => {
          if (!data) {
            return;
          }

          const doRefreshWidget = _.get(this, 'customOptions.widgetInterface.doRefreshWidget');
          if (doRefreshWidget) {
            const dataRow = data.args.row;
            doRefreshWidget(dataRow);
          } else {
            const _id = $state.params._id;
            $state.go($state.current.name, { _id, seed: Date.now() });
          }
        })
        .catch((err) => {
          if (err !== 'cancel') {
            ErrorHelpers.handleError(err, 'Widget update form');
          }
        });
    }

    function exportToPng() {
      let name = _.get(this, 'row.widgetRow.name');
      name = name ? `_${name.replaceAll(/[^\w]+/g, '')}` : ``;
      AdpWidgetsService.exportElementAsPng({
        selector: '.adp-single-widget',
        filePrefix: `widgetExport${name}`,
      });
    }

    function applyAndView(args, formHooks) {
      const context = this;
      args.action = 'update';
      return AdpFormActions.apply.call(context, args, formHooks).then((responseData) => {
        const widgetUrl = `/_widgets/${responseData._id}`;
        window.open(widgetUrl);
      });
    }

    function editSubTile() {
      const tile = this.row;
      const containerType = _.get(tile, 'container.widgetRow.type');
      const widgetInterface = _.get(this, 'customOptions.widgetInterface');
      const linksInterface = _.get(widgetInterface, 'controlLinks');
      const schema = _getSplitTileSchema(containerType);

      const args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: 'update',
        formData: tile.data,
        schema,
      });

      args.customData = { linksInterface };
      args.customOptions = { widgetInterface, tile };

      return AdpGeneratorModalService.formModal({ args });
    }

    function removeSubTileWidget() {
      const tile = this.row;
      // ToDo: Rude&straight. Need to check links, but not so urgent, so later
      delete tile.data.widget;
      tile.widgetRow = undefined;

      _.set(this, 'customOptions.tile', tile);

      const args = { row: tile.data };
      applyTile.call(this, args);
    }

    function saveTiles({ tiles, onSave, widgetType, widgetId }) {
      const tabs = _.map(tiles, ({ data }) => data);
      const schema = AdpSchemaService.getSchemaByName('_widgets');
      const record = { _id: widgetId, [widgetType]: { tabs } };

      return GraphqlCollectionMutator.update(schema, record, [`${widgetType}.tabs`]).then(() => onSave && onSave());
    }

    function submitTile(args, formHooks, ctx, scope) {
      return applyTile.call(this, args, formHooks, ctx, scope).then((respData) => {
        formHooks.onComplete && formHooks.onComplete(args, respData);
      });
    }

    function applyTile(args) {
      const { row } = args;
      const tile = _.get(this, 'customOptions.tile');
      const containerType = _.get(tile, 'container.widgetRow.type');
      const widgetId = _.get(tile, 'container.widgetRow._id');
      const tiles = _.get(tile, 'container.tiles');
      const editInterface = _.get(this, 'customOptions.widgetInterface');
      const onSave = () => {
        editInterface.onBoardChange && editInterface.onBoardChange();
      };

      tile.data = row;

      return (function () {
        if (!row.widget) {
          $('adp-widget-tile', tile.$container).remove();
          return Promise.resolve();
        }

        return AdpWidgetsService.loadWidgetConfig(row.widget._id).then((serverData) =>
          AdpWidgetsService.updateTileWidget({ tile, serverData, editInterface })
        );
      })().then(() => saveTiles({ tiles, onSave, widgetType: containerType, widgetId }));
    }

    function cancelSubmitTile(args, formHooks) {
      formHooks.onCancel && formHooks.onCancel(args);
      return Promise.resolve('');
    }

    function _getSplitTileSchema(type) {
      const widgetsSchema = AdpSchemaService.getSchemaByName('_widgets');
      const fields = _.get(widgetsSchema, `fields.${type}.fields.tabs.fields`);
      const actions = {
        fields: _.chain(widgetsSchema)
          .get('actions.fields', [])
          .pickBy((action) => action.position === 'tile.edit.form')
          .cloneDeep()
          .each((action) => {
            action.position = 'form.bottom';
          })
          .value(),
      };

      const fullName = _.startCase(`${type} tiles`);
      const schemaName = _.kebabCase(fullName);

      return {
        type: 'Schema',
        schemaName,
        fullName,
        fields,
        actions,
      };
    }

    return {
      editWidget,
      exportToPng,
      editSubTile,
      removeSubTileWidget,
      applyAndView,
      saveTiles,
      cancelSubmitTile,
      submitTile,
      applyTile,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').controller('AdpWidgetEmbedController', AdpWidgetEmbedController);

  /** @ngInject */
  function AdpWidgetEmbedController(
    $http,
    $state,
    $scope,
    ServerError,
    AdpWidgetsHelper,
    AdpWidgetsService,
    APP_CONFIG
  ) {
    const vm = this;
    const { sharedWidgetId } = $state.params;
    const body = { sharedWidgetId };
    const url = APP_CONFIG.apiUrl + APP_CONFIG.publishedEndpointPrefix + '/w/c';

    AdpWidgetsHelper.preventAuthEffects();
    vm.isLoading = true;

    $http
      .post(url, body)
      .then((result) => {
        const { data, success, message } = result.data;
        if (!success) {
          throw new ServerError(message);
        }

        const board = { isEmbedded: true };
        const tiles = _.chain(data)
          .get('widgetConfiguration.tiles')
          .map((t) => AdpWidgetsService.tileFromRow(t, '', board, $scope))
          .value();

        const { widgetRow, widgetConfiguration, widgetDatasource } = data;
        const INTERFACE = window.adpAppStore.appInterface();
        const appSchema = window.adpAppStore.appModel();
        const config = _.cloneDeep(APP_CONFIG);
        const { type: widgetType, styling } = widgetRow;
        const widgetSchema = _.get(INTERFACE, ['widgets', widgetType]);

        _.set(styling, 'header.showTitle', 'never');
        AdpWidgetsHelper.setManifestFile(widgetRow);

        vm.tile = {
          widgetSchema,
          widgetRow,
          widgetConfiguration,
          widgetDatasource,
          appSchema,
          config,
          position: 'embedded.view',
          data: {
            styling,
          },
          tiles,
          board: { isEmbedded: true },
        };
      })
      .catch((err) => {
        vm.errorMessage = err.message || err;
      })
      .finally(() => {
        vm.isLoading = false;
      });
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetFactory', adpWidgetFactory);

  /** @ngInject */
  function adpWidgetFactory($compile, AdpWidgetsService, AdpCustomCss) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        tile: '<',
      },
      link: function (scope, element) {
        if (!scope.interface) {
          scope.interface = _.get(scope, 'tile.board.interface');
        }
        scope.args = AdpWidgetsService.getWidgetUnifiedArgs(scope.tile);

        const widgetRow = _.get(scope, 'tile.widgetRow') || {};
        const componentName = _.get(scope, 'args.widgetSchema.component');
        const template = `<${componentName} interface='interface' args='args' tile='tile'/>`;
        const $res = $compile(template)(scope);
        const { _id, type } = widgetRow;
        const widgetCss = _.get(widgetRow, 'advanced.widgetCss');
        const removeCssHandler = AdpCustomCss.setStyleElement(widgetCss, _id, $res);
        element.on('$destroy', removeCssHandler);
        element
          .empty()
          .append($res)
          .removeClass()
          .addClass('adp-widget-container adp-widget-' + type)
          .addClass(_.get(widgetRow, 'advanced.widgetCssClasses') || []);
      },
    };
  }
})();
;(function () {
  angular.module('app.aggregationPipeline').factory('AggregationPipelineActions', AggregationPipelineActions);

  /** @ngInject */
  function AggregationPipelineActions(
    APP_CONFIG,
    AdpNotificationService,
    AdpUnifiedArgs,
    ErrorHelpers,
    $http,
    AdpSocketIoService,
    AdpFormActions,
    AdpGeneratorModalService,
    AdpModalFormService,
    AdpModalService
  ) {
    function previewPipelineResult(args) {
      const { row } = this;

      return _generateCustomPresentation(args).then(
        (presentation) =>
          AdpModalService.createModal('aggregationPipelineDataPreview', {
            row,
            presentation,
            windowClass: 'aggregation-pipeline-data-preview-dialog',
          }).result
      );
    }

    function applyAndRun(args, formHooks) {
      const updatePaths = undefined;
      const customMutatorName = `${args.modelSchema.schemaName}UpdateOneWithDataset`;
      args.mutationArgs = [updatePaths, customMutatorName];

      return _getCvParameters
        .apply(this)
        .then(({ data }) => data)
        .then((pipelineParams) =>
          AdpFormActions.apply.call(this, args, formHooks).then(() => _runPipeline.apply(this, [true, pipelineParams]))
        );
    }

    function runPipeline() {
      const { name } = this.row;
      const message = `Are you sure to run '${name}' Custom View with default parameters applied?`;
      const extraButtonText = 'Edit this CV';
      const extraButtonCb = () => {
        const params = {
          schemaName: '_aggregationPipelines',
          recordId: _.get(this, 'row._id'),
          action: 'update',
        };
        AdpModalFormService.openForm(params);
      };
      return AdpModalService.confirm({ message, extraButtonText, extraButtonCb }).then(() =>
        _runPipeline.apply(this, [false])
      );
    }

    function _runPipeline(ignoreDisabledState, pipelineParams) {
      const context = this;
      const socketMessageProcessor = (data) => {
        if (data.type === 'aggregationPipeline') {
          const { message } = data;
          const { status } = data.data;
          const notifyMethod = status === 'error' ? 'notifyError' : 'notifySuccess';

          AdpNotificationService[notifyMethod](message);

          if (status === 'start') {
            return;
          }

          AdpSocketIoService.unRegisterMessageProcessor(socketMessageProcessor);
        }
      };
      const { disabled, _id } = context.row;
      if (!ignoreDisabledState && disabled) {
        AdpNotificationService.notifyError('Unable to run disabled CV here. Please use Apply&Run on Update form.');
        return;
      }

      const body = { _id };
      if (pipelineParams) {
        body.pipelineParams = pipelineParams;
      }
      const url = `${APP_CONFIG.apiUrl}/runPipeline`;

      AdpSocketIoService.registerMessageProcessor(socketMessageProcessor);

      return $http
        .post(url, body)
        .then(({ data }) => {
          if (!data.success) {
            throw new Error(data.message);
          }
        })
        .catch((error) => {
          AdpSocketIoService.unRegisterMessageProcessor(socketMessageProcessor);
          error && ErrorHelpers.handleError(error);
        });
    }

    function pipelineParametersSubmitAction(args, formHooks) {
      formHooks.onComplete && formHooks.onComplete(args, args.row);
    }

    function _getCvParameters() {
      const formData = _.get(this, 'row.lastParameters') || _getCvParametersDefaults.apply(this);
      const schema = _getCvParametersFormSchema.apply(this);

      const parameters = _.get(this, 'row.parameters') || [];
      const paramStr = parameters.length ? ' with following parameters' : '';
      const formHeaderText = `Are you sure to run '${this.row.name}' Custom View${paramStr}?`;

      const modalOptions = {
        args: AdpUnifiedArgs.getHelperParamsWithConfig({ path: '', formData, schema }),
        formOptions: { formHeaderText },
      };

      return AdpGeneratorModalService.formModal(modalOptions);
    }

    function _getCvParametersFormSchema() {
      const schema = {
        fullName: 'Pipeline parameters',
        actions: {
          fields: {
            setPipelineParameters: {
              fullName: 'Set Pipeline Parameters',
            },
            runPipe: {
              fullName: 'Run pipeline',
              position: 'form.bottom',
              description: 'Submit form data',
              action: {
                type: 'module',
                link: 'AggregationPipelineActions',
                method: 'pipelineParametersSubmitAction',
              },
              actionOrder: 3,
              hotKey: 'Enter',
              htmlAttributes: {
                className: 'adp-action-b-primary',
              },
              actionName: 'runPipe',
            },
            canselSubmit: {
              fullName: 'Cancel',
              position: 'form.bottom',
              description: 'Cancel',
              action: {
                type: 'module',
                link: 'AdpFormActions',
                method: 'cancel',
              },
              actionOrder: 1,
              hotKey: 'Escape',
              htmlAttributes: {
                className: 'adp-action-b-secondary',
              },
              actionName: 'cancelSubmit',
            },
          },
        },
      };

      const commonFieldFields = {
        permissions: { view: true },
        showInForm: true,
        showFormLabel: true,
      };

      _.each(this.row.parameters, ({ key, type }) => {
        const field = {
          type,
          fieldName: key,
          fullName: _.startCase(key),
        };
        _.set(schema, ['fields', key], { ...commonFieldFields, ...field });
      });

      return schema;
    }

    function _getCvParametersDefaults() {
      const parameters = _.get(this, 'row.parameters') || [];
      return _.fromPairs(_.map(parameters, ({ key, defaultValue }) => [key, defaultValue]));
    }

    function viewPipelineSpecification() {
      const { row } = this;

      return AdpModalService.createModal('aggregationPipelineSpecification', { row }).result;
    }

    function _generateCustomPresentation(args) {
      const fn = _.get(window.appModelHelpers, 'FrontendLists.aggregationPipelineStageFieldsList');
      const stagesCount = _.get(args, 'row.stages.length', 0);

      _.set(args, 'customData.aggregationPipelineStage', stagesCount);

      return fn.call(args).then((fields) =>
        _.map(fields, (f) => ({
          name: f.name,
          title: f.fullName,
          visible: true,
          type: f.type || 'String',
          searchable: true,
          width: '',
        }))
      );
    }

    return {
      previewPipelineResult,
      viewPipelineSpecification,
      applyAndRun,
      runPipeline,
      pipelineParametersSubmitAction,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommandRunner')
    .component('adpCommandRunnerModal', {
      templateUrl: 'client-modules/adp-command-runner/adp-command-runner-modal/adp-command-runner-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller(AdpUnifiedArgs, AdpModalFormService) {
        var vm = this;

        vm.$onInit = function () {
          vm.options = vm.resolve.options;
          const commandArgs = vm.resolve.options.args;
          const parameters = _.get(commandArgs, `row.parameters`) || [];
          vm.isEmpty = _.isEmpty(parameters);

          const unifiedArgsOptions = {
            path: '',
            action: 'bjrCommand',
            formData: { parameters },
          };
          const parametersFieldScheme = _.cloneDeep(_.get(commandArgs, `modelSchema.fields.parameters`));
          _.set(parametersFieldScheme, "parameters.expanded", true);
          _.set(parametersFieldScheme, 'fields.defaultValue.permissions.create', false);
          _.set(parametersFieldScheme, 'fields.defaultValue.permissions.update', false);
          _.set(parametersFieldScheme, 'fields.value', {
            type: 'String',
            fieldName: "value",
            fullName: "Value For The Current Command Run",
            description: "Leave empty to apply default value",
            parameters: { visible: true },
            "showFormLabel": true,
            "showInForm": true,
            permissions: { view: true, create: true, update: true },
          });

          vm.args = AdpUnifiedArgs.getHelperParamsWithConfig({
            schema: {
              type: 'Schema',
              fields: vm.isEmpty ? {} : { parameters: parametersFieldScheme },
            },
            ...unifiedArgsOptions,
          });
        };

        vm.onEdit = function () {
          const recordId = _.get(vm, 'options.args.fieldSchema.action.parameters._id') || '';
          const params = {
            schemaName: 'bjrExternalCommands',
            recordId,
            action: 'update'
          }
          AdpModalFormService.openForm(params);
          vm.dismiss({ $value: 'cancel' });
        };

        vm.onCancel = function () {
          return vm.dismiss({ $value: 'cancel' });
        };

        vm.formOptions = {
          localActionsStrategy: {
            submit(args) {
              return Promise.resolve()
                .then(() => {
                  const $value = vm.isEmpty ? null : args.row;
                  vm.close({ $value });
                  return $value;
                });
            },
          },
          disableFullscreen: true,
        };
      },
      controllerAs: 'vm'
    });
})();
;;(function () {
  angular.module('app.adpFormActions')
    .factory('AdpCopyPasteActionService', AdpCopyPasteActionService);

  // TODO: handle error for compression and json parse or stringify
  // TODO: validation of record by schema
  const promisify = (func) => {
    return (...args) => {
      return new Promise((resolve, reject) => {
        func(...args, (err, res) => err
          ? reject(err)
          : resolve(res)
        );
      });
    }
  }

  const attempt = (fn, ...args) => {
    const parseResult = _.attempt(fn, ...args);

    if (_.isError(parseResult)) {
      throw parseResult;
    }

    return parseResult;
  }

  const gzip = promisify(fflate.deflate);
  const gunzip = promisify(fflate.inflate);

  function AdpCopyPasteActionService(
    AdpFormIteratorUtils,
    AdpModalService,
    AdpUnifiedArgs,
    AdpNotificationService,
    AdpFormActionHelpers
  ) {
    return {
      compress(record) {
        const jsonString = attempt(JSON.stringify, record);
        const escapedJson = window.escape(jsonString);
        const u8JsonString = fflate.strToU8(escapedJson, true);

        return gzip(u8JsonString, { level: 9 })
          .then(compressedData => fflate.strFromU8(compressedData, true))
          .then(window.btoa);
      },

      decompress(compressedRecord) {
        const u8String = window.atob(compressedRecord);
        const u8Data = fflate.strToU8(u8String, true);

        return gunzip(u8Data)
          .then((uncompressedData) => {
            const uncompressedString = fflate.strFromU8(uncompressedData, true)
            const jsonString = window.unescape(uncompressedString);
            return attempt(JSON.parse, jsonString);
          });
      },

      callAction(args) {
        const openForm = () => AdpModalService.createModal('adpCopyPasteModal', {
          args,
          size: 'lg',
        }).result;

        return openForm()
          .then(r => {
            const record = _.get(r, 'record');
            if (record) {
              AdpFormActionHelpers.updateRecord(args, record);
            }
          });
      }
    }
  }
})();
;;(function () {
  angular.module('app.adpFormActions')
    .factory('AdpVcsActionService', AdpVcsActionService);

  function AdpVcsActionService(
    AdpModalService,
    AdpFormActionHelpers,
    AdpNotificationService
  ) {
    return {
      callAction(args) {
        args.action = 'update';
        const openForm = () => AdpModalService.createModal('adpVcsModal', {
          args,
          size: 'lg',
        }).result;

        return openForm()
          .then(({ action = 'cancel', data }) => {
            const afterModalFns = {
              load: updateForm,
              save: saveVCS,
              cancel: _.noop,
            };

            const selectedMethod = afterModalFns[action];
            selectedMethod(args, data);
          })
          .catch(err => {
            console.log('Error while processing vcs: ', err);
          });
      },

      callSaveModal(args) {
        const openForm = () => AdpModalService.createModal('adpSaveVcsModal', {
          args,
          size: 'lg',
        }).result;

        return openForm()
          .catch(err => {
            console.log('Error while processing vcs: ', err);
          });
      }
    }

    function updateForm(args, vcsRecord) {
      AdpFormActionHelpers.updateRecord(args, vcsRecord.data);
      AdpNotificationService.notifySuccess('Form data successfully updated.');
    }

    function saveVCS() {
      AdpNotificationService.notifySuccess('Form state saved to Content Version Control Log.');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
    .directive('adpVcsRecordInfo', adpVcsRecordInfo);

  function adpVcsRecordInfo() {
    const template = `
      <div class="adp-row" style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
        <div class="adp-col-12">
           <div
                ng-if="args"
                class="view-details-cell"
            >
              <div 
                ng-if="!args"
                class="view-details-label"
              >
                Selected record
              </div>
              
              <adp-record-details-cell args="args"></adp-record-details-cell>
            </div>
        </div>
      </div>`;

    return {
      restrict: 'E',
      scope: {
        args: '<',
      },
      template,
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeChoroplethLayer', AdpGlobeChoroplethLayer);

  /** @ngInject */
    function AdpGlobeChoroplethLayer(AdpGradientService) {
    const geoJsonCache = {};

    function update({ data, layer, globe, args }) {
      _getJsonData(layer, args).then(geoJson => _setPolygons({ geoJson, data, layer, globe, args }))
    }

    return {
      update,
    };

    function _setPolygons({ geoJson, data, layer, globe, args }) {
      const featureFilter = _getFeatureVisibilityFilterFn(layer, data);

      const polygons = _.filter(geoJson.features, featureFilter);
      const sideMaterial = new THREE.MeshLambertMaterial({
        color: '#888800',
        transparent: true,
        opacity:.2,
      });
      const colorAccessor = _getColorAccessor({ data, layer });
      globe
        .polygonStrokeColor(colorAccessor)
        .polygonsTransitionDuration(0)
        .polygonCapColor(colorAccessor)
        .polygonSideMaterial(sideMaterial)
        .polygonAltitude(_getElevationAccessor({ data, layer }))
        .polygonsData(polygons);
    }

    function _getJsonData(layer, args) {
      const geoJsonTypes = _.get(args, 'widgetConfiguration.geoJsonTypes', {});
      const fields = geoJsonTypes[layer.row.geoJson];
      const url = fields.dataUrl ? args.config.resourceUrl + fields.dataUrl : fields.externalDataUrl;

      if (url) {
        const geoJson = geoJsonCache[url];
        if (geoJson) {
          return Promise.resolve(geoJson)
        }
        return fetch(url)
          .then((res) => res.json())
          .then(geoJson => {
            geoJsonCache[url] = geoJson;
            return geoJson;
          })
      } else {
        throw new Error('Layer have no correct URL data');
      }
    }

    function _getFeatureVisibilityFilterFn(layer, data) {
      const { featureField } = layer.row;
      if (!featureField) {
        return true;
      }
      return feature => !!_findRecordForFeature(feature, featureField, data);
    }

    function _findRecordForFeature(feature, featureField, data) {
      return _.find(data, (row) => _.get(feature, ['properties', featureField]) === row.feature);
    }

    function _getColorAccessor({ data, layer }) {
      const { featureField } = layer.row;
      return feature => {
        const item = _findRecordForFeature(feature, featureField, data);

        const colorMode = layer.row.colorMode;

        if (colorMode === 'gradient') {
          const gradient = _.get(layer.row, 'gradient.data.row', {});
          const value = item.colorValue;
          const min = _.get(layer.row, 'gradientMinValue', 0);
          const max = _.get(layer.row, 'gradientMaxValue', 100);

          return AdpGradientService.mapValue(gradient, value, min, max);
        }

        return item.colorString || '#ffffff';
      }
    }

    function _getElevationAccessor({ data, layer }) {
      const { featureField } = layer.row;
      return feature => {
        const item = _findRecordForFeature(feature, featureField, data);
        return !item || _.isNil(item.elevation) ? 0.02 : item.elevation;
      }
    }
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeCirclesLayer', AdpGlobeCirclesLayer);

  /** @ngInject */
  function AdpGlobeCirclesLayer() {
    function create({ globe }) {
      globe.pointsTransitionDuration(0).pointAltitude('elevation').pointRadius('radius').pointColor('colorString');
    }

    function update({ data, globe }) {
      globe.pointsData(data);
    }

    function setOpacity({ globe, layer, opacity }) {
      globe.pointColor((point) => {
        const color = new THREE.Color(point.colorString);
        const hexStr = color.getHexString();
        const hexOpacity = Math.round(opacity * 255)
          .toString(16)
          .padStart(2, '0');
        return `#${hexStr}${hexOpacity}`;
      });
    }

    return {
      create,
      update,
      setOpacity,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeSatellitesLayer', AdpGlobeSatellitesLayer);

  /** @ngInject */
  function AdpGlobeSatellitesLayer() {
    function create({ globe, layer, args}) {
      const { workersNumber = 1, shapeParam1 = 4, shapeParam2 = 4 } = layer.row;
      const api = _.get(args, 'layersApi.satellites', {});
      const visualisationType = _.get(args, 'row.globe.visualisationType');
      const workerUrl = window.location.origin + _.get(args,  'widgetConfiguration.satelliteWorkerUrl', '/api/public/js/workers/sat-tracker-worker.js')

      _remixTimeRenderApi({layer, api, args});
      _setSatellitesCountHookApi({layer, api, args});

      const satEngineConfig = {
        globe,
        workerUrl,
        workersNumber,
        satMeshRadialSegments: shapeParam1,
        satMeshLengthSegments: shapeParam2,
        visualisationType,
        api,
      };

      layer.adpSatEngine = new window.adpApi.AdpSatEngine(layer);
      layer.onDestroy = () => {
        layer.adpSatEngine.destroy();
        layer.adpSatEngine = null;
      };

      const parameters = {
        timeAcceleration: _.get(layer, 'row.timeAcceleration', 10),
        refreshRate: _.get(layer, 'row.refreshRate', 250), // FPS interval
        approximationAngle: _.get(layer, 'row.approximationAngle', 8),
        displayOrbitRevolutions: _.get(layer, 'row.displayOrbitRevolutions', 1),
        sizeMultiplier: _.get(layer, 'row.sizeMultiplier', 1),
        selectionIds: [],
      };

      return layer.adpSatEngine.init(satEngineConfig).then(ret=>{
        layer.adpSatEngine.adjustParameters(parameters);
        return ret;
      });
    }

    function _remixTimeRenderApi({ layer, api, args }) {
      const currentRenderer = _.get(api, 'timeRenderer');
      const showCurrentTimestamp = _.get(layer, 'row.showCurrentTimestamp');
      let timeChangeCb = null;
      const newRenderer = (nowTime) => {
        currentRenderer && showCurrentTimestamp && currentRenderer(nowTime);
        timeChangeCb && timeChangeCb(nowTime);
      };
      _.set(api, 'timeRenderer', newRenderer);
      const widgetId = _.get(args, 'row._id');
      const layerId = layer._id;
      _.set(window, `adp.dashboard.widgets.${widgetId}.${layerId}.hookOnTimeChange`, onTimeChangeHook);

      function onTimeChangeHook(cb) {
        timeChangeCb = cb;
      }
    }

    function _setSatellitesCountHookApi({ layer, api, args }) {
      const widgetId = _.get(args, 'row._id');
      const layerId = layer._id;
      let satCountChangeCb = null;

      _.set(api, 'onSatCountChange', changeCb);
      _.set(window, `adp.dashboard.widgets.${widgetId}.${layerId}.onTotalDisplayedRecordCountChange`, hook);

      function changeCb(count) {
        satCountChangeCb && satCountChangeCb(count);
      }

      function hook(cb) {
        satCountChangeCb = cb;
      }
    }

    function update({ layer, data }) {
      if (!layer.adpSatEngine.isInitialised) {
        console.log('Satellite engine is not ready yet');
        return;
      }

      layer.adpSatEngine.setSatData(data);
      layer.adpSatEngine.adjustParameters({ selectionIds: [] });
    }

    function updateParameters({ layer, selection }) {
      if (!layer.adpSatEngine.isInitialised) {
        console.log('Satellite engine is not ready yet');
        return;
      }

      const parameters = {};
      const transformers = {
        selectionIds: (value) => _.slice(value, 1),
        currentTime: (value) => new Date(_.get(value, '1')).getTime(),
        _default: (value) => _.get(value, '1'),
      };

      _.each(selection, (value, paramName) => {
        const transformer = transformers[paramName] || transformers._default;
        parameters[paramName] = transformer(value);
      });

      layer.adpSatEngine.adjustParameters(parameters);
    }

    function setOpacity({ layer, opacity }) {
      if (!layer.adpSatEngine.isInitialised) {
        return;
      }

      const isChanged = (layer.opacity !== 0) ^ (opacity !== 0);

      if (isChanged) {
        layer.adpSatEngine.setOpacity(opacity);
        layer.opacity = opacity;
      }
    }

    return {
      create,
      update,
      updateParameters,
      setOpacity,
    };
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeTextureLayer', AdpGlobeTextureLayer);

  /** @ngInject */
  function AdpGlobeTextureLayer() {
    function update({ globe, layer, data, args }) {
      const type = layer.row.texture;
      let template;
      if (type === 'customFromDataset') {
        template = _.get(data, '0.textureString', '');
      } else {
        const textures = _.get(args, 'widgetConfiguration.surfaceTextures', {});
        const texture = textures[layer.row.texture];
        template = texture.url;
      }

      const url = _getUrl(template, { ...args, layer });

      globe.globeImageUrl(url);
    }

    function _getUrl(template, context) {
      if (!template.includes('this')) {
        return template;
      }

      try {
        const fn = new Function(`return ${template}`);
        return fn.call(context);
      } catch (e) {
        return template;
      }
    }

    return {
      update,
    };
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpGridRowActions').component('adpRawRecordView', {
    templateUrl: "client-modules/adp-grid-row-actions/raw-record-view/adp-raw-record-view.html",
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpRawRecordViewController',
    controllerAs: 'vm',
  });
})();
;(function () {
  'use strict';

  angular.module('app.adpGridRowActions')
    .controller('AdpRawRecordViewController', AdpRawRecordViewController);

  /** @ngInject */
  function AdpRawRecordViewController(AdpUnifiedArgs) {
    const vm = this;

    vm.$onInit = doInit;
    vm.doClose = () => vm.close();

    function doInit() {
      const data = _.get(vm, 'resolve.options.data', {});
      vm.schemaName = _.get(vm, 'resolve.options.schemaName');
      vm.fieldArgs = mockUnifiedArgs(data);
      vm.options = { height: '75vh' };
    }

    function mockUnifiedArgs(data) {
      const args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        formData: data,
        schema: {},
        action: 'viewDetails'
      });
      args.fieldSchema = {
        type: 'Mixed',
        fieldName: 'rawRecord'
      };
      args.data = data;

      const selectorToRecogniseDataType = '.adp-raw-record-modal .name-rawRecord .dx-tab-selected .dx-tab-text';
      _.set(args, 'customData.dataTypeTabSelector', selectorToRecogniseDataType);

      return args;
    }
  }
})();
;(function () {
  angular.module('app.adpGridstack').component('adpGsDashboardMap', {
    templateUrl: 'client-modules/adp-gridstack/adp-gs-dashboard-map/adp-gs-dashboard-map.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpGsDashboardMapController',
    controllerAs: 'vm',
  });
})();
;(function () {
  angular.module('app.adpGridstack').controller('AdpGsDashboardMapController', adpGsDashboardMap);

  /** @ngInject */
  function adpGsDashboardMap($timeout, AdpCodeLoadHelper) {
    const vm = this;

    vm.$onInit = function () {
      vm.options = vm.resolve.options;

      return AdpCodeLoadHelper.loadVendorGroup('echarts').then(() => {
        $timeout(initGraph, 600);
      });
    };

    vm.confirm = () => vm.close({ confirmed: true });
    vm.cancel = () => vm.dismiss({ confirmed: false });

    function initGraph() {
      const { echartsTheme = 'light' } = window.adpAppStore.appInterface();
      const [chartEl] = $('#mapContainer');
      // eslint-disable-next-line no-undef
      const chart = echarts.init(chartEl, echartsTheme);
      const WIDGET_COLOR = 'slateblue';
      const LAYER_COLOR = 'steelblue';
      const CONTROL_SLIDER_COLOR = 'green';
      const WIDGET_SLIDER_COLOR = 'mediumseagreen';
      const PARAM_COLOR = 'orange';
      const LOST_COLOR = 'pink';
      const nodeTypes = {
        widget: {
          name: 'Widget',
          symbol: 'rect',
          symbolSize: [150, 50],
          itemStyle: {
            color: WIDGET_COLOR,
          },
        },
        layer: {
          name: 'Data layer',
          symbol: 'rect',
          symbolSize: [80, 25],
          itemStyle: {
            color: LAYER_COLOR,
          },
        },
        param: {
          name: 'Parameter',
          symbol: 'circle',
          symbolSize: 45,
          itemStyle: {
            color: PARAM_COLOR,
          },
        },
        lostLink: {
          name: 'Lost link',
          symbol: 'rect',
          symbolSize: [80, 25],
          itemStyle: {
            color: LOST_COLOR,
          },
        },
        controlSlider: {
          name: 'Slider',
          symbol: 'circle',
          symbolSize: 40,
          itemStyle: {
            color: CONTROL_SLIDER_COLOR,
          },
        },
        widgetAsSlider: {
          name: 'Slider',
          symbol: 'circle',
          symbolSize: 40,
          itemStyle: {
            color: WIDGET_SLIDER_COLOR,
          },
        },
      };
      const linkTypes = {
        w2w: {
          lineStyle: {
            width: 4,
            color: WIDGET_COLOR,
          },
          value: 5,
        },
        widgetClone: {
          lineStyle: {
            width: 1,
            type: 'dashed',
            color: 'silver',
          },
          name: 'Same widget',
          value: 0.2,
        },
        w2l: {
          lineStyle: {
            width: 4,
            color: LAYER_COLOR,
          },
          value: 5,
        },
        w2s: {
          lineStyle: {
            width: 4,
            color: WIDGET_SLIDER_COLOR,
          },
          value: 5,
        },
        w2p: {
          lineStyle: {
            width: 2,
            color: PARAM_COLOR,
          },
          value: 5,
        },
        s2p: {
          value: 1,
          symbolSize: 6,
        },
      };
      const data = assignTypes(vm.options.nodes, nodeTypes, false);
      const links = assignTypes(vm.options.links, linkTypes, true);
      const chartOptions = {
        tooltip: {
          // hideDelay: 2000,
          // triggerOn: 'click',
          // extraCssText: 'pointer-events:all;color:red;',
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: (params) => `${params.data.typeName} ${params.name} ${params.data.info || ''}`,
        },
        series: [
          {
            type: 'graph',
            draggable: true,
            roam: true,
            label: {
              show: true,
            },
            categories: _.map(nodeTypes, (x) => x),
            layout: 'force',
            data,
            links,
            edgeSymbol: ['none', 'arrow'],
            edgeSymbolSize: 14,
            force: {
              repulsion: 1000,
              initLayout: null,
              gravity: 0.1,
              friction: 0.6,
              edgeLength: [80, 390],
              layoutAnimation: true,
            },
          },
        ],
      };
      chart.setOption(chartOptions);
      chart.on('click', onNodeClick);
    }

    function onNodeClick(params) {
      vm.nodeInfo = getNodeInfo(params.data);
    }

    function assignTypes(data, types, mixin) {
      const indexes = mixin ? null : _.fromPairs(_.map(_.toPairs(types), ([key], index) => [key, index]));
      return _.map(data, ({ type, ...item }) => {
        const fromType = mixin ? types[type] || {} : {};
        const typeName = _.startCase(type);
        if (item.name) {
          item.name = item.name.replace(/\s(\(\w+\))/, '\n$1');
        }
        const res = { typeName, ...fromType, ...item };
        if (!mixin) {
          res.category = indexes[type];
        }

        return res;
      });
    }

    const infoMap = {
      c0: ({ widgetId }) => `Widget id ${widgetId}`,
      c1: ({ layerId }) => `Layer id ${layerId}`,
      c2: ({ id }) => `Parameter id=${id}`,
    };

    function getNodeInfo(node) {
      const { category } = node;
      const infoFactory = infoMap[`c${category}`];
      if (infoFactory) {
        return infoFactory(node);
      }
      return '';
    }
  }
})();
;(function () {
  angular.module('app.adpGridstack').controller('AdpGsEmbedController', AdpGsEmbedController);

  /** @ngInject */
  function AdpGsEmbedController(APP_CONFIG, AdpGsService, AdpWidgetsHelper, ServerError, $element, $state, $http) {
    const vm = this;
    const editInterface = {
      toggleMinimize: onTileMinimize,
      toggleMaximize: onTileMaximize,
      getBoardData,
    };
    let boardLayers;
    vm.board = null;
    vm.isLoading = true;

    const dashboardLoadPromise = getBoard()
      .then((data) => {
        const { dashboard, widgetActions } = data;
        if (!_.isEmpty(widgetActions)) {
          // Force vital data into schema to make widget's headers work fine with actions
          setSchemaWidgetsActions(widgetActions);
        }
        return dashboard;
      })
      .then(AdpGsService.transformBoardRecord)
      .then(AdpGsService.boardFromRow);

    AdpWidgetsHelper.preventAuthEffects();
    AdpGsService.initializeDashboard(false, dashboardLoadPromise, editInterface, true)
      .then(onInitialize)
      .finally(() => {
        vm.isLoading = false;
      })
      .catch((err) => {
        vm.errorMessage = err.message || err;
      });

    function onInitialize({ board, layers, css }) {
      vm.board = board;
      vm.boardCss = css.boardCss;
      vm.containerCss = css.containerCss;
      vm.bgCss = css.bgCss;
      vm.stretchBg = _.get(board, 'data.styling.dimensions.stretchBackgroundBeyondDashboard');
      vm.boardClass = {
        'adp-gs-fits-height': _.get(board, 'data.rowHeightStrategy', 'square') !== 'square',
      };
      boardLayers = layers;
      const themes = _.get(board, 'data.styling.themes');
      if (themes) {
        AdpGsService.setThemes(themes);
      }

      $(window).on('resize', boardLayers.onWindowResize);
      _.defer(boardLayers.onWindowResize);
      $element.on('$destroy', () => {
        $(window).off('resize', boardLayers.onWindowResize);
      });
      setTimeout(boardLayers.onWindowResize, 200);
    }

    function onTileMinimize(id) {
      boardLayers.toggleMinimizeTile(vm.board.tiles.find((t) => t.id === id));
    }

    function onTileMaximize(id) {
      boardLayers.toggleMaximizeTile(vm.board.tiles.find((t) => t.id === id));
    }

    function getBoard() {
      const { sharedDashboardId } = $state.params;
      const body = { sharedDashboardId };
      const url = `${APP_CONFIG.apiUrl + APP_CONFIG.publishedEndpointPrefix}/d/c`;

      return $http.post(url, body).then((result) => {
        const { data, success, message } = result.data;
        if (!success) {
          throw new ServerError(message);
        }
        return data;
      });
    }

    function setSchemaWidgetsActions(widgetActions) {
      const appModel = window.adpAppStore.appModel();
      const currentActions = _.get(appModel, '_widgets.actions.fields', {});
      const updatedActions = { ...currentActions, ...widgetActions };
      _.set(appModel, '_widgets.actions.fields', updatedActions);
    }

    // ToDO: reuse this from
    function getBoardData() {
      return {
        board: vm.board,
        boardArgs: vm.boardArgs,
        boardLayers: vm.boardLayers,
      };
    }
  }
})();
;(function () {
  angular.module('app.adpGridstack').factory('AdpGsFloatApi', AdpGsFloatApi);

  const REALLY_TOP_ZINDEX = 100000;

  function AdpGsFloatApi($timeout) {
    return function (editMode, board, onChangeCallback) {
      const FLOAT_LAYER_ID = '#adp-float-layer';
      const MINIMIZED_CLASS_NAME = 'adp-tile-minimized';
      const FLYING_CLASS_NAME = 'adp-tile-flying';
      const floatingTiles = {};
      const layerContainer = $(FLOAT_LAYER_ID);

      function addTile(tile, params) {
        const { id } = tile;
        const $element = $(`<div class="adp-tile adp-tile-floating" gs-id="${id}">`);
        const isMinimized = !!tile.data.isMinimized;
        const zPosition = 1;

        floatingTiles[id] = {
          id,
          $element,
          zPosition,
          tile,
        };

        layerContainer.append($element);
        resetTileFrameOptions(tile, $element);

        $element.on('mousedown', () => _bringToFront(id)).toggleClass(MINIMIZED_CLASS_NAME, !!isMinimized);

        if (_.get(params, 'bringToFront')) {
          _bringToFront(id);
        }

        return $element;
      }

      function resetTileFrameOptions(tile, $el) {
        const options = tile.data;
        const $element = $el || getTileElemById(tile.id);
        const dragConfig = getDragConfig(tile);
        const resizeConfig = getResizeConfig(tile);

        dragConfig && $element.draggable(dragConfig);
        resizeConfig && $element.resizable(resizeConfig);

        const css = {
          ...rowToPositionAndSize(options),
        };
        tile._originalCss = css;

        $element.css(css);
      }

      function getDragConfig(tile) {
        const { floatingPositionX, floatingPositionY, floatingWidth, floatingHeight } = tile.data;
        const freeFloatX = _isActiveDragOrResize(floatingPositionX) && floatingWidth !== 'cover';
        const freeFloatY = _isActiveDragOrResize(floatingPositionY) && floatingHeight !== 'cover';
        const isDraggable = freeFloatX || freeFloatY;

        if (!editMode && !isDraggable) {
          return;
        }

        const config = {
          containment: '#adp-dashboard-board',
          handle: '.adp-widget-blocker,.adp-tile-frame-header',
          stop: getOnDragStop(tile),
          disabled: !isDraggable,
        };

        if (freeFloatX && !freeFloatY) {
          config.axis = 'x';
        } else if (freeFloatY && !freeFloatX) {
          config.axis = 'y';
        } else {
          config.axis = false;
        }

        return config;
      }

      function getResizeConfig(tile) {
        const { floatingWidth, floatingHeight, isMinimized } = tile.data;
        const isResizableX = _isActiveDragOrResize(floatingWidth);
        const isResizableY = _isActiveDragOrResize(floatingHeight);
        const isResizable = isResizableX || isResizableY;

        if (!editMode && !isResizable) {
          return;
        }

        const config = {
          containment: '#adp-dashboard-board',
          disabled: isMinimized || !isResizable,
          stop: getOnResizeStop(tile),
          start: getOnResizeStart(tile),
        };
        const handles = [];
        const bot = isResizableY;
        const right = isResizableX;
        right && handles.push('e');
        bot && handles.push('s');
        bot && right && handles.push('se');
        config.handles = handles.join(', ') || '---';

        return config;
      }

      function _isActiveDragOrResize(val) {
        const isFree = _isValueFree(val);
        const isUnderConfig = editMode && (val === 'absolute' || val === 'relative');
        return isFree || isUnderConfig;
      }

      function _isValueFree(val) {
        return val === 'free' || _.isNull(val);
      }

      function rowToPositionAndSize(options) {
        const css = {};
        const { floatingPositionX, floatingPositionY } = options;
        if (_isValueFree(floatingPositionX)) {
          options.right = null;
        }
        if (_isValueFree(floatingPositionY)) {
          options.bottom = null;
        }

        _.each(['top', 'bottom', 'left', 'right', 'width', 'height'], (side) => {
          let value = options[side];
          if (_.isNil(value) || value === '') {
            value = 'auto';
          }
          css[side] = _addDefaultUnits(value);
        });

        return css;
      }

      function getOnDragStop(tile) {
        const { floatingPositionX, floatingPositionY } = tile.data;
        const freeFloatX = _isActiveDragOrResize(floatingPositionX);
        const freeFloatY = _isActiveDragOrResize(floatingPositionY);

        return (event, ui) => {
          const { data } = tile;
          const { top, left } = ui.position;
          if (freeFloatX) {
            if (tile._originalCss.left === 'auto') {
              data.right = layerContainer.width() - left - $(event.target).width();
            } else {
              data.left = left;
            }
          } else {
            $(event.target).css('left', tile._originalCss.left);
          }
          if (freeFloatY) {
            if (tile._originalCss.top === 'auto') {
              data.bottom = layerContainer.height() - top - $(event.target).height();
            } else {
              data.top = top;
            }
          } else {
            $(event.target).css('top', tile._originalCss.top);
          }

          _.each(['top', 'left', 'bottom', 'right'], (side) => {
            if (!_.isNil(data[side])) {
              data[side] = data[side].toString();
            }
          });
          _onChange();
        };
      }

      function getOnResizeStop(tile) {
        const { floatingWidth, floatingHeight, floatingPositionX, floatingPositionY } = tile.data;
        const isResizableX = _isActiveDragOrResize(floatingWidth);
        const isResizableY = _isActiveDragOrResize(floatingHeight);
        const freeFloatX = _isActiveDragOrResize(floatingPositionX);
        const freeFloatY = _isActiveDragOrResize(floatingPositionY);

        return (event, ui) => {
          const { $scope, data } = tile;
          const { top, left } = ui.position;
          const { width, height } = ui.size;
          if (isResizableX) {
            data.width = width;
          } else {
            $(event.target).css('width', tile._originalCss.width);
          }
          if (isResizableY) {
            data.height = height;
          } else {
            $(event.target).css('height', tile._originalCss.height);
          }
          if (freeFloatX) {
            data.left = left;
          } else {
            $(event.target).css('left', tile._originalCss.left);
          }
          if (freeFloatY) {
            data.top = top;
          } else {
            $(event.target).css('top', tile._originalCss.top);
          }

          _.each(['top', 'left', 'width', 'height'], (side) => {
            data[side] = data[side].toString();
          });

          $scope && $scope.$broadcast('widgetTileResize');

          _onChange();
        };
      }

      function getOnResizeStart() {
        return (event, ui) => {
          const { top, left } = ui.position;
          $(event.target).css('left', left);
          $(event.target).css('top', top);
        };
      }

      function removeTile(id) {
        const el = getTileElemById(id);
        el && el.remove();

        delete floatingTiles[id];
      }

      function setFixed() {}

      function getTileElemById(id) {
        return _.get(floatingTiles, [id, '$element']);
      }

      function getContainerSize() {
        return { w: layerContainer.innerWidth() - 1, h: layerContainer.innerHeight() - 1 };
      }

      function getTileActualPosition(tile) {
        const { id } = tile;
        const $element = $(`.adp-tile[gs-id="${id}"]`, layerContainer);
        const pos = $element.position();
        return {
          top: pos.top,
          left: pos.left,
          width: $element.width(),
          height: $element.height(),
        };
      }

      function _bringToFront(tileId) {
        const sorter1 = (layer) => _.get(layer, 'tile.data.zOrder') || 0;
        const sorter2 = (layer) => (layer.id === tileId ? REALLY_TOP_ZINDEX : layer.zPosition);
        const sortedByZ = _.sortBy(floatingTiles, [sorter1, sorter2]);
        let index = 1;

        _.each(sortedByZ, (layer) => {
          layer.$element.css({ zIndex: ++index });
          layer.zPosition = index;
        });
      }

      function toggleMinimize(tile) {
        const { id, data, $scope } = tile;
        data.isMinimized = !data.isMinimized;
        const { $element } = floatingTiles[id];
        const { isMinimized } = data;

        $element.resizable('instance') && $element.resizable('option', 'disabled', isMinimized);
        $element.addClass(FLYING_CLASS_NAME);

        if (isMinimized) {
          tile._originalCss.width = $element.css('width');
          tile._originalCss.height = $element.css('height');
          $element.css({ height: 25, width: 125 }).addClass(MINIMIZED_CLASS_NAME);
        } else {
          $element.css(_.pick(tile._originalCss, ['width', 'height'])).removeClass(MINIMIZED_CLASS_NAME);
        }

        $timeout(() => {
          $element.removeClass(FLYING_CLASS_NAME);

          if (!isMinimized) {
            resetTileFrameOptions(tile, $element);
            $scope && $scope.$broadcast('widgetTileResize');
          }

          _onChange();
        }, 310);
      }

      function _addDefaultUnits(value) {
        if (_.isNumber(value) || value.replaceAll(/\d/g, '') === '') {
          return `${value}px`;
        }
        return value;
      }

      function _onChange() {
        onChangeCallback && onChangeCallback();
      }

      function onWindowResize() {
        if (_.isEmpty(floatingTiles)) {
          return;
        }
        const rowHeightStrategy = _.get(board, 'data.rowHeightStrategy') || 'square';
        const dashboardFitsHeight = rowHeightStrategy !== 'square';
        const containerHeight = layerContainer.parent().height();
        const gridContainer = $('#adp-grid-stack');
        const gridContainerHeight = gridContainer.height();
        const height = dashboardFitsHeight ? containerHeight : Math.max(containerHeight, gridContainerHeight);

        layerContainer.height(dashboardFitsHeight ? 'auto' : height);

        // Need to retranslate resize event to floating tiles because
        setTimeout(() => {
          _.each(floatingTiles, (tile) => {
            const $scope = _.get(tile, 'tile.$scope');
            $scope && $scope.$broadcast('widgetTileResize');
          });
        }, 200);
      }

      return {
        removeTile,
        addTile,
        setFixed,
        getTileElemById,
        getContainerSize,
        getTileActualPosition,
        toggleMinimize,
        onWindowResize,
        resetTileFrameOptions,
      };
    };
  }
})();
;(function () {
  angular.module('app.adpGridstack').factory('AdpGsGridApi', AdpGsGridApi);

  function AdpGsGridApi($timeout) {
    return function (editMode, board) {
      const gridCommonOptions = {
        cellHeight: 'initial',
        disableOneColumnMode: true,
        column: 24, // also change in adp-gs.controller.js & dashboard.scss!
      };
      const editOptions = {
        alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent),
        draggable: { handle: '.adp-widget-blocker,.adp-tile-frame-header' },
        acceptWidgets: true,
      };
      const viewOptions = {
        float: true,
        disableDrag: true,
        disableResize: true,
      };

      const gridContainer = $('#adp-grid-stack');
      const options = _.merge(gridCommonOptions, editMode ? editOptions : viewOptions);
      const grid = GridStack.init(options, gridContainer[0]);

      if (editMode) {
        $timeout(() => {
          GridStack.setupDragIn('.grid-stack-dragin', {
            handle: 'span',
            revert: 'invalid',
            scroll: false,
            appendTo: 'body',
            helper: () => $("<div class='adp-tile-new-drag-helper'></div>")[0],
          });
        }, 500);
      }

      function removeTile(id) {
        const tile = _.find(grid.engine.nodes, (node) => node.id === id);

        grid.removeWidget(tile.el);
      }

      function addTile(tile) {
        const opts = _.clone(tile.data);
        const $element = $('<div class="grid-stack-item adp-tile">');

        opts.noResize = !!opts.positionFixed;
        opts.noMove = !!opts.positionFixed;
        opts.id = tile.id;

        grid.addWidget($element[0], opts);

        return $element;
      }

      function setFixed(id, isFixed) {
        const $el = getTileElemById(id);
        if ($el.length) {
          grid.movable($el[0], !isFixed);
          grid.resizable($el[0], !isFixed);
        }
      }

      function getTileElemById(id) {
        return $(`[gs-id=${id}]`);
      }

      function getEngine() {
        return grid;
      }

      function getCellSize() {
        return { w: grid.cellWidth(), h: grid.getCellHeight() };
      }

      function getContainerSize() {
        const boxWidth = grid.engine.column;

        return { w: boxWidth, h: boxWidth * 2 };
      }

      function onWindowResize() {
        const rowHeightStrategy = _.get(board, 'data.rowHeightStrategy') || 'square';

        setTimeout(() => {
          _.each(board.tiles, (tile) => {
            const { isFloating } = tile.data;
            if (!isFloating) {
              tile.$scope && tile.$scope.$broadcast('widgetTileResize');
            }
          });
        }, 100);

        if (rowHeightStrategy === 'square') {
          grid.cellHeight('auto');
          return;
        }

        const isHeightFixed = !!_.get(board, 'data.styling.dimensions.isFixed');
        const gapY =
          _.get(board, 'data.styling.tile.dimensions.marginTop', 0) +
          _.get(board, 'data.styling.tile.dimensions.marginBottom', 0);
        let rowsCount;
        // up to .adp-vert-column-body which is true container, with no scrollbars
        let containerHeight;
        if (isHeightFixed) {
          containerHeight = gridContainer.parent().height() - gapY;
        } else {
          containerHeight = gridContainer.parent().parent().height() - gapY;
        }
        if (rowHeightStrategy === 'fixed') {
          rowsCount = board.data.rowsCount;
        } else if (rowHeightStrategy === 'ratio16_9') {
          rowsCount = 13;
        } else if (rowHeightStrategy === 'ratio16_10') {
          rowsCount = 15;
        } else if (rowHeightStrategy === 'ratio4_3') {
          rowsCount = 18;
        }

        grid.cellHeight(containerHeight / rowsCount);
      }

      return {
        getEngine,
        addTile,
        removeTile,
        setFixed,
        getTileElemById,
        getContainerSize,
        getCellSize,
        onWindowResize,
      };
    };
  }
})();
;(function () {
  angular.module('app.adpGridstack').factory('AdpGsLayers', AdpGsLayers);

  function AdpGsLayers(AdpGsGridApi, AdpGsFloatApi, $timeout) {
    return function (editMode, board, onChangeCallback) {
      const api = {
        grid: AdpGsGridApi(editMode, board, onChangeCallback),
        float: AdpGsFloatApi(editMode, board, onChangeCallback),
      };

      function addTile(tile, options) {
        return _getApiMethod('addTile', tile.id)(tile, options);
      }

      function removeTile(id) {
        return _getApiMethod('removeTile', id)(id);
      }

      function setFixed(id, isFixed) {
        return _getApiMethod('setFixed', id)(id, isFixed);
      }

      function getTileElemById(id) {
        return _getApiMethod('getTileElemById', id)(id);
      }

      function toggleMinimizeTile(tile) {
        if (tile.isMaximized) {
          toggleMaximizeTile(tile);
        }

        return _getApiMethod('toggleMinimize', tile.id)(tile);
      }

      function toggleMaximizeTile(tile) {
        tile.isMaximized = !tile.isMaximized;
        const WELL_AFTER_FLYING_ANIMATION = 500;
        const { id, data, $scope } = tile;
        const { isFloating } = data;
        const { isMaximized } = tile;
        const $gridCell = getTileElemById(id);
        const $maxContainer = $('.adp-dashboard-maximize-container');
        const parentBox = $maxContainer.parent();
        const parentOffset = parentBox.offset();
        const $adpWidgetTile = $('>adp-widget-tile', isMaximized ? $gridCell : $maxContainer);
        const gridCellOffset = $gridCell.offset();
        const gridCellAbsPosition = {
          left: gridCellOffset.left - parentOffset.left,
          top: gridCellOffset.top - parentOffset.top + parentBox.scrollTop(),
          width: $gridCell.width(),
          height: $gridCell.height(),
        };

        if (isMaximized) {
          $maxContainer.css(gridCellAbsPosition);
          $timeout(() => {
            $maxContainer.append($adpWidgetTile).addClass('flying').css({
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
            });
          });
        } else {
          const $homelandEl = $(`[gs-id=${id}]`);
          $maxContainer.css(gridCellAbsPosition).addClass('flying');
          $timeout(() => {
            $adpWidgetTile.appendTo($homelandEl);
            $maxContainer.css({ width: null, height: null });
          }, WELL_AFTER_FLYING_ANIMATION);
          if (isFloating) {
            const { x, y } = data;
            $gridCell.css({ left: x, top: y });
          }
        }

        // This creepy code should be synced with CSS transition
        // type of .adp-dashboard-maximize-container.flying class with is 300ms by now
        for (let i = 100; i < WELL_AFTER_FLYING_ANIMATION; i += 100) {
          $timeout(() => $scope.$broadcast('widgetTileResize'), i);
        }
        $timeout(() => $maxContainer.removeClass('flying'), WELL_AFTER_FLYING_ANIMATION);
      }

      function _getApiMethod(methodName, tileId) {
        const type = _isTileFloats(tileId) ? 'float' : 'grid';

        return api[type][methodName];
      }

      function _isTileFloats(id) {
        const tile = _.find(board.tiles, (t) => t.id === id);
        return _.get(tile, 'data.isFloating');
      }

      function getGrid() {
        return api.grid.getEngine();
      }

      function changeTileFloat(tile, newFloatState) {
        const position = _transformPosition(tile, newFloatState);
        let newContainer;

        _.assign(tile.data, position);
        _.defer(onChangeCallback);

        if (newFloatState) {
          api.grid.removeTile(tile.id);
          newContainer = api.float.addTile(tile, { bringToFront: true });
        } else {
          api.float.removeTile(tile.id);
          newContainer = api.grid.addTile(tile);
        }

        tile.$container = newContainer;
        _.set(tile, 'data.isFloating', !!newFloatState);
      }

      function _transformPosition(tile, newFloatState) {
        const tileData = tile.data;
        const position = {};
        const cellSize = api.grid.getCellSize();

        if (newFloatState) {
          position.left = `${Math.round(tileData.x * cellSize.w)}px`;
          position.top = `${Math.round(tileData.y * cellSize.h)}px`;
          position.width = `${Math.round(tileData.w * cellSize.w)}px`;
          position.height = `${Math.round(tileData.h * cellSize.h)}px`;
          position.isMinimized = null;
          position.minimizedX = null;
          position.minimizedY = null;
        } else {
          const actualTilePosition = api.float.getTileActualPosition(tile);
          position.x = Math.round(actualTilePosition.left / cellSize.w);
          position.y = Math.round(actualTilePosition.top / cellSize.h);
          position.w = Math.round(actualTilePosition.width / cellSize.w);
          position.h = Math.round(actualTilePosition.height / cellSize.h);
        }

        return position;
      }

      function setGridAutopack(autopack) {
        const grid = getGrid();
        grid.float(!autopack);
      }

      function resetTileFrameOptions(tile) {
        if (_.get(tile, 'data.isFloating')) {
          api.float.resetTileFrameOptions(tile);
        }
      }

      const onWindowResize = _.debounce((e) => {
        // Preventing reaction on jQuery-resizable event which bubbles up here with same name
        if (e && e.target !== window) {
          return;
        }
        api.grid.onWindowResize();
        _.defer(api.float.onWindowResize);
      }, 100);

      return {
        getGrid,
        removeTile,
        addTile,
        changeTileFloat,
        setFixed,
        setGridAutopack,
        getTileElemById,
        toggleMinimizeTile,
        toggleMaximizeTile,
        resetTileFrameOptions,
        onWindowResize,
      };
    };
  }
})();
;(function () {
  angular.module('app.adpGridstack').directive('adpDashboardViewer', adpDashboardViewer);

  function adpDashboardViewer() {
    return {
      restrict: 'E',
      scope: {
        dashboardId: '@',
        showHeader: '@',
      },
      templateUrl: 'client-modules/adp-gridstack/directives/adp-dashboard-view.html',
      controller: 'AdpGsViewController',
    };
  }
})();
;(function () {
  angular.module('app.adpGridstack').factory('AdpGsControlLinksService', AdpGsControlLinksService);

  function AdpGsControlLinksService($timeout, ControllerCreationService, AdpWidgetsService, AdpWidgetLinksSetup) {
    return function (board) {
      function getLinks() {
        return board.controlLinks || {};
      }

      function getDashboard() {
        return board;
      }

      function setLinkValue(_events) {
        const links = getLinks();
        const events = _.isArray(_events) ? _events : [_events];

        return _.map(events, (params) => {
          const { linkId } = params;
          const { value } = params;
          const link = links[linkId];

          if (!link) {
            return { ok: false, message: 'No related widget parameter is found' };
          }

          try {
            const payload = _.pick(params, [
              'value',
              'sourceControlId',
              'sourceWidgetId',
              'throttle',
              'readyResolver',
              'paramType',
              'handleBySameWidget',
            ]);
            payload.prevValue = link.value;
            payload.dxFilter = _createDxFilter(link, params);
            payload.paramType = payload.paramType || _.get(link, 'paramSchema.type');

            link.value = value;

            const tilesReceived = _broadcastLinkEvent(link, payload);

            if (!tilesReceived && payload.readyResolver) {
              // Resolving is required since there is no real widget was affected and resolver have no chance to run
              // This may happen if widget is not available somehow but link to it still exists (widget is hidden for example)
              payload.readyResolver();
            }
          } catch (err) {
            return { ok: false, message: err.message };
          }

          return { ok: true };
        });
      }

      function isWidgetControlled(widgetId, dataLayerId = '') {
        const allLinks = getLinks();
        const linksCreatedByWidget = _.filter(
          allLinks,
          (link) => link.widgetId === widgetId && !link.selectOnly && (!dataLayerId || link.dataLayerId === dataLayerId)
        );
        if (!linksCreatedByWidget.length) {
          return false;
        }
        const allDashboardWidgetIds = AdpWidgetsService.getTilesWidgetIds(board.tiles);
        return !!_.find(
          linksCreatedByWidget,
          (link) => _.intersection(link.linkedTo || [], allDashboardWidgetIds).length
        );
      }

      function awaitAllWidgetsSubscribed() {
        const semaphores = board.tileSemaphores ? _.values(board.tileSemaphores) : [];
        const promises = _.map(semaphores, (semaphore) => semaphore.promise);

        return Promise.all(promises);
      }

      function _setTilesSemaphores(tiles) {
        _.each(tiles, (tile) => {
          if (tile.tiles) {
            return _setTilesSemaphores(tile.tiles);
          }

          const { widgetRow: widget } = tile;

          if (!widget) {
            return;
          }

          const { type } = widget;

          if (type !== 'forbidden' && isWidgetControlled(widget._id)) {
            _initTileSemaphore(tile);
          }
        });
      }

      function _initTileSemaphore(tile) {
        const { widgetRow: widget, id: tileId } = tile;
        const { type, title } = widget;
        let resolver;
        let isFulfilled = false;
        const promise = new Promise((resolve) => {
          resolver = resolve;
        }).then(() => {
          isFulfilled = true;
        });

        if (!board.tileSemaphores) {
          board.tileSemaphores = {};
        }

        $timeout(() => {
          if (!isFulfilled) {
            console.warn(
              `Widget of type ${type} in tile ${tileId} with title (${title || '<no title>'}) is not ready in 10sec`
            );
          }
        }, 10000);

        board.tileSemaphores[tileId] = { promise, resolver };
      }

      function markTileAsSubscribed(tileId) {
        const semaphore = _.get(board, ['tileSemaphores', tileId]);

        if (semaphore) {
          semaphore.promise
            .then(() => {
              delete board.tileSemaphores[tileId];
            })
            .catch(_.noop);

          semaphore.resolver();
        }
      }

      function resendAllWidgetLinks(widgetId) {
        const widgetLinks = _.filter(getLinks(), (link) => link.widgetId === widgetId);

        _sendEventByLinks(widgetLinks);
      }

      function touchLinksControlledByWidget(widgetId) {
        const allLinks = getLinks();
        const linksControlledByWidget = _.filter(allLinks, (link) => _.includes(_.get(link, 'linkedTo', []), widgetId));

        _sendEventByLinks(linksControlledByWidget, true);
      }

      function _sendEventByLinks(links, forceEmpty = false) {
        _.each(links, (link) => {
          const { value } = link;
          if (value || forceEmpty) {
            _sendEventByLink(link, value);
          }
        });
      }

      function _sendEventByLink(link, _value) {
        const value = _value || ['empty'];
        const dxFilter = _createDxFilter(link, { value });
        const payload = {
          value,
          prevValue: value,
          dxFilter,
          throttle: 300,
        };

        _broadcastLinkEvent(link, payload);
      }

      function _broadcastLinkEvent(linkToBroadcast, payloadPart) {
        return _broadcastAmongTiles(board.tiles, linkToBroadcast, payloadPart);
      }

      function _broadcastAmongTiles(tiles, linkToBroadcast, payloadPart) {
        let tilesReceived = 0;
        _.each(tiles, (tile) => {
          if (tile.tiles) {
            const affected = _broadcastAmongTiles(tile.tiles, linkToBroadcast, payloadPart);
            tilesReceived += affected;
          } else if (_broadcastToTile(tile, linkToBroadcast, payloadPart)) {
            tilesReceived++;
          }
        });

        return tilesReceived;
      }

      function _broadcastToTile(tile, linkToBroadcast, payloadPart) {
        if (!tile.$scope) {
          return;
        }

        const { linkId, widgetId } = linkToBroadcast;
        const tileWidgetId = _.get(tile, 'widgetRow._id');
        const pointingWidgetIds = linkToBroadcast.linkedTo || [];
        const broadcastToAnotherSlider = !!_.includes(pointingWidgetIds, tileWidgetId);
        const broadcastToRealDataLayer = tileWidgetId === widgetId;

        if (broadcastToAnotherSlider) {
          tile.$scope.$broadcast('controlLinkValueChange', { linkId, ...payloadPart, fromSlider: false });
        }

        // where is a possibility that one dataLayer of widget controls another dataLayer of widget.
        if (broadcastToRealDataLayer) {
          tile.$scope.$broadcast('controlLinkValueChange', { linkId, ...payloadPart, fromSlider: true });
          return true;
        }
      }

      function _createDxFilter(link, params) {
        const factories = { empty, regex, any, combine, between, '>=': morethan, '<=': lessthan, geoNear, common };

        return createFilterPart(link.paramName, params.value || []);

        function createFilterPart(name, value) {
          const operation = value[0];
          const values = _.slice(value, 1);
          const factory = factories[operation] || factories.common;

          if (name === '[fts]') {
            return values[0] ? ['_textSearch', values[0]] : null;
          }

          return factory(name, values, operation);
        }

        function regex(name, values, operation) {
          try {
            RegExp(values[0]);
          } catch (e) {
            throw new Error('Invalid regular expression');
          }
          return [name, operation, values[0]];
        }

        function any(name, values) {
          if (!values.length) {
            return null;
          }

          let combinedFilter = [];

          if (values.length === 1) {
            combinedFilter = [name, '=', values[0]];
          } else {
            _.each(values, (x, indx) => {
              indx && combinedFilter.push('or');
              combinedFilter.push([name, '=', x]);
            });
          }

          return combinedFilter;
        }

        function combine(name, values) {
          const parts = values.map((v) => createFilterPart(name, v));
          const res = [];
          _.each(parts, (p, i) => {
            i && res.push('or');
            res.push(p);
          });
          return res;
        }

        function between(name, values) {
          const secureDates = _.map(values, (val) => (_.isDate(val) ? val.toISOString() : val));
          return [[name, '>=', secureDates[0]], 'and', [name, '<=', secureDates[1]]];
        }

        function morethan(name, values) {
          const secureDates = _.map(values, (val) => (_.isDate(val) ? val.toISOString() : val));
          return [name, '>=', secureDates[0]];
        }

        function lessthan(name, values) {
          const secureDates = _.map(values, (val) => (_.isDate(val) ? val.toISOString() : val));
          return [name, '<=', secureDates[0]];
        }

        function empty() {
          return null;
        }

        function geoNear(name, values) {
          return [name, 'geoNear', _.omit(values[0], 'label')];
        }

        function common(name, values, operation) {
          return [name, operation, values[0]];
        }
      }

      function selLinksValuesFromBestSliders({ linkIds, prevValue }) {
        const prevOperation = _.get(prevValue, '0');
        const prevValues = _.slice(prevValue, 1);

        return _getAllValuesForLinks(linkIds).then((slidersRelatedToLinks) => {
          const allLinks = getLinks();

          _.each(linkIds, (linkId) => {
            const link = allLinks[linkId];
            if (!link) {
              return;
            }
            const slidersOfLink = _.filter(slidersRelatedToLinks, ({ linkIds: sliderLinks }) =>
              _.includes(sliderLinks, linkId)
            );
            const sorted = _.sortBy(slidersOfLink, relevanceSorter);
            const sliderToGetValueFrom = sorted.pop();
            const value = _.get(sliderToGetValueFrom, 'value', null);

            _sendEventByLink(link, value);
          });
        });

        function relevanceSorter(item) {
          if (!_.isArray(item.value)) {
            return 0;
          }
          const operation = item.value[0];
          const values = _.slice(item.value, 1);
          const statusScore = item.activeStatus === 'on' ? 100 : 0;
          const operationScore = operation === prevOperation ? 100 : 0;
          const notEmptyOperationScore = operation !== 'empty' ? 10 : 0;
          const similarValueScore = _.intersection(values, prevValues).length;

          return statusScore + operationScore + notEmptyOperationScore + similarValueScore;
        }
      }

      function resetAllLinksToInitial() {
        const allLinks = getLinks();
        const allWidgets = _.compact(_.map(board.tiles, (tile) => tile.widgetRow));

        const payloads = _.map(allLinks, (link) => {
          const { linkId, linkedTo } = link;
          const linkedWidgets = _.filter(allWidgets, (widget) => _.includes(linkedTo, widget._id));
          const controlWidget = _.find(linkedWidgets, (widget) => widget.type === 'control');
          let value = ['empty'];

          if (controlWidget) {
            const controllers = _.get(controlWidget, 'control.controllers', []);
            const controller = _.find(controllers, (ctrl) => _.includes(ctrl.linkIds, linkId));
            value = _getWidgetControllerInitialFilter(controller);
          }

          return { linkId, value };
        });

        return setLinkValue(payloads);
      }

      function _getWidgetControllerInitialFilter(controller) {
        const { controlType } = controller;
        const typeParams = ControllerCreationService.getControlWidgetSliderTypes();
        const { getInitialFilter, paramsPath = '-' } = _.get(typeParams, controlType, {});
        const controlParams = _.get(controller, paramsPath);
        return getInitialFilter ? getInitialFilter(controlParams) : ['empty'];
      }

      function _getAllValuesForLinks(linkIds) {
        const answerPromises = [];

        _.each(board.tiles, (tile) => {
          const wType = _.get(tile, 'widgetRow.type');
          if (wType !== 'control') {
            return;
          }

          const controllers = _.get(tile, 'widgetRow.control.controllers');
          const hasRelatedSliders = _.find(
            controllers,
            (controller) => _.intersection(controller.linkIds, linkIds).length
          );
          if (!hasRelatedSliders) {
            return;
          }

          const { $scope } = tile;
          if (!$scope) {
            return;
          }

          const promise = new Promise((resolve) => {
            const payload = {
              linkIds,
              resolve,
            };

            $scope.$broadcast('controlLinksGetAllValues', payload);
          });

          answerPromises.push(promise);
        });

        return Promise.all(answerPromises).then(_.flatten);
      }

      function getLinksReport() {
        const nodes = [];
        const links = [];

        const allLayers = _.chain(board.tiles)
          .map((tile) => getWidgetLayers(tile))
          .flattenDeep()
          .compact()
          .value();
        const allLinks = getLinks();

        _.each(allLinks, (link) => {
          const { linkId, paramName, dataLayerId, widgetId } = link;
          const srcLayer = _.find(
            allLayers,
            (l) => l.widgetId === widgetId && (l.layerId === dataLayerId || !l.layerId)
          );
          if (!srcLayer) {
            nodes.push({ id: linkId, name: paramName, type: 'lostLink', info: linkId });
          } else {
            nodes.push({ id: linkId, name: paramName, type: 'param', info: linkId });
            links.push({ source: srcLayer.graphId, target: linkId, type: 'w2p' });
          }
        });

        _.each(allLayers, ({ layerId, graphId, widgetId, sliders, directConnections }) => {
          _.each(sliders, (slider, index) => {
            const rand = Math.round(Math.random() * 10000);
            const sliderNodeId = `s_${index}_${rand}_${layerId || widgetId}`;
            const { name, clickValue, mappingType, linkIds } = slider;
            const sliderType = mappingType ? 'widgetAsSlider' : 'controlSlider';
            const nodeName = name || `${clickValue} (${mappingType})`;

            nodes.push({ id: sliderNodeId, name: nodeName, type: sliderType });
            links.push({ source: graphId, target: sliderNodeId, type: 'w2s' });

            _.each(linkIds, (linkId) => {
              links.push({ source: sliderNodeId, target: linkId, type: 's2p' });
            });
          });

          _.each(directConnections, (linkId) => {
            links.push({ source: graphId, target: linkId, type: 's2p' });
          });
        });

        function getWidgetLayers(tile, parentId) {
          const { widgetRow, widgetDatasource, widgetConfiguration, tiles: subTiles } = tile;
          if (!widgetRow) {
            // processing Split tree as flat set of child widgets
            if (subTiles) {
              return _.map(subTiles, (t) => getWidgetLayers(t, parentId));
            }
            return;
          }
          const { name: widgetName, _id: widgetId, type } = widgetRow;
          const rand = Math.round(Math.random() * 10000);
          const widgetNodeId = `w_${widgetId}_${rand}`;
          const widgetNode = { id: widgetNodeId, widgetId, name: `${widgetName} (${type})`, type: 'widget' };
          nodes.push(widgetNode);
          if (parentId) {
            links.push({ source: parentId, target: widgetNodeId, type: 'w2w' });
          }
          const widgetClone = _.find(nodes, (node) => node.widgetId === widgetId);
          if (widgetClone) {
            links.push({ source: widgetNodeId, target: widgetClone.id, type: 'widgetClone' });
          }

          if (subTiles) {
            return _.map(subTiles, (t) => getWidgetLayers(t, widgetNodeId));
          }

          const allDataLayers = _.map(widgetDatasource, ({ name }, key) => ({ layerName: name, layerId: key }));
          const allSliders = AdpWidgetLinksSetup.getWidgetSliders(widgetRow, widgetConfiguration);

          if (_.isEmpty(allDataLayers) || (allDataLayers.length === 1 && allDataLayers[0].layerId === 'default')) {
            const sliders = _.get(allSliders, 'dataLayers.default.sliders', []);
            const directConnections = type === 'calculatedHtml' ? _.get(widgetRow, [type, 'linksControlledIds']) : [];
            return { name: widgetName, widgetId, graphId: widgetNodeId, sliders, directConnections };
          }

          return _.map(allDataLayers, ({ layerName, layerId }) => {
            const layerSliders = _.get(allSliders, ['dataLayers', layerId, 'sliders'], []);
            const layerNodeId = `l_${widgetNodeId}_${layerId}`;
            nodes.push({ id: layerNodeId, name: layerName, layerId, type: 'layer' });
            links.push({ source: widgetNodeId, target: layerNodeId, type: 'w2l' });

            return { name: layerName, layerId, widgetId, graphId: layerNodeId, sliders: layerSliders };
          });
        }

        return { nodes, links };
      }

      _setTilesSemaphores(board.tiles);

      return {
        getLinks,
        getDashboard,
        setLinkValue,
        awaitAllWidgetsSubscribed,
        isWidgetControlled,
        markTileAsSubscribed,
        resendAllWidgetLinks,
        touchLinksControlledByWidget,
        selLinksValuesFromBestSliders,
        resetAllLinksToInitial,
        getLinksReport,
      };
    };
  }
})();
;(function () {
  angular.module('app.adpGridstack').factory('AdpGsService', adpGsService);

  const POSITION_ATTRS = ['x', 'y', 'w', 'h'];

  function adpGsService(
    $state,
    $timeout,
    $http,
    AdpGsLayers,
    AdpGsControlLinksService,
    GraphqlCollectionMutationBuilder,
    GraphqlRequest,
    AdpClientCommonHelper,
    AdpModalFormService,
    AdpUnifiedArgs,
    AdpFormDataUtils,
    AdpSchemaService,
    AdpWidgetsService,
    AdpLayoutConfigService,
    AdpGeneratorModalService,
    ErrorHelpers,
    ServerError,
    APP_CONFIG
  ) {
    function initializeDashboard(editMode, conditionOrPromise, editInterface, isEmbedded) {
      const boardLoadPromise = conditionOrPromise.then
        ? conditionOrPromise
        : _getBoardById(conditionOrPromise, editMode);
      const promises = [boardLoadPromise];

      if (_.isUndefined(window.GridStack)) {
        promises.push(_loadGridstackVendorCode());
      }

      return Promise.all(promises).then((loaded) => {
        const board = loaded[0];
        const layers = AdpGsLayers(editMode, board, editInterface.onBoardChange);

        board.isEmbedded = isEmbedded;
        layers.setGridAutopack(board.data.autoPackWidgets);

        editInterface.controlLinks = AdpGsControlLinksService(board);
        board.interface = editInterface;

        _setTiles(layers, board, editInterface);
        _publishDashboardLinksApi(editInterface);
        _setLinkValuesFromState(editInterface);

        return getDashboardStyle(board).then((css) => ({ board, layers, css }));
      });
    }

    function createEmptyGridTile(context, newTile) {
      const { boardLayers: layers, board } = context;
      const tileRow = _.pick(newTile, POSITION_ATTRS);
      // ToDo: make sure id is working fine here
      const id = `id${Math.floor(Math.random() * 1000000000)}`;
      tileRow._id = id;
      const tile = AdpWidgetsService.tileFromRow({ tileRow }, 'tile.edit', board);

      board.tiles.push(tile);
      layers.getGrid().removeWidget(newTile.el);
      const $addedElem = layers.addTile(tile);
      tile.$container = $addedElem;
      tile.container = board;
      $addedElem.addClass('just-created');

      return openTileFormDialog('create', tileRow, id, context)
        .then((success) => {
          if (!success) {
            throw 'cancel';
          }
          $addedElem.removeClass('just-created');
        })
        .catch((err) => {
          if (err !== 'cancel') {
            ErrorHelpers.handleError(err, 'Tile form');
          }
          layers.getGrid().removeWidget($addedElem[0]);
          board.tiles.pop();
        });
    }

    function handleTileUpdate(layers, board, id, dataRow, editInterface) {
      const tile = getTileById(board, id);
      const isFloatChanged = !!tile.data.isFloating !== !!dataRow.isFloating;

      // Update form may return wrong position attributes, since they recalculated after each Apply
      tile.data = { ..._.pick(tile.data, POSITION_ATTRS), ..._.omit(_.cloneDeep(dataRow), POSITION_ATTRS) };

      if (isFloatChanged) {
        layers.changeTileFloat(tile, !!dataRow.isFloating);
      }

      layers.setFixed(id, dataRow.positionFixed);

      if (dataRow.widget) {
        return AdpWidgetsService.loadWidgetConfig(dataRow.widget._id)
          .then((serverData) =>
            AdpWidgetsService.updateTileWidget({ tile, serverData, editInterface, widgetUpdated: true })
          )
          .then(() => {
            layers.onWindowResize();
            layers.resetTileFrameOptions(tile);
          });
      }
      tile.widgetRow = null;
      return Promise.resolve();
    }

    function saveDashboard({ schema, board, widgetsToRefreshAfter = [] }) {
      const recordData = _boardToRow(board);
      const args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        schema,
        formData: recordData,
        action: null,
      });

      const record = AdpFormDataUtils.transformDataBeforeSending(args).row;
      const mutatorName = `${schema.schemaName}UpdateOne`;
      const query = GraphqlCollectionMutationBuilder.update(mutatorName, schema).replace(
        /\{\s*_id\s*}/,
        '{_id controlLinks}'
      );
      const recordWithoutId = _.cloneDeep(record);
      _.unset(recordWithoutId, '_id');
      _.unset(recordWithoutId, '_actions');

      return GraphqlRequest({
        name: mutatorName,
        query,
        variables: {
          record: recordWithoutId,
          filter: { _id: record._id },
        },
      }).then((data) => {
        const newLinks = copyValuesToNewLinks(board.controlLinks, data.controlLinks);
        const widgetsWithChangedLinks = recognizeWidgetsToReload(board.controlLinks, newLinks);
        const widgetsToRefresh = _.uniq(_.union(widgetsToRefreshAfter, widgetsWithChangedLinks));
        board.controlLinks = newLinks;
        refreshWidgets(board, widgetsToRefresh);
        return data;
      });
    }

    function copyValuesToNewLinks(prev, nextArr) {
      const next = _.fromPairs(_.map(nextArr, (link) => [link.linkId, link]));
      _.each(prev, (l, lid) => {
        const n = next[lid];
        if (!n) {
          return;
        }
        n.value = l.value;
        if (l.prevValue) {
          n.prevValue = l.prevValue;
        }
      });
      return next;
    }

    function recognizeWidgetsToReload(prev, next) {
      const changed = [];

      _.each(prev, (link1, lid) => {
        const link2 = next[lid];
        if (!link2) {
          changed.push(link1);
          return;
        }
        if (JSON.stringify(link1) !== JSON.stringify(link2)) {
          changed.push(link2);
        }
      });

      _.each(next, (link2, lid) => {
        const link1 = prev[lid];
        if (!link1) {
          changed.push(link2);
        }
      });

      return _(changed)
        .map((l) => [l.widgetId, ...l.linkedTo])
        .flatten()
        .uniq()
        .value();
    }

    function refreshWidgets(board, ids) {
      _.each(ids, (widgetId) => {
        if (!widgetId) {
          return;
        }
        const tiles = getTilesByWidgetId(board, widgetId);

        AdpWidgetsService.loadWidgetConfig(widgetId)
          .then((serverData) => {
            _.each(tiles, (tile) => {
              AdpWidgetsService.updateTileWidget({ tile, serverData });
            });
          })
          .catch((e) => ErrorHelpers.handleError(e, 'Widget configuration load error'));
      });
    }

    function editTileWidget(context) {
      const tile = context.row;
      const { widgetRow } = tile;

      return _openWidgetFormDialog('update', widgetRow, context);
    }

    function openTileFormDialog(actionName, formData, tileId, context) {
      // ToDo: refactor to eliminate this args param as this is duplication
      const linksInterface = _.get(context, 'editInterface.controlLinks');
      const tileSchema = _getTileSchema();
      const args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: actionName,
        formData,
        schema: tileSchema,
      });
      args.dashboardContext = context;
      args.customData = { linksInterface, tileId };

      return AdpGeneratorModalService.formModal({ args });
    }

    function _openWidgetFormDialog(actionName, formData, context) {
      const recordId = formData._id;
      const linksInterface = _.get(context, 'customOptions.widgetInterface.controlLinks');
      const customData = { linksInterface };

      return AdpModalFormService.openForm({
        schemaName: '_widgets',
        action: 'update',
        recordId,
        customData,
      }).then((response) => {
        if (!response) {
          throw 'cancel';
        }
        return response;
      });
    }

    function _getTileSchema() {
      const dashboardSchema = AdpSchemaService.getSchemaByName('_dashboards');
      const fields = _.get(dashboardSchema, 'fields.tiles.fields');
      const actions = {
        fields: _.chain(dashboardSchema)
          .get('actions.fields', [])
          .pickBy((action) => action.position === 'tile.edit.form')
          .cloneDeep()
          .each((action) => {
            action.position = 'form.bottom';
          })
          .value(),
      };

      return {
        type: 'Schema',
        schemaName: 'Tiles',
        fullName: 'Tiles',
        fields,
        actions,
      };
    }

    function openDashboardFormDialog(dashboardId) {
      return AdpModalFormService.openForm({
        schemaName: '_dashboards',
        action: 'update',
        recordId: dashboardId,
        formOptions: {
          disableFullscreen: true,
        },
      });
    }

    function _boardToRow(board) {
      const data = _.clone(board.data);
      const validTiles = _.cloneDeep(_.filter(board.tiles, (tile) => tile.widgetRow));

      data.tiles = _.map(validTiles, (tile) => tile.data);

      return data;
    }

    function getDashboardStyle(board) {
      const containerCss = {};
      const boardCss = {};
      const bgCss = {
        backgroundColor: _.get(board, 'data.styling.background.color'),
      };
      const styleOptions = {
        cssNames: _.get(board, 'data.styling.cssNames', '')
          .split(/[^\w_-]+/)
          .join(' '),
      };
      const image = _.get(board, 'data.styling.background.image[0]');
      if (image) {
        const position = _.get(board, 'data.styling.background.position');
        const size = _.get(board, 'data.styling.background.size');

        bgCss.backgroundPosition =
          position !== 'manual' ? size : _.get(board, 'data.styling.background.positionManual');
        bgCss.backgroundSize = size !== 'manual' ? size : _.get(board, 'data.styling.background.sizeManual');
        bgCss.backgroundRepeat = _.get(board, 'data.styling.background.repeat');
        bgCss.backgroundAttachment = _.get(board, 'data.styling.background.attachment');

        const type = image.cropped ? 'CROPPED' : 'ASIS';
        bgCss.backgroundImage = `url(${APP_CONFIG.apiUrl}/file-permanent/${image.id}?fileType=${type})`;
      }

      const opacity = _.get(board, 'data.styling.background.opacity');
      const blur = _.get(board, 'data.styling.background.blur');
      if (!_.isNil(opacity) && opacity < 100) {
        bgCss.opacity = opacity / 100;
      }
      if (blur) {
        bgCss.filter = `blur(${blur}px)`;
      }

      const dim = _.get(board, 'data.styling.dimensions', {});
      if (dim.isFixed) {
        const { width, height } = _addDefaultUnits(_.pick(dim, ['width', 'height']));
        boardCss.width = width;
        boardCss.height = height;
        boardCss.minWidth = width;
        boardCss.minHeight = height;
      } else {
        _.assign(boardCss, _addDefaultUnits(_.pick(dim, ['minWidth', 'minHeight', 'maxWidth', 'maxHeight'])));
      }

      const tileDim = _.get(board, 'data.styling.tile.dimensions', {});
      const marginBottom = _.get(tileDim, 'marginTop') || 0;
      const marginTop = _.get(tileDim, 'marginBottom') || 0;
      const marginRight = _.get(tileDim, 'marginLeft') || 0;
      const marginLeft = _.get(tileDim, 'marginRight') || 0;
      // Values are flipped by reason: we add padding to the bottom to mimic top margin of tile "below the edge".
      // Overall result: all gaps between tiles and board edges looks consistent.

      if (marginTop || marginBottom || marginLeft || marginRight) {
        boardCss.padding = `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`;
      }

      return Promise.resolve(_.mapValues({ boardCss, containerCss, bgCss, styleOptions }, (v) => _.omitBy(v, _.isNil)));

      function _addDefaultUnits(obj) {
        return _.mapValues(obj, (val) => {
          if (parseInt(val, 10).toString() === val) {
            return `${val}px`;
          }
          return val;
        });
      }
    }

    function setTitle(board) {
      const INTERFACE = window.adpAppStore.appInterface();
      const title = board?.data?.name || INTERFACE.app.title;
      const setMobileTestTitle = _.get(board, 'data.styling.header.show') !== 'show';

      _setTitle(title, setMobileTestTitle);
    }

    function cleanTitle() {
      _setTitle('');
    }

    function _setTitle(title, setMobileTestTitle = true) {
      _.defer(() => {
        $('html head title').text(title);
        setMobileTestTitle && $('#adp-mobile-page-title').text(title);
      });
    }

    function _getBoardById(condition, editMode) {
      const url = `${APP_CONFIG.apiUrl}/d/c`;
      const body = condition;

      if (editMode) {
        body.includeHidden = true;
      }

      return $http
        .post(url, body)
        .then(({ data }) => {
          const { data: board, success, message } = data;

          if (!success) {
            throw new ServerError(message);
          }

          return board;
        })
        .then((row) => (!editMode ? transformBoardRecord(row) : row))
        .then(boardFromRow)
        .catch((error) => {
          ErrorHelpers.handleError(error, 'Unknown error while loading dashboard');
          throw error;
        });
    }

    function _setTiles(layers, board, editInterface) {
      const grid = layers.getGrid();

      grid.batchUpdate();

      _.each(board.tiles, (tile) => {
        const element = layers.addTile(tile, { bringToFront: true });
        tile.position = editInterface.editTile ? 'tile.edit' : 'tile.view';
        tile.$container = element;
        AdpWidgetsService.resetTileWidget(tile);
      });

      grid.commit();
    }

    function boardFromRow(data) {
      const board = {
        data: _.omit(data, ['tiles', 'controlLinks']),
      };

      board.controlLinks = {};
      board.tiles = _.map(data.tiles, (tileRow) => {
        const tile = AdpWidgetsService.tileFromRow(tileRow, '', board);
        tile.container = board;
        return tile;
      });

      _.each(data.controlLinks, (link) => {
        board.controlLinks[link.linkId] = link;
      });

      return board;
    }

    function transformBoardRecord(row) {
      const { allowTransformingDashboardRecord, transformingDashboardRecord } = row;
      if (!allowTransformingDashboardRecord) {
        return row;
      }

      try {
        const context = { row };
        const func = new Function(transformingDashboardRecord);
        func.call(context);
      } catch (e) {
        console.log('Dashboard transformation error', e);
      }

      return row;
    }

    function _loadGridstackVendorCode() {
      const jsUrl = `${APP_CONFIG.resourceUrl}/public/js/lib/gridstack/index.js`;
      const cssUrl = `${APP_CONFIG.resourceUrl}/public/js/lib/gridstack/css/style.css`;
      return Promise.all([AdpClientCommonHelper.loadScript(jsUrl), AdpClientCommonHelper.loadCss(cssUrl)]);
    }

    function _publishDashboardLinksApi(editInterface) {
      const { controlLinks } = editInterface;
      _.set(window, 'adpApi.dashboardLinkSetValue', setLinkValue);
      _.set(window, 'adpApi.dashboardLinkGetValue', getLinkValue);
      _.set(window, 'adpApi.dashboardLinkReset', resetLinkValue);

      function setLinkValue(linkId, _value) {
        const value = ['string', 'number'].includes(typeof _value) ? ['=', _value] : _value;
        const payload = { linkId, value };
        controlLinks.setLinkValue(payload);
      }

      function getLinkValue(linkId) {
        const allLinks = controlLinks.getLinks();
        return _.get(allLinks, [linkId, 'value']);
      }

      function resetLinkValue(linkId) {
        setLinkValue(linkId, ['empty']);
      }
    }

    function _setLinkValuesFromState(editInterface) {
      const { controlLinks } = editInterface;
      return controlLinks.awaitAllWidgetsSubscribed().then(() => {
        $timeout(() => {
          const filter = _parseFilterFromUrl();
          _.each(filter, (value, linkId) => controlLinks.setLinkValue({ linkId, value }));
        }, 200);
      });
    }

    function _parseFilterFromUrl() {
      // ToDo: this is dirty solution and need to be refactored to wipe crazy substitution out!
      const crazySubst = '--!@##@!--';
      let filter = decodeURIComponent($state.params.filter || '');
      filter = filter.replaceAll('\\&', crazySubst);
      const decodedFilterKeyValPairs = filter.split('&');
      const result = {};

      _.each(decodedFilterKeyValPairs, (keyVal) => {
        const parts = keyVal.replaceAll(crazySubst, '&').match(/^(\w+)=(\[.*?\])$/);
        const val = _.get(parts, '2');
        if (_.isNil(val)) {
          return;
        }
        const key = _.get(parts, '1');

        try {
          result[key] = JSON.parse(val);
        } catch (e) {
          console.error('Parsing URL filter error', val, e);
        }
      });

      return result;
    }

    function setThemes(themes) {
      let devextremeTheme;
      if (themes) {
        const systemThemes = _.pick(window.adpAppStore.appInterface(), [
          'skin',
          'devextremeTheme',
          'echartsTheme',
          'echartsDecal',
          'ckeditorTheme',
          'aceTheme',
          'scrollbarTheme',
          'googleMapsTheme',
        ]);
        window.forcedThemes = _.defaults({}, themes, systemThemes);
        devextremeTheme = themes.devextremeTheme;
      } else {
        delete window.forcedThemes;
        devextremeTheme = window.adpAppStore.appInterface().devextremeTheme;
      }

      // eslint-disable-next-line no-undef
      DevExpress.ui.themes.current(devextremeTheme);
      AdpLayoutConfigService.setSkin();
      AdpLayoutConfigService.applyThemeClasses();
    }

    function getTileById(board, id) {
      return _findTileInContainer(board.tiles, (t) => t.id === id);
    }

    function _findTileInContainer(tiles, predicate) {
      if (!tiles) {
        return;
      }
      const onThisLevel = _.find(tiles, predicate);
      if (onThisLevel) {
        return onThisLevel;
      }

      let onSubLevel;

      _.forOwn(tiles, (tile) => {
        const t = _findTileInContainer(tile.tiles, predicate);
        if (t) {
          onSubLevel = t;
          return false;
        }
      });

      return onSubLevel;
    }

    function getTilesByWidgetId(board, widgetId) {
      return _findTilesInContainer(board.tiles, (t) => _.get(t, 'widgetRow._id') === widgetId);
    }

    function _findTilesInContainer(tiles, predicate) {
      if (!tiles) {
        return;
      }
      const onThisLevel = _.filter(tiles, predicate);
      let onSubLevels = [];

      _.forOwn(tiles, (tile) => {
        onSubLevels = _.union(onSubLevels, _findTilesInContainer(tile.tiles, predicate));
      });

      return _.union(onThisLevel, onSubLevels);
    }

    return {
      initializeDashboard,
      saveDashboard,
      handleTileUpdate,
      createEmptyGridTile,
      openTileFormDialog,
      openDashboardFormDialog,
      boardFromRow,
      transformBoardRecord,
      getDashboardStyle,
      editTileWidget,
      setThemes,
      setTitle,
      cleanTitle,
      getTileById,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .component('adpGuidedTourDialog', {
      templateUrl: 'client-modules/adp-guided-tour/adp-guided-tour-dialog/adp-guided-tour-dialog.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpGuidedTourDialogController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .controller('AdpGuidedTourDialogController', AdpGuidedTourDialogController);

  /** @ngInject */
  function AdpGuidedTourDialogController($scope) {
    var vm = this;

    vm.$onInit = function () {
      vm.radioGroupOption = {
        valueExpr: 'id',
        displayExpr: 'text',
        items: [{
          id: 'stopShowingTours',
          text: 'Stop showing any guided tours',
        }, {
          id: 'keepShowingTours',
          text: 'Stop this tour for now, but show this and other tours next time I visit a new page',
        }]
      };

      vm.result = _.get(vm.radioGroupOption, 'items.0.id');
    };

    vm.submit = function () {
      if ($scope.form.$invalid) {
        return;
      }
      vm.close({ $value: vm.result });
    }

    vm.cancel = function () {
      vm.close();
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpGuidedTour')
    .directive('adpGuidedTourStatus', function (
      $transitions,
      $location,
      AdpGuidedTourService,
      $state
    ) {
      return {
        restrict: 'E',
        replace: true,
        template: '<div class="adp-guided-tour-footer-status" ng-if="hasTour" ng-click="start()">Guided Tour Available</div>',
        link: function (scope) {
          scope.hasTour = AdpGuidedTourService.checkTourExistForPage($state.current);
          var unbindEvent = $transitions.onSuccess(null, handleStatusMessageVisibility);
          scope.$on('destroy', function () {
            unbindEvent();
          });

          function handleStatusMessageVisibility() {
            scope.hasTour = AdpGuidedTourService.checkTourExistForPage($state.current);
          }

          scope.start = function () {
            const currentUrl = $location.path();
            AdpGuidedTourService.createAndStart(currentUrl);
          }
        }
      }
    });

})();
;(function () {
  angular.module('app.adpPaymentPlans').component('adpPaymentPlansModalComponent', {
    templateUrl: 'client-modules/adp-payment-plans/adp-payment-plans-modal/adp-payment-plans-modal.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: 'AdpPaymentPlansModalController',
    controllerAs: 'vm',
  });
})();
;(function () {
  angular.module('app.adpPaymentPlans').controller('AdpPaymentPlansModalController', AdpPaymentPlansModalController);

  /** @ngInject */
  function AdpPaymentPlansModalController(
    APP_CONFIG,
    $http,
    GraphqlCollectionQuery,
    ErrorHelpers,
    ServerError,
    AdpSchemaService,
    AdpModalService,
    AdpModalFormService,
    AdpNotificationService
  ) {
    const vm = this;
    vm.selectedPlan = null;
    vm.highlightedPlan = null;
    vm.status = 'select-plans';
    vm.planName = () => `${vm.selectedPlan.name}(${vm.selectedOption.optionName})`;
    vm.optionPrice = (option) => (option.price ? `$${option.price}` : 'Free');

    vm.$onInit = function () {
      vm.selectPlan = doSelectPlan;
      vm.proceed = doProceed;
      vm.addPaymentProfile = () => createNewPaymentProfile().catch(_catchErrors);
      vm.selectPaymentProfile = selectPaymentProfile;
      vm.deletePaymentProfile = deletePaymentProfile;

      _startLoading();
      return Promise.all([loadAvailablePlans(), getCurrentUserPlan()])
        .then(([plansList, { userPlan, nextUserPlan }]) => {
          vm.plansList = plansList;
          vm.currentPlan = userPlan;
          vm.nextPlan = nextUserPlan;
          const nextChargeData = _.get(userPlan, 'expiresAt');
          vm.nextChargeDate = nextChargeData ? dayjs(nextChargeData).format('MM/DD/YYYY') : '(N/A)';
        })
        .catch((error) => {
          ErrorHelpers.handleError(error, 'Error while loading list of plans');
          throw error;
        })
        .finally(_stopLoading);
    };

    function doSelectPlan(planName, optionName) {
      _startLoading();
      return loadPaymentProfiles()
        .then(() => {
          vm.selectedPlan = _getPlanByName(planName);
          vm.selectedOption = _.find(vm.selectedPlan.options, (option) => option.optionName === optionName);

          if (requireToAddPaymentProfile(vm.customerPaymentProfiles)) {
            vm.status = 'add-pay-profiles';
          } else {
            compareOldPlanWithNew();
          }
        })
        .then((res) => {
          console.log('===RES', res);
        })
        .catch(_catchErrors)
        .finally(_stopLoading);
    }

    function doProceed() {
      if (vm.status === 'add-pay-profiles') {
        return createNewPaymentProfile().then(compareOldPlanWithNew).catch(_catchErrors);
      }

      return activateNewPlan().catch(_catchErrors);
    }

    function compareOldPlanWithNew() {
      const currentPrice = _.get(vm.currentPlan, 'optionObj.price') || 0;
      const selectedPrice = _.get(vm, 'selectedOption.price');

      if (currentPrice > 0 && selectedPrice === 0) {
        vm.status = 'switch-to-free';
      } else {
        vm.status = currentPrice > selectedPrice ? 'switch-to-cheaper' : 'buy-new';
      }
    }

    function requireToAddPaymentProfile(paymentProfiles) {
      const selectedPrice = _.get(vm, 'selectedOption.price');
      return selectedPrice && _.isEmpty(paymentProfiles);
    }

    function loadPaymentProfiles() {
      const url = `${APP_CONFIG.apiUrl}/getPaymentProfiles`;

      return $http
        .get(url)
        .then(_checkServerError)
        .then(({ data }) => {
          const { customerPaymentProfiles, customerProfileId } = data;
          vm.customerPaymentProfiles = customerPaymentProfiles;
          vm.customerProfileId = customerProfileId;
          const defaultProfile =
            _.find(vm.customerPaymentProfiles, (p) => p.isDefault) || _.get(vm.customerPaymentProfiles, '0');
          defaultProfile && selectPaymentProfile(defaultProfile.customerPaymentProfileId);
        });
    }

    function loadAvailablePlans() {
      const schema = AdpSchemaService.getSchemaByName('_userPlans');
      const params = {
        skip: 0,
        take: 1000,
      };

      return GraphqlCollectionQuery(schema, params).then((result) => result.items);
    }

    function getCurrentUserPlan() {
      const url = `${APP_CONFIG.apiUrl}/user-plan-info`;

      return $http
        .get(url)
        .then(_checkServerError)
        .then(({ data }) => {
          const { userPlan, nextUserPlan } = data;
          console.log('User plans', userPlan, nextUserPlan);
          return { userPlan, nextUserPlan };
        });
    }

    function activateNewPlan() {
      const url = `${APP_CONFIG.apiUrl}/purchase-user-plan`;
      const { name } = vm.selectedPlan;
      const { optionName, price, period } = vm.selectedOption;
      const { customerPaymentProfileId } = vm.customerPaymentProfiles[0]; // ToDo: implement payment profile selection
      const optionObj = { optionName, price, period };
      const paymentData = { customerProfileId: vm.customerProfileId, customerPaymentProfileId };
      const body = { name, optionObj, autoRenew: true, paymentData };

      _startLoading();
      return $http
        .post(url, body)
        .then(_checkServerError)
        .then(({ message }) => {
          vm.status = 'ok';
          vm.selectedPlan = null; // Creepy way to hide 'Process' button;
          vm.statusMessage = message;
        })
        .finally(_stopLoading);
    }

    function addPaymentProfile(cardData) {
      const url = `${APP_CONFIG.apiUrl}/addPaymentProfile`;

      return $http
        .post(url, cardData)
        .then(_checkServerError)
        .catch((err) => {
          if (!err) {
            return;
          }
          const message = err.message || err;
          AdpNotificationService.notifyError(message);
          throw new ServerError(message);
        });
    }

    function selectPaymentProfile(profileId) {
      vm.selectedPaymentProfile = profileId;
      _.each(vm.customerPaymentProfiles, (p) => {
        p.isSelected = p.customerPaymentProfileId === profileId;
      });
    }

    function deletePaymentProfile(event, profileId) {
      event.stopPropagation();
      _startLoading();
      return AdpModalService.confirm({ message: 'Are you sure you want to remove this payment profile?' })
        .then(() => {
          const url = `${APP_CONFIG.apiUrl}/deletePaymentProfile`;
          const body = { customerPaymentProfileId: profileId };

          return $http.post(url, body).then(_checkServerError).then(loadPaymentProfiles).catch(_catchErrors);
        })
        .finally(_stopLoading);
    }

    function openAddPaymentMethodDialog() {
      return AdpModalFormService.openForm({
        schemaName: '_creditCardForm',
        action: 'create',
        formOptions: {
          disableFullscreen: true,
        },
      }).then((res) => {
        if (!res) {
          throw new Error('canceled');
        }
        return res;
      });
    }

    function createNewPaymentProfile() {
      return openAddPaymentMethodDialog()
        .then(({ args }) => {
          const cardData = _.get(args, 'row');
          cardData.expirationDate = dayjs(cardData.expirationDate).format('YYYY-MM');
          return addPaymentProfile(cardData);
        })
        .then(loadPaymentProfiles);
    }

    function _getPlanByName(planName) {
      return _.find(vm.plansList, (plan) => plan.name === planName);
    }

    function _checkServerError(res) {
      const { success, data, message } = _.get(res, 'data', {});
      if (!success) {
        throw new ServerError(message);
      }
      return { data, message };
    }

    function _catchErrors(error) {
      if (error && error !== 'canceled') {
        ErrorHelpers.handleError(error);
      }
    }

    function _startLoading() {
      vm.isLoading = true;
    }

    function _stopLoading() {
      vm.isLoading = false;
    }
  }
})();
;;(function () {
  'use strict';

  const template = `
    <adp-form
      args="::vm.args"
      form-options="::vm.formOptions"
    >
      <form-header>
        <h2 class="semi-bold">Add new "Add Single Sign-On"</h2>
      </form-header>
    
      <form-footer>
        <footer class="adp-action-b-container">
          <button
            type="button"
            ng-click="vm.onCancel()"
            class="adp-action-b-secondary"
          >
            Cancel
          </button>
    
          <button
            type="submit"
            class="adp-action-b-primary"
          >
            Setup
          </button>
        </footer>
      </form-footer>
    </adp-form>`;

  angular
    .module('app.adpSso')
    .component('adpAddSsoModal', {
      template,
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpAddSsoModalController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpSso')
    .controller('AdpAddSsoModalController', AdpAddSsoModalController);

  /** @ngInject */
  function AdpAddSsoModalController(
    ACTIONS,
    adpSsoService,
    AdpUnifiedArgs
  ) {
    const vm = this;

    vm.$onInit = () => {
      vm.profileArgs = vm.resolve.options.args;

      const identityProvider = _.get(window.adpAppStore.appModel(), 'users.fields.sso.fields.identityProvider');
      // Field 'identityProvider' in original scheme is secured for direct write
      // However, if user can change enabled value then he can add an identity provider via 'adpSsoService.setupSSO'
      const writePermission = _.get(window.adpAppStore.appModel(), 'users.fields.sso.fields.enabled.permissions.update');
      _.set(identityProvider, 'permissions.update', writePermission);
      vm.args =  AdpUnifiedArgs.getHelperParams({
        path: '',
        action: 'add-sso',
        schema: {
          type: 'Schema',
          schemaName: 'ssoItem',
          fields: { identityProvider },
        },
        formData: null,
      });

      vm.onCancel = () => vm.dismiss({ $value: 'cancel' });

      vm.formOptions = {
        localActionsStrategy: {
          submit({ row: { identityProvider} }) {
            return adpSsoService.setupSSO(identityProvider, vm.profileArgs);
          },
        },
        disableFullscreen: true,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapBarsLayer', AdpTopomapBarsLayer);

  /** @ngInject */
  function AdpTopomapBarsLayer() {
    function create({layer, topo}) {
      topo.layersGroup.add(layer.sceneGroup);
    }

    function update({data, layer, topo}) {
      const {engine, terrainGroup, globalScale = 1} = topo;
      const {bbox, proj, unitsPerMeter} = engine.getProjection([topo.lat, topo.lng], topo.radius);
      // bbox is [w, s, e, n]
      // console.log("^^ ", data)
      // console.log("^^ ", bbox, proj, unitsPerMeter)
      layer.sceneGroup.clear();
      const radialSegments = _.get(layer, 'row.radialSegments', 6);
      const dataChunks = _.chunk(data, 10);
      const rayCaster = new THREE.Raycaster();
      const rayCastDirection = new THREE.Vector3(0, -1, 0);
      const raycastHeight = (x, z) => {
        rayCaster.set(new THREE.Vector3(x * globalScale, 50 * globalScale, -z * globalScale), rayCastDirection);
        const intersect = rayCaster.intersectObject(terrainGroup);
        return _.get(intersect, "0.point.y");
      }

      return new Promise(resolve => {
        let added = 0;
        processDataChunks();

        function processDataChunks() {
          if (!_.isEmpty(dataChunks)) {
            setTimeout(() => processNextDataChunk(), 5);
          } else {
            console.log("---data chunks are processed. Added", added);
            resolve({added});
          }
        }

        function processNextDataChunk() {
          const data = dataChunks.shift();
          if (!data) {
            return;
          }
          _.each(data, ({lat, lng, diameter, height, elevation, colorString: col, name}) => {
            // ToDo: filter points by bbox (but remember that actual terrain is way larger area than mentioned by params)
            const radius = diameter / 2;
            const color = new THREE.Color(col);
            // ToDo: use color dictionary to reuse same-colored materials
            const material = new THREE.MeshStandardMaterial({color});
            const r = radius * unitsPerMeter;
            const h = height * unitsPerMeter;
            const ele = (elevation + height / 2) * unitsPerMeter;
            const geometry = new THREE.CylinderGeometry(r, r, h, radialSegments);
            const barMesh = new THREE.Mesh(geometry, material);
            const [latProj, lngProj] = proj([lat, lng]);
            const x = latProj;
            const y = raycastHeight(latProj, lngProj);
            const z = -lngProj;

            if (!_.isNil(y)) {
              barMesh.position.set(x, y / globalScale + ele, z);
              layer.sceneGroup.add(barMesh);
              added++;
            }
          });
          processDataChunks();
        }
      })
    }

    return {
      create,
      update,
    };
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapChoroplethLayer', AdpTopomapChoroplethLayer);

  /** @ngInject */
    function AdpTopomapChoroplethLayer(AdpGradientService) {
    const geoJsonCache = {};

    function update({ data, layer, topo, args }) {
      _getJsonData(layer, args).then(geoJson => _setPolygons({ geoJson, data, layer, topo, args }))
    }

    return {
      update,
    };

    function _setPolygons({ geoJson, data, layer, topo, args }) {
      const featureFilter = _getFeatureVisibilityFilterFn(layer, data);

      const polygons = _.filter(geoJson.features, featureFilter);
      const sideMaterial = new THREE.MeshLambertMaterial({
        color: '#888800',
        transparent: true,
        opacity:.2,
      });
      const colorAccessor = _getColorAccessor({ data, layer });
      topo
        .polygonStrokeColor(colorAccessor)
        .polygonsTransitionDuration(0)
        .polygonCapColor(colorAccessor)
        .polygonSideMaterial(sideMaterial)
        .polygonAltitude(_getElevationAccessor({ data, layer }))
        .polygonsData(polygons);
    }

    function _getJsonData(layer, args) {
      const geoJsonTypes = _.get(args, 'widgetConfiguration.geoJsonTypes', {});
      const fields = geoJsonTypes[layer.row.geoJson];
      const url = fields.dataUrl ? args.config.resourceUrl + fields.dataUrl : fields.externalDataUrl;

      if (url) {
        const geoJson = geoJsonCache[url];
        if (geoJson) {
          return Promise.resolve(geoJson)
        }
        return fetch(url)
          .then((res) => res.json())
          .then(geoJson => {
            geoJsonCache[url] = geoJson;
            return geoJson;
          })
      } else {
        throw new Error('Layer have no correct URL data');
      }
    }

    function _getFeatureVisibilityFilterFn(layer, data) {
      const { featureField } = layer.row;
      if (!featureField) {
        return true;
      }
      return feature => !!_findRecordForFeature(feature, featureField, data);
    }

    function _findRecordForFeature(feature, featureField, data) {
      return _.find(data, (row) => _.get(feature, ['properties', featureField]) === row.feature);
    }

    function _getColorAccessor({ data, layer }) {
      const { featureField } = layer.row;
      return feature => {
        const item = _findRecordForFeature(feature, featureField, data);

        const colorMode = layer.row.colorMode;

        if (colorMode === 'gradient') {
          const gradient = _.get(layer.row, 'gradient.data.row', {});
          const value = item.colorValue;
          const min = _.get(layer.row, 'gradientMinValue', 0);
          const max = _.get(layer.row, 'gradientMaxValue', 100);

          return AdpGradientService.mapValue(gradient, value, min, max);
        }

        return item.colorString || '#ffffff';
      }
    }

    function _getElevationAccessor({ data, layer }) {
      const { featureField } = layer.row;
      return feature => {
        const item = _findRecordForFeature(feature, featureField, data);
        return !item || _.isNil(item.elevation) ? 0.02 : item.elevation;
      }
    }
  }
})();

;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetHeader', adpWidgetHeader);

  /** @ngInject */
  function adpWidgetHeader(AdpIconsHelper, AdpSchemaService, ActionsHelpers) {
    return {
      restrict: 'E',
      scope: false,
      replace: true,
      templateUrl: 'client-modules/adp-widgets/adp-widget-header/adp-widget-header.html',
      link: function (scope) {
        const api = scope.interface || _.get(scope, 'tile.board.interface');
        const actionTypeCbGetter = {
          local: getLocalCb,
          module: ActionsHelpers.getForModuleType,
          action: ActionsHelpers.getForHelperType,
        };

        scope.actions = getActions(scope);
        scope.collapseHeader = () => scope.collapseCb && scope.collapseCb();

        const widgetRelatedAttrs = _.pickBy(scope.tile, (v, k) => _.startsWith(k, 'widget'));
        const unifiedArgs = _.assign({}, widgetRelatedAttrs, { row: scope.tile });

        scope.execAction = function (action, name, $event) {
          const cbGetter = _.get(actionTypeCbGetter, _.get(action, 'action.type', 'action'));
          if (!_.isFunction(cbGetter)) {
            return;
          }

          const cb = cbGetter(action);

          if (!cb) {
            console.log('== Action callback not found for', name);
            return;
          }

          const argsForAction = _.assign(
            {},
            unifiedArgs,
            {
              action: name,
              fieldSchema: action,
            },
            {
              customOptions: {
                widgetInterface: api,
              },
            }
          );
          return cb.apply(argsForAction, [argsForAction, $event]);
        };
        scope.getIcon = getIcon;
        scope.getCSS = (action) => {
          const className = _.get(action, 'htmlAttributes.className', '');
          return `adp-wh-control adp-action-${action.actionName} ${className}`;
        };
        scope.visibleGetter = (action) =>
          _.isString(action.visible) ? evalProperty(action, 'visible', false) : action.visible || true;

        function getLocalCb(action) {
          const methodName = _.get(action, 'action.link');
          const cb = _.get(api, methodName);
          return function () {
            const tileId = this.row.id;
            cb && cb.call(this, tileId);
          };
        }

        function evalProperty(action, propertyPath, defaultValue) {
          try {
            const args = _.assign({}, unifiedArgs, { action: name, fieldSchema: action });
            const fn = new Function(`return ${_.get(action, propertyPath)}`);
            return fn.call(args);
          } catch (e) {
            console.error(`Error evaluating "${propertyPath}"`, e);
            if (_.isNil(defaultValue)) {
              return defaultValue;
            }
          }
        }

        function getIcon(_icon) {
          if (!_icon) {
            return;
          }
          const icon = _.clone(_icon);
          if (icon.link && icon.link.indexOf('this.') >= 0) {
            icon.link = evalProperty(icon, 'link', 'smile-o');
          }
          return _.get(AdpIconsHelper.getIconHtml(icon), '0.outerHTML', '');
        }
      },
    };

    function getActions(scope) {
      const modelSchema = AdpSchemaService.getSchemaByName('_widgets');
      const actionsPos = scope.tile.position;
      const isAllowedByPosition = (action) => ActionsHelpers.isActionAllowed(action, actionsPos);
      return _.chain(modelSchema)
        .get('actions.fields')
        .pickBy(isAllowedByPosition)
        .entries()
        .orderBy(['[1].actionOrder'], ['asc'])
        .fromPairs()
        .value();
    }
  }
})();
;(function () {
  angular.module('app.adpWidgets').directive('adpWidgetTile', adpWidgetTile);

  /** @ngInject */
  function adpWidgetTile(APP_CONFIG, AdpWidgetsService) {
    return {
      restrict: 'E',
      scope: {
        tile: '<',
        interface: '<',
      },
      templateUrl: 'client-modules/adp-widgets/adp-widget-tile/adp-widget-tile.html',
      link(scope) {
        const tile = scope.tile;
        const widgetType = _.get(tile, 'widgetRow.type');
        const isForbidden = _.get(tile, 'widgetRow.isForbidden') || _.get(tile, 'widgetRow.errorMessage');
        const { containerStyle, bgStyle, headerStyle, bodyStyle, styleOptions } =
          AdpWidgetsService.getStyleValues(tile);
        const { showTitle, cssNames } = styleOptions;
        const tileId = _.get(scope, 'tile.data._id');
        if (!scope.interface) {
          scope.interface = _.get(scope, 'tile.board.interface');
        }
        scope.collapseCb = () => {
          scope.isTitleCollapsed = !scope.isTitleCollapsed;
          scope.$broadcast('widgetTileResize');
        };
        tile.$scope = scope; // ToDo: this may be crazy... but this works.
        scope.widgetType = widgetType;
        scope.containerStyle = containerStyle;
        scope.bgStyle = bgStyle;
        scope.headerStyle = headerStyle;
        scope.bodyStyle = bodyStyle;
        scope.showTitle = showTitle;
        scope.isForbidden = isForbidden;
        scope.isTitleCollapsed = false;
        scope.tileId = `tile_${tileId}`;
        scope.cssNames = cssNames;

        scope.$on('widgetIsSubscribed', onWidgetSubscribed);
        scope.widgetScopeSetter = (widgetScope) => _.set(scope, 'tile.widgetScope', widgetScope);

        function onWidgetSubscribed(e) {
          const linksInterface = AdpWidgetsService.getControlLinksInterface(scope.interface);
          if (!linksInterface) {
            return;
          }
          e.stopPropagation();
          linksInterface.markTileAsSubscribed(tileId);
        }
      },
    };
  }
})();
;(function () {
  angular.module('app.adpWidgets').factory('AdpFramesComms', framesComms);

  /** @ngInject */
  function framesComms() {
    return function ({ partnerFrame, requestProcessors, label, timeout = 2000 }) {
      const messageStack = [];

      window.addEventListener('message', receiveMessage);

      function receiveMessage(event) {
        const { data = {} } = event;
        if (data.answer) {
          processAnswer(data);
        } else {
          answerRequest(data);
        }
      }

      function answerRequest(data) {
        const { cmd, mark, payload } = data;
        // console.log(`---${label} get request`, cmd,  payload || '');
        const processor = requestProcessors[cmd];
        if (processor) {
          const result = processor(payload) || {};
          const onResult = (p) => {
            const message = { answer: mark, payload: p };
            // console.log(`---${label} answering with`, message);
            partnerFrame.postMessage(message, '*');
          };
          return result.then ? result.then(onResult) : onResult(result);
        }
      }

      function processAnswer(data) {
        const { answer, payload } = data;
        const stackItemIndex = _.findIndex(messageStack, (item) => item.mark === answer);
        if (stackItemIndex < 0) {
          console.error(`${label}: No request found for answer`, data);
          return;
        }
        const stackItem = messageStack[stackItemIndex];
        const { resolve } = stackItem;
        _.pull(messageStack, stackItem);
        resolve(payload);
      }

      function postMessage(cmd, payload) {
        const mark = Math.round(Math.random() * 1000000);
        let rs;
        let rj;
        const promise = new Promise((resolve, reject) => {
          rs = resolve;
          rj = reject;
        });
        const stackItem = { mark, resolve: rs, reject: rj, cmd };
        const message = { cmd, payload, mark };
        messageStack.push(stackItem);
        partnerFrame.postMessage(message, '*');

        setTimeout(() => {
          const stackItemIndex = _.findIndex(messageStack, (item) => item.mark === mark);
          if (stackItemIndex >= 0) {
            const item = messageStack[stackItemIndex];
            console.error(`${label}: ${item.cmd} request is not fulfilled.`);
            _.pull(messageStack, stackItem);
          }
          // ToDo: add timeout for handing messages;
        }, timeout);

        return promise;
      }

      function onDestroy() {
        window.removeEventListener('message', receiveMessage);
      }

      function registerProcessor(name, fn) {
        requestProcessors[name] = fn;
      }

      return { postMessage, registerProcessor, onDestroy };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpWidgetLinksSetup', AdpWidgetLinksSetup);

  /**********************
   *
   *   After widget update by dashboard editor links, related to widgets, need to be updated.
   *   Because widgets have different data structure, this module implements custom ways to determine all links for widget
   *   Returns two sets:
   *        1. 'ownLinks' - full link objects for every published parameter of widget (e.g. links-created-by-widget
   *        2. 'controlledLinksIds' - array of link ids which are controlled by this widget's slides (e.g. links-controlled-by-widget)
   *
   *********************/

  function AdpWidgetLinksSetup() {
    const getSliderMethods = {
      default: defaultGetSliders,
      leafletMap: leafletGetSliders,
      vis3d: vis3dGetSliders,
      control: controlGetSliders,
      sankey: sankeyGetSliders,
      graph: graphGetSliders,
      scheduler: schedulerSliders,
      calendarPicker: calendarPickerSliders,
    };

    function getWidgetSliders(widgetRow, widgetConfiguration) {
      const type = widgetRow.type;
      const fn = getSliderMethods[type] || getSliderMethods.default;

      return fn(widgetRow, widgetConfiguration);
    }

    function defaultGetSliders(widgetRow) {
      const type = widgetRow.type;
      const sliders = _.get(widgetRow, `${type}.sliders`, []);
      return _wrapWithWidgetInfo({ default: { sliders } }, widgetRow);
    }

    function leafletGetSliders(widgetRow) {
      const layerRows = _.get(widgetRow, 'leafletMap.layers', []);
      const activeLayers = _.filter(layerRows, (layer) => !layer.disabled);
      const dataLayers = _.fromPairs(
        _.map(activeLayers, (layerRow) => {
          const { type } = layerRow;
          const sliders = _.get(layerRow, [type, 'sliders'], []);
          const layerInfo = {
            name: `${layerRow.name} (${layerRow.type})`,
            sliders,
          };
          return [layerRow._id, layerInfo];
        })
      );

      return _wrapWithWidgetInfo(dataLayers, widgetRow);
    }

    function vis3dGetSliders(widgetRow) {
      return _multiGetSliders({
        widgetRow,
        slidersPathFn: (type) => `vis3d.${type}Sliders`,
      });
    }

    function controlGetSliders(widgetRow, widgetConfiguration) {
      const controllers = _.get(widgetConfiguration, 'sliders', []);
      const sliders = _.compact(
        _.map(controllers, (slider) => {
          const { controlType: type, label, linkIds } = slider;
          if (!_.get(linkIds, 'length')) {
            return;
          }
          slider.name = label ? `${label} (${type})` : type;
          return slider;
        })
      );

      return _wrapWithWidgetInfo({ default: { sliders } }, widgetRow);
    }

    function sankeyGetSliders(widgetRow) {
      return _multiGetSliders({
        widgetRow,
        slidersPathFn: (type) => `sankey.${type}Related.sliders`,
      });
    }

    function graphGetSliders(widgetRow) {
      return _multiGetSliders({
        widgetRow,
        slidersPathFn: (type) => `graph.${type}Related.sliders`,
      });
    }

    function schedulerSliders(widgetRow) {
      const dateSlider = _.get(widgetRow, `calendarPicker.dateRangeControlSlider`);
      const sliders = _.get(widgetRow, `${type}.sliders`, []);
      if (!_.isEmpty(dateSlider?.linkIds)) {
        sliders.push({ ...dateSlider, name: 'Date cell' });
      }
      return _wrapWithWidgetInfo({ default: { sliders } }, widgetRow);
    }

    function calendarPickerSliders(widgetRow) {
      const dateSlider = _.get(widgetRow, `calendarPicker.dateRangeControlSlider`);
      const sliders = _.isEmpty(dateSlider?.linkIds) ? [] : [{ ...dateSlider, name: 'Date cell' }];
      return _wrapWithWidgetInfo({ default: { sliders } }, widgetRow);
    }

    function _multiGetSliders({ widgetRow, slidersPathFn, namesArr = ['nodes', 'links'] }) {
      const dataLayers = _.fromPairs(
        _.map(namesArr, (type) => {
          const typeName = _.upperFirst(type);
          const sliders = _.get(widgetRow, slidersPathFn(type), []);
          const layerInfo = {
            name: `${typeName} links`,
            sliders,
          };
          return [typeName, layerInfo];
        })
      );

      return _wrapWithWidgetInfo(dataLayers, widgetRow);
    }

    function _wrapWithWidgetInfo(_dataLayers, widgetRow) {
      const { type, name, _id: id } = widgetRow;
      const dataLayers = _.pickBy(_dataLayers, (layer) => _.get(layer, 'sliders.length'));
      return { id, name, type, dataLayers };
    }

    return {
      getWidgetSliders,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpWidgetsEjs', AdpWidgetsEjs);

  // Be carefull with injections - this module is used in ar-anything webpack compilation
  function AdpWidgetsEjs() {
    function compile({ template }) {
      if (!template) {
        return () => '';
      }
      try {
        const unescaped = template.replaceAll(
          /&lt;%(.*?)%&gt;/g,
          (m, $1) => `<%${_.unescape($1).replaceAll('&nbsp;', ' ')}%>`
        );
        return window.ejs.compile(unescaped, { client: true });
      } catch (e) {
        console.error(e.message);
        return () => 'Template compilation error.';
      }
    }

    function render({ template, data: dt = {}, context }) {
      const compiled = compile({ template });
      const data = { ...dt, _: window.lodash, dayjs: window.dayjs, window };

      try {
        return compiled.call(context, data);
      } catch (e) {
        console.error(e.message);
        return 'Template render error.';
      }
    }

    return {
      compile,
      render,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpWidgetsTooltipService', adpWidgetsTooltipService);

  function adpWidgetsTooltipService(AdpWidgetsService) {
    return {
      getTooltipFunction,
    };

    function getTooltipFunction({ args, path, memoizeKeyGetter, mappedFieldGetter }) {
      const tooltipTmpl = _.trim(_.get(args, path));
      if (!tooltipTmpl) {
        return;
      }

      const oneOnly = (x) => (_.isArray(x) ? x[0] : x);
      const keyGetter = (_item, contextParams) => {
        const item = _item && oneOnly(_item);
        return memoizeKeyGetter(item);
      };

      return AdpWidgetsService.memoize((_item, contextParams) => {
        const item = oneOnly(_item);
        if (!item) {
          return '';
        }

        const tooltipContext = {
          ...contextParams,
          mapped: mappedFieldGetter(item),
          row: item,
        };

        return AdpWidgetsService.getTooltipText(tooltipTmpl, tooltipContext);
      }, keyGetter);
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpWidgetsHelper', AdpWidgetsHelper);

  function AdpWidgetsHelper(APP_CONFIG, AdpSessionHelper) {
    function preventAuthEffects() {
      AdpSessionHelper.cancelAllTimers();
    }

    function setManifestFile({ _id, sharedWidgetId }) {
      const elem = document.querySelector('link[rel="manifest"]');
      if (!elem) {
        // ToDo: create manifest declaration if not exists
        return;
      }
      const { apiPrefix } = APP_CONFIG;
      const manifestFileName = `${apiPrefix}/manifest.${sharedWidgetId || _id}.json`;
      elem.setAttribute('href', manifestFileName);
    }

    return {
      preventAuthEffects,
      setManifestFile,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpWidgetsService', adpWidgetsService);

  function adpWidgetsService(
    $rootScope,
    $compile,
    APP_CONFIG,
    ServerError,
    ErrorHelpers,
    AdpNotificationService,
    AdpClientCommonHelper,
    AdpSchemaService,
    $http,
    $timeout,
    AdpSocketIoService,
    AdpWidgetsEjs,
    ObjectId
  ) {
    const semaphores = {};
    const localDataCache = {};

    function _semaphoreInterface(semaphoreName, promise) {
      const currentSemaphore = semaphores[semaphoreName];
      if (_.isUndefined(promise)) {
        return currentSemaphore;
      } else {
        if (currentSemaphore) {
          throw new Error('Semaphore ' + semaphoreName + ' already exists');
        } else {
          semaphores[semaphoreName] = new Promise((resolve) => {
            promise.then((promiseResult) => {
              delete semaphores[semaphoreName];
              resolve(promiseResult);
            });
          });
        }
      }
    }

    function loadVendorCodeOnce(isVendorCodeReadyFn, loaderFn, semaphoreName) {
      if (isVendorCodeReadyFn()) {
        return Promise.resolve();
      }
      // We need to check if vendor code is present, to coordinate its loading between widgets
      const semaphore = _semaphoreInterface(semaphoreName);

      if (!semaphore) {
        const loadingPromise = loaderFn();
        _semaphoreInterface(semaphoreName, loadingPromise);

        return loadingPromise;
      } else {
        return semaphore.then(() => loadVendorCodeOnce(isVendorCodeReadyFn, loaderFn, semaphoreName));
      }
    }

    function fetchWidgetData(args, _options = {}) {
      const options = _options.default ? _options.default : _options;
      const dataLayerId = options.dataLayerId || 'default';
      const useLocalProcessing = _.get(args, ['widgetDataLayers', dataLayerId, 'useLocalProcessing']);

      if (useLocalProcessing) {
        const cacheKey = `${args.row._id}-${dataLayerId}`;
        if (_.isEmpty(localDataCache[cacheKey])) {
          return _fetchDataFromServer(args, { ...options, filter: '', virtualFilters: '' }).then((data) => {
            localDataCache[cacheKey] = data;
            return _processDataLocally(data, options, args);
          });
        }

        return _processDataLocally(localDataCache[cacheKey], options, args);
      }
      return _fetchDataFromServer(args, options);
    }

    const processHandlers = {
      defaultFiltering({ args, options, context }) {
        if (!options.filter) {
          context.output = context.input;
          return;
        }
        const dataLayerId = options.dataLayerId || 'default';
        const namesMap = _.get(args, `widgetConfiguration.layersConf.${dataLayerId}.namesMap`);
        const filtrationFn = _createFiltrationFn(options, namesMap);
        context.output = _.filter(context.input, filtrationFn);
      },
      customJsCode({ args, context, processStage }) {
        const { code } = processStage.customJsCode;
        new Function('_, ObjectId, dayjs, JSON5', code).apply(context, [_, ObjectId, dayjs, JSON5]);
      },
    };

    function _processDataLocally({ data }, options, args) {
      const dataLayerId = options.dataLayerId || 'default';
      const processStages = _.get(args, ['widgetDataLayers', dataLayerId, 'processStages']);
      if (!_.isArray(processStages) || !processStages.length) {
        return Promise.resolve({ data });
      }

      const context = { input: data };
      _.each(processStages, (processStage) => {
        const handler = processHandlers[processStage.type];
        handler && handler({ args, context, options, processStage });
      });
      return Promise.resolve({ data: context.output });
    }

    function _createFiltrationFn({ filter }, namesMap) {
      const fnBody = `return ${_convertFilter(filter, namesMap)}`;
      return new Function('row', fnBody);
    }

    function _getOperationValue(v) {
      if (_.isString(v)) {
        return `'${v}'`;
      }
      if (_.isDate(v)) {
        return `'${v.toISOString()}'`;
      }
      return v.toString();
    }

    function _convertFilter(filter, namesMap) {
      if (_.isEmpty(filter)) {
        return 'true';
      }
      if (_.get(filter, 'length') === 1) {
        return _convertFilter(filter[0], namesMap);
      }
      const [f, op, v] = filter;
      if (op === 'or' || op === 'and') {
        const logicMap = { or: '||', and: '&&' };
        return _(filter)
          .chunk(2)
          .map((expr) => _embrace(_convertFilter(expr[0], namesMap)))
          .value()
          .join(` ${logicMap[op]} `);
      }

      const operations = {
        '=': (f, v) => `${f} === ${_getOperationValue(v)}`,
        '!=': (f, v) => `${f} !== ${_getOperationValue(v)}`,
        '>': (f, v) => `${f} > ${_getOperationValue(v)}`,
        '>=': (f, v) => `${f} >= ${_getOperationValue(v)}`,
        '<': (f, v) => `${f} < ${_getOperationValue(v)}`,
        '<=': (f, v) => `${f} <= ${_getOperationValue(v)}`,
        contains: (f, v) => `${f}?.includes('${v}')`,
        notcontains: (f, v) => `!${f}?.includes('${v}')`,
        startswith: (f, v) => `${f}?.startsWith('${v}')`,
        endswith: (f, v) => `${f}?.endsWith('${v}')`,
        regex: (f, v) => `${f}?.match(/${v}/)`,
      };
      const operation = operations[op];
      if (!operation) {
        console.error('Local filtering operation', op, 'is not supported. Filter is [', f, op, v, ']');
        return 'true';
      }
      // namesMap is not defined for most widget types (in fact in the time of writing it was only defined for 3d-globe layers)
      // So we filter by original filed names.
      // namesMap should be defined for each widget with data mapping for proper filtering
      const fieldMappedName = _.isNil(namesMap) ? f : _.get(namesMap, f);
      const fieldName = fieldMappedName ? `row.${fieldMappedName}` : `row._mappedFields?.${f}`;
      return operation(fieldName, v, op);
    }

    function _embrace(expr) {
      return `(${expr})`;
    }

    function _fetchDataFromServer(args, options) {
      const { row, isEmbedded } = args;
      const { publishedEndpointPrefix, apiUrl } = APP_CONFIG;
      const { _id, sharedWidgetId } = row;
      const prefix = isEmbedded ? publishedEndpointPrefix : '';
      const url = apiUrl + prefix + '/w/d';
      const widgetIdPart = isEmbedded ? { sharedWidgetId } : { _id };
      const body = { ...options, ...widgetIdPart };
      return $http
        .post(url, body)
        .then(({ data }) => {
          if (data.success === false) {
            const message = `${row.name}(${row.type}) data error: ${data.message}`;
            throw new ServerError(message);
          }
          if (data.errors) {
            throw new ServerError(data.errors.join('; '));
          }
          return data.data;
        })
        .catch((err) => {
          ErrorHelpers.handleError(err, 'Widget data loading error');
          return { data: [], messages: [err.message || err] };
        });
    }

    function handleControlLinkChange({
      scope,
      widgetId,
      onLinkChange,
      onSelectLinkChange,
      handleThisWidgetEvents = false,
    }) {
      const linksInterface = getControlLinksInterface(scope.interface);
      if (!linksInterface) {
        return;
      }

      _resetLocalFilteringCacheForWidget(widgetId);

      const dataLayerFilters = {};
      const throttleMarkers = {};
      const allLinks = linksInterface.getLinks();

      scope.$on('controlLinkValueChange', changeEventHandler);
      scope.$emit('widgetIsSubscribed', { widgetId });

      linksInterface.resendAllWidgetLinks(widgetId);

      function changeEventHandler(e, eventPayload) {
        const {
          linkId,
          sourceWidgetId,
          dxFilter,
          value: filterValue,
          throttle = 0,
          fromSlider,
          handleBySameWidget,
        } = eventPayload;
        const link = allLinks[linkId];
        const { paramName, dataLayerId = 'default', isVirtual, selectOnly } = link;
        const ignoreEvent =
          !fromSlider || (!handleBySameWidget && !handleThisWidgetEvents && sourceWidgetId === widgetId);

        if (ignoreEvent) {
          return;
        }
        // ToDo - pick this min timeout === 300 from configuration (user or interface, need to decide)
        const timeout = Math.max(throttle, 300);
        const sourceId = getFilterSourceTag(eventPayload);
        const lockedMarkerId = _getLockMarkerId(dataLayerId, selectOnly);
        let lockedMarker = {};
        _.set(throttleMarkers, lockedMarkerId, lockedMarker);
        _.set(dataLayerFilters, [dataLayerId, paramName], { dxFilter, sourceId, filterValue, isVirtual, selectOnly });

        $timeout(() => onFilterChange(lockedMarker, eventPayload, paramName), timeout);
      }

      function onFilterChange(lockedMarker, eventPayload, paramName) {
        const { linkId, readyResolver } = eventPayload;
        const link = allLinks[linkId];
        const { dataLayerId = 'default', selectOnly } = link;
        const onReady = readyResolver ? (status) => readyResolver(status) : _.noop;
        const lockedMarkerId = _getLockMarkerId(dataLayerId, selectOnly);
        const marker = _.get(throttleMarkers, lockedMarkerId);

        if (lockedMarker !== marker) {
          onReady();
          return;
        }

        const dataLayerFilter = _.get(dataLayerFilters, dataLayerId, {});

        // ToDo: rethink logic as many event type are introduced and code become messy
        if (selectOnly && onSelectLinkChange) {
          const selectionFilters = getSelectionOnlyFilters(dataLayerFilter);
          const parameters = {
            dataLayerId,
            selectionFilters,
            changedParamName: paramName,
          };
          filterCallbackProcessor(onSelectLinkChange, parameters, () => onReady(true));
          return;
        }

        const combinedFilter = combineDataLayerFilters(dataLayerFilter);
        const virtualFilters = getVirtualFilters(dataLayerFilter);
        const dataLoadParams = {
          dataLayerId,
          dxFilter: combinedFilter.length ? combinedFilter : '',
          datasetId: eventPayload.datasetId,
          virtualFilters,
        };

        filterCallbackProcessor(onLinkChange, dataLoadParams, () => {
          onReady(true);
        });
      }

      function filterCallbackProcessor(onChangeCb, changeParams, onReadyCb) {
        const loaderCanceler = delayLoader(scope);
        const result = Promise.resolve(onChangeCb(changeParams));

        result.then(onReadyCb).finally(loaderCanceler);

        return result;
      }

      function combineDataLayerFilters(dataLayerFilter) {
        const filters = _.filter(
          dataLayerFilter,
          ({ dxFilter, isVirtual, selectOnly }) => !isVirtual && !_.isEmpty(dxFilter) && !selectOnly
        );
        let combinedFilter;

        if (filters.length === 1) {
          combinedFilter = filters[0].dxFilter;
        } else {
          const groups = groupFiltersBySource(filters);
          const sameSourceFilters = _.map(groups, (groupFilters) => unionFilters(groupFilters, 'or'));
          combinedFilter = unionFilters(sameSourceFilters, 'and');
        }

        return combinedFilter;
      }

      function getVirtualFilters(dataLayerFilter) {
        return _.chain(dataLayerFilter)
          .pickBy(({ isVirtual }) => isVirtual)
          .mapValues((item) => item.dxFilter)
          .value();
      }

      function getSelectionOnlyFilters(dataLayerFilter) {
        return _.chain(dataLayerFilter)
          .pickBy(({ selectOnly }) => selectOnly)
          .mapValues((item) => item.filterValue)
          .value();
      }

      function groupFiltersBySource(filters) {
        return _.reduce(
          filters,
          (groups, { dxFilter, sourceId }) => {
            if (!groups[sourceId]) {
              groups[sourceId] = [];
            }
            groups[sourceId].push(dxFilter);
            return groups;
          },
          {}
        );
      }

      function unionFilters(filters, operand) {
        const result = [];
        _.each(filters, (dxFilter, indx) => {
          if (dxFilter.length) {
            indx && result.push(operand);
            result.push(dxFilter);
          }
        });
        return result;
      }

      function getFilterSourceTag(eventPayload) {
        const { sourceWidgetId, sourceControlId } = eventPayload;
        const isSourceUnknown = !sourceWidgetId && !sourceControlId;
        if (isSourceUnknown) {
          const avoidsUnnecessaryGrouping = Math.round(Math.random() * 100000);
          return avoidsUnnecessaryGrouping;
        }
        return `${sourceWidgetId}${sourceControlId}`;
      }

      function _getLockMarkerId(dataLayerId, selectOnly) {
        return `${selectOnly ? 's' : 'f'}${dataLayerId}`;
      }
    }

    function _resetLocalFilteringCacheForWidget(widgetId) {
      _.each(_.keys(localDataCache), (key) => {
        if (_.startsWith(key, widgetId)) {
          localDataCache[key] = null;
        }
      });
    }

    function handleDatasetUpdate({ args, $element, onDatasetUpdate }) {
      const listenWsConfig = _.get(args, `widgetListenWs`);

      if (!listenWsConfig) {
        return;
      }

      const widgetId = args.row._id;
      AdpSocketIoService.subscribeWidget(widgetId);
      AdpSocketIoService.registerMessageProcessor(processor, {});

      $element.on('$destroy', onDestroy);

      function processor(wsBody) {
        const { type, updates } = wsBody;
        if (type === 'widgetUpdates' && updates) {
          const widgetChanges = updates.find((elem) => elem.widgetId === widgetId);
          if (widgetChanges) {
            const changedLayers = widgetChanges.dataLayerIds || ['default'];
            return onDatasetUpdate(changedLayers);
          }
        }
      }

      function onDestroy() {
        // ToDo: in case of two same widgets on the dashboard unsubscribing one will unsubscribe all...
        AdpSocketIoService.unSubscribeWidget(widgetId);
        AdpSocketIoService.unRegisterMessageProcessor(processor);
      }
    }

    function getSlidersOfWidget(args, editInterface, linksPath = 'sliders') {
      const widgetType = _.get(args, 'row.type');
      const sliders = _.get(args, `row.${widgetType}.${linksPath}`);
      const linksInterface = getControlLinksInterface(editInterface);

      if (!_.isArray(sliders) || !linksInterface) {
        return [];
      }

      return sliders;
    }

    function touchLinksControlledByWidget(widgetId, editInterface) {
      const linksInterface = getControlLinksInterface(editInterface);

      if (!linksInterface) {
        return [];
      }
      linksInterface.awaitAllWidgetsSubscribed().then(() => {
        // Pause is required here because after 'allWidgetsSubscribed' control widgets start initialisation,
        // sending its initial filters to all widgets.
        // We need to let Control Widgets do it prior to touching widget-controlled links.
        $timeout(() => {
          linksInterface.touchLinksControlledByWidget(widgetId);
        }, 750);
      });
    }

    function isWidgetControlled(widgetId, editInterface) {
      const linksInterface = getControlLinksInterface(editInterface);

      if (!linksInterface) {
        return false;
      }

      return linksInterface.isWidgetControlled(widgetId);
    }

    function getControlLinksInterface(scopeInterface) {
      return _.get(scopeInterface, 'controlLinks');
    }

    function sendControlledLinksChangeEvents(value, linkIds, widgetId, editInterface) {
      const linksInterface = getControlLinksInterface(editInterface);

      if (!linksInterface) {
        return false;
      }

      const simplifiedValue = _eventValueSimplify(value);
      const eventPayloads = _.map(linkIds, (linkId) => ({
        linkId,
        value: simplifiedValue,
        sourceWidgetId: widgetId,
        sourceControlId: widgetId,
      }));

      // ToDo: process result of send function somehow
      linksInterface.setLinkValue(eventPayloads);
    }

    function _eventValueSimplify(value) {
      const op = _.get(value, '0');
      if (!op) {
        return ['empty'];
      }
      const data = value.slice(1);

      if (op === 'any' && data.length === 1) {
        return ['=', data[0]];
      }

      return _.clone(value);
    }

    function _transformWidgetDatasource(dataSources) {
      const widgetListenWs = _.chain(dataSources)
        .map(({ listenWithWs }, dataLayerName) => (listenWithWs ? [dataLayerName, listenWithWs] : null))
        .compact()
        .fromPairs()
        .value();
      const widgetDataLayers = _.mapValues(dataSources, (dataSourceInfo) => _.omit(dataSourceInfo, ['listenWithWs']));
      return { widgetListenWs, widgetDataLayers };
    }

    function sendValuesToControlled(clickValuesArr, sliders, widgetId, editInterface) {
      _.each(sliders, (slider, index) => {
        const values = _.map(clickValuesArr, (clickValues) => _.get(clickValues, index));
        const filter = values.length === 1 ? ['=', values[0]] : values.length > 1 ? ['any', ...values] : ['empty'];
        sendControlledLinksChangeEvents(filter, slider.linkIds, widgetId, editInterface);
      });
    }

    function handleControlledLinksChange({ onLinkUpdate, widgetId, scope }) {
      const debouncedHandler = _.debounce(updateEventHandler, 100);

      scope.$on('controlLinkValueChange', debouncedHandler);

      function updateEventHandler(e, eventPayload) {
        const { sourceWidgetId, fromSlider } = eventPayload;
        const ignoreEvent = fromSlider || sourceWidgetId === widgetId;
        if (ignoreEvent) {
          return;
        }

        onLinkUpdate(eventPayload);
      }
    }

    function getTooltipText(template, data) {
      return AdpWidgetsEjs.render({ template, data });
    }

    function memoize(fn, getKey) {
      const cache = {};

      return function () {
        const key = getKey(...arguments);

        if (cache[key] !== undefined) {
          return cache[key];
        }

        const result = fn(...arguments);
        cache[key] = result;

        return result;
      };
    }

    function exportElementAsPng({ selector, filePrefix }) {
      const toast = AdpNotificationService.notifyInfo('Exporting, wait a while...');

      if (_.isUndefined(window.html2canvas)) {
        const jsUrl = `${APP_CONFIG.resourceUrl}/public/js/lib/html2canvas/index.js`;
        AdpClientCommonHelper.loadScript(jsUrl).then(_doExport);
      } else {
        _doExport();
      }

      function _doExport() {
        try {
          window
            .html2canvas(document.querySelector(selector))
            .then((canvas) => {
              canvas.toBlob((blob) => {
                AdpClientCommonHelper.downloadFile({ blob, filePrefix });
                AdpNotificationService.notifySuccess('Exported successfully!', '', { replace: toast });
              });
            })
            .catch((e) => {
              throw e;
            });
        } catch (e) {
          console.log('Error while exporting into image', e);
          AdpNotificationService.notifyError('Export is failed');
        } finally {
          toastr.clear(toast);
        }
      }
    }

    function setWidgetScopeToTile(widgetScope) {
      let curScope = widgetScope;
      while (!curScope.widgetScopeSetter && curScope.$parent) {
        curScope = curScope.$parent;
      }
      if (curScope.widgetScopeSetter) {
        curScope.widgetScopeSetter(widgetScope);
      }
    }

    function resetTileWidget(tile) {
      const scope = tile.$scope;
      const { $container } = tile;
      if (!$container) {
        console.error('No $container in tile');
        return;
      }

      const template = `<adp-widget-tile tile="tile" args="args" interface="interface"/>`;
      for (let cs = scope.$$childHead; cs; cs = cs.$$nextSibling) {
        cs.$destroy();
      }

      const $el = $compile(template)(scope);
      $('adp-widget-tile', $container).remove();

      $container.prepend($el);
    }

    function updateTileWidget({ tile, serverData }) {
      const { widgetRow, widgetConfiguration, widgetDatasource } = serverData;
      tile.widgetRow = widgetRow;
      tile.widgetConfiguration = widgetConfiguration;
      tile.widgetDatasource = widgetDatasource;

      _expandChildTiles(tile);

      return resetTileWidget(tile);
    }

    function getWidgetUnifiedArgs(tile) {
      const isEmbedded = !!_.get(tile, 'board.isEmbedded');
      const { widgetListenWs, widgetDataLayers } = _transformWidgetDatasource(tile.widgetDatasource);
      return {
        ..._.pick(tile, ['widgetConfiguration', 'widgetNoFilterMessages']),
        widgetListenWs,
        widgetDataLayers,
        widgetSchema: _getWidgetInterface(tile),
        modelSchema: AdpSchemaService.getSchemaByName('_widgets'),
        appSchema: window.adpAppStore.appModel(),
        config: _.cloneDeep(APP_CONFIG),
        row: tile.widgetRow,
        isEmbedded,
      };
    }

    function _getWidgetInterface(tile) {
      const INTERFACE = window.adpAppStore.appInterface();
      const widgetType = _.get(tile, 'widgetRow.type');
      return _.get(INTERFACE, ['widgets', widgetType]);
    }

    function tileFromRow(tile, position, board, $parentScope) {
      const { widgetRow, widgetConfiguration = {}, widgetNoFilterMessages, widgetDatasource, tileRow: data } = tile;
      const id = data._id;
      const $scope = $rootScope.$new();
      const result = {
        id,
        $scope,
        board,
        data,
        position,
        widgetRow,
        widgetConfiguration,
        widgetDatasource,
        widgetNoFilterMessages,
      };

      $scope.tile = result;

      _expandChildTiles(result);

      return result;
    }

    function _expandChildTiles(tile) {
      const { widgetConfiguration, board, position } = tile;
      const tiles = _.get(widgetConfiguration, 'tiles');
      // ToDO: need to introduce attribute 'container' for this cases
      if (tiles) {
        tile.tiles = _.map(tiles, (tileRow) => tileFromRow(tileRow, position, board));
      } else {
        delete tile.tiles;
      }

      return tile;
    }

    function loadWidgetConfig(_id) {
      const body = { _id };
      const url = `${APP_CONFIG.apiUrl}/w/c`;

      return $http.post(url, body).then((result) => {
        const { data, success, error } = result.data;
        if (!success) {
          throw ServerError(error);
        }

        return data;
      });
    }

    function delayLoader(scope, attrName = 'isLoading', delay = 500) {
      const timer = $timeout(() => {
        scope[attrName] = true;
      }, delay);
      return () => {
        $timeout.cancel(timer);
        scope[attrName] = false;
      };
    }

    function getTilesWidgetIds(tiles) {
      return _(tiles)
        .map((tile) => {
          if (tile.tiles) {
            return getTilesWidgetIds(tile.tiles);
          }
          const widgetId = _.get(tile, 'widgetRow._id');
          return [widgetId];
        })
        .flatten()
        .compact()
        .value();
    }

    function getStyleValues(tile, stylingConfigPath = `data.styling`, defaults = {}) {
      const { skin } = window.forcedThemes || window.adpAppStore.appInterface();
      const theme = skin === 'smart-style-5' ? 'dark' : 'light';
      const containerStyle = {};
      const bgStyle = {};
      const headerStyle = {};
      const bodyStyle = {};
      const styleOptions = {
        showTitle: getByPath('header.showTitle', 'hover'),
        cssNames: getByPath('cssNames', '')
          .split(/[^\w_-]+/)
          .join(' '),
      };

      setAttribute(containerStyle, 'marginTop', 'px', 'dimensions.marginTop');
      setAttribute(containerStyle, 'marginBottom', 'px', 'dimensions.marginBottom');
      setAttribute(containerStyle, 'marginLeft', 'px', 'dimensions.marginLeft');
      setAttribute(containerStyle, 'marginRight', 'px', 'dimensions.marginRight');

      setAttribute(bodyStyle, 'marginTop', 'px', 'dimensions.paddingTop');
      setAttribute(bodyStyle, 'marginBottom', 'px', 'dimensions.paddingBottom');
      setAttribute(bodyStyle, 'marginLeft', 'px', 'dimensions.paddingLeft');
      setAttribute(bodyStyle, 'marginRight', 'px', 'dimensions.paddingRight');

      setAttribute(bgStyle, 'backgroundColor', '', 'background.color');
      setAttribute(bgStyle, 'backgroundRepeat', '', 'background.repeat');
      setAttribute(bgStyle, 'backgroundAttachment', '', 'background.attachment');

      const blur = getByPath('background.blur', 0);
      if (blur) {
        containerStyle.backdropFilter = `blur(${blur}px)`;
      }

      setAttribute(containerStyle, 'borderWidth', 'px', 'border.width');
      setAttribute(containerStyle, 'borderColor', '', 'border.color');
      setAttribute(containerStyle, 'borderStyle', '', 'border.style');

      const shadowX = getByPath('shadow.x', 0);
      const shadowY = getByPath('shadow.y', 0);
      const shadowBlur = getByPath('shadow.blur', 0);
      const shadowSpread = getByPath('shadow.spread', 0);
      const shadowColor = getByPath('shadow.color', 'black');
      const shadowOpacity = getByPath('shadow.opacity', 50);
      const borderRadiusNum = getByPath('border.radius', 0);

      if (shadowBlur || shadowSpread || shadowX || shadowY) {
        const alphaShadowColor = hexColorWithOpacity(shadowColor, shadowOpacity);
        containerStyle.boxShadow = `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${alphaShadowColor}`;
      }

      if (borderRadiusNum) {
        containerStyle.borderRadius = `${borderRadiusNum}px`;
        headerStyle.padding = `0 ${borderRadiusNum / 2}px 0 ${borderRadiusNum / 7}px`;
      }

      const defaultHeaderColor =
        theme === 'light' ? defaults.headerBgLight || '#87CEFA' : defaults.headerBgDark || '#10486b';
      const defaultHeaderOpacity = _.isNil(defaults.headerOpacity) ? 100 : defaults.headerOpacity;
      const headerColor = getByPath('header.bgColor', defaultHeaderColor);
      const headerOpacity = getByPath('header.opacity', defaultHeaderOpacity);
      headerStyle.backgroundColor = hexColorWithOpacity(headerColor, headerOpacity);

      setAttribute(headerStyle, 'fontFamily', '', 'header.face');
      setAttribute(headerStyle, 'color', '', 'header.textColor');
      setAttribute(headerStyle, 'textAlign', '', 'header.align');

      const opacity = getByPath('background.opacity', 100) / 100;
      if (opacity < 1) {
        bgStyle.opacity = opacity;
      }

      const position = getByPath('background.position', '');
      if (position) {
        bgStyle.backgroundPosition = position === 'manual' ? getByPath('background.positionManual', '') : position;
      }

      const size = getByPath('background.size', '');
      if (size) {
        bgStyle.backgroundSize = size === 'manual' ? getByPath('background.sizeManual', '') : size;
      }

      const image = getByPath('background.image[0]');
      if (image) {
        const type = image.cropped ? 'CROPPED' : 'ASIS';
        const imageUrl = `${APP_CONFIG.apiUrl}/file-permanent/${image.id}?fileType=${type}`;
        bgStyle.backgroundImage = `url(${imageUrl})`;
      }

      return { containerStyle, bgStyle, headerStyle, bodyStyle, styleOptions };

      function getByPath(path, defaultValue) {
        return getStyleAttribute({ tile, stylingConfigPath, path, defaultValue });
      }

      function setAttribute(styleObj, attrName, units, _path, defaultValue) {
        const path = _path || attrName;
        const value = getByPath(path, defaultValue);
        if (!_.isNil(value)) {
          styleObj[attrName] = value + units;
          return value;
        }
      }
    }

    function getStyleAttribute({ tile, stylingConfigPath = `data.styling`, path, defaultValue }) {
      const tileValue = _.get(tile, `${stylingConfigPath}.${path}`);
      if (!_.isNil(tileValue) && tileValue !== 'inherit') {
        return tileValue;
      }
      // const containerValue = _.get(scope, `tile.container.data.styling.tile.${path}`);
      //
      // if (!_.isNil(containerValue)) {
      //   return containerValue;
      // }
      //*
      let containerPath = `container`;
      do {
        const hasContainerTile = !!_.get(tile, containerPath);
        if (!hasContainerTile) {
          break;
        }
        const inheritedValue = _.get(tile, `${containerPath}.${stylingConfigPath}.tile.${path}`);
        if (!_.isNil(inheritedValue)) {
          return inheritedValue;
        }
        containerPath += '.container';
      } while (true);
      //  * */

      if (!_.isNil(defaultValue)) {
        return defaultValue;
      }
      return null;
    }

    function hexColorWithOpacity(hex, opacity) {
      const colors = _.range(3).map((i) => parseInt(hex.substring(1 + i * 2, 3 + i * 2), 16));
      const colString = colors.join(',');

      return opacity < 100 ? `rgba(${colString},${opacity / 100})` : `rgb(${colString})`;
    }

    function getArMarkerAttributes(args) {
      const { row, config } = args;
      const { type: widgetType } = row;
      const markerPatternType = _.get(row, `${widgetType}.arParameters.markerPatternType`) || 'hiro';
      const markerAttrs = {
        smooth: true,
        'smooth-count': 10,
      };

      if (markerPatternType === 'hiro') {
        markerAttrs.preset = 'hiro';
      } else {
        const { apiUrl, publishedEndpointPrefix } = config;
        const { canBeShared, sharedWidgetId, _id } = row;
        const markerFileName = canBeShared
          ? `${apiUrl}${publishedEndpointPrefix}/w/ar/p/${sharedWidgetId}`
          : `${apiUrl}/w/ar/p/${_id}`;
        markerAttrs.type = 'pattern';
        markerAttrs.patternUrl = markerFileName;
        console.log(`==== Marker URL for ${widgetType} is `, markerFileName);
      }

      return markerAttrs;
    }

    return {
      getWidgetUnifiedArgs,
      fetchWidgetData,
      loadVendorCodeOnce,
      handleControlLinkChange,
      handleDatasetUpdate,
      isWidgetControlled,
      getControlLinksInterface,
      getSlidersOfWidget,
      sendValuesToControlled,
      sendControlledLinksChangeEvents,
      touchLinksControlledByWidget,
      handleControlledLinksChange,
      getTooltipText,
      exportElementAsPng,
      memoize,
      setWidgetScopeToTile,
      delayLoader,
      getStyleValues,
      getStyleAttribute,
      hexColorWithOpacity,
      getArMarkerAttributes,
      tileFromRow, // Used in dashboards module!!!
      resetTileWidget, // Used in dashboards module!!!
      updateTileWidget, // Used in dashboards module!!!
      loadWidgetConfig, // Used in dashboards module!!!
      getTilesWidgetIds, // Used in dashboards module!!!
    };
  }
})();
;(function () {
  angular.module('app.aggregationPipeline').component('aggregationPipelineDataPreview', {
    templateUrl:
      'client-modules/aggregation-pipeline/aggregation-pipeline-data-preview/aggregation-pipeline-data-preview.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: AggregationPipelineDataPreview,
    controllerAs: 'vm',
  });

  function AggregationPipelineDataPreview(APP_CONFIG, ErrorHelpers, $http, $element) {
    const typeToColumnType = {
      Date: 'date',
      Time: 'string',
      DateTime: 'datetime',
      String: 'string',
      Number: 'number',
      Double: 'number',
      Int32: 'number',
      Int64: 'number',
      Boolean: 'boolean',
      TriStateBoolean: 'string',
      ObjectID: 'string',
      Password: 'string',
      Email: 'string',
      Phone: 'string',
      Url: 'string',
      Text: 'string',
      Barcode: 'string',
      Html: 'string',
      Code: 'string',
    };
    const vm = this;
    vm.loading = true;

    vm.$onInit = function () {
      vm.options = vm.resolve.options;

      const { row, presentation } = vm.options;
      const url = `${APP_CONFIG.apiUrl}/aggregation-pipeline-preview`;
      const updatedRow = _.assign({}, row, { customViewPresentation: presentation });

      return $http
        .post(url, { data: updatedRow })
        .then(({ data }) => {
          const { success, isValidPipeline, message, data: rows, schemaFields } = data;
          const validPipelineMessage = isValidPipeline ? 'Pipeline is valid. ' : '';
          if (!success) {
            throw new Error(validPipelineMessage + message);
          }
          return _initGrid(rows, schemaFields);
        })
        .catch((e) => {
          if (e.message) {
            vm.message = e.message;
          }

          ErrorHelpers.handleError(e, 'Aggregation pipeline preview error');
        })
        .finally(() => {
          vm.loading = false;
        });
    };

    vm.close = () => vm.dismiss({ confirmed: false });

    function _initGrid(data, schemaFields) {
      const columns = _getColumns(schemaFields);
      vm.message = '';

      $('.ap-grid-container', $element).dxDataGrid({
        dataSource: data,
        columns,
        pager: {
          showInfo: true,
          showNavigationButtons: true,
        },
        hoverStateEnabled: true,
        showColumnLines: true,
        allowColumnResizing: true,
        width: '100%',
      });
    }

    function _getColumnType(type) {
      if (type.indexOf('[]') > 0) {
        return 'object';
      }
      return typeToColumnType[type] || 'object';
    }

    function _getColumns(schemaFields) {
      return _.map(schemaFields, (field, fieldName) => {
        const dataType = _getColumnType(field.type);
        const line = {
          dataType,
          dataField: fieldName,
          caption: field.fullName,
          sortingMethod: _getSortingMethod(dataType),
          minWidth: 50,
        };

        if (line.dataType === 'object') {
          line.cellTemplate = _cellTemplateObject;
        }

        return line;
      });
    }

    function _getSortingMethod(type) {
      const methodsMap = {
        string: stringSort,
        number: numberSort,
        date: datetimeSort,
        datetime: datetimeSort,
      };

      return methodsMap[type] || stringSort;
    }

    function nullSort(a, b) {
      const aIsNull = _.isNil(a);
      const bIsNull = _.isNil(b);

      if (aIsNull && bIsNull) return 0;
      if (aIsNull) return -1;
      if (bIsNull) return 1;

      return null;
    }

    function stringSort(a, b) {
      const nullCompare = nullSort(a, b);
      return nullCompare === null ? a.localeCompare(b) : nullCompare;
    }

    function numberSort(a, b) {
      const nullCompare = nullSort(a, b);
      if (!_.isNull(nullCompare)) {
        return nullCompare;
      }
      if (a === b) {
        return 0;
      }
      return a < b ? -1 : 1;
    }

    function datetimeSort(a, b) {
      return numberSort(a.getTime(), b.getTime());
    }

    function _cellTemplateObject(container, params) {
      const text = JSON.stringify(params.value, null, 1);
      container.append($('<span>').text(text));
    }
  }
})();
;(function () {
  angular.module('app.aggregationPipeline').component('aggregationPipelineSpecification', {
    templateUrl:
      'client-modules/aggregation-pipeline/aggregation-pipeline-specification/aggregation-pipeline-specification.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
    },
    controller: AggregationPipelineSpecification,
    controllerAs: 'vm',
  });

  function AggregationPipelineSpecification(APP_CONFIG, $http, ErrorHelpers, AdpNotificationService) {
    const vm = this;
    vm.loading = true;

    vm.$onInit = function () {
      vm.options = vm.resolve.options;

      const { row } = vm.options;
      const url = `${APP_CONFIG.apiUrl}/aggregation-pipeline-specification`;

      return $http
        .post(url, { data: row })
        .then(({ data }) => {
          const validPipelineMessage = data.isValidPipeline ? 'Pipeline is valid. ' : '';

          if (!data.success) {
            throw new Error(validPipelineMessage + data.message);
          }

          vm.specification = JSON.stringify(data.data, null, 2);
        })
        .catch((e) => {
          if (e.message) {
            vm.message = e.message;
          }

          ErrorHelpers.handleError(e, 'Aggregation pipeline specification preview error');
        })
        .finally(() => {
          vm.loading = false;
        });
    };

    vm.copy = () => {
      const itemContents = {};
      const dataToCopy = vm.specification || '';
      const type = 'text/plain';
      itemContents[type] = new Blob([dataToCopy], { type });

      const ClipboardAPI = window.clipboard;
      const copyItem = new ClipboardAPI.ClipboardItem(itemContents);

      AdpNotificationService.notifySuccess('Copied into clipboard');
      return ClipboardAPI.write([copyItem]);
    };

    vm.close = () => vm.dismiss({ confirmed: false });
  }
})();
;(function () {
  angular.module('app.aggregationPipeline').directive('aggregationPipelineStage', aggregationPipelineStage);

  /** @ngInject */
  function aggregationPipelineStage(ControlSetterGetter, AdpUnifiedArgs, AdpLayoutConfigService) {
    const NEW_FIELD_NAME = '[newField]';
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl:
        'client-modules/aggregation-pipeline/aggregation-pipeline-stage/aggregation-pipeline-stage.template.html',
      link(scope, element) {
        updateGetters();
        scope.enabledCheckboxCfg = getEnabledCheckboxConfig();
        scope.typeSelectorCfg = getTypeSelectorCfg();
        scope.stopPropagation = (e) => e.stopPropagation();

        scope.$on('formChanged', renderTitleValues);
        scope.$watch('args.path', () => {
          updateGetters();
          renderTitleValues();
        });

        function updateGetters() {
          scope.getterSetterType = ControlSetterGetter(AdpUnifiedArgs.next(scope.args, 'type'));
          scope.getterSetterEnabled = ControlSetterGetter(AdpUnifiedArgs.next(scope.args, 'enabled'));
        }

        function renderTitleValues() {
          setStageTitle();
          applyOverlayToArrayControl();
        }

        function getEnabledCheckboxConfig() {
          const setDefaultEnabledStatus = function () {
            const defaultValue = _.get(scope.args, 'fieldSchema.fields.enabled.default');
            const currentValue = scope.getterSetterEnabled();
            if (currentValue === undefined && defaultValue === true) {
              scope.getterSetterEnabled(defaultValue);
            }
          };

          setDefaultEnabledStatus();

          return {
            value: scope.getterSetterEnabled() === true,
            onValueChanged(e) {
              e.event && e.event.stopPropagation();
              const val = e.value === false ? null : true;
              scope.getterSetterEnabled(val);
              scope.formContext.rootFormScope.$broadcast('formChanged');
            },
            elementAttr: {
              class: 'aggregation-pipeline-stage-btn',
            },
          };
        }

        function applyOverlayToArrayControl() {
          const arrayItemNode = element.closest('.subform-frame');
          const contentBody = arrayItemNode.children('.subform-frame__content');
          const OVERLAY_CLASS_NAME = 'pipeline-stage-overlay';

          const enabled = scope.getterSetterEnabled();
          const overlay = contentBody.children(`.${OVERLAY_CLASS_NAME}`);

          if (enabled) {
            contentBody.children(`.${OVERLAY_CLASS_NAME}`).remove();
          } else {
            overlay.length === 0 && contentBody.append(`<div class="${OVERLAY_CLASS_NAME}">`);
          }
          applyFogToStageHeader(enabled);
        }

        function applyFogToStageHeader(enabled) {
          if (AdpLayoutConfigService.isDarkTheme()) {
            const dimmedHeaderBg = enabled ? '' : 'linear-gradient(rgb(70, 70, 70, 0.5), rgb(70, 70, 70, 0.5))';
            const dimmedHeaderColor = enabled ? '' : '#777';
            applyStyleToHeader('background-image', dimmedHeaderBg);
            applyStyleToHeader('color', dimmedHeaderColor);
          } else {
            const dimmedHeaderBg = enabled ? '' : 'linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4))';
            applyStyleToHeader('background-image', dimmedHeaderBg);
          }
        }

        function applyStyleToHeader(styleName, style) {
          const header = element.closest('.subform-frame__title');

          if (style) {
            header.css(styleName, style);
          } else {
            header.css(styleName, '');
          }
        }

        function setStageTitle() {
          const getSortArrow = (order) => (order ? `<i class="fa fa-arrow-${order > 0 ? 'up' : 'down'}"></i>` : ``);
          const getSortersString = (sorters) =>
            _.map(sorters, ({ fieldName, order }) => fieldName + getSortArrow(order)).join(', ');
          const fieldNamesList = (list) => _.map(list, (f) => f.fieldName).join(', ');
          const titleHelpers = {
            addFields({ fields }) {
              return fieldNamesList(fields);
            },
            bucket({ groupBy, boundaries, output }) {
              let boundariesText;
              const byText = groupBy && `By: ${groupBy}`;
              if (_.isArray(boundaries)) {
                const out = _.map(output, (f) => f.fieldName).join(', ');
                boundariesText = `Boundaries: ${boundaries.join(', ')} &rarr; ${out}`;
              }
              return _.compact([byText, boundariesText]).join(', ');
            },
            bucketAuto({ groupBy, buckets, output }) {
              let bucketsText;
              const byText = groupBy && `By: ${groupBy}`;
              if (buckets) {
                const out = _.map(output, (f) => f.fieldName).join(', ');
                bucketsText = `${buckets} buckets &rarr; ${out}`;
              }
              return _.compact([byText, bucketsText]).join(', ');
            },
            collStats({
              includeLatencyStats,
              includeLatencyHistograms,
              includeStorageStats,
              storageStatsScale,
              includeCount,
              includeQueryExecStats,
            }) {
              const res = _.compact([
                includeLatencyStats && `Latency${includeLatencyHistograms ? ' w/histograms' : ''}`,
                includeStorageStats && `Storage${storageStatsScale ? ` w/scale ${storageStatsScale}` : ''}`,
                includeCount && 'Count',
                includeQueryExecStats && 'QueryExec',
              ]);
              return res.join(', ');
            },
            comment({ commentText }) {
              return _.escape(commentText) || '';
            },
            count({ outputFieldName }) {
              return outputFieldName || '';
            },
            customStage({ expression }) {
              return _.escape(expression) || '';
            },
            densify({ field, partitionByFields, rangeStep, rangeUnit, rangeBounds, rangeBoundsExpression }) {
              const arr = [];
              field && arr.push(field);
              if (!_.isEmpty(partitionByFields)) {
                arr.push(`Partition by ${partitionByFields.join(',')}`);
              }
              if (rangeStep) {
                arr.push(`Step: ${rangeStep}`);
              }
              if (rangeUnit) {
                arr.push(`time unit: ${rangeUnit}`);
              }
              if (rangeBounds) {
                const bounds = rangeBounds === 'range' ? rangeBoundsExpression : rangeBounds;
                arr.push(`Bounds:${bounds}`);
              }

              return arr.join(', ');
            },
            fill({ partitionBy, partitionByFields, sortBy, output }) {
              const arr = [];
              if (!_.isEmpty(partitionBy)) {
                arr.push(`Partition by ${partitionBy}`);
              }
              if (!_.isEmpty(partitionByFields)) {
                arr.push(`Partition by ${partitionByFields.join(',')}`);
              }
              if (!_.isEmpty(sortBy)) {
                arr.push(getSortersString(sortBy));
              }
              if (!_.isEmpty(output)) {
                const outputs = _.map(output, ({ fieldName }) => fieldName).join(', ');
                arr.push(`Output: ${outputs}`);
              }

              return arr.join(', ');
            },
            geoNear({ near, minDistance, maxDistance, distanceMultiplier }) {
              const res = _.compact([
                near.match(/\[(.*?)\]/)[0] || '',
                minDistance && `Min ${minDistance}`,
                maxDistance && `Max ${maxDistance}`,
                distanceMultiplier && `Multiplier: x${distanceMultiplier}`,
              ]);
              return res.join(', ');
            },
            group({ fields, groupBy }) {
              const placeholder = '___';
              const by = _.map(groupBy, (f) => (f.fieldName === NEW_FIELD_NAME ? f.fieldNewName : f.fieldName)).join(
                ', '
              );
              const add = fieldNamesList(fields);

              return `By: ${by || placeholder}; Add: ${add || placeholder}`;
            },
            limit({ number }) {
              return number;
            },
            lookup(item) {
              const placeholder = '___';
              const datasetName = _.get(item, 'from.label') || placeholder;
              const { localField = placeholder, foreignField = placeholder, as = placeholder } = item;
              return `${datasetName} by ${localField}:${foreignField} &rarr; ${as}`;
            },
            match({ fields }) {
              return fieldNamesList(fields);
            },
            matchByConfig({ fields }) {
              return fieldNamesList(fields);
            },
            project({ fields }) {
              return _.map(fields, (f) => (f.fieldName === NEW_FIELD_NAME ? f.fieldNewName : f.fieldName)).join(', ');
            },
            redact(stage) {
              return `if ${stage.if} then ${stage.then} else ${stage.else}`;
            },
            replaceWith({ expression }) {
              return expression;
            },
            sample({ size }) {
              return size;
            },
            set({ fields }) {
              return _.map(fields, (f) => f.fieldName).join(', ');
            },
            setWindowFields({ partitionBy, sortBy, output }) {
              const arr = [];
              if (partitionBy) {
                arr.push(`Partition: ${partitionBy}`);
              }
              if (!_.isEmpty(sortBy)) {
                arr.push(getSortersString(sortBy));
              }
              if (!_.isEmpty(output)) {
                const outputs = _.map(output, ({ fieldName }) => fieldName).join(', ');
                arr.push(`Output: ${outputs}`);
              }
              return arr.join('; ');
            },
            skip({ number }) {
              return number;
            },
            sort({ fields }) {
              const filtered = _.pickBy(fields, _.identity);
              return getSortersString(filtered);
            },
            sortByCount({ expression }) {
              return _.escape(expression) || '';
            },
            unionWith({ coll }) {
              return _.get(coll, 'label') || '';
            },
            unset({ fields }) {
              return fields.join(', ');
            },
            unwind({ path, includeArrayIndex, preserveNullAndEmptyArrays }) {
              const arr = [path];
              if (includeArrayIndex) {
                arr.push(`Index: ${includeArrayIndex}`);
              }
              if (preserveNullAndEmptyArrays) {
                arr.push(`Preserve empties`);
              }
              return arr.join(', ');
            },
          };

          const type = (getArrayItemProp('type') || '').substring(1);
          if (type) {
            const helper = titleHelpers[type];
            const item = getArrayItemProp(type) || {};
            let title = '';
            if (helper) {
              title = helper(item) || '';
            }

            scope.stageTitle = title;
          } else {
            scope.stageTitle = '$[undefined stage]';
          }
        }

        function getArrayItemProp(prop) {
          const arrayItemPath = [scope.args.path, prop].join('.');
          return _.get(scope.args.row, arrayItemPath);
        }

        function getTypeSelectorCfg() {
          const typeArgs = AdpUnifiedArgs.next(scope.args, 'type');
          const { values } = typeArgs.fieldSchema.list;

          return {
            value: scope.getterSetterType() || null,
            valueExpr: 'value',
            displayExpr: 'label',
            showClearButton: true,
            stylingMode: 'outlined',
            items: _.map(values, (val, key) => ({ value: key, label: val })),
            onValueChanged(e) {
              scope.getterSetterType(e.value);
              scope.formContext.rootFormScope.$broadcast('formChanged');
            },
          };
        }
      },
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
    .component('adpCopyPasteModal', {
      templateUrl: 'client-modules/adp-form-actions/adp-copy-paste-action/adp-copy-paste-modal/adp-copy-paste-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpCopyPasteModalController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
    .controller('AdpCopyPasteModalController', AdpCopyPasteModalController);

  /** @ngInject */
  function AdpCopyPasteModalController(
    $element,
    $scope,
    AdpCopyPasteActionService,
    AdpNotificationService
  ) {
    const vm = this;

    vm.$onInit = () => {
      vm.args = vm.resolve.options.args;
      vm.formData = { compressedRecord: '' };
      vm.textAreaCfg = { height: 200, readOnly: true };

      vm.disabled = true;
      AdpCopyPasteActionService.compress(vm.args.row)
        .then((compressedData) => {
          vm.formData.compressedRecord = compressedData;
        })
        .catch(err => {
          notifyError(err, 'Something went wrong trying to encode data. Please, try again later.');
        })
        .finally(() => {
          vm.disabled = false;
        });
    };

    vm.cancel = () => {
      vm.dismiss({ $value: 'cancel' });
    }

    vm.copy = () => {
      const ClipboardAPI = window.clipboard;

      vm.disabled = true;
      return ClipboardAPI.writeText(vm.formData.compressedRecord)
        .catch(notifyError)
        .finally(() => {
          vm.disabled = false;
        });
    };

    vm.paste = () => {
      const ClipboardAPI = window.clipboard;

      vm.disabled = true;
      ClipboardAPI.readText()
        .then((clipBoardText) => {
          vm.formData.compressedRecord = clipBoardText;
        })
        .catch(notifyError)
        .finally(() => {
          vm.disabled = false;
        });
    };

    vm.updateRecord = () => {
      if ($scope.form.$invalid) {
        return;
      }

      const { compressedRecord } = vm.formData;
      vm.disabled = true;
      return AdpCopyPasteActionService.decompress(compressedRecord)
        .then(record => vm.close({ $value: { record } }))
        .catch(err => {
          notifyError(err, 'Something went wrong trying to decode data. Please, check data string has correct format.');
        })
        .finally(() => {
          vm.disabled = false;
        });
    }

    function notifyError(err, message) {
      const errorMessage = message || 'Something went wrong. Please, try again later.';
      AdpNotificationService.notifyError(errorMessage);
      console.error(err);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
    .component('adpSaveVcsModal', {
      templateUrl: 'client-modules/adp-form-actions/adp-vcs-action/adp-save-vcs-modal/adp-save-vcs-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpSaveVcsModalController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
      .controller('AdpSaveVcsModalController', AdpSaveVcsModalController);

  /** @ngInject */
  function AdpSaveVcsModalController(
    $element,
    $scope,
    AdpCopyPasteActionService,
    AdpNotificationService,
    GraphqlCollectionMutator,
    AdpSchemaService,
    AdpFormDataUtils,
    AdpUnifiedArgs
  ) {
    const vm = this;

    vm.$onInit = () => {
      vm.args = vm.resolve.options.args;
      vm.versionLogSchema = AdpSchemaService.getSchemaByName('_versionControlLog');
      vm.formData = {
        name: '',
        description: '',
      };

      vm.textBoxConfig = {
        value: null,
        valueChangeEvent: 'input'
      };

      vm.textAreaConfig = {
        minHeight: '80px',
        autoResizeEnabled: true,
        valueChangeEvent: 'input blur',
      };
    };

    vm.cancel = () => {
      const $value = { action: 'cancel' };
      vm.close({ $value });
    };

    vm.done = () => {
      AdpNotificationService.notifySuccess('Record successfully saved to Content Version Control Log.');
      const $value = { action: 'save' };
      vm.close({ $value });
    }

    vm.save = () => {
      if ($scope.form.$invalid) {
        return;
      }

      const { modelSchema, row } = getRecordArgs()
      return GraphqlCollectionMutator.create(modelSchema, row)
        .then(vm.done)
        .catch((err) => {
          notifyError(err, err.message[0]);
        });
    };

    function getRecordData(data) {
      const systemFields = [
        '_id', '_actions', 'adpCreator', 'adpCreatedAt', 'adpUpdatedAt', 'adpDeletedAt', 'adpAcl'
      ];

      return _.omit(data, systemFields);
    }

    function getRecordArgs() {
      const { row, modelSchema } = vm.args;
      const recordToSave = {
        ...vm.formData,
        data: getRecordData(row),
        recordId: row._id,
        modelName: modelSchema.schemaName,
      };

      const options = {
        path: '',
        formData: recordToSave,
        schema: vm.versionLogSchema,
        action: 'create',
      };
      const args = AdpUnifiedArgs.getHelperParams(options);
      return AdpFormDataUtils.transformDataBeforeSending(args);
    }

    function notifyError(err, message = 'Something went wrong. Please, try again later.') {
      AdpNotificationService.notifyError(err, message);
      console.error(err);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
    .component('adpVcsModal', {
      templateUrl: 'client-modules/adp-form-actions/adp-vcs-action/adp-vcs-modal/adp-vcs-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpVcsModalController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpFormActions')
    .controller('AdpVcsModalController', AdpVcsModalController);

  /** @ngInject */
  function AdpVcsModalController(
    $element,
    $scope,
    AdpCopyPasteActionService,
    AdpNotificationService,
    GraphqlCollectionQuery,
    AdpValidationUtils,
    AdpVcsActionService,
    AdpSchemaService,
    AdpUnifiedArgs,
    GraphqlCollectionMutator,
    AdpModalService
  ) {
    const vm = this;

    vm.$onInit = () => {
      vm.argsOfRecord = vm.resolve.options.args;
      vm.formData = { selectedVersion: null };
      vm.loadAndDeletedDisabled = true;
      vm.versionLogSchema = AdpSchemaService.getSchemaByName('_versionControlLog');

      vm.dataSource = new DevExpress.data.DataSource({
        paginate: true,
        pageSize: 20,
        key: '_id',
        load(loadOptions) {
          const requestSchema = AdpSchemaService.getSchemaByName('_versionControlLog');
          const { row, modelSchema } = vm.argsOfRecord;

          return GraphqlCollectionQuery(requestSchema, {
            ...loadOptions,
            filter: [['modelName', '=', modelSchema.schemaName], 'and', ['recordId', '=', row._id]],
            sort: [{ selector: 'adpUpdatedAt', desc: true }],
          }).then(({ items }) => items);
        },
      });

      vm.configForRecordsList = {
        dataSource: vm.dataSource,
        value: vm.formData.selectedVersion,
        showClearButton: false,
        valueExpr: 'this',
        elementAttr: { class: 'adp-select-box' },
        itemTemplate: displayExpr,
        displayExpr,
        onValueChanged({ value }) {
          vm.loadAndDeletedDisabled = !value;
          vm.selectedArgs = getSelectedArgs(value);
        },
      };
    };

    vm.cancel = () => {
      const $value = { action: 'cancel' };
      vm.close({ $value });
    };

    vm.saveCurrentRecordDataToVCS = () => {
      return AdpVcsActionService.callSaveModal(vm.argsOfRecord)
        .then(vm.cancel);
    };

    vm.delete = () => {
      return AdpModalService.confirm({
        message: 'Are you sure you want to delete selected record version?',
      }).then(() => {
        return GraphqlCollectionMutator.delete(vm.versionLogSchema, vm.formData.selectedVersion)
          .then(() => {
            AdpNotificationService.notifySuccess('Record successfully deleted from Content Version Control Log.');
            vm.formData.selectedVersion = null;
            return vm.dataSource.reload();
          })
          .catch((err) => {
            notifyError(err, err.message[0]);
          });
      });
    };

    vm.loadRecordToForm = () => {
      const $value = { action: 'load', data: vm.formData.selectedVersion };
      vm.close({ $value });
    }

    function displayExpr(item) {
      if (!item) {
        return item;
      }

      const { name, adpUpdatedAt } = item;
      const dateFormat = AdpValidationUtils.getDateFormat('Date');
      const formattedDate = window.dayjs(adpUpdatedAt).format(dateFormat);

      return `[${formattedDate}] ${name}`;
    }

    function getSelectedArgs(row) {
      if (!row) {
        return null;
      }

      const options = {
        path: 'data',
        formData: row,
        schema: vm.versionLogSchema,
        action: 'viewDetails',
      };
      return AdpUnifiedArgs.getHelperParams(options);
    }

    function notifyError(err, message = 'Something went wrong. Please, try again later.') {
      AdpNotificationService.notifyError(err, message);
      console.error(err);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpTopomap')
    .directive('adpTopomapAr', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      controller: 'AdpWidgetTopomapController',
      controllerAs: 'vm',
      templateUrl: `client-modules/adp-topomap/modes/ar/adp-topomap-ar-top-frame.html`
    };
  }
})();
;;(function () {
  'use strict';

  angular.module('app.adpTopomap')
    .factory('AdpTopomapArTopFrame', AdpTopomapArTopFrame);

  function AdpTopomapArTopFrame(
    $sce,
    APP_CONFIG,
    AdpFramesComms
  ) {
    // Main logic works in top iframe and communicate with IFRAME inner document via AdpFrameComms.
    return function ({args, $scope}) {
      const framesComms = AdpFramesComms({
        partnerFrame: window.frames['adp_topomap_ar'].contentWindow,
        requestProcessors: {
          loaded: prepareIframeParameters,
        },
        label: 'TOP',
        timeout: 10000,
      });
      const frameReadyPromise = new Promise(frameReadyResolver => {
        framesComms.registerProcessor('ready', ({layersInfo}) => {
          console.log("=== frameReady", layersInfo);
          const initResult = {
            // Fake topo & layers to fulfill controller's expectations
            topo: {},
            layers: layersInfo,
            callbacks: {
              destroyCb: framesComms.onDestroy,
              updateLayerData,
              updateSurface,
            }
          }
          frameReadyResolver(initResult);
        });
      });
      const {resourceUrl} = APP_CONFIG;
      const iframeUrl = `${resourceUrl}/public/js/lib/adp-topomap-ar.html?d=${Date.now()}`;
      $scope.iframeUrl = $sce.trustAsResourceUrl(iframeUrl);

      return frameReadyPromise;

      function updateSurface(payload) {
        return framesComms.postMessage('refreshSurface', payload);
      }

      function updateLayerData(payload) {
        return framesComms.postMessage('refreshData', payload);
      }

      function prepareIframeParameters() {
        const params = {}; // ToDo: assumed to contain siurceWidth, lights and so on, but maybe this data already in args. Check it!
        return {args, params};
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapAr', AdpTopomapAr);

  function AdpTopomapAr(APP_CONFIG, AdpWidgetsService, AdpClientCommonHelper, AdpTopomapService) {
    return function ({args, $element, $scope}) {
      //   const widgetId = _.get(args, 'row._id');
      //    const enableVr = _.get(args, 'row.topomap.visualisationType') === 'vr';
      let widgetWidth;
      let widgetHeight;

      return loadVendorCode().then(() => setScene($element[0]))
        .then(topo => {
          const resizeTopomap = getResizer(topo);
          const callbacks = {
            doResize: resizeTopomap,
          };

          resizeTopomap();

          return AdpTopomapService.createLayers({topo, args}).then((layers) => {
            return {topo, layers, callbacks};
          });
        });

      function setScene(containerElement) {
        return new Promise((setSceneResolve)=>{
          const renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
          });
          renderer.setClearColor(new THREE.Color('lightgrey'), 0)
          renderer.setSize(640, 480);
          renderer.domElement.style.position = 'absolute'
          renderer.domElement.style.top = '0px'
          renderer.domElement.style.left = '0px'
          containerElement.appendChild(renderer.domElement);
          const onRenderFns = [];
          let arToolkitContext, arMarkerControls;
          const scene = new THREE.Scene();
          const camera = new THREE.Camera();
          scene.add(camera);
          const arToolkitSource = new THREEx.ArToolkitSource({
            sourceType: 'webcam',
            sourceWidth: window.innerWidth > window.innerHeight ? 640 : 480,
            sourceHeight: window.innerWidth > window.innerHeight ? 480 : 640,
            containerElement,
          })

          arToolkitSource.init(function onReady() {
            arToolkitSource.domElement.addEventListener('canplay', initARContext);
            window.arToolkitSource = arToolkitSource;
          })

          onRenderFns.push(function () {
            if (!arToolkitContext || !arToolkitSource || !arToolkitSource.ready) {
              return;
            }

            arToolkitContext.update(arToolkitSource.domElement)

            // update scene.visible if the marker is seen
            scene.visible = camera.visible;
          })

          onRenderFns.push(function () {
            renderer.render(scene, camera);
          })

          // run the rendering loop
          let lastMs = null;
          requestAnimationFrame(function animate(nowMs) {
            // keep looping
            requestAnimationFrame(animate);
            // measure time
            lastMs = lastMs || nowMs - 1000 / 60
            const deltaMs = Math.min(200, nowMs - lastMs)
            lastMs = nowMs
            // call each update function
            onRenderFns.forEach(fn=>fn(deltaMs / 1000, nowMs / 1000));
          })

          const terrainGroup = new THREE.Group();
          scene.add(terrainGroup);

          const engine = new ThreeGeo({
            tokenMapbox: APP_CONFIG.mapboxToken,
          });

          function initARContext() { // create atToolkitContext
            arToolkitContext = new THREEx.ArToolkitContext({
              // ToDo: solve with CameraParameters file
              cameraParametersUrl: THREEx.ArToolkitContext.baseURL + '../data/data/camera_para.dat',
              detectionMode: 'mono'
            })
            // initialize it
            arToolkitContext.init(() => { // copy projection matrix to camera
              camera.projectionMatrix.copy(arToolkitContext.getProjectionMatrix());

              arToolkitContext.arController.orientation = getSourceOrientation();
              arToolkitContext.arController.options.orientation = getSourceOrientation();

              console.log('arToolkitContext', arToolkitContext);
              window.arToolkitContext = arToolkitContext;
            })

            // MARKER
            const marketParameters = AdpWidgetsService.getArMarkerAttributes(args);
            arMarkerControls = new THREEx.ArMarkerControls(arToolkitContext, camera, {
              ...marketParameters,
              changeMatrixMode: 'cameraTransformMatrix'
            })

            scene.visible = false

            console.log('ArMarkerControls', arMarkerControls);
            window.arMarkerControls = arMarkerControls;

            setSceneResolve({scene, camera, renderer, terrainGroup, engine, arToolkitSource, arToolkitContext});
          }

          function getSourceOrientation() {
            if (!arToolkitSource) {
              return null;
            }

            console.log(
              'actual source dimensions',
              arToolkitSource.domElement.videoWidth,
              arToolkitSource.domElement.videoHeight
            );

            if (arToolkitSource.domElement.videoWidth > arToolkitSource.domElement.videoHeight) {
              console.log('source orientation', 'landscape');
              return 'landscape';
            } else {
              console.log('source orientation', 'portrait');
              return 'portrait';
            }
          }
        })
      }

      function getResizer(topo) {
        return () => {
          widgetWidth = $element.width();
          widgetHeight = $element.height();

          topo.arToolkitSource?.onResizeElement(widgetWidth, widgetHeight);
          topo.arToolkitSource?.copyElementSizeTo(topo.renderer.domElement)
          if (topo.arToolkitContext?.arController) {
            topo.arToolkitSource.copyElementSizeTo(topo.arToolkitContext.arController.canvas)
          }
        }
      }

      function loadVendorCode() {
        const vendorList = [
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/three.compiled.js`,
            probe: () => typeof THREE !== 'undefined',
            sync: true,
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/ar-threex.js`,
            probe: () => typeof THREEx !== 'undefined',
            sync: true,
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/three-geo.min.js`,
            probe: () => typeof ThreeGeo !== 'undefined',
            sync: true,
          },
        ];

        return AdpClientCommonHelper.loadVendors(vendorList);
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpTopomap')
    .directive('adpTopomap3d', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      controller: 'AdpWidgetTopomapController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-topomap/modes/3d/adp-topomap-3d.html'
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomap3d', AdpTopomap3d);

  function AdpTopomap3d(APP_CONFIG, AdpClientCommonHelper, AdpTopomapService) {
    return function ({args, $element, $scope}) {
      let widgetWidth;
      let widgetHeight;

      return loadVendorCode().then(() => {
        const argsWithExtras = {
          ...args,
        };
        const canvas = $('.scene-canvas', $element)[0];
        const topo = createMainTopoObject(canvas);
        const resizeTopomap = getResizer(topo);
        const callbacks = {
          doResize: resizeTopomap,
          // ToDo: add destroy handler to remove ThreeGeo object
        };

        resizeTopomap();

        return AdpTopomapService.createLayers({topo, args: argsWithExtras})
          .then((layers) => {
            topo.render();
            return {topo, layers, callbacks};
          });
      });

      function createMainTopoObject(canvas) {
        const scene = new THREE.Scene();
        const renderer = new THREE.WebGLRenderer({canvas, antialias: true, alpha: true});
        const camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 100);
        const controls = new OrbitControls(camera, renderer.domElement);

        scene.background = null;
        renderer.setPixelRatio(window.devicePixelRatio);
        camera.position.set(2, 1, 0);
        camera.near = 0.001;
        controls.listenToKeyEvents(window); // optional
        controls.addEventListener('change', render);
        controls.dampingFactor = 0.05;
        controls.screenSpacePanning = false;
        controls.minDistance = 0.1;
        controls.maxDistance = 10;
        controls.maxPolarAngle = Math.PI / 2;

        const dirLight1 = new THREE.DirectionalLight(0xffffff, 3);
        dirLight1.position.set(1, 1, 1);
        scene.add(dirLight1);

        const ambientLight = new THREE.AmbientLight(0x555555);
        scene.add(ambientLight);

        const terrainGroup = new THREE.Group();
        scene.add(terrainGroup);

        const layersGroup = new THREE.Group();
        scene.add(layersGroup);

        const engine = new ThreeGeo({
          tokenMapbox: APP_CONFIG.mapboxToken,
        });

        return {render, setSize, terrainGroup, layersGroup, engine};

        function render() {
          renderer.render(scene, camera);
        }

        function setSize(width, height) {
          camera.aspect = width / height;
          camera.updateProjectionMatrix();
          renderer.setSize( width, height );
          controls.update();
        }
      }

      function getResizer(topo) {
        return () => {
          widgetWidth = $element.width();
          widgetHeight = $element.height();

          topo.setSize(widgetWidth, widgetHeight);
        }
      }

      function loadVendorCode() {
        const vendorList = [
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/three.compiled.js`,
            probe: () => typeof THREE !== 'undefined',
            sync: true,
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/orbit-controls-plus.compiled.js`,
            probe: () => typeof THREE !== 'undefined',
            //sync: true,
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/three-geo.min.js`,
            probe: () => typeof ThreeGeo !== 'undefined',
            sync: true,
          },
        ];

        return AdpClientCommonHelper.loadVendors(vendorList);
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpTopomap')
    .directive('adpTopomapVr', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      controller: 'AdpWidgetTopomapController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-topomap/modes/vr/adp-topomap-vr.html'
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpTopomap').factory('AdpTopomapVr', AdpTopomapVr);

  function AdpTopomapVr(APP_CONFIG, AdpClientCommonHelper, AdpTopomapService) {
    return function ({args, $element, $scope}) {
      const $container = $element.find('.adp-topomap-box');
      const getTopoObject = () => {
        const element = $container.find('a-entity[adp-topomap]');
        return _.get(element, '0.components.adp-topomap.topo');
      };


      return loadVendorCode()
        .then(() => createAframeScene($container))
        .then(() => AdpClientCommonHelper.awaitFor(getTopoObject))
        .then(topo => {
          topo.engine = new ThreeGeo({
            tokenMapbox: APP_CONFIG.mapboxToken,
          });
          const argsWithExtras = {
            ...args,
          };

          const resizeTopomap = getResizer(topo);
          const callbacks = {
            doResize: resizeTopomap,
          };

          resizeTopomap();

          return AdpTopomapService.createLayers({topo, args: argsWithExtras})
            .then((layers) => {
              topo.render();

              return {topo, layers, callbacks};
            });
        })
    }

    function createAframeScene(rootElem) {
      const template = `
       <a-scene embedded="true" vr-mode-ui="true"  xr-mode-ui="" device-orientation-permission-ui="">
            <a-entity position="0 0.1 0.2" rotation="0 0 0"  movement-controls="controls: gamepad; fly: true; speed: 0.5"
                  gamepad-controls="">
                <a-entity laser-controls="hand: left"
       <!--             raycaster="objects: [globe]; interval: 100; lineColor: steelblue; lineOpacity: 0.85; "-->
                    hp-mixed-reality-controls="" magicleap-controls="" oculus-go-controls="" oculus-touch-controls=""
                    pico-controls="" valve-index-controls="" vive-controls="" vive-focus-controls=""
                    windows-motion-controls="" generic-tracked-controller-controls=""></a-entity>
                <a-entity laser-controls="hand: right"
                <!--    raycaster="objects: [globe]; interval: 100; lineColor: steelblue; lineOpacity: 0.85;"-->
                    hp-mixed-reality-controls="" magicleap-controls="" oculus-go-controls="" oculus-touch-controls=""
                    pico-controls="" valve-index-controls="" vive-controls="" vive-focus-controls=""
                    windows-motion-controls="" generic-tracked-controller-controls=""></a-entity>
                <a-camera position="-0.12 -0.04 -0.087" rotation="1.6 7.563 0" wasd-controls="fly: true; acceleration: 10;"></a-camera>
            </a-entity>
            <a-entity id="topo" adp-topomap></a-entity> 
        </a-scene>`;
      $(rootElem).append(template);
    }

    function getResizer(topo) {
      return () => {
        // ToDo: figure out what we need here
      }
    }

    function loadVendorCode() {
      const vendorList = [
        {
          url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/three.compiled.js`,
          probe: () => typeof THREE !== 'undefined',
          sync: true,
        },
        {
          url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/aframe-master.min.js`,
          probe: () => typeof AFRAME !== 'undefined',
          sync: true,
        },
        {
          url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/aframe-extras.controls.min.js`,
          probe: () => typeof AFRAME.components['movement-controls'] !== 'undefined',
          sync: true,
        },
        {
          url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/three-geo.min.js`,
          probe: () => typeof ThreeGeo !== 'undefined',
        },
        {
          url: `${APP_CONFIG.resourceUrl}/public/js/lib/adp-topomap-ar.component.js`,
          probe: () => {
            return typeof AFRAME.components['adp-topomap'] !== 'undefined'
          },
        }
      ];

      return AdpClientCommonHelper.loadVendors(vendorList);
    }
  }
})();
;(function() {
  angular.module('app.adpWidgets').controller('AdpWidgetArAnythingController', AdpWidgetArAnythingController);

  /** @ngInject */
  function AdpWidgetArAnythingController(
    $sce,
    $scope,
    $element,
    $rootScope,
    $timeout,
    APP_CONFIG,
    AdpNotificationService,
    AdpWidgetsService,
    AdpMediaTypeHelper,
    AdpFramesComms,
  ) {
    const vm = this;
    const { args, interface: editInterface } = $scope;
    const { type: widgetType, _id: widgetId } = args.row;
    const positioningType = _.get(args, ['row', widgetType, 'type'], 'marker');
    let filters = {};
    let preloaded = {};
    let frameReady = false;
    const requestProcessors = {
      loaded: prepareAframeSceneParameters,
      ready: onFrameReady,
      layerSwipe: onLayerSwipe,
      layerVisibility: _.noop,
    };

    const framesComms = AdpFramesComms({
      partnerFrame: window.frames.adp_ar_anything.contentWindow,
      requestProcessors,
      label: 'TOP',
    });

    vm.$onInit = function() {
      const { resourceUrl } = APP_CONFIG;
      // ToDo: need better way to guarantee unique iframe html loading still allowing to cache same files
      const iframeUrl = `${resourceUrl}/public/js/lib/adp-ar-anything-${positioningType}.html?d=${Date.now()}`;

      vm.iframeUrl = $sce.trustAsResourceUrl(iframeUrl);

      $scope.$on('widgetTileResize', () => vm.doResize && vm.doResize());
      AdpWidgetsService.handleControlLinkChange({ scope: $scope, widgetId, onLinkChange });
      loadInitialData($scope);

      const onDatasetUpdate = () => {
        reloadData(filters);
      };

      AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
      AdpWidgetsService.touchLinksControlledByWidget(widgetId, editInterface);

      registerGpsChangeHook();
    };

    function onLinkChange(event) {
      const { dxFilter, virtualFilters } = event;
      filters = { filter: dxFilter, virtualFilters };

      return reloadData(filters);
    }

    function fetchDataFromServer({ loadParams }) {
      return AdpWidgetsService.fetchWidgetData(args, loadParams).then(({ data, messages }) => {
        vm.errorMessage = messages ? messages.join('</br>') : '';
        return _.mapValues(data, replaceLinkIdWithPath);
      });
    }

    function replaceLinkIdWithPath(layer) {
      _.each(layer.groups, group => {
        _.each(group.objects, obj => {
          _.each(['geometryFile', 'sound.file'], (path) => {
            const fileObj = _.get(obj, path);
            const linkId = _.get(fileObj, 'linkId');
            if (linkId) {
              _.unset(fileObj, 'linkId');
              fileObj.path = [APP_CONFIG.apiUrl, 'file', linkId].join('/');
            }
            _.set(obj, path, fileObj);
          });
        });
      });

      return layer;
    }

    function prepareAframeSceneParameters() {
      const { row } = args;
      const directionalLightIntensity = _.get(row, [widgetType, 'directionalLightIntensity'], 0.6);
      const sourceWidth = _.get(row, [widgetType, 'sourceWidth']);
      const sourceHeight = _.get(row, [widgetType, 'sourceHeight']);
      const lights = { directionalLightIntensity };
      const cameraParametersUrl = `${APP_CONFIG.resourceUrl}/public/assets/camera_para.dat`;
      const debugLog = !!_.get(row, [widgetType, 'enableDebugInfo']);
      const showLabels = !!_.get(row, [widgetType, 'showLabels']);
      const templates = _.get(args, 'widgetConfiguration.templates');
      const options = { templates, sourceWidth, sourceHeight, cameraParametersUrl, debugLog };

      const markerOrLocation = _.get(row, [widgetType, 'type']);
      if (markerOrLocation === 'marker') {
        options.afterMarkerGoneKeepMesh = _.get(row, [widgetType, 'afterMarkerGoneKeepMesh'], 5000) || 0;
      }

      if (showLabels) {
        options.labels = { show: true };
      }

      return { lights, options };
    }

    function onFrameReady() {
      frameReady = true;
      framesComms.postMessage('refreshDataArr', preloaded);
    }

    function onLayerSwipe({ layerId, values }) {
      const layers = _.get(args, ['row', widgetType, 'layers'], []);
      const layer = _.find(layers, (l) => l._id === layerId);
      const { type } = layer;
      const sliders = _.get(layer, [type, 'sliders'], []);
      _.each(sliders, (slider, sliderIndex) => {
        const uniqValues = _(values)
          .map((v) => v[sliderIndex])
          .uniq()
          .value();
        const filterOperation = !uniqValues.length ? 'empty' : uniqValues.length === 1 ? '=' : 'any';
        const filter = [filterOperation, ...uniqValues];
        const ids = _.get(slider, 'linkIds', []);
        AdpWidgetsService.sendControlledLinksChangeEvents(filter, ids, widgetId, editInterface);
      });
    }

    function registerGpsChangeHook() {
      let handler;
      const hook = (cb) => {
        handler = cb;
      };
      const onChange = ({ position }) => handler && handler(position);

      _.set(window, `adp.dashboard.widgets.${widgetId}.onGpsChangeHook`, hook);

      framesComms.registerProcessor('gpsChange', onChange);
    }

    function reloadData(loadParams = {}) {
      return fetchDataFromServer({ loadParams })
        .then((data) => ({ layersData: data }))
        .then((data) => {
          const payload = { ...data, ...loadParams };
          if (frameReady) {
            framesComms.postMessage('refreshDataArr', payload);
          } else {
            preloaded = payload;
          }
        });
    }

    function loadInitialData() {
      const linksInterface = AdpWidgetsService.getControlLinksInterface(editInterface);
      const isControlled = linksInterface && linksInterface.isWidgetControlled(widgetId);

      if (!isControlled) {
        reloadData();
      }
    }

  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('adpWidgetArAnything', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      controller: 'AdpWidgetArAnythingController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/ar-anything/ar-anything.html',
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetCalculatedHtml', adpWidgetCalculatedHtml);

  /** @ngInject */
  function adpWidgetCalculatedHtml($sce, $timeout, APP_CONFIG, AdpWidgetsService, AdpWidgetsEjs) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
        tile: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/calculated-html/adp-widget-calculated.html',
      link(scope, $element) {
        const widgetRow = _.get(scope, 'args.row.calculatedHtml', {});
        const widgetConfig = _.get(scope, 'args.widgetConfiguration', {});
        const { contentAlign } = widgetRow;
        const { enableServerSideEjs } = widgetRow;
        const widgetId = _.get(scope, 'args.row._id');
        const sliders = AdpWidgetsService.getSlidersOfWidget(scope.args, scope.interface);
        const callbacks = getCallbackFunctions(widgetConfig);
        const alignStyles = {
          'center-center': { justifyContent: 'space-evenly', alignItems: 'center' },
        };
        let isInitialised = false;
        let messageWasShown = false;
        let lastInitPromise = Promise.resolve();
        let onDestroy = null;
        const customActions = _.get(appModelHelpers, 'CustomActions') || {};
        const queryParams = _extractQueryParams();

        scope.alignStyle = alignStyles[contentAlign];
        scope.templateContext = {
          $container: $element,
          customActions,
          appConfig: APP_CONFIG,
          args: scope.args,
          tile: scope.tile,
          selectionFilters: {},
          queryParams,
        };
        $element.on('$destroy', () => {
          if (_.isFunction(onDestroy)) {
            onDestroy();
          }
        });
        scope.$on('widgetTileResize', onTileResize);

        if (sliders.length) {
          scope.templateContext.onSelectOnClick = (clickValuesArr) => {
            AdpWidgetsService.sendValuesToControlled(clickValuesArr, sliders, widgetId, scope.interface);
          };
        }

        (function init() {
          const widgetId = _.get(scope, 'args.row._id');
          const isControlled = AdpWidgetsService.isWidgetControlled(widgetId, scope.interface);
          const { args } = scope;
          let currentFilters = {};

          scope.getFilterForDatalayer = () => currentFilters.filter || [];
          AdpWidgetsService.setWidgetScopeToTile(scope);

          const onDatasetUpdate = () => fetchWidgetData(currentFilters);
          AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
          scope.templateContext.reloadData = onDatasetUpdate;

          if (!isControlled) {
            return fetchWidgetData();
          } else {
            function onLinkChange({ dxFilter, virtualFilters }) {
              currentFilters = { filter: dxFilter, virtualFilters };
              return fetchWidgetData(currentFilters);
            }

            AdpWidgetsService.handleControlLinkChange({ scope, widgetId, onLinkChange, onSelectLinkChange });
          }

          AdpWidgetsService.handleControlledLinksChange({ onLinkUpdate, widgetId, scope });
        })();

        function onLinkUpdate(event) {
          if (_.isFunction(scope.templateContext.onLinkUpdate)) {
            scope.templateContext.onLinkUpdate.call(scope.templateContext, event);
          }
        }

        function fetchWidgetData(options) {
          lastInitPromise = lastInitPromise
            .then(() => AdpWidgetsService.fetchWidgetData(scope.args, options))
            .then((response) => onDataArrived(response, options))
            .then((destroyCallback) => {
              // destroy callback is optionally returned from initiation code
              onDestroy = destroyCallback;
            })
            .then(onDataChange);

          return lastInitPromise;
        }

        async function onSelectLinkChange({ selectionFilters }) {
          _.set(scope.templateContext, 'selectionFilters', selectionFilters);
          return await onDataChange();
        }

        function onDataArrived({ data, template = '', messages }, options) {
          _.assign(scope.templateContext, { rows: data, ...options });
          let html;

          if (messages) {
            messageWasShown = true;
            html = `<div class='adp-widget-container-error-message'>${messages.join('<br/>')}</div>`;
            return setWidgetHtml(html).then(onInitCallback);
          }

          const reInitialise = !isInitialised || !callbacks.onData || messageWasShown;
          if (!reInitialise) {
            return;
          }

          const templateToRender = enableServerSideEjs ? template : widgetRow.contentTemplate;
          messageWasShown = false;
          html = AdpWidgetsEjs.render({ template: templateToRender, context: scope.templateContext });

          return setWidgetHtml(html).then(onInitCallback);
        }

        async function onInitCallback() {
          if (isInitialised || !callbacks.onInit) {
            return;
          }
          const resultOrPromise = callbacks.onInit.call(scope.templateContext);
          if (resultOrPromise && resultOrPromise.then) {
            return resultOrPromise.then((initResult) => {
              isInitialised = true;
              return initResult;
            });
          }

          isInitialised = true;
          return resultOrPromise;
        }

        function onDataChange() {
          if (!callbacks.onData || !isInitialised) {
            return;
          }
          return callbacks.onData.call(scope.templateContext);
        }

        function setWidgetHtml(html) {
          return new Promise((resolveAfterAWhile) => {
            scope.safeHtml = $sce.trustAsHtml(html);
            // Giving a pause to give DOM a chance to be ready BEFORE onInit&onData called
            $timeout(resolveAfterAWhile, 25);
          });
        }

        function onTileResize() {
          if (scope.templateContext.onTileResize) {
            scope.templateContext.onTileResize();
          }
        }
      },
    };

    function getCallbackFunctions(widgetConfig) {
      const { callbackCode } = widgetConfig;
      const ret = {};

      _.forEach(callbackCode, (code, callbackName) => {
        try {
          ret[callbackName] = new Function('', code);
        } catch (e) {
          console.error(`Failed to create ${callbackName} callback with err`, e);
        }
      });

      return ret;
    }

    function _extractQueryParams() {
      const queryString = window.location.search.substring(1);

      return _.fromPairs(
        _.compact(
          queryString.split('&').map((pairString) => {
            const res = pairString.match(/^(\w+)=(.*?)$/);
            if (!res) {
              return;
            }
            return [res[1], decodeURIComponent(res[2])];
          })
        )
      );
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetCalendarPicker', adpWidgetCalendarPicker);

  /** @ngInject */
  function adpWidgetCalendarPicker(AdpWidgetsService) {
    return {
      restrict: 'E',
      template: `
        <div class="adp-widget-container">
          <div class="adp-widget-calendar-picker"></div>
          <div class="adp-widget-container-error-message well-background" ng-show="errorMessage" ng-bind-html="errorMessage"></div>
          <adp-page-loader loading="isLoading"></adp-page-loader>
        </div>`,
      scope: {
        interface: '<',
        args: '<',
      },
      link: function (scope, $element) {
        const { args } = scope;
        const selectionMode = _.get(args, 'widgetConfiguration.selectionMode', 'single');
        let dataRows = [];
        let widgetInstance;
        let lastFilter = [];
        const widgetId = args.row._id;
        const isControlled = AdpWidgetsService.isWidgetControlled(widgetId, scope.interface);

        if (isControlled) {
          const onLinkChange = ({ dxFilter, virtualFilters }) => {
            lastFilter = { filter: dxFilter, virtualFilters };
            return loadWidgetData(lastFilter);
          };
          AdpWidgetsService.handleControlLinkChange({ scope, widgetId, onLinkChange });
        } else {
          loadWidgetData();
        }

        handleDatasetUpdates(widgetId);

        function handleDatasetUpdates(widgetId) {
          const onDatasetUpdate = () => loadWidgetData(lastFilter);
          AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
          AdpWidgetsService.touchLinksControlledByWidget(widgetId, scope.interface);
        }

        function initialiseComponent() {
          const options = createInitialOptions(args);
          $element.find('.adp-widget-calendar-picker').dxCalendar(options);
        }

        function createInitialOptions(args) {
          const { widgetConfiguration } = args;
          const options = _.cloneDeep(widgetConfiguration);

          applyJsonExtend(args, options);
          setCellTemplate(options);
          enableWidgetAsControl(widgetId, options);

          options.onInitialized = (event) => {
            widgetInstance = event.component;
          };

          return options;
        }

        function setCellTemplate(options) {
          const cellTmpl = _.trim(_.get(args, 'row.calendarPicker.cellConfig.templateText'));
          if (!cellTmpl) {
            return;
          }

          options.cellTemplate = AdpWidgetsService.memoize(
            ({ date, text: dateText, view }, cellIndex, cellContainer) => {
              const isTemplatingSupported = view === 'month' && date;
              if (!isTemplatingSupported) {
                return `<span>${dateText}</span>`;
              }
              const cellRows = _.filter(dataRows, (row) => _isSameDate(date, row.date));
              const ctx = { cellRows, cellContainer, cellIndex, rows: dataRows, date, dateText };

              return `<span>${AdpWidgetsService.getTooltipText(cellTmpl, ctx)}</span>`;
            },
            ({ date }) => date.toString()
          );
        }

        function refreshTemplates() {
          const optionsObj = {};
          setCellTemplate(optionsObj);
          widgetInstance.option(optionsObj);
          widgetInstance.repaint();
        }

        function applyJsonExtend(args, options) {
          const extender = _.get(args, `row.calendarPicker.config`);

          if (!_.isEmpty(extender)) {
            return _.merge(options, extender);
          }
        }

        function enableWidgetAsControl(widgetId, options) {
          const linkIdControlledByDates = AdpWidgetsService.getSlidersOfWidget(
            args,
            scope.interface,
            'dateRangeControlSlider.linkIds'
          );

          if (!_.isEmpty(linkIdControlledByDates)) {
            options.onValueChanged = _.debounce((event) => {
              const { value } = event;
              const filter = selectedRangeToFilter(value);
              AdpWidgetsService.sendControlledLinksChangeEvents(
                filter,
                linkIdControlledByDates,
                widgetId,
                scope.interface
              );
            });
          }
        }

        function selectedRangeToFilter(value) {
          const h24 = 24 * 60 * 60 * 1000;
          let ranges = [];

          if (selectionMode === 'single') {
            ranges.push(['between', value, new Date(value.getTime() + h24)]);
          } else if (selectionMode === 'range') {
            ranges.push(['between', value[0], new Date((value[1] || value[0]).getTime() + h24)]);
          } else if (selectionMode === 'multiple') {
            const packed = _packRanges(value);
            ranges = _.map(packed, (r) => ['between', ...r]);
          }

          if (!ranges.length) {
            return;
          }

          if (ranges.length === 1) {
            return ranges[0];
          }

          return ['combine', ...ranges];

          function _packRanges(dates) {
            const sorted = _.sortBy(dates);
            const packed = [];
            let curStart = 0;
            let prevPoint = 0;
            _.each(sorted, (d) => {
              const point = d.getTime();
              if (point - prevPoint > h24) {
                if (curStart) {
                  packed.push([new Date(curStart), new Date(prevPoint + h24)]);
                }
                curStart = point;
              }
              prevPoint = point;
            });
            if (curStart) {
              packed.push([new Date(curStart), new Date(prevPoint + h24)]);
            }
            return packed;
          }
        }

        function loadWidgetData(options) {
          return AdpWidgetsService.fetchWidgetData(args, options).then(({ messages, data }) => {
            if (messages) {
              scope.errorMessage = messages.join('</br>');
              if (widgetInstance) {
                widgetInstance.dispose();
                widgetInstance = null;
              }
            } else {
              scope.errorMessage = '';
              dataRows = _.get(data, '0._mappedFields') ? _.map(data, (d) => ({ ...d, ...d._mappedFields })) : data;
              if (widgetInstance) {
                refreshTemplates();
              } else {
                initialiseComponent();
              }
            }
          });
        }

        function _isSameDate(day, moment) {
          const start = day.getTime();
          const end = start + 24 * 60 * 60 * 1000;
          const seconds = new Date(moment).getTime();
          return start <= seconds && seconds < end;
        }
      },
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetControl', widget);

  /** @ngInject */
  function widget(
    APP_CONFIG,
    $timeout,
    AdpClientCommonHelper,
    ErrorHelpers,
    AdpWidgetsService,
    ControllerCreationService,
    ControlWidgetHelper
  ) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/control-widget.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const isVendorCodeAvailable = () => window.chrono;

      AdpWidgetsService.loadVendorCodeOnce(isVendorCodeAvailable, loadVendorCode, 'ControlWidgetVendorCode')
        .then(() => initWidget(scope, $element))
        .catch((err) => ErrorHelpers.handleError(err, 'Control widget error'));
    }

    function loadVendorCode() {
      const jsUrl = APP_CONFIG.resourceUrl + '/public/js/lib/chrono/index.js';
      return AdpClientCommonHelper.loadScript(jsUrl);
    }

    function initWidget(scope) {
      const args = scope.args;
      const widgetId = args.row._id;
      const linksInterface = AdpWidgetsService.getControlLinksInterface(scope.interface);

      if (!linksInterface) {
        scope.errorMessage = 'This widget works only within dashboard';
        return;
      }

      // Need to extract presets data before controllers initialisation to use initial values from default preset
      let controllerRows = _.get(args, 'widgetConfiguration.sliders') || [];
      const presetsRow = _.find(controllerRows, (c) => c.controlType === 'LoadPresets');
      let defaultPreset;

      if (presetsRow) {
        const presetsPermissions = _.get(args, 'widgetConfiguration.presetsPermissions') || {};
        const presets = _.get(args, 'widgetConfiguration.presets') || [];
        defaultPreset = _.find(presets, (p) => p.isDefault);
        _.set(presetsRow, `loadPresets.presets`, presets);
        _.set(presetsRow, `loadPresets.presetsPermissions`, presetsPermissions);
      }

      linksInterface.markTileAsSubscribed(widgetId); // We require this for API consistency

      linksInterface.awaitAllWidgetsSubscribed().then(() => {
        scope.controllers = createControllers(controllerRows, scope, defaultPreset);
        scope.groupingTree = makeGroupingTree(scope.controllers);

        scope.$on('controlLinkValueChange', (e, payload) => {
          _.each(scope.controllers, (controller) => {
            const isSameControl = payload.sourceWidgetId === widgetId && payload.sourceControlId === controller._id;
            const isReadyToChange = controller.isInitialised && controller.activeStatus !== 'off';

            if (isSameControl || !isReadyToChange) {
              return;
            }

            if (_.indexOf(controller.linkIds, payload.linkId) >= 0) {
              ControlWidgetHelper.setControllerLinksSync(controller);

              if (!ControlWidgetHelper.isValidValue(payload.value)) {
                controller.errorMessage = 'Invalid value';
                ControlWidgetHelper.setValueSync(controller, false);
              } else {
                controller.errorMessage = '';
                controller.api._setValue(payload.value);
              }
            }
          });
        });
        scope.$on('controlLinksGetAllValues', (e, payload) => {
          const { linkIds, resolve } = payload;
          const result = ControlWidgetHelper.collectControllersValues(scope.controllers, linkIds);

          resolve(result);
        });
      });
    }

    function makeGroupingTree(controllers) {
      const result = [];
      let subset;
      _.each(controllers, (controller) => {
        const { type } = controller;
        if (type === 'Group') {
          subset = [];
          controller.subset = subset;
          result.push(controller);
        } else if (type === 'GroupEnd') {
          subset = null;
        } else {
          if (subset) {
            subset.push(controller);
          } else {
            result.push(controller);
          }
        }
      });
      return result;
    }

    function createControllers(rowsData, widgetScope, defaultPreset) {
      const thisWidgetId = widgetScope.args.row._id;
      const linksInterface = AdpWidgetsService.getControlLinksInterface(widgetScope.interface);
      const existingLinks = linksInterface.getLinks();

      return _.compact(
        _.map(rowsData, (row) => {
          const controller = createController(row);

          if (['GroupEnd'].includes(controller.type)) {
            return controller;
          }

          controller.links = _.compact(_.map(controller.linkIds, (id) => existingLinks[id]));
          controller.widgetId = thisWidgetId;

          if (defaultPreset) {
            const forcedFromPreset = _.find(defaultPreset.filterStates, (state) => state.filterId === controller._id);
            if (forcedFromPreset) {
              if (controller.activeStatus === 'on' && forcedFromPreset.disabled) {
                controller.activeStatus = 'off';
              }
              controller.presetForced = forcedFromPreset.value;
            }
          }

          ControllerCreationService.createMethods(controller, widgetScope);

          return controller;
        })
      );
    }

    function createController(row) {
      const { _id, controlType: type, label, description, linkIds, initiallyDisabled, ...params } = row;
      const noStatusRequired = !ControllerCreationService.showStatusSwitch(type);
      const initialStatus = initiallyDisabled ? 'off' : 'on';
      return {
        _id,
        type,
        label,
        description,
        linkIds,
        isInitialised: false,
        activeStatus: noStatusRequired ? 'void' : initialStatus,
        params: ControllerCreationService.getConfigParams(params, type),
      };
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('ControlWidgetHelper', controlWidgetHelper);

  /** @ngInject */
  function controlWidgetHelper($sce) {
    const validOperations = [
      'contains',
      'notcontains',
      'startswith',
      'endswith',
      '=',
      '<>',
      '>=',
      '<=',
      'regex',
      'between',
      'any',
      'empty',
      'combine',
      'geoNear',
    ];

    function sendLinkChangeEvents(value, controller, linksInterface, options = {}) {
      const throttle = _.get(options, 'throttle', 0);
      const { readyResolver } = options;
      const allLinksPromises = [];

      if (!controller.links || !controller.links.length) {
        controller.errorMessage = 'Link is broken';
        return;
      }

      const eventPayloads = _.map(controller.links, function (link) {
        const eventData = {
          linkId: link.linkId,
          value: _.clone(value),
          sourceWidgetId: controller.widgetId,
          sourceControlId: controller._id,
        };

        if (throttle) {
          eventData.throttle = throttle;
        }

        if (readyResolver) {
          const promise = new Promise((resolve) => (eventData.readyResolver = resolve));

          allLinksPromises.push(promise);
        }

        return eventData;
      });

      if (readyResolver) {
        Promise.all(allLinksPromises).then(readyResolver);
      }

      var results = linksInterface.setLinkValue(eventPayloads);
      var errors = _.uniq(
        _.map(
          _.filter(results, (x) => !x.ok),
          (res) => res.message
        )
      );
      if (!errors.length) {
        controller.errorMessage = '';
      } else {
        controller.errorMessage = errors.join('; ');
      }
    }

    function controlInitHandler(compsObj, compName) {
      return (e) => {
        compsObj[compName] = e.component;
      };
    }

    function controlChangeHandler(controller, linksInterface, handler) {
      const debouncedEventSender = _.debounce(sendLinkChangeEvents, 250);

      return function (e) {
        if (this.adpIgnoreEvent || !e.event) {
          this.adpIgnoreEvent = false;
          return; // Ignore programmatically-caused changes
        }
        const newValue = handler(e.value);

        if (!_.isUndefined(newValue)) {
          debouncedEventSender(newValue, controller, linksInterface);
        }
      };
    }

    function getControllerLinksValue(controller) {
      if (!controller.links || !controller.links.length) {
        return null;
      }

      return controller.links[0].value;
    }

    function setControllerLinksSync(controller) {
      const value0 = getControllerLinksValue(controller);
      let isSync = true;

      if (_.isArray(controller.links)) {
        for (var i in controller.links) {
          if (i && !isEqual(controller.links[i].value, value0)) {
            isSync = false;
            break;
          }
        }
      }

      setLinksSync(controller, isSync);
    }

    function isEqual(val1, val2) {
      var isarr1 = _.isArray(val1);
      var isarr2 = _.isArray(val2);

      if (isarr1 && isarr2 && val1.length === val2.length && _.difference(val1, val2).length === 0) {
        return true;
      }

      if (!isarr1 && !isarr2) {
        return val1 === val2;
      }

      return false;
    }

    function getAllListValues(controller) {
      const list = _.get(controller, 'params.listItems', []);

      return _.map(list, (item) => {
        let { value, label, ...rest } = item;
        label = label || _.startCase(value);
        return { value, label, ...rest };
      });
    }

    function getAllListValuesSafeHtmlLabel(controller) {
      const list = getAllListValues(controller);

      return _.map(list, (item) => {
        const { label, ...rest } = item;
        const safeHtmlLabel = $sce.trustAsHtml(label);
        return { safeHtmlLabel, label, ...rest };
      });
    }

    function getSecondsByUnitName(timePrecision) {
      const map = {
        year: 31556952, // === Math.round(3600 * 24 * 365.2425),
        month: 3600 * 24 * 30,
        week: 3600 * 24 * 7,
        day: 3600 * 24,
        hour: 3600,
        minute: 60,
        second: 1,
      };

      return map[timePrecision] || 1;
    }

    function isValidValue(value) {
      if (!_.isArray(value)) {
        return false;
      }

      if (validOperations.indexOf(value[0]) < 0) {
        return false;
      }

      return true;
    }

    function initValue(controller, linksInterface) {
      const { defaultValue, transformIn, fixWithLimits, updateSync, curVal } = controller.api;
      const defaultVal = _.isUndefined(controller.presetForced) ? defaultValue() : transformIn(controller.presetForced);
      const existingValue = getControllerLinksValue(controller);

      setControllerLinksSync(controller);

      if (_.isNil(existingValue)) {
        if (!_.isNil(defaultVal)) {
          curVal(defaultVal);
          broadcastValue(controller, linksInterface, { throttle: 50 });
        }

        return curVal();
      }

      updateSync(existingValue);

      let val = transformIn(existingValue);

      if (fixWithLimits) {
        const { value, err } = fixWithLimits(val);

        if (err) {
          controller.errorMessage = err;
        }

        val = value;
      }

      return curVal(val);
    }

    function setValueSync(controller, bool) {
      if (controller.activeStatus === 'off') {
        return;
      }

      controller.valueSync = bool;
      controller.activeStatus = bool && controller.linksSync ? 'on' : 'gray';
    }

    function setLinksSync(controller, bool) {
      controller.linksSync = bool;

      if (!bool) {
        controller.activeStatus = 'gray';
      }
    }

    function broadcastValue(controller, linksInterface, options) {
      const value = controller.api.curVal();
      const isDisabled = controller.activeStatus === 'off';
      const toSend = isDisabled ? ['empty'] : controller.api.transformOut(value);

      sendLinkChangeEvents(toSend, controller, linksInterface, options);
    }

    function registerValueSetter(controller, cb) {
      // debounce is required because each link change event propagate to link's widget AND to all control widgets.
      // So two events for two links from different widgets will hit same control widget twice, forcing slider to hold two handler calls in one cycle.
      // This will mess up mechanism which avoiding non-UI changes of slider input (with 'adpIgnoreEvent' event attribute involved)
      controller.api._setValue = _.debounce(cb, 5);
      controller.isInitialised = true;
    }

    function registerOnStateChange(controller, cb) {
      controller.api._onStateChange = cb;
    }

    function setSyncAll(controller) {
      setValueSync(controller, true);
      setLinksSync(controller, true);
      controller.activeStatus = 'on';
    }

    function getExceedLimitsErrorMessage(err) {
      return err.length ? err.join(' & ') + ' ' + (err.length > 1 ? 'are' : 'is') + ' out of range' : '';
    }

    function collectControllersValues(controllers, filterIds) {
      const result = [];

      _.each(controllers, (controller) => {
        const { isInitialised, activeStatus, label, linkIds } = controller;
        const isConsiderable = isInitialised && activeStatus !== 'off' && _.intersection(linkIds, filterIds).length;
        if (!isConsiderable) {
          return;
        }
        const value = controller.api.transformOut(controller.api.curVal());
        result.push({ value, activeStatus, label, linkIds });
      });
      return result;
    }

    function getDateTimePoint(dateObject, nilAllowed = false) {
      return _getTimePoint(dateObject, nilAllowed);
    }

    function _getTimePoint(object, nilAllowed = false) {
      const type = _.get(object, 'type');
      if (nilAllowed && !type) {
        return;
      }

      if (type === 'relative') {
        const value = _.get(object, `relativeDate`);
        if (nilAllowed && _.isNil(value)) {
          return;
        }

        return window.chrono.parseDate(value);
      }

      const value = _.get(object, `regularDate`);
      if (nilAllowed && _.isNil(value)) {
        return;
      }

      return new Date(value);
    }

    function fixRangeWithLimits(a, b, min, max, allowOpenMin, allowOpenMax) {
      const errors = [];
      let start = a;
      let end = b;
      if (start < min) {
        !allowOpenMin && errors.push('Min');
        start = min;

        if (end < min) {
          !allowOpenMax && errors.push('Max');
          end = min;
        }
      }
      if (end > max) {
        !allowOpenMax && errors.push('Max');
        end = max;

        if (start > max) {
          !allowOpenMin && errors.push('Min');
          start = max;
        }
      }
      return { pair: [start, end], errors };
    }

    function fixValueWithLimits(a, min, max) {
      const errors = [];
      let value = a;
      if (value < min) {
        errors.push('Min');
        value = min;
      }
      if (value > max) {
        errors.push('Max');
        value = max;
      }
      return { value, errors };
    }

    function isSameValues(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    }

    function castValueType(val, type) {
      if (type === 'Number') {
        const num = parseInt(val);
        return _.isNaN(num) ? 0 : num;
      }
      if (type === 'Boolean') {
        return val.toLowerCase() !== 'false';
      }

      return val.toString();
    }

    return {
      sendLinkChangeEvents,
      controlInitHandler,
      controlChangeHandler,
      getAllListValues,
      getAllListValuesSafeHtmlLabel,
      getSecondsByUnitName,
      isValidValue,
      setControllerLinksSync,
      setValueSync,
      initValue,
      registerValueSetter,
      registerOnStateChange,
      setSyncAll,
      broadcastValue,
      getExceedLimitsErrorMessage,
      collectControllersValues,
      getDateTimePoint,
      fixRangeWithLimits,
      fixValueWithLimits,
      isSameValues,
      castValueType,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('controllerStatusSwitch', controllerStatusSwitch);

  /** @ngInject */
  function controllerStatusSwitch() {
    return {
      restrict: 'E',
      replace: true,
      template: '<div class="adp-cw-controller-status" ng-click="onStatusClick()" title="Toggle filter"></div>',
      link: directiveLink,
    };

    function directiveLink(scope) {
      const { controller } = scope;
      scope.onStatusClick = () => {
        controller.activeStatus = controller.activeStatus === 'off' ? 'on' : 'off';
        controller.api.setActiveStatus(controller.activeStatus === 'on');
      };
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetDatagrid', adpWidgetDatagrid);

  /** @ngInject */
  function adpWidgetDatagrid(AdpWidgetsService) {
    return {
      restrict: 'E',
      template: `
<div class="adp-widget-container">
  <adp-data-grid class="adp-widget-datagrid" ng-if="schema" ng-show="!errorMessage" schema="schema" options="options"></adp-data-grid>
  <div class="adp-widget-container-error-message well-background" ng-show="errorMessage" ng-bind-html="errorMessage"></div>
</div>`,
      scope: {
        interface: '<',
        args: '<',
      },
      link: function (scope, element) {
        (function init() {
          scope.schema = null;
          let lastFilter = [];
          const { args } = scope;
          const widgetId = _.get(scope, 'args.row._id');
          const isControlled = AdpWidgetsService.isWidgetControlled(widgetId, scope.interface);
          const sliders = AdpWidgetsService.getSlidersOfWidget(args, scope.interface);
          const { options, schema } = args.widgetConfiguration;
          let isDatasourceAssigned = false;
          options.dataSource = createDataSource(emptyLoad);

          scope.getFilterForDatalayer = () => lastFilter;
          AdpWidgetsService.setWidgetScopeToTile(scope);

          if (sliders.length) {
            options.onRowClick = onRowClick;

            const onLinkUpdate = (payload) => {
              const gridInstance = getGridInstance();
              if (!gridInstance) {
                return;
              }
              const linkValues = payload.value.slice(1);
              const controlledIndex = _.findIndex(sliders, (slider) => _.includes(slider.linkIds, payload.linkId));

              selectRowsWithClickValues(gridInstance, linkValues, controlledIndex);
            };
            AdpWidgetsService.handleControlledLinksChange({ onLinkUpdate, widgetId, scope });
          }

          if (isControlled) {
            const widgetId = _.get(scope, 'args.row._id');
            const onLinkChange = ({ dxFilter, virtualFilters }) => {
              if (!isDatasourceAssigned) {
                const gridInstance = getGridInstance();
                if (!gridInstance) {
                  return;
                }
                gridInstance.option('dataSource', createDataSource(dataLoad));
                isDatasourceAssigned = true;
              }
              lastFilter = { dxFilter, virtualFilters };
              return reloadGridData(lastFilter);
            };
            AdpWidgetsService.handleControlLinkChange({ scope, widgetId, onLinkChange });
          } else {
            isDatasourceAssigned = true;
            options.dataSource = createDataSource(dataLoad);
          }

          scope.options = options;
          scope.schema = schema;
          fixOptionsForWidget();

          const onDatasetUpdate = () => reloadGridData(lastFilter, true);
          AdpWidgetsService.handleDatasetUpdate({ args, $element: element, onDatasetUpdate });
          AdpWidgetsService.touchLinksControlledByWidget(widgetId, scope.interface);

          function onRowClick(e) {
            const selectedRows = e.component.getSelectedRowsData();
            const clickValuesArr = _.map(selectedRows, (row) => row._clickValues);
            AdpWidgetsService.sendValuesToControlled(clickValuesArr, sliders, widgetId, scope.interface);
          }

          function dataLoad({ filter: { dxFilter, virtualFilters } = {}, sort, skip, take }) {
            const opts = { filter: dxFilter, virtualFilters, sort, skip, take };

            return AdpWidgetsService.fetchWidgetData(args, opts).then(({ messages, ...data }) => {
              scope.errorMessage = messages ? messages.join('</br>') : null;
              return data;
            });
          }

          function emptyLoad() {
            return Promise.resolve({ totalCount: 0, data: [] });
          }
        })();

        function createDataSource(load) {
          return { store: new DevExpress.data.CustomStore({ load }) };
        }

        function selectRowsWithClickValues(gridInstance, linkValues, controlledGroupIndex) {
          const gridDataSource = gridInstance.getDataSource();
          const indexes = [];

          gridDataSource._items.forEach((row, index) => {
            if (_.includes(linkValues, row._clickValues[controlledGroupIndex])) {
              indexes.push(index);
            }
          });
          return gridInstance.selectRowsByIndexes(indexes);
        }

        function reloadGridData({ dxFilter = [], virtualFilters }, forceReload = false) {
          const gridInstance = getGridInstance();
          if (!gridInstance) {
            return;
          }
          const gridDataSource = gridInstance.getDataSource();

          return new Promise((resolve) => {
            const onDsLoading = (isLoading) => {
              if (!isLoading) {
                gridDataSource.off('loadingChanged', onDsLoading);
                resolve();
              }
            };

            gridDataSource.on('loadingChanged', onDsLoading);
            if (forceReload) {
              gridInstance.refresh(true);
            } else {
              gridInstance.filter({ dxFilter, virtualFilters });
            }
          });
        }

        function getGridInstance() {
          try {
            return element.find('[dx-data-grid]').dxDataGrid('instance');
          } catch (e) {
            console.error('Failed to locate grid instance');
            return null;
          }
        }

        function fixOptionsForWidget() {
          // disabling selection column due to lack of space inside dashboard
          // keeping only ability to select by clicking on row
          const multipleSelectionEnabled = _.get(scope.schema, 'parameters.selection.mode') === 'multiple';
          multipleSelectionEnabled && _.set(scope.schema, 'parameters.selection.showCheckBoxesMode', 'none');
        }
      },
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetChart', adpWidgetChart);

  /** @ngInject */
  function adpWidgetChart($sce, $timeout, AdpCodeLoadHelper) {
    const template = `
        <div 
            class="adp-widget-container"
            ng-class="{ 'adp-chart-initialized': initialized }"
          >
          <div 
            class="adp-widget-container adp-charts-container" 
            ng-show="!errorMessage"
          ></div>
            
          <div 
          class="adp-widget-container-error-message"
          ng-show="errorMessage"
          ng-bind-html="errorMessage"></div>
        </div>`;

    return {
      restrict: 'E',
      template,
      scope: {
        options: '=',
        data: '=',
        messages: '=',
        eventHandlers: '=',
      },
      replace: true,
      link: function (scope, element) {
        let chart;
        initChart();
        scope.$watch('[options, data]', ([newOptions, newData], [oldOptions, oldData]) => {
          if (newOptions === oldOptions && newData === oldData) {
            return;
          }

          setChartOptions();
        });

        function initChart() {
          scope.initialized = false;
          initChartInstance().then(() => {
            setChartOptions();
            bindEvents(chart);
          });
        }

        function initChartInstance() {
          chart && chart.dispose();

          const { echartsTheme = 'light' } = window.forcedThemes || window.adpAppStore.appInterface();
          const [chartEl] = $('.adp-charts-container', element);

          return AdpCodeLoadHelper.loadVendorGroup('echarts').then(() => {
            chart = echarts.init(chartEl, echartsTheme);
          });
        }

        function setChartOptions() {
          if (scope.messages) {
            setError(scope.messages.join('<br/>'));
            return;
          }

          if (hasNoData()) {
            setError('No Data Available');
            return;
          }

          if (!chart) {
            initChartInstance().then(() => {
              bindEvents(chart);
              setChartOptionsToExistingChart();
            });
          } else {
            setChartOptionsToExistingChart();
          }
        }

        function setChartOptionsToExistingChart() {
          if (scope.eventHandlers) {
            const { onClick, onSelect } = scope.eventHandlers;
            if (onClick) {
              chart.on('click', params => onClick(params, chart));
              chart.getZr().on('click', params => {
                if (!params.target) {
                  onClick({ clickOnEmptySpace: true }, chart);
                }
              });
            }
            if (onSelect) {
              chart.on('selectchanged', params => onSelect(params, chart));
            }
          }

          const setOptions = setData(scope.options, scope.data);

          try {
            chart.setOption(scope.options, setOptions);
            chart.on('finished', () => {
              $timeout(() => {
                scope.initialized = true;
                scope.$apply();
                chart.off('finished');
              });
            });
            scope.errorMessage = '';
            _.defer(chart.resize);
          } catch (e) {
            setError(e.message || e);
            console.error('Error applying option to widget chart:', e);
          }
        }

        function hasNoData() {
          const data = scope.data.path ? scope.data.source : scope.data;
          return _.isNil(scope.options) || _.isEmpty(data);
        }

        function setData(options, data) {
          if (data.merge === 'replace') {
            scope.options = data.source;
            return { notMerge: true };
          } else if (data.path) {
            setDataByPath(options, data);
          } else {
            _.set(options, 'dataset', data);
          }

          return {};
        }

        function setDataByPath(options, { path, source }) {
          if (Array.isArray(path)) {
            path.forEach(({ sourcePath, targetPath }) => {
              const sourceItem = source[sourcePath];
              const defaultValue = _.isArray(sourceItem) ? [] : {};
              const targetItem = _.get(options, targetPath) || defaultValue;
              _.mergeWith(targetItem, sourceItem, customizedMerger);
              _.set(options, targetPath, targetItem);
            })
          } else {
            const defaultValue = _.isArray(source) ? [] : {};
            const target = _.get(options, path) || defaultValue;
            _.mergeWith(target, source, customizedMerger);
            _.set(options, path, target);
          }

          function customizedMerger(objValue, srcValue, key) {
            if (_.includes(['data', 'nodes', 'links'], key)) {
              return srcValue;
            }
          }
        }

        function bindEvents(chart) {
          if (!chart) {return}
          const asyncResize = _.debounce(chart.resize, 50);
          scope.$on('widgetTileResize', asyncResize);
          scope.$on('$destroy', () => chart.dispose());
          chart.resize();
        }

        function setError(message) {
          scope.errorMessage = $sce.trustAsHtml(message);
          chart && chart.dispose();
          chart = null;
        }
      }
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpChartExtraDataHelper', AdpChartExtraDataHelper);

  function AdpChartExtraDataHelper(AdpWidgetsService) {
    const clickHandlerGetters = {
      wordcloud: _getWordCloudHandler,
      sankey: _getHandlerForNodesAndEdges,
      graph: _getHandlerForNodesAndEdges,
    };
    const sendValueGetters = {
      treeChart: _fromDataGetter,
      treeMap: _fromDataGetter,
      wordcloudV2: _fromDataGetter,
      areaChart: _useDataIndexGetter,
      sankey: _fromDataGetter,
      graph: _fromDataGetter,
      radar: _fromDataGetter,
      sunburst: _fromDataGetter,
      calendarHeatmap: _useDataIndexGetter,

      pieChartTransposed: _byDataIndexGetter,
      pieChart: _pieSelectGetter,
      stackedColumnChart: _byDataIndexGetter,
      funnel: _byDataIndexGetter,
      barChart3d: _twoDimensionalUniversalGetter,
      scatterPlot: _twoDimensionalUniversalGetter,
    };
    const sendFieldLabelGetters = {
      pieChartTransposed: _fieldLabelValueTransposed,
      pieChart: _fieldLabelValue,
      stackedColumnChart: _fieldLabelValueTransposed,
    };
    const tooltipFormatterGetters = {
      sankey: _getTooltipFormatterForNodesAndEdges,
      graph: _getTooltipFormatterForNodesAndEdges,
    };
    const mappedFieldsGetters = {
      sankey: _mappedFieldsInData,
      graph: _mappedFieldsInData,
      treeChart: _mappedFieldsInData,
      treeMap: _mappedFieldsInData,
      barChart3d: _mappedFieldsTwoDimensional,
      scatterPlot3d: _mappedFieldsTwoDimensional,
      scatterPlot: _mappedFieldsTwoDimensional,
    };
    const selectionHandlerGetters = {
      pieChartTransposed: _getCommonSelectionHandler,
      pieChart: _getCommonSelectionHandler,
      stackedColumnChart: _getCommonSelectionHandler,
      funnel: _getCommonSelectionHandler,
      scatterPlot: _getCommonSelectionHandler,
    };
    const unselectDataAndSeriesIndexGetters = {
      stackedColumnChart: _getDatasetDataSeriesIndex,
    };

    function getEventHandlers(scope) {
      const onSelect = _getSelectionChangeHandler(scope);
      let onClick;
      if (onSelect) {
        onClick = _getBackgroundClickUnselectHandler(scope);
      } else {
        // Currently most charts works with click handler, but we gradually migrate them on selectionChange events
        onClick = _getClickHandler(scope);
      }

      return { onSelect, onClick };
    }

    function _byDataIndexGetter({ scope }) {
      return (sliderIndex, seriesIndexes, dataIndexes) => {
        return getClickValuesByIndexes(dataIndexes, sliderIndex, scope);
      };
    }

    function _pieSelectGetter({ scope }) {
      return (sliderIndex, seriesIndexes) => {
        return getClickValuesByIndexes(seriesIndexes, sliderIndex, scope);
      };
    }

    function _twoDimensionalUniversalGetter({ params, scope }) {
      const { dataIndex, seriesIndex, selected } = params;

      if (selected) {
        const { seriesIndexes, dataIndexes } = _collectSelectedSeriesAndData({ selected });
        return (sliderIndex) => {
          return _.flatten(
            _.map(seriesIndexes, (sIndex) =>
              _.map(dataIndexes, (dIndex) => _.get(scope, `clickValues.${sIndex}.${dIndex}.${sliderIndex}`))
            )
          );
        };
      }

      return (sliderIndex) => {
        return _.get(scope, `clickValues.${seriesIndex}.${dataIndex}.${sliderIndex}`);
      };
    }

    function getClickValuesByIndexes(indexes, sliderIndex, scope) {
      return _.map(indexes, (idx) => _.get(scope, `clickValues.${idx}.${sliderIndex}`));
    }

    function _collectSelectedSeriesAndData({ selected }) {
      const seriesIndexes = selected.map((item) => item.seriesIndex);
      const dataIndexes = _.uniq(_.flatten(selected.map((item) => item.dataIndex)));
      return { seriesIndexes, dataIndexes };
    }

    function _getClickHandler(scope) {
      const widgetType = _.get(scope, 'args.row.type');
      const { interface: editInterface } = scope;
      const clickHandlerGetter = clickHandlerGetters[widgetType] || _getCommonHandler;

      return clickHandlerGetter({ scope, widgetType, editInterface });
    }

    function _getSelectionChangeHandler(scope) {
      const widgetType = _.get(scope, 'args.row.type');
      const { interface: editInterface } = scope;
      const selectionHandlerGetter = selectionHandlerGetters[widgetType];

      return selectionHandlerGetter && selectionHandlerGetter({ scope, widgetType, editInterface });
    }

    function _getCommonSelectionHandler({ scope, editInterface }) {
      // ToDo: review routine params to reduce duplications
      const { args } = scope;
      const widgetId = _.get(args, 'row._id');
      const widgetType = _.get(args, 'row.type');
      const sliders = AdpWidgetsService.getSlidersOfWidget(args, editInterface);
      if (!sliders.length) {
        return null;
      }
      const isSingleSelectionMode = !_.get(args, `row.${widgetType}.selectionOptions.allowMultiselect`);

      return (params, chart) => {
        if (isSingleSelectionMode) {
          const isSmthUnselected = _unselectPreviousSelection(params, chart);
          if (isSmthUnselected) {
            return;
          }
        }
        const valGetter = _getValueGetter({ params, widgetType, chart, scope });
        const fieldLabelGetter = _getFieldLabelGetter({ params, widgetType, chart, scope });
        const { seriesIndexes, dataIndexes } = _collectSelectedSeriesAndData(params);
        _makeUnselectedPale(params, chart);
        let mode1index = 0;
        let mode2index = 0;
        _.each(sliders, (slider) => {
          const mode2slider = slider.clickValue === '[useFieldName]';
          let value;
          if (mode2slider) {
            value = fieldLabelGetter(mode2index, seriesIndexes, dataIndexes);
            mode2index++;
          } else {
            value = valGetter(mode1index, seriesIndexes, dataIndexes);
            mode1index++;
          }
          _sendValueToLinks(value, slider.linkIds, widgetId, editInterface);
        });
      };
    }

    function _makeUnselectedPale(params, chart) {
      const options = chart.getOption();
      const { selected } = params;
      const isSelect = !_.isEmpty(selected);
      const newOptions = {
        series: _.map(options.series, (s) => ({
          name: s.name,
          select: {
             itemStyle: { opacity: 1 },
          },
          itemStyle: { opacity: isSelect ? 0.2 : 1 },
        })),
      };
      chart.setOption(newOptions, { silent: true });
    }

    function _unselectPreviousSelection(params, chart) {
      const { fromAction, selected, fromActionPayload } = params;
      if (fromAction === 'unselect') {
        return false;
      }
      if (selected.length === 1 && selected[0].dataIndex.length === 1) {
        return false;
      }
      const { seriesIndex, dataIndexInside } = fromActionPayload;
      let prevSeriesIndex;
      let prevDataIndex;
      _.each(selected, (s) => {
        if (s.seriesIndex !== seriesIndex) {
          prevSeriesIndex = s.seriesIndex;
          prevDataIndex = s.dataIndex[0];
        } else if (s.dataIndex.length > 1) {
          prevDataIndex = s.dataIndex[0] === dataIndexInside ? s.dataIndex[1] : s.dataIndex[0];
          prevSeriesIndex = s.seriesIndex;
        }
      });
      chart.dispatchAction({
        type: 'unselect',
        seriesIndex: [prevSeriesIndex],
        dataIndex: [prevDataIndex],
      });
      return true;
    }

    function _getFieldLabelGetter({ params, widgetType, chart, scope }) {
      const valueGetter = sendFieldLabelGetters[widgetType] || _fieldLabelValue;
      return valueGetter({ params, widgetType, chart, scope });
    }

    function _fieldLabelValue({ scope }) {
      return (sliderIndex, seriesIndexes, dataIndexes) => _getFieldLabelValue(scope.args, dataIndexes, sliderIndex);
    }

    function _fieldLabelValueTransposed({ scope }) {
      return (sliderIndex, seriesIndexes) => _getFieldLabelValue(scope.args, seriesIndexes, sliderIndex);
    }

    function _getFieldLabelValue(args, fieldIndexes, sliderIndex) {
      return fieldIndexes.map((index) => _.get(args, ['widgetConfiguration', 'fieldsClickValues', index, sliderIndex]));
    }

    function _getCommonHandler({ scope, editInterface }) {
      const { args } = scope;
      const widgetId = _.get(args, 'row._id');
      const widgetType = _.get(args, 'row.type');
      const sliders = AdpWidgetsService.getSlidersOfWidget(args, editInterface);

      if (!sliders.length) {
        return null;
      }

      return (params, chart) => {
        const valGetter = _getValueGetter({ params, widgetType, chart, scope });
        _sendValueToSliders(sliders, valGetter, widgetId, editInterface);
      };
    }

    function _getHandlerForNodesAndEdges({ scope, editInterface }) {
      const { args } = scope;
      const widgetId = _.get(args, 'row._id');
      const widgetType = _.get(args, 'row.type');
      const slidersNodes = AdpWidgetsService.getSlidersOfWidget(args, editInterface, 'nodesRelated.sliders');
      const slidersLinks = AdpWidgetsService.getSlidersOfWidget(args, editInterface, 'linksRelated.sliders');

      if (!slidersNodes.length && !slidersLinks.length) {
        return null;
      }

      return (params) => {
        const valGetter = _getValueGetter({ params, widgetType, scope });
        const sliders = params.dataType === 'edge' ? slidersLinks : slidersNodes;
        _sendValueToSliders(sliders, valGetter, widgetId, editInterface);
      };
    }

    function _getWordCloudHandler({ scope, editInterface }) {
      const { args } = scope;
      const linkIds = _.get(args, 'row.wordcloud.linksControlledIds', []);
      if (!linkIds.length) {
        return null;
      }
      return (params) => {
        const widgetId = _.get(args, 'row._id');
        if (params.clickOnEmptySpace) {
          AdpWidgetsService.sendValuesToControlled([], [{ linkIds }], widgetId, editInterface);
        }
        const clickedWord = params.name;
        AdpWidgetsService.sendValuesToControlled([[clickedWord]], [{ linkIds }], widgetId, editInterface);
      };
    }

    function _getValueGetter({ params, widgetType, chart, scope }) {
      if (params.clickOnEmptySpace) {
        return () => null;
      }
      const valueGetter = sendValueGetters[widgetType] || _commonValueGetter;
      return valueGetter({ params, widgetType, chart, scope });
    }

    function _commonValueGetter({ params, scope }) {
      const dataIndex = _.get(params, 'seriesIndex');
      return _clickValueByIndexGetter(dataIndex, scope);
    }

    function _useDataIndexGetter({ params, scope }) {
      const dataIndex = _.get(params, 'dataIndex');
      return _clickValueByIndexGetter(dataIndex, scope);
    }

    function _clickValueByIndexGetter(dataIndex, scope) {
      const clickValues = _.get(scope, `clickValues.${dataIndex}`);
      return (index) => _.get(clickValues, index);
    }

    function _fromDataGetter({ params }) {
      const clickValues = _.get(params, `data._clickValues`);
      return (index) => _.get(clickValues, index);
    }

    function _sendValueToSliders(sliders, valGetter, widgetId, editInterface) {
      _.each(sliders, (slider, index) => {
        const value = valGetter(index);
        _sendValueToLinks(value, slider.linkIds, widgetId, editInterface);
      });
    }

    function _sendValueToLinks(value, ids, widgetId, editInterface) {
      const filter = _valueToFilter(value);
      AdpWidgetsService.sendControlledLinksChangeEvents(filter, ids, widgetId, editInterface);
    }

    function _valueToFilter(value) {
      if (_.isNil(value)) {
        return ['empty'];
      }
      if (_.isArray(value)) {
        if (_.isEmpty(value)) {
          return ['empty'];
        }
        if (value.length === 1) {
          return ['=', value[0]];
        } else {
          return ['any', ...value];
        }
      } else {
        return ['=', value];
      }
    }

    function getTooltipFormatter(scope) {
      const widgetType = _.get(scope, 'args.row.type');
      const clickFormatterGetter = tooltipFormatterGetters[widgetType] || _getCommonTooltipFormatter;

      return clickFormatterGetter({ scope, widgetType });
    }

    function setTreeMapFormatter(scope) {
      const widgetType = _.get(scope, 'args.row.type');
      const pathToFormatter = `args.row.treeMap.chartLabel.formatter.tooltipConfig.templateText`;
      const formatterGetter = _getCommonTooltipFormatter({ scope, widgetType }, pathToFormatter);

      if (formatterGetter) {
        _.set(scope.options, 'series.0.label.formatter', formatterGetter);
      }
    }

    const oneOnly = (x) => (_.isArray(x) ? x[0] : x);
    const keyGetter = (params) => {
      const { seriesIndex, dataIndex } = oneOnly(params);
      return seriesIndex + '_' + dataIndex;
    };

    function _getCommonTooltipFormatter({ scope, widgetType }, path) {
      const tooltipPath = path || `args.row.${widgetType}.tooltipConfig.templateText`;
      const tooltipTmpl = _.trim(_.get(scope, tooltipPath));
      if (!tooltipTmpl) {
        return;
      }

      return AdpWidgetsService.memoize((_params) => {
        const params = oneOnly(_params);
        const tooltipContext = {
          mapped: _getMappedFields({ scope, params }),
          row: params.data,
          params,
        };
        return AdpWidgetsService.getTooltipText(tooltipTmpl, tooltipContext);
      }, keyGetter);
    }

    function _getTooltipFormatterForNodesAndEdges({ scope, widgetType }) {
      const nodeTooltipTmpl = _.trim(_.get(scope, `args.row.${widgetType}.nodesRelated.tooltipConfig.templateText`));
      const linksTooltipTmpl = _.trim(_.get(scope, `args.row.${widgetType}.linksRelated.tooltipConfig.templateText`));
      if (!nodeTooltipTmpl && !linksTooltipTmpl) {
        return;
      }

      return AdpWidgetsService.memoize((_params) => {
        const params = oneOnly(_params);
        const tmpl = params.dataType === 'edge' ? linksTooltipTmpl : nodeTooltipTmpl;
        const ctx = {
          mapped: _getMappedFields({ scope, params }),
          row: params.data,
          params,
        };
        return AdpWidgetsService.getTooltipText(tmpl, ctx);
      }, keyGetter);
    }

    function _getMappedFields({ scope, params }) {
      const widgetType = _.get(scope, 'args.row.type');
      const clickHandlerGetter = mappedFieldsGetters[widgetType] || _mappedFieldsInScope;

      return clickHandlerGetter({ scope, params });
    }

    function _mappedFieldsInScope({ scope, params }) {
      return _.get(scope, `mappedFields[${params.dataIndex}]`, {});
    }

    function _mappedFieldsInData({ params }) {
      return _.get(params, `data._mappedFields`, {});
    }

    function _mappedFieldsTwoDimensional({ scope, params }) {
      return _.get(scope, `mappedFields.${params.seriesIndex}.${params.dataIndex}`, {});
    }

    function _getBackgroundClickUnselectHandler(scope) {
      return (params, chart) => {
        if (!params.clickOnEmptySpace) {
          return;
        }
        const options = chart.getOption();
        const widgetType = _.get(scope, 'args.row.type');
        const indexGetter = unselectDataAndSeriesIndexGetters[widgetType] || _getCommonDataSeriesIndex;
        const { seriesCount, dataCount } = indexGetter(options);
        const seriesIndex = _.map(Array(seriesCount), (k, i) => i);
        const dataIndex = _.map(Array(dataCount), (k, i) => i);
        chart.dispatchAction({
          type: 'unselect',
          seriesIndex,
          dataIndex,
        });
      };
    }

    function _getCommonDataSeriesIndex(options) {
      const series = _.get(options, 'series', []);
      const seriesCount = series.length;
      const dataCount = _.max(_.map(series, (seria) => _.get(seria, 'data.length', 0)));
      return { seriesCount, dataCount };
    }

    function _getDatasetDataSeriesIndex(options) {
      const series = _.get(options, 'series', []);
      const seriesCount = series.length;
      const dataCount = _.get(options, 'dataset[0].source.length');
      return { seriesCount, dataCount };
    }

    return {
      getEventHandlers,
      getTooltipFormatter,
      setTreeMapFormatter,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets')
    .directive('adpWidgetDashboardChart', adpWidgetDashboardChart);

  /** @ngInject */
  function adpWidgetDashboardChart(AdpWidgetsService, AdpChartExtraDataHelper) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      templateUrl: "client-modules/adp-widgets/widgets/dashboard-chart/dashboard-chart.template.html",
      link: function (scope, element) {
        (function init() {
          const widgetId = _.get(scope, 'args.row._id');
          const isControlled = AdpWidgetsService.isWidgetControlled(widgetId, scope.interface);
          let currentFilters = {};

          scope.getFilterForDatalayer = dataLayerId => _.get(currentFilters, [dataLayerId, 'filter']) || [];
          scope.eventHandlers = AdpChartExtraDataHelper.getEventHandlers(scope);
          setOptions();
          AdpWidgetsService.setWidgetScopeToTile(scope);

          const tooltipFormatter = AdpChartExtraDataHelper.getTooltipFormatter(scope);
          if (tooltipFormatter) {
            _.set(scope.options, 'tooltip.formatter', tooltipFormatter);
          }
          AdpChartExtraDataHelper.setTreeMapFormatter(scope);

          if (!isControlled) {
            fetchWidgetData();
          } else {
            const onLinkChange = (payload) => {
              const options = prepareDxFilters(payload);
              const emptyFilterMessages = handleEmptyFilter(options);
              if (emptyFilterMessages.length) {
                scope.options = { _replaceMessage: emptyFilterMessages };
                scope.data = [];
              } else {
                fetchWidgetData(options);
              }
            }
            AdpWidgetsService.handleControlLinkChange({ scope, widgetId, onLinkChange });
          }

          const onDatasetUpdate = () => fetchWidgetData(currentFilters);
          const { args } = scope;
          AdpWidgetsService.handleDatasetUpdate({ args, $element: element, onDatasetUpdate });
          AdpWidgetsService.touchLinksControlledByWidget(widgetId, scope.interface);

          function prepareDxFilters(changePayload) {
            const { dxFilter, virtualFilters, dataLayerId } = changePayload;
            if (dxFilter || virtualFilters) {
              currentFilters[dataLayerId] = { filter: dxFilter, virtualFilters };
            } else {
              delete currentFilters[dataLayerId];
            }
            return currentFilters;
          }
        })();

        function handleEmptyFilter({ filter }) {
          const noFilterMessages = _.get(scope, `args.widgetNoFilterMessages`);
          const emptyFilterMessages = [];
          _.each(noFilterMessages, (message, dataLayerId) => {
            const layerFilter = _.get(filter, dataLayerId);
            if (!_.isNil(message) && _.isEmpty(layerFilter)) {
              emptyFilterMessages.push(message);
            }
          })
          return emptyFilterMessages;
        }

        function setOptions() {
          const opts = _.get(scope, 'args.widgetConfiguration.options') || {};
          const { type } = scope.args.row;
          const { echartsDecal = false } = window.forcedThemes || window.adpAppStore.appInterface();
          if (echartsDecal) {
            opts.aria = {
              enabled: true,
              decal: {
                show: true
              }
            };
          }

          const extension = _.get(scope, `args.row.${type}.config`) || {};
          scope.options = _.merge({}, opts, extension);
        }

        function fetchWidgetData(options) {
          const loaderCanceler = AdpWidgetsService.delayLoader(scope);
          return AdpWidgetsService.fetchWidgetData(scope.args, options)
            .then((loadedData) => {
              const { messages, data } = loadedData;
              if (!data) {
                return;
              }
              const { _clickValues, _mappedFields } = data;
              if (messages) {
                setOptions();
              }
              scope.messages = messages;
              scope.data = data;
              scope.clickValues = _clickValues;
              scope.mappedFields = _mappedFields;
            })
            .finally(loaderCanceler);
        }
      },
    };
  }
})();
;(function () {
  angular.module('app.adpGlobe').controller('AdpWidgetGlobeController', AdpWidgetGlobeController);

  /** @ngInject */
  function AdpWidgetGlobeController(
    $scope,
    $element,
    $rootScope,
    $timeout,
    AdpWidgetsService,
    AdpGlobeService,
    AdpGlobeArTopFrame,
    AdpGlobe3d,
    AdpGlobeVr
  ) {
    const vm = this;
    const layersFilters = {};

    vm.$onInit = function () {
      const { args, interface: editInterface } = $scope;
      const widgetId = args.row._id;
      const options = {};

      initVisualizationLogic(args, options).then(({ globe, layers, callbacks }) => {
        const destroyCb = () => {
          callbacks.onDestroy && callbacks.onDestroy();
          _.each(layers, (l) => _.isFunction(l.onDestroy) && l.onDestroy());
        }
        $element.on('$destroy', destroyCb);
        $scope.$on('widgetTileResize', _callIfFunction(callbacks.doResize));

        AdpWidgetsService.handleControlLinkChange({
          scope: $scope,
          widgetId,
          onLinkChange,
          onSelectLinkChange: updateLayerParameters,
        });
        loadInitialLayersData($scope);

        const onDatasetUpdate = (changedDataLayers) =>
          _.each(changedDataLayers, (dataLayerId) => relo({ dataLayerId, ...layersFilters[dataLayerId] }));
        AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
        AdpWidgetsService.touchLinksControlledByWidget(widgetId, editInterface);

        function onLinkChange(event) {
          const { dxFilter, virtualFilters, dataLayerId } = event;
          layersFilters[dataLayerId] = { filter: dxFilter, virtualFilters };

          return reloadData({ dataLayerId, ...layersFilters[dataLayerId] });
        }

        function reloadData(options = {}) {
          return AdpWidgetsService.fetchWidgetData(args, options).then(({ data, messages }) => {
            const { dataLayerId } = options;
            vm.errorMessage = messages ? messages.join('</br>') : '';
            updateLayerData({ dataLayerId, data });
          });
        }

        function updateLayerData(payload) {
          if (callbacks.updateLayerData) {
            return callbacks.updateLayerData(payload)
          }
          const { dataLayerId, data } = payload;
          const layer = _getLayerById(dataLayerId);
          return layer && AdpGlobeService.updateLayerData({ layer, data, globe, args });
        }

        function updateLayerParameters(payload) {
          if (callbacks.updateLayerParameters) {
            return callbacks.updateLayerParameters(payload);
          }

          const { dataLayerId, selectionFilters } = payload;
          const layer = _getLayerById(dataLayerId);
          if (layer) {
            let opacity = _.get(selectionFilters, ['_layerOpacity', 1], 100);
            opacity = Math.max(0, Math.min(opacity, 100)) / 100;
            AdpGlobeService.layerOpacity({ layer, opacity, globe, args });
            AdpGlobeService.updateLayerParameters({ layer, selection: selectionFilters, globe, args });
          }
        }

        function loadInitialLayersData($scope) {
          const { args, interface: editInterface } = $scope;
          const linksInterface = AdpWidgetsService.getControlLinksInterface(editInterface);
          const widgetId = _.get(args, 'row._id');
          const layers = _.get(args, 'row.globe.layers', []).filter((layer) => !layer.disabled);

          _.each(layers, (layer) => {
            const isLayerControlled = linksInterface && linksInterface.isWidgetControlled(widgetId, layer._id);
            if (!isLayerControlled) {
              const { _id: dataLayerId, type } = layer;
              if (type === 'texture' && layer.texture.texture !== 'customFromDataset') {
                return;
              }
              reloadData({ dataLayerId });
            }
          });
        }

        function _getLayerById(id) {
          return _.find(layers, (layer) => layer._id === id);
        }
      });
    };

    function _callIfFunction(cb) {
      return () => _.isFunction(cb) && cb();
    }

    function initVisualizationLogic(args, options) {
      const modules = {
        ar: AdpGlobeArTopFrame,
        vr: AdpGlobeVr,
        '3d': AdpGlobe3d,
      };
      const module = modules[$scope.widgetType] || modules['3d'];

      return new Promise((resolve) => {
        $timeout(() => {
          module({
            $element,
            $scope,
            $rootScope,
            args,
            options,
          }).then(resolve);
        });
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGlobe')
    .directive('adpWidgetGlobe', widget);

  /** @ngInject */
  function widget(AdpCustomCss, $compile, AdpWidgetsService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        args: '<',
      },
      link: function(scope, element) {
        const widgetRow = _.get(scope, 'args.row') || {};
        const { _id } = widgetRow;
        const widgetType = _.get(widgetRow,'globe.visualisationType');
        scope.widgetType = widgetType;
        const template = `<adp-globe-${widgetType}/>`;
        const $res = $compile(template)(scope);
        const widgetCss = _.get(widgetRow, 'advanced.widgetCss');
        const removeCssHandler = AdpCustomCss.setStyleElement(widgetCss, _id, $res);
        element.on('$destroy', removeCssHandler);
        element
          .empty()
          .append($res)
          .removeClass()
          .addClass('adp-widget-container adp-widget-globe adp-widget-globe-' + widgetType);
      }
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpGradientService', AdpGradientService);

  /** @ngInject */
  function AdpGradientService() {
    function mapValue(gradient, value, min = 0, max = 100) {
      const type = _.get(gradient, 'type');
      const steps = _.get(gradient, 'steps', []);

      if (!steps.length) {
        return 'black';
      }

      const val = (value - min) / (max - min);
      let step = 0;

      while (step < steps.length) {
        const pos = _.get(steps, [step, 'position'], 0) / 100;
        if (val <= pos) {
          break;
        }
        step++;
      }

      if (step >= steps.length) {
        const lastColor = toString(_.last(steps));
        if (value <= max) {
          return lastColor;
        }
        return gradient.colorAbove || lastColor;
      }

      if (!step) {
        const firstColor = toString(steps[0]);
        if (value >= min) {
          return firstColor;
        }
        return gradient.colorBelow || firstColor;
      }

      if (type === 'discrete') {
        return toString(steps[step]);
      }

      const { r: r1, g: g1, b: b1, position: p1 } = steps[step - 1];
      const { r: r2, g: g2, b: b2, position: p2 } = steps[step];
      const coof = (val * 100 - p1) / (p2 - p1);

      return toString({
        r: r1 + Math.round((r2 - r1) * coof),
        g: g1 + Math.round((g2 - g1) * coof),
        b: b1 + Math.round((b2 - b1) * coof),
      });

      function toString({ r, g, b }) {
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      }
    }

    function getGradientHtml(gradientRow) {
      const { type } = gradientRow;
      let prevPosition;
      const steps = _.map(gradientRow.steps, (step, i) => {
        let r = type === 'discrete' && i ? `,${step.color} ${prevPosition + 0.01}%` : ``;
        r += `,${step.color} ${step.position}%`;
        prevPosition = step.position;
        return r;
      });

      return `<div class="adp-gradient-strip" style="background-image:linear-gradient(to right${steps.join(
        ' '
      )})"></div>`;
    }

    return {
      mapValue,
      getGradientHtml,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletLayersService', AdpLeafletLayersService);

  /** @ngInject */
  function AdpLeafletLayersService(
    AdpWidgetsService,
    AdpLeafletLayersHelper,
    AdpLeafletTilesLayer,
    AdpLeafletCirclesLayer,
    AdpLeafletMarkersLayer,
    AdpLeafletImagesLayer,
    AdpLeafletChoroplethLayer,
    AdpLeafletHeatmapLayer
  ) {
    const layerModules = {
      tiles: AdpLeafletTilesLayer,
      circles: AdpLeafletCirclesLayer,
      markers: AdpLeafletMarkersLayer,
      images: AdpLeafletImagesLayer,
      choropleth: AdpLeafletChoroplethLayer,
      heatmap: AdpLeafletHeatmapLayer,
    };

    const clickHandlers = {
      common: _layerCommonClickHandler,
      tiles: _tilesClickHandler,
    };

    function createLayers(scope, infoMessagesLayer) {
      const row = _.get(scope.args, 'row', {});
      const widgetId = row._id;
      const layers = _.get(row, 'leafletMap.layers', []);
      const activeLayers = _.filter(layers, (layer) => !layer.disabled);

      return _.map(activeLayers, (layerRow, index) => {
        const { _id, type, name, opacity, wsUpdate, show, ...rowData } = layerRow;
        const { dataset, layerControlLinks, ...typedRowData } = rowData[type];
        const row = _.clone(typedRowData);
        const sliders = _.get(row, 'sliders', []);
        const datasetId = _.get(dataset, '_id');
        const doControlLinks = sliders.length > 0;
        const layer = {
          _id,
          type,
          row,
          index,
          name,
          datasetId,
          opacity: opacity / 100,
          show,
          wsUpdate,
          doControlLinks,
          cache: {},
          spin: infoMessagesLayer.getSpinHandler(_id),
        };

        if (doControlLinks) {
          layer.selection = {};
          layer.updateControlledValues = (e) => {
            e && window.Leaflet.DomEvent.stopPropagation(e);
            const selectedValues = _.uniq(_.values(layer.selection));
            AdpWidgetsService.sendValuesToControlled(selectedValues, sliders, widgetId, scope.interface);
          };
        }

        return layer;
      });
    }

    function prepareLayerContainers(map, layers) {
      const overlayPaneContainer = map.getPane('overlayPane');

      _.each(layers, (layer, index) => {
        const { type } = layer;
        const layerPaneName = `pane${index}${type}`;

        if (type === 'markers' || type === 'images') {
          // TODO: Shadow pane is used only for "spider-web-legs" of clustering.
          // Shadows are part of icons, currently, therefore not on shadowPane (which is generally wrong)
          const shadowPaneName = layerPaneName + '-shadow';
          map.createPane(shadowPaneName, overlayPaneContainer);
          layer.paneShadowName = shadowPaneName;
        }

        map.createPane(layerPaneName, overlayPaneContainer);
        layer.paneName = layerPaneName;
        layer.container = Leaflet.layerGroup();
        layer.map = map;
      });
    }

    function refreshLayer(layer, data, args) {
      const { type, instance } = layer;
      const refreshFn = getLayerMethod(type, 'refresh');
      const recreationNeeded = !instance || !refreshFn;

      if (recreationNeeded) {
        const createFn = getLayerMethod(type, 'create');
        const instance = createFn && createFn(layer, data, args);

        if (instance) {
          layer.container.clearLayers();
          layer.instance = instance;
          layer.container.addLayer(layer.instance);
        } else {
          console.error('Failing to create instance.', type);
        }

        return;
      }

      refreshFn(layer, data, args);
    }

    function setLayerOpacity(layer, opacity) {
      const { type } = layer;
      layer.opacity = opacity;

      const opacityFn = getLayerMethod(type, 'setOpacity');
      opacityFn && opacityFn(layer);
    }

    function getLayerMethod(type, methodName) {
      const layerModule = layerModules[type];

      return layerModule && layerModule[methodName];
    }

    function addLayersToMap(map, layers) {
      // Base layers are vanished as it was decided https://rocketchat.craftus.com/direct/QwiDpzknJMSHHKT5WZwrsY9WsE5gcB8TDY?msg=WaPZig5eixpyyay5f
      // to let user full control over layers order

      const baseLayers = []; //_.filter(layers, layer => layer.type === 'tiles');
      const overlayLayers = layers;
      // const overlayLayers = _.filter(layers, layer => layer.type !== 'tiles');
      // const firstBaseLayer = _.find(baseLayers, layer => layer.show);
      //
      // if (firstBaseLayer) {
      //   map.addLayer(firstBaseLayer.container);
      // }

      _.each(overlayLayers, (layer) => {
        layer.show && map.addLayer(layer.container);
      });

      return [baseLayers, overlayLayers];
    }

    function createLayerControl(layers, allowOpacitySliders) {
      // Only overlay layers are supported due baseLayers are not used by widget design concept.
      const overlayLayers = {};
      const onOpacityChangeHandlers = {};
      const initialOpacity = {};
      _.chain(layers)
        .toPairs()
        .reverse()
        .value()
        .forEach(([, layer]) => {
          overlayLayers[layer.name] = layer.container;
          onOpacityChangeHandlers[layer.name] = (opacity) => setLayerOpacity(layer, opacity);
          initialOpacity[layer.name] = layer.opacity;
        });

      if (allowOpacitySliders) {
        // Passing opacity handlers within options makes code of extended leaflet control minimal.
        return new Leaflet.Control.AdpLayersWithOpacity({}, overlayLayers, { onOpacityChangeHandlers, initialOpacity });
      }

      return Leaflet.control.layers({}, overlayLayers);
    }

    function updateLayerControlledLink(layer, payload, args) {
      const { type, doControlLinks } = layer;
      if (!doControlLinks) {
        return;
      }
      const layerFn = getLayerMethod(type, 'updateControlledLink');
      layerFn && layerFn({ layer, payload, args });
    }

    function createInformationLayer() {
      return new Leaflet.AdpInformationOverlay();
    }

    function setLayerMessages(layer, infoMessagesLayer, messages) {
      const { _id } = layer;
      infoMessagesLayer.setMessage(_id, messages);
    }

    function isLayerControlled(layer, widgetId, editInterface) {
      const linksInterface = AdpWidgetsService.getControlLinksInterface(editInterface);
      if (!linksInterface) {
        return false;
      }

      return linksInterface.isWidgetControlled(widgetId, layer._id);
    }

    function onLayerClick({ e, layer, map, scope }) {
      const { type } = layer;
      const handler = clickHandlers[type] || clickHandlers.common;
      return handler({ e, layer, map, scope });
    }

    function _layerCommonClickHandler({ layer }) {
      if (layer.doControlLinks) {
        layer.selection = {};
        AdpLeafletLayersHelper.deselectAll(layer);
        layer.updateControlledValues();
      }
    }

    function _tilesClickHandler({ e, map, layer, scope }) {
      if (!layer.doControlLinks) {
        return;
      }

      const { lat, lng: lngRaw } = map.mouseEventToLatLng(e.originalEvent);
      const lng = _normilizeLongitude(lngRaw);
      const args = scope.args;
      const widgetId = _.get(args, 'row._id');
      const { sliders } = layer.row;

      _.each(sliders, (slider) => {
        const { nearLimit: near, farLimit: far, rangeUnits } = slider;

        const filter = [
          'geoNear',
          {
            near: unitsToMeters(near, rangeUnits),
            far: unitsToMeters(far, rangeUnits),
            lng,
            lat,
          },
        ];
        AdpWidgetsService.sendControlledLinksChangeEvents(filter, slider.linkIds, widgetId, scope.interface);
      });
    }

    function unitsToMeters(x, u) {
      if (u === 'km') {
        return x * 1000;
      }
      if (u === 'mi') {
        return x * 1609.34;
      }
      return x;
    }

    function _normilizeLongitude(_lng) {
      let lng = _lng;
      while (lng > 180) {
        lng -= 360;
      }
      while (lng < -180) {
        lng += 360;
      }
      return lng;
    }

    return {
      createLayers,
      prepareLayerContainers,
      createLayerControl,
      isLayerControlled,
      addLayersToMap,
      refreshLayer,
      setLayerOpacity,
      updateLayerControlledLink,
      createInformationLayer,
      setLayerMessages,
      onLayerClick,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetLeafletMap', widget);

  /** @ngInject */
  function widget(
    APP_CONFIG,
    $timeout,
    AdpClientCommonHelper,
    AdpWidgetsService,
    AdpLeafletLayersService,
    AdpGeoLocationService,
    ErrorHelpers
  ) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      template: '<div class="adp-leaflet-map-container"></div>',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const args = scope.args;
      const widgetId = args.row._id;
      const isLeafletLibAvailable = () => typeof window.Leaflet !== 'undefined';
      const invalidateSize = _.debounce(() => map.invalidateSize(), 200);
      const lastLayerFilterStore = {};
      let layers;
      let map;
      let controlLayer;
      let infoMessagesLayer;

      AdpWidgetsService.loadVendorCodeOnce(isLeafletLibAvailable, loadVendorCode, 'LeafletMapVendorCode')
        .then(() => {
          map = initMap(element, args);
        })
        .then(() => {
          setupDatasetUpdateHandle();
          AdpWidgetsService.touchLinksControlledByWidget(widgetId, scope.interface);

          scope.getFilterForDatalayer = (dataLayerId) => _.get(lastLayerFilterStore, [dataLayerId, 'filter']) || [];
          AdpWidgetsService.setWidgetScopeToTile(scope);
        })
        .catch((err) => ErrorHelpers.handleError(err, 'Leaflet map widget error'));

      function setupDatasetUpdateHandle() {
        AdpWidgetsService.handleDatasetUpdate({ args, $element: element, onDatasetUpdate });

        function onDatasetUpdate(involvedLayers) {
          _.each(layers, (layer) => {
            const isInvolved = _.indexOf(involvedLayers, layer._id) >= 0;
            if (isInvolved) {
              const dxFilter = lastLayerFilterStore[layer._id];
              refreshLayerData(layer, dxFilter);
            }
          });
        }
      }

      function initMap($element, args) {
        const L = window.Leaflet;
        if (!L) {
          return;
        }
        const widgetRow = _.get(args, 'row.leafletMap', {});
        const mongoFormatCenter = _.get(widgetRow, 'mapCenter.coordinates', [0, 0]);
        const leafletFormatCenter = _.reverse(mongoFormatCenter);
        const {
          mapZoom: zoom = 12,
          maxZoom = 20,
          minZoom = 1,
          allowLocationDetect,
          boundN,
          boundS,
          boundE,
          boundW,
        } = widgetRow;
        const mapOptions = {
          center: leafletFormatCenter,
          zoom,
          maxZoom,
          minZoom,
          worldCopyJump: true,
        };
        // ToDo: create schema validator to prevent user to configure initial map area out of bounds, if set
        if (!_.find([boundN, boundS, boundE, boundW], _.isNil)) {
          mapOptions.maxBounds = L.latLngBounds(L.latLng(boundS, boundW), L.latLng(boundN, boundE));
        }
        const mapOptionsWithControls = setControlLayersOptions(mapOptions, widgetRow);
        const $containerElement = $('.adp-leaflet-map-container', $element);
        const map = L.map($containerElement[0], mapOptionsWithControls);

        if (allowLocationDetect) {
          detectMapCenter(map);
        }

        infoMessagesLayer = AdpLeafletLayersService.createInformationLayer();
        infoMessagesLayer.setPosition('bottomright');
        infoMessagesLayer.addTo(map);

        layers = AdpLeafletLayersService.createLayers(scope, infoMessagesLayer);

        let anyControlledLayer = false;

        AdpLeafletLayersService.prepareLayerContainers(map, layers);

        _.each(layers, (layer) => {
          const isLayerControlled = AdpLeafletLayersService.isLayerControlled(layer, widgetId, scope.interface);
          if (!isLayerControlled) {
            refreshLayerData(layer);
          } else {
            anyControlledLayer = true;
          }
        });

        // Base layers are vanished as it was decided https://rocketchat.craftus.com/direct/QwiDpzknJMSHHKT5WZwrsY9WsE5gcB8TDY?msg=WaPZig5eixpyyay5f
        // to let user full control over layers order
        const [baseLayers, overlayLayers] = AdpLeafletLayersService.addLayersToMap(map, layers);

        setupControlLayers(map, overlayLayers, widgetRow);

        scope.$on('widgetTileResize', invalidateSize);

        const hasAnyControlledLinks = _.find(layers, (layer) => layer.doControlLinks);
        if (hasAnyControlledLinks) {
          map.on('click', (e) =>
            _.each(layers, (layer) => AdpLeafletLayersService.onLayerClick({ e, layer, map, scope }))
          );

          AdpWidgetsService.handleControlledLinksChange({ onLinkUpdate, widgetId, scope });
        }

        if (anyControlledLayer) {
          AdpWidgetsService.handleControlLinkChange({
            scope,
            widgetId,
            onLinkChange,
            onSelectLinkChange,
            handleThisWidgetEvents: true,
          });
        }

        $timeout(invalidateSize, 1000);

        return map;
      }

      function detectMapCenter(map) {
        AdpGeoLocationService.getLocation()
          .then(([lng, lat]) => map.panTo([lat, lng]))
          .catch(_.noop);
      }

      function onLinkUpdate(payload) {
        _.each(layers, (layer) => AdpLeafletLayersService.updateLayerControlledLink(layer, payload, args));
      }

      function setControlLayersOptions(options, row) {
        const { controlLayersConfiguration = {} } = row;
        const { showZoomControl, showAttributionControl } = controlLayersConfiguration;

        if (!showZoomControl) {
          options.zoomControl = false;
        }

        if (!showAttributionControl) {
          options.attributionControl = false;
        }

        return options;
      }

      function setupControlLayers(map, overlayLayers, row) {
        const { controlLayersConfiguration = {} } = row;
        const {
          showZoomControl,
          zoomControlPosition,
          showLayerControl,
          layerControlPosition,
          allowOpacitySliders,
          showScaleControl,
          scaleControlPosition,
          showAttributionControl,
          attributionControlPosition,
          attributionText,
        } = controlLayersConfiguration;

        if (showAttributionControl) {
          map.attributionControl.setPosition(attributionControlPosition || 'bottomright');
          if (attributionText) {
            map.attributionControl.setPrefix(attributionText);
          }
        }

        if (showScaleControl) {
          L.control.scale({ position: scaleControlPosition || 'bottomleft' }).addTo(map);
        }

        if (showLayerControl) {
          controlLayer = AdpLeafletLayersService.createLayerControl(overlayLayers, allowOpacitySliders);
          controlLayer.addTo(map);
          controlLayer.setPosition(layerControlPosition || 'topright');
        }

        if (showZoomControl) {
          map.zoomControl.setPosition(zoomControlPosition || 'topleft');
        }
      }

      function loadVendorCode() {
        const jsUrl = APP_CONFIG.resourceUrl + '/public/js/lib/leafletjs/index.js';
        const cssUrl = APP_CONFIG.resourceUrl + '/public/js/lib/leafletjs/css/style.css';
        return Promise.all([AdpClientCommonHelper.loadScript(jsUrl), AdpClientCommonHelper.loadCss(cssUrl)]);
      }

      function onLinkChange(event) {
        const { dataLayerId } = event;
        const layer = _getLayerById(dataLayerId);

        if (!layer) {
          return;
        }

        const { dxFilter, virtualFilters } = event;
        lastLayerFilterStore[layer._id] = { filter: dxFilter, virtualFilters };

        return refreshLayerData(layer, lastLayerFilterStore[layer._id]);
      }

      function onSelectLinkChange(payload) {
        const { dataLayerId, selectionFilters, changedParamName } = payload;
        const layer = _getLayerById(dataLayerId);
        if (layer) {
          if (changedParamName === '_layerOpacity') {
            let opacity = _.get(selectionFilters, [changedParamName, 1], 100);
            opacity = Math.max(0, Math.min(opacity, 100)) / 100;

            if (controlLayer) {
              controlLayer._setLayerOpacity(layer, opacity);
            }
            return AdpLeafletLayersService.setLayerOpacity(layer, opacity);
          }
        }
      }

      function _getLayerById(id) {
        return _.find(layers, (layer) => layer._id === id);
      }

      function refreshLayerData(layer, options) {
        if (layer.datasetId) {
          const layerIdPart = { dataLayerId: layer._id };

          layer.spin(true);
          return AdpWidgetsService.fetchWidgetData(args, { ...options, ...layerIdPart })
            .then((data) => refreshLayer(layer, data))
            .finally(() => layer.spin(false));
        } else {
          refreshLayer(layer, {});
        }
      }

      function refreshLayer(layer, loadedData) {
        const { data, messages } = loadedData;
        AdpLeafletLayersService.setLayerMessages(layer, infoMessagesLayer, messages);
        AdpLeafletLayersService.refreshLayer(layer, data, args);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetScheduler', adpWidgetScheduler);

  /** @ngInject */
  function adpWidgetScheduler(AdpWidgetsService, AdpWidgetsTooltipService) {
    return {
      restrict: 'E',
      template: `
        <div class="adp-widget-container">
          <div class="adp-widget-scheduler"></div>
          <div class="adp-widget-scheduler-deselect-button btn btn-primary btn-sm" ng-click="onDeselectClick()"><i class="fa fa-ban"></i></div>
          <div class="adp-widget-container-error-message well-background" ng-show="errorMessage" ng-bind-html="errorMessage"></div>
          <adp-page-loader loading="isLoading"></adp-page-loader>
        </div>`,
      scope: {
        interface: '<',
        args: '<',
      },
      link: function (scope, $element) {
        const { args } = scope;
        let lastFilter = [];

        (function init() {
          const options = createInitialOptions(args);
          const {
            row: { _id },
          } = args;
          const isControlled = AdpWidgetsService.isWidgetControlled(_id, scope.interface);

          if (isControlled) {
            enabledControlling(options);
          } else {
            options.dataSource = createDataSource(_id, args);
          }

          enableWidgetAsControl(_id, options);
          handleDatasetUpdates(_id);

          _.defer(() => {
            $element.find('.adp-widget-scheduler').dxScheduler(options);
          });
        })();

        function handleDatasetUpdates(widgetId) {
          const onDatasetUpdate = reloadWidget;
          AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
          AdpWidgetsService.touchLinksControlledByWidget(widgetId, scope.interface);
        }

        function enabledControlling() {
          const {
            row: { _id },
          } = args;

          const onLinkChange = ({ dxFilter, virtualFilters }) => {
            lastFilter = { dxFilter, virtualFilters };
            return reloadWidget();
          };
          AdpWidgetsService.handleControlLinkChange({ scope, widgetId: _id, onLinkChange });
        }

        function createInitialOptions(args) {
          const { widgetConfiguration } = args;
          const options = _.cloneDeep(widgetConfiguration);
          setTemplates(options);
          disableFormOpen(options);
          applyJsonExtend(args, options);

          return options;
        }

        function createDataSource() {
          return new DevExpress.data.CustomStore({
            load() {
              const widgetInstance = getWidgetInstance();
              const startDate = widgetInstance.getStartViewDate();
              const endDate = widgetInstance.getEndViewDate();

              const paginationFilter = getPaginationFilter(startDate, endDate);
              const { dxFilter: parameterFilters, virtualFilters } = lastFilter;
              let filter = _.isEmpty(parameterFilters) ? paginationFilter : [paginationFilter, 'and', parameterFilters];

              const loadOptions = {
                filter,
                virtualFilters,
              };
              const loaderCanceler = AdpWidgetsService.delayLoader(scope);

              return AdpWidgetsService.fetchWidgetData(args, loadOptions)
                .then((resp) => {
                  const { messages } = resp;
                  scope.errorMessage = messages ? messages.join('</br>') : null;
                  return resp;
                })
                .finally(loaderCanceler);
            },
            onLoaded(result) {
              refreshTemplates(result?.data);
            },
          });
        }

        function getPaginationFilter(startDate, endDate) {
          const { startDateField, endDateField } = _.get(scope, 'args.row.scheduler.bindings');

          return [
            [[endDateField, '>=', startDate], 'and', [startDateField, '<', endDate]],
            'or',
            [[endDateField, '=', endDate], 'and', [startDateField, '=', endDate]],
          ];
        }

        function reloadWidget() {
          const widgetInstance = getWidgetInstance();
          let ds = widgetInstance.getDataSource();

          if (!ds) {
            const {
              row: { _id },
            } = args;
            widgetInstance.option('dataSource', createDataSource(_id, args));
            ds = widgetInstance.getDataSource();
          }

          return ds.reload();
        }

        function getWidgetInstance() {
          return $element.find('.adp-widget-scheduler').dxScheduler('instance');
        }

        function setTemplates(options, dataRows = []) {
          const paths = {
            dataCellTemplate: 'row.scheduler.dataCellConfig.templateText',
            appointmentTemplate: 'row.scheduler.appointmentConfig.templateText',
            appointmentTooltipTemplate: 'row.scheduler.tooltipConfig.templateText',
          };

          _.forEach(paths, (path, optionName) => {
            const tplFn = AdpWidgetsTooltipService.getTooltipFunction({
              args,
              path,
              memoizeKeyGetter: (item) => `${item.startDate}_${item.text}`,
              mappedFieldGetter: (item) => _.get(item, '_mappedFields') || {},
            });

            if (!tplFn) {
              return;
            }

            options[optionName] = function (item, index, container) {
              const { appointmentData } = item;
              const rows = dataRows;
              const templateContext = { container, rows, index };
              const tpl = tplFn(appointmentData || item, templateContext);
              container.append(tpl);
            };
          });
        }

        function refreshTemplates(dataRows) {
          const optionsObj = {};
          const instance = getWidgetInstance();
          setTemplates(optionsObj, dataRows);
          instance.option(optionsObj);
          instance.repaint();
        }

        function disableFormOpen(options) {
          options.onAppointmentFormOpening = (e) => {
            e.cancel = true;
          };
        }

        function applyJsonExtend(args, options) {
          const extender = _.get(args, `row.scheduler.config`);

          if (!_.isEmpty(extender)) {
            return _.merge(options, extender);
          }
        }

        function enableWidgetAsControl(widgetId, options) {
          const sliders = AdpWidgetsService.getSlidersOfWidget(args, scope.interface);
          const linkIdControlledByDates = AdpWidgetsService.getSlidersOfWidget(
            args,
            scope.interface,
            'dateRangeControlSlider.linkIds'
          );

          if (!_.isEmpty(sliders)) {
            options.onAppointmentClick = function ({ appointmentData: { _clickValues } }) {
              AdpWidgetsService.sendValuesToControlled([_clickValues], sliders, widgetId, scope.interface);
            };
          }

          if (!_.isEmpty(linkIdControlledByDates)) {
            options.onOptionChanged = _.debounce((e) => {
              if (e.name !== 'selectedCellData') {
                return;
              }

              const filter = selectedRangeToFilter(e.value);
              toggleDeselectButton(!_.isEmpty(filter));
              AdpWidgetsService.sendControlledLinksChangeEvents(
                filter,
                linkIdControlledByDates,
                widgetId,
                scope.interface
              );
            });

            scope.onDeselectClick = onDeselectClick;

            function toggleDeselectButton(activate) {
              $('.adp-widget-scheduler-deselect-button', $element).toggle(activate);
            }

            function onDeselectClick() {
              toggleDeselectButton(false);
              AdpWidgetsService.sendControlledLinksChangeEvents(
                ['empty'],
                linkIdControlledByDates,
                widgetId,
                scope.interface
              );
            }
          }
        }

        function selectedRangeToFilter(cellData) {
          const ranges = [];
          let currentStart;
          let currentEnd;
          _.each(cellData, ({ startDate, endDate }) => {
            if (currentEnd && startDate.getTime() === currentEnd.getTime()) {
              // Next cell can be included into current range
              currentEnd = endDate;
            } else {
              if (currentStart) {
                ranges.push(['between', currentStart, endDate]);
              }
              currentStart = startDate;
              currentEnd = endDate;
            }
          });

          if (currentStart) {
            ranges.push(['between', currentStart, currentEnd]);
          }

          if (_.isEmpty(ranges)) {
            return;
          }

          if (ranges.length === 1) {
            return ranges[0];
          }

          return ['combine', ...ranges];
        }
      },
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetSparkline', widget);

  /** @ngInject */
  function widget(APP_CONFIG, AdpClientCommonHelper, AdpWidgetsService, ErrorHelpers) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/sparkline/sparkline-widget.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const isVendorCodeAvailable = () => jQuery && jQuery.fn.sparkline;

      AdpWidgetsService.loadVendorCodeOnce(isVendorCodeAvailable, loadVendorCode, 'SparklineVendorCode')
        .then(() => initWidget($element, scope))
        .catch((err) => ErrorHelpers.handleError(err, 'Sparkline widget error'));
    }

    function loadVendorCode() {
      const jsUrl = APP_CONFIG.resourceUrl + '/public/js/lib/sparkline/index.js';
      return AdpClientCommonHelper.loadScript(jsUrl);
    }

    function initWidget($element, scope) {
      const $frame = $('.adp-sparkline-frame', $element);
      const args = scope.args;
      const sliders = AdpWidgetsService.getSlidersOfWidget(args, scope.interface);
      const renderSparkline = _.debounce(_renderSparkline, 100);
      let widgetOptions = {};
      let widgetData = [];
      let rawData = [];
      let lastFilter = {};

      $(window).on('resize', renderSparkline);
      scope.$on('widgetTileResize', renderSparkline);
      scope.$on('$destroy', () => $(window).off('resize', renderSparkline));
      scope.selectionClear = () => selectGraphPart(null);

      const widgetId = args.row._id;
      AdpWidgetsService.handleControlLinkChange({ scope, widgetId, onLinkChange });

      if (!AdpWidgetsService.isWidgetControlled(widgetId, scope.interface)) {
        loadWidgetData();
      }

      scope.getFilterForDatalayer = () => lastFilter.filter || [];
      AdpWidgetsService.setWidgetScopeToTile(scope);

      const onDatasetUpdate = () => loadWidgetData(lastFilter);
      AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
      AdpWidgetsService.touchLinksControlledByWidget(widgetId, scope.interface);

      function loadWidgetData(filter) {
        return AdpWidgetsService.fetchWidgetData(args, { filter }).then(({ messages, data }) => {
          if (messages) {
            scope.errorMessage = messages.join('</br>');
          } else {
            scope.errorMessage = '';
            widgetOptions = getWidgetOptions(args, data);
            widgetData = getWidgetData(args, data);
            rawData = data;

            renderSparkline();
          }
        });
      }

      function onLinkChange({ dxFilter, virtualFilters }) {
        lastFilter = { filter: dxFilter, virtualFilters };
        return loadWidgetData(dxFilter);
      }

      function _renderSparkline() {
        const $body = $('.adp-sparkline-body', $frame);
        const sparkType = widgetOptions.type;

        if (sparkType === 'pie') {
          const fitSize = Math.min($frame.width(), $frame.height());

          $body.css({ width: fitSize, height: fitSize });
        }

        if (sparkType === 'bar') {
          const bodyWidth = $body.width();
          const barCount = widgetData.length;
          widgetOptions.barSpacing = 5;
          widgetOptions.barWidth = barCount ? (bodyWidth - widgetOptions.barSpacing * (barCount - 1)) / barCount : 10;
        }

        $body.empty().sparkline(widgetData, widgetOptions);
        $body.off('sparklineClick').on('sparklineClick', onSparklineClick);
      }

      function onSparklineClick(ev) {
        if (sliders.length) {
          const sparkline = ev.sparklines[0];
          let region = sparkline.getCurrentRegionFields();
          if (_.isArray(region)) {
            region = region[0];
          }
          const dataIndex = _.get(region, 'offset');
          selectGraphPart(dataIndex);
        }
      }

      function selectGraphPart(index) {
        const clickValues = _.get(rawData, `${index}._clickValues`, []);
        AdpWidgetsService.sendValuesToControlled([clickValues], sliders, widgetId, scope.interface);
      }
    }

    function getWidgetOptions(args, data) {
      const formData = _.get(args, 'row.sparkline', {});
      const tooltipTmpl = _.trim(_.get(formData, `tooltipConfig.templateText`));
      const sparkType = formData.type;
      const userOptions = _.get(formData, 'mixedOptions', {});
      const widgetOptions = _.defaults(userOptions, {
        type: sparkType,
        width: '100%',
        height: '100%',
      });

      if (tooltipTmpl) {
        const oneOnly = (x) => (_.isArray(x) ? x[0] : x);
        const keyGetter = (spark, options, item) => item && oneOnly(item).offset;
        widgetOptions.tooltipFormatter = AdpWidgetsService.memoize((spark, options, _item) => {
          const item = oneOnly(_item);
          if (!item) {
            return '';
          }
          const mapped = _.get(data, [item.offset, '_mappedFields']);
          const tooltipContext = {
            mapped,
            row: item,
            params: options,
          };
          return AdpWidgetsService.getTooltipText(tooltipTmpl, tooltipContext);
        }, keyGetter);
      }

      if (sparkType === 'pie') {
        const hasColorField = _.get(args, 'row.sparkline.colorField');

        if (hasColorField) {
          widgetOptions.sliceColors = _.map(data, (row) => row.color || '#00000088'); // ToDo: add default color into user form
        }
      }

      return widgetOptions;
    }

    function getWidgetData(args, data) {
      return _.map(data, function (row) {
        return row.value;
      });
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpSplitWidgetContainer', widget);

  /** @ngInject */
  function widget($timeout, ObjectId, AdpWidgetsService, AdpWidgetContainerService, AdpWidgetActions) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
        tile: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/split-container/split-container.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const isEditMode = !!_.get(scope, 'interface.onBoardChange'); // need some better way to recognize editing mode
      const tiles = _.get(scope, 'tile.tiles');
      const { interface: editInterface } = scope;
      const containerTile = _.get(scope, 'tile');

      if (isEditMode && _.isEmpty(tiles)) {
        const _id = ObjectId();
        const firstTile = {
          data: { _id, offset: 0 },
          id: _id,
        };
        tiles.push(firstTile);
      }

      AdpWidgetContainerService.calculateRealOffsets(tiles);
      scope.tiles = tiles;
      scope.saveTiles = saveTiles;

      _.each(tiles, (tile) => {
        // ToDO: need to do smth with position
        tile.position = 'container.tile.' + (isEditMode ? 'edit' : 'view');
        tile.container = containerTile;
      });

      scope.$watch('tile.data.positionFixed', (value) => {
        scope.editMode = isEditMode && !value;
        _.each(tiles, (tile) => {
          tile._editMode = scope.editMode;
        });
      });
      scope.$watch('tile.tiles.length', () => {
        scope.rootTiles = _.filter(tiles, (t) => !t.data.parentId);
      });
      scope.$on('widgetTileResize', (e, payload) => AdpWidgetContainerService.passEventToTiles(e, payload, tiles));

      const linksInterface = AdpWidgetsService.getControlLinksInterface(editInterface);
      if (!linksInterface) {
        return;
      }
      resendAllTilesLinks(tiles, linksInterface);

      function saveTiles(editorTiles) {
        const widgetId = _.get(scope, 'args.row._id');

        return AdpWidgetActions.saveTiles({
          tiles: editorTiles,
          onSave: editInterface.onBoardChange,
          widgetId,
          widgetType: 'split',
        });
      }
    }

    function resendAllTilesLinks(tiles, linksInterface) {
      $timeout(
        () =>
          _.each(tiles, (tile) => {
            if (tile.tiles) {
              resendAllTilesLinks(tile.tiles, linksInterface);
            } else {
              const widgetId = _.get(tile, 'data.widget._id');
              widgetId && linksInterface.resendAllWidgetLinks(widgetId);
            }
          }),
        50
      );
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpSplitEditorBlock', widget);

  const EDITOR_BLOCK_CLASS_NAME = 'adp-split-editor-box';

  /** @ngInject */
  function widget($timeout, AdpWidgetsService, AdpWidgetContainerService, AdpWidgetActions) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        tile: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/split-container/split-editor-block.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const { tile, interface: editInterface } = scope;
      const tiles = _.get(tile, 'container.tiles');
      const { _isWrapper: isWrapper } = tile;

      if (isWrapper) {
        return;
      }

      const parentId = tile.data.parentId;
      const tilesOnLevel = AdpWidgetContainerService.getTilesOnLevel(tiles, parentId);
      const tileIndexOnLevel = _.findIndex(tilesOnLevel, tile);

      scope.hasWidget = !isWrapper && !!_.get(tile, 'data.widget');
      scope.isFirstOnLevel = !tileIndexOnLevel;
      scope.isLastOnLevel = tileIndexOnLevel === tilesOnLevel.length - 1;

      scope.$watch('tile.data.fix', () => {
        const tileFix = _.get(tile, 'data.fix') || 'free';
        scope.editorClass = {
          [`adp-split-fix-${tileFix}`]: 1,
          [`ec-${tile.id}`]: 1,
        };
      });

      if (scope.hasWidget) {
        $element.draggable({
          handle: '.swap-tile',
          helper: () => $('<div class="adp-split-drag-helper">Drop me at new place</div>'),
          cursorAt: { left: 75, top: 75 },
          containment: tile.container.$container,
          appendTo: tile.container.$container,
          scope: 'split',
        });
      }

      $element
        .droppable({
          accept: `.${EDITOR_BLOCK_CLASS_NAME}`,
          scope: 'split',
          drop: (_e, _ui) => {
            const thisTileId = tile.id;
            const classList = _.get(_ui, 'draggable[0].classList', []);
            const idClass = _.find(classList, (x) => _.startsWith(x, 'ec-')) || '';
            const dropTileId = idClass.substring(3);
            if (thisTileId === dropTileId) {
              return;
            }
            swapTiles(thisTileId, dropTileId);
          },
        })
        .on('dropover', (e) => e.stopPropagation()); // Required to stop gridstackjs unadequate reaction on this drag&drop

      scope.toggleBranchHover = (toggleOn) => {
        let curTile = tile;
        do {
          $(`.ec-${curTile.id}`).toggleClass('mouse-hover', toggleOn);
          curTile = AdpWidgetContainerService.getParentTile(tiles, curTile);
        } while (curTile);
      };

      scope.splitTile = (makeColumn) => {
        const newTileContainer = AdpWidgetContainerService.cloneEmptyTile(tile);
        const newEmptyTile = AdpWidgetContainerService.cloneEmptyTile(tile);
        const tileIndex = _.findIndex(tiles, tile);

        newTileContainer.data.isVertical = makeColumn;

        newEmptyTile.data.parentId = newTileContainer.id;
        newEmptyTile.data.fix = 'free';
        newEmptyTile.data.offset = 50;

        tile.data.parentId = newTileContainer.id;
        tile.data.offset = 0;
        tile.data.fix = 'free';

        tiles.splice(tileIndex, 1, newTileContainer, tile, newEmptyTile);
        tile.$scope && tile.$scope.$broadcast('widgetTileResize');

        syncTiles();
      };

      scope.editTile = () => {
        const context = {
          row: tile,
          customOptions: { widgetInterface: editInterface },
        };
        return AdpWidgetActions.editSubTile.call(context);
      };

      scope.removeTile = () => {
        AdpWidgetContainerService.removeTile(tiles, tile);

        syncTiles();
      };

      function swapTiles(id1, id2) {
        const tile1 = getTile(id1);
        const tile2 = getTile(id2);

        if (!tile1 || !tile2) {
          console.error('---- no tile found in swap');
        }
        const fieldsToKeep = ['parentId', 'offset', 'fix'];
        const tmp = _.pick(tile1.data, fieldsToKeep);
        _.assign(tile1.data, _.pick(tile2.data, fieldsToKeep));
        _.assign(tile2.data, tmp);

        syncTiles();
      }

      function addAndRedistributeTiles(parentId, addedTile) {
        const tilesOnLevel = AdpWidgetContainerService.getTilesOnLevel(tiles, parentId);
        const levelCount = tilesOnLevel.length;
        const newTileWidth = 100 / (levelCount + 1);
        const coefficient = 100 / (100 + newTileWidth);

        _.each(tilesOnLevel, (tile) => {
          tile.data.offset = tile.data.offset * coefficient;
        });

        tiles.push(addedTile);
        addedTile.data.offset = 100 - newTileWidth;
      }

      function syncTiles() {
        cascadeRemoveContainersWithOnlyOneChild();
        optimizeBranchesWithSameOrientation();

        setTimeout(() => {
          AdpWidgetContainerService.calculateRealOffsets(tiles);
          saveTiles(tiles);
        }, 50);

        function optimizeBranchesWithSameOrientation(parentId) {
          const parent = getTile(parentId);
          const isVertical = !!_.get(parent, 'data.isVertical');
          const tilesOnLevel = AdpWidgetContainerService.getTilesOnLevel(tiles, parentId);
          const hasFixed = !!_.find(tilesOnLevel, (t) => t.data.fix !== 'free');

          _.each(tilesOnLevel, (tile) => {
            const { id: tileId } = tile;
            optimizeBranchesWithSameOrientation(tileId);

            if (hasFixed || !!tile.data.isVertical !== isVertical) {
              return;
            }

            const subTiles = AdpWidgetContainerService.getTilesOnLevel(tiles, tileId);

            if (!subTiles.length) {
              return;
            }

            const nextTile = AdpWidgetContainerService.getNeighbourTile(tiles, tile);
            const nextOffset = _.get(nextTile, 'data.offset', 100);
            const startOffset = tile.data.offset;

            _.each(subTiles, (stile) => {
              stile.data.parentId = parentId;
              stile.data.offset = startOffset + (stile.data.offset * (nextOffset - startOffset)) / 100;
            });

            AdpWidgetContainerService.removeTileFromArray(tiles, tile);
          });
        }

        function cascadeRemoveContainersWithOnlyOneChild(parentId) {
          const tilesOnLevel = AdpWidgetContainerService.getTilesOnLevel(tiles, parentId);
          if (tilesOnLevel.length === 1 && parentId) {
            const parent = getTile(parentId);
            const lastTile = tilesOnLevel[0];
            lastTile.data.parentId = parent.data.parentId;
            lastTile.data.offset = parent.data.offset;
            lastTile.data.fix = parent.data.fix;
            AdpWidgetContainerService.removeTileFromArray(tiles, parent);
          } else {
            _.each(tilesOnLevel, (t) => cascadeRemoveContainersWithOnlyOneChild(t.id));
          }
        }
      }

      function saveTiles(tiles) {
        const widgetType = 'split';
        const widgetId = _.get(tile, 'container.widgetRow._id');
        AdpWidgetActions.saveTiles({ tiles, widgetType, widgetId });
      }

      function getTile(id) {
        return _.find(tiles, (t) => t.id === id);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpSplitEditorMoveEdge', widget);

  /** @ngInject */
  function widget($timeout, AdpWidgetsService, AdpWidgetContainerService, AdpWidgetActions) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        tile: '<',
        saveTiles: '&',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/split-container/split-editor-move-edge.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const { tile } = scope;
      const { _isVert: isVertical } = tile;
      const tiles = _.get(tile, 'container.tiles');
      const orientationPrefix = AdpWidgetContainerService.getOrientationPrefix(isVertical);

      scope.$watch('tile._style', () => {
        scope.style = getStyle();
        $element.toggleClass(`adp-split-absolute`, tile._isAbsFixer);
      });
      scope.onMouseEnter = (e) => onMoveMouseEnter(e);
      scope.toggleAbs = toggleAbs;

      $element.addClass(`adp-split-border-move-${orientationPrefix}`);

      function getStyle() {
        const top = tile._style.top;
        const left = tile._style.left;
        const style = {};

        if (!_.isNil(top)) {
          style.top = top;
        } else {
          style.bottom = tile._style.height;
        }
        if (!_.isNil(left)) {
          style.left = left;
        } else {
          style.right = tile._style.width;
        }

        if (isVertical) {
          style.width = `100%`;
        } else {
          style.height = `100%`;
        }

        return style;
      }

      function toggleAbs(event) {
        const isAltPressed = event.altKey;
        AdpWidgetContainerService.toggleTileAbsolute(tiles, tile, isAltPressed);
        saveTiles(tiles);
      }

      function onMoveMouseEnter(e) {
        const handler = $(e.currentTarget);
        // const prevTile = getNeighbourTile(tile, -1);
        const parent = AdpWidgetContainerService.getParentTile(tiles, tile);
        const $wrapper = parent ? parent.$container : $element;
        const wrapperW = $wrapper.innerWidth();
        const wrapperH = $wrapper.innerHeight();
        // const { left: boxLeft, top: boxTop } = $element.offset();
        const onMoveDragDebounced = _.throttle(onMoveDrag, 20);

        handler.draggable({
          axis: isVertical ? 'y' : 'x',
          //     containment,
          drag: (e, ui) => onMoveDragDebounced({ ui, wrapperW, wrapperH }),
          stop: (e, ui) => onMoveDragStop({ ui }),
        });
      }

      function onMoveDrag({ ui, wrapperW, wrapperH }) {
        const { position } = ui;
        const { data, _isAbsFixer } = tile;
        const { top, left } = position;

        if (data.fix === 'end') {
          data.offset = isVertical ? wrapperH - top : wrapperW - left;
        } else if (_isAbsFixer) {
          data.offset = isVertical ? top : left;
        } else {
          data.offset = isVertical ? (top * 100) / wrapperH : (left * 100) / wrapperW;
        }

        AdpWidgetContainerService.calculateRealOffsets(tiles);
      }

      function onMoveDragStop({ ui }) {
        const { fix } = tile.data;
        if (fix === 'end') {
          // Need to purge 'top(left)' attrs, since they overpowers bottom(right)
          $timeout(() => ui.helper.css({ left: 'auto', top: 'auto' }), 100);
        }
        saveTiles(tiles);
        tile.container.$scope.$broadcast('widgetTileResize');
      }

      function saveTiles(tiles) {
        const widgetType = 'split';
        const widgetId = _.get(tile, 'container.widgetRow._id');
        AdpWidgetActions.saveTiles({ tiles, widgetType, widgetId });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpSplitSubTile', directive);

  /** @ngInject */
  function directive($timeout) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: `client-modules/adp-widgets/widgets/split-container/split-subtile.directive.html`,
      link: (scope, $element) => {
        scope.t.$container = $element;
        // $timeout(() => (scope.t.$container = $element.children('.adp-absolute-fill')), 0);
      },
    };
  }
})();
;(function () {
  angular.module('app.adpWidgets').factory('AdpWidgetContainerService', AdpWidgetContainerService);

  /** @ngInject */
  function AdpWidgetContainerService($injector, $rootScope, $timeout, ObjectId, AdpSchemaService, AdpWidgetsService) {
    function getOrientationPrefix(isVertical) {
      return isVertical ? 'vertically' : 'horizontally';
    }

    function cloneEmptyTile(tile) {
      const newTile = _.pick(tile, ['position', 'board', '_editMode', 'container']);
      newTile.data = _.omit(tile.data, ['widget', 'title']);
      newTile.id = ObjectId();
      newTile.$scope = $rootScope.$new();

      return newTile;
    }

    function getTilesOnLevel(tiles, parentId) {
      return _.sortBy(
        _.filter(tiles, (t) => t.data.parentId === parentId),
        [
          (t) => (t.data.fix === 'start' ? -1 : t.data.fix === 'end' ? 1 : 0),
          (t) => (t.data.fix === 'end' ? 100000000 - t.data.offset : t.data.offset),
        ]
      );
    }

    function setTileWidget(tile) {
      const hasWidget = !!tile.data.widget;
      if (!hasWidget) {
        return;
      }
      return AdpWidgetsService.resetTileWidget(tile);
    }

    function calculateRealOffsets(tiles) {
      calculate(tiles);

      function calculate(tiles, tile) {
        const parentId = _.get(tile, 'id');
        const isVertical = !!_.get(tile, 'data.isVertical');
        const tilesOnLevel = getTilesOnLevel(tiles, parentId);
        if (tile) {
          tile.data._id = tile.id;
          if (tilesOnLevel.length) {
            tile._isWrapper = true;
            tile._subtree = tilesOnLevel;
          }
        }
        let levelMinSize = 0;

        const firstRightBoundTile = _.find(tilesOnLevel, (t) => t.data.fix === 'end');
        const rubberSpaceEnd = _.get(firstRightBoundTile, 'data.offset', 0);
        const isAbsFixer = isFixedLevel(tilesOnLevel);

        _.each(tilesOnLevel, (t, index) => {
          const offset = _.get(t, 'data.offset', 0);
          const fix = _.get(t, 'data.fix') || 'free';
          const nextTileOffset = _.get(tilesOnLevel, [index + 1, 'data', 'offset']);
          let style;
          let start, end, size;

          t._isVert = isVertical;
          t._moveBorder = index > 0;
          t._isAbsFixer = isAbsFixer;

          if (fix === 'end') {
            end = '0px';
            size = offset + 'px';
            levelMinSize += offset;
          } else {
            const nextPos = _.isNil(nextTileOffset) ? 100 : nextTileOffset;
            const tileSize = nextPos - offset;
            if (fix === 'start') {
              start = offset + 'px';
              size = tileSize + 'px';
              levelMinSize += tileSize;
            } else {
              if (isAbsFixer) {
                start = offset + 'px';
                end = rubberSpaceEnd + 'px';
              } else {
                start = offset + '%';
                size = tileSize + '%';
              }
            }
          }

          if (isVertical) {
            style = { left: 0, width: '100%' };
            if (start) {
              style.top = start;
            }
            if (end) {
              style.bottom = end;
            }
            if (size) {
              style.height = size;
            }
          } else {
            style = { top: 0, height: '100%' };
            if (start) {
              style.left = start;
            }
            if (end) {
              style.right = end;
            }
            if (size) {
              style.width = size;
            }
          }

          if (JSON.stringify(style) !== JSON.stringify(t._style)) {
            t._style = style;
          }

          calculate(tiles, t);
        });

        if (levelMinSize) {
          _.set(tile, `_style.${isVertical ? 'minHeight' : 'minWidth'}`, levelMinSize + 'px');
        }
      }
    }

    function passEventToTiles(e, payload, tiles) {
      _.each(tiles, (tile) => {
        const { $scope, tiles: subTiles } = tile;
        if ($scope) {
          $scope.$broadcast(e.name, payload);
        }
        if (subTiles) {
          passEventToTiles(e, payload, subTiles);
        }
      });
    }

    function toggleTileAbsolute(tiles, tile, preferEndFix) {
      const { arr, wrappersToRemove, rootToRestructure } = _getFlattenTilesSetWithSameDirection(tiles, tile);
      let clickedIndex = _.findIndex(arr, (x) => x.isClicked);
      const clickedCombination = arr[clickedIndex - 1].fix[0] + arr[clickedIndex].fix[0];

      // clickedCombination represents types of splitblocks, between the edge was clicked.
      // 'f' mean free, 'e' means fixed to end, 's' is fixed to right.
      // If combination is 'fe' or 'sf' - the only right action is to make fixed block free.
      // If combination is 'ff', we need to decide which block to fix, and we try fix both start and end blocks, whichever is possible.
      // However, which tryed first does matter in some scenarios. So we prefer to stick free block to the start by default, but if Alt key was pressed we prefer to stick to the end.
      if (clickedCombination === 'ff') {
        if (preferEndFix) {
          arr[clickedIndex].fix = 'end';
          if (!isConfigPossible(arr)) {
            arr[clickedIndex].fix = 'free';
            arr[clickedIndex - 1].fix = 'start';
          }
        } else {
          arr[clickedIndex - 1].fix = 'start';
          if (!isConfigPossible(arr)) {
            arr[clickedIndex - 1].fix = 'free';
            arr[clickedIndex].fix = 'end';
          }
        }
      } else {
        if (clickedCombination === 'fe') {
          arr[clickedIndex].fix = 'free';
        } else {
          arr[clickedIndex - 1].fix = 'free';
        }
      }

      const isPossible = isConfigPossible(arr);

      if (!isPossible) {
        console.error('It`s not possible to fix this border');
        return;
      }

      _restoreTilesFromFlat({ tiles, tile, rootToRestructure, arr, wrappersToRemove });

      function isConfigPossible(arr) {
        // The overall idea is: fixed blocks should stick to the edges only.
        // (e.g. fixed block cannot have free(rubber) block from both sides).
        // 'state word' is map of all block's types on the level and it should look like "sssfffeee" (/^s*f+e*$/)
        // Example of wrong state word is "sfsfe" ('s' block is surrounded by free blocks, eg 'fixed block not stuck to the edge)
        // stateWord 'ssseee' is also an illegal because we need at least one free block to compensate size changes of a parent block
        const stateWord = _.map(arr, (x) => x.fix[0]).join('');
        return stateWord.match(/^s*f+e*$/);
      }
    }

    function removeTile(tiles, tile) {
      const tileFix = _.get(tile, 'data.fix') || 'free';
      const isFixed = tileFix !== 'free';
      if (isFixed) {
        removeFixedTile();
      } else {
        removeAndRedistributeTiles();
      }
      tile.container.$scope.$broadcast('widgetTileResize');

      function removeAndRedistributeTiles() {
        const parent = getParentTile(tiles, tile);
        const parentId = _.get(parent, 'id');
        const tilesOnLevel = getTilesOnLevel(tiles, parentId);
        const isAbsFixer = isFixedLevel(tilesOnLevel);
        if (isAbsFixer) {
          console.warn('Unable to remove this tile because it has fixed neighbours');
          return;
        }

        const nextTile = getNeighbourTile(tiles, tile, 1);
        const nextOffs = _.get(nextTile, 'data.offset', 100);
        const tileWidth = nextOffs - tile.data.offset;
        const tileIndexOnLevel = _.findIndex(tilesOnLevel, tile);
        const coefficient = tileWidth < 100 ? 100 / (100 - tileWidth) : 0.5;

        _.each(
          tilesOnLevel,
          (tile, index) =>
            (tile.data.offset = (tile.data.offset - (index >= tileIndexOnLevel ? tileWidth : 0)) * coefficient)
        );

        removeTileFromArray(tiles, tile);
      }

      function removeFixedTile() {
        if (tile.data.fix === 'start') {
          const nextTile = getNeighbourTile(tiles, tile, 1);
          nextTile.data.offset = 0;
        }

        removeTileFromArray(tiles, tile);
        const { arr, wrappersToRemove, rootToRestructure } = _getFlattenTilesSetWithSameDirection(tiles, tile);
        _restoreTilesFromFlat({ tiles, tile, rootToRestructure, arr, wrappersToRemove });
      }
    }

    function _restoreTilesFromFlat({ tiles, tile, rootToRestructure, arr, wrappersToRemove }) {
      const parent = getParentTile(tiles, tile);
      const isVertical = !!_.get(parent, 'data.isVertical');
      const $container = _.get(rootToRestructure, '$container');
      const boxSize = isVertical ? $container.height() : $container.width();

      _generateFixedTileGroups(tiles, rootToRestructure, isVertical, 0, boxSize, arr);

      _.each(wrappersToRemove, (t) => tiles.splice(_.findIndex(tiles, t), 1));

      calculateRealOffsets(tiles);
    }

    function _generateFixedTileGroups(tiles, parent, isVertical, shiftPos, boxSize, arr) {
      // This function generates hierarchy of inset blocks from flat array of same-directional blocks, to follow the rule
      // 'Only 2 or 3 blocks on the level if any fixed are present'
      // (see comment on _getFlattenTilesSetWithSameDirection method for more details)
      const hasFixedStart = arr[0].fix === 'start';
      const hasFixedEnd = arr[arr.length - 1].fix === 'end';

      if (!hasFixedStart && !hasFixedEnd) {
        _.each(arr, (a) => {
          const { t, pos } = a;
          t.data.parentId = parent.id;
          t.data.fix = 'free';
          t.data.offset = Math.min(((pos - shiftPos) * 100) / boxSize, 99.5);
        });
      } else {
        const newWrapper = cloneEmptyTile(arr[0].t);
        newWrapper.data.isVertical = isVertical;
        tiles.push(newWrapper);
        let newSize = boxSize;

        if (hasFixedStart) {
          const a = arr.shift();
          const { t } = a;
          const width = arr[0].pos - shiftPos;
          t.data.parentId = parent.id;
          t.data.fix = 'start';
          t.data.offset = 0;
          newSize -= width;
        }
        if (hasFixedEnd) {
          const a = arr.pop();
          const { t, pos } = a;
          const blockSize = boxSize - (pos - shiftPos);
          t.data.parentId = parent.id;
          t.data.fix = 'end';
          t.data.offset = blockSize;
          newSize -= blockSize;
        }

        newWrapper.data.parentId = parent.id;
        newWrapper.data.fix = 'free';
        newWrapper.data.offset = arr[0].pos - shiftPos;
        newWrapper._isWrapper = true;

        _generateFixedTileGroups(tiles, newWrapper, isVertical, arr[0].pos, newSize, arr, newWrapper.$container);
      }
    }

    function _getFlattenTilesSetWithSameDirection(tiles, tile) {
      // By design split block may contain any number of free(rubber) sub-blocks.
      // However, block with fixed sub-blocks may contain only 2 or 3 sub-blocks:
      // free is a must to compensate resizing, and at one of 'start' or 'end' types, or both 'start' & 'end', is possible.
      // If split widget have several fixed block in a row, they are inserted in free block in the middle.
      // Example: lets assume we have row of 3fixed blocks fixed to start, that 1 free block and 1 last block fixed to the end.
      // So, the first level is [start, free, end] - three sub-blocks
      // Second level is sub-blocks of free block from first level: [start, free]
      // Third level is sub-block of previous free block and also has: [start, free]
      // Such a hierarchy let us relay all resizing on CSS only.
      // However, operating with such a hierarchy on config changes is a pain, so we flatten same-directional blocks before any changes.

      // This function creates a flat array of the blocks of same direction.
      // This array used only internally to operate with fixed blocks changes.
      let parent = getParentTile(tiles, tile);
      const isVertical = !!_.get(parent, 'data.isVertical');
      let prevParent = parent;
      let levelDir = isVertical;

      do {
        prevParent = getParentTile(tiles, parent);
        levelDir = !!_.get(prevParent, 'data.isVertical');
        if (!prevParent || levelDir !== isVertical) {
          break;
        }
        parent = prevParent;
      } while (true);

      const wrappersToRemove = [];
      const arr = getTilesSizedArr(parent);
      wrappersToRemove.shift(); // first parent should not be removed;

      return { arr, wrappersToRemove, rootToRestructure: parent };

      function getTilesSizedArr(startTile, startOffset = 0) {
        let $container = _.get(startTile, '$container');
        let curBoxSize = isVertical ? $container.height() : $container.width();
        const { fix = 'free' } = startTile.data;
        const subTiles = _.get(startTile, '_subtree', []);
        const isClicked = startTile === tile;
        if (!subTiles.length || !!startTile.data.isVertical !== !!isVertical) {
          return { t: startTile, fix, pos: startOffset, isClicked };
        } else {
          wrappersToRemove.push(startTile);
        }
        const fixedSubtiles = isFixedLevel(subTiles);
        const array = _.flatten(
          _.map(subTiles, (t) => {
            const hasSubTiles = _.get(t, '_subtree.length');
            const { offset = 0, fix = 'free' } = t.data;
            const pos = fixedSubtiles ? (fix === 'end' ? curBoxSize - offset : offset) : (curBoxSize * offset) / 100;
            if (!hasSubTiles) {
              return { t, fix, pos: pos + startOffset, isClicked: t === tile };
            } else {
              return getTilesSizedArr(t, pos + startOffset);
            }
          })
        );
        if (isClicked) {
          array[0].isClicked = true;
        }

        return array;
      }
    }

    function isFixedLevel(tiles) {
      const isStart = _.get(tiles, '0.data.fix') === 'start';
      if (isStart) {
        return true;
      }
      const last = _.last(tiles);
      if (!last) {
        return false;
      }
      return _.get(last, 'data.fix') === 'end';
    }

    function getParentTile(tiles, tile) {
      return _.find(tiles, (t) => t.id === tile.data.parentId);
    }

    function removeTileFromArray(tiles, tile) {
      tiles.splice(_.findIndex(tiles, tile), 1);
    }

    function getNeighbourTile(tiles, tile, direction = 1) {
      const parent = getParentTile(tiles, tile);
      const parentId = _.get(parent, 'id');
      const tilesOnLevel = getTilesOnLevel(tiles, parentId);
      const tileIndexOnLevel = _.findIndex(tilesOnLevel, tile);
      return tilesOnLevel[tileIndexOnLevel + direction];
    }

    return {
      calculateRealOffsets,
      setTileWidget,
      getParentTile,
      getNeighbourTile,
      removeTile,
      removeTileFromArray,
      passEventToTiles,
      getTilesOnLevel,
      cloneEmptyTile,
      getOrientationPrefix,
      toggleTileAbsolute,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetStaticHtml', adpWidgetStaticHtml);

  /** @ngInject */
  function adpWidgetStaticHtml($sce) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      template: `<div ng-bind-html="safeHtml" style="height:100%"></div>`,
      link(scope) {
        const content = _.get(scope, 'args.row.staticHtml.html') || '';
        scope.safeHtml = $sce.trustAsHtml(content);
      },
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpTabbedWidgetContainer', widget);

  /** @ngInject */
  function widget($timeout, $compile, $rootScope, AdpWidgetContainerService, AdpWidgetsService) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
        tile: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/tabbed-container/tabbed-container.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      let dxComponent;
      const args = scope.args;
      const isEditMode = !!_.get(scope, 'interface.onBoardChange'); // need some better way to recognize editing mode
      const tileRows = _.get(args, 'widgetConfiguration.tiles') || [];
      const alignTabs = _.get(args, 'row.tabbed.alignTabs');
      const activeRows = _.filter(tileRows, (row) => !_.get(row, 'tileRow.hidden'));
      const widgetTile = _.get(scope, 'tile');
      const { interface: editInterface } = scope;
      const { tiles } = widgetTile;
      const items = _.map(tiles, (tile) => ({
        title: tile.data.title,
        tile,
      }));
      const selectedIndex = _.findIndex(activeRows, (row) => _.get(row, 'tileRow.selected')) || 0;
      const itemTemplate = (tab, index, $container) => {
        const { tile } = tab;
        const { widgetRow } = tile;
        if (widgetRow.isForbidden) {
          return _createForbiddenTab($element, widgetRow.name);
        }
        // ToDO: need to do smth with position
        tile.position = 'container.tile.' + (isEditMode ? 'edit' : 'view');
        tile.container = widgetTile;
        tile.$container = $container;
        AdpWidgetContainerService.setTileWidget(tile);
      };
      const onContentReady = (e) => {
        const linksInterface = AdpWidgetsService.getControlLinksInterface(scope.interface);
        if (!linksInterface) {
          return;
        }
        _.each(tiles, (tile) => linksInterface.resendAllWidgetLinks(_.get(tile, 'widgetRow._id')));
        dxComponent = e.component;
        dxComponent.option('onContentReady', null);
      };
      const dxComponentOptions = {
        items,
        deferRendering: false,
        swipeEnabled: false,
        selectedIndex,
        itemTemplate,
        onContentReady,
      };
      let dxComponentName;
      if (alignTabs === 'hidden') {
        dxComponentName = 'dxMultiView';
        _.assign(dxComponentOptions, {
          swipeEnabled: false,
          animationEnabled: false,
        });
      } else {
        dxComponentName = 'dxTabPanel';
        const itemTitleTemplate = (tab, index, $container) => {
          const { title, tile } = tab;
          const bgColor = AdpWidgetsService.getStyleAttribute({ tile, path: 'background.color' });

          if (bgColor) {
            const bgOpacity = AdpWidgetsService.getStyleAttribute({
              tile,
              path: 'background.opacity',
              defaultValue: 100,
            });
            const backgroundColor = AdpWidgetsService.hexColorWithOpacity(bgColor, bgOpacity);
            $container.parent().css({ backgroundColor });
          }

          return title;
        };
        _.assign(dxComponentOptions, { itemTitleTemplate });
        if (alignTabs) {
          scope.classNames = `adp-tabbed-align-tabs-${alignTabs}`;
        }
      }

      $element[dxComponentName](dxComponentOptions);

      _createApiMethods();

      scope.$on('widgetTileResize', (e, payload) => AdpWidgetContainerService.passEventToTiles(e, payload, tiles));

      function _createForbiddenTab($element, message) {
        return `<div class='adp-widget-publish-error'>${message}</div>`;
      }

      function _createApiMethods() {
        const widgetId = _.get(scope, 'args.row._id');
        const apiMethodPath = `_adp.widget${widgetId}.activateTab`;
        _.set(window, apiMethodPath, _activateTab);
      }

      function _activateTab(tabIndex) {
        if (!dxComponent) {
          return;
        }
        const selection = items[tabIndex];
        dxComponent.option('selectedItem', selection);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetValue', widget);

  /** @ngInject */
  function widget(
    $http,
    APP_CONFIG,
    AdpClientCommonHelper,
    AdpNotificationService,
    AdpWidgetsService,
    AdpWidgetsEjs,
    $timeout,
    $sce
  ) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/value-widget/value-widget.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const args = scope.args;
      const widgetId = args.row._id;
      const isControlled = AdpWidgetsService.isWidgetControlled(widgetId, scope.interface);
      const widgetRow = _.get(args, 'row.value');
      const { label } = widgetRow;
      const layoutType = _.get(widgetRow, 'layout', 'one-line');
      const verticalAlign = _.get(widgetRow, 'verticalAlign');
      scope.vericalPosition = { top: 'valign-top', bottom: 'valign-bottom' }[verticalAlign];

      let lastFilter = {};

      scope.advancedTemplate = _.get(scope, 'args.row.value.advancedTemplate');
      if (!scope.advancedTemplate) {
        prepareSimpleTemplate();
      }
      scope.initialized = false;

      if (!isControlled) {
        loadWidgetData(widgetRow, {});
      } else {
        AdpWidgetsService.handleControlLinkChange({ scope, widgetId, onLinkChange });
      }

      scope.getFilterForDatalayer = () => lastFilter.filter || [];
      AdpWidgetsService.setWidgetScopeToTile(scope);

      const onDatasetUpdate = () => loadWidgetData(widgetRow, lastFilter);

      AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });

      function loadWidgetData(widgetRow, options) {
        const { dataset, valueField, aggregationCommand, expression } = widgetRow;
        const command = aggregationCommand === 'custom' ? expression : aggregationCommand;
        const fetchOptions = _.assign(
          {
            datasetId: dataset._id,
            fieldsOperations: { [valueField]: command },
          },
          options
        );
        const loaderCanceler = AdpWidgetsService.delayLoader(scope);

        return AdpWidgetsService.fetchWidgetData(scope.args, fetchOptions)
          .then((data) => {
            updateTemplate(data, fetchOptions);

            !scope.initialized &&
              $timeout(() => {
                scope.initialized = true;
              });
          })
          .finally(loaderCanceler);
      }

      function onLinkChange({ dxFilter, virtualFilters }) {
        lastFilter = { filter: dxFilter, virtualFilters };
        return loadWidgetData(widgetRow, lastFilter);
      }

      function updateTemplate(data, options) {
        const { valueField, digitsAfterComma, contentTemplate } = widgetRow;
        const value = _.get(data, valueField) || 0;

        if (scope.advancedTemplate) {
          const customActions = _.get(window.appModelHelpers, 'CustomActions') || {};
          const context = { row: data, data: value, customActions, ...options };
          const html = AdpWidgetsEjs.render({ template: contentTemplate, context });
          scope.safeHtml = $sce.trustAsHtml(html);
        } else {
          scope.value = roundResult(value, digitsAfterComma);
          scope.data = data;
        }
      }

      function prepareSimpleTemplate() {
        const css = {
          default: {
            fontSize: '100%',
          },
        };

        _.each(['value', 'label'], (name) => {
          css[name] = _.get(widgetRow, name + 'Style', {});
          css[name] = _.omitBy(css[name], _.isNull);

          if (css[name].fontSize) {
            css[name].fontSize += '%';
          }
        });

        scope.valueCss = _.defaults(css.value, css.default);
        scope.labelCss = _.defaults(css.label, css.value);
        scope.containerLayout = 'adp-vw-layout-' + layoutType;
        scope.label = label;
      }
      function roundResult(value, digits) {
        return _.isNil(digits) || !_.isNumber(value) ? value : value.toFixed(digits);
      }
    }
  }
})();
;(function () {
  angular
    .module('app.adpWidgets')
    .controller('AdpWidgetGraphVisualisationController', AdpWidgetGraphVisualisationController);

  /** @ngInject */
  function AdpWidgetGraphVisualisationController(
    $scope,
    $element,
    $rootScope,
    $interval,
    $timeout,
    $http,
    $sce,
    $document,
    AdpNotificationService,
    AdpClientCommonHelper,
    AdpForceGraphService,
    AdpFullscreenService,
    APP_CONFIG,
    AdpWidgetsService,
    ForceGraphLogic2d,
    ForceGraphLogic3d,
    ForceGraphLogicVr,
    ForceGraphArTopFrame
  ) {
    const vm = this;
    let lastFilteringMarker;
    let lastFilters = {};

    vm.$onInit = function () {
      const { args, interface: editInterface } = $scope;
      const linksInterface = AdpWidgetsService.getControlLinksInterface(editInterface);
      const widgetId = args.row._id;
      const skipInitialDataLoad = AdpWidgetsService.isWidgetControlled(widgetId, editInterface);
      const dagMode = _.get(args, 'row.vis3d.enableDagMode') && _.get(args, 'row.vis3d.dagModeLayout');
      let theme = _.get(args, 'row.vis3d.forceTheme');
      if (!theme) {
        const { skin } = window.forcedThemes || window.adpAppStore.appInterface();
        theme = skin === 'smart-style-5' ? 'dark' : 'light';
      }
      vm.theme = 'adp-fg-theme-' + theme;
      const templates = _.get(args, 'widgetConfiguration.templates', {});
      const options = { skipInitialDataLoad, dagMode, theme, templates };
      const visualisationMode = _.get(args, 'row.vis3d.visualisationType', '');

      if (linksInterface) {
        const slidersBy = {
          node: _.get(args, 'row.vis3d.nodesSliders', []),
          link: _.get(args, 'row.vis3d.linksSliders', []),
        };

        if (slidersBy.node.length || slidersBy.link.length) {
          vm.onSelectionChange = getSelectionChangeHandler(slidersBy, widgetId, editInterface);
          options.isWidgetControlling = true;
        }
      }
      options.visualisationMode = visualisationMode;

      initVisualizationLogic(args, options)
        .then(() => {
          $scope.$on('widgetTileResize', () => vm.doResize && vm.doResize());
          AdpWidgetsService.handleControlLinkChange({ scope: $scope, widgetId, onLinkChange });
        })
        .then(() => {
          if (visualisationMode === 'vr') {
            const infoTextEl = document.createElement('a-text');
            const cameraEl = $element[0].querySelector('a-entity[camera]');
            infoTextEl.setAttribute('position', { x: 0, y: 0, z: -1 });
            infoTextEl.setAttribute('align', 'center');
            infoTextEl.setAttribute('width', '1.5');
            cameraEl.appendChild(infoTextEl);
            // ToDo: this should be definetely merged with prev code branch and made this ugly way only because demo urge
            vm.onSelectionChange = (selection) => {
              const text = _.map(selection, (item) => _.get(item, 'node.n', '')).join('; ');
              infoTextEl.setAttribute('value', text);
            };
          }
        });

      const onDatasetUpdate = () => vm.reloadGraphData && vm.reloadGraphData(lastFilters);
      AdpWidgetsService.handleDatasetUpdate({ args, $element, onDatasetUpdate });
      AdpWidgetsService.touchLinksControlledByWidget(widgetId, editInterface);

      $scope.getFilterForDatalayer = (dataLayerId) => _.get(lastFilters, [dataLayerId, 'filter']) || [];
      AdpWidgetsService.setWidgetScopeToTile($scope);
    };

    function getSelectionChangeHandler(slidersBy, widgetId, editInterface) {
      return (selection) => {
        _.each(['node', 'link'], (type) => {
          const sliders = slidersBy[type];
          const typedItems = _.filter(selection, (item) => item.type === type);

          _.each(sliders, (slider, index) => {
            const { linkIds } = slider;
            const values = _.map(typedItems, (item) => _.get(item, ['clickValues', index]));
            const filter = values.length ? ['any', ...values] : ['empty'];
            AdpWidgetsService.sendControlledLinksChangeEvents(filter, linkIds, widgetId, editInterface);
          });
        });
      };
    }

    function onLinkChange(event) {
      const { dataLayerId, dxFilter, virtualFilters } = event;

      if (dataLayerId === 'nodes') {
        lastFilters.nodes = { filter: dxFilter, virtualFilters };
      } else if (event.dataLayerId === 'links') {
        lastFilters.links = { filter: dxFilter, virtualFilters };
      }
      lastFilteringMarker = Math.random() * 10000000; // This marker will change on each filtering, so only latest filtered data will be applied to graph;
      return vm.reloadGraphData && vm.reloadGraphData({ filter: lastFilters, marker: lastFilteringMarker });
    }

    function initVisualizationLogic(args, options) {
      const modules = {
        '3d': ForceGraphLogic3d,
        '2d': ForceGraphLogic2d,
        vr: ForceGraphLogicVr,
        ar: ForceGraphArTopFrame,
      };
      const containerElement = $('.adp-fg-container', $element);
      const tagBoxCreator = function ($el, params) {
        $el.dxTagBox && $el.dxTagBox(params);
      };
      const row = _.get(args, 'row');
      const visualisationMode = _.get(row, 'vis3d.visualisationType', '');
      const module = modules[visualisationMode];

      if (!module) {
        $element.text('No visualisation type module found');
      }

      return new Promise((resolve) => {
        $timeout(() => {
          module.mainLogic
            .call(vm, {
              containerElement,
              $scope,
              $rootScope,
              $interval,
              $timeout,
              $http,
              $sce,
              $document,
              AdpNotificationService,
              AdpFullscreenService,
              appConfig: APP_CONFIG,
              tagBoxCreator,
              doLoadData,
              doLoadConfig,
              row,
              options,
            })
            .then((onDestroy) => {
              onDestroy &&
                $element.on('$destroy', () => {
                  onDestroy();
                });
            })
            .finally(resolve);
        });
      });
    }

    function doLoadData(_options = {}) {
      const { args } = $scope;
      const { marker, ...options } = _options;

      return AdpWidgetsService.fetchWidgetData(args, options).then(({ data, messages }) => {
        const notLastResponse = marker && marker !== lastFilteringMarker;
        if (notLastResponse || !data) {
          return { ignoreResponse: true };
        }
        vm.errorMessage = messages ? messages.join('</br>') : '';
        const transformedData = transformGraphData(args, data);
        const preparedData = AdpForceGraphService.prepareGraphData(transformedData);
        return { data: preparedData };
      });
    }

    function transformGraphData(args, { nodes: _nodes, links: _links }) {
      const { nodeDefaults, linkDefaults } = args.widgetConfiguration;
      const tags = {};
      const nodes = {};
      const legend = { nodes: {}, links: {} };
      const { nodeLabelLineLength, linkLabelLineLength } = args.row.vis3d;

      _.each(_nodes, (node) => {
        const typeId = _.get(node, 'typeName');
        const type = _.get(args, `widgetConfiguration.nodeTypes.${typeId}`, {});
        let item = {
          id: node.id || nodeDefaults.id,
          n: splitToLines(node.label, nodeLabelLineLength),
          d: (node.description || '').replace(/\n/g, ' '),
          tags: extractTags(node.tags),
          // obj: {}, // ToDo: implement node annotation then discussed. UPD apr2024: Seems absolette
          crtd: formatDateTime(node.adpCreatedAt, 'DateTime'),
          uptd: formatDateTime(node.adpUpdatedAt, 'DateTime'),
          _clickValues: node._clickValues,
          _mapped: node._mappedFields,
        };

        item = enrichItem(item, node, type, nodeDefaults, { col: 'color', size: 'size', shp: 'shape', image: 'image' });

        item.size = Math.min(100, item.size || 5);

        nodes[item.id] = item;

        if (typeId && !legend.nodes[typeId] && !_.isEmpty(type)) {
          legend.nodes[typeId] = enrichItem({}, type, nodeDefaults, {}, { text: 'name', col: 'color', shp: 'shape' });
        }
      });

      const links = _.compact(
        _.map(_links, (link) => {
          const source = _.get(link, 'source');
          const target = _.get(link, 'target');
          if (!nodes[source] || !nodes[target]) {
            return null;
          }
          const typeId = _.get(link, 'typeName');
          const type = _.get(args, `widgetConfiguration.linkTypes.${typeId}`, {});
          let item = {
            n: splitToLines(link.label, linkLabelLineLength),
            d: (link.description || '').replace(/\n/g, ' '),
            tags: extractTags(link.tags),
            source: source,
            target: target,
            // obj: {
            //   // Source: _.get(link, 'sourceName'), //ToDo - find corresponding nodes in array from above...
            //   Type: _.get(type, 'name'),
            //   // Target: _.get(link, 'targetName'),
            // },
            crtd: formatDateTime(link.adpCreatedAt, 'DateTime'),
            uptd: formatDateTime(link.adpUpdatedAt, 'DateTime'),
            _clickValues: link._clickValues,
            _mapped: link._mappedFields,
          };

          item = enrichItem(item, link, type, linkDefaults, {
            col: 'color',
            w: 'width',
            dst: 'distance',
            pw: 'particleSize',
            pcol: 'particleColor',
            pspd: 'particleSpeed',
            trf: 'particleIntensity',
            curv: 'curvature',
            arSize: 'arrowSize',
            fsize: 'labelFontSize',
          });

          item.pw = Math.max(0, Math.min(100, item.pw || 0));

          if (typeId && !legend.links[typeId] && !_.isEmpty(type)) {
            legend.links[typeId] = enrichItem({}, type, linkDefaults, {}, { text: 'name', col: 'color', w: 'width' });
            legend.links[typeId].w = legend.links[typeId].w || 1;
          }

          return item;
        })
      );

      return { legend: _.mapValues(legend, _.values), nodes: _.values(nodes), links, tags };

      function enrichItem(item, src1, src2, src3, map) {
        _.each(map, function (attr, key) {
          const val = _.isNil(src1[attr]) ? (_.isNil(src2[attr]) ? src3[attr] : src2[attr]) : src1[attr];
          if (!_.isNil(val)) {
            item[key] = val;
          }
        });

        return item;
      }

      function extractTags(_tags) {
        if (!_tags || !_tags.length) {
          return [];
        }

        _.each(_tags, function (tag) {
          tags[tag._id] = tag.label;
        });

        return _.map(_tags, function (tag) {
          return _.indexOf(_.keys(tags), tag._id);
        });
      }

      function formatDateTime(value, type) {
        const dateFormats = {
          Date: 'M/D/YYYY',
          Time: 'h:mm a',
          DateTime: 'M/D/YYYY h:mm a',
        };

        return dayjs(value).format(dateFormats[type]);
      }
    }

    function splitToLines(text, lineLength) {
      if (!lineLength) {
        return text;
      }
      const splitSymbols = ' .,-:;()/\\[]{}';
      const lines = (text || '').split('\n');
      const shortLines = _.map(lines, (line) => {
        const resLines = [];
        let curLine = '';
        let lastSplitter;
        const letters = line.split('');
        _.each(letters, (letter) => {
          const isSplitter = splitSymbols.includes(letter);
          if (curLine.length >= lineLength && lastSplitter) {
            resLines.push(curLine.substring(0, lastSplitter + 1).trim());
            curLine = curLine.substring(lastSplitter + 1);
            lastSplitter = 0;
          }
          if (isSplitter) {
            lastSplitter = curLine.length;
          }
          curLine += letter;
        });

        if (curLine.trim()) {
          resLines.push(curLine.trim());
        }

        return resLines.join('\n');
      });

      return shortLines.join('\n');
    }

    function doLoadConfig() {
      const { args } = $scope;
      const isEmbedded = !!args.isEmbedded;
      const config = _.get(args, 'widgetConfiguration.config', {});
      const configRecordId = _.get(args, 'widgetConfiguration.configRecordId');
      const appearanceData = _.get(args, 'row.vis3d.appearance', {});
      const appearance = _.fromPairs(
        _.map(['allowConfig', 'allowInfo', 'allowLegend', 'allowNavigation', 'allowConfigSave'], (key) => [
          key,
          !!appearanceData[key],
        ])
      );

      config.showOptions = false;
      config.configRecordId = configRecordId;

      if (isEmbedded) {
        appearance.allowConfigSave = false;
      }

      return Promise.resolve(_.assign(config, appearance));
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('adpWidgetGraphVisualisation', widget);

  /** @ngInject */
  function widget($compile) {
    return {
      restrict: 'E',
      scope: {
        interface: '<',
        args: '<',
      },
      link: function (scope, element) {
        const visualisationType = _.get(scope, 'args.row.vis3d.visualisationType', '3d');
        const template = `<graph-visualisation-${visualisationType} interface="interface" args="args"/>`;
        const $res = $compile(template)(scope);

        element.empty().append($res);
      },
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('controlWidgetFactory', controlWidgetFactory);

  /** @ngInject */
  function controlWidgetFactory($compile, ControllerCreationService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
        args: '<',
      },
      link: function (scope, element) {
        const controller = scope.controller;
        scope.tooltipField = controller;
        const template = ControllerCreationService.getControllerTemplate(controller);
        const $res = $compile(template)(scope);

        element.replaceWith($res);

        scope.$watch('controller.errorMessage', (msg) => {
          scope.errorMessage = msg;
        });

        if (controller.activeStatus) {
          const onStatusChange = _.get(controller, 'api._onStateChange');
          scope.$watch('controller.activeStatus', () => {
            const status = controller.activeStatus;
            const statusClass = `adp-cw-row-status-${status}`;
            const labeledClass = 'adp-cw-row-' + (controller.label ? 'labeled' : 'unlabeled');

            scope.cssClass = `${statusClass} ${labeledClass}`;

            if (onStatusChange) {
              onStatusChange(controller.activeStatus);
            }
          });
        } else {
          scope.cssClass = `adp-cw-row-status-passive`;
        }
      },
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('ControllerCreationService', controllerCreationService);

  /** @ngInject */
  function controllerCreationService(
    AdpWidgetsService,
    ControlWidgetHelper,
    DateTimeRangeModule,
    DateTimeSliderModule,
    TimeRangeModule,
    DiscreteRangeModule,
    NumberRangeModule,
    NumberSliderModule,
    NumberInputModule,
    StringFilterModule,
    ListSelectModule,
    ListMultiSelectModule,
    LookupListModule,
    TimelapseListModule,
    TimelapseRangeModule,
    LocationSliderModule,
    GroupSliderModule,
    LoadPresetsModule,
    SwitchModule
  ) {
    const controlWidgetSliderTypes = {
      DateTimeRange: {
        module: DateTimeRangeModule,
        paramsPath: 'dateTimeRangeParams',
        directive: 'date-time-range-control',
        getInitialFilter: (params) => {
          const { min, max } = params;
          return _.map([min, max], (v) => ControlWidgetHelper.getDateTimePoint(v).toISOString()).unshift('between');
        },
      },
      TimeRange: {
        module: TimeRangeModule,
        paramsPath: 'timeRangeParams',
        directive: 'time-range-control',
        getInitialFilter: (params) => {
          const { min, max } = params;
          return ['between', min, max];
        },
      },
      DateTimeSlider: {
        module: DateTimeSliderModule,
        paramsPath: 'dateTimeSliderParams',
        directive: 'date-time-slider-control',
        hideLabelCondition: (params) => !params.showInput && params.showValue,
        getInitialFilter: (params) =>
          _.isNil(params.initialValue)
            ? ['empty']
            : ['=', ControlWidgetHelper.getDateTimePoint(params.initialValue).toISOString()],
      },
      NumberRange: {
        module: NumberRangeModule,
        paramsPath: 'numberRangeParams',
        directive: 'number-range-control',
        getInitialFilter: (params) => ['between', params.min, params.max],
      },
      NumberSlider: {
        module: NumberSliderModule,
        paramsPath: 'numberSliderParams',
        directive: 'number-slider-control',
        hideLabelCondition: (params) => !params.showInput && params.showValue,
        getInitialFilter: (params) => (_.isNil(params.initialValue) ? ['empty'] : ['=', params.initialValue]),
      },
      DiscreteRange: {
        module: DiscreteRangeModule,
        paramsPath: 'discreteRangeParams',
        directive: 'discrete-range-control',
        hideLabelCondition: (params) => params.concatValueWithLabel,
      },
      NumberInput: {
        module: NumberInputModule,
        paramsPath: 'numberInputParams',
        directive: 'number-input-control',
        getInitialFilter: (params) => (_.isNil(params.initialValue) ? ['empty'] : ['=', params.initialValue]),
      },
      StringFilter: {
        module: StringFilterModule,
        paramsPath: 'numberInputParams', // Shares same config with NumberInput
        directive: 'string-filter-control',
      },
      StringFilterForLists: {
        // All the same, only operations differs in module file
        module: StringFilterModule,
        paramsPath: 'numberInputParams', // Shares same config with NumberInput
        directive: 'string-filter-control',
      },
      ListSelect: {
        module: ListSelectModule,
        paramsPath: 'listParams',
        directive: 'list-select-control',
      },
      ListMultiSelectDropdown: {
        module: ListMultiSelectModule,
        paramsPath: 'multiListParams',
        directive: 'list-multi-select-dropdown-control',
      },
      ListMultiSelect: {
        module: ListMultiSelectModule,
        paramsPath: 'multiListParams',
        directive: 'list-multi-select-control',
      },
      LookupList: {
        module: LookupListModule,
        paramsPath: 'lookupListParams',
        directive: 'lookup-list-control',
      },
      TimelapseDateTime: {
        module: TimelapseRangeModule,
        paramsPath: 'timelapseDateTimeParams',
        directive: 'timelapse-date-time-control',
        getInitialFilter: (params) => {
          const { from, to } = params;
          return _.map([from, to], (seconds) => new Date(seconds * 1000).toISOString()).unshift('between');
        },
      },
      TimelapseNumber: {
        module: TimelapseRangeModule,
        paramsPath: 'timelapseNumberParams',
        directive: 'timelapse-num-control',
        getInitialFilter: (params) => ['between', params.from, params.to],
      },
      TimelapseList: {
        module: TimelapseListModule,
        paramsPath: 'timelapseListParams',
        directive: 'timelapse-list-control',
      },
      ResetAll: {
        directive: 'reset-all-control',
        paramsPath: 'resetAllButtonLabel',
        statusSwitch: false,
      },
      Group: {
        module: GroupSliderModule,
        directive: 'control-widget-group',
        paramsPath: 'groupParams',
        statusSwitch: false,
      },
      GroupEnd: {
        statusSwitch: false,
      },
      StaticHtml: {
        directive: 'static-html-slider-control',
        paramsPath: 'staticHtmlParams',
        statusSwitch: false,
      },
      Location: {
        module: LocationSliderModule,
        directive: 'location-slider-control',
        paramsPath: 'locationParams',
      },
      LoadPresets: {
        module: LoadPresetsModule,
        directive: 'load-presets-control',
        paramsPath: 'loadPresets',
        statusSwitch: false,
      },
      Code: {},
      Switch: {
        module: SwitchModule,
        paramsPath: 'switchParams',
        directive: 'switch-control',
      },
    };

    function createMethods(controller, widgetScope) {
      const { type } = controller;
      const module = _.get(controlWidgetSliderTypes, [type, 'module']);

      if (module) {
        const commonMethods = _getCommonMethods(controller, widgetScope);
        const typedMethods = module(controller, widgetScope);

        controller.api = _.assign(commonMethods, typedMethods);
      } else {
        controller.api = {};
      }
    }

    function _getCommonMethods(controller, widgetScope) {
      const linksInterface = AdpWidgetsService.getControlLinksInterface(widgetScope.interface);
      return {
        curVal,
        setActiveStatus,
      };

      function curVal(val) {
        if (!_.isUndefined(val)) {
          controller._changedOn = Date.now();
          controller._currentValue = val;
        }

        return controller._currentValue;
      }

      function setActiveStatus(isActive, skipValueChange) {
        if (isActive) {
          const sendValue = controller.api.transformOut(controller.api.curVal());

          ControlWidgetHelper.sendLinkChangeEvents(sendValue, controller, linksInterface);
          ControlWidgetHelper.setSyncAll(controller);
        } else {
          if (!skipValueChange) {
            _setBestLinksValue(controller, linksInterface);
          }
        }
      }
    }

    function _setBestLinksValue(controller, linksInterface) {
      const { linkIds } = controller;
      const { transformOut, curVal } = controller.api;
      const prevValue = transformOut(curVal());

      // Overall idea is to iterate over all links was controlled by this
      // slider(which is turned inactive) and for each link find the best new value.
      // This is important because sliders may have different value formats and
      // limitations, but controlling same link, forcing sliders to be 'unsync' (e.g. in 'gray' state)
      // So, if one of the sliders controlling same link is turned inactive, the rest may have better value to fit all.
      // So we are about to figure out which links and what values in following call:
      linksInterface.selLinksValuesFromBestSliders({ linkIds, prevValue });
    }

    function getConfigParams(params, type) {
      const path = _.get(controlWidgetSliderTypes, [type, 'paramsPath']);

      return path ? _.cloneDeep(params[path]) : {};
    }

    function getControllerTemplate(controller) {
      const directiveName = _directiveName(controller.type);
      const directiveHtml = `<${directiveName} interface="interface" controller="controller" args="args" class="adp-cw-slider-body"></${directiveName}>`;

      if (controller.type === 'Group') {
        return directiveHtml;
      }

      const hideLabelCondition = _.get(controlWidgetSliderTypes, [controller.type, 'hideLabelCondition']);
      const hasLabel = controller.label && (!hideLabelCondition || !hideLabelCondition(controller.params));
      const tooltipHtml = controller.description
        ? `<div class="adp-control-row-tooltip"><adp-tooltip></adp-tooltip></div>`
        : '';
      const labelHtml = hasLabel ? `<label class="adp-control-row-label">${controller.label}</label>` : '';
      const statusSwitchHtml = showStatusSwitch(controller.type)
        ? '<controller-status-switch></controller-status-switch>'
        : '';

      return [
        `<div class="adp-control-row ${tooltipHtml ? 'has-tooltip' : ''}" ng-class="cssClass">`,
        labelHtml,
        tooltipHtml,
        statusSwitchHtml,
        directiveHtml,
        '<div class="err-message" ng-if="!!errorMessage">{{ errorMessage }}</div>',
        '</div>',
      ].join('');
    }

    function _directiveName(type) {
      return _.get(controlWidgetSliderTypes, [type, 'directive'], '');
    }

    function showStatusSwitch(type) {
      return _.get(controlWidgetSliderTypes, [type, 'statusSwitch']) !== false;
    }

    return {
      getControllerTemplate,
      createMethods,
      getConfigParams,
      showStatusSwitch,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGlobe')
    .directive('adpGlobe3d', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      controller: 'AdpWidgetGlobeController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/globe/3d/adp-globe-3d.html'
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobe3d', AdpGlobe3d);

  function AdpGlobe3d(APP_CONFIG, AdpClientCommonHelper, AdpGlobeService) {
    return function ({ args, $element, $scope }) {
      const widgetId = _.get(args, 'row._id');
      const $labelsContainer = $('.labels-screen', $element);
      const labelElements = {};
      let widgetWidth;
      let widgetHeight;

      return loadVendorCode(args).then(() => {
        const editInterface = _.get($scope, 'interface');
        const extras = {};
        _.set(extras, 'layersApi.satellites', {
          timeRenderer: getTimeRenderer(),
          labelPositioner: getLabelPositioner(),
          labelCreator: getLabelCreator(),
        });
        const containerElement = $('.visualisation-box', $element).get(0);
        const globe = Globe()(containerElement).backgroundColor('rgba(0,0,0,0)');
        const argsWithExtras = {
          ...args,
          ...extras,
        };

        return AdpGlobeService.createLayers({ globe, args: argsWithExtras }).then((layers) => {
          // ToDo: why this code not in texture layer init(create) method???
          AdpGlobeService.handleGlobeSurface({ layers, globe, args });

          resizeGlobe();

          const satLayer = _.find(layers, (layer) => layer.type === 'satellites');
          if (satLayer) {
            // Using globe.onObjectClick() is not an option because it doesnt provide clicked instanceId
            const canvas = globe.controls().domElement;

            setTimeout(() => {
              const camera = globe.camera();
              const scene = globe.scene();
              let instanced;

              $(canvas)
                .click((e) => {
                  const { offsetX, offsetY } = e;
                  const { clientWidth, clientHeight } = canvas;
                  const x = (offsetX / clientWidth) * 2 - 1;
                  const y = -(offsetY / clientHeight) * 2 + 1;
                  const raycaster = new THREE.Raycaster();
                  const pointer = new THREE.Vector2(x, y);
                  raycaster.setFromCamera(pointer, camera);

                  if (!instanced) {
                    instanced = findSceneDeep(scene);
                  }

                  const intersects = raycaster.intersectObjects([instanced], true);

                  if (intersects.length) {
                    const intersectId = _.get(intersects, '0.instanceId');
                    const intersectShape = _.get(intersects, '0.object._shapeName');
                    const sat = satLayer.adpSatEngine.getSatIdByShapeAndIndex(intersectId, intersectShape);
                    if (sat) {
                      AdpGlobeService.setSatSelection([sat.satId], widgetId, satLayer, editInterface);
                    }
                  }
                });
            });
          }

          return {
            globe,
            layers,
            callbacks: {
              doResize: resizeGlobe,
            },
          };

          function findSceneDeep(obj) {
            let res;
            _.each(obj.children, (ch) => {
              if (ch.__globeObjType === 'object') {
                res = ch;
              } else {
                res = findSceneDeep(ch);
              }
              if (res) {
                return false;
              }
            });
            return res;
          }
        });

        function resizeGlobe() {
          widgetWidth = $element.width();
          widgetHeight = $element.height();
          globe.width(widgetWidth);
          globe.height(widgetHeight);
        }
      });

      function getTimeRenderer() {
        const timeLoggerElement = $('.time-log', $element).get(0);
        return (time) => {
          timeLoggerElement.innerText = new Date(time).toString();
        };
      }

      function getLabelCreator() {
        return (labels) => {
          const touched = [];
          _.each(labels, (labelObj) => {
            const { id, label } = labelObj;
            let $labelEl = _.get(labelElements, [id, '$el']);
            if (!$labelEl) {
              $labelEl = $("<div class='sat-label'>").text(label).appendTo($labelsContainer);
              _.set(labelElements, [id, '$el'], $labelEl);
            }
            touched.push(id.toString());
          });
          _.each(_.keys(labelElements), (key) => {
            if (!_.includes(touched, key)) {
              labelElements[key].$el.remove();
              delete labelElements[key];
            }
          });
        };
      }

      function getLabelPositioner() {
        return (labels) => {
          _.each(labels, (labelObj) => {
            const { x, y, id } = labelObj;
            let $labelEl = _.get(labelElements, [id, '$el']);
            if ($labelEl) {
              const left = Math.round((0.5 + x / 2) * widgetWidth);
              const top = Math.round((0.5 - y / 2) * widgetHeight);
              $labelEl.css({ top, left });
            }
          });
        };
      }

      function loadVendorCode(args) {
        const vendorList = [
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/compiled.vendors.js`,
            probe: () => typeof THREE !== 'undefined',
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/globe.gl.min.js`,
            probe: () => typeof Globe !== 'undefined',
          },
        ];

        const layers = _.get(args, 'row.globe.layers');
        const hasSatellites = _.find(layers, (layer) => layer.type === 'satellites');

        if (hasSatellites) {
          vendorList.push({
            url: `${APP_CONFIG.resourceUrl}/public/js/sat-tracker-widget-code.js`,
            probe: () => typeof window.adpApi.AdpSatEngine !== 'undefined',
          });
        }

        return AdpClientCommonHelper.loadVendors(vendorList);
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular.module('app.adpGlobe')
    .factory('AdpGlobeArTopFrame', AdpGlobeArTopFrame);

  function AdpGlobeArTopFrame(
    $sce,
    APP_CONFIG,
    AdpFramesComms
  ) {
    // Main logic works in top iframe and communicate with IFRAME inner document via AdpFrameComms.
    return function ({ args, $scope, options }) {
      const { resourceUrl } = APP_CONFIG;
      const requestProcessors = {
        loaded: () => args,
        ready: onFrameReady,
      };
      const iframeUrl = `${resourceUrl}/public/js/lib/adp-globe-ar.html?d=${ Date.now() }`;
      const framesComms = AdpFramesComms({
        partnerFrame: window.frames['adp_globe_ar'].contentWindow,
        requestProcessors,
        label: 'TOP'
      });
      const preloaded = {};
      const preselected = {};
      let frameReady = false;

      $scope.iframeUrl = $sce.trustAsResourceUrl(iframeUrl);

      return Promise.resolve({
        callbacks: {
          destroyCb: framesComms.onDestroy,
          updateLayerData,
          updateLayerParameters,
        },
      });

      function updateLayerData(payload) {
        if (frameReady) {
          framesComms.postMessage('refreshData', payload);
        } else {
          const { dataLayerId } = payload;
          preloaded[dataLayerId] = payload;
        }
      }

      function updateLayerParameters(payload) {
        if (frameReady) {
          framesComms.postMessage('refreshParameters', payload);
        } else {
          const { dataLayerId } = payload;
          preselected[dataLayerId] = payload;
        }
      }

      function onFrameReady() {
        frameReady = true;
        _.each(preloaded, (payload, dataLayerId) => {
          framesComms.postMessage('refreshData', payload);
          delete preloaded[dataLayerId];
        })
        _.each(preselected, (payload, dataLayerId) => {
          framesComms.postMessage('refreshParameters', payload);
          delete preselected[dataLayerId];
        })
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGlobe')
    .directive('adpGlobeAr', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      controller: 'AdpWidgetGlobeController',
      controllerAs: 'vm',
      templateUrl: `client-modules/adp-widgets/widgets/globe/ar/adp-globe-ar-top-frame.html`
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGlobe')
    .directive('adpGlobeVr', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      controller: 'AdpWidgetGlobeController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/globe/vr/adp-globe-vr.html',
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpGlobe').factory('AdpGlobeVr', AdpGlobeVr);

  function AdpGlobeVr($timeout, APP_CONFIG, AdpClientCommonHelper, AdpGlobeService) {
    return function ({ args, $scope, $element }) {
      const widgetId = _.get(args, 'row._id');
      const getGlobeObject = () => {
        const element = document.querySelector('a-entity[globe]');
        const component = _.get(element, 'components.globe.globe');
        return element && component ? [element, component] : null;
      };
      return loadVendorCode()
        .then(() => {
          $scope.vendorCodeReady = true;
        })
        .then(() => AdpClientCommonHelper.awaitFor(getGlobeObject))
        .then(() => {
          const [globeEl, globe] = getGlobeObject();
          const editInterface = _.get($scope, 'interface');
          const extras = {};
          _.set(extras, 'layersApi.satellites', {
            // timeRenderer: getTimeRenderer(),
            // labelPositioner: getLabelPositioner(),
            labelCreator: getLabelCreator(),
          });
          const argsWithExtras = {
            ...args,
           ...extras,
          };
          const handler = {
            get(target, prop, receiver) {
              const res = Reflect.get(...arguments);
              if (prop === 'justSetObject3D') {
                globeEl.setObject3D('globeGroup', globe);
              }
              return res;
            },
          };
          const globeProxy = new Proxy(globe, handler);
          let satLayer;

          // I have no idea why this set of onClick must be BEFORE creation of layers.
          // So i have to use global var satLayer here...
          globeEl.setAttribute('globe', {
            onClick: (obj, e) => {
              if (satLayer) {
                const shapeName = _.get(e, '_intersection.object._shapeName');
                const instanceId = _.get(e, '_intersection.instanceId');
                const sat = satLayer.adpSatEngine.getSatIdByShapeAndIndex(instanceId, shapeName);
                if (sat) {
                  AdpGlobeService.setSatSelection([sat.satId], widgetId, satLayer, editInterface);
                }
              }
            },
          });

          return AdpGlobeService.createLayers({ globe : globeProxy, args: argsWithExtras }).then((layers) => {
            AdpGlobeService.handleGlobeSurface({ layers, globe, args });
            satLayer = _.find(layers, (layer) => layer.type === 'satellites');

            // ToDO: think how to call seObject3D() after instances are set but not with globeProxy
            // if (satLayer) {
            //    globeEl.setObject3D('globeGroup', globe);
            // }

            return {
              globe,
              layers,
              callbacks: {
                // doResize: resizeGlobe,
              },
            };
          });
        });

      function loadVendorCode() {
        const vendorList = [
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/compiled.vendors.js`,
            probe: () => typeof THREE !== 'undefined',
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/aframe-master.min.js`,
            probe: () => typeof AFRAME !== 'undefined',
            sync: true,
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/aframe-extras.controls.min.js`,
            probe: () => typeof AFRAME.components['movement-controls'] !== 'undefined',
            sync: true,
          },
          {
            url: `${APP_CONFIG.resourceUrl}/public/js/lib/vendor/aframe-globe-component.min.js`,
            probe: () => typeof AFRAME.components.globe !== 'undefined',
            sync: true,
          },
        ];

        const layers = _.get(args, 'row.globe.layers');
        const hasSatellites = _.find(layers, (layer) => layer.type === 'satellites');

        if (hasSatellites) {
          vendorList.push({
            url: `${APP_CONFIG.resourceUrl}/public/js/sat-tracker-widget-code.js`,
            probe: () => typeof window.adpApi.AdpSatEngine !== 'undefined',
          });
        }

        return AdpClientCommonHelper.loadVendors(vendorList);
      }

      function getLabelCreator() {
        const textEl = document.querySelector('#sat-label');
        return (labels) => {
          const text = _.map(labels, (l) => l.label).join(', ');
          textEl.setAttribute('value', text);
        };
      }
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletChoroplethLayer', AdpLeafletChoroplethLayer);

  /** @ngInject */
  function AdpLeafletChoroplethLayer(AdpWidgetsService, AdpLeafletLayersHelper, APP_CONFIG) {
    const geoJsonCache = {};

    function create(layer, data, args) {
      const commonStyle = AdpLeafletLayersHelper.getPathStyle(layer.row);
      const options = {
        pane: layer.paneName,
      };

      layer.cache.opacity = _.isUndefined(commonStyle.opacity) ? 1 : commonStyle.opacity;
      layer.cache.fillOpacity = _.isUndefined(commonStyle.fillOpacity) ? 1 : commonStyle.fillOpacity;

      options.filter = _getFeatureVisibilityFilterFn(layer, data);
      options.style = _getFeatureStyleFn(layer, data, args);
      options.onEachFeature = _getOnEachFeatureFn(layer, data);

      if (layer.doControlLinks) {
        options.bubblingMouseEvents = false;
      }

      const instance = Leaflet.geoJSON(null, options);

      layer.spin(true);
      _getJsonData(layer, args)
        .then((json) => instance.addData(json))
        .catch((err) => console.error('GeoJSON layer load error', err))
        .finally(() => {
          layer.spin(false);
        });

      return instance;
    }

    function setOpacity(layer) {
      if (!layer.instance) {
        return;
      }
      const opacityPair = AdpLeafletLayersHelper.getOpacityPair(layer);

      layer.instance.eachLayer((feature) => {
        const options = _.assign(feature.options, opacityPair);
        feature.setStyle(options);
      });
    }

    function refresh(layer, data, args) {
      let geoJsonData = geoJsonCache[layer._id];
      let geoJsonPromise;

      if (geoJsonData) {
        geoJsonPromise = Promise.resolve(geoJsonData);
      } else {
        geoJsonPromise = _getJsonData(layer, args);
      }
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);
      const commonStyle = AdpLeafletLayersHelper.getPathStyle(layer.row);
      const dataMap = _.fromPairs(_.map(data, (row) => [_getItemId(row), row]));

      layer.spin(true);
      geoJsonPromise
        .then((jsonData) => {
          layer.instance.eachLayer((feature) => {
            const featureId = feature._adpId;
            if (dataMap[featureId]) {
              feature.setStyle(_getStyleFromDataRow(dataMap[featureId], layer, rowValueGetter, commonStyle));
              feature._dataRow = dataMap[featureId];
              delete dataMap[featureId];
            } else {
              layer.instance.removeLayer(feature);
            }
          });

          if (!_.isEmpty(dataMap)) {
            const dataToAdd = _.values(dataMap);
            layer.instance.options.filter = _getFeatureVisibilityFilterFn(layer, dataToAdd);
            layer.instance.options.style = _getFeatureStyleFn(layer, dataToAdd, args);
            layer.instance.options.onEachFeature = _getOnEachFeatureFn(layer, dataToAdd);
            layer.instance.addData(jsonData);
          }
        })
        .catch((err) => console.error('GeoJSON layer load error', err))
        .finally(() => {
          layer.spin(false);
        });
    }

    function _findRecordForFeature(feature, featureField, data) {
      return _.find(data, (row) => _.get(feature, ['properties', featureField]) === row.feature);
    }

    function _getStyleFromDataRow(row, layer, rowValueGetter, commonStyle) {
      const color = AdpLeafletLayersHelper.getColor(row, layer, rowValueGetter);
      const opacityPair = AdpLeafletLayersHelper.getOpacityPair(layer);
      const style = { fillColor: color, color };
      // ToDo: find a way to visualise outOfRange

      return _.assign(style, commonStyle, opacityPair);
    }

    function _getJsonData(layer, args) {
      const geoJsonTypes = _.get(args, 'widgetConfiguration.geoJsonTypes', {});
      const fields = geoJsonTypes[layer.row.geoJson];
      const url = fields.dataUrl ? APP_CONFIG.resourceUrl + fields.dataUrl : fields.externalDataUrl;
      if (url) {
        return fetch(url)
          .then((res) => res.json())
          .then((jsonData) => (geoJsonCache[layer._id] = jsonData));
      } else {
        throw new Error('Layer have no correct URL data');
      }
    }

    function _getFeatureVisibilityFilterFn(layer, data) {
      const { featureField } = layer.row;
      if (!featureField) {
        return true;
      }
      return (feature) => !!_findRecordForFeature(feature, featureField, data);
    }

    function _getFeatureStyleFn(layer, data, args) {
      const { featureField } = layer.row;
      if (!featureField) {
        return;
      }
      const commonStyle = AdpLeafletLayersHelper.getPathStyle(layer.row);
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);

      return (feature) => {
        const row = _findRecordForFeature(feature, featureField, data);
        if (row) {
          return _getStyleFromDataRow(row, layer, rowValueGetter, commonStyle);
        }
      };
    }

    function _getOnEachFeatureFn(layer, data) {
      const { featureField } = layer.row;
      if (!featureField) {
        return;
      }
      const tooltipFactory = AdpLeafletLayersHelper.getTooltipFactory(layer);
      const clickHandler = AdpLeafletLayersHelper.getClickHandler(layer);

      return (feature, featureLayer) => {
        const row = _findRecordForFeature(feature, featureField, data);
        if (row) {
          featureLayer._adpId = _getItemId(row);
          featureLayer._dataRow = row;

          AdpLeafletLayersHelper.addTooltipAndHandler({ leafletLayer: featureLayer, tooltipFactory, clickHandler });
        }
      };
    }

    function _getItemId(row) {
      // ID must be a string;
      return 'id' + row.id;
    }

    return { create, refresh, setOpacity };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletCirclesLayer', AdpLeafletCirclesLayer);

  /** @ngInject */
  function AdpLeafletCirclesLayer(AdpWidgetsService, AdpLeafletLayersHelper) {
    function create(layer, data, args) {
      const commonStyle = AdpLeafletLayersHelper.getPathStyle(layer.row);

      layer.cache.opacity = _.isUndefined(commonStyle.opacity) ? 1 : commonStyle.opacity;
      layer.cache.fillOpacity = _.isUndefined(commonStyle.fillOpacity) ? 1 : commonStyle.fillOpacity;

      const circleFactory = _getCircleFactory(layer, args);
      const circles = _.map(data, circleFactory);

      return Leaflet.layerGroup(circles);
    }

    function setOpacity(layer) {
      if (!layer.instance) {
        return;
      }

      const opacityPair = AdpLeafletLayersHelper.getOpacityPair(layer);

      layer.instance.eachLayer((circle) => {
        const options = _.assign(circle.options, opacityPair);
        circle.setStyle(options);
      });
    }

    function refresh(layer, data, args) {
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);
      const commonStyle = AdpLeafletLayersHelper.getPathStyle(layer.row);
      const dataMap = _.fromPairs(_.map(data, (row) => [_getItemId(row), row]));

      layer.instance.eachLayer((circle) => {
        const circleId = circle._adpId;
        if (dataMap[circleId]) {
          circle.setStyle(_getStyleFromDataRow(dataMap[circleId], layer, rowValueGetter, commonStyle));
          circle._dataRow = dataMap[circleId];
          delete dataMap[circleId];
        } else {
          layer.instance.removeLayer(circle);
        }
      });

      if (!_.isEmpty(dataMap)) {
        const circleFactory = _getCircleFactory(layer, args);
        _.each(dataMap, (row) => {
          const circle = circleFactory(row);
          layer.instance.addLayer(circle);
        });
      }
    }

    function _getItemId(row) {
      // ID must be a string;
      return 'id' + (row.id || `${row.lat}-${row.lng}`);
    }

    function _getStyleFromDataRow(row, layer, rowValueGetter, commonStyle) {
      const color = AdpLeafletLayersHelper.getColor(row, layer, rowValueGetter);
      const radius = rowValueGetter(row, 'value', 1) * 1000;
      const fillColor = color;
      const pane = layer.paneName;
      const opacityPair = AdpLeafletLayersHelper.getOpacityPair(layer);
      return _.assign({ color, radius, fillColor, pane }, commonStyle, opacityPair);
    }

    function _getCircleFactory(layer, args) {
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);
      const commonStyle = AdpLeafletLayersHelper.getPathStyle(layer.row);
      const tooltipFactory = AdpLeafletLayersHelper.getTooltipFactory(layer);
      const clickHandler = AdpLeafletLayersHelper.getClickHandler(layer);

      if (layer.doControlLinks) {
        commonStyle.bubblingMouseEvents = false;
      }

      return (row) => {
        const coords = [rowValueGetter(row, 'lat', 0), rowValueGetter(row, 'lng', 0)];
        const circleStyle = _getStyleFromDataRow(row, layer, rowValueGetter, commonStyle);
        const circle = Leaflet.circle(coords, circleStyle);

        circle._dataRow = row;
        circle._adpId = _getItemId(row);

        AdpLeafletLayersHelper.addTooltipAndHandler({ leafletLayer: circle, tooltipFactory, clickHandler });

        return circle;
      };
    }

    return { create, setOpacity, refresh };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletHeatmapLayer', AdpLeafletHeatmapLayer);

  /** @ngInject */
  function AdpLeafletHeatmapLayer(AdpLeafletLayersHelper) {
    function create(layer, data, args) {
      const { radius, blur, minOpacity, maxZoom } = layer.row;
      const mappedData = _mapHeatData(layer, data, args);
      const gradient = _.get(layer.row, 'gradient.data.row');
      const options = {
        radius,
        blur,
        maxZoom,
        minOpacity: minOpacity / 100,
        pane: layer.paneName,
        opacity: layer.opacity,
      };

      if (gradient) {
        options.gradient = _prepareGradient(gradient);
      }

      return new Leaflet.HeatLayer(mappedData, options);
    }

    function setOpacity(layer) {
      if (!layer.instance) {
        return;
      }

      layer.instance.setOpacity(layer.opacity);
    }

    function _prepareGradient(gradient) {
      if (gradient.type === 'discrete') {
        const res = {};
        let prevColor;

        _.each(gradient.steps, (step, index) => {
          const { position, color } = step;
          res[position / 100] = color;

          if (index) {
            res[position / 100 - 0.001] = prevColor;
          }
          prevColor = color;
        });

        if (_.last(gradient.steps).position < 1) {
          res[1] = prevColor;
        }

        return res;
      }

      return _.fromPairs(_.map(gradient.steps, (step) => [step.position / 100, step.color]));
    }

    function _mapHeatData(layer, data, args) {
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);
      const { gradientMinValue: min, gradientMaxValue: max } = layer.row;

      return _.map(data, (row) => {
        const lat = rowValueGetter(row, 'lat', 0);
        const lng = rowValueGetter(row, 'lng', 0);
        let value = rowValueGetter(row, 'colorValue', 0);

        value = (value - min) / (max - min);
        // value = value > 1 ? 1 : value < 0 ? 0 : value;

        return [lat, lng, value];
      });
    }

    return { create, setOpacity };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletImagesLayer', AdpLeafletImagesLayer);

  /** @ngInject */
  function AdpLeafletImagesLayer(AdpWidgetsService, AdpLeafletLayersHelper) {
    const create = AdpLeafletLayersHelper.getMarkerLayerCreator(_getMarkerFactory);
    const setOpacity = AdpLeafletLayersHelper.getMarkerLayerOpacitySetter(_getMarkerFactory);
    const refresh = AdpLeafletLayersHelper.getMarkerLayerRefresher(_getMarkerFactory, _getItemId, _updateMarker);

    function _updateMarker(layer, marker, row, rowValueGetter, args) {
      const coords = [rowValueGetter(row, 'lat', 0), rowValueGetter(row, 'lng', 0)];
      if (!marker.getLatLng().equals(coords)) {
        marker.setLatLng(coords);
      }

      // ToDo: Recognize data changes and update only if smth changed. Currently original data is not stored so comparison is non-trivial. As idea to use crc of prev data as stored data
      const { icon } = _getIconOptions(layer, row, args);
      const originalOpacity = rowValueGetter(row, 'opacity') / 100;

      marker.setIcon(Leaflet.divIcon(icon));
      marker.setOpacity(originalOpacity * layer.opacity);
      marker.options.originalOpacity = originalOpacity;
      marker._dataRow = row;
    }

    function _getMarkerFactory(layer, args) {
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);
      const tooltipFactory = AdpLeafletLayersHelper.getTooltipFactory(layer);
      const clickHandler = AdpLeafletLayersHelper.getClickHandler(layer);
      const layerOpacity = layer.opacity;

      return (row) => {
        const coords = [rowValueGetter(row, 'lat', 0), rowValueGetter(row, 'lng', 0)];
        const originalOpacity = rowValueGetter(row, 'opacity') / 100;
        const opacity = originalOpacity * layerOpacity;
        const iconOptions = _getIconOptions(layer, row, rowValueGetter);
        const markerOptions = {
          ...iconOptions,
          title: '',
          opacity,
          originalOpacity,
          pane: layer.paneName,
        };
        const markerLayer = Leaflet.marker(coords, markerOptions);

        markerLayer._dataRow = row;
        markerLayer._adpId = _getItemId(row);
        AdpLeafletLayersHelper.addTooltipAndHandler({ leafletLayer: markerLayer, tooltipFactory, clickHandler });

        return markerLayer;
      };
    }

    function _getIconOptions(layer, row, rowValueGetter) {
      const iconUrl = rowValueGetter(row, 'iconUrl');
      const iconSizeX = rowValueGetter(row, 'iconSizeX');
      const iconSizeY = rowValueGetter(row, 'iconSizeY');
      const iconAnchorX = rowValueGetter(row, 'iconAnchorX');
      const iconAnchorY = rowValueGetter(row, 'iconAnchorY');
      const iconOptions = {
        iconUrl,
        iconSize: [iconSizeX || 0, iconSizeY || 0],
        iconAnchor: [iconAnchorX || 0, iconAnchorY || 0],
      };
      const icon = Leaflet.icon(iconOptions);
      return { icon };
    }

    function _getItemId(row) {
      return row.id || `${row.lat}-${row.lng}`;
    }

    return { create, setOpacity, refresh };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletMarkersLayer', AdpLeafletMarkersLayer);

  /** @ngInject */
  function AdpLeafletMarkersLayer(AdpWidgetsService, AdpLeafletLayersHelper) {
    const RETINA = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    const create = AdpLeafletLayersHelper.getMarkerLayerCreator(_getMarkerFactory);
    const setOpacity = AdpLeafletLayersHelper.getMarkerLayerOpacitySetter(_getMarkerFactory);
    const refresh = AdpLeafletLayersHelper.getMarkerLayerRefresher(_getMarkerFactory, _getItemId, _updateMarker);
    const iconsCache = {};

    function updateControlledLink({ layer, payload, args }) {
      const { linkId } = payload;
      const sliders = _.get(layer, 'row.sliders', []);
      const linkValues = payload.value.slice(1) || [];
      const markersSelector = _getMarkersSelector(args);

      _.each(sliders, (slider, sliderIndex) => {
        if (!slider.linkIds.includes(linkId)) {
          return;
        }
        // ToDo: consider multiselection parameter - its possible we select several elements but ony one is assumed by parameter
        layer.selection = {};
        layer.instance.eachLayer((element) => {
          const { _adpId: elementId, _dataRow } = element;
          const clickValues = _.get(_dataRow, [`_clickValues`], []);
          if (linkValues.includes(clickValues[sliderIndex])) {
            layer.selection[elementId] = clickValues;
          }
        });
        AdpLeafletLayersHelper.updateLayerSelection({
          layer,
          itemsSelector: markersSelector,
        });
      });
    }

    function _updateMarker(layer, marker, row, rowValueGetter, args) {
      const coords = [rowValueGetter(row, 'lat', 0), rowValueGetter(row, 'lng', 0)];
      if (!marker.getLatLng().equals(coords)) {
        marker.setLatLng(coords);
      }

      _setMarkerIcon({ layer, marker, args });

      const originalOpacity = rowValueGetter(row, 'opacity') / 100;
      marker.setOpacity(originalOpacity * layer.opacity);
      marker.options.originalOpacity = originalOpacity;
      marker._dataRow = row;
      marker._iconsNames = null;
    }

    function _getMarkersSelector(args) {
      return ({ layer, selectedInstances, deselectedInstances }) =>
        _selectMarkers({ layer, args, selectedInstances, deselectedInstances });
    }

    function _selectMarkers(params) {
      const { layer, args, selectedInstances, deselectedInstances } = params;
      const { actionOnSelect } = layer.row;
      _.each(deselectedInstances, (marker) => {
        _setMarkerIcon({ layer, marker, args, isSelected: false });
        _bringMarkerDown(marker);
      });
      _.each(selectedInstances, (marker) => {
        _setMarkerIcon({ layer, marker, args, isSelected: true });
        _bringMarkerUp(marker);
      });

      if (!_.isEmpty(selectedInstances)) {
        if (actionOnSelect === 'pan') {
          const zoom = layer.map.getZoom();
          _flyToMarkers({ map: layer.map, markers: selectedInstances, zoom });
        } else if (actionOnSelect === 'zoom') {
          const maxZoom = _.get(args, 'row.leafletMap.maxZoom', 1);
          const zoom = Math.min(_.get(layer.row, 'maxZoomOnSelect', 20), maxZoom);
          _flyToMarkers({ map: layer.map, markers: selectedInstances, zoom });
        }
      }
    }

    function _bringMarkerUp(marker) {
      marker.setZIndexOffset(100);
    }

    function _bringMarkerDown(marker) {
      marker.setZIndexOffset(1);
    }

    function _flyToMarkers({ map, markers, zoom }) {
      const points = [];
      _.each(markers, ({ _dataRow: data }) => {
        points.push([data.lat, data.lng]);
      });
      const bounds = new L.LatLngBounds(points);
      map.flyToBounds(bounds, { maxZoom: zoom });
    }

    function _setMarkerIcon({ layer, marker, args, isSelected }) {
      const name = isSelected ? 'selectedIcon' : 'icon';
      const row = marker._dataRow;
      if (row[name] === marker._iconName) {
        return;
      }
      const cachePath = '_iconsNames.' + name;
      let cachedIconName = _.get(marker, cachePath);
      let cachedIcon = cachedIconName && iconsCache[cachedIconName];

      if (!cachedIconName || !cachedIcon) {
        const { icon, iconName } = _getIconOptions(layer, row, args, isSelected);
        _.set(marker, cachePath, iconName);
        cachedIcon = icon;
        cachedIconName = iconName;
      }

      if (cachedIcon) {
        marker.setIcon(cachedIcon);
        marker._iconName = cachedIconName;
      }
    }

    function _getMarkerFactory(layer, args) {
      const rowValueGetter = AdpLeafletLayersHelper.getDataDefaults(layer, args);
      const tooltipFactory = AdpLeafletLayersHelper.getTooltipFactory(layer);
      const markersSelector = _getMarkersSelector(args);
      const clickHandler = AdpLeafletLayersHelper.getClickHandler(layer, markersSelector);
      const layerOpacity = layer.opacity;

      return (row) => {
        const coords = [rowValueGetter(row, 'lat', 0), rowValueGetter(row, 'lng', 0)];
        const originalOpacity = rowValueGetter(row, 'opacity') / 100;
        const opacity = originalOpacity * layerOpacity;
        const { icon, iconName } = _getIconOptions(layer, row, args);
        const markerOptions = {
          icon,
          opacity,
          originalOpacity,
          title: '',
          pane: layer.paneName,
          shadowPane: layer.paneShadowName,
        };
        const markerLayer = Leaflet.marker(coords, markerOptions);
        markerLayer._adpId = _getItemId(row);
        markerLayer._dataRow = row;
        markerLayer._iconName = iconName;
        markerLayer._isSelected = false;
        AdpLeafletLayersHelper.addTooltipAndHandler({ leafletLayer: markerLayer, tooltipFactory, clickHandler });

        return markerLayer;
      };
    }

    function _getIconOptions(layer, row, args, isSelected) {
      const name = isSelected ? 'selectedIcon' : 'icon';
      let iconName = row[name];
      let iconData = _.get(args, `widgetConfiguration.icons.${iconName}`);
      const addSelectMark = isSelected && !iconData;
      if (addSelectMark) {
        iconName = row.icon;
        iconData = _.get(args, `widgetConfiguration.icons.${iconName}`);
      }
      if (!iconData) {
        console.warn(`No icon found by name '${iconName}'`);
        return {};
      }
      if (addSelectMark) {
        iconName += '_wSelectMark'; // Required for latter comparisons
      }

      if (!iconsCache[iconName]) {
        const options = _getIconLayerParams(iconData, addSelectMark);
        iconsCache[iconName] = Leaflet.divIcon(options);
      }

      return { icon: iconsCache[iconName], iconName };
    }

    function _getIconLayerParams(data, addSelectMark) {
      const parts = [];
      const margins = [0, 0, 0, 0];

      _.each(['shadow', 'icon'], (part) => {
        const src = RETINA ? data[part + 'Retina'] || data[part] : data[part];
        if (!src) {
          return;
        }
        const attrs = {};
        const size = {};
        const anchor = {};

        _.each(['X', 'Y'], (dim) => {
          size[dim] = _.get(data, `${part}Size${dim}`, 40);
          anchor[dim] = _.get(data, `${part}Anchor${dim}`, size[dim] / 2);
        });

        attrs.src = src;
        attrs.class = 'adp-marker-icon';
        attrs.style = `margin:${-anchor.Y}px 0 0 ${-anchor.X}px`;
        attrs.width = size.X;
        attrs.height = size.Y;
        const attrString = _.map(attrs, (v, k) => `${k}="${v}"`).join(' ');

        parts.push(`<img ${attrString} alt="${part}"/>`);

        addSelectMark && _saveMargins(anchor.X, size.X - anchor.X, anchor.Y, size.Y - anchor.Y);
      });

      const css = {};
      const { charIcon } = data;

      if (charIcon) {
        if (charIcon.icon) {
          const addWidth = 10;
          const size = _.get(charIcon, 'charSize', 20);
          const anchorX = _.get(charIcon, 'charAnchorX', size / 2);
          const anchorY = _.get(charIcon, 'charAnchorY', size / 2);
          const color = _.get(charIcon, 'charColor');

          css.width = size + addWidth + 'px';
          css.height = size + 'px';
          css.margin = `${-anchorY}px 0 0 ${-anchorX - addWidth / 2}px`;
          css.fontSize = size + 'px';
          if (color) {
            css.color = color;
          }

          const style = _.map(css, (v, k) => _.kebabCase(k) + ':' + v).join(';');
          const { name, family } = charIcon.icon;
          let className;

          if (family === 'fa') {
            className = `fa fa-${name}`;
          } else if (family === 'dx') {
            className = `dx-icon-${name}`;
          }

          parts.push(`<div style="${style}" class="adp-marker-icon-char"><i class="${className}"></i></div>`);

          addSelectMark && _saveMargins(anchorX, size - anchorX, anchorY, size - anchorY);
        }
      }

      if (addSelectMark) {
        const css = {
          width: margins[2] + margins[0] + 'px',
          height: margins[3] + margins[1] + 'px',
          borderRadius: '50%',
          backgroundColor: 'rgba(200, 0, 0, .5)',
          margin: `${-margins[2]}px 0 0 ${-margins[0]}px`,
        };
        const style = _styleString(css);

        parts.push(`<div style="${style}"/>`);
      }

      return {
        iconSize: [0.1, 0.1],
        iconAnchor: [0, 0],
        html: parts.join(''),
        className: 'adp-marker-icon-box',
        popupAnchor: [data.popupAnchorX || 0, data.popupAnchorY || 0],
      };

      function _styleString(css) {
        return _.map(css, (v, k) => _.kebabCase(k) + ':' + v).join(';');
      }

      function _saveMargins(left, right, top, bottom) {
        _.each(arguments, (val, index) => {
          if (_.isNil(margins[index]) || margins[index] < val) {
            margins[index] = val;
          }
        });
      }
    }

    function _getItemId(row) {
      // ID must be a string;
      return 'id' + (row.id || `${row.lat}-${row.lng}`);
    }

    return { create, setOpacity, refresh, updateControlledLink };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletTilesLayer', AdpLeafletTilesLayer);

  /** @ngInject */
  function AdpLeafletTilesLayer() {
    function create(layer, data, args) {
      const tileTypes = _.get(args, 'widgetConfiguration.tileTypes', {});
      const fields = tileTypes[layer.row.tiles];

      if (!fields) {
        return;
      }

      return Leaflet.tileLayer(fields.urlTemplate, {
        pane: layer.paneName,
        attribution: fields.attribution || '',
        opacity: layer.opacity,
      });
    }

    function setOpacity(layer) {
      if (!layer.instance) {
        return;
      }

      layer.instance.setOpacity(layer.opacity);
    }

    return { create, setOpacity };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('AdpLeafletLayersHelper', AdpLeafletLayersHelper);

  /** @ngInject */
  function AdpLeafletLayersHelper(AdpGradientService, AdpWidgetsService) {
    function getDataDefaults(layer, args) {
      const layerFields = _.get(args, 'widgetSchema.parameters.fields.' + layer.type, []);
      const defaults = _.fromPairs(
        _.map(layerFields, (field) => {
          const defName = 'default' + field.substr(0, 1).toUpperCase() + field.substr(1);
          const value = _.get(layer.row, defName);

          return [field, value];
        })
      );

      return (item, name, def = '') =>
        _.isNil(item[name]) ? (_.isNil(defaults[name]) ? def : defaults[name]) : item[name];
    }

    function getColor(row, layer, getVal, params = {}) {
      const { modeField = 'colorMode', stringValName = 'colorString', numberValName = 'colorValue' } = params;
      const colorMode = layer.row[modeField];

      if (colorMode === 'gradient') {
        const gradient = _.get(layer.row, 'gradient.data.row', {});
        const value = row[numberValName];
        const min = _.get(layer.row, 'gradientMinValue', 0);
        const max = _.get(layer.row, 'gradientMaxValue', 100);

        return AdpGradientService.mapValue(gradient, value, min, max);
      }

      return getVal(row, stringValName, 'transparent');
    }

    function getPathStyle(row) {
      const divideBy100 = ['opacity', 'fillOpacity'];
      const leafletOptionNames = ['color', 'weight', 'dashArray', ...divideBy100];
      const style = {};

      _.each(leafletOptionNames, (name) => {
        const rowAttrName = 'style' + name[0].toUpperCase() + name.substring(1);
        const val = row[rowAttrName];
        if (!_.isNil(val)) {
          style[name] = val;

          if (_.includes(divideBy100, name)) {
            style[name] /= 100;
          }
        }
      });

      return style;
    }

    function getOpacityPair(layer) {
      return {
        opacity: layer.opacity * layer.cache.opacity,
        fillOpacity: layer.opacity * layer.cache.fillOpacity,
      };
    }

    function getTooltipFactory(layer) {
      const tooltipTmpl = _.trim(_.get(layer, 'row.tooltipConfig.templateText'));
      if (!tooltipTmpl) {
        return;
      }

      return (mapLayer) => {
        const row = _.get(mapLayer, '_dataRow', {});
        const mapped = _.get(row, '_mappedFields', {});
        const tooltipContext = { mapped, row };
        return AdpWidgetsService.getTooltipText(tooltipTmpl, tooltipContext);
      };
    }

    // Bad parameters wording but i dont see a good way to differentiate
    // Leaflet internal Layer instance(generated for each marker/circle/etc) from 'layer' object which is
    // logical part of internal widget's 'layers' data.
    function getClickHandler(layer, itemsSelector) {
      if (!layer.doControlLinks) {
        return;
      }
      const allowMultiSelect = _.get(layer, 'row.selectionOptions.allowMultiselect');

      return (event) => {
        const clickedLeafletElement = event.sourceTarget;
        const id = clickedLeafletElement._adpId;
        const isSelected = !_.isUndefined(layer.selection[id]);
        if (!allowMultiSelect) {
          layer.selection = {};
          deselectAll(layer);
        }
        if (isSelected) {
          if (allowMultiSelect) {
            layer.selection = _.omit(layer.selection, [id]);
          }
        } else {
          const item = _.get(clickedLeafletElement, '_dataRow', {});
          layer.selection[id] = item._clickValues;
        }

        updateLayerSelection({ layer, itemsSelector });
        layer.updateControlledValues();
      };
    }

    function updateLayerSelection({ layer, itemsSelector }) {
      const hasCustomSelector = _.isFunction(itemsSelector);
      const selectedInstances = [];
      const deselectedInstances = [];

      layer.instance.eachLayer((element) => {
        const elementId = element._adpId;
        const shouldBeSelected = !!_.get(layer, ['selection', elementId]);
        if (element._isSelected !== shouldBeSelected) {
          if (!hasCustomSelector) {
            const $layerElem = $(element.getElement());
            $layerElem.toggleClass('adp-leaflet-selected', shouldBeSelected);
          }

          if (hasCustomSelector && !shouldBeSelected) {
            deselectedInstances.push(element);
          }
        }
        element._isSelected = shouldBeSelected;

        if (hasCustomSelector && shouldBeSelected) {
          selectedInstances.push(element);
        }
      });

      if (hasCustomSelector) {
        itemsSelector({ layer, selectedInstances, deselectedInstances });
      }
    }

    function addTooltipAndHandler({ leafletLayer, tooltipFactory, clickHandler }) {
      if (tooltipFactory) {
        leafletLayer.bindTooltip(tooltipFactory, { sticky: true });
      }
      if (clickHandler) {
        leafletLayer.on('click', clickHandler);
      }
      return leafletLayer;
    }

    function deselectAll(layer) {
      const paneElement = layer.instance.getPane();
      $('.adp-leaflet-selected', paneElement).removeClass('adp-leaflet-selected');
    }

    function getMarkerLayerCreator(_getMarkerFactory) {
      return (layer, data, args) => {
        const { useClustering } = layer.row;
        const factory = _getMarkerFactory(layer, args);
        const markers = _.compact(_.map(data, factory));

        if (useClustering) {
          const clusters = L.markerClusterGroup({
            spiderLegPolylineOptions: {
              pane: layer.paneShadowName,
            },
          });
          clusters.addLayers(markers);
          return clusters;
        } else {
          return Leaflet.layerGroup(markers);
        }
      };
    }

    function getMarkerLayerOpacitySetter() {
      return (layer) => {
        if (!layer.instance) {
          return;
        }

        layer.instance.eachLayer((marker) => {
          const opacity = marker.options.originalOpacity * layer.opacity;
          marker.setOpacity(opacity);
        });
      };
    }

    function getMarkerLayerRefresher(_getMarkerFactory, _getItemId, _updateMarker) {
      return (layer, data, args) => {
        const rowValueGetter = getDataDefaults(layer, args);
        const dataMap = _.fromPairs(_.map(data, (row) => [_getItemId(row), row]));

        layer.instance.eachLayer((marker) => {
          const markerId = marker._adpId;
          if (dataMap[markerId]) {
            _updateMarker(layer, marker, dataMap[markerId], rowValueGetter, args);
            delete dataMap[markerId];
          } else {
            layer.instance.removeLayer(marker);
          }
        });

        if (!_.isEmpty(dataMap)) {
          const markerFactory = _getMarkerFactory(layer, args);
          _.each(dataMap, (item) => {
            const marker = markerFactory(item);
            layer.instance.addLayer(marker);
          });
        }
      };
    }

    return {
      getDataDefaults,
      getColor,
      getPathStyle,
      getOpacityPair,
      getTooltipFactory,
      getClickHandler,
      addTooltipAndHandler,
      getMarkerLayerCreator,
      getMarkerLayerOpacitySetter,
      getMarkerLayerRefresher,
      deselectAll,
      updateLayerSelection,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('graphVisualisation3d', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        args: '<',
      },
      controller: 'AdpWidgetGraphVisualisationController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/vis3d/3d/graphVisualisation3d.html',
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('graphVisualisation2d', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        args: '<',
      },
      controller: 'AdpWidgetGraphVisualisationController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/vis3d/2d/graphVisualisation2d.html',
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('ForceGraphArTopFrame', ForceGraphArTopFrame);

  function ForceGraphArTopFrame($sce, AdpNotificationService, AdpFramesComms) {
    function mainLogic({ doLoadData, doLoadConfig, appConfig, row, options }) {
      const vm = this;
      const { resourceUrl } = appConfig;
      const { skipInitialDataLoad } = options;
      const markerFileName = getMarkerFileName();
      const sceneScale = _.get(row, 'vis3d.arParameters.sceneScale') || 100;
      const INTERFACE = window.adpAppStore.appInterface();
      const logoPath = _.get(INTERFACE, 'app.logo.large');
      const logoUrl = `${resourceUrl}${logoPath}`;
      const framesOptions = {
        appConfig,
        markerFileName,
        sceneScale,
        trackHover: options.isWidgetControlling,
        logoUrl,
        skipInitialDataLoad,
      };
      const requestProcessors = {
        loaded: () => framesOptions,
        ready: onFrameReady,
        getConfig: doLoadConfig,
        getData: onGetData,
        selection: (selection) => vm.onSelectionChange && vm.onSelectionChange(selection),
        arEvent: onArEvent,
      };
      const url = `${resourceUrl}/public/js/lib/adp-ar.html?t=${Math.floor(Math.random() * 1000)}`;
      const framesComms = AdpFramesComms({
        partnerFrame: window.frames['adp_ar'].contentWindow,
        requestProcessors,
        label: 'TOP',
      });
      let frameReady = false;
      let storedLoadParams;

      vm.iframeUrl = $sce.trustAsResourceUrl(url);
      vm.reloadGraphData = (loadParams) => {
        if (frameReady) {
          framesComms.postMessage('refreshData', { loadParams });
        } else {
          storedLoadParams = loadParams;
        }
      };

      return Promise.resolve(framesComms.onDestroy);

      function getMarkerFileName() {
        const { apiUrl, publishedEndpointPrefix } = appConfig;
        const markerPatternType = _.get(row, 'vis3d.arParameters.markerPatternType') || 'hiro';
        if (markerPatternType === 'hiro') {
          return '';
        }
        const { canBeShared, sharedWidgetId, _id } = row;
        if (canBeShared) {
          return `${apiUrl}${publishedEndpointPrefix}/w/ar/p/${sharedWidgetId}`;
        }

        return `${apiUrl}/w/ar/p/${_id}`;
      }

      function onGetData(params = {}) {
        return doLoadData(params);
      }

      function onFrameReady() {
        frameReady = true;
        if (storedLoadParams) {
          framesComms.postMessage('refreshData', { loadParams: storedLoadParams });
          storedLoadParams = null;
        }
      }

      function onArEvent(eventName) {
        const eventMessages = {
          markerLost: 'Please keep the camera pointed clearly at the marker',
          noVideoFound: 'Please enable the camera and phone sensors for this visualization',
        };

        const message = eventMessages[eventName] || '';
        vm.arMessage = message || vm.arMessage;
        vm.isArMessagePresent = !!message;
      }
    }

    return {
      mainLogic,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('graphVisualisationAr', widget)
    .directive('iframeOnload', iframeOnload);

  /** @ngInject */
  function iframeOnload() {
    return {
      scope: {
        callBack: '&iframeOnload'
      },
      restrict: 'A',
      link: function (scope, element) {
        element.on('load', () => scope.callBack());
        scope.$on('$destroy', () => element.off('load'))
      }
    }
  }

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        args: '<'
      },
      controller: 'AdpWidgetGraphVisualisationController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/vis3d/ar/graphVisualisationAr.html'
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('graphVisualisationVr', widget);

  /** @ngInject */
  function widget() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        args: '<',
      },
      controller: 'AdpWidgetGraphVisualisationController',
      controllerAs: 'vm',
      templateUrl: 'client-modules/adp-widgets/widgets/vis3d/vr/graphVisualisationVr.html',
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('dateTimeRangeControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl:
        'client-modules/adp-widgets/widgets/control-widget/controls/date-time-range/date-time-range-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { allowOpenMin, allowOpenMax, timeOnly, showInputs, inputDisplayFormat } = controller.params;
      const { curVal, transformIn, transformOut, updateSync, fixWithLimits, datesToSeconds, secondsToDates } =
        controller.api;
      const { limitsSec } = controller.data;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const allowOpen = [allowOpenMin, allowOpenMax];
      const limitsDate = _.map(limitsSec, (sec) => new Date(sec * 1000));
      const timePrecision = ControlWidgetHelper.getSecondsByUnitName(controller.params.timePrecision);
      const $rangeElement = element.find('.adp-cw-bar');
      const rangeConfig = {
        min: limitsSec[0],
        max: limitsSec[1],
        start: initialValue[0],
        end: initialValue[1],
        step: timePrecision,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'slider'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onRangeValue),
      };

      $rangeElement.dxRangeSlider(rangeConfig);

      const sideNames = ['left', 'right'];
      const rangeSize = limitsSec[1] - limitsSec[0];
      const inputType = timeOnly || rangeSize < 3600 * 24 ? 'time' : timePrecision > 3600 ? 'date' : 'datetime';
      const dateValues = secondsToDates(initialValue);

      _.each(sideNames, function (sideName, index) {
        const isEndOpen = allowOpen[index] && initialValue[index] === limitsDate[index];
        if (showInputs) {
          const inputConfig = {
            min: limitsDate[0],
            max: limitsDate[1],
            value: isEndOpen ? null : dateValues[index],
            stylingMode: 'outlined',
            pickerType: 'calendar',
            displayFormat: inputDisplayFormat || 'shortDate',
            showDropDownButton: false,
            openOnFieldClick: true,
            dropDownOptions: {
              container: '#adp-dashboard-container',
            },
            type: inputType,
            onInitialized: ControlWidgetHelper.controlInitHandler(components, sideName),
            onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, (val) =>
              onInputValue(val, index)
            ),
          };
          element
            .find('.adp-cw-input-' + sideName)
            .addClass('adp-cw-active')
            .dxDateBox(inputConfig);
        }
      });

      ControlWidgetHelper.registerValueSetter(controller, setValue);

      function setValue(value) {
        const transformed = transformIn(value);
        const { value: newValue, err } = fixWithLimits(transformed);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        curVal(newValue);

        if (err) {
          controller.errorMessage = err;
        }

        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          components.slider.option({ start: newValue[0], end: newValue[1] });

          setInputValue(0, newValue[0]);
          setInputValue(1, newValue[1]);
        }
      }

      function onRangeValue(value) {
        ControlWidgetHelper.setSyncAll(controller);

        setInputValue(0, value[0]);
        setInputValue(1, value[1]);

        curVal(value);
        return transformOut(value);
      }

      function onInputValue(value, index) {
        const newValue = secondsToDates(curVal());
        const isEndOpen = value === null && allowOpen[index];
        newValue[index] = isEndOpen ? limitsSec[index] : value;
        $rangeElement.toggleClass(`adp-cw-range-open-${sideNames[index]}`, isEndOpen);
        ControlWidgetHelper.setSyncAll(controller);
        const currentValue = curVal(datesToSeconds(newValue));
        components.slider.option({ start: currentValue[0], end: currentValue[1] });
        return transformOut(currentValue);
      }

      function setInputValue(index, value) {
        const sideName = sideNames[index];
        if (components[sideName]) {
          const isEndOpen = allowOpen[index] && value === limitsSec[index];
          components[sideName].option('value', isEndOpen ? null : secondsToDates(value));
          $rangeElement.toggleClass(`adp-cw-range-open-${sideName}`, isEndOpen);
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('DateTimeRangeModule', DateTimeRangeModule);

  /** @ngInject */
  function DateTimeRangeModule(ControlWidgetHelper) {
    return function (controller) {
      const { allowOpenMin, allowOpenMax } = controller.params;
      const limitsSec = _getRangeLimitsInSeconds();

      controller.data = { limitsSec };

      function _isMinOpen(value) {
        return allowOpenMin && value[0] === limitsSec[0];
      }

      function _isMaxOpen(value) {
        return allowOpenMax && value[1] === limitsSec[1];
      }

      function _getRangeLimitsInSeconds() {
        const { min, max } = controller.params;
        const limitsDate = _.map([min, max], (val) => ControlWidgetHelper.getDateTimePoint(val));
        return datesToSeconds(limitsDate);
      }

      function defaultValue() {
        const { initialMin: min, initialMax: max } = controller.params;
        const limitsDate = _.map(
          [min, max],
          (val, index) => ControlWidgetHelper.getDateTimePoint(val, true) || limitsSec[index] * 1000
        );
        return datesToSeconds(limitsDate);
      }

      function transformIn(value) {
        const operation = value[0];
        let start;
        let end;

        if (operation === 'empty') {
          return [limitsSec[0], limitsSec[1]];
        }

        const secs = datesToSeconds(_.slice(value, 1));
        start = secs[0];

        if (operation === '>=') {
          end = limitsSec[1];
        } else if (operation === '<=') {
          end = start;
          start = limitsSec[0];
        } else if (operation !== 'between') {
          end = secs[0];
        } else {
          end = secs[1];
        }

        return [start, end];
      }

      function transformOut(value) {
        const openMin = _isMinOpen(value);
        const openMax = _isMaxOpen(value);
        const dates = secondsToDates(value);
        if (openMax && openMin) {
          return ['empty'];
        }
        if (openMax) {
          return ['>=', dates[0]];
        }
        if (openMin) {
          return ['<=', dates[1]];
        }

        return ['between', ...dates];
      }

      function updateSync(value) {
        const operation = value[0];
        const leftOpen = allowOpenMin && operation === '<=';
        const rightOpen = allowOpenMax && operation === '>=';
        const exactOperation = _.includes(['=', 'between'], operation);
        const isValueSync = !controller.errorMessage && (exactOperation || leftOpen || rightOpen);

        ControlWidgetHelper.setValueSync(controller, isValueSync);
      }

      function fixWithLimits(value) {
        const { pair, errors } = ControlWidgetHelper.fixRangeWithLimits(
          value[0],
          value[1],
          limitsSec[0],
          limitsSec[1],
          allowOpenMin,
          allowOpenMax
        );

        return { value: pair, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      function datesToSeconds(value) {
        return _.map(
          _.map(value, (val) => (_.isDate(val) ? val : new Date(val))),
          (val) => Math.round(val.getTime() / 1000)
        );
      }

      function secondsToDates(value) {
        const convert = (val) => new Date(val * 1000);
        return _.isArray(value) ? _.map(value, convert) : convert(value);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
        datesToSeconds,
        secondsToDates,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('dateTimeSliderControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl:
        'client-modules/adp-widgets/widgets/control-widget/controls/date-time-slider/date-time-slider-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { showInput, showValue, displayFormat } = controller.params;
      const { curVal, transformIn, transformOut, updateSync, fixWithLimits, dateToSeconds, secondsToDate } =
        controller.api;
      const { limitsSec } = controller.data;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const limitsDate = _.map(limitsSec, (sec) => new Date(sec * 1000));
      const timePrecision = ControlWidgetHelper.getSecondsByUnitName(controller.params.timePrecision);
      const sliderConfig = {
        min: limitsSec[0],
        max: limitsSec[1],
        value: initialValue,
        step: timePrecision,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'slider'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onSliderValue),
      };
      const initialDateValue = secondsToDate(initialValue);

      scope.showLabel = !showInput && showValue;
      scope.controllerLabel = controller.label ? `${controller.label}:` : '';

      element.find('.adp-cw-bar').dxSlider(sliderConfig);

      if (showInput) {
        const sliderSize = limitsSec[1] - limitsSec[0];
        const inputType =
          controller.params.timeOnly || sliderSize < 3600 * 24 ? 'time' : timePrecision > 3600 ? 'date' : 'datetime';
        const inputConfig = {
          min: limitsDate[0],
          max: limitsDate[1],
          value: initialDateValue,
          stylingMode: 'outlined',
          pickerType: 'calendar',
          displayFormat: displayFormat || 'shortDate',
          showDropDownButton: false,
          openOnFieldClick: true,
          dropDownOptions: {
            container: '#adp-dashboard-container',
          },
          type: inputType,
          onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
          onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputValue),
        };
        element.find('.adp-cw-input-left').addClass('adp-cw-active').dxDateBox(inputConfig);
      } else {
        displayValue(initialValue);
      }

      ControlWidgetHelper.registerValueSetter(controller, setValue);

      function setValue(value) {
        const transformed = transformIn(value);
        const { value: newValue, err } = fixWithLimits(transformed);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        curVal(newValue);

        if (err) {
          controller.errorMessage = err;
        }

        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          components.slider.option({ value: newValue });
          displayValue(newValue);
        }
      }

      function onSliderValue(value) {
        ControlWidgetHelper.setSyncAll(controller);
        displayValue(value);
        curVal(value);
        return transformOut(value);
      }

      function onInputValue(input) {
        ControlWidgetHelper.setSyncAll(controller);
        const value = curVal(dateToSeconds(input));
        components.slider.option({ value });
        return transformOut(value);
      }

      function displayValue(pos) {
        const date = secondsToDate(pos);
        if (showInput) {
          components.input && components.input.option('value', date);
        } else if (showValue) {
          scope.valueLabel = DevExpress.localization.formatDate(date, displayFormat || 'shortDate');
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('DateTimeSliderModule', DateTimeSliderModule);

  /** @ngInject */
  function DateTimeSliderModule(ControlWidgetHelper) {
    return function (controller) {
      const limitsSec = _getRangeLimitsInSeconds();

      controller.data = { limitsSec };

      function _getRangeLimitsInSeconds() {
        const { min, max } = controller.params;
        return _.map([min, max], (val) => dateToSeconds(ControlWidgetHelper.getDateTimePoint(val)));
      }

      function defaultValue() {
        const { initialValue, min } = controller.params;
        const initialTimePoint = ControlWidgetHelper.getDateTimePoint(initialValue, true);
        if (initialTimePoint) {
          return dateToSeconds(initialTimePoint);
        }
        const timePoint = ControlWidgetHelper.getDateTimePoint(min);
        return dateToSeconds(timePoint);
      }

      function transformIn(value) {
        const operation = value[0];
        return operation === 'empty' ? limitsSec[0] : dateToSeconds(value[1]);
      }

      function transformOut(pos) {
        return ['=', secondsToDate(pos)];
      }

      function updateSync(value) {
        const operation = value[0];
        const isValueSync = !controller.errorMessage && operation === '=';

        ControlWidgetHelper.setValueSync(controller, isValueSync);
      }

      function fixWithLimits(pos) {
        const { value, errors } = ControlWidgetHelper.fixValueWithLimits(pos, limitsSec[0], limitsSec[1]);

        return { value, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      function dateToSeconds(value) {
        const val = _.isDate(value) ? value : new Date(value);
        return Math.round(val.getTime() / 1000);
      }

      function secondsToDate(value) {
        return new Date(value * 1000);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
        dateToSeconds,
        secondsToDate,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('discreteRangeControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl:
        'client-modules/adp-widgets/widgets/control-widget/controls/discrete-range/discrete-range-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const {
        data: { allItems },
      } = controller;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const sliderConfig = {
        min: 0,
        max: allItems.length - 1,
        value: initialValue,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'slider'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onRangeValue),
      };

      setLabel(initialValue);
      scope.stepCount = allItems.length;
      scope.tooltipField = controller;
      ControlWidgetHelper.registerValueSetter(controller, setValue);
      element.find('.adp-cw-bar').dxSlider(sliderConfig);

      function setValue(value) {
        const newValue = transformIn(value, controller);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        curVal(newValue);
        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          components.slider.option({ value: newValue });
          setLabel(newValue);
        }
      }

      function onRangeValue(value) {
        ControlWidgetHelper.setSyncAll(controller);
        curVal(value);
        setLabel(value);
        return transformOut(value);
      }

      function setLabel(val) {
        const item = _.get(allItems, val);
        if (!item) {
          return;
        }
        scope.safeHtmlDisplayString = item.safeHtmlLabel;
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('DiscreteRangeModule', DiscreteRangeModule);

  /** @ngInject */
  function DiscreteRangeModule(ControlWidgetHelper) {
    return function (controller) {
      const allItems = ControlWidgetHelper.getAllListValuesSafeHtmlLabel(controller);
      const allValues = _.map(allItems, (item) => item.value);

      controller.data = { allItems };

      function defaultValue() {
        return Math.max(
          _.findIndex(allItems, (item) => item.selected),
          0
        );
      }

      function transformIn(value) {
        const operation = _.get(value, '0', 'empty');

        if (operation === 'empty') {
          return -1;
        }

        if (operation === 'combine') {
          const candidates = _.compact(value.slice(1).map(transformIn));

          if (!candidates.length) {
            return '';
          }

          return candidates[0];
        }

        const val = value[1].toString();
        return _.indexOf(allValues, val);
      }

      function transformOut(value) {
        let val = _.get(allItems, [value, 'value'], '');
        const { treatValuesAs } = controller.params;
        const typedValue = ControlWidgetHelper.castValueType(value, treatValuesAs);
        return ['=', typedValue];
      }

      function updateSync(value) {
        const operation = value[0];
        let isSync = false;

        if (operation === '=') {
          isSync = _.indexOf(allValues, value[1].toString()) >= 0;
        } else if (operation === 'empty') {
          const currentVal = controller.api.curVal();
          isSync = currentVal === '';
        }

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('listMultiSelectControl', control);

  /** @ngInject */
  function control(
    ControlWidgetHelper
  ) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/list-multi-select/list-multi-select-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const {data: {allItems}} = controller;
      const {curVal, transformIn, updateSync} = controller.api;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      scope.items = allItems;
      scope.columns = _.get(controller, 'params.columns') || 1;

      _.defer(() => renderValues());

      scope.toggleItem = function () {
        const currentValue = _.compact(
          _.map(scope.items, item =>
            $('input[name="' + item.value + '"]', element).prop('checked') ? item.value : null
          )
        );
        curVal(currentValue);
        ControlWidgetHelper.setSyncAll(controller);
        ControlWidgetHelper.broadcastValue(controller, linksInterface);
      }

      function setValue(value) {
        curVal(transformIn(value));
        updateSync(value);
        renderValues();
      }

      function renderValues() {
        const value = curVal();

        _.each(scope.items, item => {
          const $inp = element.find('input[name="' + item.value + '"]');
          $inp.prop('checked', _.indexOf(value, item.value) >= 0);
        });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('ListMultiSelectModule', ListMultiSelectModule);

  /** @ngInject */
  function ListMultiSelectModule(ControlWidgetHelper) {
    return function (controller) {
      const allItems = ControlWidgetHelper.getAllListValuesSafeHtmlLabel(controller);
      const allValues = _.map(allItems, (item) => item.value);

      controller.data = { allItems };

      function defaultValue() {
        return _.compact(_.map(allItems, (item) => item.selected && item.value));
      }

      function transformIn(value) {
        const operation = value[0];

        if (operation === 'combine') {
          const candidates = value.slice(1).map(transformIn);

          return _.chain(candidates).flatten().compact().uniq().value();
        }

        const values = _getStringVals(value);

        return _.intersection(allValues, values);
      }

      function transformOut(value) {
        const operation = !value || value.length === 0 ? 'empty' : value.length === 1 ? '=' : 'any';
        const { treatValuesAs } = controller.params;
        const typedValues = _.map(value, (val) => ControlWidgetHelper.castValueType(val, treatValuesAs));
        return [operation, ...typedValues];
      }

      function updateSync(value) {
        const operation = value[0];
        const values = _getStringVals(value);
        let isSync;

        if (operation === 'empty') {
          const currentVal = controller.api.curVal();
          isSync = _.isNil(currentVal) || !currentVal.length;
        } else {
          isSync = operation === 'any' || operation === '=';
          isSync = isSync && !_.pullAll(values, allValues).length;
        }

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      function _getStringVals(value) {
        return _.map(_.slice(value, 1), (x) => x.toString());
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('controlWidgetGroup', controlWidgetGroup);

  /** @ngInject */
  function controlWidgetGroup(
    ControlWidgetHelper,
    AdpWidgetsService
  ) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/group/control-widget-group.html',
      link: directiveLink,
    };

    function directiveLink(scope) {
      const controller = scope.controller;
      const { curVal, defaultValue } = controller.api;
      let value = _.isUndefined(controller.presetForced) ? defaultValue() : controller.presetForced;
      const { containerStyle, bgStyle, headerStyle, bodyStyle, styleOptions }
        = AdpWidgetsService.getStyleValues(controller.params, 'styling', {
        headerBgLight: '#000000',
        headerBgDark: '#FFFFFF',
        headerOpacity: 10,
      });

      scope.tooltipField = controller;
      scope.containerStyle = containerStyle;
      scope.bgStyle = bgStyle;
      scope.bodyStyle = bodyStyle;
      if (styleOptions.showTitle === 'never') {
        value = true;
        scope.hideHeader = true;
      } else {
        scope.headerStyle = headerStyle;
        scope.onClick = () => setValue(!curVal());
      }

      ControlWidgetHelper.registerValueSetter(controller, setValue);
      headerStyle.padding = null; // compensation of border radius is not required here

      setValue(value);

      function setValue(value) {
        scope.expanded = value;
        curVal(value);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('GroupSliderModule', GroupSliderModule);

  /** @ngInject */
  function GroupSliderModule() {
    return function(controller) {
      function defaultValue() {
        return _.get(controller, 'params.expanded');
      }

      function setActiveStatus() {} // required to suppress std functionality

      function transformOut(x) { return x }

      return {
        defaultValue,
        setActiveStatus,
        transformOut,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('listMultiSelectDropdownControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl:
        'client-modules/adp-widgets/widgets/control-widget/controls/list-multi-select-dropdown/list-multi-select-dropdown-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const {
        data: { allItems },
      } = controller;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;
      const onInputChange = (value) => {
        ControlWidgetHelper.setSyncAll(controller);
        curVal(value);
        return transformOut(value);
      };
      const dataSource = allItems;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      const tagBoxConfig = {
        dataSource,
        displayExpr: 'label',
        valueExpr: 'value',
        hoverStateEnabled: false,
        focusStateEnabled: false,
        isValid: true,
        showClearButton: true,
        stylingMode: 'outlined',
        dropDownOptions: {
          container: '#adp-dashboard-container',
        },
        placeholder: '',
        value: curVal(),
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputChange),
        itemTemplate(data) {
          return data.label;
        },
        tagTemplate(data) {
          return `<div class="dx-tag-content"><span>${data.label}</span>
              <div class="dx-tag-remove-button"></div>
            </div>`;
        },
      };

      element.find('.adp-cw-multi-select-dropdown').dxTagBox(tagBoxConfig);

      function setValue(value) {
        const newValue = transformIn(value, controller);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        curVal(newValue);
        updateSync(value);

        components.input.adpIgnoreEvent = true;
        components.input.option({ value: newValue });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('listSelectControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/list-select/list-select-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const {
        data: { allItems },
      } = controller;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;
      const onInputChange = (value) => {
        ControlWidgetHelper.setSyncAll(controller);
        curVal(value);
        return transformOut(value);
      };
      const dataSource = allItems;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      const selectBoxConfig = {
        dataSource,
        displayExpr: 'label',
        valueExpr: 'value',
        hoverStateEnabled: false,
        focusStateEnabled: false,
        isValid: true,
        showClearButton: true,
        stylingMode: 'outlined',
        placeholder: '',
        dropDownOptions: {
          container: '#adp-dashboard-container',
        },
        value: curVal(),
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputChange),
      };

      element.find('.adp-cw-list-select').dxSelectBox(selectBoxConfig);

      function setValue(value) {
        const newValue = transformIn(value, controller);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }
        curVal(newValue);
        updateSync(value);
        components.input.adpIgnoreEvent = true;
        components.input.option({ value: newValue });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('ListSelectModule', ListSelectModule);

  /** @ngInject */
  function ListSelectModule(ControlWidgetHelper) {
    return function (controller) {
      const allItems = ControlWidgetHelper.getAllListValues(controller);
      const allValues = _.map(allItems, (item) => item.value);

      controller.data = { allItems };

      function defaultValue() {
        const initialItem = _.find(allItems, (item) => item.selected);
        return initialItem ? initialItem.value : '';
      }

      function transformIn(value) {
        const operation = _.get(value, '0', 'empty');

        if (operation === 'empty') {
          return '';
        }

        if (operation === 'combine') {
          const candidates = _.compact(value.slice(1).map(transformIn));

          if (!candidates.length) {
            return '';
          }

          return candidates[0];
        }

        const val = value[1].toString();

        return _.indexOf(allValues, val) >= 0 ? val : '';
      }

      function transformOut(value) {
        if (value === '') {
          return ['empty'];
        } else {
          const { treatValuesAs } = controller.params;
          const typedValue = ControlWidgetHelper.castValueType(value, treatValuesAs);
          return ['=', typedValue];
        }
      }

      function updateSync(value) {
        const operation = value[0];
        const val = controller.api.transformIn(value);
        let isSync = false;

        if (operation === '=') {
          isSync = _.indexOf(allValues, val) >= 0;
        } else if (operation === 'empty') {
          const currentVal = controller.api.curVal();
          isSync = currentVal === '';
        }

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('loadPresetsControl', control);

  /** @ngInject */
  function control(
    $timeout,
    AdpModalService,
    AdpUnifiedArgs,
    AdpSchemaService,
    AdpGeneratorModalService,
    AdpNotificationService,
    ErrorHelpers,
    GraphqlCollectionMutator
  ) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/load-presets/load-presets-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, $element) {
      const presetSchema = _.cloneDeep(AdpSchemaService.getSchemaByName('_controlWidgetFilters'));
      const controller = _.get(scope, 'controller');
      const controllers = controller.api.getWidgetControllers();
      // eslint-disable-next-line no-undef
      const isLoggedIn = !lsService.isGuest();
      const { presetsPermissions, allowUpdateSubscription, allowSave, presets } = controller.params;

      scope.allowSavePreset = allowSave;
      scope.savePreset = onSavePreset(scope, $element);
      scope.presets = presets || [];

      if (!allowUpdateSubscription) {
        _.set(presetSchema, 'fields.subscribeForUpdates.showInForm', false);
      }

      setupPresetDropdown(scope, $element);

      function setupPresetDropdown(scope, $element) {
        const defaultPreset = _.find(scope.presets, (p) => p.isDefault);
        const selectBoxConfig = {
          dataSource: scope.presets,
          displayExpr: 'name',
          valueExpr: '_id',
          hoverStateEnabled: false,
          focusStateEnabled: false,
          isValid: true,
          stylingMode: 'outlined',
          placeholder: 'Select preset...',
          value: _.get(defaultPreset, '_id'),
          onItemClick: (e) => activatePreset(e.itemData),
          itemTemplate: (data, index) => {
            const $item = $(`<div class='adp-cw-preset-item'>`).append(
              `<div class='name ${data.isDefault ? 'bold' : ''}'>${data.name}</div>`
            );

            if (_.get(data, '_actions.delete')) {
              $item.append(
                $(`<div class='remove'><i class='fa fa-trash'></i></div>`).click((e) => onItemRemove(e, index))
              );
            }

            return $item;
          },
        };

        $timeout(() => $element.find('.adp-preset-list-box').dxSelectBox(selectBoxConfig), 500);

        function onItemRemove(e, index) {
          const removePreset = scope.presets[index];
          AdpModalService.confirm({ message: `Are you sure to remove '${removePreset.name}' preset?` })
            .then(() => GraphqlCollectionMutator.delete(presetSchema, { _id: removePreset._id }))
            .then(() => {
              scope.presets = _.filter(scope.presets, (p) => p._id !== removePreset._id);
              setupPresetDropdown(scope, $element);
            })
            .catch((err) => {
              if (err) {
                ErrorHelpers.handleError(err, 'Unable to delete preset');
              }
            });

          e.stopPropagation();
        }
      }

      function onSavePreset(scope, $element) {
        return () => {
          let errMessage = '';
          if (!isLoggedIn) {
            errMessage = 'Please create an account to save presets';
          }
          if (!presetsPermissions.create) {
            errMessage = "Your account doesn't have permissions to save presets";
          }
          if (errMessage) {
            AdpNotificationService.notifyError(errMessage);
            return;
          }

          const presetData = prefillPresetRow();
          const modalOptions = {
            args: AdpUnifiedArgs.getHelperParamsWithConfig({
              path: '',
              action: 'create',
              formData: presetData,
              schema: presetSchema,
            }),
          };

          return AdpGeneratorModalService.formModal(modalOptions)
            .then((result) => {
              if (!result) {
                throw new Error('canceled');
              }
              const row = _.get(result, 'args.row');
              const newId = _.get(result, 'data._id');
              const newPresetItem = _.assign(presetData, _.pick(row, ['name', 'isDefault']), { _id: newId });

              scope.presets.push(newPresetItem);
              scope.presets = _.sortBy(scope.presets, ['name']);

              if (presetData.isDefault) {
                return clearPreviousDefaults(scope, newId).then(() => newId);
              }

              return newId;
            })
            .then((newId) => setupPresetDropdown(scope, $element, newId))
            .catch((err) => {
              if (err.message !== 'canceled') {
                ErrorHelpers.handleError(err, 'Unable to save preset');
              }
            });
        };

        function clearPreviousDefaults(scope, newId) {
          const prevDefaults = _.filter(scope.presets, (preset) => preset.isDefault);
          const savePromises = _.map(prevDefaults, (preset) => {
            if (preset._id === newId) {
              return;
            }
            preset.isDefault = false;
            return GraphqlCollectionMutator.update(presetSchema, preset, ['isDefault']);
          });

          return Promise.all(savePromises);
        }

        function prefillPresetRow() {
          const data = {};
          const { widgetId } = controller;
          data.widget = { table: '_widgets', _id: widgetId };
          data.filterStates = getFilterValues(controllers);

          return data;
        }

        function getFilterValues() {
          return _(controllers)
            .sortBy(['_changedOn'])
            .map((controller) => {
              const { _id, api, activeStatus } = controller;
              if (!api) {
                return;
              }
              const { curVal, transformOut } = api;
              if (!transformOut) {
                return;
              }
              const value = transformOut(curVal());

              return { filterId: _id, value, activeStatus };
            })
            .compact()
            .value();
        }
      }

      function activatePreset(preset) {
        const controllers = controller.api.getWidgetControllers();
        const { filterStates } = preset;
        const controllersToSwitch = [];

        _.each(filterStates, (state) => {
          const { filterId, value, activeStatus } = state;
          const controller = _.find(controllers, (controller) => controller._id === filterId);
          if (!controller || !controller.api) {
            return;
          }

          if (activeStatus === 'on') {
            controller.api._setValue(value);
            controllersToSwitch.push({ controller, activeStatus });
          } else {
            controller.activeStatus = activeStatus;
          }
        });

        $timeout(
          // timeout is bad solution because potential race condition.
          // But it is required to let all controller.api._setValue() to happen before. All _.setValues is debounced by 5ms
          () =>
            _.each(controllersToSwitch, ({ controller, activeStatus }) =>
              controller.api.setActiveStatus(activeStatus === 'on', true)
            ),
          500
        );
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .factory('LoadPresetsModule', LoadPresetsModule);

  /** @ngInject */
  function LoadPresetsModule() {
    return function (controller, widgetScope) {
      function getWidgetControllers(){
        return widgetScope.controllers;
      }

      return {
        getWidgetControllers,
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('lookupListControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper, GraphqlRequest, ErrorHelpers) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/lookup-list/lookup-list-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const {
        params: { valueField, labelField = valueField },
      } = controller;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;
      const onInputChange = (value) => {
        ControlWidgetHelper.setSyncAll(controller);
        curVal(value);
        return transformOut(value);
      };

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      const fields = [valueField, labelField === valueField ? '' : labelField].join(' ');
      const queryName = controller.data.collectionName + 'Dx';
      const query = `
            query q($sort: String, $page: Int, $perPage: Int, $dxQuery: String!) {
            ${queryName} ( sort: $sort, page: $page, perPage: $perPage, filter:{ dxQuery: $dxQuery} ) {
            count items{${fields}}
            }}`;

      //ToDO: dispose this datasource object on directive end
      const dataSource = new DevExpress.data.DataSource({ load });
      const tagBoxConfig = {
        dataSource,
        displayExpr: labelField,
        valueExpr: valueField,
        hoverStateEnabled: false,
        focusStateEnabled: false,
        searchEnabled: true,
        multiline: true,
        searchExpr: labelField,
        isValid: true,
        showClearButton: true,
        stylingMode: 'outlined',
        placeholder: '',
        dropDownOptions: {
          container: '#adp-dashboard-container',
        },
        value: curVal(),
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'tagBox'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputChange),
      };

      element.find('.adp-cw-multi-select-dropdown').dxTagBox(tagBoxConfig);

      function load(params) {
        const { skip, take, searchExpr, searchOperation, searchValue } = params;
        const page = Math.floor(skip / take) + 1;
        const perPage = take || 10;
        const dxQuery = searchValue ? `['${searchExpr}','${searchOperation}','${searchValue}']` : ``;
        const variables = {
          page: _.isNaN(page) ? 1 : page,
          perPage,
          sort: `{${labelField}:1}`,
          dxQuery,
        };

        return GraphqlRequest({
          name: queryName,
          query,
          variables,
        })
          .then(({ count: totalCount, items: data }) => ({
            totalCount,
            data,
          }))
          .catch((err) => {
            ErrorHelpers.handleError(err);
          });
      }

      function setValue(value) {
        const newValue = transformIn(value, controller);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }
        curVal(newValue);
        updateSync(value);
        components.tagBox.adpIgnoreEvent = true;
        components.tagBox.option({ value: newValue });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('LookupListModule', LookupListModule);

  /** @ngInject */
  function LookupListModule(ControlWidgetHelper) {
    return function (controller) {
      const { type, dataset, model, sendValuesAs = 'string' } = controller.params;
      const collectionName = type === 'model' ? model : `_ds_${dataset._id}`;
      controller.data = { collectionName };

      function defaultValue() {
        return [];
      }

      function transformIn(value) {
        const operation = value[0];

        if (operation === 'combine') {
          const candidates = value.slice(1).map(transformIn);

          return _.chain(candidates).flatten().compact().uniq().value();
        }

        // TODO: use only intersection with known fields
        return _transformInValues(value);
        // const values = _transformInValues(value);

        // return _.intersection(allValues, values);
      }

      function transformOut(value) {
        const operation = !value || value.length === 0 ? 'empty' : value.length === 1 ? '=' : 'any';
        return [operation, ..._transformOutValues(value)];
      }

      function _transformInValues(value) {
        const values = _.slice(value, 1);
        // Values here may appear as {_id,table} objects OR just array of _id's,
        // depending on sendValueAs property of another slider.
        // Internally by controller array of id's is used.
        return _.map(values, (x) => (x?._id ? x._id : x.toString()));
      }

      function _transformOutValues(value) {
        if (sendValuesAs === 'string') {
          return value;
        }
        const table = controller.data.collectionName;
        return _.map(value, (_id) => ({ _id, table }));
      }

      function updateSync(value) {
        const operation = value[0];
        let isSync;

        if (operation === 'empty') {
          const currentVal = controller.api.curVal();
          isSync = _.isNil(currentVal) || !currentVal.length;
        } else {
          isSync = false; // Unable to sync since full values list may not be yet loaded
        }

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('locationSliderControl', control);

  /** @ngInject */
  function control(
    $timeout,
    NgMap,
    ControlWidgetHelper,
    AdpLocationControlService,
    AdpSchemaService,
    AdpUnifiedArgs,
    AdpFormDataUtils,
    GraphqlCollectionMutator,
    GraphqlRequest,
    ErrorHelpers
  ) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
        args: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/location/location-slider-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, el) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { curVal, transformIn, transformOut, updateSync, fixWithLimits, fromNativeUnits, toNativeUnits } =
        controller.api;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const { params } = controller;
      const { useDropdown } = params;
      const showInputs = params.showInputs && !useDropdown;
      const useNearRange = params.useNearRange && !useDropdown;
      const { maxFar, minFar } = controller.data;
      const rangeValueChangeHandler = ControlWidgetHelper.controlChangeHandler(
        controller,
        linksInterface,
        onRangeValue
      );

      const storeUserLocation = params.saveLastUserLocation ? _.debounce(doStoreUserLocation, 2000) : _.noop;
      const getterSetterFn = (newValue) => {
        const value = curVal();
        {
          const { label, lng, lat } = value;
          if (_.isUndefined(newValue)) {
            return { label, coordinates: [lng, lat] };
          }
          if (ControlWidgetHelper.isSameValues({ label, coordinates: [lng, lat] }, newValue)) {
            return value;
          }
        }

        const {
          label,
          coordinates: [lng, lat],
        } = newValue;
        value.label = label;
        value.lng = lng;
        value.lat = lat;
        updateDistanceText(value);
        updateDonut(value);

        curVal(value);
        ControlWidgetHelper.setSyncAll(controller);
        ControlWidgetHelper.sendLinkChangeEvents(transformOut(value), controller, linksInterface);
        storeUserLocation(value);
        return newValue;
      };

      ControlWidgetHelper.registerValueSetter(controller, setValue);

      if (useDropdown) {
        const selectBoxConfig = {
          dataSource: controller.data.rangeValues,
          displayExpr: 'label',
          valueExpr: 'value',
          hoverStateEnabled: false,
          focusStateEnabled: false,
          isValid: true,
          stylingMode: 'outlined',
          placeholder: '',
          dropDownOptions: {
            container: '#adp-dashboard-container',
          },
          title: 'Range',
          value: initialValue.far,
          onInitialized: ControlWidgetHelper.controlInitHandler(components, 'dropdown'),
          onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onDropdownValue),
        };
        _initControl('.adp-cw-list-select', 'dxSelectBox', selectBoxConfig);
      } else {
        const onRangeInitialized = ControlWidgetHelper.controlInitHandler(components, 'slider');

        if (showInputs) {
          const inputSides = useNearRange ? ['near', 'far'] : ['far'];
          _.each(inputSides, (sideName) => {
            const inputConfig = {
              min: 0,
              max: toNativeUnits(maxFar),
              value: toNativeUnits(initialValue[sideName]),
              stylingMode: 'outlined',
              valueChangeEvent: 'keyup',
              onInitialized: ControlWidgetHelper.controlInitHandler(components, sideName),
              onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, (val) =>
                onInputValue(val, sideName)
              ),
            };
            _initControl('.adp-cw-input-' + sideName, 'dxNumberBox', inputConfig).then(($el) =>
              $el.addClass('adp-cw-active')
            );
          });
        }
        if (!useNearRange) {
          const sliderConfig = {
            min: minFar,
            max: maxFar,
            value: initialValue.far,
            onInitialized: onRangeInitialized,
            onValueChanged: rangeValueChangeHandler,
          };
          _initControl('.adp-cw-bar', 'dxSlider', sliderConfig);
        } else {
          const onRangeValue = (e) => {
            if (minFar && e.value[1] < minFar) {
              components.slider.option({ start: e.value[0], end: minFar });
              return;
            }
            return rangeValueChangeHandler(e);
          };
          const rangeConfig = {
            min: 0,
            max: maxFar,
            start: initialValue.near,
            end: initialValue.far,
            onInitialized: onRangeInitialized,
            onValueChanged: onRangeValue,
          };
          _initControl('.adp-cw-bar', 'dxRangeSlider', rangeConfig);
        }
      }

      NgMap.getMap().then((map) => {
        scope.mapInstance = map;
        scope.mapInstance.setOptions({
          zoomControl: false,
          streetViewControl: false,
          scaleControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        });
      });

      updateDonut(curVal());
      updateDistanceText(curVal());

      AdpLocationControlService.locationController({ scope, el, getterSetterFn, setValidity: _.noop, params }).then(
        () => {
          let isAlreadyDetected = false;
          const restoreLocationPromise = restoreUserLocation();
          const detectPromise = params.detectUserLocation ? scope.detect() : Promise.reject();

          restoreLocationPromise.then((location) => {
            if (isAlreadyDetected) {
              return;
            }
            setLocationValue(location);
          });
          detectPromise.then(() => {
            isAlreadyDetected = true; // detector calls setter inside locationController, so detected location is set already.
          });
        }
      );

      function setValue(outsideValue) {
        const transformed = transformIn(outsideValue);
        const { value, err } = fixWithLimits(transformed);

        if (err) {
          controller.errorMessage = err;
        }

        setLocationValue(value);
      }

      function setLocationValue(value) {
        if (ControlWidgetHelper.isSameValues(value, curVal())) {
          return;
        }
        curVal(value);

        updateDonut(value);
        updateDistanceText(value);
        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          if (useNearRange) {
            components.slider.option({ start: value.near, end: value.far });
          } else {
            components.slider.option({ value: value.far });
          }
        }

        components.near && components.near.option('value', toNativeUnits(value.near));
        components.far && components.far.option('value', toNativeUnits(value.far));

        scope.addressLabel = value.label;
        setTimeout(() => {
          if (scope.mapInstance) {
            scope.mapInstance.setCenter(value);
            const marker = scope.mapInstance.markers[0];
            marker && marker.setPosition(value);
          }
        }, 500);
      }

      function onRangeValue(rangeValue) {
        const value = curVal();

        if (useNearRange) {
          value.near = roundToNative(rangeValue[0]);
          value.far = roundToNative(rangeValue[1]);
        } else {
          value.near = 0;
          value.far = roundToNative(rangeValue);
        }

        curVal(value);
        ControlWidgetHelper.setSyncAll(controller);
        updateDonut(value);
        updateDistanceText(value);
        components.near && components.near.option('value', toNativeUnits(value.near));
        components.far && components.far.option('value', toNativeUnits(value.far));
        return transformOut(value);
      }

      function onInputValue(val, sideName) {
        const value = curVal();
        value[sideName] = fromNativeUnits(val);
        if (useNearRange) {
          components.slider.option({ start: value.near, end: value.far });
        } else {
          components.slider.option({ value: value.far });
        }
        curVal(value);
        ControlWidgetHelper.setSyncAll(controller);
        updateDonut(value);
        scope.value = value;
        return transformOut(value);
      }

      function onDropdownValue(val) {
        const value = curVal();
        value.near = 0;
        value.far = val;
        curVal(value);
        ControlWidgetHelper.setSyncAll(controller);
        updateDonut(value);
        scope.value = value;
        return transformOut(value);
      }

      function updateDonut(value) {
        const CIRCLE_SIDES = 36;
        const getRadArr = (lat, r) => [r / (111111 * Math.cos(lat * (Math.PI / 180))), r / 111111];
        const roundCoord = (x) => Math.round(x * 1000000) / 1000000;
        const { lng, lat, near, far } = value;
        const doublePi = 2 * Math.PI;
        const delta = doublePi / CIRCLE_SIDES;
        const outerCircleArr = [];
        const farRadArr = getRadArr(lat, far);

        for (let angle = 0; angle < doublePi - delta / 2; angle += delta) {
          const y = lat + farRadArr[1] * Math.sin(angle);
          const x = lng + farRadArr[0] * Math.cos(angle);
          outerCircleArr.push(`[${roundCoord(y)},${roundCoord(x)}]`);
        }

        if (near) {
          const innerCircleArr = [];
          const nearRadArr = getRadArr(lat, near);
          for (let angle = doublePi; angle > delta; angle -= delta) {
            const y = lat + nearRadArr[1] * Math.sin(angle);
            const x = lng + nearRadArr[0] * Math.cos(angle);
            innerCircleArr.push(`[${roundCoord(y)},${roundCoord(x)}]`);
          }

          scope.donutShapePaths = `[[${outerCircleArr.join(',')}],[${innerCircleArr.join(',')}]]`;
          return;
        }
        scope.donutShapePaths = `[${outerCircleArr.join(',')}]`;
      }

      function doStoreUserLocation(value) {
        const schema = AdpSchemaService.getSchemaByName('_userSettings');
        const configRecordId = _.get(scope, 'args.widgetConfiguration.configRecordId');
        if (!configRecordId) {
          return;
        }
        const settingsPath = 'lastLocation';
        const location = { coordinates: [value.lng, value.lat], label: value.label };
        const formData = {
          _id: configRecordId,
          [settingsPath]: location,
        };
        const args = AdpUnifiedArgs.getHelperParamsWithConfig({
          path: '',
          schema,
          formData,
          action: null,
        });
        const data = AdpFormDataUtils.transformDataBeforeSending(args).row;
        const operation = configRecordId ? 'update' : 'create';
        return GraphqlCollectionMutator[operation](schema, data, [settingsPath]).catch((e) =>
          ErrorHelpers.handleError(e, 'Error while saving settings')
        );
      }

      function restoreUserLocation() {
        if (!params.saveLastUserLocation) {
          return Promise.resolve(curVal());
        }
        const schema = AdpSchemaService.getSchemaByName('_userSettings');
        const configRecordId = _.get(scope, 'args.widgetConfiguration.configRecordId');
        const query = `query q($dxQuery: String!) { _userSettingsDx (filter: { dxQuery: $dxQuery}) {items{_id lastLocation {coordinates label} }}}`;
        const variables = { dxQuery: `["_id", "=", "${configRecordId}"]` };
        const name = schema.schemaName + 'Dx';

        return GraphqlRequest({ name, query, variables })
          .then((result) => _.get(result, `items[0].lastLocation`))
          .then((location) => {
            if (!location) {
              return curVal();
            }
            const {
              label,
              coordinates: [lng, lat],
            } = location;
            const { near, far } = curVal();
            return { lng, lat, near, far, label };
          });
      }

      function updateDistanceText(value) {
        if (showInputs || useDropdown) {
          // No text visible
          return;
        }
        const { near, far } = value;
        if (useNearRange && near) {
          scope.distanceText = `Range from ${prettyDistance(near, false)} to ${prettyDistance(far)}`;
        } else {
          scope.distanceText = `Range up to ${prettyDistance(far)}`;
        }

        function prettyDistance(m, showUnits = true) {
          if (!m) {
            return '0';
          }
          const rounder = (x) => Math.round(x * 10) / 10;
          const printUnits = (u) => (showUnits ? u : '');
          const u = controller.params.rangeUnits;
          if (u === 'mi') {
            return rounder(m / 1609.34) + printUnits('mi');
          }

          if (m < 1000) {
            return `${m}${printUnits('m')}`;
          }
          const km = m < 100000 ? rounder(m / 1000) : Math.round(m / 1000);
          return `${km}${printUnits('km')}`;
        }
      }

      function roundToNative(value) {
        return fromNativeUnits(toNativeUnits(value, 1));
      }

      function _initControl(selector, controllerName, configObj) {
        return new Promise((resolve) => {
          $timeout(() => {
            const $el = el.find(selector);
            $el[controllerName](configObj);
            resolve($el);
          }, 500);
        });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('LocationSliderModule', LocationSliderModule);

  /** @ngInject */
  function LocationSliderModule(ControlWidgetHelper) {
    return function (controller) {
      const { params } = controller;
      const { useDropdown, dropdownValues, includeNullAddress, rangeUnits } = params;
      const useNear = params.useNearRange && !useDropdown;
      const minFar = fromNativeUnits(_.get(params, 'minFar', 0));
      const maxFar = fromNativeUnits(_.get(params, 'maxFar', 1000000));
      controller.data = { minFar, maxFar };

      if (useDropdown) {
        controller.data.rangeValues = _.map(params.dropdownValues, (row) => ({
          value: fromNativeUnits(row.value),
          label: row.label || `${row.value} ${rangeUnits}`,
        }));
      }

      function defaultValue() {
        const lng = _.get(params, 'initialPoint.coordinates.0', 0);
        const lat = _.get(params, 'initialPoint.coordinates.1', 0);
        const label = _.get(params, 'initialPoint.label', 0);
        let near, far;
        if (useDropdown) {
          near = 0;
          const initialRow = _.find(dropdownValues, (row) => row.initial) || _.get(dropdownValues, '0', 0);
          far = _.get(initialRow, 'value', 0);
        } else {
          near = useNear ? _.get(params, 'initialNear', 0) : 0;
          far = _.get(params, 'initialFar', 100000);
        }
        return transformIn([
          'geoNear',
          {
            lng,
            lat,
            near: fromNativeUnits(near),
            far: fromNativeUnits(far),
            label,
          },
        ]);
      }

      function transformIn(inValue) {
        const [op, value] = inValue;
        if (op !== 'geoNear' || !_.isObject(value)) {
          controller.error = 'Wrong data format in link event';
          return controller.api.curVal();
        }
        let { lng, lat, near, far, label } = value;
        if (!useNear) {
          near = 0;
        }
        return { lng, lat, near, far, label };
      }

      function transformOut(value) {
        const data = _.clone(value);
        if (includeNullAddress) {
          data.includeNulls = true;
        }
        return ['geoNear', data];
      }

      function updateSync() {
        const isSync = !controller.errorMessage;

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      function fixWithLimits(value) {
        const { pair, errors } = ControlWidgetHelper.fixRangeWithLimits(value.near, value.far, 0, maxFar);
        value.near = pair[0];
        value.far = pair[1];

        return { value, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      function fromNativeUnits(value) {
        if (rangeUnits === 'km') {
          return value * 1000;
        }
        if (rangeUnits === 'mi') {
          return value * 1609.34;
        }
        return value;
      }

      function toNativeUnits(value, precision = 10) {
        const rounder = (x) => Math.round(x * precision) / precision;
        if (rangeUnits === 'km') {
          return rounder(value / 1000);
        }
        if (rangeUnits === 'mi') {
          return rounder(value / 1609.34);
        }
        return rounder(value);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
        fromNativeUnits,
        toNativeUnits,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('numberInputControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/number-input/number-input-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      const onInputChange = (value) => {
        ControlWidgetHelper.setSyncAll(controller);
        curVal(value);
        return transformOut(value);
      };
      const numberBoxConfig = {
        hoverStateEnabled: false,
        focusStateEnabled: false,
        isValid: true,
        showClearButton: true,
        valueChangeEvent: 'keyup',
        stylingMode: 'outlined',
        height: 24,
        value: curVal(),
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputChange),
      };

      element.find('.adp-cw-single-number').dxTextBox(numberBoxConfig);

      function setValue(value) {
        const currentValue = curVal();
        const newValue = curVal(transformIn(value, controller));

        if (currentValue === newValue) {
          return;
        }

        updateSync(value);

        components.input.adpIgnoreEvent = true;
        components.input.option({ value: newValue });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('NumberInputModule', NumberInputModule);

  /** @ngInject */
  function NumberInputModule(ControlWidgetHelper) {
    return function (controller) {
      const procIns = {
        empty: () => '',
        '=': (v) => v[0],
        between: (v) => v[0] + '-' + v[1],
        any: (v) => v.join(','),
        combine: (v) => v.map(transformIn).join(','),
      };

      function procOut(part) {
        const valueRegStr = `(\\-?\\d+)`;
        const valueReg = RegExp(`^${valueRegStr}$`);
        const rangeReg = RegExp(`^${valueRegStr}\\-${valueRegStr}$`);

        const range = part.match(rangeReg);
        if (range) {
          const ints = [parseInt(range[1]), parseInt(range[2])].sort((a, b) => a - b);
          return ['between', Math.min(ints[0], ints[1]), Math.max(ints[0], ints[1])];
        }

        const value = part.match(valueReg);
        if (value) {
          return ['=', parseInt(value[1])];
        }

        return null;
      }

      function defaultValue() {
        return _.get(controller, 'params.initialValue', '');
      }

      function transformIn(value) {
        const [operation, ...rest] = value;
        const procIn = procIns[operation] || procIns.empty;
        return procIn(rest);
      }

      function transformOut(_value) {
        const value = (_value || '').toString();
        const parts = _.compact(value.replaceAll(' ', '').split(',').map(procOut));

        if (!parts.length) {
          return ['empty'];
        }

        if (parts.length === 1) {
          return parts[0];
        }

        if (!_.find(parts, (p) => p[0] !== '=')) {
          return ['any', ...parts.map((p) => p[1])];
        }

        return ['combine', ...parts];
      }

      function updateSync(value) {
        const operation = value[0];
        const isSync = _.includes(['combine', 'between', '=', 'any', 'empty'], operation);

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('numberRangeControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/number-range/number-range-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { min, max, allowOpenMin, allowOpenMax, showInputs, stepSize = 1 } = controller.params;
      const allowOpen = [allowOpenMin, allowOpenMax];
      const limits = [min, max];
      const { curVal, transformIn, transformOut, updateSync, fixWithLimits } = controller.api;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const $rangeElement = element.find('.adp-cw-bar');
      const sideNames = ['left', 'right'];
      const rangeConfig = {
        min,
        max,
        start: initialValue[0],
        end: initialValue[1],
        step: stepSize,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'slider'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onRangeValue),
      };

      ControlWidgetHelper.registerValueSetter(controller, setValue);

      $rangeElement.dxRangeSlider(rangeConfig);

      _.each(sideNames, function (sideName, index) {
        const isEndOpen = allowOpen[index] && initialValue[index] === limits[index];
        if (showInputs) {
          const inputConfig = {
            min,
            max,
            value: isEndOpen ? null : initialValue[index],
            stylingMode: 'outlined',
            valueChangeEvent: 'keyup',
            onInitialized: ControlWidgetHelper.controlInitHandler(components, sideName),
            onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, (val) =>
              onInputValue(val, index)
            ),
          };
          element
            .find('.adp-cw-input-' + sideName)
            .addClass('adp-cw-active')
            .dxNumberBox(inputConfig);
        }
        isEndOpen && $rangeElement.addClass(`adp-cw-range-open-${sideName}`);
      });

      function setValue(value) {
        const transformed = transformIn(value);
        const { value: newValue, err } = fixWithLimits(transformed);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        if (err) {
          controller.errorMessage = err;
        }

        curVal(newValue);
        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          components.slider.option({ start: newValue[0], end: newValue[1] });

          setInputValue(0, newValue[0]);
          setInputValue(1, newValue[1]);
        }
      }

      function onRangeValue(value) {
        ControlWidgetHelper.setSyncAll(controller);
        setInputValue(0, value[0]);
        setInputValue(1, value[1]);
        curVal(value);
        return transformOut(value);
      }

      function onInputValue(value, index) {
        const newValue = _.clone(components.slider.option('value'));
        const isEndOpen = value === null && allowOpen[index];
        newValue[index] = isEndOpen ? limits[index] : value;
        $rangeElement.toggleClass(`adp-cw-range-open-${sideNames[index]}`, isEndOpen);
        ControlWidgetHelper.setSyncAll(controller);
        components.slider.option({ start: newValue[0], end: newValue[1] });
        curVal(newValue);
        return transformOut(newValue);
      }

      function setInputValue(index, value) {
        const sideName = sideNames[index];
        if (components[sideName]) {
          const isEndOpen = allowOpen[index] && value === limits[index];
          components[sideName].option('value', isEndOpen ? null : value);
          $rangeElement.toggleClass(`adp-cw-range-open-${sideName}`, isEndOpen);
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('NumberRangeModule', NumberRangeModule);

  /** @ngInject */
  function NumberRangeModule(ControlWidgetHelper) {
    return function (controller) {
      const { min, max, allowOpenMin, allowOpenMax } = controller.params;

      function _isMinOpen(value) {
        return allowOpenMin && value[0] === min;
      }

      function _isMaxOpen(value) {
        return allowOpenMax && value[1] === max;
      }

      function defaultValue() {
        const { initialMin, initialMax } = controller.params;
        const left = _.isNil(initialMin) ? min : initialMin;
        const right = _.isNil(initialMax) ? max : initialMax;
        return [left, right];
      }

      function transformIn(value) {
        const operation = value[0];
        let start;
        let end;

        if (operation === 'empty') {
          return controller.api.defaultValue();
        }

        if (operation === 'combine') {
          return transformIn(value[1]);
        }

        start = parseInt(value[1]);

        if (operation === '>=') {
          end = max;
        } else if (operation === '<=') {
          end = start;
          start = min;
        } else if (operation !== 'between') {
          end = start;
        } else {
          end = parseInt(value[2]);
        }

        return [start, end];
      }

      function transformOut(value) {
        const openMin = _isMinOpen(value);
        const openMax = _isMaxOpen(value);
        if (openMax && openMin) {
          return ['empty'];
        }
        if (openMax) {
          return ['>=', value[0]];
        }
        if (openMin) {
          return ['<=', value[1]];
        }

        return ['between', ...value];
      }

      function updateSync(value) {
        const operation = value[0];
        const leftOpen = allowOpenMin && operation === '<=';
        const rightOpen = allowOpenMax && operation === '>=';
        const exactOperation = _.includes(['=', 'between'], operation);
        const isValueSync = !controller.errorMessage && (exactOperation || leftOpen || rightOpen);

        ControlWidgetHelper.setValueSync(controller, isValueSync);
      }

      function fixWithLimits(value) {
        const { pair, errors } = ControlWidgetHelper.fixRangeWithLimits(
          value[0],
          value[1],
          min,
          max,
          allowOpenMin,
          allowOpenMax
        );

        return { value: pair, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('numberSliderControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl:
        'client-modules/adp-widgets/widgets/control-widget/controls/number-slider/number-slider-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { min, max, showInput, showValue, stepSize = 1 } = controller.params;
      const { curVal, transformIn, transformOut, updateSync, fixWithLimits } = controller.api;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const sliderConfig = {
        min,
        max,
        value: initialValue,
        step: stepSize,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'slider'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onSliderValue),
      };

      scope.showLabel = !showInput && showValue;
      scope.controllerLabel = controller.label ? `${controller.label}:` : '';

      ControlWidgetHelper.registerValueSetter(controller, setValue);

      element.find('.adp-cw-bar').dxSlider(sliderConfig);

      if (showInput) {
        const inputConfig = {
          min,
          max,
          value: initialValue,
          stylingMode: 'outlined',
          valueChangeEvent: 'keyup',
          onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
          onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputValue),
        };
        element.find('.adp-cw-input-left').addClass('adp-cw-active').dxNumberBox(inputConfig);
      } else {
        displayValue(initialValue);
      }

      function setValue(value) {
        const transformed = transformIn(value);
        const { value: newValue, err } = fixWithLimits(transformed);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        if (err) {
          controller.errorMessage = err;
        }

        curVal(newValue);
        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          components.slider.option({ value: newValue });
          displayValue(newValue);
        }
      }

      function onSliderValue(pos) {
        ControlWidgetHelper.setSyncAll(controller);
        displayValue(pos);
        curVal(pos);
        return transformOut(pos);
      }

      function onInputValue(value) {
        ControlWidgetHelper.setSyncAll(controller);
        components.slider.option({ value });
        curVal(value);
        return transformOut(value);
      }

      function displayValue(pos) {
        if (showInput) {
          components.input && components.input.option('value', pos);
        } else if (showValue) {
          scope.valueLabel = pos;
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('NumberSliderModule', NumberSliderModule);

  /** @ngInject */
  function NumberSliderModule(ControlWidgetHelper) {
    return function (controller) {
      function defaultValue() {
        const { initialValue, min } = controller.params;
        return _.isNil(initialValue) ? min : initialValue;
      }

      function transformIn(value) {
        const operation = value[0];
        let pos;

        if (operation === 'empty') {
          return controller.api.defaultValue();
        }

        if (operation === 'combine') {
          return transformIn(value[1]);
        }

        pos = parseInt(value[1]);

        return pos;
      }

      function transformOut(pos) {
        return ['=', pos];
      }

      function updateSync(value) {
        const operation = value[0];
        const isValueSync = !controller.errorMessage && operation === '=';

        ControlWidgetHelper.setValueSync(controller, isValueSync);
      }

      function fixWithLimits(pos) {
        const { min, max } = controller.params;
        const { value, errors } = ControlWidgetHelper.fixValueWithLimits(pos, min, max);

        return { value, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('staticHtmlSliderControl', control);

  /** @ngInject */
  function control($sce, AdpWidgetsEjs) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/static-html/static-html-control.html',
      link: directiveLink,
    };

    function directiveLink(scope) {
      const controller = scope.controller;
      const {
        params: { html },
      } = controller;
      const content = AdpWidgetsEjs.render({ template: html });

      scope.safeHtml = $sce.trustAsHtml(content);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('resetAllControl', control);

  /** @ngInject */
  function control() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/reset-all/reset-all-control.html',
      link: directiveLink,
    };

    function directiveLink(scope) {
      const linksInterface = scope.interface.controlLinks;

      scope.buttonLabel = _.get(scope, 'controller.params', 'Reset all');
      scope.reset = () => linksInterface.resetAllLinksToInitial();
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('switchControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/switch/switch-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      const onInputChange = (value) => {
        ControlWidgetHelper.setSyncAll(controller);
        curVal(value);
        return transformOut(value);
      };
      const switchConfig = {
        hoverStateEnabled: false,
        focusStateEnabled: false,
        isValid: true,
        stylingMode: 'outlined',
        height: 24,
        value: curVal(),
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputChange),
      };

      element.find('.adp-cw-switch').dxSwitch(switchConfig);

      function setValue(value) {
        const currentValue = curVal();
        const newValue = curVal(transformIn(value, controller));

        if (currentValue === newValue) {
          return;
        }

        updateSync(value);

        components.input.adpIgnoreEvent = true;
        components.input.option({ value: newValue });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('SwitchModule', SwitchModule);

  /** @ngInject */
  function SwitchModule(ControlWidgetHelper) {
    return function (controller) {
      const outValueType = _.get(controller, 'params.treatValueAs', 'Boolean');
      const typeCaster = (val) => ControlWidgetHelper.castValueType(val, outValueType);
      const outValue = typeCaster(_.get(controller, 'params.value', '1'));

      function defaultValue() {
        return _.get(controller, 'params.initialState', false) ? outValue : null;
      }

      function transformIn(val) {
        const [operation, value] = val;

        if (operation === 'empty' || outValue !== typeCaster(value)) {
          return null;
        }

        return true;
      }

      function transformOut(_value) {
        if (_value) {
          return ['=', outValue];
        }
        return ['empty'];
      }

      function updateSync(value) {
        const operation = value[0];
        const isSync = _.includes(['=', 'empty'], operation);

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('stringFilterControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl:
        'client-modules/adp-widgets/widgets/control-widget/controls/string-filter/string-filter-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { curVal, transformIn, transformOut, updateSync } = controller.api;
      const { filterOperations } = controller.data;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);

      const onInputChange = (value) => {
        current(1, value);
        ControlWidgetHelper.setSyncAll(controller);
        return transformOut(curVal());
      };
      const textBoxConfig = {
        hoverStateEnabled: false,
        focusStateEnabled: false,
        isValid: true,
        showClearButton: true,
        mode: 'text',
        valueChangeEvent: 'keyup',
        stylingMode: 'outlined',
        height: 20,
        value: current(1),
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'input'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onInputChange),
      };
      const menuConfig = {
        dataSource: [
          {
            icon: getCurrentOperationIcon(current(0)),
            items: _.values(filterOperations),
          },
        ],
        height: 20,
        hideSubmenuOnMouseLeave: true,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'menu'),
        onItemClick: (event) => {
          const operation = event.itemData.operation;
          if (operation) {
            event.component.option('dataSource[0].icon', event.itemData.icon);
            ControlWidgetHelper.setSyncAll(controller);
            current(0, operation);

            ControlWidgetHelper.broadcastValue(controller, linksInterface);
          }
        },
      };

      element.find('.adp-cw-filter-menu').dxMenu(menuConfig);
      element.find('.adp-cw-filter-input').dxTextBox(textBoxConfig);

      function current(index, val) {
        const state = curVal();

        if (!_.isUndefined(val)) {
          state[index] = val;
          curVal(state);
        }

        return state[index];
      }

      function setValue(value) {
        const prevState = curVal();
        const currentState = curVal(transformIn(value));

        updateSync(value);

        if (ControlWidgetHelper.isSameValues(currentState, prevState)) {
          return;
        }

        const icon = getCurrentOperationIcon(currentState[0]);

        components.input.adpIgnoreEvent = true;
        components.input.option({ value: currentState[1] });
        components.menu.option('dataSource[0].icon', icon);
      }

      function getCurrentOperationIcon(operation) {
        return _.get(filterOperations, [operation, 'icon'], 'contains');
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('StringFilterModule', StringFilterModule);

  /** @ngInject */
  function StringFilterModule(ControlWidgetHelper) {
    return function (controller) {
      const universalOperations = [
        {
          order: 2,
          text: 'Equals',
          icon: 'equal',
          operation: '=',
        },
        {
          order: 3,
          text: 'Does not equal',
          icon: 'notequal',
          operation: '<>',
        },
      ];

      const stringOnlyOperations = [
        {
          order: 0,
          text: 'Contains',
          icon: 'contains',
          operation: 'contains',
        },
        {
          order: 1,
          text: 'Does not contain',
          icon: 'doesnotcontain',
          operation: 'notcontains',
        },
        {
          order: 4,
          text: 'Starts with',
          icon: 'startswith',
          operation: 'startswith',
        },
        {
          order: 5,
          text: 'Ends with',
          icon: 'endswith',
          operation: 'endswith',
        },
        {
          order: 6,
          text: 'Regular expression',
          icon: 'palette',
          operation: 'regex',
        },
      ];

      const isListVersion = controller.type === 'StringFilterForLists';
      const filterOperationsArr = isListVersion
        ? universalOperations
        : _.union(universalOperations, stringOnlyOperations);
      const filterOperations = _(filterOperationsArr)
        .sortBy(['order'])
        .map((x) => [x.operation, _.omit(x, ['order'])])
        .fromPairs()
        .value();
      const defaultOperation = _.keys(filterOperations)[0];

      controller.data = { filterOperations };

      function defaultValue() {
        return [defaultOperation, _.get(controller, 'params.initialValue', '')];
      }

      function transformIn(value) {
        const operation = _.get(filterOperations, [value[0], 'operation']);
        const op = operation || _.get(controller, '_currentValue.0') || defaultOperation;

        return [op, value[1] || ''];
      }

      function transformOut(value) {
        if (_.isNil(value[1])) {
          return ['empty'];
        } else {
          if (value[1] === '' && value[0] !== '<>') {
            return ['empty'];
          } else {
            return value;
          }
        }
      }

      function updateSync(value) {
        const isSync = !!_.get(filterOperations, [value[0], 'operation']) || value[0] === 'empty';

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('timeRangeControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/time-range/time-range-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const components = {};
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const { allowOpenMin, allowOpenMax, timeOnly, showInputs, inputDisplayFormat } = controller.params;
      const { curVal, transformIn, transformOut, updateSync, fixWithLimits, datesToSeconds, secondsToDates } =
        controller.api;
      const { limitsSec } = controller.data;
      const initialValue = ControlWidgetHelper.initValue(controller, linksInterface);
      const allowOpen = [allowOpenMin, allowOpenMax];
      const timePrecision = ControlWidgetHelper.getSecondsByUnitName(controller.params.timePrecision);
      const $rangeElement = element.find('.adp-cw-bar');
      const rangeConfig = {
        min: limitsSec[0],
        max: limitsSec[1],
        start: initialValue[0],
        end: initialValue[1],
        step: timePrecision,
        onInitialized: ControlWidgetHelper.controlInitHandler(components, 'slider'),
        onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, onRangeValue),
      };

      $rangeElement.dxRangeSlider(rangeConfig);

      const sideNames = ['left', 'right'];
      const dateValues = secondsToDates(initialValue);
      const limitsDate = secondsToDates(limitsSec);

      _.each(sideNames, function (sideName, index) {
        const isEndOpen = allowOpen[index] && initialValue[index] === limitsDate[index];
        if (showInputs) {
          const inputConfig = {
            min: limitsDate[0],
            max: limitsDate[1],
            value: isEndOpen ? null : dateValues[index],
            stylingMode: 'outlined',
            pickerType: 'calendar',
            displayFormat: inputDisplayFormat || 'shortDate',
            showDropDownButton: false,
            openOnFieldClick: true,
            dropDownOptions: {
              container: '#adp-dashboard-container',
            },
            type: 'time',
            onInitialized: ControlWidgetHelper.controlInitHandler(components, sideName),
            onValueChanged: ControlWidgetHelper.controlChangeHandler(controller, linksInterface, (val) =>
              onInputValue(val, index)
            ),
          };
          element
            .find('.adp-cw-input-' + sideName)
            .addClass('adp-cw-active')
            .dxDateBox(inputConfig);
        }
      });

      ControlWidgetHelper.registerValueSetter(controller, setValue);

      function setValue(value) {
        const transformed = transformIn(value);
        const { value: newValue, err } = fixWithLimits(transformed);
        if (ControlWidgetHelper.isSameValues(newValue, curVal())) {
          return;
        }

        curVal(newValue);

        if (err) {
          controller.errorMessage = err;
        }

        updateSync(value);

        if (components.slider) {
          components.slider.adpIgnoreEvent = true;
          components.slider.option({ start: newValue[0], end: newValue[1] });

          setInputValue(0, newValue[0]);
          setInputValue(1, newValue[1]);
        }
      }

      function onRangeValue(value) {
        ControlWidgetHelper.setSyncAll(controller);

        setInputValue(0, value[0]);
        setInputValue(1, value[1]);

        curVal(value);
        return transformOut(value);
      }

      function onInputValue(value, index) {
        const newValue = curVal();
        const isEndOpen = value === null && allowOpen[index];
        if (isEndOpen) {
          newValue[index] = limitsSec[index];
        } else {
          const secs = datesToSeconds([value]);
          newValue[index] = secs[0];
        }
        $rangeElement.toggleClass(`adp-cw-range-open-${sideNames[index]}`, isEndOpen);
        ControlWidgetHelper.setSyncAll(controller);
        const currentValue = curVal(newValue);
        components.slider.option({ start: currentValue[0], end: currentValue[1] });
        return transformOut(currentValue);
      }

      function setInputValue(index, value) {
        const sideName = sideNames[index];
        if (components[sideName]) {
          const isEndOpen = allowOpen[index] && value === limitsSec[index];
          components[sideName].option('value', isEndOpen ? null : secondsToDates(value));
          $rangeElement.toggleClass(`adp-cw-range-open-${sideName}`, isEndOpen);
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('TimeRangeModule', TimeRangeModule);

  /** @ngInject */
  function TimeRangeModule(ControlWidgetHelper) {
    return function (controller) {
      const { allowOpenMin, allowOpenMax } = controller.params;
      const limitsSec = _getRangeLimitsInSeconds();

      controller.data = { limitsSec };

      function _isMinOpen(value) {
        return allowOpenMin && value[0] === limitsSec[0];
      }

      function _isMaxOpen(value) {
        return allowOpenMax && value[1] === limitsSec[1];
      }

      function hhmmStringToSeconds(value) {
        if (_.isNil(value)) {
          return null;
        }

        const sec =
          dayjs(value.padEnd(6, '0'), 'HHmmss').set('year', 2000).set('month', 1).set('date', 2).toDate().getTime() /
          1000;

        return Math.floor(sec);
      }

      function _getRangeLimitsInSeconds() {
        const { min, max } = controller.params;
        return _.map([min, max], (val) => hhmmStringToSeconds(val));
      }

      function defaultValue() {
        const { initialMin, initialMax } = controller.params;
        return _.map([initialMin, initialMax], (val, index) =>
          _.isNil(val) ? limitsSec[index] : hhmmStringToSeconds(val, true)
        );
      }

      function transformIn(value) {
        const operation = value[0];
        let start;
        let end;

        if (operation === 'empty') {
          return [limitsSec[0], limitsSec[1]];
        }

        const secs = datesToSeconds(_.slice(value, 1));
        start = secs[0];

        if (operation === '>=') {
          end = limitsSec[1];
        } else if (operation === '<=') {
          end = start;
          start = limitsSec[0];
        } else if (operation !== 'between') {
          end = secs[0];
        } else {
          end = secs[1];
        }

        return [start, end];
      }

      function transformOut(value) {
        const openMin = _isMinOpen(value);
        const openMax = _isMaxOpen(value);
        const dates = secondsToDates(value);
        if (openMax && openMin) {
          return ['empty'];
        }
        if (openMax) {
          return ['>=', dates[0]];
        }
        if (openMin) {
          return ['<=', dates[1]];
        }

        return ['between', ...dates];
      }

      function updateSync(value) {
        const operation = value[0];
        const leftOpen = allowOpenMin && operation === '<=';
        const rightOpen = allowOpenMax && operation === '>=';
        const exactOperation = _.includes(['=', 'between'], operation);
        const isValueSync = !controller.errorMessage && (exactOperation || leftOpen || rightOpen);

        ControlWidgetHelper.setValueSync(controller, isValueSync);
      }

      function fixWithLimits(value) {
        const { pair, errors } = ControlWidgetHelper.fixRangeWithLimits(
          value[0],
          value[1],
          limitsSec[0],
          limitsSec[1],
          allowOpenMin,
          allowOpenMax
        );

        return { value: pair, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      function datesToSeconds(value) {
        return _.map(value, (val) => {
          const date = _.isString(val) ? new Date(val) : val;
          date.setFullYear(2000, 1, 2);
          return date.getTime() / 1000;
        });
      }

      function secondsToDates(value) {
        const convert = (val) =>
          dayjs(val * 1000)
            .set('year', 2000)
            .set('month', 1)
            .set('date', 2)
            .format('YYYY-MM-DDTHH:mm:ss.000Z');
        return _.isArray(value) ? _.map(value, convert) : convert(value);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
        datesToSeconds,
        secondsToDates,
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .directive('timelapseListControl', control);

  /** @ngInject */
  function control(
    ControlWidgetHelper,
    TimelapseControlHelper,
    $interval
  ) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/timelapse-list/timelapse-list-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const controller = scope.controller;
      const linksInterface = scope.interface.controlLinks;
      const {curVal, transformIn, updateSync} = controller.api;
      const {params: conf, data:{allItems, allValues}} = controller;
      const transformers = {
        posByUnit: (x, from) => (!_.isUndefined(from) ? from : controller.params.from) + x,
      };
      const rangeMode = 'list';
      const mode = TimelapseControlHelper.getModeMethods(rangeMode, transformers);

      let $inputs;
      let playTimer = null;
      let allowedToStep = true;
      let restartPlayAfterLoad = false;
      let currentDirection = conf.startDirection === 'backward' ? -1 : 1;

      conf.from = 0;
      conf.to = Math.max(allItems.length - 1, 0);
      conf.rangeSize = 1;

      controller.mode = mode;

      scope.isPlaying = false;
      scope.mode = rangeMode;
      scope.play = () => doPlay(conf);
      scope.stepForward = () => doStepForward(conf);
      scope.stepBack = () => doStepBack(conf);
      scope.toggleItem = val => onItemClick(conf, val);
      scope.items = conf.showOptionsList ? allItems : [];
      scope.columns = conf.columns || 1;

      ControlWidgetHelper.initValue(controller, linksInterface);
      ControlWidgetHelper.registerValueSetter(controller, setValue);
      ControlWidgetHelper.registerOnStateChange(controller, onStateChange);
      setupEvents(scope, element);
      _.defer(() => updateControlPosition(conf));

      function setValue(value) {
        curVal(transformIn(value));

        updateSync(value)

        if (!scope.isPlaying) {
          updateControlPosition(conf);
        }
      }

      function doPlay(conf) {
        scope.isPlaying = !scope.isPlaying;

        if (scope.isPlaying) {
          if (curVal() < 0) {
            curVal(mode.getStartPosition(conf));
          }

          startPlayInterval(conf);
        } else {
          cancelPlayInterval();
        }
      }

      function doStepForward(conf) {
        if (!scope.allowStepForward || !allowedToStep) {
          return;
        }
        doOneStep(conf, 1);
        updateOnStep(conf);
      }

      function doStepBack(conf) {
        if (!scope.allowStepBack || !allowedToStep) {
          return;
        }
        doOneStep(conf, -1);
        updateOnStep(conf);
      }

      function onItemClick(conf, val) {
        const clickedPosition = _.findIndex(allValues, x => x === val);

        if (!scope.isPlaying && clickedPosition === curVal()) {
          curVal(-1);

          updateListElements(conf);
          updateControlState(conf);
          sendCurrentValue(conf);

          return;
        }
        curVal(clickedPosition);

        updateOnStep(conf);
      }

      function doOneStep(conf, direction) {
        curVal(curVal() + direction);
      }

      function startPlayInterval(conf) {
        cancelPlayInterval();

        intervalStep();
        playTimer = $interval(intervalStep, conf.stepTime);

        function intervalStep() {
          if (!allowedToStep) {
            cancelPlayInterval();
            restartPlayAfterLoad = true;
            return;
          }

          doOneStep(conf, currentDirection);
          updateOnStep(conf);
        }
      }

      function cancelPlayInterval() {
        $interval.cancel(playTimer);
        restartPlayAfterLoad = false;
      }

      function sendCurrentValue(conf, opts) {
        const options = opts || {};

        if (conf.syncDataLoad) {
          allowedToStep = false;
          options.readyResolver = () => {
            allowedToStep = true;
            if (restartPlayAfterLoad) {
              startPlayInterval(conf);
              restartPlayAfterLoad = false;
            }
          }
        }

        ControlWidgetHelper.broadcastValue(controller, linksInterface, options);
      }

      function updateControlPosition(conf) {
        updateListElements(conf);
        updateControlState(conf);
      }

      function updateControlState(conf) {
        updateDisplayString(conf);

        scope.allowStepForward = curVal() > -1 && curVal() < conf.to;
        scope.allowStepBack = curVal() > conf.from;
      }

      function updateListElements(conf) {
        if (!conf.showOptionsList) {
          return;
        }

        if (!$inputs || !$inputs.length) {
          $inputs = $('input', element);
        }
        $inputs.prop('checked', false);

        const inp = _.get($inputs, curVal());

        if (inp) {
          $(inp).prop('checked', true);
        }
      }

      function updateDisplayString(conf) {
        if (!conf.showOptionsList) {
          const val = allValues[curVal()];
          const item = _.find(allItems, x => x.value === val);
          scope.displayString = _.get(item, 'safeHtmlLabel') || '';
        }
      }

      function updateOnStep(conf) {
        const edges = mode.edgesStatus(curVal(), conf);

        if (edges.isViolated) {
          if (conf.loopMode === 'bounce') {
            currentDirection *= -1;
            curVal(edges.sameSide);
            doOneStep(conf, currentDirection);
          } else if (conf.loopMode === 'once') {
            curVal(edges.sameSide);
            scope.isPlaying = false;
            cancelPlayInterval();
          } else {
            curVal(edges.oppositeSide);
          }
        }

        ControlWidgetHelper.setSyncAll(controller);

        updateControlPosition(conf);
        sendCurrentValue(conf);
      }

      function onStateChange(state) {
        if (state !== 'on') {
          scope.isPlaying = false;
          cancelPlayInterval();
        }
      }

      function setupEvents(scope, element) {
        scope.$on('$destroy', cancelPlayInterval);
        element.on('$destroy', cancelPlayInterval);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('TimelapseListModule', TimelapseListModule);

  /** @ngInject */
  function TimelapseListModule(ControlWidgetHelper) {
    return function (controller) {
      const allItems = ControlWidgetHelper.getAllListValuesSafeHtmlLabel(controller);
      const allValues = _.map(allItems, (item) => item.value);

      controller.data = { allItems, allValues };

      function defaultValue() {
        const index = Math.max(_.findIndex(allItems, (item) => item.selected));

        if (index < 0) {
          return;
        }

        return index;
      }

      function transformIn(value) {
        const operation = value[0];

        if (operation === 'empty') {
          return -1;
        }

        if (operation === 'combine') {
          return transformIn(value[1]);
        }

        const strVal = (value[1] || '').toString();

        return _.findIndex(allValues, (x) => x === strVal);
      }

      function transformOut(value) {
        const { treatValuesAs } = controller.params;
        let currentVal = _.get(allValues, value, null);
        if (_.isNull(currentVal)) {
          return ['empty'];
        }
        const typedValue = ControlWidgetHelper.castValueType(currentVal, treatValuesAs);
        return ['=', typedValue];
      }

      function updateSync(value) {
        const operation = value[0];
        const isSync = operation === '=' && allValues.indexOf(value[1].toString()) >= 0;

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
      };
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('TimelapseControlHelper', helper);

  /** @ngInject */
  function helper(
    ControlWidgetHelper,
    TimelapseModeFixedRange,
    TimelapseModeFixedFrom,
    TimelapseModeFixedTo,
    TimelapseModeCommon,
    $interval
  ) {
    function getModeMethods(name, transformers) {
      const modes = {
        fixedRange: TimelapseModeFixedRange,
        fixedFrom: TimelapseModeFixedFrom,
        fixedTo: TimelapseModeFixedTo,
        list: TimelapseModeCommon,
      };

      const modeApiFactory = modes[name] || modes.fixedRange;
      const mode = modeApiFactory(transformers);

      mode.transformers = transformers;

      return mode;
    }

    function setupControlLogic(scope, element, transformers) {
      const MOVE_THROTTLE_INTERVAL = 50;
      const controller = scope.controller;
      const { params: conf } = controller;
      const linksInterface = scope.interface.controlLinks;
      const onMoveThrottled = _.throttle(onMove, MOVE_THROTTLE_INTERVAL);
      const rangeMode = conf.rangeMode || 'fixedRange';
      const { curVal, transformIn, updateSync, fixWithLimits } = controller.api;
      const mode = getModeMethods(rangeMode, transformers);

      controller.mode = mode;

      let playTimer = null;
      let allowedToStep = true;
      let restartPlayAfterLoad = 0;
      let restartPlayMark;
      let prevDragPosition = null;

      ControlWidgetHelper.initValue(controller, linksInterface);

      scope.isPlaying = false;
      scope.mode = rangeMode;
      scope.play = doPlay;
      scope.stepForward = doStepForward;
      scope.stepBack = doStepBack;

      conf.currentDirection = conf.startDirection === 'backward' ? -1 : 1;

      mode.prepareDomElements(element, conf);

      setupEvents(scope, element, conf);

      ControlWidgetHelper.registerValueSetter(controller, setValue);
      ControlWidgetHelper.registerOnStateChange(controller, onStateChange);

      _.defer(() => {
        recalculateConfigValues(conf);
        updateControlPosition();
      });

      function setValue(value) {
        const transformed = transformIn(value);
        const { value: fixed, err } = fixWithLimits(transformed);

        curVal(fixed);
        updateSync(value);

        if (err.length) {
          controller.errorMessage = err;
        }

        if (!scope.isPlaying) {
          // Playing control will force correct values quite soon, no need in error messages
          updateControlPosition();
        }
      }

      function onDrag(event, ui) {
        const left = ui.position.left;

        onMoveThrottled(left);
      }

      function onMove(left) {
        const leftOnGrid = Math.round(left / conf.gridStep) * conf.gridStep;

        if (prevDragPosition !== leftOnGrid) {
          const gridPosition = mode.positionFromOffset(leftOnGrid, conf);
          const currentStep = Math.round((gridPosition - conf.from) / transformers.scaledSize(conf.stepSize));

          curVal(transformers.posByUnit(currentStep * conf.stepSize, conf.from, conf.stepUnits));
          const edges = mode.edgesStatus(curVal(), conf);

          if (edges.isViolated) {
            curVal(edges.sameSide);
          }

          const left = mode.offsetFromPosition(curVal(), conf);
          controller.activeStatus = 'on';
          mode.updateDomElements(left, conf);
          updateControlState();
          sendCurrentValue();

          ControlWidgetHelper.setValueSync(controller, true);
          prevDragPosition = leftOnGrid;
        }
      }

      function onTrackClick(e) {
        const rangeSizeInPixels = mode.offsetFromPosition(conf.from + transformers.scaledSize(conf.stepSize), conf);
        let clickOffset = e.offsetX - rangeSizeInPixels / 2;

        if (e.target !== e.currentTarget) {
          const left = mode.offsetFromPosition(curVal(), conf);
          clickOffset += left;
        }

        onMoveThrottled(clickOffset);

        alignDragHandler();
      }

      function doPlay() {
        scope.isPlaying = !scope.isPlaying;

        if (scope.isPlaying) {
          startPlayInterval();
        } else {
          cancelPlayInterval();
        }
      }

      function doStepForward() {
        if (!scope.allowStepForward || !allowedToStep) {
          return;
        }
        doOneStep(1);
        updateOnStep();
      }

      function doStepBack() {
        if (!scope.allowStepBack || !allowedToStep) {
          return;
        }
        doOneStep(-1);
        updateOnStep();
      }

      function doOneStep(direction) {
        curVal(transformers.posByUnit(conf.stepSize * direction, curVal(), conf.stepUnits));
      }

      function startPlayInterval(mark) {
        cancelPlayInterval();

        if (mark && mark !== restartPlayMark) {
          restartPlayAfterLoad = true;
          return;
        }
        intervalStep();
        playTimer = $interval(intervalStep, conf.stepTime);

        function intervalStep() {
          if (!allowedToStep) {
            cancelPlayInterval();
            restartPlayAfterLoad = true;
            return;
          }

          doOneStep(conf.currentDirection);
          updateOnStep();
        }
      }

      function cancelPlayInterval() {
        $interval.cancel(playTimer);
        restartPlayAfterLoad = false;
      }

      function sendCurrentValue(opts) {
        const options = opts || {};
        const mark = Math.floor(Math.random()*100000);
        restartPlayMark = mark;

        if (conf.syncDataLoad) {
          allowedToStep = false;
          options.readyResolver = () => {
            allowedToStep = true;
            if (restartPlayAfterLoad) {
              restartPlayAfterLoad = false;
              startPlayInterval(mark);
            }
          };
        }

        ControlWidgetHelper.broadcastValue(controller, linksInterface, options);
      }

      function alignDragHandler(left) {
        const leftPx = !_.isUndefined(left) ? left : mode.offsetFromPosition(curVal(), conf);
        const leftPr = (leftPx * 100) / conf.barWidth + '%';
        conf.draggingElem.css('left', leftPr);
      }

      function updateControlPosition() {
        const left = mode.offsetFromPosition(curVal(), conf);

        mode.updateDomElements(left, conf);
        alignDragHandler(left);

        updateControlState();
      }

      function updateControlState() {
        updateDisplayString();

        const allowControls = mode.allowStepControls(curVal(), conf);
        scope.allowStepForward = allowControls[0];
        scope.allowStepBack = allowControls[1];
      }

      function updateDisplayString() {
        if (conf.showValues) {
          scope.displayString = mode.getDisplayString(curVal(), conf);
        }
      }

      function updateOnStep() {
        const edges = mode.edgesStatus(curVal(), conf);

        if (edges.isViolated) {
          if (conf.loopMode === 'bounce') {
            curVal(edges.sameSide);
            conf.currentDirection *= -1;
            doOneStep(conf.currentDirection);
          } else if (conf.loopMode === 'once') {
            curVal(edges.sameSide);
            scope.isPlaying = false;
            cancelPlayInterval();
          } else {
            curVal(edges.oppositeSide);
          }
        }

        ControlWidgetHelper.setSyncAll(controller);
        updateControlPosition();
        sendCurrentValue();
      }

      function recalculateConfigValues(conf) {
        const steps = (conf.to - conf.from) / transformers.scaledSize(conf.stepSize);

        conf.barWidth = conf.boundaryElem.width();
        conf.widthToGo = mode.getBarWidthAvailable(conf);
        conf.boxOffset = conf.boundaryElem.offset();
        conf.gridStep = conf.barWidth / steps;

        prevDragPosition = null;
      }

      function onWinResize() {
        recalculateConfigValues(conf);
        updateControlPosition();
      }

      function onStateChange(state) {
        if (state !== 'on') {
          scope.isPlaying = false;
          cancelPlayInterval();
        }
      }

      function setupEvents(scope, element, conf) {
        conf.draggingElem.on('click', (e) => e.stopPropagation());
        conf.boundaryElem.on('click', onTrackClick);

        $(conf.draggingElem).draggable({
          axis: 'x',
          containment: 'parent',
          drag: onDrag,
          stop: () => setTimeout(alignDragHandler, MOVE_THROTTLE_INTERVAL * 2),
        });
        scope.$on('widgetTileResize', onWinResize);
        $(window).on('resize', onWinResize);
        scope.$on('$destroy', disposeEvents);
        element.on('$destroy', disposeEvents);
      }

      function disposeEvents() {
        $(window).off('resize', onWinResize);
        cancelPlayInterval();
      }
    }

    return {
      getModeMethods,
      setupControlLogic,
    };
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('timelapseDateTimeControl', control);

  /** @ngInject */
  function control(ControlWidgetHelper, TimelapseControlHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/timelapse-ranges/timelapse-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const controller = scope.controller;
      const transformers = getTransformers(controller);
      const fromPoint = ControlWidgetHelper.getDateTimePoint(controller.params.from);
      const toPoint = ControlWidgetHelper.getDateTimePoint(controller.params.to);
      const initialPoint = ControlWidgetHelper.getDateTimePoint(controller.params.initialValue, true);

      // mutating parameters let us unify approach across timelapse modes
      controller.params.from = transformers.fromData(fromPoint);
      controller.params.to = transformers.fromData(toPoint);
      controller.params.initialValue = _.isNil(initialPoint) ? null : transformers.fromData(initialPoint);

      TimelapseControlHelper.setupControlLogic(scope, element, transformers);

      function getTransformers(controller) {
        const { params } = controller;
        const stepScale = ControlWidgetHelper.getSecondsByUnitName(params.stepUnits);
        const rangeScale = ControlWidgetHelper.getSecondsByUnitName(params.rangeUnits);
        const dateToSeconds = (dateOrString) => {
          const t = new Date(dateOrString);
          return Math.floor(t.getTime() / 1000);
        }
        const secondsToDate = (x) => new Date(x * 1000);
        const secondsToFormat = (sec) =>
          DevExpress.localization.formatDate(secondsToDate(sec), params.displayFormat || 'shortDate');
        const posByUnit = (x, from, unit) => {
          const fromDate = dayjs.unix(from || params.from);
          const stepDate = fromDate.add(x, unit);

          return stepDate.unix();
        };

        return {
          toData: secondsToDate,
          fromData: dateToSeconds,
          toScreen: secondsToFormat,
          toSend: secondsToDate,
          scaledSize: (x) => x * stepScale,
          scaledRange: (x) => x * rangeScale,
          posByUnit,
        };
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').directive('timelapseNumControl', control);

  /** @ngInject */
  function control(TimelapseControlHelper) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        interface: '<',
        controller: '<',
      },
      templateUrl: 'client-modules/adp-widgets/widgets/control-widget/controls/timelapse-ranges/timelapse-control.html',
      link: directiveLink,
    };

    function directiveLink(scope, element) {
      const controller = scope.controller;

      // Defer is required since DOM is not ready here at least in case of fixed scrollbars on macOs
      _.defer(() => TimelapseControlHelper.setupControlLogic(scope, element, getTransformers(controller)));

      function getTransformers(controller) {
        const asIs = (x) => x;

        return {
          toData: (x) => x.toString(),
          fromData: (x) => parseInt(x),
          toScreen: asIs,
          toSend: asIs,
          scaledSize: asIs,
          scaledRange: asIs,
          posByUnit: (x, from) => (!_.isUndefined(from) ? from : controller.params.from) + x,
        };
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('TimelapseRangeModule', TimelapseRangeModule);

  /** @ngInject */
  function TimelapseRangeModule(ControlWidgetHelper) {
    return function (controller) {
      function defaultValue() {
        const { initialValue } = controller.params;
        if (_.isNil(initialValue)) {
          return transformIn(['empty']);
        }

        return initialValue;
      }

      function transformIn(value) {
        const { mode, params } = controller;
        const operation = value[0];
        const { fromData } = mode.transformers;
        let val;

        if (operation === 'empty') {
          const statPos = mode.getStartPosition(params);
          return mode.getValueFromArray(statPos);
        }

        if (operation === 'combine') {
          return transformIn(value[1]);
        }

        const values = _.slice(value, 1);
        val = operation !== 'between' ? values[0] : mode.getValueFromArray(values);
        val = fromData(val);

        return val;
      }

      function transformOut(value) {
        const { mode, params } = controller;

        return ['between', ...mode.valueFromPosition(value, params)];
      }

      function updateSync(value) {
        const { mode, params } = controller;
        const operation = value[0];
        const isSync = operation === 'between' && !controller.errorMessage && mode.isValueSynchronized(value, params);

        ControlWidgetHelper.setValueSync(controller, isSync);
      }

      function fixWithLimits(value) {
        const errors = [];
        const { mode, params } = controller;
        const val = mode.fixValueByLimits(value, params, errors);

        return { value: val, err: ControlWidgetHelper.getExceedLimitsErrorMessage(errors) };
      }

      return {
        defaultValue,
        transformIn,
        transformOut,
        updateSync,
        fixWithLimits,
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular.module('app.adpWidgets')
    .factory('AdpArMarkerService', AdpArMarkerService);

  function AdpArMarkerService() {
    function encodeImageURL(imageURL) {
      return new Promise((resolve) => {
        const image = new Image;
        image.onload = () => resolve(encodeImage(image))
        image.src = imageURL;
      })
    }

    function encodeImage(image) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = 16;
      canvas.height = 16;

      let patternFileString = '';
      for (let orientation = 0; orientation > -2 * Math.PI; orientation -= Math.PI / 2) {
        context.save();
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate(orientation);
        context.drawImage(image, -canvas.width / 2, -canvas.height / 2, canvas.width, canvas.height);
        context.restore();

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height)

        if (orientation !== 0) patternFileString += '\n'
        // NOTE bgr order and not rgb!!! so from 2 to 0
        for (let channelOffset = 2; channelOffset >= 0; channelOffset--) {
          for (let y = 0; y < imageData.height; y++) {
            for (let x = 0; x < imageData.width; x++) {
              const offset = (y * imageData.width * 4) + (x * 4) + channelOffset
              const value = imageData.data[offset]
              if (x !== 0) {
                patternFileString += ' ';
              }
              patternFileString += String(value).padStart(3);
            }
            patternFileString += '\n';
          }
        }
      }

      return patternFileString;
    }

    return {
      encodeImageURL,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .factory('TimelapseModeCommon', TimelapseModeCommon);

  /** @ngInject */
  function TimelapseModeCommon() {
    return function (transformer) {
      function prepareDomElements(element, conf) {
        conf.boundaryElem = element.find('.adp-cw-timelapse-bar-boundary');
        conf.handlerElem = element.find('.adp-cw-timelapse-track-color');
        conf.draggingElem = element.find('.adp-cw-timelapse-drag-handle');
      }

      function getStartPosition(conf) {
        return conf.startDirection === 'backward' ? conf.to : conf.from;
      }

      function getDisplayString(cur, conf) {
        return transformer.toScreen(cur) + ' - ' + transformer.toScreen(conf.to)
      }

      function updateDomElements(left, conf) {
        conf.handlerElem.css({
          left: left,
          width: (left / conf.barWidth * 100) + '%',
        });

        conf.leftBallElem.css({left});
      }

      function getValueFromArray(value) {
        return value[0];
      }

      function fixValueByLimits(val, conf, err) {
        if (val < conf.from) {
          err.push('Min');
          val = conf.from;
        }
        if (val > conf.to) {
          err.push('Max');
          val = conf.to;
        }

        return val;
      }

      function valueFromPosition(cur, conf) {
        const start = transformer.toSend(cur);
        const finish = transformer.toSend(conf.to);

        return [start, finish];
      }

      function offsetFromPosition(cur, conf) {
        const wholeRange = conf.to - conf.from;
        const progress = (cur - conf.from) / wholeRange;
        return progress * conf.barWidth;
      }

      function positionFromOffset(left, conf) {
        const progress = left / conf.barWidth;
        const pos = conf.from + (conf.to - conf.from) * progress;
        return Math.min(Math.max(conf.from, pos), conf.to);
      }

      function allowStepControls(currentPosition, conf) {
        return [
          currentPosition < conf.to,
          currentPosition > conf.from,
        ]
      }

      function edgesStatus(cur, conf) {
        const leftViolated = cur < conf.from;
        const rightViolated = cur > conf.to;
        const left = conf.from;
        const right = conf.to;

        return {
          isViolated: leftViolated || rightViolated,
          sameSide: leftViolated ? left : right,
          oppositeSide: leftViolated ? right : left,
        }
      }

      function getBarWidthAvailable(conf) {
        return conf.barWidth;
      }

      return {
        prepareDomElements,
        getStartPosition,
        getDisplayString,
        updateDomElements,
        getValueFromArray,
        fixValueByLimits,
        valueFromPosition,
        offsetFromPosition,
        positionFromOffset,
        allowStepControls,
        edgesStatus,
        getBarWidthAvailable,
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .factory('TimelapseModeFixedFrom', TimelapseModeFixedFrom);

  /** @ngInject */
  function TimelapseModeFixedFrom(TimelapseModeCommon) {
    return function (transformer) {
      const commonMethods = TimelapseModeCommon(transformer);

      function prepareDomElements(element, conf) {
        commonMethods.prepareDomElements(element, conf);
        conf.rightBallElem = element.find('.adp-cw-timelapse-ball.right');
      }

      function getStartPosition(conf) {
        return [conf.from, conf.startDirection === 'backward' ? conf.to : conf.from]
      }

      function getValueFromArray(value) {
        return value[1];
      }

      function getDisplayString(cur, conf) {
        return transformer.toScreen(conf.from) + ' - ' + transformer.toScreen(cur)
      }

      function updateDomElements(left, conf) {
        conf.handlerElem.css({
          left: 0,
          width: (left / conf.barWidth * 100) + '%',
        });

        conf.rightBallElem.css({left});
      }

      function isValueSynchronized(value, conf){
        return transformer.fromData(value[1]) === conf.from;
      }

      function valueFromPosition(cur, conf) {
        var start = transformer.toSend(conf.from);
        var finish = transformer.toSend(cur);

        return [start, finish];
      }

      return {
        getDisplayString,
        updateDomElements,
        isValueSynchronized,
        valueFromPosition,
        prepareDomElements,
        getStartPosition,
        getValueFromArray,
        fixValueByLimits: commonMethods.fixValueByLimits,
        offsetFromPosition: commonMethods.offsetFromPosition,
        positionFromOffset: commonMethods.positionFromOffset,
        allowStepControls: commonMethods.allowStepControls,
        edgesStatus: commonMethods.edgesStatus,
        getBarWidthAvailable: commonMethods.getBarWidthAvailable,
      }
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets').factory('TimelapseModeFixedRange', TimelapseModeFixedRange);

  /** @ngInject */
  function TimelapseModeFixedRange(TimelapseModeCommon) {
    return function (transformer) {
      const commonMethods = TimelapseModeCommon(transformer);

      function prepareDomElements(element, conf) {
        const handlerWidthPercent = transformer.scaledRange(conf.rangeSize) / (conf.to - conf.from);

        commonMethods.prepareDomElements(element, conf);
        conf.leftBallElem = element.find('.adp-cw-timelapse-ball.left');
        conf.rightBallElem = element.find('.adp-cw-timelapse-ball.right');
        conf.draggingElem.css({ width: handlerWidthPercent * 100 + '%' });
      }

      function _getMaxLimit(conf) {
        return _rangeLeftSide(conf.to, conf);
      }

      function _rangeRightSide(x, conf) {
        return transformer.posByUnit(conf.rangeSize, x, conf.rangeUnits);
      }

      function _rangeLeftSide(x, conf) {
        return transformer.posByUnit(-conf.rangeSize, x, conf.rangeUnits);
      }

      function getStartPosition(conf) {
        if (conf.startDirection === 'backward') {
          return [_getMaxLimit(conf), conf.to];
        } else {
          return [conf.from, _rangeRightSide(conf.from, conf)];
        }
      }

      function getDisplayString(cur, conf) {
        const right = _rangeRightSide(cur, conf);
        return transformer.toScreen(cur) + ' - ' + transformer.toScreen(right);
      }

      function updateDomElements(left, conf) {
        const handlerWidthPercent = transformer.scaledRange(conf.rangeSize) / (conf.to - conf.from);

        conf.handlerElem.css({
          left,
          width: handlerWidthPercent * 100 + '%',
        });
        conf.leftBallElem.css({ left });
        conf.rightBallElem.css({ left: left + conf.barWidth * handlerWidthPercent });
      }

      function fixValueByLimits(value, conf, err) {
        if (value < conf.from) {
          err.push('Min');
          value = conf.from;
        }

        const maxLimit = _getMaxLimit(conf);
        if (value > maxLimit) {
          err.push('Max');
          value = maxLimit;
        }

        return value;
      }

      function isValueSynchronized(value, conf) {
        return transformer.fromData(value[2]) === _rangeRightSide(transformer.fromData(value[1]), conf);
      }

      function valueFromPosition(cur, conf) {
        const left = cur;
        const right = _rangeRightSide(cur, conf);

        return _.map([left, right], transformer.toSend);
      }

      function offsetFromPosition(cur, conf) {
        const scaledRangeSize = transformer.scaledRange(conf.rangeSize);
        const handlerWidthPercent = scaledRangeSize / (conf.to - conf.from);
        const wholeRange = conf.to - conf.from - scaledRangeSize;
        const progress = (cur - conf.from) / wholeRange;

        return progress * conf.barWidth * (1 - handlerWidthPercent);
      }

      function positionFromOffset(left, conf) {
        const scaledRangeSize = transformer.scaledRange(conf.rangeSize);
        const handlerWidthPercent = scaledRangeSize / (conf.to - conf.from);
        const progress = left / (conf.barWidth * (1 - handlerWidthPercent));
        const pos = conf.from + (conf.to - scaledRangeSize - conf.from) * progress;

        return Math.min(Math.max(conf.from, pos), conf.to);
      }

      function allowStepControls(currentPosition, conf) {
        return [currentPosition < _rangeLeftSide(conf.to, conf), currentPosition > conf.from];
      }

      function edgesStatus(cur, conf) {
        const rightLimit = _getMaxLimit(conf);
        const leftViolated = cur < conf.from;
        const rightViolated = cur > rightLimit;
        const left = conf.from;
        const right = rightLimit;

        return {
          isViolated: leftViolated || rightViolated,
          sameSide: leftViolated ? left : right,
          oppositeSide: leftViolated ? right : left,
        };
      }

      function getBarWidthAvailable(conf) {
        return (
          (conf.barWidth * (conf.to - conf.from - transformer.scaledRange(conf.rangeSize))) / (conf.to - conf.from)
        );
      }

      return {
        prepareDomElements,
        getStartPosition,
        getDisplayString,
        updateDomElements,
        getValueFromArray: commonMethods.getValueFromArray,
        fixValueByLimits,
        isValueSynchronized,
        valueFromPosition,
        offsetFromPosition,
        positionFromOffset,
        allowStepControls,
        edgesStatus,
        getBarWidthAvailable,
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpWidgets')
    .factory('TimelapseModeFixedTo', TimelapseModeFixedTo);

  /** @ngInject */
  function TimelapseModeFixedTo(TimelapseModeCommon) {
    return function (transformer) {
      const commonMethods = TimelapseModeCommon(transformer);

      function prepareDomElements(element, conf) {
        commonMethods.prepareDomElements(element, conf);
        conf.leftBallElem = element.find('.adp-cw-timelapse-ball.left');
      }

      function getStartPosition(conf) {
        return [conf.startDirection === 'backward' ? conf.to : conf.from, conf.to]
      }

      function getDisplayString(cur, conf) {
        return transformer.toScreen(cur) + ' - ' + transformer.toScreen(conf.to)
      }

      function updateDomElements(left, conf) {
        conf.handlerElem.css({
          left,
          width: ((conf.barWidth - left) / conf.barWidth * 100) + '%',
        });

        conf.leftBallElem.css({left});
      }

      function isValueSynchronized(value, conf) {
        return transformer.fromData(value[2]) !== conf.to;
      }

      function valueFromPosition(cur, conf) {
        var start = transformer.toSend(cur);
        var finish = transformer.toSend(conf.to);

        return [start, finish];
      }

      return {
        getDisplayString,
        updateDomElements,
        isValueSynchronized,
        valueFromPosition,
        prepareDomElements,
        getStartPosition,
        getValueFromArray: commonMethods.getValueFromArray,
        fixValueByLimits: commonMethods.fixValueByLimits,
        offsetFromPosition: commonMethods.offsetFromPosition,
        positionFromOffset: commonMethods.positionFromOffset,
        allowStepControls: commonMethods.allowStepControls,
        edgesStatus: commonMethods.edgesStatus,
        getBarWidthAvailable: commonMethods.getBarWidthAvailable,
      }
    }
  }
})();
;;(function(){
  'use strict';

  angular.module('SmartAdmin', ['SmartAdmin.Layout']);
})();
;;(function () {
  'use strict';

  angular.module('app.adpApi', []);
})();;;(function () {
  "use strict";

  function getStateUrl(url, suffix) {
    return !!suffix ? suffix + url : url;
  }

  angular
    .module('app.adpAuth', [
      'ui.router',
      'vcRecaptcha',
      'app.adpForms'
    ])
    /** @ngInject **/
    .config(function ($sceDelegateProvider, APP_CONFIG) {
      $sceDelegateProvider.resourceUrlWhitelist([
        `self`,
        `${APP_CONFIG.apiUrl}/**`,
      ]);
    })
    .config(function ($stateProvider, APP_CONFIG) {
      function getTemplateUrl(stateName) {
        return `${APP_CONFIG.apiUrl}/template?path=pages/login/${stateName}`;
      }

      $stateProvider
        .state('auth', {
          abstract: true,
          views: {
            root: {
              templateUrl: getTemplateUrl('layout'),
              controller: 'AuthRootController as vm'
            }
          }
        })

        .state('auth.login', {
          url: getStateUrl('/login?returnUrl', APP_CONFIG.appSuffix),
          params: {
            returnUrl: null
          },
          views: {
            content: {
              templateUrl: getTemplateUrl('login'),
              controller: 'LoginController as vm'
            }
          },
          data: {
            title: 'Login',
            htmlId: 'auth-page',
            htmlClasses: 'login-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.login-two-factor', {
          url: getStateUrl('/login-two-factor?returnUrl', APP_CONFIG.appSuffix),
          params: {
            returnUrl: null,
            context: null,
          },
          views: {
            content: {
              templateUrl: getTemplateUrl('login-two-factor'),
              controller: 'LoginTwoFactorController as vm'
            }
          },
          data: {
            title: 'Login',
            htmlId: 'auth-page',
            htmlClasses: 'login-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.enable-two-factor', {
          url: getStateUrl('/login-enable-two-factor?returnUrl', APP_CONFIG.appSuffix),
          params: {
            returnUrl: null,
            context: null,
          },
          views: {
            content: {
              templateUrl: getTemplateUrl('enable-two-factor'),
              controller: 'LoginEnableTwoFactorController as vm'
            }
          },
          data: {
            title: 'Login',
            htmlId: 'auth-page',
            htmlClasses: 'login-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.unverified-email', {
          url: getStateUrl('/login-unverified-email?returnUrl', APP_CONFIG.appSuffix),
          params: {
            returnUrl: null,
            context: null,
          },
          views: {
            content: {
              templateUrl: getTemplateUrl('unverified-email'),
              controller: 'LoginUnverifiedEmailController as vm'
            }
          },
          data: {
            title: 'Login',
            htmlId: 'auth-page',
            htmlClasses: 'login-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.verified-email-confirm-account', {
          url: getStateUrl('/confirm-account?token', APP_CONFIG.appSuffix),
          params: {
            returnUrl: null,
            context: null,
          },
          views: {
            content: {
              controller: 'LoginVerifiedEmailConfirmAccountController as vm'
            }
          },
          data: {
            title: 'Login',
            htmlId: 'auth-page',
            htmlClasses: 'login-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.password-change', {
          url: getStateUrl('/password/change?returnUrl', APP_CONFIG.appSuffix),
          params: {
            returnUrl: null,
            context: null,
          },
          views: {
            content: {
              templateUrl: getTemplateUrl('password-change'),
              controller: 'PasswordChangeController as vm'
            }
          },
          data: {
            title: 'Password Change',
            htmlId: 'auth-page',
            htmlClasses: 'login-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.register', {
          url: getStateUrl('/register', APP_CONFIG.appSuffix),
          views: {
            content: {
              templateUrl: getTemplateUrl('register'),
              controller: 'RegisterController as vm'
            }
          },
          data: {
            title: 'Register',
            htmlId: 'auth-page',
            redirectStrategy: 'guest'
          }
        })

          .state('auth.register-sso-user', {
            url: getStateUrl('/register-form', APP_CONFIG.appSuffix),
            params: {
              returnUrl: null,
              context: null,
            },
            views: {
              content: {
                templateUrl: getTemplateUrl('register-sso-user'),
                controller: 'RegisterSsoUserController as vm'
              }
            },
            data: {
              title: 'Register',
              htmlId: 'auth-page',
              redirectStrategy: 'guest'
            }
          })

        .state('auth.forgot', {
          url: getStateUrl('/password/forgot', APP_CONFIG.appSuffix),
          views: {
            content: {
              templateUrl: getTemplateUrl('forgot-password'),
              controller: 'ForgotPasswordController as vm'
            }
          },
          data: {
            title: 'Forgot Password',
            htmlId: 'auth-page',
            redirectStrategy: 'guest'
          }
        })

        .state('auth.reset', {
          url: getStateUrl('/password/reset?token&login', APP_CONFIG.appSuffix),
          params: {
            token: null,
            login: null
          },
          views: {
            content: {
              templateUrl: getTemplateUrl('reset-password'),
              controller: 'ResetPasswordController as vm'
            }
          },
          data: {
            title: 'Reset Password',
            htmlId: 'auth-page',
            redirectStrategy: 'guest'
          }
        })
    });
})()
;;(function () {
  'use strict';

  angular.module('app.adpCommon', []);
})();;;(function () {
  'use strict';
  
  angular.module('app.adpDashboard', ['app.adpGenerator']);
})();
;;(function () {
  'use strict';

  angular.module('app.adpDataGrid', [
    'app.adpApi',
    'dx',
  ]);
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader', [
    'angularFileUpload',
    'uiCropper'
  ]);

  angular
    .module('app.adpUploader')
    .config(['$provide', function($provide) {
      $provide.decorator('FileUploader', ['$delegate', function(FileUploader) {
        FileUploader.prototype._xhrTransport = function (item) {
          var xhr = item._xhr = new XMLHttpRequest();
          var sendable;

          if (!item.disableMultipart) {
            sendable = new FormData();
            _.forEach(item.formData, (obj) => {
              _.forEach(obj, (value, key) => {
                sendable.append(key, value);
              });
            });

            // PATCHED
            !item._file.isDummyFile && sendable.append(item.alias, item._file, item.file.name);
          }
          else {
            sendable = item._file;
          }

          if(typeof(item._file.size) != 'number') {
            throw new TypeError('The file specified is no longer valid');
          }

          xhr.upload.onprogress = (event) => {
            var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
            this._onProgressItem(item, progress);
          };

          xhr.onload = () => {
            var headers = this._parseHeaders(xhr.getAllResponseHeaders());
            var response = this._transformResponse(xhr.response, headers);
            var gist = this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
            var method = '_on' + gist + 'Item';
            this[method](item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
          };

          xhr.onerror = () => {
            var headers = this._parseHeaders(xhr.getAllResponseHeaders());
            var response = this._transformResponse(xhr.response, headers);
            this._onErrorItem(item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
          };

          xhr.onabort = () => {
            var headers = this._parseHeaders(xhr.getAllResponseHeaders());
            var response = this._transformResponse(xhr.response, headers);
            this._onCancelItem(item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
          };

          xhr.ontimeout = (e) => {
            var headers = this._parseHeaders(xhr.getAllResponseHeaders());
            var response = "Request Timeout.";
            this._onTimeoutItem(item);
            this._onCompleteItem(item, response, 408, headers);
          };

          xhr.open(item.method, item.url, true);

          xhr.timeout = item.timeout || 0;
          xhr.withCredentials = item.withCredentials;

          _.forEach(item.headers, (value, name) => {
            xhr.setRequestHeader(name, value);
          });

          xhr.send(sendable);
        }

        return FileUploader;
      }])
    }])
})();;;(function () {
  'use strict';

  angular.module('app.adpForms', ['ngMessages', 'ui.sortable']);

  angular
    .module('app.adpForms')
    .config(function () {
      CKEDITOR.disableAutoInline = true;
      ace.config.set('workerPath', 'lib/ace-builds/src-noconflict');
      addCollapseButtonToCkeditor();
    });

  function addCollapseButtonToCkeditor() {
    var pluginName = 'collapse';

    CKEDITOR.plugins.add(pluginName, {
      init(editor) {
        if (!_.isArray(editor.config.toolbar)) {
          return;
        }

        var hasCollapseButton = _.find(
          editor.config.toolbar,
  group => _.find(group.items, name => name === 'Collapse')
        );

        if (!hasCollapseButton) {
          return;
        }

        editor.once('instanceReady', function () {
          const editorName = editor.name;
          $('.cke_editor_' + editorName + ' .cke_top').addClass('force-auto');
          toggleButtons(editor);
          $('.cke_editor_' + editorName + ' .cke_button__moretools .cke_button_icon').removeClass('collapsed');
        });

        editor.ui.addButton('Collapse', {
          label: 'Show more buttons',
          command: 'CollapseAction',
          icon: 'Collapse',
          className: 'cke_button__moretools',
        });

        editor.addCommand('CollapseAction', {
          exec: function () {
            toggleButtons(editor);
          }
        });
      }
    });

    function toggleButtons(editor) {
      const editorName = editor.name;
      const selector = '.cke_editor_' + editorName + ' .cke_toolbar_last';
      $(document.querySelector(selector)).nextAll().toggle();
      $('.cke_editor_' + editorName + ' .cke_button__moretools .cke_button_icon').toggleClass('collapsed');
    }
  }
})();
;;(function () {
  'use strict';

angular
  .module('app.adpGenerator', [
    'ui.router',
    'app.adpAuth',
    'app.adpDashboard',
    'app.adpDataGrid'
  ])
  .run(onRun)
  .config(onConfig);

  function onConfig (AppGeneratorProvider) {
    AppGeneratorProvider.generateApp();
  }

  function onRun($transitions, $uibModalStack) {
    $transitions.onStart(null, function (transition) {
      var toState = transition.to();
      var fromState = transition.from();
      if (toState.name === fromState.name) {
        return;
      }

      $uibModalStack.dismissAll('State transition');
    })
  }
})();
;"use strict";


angular
  .module('app.adpLayout', ['ui.router'])
  .config(function ($stateProvider) {
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          root: {
            templateUrl: 'app/adp-layout/layout.tpl.html',
            controller: 'LayoutController as vm'
          }
        }
      });
  });

;;(function () {
  'use strict';

  angular.module('app.adpRecorders', []);
})();;;(function () {
  'use strict';

  angular.module('app.adpUi', []);
})();;(function(){
    "use strict";

    angular.module('SmartAdmin.Layout', []);
})();;;(function () {
  'use strict';

  /**
   * @ngdoc overview
   * @name app [smartadminApp]
   * @description
   * # app [smartadminApp]
   *
   * Main module of the application.
   */
  angular.module('app', [
    'ngSanitize',
    'ngCookies',
    'ui.router',
    'ui.bootstrap',
    'ngMap',
    'SmartAdmin',

    // App
    'APP_MODEL_CONFIG',
    'app.adpLayout',
    'app.adpAuth',
    'app.adpGenerator',
    'app.adpCommon',
    'app.adpForms',
    'app.adpDashboard',
    'app.adpUi',
    'app.adpUploader',
    'app.adpRecorders',
    'app.adpFormActions',
  ]);
})();;;(function () {
  'use strict';

  addClientModules(angular.module('app'));

  function addClientModules(rootModule) {
    var depsList = ["app.aggregationPipeline","app.adpEmbedCodeModal","app.adpWidgets","app.adpGridstack","app.adpForceGraph","app.adpGlobe","app.adpGuidedTour","app.adpPaymentPlans","app.adpMarketplaceCart","app.adpMarketplaceServerActions","app.adpTopomap","app.adpClientCommon","app.adpCommandRunner","app.adpContactSupport","app.adpDataExport","app.adpDataImport","app.adpDatasetActions","app.adpDeleteMyAccount","app.adpFilterBuilder","app.adpFormActions","app.adpGridColumnChooser","app.adpGridPrint","app.adpGridControlActions","app.adpGridQuickFilter","app.adpGridRowActions","app.adpGridViewManager","app.adpNginxWhiteList","app.adpPasswordRequirements","app.adpProfile","app.adpRolesPermissionsEditor","app.adpRtcActions","app.adpSmtpTest","app.adpSso","app.adpSyntheticGenerate","app.adpTableActions","app.adpTwoFactorConfigControl","app.default"];
    if (!depsList.length) {
      return;
    }

    getExistingModules(depsList).forEach(function (name) {
      rootModule.requires.push(name);
    });
  }

  function getExistingModules(names) {
    if (!names.length) return [];

    var modules = [];

    _.each(names, function (moduleName) {
      try {
        if (angular.module(moduleName)) {
          modules.push(moduleName);
        }
      } catch(err) {
        console.error('Error trying to register client module, module might not exist:', err);
      }
    });

    return modules;
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpGenerator')
    .provider('AdpStateGenerator', AdpStateGenerator);

  const contents = {
    'dashboard': {
      controller: 'DashboardController as vm',
      templateUrl: 'app/adp-generator/views/dashboard.html'
    },
    'singleRecord': {
      controller: 'SingleRecordController as vm',
      templateUrl: 'app/adp-generator/views/single-record.html'
    },
    'multiRecord': {
      controller: 'MultiRecordController as vm',
      templateUrl: 'app/adp-generator/views/multi-record.html'
    },
    customPage({ template, controller }) {
      const customPageParams = { template };

      if (controller) {
        customPageParams.controller = controller + ' as vm';
      }

      return customPageParams;
    },
  };

  const stateDefault = {
    url: '',
    views: { content: {} },
    data: {}
  };

  /**
   * @ngdoc service
   * @memberOf app.adpGenerator
   * @description
   * Angular provider for registering ui router states from app models.
   *
   * @param {service} $stateProvider
   * @return {{createStates: AdpStateGenerator.createStates, createDashboards: AdpStateGenerator.createDashboards, createCustomPages: AdpStateGenerator.createCustomPages, _replaceUrlParams: _replaceUrlParams, $get: service.$get}}
   * @constructor
   */
  function AdpStateGenerator($stateProvider, APP_CONFIG) {
    var $stateRegistry = $stateProvider.stateRegistry;

    var service = {
      createStates,
      createDashboards,
      createCustomPages,
      createBuiltInStates,
      getDefaultStateParams,
      createAliasStates,
      _replaceUrlParams,
      linkToState,
      findDashboard,
      getCurrentUser,
      $get() {
        return service;
      }
    };

    //============== METHODS
    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Iterate application models collection to register standard ui router states.
     *
     * States are created only for models items, which has True value for item.visible and item.type 'Schema'
     * or 'Subschema'. Other models are ignored.
     *
     * State names are generated as string 'app.' + key of model to keep ui state flat.
     *
     * Example: if model has following structure model: { childModel: {} }, than stateName for model.childModel
     * will be "app.childModel".
     *
     * @param {Object} schema
     * @param {Object} interfaceConfig
     * @param {String} parentStateName - path to parent state to search
     */
    function createStates(schema, interfaceConfig, parentStateName) {
      _.each(schema, function (item, key) {
        try {
          var state, parent;
          item.schemaName = key;

          if (!_isState(item)) return;
          if (_isCustomState(key, parentStateName, interfaceConfig)) {
            return;
          }

          state = _createState(item, key, parentStateName);

          if (_isParent(item)) {
            parent = parentStateName ? parentStateName + '.' + key : key;

            createStates(item.fields, interfaceConfig, parent);
          }

          $stateRegistry.register(state);
        } catch (e) {
          console.error('State creation failed with error: ', e);
          console.error('For schema definition :', item);
        }
      });
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Create state definition for non-custom ui router states.
     *
     * State definition:
     * - stateDefinition.url - created as conversion of schema path to url.
     *  Example: schema path phis.encounters.diagnoses is converted to phis/encounters/diagnoses
     *
     * - stateDefinition.name - created from schema key
     *  Example: if creating state for "childModel" in model: { childModel: {} } name is "childModel"
     *
     * - stateDefinition.views - content, which provided to ui router. Check description of _getPageContent()
     *  for more details.
     *
     * - stateDefinition.data  - data, which provided with every ui router state. Check description of _getPageData()
     *  for more details.
     *
     * @param {Object} schemaItem
     * @param {String} schemaName
     * @param {String} parentSchemaPath
     * @return {Object} schemaDefinition
     * @private
     */
    function  _createState(schemaItem, schemaName, parentSchemaPath) {
      try {
        var state = _.clone(stateDefault);
        var schemaPath = _getSchemaPath(schemaName, parentSchemaPath);

        state.data = _getPageData(schemaItem, schemaName, schemaPath);
        state.name = 'app.' + schemaName;
        state.views = _getPageContent(schemaPath);

        state.params = _getModelPageParams();
        state.url = _getStateUrl(schemaPath) + '?action&_id&filter&customOpt&gridSearch&noLsFilter';

        return state;
      } catch (e) {
        console.error('Page state creation failed with error: ', e);
        console.error('Page state definition:', state);
        console.error('App model schema:', schemaPath);
      }
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Iterate menuItems[] to search DashboardPage config and create dashboard state.
     *
     * @param {Object[]} menuItems
     */
    function createDashboards(menuSchema) {
      const dashboards = findDashboard(menuSchema.fields);
      if (!dashboards.length) return;

      dashboards.forEach(function (dashboard) {
        _createDashboardState(dashboard);
      });
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Find DashboardPage in menuItems[] config
     *
     * @param {Object[]} menuItems
     *
     * @return {Object} menuItem
     */
    function findDashboard(menuItems) {
      return _.filter(menuItems,  (item) => item?.type === 'MenuDashboardLink');
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Register dashboard ui router state.
     *
     * @param {Object} dashboardMenuItem
     * @private
     */
    function _createDashboardState(dashboardMenuItem) {
      try {
        var state = _.clone(stateDefault);
        var link = dashboardMenuItem.link;
        var title = dashboardMenuItem.fullName;

        state.name = linkToState(link);
        state.url = _addBaseUrlSuffix( '/' + link, APP_CONFIG.appSuffix);
        state.data = {
          redirectStrategy: 'user',
          title: title,
          // intentional duplication of title to avoid compabillity issues in already implemented applications
          pageParams: {
            title: title,
            dashboardName: link
          }
        };

        state.views = {
          content: contents['dashboard']
        };

        $stateRegistry.register(state);
      } catch(e) {
        console.error('Dashboard state creation failed with error: ', e);
        console.error('Dashboard state definition:', state);
      }
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Iterate application interface.pages to register custom ui router states for custom pages.
     *
     * @param {Object} interfaceConfig
     */
    function createCustomPages(interfaceConfig) {
      _.each(interfaceConfig.pages, _createCustomPageState);
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Register ui router state for custom page.
     *
     * State name is created as concatenation of 'app.' string and name param of page.
     *
     * State definition:
     * - stateDefinition.url - page link with params, which are added from CurrentUser object.
     *
     * - stateDefinition.views - content, which provided to ui router.
     *
     * - stateDefinition.data  - data, which provided with custom page. pageConfig params are copied here.
     *
     * @param {Object} pageConfig - value from interfaceConfig.pages
     * @param {String} name - key from interfaceConfig.pages
     * @private
     */
    function _createCustomPageState(pageConfig, name) {
      try {
        var state = _.cloneDeep(stateDefault);

        state.name = 'app.' + name;
        state.url = _addBaseUrlSuffix(_addRulesToUrlParams(pageConfig.link), APP_CONFIG.appSuffix);
        pageConfig.link = state.url;
        state.data = _.extend({
          title: pageConfig.fullName,
          // intentional duplication of title to avoid compabillity issues in already implemented applications
          pageParams: {
            title: pageConfig.fullName
          },
          redirectStrategy: 'user',
        }, pageConfig);

        state.views = {
          content: contents.customPage(pageConfig)
        };

        $stateRegistry.register(state);
      } catch(e) {
        console.error('Custom page state creation failed with error: ', e);
        console.error('Custom page state definition:', state);
      }
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Return true, if state is custom page.
     * @param {String} schemaName
     * @param {String} parentName
     * @param {Object} interfaceConfig
     * @return {boolean}
     * @private
     */
    function _isCustomState(schemaName, parentName, interfaceConfig) {
      var schemaPath = _getSchemaPath(schemaName, parentName);
      var stateUrl = _getStateUrl(schemaPath);

      return !!_.find(interfaceConfig.pages, function (page) {
        return page.link === stateUrl;
      });
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Covert link params to link with params with regex. Regex is matching mongo _id.
     * We need this for ui router url matching.
     *
     * @param {String} link
     * @return {String}
     * @private
     */
    function _addRulesToUrlParams(link) {
      var linkToFormat = link;
      // regex for mongo _id - 24 chars length hex number
      var hexNumberRegex = "[0-9A-Fa-f]{24}";

      return linkToFormat.replace(/\/:([a-zA-Z]+)\//g, function (_, idName) {
        return ['/{', idName, ':',  hexNumberRegex,'}/', ].join('');
      });
    }

    /**
     * @memberOf AdpStateGenerator
     * @description
     * Replace url params with exact values from CurrentUser object.
     * @param {string} link
     * @return {string}
     * @private
     */
    function _replaceUrlParams(link) {
      var user = getCurrentUser();

      var linkToFormat = link.toLowerCase();

      return linkToFormat.replace(/\/:([a-zA-Z]+)\//g, function (_, idName) {
        return ['/', user[idName], '/'].join('');
      });
    }

    function getCurrentUser() {
      var userString = localStorage.getItem('user');

      try {
        return JSON.parse(userString);
      } catch (e) {}
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Convert schemaPath to state url.
     * Example: schema path phis.encounters.diagnoses is converted to phis/encounters/diagnoses
     *
     * @param schemaPath
     * @return {string} stateUrl
     * @private
     */
    function _getStateUrl(schemaPath) {
      var baseStateUrl = '/' + schemaPath.replace(/\./g, '/');
      return _addBaseUrlSuffix(baseStateUrl, APP_CONFIG.appSuffix);
    }

    function _addBaseUrlSuffix(url, suffix) {
      return !!suffix ? suffix + url : url;
    }

    function _getSchemaPath(schemaName, parentSchemaPath) {
      var schemaPath = schemaName;

      if (parentSchemaPath) {
        schemaPath = parentSchemaPath + '.' + schemaPath;
      }

      return schemaPath;
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Get page data, which is provided to every ui router state.
     *
     * - pageData.title - schemaItem.fullName
     * - pageData.redirectStrategy - defines permissions to access page
     * - pageData.pageParams - Check description of _getPageData() for more details.
     *
     * @param {Object} schemaItem
     * @param {String} schemaName
     * @param {String} schemaPath
     *
     * @return {{title: string, pageParams: Object, redirectStrategy: string}} pageData
     * @private
     */
    function _getPageData(schemaItem, schemaName, schemaPath) {
      var params = {
        title: schemaItem.fullName,
        schemaPath: schemaPath,
        // deprecated for usage outside of provide phase
        pageParams: _getPageParams(schemaItem, schemaName, schemaPath),
        // atm: assuming that all states are restricted only to authorized users
        // TODO: change later
        redirectStrategy: 'user'
      };

      if (schemaItem.cssClass) {
        params.cssClass = schemaItem.cssClass;
      }

      return params;
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * * Get pageParams, which is provided to every ui router state with pageData.
     *
     * - pageParams.title - schemaItem.fullName
     * - pageParams.fieldName - schemaName. TODO: not correct name of property, rename
     * - pageParams.schemaPath - schemaPath. Searchable with _.get
     * - pageParams.link - state url
     * - pageParams.parentStateName
     *
     * @param {Object} schemaItem
     * @param {String} schemaName
     * @param {String} schemaPath
     *
     * @return {{title: *, fieldName: *, schemaPath: *, link: string}}
     * @private
     */
    function _getPageParams(schemaItem, schemaName, schemaPath) {
      var pageParams = {
        title: schemaItem.fullName,
        fieldName: schemaName,
        schemaPath: schemaPath.split('.').join('.fields.'),
        link: _getStateUrl(schemaPath),
      };

      if (_isChild(schemaPath)) {
        pageParams.parentStateName = _getParentState(schemaPath);
      }

      return pageParams;
    }

    /**
     * @memberOf AdpStateGenerator
     *
     * @description
     * Get content for ui router state.views property. Defines what type of page would be rendered for standard
     * ui router state.
     *
     * Possible content types for standard pages:
     * - singleRecord if schema has singleRecord property;
     * - multiRecord if schema has no singleRecord property;
     * - multiRecordNested if schema has no singleRecord property and 2+ levels deep in app models;
     *
     * @param {string} schemaPath
     * @return {{content: *}}
     * @private
     */
    function _getPageContent(schemaPath) {
      var schema = _getSchema(schemaPath);
      var pageType;

      if (schema.singleRecord) {
        pageType = 'singleRecord';
      } else {
        pageType = _isNestedState(schemaPath) ? 'multiRecordNested' : 'multiRecord';
      }

      return {
        content: contents[pageType]
      }
    }

    function getDefaultStateParams(menuInterface) {
      menuInterface = menuInterface || {};
      var state, defaultMenuItem, URL_PARAMS_REGEX = /\/:([^\/\n\r]+)/g;
      var url;

      if ('default' in menuInterface) {
        state = {
          url: APP_CONFIG.appSuffix + menuInterface.default,
          stateName: linkToState(menuInterface.default)
        };
      } else {
        defaultMenuItem = _findDefaultInMenu(menuInterface);
        url = _.get(defaultMenuItem, 'link', '/');

        state = {
          url: url,
          stateName: linkToState(url)
        };
      }

      if (URL_PARAMS_REGEX.test(state.link)) {
        console.error('======= Default state link ' + defaultMenuItem.link + ' can\'t contain url params');
      }

      return state;
    }

    function createAliasStates(INTERFACE) {
      const { frontendAliases } = INTERFACE.app;
      const register = ({ alias, target }) => {
        $stateRegistry.register({
          name: 'app.' + _.camelCase('alias' + alias),
          url: _addBaseUrlSuffix(alias, APP_CONFIG.appSuffix),
          data: {
            title: 'Alias page',
            redirectStrategy: 'user',
          },
          params: _getModelPageParamsWithDynamicID(),
          views: {
            content: {
              controller: function ($urlService, $state, $timeout) {
                const foundState = $urlService.match({ path: target });
                const params = { ...(foundState.match || {}), ...$urlService.search() };
                const state = _.get(foundState, 'rule.state');

                if (!state) {
                  this.notFound = true;
                  return;
                }

                $timeout(() => $state.go(state, params, { location: false }));
              },
              template: `
                <adp-content-container class="single-record">
                  <adp-section-container ng-if="!$ctrl.notFound">
                    <adp-page-title>Page for alias "${alias}" not found</adp-page-title>
                  </adp-section-container>
                </adp-content-container>`,
            },
          }
        });
      }

      _.each(frontendAliases, register);
    }

    function _getSchema(path) {
      var schemaPath = path.split('.').join('.fields.');
      var APP_MODEL = window.adpAppStore.appModel();

      return _.get(APP_MODEL, schemaPath);
    }

    function _getParentState(schemaPath) {
      var parentName = schemaPath.split('.');

      return 'app.' + _.nth(parentName, -2);
    }

    function _isNestedState(schemaPath) {
      return schemaPath.split('.').length > 2;
    }

    function _isChild(schemaPath) {
      return schemaPath.split('.').length > 1;
    }

    function _isState(item) {
      var isSchema = item.type === 'Schema' || item.type === 'Subschema';
      var isVisible = item.visible !== false;

      return isSchema && isVisible;
    }

    function _isParent(schema) {
      var subSchemaKey = _.findKey(schema.fields, {type: 'Subschema'});

      return !!subSchemaKey;
    }

    function _findDefaultInMenu(menuInterface) {
      // TODO: check if state has schema
      return _.chain(menuInterface.fields)
              .flatMap(function(item) {
                return item.fields ? _.flatten(_.toArray(item.fields)) : item;
              })
              .find(function (item) {
                return 'link' in item;
              })
              .value();
    }
    function linkToState(link) {
      var newLink = 'app.' + _.last(link.split('/'));

      return _dashCaseToCamelCase(newLink);
    }

    function _dashCaseToCamelCase(string) {
      return string.replace(/-([a-z0-9])/g, function (g) {
        return g[1].toUpperCase();
      });
    }

    function createBuiltInStates() {
      const datasetsId = {
        name: 'app.datasetsId',
        url: _addBaseUrlSuffix('/datasets/{_id:[0-9A-Fa-f]{24}}?action&filter&customOpt&gridSearch&noLsFilter', APP_CONFIG.appSuffix),
        views: {
          content: {
            templateUrl: 'app/adp-generator/views/datasets.html',
            controller: 'DatasetController as vm'
          }
        },
        data: {
          title: 'Datasets',
          redirectStrategy: 'user'
        },
        params: _getModelPageParams(),
      }

      $stateRegistry.register(datasetsId);
    }

    function _getModelPageParams() {
      return {
        action: {value: null, dynamic: true},
        filter: {value: null, dynamic: true},
        customOpt: {value: null, dynamic: true},
        gridSearch: {value: null, dynamic: true},
        noLsFilter: {value: null, dynamic: true},
      }
    }

    function _getModelPageParamsWithDynamicID() {
      return { ..._getModelPageParams(), _id: {value: null, dynamic: true} };
    }

    return service;
  }
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .provider('AppGenerator', AppGenerator);

  function AppGenerator(
    AdpStateGeneratorProvider,
    $urlRouterProvider,
    APP_CONFIG
  ) {
    const service = {
      generateApp,
      $get() {
        return service;
      },
    };

    function generateApp() {
      var APP_MODEL = window.adpAppStore.appModel();
      var INTERFACE = window.adpAppStore.appInterface();
      var DEFAULT_STATE;

      try {
        AdpStateGeneratorProvider.createDashboards(INTERFACE.mainMenu);
      } catch (e) {
        console.log('Menu item creation failed due to error: ', e)
      }

      try {
        AdpStateGeneratorProvider.createCustomPages(INTERFACE);
      } catch (e) {
        console.log('Custom page creation failed due to error: ', e)
      }

      try {
        AdpStateGeneratorProvider.createAliasStates(INTERFACE);
      } catch (e) {
        console.log('Schema pages creation failed due to error: ', e)
      }

      try {
        AdpStateGeneratorProvider.createStates(APP_MODEL, INTERFACE);
      } catch (e) {
        console.log('Schema pages creation failed due to error: ', e)
      }

      try {
        AdpStateGeneratorProvider.createBuiltInStates(APP_MODEL, INTERFACE);
      } catch (e) {
        console.log('Built in page creation failed due to error: ', e)
      }

      try {
        DEFAULT_STATE = AdpStateGeneratorProvider.getDefaultStateParams(INTERFACE.mainMenu);
        window.adpAppStore.defaultState(DEFAULT_STATE);

        $urlRouterProvider.otherwise(function () {
          var authSetting = window.adpAppStore.appInterface().app.auth;
          var loginUrl = !!APP_CONFIG.appSuffix ? (APP_CONFIG.appSuffix + '/login') : '/login';

          if (authSetting.requireAuthentication && lsService.isGuest()) {
            return loginUrl;
          } else {
            return DEFAULT_STATE.url;
          }
        });
      } catch (e) {
        console.log('Menu item creation failed due to error: ', e)
      }
    }

    return service;
  }
})();
;angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/index.html','<!DOCTYPE html>\n<html lang="en-us" class="no-js">\n<head>\n\n  <meta charset="utf-8">\n  <title>{{ interface.app.title }}</title>\n  <base href="{{ baseUrl }}">\n\n  <link rel="manifest" crossorigin="use-credentials" href="{{ baseUrlForManifest }}manifest.json">\n\n  <meta name="description" content="{{ interface.app.description }}">\n  <meta name="keywords" content="{{ interface.app.keywords }}">\n\n  <meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no">\n\n  <!-- build:css({.tmp,./}) /styles/main.vendors.css -->\n  <!-- bower:css -->\n  <!-- run `gulp inject` to automatically populate bower styles dependencies -->\n  <!-- endbower -->\n  <!-- endbuild -->\n\n  <link rel="stylesheet" href="/lib/devextreme/dx.common.css">\n\n  <!-- Generic themes -->\n  <link rel="dx-theme" data-theme="generic.light" href="/lib/devextreme/dx.light.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.dark" href="/lib/devextreme/dx.dark.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.carmine" href="/lib/devextreme/dx.carmine.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.softblue" href="/lib/devextreme/dx.softblue.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.darkmoon" href="/lib/devextreme/dx.darkmoon.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.darkviolet" href="/lib/devextreme/dx.darkviolet.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.greenmist" href="/lib/devextreme/dx.greenmist.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.contrast" href="/lib/devextreme/dx.contrast.css" data-active="false">\n\n  <!-- Generic compact themes -->\n  <link rel="dx-theme" data-theme="generic.light.compact" href="/lib/devextreme/dx.light.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.dark.compact" href="/lib/devextreme/dx.dark.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.carmine.compact" href="/lib/devextreme/dx.carmine.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.softblue.compact" href="/lib/devextreme/dx.softblue.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.darkmoon.compact" href="/lib/devextreme/dx.darkmoon.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.darkviolet.compact" href="/lib/devextreme/dx.darkviolet.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.greenmist.compact" href="/lib/devextreme/dx.greenmist.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="generic.contrast.compact" href="/lib/devextreme/dx.contrast.compact.css" data-active="false">\n\n  <!-- Material themes -->\n  <link rel="dx-theme" data-theme="material.blue.light" href="/lib/devextreme/dx.material.blue.light.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.blue.dark" href="/lib/devextreme/dx.material.blue.dark.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.lime.light" href="/lib/devextreme/dx.material.lime.light.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.lime.dark" href="/lib/devextreme/dx.material.lime.dark.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.orange.dark" href="/lib/devextreme/dx.material.orange.dark.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.orange.light" href="/lib/devextreme/dx.material.orange.light.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.purple.dark" href="/lib/devextreme/dx.material.purple.dark.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.purple.light" href="/lib/devextreme/dx.material.purple.light.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.teal.dark" href="/lib/devextreme/dx.material.teal.dark.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.teal.light" href="/lib/devextreme/dx.material.teal.light.css" data-active="false">\n\n  <!-- Material compact themes -->\n  <link rel="dx-theme" data-theme="material.blue.light.compact" href="/lib/devextreme/dx.material.blue.light.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.blue.dark.compact" href="/lib/devextreme/dx.material.blue.dark.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.lime.light.compact" href="/lib/devextreme/dx.material.lime.light.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.lime.dark.compact" href="/lib/devextreme/dx.material.lime.dark.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.orange.light.compact" href="/lib/devextreme/dx.material.orange.light.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.orange.dark.compact" href="/lib/devextreme/dx.material.orange.dark.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.purple.light.compact" href="/lib/devextreme/dx.material.purple.light.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.purple.dark.compact" href="/lib/devextreme/dx.material.purple.dark.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.teal.light.compact" href="/lib/devextreme/dx.material.teal.light.compact.css" data-active="false">\n  <link rel="dx-theme" data-theme="material.teal.dark.compact" href="/lib/devextreme/dx.material.teal.dark.compact.css" data-active="false">\n\n\n  <!-- build:css(.tmp) /styles/index.css -->\n  <link rel="stylesheet" href="/styles/index.css">\n  <!-- endbuild -->\n  <!-- replaceSpecial:cssCodeFromGlobalConf -->\n\n  <link rel="apple-touch-icon" href="{{ interface.app.favicon[180x180] }}" sizes="180x180">\n\n  <link rel="icon" type="image/png" href="{{ interface.app.favicon[32x32] }}" sizes="32x32">\n\n  <link rel="icon" type="image/png" href="{{ interface.app.favicon[16x16] }}" sizes="16x16">\n\n  <link rel="mask-icon" color="{{ interface.app.favicon[\'16x16\'] }}">\n\n\n  <!-- iOS web-app metas : hides Safari UI Components and Changes Status Bar Appearance -->\n  <meta name="apple-mobile-web-app-capable" content="yes">\n  <meta name="apple-mobile-web-app-status-bar-style" content="black">\n</head>\n<!--\n\nTABLE OF CONTENTS.\n\nUse search to find needed section.\n\n===================================================================\n\n|  01. #CSS Links                |  all CSS links and file paths  |\n|  02. #FAVICONS                 |  Favicon links and file paths  |\n|  03. #GOOGLE FONT              |  Google font link              |\n|  04. #APP SCREEN / ICONS       |  app icons, screen backdrops   |\n|  05. #BODY                     |  body tag                      |\n|  06. #HEADER                   |  header tag                    |\n\n===================================================================\n\n-->\n\n<!-- #HEAD IDS -->\n<!--\n- #auth-page - Auth page, eg: login, register, forgot password\n- no id - other pages.\n\n-->\n<!-- #BODY -->\n<!-- Possible Classes (to hardcode the classes you must disable the __ module)\n\n* \'smart-style-{SKIN#}\'\n* \'smart-rtl\'         - Switch theme mode to RTL\n* \'menu-on-top\'       - Switch to top navigation (no DOM change required)\n* \'no-menu\'           - Hides the menu completely\n* \'hidden-menu\'       - Hides the main menu but still accessable by hovering over left edge (removed from code on 25/04/24)\n* \'fixed-header\'      - Fixes the header  (removed from code on 25/04/24)\n* \'fixed-navigation\'  - Fixes the main menu\n* \'fixed-ribbon\'      - Fixes breadcrumb\n* \'fixed-page-footer\' - Fixes footer\n* \'container\'         - boxed layout mode (non-responsive: will not work with fixed-navigation & fixed-ribbon)\n\nPossible attributes\n\n* \'data-smart-device-detect\' - Detects if mobile or desktop, adds a class to body tag\n* \'data-smart-fast-click\'    - Mobile click events\n* \'data-smart-layout\'        - Mobile view event listener\n* \'data-smart-page-title\'    - Page title\n\n-->\n\n<body data-smart-device-detect="" data-smart-fast-click="" data-smart-layout="" data-smart-page-title="{{ interface.app.title }}">\n\n<!-- ui-view container -->\n<div id="root-block" data-ui-view="root" data-autoscroll="false"></div>\n\n<!--[if lt IE 7]>\n<p class="browsehappy">\n  You are using an <strong>outdated</strong> browser. Please\n  <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>\n<![endif]-->\n\n\n<!-- app root -->\n<div adp-app-page-loader="" class="adp-app-page-loader">\n  <i class="lds-dual-ring"></i>\n</div>\n<script>\n  /// ToDo: this is polyfill for dashboard html2canvas screeshot functionality, move it closer somehow.\n  HTMLCanvasElement.prototype.getContext = function(origFn) {\n    return function(type, attribs) {\n      attribs = attribs || {};\n      attribs.preserveDrawingBuffer = true;\n      return origFn.call(this, type, attribs);\n    };\n  }(HTMLCanvasElement.prototype.getContext);\n\n  <!--DynamicVendorsMap-->\n</script>\n\n<!-- build:js({.tmp,./}) /scripts/polyfills.js -->\n<!-- inject:polyfills -->\n<!-- endinject -->\n<!-- endbuild -->\n\n<script src="/workers/lib/libvorbis.min.js"></script>\n<script src="/workers/lib/recorder.js"></script>\n<script src="/lib/ckeditor/ckeditor.js"></script>\n<script src="/lib/ace-builds/src-noconflict/ace.js"></script>\n<script src="/lib/ace-builds/src-noconflict/ext-language_tools.js"></script>\n<script src="/lib/ace-builds/src-noconflict/mode-python.js"></script>\n<script src="/lib/ace-builds/src-noconflict/mode-json.js"></script>\n<script src="/lib/ace-builds/src-noconflict/mode-sql.js"></script>\n<script src="/lib/ace-builds/src-noconflict/theme-chrome.js"></script>\n<script src="/lib/ace-builds/src-noconflict/theme-github.js"></script>\n<script src="/lib/ace-builds/src-noconflict/theme-ambiance.js"></script>\n<script src="/lib/ace-builds/src-noconflict/theme-chaos.js"></script>\n<script src="/lib/ace-builds/src-noconflict/theme-terminal.js"></script>\n<script src="/lib/mongodb-ace-autocompleter.js"></script>\n\n<!-- build:js({.tmp,./}) /scripts/main.vendors.js -->\n<!-- bower:js -->\n<!-- endbower -->\n<!-- endbuild -->\n\n<!-- build:js({.tmp,./}) /scripts/app.js -->\n<!-- inject:js -->\n<!-- endinject -->\n<!-- endbuild -->\n\n<!-- replaceSpecial:developmentJsCodeFromGlobalConf -->\n</body>\n</html>\n');
$templateCache.put('app/adp-layout/layout.tpl.html','<!-- HEADER -->\n<div ng-if="::vm.header.visible" data-smart-include="app/adp-layout/partials/header.tpl.html" class="placeholder-header">\n</div>\n<!-- END HEADER -->\n\n<div id="central-block">\n    <!-- Left panel : Navigation area -->\n    <!-- Note: This width of the aside area can be adjusted through LESS variables -->\n    <div data-smart-include="app/adp-layout/partials/navigation.tpl.html" class="placeholder-left-panel">\n    </div>\n    <!-- END NAVIGATION -->\n\n    <!-- MAIN PANEL -->\n    <div id="main" role="main">\n        <!-- RIBBON -->\n        <div id="ribbon" ng-if="::vm.header.components.breadcrumbs">\n            <!-- breadcrumb -->\n            <adp-breadcrumbs></adp-breadcrumbs>\n            <!-- end breadcrumb -->\n        </div>\n        <!-- END RIBBON -->\n\n        <div data-smart-router-animation-wrap="content content@app" data-wrap-for="#content">\n            <div data-ui-view="content" data-autoscroll="false"></div>\n        </div>\n\n    </div>\n    <!-- END MAIN PANEL -->\n</div>\n\n<!-- PAGE FOOTER -->\n<div ng-if="::vm.footer.visible" data-smart-include="app/adp-layout/partials/footer.tpl.html">\n</div>\n\n<adp-user-menu ng-if="::vm.header.components.userMenu"></adp-user-menu>\n\n<!-- END PAGE FOOTER -->\n');
$templateCache.put('app/adp-dashboard/adp-dashboard/adp-dashboard.html','<div class="adp-dashboard">\n  <h3>Dashboard</h3>\n  <div class="adp-dashboard__grid" ng-if="dashboardData">\n\n    <adp-dashboard-tile ng-repeat="(key, item) in dashboardItems" item="item" data="dashboardData[key]">\n    </adp-dashboard-tile>\n  </div>\n</div>\n');
$templateCache.put('app/adp-generator/views/dashboard.html','<adp-page-loader loading="vm.loading">\n</adp-page-loader>\n\n<adp-content-container>\n\n  <adp-dashboard dashboard-name="::vm.pageParams.dashboardName"></adp-dashboard>\n\n</adp-content-container>\n');
$templateCache.put('app/adp-generator/views/datasets.html','<adp-content-container ng-if="vm.loaded" class="multi-record">\n  <div ng-if="vm.success">\n    <adp-section-container>\n      <adp-page-title>{{ ::vm.schema.fullName }}</adp-page-title>\n\n      <adp-page-description schema="::vm.schema"></adp-page-description>\n    </adp-section-container>\n\n    <adp-section-container class="adp-data-grid-container">\n      <adp-data-grid schema="vm.schema"></adp-data-grid>\n    </adp-section-container>\n  </div>\n\n  <adp-content-container ng-if="!vm.success">\n    <adp-section-container>\n      <adp-page-title>{{vm.errorMessage}}</adp-page-title>\n    </adp-section-container>\n  </adp-content-container>\n</adp-content-container>\n\n<adp-content-container ng-if="!vm.loaded">\n  <adp-page-loader></adp-page-loader>\n</adp-content-container>\n');
$templateCache.put('app/adp-generator/views/multi-record.html','<adp-content-container class="multi-record">\n  <adp-section-container>\n    <adp-page-title>{{ ::vm.schema.fullName }}</adp-page-title>\n\n    <adp-page-description schema="::vm.schema"></adp-page-description>\n  </adp-section-container>\n\n  <adp-section-container class="adp-data-grid-container">\n    <adp-data-grid schema="vm.schema"></adp-data-grid>\n  </adp-section-container>\n</adp-content-container>\n');
$templateCache.put('app/adp-generator/views/single-record.html','<adp-page-loader loading="vm.loading">\n</adp-page-loader>\n\n<adp-content-container class="single-record" ng-if="!vm.loading">\n\n  <adp-section-container>\n    <adp-page-title>{{::vm.args.modelSchema.fullName}}</adp-page-title>\n\n    <adp-page-description schema="::vm.args.modelSchema"></adp-page-description>\n\n    <button type="button" ng-if="!vm.editing && vm.showButton(vm.ACTIONS.CREATE)" ng-click="vm.enterEditMode()" class="btn btn-primary page-action">\n      Create\n    </button>\n\n    <button type="button" ng-if="!vm.editing && vm.showButton(vm.ACTIONS.UPDATE)" ng-click="vm.enterEditMode()" class="btn btn-primary page-action">\n      Edit\n    </button>\n  </adp-section-container>\n\n  <adp-section-container ng-if="!vm.editing">\n\n    <adp-record-details schema="::vm.args.modelSchema" data="::vm.args.row">\n    </adp-record-details>\n\n  </adp-section-container>\n\n  <adp-form class="single-record-form" ng-if="vm.editing" args="::vm.editArgs" form-options="::vm.formOptions">\n  </adp-form>\n</adp-content-container>\n');
$templateCache.put('app/adp-layout/partials/footer.tpl.html','<div id="page-footer" class="page-footer">\n  <div class="row">\n    <div class="col-xs-12 col-sm-6">\n      <span ng-if="::vm.footer.components.copyright" data-footer-target="vm.footer.components.copyright" class="txt-color-white"></span>\n    </div>\n\n    <div class="col-xs-6 col-sm-6 text-right hidden-xs">\n      <div class="txt-color-white inline-block">\n        <i ng-if="::vm.footer.components.lastAccountActivity" class="txt-color-blueLight hidden-mobile">\n          Last account activity\n          <i class="fa fa-clock-o"></i>\n          <strong>52 mins ago &nbsp;</strong>\n        </i>\n\n        <div class="btn-group dropup" ng-if="::vm.footer.components.status">\n          <button class="btn btn-xs dropdown-toggle bg-color-blue txt-color-white" data-toggle="dropdown">\n            <i class="fa fa-link"></i> <span class="caret"></span>\n          </button>\n          <ul class="dropdown-menu pull-right text-left">\n            <li>\n              <div class="padding-5">\n                <p class="txt-color-darken font-sm no-margin">Download Progress</p>\n\n                <div class="progress progress-micro no-margin">\n                  <div class="progress-bar progress-bar-success" style="width: 50%"></div>\n                </div>\n              </div>\n            </li>\n            <li class="divider"></li>\n            <li>\n              <div class="padding-5">\n                <p class="txt-color-darken font-sm no-margin">Server Load</p>\n\n                <div class="progress progress-micro no-margin">\n                  <div class="progress-bar progress-bar-success" style="width: 20%"></div>\n                </div>\n              </div>\n            </li>\n            <li class="divider"></li>\n            <li>\n              <div class="padding-5">\n                <p class="txt-color-darken font-sm no-margin">Memory Load <span class="text-danger">*critical*</span>\n                </p>\n\n                <div class="progress progress-micro no-margin">\n                  <div class="progress-bar progress-bar-danger" style="width: 70%"></div>\n                </div>\n              </div>\n            </li>\n            <li class="divider"></li>\n            <li>\n              <div class="padding-5">\n                <button class="btn btn-block btn-default">refresh</button>\n              </div>\n            </li>\n          </ul>\n        </div>\n\n        <adp-guided-tour-status>\n      </adp-guided-tour-status></div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/adp-layout/partials/header.tpl.html','<header id="header">\n  <div id="logo-group">\n    <!-- end collapse menu -->\n\n    <!-- PLACE YOUR LOGO HERE -->\n    <span id="logo">\n      <adp-app-logo></adp-app-logo> {{::vm.appTitle}}\n    </span>\n    <!-- END LOGO PLACEHOLDER -->\n\n    <!-- Note: The activity badge color changes when clicked and resets the number to 0\n    Suggestion: You may want to set a flag when this happens to tick off all checked messages / notifications -->\n\n    <adp-activities-dropdown ng-if="::vm.header.components.alerts">\n    </adp-activities-dropdown>\n  </div>\n\n  <adp-recent-projects ng-if="::vm.header.components.projectSelector">\n  </adp-recent-projects>\n\n  <!-- pulled right: nav area -->\n  <div class="pull-right">\n\n    <!-- collapse menu button -->\n    <div class="btn-header btn-nav-menu pull-right">\n        <span>\n            <a toggle-menu="" title="Collapse Menu">\n                <i class="fa fa-reorder"></i>\n            </a>\n        </span>\n    </div>\n    <!-- end collapse menu -->\n\n    <!-- #MOBILE -->\n    <!-- Top menu profile link : this shows only when top menu is active -->\n    <ul ng-if="::vm.header.components.menuToggle" id="mobile-profile-img" class="header-dropdown-list hidden-xs padding-5">\n      <li class="">\n        <a href="#" class="dropdown-toggle no-margin userdropdown" data-toggle="dropdown">\n          <img ng-src="{{\'/assets/img/avatars/male.png\'}}" alt="John Doe" class="online">\n        </a>\n        <ul class="dropdown-menu pull-right">\n          <li>\n            <a href-void="" class="padding-10 padding-top-0 padding-bottom-0"><i class="fa fa-cog"></i> Setting</a>\n          </li>\n          <li class="divider"></li>\n          <li>\n            <a class="padding-10 padding-top-0 padding-bottom-0"> <i class="fa fa-user"></i>\n              <u>P</u>rofile</a>\n          </li>\n          <li class="divider"></li>\n          <li>\n            <a href-void="" class="padding-10 padding-top-0 padding-bottom-0" data-action="toggleShortcut"><i class="fa fa-arrow-down"></i> <u>S</u>hortcut</a>\n          </li>\n          <li class="divider"></li>\n          <li>\n            <a href-void="" class="padding-10 padding-top-0 padding-bottom-0" data-action="launchFullscreen"><i class="fa fa-arrows-alt"></i> Full <u>S</u>creen</a>\n          </li>\n          <li class="divider"></li>\n          <li>\n            <a ng-click="vm.logout()" class="padding-10 padding-top-5 padding-bottom-5" data-action="userLogout">\n              <i class="fa fa-sign-out fa-lg"></i> <strong><u>L</u>ogout</strong>\n            </a>\n          </li>\n        </ul>\n      </li>\n    </ul>\n\n    <adp-user-dropdown class="btn-header btn-nav-menu pull-right"></adp-user-dropdown>\n\n    <!-- search mobile button (this is hidden till mobile view port) -->\n    <div id="search-mobile" class="btn-header transparent pull-right hidden-xs" data-search-mobile="">\n      <span> <a href="#" title="Search"><i class="fa fa-search"></i></a> </span>\n    </div>\n    <!-- end search mobile button -->\n\n    <!-- input: search field -->\n    <form action="#/search" ng-if="::vm.header.components.search" class="header-search pull-right">\n      <input id="search-fld" type="text" name="param" placeholder="Find reports and more" data-autocomplete="[\n        &quot;ActionScript&quot;,\n        &quot;AppleScript&quot;,\n        &quot;Asp&quot;,\n        &quot;BASIC&quot;,\n        &quot;C&quot;,\n        &quot;C++&quot;,\n        &quot;Clojure&quot;,\n        &quot;COBOL&quot;,\n        &quot;ColdFusion&quot;,\n        &quot;Erlang&quot;,\n        &quot;Fortran&quot;,\n        &quot;Groovy&quot;,\n        &quot;Haskell&quot;,\n        &quot;Java&quot;,\n        &quot;JavaScript&quot;,\n        &quot;Lisp&quot;,\n        &quot;Perl&quot;,\n        &quot;PHP&quot;,\n        &quot;Python&quot;,\n        &quot;Ruby&quot;,\n        &quot;Scala&quot;,\n        &quot;Scheme&quot;]">\n      <button type="submit">\n        <i class="fa fa-search"></i>\n      </button>\n      <a href="$" id="cancel-search-js" title="Cancel Search"><i class="fa fa-times"></i></a>\n    </form>\n    <!-- end input: search field -->\n\n    <!-- fullscreen button -->\n    <div id="fullscreen" ng-if="::vm.header.components.fullScreenToggle" class="btn-header transparent pull-right">\n        <span>\n          <a title="Full Screen" ng-click="vm.toggleFullScreen()">\n            <i class="fa fa-arrows-alt"></i>\n          </a>\n        </span>\n    </div>\n    <!-- end fullscreen button -->\n\n\n    <!-- multiple lang dropdown : find all flags in the flags page -->\n    <adp-language-selector ng-if="::vm.header.components.languageSelector">\n    </adp-language-selector>\n    <!-- end multiple lang -->\n  </div>\n  <!-- end pulled right: nav area -->\n\n</header>\n');
$templateCache.put('app/adp-layout/partials/navigation.tpl.html','<aside id="left-panel">\n    <div adp-mobile-page-title="" id="adp-mobile-page-title"></div>\n    <nav adp-main-menu=""></nav>\n</aside>\n');
$templateCache.put('app/adp-layout/partials/sub-header.tpl.html','<div class="col-xs-12 col-sm-5 col-md-5 col-lg-8" data-sparkline-container="">\n    <ul id="sparks" class="">\n        <li class="sparks-info">\n            <h5> My Income <span class="txt-color-blue">$47,171</span></h5>\n            <div class="sparkline txt-color-blue hidden-mobile hidden-md hidden-sm">\n                1300, 1877, 2500, 2577, 2000, 2100, 3000, 2700, 3631, 2471, 2700, 3631, 2471\n            </div>\n        </li>\n        <li class="sparks-info">\n            <h5> Site Traffic <span class="txt-color-purple"><i class="fa fa-arrow-circle-up"></i>&nbsp;45%</span></h5>\n            <div class="sparkline txt-color-purple hidden-mobile hidden-md hidden-sm">\n                110,150,300,130,400,240,220,310,220,300, 270, 210\n            </div>\n        </li>\n        <li class="sparks-info">\n            <h5> Site Orders <span class="txt-color-greenDark"><i class="fa fa-shopping-cart"></i>&nbsp;2447</span></h5>\n            <div class="sparkline txt-color-greenDark hidden-mobile hidden-md hidden-sm">\n                110,150,300,130,400,240,220,310,220,300, 270, 210\n            </div>\n        </li>\n    </ul>\n</div>\n\t\t\t');
$templateCache.put('app/adp-layout/partials/voice-commands.tpl.html','<!-- TRIGGER BUTTON:\n<a href="/my-ajax-page.html" data-toggle="modal" data-target="#remoteModal" class="btn btn-default">Open Modal</a>  -->\n\n<!-- MODAL PLACE HOLDER\n<div class="modal fade" id="remoteModal" tabindex="-1" role="dialog" aria-labelledby="remoteModalLabel" aria-hidden="true">\n<div class="modal-dialog">\n<div class="modal-content"></div>\n</div>\n</div>   -->\n<!--////////////////////////////////////-->\n\n<!--<div class="modal-header">\n<button type="button" class="close" data-dismiss="modal" aria-hidden="true">\n&times;\n</button>\n<h4 class="modal-title" id="myModalLabel">Command List</h4>\n</div>-->\n<div class="modal-body">\n\n\t<h1><i class="fa fa-microphone text-muted"></i>&nbsp;&nbsp; AppAdmin Voice Command</h1>\n\t<hr class="simple">\n\t<h5>Instruction</h5>\n\n\tClick <span class="text-success">"Allow"</span> to access your microphone and activate Voice Command.\n\tYou will notice a <span class="text-primary"><strong>BLUE</strong> Flash</span> on the microphone icon indicating activation.\n\tThe icon will appear <span class="text-danger"><strong>RED</strong></span> <span class="label label-danger"><i class="fa fa-microphone fa-lg"></i></span> if you <span class="text-danger">"Deny"</span> access or don\'t have any microphone installed.\n\t<br>\n\t<br>\n\tAs a security precaution, your browser will disconnect the microphone every 60 to 120 seconds (sooner if not being used). In which case Voice Command will prompt you again to <span class="text-success">"Allow"</span> or <span class="text-danger">"Deny"</span> access to your microphone.\n\t<br>\n\t<br>\n\tIf you host your page over <strong>http<span class="text-success">s</span></strong> (secure socket layer) protocol you can wave this security measure and have an unintrupted Voice Command.\n\t<br>\n\t<br>\n\t<h5>Commands</h5>\n\t<ul>\n\t\t<li>\n\t\t\t<strong>\'show\' </strong> then say the <strong>*page*</strong> you want to go to. For example <strong>"show inbox"</strong> or <strong>"show calendar"</strong>\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'mute\' </strong> - mutes all sound effects for the theme.\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'sound on\'</strong> - unmutes all sound effects for the theme.\n\t\t</li>\n\t\t<li>\n\t\t\t<span class="text-danger"><strong>\'stop\'</strong></span> - deactivates voice command.\n\t\t</li>\n\t\t<li>\n\t\t\t<span class="text-primary"><strong>\'help\'</strong></span> - brings up the command list\n\t\t</li>\n\t\t<li>\n\t\t\t<span class="text-danger"><strong>\'got it\'</strong></span> - closes help modal\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'hide navigation\'</strong> - toggle navigation collapse\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'show navigation\'</strong> - toggle navigation to open (can be used again to close)\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'scroll up\'</strong> - scrolls to the top of the page\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'scroll down\'</strong> - scrollts to the bottom of the page\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'go back\' </strong> - goes back in history (history -1 click)\n\t\t</li>\n\t\t<li>\n\t\t\t<strong>\'logout\'</strong> - logs you out\n\t\t</li>\n\t</ul>\n\t<br>\n\t<h5>Adding your own commands</h5>\n\tVoice Command supports up to 80 languages. Adding your own commands is extreamly easy. All commands are stored inside <strong>app.config.js</strong> file under the <code>var commands = {...}</code>. \n\n\t<hr class="simple">\n\t<div class="text-right">\n\t\t<button type="button" class="btn btn-success btn-lg" data-dismiss="modal">\n\t\t\tGot it!\n\t\t</button>\n\t</div>\n\n</div>\n<!--<div class="modal-footer">\n<button type="button" class="btn btn-primary" data-dismiss="modal">Got it!</button>\n</div> -->');
$templateCache.put('app/adp-auth/directives/last-login-data-modal/last-login-data-modal.html','<div class="modal-header delete-action-modal">\n  <h3 class="adp-last-login-title modal-title"><i class="fa fa-sign-in" aria-hidden="true"></i>\n     Latest Login Attempts</h3>\n\n  <p>Please <strong>review the latest login attempts</strong> for this account and report suspicious activity, if any, to the system administrator:</p>\n\n  <div>\n    <p class="adp-last-login-item" ng-repeat="item in vm.lastLoginData track by $index">\n      {{vm.toData(item.date)}} from {{item.ip}} - {{item.status}}\n    </p>\n  </div>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-primary" type="button" ng-click="vm.confirm()">\n    Proceed\n  </button>\n</div>\n');
$templateCache.put('app/adp-auth/directives/login-info/login-info.template.html','<div ng-class="{\'disabled\': disabled}" class="login-info ng-cloak">\n  <span>\n    <!-- User image size is adjusted inside CSS, it should stay as it -->\n    <a href="" adp-user-menu-toggle="">\n      <img ng-src="{{baseUrl + \'assets/img/profile.jpg\'}}" alt="me" class="online">\n      <span>{{user.login}}</span>\n      <i class="fa fa-angle-down"></i>\n    </a>\n  </span>\n</div>\n');
$templateCache.put('app/adp-common/directives/adp-alert-modal/adp-alert-modal.html','<div ng-if="vm.options.title" class="modal-header">\n  <h3 class="modal-title">{{vm.options.title}}</h3>\n</div>\n\n<div class="modal-body" ng-bind-html="vm.options.message"></div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-primary" type="button" adp-hot-key="Enter" ng-click="vm.cancel()">\n    OK\n  </button>\n</div>\n');
$templateCache.put('app/adp-common/directives/adp-app-logo/adp-app-logo.html','<img class="adp-app-logo" ng-if="logoSrc" ng-src="{{logoUrl}}" alt="{{title}}">\n');
$templateCache.put('app/adp-common/directives/adp-confirm-dialog-modal/adp-confirm-dialog-modal.html','<div class="modal-header delete-action-modal">\n  <h3 class="modal-title">{{vm.options.message}}</h3>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.cancel()" adp-hot-key="Escape" ng-if="!vm.options.hideCancelButton">\n    Cancel\n  </button>\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.extra()" ng-if="vm.options.extraButtonText">\n    {{vm.options.extraButtonText}}\n  </button>\n\n  <button class="adp-action-b-primary" type="button" adp-hot-key="Enter" ng-click="vm.confirm()">\n    {{vm.options.okButtonText || \'Yes\'}}\n  </button>\n</div>\n');
$templateCache.put('app/adp-common/directives/adp-read-file-dialog-modal/adp-read-file-dialog-modal.html','<div class="modal-header">\n    <h3 class="modal-title">{{vm.options.title}}</h3>\n</div>\n<div class="modal-body readFile-action-modal drop-zone">\n    <section class="input-container" ng-class="{\'state-error\': vm.error}">\n        <input type="file" select-ng-file="" ng-model="vm.fileArray" ng-change="vm.onChange()" style="height:1px; opacity:0">\n        <button class="btn btn-primary" ng-click="vm.onInput()">\n            Drop here or Choose file\n        </button>\n        <div class="note note-error" ng-if="vm.error">\n            {{vm.error}}\n        </div>\n        <div class="selected-files-list">{{ vm.selectedFilesText }}</div>\n    </section>\n</div>\n<div class="modal-footer" adp-handle-hot-keys="">\n    <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n        Cancel\n    </button>\n    <button class="adp-action-b-primary" ng-click="vm.onReadFile()" adp-hot-key="Enter" ng-disabled="vm.error">\n        {{ vm.options.uploadButtonText }}\n    </button>\n</div>\n');
$templateCache.put('app/adp-common/directives/adp-prompt-dialog-modal/adp-prompt-dialog-modal.html','<div class="modal-header">\n    <h3 class="modal-title">{{vm.options.title}}</h3>\n</div>\n\n<div class="modal-body prompt-action-modal">\n    <div ng-if="vm.text" class="adp-pre-wrap">{{ vm.text }}</div>\n\n    <section class="input-container" ng-class="{ \'state-error\': vm.error }">\n        <div dx-text-box="vm.config" ng-model="vm.value"></div>\n        <div class="note note-error" ng-if="vm.error">\n          {{vm.error}}\n        </div>\n    </section>\n</div>\n<div class="modal-footer" adp-handle-hot-keys="">\n    <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n        Cancel\n    </button>\n\n    <button class="adp-action-b-primary" adp-hot-key="Enter" ng-click="vm.save()" ng-disabled="vm.error">\n        {{ vm.saveButtonText }}\n    </button>\n</div>\n');
$templateCache.put('app/adp-data-grid/components/adp-data-grid/adp-data-grid.template.html','<div class="adp-datagrid-box">\n  <div ng-if="vm.dataGridOptions" dx-data-grid="vm.dataGridOptions"></div>\n\n  <div dx-tooltip="vm.gridOptions"></div>\n</div>\n');
$templateCache.put('app/adp-data-grid/components/adp-record-details/adp-record-details.template.html','<div class="adp-row" ng-repeat="fieldOrGroup in ::vm.fields track by $index" ng-class="::[vm.schema.schemaName]">\n  <div ng-if="fieldOrGroup.fields && vm.showValue(field)" ng-repeat="field in fieldOrGroup.fields track by $index" ng-class="[vm.selectColumnClass(field)]">\n    <record-details-value-row field="::field" schema="::vm.schema" filtered-record="::vm.filteredRecord" args="::vm.args"></record-details-value-row>\n  </div>\n\n  <div class="adp-col adp-col-12" ng-if="::fieldOrGroup.groups">\n    <div class="view-details-row view-details-row-group">\n      <record-details-grouping groups="::fieldOrGroup.groups" schema="::vm.schema" filtered-record="::vm.filteredRecord" args="::vm.args"></record-details-grouping>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/adp-file-uploader/components/adp-audio-modal/adp-audio-modal.template.html','<div class="modal-header text-center">\n  <h3 class="modal-title">\n    Record audio\n  </h3>\n\n  <adp-uploader-errors uploader="vm.uploader">\n  </adp-uploader-errors>\n</div>\n\n<div class="modal-body">\n  <adp-audio-recorder result-file="vm.resultFile" options="vm.options">\n  </adp-audio-recorder>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n    Cancel\n  </button>\n  <button class="adp-action-b-primary" type="button" adp-hot-key="Enter" ng-disabled="vm.isEmpty()" ng-click="vm.save()">\n    Save\n  </button>\n</div>\n');
$templateCache.put('app/adp-file-uploader/components/adp-crop-modal/adp-crop-modal.template.html','<div class="modal-header text-center">\n  <h3 class="modal-title">\n    Please select an area for your profile picture.\n  </h3>\n\n  <adp-uploader-errors uploader="vm.uploader">\n  </adp-uploader-errors>\n</div>\n\n<div class="adp-crop-modal-body modal-body">\n  <ui-cropper ng-if="vm.inputImage" image="vm.inputImage" cropject="vm.currentItemCropParams" area-type="rectangle" init-max-area="true" aspect-ratio="vm.aspectRatio" result-image="vm.outputImage">\n  </ui-cropper>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n    Cancel\n  </button>\n\n  <button class="adp-action-b-primary" type="button" ng-click="vm.save()">\n    Save\n  </button>\n\n  <button class="adp-action-b-primary" type="button" ng-if="vm.items.length > 0" ng-click="vm.next()">\n    Crop next image\n  </button>\n</div>\n');
$templateCache.put('app/adp-file-uploader/components/adp-photo-modal/adp-photo-modal.template.html','<div class="modal-header text-center">\n  <h3 class="modal-title">\n    Make a photo\n  </h3>\n\n  <adp-uploader-errors uploader="vm.uploader">\n  </adp-uploader-errors>\n</div>\n\n<div class="modal-body">\n  <adp-photo-recorder player="vm.player" result-file="vm.resultFile" options="vm.options">\n  </adp-photo-recorder>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n    Cancel\n  </button>\n\n  <button class="adp-action-b-tertiary" type="button" ng-if="vm.isEmpty() && vm.player.record().isRecording()" ng-click="vm.capturePhoto()">\n    Take a photo\n  </button>\n\n  <button class="adp-action-b-tertiary" type="button" ng-if="!vm.isEmpty()" ng-click="vm.retryPhoto()">\n    Retry photo capture\n  </button>\n\n  <button class="adp-action-b-primary" type="button" adp-hot-key="Enter" ng-disabled="vm.isEmpty()" ng-click="vm.save()">\n    Save\n  </button>\n</div>\n');
$templateCache.put('app/adp-file-uploader/components/adp-video-modal/adp-video-modal.template.html','<div class="modal-header text-center">\n  <h3 class="modal-title">\n    Record video\n  </h3>\n\n  <adp-uploader-errors uploader="vm.uploader">\n  </adp-uploader-errors>\n</div>\n\n<div class="modal-body">\n  <adp-video-recorder result-file="vm.resultFile" options="vm.options">\n  </adp-video-recorder>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n    Cancel\n  </button>\n  <button class="adp-action-b-primary" type="button" adp-hot-key="Enter" ng-disabled="vm.isEmpty()" ng-click="vm.save()">\n    Save\n  </button>\n</div>\n');
$templateCache.put('app/adp-file-uploader/directives/adp-file-uploader/adp-file-uploader.template.html','<!-- CONTROLS:START -->\n<div class="adp-file-uploader-dropzone" ng-if="uploader">\n  <div adp-file-uploader-dropzone="" data="data" uploader="uploader" class="adp-uploader-btns adp-uploader-row">\n\n    <button ng-click="uploader.callAddFileWindows()" class="btn btn-primary" ng-attr-adp-qaid-fileupload-btn="{{args.path}}" ng-disabled="uploader.isFileCollection && !args.row.fileType" type="button">\n      <span ng-show="options.enableDragAndDrop">\n        Drop file or click to upload\n      </span>\n\n      <span ng-show="!options.enableDragAndDrop">\n        Click to upload\n      </span>\n    </button>\n\n    <button ng-if="options.enableMicrophone" ng-click="callAudioModal()" type="button" ng-attr-adp-qaid-audio-record-btn="{{args.path}}" class="btn btn-primary">\n      Record audio\n    </button>\n\n    <button ng-if="options.enableWebcam" ng-click="callVideoModal()" type="button" ng-attr-adp-qaid-video-record-btn="{{args.path}}" class="btn btn-primary">\n      Record video\n    </button>\n\n    <div ng-if="options.enablePhotoCapture" ng-click="callPhotoModal()" type="button" ng-attr-adp-qaid-photo-record-btn="{{args.path}}" class="btn btn-primary">\n      Take a photo\n    </div>\n  </div>\n\n  <div class="adp-uploader-row">\n    <adp-uploader-errors uploader="uploader">\n    </adp-uploader-errors>\n  </div>\n\n  <div class="adp-uploader-row">\n    <adp-file-uploader-list data="data" uploader="uploader">\n    </adp-file-uploader-list>\n  </div>\n\n  <div ng-if="uploader.isUploading" class="adp-uploader-row">\n    Upload progress:\n    <div class="progress" style="">\n      <div class="progress-bar" role="progressbar" ng-style="{ \'width\': uploader.progress + \'%\' }">\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/adp-file-uploader/directives/adp-file-uploader-dropzone/adp-file-uploader-dropzone.template.html','<div ng-click="uploader.callAddFileWindows()" ng-class="{\'adp-file-uploader-over\': dropOver}" class="well adp-dropzone">\n  <i class="fa fa-upload"></i> Drop file or click to upload\n</div>');
$templateCache.put('app/adp-file-uploader/directives/adp-file-uploader-list/adp-file-uploader-list.template.html','<table class="adp-uploader-list table table-striped">\n  <tbody>\n  <tr ng-repeat="item in uploader.queue">\n    <td class="adp-uploader-list-thumb">\n      <adp-thumb file-item="item._file">\n      </adp-thumb>\n    </td>\n\n    <td class="adp-uploader-list-info">\n      <div class="adp-uploader-list-actions">\n        <button type="button" class="btn btn-primary" ng-if="$parent.isCropEnabled(item)" ng-click="$parent.crop(item)" ng-disabled="item.isUploading">\n          <span class="fa fa-crop"></span> Crop\n        </button>\n\n        <button type="button" class="btn btn-danger" ng-disabled="item.isUploading" ng-click="$parent.remove(item)" ng-show="::!$parent.uploader.isFileCollection">\n          <span class="fa fa-trash"></span> Remove\n        </button>\n      </div>\n      <strong><a href="">{{ item.file.name }}</a></strong>\n\n      <span ng-show="uploader.isHTML5">\n        {{ item.file.size | adpBytes }}\n      </span>\n    </td>\n  </tr>\n\n  </tbody>\n</table>\n');
$templateCache.put('app/adp-file-uploader/directives/adp-uploader-errors/adp-uploader-errors.template.html','<div ng-if="uploader.errors.length" class="adp-uploader-errors-box text-left">\n  <h5 class="semi-bold">Some files was removed due to errors:</h5>\n\n  <ol class="adp-uploader-errors note note-error">\n    <li class="error-message" ng-repeat="error in uploader.errors">\n      {{error.file}}: {{error.message}}\n    </li>\n  </ol>\n\n  <button class="btn btn-danger btn-xs" ng-click="hide()" type="button">\n    Hide\n  </button>\n</div>');
$templateCache.put('app/adp-forms/directives/adp-form/adp-form.html','<form name="form" ng-attr-adp-qaid-form="{{args.modelSchema.schemaName}}" class="smart-form client-form" ng-class="[formActionClass, args.modelSchema.schemaName]" novalidate="" adp-fullscreen="" ng-submit="submit(args)">\n  <header class="smart-form-header">\n    <span ng-transclude-replace="header"></span>\n    <adp-fullscreen-button></adp-fullscreen-button>\n  </header>\n\n  <div ng-transclude-replace="body"></div>\n\n  <adp-form-iterator></adp-form-iterator>\n\n  <fieldset class="form-error-count input-container state-error" ng-if="errorCount.cnt > 0">\n    <div class="note-error col col-12 text-right">\n      <span ng-if="errorCount.cnt == 1">\n        {{errorCount.cnt}} error found in the form.\n      </span>\n\n      <span ng-if="errorCount.cnt >= 2">\n        {{errorCount.cnt}} errors found in the form.\n      </span>\n    </div>\n  </fieldset>\n\n  <div ng-transclude-replace="footer" ng-if="::formOptions.localActionsStrategy"></div>\n\n  <adp-form-actions ng-if="::formOptions.schemaActionsStrategy"></adp-form-actions>\n</form>\n\n<adp-page-loader class="adp-position-center" loading="loading"></adp-page-loader>\n');
$templateCache.put('app/adp-forms/directives/adp-form-field-container/adp-form-field-container.html','<section class="input-container" ng-field-name="{{::args.fieldSchema.fieldName}}" ng-transclude=""></section>\n');
$templateCache.put('app/adp-forms/directives/adp-form-group-messages/adp-form-group-messages.html','<div class="adp-form-group-messages">\n  <adp-messages ng-repeat="args in ::argsList track by $index" ng-attr-adp-qaid-group-field-error-messages="{{args.path}}" args="args"></adp-messages>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-messages/adp-messages.html','<div ng-messages="" for="fieldModel.$error" ng-if="fieldModel.$dirty" class="note note-error">\n\n  <span ng-message="required">{{::args.fieldSchema.fullName}} is required.</span>\n\n  <span ng-message="regex">{{messages[\'regex\']}}</span>\n\n  <span ng-message="min">{{messages[\'min\']}}</span>\n\n  <span ng-message="max">{{messages[\'max\']}}</span>\n\n  <span ng-message="minLength">{{messages[\'minLength\']}}</span>\n\n  <span ng-message="maxLength">{{messages[\'maxLength\']}}</span>\n\n  <span ng-message="passwordMatch">Passwords do not match.</span>\n\n  <span ng-message="location">Address not found. Please try again.</span>\n\n  <span ng-message="notInFuture">{{messages.notInFuture}}</span>\n\n  <span ng-message="notInPast">{{messages.notInPast}}</span>\n\n  <span ng-message="int32">{{messages.int32 || "Value is not a valid int32 number."}}</span>\n\n  <span ng-message="int64">{{messages.int64 || "Value is not a valid int32 number."}}</span>\n\n  <span ng-message="number">\n    <span ng-if="[\'Int32\', \'Int64\'].includes(args.fieldSchema.type)">\n      "{{::args.fieldSchema.fullName}}" is not a valid integer number.\n    </span>\n\n    <span ng-if="![\'Int32\', \'Int64\'].includes(args.fieldSchema.type)">\n      "{{::args.fieldSchema.fullName}}" is not a valid number.\n    </span>\n  </span>\n\n  <span ng-message="pattern">\n    <span ng-if="args.fieldSchema.type === \'Decimal128\'">\n      "{{::args.fieldSchema.fullName}}" is not a decimal valid number.\n    </span>\n\n    <span ng-if="[\'Int32\', \'Int64\'].includes(args.fieldSchema.type)">\n      "{{::args.fieldSchema.fullName}}" is not a valid integer number.\n    </span>\n  </span>\n\n  <span ng-message="associativeArrayKeyUnique">\n    {{messages.associativeArrayKeyUnique}}\n  </span>\n\n  <span ng-message="schemaKeyRegExp">\n    {{messages.schemaKeyRegExp}}\n  </span>\n\n  <span ng-message="syntaxCodeEditorError">\n    Code editor contains errors. Fix all syntax errors before submitting\n  </span>\n\n  <span ng-message="jsonSyntaxCodeEditorError">\n    Invalid JSON.\n  </span>\n\n  <span ng-message="dateValid">\n    Date is invalid.\n  </span>\n\n  <span ng-message="fileType">\n    File type is invalid.\n  </span>\n</div>\n');
$templateCache.put('app/adp-generator/directives/adp-cell-editor-modal/adp-cell-editor-modal.html','<adp-form args="::vm.args" form-options="::vm.formOptions" adp-form-params="::vm.formParams">\n  <form-header>\n    <h2 class="semi-bold">{{ ::vm.actionText }} "{{ ::vm.args.modelSchema.fullName }}"</h2>\n  </form-header>\n\n  <form-footer adp-handle-hot-keys="">\n    <footer class="adp-action-b-container">\n      <button class="adp-action-b-secondary" type="button" ng-click="vm.cancel()">\n        Cancel\n      </button>\n\n      <button class="adp-action-b-primary" type="submit">\n        {{ ::vm.actionText }}\n      </button>\n    </footer>\n  </form-footer>\n\n</adp-form>\n');
$templateCache.put('app/adp-generator/directives/adp-default-action-modal/adp-default-action-modal.html','<div class="modal-header text-center">\n  <h3 class="modal-title">\n    Record details.\n  </h3>\n</div>\n\n<div class="modal-body">\n  <table>\n    <tr ng-repeat="(key, value) in vm.itemData">\n      <td>\n        <strong>{{key}}</strong>\n      </td>\n      <td>\n        {{value}}\n      </td>\n    </tr>\n  </table>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-primary" type="button" ng-click="vm.close()">\n    Close\n  </button>\n</div>\n');
$templateCache.put('app/adp-generator/directives/adp-record-details-modal/adp-record-details-modal.html','<div adp-fullscreen="">\n  <div class="smart-form client-form">\n    <header class="smart-form-header">\n      <h2 class="semi-bold">\n        Record details\n      </h2>\n\n      <adp-fullscreen-button></adp-fullscreen-button>\n    </header>\n  </div>\n\n  <div class="modal-body">\n    <adp-record-details schema="vm.schema" data="vm.data"></adp-record-details>\n  </div>\n\n  <div class="smart-form client-form">\n    <footer class="adp-action-b-container" adp-handle-hot-keys="">\n      <button class="adp-action-b-primary" type="button" ng-click="vm.close()">\n        Close\n      </button>\n    </footer>\n  </div>\n</div>\n');
$templateCache.put('app/adp-generator/directives/adp-record-form-modal/adp-record-form-modal.html','<adp-form args="::vm.args" form-options="::vm.formOptions" adp-form-params="::vm.formParams">\n  <form-header ng-if="::vm.formHeaderText">\n    <h2 class="semi-bold">{{::vm.formHeaderText}}</h2>\n  </form-header>\n\n</adp-form>\n');
$templateCache.put('app/adp-recorders/directives/adp-audio-recorder/adp-audio-recorder.template.html','<div class="adp-recorder-viewport"></div>\n\n<div class="adp-record-engine">\n  <label class="label">Record as:</label>\n\n  <select class="form-control adp-record-engine-label" ng-model="currentEngine" ng-options="item for item in engines" ng-change="setEngine()">\n  </select>\n</div>\n');
$templateCache.put('app/adp-recorders/directives/adp-photo-recorder/adp-photo-recorder.template.html','<div class="adp-recorder-viewport"></div>\n');
$templateCache.put('app/adp-recorders/directives/adp-video-recorder/adp-video-recorder.template.html','<div class="adp-recorder-viewport"></div>');
$templateCache.put('app/adp-ui/components/adp-activities-dropdown/adp-activities-dropdown.template.html','<span id="activity" class="activity-dropdown" adp-activities-dropdown-toggle="">\n    <i class="fa fa-user"></i>\n    <b class="badge bg-color-red">21</b>\n</span>\n\n<div class="ajax-dropdown">\n\n  <!-- the ID links are fetched via AJAX to the ajax container "ajax-notifications" -->\n  <div class="btn-group btn-group-justified" data-toggle="buttons">\n\n    <label class="btn btn-default" ng-class="{ \'active\' : vm.isActive(type.name)}" ng-repeat="(key, type) in vm.activities.types" ng-click="vm.setTab(type.name)">\n\n      <input type="radio" name="activity"> {{type.title}} ({{type.length}})\n    </label>\n\n  </div>\n\n  <!-- notification content -->\n  <div class="ajax-notifications custom-scroll" ng-switch="vm.activeTab">\n    <div smart-include="app/adp-ui/components/adp-activities-dropdown/partials/tab-msgs.html" ng-switch-when="msgs"></div>\n    <div smart-include="app/adp-ui/components/adp-activities-dropdown/partials/tab-notify.html" ng-switch-when="notify"></div>\n    <div smart-include="app/adp-ui/components/adp-activities-dropdown/partials/tab-tasks.html" ng-switch-when="tasks"></div>\n    <div smart-include="app/adp-ui/components/adp-activities-dropdown/partials/tab-default.html" ng-switch-when="default"></div>\n  </div>\n  <!-- end notification content -->\n\n  <!-- footer: refresh area -->\n  <span> Last updated on: {{vm.activities.last_update}}\n    <button type="button" data-loading-text="<i class=\'fa fa-refresh fa-spin\'></i> Loading..." class="btn btn-xs btn-default pull-right">\n       <i class="fa fa-refresh"></i>\n    </button>\n  </span>\n  <!-- end footer -->\n\n</div>\n');
$templateCache.put('app/adp-ui/components/adp-content-container/adp-content-container.template.html','<div id="content" class="clearfix" ng-transclude="">\n</div>');
$templateCache.put('app/adp-ui/components/adp-language-selector/adp-language-selector.template.html','<ul class="header-dropdown-list hidden-xs ng-cloak">\n  <li class="dropdown" dropdown="">\n\n    <a class="dropdown-toggle" data-toggle="dropdown" href="">\n      <img ng-src="{{vm.baseUrl + \'/assets/img/blank.gif\'}}" class="flag flag-{{$root.currentLanguage.key}}" alt="{{$root.currentLanguage.alt}}">\n      <span> {{$root.currentLanguage.title}} </span>\n\n      <i class="fa fa-angle-down"></i> </a>\n\n    <ul class="dropdown-menu pull-right">\n      <li ng-class="{ \'active\': language == $root.currentLanguage }" ng-repeat="language in $root.languages track by $index">\n\n        <a ng-click="vm.selectLanguage(language)">\n          <img ng-src="{{vm.baseUrl + \'/assets/img/blank.gif\'}}" class="flag flag-{{language.key}}" alt="{{language.alt}}">\n          {{language.title}}\n        </a>\n\n      </li>\n    </ul>\n  </li>\n</ul>\n');
$templateCache.put('app/adp-ui/components/adp-page-description/adp-page-description.template.html','<div ng-if="!$ctrl.isEmpty">\n  <div ng-bind-html="$ctrl.description"></div>\n</div>');
$templateCache.put('app/adp-ui/components/adp-page-title/adp-page-title.template.html','<h1 class="semi-bold" ng-transclude="" page-title="{{$ctrl.pageTitle}}"></h1>\n');
$templateCache.put('app/adp-ui/components/adp-recent-projects/adp-recent-projects.template.html','<div class="project-context hidden-xs dropdown" dropdown="">\n\n    <span class="label">Projects:</span>\n\n    <span class="project-selector dropdown-toggle" data-toggle="dropdown">\n      Recent projects <i ng-if="vm.projects.length" class="fa fa-angle-down"></i>\n    </span>\n\n    <ul class="dropdown-menu" ng-if="vm.projects.length">\n        <li ng-repeat="project in vm.projects">\n            <a href="{{project.href}}">{{project.title}}</a>\n        </li>\n        <li class="divider"></li>\n        <li>\n            <a ng-click="vm.clearProjects()">\n              <i class="fa fa-power-off"></i> Clear\n            </a>\n        </li>\n    </ul>\n\n</div>');
$templateCache.put('app/adp-ui/components/adp-section-container/adp-section-container.template.html','<div class="well" ng-transclude="">\n</div>');
$templateCache.put('app/adp-ui/components/adp-section-title/adp-section-title.template.html','<h2 class="semi-bold" ng-transclude=""></h2>');
$templateCache.put('app/adp-ui/directives/adp-breadcrumbs/adp-breadcrumbs.template.html','<ol class="breadcrumb">\n  <li ng-if="breadcrumbs.length" ng-repeat="breadcrumb in breadcrumbs track by $index">\n    <a ng-href="{{breadcrumb.href}}">{{breadcrumb.content}}</a>\n  </li>\n</ol>');
$templateCache.put('app/adp-ui/directives/adp-clipboard-button/adp-clipboard-button.template.html','<div ng-if="::showClipboardBtn">\n  <div dx-menu="::menuOptions"></div>\n  <div ng-if="::tooltipOptions" dx-tooltip="::tooltipOptions">\n    Copied!\n  </div>\n</div>\n');
$templateCache.put('app/adp-ui/directives/adp-fullscreen/adp-fullscreen-button.html','<button type="button" class="smart-form-fullscreen fa" ng-if="!formOptions.disableFullscreen || isFullscreenSupported()" ng-click="toggleFullScreen()" ng-class="{ \'fa-expand\': !$root.isFullscreen, \'fa-compress\': $root.isFullscreen }">\n</button>\n');
$templateCache.put('app/adp-ui/directives/adp-page-loader/adp-page-loader.template.html','<div class="adp-page-loader" style="{{style}}" ng-class="{\'adp-visible\': loading}">\n  <i class="fa fa-gear fa-4x fa-spin"></i>\n</div>\n');
$templateCache.put('app/adp-ui/directives/adp-tooltip/adp-tooltip.template.html','<span ng-show="::hasDescription">\n  <b class="adp-tooltip-trigger fa fa-question-circle"></b>\n  <span dx-tooltip="::tooltipOptions"></span>\n</span>\n');
$templateCache.put('app/adp-data-grid/components/adp-record-details/record-details-value-row/record-details-value-row.template.html','<div ng-switch="" on="field.type" ng-class="[valueRowClass]">\n  <div ng-switch-when="Blank"></div>\n\n  <div ng-switch-when="FormSeparator">\n    <adp-form-separator field-schema="::field"></adp-form-separator>\n  </div>\n\n  <div ng-switch-default="">\n    <div class="view-details-label">\n      {{field.fullName}}\n      <adp-view-details-tooltip field="::field"></adp-view-details-tooltip>\n      <adp-clipboard-button></adp-clipboard-button>\n    </div>\n\n    <div class="view-details-cell">\n      <adp-record-details-cell args="::args"></adp-record-details-cell>\n    </div>\n  </div>\n\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form/adp-form-actions/adp-form-actions.html','<footer class="adp-action-b-container" adp-handle-hot-keys="form">\n  <button ng-repeat-start="(name, action) in actions" ng-if="visibleGetter(action) && [\'module\', \'action\'].includes(action.action.type)" ng-class="[action.className]" data-action-name="{{name}}" adp-hot-key="{{action.hotKey}}" ng-click="execFormAction(action, name)" ng-attr-style="{{action.htmlAttributes.style}}" ng-attr-type="{{action.htmlAttributes.type}}" ng-attr-title="{{action.description}}" ng-attr-adp-qaid-form-action="{{name}}" ng-disabled="disabledState(action)">\n    <span ng-if="hasIcon(action)" ng-bind-html="getIcon(action.icon)"></span>\n    <span ng-if="hasFullName(action)">{{ fullNameGetter(action) }}</span>\n  </button>\n\n  <a ng-repeat-end="" ng-if="action.action.type === \'link\' && visibleGetter(action)" ng-href="{{evalLink(action)}}" target="_blank" ng-class="[action.className]" data-action-name="{{name}}" ng-attr-style="{{action.htmlAttributes.style}}" ng-attr-type="{{action.htmlAttributes.type}}" ng-attr-title="{{action.description}}" ng-attr-adp-qaid-form-action="{{name}}" ng-disabled="disabledState(action)">\n    <span ng-if="hasIcon(action)" ng-bind-html="getIcon(action.icon)"></span>\n    <span ng-if="hasFullName(action)">{{ fullNameGetter(action) }}</span>\n  </a>\n</footer>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/boolean-control/boolean-control.html','<div></div>\n\n<input type="hidden" name="{{::args.fieldSchema.fieldName}}" id="{{::controlId}}" adp-validate="::args" ng-required="isRequired()" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/code-control/code-control.html','<adp-ace editors-config="::editorsConfig" editor-id="::editorId" ng-required="isRequired()" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n</adp-ace>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/cron-expression-control/cron-expression-control.html','\n<input type="hidden" name="{{::args.fieldSchema.fieldName}}" id="{{::controlId}}" adp-validate="::args" ng-required="isRequired()" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n<div class="adp-form-fieldset">\n<div class="col col-6" ng-attr-adp-qaid-field-control="{{args.path}}"></div>\n<div class="col col-6 adp-human-readable"></div>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/datetime-control/datetime-control.html','<div dx-tag-box="::config" ng-if="::config" field-name="{{::args.fieldSchema.fieldName}}">\n</div>\n\n<input type="hidden" ng-required="isRequired()" adp-validate="::args" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/decimal-array-control/decimal-array-control.html','<div dx-tag-box="::config" class="adp-number-array" ng-if="::config" field-name="{{::args.fieldSchema.fieldName}}">\n</div>\n\n<input type="hidden" ng-required="isRequired()" adp-validate="::args" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/dx-control-factory/dx-control-factory.html','<div></div>\n\n<input name="{{::args.fieldSchema.fieldName}}" adp-validate="::args" ng-required="isRequired()" type="hidden" ng-model="getterSetter" ng-model-options="{ allowInvalid: true, debounce: 200, getterSetter: true }">\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/file-control/file-control.html','<adp-file-uploader ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }" file-required="isRequired()" name="{{::args.fieldSchema.fieldName}}" args="args" form-context="formContext"></adp-file-uploader>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/form-render-control/form-render-control.html','<div ng-attr-form-render-view="{{args.path}}" ng-attr-adp-qaid-form-render-field-content="{{args.path}}"></div>');
$templateCache.put('app/adp-forms/directives/adp-form-controls/grid-control/grid-control.html','<adp-data-grid schema="::modelSchemaForGrid" options="::options" ng-attr-adp-qaid-grid-control="{{args.path}}"></adp-data-grid>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/html-control/html-control.html','<adp-ckeditor ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }" ng-required="isRequired()" editors-config="::editorsConfig" name="{{::args.fieldSchema.fieldName}}" editor-id="args.path">\n</adp-ckeditor>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/icon-control/icon-control.html','<div class="dx-show-invalid-badge dx-textbox dx-texteditor dx-editor-filled dx-texteditor-empty dx-widget">\n  <div style="cursor: pointer" class="dx-texteditor-container">\n    <div class="dx-texteditor-input-container" ng-click="showModal()">\n      <div class="dx-texteditor-input-container">\n        <div class="dx-texteditor-input" ng-show="hasValue">\n          <span ng-bind-html="iconTpl"></span> {{iconTpl}}\n        </div>\n\n        <div class="dx-texteditor-input" ng-show="!hasValue">\n          &nbsp;\n        </div>\n      </div>\n    </div>\n\n    <div class="dx-texteditor-buttons-container">\n      <span class="dx-clear-button-area" ng-show="hasValue">\n        <span class="dx-icon dx-icon-clear" ng-click="clearValue()"></span>\n      </span>\n      <div ng-click="showModal()" role="button" aria-label="spindown" class="dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon" tabindex="0">\n        <div class="dx-button-content"><i class="dx-icon dx-icon-spindown"></i>\n          <div class="dx-inkripple"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<input name="{{::args.fieldSchema.fieldName}}" adp-validate="::args" ng-required="isRequired()" type="hidden" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/imperial-units-control/imperial-units-control.html','<div class="adp-inline-form-control">\n  <div dx-select-box="configFirstUnit" class="adp-inline-form-control-left" name="{{::args.fieldSchema.fieldName}}FirstUnit"></div>\n\n  <div dx-select-box="configSecondUnit" class="adp-inline-form-control-right" name="{{::args.fieldSchema.fieldName}}SecondUnit"></div>\n</div>\n\n<input type="hidden" ng-required="isRequired()" adp-validate="::args" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }" name="{{::args.fieldSchema.fieldName}}">\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/list-control/list-control.html','<div class="adp-list-control-sortable-wrapper">\n  <div class="adp-list-control"></div>\n</div>\n\n<input name="{{::args.fieldSchema.fieldName}}" id="{{::args.fieldSchema.fieldName}}" adp-validate="::args" ng-required="isRequired()" ng-model="getterSetter" ng-model-options="{ allowInvalid: true, getterSetter: true }" type="hidden">\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/location-control/location-control.html','<div class="input">\n  <div class="adp-location-geo-loader" ng-if="detecting">\n    <span class="fa fa-gear fa-4x fa-spin"></span> <span class="adp-location-geo-loader-text">Locating...</span>\n  </div>\n\n  <div class="adp-location-row">\n    <div class="adp-location-row-input">\n      <input ng-readonly="true" ng-if="::!fieldParams.showAddress" ng-model="addressLabel" class="form-control">\n\n      <input places-auto-complete="" class="form-control-location form-control" ng-class="{ detecting: detecting }" ng-model="addressLabel" ng-disabled="detecting" ng-if="isReady && fieldParams.showAddress" on-place-changed="placeChanged()">\n\n      <input name="{{::args.fieldSchema.fieldName}}" id="{{::args.fieldSchema.fieldName}}" adp-validate="::args" style="display: none" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }" ng-required="isRequired()">\n    </div>\n\n    <button class="adp-form-field-location-btn btn adp-action-b-secondary" ng-click="detect()" ng-if="::fieldParams.showLocate" type="button" ng-disabled="!isReady || detecting">\n      Detect location\n    </button>\n\n    <button class="adp-form-field-location-btn btn adp-action-b-secondary" ng-click="toggleMapVisibility()" ng-if="::fieldParams.showToggleMapControl" type="button" ng-disabled="!isReady || detecting">\n      {{isMapVisible ? \'Hide map\' : \'Show map\'}}\n    </button>\n  </div>\n\n  <ng-map id="{{mapId}}" ng-if="isReady && isMapVisible" on-click="onClick()" zoom="{{map.zoom}}" center="{{map.center}}" disable-default-u-i="true" disable-double-click-zoom="true" keyboard-shortcuts="false" styles="{{mapStyles}}" ng-style="css">\n    <marker position="{{map.markerPosition}}">\n    </marker>\n  </ng-map>\n\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/lookup-control/lookup-control.html','<div class="adp-inline-form-control" ng-class="[columnClass, fieldNameClass]">\n  <lookup-table-selector class="adp-inline-form-control-left" props="::props">\n  </lookup-table-selector>\n\n  <lookup-selector-single class="adp-inline-form-control-right" ng-if="::!multiple" props="::props">\n  </lookup-selector-single>\n\n  <lookup-selector-multiple class="adp-inline-form-control-right" ng-if="::multiple" props="::props">\n  </lookup-selector-multiple>\n\n  <input type="text" class="hidden" style="width:100%" adp-validate="::args" ng-required="isRequired()" name="{{::args.fieldSchema.fieldName}}" id="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/number-array-control/number-array-control.html','<div dx-tag-box="::config" class="adp-number-array" ng-if="::config" field-name="{{::args.fieldSchema.fieldName}}">\n</div>\n\n<input type="hidden" ng-required="isRequired()" adp-validate="::args" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/password-control/adp-password-modal.html','<adp-form form-options="::vm.formOptions" args="::vm.args">\n  <form-header>Update Password</form-header>\n\n  <form-footer>\n    <footer class="adp-action-b-container">\n      <button type="button" ng-click="vm.onCancel()" class="adp-action-b-secondary">\n        Cancel\n      </button>\n\n      <button type="submit" class="adp-action-b-primary">\n        Update\n      </button>\n    </footer>\n  </form-footer>\n</adp-form>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/password-control/password-control.html','<a href="" ng-click="onClick($event)" ng-attr-adp-qaid-password-field-link="{{args.path}}">Update password</a>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/random-id-control/random-id-control.html','<div></div>\n\n<input type="hidden" name="{{::args.fieldSchema.fieldName}}" id="{{::controlId}}" adp-validate="::args" ng-required="isRequired()" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/readonly-control/readonly-control.html','<adp-record-details-cell ng-attr-adp-qaid-readonly-field-content="{{args.path}}" args="::args"></adp-record-details-cell>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/recaptcha-control/recaptcha-control.html','<div vc-recaptcha="" key="::key" stoken="::reCaptchaSecret" class="recaptcha" name="{{::args.fieldSchema.fieldName}}" ng-required="true" ng-model="args.row[\'g-recaptcha-response\']">\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/string-array-control/string-array-control.html','<div dx-tag-box="::config" ng-if="::config" field-name="{{::args.fieldSchema.fieldName}}">\n</div>\n\n<input type="hidden" ng-required="isRequired()" adp-validate="::args" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/tree-selector-control/tree-selector-control.html','<input type="hidden" adp-validate="::args" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ allowInvalid: true, getterSetter: true }" tree-selector-required="isRequired()">\n\n<tree-selector args="::args" form-data="::args.row" index-of-level="0"></tree-selector>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/tri-state-boolean-control/tri-state-boolean-control.html','<div dx-check-box="::config" ng-if="::config" field-name="{{::args.fieldSchema.fieldName}}">\n</div>\n\n<input type="hidden" adp-validate="::args" name="{{::args.fieldSchema.fieldName}}" ng-model="getterSetter" ng-model-options="{ debounce: 30, getterSetter: true }">\n\n');
$templateCache.put('app/adp-forms/directives/adp-form-fields/adp-form-field-blank/adp-form-field-blank.html','<adp-form-field-container class="adp-blank-field-container" enabled="false"></adp-form-field-container>\n');
$templateCache.put('app/adp-forms/directives/adp-form-fields/adp-form-field-default/adp-form-field-default.html','<adp-form-field-container>\n  <label ng-if="::args.fieldSchema.showFormLabel" ng-attr-adp-qaid-field-label="{{args.path}}" class="label">\n    {{::args.fieldSchema.fullName}}\n\n    <adp-required-mark></adp-required-mark>\n    <adp-tooltip></adp-tooltip>\n    <adp-clipboard-button></adp-clipboard-button>\n  </label>\n\n  <default-control-factory args="::args"></default-control-factory>\n\n  <adp-messages ng-attr-adp-qaid-field-error-messages="{{args.path}}" args="::args"></adp-messages>\n</adp-form-field-container>\n');
$templateCache.put('app/adp-forms/directives/adp-form-fields/adp-form-field-form-separator/adp-form-field-form-separator.html','<adp-form-field-container class="adp-blank-field-container" args="::args">\n  <adp-form-separator field-schema="::args.fieldSchema"></adp-form-separator>\n</adp-form-field-container>\n');
$templateCache.put('app/adp-forms/directives/adp-form-fields/adp-form-field-readonly/adp-form-field-readonly.html','<adp-form-field-container args="::args">\n  <div class="readonly-control-wrapper" style="display: flex; width: 100%; flex-direction: column">\n    <label ng-attr-adp-qaid-field-label="{{args.path}}" class="label" ng-if="::args.fieldSchema.showFormLabel">\n      {{::args.fieldSchema.fullName}}\n\n      <adp-tooltip></adp-tooltip>\n    </label>\n\n    <readonly-control style="width: 100%" args="::args"></readonly-control>\n  </div>\n\n</adp-form-field-container>\n');
$templateCache.put('app/adp-forms/directives/adp-form-fields/adp-form-field-recaptcha/adp-form-field-recaptcha.html','<adp-form-field-container ng-if="showCaptcha" args="::args">\n  <recaptcha-control args="::args"></recaptcha-control>\n  <adp-messages ng-attr-adp-qaid-field-error-messages="{{args.path}}" args="::args"></adp-messages>\n</adp-form-field-container>\n');
$templateCache.put('app/adp-forms/directives/adp-form-fields/adp-form-field-static-html/adp-form-field-static-html.html','<adp-form-field-container args="::args">\n  <static-html-control args="::args"></static-html-control>\n</adp-form-field-container>\n');
$templateCache.put('app/adp-forms/directives/adp-form-group/adp-form-group-accordion-or-grouping/adp-form-group-accordion-or-grouping.html','<div class="array-form-frame">\n  <div class="array-ng-form-frame group-form-frame clearfix" ng-show="isVisible[groupArgs.fieldSchema.fieldName]" ng-group-name="{{::groupArgs.fieldSchema.fieldName}}" ng-class="{\'has-errors\': groupHasErrors(groupArgs.fieldSchema.fields) }" ng-repeat="groupArgs in ::argsForGroups track by $index" ng-attr-adp-qaid-group-name="{{groupArgs.fieldSchema.fieldName}}">\n    <div class="subform-frame" ng-class="{\n        \'subform-frame--is-collapsed\': !groupsContentVisibility[groupArgs.fieldSchema.fieldName],\n        \'subform-frame--invalid\': groupHasErrors(groupArgs.fieldSchema.fields),\n       }">\n      <h3 class="subform-frame__title" ng-click="toggle($event, groupArgs.fieldSchema.fieldName)" ng-attr-adp-qaid-group-toggle-btn="{{::groupArgs.fieldSchema.fieldName}}">\n        <div class="subform-frame__panel">\n          <button type="button" class="subform-frame__collapse subform-frame__btn fa" ng-class="{\n              \'fa-chevron-up\': groupsContentVisibility[groupArgs.fieldSchema.fieldName],\n              \'fa-chevron-down\': !groupsContentVisibility[groupArgs.fieldSchema.fieldName]\n            }"></button>\n\n          <complex-item-header args="::groupArgs" form-context="::formContext"></complex-item-header>\n        </div>\n\n        <div ng-if="formContext.rootForm.$submitted" class="subform-frame__errors-cnt note-error">\n          <span ng-show="errorCnt[groupArgs.fieldSchema.fieldName] == 1">\n            {{errorCnt[groupArgs.fieldSchema.fieldName]}} error found.\n          </span>\n\n          <span ng-show="errorCnt[groupArgs.fieldSchema.fieldName] >= 2">\n            {{errorCnt[groupArgs.fieldSchema.fieldName]}} errors found.\n          </span>\n        </div>\n      </h3>\n\n      <div class="subform-frame__content adp-form-fieldset clearfix" ng-attr-adp-qaid-group-body="{{groupArgs.fieldSchema.fieldName}}" ng-show="groupsContentVisibility[groupArgs.fieldSchema.fieldName]">\n        <adp-form-field-factory ng-repeat="field in ::groupArgs.fieldSchema.fields track by $index" field-name="::field.fieldName" args="::$parent.args" form-context="::$parent.formContext"></adp-form-field-factory>\n      </div>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/adp-forms/directives/adp-form-group/adp-form-group-wizard/adp-form-group-wizard.html','<fiedlset ng-if="!isEmpty()" class="fuelux">\n  <div class="widget-body">\n    <div class="wizard clearfix">\n      <ul class="steps">\n        <li ng-show="isVisible[group.fieldName]" ng-repeat="group in ::groups track by $index" ng-click="setCurrent(group.fieldName)" ng-wizard-menu-item="{{::group.fieldName}}" ng-class="{\n            \'active\': currentName == group.fieldName,\n            \'complete\': groupCompleted(group.fields),\n            \'has-errors\': groupHasErrors(group.fields),\n          }">\n\n          <span class="badge badge-info">{{$index + 1}}</span>\n          <span ng-bind-html="getHeader(group)" ng-attr-adp-qaid-group-header="{{group.fieldName}}"></span>\n\n          <span class="chevron"></span>\n        </li>\n      </ul>\n\n      <div class="actions">\n        <button type="button" ng-click="prev()" class="btn btn-sm btn-default btn-prev" ng-disabled="isFirst()">\n          <i class="fa fa-arrow-left"></i> Prev\n        </button>\n\n        <button type="button" class="btn btn-sm btn-success btn-next" ng-click="next()" ng-show="!isLast()">\n          Next <i class="fa fa-arrow-right"></i>\n        </button>\n\n        <button type="submit" class="btn btn-sm btn-primary btn-next" ng-show="isLast()">\n          Finish <i class="fa fa-check"></i>\n        </button>\n      </div>\n    </div>\n\n    <div class="step-content clearfix">\n      <div ng-repeat="group in ::groups track by $index" ng-show="isVisible[group.fieldName]" ng-group-name="{{::group.fieldName}}" class="step-pane" ng-class="{\'active\': currentName == group.fieldName }" ng-attr-adp-qaid-group-name="{{group.fieldName}}">\n        <h3 class="step-pane-title">\n          <strong>Step {{$index + 1}}</strong> - {{::group.fullName}}</h3>\n\n        <div class="adp-form-fieldset">\n          <adp-form-field-factory ng-repeat="field in ::group.fields track by $index" field-name="::field.fieldName" args="::$parent.args" form-context="::$parent.formContext"></adp-form-field-factory>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</fiedlset>\n');
$templateCache.put('app/adp-ui/components/adp-activities-dropdown/partials/tab-default.html','<div>\n\t<div class="alert alert-transparent">\n\t\t<h4>Click a button to show messages here</h4>\n\t\tThis blank page message helps protect your privacy, or you can show the first message here automatically.\n\t</div>\n\n\t<i class="fa fa-lock fa-4x fa-border"></i>\n</div>');
$templateCache.put('app/adp-ui/components/adp-activities-dropdown/partials/tab-msgs.html','<ul class="notification-body">\n\t<li ng-repeat="msg in vm.currentActivityItems">\n\t\t<span ng-class="{\'unread\' : msg.status == \'unread\'}">\n\t\t\t<a href="javascript:void(0);" class="msg">\n\t\t\t\t<img ng-src="{{msg.image}}" alt="" class="air air-top-left margin-top-5" width="40" height="40">\n\t\t\t\t<span class="from">{{msg.title}}</span>\n\t\t\t\t<time>{{imsgnfo.time}}</time>\n\t\t\t\t<span class="subject">{{msg.subject}}</span>\n\t\t\t\t<span class="msg-body">{{msg.message}}</span>\n\t\t\t</a>\n\t\t</span>\n\t</li>\n</ul>');
$templateCache.put('app/adp-ui/components/adp-activities-dropdown/partials/tab-notify.html','<ul class="notification-body">\n\t<li ng-repeat="not in vm.currentActivityItems">\n\t\t<span class="padding-10">\n\n\t\t\t<em class="badge padding-5 no-border-radius bg-color-blueLight pull-left margin-right-5">\n\t\t\t\t<i class="fa {{not.icon}} fa-fw fa-2x"></i>\n\t\t\t</em>\n\t\t\t\n\t\t\t<span>\n\t\t\t\t {{not.message}}\n\t\t\t\t <br>\n\t\t\t\t <span class="pull-right font-xs text-muted"><i>{{not.time}}</i></span>\n\t\t\t</span>\n\t\t\t\n\t\t</span>\n\t</li>\n</ul>');
$templateCache.put('app/adp-ui/components/adp-activities-dropdown/partials/tab-tasks.html','<ul class="notification-body">\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><i class="fa fa-warning text-warning"></i> <strong>PRIMARY:</strong> <i>Upgrade Infestructure</i> <span class="pull-right semi-bold text-muted">85%</span></p>\n\t\t\t\t<div class="progress progress-md progress-striped">\n\t\t\t\t\t<div class="progress-bar bg-color-teal" style="width: 85%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin">last updated on 12/12/2013</em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><strong>URGENT:</strong> <i> Code foundation</i> <span class="pull-right semi-bold text-muted">65%</span></p>\n\t\t\t\t<div class="progress progress-sm">\n\t\t\t\t\t<div class="progress-bar bg-color-teal" style="width: 65%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin">last updated on 12/12/2013</em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><strong>URGENT:</strong> <i>Project Plan</i> <span class="pull-right semi-bold text-muted">25%</span></p>\n\t\t\t\t<div class="progress progress-xs">\n\t\t\t\t\t<div class="progress-bar bg-color-teal" style="width: 25%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin">last updated on 12/12/2013</em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><strong>CRITICAL:</strong> <i> Wireframes</i> <span class="pull-right semi-bold text-danger">5%</span></p>\n\t\t\t\t<div class="progress progress-xs">\n\t\t\t\t\t<div class="progress-bar progress-bar-danger" style="width: 5%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin">last updated on 12/12/2013</em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><strong>NORMAL:</strong> <i>Compile hotfix</i> <span class="pull-right semi-bold text-muted">99%</span></p>\n\t\t\t\t<div class="progress progress-xs">\n\t\t\t\t\t<div class="progress-bar progress-bar-success" style="width: 99%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin">last updated on 12/12/2013</em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><strong>MINOR:</strong> <i>Bug fix #213</i><span class="pull-right semi-bold text-muted"><i class="fa fa-check text-success"></i> Complete</span></p>\n\t\t\t\t<div class="progress progress-micro">\n\t\t\t\t\t<div class="progress-bar progress-bar-success" style="width: 100%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin">last updated on 12/12/2013</em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n\t<li>\n\t\t<span>\n\t\t\t<div class="bar-holder no-padding">\n\t\t\t\t<p class="margin-bottom-5"><strong>MINOR:</strong> <i>Bug fix #134</i><span class="pull-right semi-bold text-muted"><i class="fa fa-check text-success"></i> Complete</span></p>\n\t\t\t\t<div class="progress progress-micro">\n\t\t\t\t\t<div class="progress-bar progress-bar-success" style="width: 100%"></div>\n\t\t\t\t</div>\n\t\t\t\t<em class="note no-margin display-inline"><a href="javascript:void(0);">see notes</a></em>\n\t\t\t</div>\n\t\t</span>\n\t</li>\n</ul>');
$templateCache.put('app/adp-ui/components/adp-images/adp-image/adp-image.template.html','<div class="adp-thumb">\n  <img class="img-responsive" ng-if="vm.src" ng-src="{{vm.src}}" ng-attr-width="{{vm.width}}" ng-attr-height="{{vm.height}}">\n</div>\n');
$templateCache.put('app/adp-ui/components/adp-images/adp-thumb/adp-thumb.template.html','<div class="adp-thumb" ng-switch="vm.fileType">\n  <img ng-switch-when="images" class="img-responsive" ng-if="vm.src" ng-src="{{vm.src}}">\n\n  <span ng-switch-when="audio" class="fa-4x fa fa-file-audio-o">\n  </span>\n\n  <span ng-switch-when="video" class="fa-4x fa fa-file-video-o">\n  </span>\n\n  <span ng-switch-when="docs" class="fa-4x fa fa-file-text-o">\n  </span>\n</div>\n');
$templateCache.put('app/adp-data-grid/components/adp-record-details/groups/record-details-grouping/record-details-grouping.template.html','<div dx-accordion="accordionOptions" dx-item-alias="group" class="view-details-accordion">\n  <div data-options="dxTemplate : { name: \'title\' }">\n    {{::group.fullName}} <adp-view-details-tooltip field="::group"></adp-view-details-tooltip>\n  </div>\n\n  <div data-options="dxTemplate : { name: \'group\' } ">\n    <div class="accordion-item">\n\n      <div class="adp-row">\n        <div ng-repeat="field in group.fields track by $index" ng-class="[selectColumnClass(field)]" ng-if="group.fields && showValue(field)">\n          <record-details-value-row field="::field" schema="::schema" filtered-record="::filteredRecord" args="::args"></record-details-value-row>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/icon-control/select-icon-modal/select-icon-modal.html','<div class="modal-header delete-action-modal">\n  <h3 class="modal-title">Icon picker</h3>\n</div>\n\n<div dx-tab-panel="vm.tabPanelOptions" dx-item-alias="iconList">\n  <div data-options="dxTemplate : { name: \'item\' } ">\n    <div class="tabpanel-item tabpanel-item-picker">\n      <div class="adp-icon-picker">\n        <div class="adp-icon-pick-top-panel">\n          <div dx-text-box="vm.filterInputConfig" ng-if="vm.filterInputConfig" ng-model="vm.query[iconList.family]"></div>\n\n          <div class="adp-icon-picker-error">\n            <span ng-show="vm.hasError">Icon required</span>\n          </div>\n\n          <div class="adp-icon-picker-selected">\n            <strong>Selected:</strong>  <span ng-bind-html="vm.template()"></span>\n          </div>\n        </div>\n\n        <div class="adp-icon-picker-list">\n          <div ng-repeat="icon in iconList.items | filter: vm.query[iconList.family]" class="adp-icon-picker-item" ng-class="{ selected: icon === vm.selected.name }" ng-click="vm.select(icon, iconList.family)">\n            <div class="adp-icon-picker-item-content">\n              <div class="adp-icon-picker-item-icon">\n                <i ng-if="iconList.family === \'fa\'" ng-class="[\'fa fa-\' + icon]"></i>\n                <i ng-if="iconList.family === \'dx\'" ng-class="[\'dx-icon-\' + icon]"></i>\n              </div>\n\n              <div class="adp-icon-picker-item-name">\n                {{vm.toStartCase(icon)}}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.cancel()" adp-hot-key="Escape">\n    Cancel\n  </button>\n\n  <button class="adp-action-b-primary" type="button" adp-hot-key="Enter" ng-click="vm.confirm()">\n    Select\n  </button>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/lookup-control/lookup-table-selector/lookup-table-selector.html','<div dx-select-box="::config" class="adp-select-box"></div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/tree-selector-control/selector/tree-selector.html','<div>\n  <div dx-select-box="::config" ng-if="::config"></div>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/array/array-control/array-control.html','<div class="array-form-frame clearfix" ui-sortable="::sortableCfg" ui-preserve-size="" ng-model="arrayData" name="{{::args.fieldSchema.fieldName}}" arrays-path="args.path" ng-attr-adp-qaid-array="{{args.path}}">\n  <ng-form ng-repeat="dataItem in arrayData track by dataItem._id" style="display: block" class="array-ng-form-frame clearfix" name="{{args.fieldSchema.fieldName + \'[\' + $index + \']\'}}" ng-attr-adp-qaid-array-item="{{args.path + \'[\' + $index + \']\'}}">\n\n    <div class="subform-frame clearfix" ng-class="[{\n        \'subform-frame--is-collapsed\': !visibilityStatus[$index],\n        \'subform-frame--invalid\': rootForm.$submitted && form[args.fieldSchema.fieldName + \'[\' + $index + \']\'].$invalid,\n       }, frameClass]">\n      <h3 class="subform-frame__title" ng-class="{\n          \'subform-frame__title--invalid\': rootForm.$submitted && form[args.fieldSchema.fieldName + \'[\' + $index + \']\'].$invalid,\n          \'subform-frame__title--opened\': visibilityStatus[$index],\n         }" ng-click="toggle($event, $index)" ng-attr-adp-qaid-complex-field-collapse-btn="{{args.path + \'[\' + $index + \']\'}}">\n        <div class="subform-frame__panel" ng-attr-adp-qaid-complex-field-header="{{args.path + \'[\' + $index + \']\'}}">\n          <button type="button" class="subform-frame__collapse subform-frame__btn fa" ng-class="{\n              \'fa-chevron-up\': visibilityStatus[$index],\n              \'fa-chevron-down\': !visibilityStatus[$index]\n            }"></button>\n\n          <complex-item-header args="::args" index="$index" form-context="::formContext"></complex-item-header>\n\n          <array-control-color-dropdown args="::args" index="$index"></array-control-color-dropdown>\n\n          <button type="button" class="subform-frame__clone subform-frame__btn fa fa-clone" ng-click="cloneItem($event, $index)" ng-attr-adp-qaid-complex-field-clone-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n\n          <button type="button" class="subform-frame__move-to-bottom subform-frame__btn fa fa-level-up" ng-disabled="disableMoveToTop($index)" ng-click="moveToTop($event, $index)" ng-attr-adp-qaid-complex-field-move-to-top-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n\n          <button type="button" class="subform-frame__move-to-top subform-frame__btn fa fa-level-down" ng-disabled="disableMoveToBottom($index)" ng-click="moveToBottom($event, $index)" ng-attr-adp-qaid-complex-field-move-to-top-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n\n          <button type="button" class="subform-frame__remove subform-frame__btn fa fa-trash" ng-disabled="isRemoveDisabled()" ng-click="remove($event, $index)" ng-attr-adp-qaid-complex-field-remove-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n        </div>\n\n        <error-counter args="::args" form-context="::$parent.formContext" index="$index"></error-counter>\n\n      </h3>\n\n      <div class="subform-frame__content adp-form-fieldset clearfix" ng-class="[frameContentClass]" ng-hide="!visibilityStatus[$index]">\n        <adp-form-field-factory ng-if="::isAssociative" args="::args" form-context="::$parent.formContext" is-key="true" index="$parent.$index"></adp-form-field-factory>\n\n        <adp-form-field-factory ng-repeat="subField in ::arrayFields" args="::args" form-context="::$parent.formContext" field-name="::subField.fieldName" index="$parent.$index"></adp-form-field-factory>\n      </div>\n\n    </div>\n\n  </ng-form>\n</div>\n\n<div class="array-form-btns clearfix">\n  <button type="button" class="btn btn-default js-array-add-item-btn" ng-click="addArrayItem()" ng-attr-adp-qaid-add-array-item-btn="{{args.path}}">\n    Add new "{{::addNewBtnName}}"\n  </button>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/array/array-control-grid/array-control-grid.html','<div class="complex-grid-control responsive-table">\n  <table class="table-bordered table" style="table-layout: fixed" ng-model="arrayData" name="{{::args.fieldSchema.fieldName}}" arrays-path="args.path" ng-attr-adp-qaid-array="{{args.path}}">\n    <thead>\n    <tr>\n      <th class="complex-grid-control-cell-icon">\n        <div class="complex-grid-control-btn complex-grid-control-btn-handle btn-head">\n          <i class="icon dx-icon-dragvertical"></i>\n        </div>\n      </th>\n\n      <th ng-if="::isAssociative" class="complex-grid-control-head" ng-class="::[\'col col-md-\' + (args.fieldSchema._key.formWidth || 12)]">\n        {{::args.fieldSchema._key.fullName}}\n      </th>\n\n      <th ng-repeat="field in arrayFields  track by $index" class="complex-grid-control-head" ng-class="::[\'col col-md-\' + (field.formWidth || 12)]">\n        {{::field.fullName}}\n      </th>\n\n      <th class="complex-grid-control-cell-icon">\n        <button type="button" class="complex-grid-control-btn btn-head" disabled="">\n          <i class="fa fa-trash"></i>\n        </button>\n      </th>\n    </tr>\n    </thead>\n\n    <tbody ui-sortable="sortableCfg" ui-preserve-size="" ng-model="arrayData">\n    <tr ng-repeat="dataItem in arrayData track by dataItem._id" class="complex-grid-control-row" ng-form="{{args.fieldSchema.fieldName + \'[\' + $index + \']\'}}" ng-attr-adp-qaid-array-item="{{args.path + \'[\' + $index + \']\'}}">\n      <td class="complex-grid-control-cell-icon js-grid-handler">\n        <div class="complex-grid-control-btn complex-grid-control-btn-handle">\n          <i class="icon dx-icon-dragvertical"></i>\n        </div>\n      </td>\n\n      <td ng-if="::isAssociative" class="complex-grid-control-cell" ng-class="::[\'col col-md-\' + (args.fieldSchema._key.formWidth || 12)]">\n        <complex-item-grid-cell args="::args" form-context="::formContext" is-key="true" index="$index"></complex-item-grid-cell>\n      </td>\n\n      <td ng-repeat="field in ::arrayFields track by $index" class="complex-grid-control-cell" ng-class="::[\'col col-md-\' + (field.formWidth || 12)]">\n        <complex-item-grid-cell args="::args" form-context="::formContext" field-name="::field.fieldName" index="$parent.$index"></complex-item-grid-cell>\n      </td>\n\n      <td class="complex-grid-control-cell-icon">\n        <button type="button" class="complex-grid-control-btn" ng-click="cloneItem($event, $index)" ng-attr-adp-qaid-complex-field-clone-btn="{{args.path + \'[\' + $parent.$index + \']\'}}">\n          <i class="fa fa-clone"></i>\n        </button>\n\n        <button type="button" class="complex-grid-control-btn" ng-disabled="isRemoveDisabled()" ng-click="remove($event, $index)" ng-attr-adp-qaid-complex-field-remove-btn="{{args.path + \'[\' + $parent.$index + \']\'}}">\n          <i class="fa fa-trash"></i>\n        </button>\n      </td>\n    </tr>\n\n    </tbody>\n  </table>\n\n  <div class="complex-grid-control-btns">\n    <button type="button" class="btn btn-default js-array-add-item-btn" ng-click="addArrayItem()" ng-attr-adp-qaid-add-array-item-btn="{{args.path}}">\n      <i class="complex-grid-control-add-btn fa fa-plus"></i>\n    </button>\n  </div>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/array/array-control-tree/array-control-tree.html','<div class="complex-tree-control responsive-table" ng-model="arrayData" name="{{::args.fieldSchema.fieldName}}" arrays-path="args.path" ng-attr-adp-qaid-array="{{args.path}}">\n    <div class="adp-array-tree-view adp-form-fieldset" ng-style="treeViewStyle">\n        <div class="adp-array-tree-view-tree-box col col-4">\n            <div class="treeBox"></div>\n        </div>\n\n        <ng-form ng-show="selectedIndex > -1 && selectedIndex === $index" ng-repeat="dataItem in arrayData track by dataItem._id" style="display: block" class="adp-array-tree-view-form-box col col-8" ng-attr-adp-qaid-array-item="{{args.path + \'[\' + $index + \']\'}}" name="{{args.fieldSchema.fieldName + \'[\' + $index + \']\'}}">\n          <div class="adp-form-fieldset formBox">\n            <adp-form-field-factory ng-repeat="subField in ::arrayFields" args="::args" form-context="::$parent.formContext" field-name="::subField.fieldName" index="$parent.$index"></adp-form-field-factory>\n          </div>\n        </ng-form>\n    </div>\n\n    <div class="complex-tree-control-btns">\n        <button type="button" class="btn btn-default js-array-add-item-btn" ng-click="addArrayItem()" ng-disabled="!initialized" ng-attr-adp-qaid-add-array-item-btn="{{args.path}}">\n          Add new "{{::addNewBtnName}}"\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/components/error-counter/error-counter.html','<div class="subform-frame__errors-cnt">\n  <span ng-show="errorCnt == 1">\n    {{errorCnt}} error found.\n  </span>\n\n  <span ng-show="errorCnt >= 2">\n    {{errorCnt}} errors found.\n  </span>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/key-val/key-val-control/key-val-control.html','<div class="array-form-frame clearfix" ui-sortable="::sortableCfg" ui-preserve-size="" ng-model="arrayData" name="{{::args.fieldSchema.fieldName}}" arrays-path="args.path" ng-attr-adp-qaid-array="{{args.path}}">\n  <ng-form ng-repeat="dataItem in arrayData track by dataItem._id" style="display: block" class="array-ng-form-frame clearfix" name="{{args.fieldSchema.fieldName + \'[\' + $index + \']\'}}" ng-attr-adp-qaid-array-item="{{args.path + \'[\' + $index + \']\'}}">\n    <div class="subform-frame clearfix" ng-class="[{\n        \'subform-frame--is-collapsed\': !visibilityStatus[$index],\n        \'subform-frame--invalid\': rootForm.$submitted && form[args.fieldSchema.fieldName + \'[\' + $index + \']\'].$invalid,\n       }, frameClass]">\n      <h3 class="subform-frame__title" ng-class="{\n          \'subform-frame__title--invalid\': rootForm.$submitted && form[args.fieldSchema.fieldName + \'[\' + $index + \']\'].$invalid,\n          \'subform-frame__title--opened\': visibilityStatus[$index],\n         }" ng-click="toggle($event, $index)" ng-attr-adp-qaid-complex-field-collapse-btn="{{args.path + \'[\' + $index + \']\'}}">\n        <div class="subform-frame__panel" ng-attr-adp-qaid-complex-field-header="{{args.path + \'[\' + $index + \']\'}}">\n          <button type="button" class="subform-frame__collapse subform-frame__btn fa" ng-class="{\n              \'fa-chevron-up\': visibilityStatus[$index],\n              \'fa-chevron-down\': !visibilityStatus[$index]\n            }"></button>\n\n          <complex-item-header args="args" index="$index" form-context="formContext"></complex-item-header>\n\n          <button type="button" class="subform-frame__move-to-bottom subform-frame__btn fa fa-level-up" ng-disabled="disableMoveToTop($index)" ng-click="moveToTop($event, $index)" ng-attr-adp-qaid-complex-field-move-to-top-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n\n          <button type="button" class="subform-frame__move-to-top subform-frame__btn fa fa-level-down" ng-disabled="disableMoveToBottom($index)" ng-click="moveToBottom($event, $index)" ng-attr-adp-qaid-complex-field-move-to-top-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n\n          <button type="button" class="subform-frame__remove subform-frame__btn fa fa-trash" ng-disabled="isRemoveDisabled()" ng-click="remove($event, $index)" ng-attr-adp-qaid-complex-field-remove-btn="{{args.path + \'[\' + $index + \']\'}}"></button>\n        </div>\n\n        <error-counter args="::args" form-context="::$parent.formContext" index="$index"></error-counter>\n\n      </h3>\n\n      <div class="subform-frame__content adp-form-fieldset clearfix" ng-class="::[frameContentClass]" ng-hide="!visibilityStatus[$index]">\n        <adp-form-field-factory args="::args" form-context="::formContext" field-name="::\'_key\'" index="$index"></adp-form-field-factory>\n\n        <adp-form-field-factory args="::args" form-context="::formContext" field-name="::\'_value\'" index="$index"></adp-form-field-factory>\n      </div>\n\n    </div>\n\n  </ng-form>\n</div>\n\n<div class="array-form-btns clearfix">\n  <button type="button" class="btn btn-default js-array-add-item-btn" ng-click="addArrayItem()" ng-attr-adp-qaid-add-array-item-btn="{{args.path}}">\n    Add new "{{::addNewBtnName}}"\n  </button>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/key-val/key-val-grid/key-val-grid.html','<div class="complex-grid-control responsive-table">\n  <table class="table-bordered table" style="table-layout: fixed" ng-model="arrayData" name="{{::args.fieldSchema.fieldName}}" arrays-path="args.path" ng-attr-adp-qaid-array="{{args.path}}">\n    <thead>\n    <tr>\n      <th class="complex-grid-control-cell-icon">\n        <div class="complex-grid-control-btn complex-grid-control-btn-handle btn-head">\n          <i class="icon dx-icon-dragvertical"></i>\n        </div>\n      </th>\n\n      <th class="complex-grid-control-head" ng-class="::[\'col col-md-\' + (args.fieldSchema.fields._key.formWidth || 12)]">\n        {{::args.fieldSchema.fields._key.fullName}}\n      </th>\n\n      <th class="complex-grid-control-head" ng-class="::[\'col col-md-\' + (args.fieldSchema.fields._value.formWidth || 12)]">\n        {{::args.fieldSchema.fields._value.fullName}}\n      </th>\n\n      <th class="complex-grid-control-cell-icon">\n        <button type="button" class="complex-grid-control-btn btn-head" disabled="">\n          <i class="fa fa-trash"></i>\n        </button>\n      </th>\n    </tr>\n    </thead>\n\n    <tbody ui-sortable="::sortableCfg" ui-preserve-size="" ng-model="arrayData">\n    <tr ng-repeat="dataItem in arrayData track by dataItem._id" class="complex-grid-control-row" ng-form="{{args.fieldSchema.fieldName + \'[\' + $index + \']\'}}" ng-attr-adp-qaid-array-item="{{args.path + \'[\' + $index + \']\'}}">\n      <td class="complex-grid-control-cell-icon js-grid-handler">\n        <div class="complex-grid-control-btn complex-grid-control-btn-handle">\n          <i class="icon dx-icon-dragvertical"></i>\n        </div>\n      </td>\n\n      <td class="complex-grid-control-cell" ng-class="::[\'col col-md-\' + (args.fieldSchema.fields._key.formWidth || 12)]">\n        <div class="complex-grid-control-cell-content">\n          <adp-form-field-factory args="::args" form-context="::formContext" field-name="::\'_key\'" index="$index" ng-data-path="::args.path"></adp-form-field-factory>\n        </div>\n      </td>\n\n      <td class="complex-grid-control-cell" ng-class="::[\'col col-md-\' + (args.fieldSchema.fields._value.formWidth || 12)]">\n        <div class="complex-grid-control-cell-content">\n          <adp-form-field-factory args="::args" form-context="::formContext" field-name="::\'_value\'" index="$index" ng-data-path="::args.path"></adp-form-field-factory>\n        </div>\n      </td>\n\n      <td class="complex-grid-control-cell-icon">\n        <button type="button" class="complex-grid-control-btn" ng-disabled="isRemoveDisabled()" ng-click="remove($event, $index)" ng-attr-adp-qaid-complex-field-remove-btn="{{args.path + \'[\' + $parent.$index + \']\'}}">\n          <i class="fa fa-trash"></i>\n        </button>\n      </td>\n    </tr>\n\n    </tbody>\n  </table>\n\n  <div class="complex-grid-control-btns">\n    <button type="button" class="btn btn-default js-array-add-item-btn" ng-click="addArrayItem()" ng-attr-adp-qaid-add-array-item-btn="{{args.path}}">\n      <i class="complex-grid-control-add-btn fa fa-plus"></i>\n    </button>\n  </div>\n</div>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/object/object-control/object-control.html','<ng-form ng-attr-adp-qaid-object="{{args.path}}" name="{{::fieldName}}">\n  <div class="subform-frame clearfix" ng-class="[{\n    \'subform-frame--is-collapsed\': !isVisible,\n    \'subform-frame--invalid\': rootForm.$submitted && form[fieldName].$invalid\n   }, frameClass]">\n    <h3 class="subform-frame__title" ng-class="{\n        \'subform-frame__title--invalid\': rootForm.$submitted && form[fieldName].$invalid,\n        \'subform-frame__title--opened\': isVisible\n      }" ng-click="toggle()" ng-attr-adp-qaid-complex-collapse-btn="{{args.path}}">\n      <div class="subform-frame__panel" ng-attr-adp-qaid-complex-field-header="{{args.path}}">\n        <button type="button" class="subform-frame__collapse subform-frame__btn fa" ng-class="{ \'fa-chevron-up\': isVisible, \'fa-chevron-down\': !isVisible }"></button>\n\n        <complex-item-header args="::args" form-context="::formContext"></complex-item-header>\n      </div>\n\n      <error-counter args="::args" form-context="::formContext" index="$parent.index"></error-counter>\n    </h3>\n\n    <div class="subform-frame__content clearfix adp-form-fieldset" ng-class="::[frameContentClass]" ng-hide="!isVisible">\n      <adp-form-field-factory ng-repeat="field in ::fields track by $index" args="::args" form-context="::formContext" field-name="::field.fieldName"></adp-form-field-factory>\n    </div>\n  </div>\n</ng-form>\n');
$templateCache.put('app/adp-forms/directives/adp-form-controls/complex/object/object-control-grid/object-control-grid.html','<ng-form ng-attr-adp-qaid-object="{{args.path}}" name="{{::fieldName}}">\n  <div class="complex-grid-control responsive-table">\n    <table class="table-bordered table">\n      <thead>\n      <tr>\n        <th ng-repeat="field in ::fields  track by $index" class="complex-grid-control-head">\n          {{field.fullName}}\n        </th>\n      </tr>\n      </thead>\n\n      <tbody>\n      <tr>\n        <td ng-repeat="field in ::fields track by $index" class="complex-grid-control-cell">\n          <complex-item-grid-cell args="::args" form-context="::formContext" field-name="::field.fieldName"></complex-item-grid-cell>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</ng-form>\n');}]);;angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('client-modules/adp-data-import/adp-data-import-modal.html','<div class="modal-header import-report-modal" ng-if="vm.currentProcess">\n    <adp-page-loader loading="true" style="position: static"></adp-page-loader>\n</div>\n<div class="modal-body import-report-modal" ng-if="vm.currentProcess">\n    <h3>{{ vm.currentProcess }}</h3>\n</div>\n<div class="modal-header import-report-modal" ng-if="!vm.currentProcess">\n    <h3 class="modal-title success-icon" ng-if="vm.success">Import successful</h3>\n    <h3 class="modal-title warning-icon" ng-if="vm.proceedRequired">Warning: the following field names are not in the\n        dataset</h3>\n    <h3 class="modal-title error-icon" ng-if="vm.errors.length">Errors occurred while importing</h3>\n</div>\n<div class="modal-body import-report-modal" ng-if="!vm.currentProcess">\n    <h3 ng-if="vm.success">\n        <span ng-if="vm.rowsCount>1">{{vm.rowsCount}} documents are</span>\n        <span ng-if="vm.rowsCount==1">One document is</span>\n        inserted successfully\n    </h3>\n    <div ng-if="vm.proceedRequired">\n        <p>The following field names are not present in the dataset: <strong>{{vm.invalidColumnNames}}</strong></p>\n        <p>If you choose to proceed, they will be added to the dataset.</p>\n    </div>\n    <div ng-if="vm.errors.length">\n        <div ng-repeat="error in vm.errors">\n            <div><span ng-if="error.item">{{error.item}}: </span><strong>{{error.message}}</strong></div>\n        </div>\n    </div>\n</div>\n<div class="modal-footer" adp-handle-hot-keys="">\n    <button class="adp-action-b-primary" ng-click="vm.onProceed()" adp-hot-key="Enter" ng-if="vm.proceedRequired" ng-disabled="vm.currentProcess">Proceed\n    </button>\n    <button ng-class="{\'adp-action-b-primary\':!vm.proceedRequired,\'adp-action-b-secondary\':vm.proceedRequired}" ng-click="vm.onClose()" adp-hot-key="Escape">Close\n    </button>\n</div>\n');
$templateCache.put('client-modules/adp-embed-code-modal/adp-embed-code-modal.html','<div class="modal-header">\n  <h3 class="modal-title">{{ vm.entityName }} embedding HTML code</h3>\n</div>\n\n<div class="modal-body">\n  Use the following HTML code in order to embed the {{ vm.entityName.toLowerCase() }} on your webpage:\n  <div class="adp-widget-embed-code-block">\n    <pre>&lt;iframe width="400" height="300" src="{{ vm.embedUrl }}"&gt;&lt;/iframe&gt;</pre>\n    <div id="adp-clipboard-copy"></div>\n  </div>\n</div>\n\n<div class="modal-footer" adp-ui-buttons-handle-keyboard="">\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.close()">\n    Cancel\n  </button>\n  <button class="adp-action-b-primary" type="submit" ng-click="vm.close()">\n    Close\n  </button>\n</div>\n');
$templateCache.put('client-modules/adp-gridstack/adp-gs-header.html','<div class="adp-dashboard-header" ng-class="{ \'adp-collapsed\': isTitleCollapsed }">\n  <div class="adp-dashboard-header-control adp-dashboard-minimize fa" ng-click="headerCollapseCb()" ng-class="{ \'fa-angle-left\': !isTitleCollapsed, \'fa-angle-right\': !!isTitleCollapsed }" aria-hidden="true" title="{{ !!isTitleCollapsed ? \'Expand header\' : \'Minimize header\'}}"></div>\n  <div class="adp-dashboard-title">{{ args.row.name }}</div>\n  <div class="adp-action-b-container">\n    <div ng-repeat="(name, action) in actions" ng-click="execAction(action, name)" ng-href="{{evalLink(action)}}" ng-class="getCSS(action)" data-action-name="{{name}}" ng-attr-title="{{action.description}}" ng-attr-adp-qaid-form-action="{{name}}" ng-if="visibleGetter(action)" ng-disabled="disabledState(action)">\n      <span ng-if="hasIcon(action)" ng-bind-html="getIcon(action.icon)"></span>\n      <span ng-if="hasFullName(action)">{{ fullNameGetter(action) }}</span>\n    </div>\n    <div class="adp-dashboard-header-control adp-dashboard-action-fullscreen" title="Fullscreen mode" ng-click="toggleFullscreen()">\n      <i ng-class="{fa:1, \'fa-compress\':!!isFullscreen, \'fa-expand\':!isFullscreen}"></i>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/adp-widget-embed.html','<div class="adp-widget-publish-error" ng-if="vm.errorMessage">{{ vm.errorMessage }}</div>\n<adp-widget-tile ng-if="!vm.isLoading && !vm.errorMessage" tile="vm.tile"></adp-widget-tile>\n');
$templateCache.put('client-modules/adp-widgets/adp-widget-frameless.html','<div class="adp-widget-publish-error" ng-if="vm.errorMessage">{{ vm.errorMessage }}</div>\n<adp-widget-tile ng-if="!vm.isLoading && !vm.errorMessage" tile="vm.tile"></adp-widget-tile>\n');
$templateCache.put('client-modules/adp-command-runner/adp-command-runner-modal/adp-command-runner-modal.html','<adp-form form-options="::vm.formOptions" args="::vm.args" class="adp-bjr-command-confirm-modal" ng-class="{ \'is-empty\': vm.isEmpty }">\n  <form-header>\n    <h3>{{vm.options.message}}</h3>\n  </form-header>\n\n  <form-footer>\n    <footer class="adp-action-b-container" adp-handle-hot-keys="">\n      <button type="button" ng-click="vm.onCancel()" adp-hot-key="Escape" class="adp-action-b-secondary">\n        Cancel\n      </button>\n      <button type="button" ng-click="vm.onEdit()" class="adp-action-b-secondary">\n        Edit command\n      </button>\n\n      <button type="submit" adp-hot-key="Enter" class="adp-action-b-primary">\n        {{vm.options.okButtonText || \'Yes\'}}\n      </button>\n    </footer>\n  </form-footer>\n</adp-form>\n');
$templateCache.put('client-modules/adp-grid-row-actions/raw-record-view/adp-raw-record-view.html','<div class="adp-raw-record-modal">\n<div class="modal-header">\n    <h3 class="modal-title">\n        Raw record\n        <adp-clipboard-button args="vm.fieldArgs"></adp-clipboard-button>\n    </h3>\n</div>\n<div class="modal-body">\n    <adp-record-details-cell args="vm.fieldArgs" options="vm.options"></adp-record-details-cell>\n</div>\n<div class="modal-footer" adp-handle-hot-keys="">\n    <button class="adp-action-b-primary" adp-hot-key="Escape" type="button" ng-click="vm.doClose()">\n        Close\n    </button>\n</div>\n</div>\n');
$templateCache.put('client-modules/adp-guided-tour/adp-guided-tour-dialog/adp-guided-tour-dialog.html','<div style="position: fixed; left: 50%; top: 50%; margin: 0px; transform: translate(-50%, -50%)" class="shepherd-element shepherd-enabled">\n  <form name="form" ng-submit="vm.submit()">\n    <div class="shepherd-text">\n      <div dx-radio-group="vm.radioGroupOption" name="tour" ng-required="true" ng-model="vm.result"></div>\n\n      <div ng-messages="" ng-if="form.$submitted" for="form.tour.$error" style="color: #b94a48" class="note note-error">\n        <div ng-message="required">Answer is required</div>\n      </div>\n    </div>\n\n    <footer class="shepherd-footer">\n      <button class="shepherd-button shepherd-button-secondary" ng-click="vm.cancel()" type="button">Return to tour</button>\n\n      <button class="shepherd-button" type="submit">Save</button>\n    </footer>\n  </form>\n</div>\n');
$templateCache.put('client-modules/adp-gridstack/adp-gs-embed/adp-gs-embed.html','<div class="adp-abs-fill well-background" ng-style="vm.containerCss">\n  <div id="adp-dashboard-container">\n    <div class="adp-dashboard-bg" ng-style="vm.bgCss" ng-if="vm.stretchBg"></div>\n    <div class="adp-widget-publish-error" ng-if="vm.errorMessage">{{ vm.errorMessage }}</div>\n    <div id="adp-dashboard-board" ng-style="vm.boardCss">\n      <div class="adp-dashboard-bg" ng-style="vm.bgCss" ng-if="!vm.stretchBg"></div>\n      <div id="adp-grid-stack" class="grid-stack"></div>\n      <div id="adp-float-layer"></div>\n    </div>\n    <div class="adp-dashboard-maximize-container">\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-gridstack/adp-gs-dashboard-map/adp-gs-dashboard-map.html','<div class="modal-header">\n  <h3 class="modal-title">Dashboard linking map</h3>\n  <div class="adp-dashboard-map-info">{{ vm.nodeInfo }}</div>\n</div>\n<div class="modal-body">\n  <div class="adp-widget-container" id="mapContainer">\n  </div>\n</div>\n<div class="modal-footer" adp-handle-hot-keys="">\n  <button class="adp-action-b-secondary" type="button" adp-hot-key="Escape" ng-click="vm.cancel()">\n    Close\n  </button>\n</div>\n');
$templateCache.put('client-modules/adp-gridstack/adp-gs-frameless/adp-gs-frameless.html','<div class="adp-abs-fill well-background" ng-style="vm.containerCss">\n  <div id="adp-dashboard-container">\n    <div class="adp-dashboard-bg" ng-style="vm.bgCss" ng-if="vm.stretchBg"></div>\n    <div class="adp-widget-publish-error" ng-if="vm.errorMessage">{{ vm.errorMessage }}</div>\n    <div id="adp-dashboard-board" ng-style="vm.boardCss">\n      <div class="adp-dashboard-bg" ng-style="vm.bgCss" ng-if="!vm.stretchBg"></div>\n      <div id="adp-grid-stack" class="grid-stack"></div>\n      <div id="adp-float-layer"></div>\n    </div>\n    <div class="adp-dashboard-maximize-container">\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-gridstack/directives/adp-dashboard-view.html','<div class="adp-vert-column adp-dashboard-wrapper">\n  <div class="adp-vert-column-header well-background">\n    <adp-gs-header args="vm.boardArgs" mode="view.header" ng-if="vm.boardArgs"></adp-gs-header>\n  </div>\n  <div class="adp-vert-column-body well-background" ng-style="vm.containerCss">\n    <div id="adp-dashboard-container" ng-class="vm.boardClass">\n      <div class="adp-dashboard-bg" ng-style="vm.bgCss" ng-if="vm.stretchBg"></div>\n      <div id="adp-dashboard-board" ng-style="vm.boardCss">\n        <div class="adp-dashboard-bg" ng-style="vm.bgCss" ng-if="!vm.stretchBg"></div>\n        <div id="adp-grid-stack" class="grid-stack"></div>\n        <div id="adp-float-layer"></div>\n      </div>\n    </div>\n    <div class="adp-dashboard-maximize-container">\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-payment-plans/adp-payment-plans-modal/adp-payment-plans-modal.html','<div class="modal-header">\n  <h3 class="modal-title">Choose your plan</h3>\n</div>\n\n<div class="modal-body">\n  <adp-page-loader loading="vm.isLoading"></adp-page-loader>\n  <div class="adp-widget-payment-plans-container" ng-if="vm.status===&quot;select-plans&quot;">\n    <div ng-repeat="plan in vm.plansList" class="adp-widget-payment-plan-block">\n      <div class="adp-widget-payment-plan-frame">\n        <h2>{{plan.name}}</h2>\n        <h4>{{plan.intro}}</h4>\n        <p>{{plan.description}}</p>\n        <div ng-repeat="option in plan.options" class="adp-widget-payment-plan-option-block">\n          <p><b>{{option.optionName}} </b><br>{{ vm.optionPrice(option) }}, {{option.period}}</p>\n          <button class="adp-action-b-primary" type="button" ng-click="vm.selectPlan(plan.name, option.optionName)">\n            Select\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div ng-if="vm.status===&quot;add-pay-profiles&quot;">\n    <p>Currently you do not have any payment methods in the system.\n    </p><p>Click \u201CProceed\u201D in order to add a payment method\n  </p></div>\n  <div ng-if="vm.status===&quot;buy-free&quot;">\n    <p>Click \u201CProceed\u201D to activate {{ vm.planName() }} plan.\n    </p><p>This option is totally free so we will not charge you a penny.\n  </p></div>\n  <div ng-if="vm.status===&quot;buy-new&quot;">\n    <p>Click \u201CProceed\u201D to activate {{ vm.planName() }} plan.\n    </p><p>This will keep charging your selected payment method every {{ vm.selectedOption.period }} for\n      the amount of {{ vm.optionPrice(vm.selectedOption) }} until you switch to a different plan.\n    </p><p>Choose your payment method:</p>\n    <div class="adp-payment-profile-list-container">\n      <div ng-repeat="profile in vm.customerPaymentProfiles" class="adp-payment-profile-box" ng-click="vm.selectPaymentProfile(profile.customerPaymentProfileId)" ng-class="{&quot;adp-payment-profile-selected&quot;:profile.isSelected}">\n        <label>{{profile.paymentProfileName}}</label>\n        <div class="adp-payment-profile-remove" ng-click="vm.deletePaymentProfile($event, profile.customerPaymentProfileId)">+</div>\n      </div>\n      <div class="adp-payment-profile-box">\n        <button class="btn btn-primary" type="button" ng-click="vm.addPaymentProfile()">\n          Add new\n        </button>\n      </div>\n    </div>\n    <p>By proceeding with this transaction you\u2019re agreeing to our <a href="/api/terms-of-service" target="blank">terms and conditions</a>.\n  </p></div>\n  <div ng-if="vm.status===&quot;switch-to-cheaper&quot;">\n    <p>Click \u201CProceed\u201D to switch your plan to {{ vm.planName() }}.\n    </p><p>You can still keep enjoying you current {{ vm.currentPlan.name }} plan until the end of the billing period on\n      {{ vm.nextChargeDate }} and then you will be switched to {{ vm.selectedPlan.name }}.\n    </p><p>By proceeding with this transaction you\u2019re agreeing to our <a href="/api/terms-of-service" target="blank">terms and conditions</a>.\n  </p></div>\n  <div ng-if="vm.status===&quot;switch-to-free&quot;">\n    <p>Click \u201CProceed\u201D to switch your plan to {{ vm.planName() }}.\n    </p><p>This will stop recurring charges to your payment method at the end of the current billing period, but you\n      will be able to use the current plan\u2019s features until the end of the billing period on {{ vm.nextChargeDate }}.\n    </p><p>By proceeding with this transaction you\u2019re agreeing to our <a href="/api/terms-of-service" target="blank">terms and conditions</a>.\n  </p></div>\n  <div ng-if="vm.status===&quot;ok&quot;">\n    {{ vm.statusMessage }}\n  </div>\n</div>\n\n<div class="modal-footer" adp-ui-buttons-handle-keyboard="">\n  <button class="adp-action-b-secondary" type="button" ng-if="vm.status!==&quot;ok&quot;" ng-click="vm.close()">\n    Cancel\n  </button>\n  <button class="adp-action-b-primary" type="button" ng-if="vm.selectedPlan" ng-click="vm.proceed()">\n    Proceed\n  </button>\n  <button class="adp-action-b-primary" type="button" ng-if="vm.status===&quot;ok&quot;" ng-click="vm.close()">\n    Ok\n  </button>\n</div>\n');
$templateCache.put('client-modules/aggregation-pipeline/aggregation-pipeline-data-preview/aggregation-pipeline-data-preview.html','<div class="modal-header">\n  <h3 class="modal-title">{{ vm.options.row.name }} custom view preview</h3>\n  <adp-fullscreen-button></adp-fullscreen-button>\n</div>\n\n<div class="modal-body aggregation-pipeline-data-preview">\n  <h3 class="ap-message" ng-if="vm.loading">\n    <i class="fa fa-circle-o-notch fa-2x fa-spin"></i>\n    <br>Loading...\n  </h3>\n  <h3 class="ap-message" ng-if="vm.message">{{ vm.message }}</h3>\n  <div class="ap-grid-container"></div>\n</div>\n\n<div class="modal-footer" adp-ui-buttons-handle-keyboard="">\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.close()">\n    Cancel\n  </button>\n  <button class="adp-action-b-primary" type="submit" ng-click="vm.close()">\n    Close\n  </button>\n</div>\n');
$templateCache.put('client-modules/aggregation-pipeline/aggregation-pipeline-specification/aggregation-pipeline-specification.html','<div class="modal-header">\n  <h3 class="modal-title">{{ vm.options.row.name }} custom view pipeline specification</h3>\n</div>\n\n<div class="modal-body aggregation-pipeline-specification">\n  <h3 class="ap-message" ng-if="vm.loading">\n    <i class="fa fa-circle-o-notch fa-2x fa-spin"></i>\n    <br>Loading...\n  </h3>\n  <h3 class="ap-message" ng-if="vm.message">{{ vm.message }}</h3>\n  <pre class="ap-specification-container" ng-if="!vm.message">{{ vm.specification }}</pre>\n</div>\n\n<div class="modal-footer" adp-ui-buttons-handle-keyboard="">\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.close()">\n    Cancel\n  </button>\n  <button class="adp-action-b-secondary" type="button" ng-click="vm.copy()">\n    Copy to clipboard\n  </button>\n  <button class="adp-action-b-primary" type="submit" ng-click="vm.close()">\n    Close\n  </button>\n</div>\n');
$templateCache.put('client-modules/aggregation-pipeline/aggregation-pipeline-stage/aggregation-pipeline-stage.template.html','<div class="aggregation-pipeline-stage">\n  <div class="aggregation-pipeline-stage-number">{{args.index}}</div>\n\n  <div class="aggregation-pipeline-stage-type" ng-click="stopPropagation($event)">\n    <div dx-select-box="typeSelectorCfg"></div>\n\n    <adp-tooltip adp-field="::args.fieldSchema"></adp-tooltip>\n  </div>\n\n  <div class="aggregation-pipeline-stage-text">\n    <div class="aggregation-pipeline-stage-text-inner" ng-bind-html="stageTitle"></div>\n  </div>\n\n  <div ng-if="::enabledCheckboxCfg" dx-check-box="::enabledCheckboxCfg"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/adp-widget-header/adp-widget-header.html','<div class="adp-tile-frame-header">\n  <div ng-click="collapseHeader()" class="adp-wh-control adp-tile-frame-header-collapse" aria-hidden="true" title="Toggle header">\n    <i class="adp-icon fa fa-angle-left"></i>\n  </div>\n  <div class="adp-widget-title" title="{{tile.data.title}}">{{tile.data.title}} {{tile.data.hidden?\'(not visible)\':\'\'}}</div>\n  <div ng-repeat="(name, action) in actions" ng-click="execAction(action, name, $event)" ng-class="getCSS(action)" data-action-name="{{name}}" ng-attr-title="{{action.fullName}}" ng-attr-adp-qaid-form-action="{{name}}" ng-if="visibleGetter(action)">\n    <span ng-bind-html="getIcon(action.icon)"></span>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/adp-widget-tile/adp-widget-tile.html','<div class="adp-tile-frame {{cssNames}}" ng-class="{[\'adp-tile-title-\' + showTitle]: 1, [\'adp-tile-type-\'+widgetType]:1, \'adp-tile-maximized\': isMaximized, \'adp-tile-frame-header-collapsed\': isTitleCollapsed}" ng-style="containerStyle" id="{{ tileId }}">\n  <div class="adp-dashboard-bg well-background" ng-style="bgStyle"></div>\n  <adp-widget-header ng-if="showTitle !== \'never\' || interface.editTile" ng-style="headerStyle"></adp-widget-header>\n  <div class="adp-tile-frame-body" ng-style="bodyStyle">\n    <adp-widget-factory ng-if="!isForbidden" interface="interface" tile="tile"></adp-widget-factory>\n    <div ng-if="isForbidden" class="adp-widget-publish-error">{{ tile.widgetRow.errorMessage}}</div>\n  </div>\n  <adp-split-editor-block ng-if="tile._editMode" tile="tile" interface="interface"></adp-split-editor-block>\n  <div class="adp-widget-blocker" ng-if="interface.togglePin && tile.data.positionFixed===false"></div>\n</div>\n');
$templateCache.put('client-modules/adp-form-actions/adp-vcs-action/adp-save-vcs-modal/adp-save-vcs-modal.html','<form name="form" ng-attr-adp-qaid-copy-paste-form="{{vm.args.modelSchema.schemaName}}" class="smart-form client-form" novalidate="" ng-submit="vm.save()">\n  <header class="smart-form-header">Content Version Control</header>\n\n  <div class="adp-form-body">\n    <fieldset>\n      <div class="adp-form-fieldset">\n        <div class="col col-12">\n          <section class="input-container">\n            <label class="label">\n              Name <span class="text-danger">&nbsp;*</span>\n            </label>\n\n            <div dx-text-box="vm.textBoxConfig" name="name" ng-model="vm.formData.name" ng-required="true"></div>\n\n            <div ng-messages="" ng-if="form.$submitted || form.name.$dirty" for="form.name.$error" class="note note-error">\n              <span ng-message="required">Name is required.</span>\n            </div>\n          </section>\n\n          <section class="input-container">\n            <label class="label">\n              Description\n            </label>\n\n            <div dx-text-area="vm.textAreaConfig" name="description" ng-model="vm.formData.description"></div>\n          </section>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n\n  <footer class="adp-action-b-container" adp-handle-hot-keys="form">\n    <button class="adp-action-b-secondary" ng-click="vm.cancel()" adp-hot-key="Escape" type="button">\n      Cancel\n    </button>\n\n    <button class="adp-action-b-primary" type="submit">\n      Save\n    </button>\n  </footer>\n\n</form>\n');
$templateCache.put('client-modules/adp-form-actions/adp-copy-paste-action/adp-copy-paste-modal/adp-copy-paste-modal.html','<form name="form" ng-attr-adp-qaid-copy-paste-form="{{vm.args.modelSchema.schemaName}}" class="smart-form client-form" novalidate="" ng-submit="vm.updateRecord()">\n  <header class="smart-form-header">Copy/Paste CV Code</header>\n\n  <div class="adp-form-body">\n    <fieldset>\n      <div class="adp-form-fieldset">\n        <p style="margin-bottom: 20px" class="alert alert-info col col-12">\n          The code below represents this record. You can either copy it or paste a new record code below. If you paste the new code it will completely overwrite the current record. This feature provides a way to back up versions of your records or copy them from one environment to another.\n        </p>\n\n        <div class="col col-12">\n          <section class="input-container" ng-field-name="name" ng-class="{\n            \'state-error\': form.compressedRecord.$dirty && form.compressedRecord.$invalid,\n            \'state-success\': form.compressedRecord.$dirty && form.compressedRecord.$valid\n        }">\n            <label class="label">Record Code:</label>\n\n            <div class="clipboard-loader-overlay" ng-if="vm.disabled">\n              <div class="clipboard-loader fa fa-gear fa-spin fa-5x"></div>\n            </div>\n\n            <div dx-text-area="vm.textAreaCfg" name="compressedRecord" ng-model="vm.formData.compressedRecord"></div>\n\n            <div ng-messages="" for="form.compressedRecord.$error" ng-if="form.compressedRecord.$dirty" class="note note-error"></div>\n          </section>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n\n  <footer class="adp-action-b-container" adp-handle-hot-keys="form">\n    <button class="adp-action-b-secondary" ng-click="vm.cancel()" adp-hot-key="Escape" type="button">\n      Close\n    </button>\n\n    <button class="adp-action-b-secondary" ng-click="vm.copy()" ng-disabled="vm.disabled" type="button">\n      Copy\n    </button>\n\n    <button class="adp-action-b-secondary" ng-click="vm.paste()" ng-disabled="vm.disabled" type="button">\n      Paste\n    </button>\n\n    <button class="adp-action-b-primary" type="submit" ng-disabled="vm.disabled">\n      Update Record\n    </button>\n  </footer>\n\n</form>\n');
$templateCache.put('client-modules/adp-form-actions/adp-vcs-action/adp-vcs-modal/adp-vcs-modal.html','<form name="form" class="smart-form client-form" novalidate="" ng-submit="vm.loadRecordToForm()">\n  <header class="smart-form-header">Content Version Control</header>\n\n  <div class="adp-form-body">\n    <fieldset>\n      <div class="adp-form-fieldset">\n        <div class="col col-12">\n          <section class="input-container">\n            <label class="label">Select record\'s version</label>\n            <div dx-select-box="vm.configForRecordsList" ng-model="vm.formData.selectedVersion"></div>\n\n            <adp-vcs-record-info args="vm.selectedArgs"></adp-vcs-record-info>\n          </section>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n\n  <footer class="adp-action-b-container" adp-handle-hot-keys="form">\n    <button class="adp-action-b-secondary" ng-click="vm.cancel()" adp-hot-key="Escape" type="button">\n      Cancel\n    </button>\n\n    <button class="adp-action-b-primary" type="button" ng-click="vm.saveCurrentRecordDataToVCS()">\n      Save\n    </button>\n\n    <button class="adp-action-b-primary btn-danger" ng-disabled="vm.loadAndDeletedDisabled" type="button" ng-click="vm.delete()">\n      Delete\n    </button>\n\n    <button class="adp-action-b-primary" type="submit" ng-disabled="vm.loadAndDeletedDisabled">\n      Load\n    </button>\n  </footer>\n\n</form>\n');
$templateCache.put('client-modules/adp-topomap/modes/3d/adp-topomap-3d.html','<div class="adp-absolute-fill adp-topomap-3d">\n  <canvas class="adp-absolute-fill scene-canvas"></canvas>\n  <adp-page-loader loading="vm.isLoading"></adp-page-loader>\n</div>');
$templateCache.put('client-modules/adp-topomap/modes/ar/adp-topomap-ar-top-frame.html','<div class="adp-widget-container">\n  <iframe width="100%" height="100%" id="adp_topomap_ar" ng-src="{{iframeUrl}}" allow="xr-spatial-tracking,camera" allowfullscreen="1"></iframe>\n</div>');
$templateCache.put('client-modules/adp-topomap/modes/vr/adp-topomap-vr.html','<div class="adp-absolute-fill adp-topomap-vr">\n    <div class="adp-absolute-fill adp-topomap-box"></div>\n    <adp-page-loader loading="vm.isLoading"></adp-page-loader>\n</div>');
$templateCache.put('client-modules/adp-widgets/widgets/ar-anything/ar-anything.html','<div class="adp-widget-container">\n    <iframe width="100%" height="100%" id="adp_ar_anything" ng-src="{{vm.iframeUrl}}" allow="xr-spatial-tracking,camera,geolocation" allowfullscreen="1" iframe-onload="vm.iframeOnLoad()"></iframe>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/calculated-html/adp-widget-calculated.html','<div class="adp-calc-html-align-container" ng-style="alignStyle">\n    <div class="safe-html" ng-bind-html="safeHtml"></div>\n    <adp-page-loader loading="isLoading"></adp-page-loader>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/control-widget.html','<div class="adp-control-widget-container adp-vert-column" ng-class="{\'adp-cw-switchable-state\': args.row.control.switchableControllers, \'adp-cw-show-color-indicator\':!args.row.control.hideColorIndicator}">\n  <div class="adp-vert-column-body">\n    <div class="err-message" ng-if="!!errorMessage">{{ errorMessage }}</div>\n    <control-widget-factory ng-repeat="controller in groupingTree" controller="controller" interface="interface" args="args">\n    </control-widget-factory>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/dashboard-chart/dashboard-chart.template.html','<div class="adp-widget-container">\n    <adp-widget-chart options="options" data="data" messages="messages" event-handlers="eventHandlers" ng-if="data"></adp-widget-chart>\n    <adp-page-loader loading="isLoading"></adp-page-loader>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/sparkline/sparkline-widget.html','<div class="adp-widget-container">\n  <div class="adp-widget-container-error-message" ng-show="errorMessage" ng-bind-html="errorMessage"></div>\n  <div class="adp-sparkline-frame" ng-show="!errorMessage">\n    <div class="adp-sparkline-body"></div>\n  </div>\n  <div class="adp-sparkline-selection" ng-if="!!selectionText">\n    <div class="text">{{selectionText}}</div>\n    <div class="clear" ng-click="selectionClear()">clear</div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/split-container/split-container.html','<div class="adp-split-widget-container">\n    <adp-split-sub-tile ng-repeat="t in rootTiles track by t.id"></adp-split-sub-tile>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/split-container/split-editor-block.html','<div class="adp-split-editor-box" ng-class="editorClass" ng-mouseenter="toggleBranchHover(true)" ng-mouseleave="toggleBranchHover(false)">\n    <div class="adp-split-vertically">\n        <div class="adp-split-button" title="Split vertically" ng-click="splitTile(false)">\n            <i class="fa fa-scissors"></i>\n        </div>\n    </div>\n\n    <div class="adp-split-horizontally">\n        <div class="adp-split-button" title="Split horizontally" ng-click="splitTile(true)">\n            <i class="fa fa-scissors"></i>\n        </div>\n    </div>\n\n    <div class="adp-split-button swap-tile" title="Swap tile" ng-if="hasWidget">\n        <i class="fa fa-arrows"></i>\n    </div>\n\n    <div class="adp-split-button tile-remove" title="Remove tile" ng-if="!hasWidget && (parent || !isFirstOnLevel || !isLastOnLevel)" ng-click="removeTile()">\n        <i class="fa fa-trash"></i>\n    </div>\n\n    <div class="adp-split-button edit-tile" title="Edit tile" ng-if="!hasWidget" ng-click="editTile()">\n        <i class="fa fa-cog"></i>\n    </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/split-container/split-editor-move-edge.html','<div class="adp-split-border-move" ng-style="style" ng-mouseenter="onMouseEnter($event)">\n    <div class="adp-split-button toggle-abs" title="Absolute switch" ng-click="toggleAbs($event)">\n        <i class="fa fa-lock"></i>\n    </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/split-container/split-subtile.directive.html','<div class="adp-split-block" ng-style="t._style" id="tile-{{t.id}}">\n    <adp-widget-tile ng-if="t.widgetRow" tile="t" interface="interface"></adp-widget-tile>\n    <adp-split-editor-block ng-if="t._editMode && !t._isWrapper && !t.widgetRow" tile="t" interface="interface"></adp-split-editor-block>\n    <adp-split-sub-tile ng-repeat-start="t in t._subtree track by t.id"></adp-split-sub-tile>\n    <adp-split-editor-move-edge ng-repeat-end="" ng-if="t._editMode && t._moveBorder" tile="t" save-tiles="saveTiles"></adp-split-editor-move-edge>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/tabbed-container/tabbed-container.html','<div class="adp-tabbed-widget-container" ng-class="::classNames"></div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/value-widget/value-widget.html','<div ng-class="{ \'adp-chart-initialized\': initialized }">\n  <div ng-if="::advancedTemplate" ng-bind-html="safeHtml" class="safe-html adp-value-widget" ng-class="[vericalPosition]"></div>\n\n  <div ng-if="::!advancedTemplate" class="adp-value-widget" ng-class="[containerLayout, vericalPosition]">\n    <div class="adp-vw-part adp-vw-label" ng-style="labelCss">{{label}}</div>\n    <div class="adp-vw-part adp-vw-value" ng-style="valueCss">{{value}}</div>\n  </div>\n\n  <adp-page-loader loading="isLoading"></adp-page-loader>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/globe/3d/adp-globe-3d.html','<div class="adp-absolute-fill">\n  <div class="visualisation-box"></div>\n  <div class="labels-screen"></div>\n  <div class="time-log"></div>\n  <adp-page-loader loading="isLoading"></adp-page-loader>\n</div>');
$templateCache.put('client-modules/adp-widgets/widgets/globe/ar/adp-globe-ar-top-frame.html','<div class="adp-widget-container">\n  <iframe width="100%" height="100%" id="adp_globe_ar" ng-src="{{iframeUrl}}" allow="xr-spatial-tracking,camera" allowfullscreen="1"></iframe>\n</div>');
$templateCache.put('client-modules/adp-widgets/widgets/globe/vr/adp-globe-vr.html','<div class="adp-absolute-fill" ng-if="vendorCodeReady">\n  <a-scene background="color: #001" embedded="" vr-mode-ui="">\n    <a-entity position="0 0 25" movement-controls="controls: gamepad; fly: true; speed: 0.5">\n      <a-entity cursor="rayOrigin: mouse; mouseCursorStylesEnabled: true;" raycaster="objects: [globe]; interval: 100"></a-entity>\n      <a-entity laser-controls="hand: left" raycaster="objects: [globe]; interval: 100; lineColor: steelblue; lineOpacity: 0.85; "></a-entity>\n      <a-entity laser-controls="hand: right" raycaster="objects: [globe]; interval: 100; lineColor: steelblue; lineOpacity: 0.85;"></a-entity>\n      <a-camera look-controls="pointerLockEnabled: false"> <!--  wasd-controls="fly: true; acceleration: 50;" -->\n        <a-text id="sat-label" position="-3 -1.5 -2" width="2" color="#ffbbbb"></a-text>\n        <a-text id="globe-tooltip" position="0 -1.1 -2" width="2" align="center" color="lavender"></a-text>\n        <a-text id="globe-tooltip-details" position="0 -1.25 -2" width="3" align="center" color="yellow"></a-text>\n      </a-camera>\n    </a-entity>\n    <a-entity id="globe" scale="0.1 0.1 0.1" rotation="0 90 0" globe=""></a-entity>\n  </a-scene>\n</div>');
$templateCache.put('client-modules/adp-widgets/widgets/vis3d/2d/graphVisualisation2d.html','<div ng-class="vm.theme">\n  <adp-page-loader loading="vm.state.isLoading"></adp-page-loader>\n  <div class="adp-fg-container adp-fg-container-2d" ng-class="{ \'is-fullscreen\': $root.isFullscreen}">\n    <div class="adp-fg-box"></div>\n    <div class="adp-fg-messages" ng-if="vm.errorMessage" ng-bind-html="vm.errorMessage"></div>\n    <div class="adp-fg-left-panel" ng-class="{\'both-open\': vm.state.config.showOptions && vm.state.config.showLegend}">\n      <div class="adp-fg-panel-block adp-fg-left-panel-block adp-fg-config" ng-class="{ open: vm.state.config.showOptions && vm.state.config.allowConfig}">\n        <div class="adp-fg-config-box adp-fg-panel-box" ng-if="vm.state.config.allowConfig">\n          <div class="adp-fg-config-form">\n            <div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Filter</div>\n\n                <div class="form-row">Entities\n                  <span><input ng-model="vm.state.config.nodeFilter" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Relationships\n                  <span><input ng-model="vm.state.config.linkFilter" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Tags\n                  <div class="adp-fg-tags-container same-width"></div>\n                </div>\n                <label class="form-row">\n                  Highlight adjacent [T]\n                  <span><input type="checkbox" ng-model="vm.state.config.highlightAdjacent" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Show labels for</div>\n                <label class="form-row">\n                  Highlighted entities\n                  <span><input type="checkbox" ng-model="vm.state.config.hlLabelNodes" ng-checked="vm.state.config.hlLabelNodes" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  Highlighted relationships\n                  <span><input type="checkbox" ng-model="vm.state.config.hlLabelLinks" ng-checked="vm.state.config.hlLabelLinks" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  All entities [E]\n                  <span><input type="checkbox" ng-model="vm.state.config.labelNodes" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  All relationships [R]\n                  <span><input type="checkbox" ng-model="vm.state.config.labelLinks" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Selection</div>\n                <div class="form-row">Colorize\n                  <span>%<input type="number" ng-model="vm.state.config.hlColorize" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Dim not selected\n                  <span>%<input type="number" ng-model="vm.state.config.hlDim" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Relationships</div>\n                <label class="form-row">\n                  Show arrows\n                  <span><input type="checkbox" ng-model="vm.state.config.showArrows" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  Show particles\n                  <span><input type="checkbox" ng-model="vm.state.config.showParticles" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <div class="form-row">Arrows size\n                  <span>x<input type="number" ng-model="vm.state.config.arrowSize" ng-change="vm.doRefreshGraph();" class="same-width"></span>\n                </div>\n                <div class="form-row">Particles size\n                  <span>x<input type="number" ng-model="vm.state.config.particleSize" ng-change="vm.doRefreshGraph();" class="same-width"></span>\n                </div>\n                <div class="form-row">Curvature\n                  <span>%<input type="number" ng-model="vm.state.config.linkCurvature" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Length [+/-]\n                  <span>%<input type="number" ng-model="vm.state.config.linkDistance" ng-change="vm.doRefreshGraph();vm.reheatSimulation()" class="same-width"></span>\n                </div>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Other</div>\n                <label class="form-row">\n                  Fix dragged entity [X]\n                  <span><input type="checkbox" ng-model="vm.state.config.fixDragged" ng-change="vm.resetFixDragged()"></span>\n                </label>\n              </div>\n              <div class="justify-between">\n                <button ng-click="vm.screenCapture()" ng-disabled="vm.exportingImage" class="btn">\n                  {{ vm.exportingImage ? \'Exporting....\' : \'Export as PNG\' }}\n                </button>\n<!--                <button ng-click=\'vm.exportAsHtml()\'-->\n<!--                        ng-disabled="vm.exportingHtml"-->\n<!--                        class="btn">-->\n<!--                  {{ vm.exportingHtml ? \'Exporting....\' : \'Export as HTML\' }}-->\n<!--                </button>-->\n              </div>\n              <div class="justify-between" ng-if="vm.state.config.allowConfigSave">\n                <button ng-click="vm.saveConfig()" class="btn">Save config [S]\n                </button>\n                <button ng-click="vm.loadConfig()" ng-disabled="!vm.state.cachedConfig" class="btn">Load config [L]\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="adp-fg-config-icon adp-fg-panel-icon fa fa-bars" ng-if="vm.state.config.allowConfig" ng-click="vm.toggleConfig()"></div>\n        <div class="adp-fg-close" ng-click="vm.toggleConfig()">x close</div>\n      </div>\n      <div class="adp-fg-panel-block adp-fg-left-panel-block adp-fg-legend" ng-class="{open: vm.state.config.showLegend && vm.state.config.allowLegend}">\n        <div class="adp-fg-panel-box adp-fg-legend-box" ng-if="vm.state.config.allowLegend">\n          <div class="adp-fg-fieldset" ng-if="vm.state.legend.nodes.length">\n            <div class="adp-fg-fieldset-label">Entities</div>\n            <div ng-repeat="type in vm.state.legend.nodes" class="adp-fg-legend-item">\n              <div class="adp-fg-leg-icon">\n                <div ng-class="{ &quot;adp-fg-leg-icon-node&quot;:1,  [&quot;shape_&quot; + type.shp.toLowerCase()]:1 }" ng-style="{ backgroundColor: type.col || &quot;white&quot; }"></div>\n              </div>\n              <div class="adp-fg-leg-txt">{{ type.text || \'[no title]\' }}</div>\n            </div>\n          </div>\n          <div class="adp-fg-fieldset" ng-if="vm.state.legend.links.length">\n            <div class="adp-fg-fieldset-label">Relationships</div>\n            <div ng-repeat="type in vm.state.legend.links" class="adp-fg-legend-item">\n              <div class="adp-fg-leg-icon">\n                <div class="adp-fg-leg-icon-link" ng-style="{ borderBottomWidth: type.w + &quot;px&quot;, borderColor: type.col || &quot;white&quot; }"></div>\n              </div>\n              <div class="adp-fg-leg-txt">{{ type.text || \'[no title]\' }}</div>\n            </div>\n          </div>\n        </div>\n        <div class="adp-fg-legend-icon adp-fg-panel-icon" title="Show legend" ng-if="vm.state.config.allowLegend" ng-click="vm.toggleLegend($event)">Legend</div>\n        <div class="adp-fg-close" ng-click="vm.toggleLegend($event)">x close</div>\n      </div>\n    </div>\n    <div class="adp-fg-panel-block adp-fg-right-panel-block adp-fg-info" ng-if="vm.state.config.allowInfo" ng-class="{open: vm.state.config.showInfo, hidden:!vm.state.selectedNodes.length}">\n      <div class="adp-fg-info-box adp-fg-panel-box" ng-show="!!vm.state.selectedNodes.length">\n        <div ng-repeat="node in vm.state.selectedNodes" class="adp-fg-entity-info">\n        <div class="adp-fg-info-icon">\n          <div ng-class="{ &quot;adp-fg-leg-icon-node&quot;:1, [&quot;shape_&quot; +  node.shp.toLowerCase()]:1 }" ng-style="{ backgroundColor:  node.col || &quot;white&quot; }" ng-if="node.__type === &quot;node&quot;"></div>\n          <div class="adp-fg-leg-icon-link" ng-style="{borderBottomWidth: (node.w ? (node.w + 2) : 1 ) + &quot;px&quot;, borderColor: node.col || &quot;white&quot; }" ng-if="node.__type === &quot;link&quot;"></div>\n        </div>\n          <span ng-bind-html="vm.getInfoHtml(node)"></span>\n      </div>\n      </div>\n      <div class="adp-fg-info-icon adp-fg-panel-icon fa fa-info-circle" ng-click="vm.toggleInfo()"></div>\n      <div class="adp-fg-close" ng-click="vm.toggleInfo()">x close</div>\n    </div>\n    <div class="adp-fg-nav-controls" ng-if="vm.state.config && vm.state.config.allowNavigation">\n      <button ng-click="vm.navigationZoomIn()" class="btn">+</button>\n      <button ng-click="vm.navigationZoomOut()" class="btn">-</button>\n      <button ng-click="vm.navigationCenter()" class="btn"><i class="fa fa-dot-circle-o"></i></button>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/vis3d/ar/graphVisualisationAr.html','<div class="adp-widget-container">\n    <iframe width="100%" height="100%" id="adp_ar" ng-src="{{vm.iframeUrl}}" allow="xr-spatial-tracking,camera" allowfullscreen="1" iframe-onload="vm.iframeOnLoad()"></iframe>\n    <div class="adp-ar-message-container">\n        <div class="adp-ar-message" ng-class="{\'adp-ar-message-present\':vm.isArMessagePresent}">{{vm.arMessage}}</div>\n    </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/vis3d/3d/graphVisualisation3d.html','<div ng-class="vm.theme">\n  <adp-page-loader loading="vm.state.isLoading"></adp-page-loader>\n  <div class="adp-fg-container adp-fg-container-3d" ng-class="{ \'is-fullscreen\': $root.isFullscreen }">\n    <div class="adp-fg-box"></div>\n    <div class="adp-fg-messages" ng-if="vm.errorMessage" ng-bind-html="vm.errorMessage"></div>\n    <div class="adp-fg-left-panel" ng-class="{\'both-open\': vm.state.config.showOptions && vm.state.config.showLegend}">\n      <div class="adp-fg-panel-block adp-fg-left-panel-block adp-fg-config" ng-class="{open: vm.state.config.showOptions && vm.state.config.allowConfig}">\n        <div class="adp-fg-config-box adp-fg-panel-box" ng-if="vm.state.config.allowConfig">\n          <div class="adp-fg-config-form">\n            <div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Filter</div>\n\n                <div class="form-row">Entities\n                  <span><input ng-model="vm.state.config.nodeFilter" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Relationships\n                  <span><input ng-model="vm.state.config.linkFilter" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Tags\n                  <div class="adp-fg-tags-container same-width"></div>\n                </div>\n                <label class="form-row">\n                  Highlight adjacent [T]\n                  <span><input type="checkbox" ng-model="vm.state.config.highlightAdjacent" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Show labels for</div>\n                <label class="form-row">\n                  Highlighted entities\n                  <span><input type="checkbox" ng-model="vm.state.config.hlLabelNodes" ng-checked="vm.state.config.hlLabelNodes" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  Highlighted relationships\n                  <span><input type="checkbox" ng-model="vm.state.config.hlLabelLinks" ng-checked="vm.state.config.hlLabelLinks" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  All entities [E]\n                  <span><input type="checkbox" ng-model="vm.state.config.labelNodes" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  All relationships [R]\n                  <span><input type="checkbox" ng-model="vm.state.config.labelLinks" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Selection</div>\n                <div class="form-row">Colorize\n                  <span>%<input type="number" ng-model="vm.state.config.hlColorize" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Highlight\n                  <span>%<input type="number" ng-model="vm.state.config.hlBrightness" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Glow bloom\n                  <span>%<input type="number" ng-model="vm.state.config.hlGlow" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Dim not selected\n                  <span>%<input type="number" ng-model="vm.state.config.hlDim" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Relationships</div>\n                <label class="form-row">\n                  Show arrows\n                  <span><input type="checkbox" ng-model="vm.state.config.showArrows" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <label class="form-row">\n                  Show particles\n                  <span><input type="checkbox" ng-model="vm.state.config.showParticles" ng-change="vm.doRefreshGraph()"></span>\n                </label>\n                <div class="form-row">Arrows size\n                  <span>x<input type="number" ng-model="vm.state.config.arrowSize" ng-change="vm.doRefreshGraph();" class="same-width"></span>\n                </div>\n                <div class="form-row">Particles size\n                  <span>x<input type="number" ng-model="vm.state.config.particleSize" ng-change="vm.doRefreshGraph();" class="same-width"></span>\n                </div>\n                <div class="form-row">Curvature\n                  <span>%<input type="number" ng-model="vm.state.config.linkCurvature" ng-change="vm.doRefreshGraph()" class="same-width"></span>\n                </div>\n                <div class="form-row">Length [+/-]\n                  <span>%<input type="number" ng-model="vm.state.config.linkDistance" ng-change="vm.doRefreshGraph();vm.reheatSimulation()" class="same-width"></span>\n                </div>\n              </div>\n              <div class="adp-fg-fieldset">\n                <div class="adp-fg-fieldset-label">Other</div>\n                <label class="form-row">\n                  Fix dragged entity [X]\n                  <span><input type="checkbox" ng-model="vm.state.config.fixDragged" ng-change="vm.resetFixDragged()"></span>\n                </label>\n                <label class="form-row">\n                  Camera orbiting [O]\n                  <span><input type="checkbox" ng-model="vm.state.config.animCamera" ng-change="vm.toggleCameraOrbit()"></span>\n                </label>\n              </div>\n              <div class="justify-between">\n                <button ng-click="vm.screenCapture()" ng-disabled="vm.exportingImage" class="btn">\n                  {{ vm.exportingImage ? \'Exporting....\' : \'Export as PNG\' }}\n                </button>\n                <button ng-click="vm.exportAsHtml()" ng-disabled="vm.exportingHtml" class="btn">\n                  {{ vm.exportingHtml ? \'Exporting....\' : \'Export as HTML\' }}\n                </button>\n              </div>\n<!--              <div class="justify-between">\n                <button ng-click=\'vm.activateVr()\'\n                        class="btn">View in VR\n                </button>\n                <button ng-click=\'vm.activateAr()\'\n                        class="btn">View in AR\n                </button>\n              </div>-->\n              <div class="justify-between" ng-if="vm.state.config.allowConfigSave">\n                <button ng-click="vm.saveConfig()" class="btn">Save config [S]\n                </button>\n                <button ng-click="vm.loadConfig()" ng-disabled="!vm.state.cachedConfig" class="btn">Load config [L]\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="adp-fg-config-icon adp-fg-panel-icon fa fa-bars" ng-if="vm.state.config.allowConfig" ng-click="vm.toggleConfig()"></div>\n        <div class="adp-fg-close" ng-click="vm.toggleConfig()">x close</div>\n      </div>\n      <div class="adp-fg-panel-block adp-fg-left-panel-block adp-fg-legend" ng-class="{open: vm.state.config.showLegend && vm.state.config.allowLegend}">\n        <div class="adp-fg-panel-box adp-fg-legend-box" ng-if="vm.state.config.allowLegend">\n          <div class="adp-fg-fieldset" ng-if="vm.state.legend.nodes.length">\n            <div class="adp-fg-fieldset-label">Entities</div>\n            <div ng-repeat="type in vm.state.legend.nodes" class="adp-fg-legend-item">\n              <div class="adp-fg-leg-icon">\n                <div class="adp-fg-leg-icon-node" ng-class="{[&quot;shape_&quot; + type.shp.toLowerCase()]:1 }" ng-style="{ backgroundColor: type.col || &quot;white&quot; }"></div>\n              </div>\n              <div class="adp-fg-leg-txt">{{ type.text || \'[no title]\' }}</div>\n            </div>\n          </div>\n          <div class="adp-fg-fieldset" ng-if="vm.state.legend.links.length">\n            <div class="adp-fg-fieldset-label">Relationships</div>\n            <div ng-repeat="type in vm.state.legend.links" class="adp-fg-legend-item">\n              <div class="adp-fg-leg-icon">\n                <div class="adp-fg-leg-icon-link" ng-style="{ borderBottomWidth: type.w + &quot;px&quot;, borderColor: type.col || &quot;white&quot; }"></div>\n              </div>\n              <div class="adp-fg-leg-txt">{{ type.text || \'[no title]\' }}</div>\n            </div>\n          </div>\n        </div>\n        <div class="adp-fg-legend-icon adp-fg-panel-icon" title="Show legend" ng-if="vm.state.config.allowLegend" ng-click="vm.toggleLegend($event)">Legend</div>\n        <div class="adp-fg-close" ng-click="vm.toggleLegend($event)">x close</div>\n      </div>\n    </div>\n    <div class="adp-fg-panel-block adp-fg-right-panel-block adp-fg-info" ng-if="vm.state.config.allowInfo" ng-class="{open: vm.state.config.showInfo, hidden:!vm.state.selectedNodes.length}">\n      <div class="adp-fg-info-box adp-fg-panel-box" ng-show="!!vm.state.selectedNodes.length">\n        <div ng-repeat="node in vm.state.selectedNodes" class="adp-fg-entity-info">\n          <div class="adp-fg-info-icon">\n            <div ng-class="{ &quot;adp-fg-leg-icon-node&quot;:1, [&quot;shape_&quot; +  node.shp.toLowerCase()]:1 }" ng-style="{ backgroundColor:  node.col || &quot;white&quot; }" ng-if="node.__type === &quot;node&quot;"></div>\n            <div class="adp-fg-leg-icon-link" ng-style="{borderBottomWidth: (node.w ? (node.w + 2) : 1 ) + &quot;px&quot;, borderColor: node.col || &quot;white&quot; }" ng-if="node.__type === &quot;link&quot;"></div>\n          </div>\n          <span ng-bind-html="vm.getInfoHtml(node)"></span>\n        </div>\n      </div>\n      <div class="adp-fg-info-icon adp-fg-panel-icon fa fa-info-circle" ng-click="vm.toggleInfo()"></div>\n      <div class="adp-fg-close" ng-click="vm.toggleInfo()">x close</div>\n    </div>\n    <div class="adp-fg-nav-controls" ng-if="vm.state.config && vm.state.config.allowNavigation">\n      <button ng-click="vm.navigationZoomIn()" class="btn">+</button>\n      <button ng-click="vm.navigationZoomOut()" class="btn">-</button>\n      <button ng-click="vm.navigationCenter()" class="btn"><i class="fa fa-dot-circle-o"></i></button>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/vis3d/vr/graphVisualisationVr.html','<div>\n  <adp-page-loader loading="vm.state.isLoading"></adp-page-loader>\n  <div class="adp-fg-container adp-fg-container-vr" ng-class="{ \'is-fullscreen\': $root.isFullscreen }">\n    <div class="adp-fg-box"></div>\n    <div class="adp-fg-messages" ng-if="vm.errorMessage" ng-bind-html="vm.errorMessage"></div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/date-time-range/date-time-range-control.html','<div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-input adp-cw-input-left"></div>\n    <div class="adp-cw-input adp-cw-input-right"></div>\n  </div>\n  <div class="adp-cw-bar"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/date-time-slider/date-time-slider-control.html','<div>\n  <div class="adp-cw-discrete-label-collapsed" ng-if="showLabel">\n    <strong>{{controllerLabel}}</strong> {{valueLabel}}\n  </div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-input adp-cw-input-left"></div>\n  </div>\n  <div class="adp-cw-bar"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/discrete-range/discrete-range-control.html','<div>\n    <div class="adp-cw-discrete-label-collapsed" ng-if="controller.params.concatValueWithLabel">\n        <strong>{{controller.label}}:</strong> <span ng-bind-html="safeHtmlDisplayString"></span>\n    </div>\n    <div class="adp-cw-discrete-label" ng-if="!controller.params.concatValueWithLabel" ng-bind-html="safeHtmlDisplayString">\n    </div>\n    <div class="adp-cw-slider-steps-container">\n        <div class="adp-cw-slider-steps">\n            <div ng-repeat="x in [].constructor(stepCount-1) track by $index" class="adp-discrete-step"></div>\n        </div>\n    </div>\n    <div class="adp-cw-bar"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/group/control-widget-group.html','<div class="adp-cw-group" ng-style="containerStyle">\n    <div class="adp-dashboard-bg" ng-style="bgStyle"></div>\n    <div class="adp-cw-group-header" ng-if="!hideHeader" ng-style="headerStyle" ng-class="{\'adp-cw-group-header-expanded\': expanded}">\n        <div class="adp-cw-group-title" ng-click="onClick()">{{ controller.label || \'[ No title ]\'}}</div>\n        <div class="adp-cw-tooltip">\n            <adp-tooltip></adp-tooltip>\n        </div>\n    </div>\n    <div class="adp-cw-group-body" ng-style="bodyStyle" ng-class="{\'adp-cw-group-body-expanded\': expanded}">\n        <control-widget-factory ng-repeat="item in controller.subset" controller="item" interface="interface">\n        </control-widget-factory>\n    </div>\n</div>\n\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/list-multi-select/list-multi-select-control.html','<div class="adp-cw-list">\n  <div class="adp-cw-list-columns">\n    <div ng-repeat="item in items" class="adp-cw-list-item" ng-style="{flexBasis: (100 / columns) + \'%\'}">\n      <label>\n        <input type="checkbox" ng-click="toggleItem(item.value)" name="{{item.value}}">\n        <span ng-bind-html="item.safeHtmlLabel"></span>\n      </label>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/list-multi-select-dropdown/list-multi-select-dropdown-control.html','<div>\n  <div class="adp-cw-multi-select-dropdown">\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/list-select/list-select-control.html','<div>\n  <div class="adp-cw-list-select"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/load-presets/load-presets-control.html','<div class="adp-cw-load-presets">\n    <div class="adp-preset-list-box"></div>\n    <div class="btn btn-primary" ng-if="allowSavePreset" ng-click="savePreset()">Save</div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/location/location-slider-control.html','<div class="adp-cw-location">\n    <div class="adp-location-geo-loader" ng-if="detecting">\n        <span class="fa fa-location-arrow fa-spin"></span> <span class="adp-location-geo-loader-text">Locating...</span>\n    </div>\n    <div class="adp-cw-location-row">\n        <div ng-if="!fieldParams.showAddress && !detecting" class="adp-cw-location-address">{{ addressLabel }}</div>\n        <input places-auto-complete="" class="form-control-location form-control" ng-class="{ detecting: detecting }" ng-model="addressLabel" ng-disabled="detecting" ng-if="isReady && fieldParams.showAddress" on-place-changed="placeChanged()">\n        <div class="adp-cw-location-controls">\n            <div ng-if="!fieldParams.showInputs && !fieldParams.useDropdown" class="adp-cw-location-distance">{{ distanceText }}</div>\n            <div class="adp-cw-input-boxes" ng-if="fieldParams.showInputs && !fieldParams.useDropdown">\n                <div class="adp-cw-input adp-cw-input-left adp-cw-input-near" ng-if="fieldParams.useNearRange"></div>\n                <div class="adp-cw-input adp-cw-input-right adp-cw-input-far"></div>\n            </div>\n            <div class="adp-cw-list-select adp-cw-location-dropdown" ng-if="fieldParams.useDropdown"></div>\n            <div class="adp-cw-location-btn" ng-class="{\'adp-cw-active\': detecting, \'adp-cw-disabled\': !isReady}" ng-click="detect()" ng-if="fieldParams.showLocate" title="Detect location">\n                <i class="fa fa-location-arrow"></i>\n            </div>\n            <div class="adp-cw-location-btn" ng-class="{\'adp-cw-active\': isMapVisible, \'adp-cw-disabled\': !isReady}" ng-click="toggleMapVisibility()" ng-if="fieldParams.showToggleMapControl" ng-title="isMapVisible ? \'Hide map\' : \'Show map\'">\n                <i class="fa fa-map-o"></i>\n            </div>\n        </div>\n    </div>\n    <div class="adp-cw-bar" ng-if="!fieldParams.useDropdown"></div>\n    <ng-map id="{{mapId}}" ng-if="isReady && isMapVisible" on-click="onClick()" zoom="{{map.zoom}}" center="{{map.center}}" disable-double-click-zoom="true" keyboard-shortcuts="false" styles="{{mapStyles}}" ng-style="css" draggable-cursor="pointer">\n        <marker position="{{ map.markerPosition }}"></marker>\n        <shape id="polyline" name="polygon" geodesic="true" clickable="false" ng-if="!detecting" stroke-color="#FF0000" stroke-opacity="1.0" stroke-weight="2" paths="{{ donutShapePaths }}">\n        </shape>\n    </ng-map>\n</div>\n\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/lookup-list/lookup-list-control.html','<div>\n  <div class="adp-cw-multi-select-dropdown"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/number-input/number-input-control.html','<div>\n  <div class="adp-cw-single-number"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/number-range/number-range-control.html','<div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-input adp-cw-input-left"></div>\n    <div class="adp-cw-input adp-cw-input-right"></div>\n  </div>\n  <div class="adp-cw-bar"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/number-slider/number-slider-control.html','<div>\n  <div class="adp-cw-discrete-label-collapsed" ng-if="showLabel">\n    <strong>{{controllerLabel}}</strong> {{valueLabel}}\n  </div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-input adp-cw-input-left"></div>\n  </div>\n  <div class="adp-cw-bar"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/reset-all/reset-all-control.html','<div>\n  <button ng-click="reset()" class="adp-action-b-primary">{{ buttonLabel }}</button>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/static-html/static-html-control.html','<div ng-bind-html="safeHtml"></div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/string-filter/string-filter-control.html','<div>\n  <div class="adp-cw-string-filter">\n    <div class="adp-cw-filter-menu"></div>\n    <div class="adp-cw-filter-input"></div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/switch/switch-control.html','<div>\n  <div class="adp-cw-switch"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/time-range/time-range-control.html','<div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-input adp-cw-input-left"></div>\n    <div class="adp-cw-input adp-cw-input-right"></div>\n  </div>\n  <div class="adp-cw-bar"></div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/timelapse-list/timelapse-list-control.html','<div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-timelapse-controls">\n      <div ng-click="stepBack()" title="Step back" ng-class="{\'adp-disabled\':!allowStepBack}"><i class="fa fa-step-backward"></i></div>\n      <div ng-click="play()" title="Play animation"><i class="fa" ng-class="{\'fa-play\':!isPlaying,\'fa-pause\':isPlaying}"></i></div>\n      <div ng-click="stepForward()" title="Step forward" ng-class="{\'adp-disabled\':!allowStepForward}"><i class="fa fa-step-forward"></i></div>\n    </div>\n    <div class="adp-cw-timelapse-values" ng-bind-html="displayString"></div>\n  </div>\n  <div class="adp-cw-list">\n    <div ng-repeat="item in items" class="adp-cw-list-item" ng-style="{flexBasis: (100 / columns) + \'%\'}">\n      <label>\n        <input type="checkbox" ng-click="toggleItem(item.value)" name="{{item.value}}">\n        <span ng-bind-html="item.safeHtmlLabel"></span>\n      </label>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('client-modules/adp-widgets/widgets/control-widget/controls/timelapse-ranges/timelapse-control.html','<div>\n  <div class="adp-cw-input-boxes">\n    <div class="adp-cw-timelapse-controls">\n      <div ng-click="stepBack()" title="Step back" ng-class="{\'adp-disabled\':!allowStepBack}"><i class="fa fa-step-backward"></i></div>\n      <div ng-click="play()" title="Play animation"><i class="fa" ng-class="{\'fa-play\':!isPlaying,\'fa-pause\':isPlaying}"></i></div>\n      <div ng-click="stepForward()" title="Step forward" ng-class="{\'adp-disabled\':!allowStepForward}"><i class="fa fa-step-forward"></i></div>\n    </div>\n    <div class="adp-cw-timelapse-values">{{displayString}}</div>\n  </div>\n  <div class="adp-cw-timelapse-bar-boundary">\n    <div class="adp-cw-timelapse-track-gray"></div>\n    <div class="adp-cw-timelapse-track-color">\n      <div class="adp-cw-track-color"></div>\n    </div>\n    <div class="adp-cw-timelapse-ball left">\n      <div class="adp-cw-ball"></div>\n    </div>\n    <div class="adp-cw-timelapse-ball right">\n      <div class="adp-cw-ball"></div>\n    </div>\n    <div class="adp-cw-timelapse-drag-handle">\n      <div class="adp-cw-drag"></div>\n    </div>\n  </div>\n</div>\n');}]);;;(function () {
  'use strict';

  angular
    .module('app')
    .config(httpConfig)
    .config(appConfig)
    .config(function($stateProvider) {
      $stateProvider.decorator('parent', function (internalStateObj, parentFn) {
        // This fn is called by StateBuilder each time a state is registered
        // The first arg is the internal state. Capture it and add an accessor to public state object.
        internalStateObj.self.$$state = function() { return internalStateObj; };

        // pass through to default .parent() function
        return parentFn(internalStateObj);
      });
    });

  /** @ngInject */
  function appConfig(
    $logProvider,
    $locationProvider,
    APP_CONFIG,
    $provide
  ) {
    $provide.decorator('$sniffer', function($delegate) {
      $delegate.history = !window.location.hash;
      return $delegate;
    });

    $logProvider.debugEnabled(APP_CONFIG.debug);
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('');
  }

  /** @ngInject */
  function httpConfig($httpProvider) {
    $httpProvider.interceptors.push('AdpHttpInterceptor');
    $httpProvider.defaults.withCredentials = true;
  }
})();
;;(function () {
  'use strict';

  angular.module('app')
    .run(setupUserData)
    .run(runBlock)
    .run(setupSocketIo)
    .run(handleReturnUrlForUnauthorizedUsers)
    .run(setupTimers)
    .run(initMainMenu);

  /** @ngInject */
  function setupUserData($rootScope) {
    var user = lsService.getUser();

    if (_.isNull(user)) {
      lsService.setGuestUserData();
      return;
    }

    $rootScope.avatar = user.avatar;
  }

  /** @ngInject */
  function initMainMenu(AdpMenuService) {
    _.defer(AdpMenuService.generateMenu);
  }

  /** @ngInject */
  function runBlock(
    AdpRouteGuardService,
    AdpSessionService,
    $transitions
  ) {
    $transitions
      .onSuccess(null, (transition) => {
        const toState = transition.to();
        AdpRouteGuardService.redirectStrategy(toState);
      });

    AdpSessionService.setAjaxAuthHeaders();
  }

  function setupSocketIo(AdpSocketIoService){
    AdpSocketIoService.doLogin();
  }

  function setupTimers(AdpSchemaService, AdpSessionHelper, AdpUserActivityHelper) {
    if (!lsService.isGuest()) {
      AdpSessionHelper.setTokenRefreshTimeout();
      AdpSessionHelper.setSessionRemainingTimeout();
      AdpUserActivityHelper.setUserActivityTracker();
    }
  }

  // todo: refactor
  function handleReturnUrlForUnauthorizedUsers(
    $urlService,
    $rootScope,
    $state,
    $timeout,
    $location,
    AdpSessionService
  ) {
    $rootScope.$on('$locationChangeStart', (event) => {
      const currentUrl = $location.path();
      const { sso } = $location.search();
      const isGuest = lsService.isGuest();

      const isSsoRedirect = sso && isGuest;
      if (isSsoRedirect) {
        event.preventDefault();
        AdpSessionService.handleSsoRedirect();
        return;
      }

      const stateToGo = _.find($state.get(), function(state) {
        const { url } = state.$$state();
        return url && url.exec(currentUrl);
      });

      const privatePage = _.get(stateToGo, 'data.redirectStrategy') === 'user';
      const { requireAuthentication } = window.adpAppStore.appInterface().app.auth;
      if (!requireAuthentication) {
        return;
      }
      if ((privatePage || !stateToGo) && lsService.isGuest()) {
        event.preventDefault();
        $state.go('auth.login', { returnUrl: getReturnUrl($location) });
        return;
      }
    });

    function getReturnUrl(location) {
      var returnUrl = encodeURIComponent(location.url());
      var isEmpty = returnUrl === '/' || returnUrl === '' || location.path === '/login';

      return isEmpty ? '' : returnUrl;
    }
  }
})();
;(function setDecExtremeKey() {
    const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjIzZmY4MDUxLWQzYTctNDdmZS05NTc5LWQ1ZTQwODQ4MzIxMyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.SbfJJVnm0T1GgACU3YdRTPkUBHxv14T9+0NDcv95a2J+JxZ1uq4BZ57SbH4Q0BHyFabPIz6Tg35PcymBL0mcxABIXM3mrj6Ke4/K47aohzrT7JoGzNSK6o0AT8A9OOhI6WBRkw==';
    DevExpress.config({licenseKey});
})();;;(function () {
  angular
    .module('app.adpCommon')
    .constant('ACTIONS', {
      CREATE: 'create',
      CLONE: 'clone',
      CLONE_DATASET: 'cloneDataSet',
      UPDATE: 'update',
      DELETE: 'delete',
      VIEW_DETAILS: 'viewDetails',
      VIEW: 'view',
    });
})();
;;(function () {
  'use strict';
  
  angular
    .module('app.adpDashboard')
    .directive('adpDashboardContent', adpDashboardContent);
  
  /** @ngInject */
  function adpDashboardContent (
    $compile,
    adpTemplateEngineService
  ) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        data: '='
      },
      transclude: true,
      replace: true,
      link: function (scope, element) {
        var parsedTemplate = adpTemplateEngineService.parseTemplate(
            scope.item.template,
            scope.item.parameters.color,
            scope.data
        );

        element.html(parsedTemplate);
        $compile(element.contents())(scope);
      }
    };
  }
})();
;;(function () {
  angular
    .module('app.adpDataGrid')
    .constant('GRID_FORMAT', {
      EMPTY_VALUE: '-',
      NOT_SET_FILTER_VALUE: '<not set>',
    });
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpLayout')
    .controller('LayoutController', LayoutController);

  /** @ngInject */
  function LayoutController($rootScope, AdpFullscreenService, $timeout) {
    var INTERFACE = window.adpAppStore.appInterface();
    var vm = this;
    vm.interface = INTERFACE;
    vm.header = INTERFACE.app.header;
    vm.footer = INTERFACE.app.footer;
    vm.copyrightText = $(`<div class="adp-copyright-text">${vm.footer.components.copyrightText}</div>`);
    vm.appTitle = vm.interface.app.title || '';

    $timeout(() => $('[data-footer-target="vm.footer.components.copyright"]').append(vm.copyrightText));

    vm.toggleFullScreen = function () {
      $rootScope.isFullscreen = !$rootScope.isFullscreen;
    };

    $rootScope.$watch(function () {
      return $rootScope.isFullscreen;
    }, function(fullscreenEnabled) {
      fullscreenEnabled ?
        AdpFullscreenService.requestFullscreen(document.documentElement) :
        AdpFullscreenService.exitFullscreen();
    });
  }
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .factory('AdpRecorderFactory', AdpRecorderFactory);

  function AdpRecorderFactory(AdpCodeLoadHelper, AdpNotificationService, $log) {
    return {mix};

    function mix($scope, $element, type) {
      $scope.isLoading = true;

      return AdpCodeLoadHelper.loadVendorGroup('videojs')
        .then(() => {
          $scope.readyToSave = false;
          $scope.type = type;

          const VIEWPORT_STRATEGIES = {
            'audio': createAudioNode,
            'video': createMovieNode,
            'image': createImageNode,
          };

          function createMovieNode() {
            return createVideoNode('adp-video-recorder');
          }

          function createImageNode() {
            return createVideoNode('adp-photo-recorder');
          }

          function createAudioNode() {
            const node = new Audio();
            node.id = 'player_' + $scope.$id;
            node.className = 'video-js vjs-default-skin';

            return node;
          }

          function createVideoNode(className) {
            const node = document.createElement('video');
            node.id = 'player_' + $scope.$id;
            node.className = 'video-js vjs-default-skin ' + className;

            return node;
          }

          $scope.init = function (defaults) {
            if (!$scope.DEFAULTS) {
              $scope.DEFAULTS = defaults;
            }

            $scope.setup();

            $scope.viewportNode = VIEWPORT_STRATEGIES[$scope.type]();
            $element[0]
              .querySelector('.adp-recorder-viewport')
              .appendChild($scope.viewportNode);

            $scope.player = videojs($scope.viewportNode.id, $scope.options);
            $scope.bindEvents();
          };

          $scope.setup = function () {
            $scope.options = _.merge($scope.DEFAULTS, $scope.options);
          };

          $scope.reInit = function () {
            destroyPlayer($scope);
            $scope.init();
          };

          $scope.bindEvents = function () {
            $scope.player.on('finishRecord', finishRecordHandler.bind(this, $scope));
            $scope.player.on('deviceError', deviceErrorHandler.bind(this, $scope));
            registerDestroyPlayerHandler($scope);
          };
        })
        .finally(()=>{
          $scope.isLoading = false;
        });

      function finishRecordHandler($scope) {
        $scope.resultFile = $scope.player.recordedData;
        $scope.$digest();
      }

      function deviceErrorHandler($scope) {
        if ($scope.player.deviceErrorCode.message === 'DevicesNotFoundError') {
          AdpNotificationService.notifyError('Recording device is busy by another application or browser tab.');
        }

        $log.debug('Device error:', $scope.player.deviceErrorCode);
      }

      function registerDestroyPlayerHandler($scope) {
        // WORKAROUND: register $destroy listener only once
        const fnName = 'bound ' + destroyPlayer.name;
        const listenerRegistered = _.findIndex($scope.$$listeners['$destroy'], function (fn) {
          return fn.name === fnName;
        });

        if (listenerRegistered < 0) {
          $scope.$$listeners['$destroy'].push(destroyPlayer.bind(this, $scope));
        }
      }

      const DESTROY_ENGINE_STRATEGIES = {
        'lamejs': function (engine, type) {
          closeAudioContext(engine, type);

          engine.engine.terminate();
          $log.debug('Worker terminated for ', type)
        },
        'recorder.js': function (engine, type) {
          closeAudioContext(engine, type);

          engine.engine.worker.terminate();
          $log.debug('Worker terminated for ', type)
        }
      };

      function destroyPlayer($scope) {
        const engine = $scope.player.record().engine;
        const engineType = getEngine($scope.player);

        if (engine && DESTROY_ENGINE_STRATEGIES[engineType]) {
          DESTROY_ENGINE_STRATEGIES[engineType](engine, engineType);
        }

        $scope.player.record().stopDevice();
        $scope.player.dispose();
        delete $scope.player;
        angular.element($scope.viewportNode).remove();
      }

      function getEngine(player) {
        return player.record().audioEngine;
      }

      function closeAudioContext(engine, engineType) {
        if (engine.audioContext.state === 'running') {
          engine.audioContext
            .close()
            .then(function () {
              $log.debug('Audio context closed for ', engineType)
            });
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .controller('AuthRootController', AuthRootController);

  /** @ngInject */
  function AuthRootController(
    APP_CONFIG,
  ) {
    const vm = this;
    vm.APP_CONFIG = APP_CONFIG;
  }
})();
;;(function () {
    'use strict';

    angular
        .module('app.adpAuth')
        .controller('LoginEnableTwoFactorController', LoginEnableTwoFactorController);

    /** @ngInject */
    function LoginEnableTwoFactorController(
        $state,
        AdpAuthSchemas,
        AdpSessionService
    ) {
        AdpSessionService.emptyCredentialsForward();

        const INTERFACE = window.adpAppStore.appInterface();
        const vm = this;
        const context = _.get($state, 'params.context') || {};
        const {credentials = {}, ssoData} = context;

        vm.authParams = INTERFACE.loginPage.parameters;
        vm.args = AdpAuthSchemas.loginEnableTwoFactorArgs();
        const login = ssoData ? ssoData.login : credentials.login;
        vm.args.row = { login }; // Login is used to generate MFA QR code
        vm.formOptions = {
            disableFullscreen: true,
            localActionsStrategy: {
                submit(args) {
                    return AdpSessionService.doLogin({...context, credentials: {...args.row, ...credentials}});
                }
            }
        };
    }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .controller('LoginTwoFactorController', LoginTwoFactorController);

  /** @ngInject */
  function LoginTwoFactorController(
    $state,
    AdpAuthSchemas,
    AdpSessionService
  ) {
    AdpSessionService.emptyCredentialsForward();

    const INTERFACE = window.adpAppStore.appInterface();
    const vm = this;
    const context = _.get($state, 'params.context') || {};
    const { credentials = {} } = context;

    vm.authParams = INTERFACE.loginPage.parameters;
    vm.showSignUp = INTERFACE.app.auth.enableRegistration;
    vm.showReset = INTERFACE.app.auth.enableUserPasswordReset;
    vm.args = AdpAuthSchemas.loginTwoFactorArgs();
    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit(args) {
          return AdpSessionService.doLogin({ ...context, credentials: { ...args.row, ...credentials } });
        }
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .controller('LoginUnverifiedEmailController', LoginUnverifiedEmailController);

  /** @ngInject */
  function LoginUnverifiedEmailController(
    $state,
    $interval,
    AdpModalService,
    AdpNotificationService,
    AdpSessionService,
    AdpSessionHelper
  ) {
    AdpSessionService.emptyCredentialsForward();

    const vm = this;
    let interval;
    let resendTimeout;
    const context = _.get($state, 'params.context') || {};
    const { emailConfirmationNextAttemptIn } = context;

    restartTimeoutTimer(emailConfirmationNextAttemptIn);

    vm.resendEmail = () => {
      AdpModalService.prompt({
        title: 'Re-send verification email',
        text: 'Please enter the email address you used during the registration',
        saveButtonText: 'Send'
      })
        .then(email => {
          if (email) {
            AdpSessionHelper.resendEmailVerification(email)
              .then(emailConfirmationNextAttemptIn => restartTimeoutTimer(emailConfirmationNextAttemptIn))
              .catch( err => AdpNotificationService.error( err.message || err ));
          }
        })
    }

    function restartTimeoutTimer(timeout) {
      $interval.cancel(interval);
      setResendTimeout(timeout);
      if (timeout > 0) {
        interval = $interval(intervalIteration, 1000);
      }
    }

    function intervalIteration() {
      if (resendTimeout < 1000) {
        restartTimeoutTimer(0);
      } else {
        setResendTimeout(resendTimeout - 1000);
      }
    }

    function setResendTimeout(timeout) {
      resendTimeout = timeout;
      vm.resendTimeoutString = resendTimeout > 0 ? dayjs(resendTimeout).format('mm:ss') : '';
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .controller('LoginVerifiedEmailConfirmAccountController', LoginVerifiedEmailConfirmAccountController);

  /** @ngInject */
  function LoginVerifiedEmailConfirmAccountController(
    $state,
    AdpNotificationService,
    AdpSessionHelper
  ) {
    const token = _.get($state, 'params.token');

    AdpSessionHelper.emailVerificationConfirmAccount(token)
      .then(message => AdpNotificationService.notifySuccess(message))
      .catch(err => AdpNotificationService.notifyError(err.message || err))
      .finally(() => $state.go('auth.login', $state.params))
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(
    AdpAuthSchemas,
    AdpSessionService,
    APP_CONFIG,
    $state
  ) {
    const INTERFACE = window.adpAppStore.appInterface();
    const vm = this;
    vm.args = AdpAuthSchemas.loginArgs();
    vm.authParams = _.get(INTERFACE, 'loginPage.parameters') || {};
    const appAuth = _.get(INTERFACE, 'app.auth') || {};
    vm.showSignUp = appAuth.enableRegistration;
    vm.showReset = appAuth.enableUserPasswordReset;
    vm.providers = appAuth.identityProviders || [];
    vm.hasProviders = !!vm.providers.length;

    vm.getSsoUrl = ({ idpId }) => {
      const returnUrl = $state.params.returnUrl;
      const hasReturnUrl = returnUrl && returnUrl !== '/';
      const returnUrlPart = hasReturnUrl ? '?returnUrl=' + encodeURIComponent(returnUrl) : ''
      return `${APP_CONFIG.apiUrl}/auth/sso/${idpId}${returnUrlPart}`;
    };

    vm.openSsoPopup = (provider) => {
      const width = 500;
      const height = 600;
      const top = (window.innerWidth - height) / 2;
      const left = (window.innerWidth - width) / 2;
      const url = vm.getSsoUrl(provider);
      window.open(url, "AdpSsoLogin", `popup=1,width=${width},height=${height},top=${top},left=${left}`);
    };

    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit(args) {
          return AdpSessionService.doLogin({ credentials: args.row });
        }
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .controller('PasswordChangeController', PasswordChangeController);

  /** @ngInject */
  function PasswordChangeController(
    AdpSessionService,
    AdpAuthSchemas,
    $state
  ) {
    AdpSessionService.emptyCredentialsForward();

    const vm = this;
    const INTERFACE = window.adpAppStore.appInterface();
    const { credentials = {} } = _.get($state, 'params.context') || {};

    vm.authParams = INTERFACE.loginPage.parameters;
    vm.args = AdpAuthSchemas.resetPasswordArgs();
    vm.daysPeriod = _.get($state, 'params.context.changePasswordRequireParams.daysToForceChange');
    vm.rememberLast = _.get($state, 'params.context.changePasswordRequireParams.lastPasswords');
    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit: function (args) {
          return AdpSessionService.doLogin({
            credentials: { newPassword: args.row.password, ...credentials }
          });
        }
      }
    };
  }
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpAuth')
    .controller('ForgotPasswordController', ForgotPasswordController)
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ForgotPasswordController(
    AdpAuthSchemas,
    AdpSessionService
  ) {
    var vm = this;
    var INTERFACE = window.adpAppStore.appInterface();
    vm.authParams = INTERFACE.loginPage.parameters;

    vm.args = AdpAuthSchemas.forgotPasswordArgs();
    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit: function (args) {
          return AdpSessionService.forgot(args.row);
        },
      },
    };
  }

  /** @ngInject */
  function ResetPasswordController(
    AdpSessionService,
    AdpAuthSchemas,
    AdpNotificationService,
    ResponseError,
    $state
) {
    var vm = this;
    var INTERFACE = window.adpAppStore.appInterface();
    vm.authParams = INTERFACE.loginPage.parameters;
    vm.args = AdpAuthSchemas.resetPasswordArgs();
    vm.isReset = false;

    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit: function(args) {
          return AdpSessionService
            .reset(args.row)
            .then(function (res) {
              if (!res.data.success) {
                throw new ResponseError(res.data.message);
              }

              vm.isReset = true;
              AdpNotificationService.notifySuccess("Password has been reset, please sign in using your new password");
              return res;
            });
        }
      },
    };

    vm.goLogin = function(){
      $state.go('auth.login');
    }
  }
})();
;;(function () {
    "use strict";

    angular
        .module('app.adpAuth')
        .controller('RegisterSsoUserController', RegisterSsoUserController);

    /** @ngInject */
    function RegisterSsoUserController(
        AdpUserService,
        $state,
        AdpNotificationService,
        AdpSessionService,
        AdpAuthSchemas
    ) {
        const vm = this;
        const INTERFACE = window.adpAppStore.appInterface();
        const context = _.get($state, 'params.context') || {};
        const { ssoData } = context;
        if (!ssoData) {
            return $state.go('auth.login', $state.params);
        }
        const { login } = context.ssoData;
        vm.args = AdpAuthSchemas.registrationSsoArgs();
        vm.authParams = INTERFACE.loginPage.parameters;
        vm.args.row = {
            login,
            email: login,
        };
        vm.formOptions = {
            disableFullscreen: true,
            localActionsStrategy: {
                submit: function (args) {
                    _.set(context, 'ssoData.user', args.row);
                    return AdpSessionService.login(context);
                },
            },
        };
    }
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpAuth')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController(
    AdpUserService,
    $state,
    AdpNotificationService,
    AdpAuthSchemas
  ) {
    var vm = this;
    var INTERFACE = window.adpAppStore.appInterface();
    vm.args = AdpAuthSchemas.registrationArgs();

    vm.authParams = INTERFACE.loginPage.parameters;
    vm.showLogin = INTERFACE.app.auth.enableAuthentication;

    vm.formOptions = {
      disableFullscreen: true,
      localActionsStrategy: {
        submit: function (args) {
          return AdpUserService.create(args.row)
            .then(function (response) {
              AdpNotificationService.notifySuccess(response.data.message);
              return $state.go('auth.login');
            });
        },
      },
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .component('adpInactivityLogoutDialogModal', {
      template: [
        '<div class="modal-header">',
        '  <h3 class="modal-title">You have been inactive for a while</h3>',
        '</div>',
        '<div class="modal-body">',
        '<p>For your security, we will automatically sign you out <strong>{{vm.timeTicker}}</strong></p>',
        '<p>Please click "Sign out" to sign out immediately or "Stay signed in" to continue your session.</p>',
        '</div>',
        '<div class="modal-footer">',
        '  <button',
        '    class="adp-action-b-secondary"',
        '    type="button"',
        '    ng-click="vm.logout()">Sign out',
        '  </button>',
        '  <button',
        '          class="adp-action-b-primary"',
        '          type="button"',
        '          ng-click="vm.prolong()">Stay signed in',
        '  </button>',
        '</div>'].join(''),
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: AdpInactivityLogoutDialogModalController,
      controllerAs: 'vm'
    });

  /** @ngInject */
  function AdpInactivityLogoutDialogModalController(
    $timeout
  ) {
    var vm = this;
    var timeoutAt;
    var timer

    vm.$onInit = function () {
      timeoutAt = (new Date).getTime() + vm.resolve.options.timeout;
      updateTimer();
    };

    vm.$onDestroy = clearTimeout;

    vm.prolong = function () {
      vm.close({$value: { prolong: true }});
    };

    vm.logout = function () {
      vm.close({$value: { logout: true }});
    };

    function updateTimer() {
      var leftSeconds = (timeoutAt - (new Date).getTime()) / 1000;

      if (leftSeconds > 1) {
        var mins = format(leftSeconds / 60);
        var secs = format(leftSeconds % 60);

        vm.timeTicker = 'in ' + mins + ':' + secs;

        setTimeout();
      } else {
        vm.timeTicker = 'right now';
      }
    }

    function setTimeout() {
      timer = $timeout(function () {
        updateTimer();
      }, 1000);
    }

    function clearTimeout() {
      $timeout.cancel(timer);
    }

    function format(timeFraction) {
      return ('00' + Math.floor(timeFraction)).substr(-2);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .directive('authIntro', authIntro);

  function authIntro(
    $transitions,
    APP_CONFIG,
    $compile
  ) {
    return {
      restrict: 'E',
      link(scope, element) {
        const INTERFACE = window.adpAppStore.appInterface();
        const ejsTemplate = INTERFACE?.loginPage?.intro?.template;
        scope.interface = INTERFACE;
        scope.APP_CONFIG = APP_CONFIG;

        const renderTemplate = () => {
          const html = ejs.render(ejsTemplate);
          const node = $compile(html)(scope);
          element.html(node);
        }
        renderTemplate();

        $transitions.onEnter({ to: 'auth.**' }, (trans) => {
          trans.onSuccess({}, renderTemplate);
        })
      }
    }
  }

})();;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .factory('AdpSessionHelper', AdpSessionHelper);

  var sessionTimeout = null;
  var tokenRefreshTimeout = null;
  var timerDialogInstance = null;

  /** @ngInject */
  function AdpSessionHelper(
    $http,
    $state,
    $timeout,
    $interval,
    $injector,
    AdpModalService,
    AdpUserActivityHelper,
    APP_CONFIG
  ) {
    function setSessionRemainingTimeout() {
      var isCheckSessionStatusRequired = APP_CONFIG.isInactivityLogoutEnabled;

      if (isCheckSessionStatusRequired) {
        _checkSessionExpire();
      }
    }

    function _createSessionTimeout(timerMs) {
      _cancelSessionTimeout();
      sessionTimeout = $timeout(_checkSessionExpire, timerMs);
    }

    function _cancelSessionTimeout() {
      $timeout.cancel(sessionTimeout);
    }

    function _checkSessionExpire() {
      _doSessionCheck().then(_onSessionCheck).catch(doLogout);
    }

    function _onSessionCheck(expiresIn) {
      if (!_.isNumber(expiresIn)) {
        return;
      }
      const isGuarded = isCurrentPageUnderAuthGuard();
      if (!isGuarded) {
        _createSessionTimeout(300000); // in theory user may move to guarded page once, so we need to check session, finnaly
        return;
      }

      if (isGuarded && expiresIn < _getHowLongBeforeExpireWeShowTimer()) {
        _doOpenTimerDialog(expiresIn);
        _createSessionTimeout(APP_CONFIG.inactivityLogoutPollingInterval);
        AdpUserActivityHelper.resetUserActivityTimer(true);
      } else {
        _doCloseTimerDialog();
        _createSessionTimeout(Math.max(0, expiresIn - _getHowLongBeforeExpireWeShowTimer() + 1000));
        AdpUserActivityHelper.resetUserActivityTimer();
      }
    }

    function _doSessionCheck() {
      var url = APP_CONFIG.apiUrl + '/session-status';

      return $http.post(url)
                  .then(_transformSessionEndResponse)
                  .catch(doLogout);
    }

    function _transformSessionEndResponse(data) {
      if (data.data.success) {
        var timeLeft = data.data.data.sessionEndMs;

        if (timeLeft > 0) {
          return timeLeft;
        }
      }

      throw new Error('No session found. Logout.');
    }

    function doProlongSession(lastActivityIn) {
      var url = APP_CONFIG.apiUrl + '/prolong-session';

      return $http.post(url, {data: {lastActivityIn: lastActivityIn}})
                  .then(_transformSessionEndResponse)
                  .then(_onSessionCheck)
                  .catch(doLogout);
    }

    function _doOpenTimerDialog(sessionEndsAfterMs) {
      if (timerDialogInstance) {
        return;
      }

      timerDialogInstance = AdpModalService
        .createModal(
          'adpInactivityLogoutDialogModal',
          {
            timeout: sessionEndsAfterMs,
          });

      timerDialogInstance
        .result
        .then(function (result) {
          if (result) {
            if (result.prolong) {
              return doProlongSession(0);
            }
            if (result.logout) {
              doLogout();
            }
          }
        })
        .catch(_.noop)
        .finally(function () {
          timerDialogInstance = null;
        });
    }

    function _doCloseTimerDialog() {
      if (timerDialogInstance) {
        timerDialogInstance.close();
      }
    }

    function setTokenRefreshTimeout(immediate, isLoud) {
      _cancelTokenRefreshTimeout();

      if (immediate) {
        return _tokenRefresh(isLoud);
      }
      var timeout;

      try {
        timeout = new Date(lsService.getTokenExpire()).getTime() - new Date().getTime();
      } catch (e) {
        timeout = 0;
      }

      if (timeout > APP_CONFIG.jwtAccessTokenRefreshBeforeExpire) {
        timeout -= APP_CONFIG.jwtAccessTokenRefreshBeforeExpire;
      } else {
        timeout /= 2;
      }

      timeout = Math.min(timeout, 2000000000);
      tokenRefreshTimeout = $timeout(_tokenRefresh, timeout);

      return Promise.resolve();
    }

    function _cancelTokenRefreshTimeout() {
      $timeout.cancel(tokenRefreshTimeout);
    }

    function _tokenRefresh(isLoud) {
      var url = APP_CONFIG.apiUrl + '/refresh-token' + (isLoud ? '' : '?silent=true');

      return $http.post(url)
                  .then(function (data) {
                    if (data.data.success) {
                      _tokenUpdate(data);
                    }
                  })
                  .catch(doLogout);
    }

    function _tokenUpdate(data) {
      var updatedUserData = {
        token: data.data.token,
        expiresIn: data.data.expiresIn,
        user: lsService.getUser()
      }

      lsService.setUserData(updatedUserData);
      setTokenRefreshTimeout();
    }

    function doLogout() {
      var AdpSessionService = $injector.get('AdpSessionService'); // avoiding circular dependency
      AdpSessionService.doLogout();
    }

    function cancelAllTimers() {
      _cancelSessionTimeout();
      _cancelTokenRefreshTimeout();
    }

    function _getHowLongBeforeExpireWeShowTimer() {
      return APP_CONFIG.inactivityLogoutNotificationAppearsFromSessionEnd;
    }

    function isCurrentPageUnderAuthGuard() {
      const strategy = _.get($state, 'current.data.redirectStrategy');

      return strategy === 'user';
    }

    function resendEmailVerification(email) {
      const url = APP_CONFIG.apiUrl + '/account/send-email-confirmation';
      const body = { email }

      return $http.post(url, body)
        .then(_handleServerError)
        .then(({ emailConfirmationNextAttemptIn }) => emailConfirmationNextAttemptIn)
    }

    function emailVerificationConfirmAccount(token) {
      const url = APP_CONFIG.apiUrl + '/account/confirm';
      const body = { token }

      return $http.post(url, body)
        .then(_handleServerError)
        .then(({ message }) => message)
    }

    function _handleServerError(result) {
      const { success, message, ...data } = result.data;

      if (!success) {
        throw new Error(message);
      }

      return { message, ...data };
    }

    return {
      setTokenRefreshTimeout,
      setSessionRemainingTimeout,
      cancelAllTimers,
      doLogout,
      doProlongSession,
      isCurrentPageUnderAuthGuard,
      resendEmailVerification,
      emailVerificationConfirmAccount,
    };
  }
})();
;;(function () {
  'use strict';

  var LS_KEY_NAME = 'ADP_LAST_ACTIVITY';
  var browserTabUid = Math.round(Math.random() * 1000000);

  angular
    .module('app.adpAuth')
    .factory('AdpUserActivityHelper', AdpUserActivityHelper);

  /** @ngInject */
  function AdpUserActivityHelper(
    $http,
    $timeout,
    $interval,
    $injector,
    APP_CONFIG
  ) {
    var isInactivityLogoutEnabled = APP_CONFIG.isInactivityLogoutEnabled;
    var pingIntervalTime = APP_CONFIG.inactivityLogoutFePingInterval;
    var lsUpdateIntervalTime = Math.min(pingIntervalTime * 3 / 4, 60000);
    var lastActivity = _getCurrentSec();
    var pingInterval = null;
    var lsUpdateInterval = null;
    var recordUserActivity = _.throttle(function () {
      lastActivity = _getCurrentSec();
    }, 1000);

    return {
      resetUserActivityTimer: resetUserActivityTimer,
      setUserActivityTracker: setUserActivityTracker,
    };

    function _cancelIntervals() {
      $interval.cancel(pingInterval);
      $interval.cancel(lsUpdateInterval);
    }

    function resetUserActivityTimer(skipNewTimer) {
      _cancelIntervals();
      if (!isInactivityLogoutEnabled) {
        return;
      }

      if (skipNewTimer !== true) {
        pingInterval = $interval(_pingUserActivity, pingIntervalTime);
        lsUpdateInterval = $interval(_lsUpdate, lsUpdateIntervalTime);
      }
    }

    function _pingUserActivity() {
      var lsData = _getLsData();
      var now = Date.now();
      var isThisTabLatest = lsData.tabId === browserTabUid;
      var isLatestTabSeemsClosed = lsData.lastActivity > lastActivity && now - lsData.time > pingIntervalTime;

      if (isThisTabLatest || isLatestTabSeemsClosed) {
        if (isLatestTabSeemsClosed) {
          lastActivity = lsData.lastActivity;
        }
        var secAgo = _getCurrentSec() - lastActivity;
        var AdpSessionHelper = $injector.get('AdpSessionHelper'); // Avoiding circular dependency

        AdpSessionHelper.doProlongSession(secAgo);
        _lsUpdate();
      }
    }

    function _lsUpdate() {
      var lsData = _getLsData();

      if (lsData.lastActivity > lastActivity) { // Am not most active tab
        return;
      }

      var data = {
        tabId: browserTabUid,
        time: Date.now(),
        lastActivity: lastActivity,
      };

      localStorage.setItem(LS_KEY_NAME, JSON.stringify(data));
    }

    function _getLsData() {
      var lsData = {};

      try {
        lsData = JSON.parse(localStorage.getItem(LS_KEY_NAME));
      } catch (e) {
      }

      return _.defaults(lsData, {time: 0, lastActivity: 0});
    }

    function setUserActivityTracker(doStart) {
      if (doStart === false) {
        $(document).off('mousemove', recordUserActivity);
        $(document).off('keydown', recordUserActivity);
      } else {
        if (!isInactivityLogoutEnabled) {
          return;
        }
        $(document).on('mousemove', recordUserActivity);
        $(document).on('keydown', recordUserActivity);
      }
    }

    function _getCurrentSec() {
      return Math.floor(Date.now() / 1000);
    }
  }
})();
;(function () {
  "use strict";

  angular.module("app.adpAuth").factory("AdpSessionService", AdpSessionService);

  /** @ngInject */
  function AdpSessionService(
    $http,
    $timeout,
    $cookies,
    APP_CONFIG,
    $state,
    $location,
    AdpNotificationService,
    AdpAppModel,
    AdpSocketIoService,
    AdpMenuService,
    AdpSessionHelper,
    AdpUserActivityHelper,
    ResponseError,
    $rootScope,
    $uibModal
  ) {
    return {
      doLogin,
      doLogout,
      forgot,
      reset,
      handleSsoRedirect,
      handleUnauthorized,
      setAuthHeaders,
      setAjaxAuthHeaders,
      getAuthHeaders,
      emptyCredentialsForward
    };

    function doLogin(loginContext = {}) {
      const {ssoData} = loginContext;
      let endpoint;
      let loginData;
      if (ssoData) {
        endpoint = `${APP_CONFIG.apiUrl}/login/sso`;
        loginData = _.get(loginContext, 'ssoData.user', {});
      } else {
        endpoint = `${APP_CONFIG.apiUrl}/login`;
        loginData = loginContext.credentials || {};
      }
      return $http.post(endpoint, loginData).then(userData => loginPipeline(userData, loginContext));
    }

    function handleSsoRedirect() {
      const { sso, message, providerName, login, isNewUserString } = $location.search();
      const isNewUser = isNewUserString === "true";

      if (sso === 'false') {
        AdpNotificationService.notifyError(message, 'Single Sign-On Error');
        return $state.go('auth.login', $state.params);
      }

      const context = {ssoData: {providerName, login}};
      if (isNewUser) {
        return $state.go('auth.register-sso-user', {...$state.params, context});
      }

      return doLogin(context);
    }

    function loginPipeline(userData, loginContext) {
      const context = createLoginContext(userData, loginContext);
      return Promise.resolve(checkEmailVerificationRequirement(context))
          .then(checkEnableTwoFactorRequirement)
          .then(checkPasswordChangeRequirement)
          .then(checkTwoFactorRequirement)
          .then(showLastLoginModal)
          .then(setupAppForUser)
          .then(AdpSocketIoService.doLogin)
          .catch((err) => {
            if (_.get(err, 'data.twoFactorFailed')) {
              return $state.go('auth.login');
            }
            if (err.xhrStatus === 'error') {
              throw new ResponseError(
                  'Unable to connect to the server. Please try again later.'
              );
            }
          });
    }

    function createLoginContext(userData, initialContext) {
      const { credentials, ssoData } = initialContext;
      const paramSource = userData.data || {};
      const {
        emailConfirmationRequired,
        emailConfirmationNextAttemptIn,
        twoFactorEnablingRequired,
        changePasswordRequired,
        changePasswordSuccess,
        changePasswordRequireParams,
        twoFactorTokenRequired,
        data: loginData,
        message
      } = paramSource;

      return {
        emailConfirmationRequired,
        emailConfirmationNextAttemptIn,
        twoFactorEnablingRequired,
        changePasswordRequired,
        changePasswordSuccess,
        changePasswordRequireParams,
        twoFactorTokenRequired,
        credentials,
        loginData,
        message,
        ssoData
      };
    }

    function checkEmailVerificationRequirement(context) {
      const { emailConfirmationRequired } = context

      if (emailConfirmationRequired) {
        return $state.go('auth.unverified-email', { ...$state.params, context });
      }

      return context;
    }

    function checkEnableTwoFactorRequirement(context) {
      const { twoFactorEnablingRequired } = context

      if (twoFactorEnablingRequired) {
        return $state.go('auth.enable-two-factor', { ...$state.params, context });
      }

      return context;
    }

    function checkPasswordChangeRequirement(context) {
      const { changePasswordRequired, changePasswordSuccess } = context;

      if (changePasswordRequired) {
        if (changePasswordSuccess === false) {
          const { message } = context;
          message && AdpNotificationService.notifyError(message, 'Password change error');
        }

        return $state.go('auth.password-change', { ...$state.params, context });
      }

      if (changePasswordSuccess) {
        AdpNotificationService.notifySuccess('Password has been changed successfully');
      }

      return context;
    }

    function checkTwoFactorRequirement(context) {
      const { twoFactorTokenRequired } = context;

      if (twoFactorTokenRequired) {
        return $state.go('auth.login-two-factor', { ...$state.params, context });
      }

      return context;
    }

    function setupAppForUser(context) {
      const { loginData } = context;

      lsService.setUserData(loginData);
      $rootScope.avatar = loginData.user.avatar;

      AdpSessionHelper.setTokenRefreshTimeout();
      AdpSessionHelper.setSessionRemainingTimeout();
      AdpUserActivityHelper.setUserActivityTracker();

      return AdpAppModel.getAppModel(loginData)
        .then(AdpMenuService.generateMenu)
        .then(afterLoginRedirect);
    }

    function doLogout() {
      lsService.removeUserData();
      lsService.setGuestUserData();

      AdpSocketIoService.socketLogout();
      AdpSessionHelper.cancelAllTimers();
      AdpUserActivityHelper.setUserActivityTracker(false);

      $http.post(`${APP_CONFIG.apiUrl}/logout`);
      // Because this is just notification for fellow tabs, there is no reason to process any results...

      var appInterface = window.adpAppStore.appInterface().app;
      const isGuarded = AdpSessionHelper.isCurrentPageUnderAuthGuard();

      return AdpAppModel.getAppModel()
        .then(function () {
          if (isGuarded && appInterface.auth.requireAuthentication) {
            return forceLoginPage();
          }
          $state.go($state.current.name, {}, { reload: 'app' });
        })
        .catch(forceLoginPage)
        .finally(function () {
          var hideNotificationsTimeout = appInterface.hideErrorMessagesAfterLogoutIn;

          if (hideNotificationsTimeout) {
            $timeout(AdpNotificationService.closeAll, hideNotificationsTimeout);
          }
        });

      function forceLoginPage() {
        var params =
          $location.path() === '/login'
            ? {}
            : { returnUrl: encodeURIComponent($location.url()) };

        return $state.go('auth.login', params);
      }
    }

    function forgot(params) {
      return $http
        .post(APP_CONFIG.apiUrl + '/forgot', params)
        .then(function (res) {
          if (!res.data.success) {
            throw new ResponseError(res.data.message);
          }

          const message = `Reset link has been sent to '${params.email}'. Please follow the instructions in the message to reset your password. Make sure to check your spam folder if you don’t see the email.`;
          AdpNotificationService.notifySuccess(message);
          return res;
        });
    }

    function reset(params) {
      return $http.post(APP_CONFIG.apiUrl + '/reset', {
        password: params.password,
        token: $state.params.token,
      });
    }

    function handleUnauthorized() {
      if (lsService.isGuest()) {
        return Promise.resolve();
      }

      return doLogout()
        .then(function () {
          var message = getSessionExpMessage();
          AdpNotificationService.notifyError(message);
        });
    }

    function getSessionExpMessage() {
      var guestMessage =
        'Session has expired. You may proceed as a guest or log in again.';
      var defaultMessage = 'Session has expired. Please login again';
      var authSetting = window.adpAppStore.appInterface().app.auth;

      return authSetting.requireAuthentication ? defaultMessage : guestMessage;
    }

    function afterLoginRedirect() {
      var targetUrl = window.adpAppStore.defaultState().url;
      var returnUrl = $state.params.returnUrl || $location.search().returnUrl;

      if (returnUrl) {
        targetUrl = decodeURIComponent(returnUrl);
      }

      return $location.url(targetUrl);
    }

    function setAuthHeaders(config) {
      config['headers']['Authorization'] = getAuthHeaders();
    }

    function setAjaxAuthHeaders() {
      $.ajaxPrefilter(function (options) {
        if (!options.beforeSend) {
          options.beforeSend = function (xhr) {
            xhr.setRequestHeader('Authorization', getAuthHeaders());
          };
        }
      });
    }

    function getAuthHeaders() {
      return 'JWT ' + lsService.getToken();
    }

    function showLastLoginModal(context) {
      const { lastLoginData } = _.get(context, 'loginData.user') || {};
      if (!lastLoginData) {
        return context;
      }

      return $uibModal.open({
        backdrop: 'static',
        size: 'md',
        component: 'adpLastLoginDataModal',
        keyboard: false,
        resolve: {
          lastLoginData: () => lastLoginData
        }
      })
        .result
        .then(() => context);
    }

    function emptyCredentialsForward() {
      const ssoData = _.get($state, 'params.context.ssoData');
      if (ssoData) {
        return;
      }

      const login = _.get($state, 'params.context.credentials.login');
      const password = _.get($state, 'params.context.credentials.password');
      if (!login || !password) {
        $state.go('auth.login', $state.params);
      }
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpAuth')
    .factory('AdpUserService', AdpUserService);

  /** @ngInject */
  function AdpUserService(
    $http,
    APP_CONFIG
  ) {
    return {
      create: create
    };

    function create(user) {
      return $http.post(APP_CONFIG.apiUrl + '/signup', user);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .directive('ngTranscludeReplace', ngTranscludeReplace);

  function ngTranscludeReplace($log) {
    return {
      terminal: true,
      restrict: 'EA',
      link: function ($scope, $element, $attr, ctrl, transclude) {
        if (!transclude) {
          $log.error('orphan',
            'Illegal use of ngTranscludeReplace directive in the template! ' +
            'No parent directive that requires a transclusion found. ');
          return;
        }

        transclude(function (clone) {
          if (clone.length) {
            $element.replaceWith(clone);
          } else {
            $element.remove();
          }
        }, null, $attr.ngTranscludeReplace);
      }
    };
  }
})();
;;(function () {
  angular
    .module('app.adpCommon')
    .filter('adpBytes', function() {
      return function(bytes, precision = 2) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';

        const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        const number = Math.floor(Math.log(bytes) / Math.log(1024));

        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
      }
    });
})();;;(function () {
  angular
    .module('app.adpCommon')
    .factory('AdpCodeLoadHelper', AdpCodeLoadHelper);

  function AdpCodeLoadHelper(ResponseError) {
    const groupLoadPromises = {};

    return {
      loadVendorGroup,
      loadScript,
      loadCss,
      loadVendorsCode,
      awaitFor,
    }

    function loadVendorGroup(groupName) {
      const vendorGroup = _.get(window, ['adpDynamicVendorsMap', groupName]);
      if (!vendorGroup) {
        throw new Error(`No vendor group '${groupName}' found.`);
      }

      const {js, css, probeCode} = vendorGroup;
      const probeFn = probeCode ? new Function(`return ${probeCode}`) : () => true;

      if (probeFn()) { // Already loaded - no need to try again.
        return Promise.resolve();
      }

      const currentProcess = groupLoadPromises[groupName];
      if (currentProcess) { // code loading initiated before. Just wait for it.
        return currentProcess;
      }

      const codeLoadingPromise = js ? loadVendorsCode([{
        url: js,
        probe: probeFn,
        sync: true,
      }]) : Promise.resolve();

      if (css) {
        loadCss(css);
      }
      groupLoadPromises[groupName] = codeLoadingPromise;

      codeLoadingPromise.then(() => {
        delete groupLoadPromises[groupName];
      });

      return codeLoadingPromise;
    }

    function loadScript(src) {
      return new Promise((resolve, reject) => {
        $.getScript(src)
          .done(resolve)
          .fail(() => {
            reject(new ResponseError(`Failed to load ${src}`));
          });
      });
    }

    function loadCss(src) {
      const linkTag = document.createElement('link');
      linkTag.setAttribute('rel', 'stylesheet');
      linkTag.setAttribute('type', 'text/css');
      linkTag.setAttribute('href', src);
      document.getElementsByTagName('head')[0].appendChild(linkTag);
    }

    function loadVendorsCode(spec) {
      const loadQueue = groupSpecsIntoLoadAtomsQueue(spec);

      return new Promise((resolveAfterAll) => {
        const loadVendors = () => {
          _.each(loadQueue, (loadAtom) => {
            const {isLoaded, load, probe, loadStarted, name} = loadAtom;
            if (!isLoaded) {
              const probeResult = !probe || probe();
              if (probeResult) {
                loadAtom.isLoaded = probeResult;
                return;
              }
              if (!loadStarted) {
                load();
                loadAtom.loadStarted = Date.now();
              } else {
                if (Date.now() - loadAtom.loadStarted > 15000) {
                  console.error(`${name} loading failure(takes too long)`);
                  loadAtom.isLoaded = true;
                }
              }
              return false; // Cancel cycle on this iteration
            }
          });

          const waitForSpec = _.find(loadQueue, (loadAtom) => !loadAtom.isLoaded);
          if (waitForSpec) {
            setTimeout(loadVendors, 150);
            return;
          }
          resolveAfterAll();
        };
        loadVendors();
      });

      function groupSpecsIntoLoadAtomsQueue(spec) {
        const groups = [];
        let asyncGroup = [];
        spec.forEach(lib => {
          if (lib.sync) {
            if (!_.isEmpty(asyncGroup)) {
              groups.push(transformAsyncGroupIntoLoadAtom(asyncGroup));
              asyncGroup = [];
            }
            groups.push(transformSyncLoadIntoLoadAtom(lib));
          } else {
            asyncGroup.push(lib);
          }
        });

        if (!_.isEmpty(asyncGroup)) {
          groups.push(transformAsyncGroupIntoLoadAtom(asyncGroup));
        }

        return groups;

        function transformAsyncGroupIntoLoadAtom(asyncGroup) {
          const group = {
            isLoaded: false,
            name: _.map(asyncGroup, ({url}) => _.last(url.split("/")))
              .join(" & "),
            probe: () => _.every(asyncGroup, ({probe}) => !probe || probe()),
            load: () => {
              if (group.loadingStarted) {
                return Promise.resolve();
              }
              group.loadingStarted = Date.now();

              return Promise.all(_.map(asyncGroup, ({url}) => loadScript(url)))

            }
          };

          return group;
        }

        function transformSyncLoadIntoLoadAtom(lib) {
          const load = () => loadScript(lib.url);
          return {
            isLoaded: false,
            name: _.last(lib.url.split("/")),
            load,
            ...lib
          };
        }
      }
    }

    function awaitFor(probeFn, interval = 150) {
      if (!probeFn) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const checkProbe = () => {
          const probeResult = probeFn();
          if (!probeResult) {
            setTimeout(checkProbe, interval);
            return;
          }
          resolve(probeResult);
        };
        checkProbe();
      });
    }
  }
})();;;(function () {
  angular
    .module("app.adpCommon")
    .factory("AdpFileDownloader", AdpFileDownloader);

  function AdpFileDownloader(
    $timeout
  ) {
    return function (params) {
      var a = document.createElement("a");
      var type = params.mimeType || "text/plain";
      var fileName = params.fileName || ("downloaded_" + (new Date()).getTime());
      var blob = new Blob([params.buffer], {type: type});

      return new Promise(
        function (resolve) {
          if (window.navigator.msSaveOrOpenBlob) {     // IE11
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var url = window.URL.createObjectURL(blob);
            document.body.appendChild(a);
            a.style.display = "none";
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            $timeout(function () { //Just to make sure no special effects occurs
              document.body.removeChild(a);
            }, 2000);
          }
          resolve();
        });
    }
  }
})();
;;(function () {
  angular
    .module('app.adpCommon')
    .factory('AdpIconsHelper', AdpIconsHelper);

  function AdpIconsHelper(APP_CONFIG, AdpUnifiedArgs) {
    return {
      getIconHtml: getIconHtml
    }

    function getIconHtml(icon, _options) {
      var classNames = ['adp-icon'];
      var options = _options || {};
      var $el = $('<i>');

      if (icon.type === 'class') {
        classNames.push('adp-icon-base');
        classNames.push(icon.link);
      } else if (icon.type === 'image' || icon.type === 'image100height') {
        var link = icon.link;

        if (link.substr(0, 4) !== 'http') {
          link = APP_CONFIG.resourceUrl + link;
        }

        if (icon.type === 'image100height') {
          classNames.push('adp-icon-image');
          $el = $(`<img src="${link}">`);
        } else {
          $el.css({'backgroundImage': 'url(' + link + ')'});
        }
        classNames.push('adp-icon-base');
      } else if (icon.type === 'action') {
        var helperAction = _.get(appModelHelpers, 'LabelRenderers.' + icon.link);

        if (helperAction) {
          var context = AdpUnifiedArgs.getHelperParamsWithConfig({
            path: '',
            formData: null,
            action: 'icon',
            schema: icon,
            fieldSchema: icon,
            options: options,
          });

          helperAction.call(context).then(function (link) {
            $el.css({backgroundImage: 'url(' + link + ')'});
          });

          classNames.push('adp-icon-base');
        }
      } else if (icon.type === 'dx') {
        classNames.push('dx-icon-' + icon.link);
      } else if (icon.type === 'font-awesome-brands') {
        classNames.push('fab fa-' + icon.link);
      } else {
        classNames.push('fa fa-fw fa-' + icon.link);
      }

      if (options.className) {
        classNames.push(options.className);
      }

      if (options.hint) {
        $el.attr('title', options.hint);
      }

      $el.addClass(classNames);

      return $el;
    }
  }
})();
;;(function () {
  angular
    .module("app.adpCommon")
    .factory("AdpTime", AdpTime);

  function AdpTime() {
    return {
      guessTimeZone: guessTimeZone,
    }

    function guessTimeZone() {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        return '';
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpUnifiedArgs', AdpUnifiedArgs);

  function AdpUnifiedArgs(
    AdpPath,
    APP_CONFIG
  ) {
    /**
     *
     * @param options
     * @param options.path
     * @param options.formData
     * @param options.action
     * @param options.schema
     *
     * @return unified args
     */
    function getHelperParams(options) {
      var schemaPath = AdpPath.schemaPath(options.path, options.schema);

      var args = {
        data: _.get(options.formData, options.path, null),
        row: options.formData,
        fieldSchema: _.get(options.schema.fields, schemaPath, options.schema),
        modelSchema: options.schema,
        appSchema: window.adpAppStore.appModel(),
        action: options.action,

        path: options.path,
        schemaPath: schemaPath,
        index: _getItemIndex(options.path),
        indexes: _getItemIndexes(options.path),
      };

      var parentPath = AdpPath.parent(args);
      args.parentData = _.get(args.row, parentPath) || args.row;

      return args;
    }

    /**
     *
     * @param options
     * @param options.path
     * @param options.formData
     * @param options.action
     * @param options.schema
     *
     * @return unified args
     */
    function getHelperParamsWithConfig(options) {
      var params = getHelperParams(options);
      params.config = APP_CONFIG;

      return params;
    }

    /**
     *
     * @param args - unified args
     * @param fieldName
     * @param [index]
     * @return {{path, appSchema: *, data: *, indexes, parentData, schemaPath, fieldSchema: *, action, index, row: *, modelSchema: *}}
     */
    function next(args, fieldName, index) {
      var fn = _.isNil(args.config) ? getHelperParams : getHelperParamsWithConfig;

      var nextArgs = fn({
        path: AdpPath.next(args.path, fieldName, index),
        formData: args.row,
        action: args.action,
        schema: args.modelSchema,
      });

      if (args.customData) {
        nextArgs.customData = args.customData;
      }

      return nextArgs;
    }

    function _getItemIndexes(path) {
      var regex = /\[(\d+)\]/g;
      var matches = [];
      var match = regex.exec(path);

      while (!_.isNull(match)) {
        matches.push(match[1]);
        match = regex.exec(path);
      }

      var indexes = matches.map(Number);

      return indexes.length > 0 ? indexes : null;
    }

    function _getItemIndex(path) {
      // ToDO: may be optimised by using result of _getItemIndexes() as parameter.
      var indexes = _getItemIndexes(path);

      if (_.isNull(indexes)) {
        return null;
      }

      return _.last(indexes);
    }

      function getArgsForGroup(group, rootArgs) {
      const opts = {
        path: group.fieldName,
        formData: rootArgs.row,
        action: rootArgs.action,
        schema: rootArgs.modelSchema,
      };

      const args = getHelperParamsWithConfig(opts);
      args.data = getGroupData(group, rootArgs);
      args.fieldSchema = group;

      return args;
    }

    function getGroupData(group, args) {
      var fieldNames = _.map(group.fields, function (f) { return f.fieldName });
      return _.pick(args.row, fieldNames);
    }

    return {
      getHelperParams: getHelperParams,
      getHelperParamsWithConfig: getHelperParamsWithConfig,
      next: next,
      getArgsForGroup: getArgsForGroup,
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('AdpAttrs', function () {
      return setAttributes;
    });

  function setAttributes(targetEl, args) {
    var action = args.action;

    var attrs = _.get(args, 'fieldSchema.html.' + action, {});
    _.each(attrs, function (val, name) {
      if (['class', 'style'].includes(name)) {
        appendAttr(name, val, targetEl);
      } else if (name in targetEl) {
        targetEl[name] = getProperty(val, args);
      } else {
        targetEl.setAttribute(name, val);
      }
    });
  }

  function appendAttr(name, val, targetEl) {
    var attrVal = targetEl.getAttribute(name);
    var delimiter = ({
      class: ' ',
      style: ';',
    })[name];

    var newAttrVal = _.compact([attrVal, val]).join(delimiter);
    targetEl.setAttribute(name, newAttrVal);
  }

  function getProperty(value, args) {
    if (value.type && value.type === 'function') {
      return _.partial(eventCb, value.code, args);
    }

    return value;
  }

  function eventCb(cbCodeString, args, e) {
    try {
      new Function('return ' + cbCodeString).call(args, e);
    } catch (e) {
      console.error('Error trying to call callback for ' + args.action + ' with args: ', args)
    }
  }
})();
;;(function() {
  'use strict';

  /**
   * @ng-service
   * Backend does not provide schema for Login, SignUp pages and for
   * type=Password field.
   *
   * Service provides hardcoded schemas for such pages until Backend
   * implements it.
   */
  angular
    .module('app.adpCommon')
    .service('AdpAuthSchemas', AdpAuthSchemas);

  /** @ngInject */
  function AdpAuthSchemas(AdpUnifiedArgs) {
    const AUTH_ACTIONS = {
      LOGIN: 'login',
      LOGIN_TWO_FACTOR: 'loginTwoFactor',
      LOGIN_ENABLE_TWO_FACTOR: 'loginEnableTwoFactor',
      REGISTER: 'register',
      FORGOT_PASSWORD: 'forgotPassword',
      RESET_PASSWORD: 'resetPassword',
      UPDATE_PASSWORD: 'updatePassword',
    }
    function loginArgs() {
      return getArgs(AUTH_ACTIONS.LOGIN, loginSchema());
    }

    function loginSchema() {
      const password = getPasswordModelField();
      removeRegexValidator(password);
      const loginField = getModelField('login');
      loginField.fullName = 'Username or Email';
      _.unset(loginField, 'validate');

      return {
        type: 'Schema',
        schemaName: 'login',
        fields: {
          login: loginField,
          password: password,
          recaptcha: getRecaptchaField(),
        }
      }
    }

    function loginTwoFactorArgs() {
      return getArgs(AUTH_ACTIONS.LOGIN_TWO_FACTOR, loginTwoFactorSchema());
    }

    function loginTwoFactorSchema() {
      const twoFactorTokenField = getModelField('twoFactorToken');

      twoFactorTokenField.showInForm = true;

      return {
        type: 'Schema',
        schemaName: 'login-two-factor',
        fields: {
          twoFactorToken: twoFactorTokenField,
        }
      }
    }

    function loginEnableTwoFactorArgs(){
      return getArgs(AUTH_ACTIONS.LOGIN_ENABLE_TWO_FACTOR, loginEnableTwoFactorSchema());
    }

    function loginEnableTwoFactorSchema() {
      const schema = {
        type: 'Schema',
        schemaName: 'enable-two-factor',
        fields: {}
      }

      addEnableTwoFactorField(schema.fields);

      return schema;
    }

    function registrationArgs() {
      return getArgs(AUTH_ACTIONS.REGISTER, registrationSchema());
    }

    function registrationSchema() {
      const helperAction = _.get(window, 'appModelHelpers.Account.registrationSchema');
      if (helperAction) {
        return helperAction();
      }

      const fields = {
        login: getModelField('login'),
        email: getModelField('email'),
        password: getPasswordModelField(),
        passwordConfirmation: getPasswordConfirmation(),
        isAgreeWithPolicies: getModelField('isAgreeWithPolicies'),
        recaptcha: getRecaptchaField(),
      };

      const { requireMfa } = window.adpAppStore.appInterface().app.auth;

      if (requireMfa) {
        addEnableTwoFactorField(fields);
      }

      return {
        type: 'Schema',
        schemaName: 'singup',
        fields
      }
    }

    function registrationSsoArgs() {
      return getArgs(AUTH_ACTIONS.REGISTER, registrationSsoSchema());
    }

    function registrationSsoSchema() {
      const fields = {
        login: getModelField('login'),
        email: getModelField('email'),
        isAgreeWithPolicies: getModelField('isAgreeWithPolicies'),
        recaptcha: getRecaptchaField(),
      };

      _.set(fields, 'login.permissions.' + AUTH_ACTIONS.REGISTER, false);

      const { requireMfa } = window.adpAppStore.appInterface().app.auth;

      if (requireMfa) {
        addEnableTwoFactorField(fields);
      }

      return {
        type: 'Schema',
        schemaName: 'register-sso',
        fields
      }
    }

    function addEnableTwoFactorField(fields) {
      fields.enableTwoFactor = getModelField('enableTwoFactor');
      _.set(fields, 'enableTwoFactor.formRenderer.renderMode', 'register');

      fields.twoFactorRequirementText = getModelField('twoFactorRequirementText');
    }

    function forgotPasswordArgs() {
      return getArgs(AUTH_ACTIONS.FORGOT_PASSWORD, forgotPasswordSchema());
    }

    function forgotPasswordSchema() {
      return {
        type: 'Schema',
        schemaName: 'forgotPassword',
        fields: {
          email: getModelField('email'),
          recaptcha: getRecaptchaField(),
        }
      }
    }

    function resetPasswordArgs() {
      return getArgs(AUTH_ACTIONS.RESET_PASSWORD, resetPasswordSchema());
    }

    function resetPasswordSchema() {
      return {
        type: 'Schema',
        schemaName: 'resetPassword',
        fields: {
          password: getPasswordModelField(),
          passwordConfirmation: getPasswordConfirmation(),
        }
      }
    }

    function passwordUpdateArgs() {
      return getArgs(AUTH_ACTIONS.UPDATE_PASSWORD, passwordUpdateSchema());
    }

    function passwordUpdateSchema() {
      const password = getPasswordModelField();

      return {
        type: 'Schema',
        fields: {
          password: password,
          passwordConfirmation: getPasswordConfirmation(),
        }
      }
    }

    function getArgs(action, schema) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: action,
        schema: schema,
        formData: null,
      });
    }

    function getModelField(fieldName) {
      const APP_MODEL = window.adpAppStore.appModel();
      const path = fieldPath(fieldName);
      const field = _.cloneDeep(_.get(APP_MODEL, path));
      addReadWritePermissions(field);
      if (!field.showInForm) {
        field.showInForm = true;
      }
      field.formWidth = 12;
      _.unset(field, 'formOrder');

      return field;
    }

    function getPasswordModelField() {
      const field = getModelField('password');
      field.type = 'PasswordAuth';

      return field;
    }

    function fieldPath(fieldName) {
      const PATH_PREFIX = 'users.fields.';
      return PATH_PREFIX + fieldName;
    }

    function addReadWritePermissions(field) {
      field.permissions = { view: true, create: true, update: true };
    }

    function getPasswordConfirmation() {
      const field = getPasswordModelField();

      field.fieldName = 'passwordConfirmation';
      field.fullName = 'Verify Password';
      field.validate = [
        {
          validator: 'passwordMatch',
          arguments: {
            matchedField: 'password'
          },
          errorMessages: {
            default: 'Passwords do not match'
          }
        }
      ];

      return field;
    }

    function getRecaptchaField() {
      const field = {
        type: 'Recaptcha',
        fullName: 'Recaptcha',
        fieldName: 'recaptcha',
        showInForm: true,
        required: true,
      };

      addReadWritePermissions(field);

      return field;
    }

    // check for details https://jira.craftus.com/browse/HC-1362
    function removeRegexValidator(field) {
      field.validate = field.validate.filter(function (v) {
        return v.validator !== 'regex'
      });
    }

    return {
      loginArgs,
      loginTwoFactorArgs,
      loginEnableTwoFactorArgs,
      registrationArgs,
      registrationSsoArgs,
      resetPasswordArgs,
      forgotPasswordArgs,
      passwordUpdateArgs,
      getModelField,
      getPasswordModelField,
      getPasswordConfirmation,
      getRecaptchaField,
      addEnableTwoFactorField,
      actions: AUTH_ACTIONS,
    }
  }
})();
;;(function () {
  angular
    .module('app.adpCommon')
    .factory('AdpBrowserService', AdpBrowserService);

  function AdpBrowserService() {
    return {
      isMediaTypeSupported: isMediaTypeSupported,
      isMediaRecorderSupported: isMediaRecorderSupported,
      isFullscreenSupported: isFullscreenSupported,
      isIE: isIE,
      isEdge: isEdge,
      isChrome: isChrome,
      isMobile: isMobile,
      isFirefox: isFirefox,
    };

    function isMediaTypeSupported(mimeType) {
      return isMediaRecorderSupported() && MediaRecorder.isTypeSupported(mimeType);
    }

    function isMediaRecorderSupported() {
      return 'MediaRecorder' in window;
    }

    function isFullscreenSupported() {
      return document.requestFullscreen || document.mozRequestFullScreen ||
        document.webkitRequestFullscreen || document.msRequestFullscreen;
    }

    // Internet Explorer 6-11
    function isIE() {
      return /*@cc_on!@*/false || !!document.documentMode;
    }

    // Edge 20+
    function isEdge() {
      return !isIE && !!window.StyleMedia;
    }

    // Chrome 1+
    function isChrome() {
      return Boolean(window.chrome);
    }

    function isMobile() {
      var deviceType = window.adpAppStore.appInterface().app.deviceType;

      return deviceType === 'phone' || deviceType === 'tablet';
    }

    function isFirefox() {
      var browser = navigator.userAgent.toLowerCase();
      return browser.indexOf('firefox') > -1;
    }
  }
})();
;;(function () {
  angular
    .module('app.adpCommon')
    .factory('AdpFileManagerService', AdpFileManagerService);

  function AdpFileManagerService($q) {
    return {
      imgFileObjectToDataURI: imgFileObjectToDataURI,
      invokeSaveAsDialog: invokeSaveAsDialog,
      dataURItoFile: dataURItoFile
    };

    /**
     * @param {Blob} file - File or Blob object. This parameter is required.
     * @param {string} fileName - Optional file name e.g. "Recorded-Video.webm"
     * @example
     * invokeSaveAsDialog(blob or file, [optional] fileName);
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     */
    function invokeSaveAsDialog(file, fileName) {
      if (!file) {
        throw 'Blob object is required.';
      }

      if (!file.type) {
        try {
          file["type"] = 'video/webm';
        } catch (e) {}
      }

      var fileExtension = (file.type || 'video/webm').split('/')[1];

      if (fileName && fileName.indexOf('.') !== -1) {
        var splitted = fileName.split('.');
        fileName = splitted[0];
        fileExtension = splitted[1];
      }

      var fileFullName = (fileName || (Math.round(Math.random() * 9999999999) + 888888888)) + '.' + fileExtension;

      if (typeof navigator.msSaveOrOpenBlob !== 'undefined') {
        return navigator.msSaveOrOpenBlob(file, fileFullName);
      } else if (typeof navigator.msSaveBlob !== 'undefined') {
        return navigator.msSaveBlob(file, fileFullName);
      }

      var hyperlink = document.createElement('a');
      hyperlink.href = URL.createObjectURL(file);
      hyperlink.download = fileFullName;

      hyperlink.style = 'display:none;opacity:0;color:transparent;';
      (document.body || document.documentElement).appendChild(hyperlink);

      if (typeof hyperlink.click === 'function') {
        hyperlink.click();
      } else {
        hyperlink.target = '_blank';
        hyperlink.dispatchEvent(new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        }));
      }

      URL.revokeObjectURL(hyperlink.href);
    }

    function dataURItoFile(dataURI) {
      var arr = dataURI.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }

      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var filename = [Date.now(), mimeString.split('/')[1]].join('.');

      return new File([u8arr], filename, {type:mime});
    }

    function imgFileObjectToDataURI(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      return $q(function(resolve, reject) {
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject(error);
          console.log('Error, while converting img file obeject to base64 string: ', error);
        };
      })
    }
  }
})();
;;(function () {
  angular
    .module('app.adpCommon')
    .factory('AdpGeoLocationService', AdpGeoLocationService);

  function AdpGeoLocationService(
    GoogleMapsApi,
    APP_CONFIG,
    GeoCoder,
    $q
  ) {
    let loadingPromise = null;

    return {
      reverseGeocode,
      getLocation,
      geocode,
      isReady,
    };

    function isReady() {
      if (loadingPromise) {
        return loadingPromise;
      }

      const url = _configureURL();
      loadingPromise = GoogleMapsApi.load(url);
      return loadingPromise;
    }

    function _configureURL() {
      var BASE_URL = 'https://maps.google.com/maps/api/js';
      var params = {
        libraries: 'places',
        key: APP_CONFIG.googleApiKey
      };

      var queryParamsString = _.map(params, function(value, key) {
        return [key, value].join('=');
      }).join('&');

      return [BASE_URL, queryParamsString].join('?');
    }

    /**
     * Get current location
     * @return Position(Position{})
     */
    function getLocation() {
      return $q(function(resolve, reject) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            resolve([position.coords.longitude, position.coords.latitude]);
          }, function (err) {
            reject(err);
          });
        } else {
          reject('Geolocation is not supported by this browser.');
        }
      });
    }

    /**
     * Convert humanreadable format of location to latitude and longitude
     * @param address string
     * @return Promise(latlng[])]
     */
    function geocode(place) {
      var geocoderOptions = {};
      if (place.place_id) {
        geocoderOptions.placeId = place.place_id;
      } else {
        geocoderOptions.address = place.name;
      }
      return GeoCoder.geocode(geocoderOptions)
        .then(function(result) {
          return result[0];
        }, function(error) {
          console.log('Geocode was not successful for the following reason: ' + error);
        });
    }

    /**
     * Convert latitude and longitude to human readable location format
     * @param coords[lat, lng]
     * @return Promise{string}
     */
    function reverseGeocode({lat, lng}) {
      return GeoCoder.geocode({
        'location': { lat, lng }
      })
      .then(
          ([{ formatted_address }]) => formatted_address,
          error => console.log('Geocode was not successful for the following reason: ' + error)
        );
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('AdpHttpInterceptor', AdpHttpInterceptor);

  /** @ngInject */
  function AdpHttpInterceptor(
    $injector,
    $rootScope
  ) {
    var AdpNotificationService = $injector.get('AdpNotificationService');
    var $q = $injector.get('$q');
    var $log = $injector.get('$log');
    var APP_CONFIG = $injector.get('APP_CONFIG');

    return {
      responseError(error) {
        const AdpSessionService = $injector.get('AdpSessionService');
        $log.debug('Response reject: ', error);

        if (isGraphql(_.get(error, 'config.url'))) {
          const beforeAction = error.status === 401 ?
            AdpSessionService.handleUnauthorized :
            $q.when;

          return beforeAction()
            .then(() => $q.reject(error));
        }

        handleErrorsForRestApi(error);
        return $q.reject(error);
      },
      request(config) {
        const AdpSessionService = $injector.get('AdpSessionService');
        if (!isApiRequest(config.url)) {
          return config;
        }

        AdpSessionService.setAuthHeaders(config);
        $rootScope.lastApiRequest = _.pick(config, ['method', 'headers', 'url', 'withCredentials']);

        return config;
      },
    };

    function isApiRequest(requestUrl) {
      const apiUrl = APP_CONFIG.apiUrl;
      const isAuthUrl = _.find(
        ['login', 'register', 'forgot'],
        (subStr) => _.includes(requestUrl, subStr)
      );

      if (isAuthUrl) {
        return false;
      }

      return _.includes(requestUrl, apiUrl);
    }

    function isGraphql(requestUrl) {
      var apiUrl = APP_CONFIG.apiUrl;
      return apiUrl + '/graphql' === requestUrl;
    }

    function handleErrorsForRestApi(error) {
      var AdpSessionService = $injector.get('AdpSessionService');
      var sessionExpired = isApiRequest(error.config.url) && error.status === 401;
      var hasApiError = error.status >= 400;

      if (sessionExpired) {
        return AdpSessionService.handleUnauthorized()
          .then(() =>  $q.reject(error));
      } else if (hasApiError) {
        const message = _.get(error, 'data.message') || 'Unable to connect to the server. Please try again later.';
        AdpNotificationService.notifyError(message);
      } else {
        console.error('Unknown error.', error);
      }
    }
  }
})();

;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('AdpLayoutConfigService', AdpLayoutConfigService);

  /** @ngInject */
  function AdpLayoutConfigService($rootScope) {
    function requestLayoutParams() {
      var INTERFACE = window.adpAppStore.appInterface();
      var layoutConfig = INTERFACE.layout;

      return {
        'fixed-navigation': true,
        'fixed-ribbon': layoutConfig.fixed.ribbon,
        'fixed-page-footer': layoutConfig.fixed.footer,
        'smart-rtl': layoutConfig.rtlSupport,
        'colorblind-friendly': layoutConfig.colorblind,
        'background': layoutConfig.background,
        'menu-on-top': layoutConfig.menuPosition === 'top',
        'hide-root-menu-labels': layoutConfig.hideRootMenuLabels,
        'hide-root-menu-icons': layoutConfig.hideRootMenuIcons,
      };
    }

    function updateTheme(layoutParams) {
      const $root = $('body');
      updateThemeSettings(layoutParams);
      updateMenuOnTop(layoutParams['menu-on-top']);
      setSkin();
      applyThemeClasses();

      function updateThemeSettings(layoutParams) {
        _.forEach(layoutParams, function (val, key) {
          if (key === 'menu-on-top') {
            return;
          }
          $root.toggleClass(key, val);
        });
      }

      function updateMenuOnTop(val) {
        $rootScope.$broadcast('$smartLayoutMenuOnTop', val);
        $root.toggleClass('menu-on-top', val);
        val && $root.removeClass('minified');
      }
    }

    function setSkin() {
      var $root = $('body');
      var skins = appConfig.skins;
      const { skin: currentSkin } = window.forcedThemes || window.adpAppStore.appInterface();
      $root.removeClass(_.map(skins, 'name').join(' '));
      $root.addClass(currentSkin);
    }

    this.setSkin = setSkin;

    this.get = function (name) {
      var layoutParams = requestLayoutParams();
      return name ? layoutParams[name] : layoutParams;
    };

    this.getSkin = function () {
      var INTERFACE = window.adpAppStore.appInterface();
      return INTERFACE.skin;
    };

    this.updateThemeUI = function () {
      var layoutParams = requestLayoutParams();
      updateTheme(layoutParams);
    }

    this.layoutClass = function () {
      var layoutParams = requestLayoutParams();

      return _.filter(_.keys(layoutParams), function (fieldName) {
        return layoutParams[fieldName];
      }).join(' ');
    }

    function applyThemeClasses () {
      const { devextremeTheme = '', scrollbarTheme, ckeditorTheme } = window.forcedThemes || window.adpAppStore.appInterface();
      const dxThemeParts = devextremeTheme.split('.');

      const [themePrefix] = dxThemeParts;
      const compactClass = _.last(dxThemeParts) === 'compact' ? 'dx-compact' : '';
      const themeType = themePrefix === 'material' ? 'dx-material' : 'dx-generic';
      const dxColorTheme = isDarkTheme() ? 'dx-dark' : 'dx-light';

      $('body').removeClass(['dx-compact', 'dx-material', 'dx-generic', 'dx-dark', 'dx-light']);
      $('body').addClass(dxColorTheme);
      themeType && $('body').addClass(themeType);
      compactClass && $('body').addClass(compactClass);
      scrollbarTheme && $('body').addClass(`${scrollbarTheme}-scrollbar-theme`);
      ckeditorTheme && $('body').addClass(`adp-ckeditor-${ckeditorTheme}`);
    }

    this.applyThemeClasses = applyThemeClasses;

    function isDarkTheme() {
      const { devextremeTheme } = window.adpAppStore.appInterface();
      const dxThemeParts = devextremeTheme.split('.');

      return dxThemeParts.some(part => part === 'dark');
    }
    this.isDarkTheme = isDarkTheme;
  }
})();

;(function () {
  "use strict";

  angular.module("app.adpCommon").factory("AdpMimeService", AdpMimeService);

  /** @ngInject */
  function AdpMimeService() {
    function validate(file, mimeTypePreset) {
      var MIME_TYPES = window.adpAppStore.mimeTypes();
      if (!mimeTypePreset || mimeTypePreset === 'any') {
        const fileMimeTypePreset = getFileMimeTypePreset(file);
        return !!fileMimeTypePreset;
      }
      return MIME_TYPES[mimeTypePreset].includes(file.type);
    }

    function getFileMimeTypePreset(file) {
      var MIME_TYPES = window.adpAppStore.mimeTypes();
      var mimeType = file.type;

      return _.findKey(MIME_TYPES, function (typeArray, mimeTypePreset) {
        if (mimeTypePreset === "any") {
          return false;
        }
        return MIME_TYPES[mimeTypePreset].includes(mimeType);
      });
    }

    function isImage(file) {
      return validate(file, "images");
    }

    function isVideo(file) {
      return validate(file, "video");
    }

    function isAudio(file) {
      return validate(file, "audio");
    }

    function isDocument(file) {
      return validate(file, "docs");
    }


    return {
      getFileMimeTypePreset: getFileMimeTypePreset,
      validate: validate,
      isImage: isImage,
      isVideo: isVideo,
      isAudio: isAudio,
      isDocument: isDocument,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .factory('AdpModalFormService', AdpModalFormService);

  /** @ngInject */
  function AdpModalFormService(
    AdpGeneratorModalService,
    AdpSchemaService,
    AdpUnifiedArgs,
    GraphqlCollectionQuery
  ) {
    // params
    // schemaName
    // recordId
    // action
    // formData
    function openForm(params) {
      const schema = _getSchema(params);

      return _getData(schema, params)
        .then(formData => _openModal(formData, schema, params))
    }

    function _getSchema(params) {
      return params.schema || AdpSchemaService.getSchemaByName(params.schemaName)
    }

    function _getData(schema, params) {
      if (params.action === 'update') {
        const id = params.recordId || _.get(params, 'formData._id');
        const filter = params.dataLoadFilter || ['_id', '=', id];
        return GraphqlCollectionQuery(schema, {filter})
          .then(result => _.get(result, 'items[0]'));
      }

      const formData = params.formData || {};
      return Promise.resolve(formData);
    }

    function _openModal(formData, schema, params) {
      const modalOptions = {
        args: AdpUnifiedArgs.getHelperParamsWithConfig({
          path: '',
          action: params.action || 'update',
          formData,
          schema,
        }),
        size: params.size,
      };

      if (params.formOptions) {
        modalOptions.formOptions = params.formOptions;
      }

      if (params.customData) {
        modalOptions.args.customData = params.customData;
      }

      return AdpGeneratorModalService.formModal(modalOptions);
    }

    return {
      openForm,
    };
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpGenerator")
    .factory("AdpModalService", AdpModalService);

  /** @ngInject */
  function AdpModalService($uibModal, $uibModalStack) {
    const systemDialogDefaults = {windowClass: "adp-vertically-centered", size: "md"};
    return {
      confirm: confirm,
      prompt: prompt,
      readFile: readFile,
      createModal: createModal,
      passwordUpdate: passwordUpdate,
      alert: alert,
    };

    // Available options
    // options = {
    //   message: 'string',
    //   hideCancelButton: false  - option to leave 'Yes' button alone
    //   okButtonText: 'Yes' - redefines button label
    //   actionType: String
    // }
    function confirm(options) {
      return createModal(
        "adpConfirmDialogModal",
        _.extend({actionType: "confirm"}, systemDialogDefaults, options)
      ).result;
    }

    // Available options
    // options = {
    //   title: String,          - dialog title
    //   text: String            - description text (appears between title and input)
    //   value: any,             - initial value, default is empty
    //   isRequired: true        - set to false if you allow to 'Save' with empty value
    //   validate: Function      - value => wrong_value ? 'error message' : ''
    //   saveButtonText: String  - default is 'Save'
    // }
    function prompt(options) {
      return createModal("adpPromptDialogModal",
        _.extend({actionType: "prompt"}, systemDialogDefaults, options || {})
      ).result;
    }

    // Available options
    // options = {
    //  title: String,          - dialog title
    //  validate: Function      - file => return error msg if file is not ok, empty string for success
    //                               (!!! validation if file is chosen provided internally )
    //  uploadButtonText: String  - default is 'Upload'
    //  outputFormat: [ text (default) | arrayBuffer | binaryString | dataURL ]
    //                               heck for details: https://developer.mozilla.org/ru/docs/Web/API/FileReader#Methods
    //  autoOpenFileDialog: true  - opens 'file open' dialog automatically
    //  readFile: true           - set to false and prompt will return file without reading its contents (useful for server-uploading)
    //  }
    function readFile(options) {
      return createModal("adpReadFileDialogModal",
        _.extend({actionType: "readFile"}, systemDialogDefaults, options || {})
      ).result;
    }

    function passwordUpdate(args) {
      const modalOptions = {
        actionType: "passwordUpdate",
        args,
      };

      return createModal("adpPasswordModal", modalOptions)
        .result;
    }

    // Available options
    // options = {
    //   message: 'string',
    // }
    function alert(options) {
      return createModal(
        "adpAlertModal",
        _.extend({actionType: "alert"}, systemDialogDefaults, options)
      ).result;
    }

    function createModal(componentName, options) {
      const size = options.size || 'lg';
      const modalInstance = $uibModal.open({
        backdrop: "static",
        size,
        component: componentName,
        backdropClass: options.backdropClass || '',
        windowClass: options.windowClass || '',
        keyboard: false,
        resolve: {
          options: function () {
            return options;
          },
        },
      });

      _addActionClass(options);
      _handleOnClose(modalInstance);

      return modalInstance;
    }

    function _handleOnClose(modalInstance) {
      modalInstance.closed
        .then(_removeActionClass)
        .then(() => {
          const topModal = $uibModalStack.getTop();
          const modalDomEl = _.get(topModal, 'value.modalDomEl');
          modalDomEl && modalDomEl.focus();
        })
    }

    function _addActionClass(options) {
      $("body").addClass("page-action-" + options.actionType);
    }

    function _removeActionClass(result) {
      const regex = /(^|\s)page-action-\S+/g;

      $("body").removeClass(function (index, className) {
        return (className.match(regex) || []).join(" ").trim();
      });

      return result || "EMPTY_RESULT";
    }
  }
})();
;;(function () {
  var MESSAGE_LENGTH_TRUNCATE = 120;
  var CONTAINER_ID_ERROR = "toast-container-error";

  angular
    .module("app.adpCommon")
    .factory("AdpNotificationService", AdpNotificationService);

  /** @ngInject */
  function AdpNotificationService() {
    var state = {};

    return {
      notifyError,
      notifySuccess,
      notifyInfo,
      closeAll,
    };

    function notifyError(message, title, options){
      replaceToast(options);
      return _addTabbedToast('error', message, title, Object.assign({
        containerId: CONTAINER_ID_ERROR,
        positionClass: "toast-container-universal",
        timeOut: 0,
        extendedTimeOut: 0,
        preventDuplicates: true,
        closeButton: true,
        tapToDismiss: false,
        newestOnTop: false,
        hideDuration: 200,
      }, options || {}));
    }

    function notifySuccess(message, title, options){
      replaceToast(options);
      return toastr.success(message, title, Object.assign({
        containerId: "toast-container-success",
        positionClass: "toast-container-universal",
        closeButton: true,
        newestOnTop: false,
      }, options || {}));
    }

    function notifyInfo(message, title, options){
      replaceToast(options);
      return toastr.info(message, title, Object.assign({
        timeOut: 0,
        extendedTimeOut: 0,
        containerId: "toast-container-success",
        positionClass: "toast-container-universal",
        closeButton: true,
        newestOnTop: false,
      }, options || {}));
    }

    function replaceToast(options) {
       if (options && options.replace) {
         toastr.clear($(options.replace))
       }
    }

    function _addTabbedToast(method, text, title, options){
      var message = text || '';
      var boxId = options.containerId || 'toaster-box-'+method;
      var config = _getToastsConfig( boxId );

      options.containerId = boxId;
      options.onHidden = _onCloseToast;
      options.onCloseClick = _onCloseClick;

      var $toast = toastr[method](_modifyLongMessage(message), title, options);

      if ($toast) {
        _highlightToast($toast);

        if ($toast.find(".toast-more-link").length) {
          $toast.delegate(".toast-more-link", "click", function () {
            $(".toast", config.$toastBox).removeClass("toast-expanded");
            $toast.addClass("toast-expanded");
          });

          $toast.delegate(".toast-less-link", "click", function () {
            $toast.removeClass("toast-expanded");
            _activateToast($toast);
          });
        }

        var $tab = _addToastTab($toast);

        $tab.attr("title", message.substr(0, 30) + ( message.length > 30 ? "..." : ""));

        _activateToast($toast);
      }

      return $toast;

      function _onCloseClick(e){
        var $toast = $(e.target).closest('.toast');

        config.lastIndex = _getToastIndex($toast);
      }

      function _onCloseToast(){
        var $tabs = $('.toast-tab', config.$tabBox);
        var index = config.lastIndex;

        $($tabs.get(index)).remove();
        setTimeout(_onAfterCloseToast,0);
      }

      function _onAfterCloseToast(){
        var $toasts = $('.toast', config.$toastBox);
        var index = config.lastIndex;

        if ($toasts.length) {
          _activateToast( $($toasts.get(Math.min(index, $toasts.length - 1))));
          _doRefreshCloseAll();
        } else {
          _clearContainer(config);
        }
      }

      function _getToastIndex($toast) {
        var $toasts = $('.toast', config.$toastBox);
        return $toasts.index($toast);
      }

      function _activateToast($toast) {
        var $toasts = $('.toast', config.$toastBox);
        var index = _getToastIndex($toast);
        var $tabs =  $('.toast-tab', config.$tabBox).removeClass('toast-tab-active');

        $toasts.removeClass('toast-expanded').addClass('toast-hidden');
        $($tabs.get(index)).addClass('toast-tab-active');
        $($toasts.get(index)).removeClass('toast-hidden');
      }

      function _addToastTab($toast) {
        var $tab = $('<div>').addClass('toast-tab toast-' + method);

        $tab.click(function(){
          _activateToast($toast);
        });

        $tab.appendTo(config.$tabBox);
        _doRefreshCloseAll();

        return $tab;
      }

      function _doRefreshCloseAll() {
        var $toasts = $(".toast", config.$toastBox);
        var $closeAll = $(".close-all-toast", config.$tabBox);

        if (!$closeAll.length && $toasts.length > 1) {
          $("<div>")
            .addClass("close-all-toast")
            .append($("<a>")
              .text("close all")
              .click(closeAll)
            )
            .prependTo(config.$tabBox);
        } else if ($closeAll.length && $toasts.length < 2) {
          $closeAll.remove();
        }
      }
    }

    function closeAll() {
      var config = _getToastsConfig(CONTAINER_ID_ERROR);
      var $toasts = $('.toast', config.$toastBox);
      var $closeAll = $('.close-all-toast > a', config.$tabBox);

      _.each($toasts, function (toast) {
        toastr.clear($(toast))
      });

      $closeAll.remove();
      setTimeout(function(){
        _clearContainer(config)
      }, 200);
    }

    function _clearContainer(config){
      config.$box.remove();
      state[config.id] = null;
    }

    function _highlightToast($toast) {
      $toast.css("backgroundColor", "#c3482d")
        .animate({backgroundColor: "#C46A69"}, 500);
    }

    function _modifyLongMessage(msg) {
      var newMsg = msg;
      if (msg.length > MESSAGE_LENGTH_TRUNCATE) {
        newMsg =
          "<div class='toast-shorter-message'>" +
          msg.substr(0, MESSAGE_LENGTH_TRUNCATE) +
          "&#8230;" +
          "<div class='toast-more-link'>More&#8230;</div>" +
          "</div>" +
          "<div class='toast-full-message'>" +
          msg +
          "<div class='toast-less-link'>Less&#8230;</div>" +
          "</div>"
      }

      return newMsg;
    }

    function _getToastsConfig(boxId){
      var config = state[boxId];

      if (!config) {
        var $box = $('<div id="' + boxId + '-box">').appendTo(document.body);
        var $tabBox = $('<div id="'+boxId+'-tabs">').appendTo($box);
        var $toastBox = $('<div id="'+boxId+'" class="toast-container-universal">').appendTo($box);

        state[boxId] = config = {
          id: boxId,
          $box: $box,
          $tabBox : $tabBox,
          $toastBox: $toastBox,
        }
      }

      return config;
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('AdpRouteGuardService', AdpRouteGuardService);

  /** @ngInject */
  function AdpRouteGuardService(
    AdpSessionService,
    $location,
    $state
  ) {
    var service = this;

    service.redirectStrategy = function (state) {
      var strategy = state.data['redirectStrategy'];

      if (_.isUndefined(strategy)) {
        return;
      }

      var DEFAULT_STATE = window.adpAppStore.defaultState();
      const returnUrl = decodeURIComponent($location.search().returnUrl);
      const { pathname } = new URL(returnUrl, window.location.origin);
      var returnState = ($state.current.name === 'auth.login') && _.find($state.get(), (state) => {
        const { url } = state.$$state();
        return url && url.exec(pathname);
      });

      var redirects = {
        user: $state.href('auth.login'),
        guest: returnState ? returnUrl : DEFAULT_STATE.url,
      };

      var canHaveAccess = service[strategy](state);

      if (!canHaveAccess) {
        var redirectTo = redirects[strategy];
        if (redirectTo === $state.href('auth.login')) {
          $state.go(redirects[strategy], { returnUrl: encodeURIComponent($location.url()) });
        } else {
          $location.url(redirects[strategy]);
        }
      }
    };

    service.user = function() {
      var authSettings = window.adpAppStore.appInterface().app.auth;
      if (!authSettings.requireAuthentication) {
        return true;
      }

      return !lsService.isGuest();
    };

    service.guest = function(state) {
      var authSettings = window.adpAppStore.appInterface().app.auth;

      if (state.name === 'auth.register'&& !authSettings.enableRegistration) {
        return false;
      }

      if (state.name === 'auth.login'&& !authSettings.enableAuthentication) {
        return false;
      }

      if (state.name === 'auth.forgot' && !authSettings.enableUserPasswordReset) {
        return false;
      }

      return lsService.isGuest();
    };

    return service;
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('AdpSchemaService', AdpSchemaService);

  /** @ngInject */
  function AdpSchemaService($state) {
    function getCurrentSchema() {
      var APP_MODEL = window.adpAppStore.appModel();
      var pageParams = getPageParams();

      return _.clone(_.get(APP_MODEL, pageParams.schemaPath));
    }

    function getSchemaByName(name) {
      var APP_MODEL = window.adpAppStore.appModel();
      return _.clone(_.get(APP_MODEL, name));
    }

    // deprecated: PageParams for usage after Provide state
    // TODO: move to adp-generator
    function getPageParams() {
      return _.clone($state.current.data.pageParams);
    }

    function isField(field) {
      return field.type !== 'Schema' && field.type !== 'Subschema';
    }

    function isGroup({ type }) {
      return type === 'Group' || type === 'GroupEnd';
    }

    function getFieldType(field) {
      if (_.has(field, 'list')) {
        return field.type.includes('[]') ? 'List[]' : 'List';
      }

      return field.type;
    }

    function isLookup(type) {
      return ['LookupObjectID', 'LookupObjectID[]'].includes(type);
    }

    function isReadonly(field, action) {
      var permissions = _.get(field, 'permissions', {});
      return permissions.view === true && permissions[action] === false;
    }

    function isReadable(field) {
      var permissions = _.get(field, 'permissions', {});
      return permissions.view === true;
    }

    function isDate(type) {
      return ['Date', 'DateTime', 'Time'].includes(type);
    }

    function getSorter(attrName) {
      var defaultOrderValue = 1000000;

      return function (itemA, itemB) {
        var a = _.isUndefined(itemA[attrName]) ? defaultOrderValue : itemA[attrName];
        var b = _.isUndefined(itemB[attrName]) ? defaultOrderValue : itemB[attrName];

        a = parseInt(a);
        b = parseInt(b);

        a = isNaN(a) ? defaultOrderValue : a;
        b = isNaN(b) ? defaultOrderValue : b;

        return a === b ? 0 : a > b ? 1 : -1;
      }
    }

    function getSingularForm(words) {
      const [, endOfPhrase] = words.match(/\b(\w+)\W*$/);
      const singluarForm = window.pluralize.singular(endOfPhrase);
      return words.replace(/\b(\w+)\W*$/, singluarForm);
    }

    return {
      getFieldType,
      getCurrentSchema,
      getSchemaByName,
      getPageParams,
      getSorter,
      isField,
      isGroup,
      isLookup,
      isReadonly,
      isReadable,
      isDate,
      getSingularForm,
    }
  }
})();
;(function () {
  'use strict';

  angular.module('app.adpWidgets')
    .factory('AdpCustomCss', AdpCustomCss);

  function AdpCustomCss() {
    function setStyleElement(css, id, $targetEl) {
      if (!css) {
        return _.noop;
      }

      const idClass = getIdClassName(id);
      const processedCss = prependIdToCss(css, idClass);
      const styleTagId = getStyleTagId(id);

      const styleElement = $(`<style class="${styleTagId}">${processedCss}</style>`);
      $targetEl.addClass(idClass);
      $('head').append(styleElement);

      return () => removeCustomCss(id, $targetEl);
    }

    function removeCustomCss(id, el) {
      const idClass = getIdClassName(id);
      const styleTagId = getStyleTagId(id);

      el.removeClass(idClass);
      $('head style.' + styleTagId).remove();
    }

    function getStyleTagId(id) {
      return 'adp-custom-style-' + id;
    }

    function getIdClassName(id) {
      return 'adp-custom-css-' + id;
    }

    function prependIdToCss(css, idToPrepend) {
      const { csstree } = window;
      const cssAst = csstree.toPlainObject(csstree.parse(css));
      const allSelectors = csstree.findAll(cssAst, (node) => node.type === 'Selector');

      _.forEach(allSelectors, (selectorNode) => {
        const selectorParts = selectorNode.children;
        selectorParts.unshift(
          { name: idToPrepend, type: 'ClassSelector', loc: null },
          { name: ' ', type: 'Combinator', loc: null },
        )
      });

      return csstree.generate(cssAst, { mode: 'safe' });
    }

    return {
      setStyleElement,
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('Guid', Guid);

  /** @ngInject */
  function Guid () {
    // not a real guid
    function create() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    function isGuid(string) {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(string);
    }

    return {
      create: create,
      isGuid: isGuid
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('ObjectId', ObjectId);

  /** @ngInject */
  function ObjectId() {
    return () => {
      // from https://stackoverflow.com/a/52751754/4575370
      const hex  = (value) => Math.floor(value).toString(16);

      return hex(Date.now() / 1000) +
        ' '.repeat(16).replace(/./g, () => hex(Math.random() * 16))
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDashboard')
    .directive('adpDashboard', adpDashboard);

  /** @ngInject */
  function adpDashboard (AdpDataService) {
    var INTERFACE = window.adpAppStore.appInterface();

    return {
      restrict: 'E',
      replace: true,
      scope: {
        dashboardName: '='
      },
      templateUrl: 'app/adp-dashboard/adp-dashboard/adp-dashboard.html',
      link: function (scope) {
        scope.dashboardItems = INTERFACE[scope.dashboardName]['fields'];

        AdpDataService.getDashboardData(scope.dashboardName)
          .then(function (data) {
            scope.dashboardData = data;
          });
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDashboard')
    .directive('adpDashboardTile', adpDashboardTile);

  /** @ngInject */
  function adpDashboardTile(
    $state,
    adpTemplateEngineService,
    AdpStateGenerator,
    $compile
  ) {
    var INTERFACE = window.adpAppStore.appInterface();
    return {
      restrict: 'E',
      scope: {
        item: '=',
        data: '='
      },
      replace: true,
      link: function (scope, element) {
        var actionsMap =  {
          'add': add,
          'view': view
        };

        function getTpl(template) {
          // FIXME: using inner HTML of template to avoid wrapping into <div class="dashboard">
          // FIXME: should be fixed inside of adpTemplateEngineService
          var tpl = adpTemplateEngineService.parseTemplate(
            template,
            scope.item.parameters.color,
            scope.item
          );

          return tpl.innerHTML;
        }

        function compile() {
          var tpl = INTERFACE.dashboardSubtypes.fields[scope.item.subtype].template;
          var html = getTpl(tpl);
          element.replaceWith($compile(html)(scope));
        }

        scope.action = function (actionType, item) {
          var destinationState = _linkToState(item.parameters.link);

          actionsMap[actionType](destinationState);
        };

        function add(destinationState) {
          $state.go(destinationState, {action: 'create'});
        }

        function view(destinationState) {
          $state.go(destinationState);
        }

        compile();
      }
    };
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpDashboard')
    .factory('adpTemplateEngineService', adpTemplateEngineService);


  function adpTemplateEngineService($rootScope, APP_CONFIG) {

    function getAbsoluteUrl(url) {
      return url.charAt(0) === '/' ? APP_CONFIG.resourceUrl + url : url;
    }

    function getImageUrl(src) {
      var imageSource = src;

      if ($rootScope.isIE) {
        imageSource = imageSource.split('.').join('IE.');
      }

      // return 'background-image:url(' + getAbsoluteUrl(imageSource) + ')';
      return getAbsoluteUrl(imageSource);
    }

    function TemplateGenerator(template, color, data) {
      var re = /<%(.+?)%>/g;
      var reExp = /(^( )?(var|let|const|if|else|for|switch|case|break|{|}|;))(.*)?/g;
      var reElement = /(<([^>]+)>)/ig;

      var components = {
        'no-data': function (children, args) {
          return {
            type: 'div',
            props: {
              'class': 'noData'
            },
            children: children
          };
        },
        'string': function (children, args, params) {
          if (params.parent && ['string', 'subtitle', 'fraction', 'center'].indexOf(params.parent.type) > -1) {
            return children;
          }

          var styles = [];

          if (args.hasOwnProperty('border')) {
            styles.push('border-color: ' + color);
          }

          return {
            type: 'p',
            props: {
              'class': 'dashboard__p' +
              (args.hasOwnProperty('center') ? ' dashboard__p--center' : '') +
              (args.hasOwnProperty('centered-number') ? ' dashboard__p--centered-number' : ''),
              'style': styles.join('; ')
            },
            children: children
          };
        },
        'subtitle': function (children, args) {
          return {
            type: 'h4',
            children: children
          };
        },
        'list': function (children, args) {
          return {
            type: 'ul',
            props: {
              'class': 'dashboard__list'
            },
            children: children
          };
        },
        'list-item': function (children, args) {
          return {
            type: 'li',
            props: {
              'class': 'dashboard__list-item'
            },
            children: [
              {
                type: 'p',
                props: {
                  'class': 'dashboard__list-item-point',
                  'style': 'background-color: ' + color
                }
              },
              children
            ]
          };
        },
        'grid': function (children, args) {
          return {
            type: 'div',
            props: {
              'class': 'adp-dashboard__grid'
            },
            children: children
          };
        },
        'column': function (children, args) {
          var style = [];

          if (typeof args.backgroundColor === 'string') {
            style.push('background-color: ' + args.backgroundColor + '');
          }

          return {
            type: 'div',
            props: {
              'class': 'adp-dashboard__item-33',
              'style': style.join('; ')
            },
            children: children
          };
        },
        'circle': function (children, args) {
          return {
            type: 'div',
            props: {
              'layout': 'row',
              'layout-align': 'center center',
              'class': 'dashboard__circle',
              'style': 'background-color: ' + color
            },
            children: children
          };
        },
        'fraction': function (children, args, params) {
          var fraction = children.split('/');

          return {
            type: 'span',
            props: {
              class: 'dashboard__fraction'
            },
            children: [
              {
                type: 'span',
                props: {
                  class: 'dashboard__fraction-numerator'
                },
                children: fraction[0]
              },
              {
                type: 'span',
                props: {
                  class: 'dashboard__fraction-denominator',
                  style: 'border-top-color: ' + color
                },
                children: fraction[1]
              }
            ]
          };
        },
        'image': function (children, args) {
          return {
            type: 'img',
            props: {
              class: 'dashboard__image',
              src: getImageUrl(args.source),
              alt: ''
            }
          };
        },
        'offset': function (children, args) {
          return {
            type: 'div',
            props: {
              class: 'dashboard__offset'
            }
          };
        },
        'tile': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'adp-dashboard__item'
            },
            children: {
              type: 'div',
              props: {
                'class': 'adp-dashboard__tile panel panel-default'
              },
              children: children
            }
          };
        },
        'tile-x2': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'adp-dashboard__item adp-dashboard__item-x2'
            },
            children: {
              type: 'div',
              props: {
                'class': 'adp-dashboard__tile panel panel-default'
              },
              children: children
            }
          };
        },
        'tile-x3': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'adp-dashboard__item adp-dashboard__item-x3'
            },
            children: {
              type: 'div',
              props: {
                'class': 'adp-dashboard__tile panel panel-default'
              },
              children: children
            }
          };
        },
        'tile-x4': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'adp-dashboard__item adp-dashboard__item-x4'
            },
            children: {
              type: 'div',
              props: {
                'class': 'adp-dashboard__tile panel panel-default'
              },
              children: children
            }
          };
        },
        'tile-header': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'panel-heading'
            },
            children: {
              type: 'h3',
              props: {
                class: 'panel-title'
              },
              children: children
            }
          };
        },
        'chart-body': function (children) {
          return {
            type: 'adp-chart',
            props: {
              'item': 'item',
              'data': 'data'
            },
            children: children
          };
        },
        'tile-body': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'panel-body'
            },
            children: {
              type: 'adp-dashboard-content',
              props: {
                'item': 'item',
                'data': 'data'
              },
              children: children
            }
          };
        },
        'tile-footer': function (children) {
          return {
            type: 'div',
            props: {
              'class': 'panel-footer text-capitalize'
            },
            children: {
              type: 'a',
              props: {
                'class': 'btn btn-default',
                'ng-click': 'action(item.parameters.action, item)'
              },
              children: children
            }
          };
        }
      };

      function generateTemplate(template, data) {
        if (typeof data === 'undefined') {
          data = {};
        }

        var cursor = 0;
        var code = 'with(obj) { var r=[];\n';
        var result = void 0;
        var match = void 0;


        function addLine(line, js) {
          if (js) {
            code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n';
          } else {
            code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '';
          }

          return addLine;
        }

        while (match = re.exec(template)) {
          addLine(template.slice(cursor, match.index))(match[1], true);

          cursor = match.index + match[0].length;
        }

        addLine(template.substr(cursor, template.length - cursor));
        code = (code + 'return r.join(""); }').replace(/[\r\t\n]/g, ' ');

        if (_.isEmpty(data)) {
          code = 'with(obj) {var r=[]; r.push("<no-data>No Data<no-data/>"); return r.join("");}'
        }

        try {
          result = new Function('obj', code).apply(data, [data]);
        } catch (err) {
          console.error("'" + err.message + "'", " in \n\nCode:\n", code, "\n");
        }

        return result;
      }

      function parseElement(offset) {
        var result = {
          type: null,
          args: {},
          isEnd: false,
          withEnd: false
        };

        if (offset.slice(-1) === '/') {
          result.withEnd = true;

          offset = offset.slice(0, -1);
        }

        offset.split(' ').forEach(function (str, index) {
          if (index === 0) {
            if (str.charAt(0) === '/') {
              result.isEnd = true;
            }

            result.type = str.replace(/^\//g, '');
          } else {
            var splitArg = str.split('=');

            if (splitArg[0].trim().length) {
              result.args[splitArg[0]] = splitArg[1] ? splitArg[1].replace(/(^"|"$)/g, '') : '';
            }
          }
        });

        return result;
      }

      function parseTemplate(template) {
        var cursor = 0;
        var tree = [];
        var currentLink = tree;
        var paths = [currentLink];
        var match = void 0;

        while (match = reElement.exec(template)) {
          if (template.slice(cursor, match.index).trim().length) {
            currentLink.push({
              type: 'string',
              args: {},
              children: template.slice(cursor, match.index)
            });
          }

          var element = parseElement(match[2]);

          if (!element.isEnd) {
            currentLink.push({
              type: element.type.toLowerCase(),
              args: element.args,
              children: []
            });

            currentLink = currentLink[currentLink.length - 1].children;
            paths.push(currentLink);
          }
          if (element.isEnd || element.withEnd) {
            paths.pop();
            currentLink = paths.slice(-1)[0];
          }

          cursor = match.index + match[0].length;
        }

        return tree;
      }

      function jsonToDOM(json, doc, nodes) {
        if (typeof doc === 'undefined') {
          doc = document;
        }

        if (typeof nodes === 'undefined') {
          nodes = {};
        }

        var namespaces = {
          html: 'http://www.w3.org/1999/xhtml',
          xul: 'http://www.mozilla.org/keymaster/gatekeeper/there.is.only.xul'
        };
        var defaultNamespace = namespaces.html;

        function namespace(name) {
          var m = /^(?:(.*):)?(.*)$/.exec(name);
          return [namespaces[m[1]], m[2]];
        }

        function tag(name, attr) {
          if (_.isArray(name)) {
            var frag = doc.createDocumentFragment();

            Array.prototype.forEach.call(arguments, function (arg) {
              if (!_.isArray(arg[0])) {
                frag.appendChild(tag.apply(null, arg));
              } else {
                arg.forEach(function (arg) {
                  frag.appendChild(tag.apply(null, arg));
                });
              }
            });

            return frag;
          }

          var args = Array.prototype.slice.call(arguments, 2);
          var vals = namespace(name);
          var elem = doc.createElementNS(vals[0] || defaultNamespace, vals[1]);

          for (var key in attr) {
            if (attr.hasOwnProperty(key)) {
              var val = attr[key];

              if (nodes && key === 'key') {
                nodes[val] = elem;
              }

              vals = namespace(key);

              if (typeof val === 'function') {
                elem.addEventListener(key.replace(/^on/, ''), val, false);
              } else {
                elem.setAttributeNS(vals[0] || '', vals[1], val);
              }
            }
          }
          args.forEach(function (e) {
            try {
              elem.appendChild(
                Object.prototype.toString.call(e) === '[object Array]' ? tag.apply(null, e) :
                  e instanceof doc.defaultView.Node ? e : doc.createTextNode(e)
              );
            } catch (ex) {
              elem.appendChild(doc.createTextNode(ex));
            }
          });

          return elem;
        }

        return tag.apply(null, json);
      }

      function generateDomObject(schema, parent) {
        if (typeof parent === 'undefined') {
          parent = null;
        }

        if (!schema || !schema.length) {
          return null;
        }

        if (typeof schema === 'string') {
          return schema;
        }

        var result = [];

        for (var i = 0; i < schema.length; i++) {
          var _item = schema[i];

          var currentComponent = components[_item.type];

          if (!currentComponent) {
            continue;
          }

          var childrenTemplate = generateDomObject(_item.children, _item);
          var renderedComponent = currentComponent(childrenTemplate, _item.args, {
            parent: parent
          });

          if (!renderedComponent) {
            continue;
          }

          result.push(renderedComponent);
        }

        return result.length ? (result.length === 1 ? result[0] : result) : null;
      }

      function generateJsonDom(DomObject) {
        if (!DomObject || (_.isArray(DomObject) && !DomObject.length)) {
          return [];
        }

        if (typeof DomObject === 'string') {
          if (DomObject == 'NaN') {
            return '';
          }

          return DomObject;
        }

        if (!_.isArray(DomObject)) {
          return (
            [DomObject.type, DomObject.props]
              .concat(
                generateJsonDom(
                  _.isArray(DomObject.children)
                    ? DomObject.children
                    : [DomObject.children]
                )
              )
          );
        }

        var result = [];

        DomObject.forEach(function (item) {
          var jsonDom = generateJsonDom(item);

          if (jsonDom && (!_.isArray(jsonDom) || jsonDom.length)) {
            result.push(jsonDom);
          }
        });

        return result;
      }

      return jsonToDOM(
        ['div', {
          class: 'dashboard',
          style: 'color: ' + color
        }, generateJsonDom(
          generateDomObject(
            parseTemplate(
              generateTemplate(template, data)
            )
          )
        )]
      );
    }


    return {
      parseTemplate: TemplateGenerator
    }
  }
})();

;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .directive('adpRecordDetailsCell', adpRecordDetailsCell);

  function adpRecordDetailsCell(HtmlCellRenderer) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        options: '<',
      },
      template: '<div></div>',
      link(scope, element) {
        scope.$watch('args.data', function (val) {
          if (_.isNil(val)) {
            return;
          }

          renderTemplate();
        });

        scope.$on('afterCopyPasteAction', () => {
          scope.args.data = _.get(scope.args.row, scope.args.path);
          renderTemplate();
        });

        function renderTemplate() {
          const template = createTemplate(scope.args);
          element.find('> div').replaceWith(template);
        }

        function createTemplate(args) {
          var $wrapper = $('<div>', {
            'class': [
              'name-' + args.fieldSchema.fieldName,
              'view-details-cell-type-' + args.fieldSchema.type.toLowerCase(),
              getMixedAdditionalClassName(args),
            ].join(' '),
          });
          $wrapper.append(HtmlCellRenderer(args, scope.options));

          return $wrapper;
        }

        function getMixedAdditionalClassName(args) {
          if (args.fieldSchema.type !== 'Mixed') {
            return '';
          }

          if (_.isNil(args.data) || typeof args.data !== 'object') {
            return 'view-details-cell-type-mixed-as-primitive'
          }

          return '';
        }
      }
    }
  }
})();
;;(function () {
  "use strict";

  var URL_PARAM_NAME = "customOpt";

  angular
    .module("app.adpCommon")
    .factory("AdpGridCustomOptionsService", AdpGridCustomOptionsService);

  /** @ngInject */
  function AdpGridCustomOptionsService(
    $location,
    $state
  ) {
    function AdpGridCustomOptions() {
      this.gridComponent = null;
      this.val = {};
      this.handlers = {change: {}};
      parseFromUrl.call(this);
    }

    AdpGridCustomOptions.prototype.setGridComponent = function (grid) {
      this.gridComponent = grid;
    };

    AdpGridCustomOptions.prototype.value = function (param1, param2) {
      var self = this;
      if (typeof param1 === "undefined") {
        return this.val;
      } else if (typeof param1 === "object") {
        _.each(param1, function (v, k) {
          if (self.val[k] !== v) {
            self.val[k] = v;
            setTimeout(function(){self._trigger("change", k, v);} ,0);
          }
        });
      } else if (typeof param1 === "string") {
        if (typeof param2 === "undefined") {
          return this.val[param1];
        } else {
          if (this.val[param1] !== param2) {
            this.val[param1] = param2;
            setTimeout(function(){self._trigger("change", param1, param2);}, 0);
          }
        }
      }
    };

    AdpGridCustomOptions.prototype.setHandler = function (eventName, attr, cb) {
      if (!this.handlers[eventName]) {
        this.handlers[eventName] = [];
      }

      if (!this.handlers[eventName][attr]) {
        this.handlers[eventName][attr] = [];
      }

      this.handlers[eventName][attr].push(cb);
    };

    AdpGridCustomOptions.prototype.setOrReplaceHandler = function (eventName, attr, cb) {
      if (this.handlers[eventName] && this.handlers[eventName][attr]) {
        delete this.handlers[eventName][attr];
      }
      this.setHandler(eventName, attr, cb);
    };

    AdpGridCustomOptions.prototype._trigger = function (eventName, _attr, newval) {
      var self = this;
      _.each([_attr, "$$$"], function (attr) {
        _.each(_.keys(self.handlers), function (handlerKey) {
          if (handlerKey.startsWith(eventName)) {
            if (self.handlers[handlerKey][attr] && self.handlers[handlerKey][attr].length) {
              _.each(self.handlers[handlerKey][attr], function (cb) {
                setTimeout(function(){cb.call(self, newval) }, 0);
              })
            }
          }
        })
      });

      mapToUrl.call(self);
    };

    function mapToUrl() {
      var currentParams = $location.search();
      var withoutEmpty = _.pickBy(this.value(), _.identity); //  This is generally wrong - removes ===false, and ===0, and ==='' but ok by now
      var encodedJson = _.keys(withoutEmpty).length ? encodeURIComponent(JSON.stringify(withoutEmpty)) : "";

      if (encodedJson) {
        currentParams[URL_PARAM_NAME] = encodedJson;
      } else {
        _.unset(currentParams, URL_PARAM_NAME);
      }

      $location.search(currentParams);
    }

    function parseFromUrl() {
      var result = {};

      try {
        result = JSON.parse(decodeURIComponent($state.params[URL_PARAM_NAME]) || "");
      } catch (e) {
      }

      this.value(result);
    }

    function create() {
      return new AdpGridCustomOptions;
    }

    return {
      create: create
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridDataSource', GridDataSource);

  /** @ngInject */
  function GridDataSource(
    GraphqlCollectionQuery,
    GraphqlCollectionMutator,
    AdpFormDataUtils,
    AdpNotificationService,
    $q,
    ErrorHelpers,
    ServerError,
    GridOptionsHelpers,
    GridSchema,
    AdpUnifiedArgs
  ) {
    return function (options, schema, customOptions) {
      options.dataSource = { store: createStore(schema, customOptions) };

      if (_.get(schema, 'parameters.loadInvisibleFields') === false) {
        registerColumnsVisibilityListener(options);
      }

      return options;
    }

    function createStore(schema, customOptions) {
      return new DevExpress.data.CustomStore({
        load: function (loadOptions) {
          var requestSchema = provideRequestSchema(schema, customOptions.gridComponent);

          loadOptions.customOptions = customOptions.value();
          loadOptions.isGroupFilter = groupingEnabled(customOptions.gridComponent);

          return GraphqlCollectionQuery(requestSchema, loadOptions)
            .then(!!loadOptions.group ? getGroupedData : getData)
            .catch(function (err) {
              ErrorHelpers.handleError(err);
              return $q.reject();
            });
        },
        insert: function(values) {
          var cleanedData = cleanupData(values, schema);

          return GraphqlCollectionMutator.create(schema, cleanedData)
            .catch(function (error) {
              ErrorHelpers.handleError(error, 'Unknown error, while trying to create record in cell editor');
              throw error;
            });
        },
        update: function (keys, values) {
          var data = _.assign({}, keys, values);
          var cleanedData = cleanupData(data, schema);

          return GraphqlCollectionMutator.update(schema, cleanedData)
            .catch(function (error) {
              ErrorHelpers.handleError(error, 'Unknown error, while trying to update record in cell editor');
              throw error;
            });
        }
      });
    }

    function registerColumnsVisibilityListener(options) {
      GridOptionsHelpers.onOptionChanged(options, function (e) {
        var columnsVisibilityChanged = /^columns\[\d+\].visible$/.test(e.fullName);
        var changedToVisible = e.value === true;

        if (columnsVisibilityChanged && changedToVisible) {
          e.component.refresh();
        }
      });
    }

    function provideRequestSchema(schema, gridInstance) {
      if (_.get(schema, 'parameters.loadInvisibleFields')) {
        return schema;
      }

      return GridSchema.getSchemaForVisibleColumns(schema, gridInstance);
    }

    function getData(data) {
      return {
        data: _.get(data, 'items', []),
        totalCount: _.get(data, 'count', 0),
      };
    }

    function getGroupedData(data) {
      return {
        data: _.get(data, 'data', []),
        totalCount: _.get(data, 'totalCount', 0),
        groupCount: _.get(data, 'groupCount', 0),
        summary: data.summary || []
      };
    }

    function cleanupData(values, schema) {
      var data = _.cloneDeep(values);

      [
        '__KEY__',
        '__DX_INSERT_INDEX__',
        '_actions',
        'parentKey',
        'pageIndex',
        'rowIndex',
        'dataRowIndex',
      ].forEach(function (path) {
        _.unset(data, path);
      });

      var args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        schema: schema,
        formData: data,
        action: null,
      });

      return AdpFormDataUtils.transformDataBeforeSending(args).row;
    }

    function groupingEnabled(grid) {
      for (var i = 0; i < grid.columnCount(); i++){
        if(grid.columnOption(i, 'groupIndex') > -1){
          return true;
        }
      }

      return false;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridOptionsHelpers', GridOptionsHelpers);

  /** @ngInject */
  function GridOptionsHelpers() {
    function getDxEventHandler(handlerName){
      return function(options, cb) {
        var args = [handlerName, options, cb];
        registerDxEvent.apply(null, args);
      }
    }

    function registerDxEvent(name, options, cb) {
      var prevFn = options[name];

      options[name] = function (e) {
        cb(e);

        if (prevFn) {
          prevFn(e);
        }
      };
    }

    function refreshGrid(instance) {
      // empty for singleRecord page
      var instance = instance || gridInstance();
      instance && instance.refresh();
    }

    function gridInstance() {
      var gridInstance = $('.multi-record [dx-data-grid]');
      return gridInstance.dxDataGrid('instance');
    }

    function gridInstanceBySchemaName(schemaName) {
      var gridInstance = $(`[dx-data-grid][data-grid-name="${schemaName}"]`);
      return gridInstance.dxDataGrid('instance');
    }

    function getLoadOptions(instance) {
      var instance = instance || gridInstance();
      var loadOptions = _.cloneDeep(instance.getDataSource().loadOptions());
      loadOptions.filter = instance.getCombinedFilter();

      var selectedRows = instance.getSelectedRowKeys();

      if (selectedRows.length) {
        loadOptions.filter = [];
        _.each(selectedRows, function (row) {
          loadOptions.filter.push(["_id", "=", row._id]);
          loadOptions.filter.push("or");
        });
        loadOptions.filter.pop();
      }

      return loadOptions;
    }

    function getVisibleColumnNames(instance) {
      var instance = instance || gridInstance();

      var result = instance.getVisibleColumns().map(function (c) {
        return c.dataField;
      });

      return _.compact(result);
    }

    function generateGridLsKey(storageKey, schemaName) {
      return storageKey + '_dxgrid_' + schemaName;
    }

    function limitPagerSize(options, schema) {
      const limitReturnedRecords = _.get(schema, 'limitReturnedRecords');
      if (!limitReturnedRecords) {
        return;
      }
      const pageSizes = _.sortBy(_.get(options, 'pager.allowedPageSizes', []), [x=>parseInt(x,10)]);
      const pageSizesFiltered = _.filter(pageSizes, x => x <= limitReturnedRecords);
      if (pageSizesFiltered.length < pageSizes.length) {
        if (_.last(pageSizesFiltered) < limitReturnedRecords) {
          pageSizesFiltered.push(limitReturnedRecords);
        }
        _.set(options, 'pager.allowedPageSizes', pageSizesFiltered);
      }
      const pageSize = _.get(options, 'paging.pageSize');
      if (pageSize > limitReturnedRecords) {
        _.set(options, 'paging.pageSize', pageSize);
      }
    }

    return {
      addOnInitializedHandler: getDxEventHandler('onInitialized'),
      onEditorPreparing: getDxEventHandler('onEditorPreparing'),
      onRowPrepared: getDxEventHandler('onRowPrepared'),
      onOptionChanged: getDxEventHandler('onOptionChanged'),
      onCellPrepared: getDxEventHandler('onCellPrepared'),
      refreshGrid: refreshGrid,
      generateGridLsKey: generateGridLsKey,
      getVisibleColumnNames: getVisibleColumnNames,
      getLoadOptions: getLoadOptions,
      gridInstanceBySchemaName,
      limitPagerSize,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridOptions', GridOptions);

  /** @ngInject */
  function GridOptions(
    GridColumns,
    GridColumnsHelpers,
    GridDataSource,
    GridToolbarActions,
    GridLifecycleActions,
    GridRtcActions,
    GridOptionsHelpers,
    AdpGridCustomOptionsService,
    GridFilters,
    CellEditorsService,
    GridHeaderFilters,
    GridStateStoring,
    GridTooltip
  ) {
    function create(schema) {
      const presentation = {
        showBorders: true,
        showColumnLines: true,
      };
      const customGridOptions = AdpGridCustomOptionsService.create();
      const other = {
        remoteOperations: true,
        twoWayBindingEnabled: false,
        errorRowEnabled: false,
        onDataErrorOccurred: function () {
          this.dataErrorMessage = 'Data Loading Error';
        },
        onContentReady: function (e) {
          if (e.component.totalCount() > 0) {
            return;
          }

          const filterEmpty = _.isNil(e.component.getCombinedFilter());
          const noDataText = filterEmpty ?
            'This collection is empty' :
            'The filter you specified returned no data';

          const noDataTextChanged = e.component.option('noDataText') !== noDataText;
          noDataTextChanged && e.component.option('noDataText', noDataText);
        },
      };
      const schemaParameters = _.cloneDeep(schema.parameters) || {};
      const overriders = {
        filterPanel: {
          visible: false    // Filter panel is blocked since its functionality is moved into filterBuilder(action) instead
        }
      };
      const options = _.assign(
        {},
        presentation,
        other,
        schemaParameters,
        overriders
      );

      GridDataSource(options, schema, customGridOptions);
      GridColumns(options, schema, customGridOptions);
      GridFilters.create(options, schema);
      GridHeaderFilters(options, schema);
      CellEditorsService(options, schema);
      GridFilters.setFiltersFromUrl(options, schema, customGridOptions);
      GridLifecycleActions(options, schema, customGridOptions);
      GridRtcActions(options, schema, customGridOptions);
      GridStateStoring.create(options, schema, customGridOptions);
      GridTooltip.create(options);

      const scrollMode = _.get(options, "scrolling.mode");
      if (scrollMode === 'virtual' || scrollMode === 'infinite') {
        options.paging.pageSize = Math.max(100, options.paging.pageSize);
      }

      GridOptionsHelpers.limitPagerSize(options, schema);

      const prevDisposer = options.onDisposing;
      options.onDisposing = function (event) {
        if (prevDisposer) {
          prevDisposer(event);
        }

        customGridOptions.handlers.destroy && customGridOptions.handlers.destroy();
      };

      GridOptionsHelpers.onOptionChanged(options, function (e) {
        if (e.fullName !== 'paging.pageIndex') {
          return;
        }

        const isGridVisible = e.component.element()[0].getBoundingClientRect().top > 0;
        if (isGridVisible) {
          return;
        }

        const scrollPos = e.component.element().offset().top;
        $('html, body').animate({
          scrollTop: scrollPos
        }, 300);
      });

      GridOptionsHelpers.addOnInitializedHandler(options, (e) => {
        e.component.option("stateStoring.ignoreColumnOptionNames", []);
        customGridOptions.setGridComponent(e.component);
        return GridToolbarActions(options, schema, customGridOptions);
      });

      // NOTE:x removing null values, which is possible inside datasets/:_id page
      return _.pickBy(options, o => !_.isNil(o));
    }

    return {
      create: create,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridSorting', GridSorting);

  /** @ngInject */
  function GridSorting() {
    function setSortingOptions(options, schema) {
      setDefaultSortOrder(options, schema);
    }

    function setDefaultSortOrder(options, schema) {
      var defaultSortOptions = _.get(schema, 'defaultSortBy');
      var sortIndex = 0;

      _.each(defaultSortOptions, function (order, fieldName) {
        var sortingColumn = findSortingColumn(options.columns, fieldName);
        if (!sortingColumn) {
          return;
        }

        setSortOptionsToColumn(sortingColumn, order, sortIndex);
        sortIndex++;
      });
    }

    function findSortingColumn(columns, fieldName) {
      return _.find(columns, ['dataField', fieldName]);
    }

    function setSortOptionsToColumn(column, order, index) {
      _.assign(column, {
        sortIndex: index,
        sortOrder: order === 1 ? 'asc' : 'desc',
      });
    }

    return {
      setSortingOptions: setSortingOptions,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridStateStoring', GridStateStoring);

  /** @ngInject */
  function GridStateStoring(
    GridOptionsHelpers,
    GridColumnsHelpers,
    $state
  ) {
    return { create };

    function create(options, schema, customGridOptions) {
      const stateStoringDisabledFromUrl = $state.params.noLsFilter;

      if (stateStoringDisabledFromUrl) {
        options.stateStoring.enabled = false;
        return;
      }

      const lsEnabled = options.stateStoring &&
        options.stateStoring.enabled &&
        options.stateStoring.type === "localStorage";

      if (!lsEnabled) {
        return;
      }

      const customSaveState = (state) => {
        state._customOptions = customGridOptions.value();
        state.columns.shift();
        localStorage.setItem(storageKey, JSON.stringify(state));
      };

      const storageKey = GridOptionsHelpers.generateGridLsKey(options.stateStoring.storageKey, schema.schemaName);

      options.stateStoring.storageKey = storageKey;
      options.stateStoring.type = 'custom';
      options.stateStoring.customSave = customSaveState;
      options.stateStoring.customLoad = () => {
        const json = localStorage.getItem(storageKey);
        const state = safeJSONParse(json);

        customGridOptions.value(state._customOptions || {});
        delete state._customOptions;

        setTimeout(function () {
          const toolbar = _.get(customGridOptions, 'gridComponent._views.headerPanel._toolbar');
          toolbar && toolbar.repaint();
        }, 300);

        delete state.selectedRowKeys;
        const savedStateResetRequired = !GridColumnsHelpers.isGridStateConformsSchema(state, schema);

        // ToDo: future idea - instead of returning null (to reset saved state) its possible to modify state
        //  considering schema changes (remove columns, type changes etc)
        if (savedStateResetRequired) {
          return null;
        }

        return state;
      };

      customGridOptions.setHandler("change", "$$$", function () {
        if (this.gridComponent) {
          var gridComponent = this.gridComponent;
          // deferring save is required since 'change' handler invoked by customLoad() synchronously and 'normal'
          // state of the grid still empty at that point
          setTimeout(function () {
            var state = gridComponent.state();

            customSaveState(state);
          }, 300);
        }
      });
    }

    function safeJSONParse(str) {
      let parsed;
      try {
        parsed = JSON.parse(str);
      } catch (e) {
        console.error('Error parsing ls grid state', e);
      }

      return parsed || {};
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridTooltip', GridTooltip);

  /** @ngInject */
  function GridTooltip() {
    const findTooltip = (cmp) => {
      return cmp.element().next('[dx-tooltip]').dxTooltip('instance');
    }

    return { create }

    function create(options) {
      let delayTimeout;
      let delayInterval = 300;
      options.onCellHoverChanged = function (e) {
        const cellElement = e.cellElement;
        const tooltipInstance = findTooltip(e.component);
        const disableHover = e.rowType !== 'data' || e.column.name === 'actions' || e.isEditing;

        if (disableHover) {
          tooltipInstance.hide();
          return;
        }

        if (e.eventType === 'mouseover') {
          tooltipInstance.option('contentTemplate', (data) => {
            const elementContents = cellElement.children().clone();
            elementContents.attr('style', '');
            elementContents.addClass('adp-daragrid-contents');
            data.html(elementContents);
          });

          const elementContents = cellElement.children();
          if (elementContents.html() === '-' || elementContents.text().replace(/\s/g, '') === '') {
            return;
          }

          delayTimeout = setTimeout(() => {
            tooltipInstance.show(cellElement);
          }, delayInterval);

          return;
        }

        clearTimeout(delayTimeout);
        tooltipInstance.hide();
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .factory('AdpFileUploaderModalService', AdpFileUploaderModalService);

  /** @ngInject */
  function AdpFileUploaderModalService($uibModal) {
    function cropModal(items) {
      if (!items.length) return;

      return $uibModal.open({
        backdrop: 'static',
        size: 'lg',
        component: 'adpCropModal',
        resolve: {
          items: function () {
            return items;
          },
          uploader: function () {
            return items[0].uploader;
          }
        }
      }).result;
    }

    function mediaModal(name, uploader) {
      return $uibModal.open({
        backdrop: 'static',
        size: 'lg',
        component: name,
        resolve: {
          uploader: function () {
            return uploader;
          }
        }
      }).result;
    }

    return {
      cropModal: cropModal,
      audioModal: mediaModal.bind(this, 'adpAudioModal'),
      videoModal: mediaModal.bind(this, 'adpVideoModal'),
      photoModal: mediaModal.bind(this, 'adpPhotoModal')
    };
  }
})();
;(function () {
  "use strict";

  angular
    .module("app.adpUploader")
    .factory("AdpFileUploaderService", AdpFileUploaderService);

  /** @ngInject */
  function AdpFileUploaderService(
    AdpSessionService,
    FileUploader,
    adpFileUploaderOptions,
    AdpUploaderMessages,
    AdpUploaderDimensionFilter,
    AdpFileUploaderModalService,
    AdpUploaderFilters,
    AdpMimeService,
    APP_CONFIG,
    Guid,
    $q
  ) {
    function createUploader(uploadedFiles, options) {
      var uploader = new FileUploader({
        url: APP_CONFIG.apiUrl + "/upload",
        queueLimit: options.multiple ? options.fileLimit || 5 : 1,
        withCredentials: true,
      });
      options.fileLimit = uploader.queueLimit;

      if (!_.isEmpty(uploadedFiles)) {
        _addUploadedFilesToQueue(uploader, uploadedFiles);
      }

      uploader.onBeforeUploadItem = function () {
        const headers = { Authorization: AdpSessionService.getAuthHeaders() };

        uploader.headers = headers;
        uploader.queue.forEach((item) => {
          item.headers = headers;
        });
      };

      return uploader;
    }

    function create(field, uploadedFiles) {
      const defaults = _getDefaults(field, adpFileUploaderOptions);
      const options = _.defaultsDeep({}, field.arguments, defaults);
      const uploader = createUploader(uploadedFiles, options);

      uploader.adpField = field;

      _addMethods(uploader, options, field);
      _addCustomFilters(uploader, options);
      _bindEvents(uploader, options);

      return uploader;
    }

    function createForFilesCollection(field, uploadedFiles, args) {
      const uploader = create(field, uploadedFiles);
      uploader.isFileCollection = true;

      uploader.updateFileInfo = function (args) {
        const [fileInQueue] = uploader.queue;
        if (!fileInQueue) {
          return;
        }

        fileInQueue.formData[0] = uploader.formData[0] || {};
        const { _id, fileType } = args.row;
        fileInQueue.formData[0].fileInfos = JSON.stringify([{ _id, fileType }]);
      };

      uploader.addFiles = function (files) {
        this.clearErrors();
        const isUpdate = Boolean(args.row._id);
        const options = uploader.getOptions();

        if (isUpdate) {
          const [oldFile] = uploader.queue;
          const fileToAdd = _.get(files, "0") || files;
          fileToAdd && (fileToAdd.id = oldFile.id);

          uploader.queue.shift();
          this.addToQueue([fileToAdd], options, this.filters);
        } else {
          uploader.queue.shift();
          this.addToQueue(files, options, this.filters);

          uploader.queue.forEach(function (file) {
            file._file.id = Guid.create();
          });
        }

        uploader.updateFileInfo(args);
      };
      uploader.callAddFileWindows = _addFile.bind(uploader);

      return uploader;
    }

    function createStandalone(uploadedFiles, options) {
      return createUploader(uploadedFiles, options || {});
    }

    function _getDefaults(field, defaults) {
      var fieldType = field.type.toLowerCase().replace("[]", "");

      return defaults[fieldType];
    }

    function _addUploadedFilesToQueue(uploader, files) {
      // WORKAROUND: server can't complex objects
      files.forEach(function (fileObject) {
        const dummyFile = _createDummyFile(fileObject, uploader);
        uploader.queue.push(dummyFile);
      });
    }

    function _createDummyFile(file, uploader) {
      var dummy = new FileUploader.FileItem(uploader, {
        lastModifiedDate: new Date(),
        size: file.size,
        type: file.type,
        name: file.name,
        id: file.id,
        cropped: file.cropped,
        isDummyFile: true,
      });

      dummy.progress = 100;
      dummy.isUploaded = true;
      dummy.isSuccess = true;

      return dummy;
    }

    function _addMethods(uploader, options, field) {
      uploader.clearErrors = function () {
        this.errors = [];
      };

      uploader.addFiles = function (files) {
        this.clearErrors();
        this.addToQueue(files, options, this.filters);

        uploader.queue.forEach(function (file) {
          file._file.id = Guid.create();
          uploader.setFileInfos(file, field);
        });
      };
      uploader.callAddFileWindows = _addFile.bind(uploader);

      uploader.getOptions = function () {
        return options;
      };

      uploader.updateOptions = function (newOptions) {
        _.assign(options, newOptions);
        return options;
      };

      const fileTypes = {
        any: "File",
        audio: "Audio",
        images: "Image",
        video: "Video",
      };
      uploader.setFileInfos = function (file, field) {
        if (!file) {
          return;
        }

        const { mimeTypePreset } = uploader.getOptions();
        const fileType = fileTypes[mimeTypePreset];

        file.formData[0] = uploader.formData[0] || {};
        const publish = field?.parameters?.publishFile || false;
        file.formData[0].fileInfos = JSON.stringify([{ fileType, publish }]);
      };
    }

    function _addCustomFilters(uploader, options) {
      const filterNames =
        _.get(options, "filterNames", "").toString().split(",") || [];
      var filters = AdpUploaderFilters.filters();

      _.each(filterNames, function (filterName) {
        uploader.filters.push(filters[filterName]);
      });
    }

    function _bindEvents(uploader, options) {
      uploader.onWhenAddingFileFailed = function (item, filter) {
        AdpUploaderMessages.addError(item, filter, uploader);
      };

      uploader.onAfterAddingAll = function () {
        var enableCropPromise = options.enableCropper ? enableCrop : $q.when;

        AdpUploaderDimensionFilter.filter(uploader).then(enableCropPromise);
      };

      uploader.onErrorItem = function (item, response, status) {
        var sessionExpired = status === 401 && !lsService.isGuest();

        if (sessionExpired) {
          AdpSessionService.handleUnauthorized();
        }
      };
    }

    function enableCrop(uploader) {
      var items = uploader.queue;
      var imagesOnly = _.filter(items, function (item) {
        return AdpMimeService.isImage(item.file);
      });

      return imagesOnly.length > 0
        ? AdpFileUploaderModalService.cropModal(imagesOnly)
        : $q.when();
    }

    function _addFile() {
      var options = this.getOptions();
      var uploader = this;

      if (isFileAmountLimit(uploader)) {
        return AdpUploaderMessages.showErrorMessage("queueLimit", uploader);
      }

      var input = $('<input type="file">');
      input[0].multiple = options.multiple;
      input.click();

      $(input).on("change.adpTempUpload", function (e) {
        uploader.addFiles(e.target.files);
        input.off("change.adpTempUpload");
      });
    }

    function isFileAmountLimit(uploader) {
      if (uploader.isFileCollection) {
        return false;
      }

      return uploader.queue.length >= uploader.queueLimit;
    }

    return {
      create,
      createForFilesCollection,
      createStandalone,
      isFileAmountLimit,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .factory('AdpMediaTypeHelper', AdpMediaTypeHelper);

  /** @ngInject */
  function AdpMediaTypeHelper(
    APP_CONFIG,
    $timeout,
    $http
  ) {
    const FILE_TYPES = {
      ASIS: 'asis',
      CROPPED: 'cropped',
      THUMBNAIL: 'thumbnail',
      THUMBNAIL_S: 'thumbnail_S',
      THUMBNAIL_M: 'thumbnail_M', //Same as THUMBNAIL
      THUMBNAIL_L: 'thumbnail_L',
    };
    const fileLinkCache = {};
    function getFileLink(fileItem, fileType) {
      const fileTypeToRequest = fileType || 'asis';
      const cacheKey = `${fileItem.id}${fileTypeToRequest}`;
      const cacheEntry = _.get(fileLinkCache, cacheKey);
      if (cacheEntry) {
        return cacheEntry;
      }
      const url = APP_CONFIG.apiUrl + '/file-link/' + fileItem.id + '?fileType=' + fileTypeToRequest;
      const promise = $http.get(url).then(resp=>getLink(_.get(resp, 'data.data.linkId')))
      fileLinkCache[cacheKey] = promise;
      $timeout(() => {
        delete fileLinkCache[cacheKey];
      }, 5000);
      return promise;
    }

    function getLink(linkId, attachment) {
      let link = [APP_CONFIG.apiUrl, 'file', linkId].join('/');

      if (attachment) {
        link += 'attachment=true'
      }

      return link;
    }

    function getDownLoadLink(fileItem) {
      return getFileLink(fileItem)
        .then(function (src) {
          return src + '?attachment=true';
        });
    }

    function callSaveDialog(fileItem, src) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = src;
      a.target = '_blank';
      a.download = fileItem.name;
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
      }, 2000);
    }

    function getThumbImgLink(fileItem, thumbSize = 'M') {
      const thumbType = (`THUMBNAIL_${thumbSize}`).toUpperCase();
      const fileType = FILE_TYPES[thumbType] || FILE_TYPES.THUMBNAIL_M;
      return getFileLink(fileItem, fileType);
    }

    function getPermanentImageLink(fileItem, fileSize) {
      const fileType = FILE_TYPES[fileSize] || FILE_TYPES.CROPPED;
      return `${APP_CONFIG.apiUrl}/file-permanent/${fileItem.id}?fileType=${fileType}`;
    }

    function getPermanentThumbnailLink(fileItem, thumbSize = 'M') {
      const thumbType = (`THUMBNAIL_${thumbSize}`).toUpperCase();
      const fileSize = FILE_TYPES[thumbType] ? thumbType : 'THUMBNAIL_M';
      return getPermanentImageLink(fileItem, fileSize);
    }

    function downloadWithSaveDialog(fileItem) {
      return getDownLoadLink(fileItem)
        .then(function (src) {
          callSaveDialog(fileItem, src);
        });
    }

    return {
      getFileLink: getFileLink,
      getCroppedImgLink: _.partialRight(getFileLink, FILE_TYPES.CROPPED),
      getThumbImgLink,
      getImgLink: _.partialRight(getFileLink, FILE_TYPES.ASIS),
      getDownLoadLink,
      downloadWithSaveDialog,
      getPermanentThumbnailLink,
      getPermanentImageLink,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .factory('AdpUploaderDimensionFilter', AdpUploaderDimensionFilter);

  /** @ngInject */
  function AdpUploaderDimensionFilter(
    AdpUploaderMessages,
    AdpMimeService,
    $q
  ) {
    function filter(uploader) {
      var hasFilter = _hasDimensionFilter(uploader.getOptions());

      var imagesOnly = _.filter(uploader.queue, function (item) {
        return AdpMimeService.isImage(item.file) && !item.isUploaded;
      });

      if (!imagesOnly.length || !hasFilter) return $q.when(uploader);

      return $q.all(imagesOnly.map(_getDimension))
        .then(function (itemParams) {
          _filterByDimension(itemParams, uploader);
          return uploader;
        })
    }

    function _filterByDimension(itemsParams, uploader) {
      var options = uploader.getOptions();

      _.each(itemsParams, function (params) {
        if (params.message === 'NOT_AN_IMAGE') return;
        var doRemove = false;

        if (options.minWidth && params.w < options.minWidth) {
          doRemove = true;
        }

        if (options.maxWidth && params.w > options.maxWidth) {
          doRemove = true;
        }

        if (options.minHeight && params.h < options.minHeight) {
          doRemove = true;
        }

        if (options.maxHeight && params.h > options.maxHeight) {
          doRemove = true;
        }

        if (doRemove) {
          params.item.remove();
          AdpUploaderMessages.addError(params.item.file, {name: 'dimension'}, uploader)
        }
      });
    }

    function _getDimensionFilters() {
      return ['minWidth', 'maxWidth', 'minHeight', 'maxHeight'];
    }

    function _getDimension(item) {
      return $q(function (resolve, reject) {
        var img = new Image();

        img.src = URL.createObjectURL(item._file);

        img.onload = function() {
          var width = img.naturalWidth,
            height = img.naturalHeight;

          window.URL.revokeObjectURL(img.src);
          if (width && height) {
            resolve({item: item, w: width, h: height });
          } else {
            resolve({message: 'NOT_AN_IMAGE'})
          }
        };
      });
    }

    function _hasDimensionFilter(options) {
      var filters = _.filter(_getDimensionFilters(), function (prop) {
        return options[prop];
      });

      return filters.length > 0;
    }

    return {
      filter: filter
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .factory('AdpUploaderFilters', AdpUploaderFilters);

  /** @ngInject */
  function AdpUploaderFilters(AdpMimeService) {
    var filters = {
      maxFileSize: {
        name: 'maxFileSize',
        fn: function(item, options) {
          return item.size <= options.maxFileSize;
        }
      },
      mimeType: {
        name: 'mimeType',
         fn: function(item, options) {
           return AdpMimeService.validate(item, options.mimeTypePreset);
        }
      },
      folder: {
        name: 'folder',
        fn: function (item) {
          return item.type;
        }
      }
    };

    return {
      filters: function () {
        return filters;
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .factory('AdpUploaderMessages', AdpUploaderMessages);

  /** @ngInject */
  function AdpUploaderMessages(AdpNotificationService) {
    var MESSAGES = {
      'folder': function () {
        return 'Folder upload is not allowed.';
      },
      'queueLimit': function (options) {
        return ['Maximum files amount is exceeded. Maximum files amount is ', options.fileLimit || 1, '.'].join(' ');
      },
      'maxFileSize': function (options) {
        return ['File is too big. Maximum files size is ', _bytesToSize(options.maxFileSize), '.'].join(' ');
      },
      'mimeType': function () {
        return 'File type is not supported.'
      },
      'duplicates': function () {
        return 'Files is already added.'
      },
      'dimension': function (options) {
        var sizesMessage = getDimensionMessageSizes(options);
        return 'Image must be ' + sizesMessage + '.'
      }
    };

    var dimensions = {
      'minWidth': function (options) {
        return options.minWidth ? 'no less than ' + options.minWidth + 'px wide' : '';
      },
      'maxWidth': function (options) {
        return options.maxWidth ? 'no more than ' + options.maxWidth + 'px wide' : '';
      },
      'minHeight': function (options) {
        return options.minHeight ? 'no less than ' + options.minWidth + 'px tall' : '';
      },
      'maxHeight': function (options) {
        return options.maxHeight ? 'no more than ' + options.maxHeight + 'px tall' : '';
      }
    };

    function getDimensionMessageSizes(options) {
      return _.map(dimensions, function (messageFn) {
        return messageFn(options);
      }).join(', ');
    }

    function _bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    function addError(item, filter, uploader) {
      if (!uploader.errors) {
        uploader.errors = [];
      }

      uploader.errors.push({
        file: item.name,
        message: MESSAGES[filter.name](uploader.getOptions())
      });
    }

    function getMessage(name, options) {
      return MESSAGES[name](options)
    }

    function showErrorMessage(name, uploader) {
      var message = getMessage(name, uploader.getOptions());
      return AdpNotificationService.notifyError(message);
    }

    return {
      addError: addError,
      getMessage: getMessage,
      showErrorMessage: showErrorMessage
    }
  }
})();
;  ;(function () {
  angular
    .module('app.adpUploader')
    .value('adpFileUploaderOptions', {
      'image': {
        'multiple': false,
        "enableDragAndDrop": true,
        "maxFileSize": 5000000,
        'mimeTypePreset': 'images',
        "minWidth": 50,
        "maxWidth": 5000,
        "minHeight": 50,
        "maxHeight": 5000,
        "enableCropper": true,
        "enablePhotoCapture": true,
        "aspectRatio": 1,
        filterNames: 'maxFileSize,mimeType,folder',
      },
      'file': {
        'multiple': false,
        "enableDragAndDrop": true,
        "maxFileSize": 5000000,
        'mimeTypePreset': 'any',
        filterNames: 'maxFileSize,mimeType',
      },
      'video': {
        'multiple': false,
        "enableDragAndDrop": true,
        "maxFileSize": 5000000,
        'mimeTypePreset': 'video',
        "enableWebcam": true,
        filterNames: 'maxFileSize,mimeType,folder',
      },
      'audio': {
        'multiple': false,
        "enableDragAndDrop": true,
        "maxFileSize": 5000000,
        'mimeTypePreset': 'audio',
        "enableMicrophone": true,
        filterNames: 'maxFileSize,mimeType,folder',
      }
    });
})();
;;(function () {
  angular
    .module('app.adpForms')
    // todo: move to schema service closer to type definitions
    .constant('DX_ACCOUNTING_FORMAT', '$#,##0.##;-$#,##0.##')
    .constant('DX_PERCENT_FORMAT', "#0.##%")
    .constant('DATE_FORMAT', 'M/D/YYYY')
    .constant('TIME_FORMAT', 'h:mm a')
    .constant('DATE_TIME_FORMAT', 'M/D/YYYY h:mm a')
    .constant('IMPERIAL_UNITS_DEFAULTS', {
      'ImperialHeight': [
        {
          name: 'foots',
          shortName: 'ft',
          label: '\'',
          range: [0, 9]
        },
        {
          name: 'inches',
          shortName: 'in',
          label: '\'\'',
          range: [0, 12]
        }
      ],
      'ImperialWeightWithOz': [
        {
          name: 'pounds',
          shortName: 'lb',
          label: 'lb',
          range: [0, 11]
        },
        {
          name: 'ounce',
          shortName: 'oz',
          label: 'oz',
          range: [0, 16]
        }
      ],
      'ImperialWeight': [
        {
          name: 'pounds',
          shortName: 'lb',
          label: 'lb',
          range: [0, 11]
        }
      ]
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpAutocomplete', adpAutocomplete);

  function adpAutocomplete(
    AdpFieldsService
  ) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, element, attrs) {
        var unbind = scope.$watch(attrs.adpAutocomplete, function(field) {
          element[0].autocomplete = AdpFieldsService.autocompleteValue(field);
          unbind();
        });
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpDateFormatter', function(AdpValidationUtils) {
      return {
        require: 'ngModel',
        scope: {
          adpDateFormatter: '='
        },
        link: function(scope, element, attrs, ngModel) {
          var type = scope.adpDateFormatter;
          var dateFormat = AdpValidationUtils.getDateFormat(type);

          ngModel.$formatters.push(function(date) {
            return date ? dayjs(date).format(dateFormat) : '';
          });

          ngModel.$parsers.push(function(dateString) {
            if (dateString === '') {
              return dateString;
            }
            var d = dayjs(dateString, dateFormat, true);
            return d.toDate();
          });

          // what is happening here is that
          // when datepicker plugins is initialized
          // iso date is set as viewValue
          // so we need to validate date using two date formats
          ngModel.$validators.dateValid = function (viewValue) {
            if (!viewValue) return true;

            return AdpValidationUtils.isValidDate(viewValue, type);
          }
        }
      };
    });
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpRequiredMark', adpRequiredMark);

  function adpRequiredMark(AdpValidationUtils) {
    return {
      restrict: 'E',
      scope: false,
      template: '<span class="text-danger" ng-show="isRequired()">&nbsp;*</span>',
      require: '^^form',
      link: function (scope) {
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpValidate', adpValidate);

  function adpValidate(
    AdpValidationRules
  ) {
    return {
      restrict: 'A',
      scope: false,
      require: ['ngModel', '^^form'],
      link: function (scope, element, attrs, ctrls) {
        var unbind = scope.$watch(attrs.adpValidate, function(validationParams) {
          init();
          extendValidators(validationParams);

          unbind();
        });

        function init() {
          scope.model = ctrls[0];
          scope.form = ctrls[1];
          scope.model.$validators = scope.model.$validators || {};
        }

        function extendValidators(args) {
          var validator = getRules(args);
          if (_.isEmpty(validator)) {
            return;
          }

          injectValidators(args, scope.form);
        }

        function getRules(args) {
          return _.get(args, 'fieldSchema.validate', []);
        }

        function injectValidators(args, angularForm) {
          var formData = args.row;
          var form = angularForm;

          var rules = getRules(args);
          var resultValidators = {};

          rules.forEach(function (validatorRule) {
            var validatorName = validatorRule.validator;
            if (!AdpValidationRules[validatorName]) {
              return;
            }

            resultValidators[validatorName] = function (viewValue) {
              if (_.isNil(viewValue) || viewValue === '') {
                return true;
              }

              var validatorArgs = _.assign({}, args, {
                data: viewValue,
                validationRule: validatorRule,
                formData: getAngularShallowFormDataCopy(form, formData),
              });

              return AdpValidationRules[validatorName](validatorArgs);
            };
          });

          var angularFormControl = _.get(form, args.fieldSchema.fieldName);
          angular.extend(angularFormControl.$validators, resultValidators);
        }

        function getAngularShallowFormDataCopy(angularForm, formData) {
          var result = {};
          _.each(formData, function (value, key) {
            if (_.isNil(angularForm[key])) {
              return;
            }
            result[key] = angularForm[key].$viewValue;
          });

          return result;
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('escapeLetters', function() {
      return {
        scope: {
          escapeLetters: '='
        },
        link: function(scope, element) {
          if (!scope.escapeLetters) return;
          var E_LOWER_KEY_CODE = 101,
              E_UPPER_KEY_CODE = 69,
              ESCAPE_REGEX = /e|E/;

          element.bind('keypress.escapeLetters', handleInput);
          function handleInput(e) {
            var keyCode = e.keyCode || e.which;

            if (keyCode === E_LOWER_KEY_CODE || keyCode === E_UPPER_KEY_CODE) {
              e.preventDefault();
            }
          }

          element.bind('paste.escapeLetters', handlePaste);
          function handlePaste(e) {
            var clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
            var pastedData = clipboardData.getData('Text');

            if(ESCAPE_REGEX.test(pastedData)) {
              e.stopPropagation();
              e.preventDefault();
            }
          }

          scope.$on('$destroy', function() {
            element.off('keypress.escapeLetters');
            element.off('paste.escapeLetters');
          });
        }
      };
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ListControlSortable', ListControlSortable);

  // DEPRECATED
  function ListControlSortable() {
    const getDragItemIndex = (el) => {
      const dxTagEl = $(el).closest('.dx-tag');
      return dxTagEl.index();
    };

    const isDraggable = (el) => {
      const attrContent = $(el).closest('.dx-tag-content').attr('draggable');
      return attrContent === 'true';
    }

    const setDragElStyles = (el) => {
      const draggableEl = $(el).closest('.dx-tag-content');
      draggableEl.css('opacity', '0.4');
    }

    const resetDragElStyles = (el) => {
      const tags = $(el).find('.dx-tag-content');
      tags.css('opacity', '');
    }

    const swapItems = (e, items) => {
      const fromId = _.toNumber(e.originalEvent.dataTransfer.getData('text'));
      const toId = getDragItemIndex(e.target);
      if (fromId === toId) {
        return;
      }

      [items[fromId], items[toId]] = [items[toId], items[fromId]];
    }

    function setupTagsReordering({ element, onDrop, args }) {
      if (!isReorderingAllowed(args)) {
        return;
      }

      element.on('dragover', function (e) {
        e.preventDefault();
      });

      element.on('dragstart', function (e) {
        if (!isDraggable(e.target)) {
          return;
        }

        const fromId = getDragItemIndex(e.target);
        e.originalEvent.dataTransfer.clearData();
        e.originalEvent.dataTransfer.setData('text/plain', fromId);
        e.originalEvent.dataTransfer.effectAllowed = 'move';
        setDragElStyles(e.target);
      });

      element.on('dragend', function () {
        resetDragElStyles(element);
      });

      element.on('drop', function (e) {
        e.preventDefault();
        if (!isDraggable(e.target)) {
          return;
        }

        onDrop(e);
      });
    }

    function isReorderingAllowed(args) {
      const { allowRearranging } = _.get(args, 'fieldSchema.parameters') ?? { allowRearranging: false };
      return allowRearranging;
    }

    return {
      isReorderingAllowed,
      setupTagsReordering,
      swapItems,
    };
  }
})();;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpAsyncListsService', AdpAsyncListsService);

  function AdpAsyncListsService(
    AdpRecordMeta,
    AdpListsService
  ) {
    function addLabelForDynamicList(args, component) {
      if (!AdpListsService.isAsync(args)) {
        return;
      }

      if (!args.data) {
        return;
      }
      const ds = component.option('dataSource');
      const dsItems = ds.items();
      const label = AdpRecordMeta.get(args, args.path + '.label');

      let pushIn = dsItems;
      if (AdpListsService.isGrouped(args)) {
        pushIn = [];
        dsItems.push({ key: "Group", items: pushIn });
      }

      if (_.endsWith(args.fieldSchema.type, '[]')) {
        args.data.forEach((val, idx) => {
          pushIn.push({ value: _.toString(val), label: (label && label[idx] || val) });
        });
      } else {
        pushIn.push({ value: _.toString(args.data), label: label });
      }
    }

    function clearDs(args, cmp) {
      if (!AdpListsService.isAsync(args)) {
        return;
      }

      var ds = cmp.option('dataSource');
      ds.items().length = 0;
      ds.reload();
    }

    function setDynamicListLabel(args, e) {
      if (!AdpListsService.isAsync(args)) {
        return;
      }

      var ds = e.component.option('dataSource');
      var labels = findItemWithLabel(e.value, ds.items(), args)

      if (_.endsWith(args.fieldSchema.type, '[]')) {
        setLabelIntoMeta(_.isEmpty(labels) ? null : labels, args);
      } else {
        setLabelIntoMeta(labels[0] || null, args);
      }
    }

    function findItemWithLabel(label, items, args) {
      const labels = _.isArray(label) ? label : [label];
      const dsItems = AdpListsService.isGrouped(args) ?
        _.flatten(_.map(items, 'items')) :
        items;

      return _.chain(dsItems)
        .filter(i => labels.includes(i.value))
        .map('label')
        .value();
    }

    function setLabelIntoMeta(label, args) {
      AdpRecordMeta.set(args, args.path + '.label', label);
    }

    return {
      addLabelForDynamicList,
      setDynamicListLabel,
      clearDs,
    };
  }
})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('FIELDS_WITH_UNIQUE_WRAPPER', [
      'Object',
      'Array',
      'AssociativeArray',
      'Blank',
      'StaticHtml',
      'Readonly',
      'Recaptcha',
      'FormSeparator',
    ])
    .constant('OTHER_FIELDS', {
      'String[]': 'string-array',
      'Number[]': 'number-array',
      'Double[]': 'number-array',
      'Int32[]': 'number-array',
      'Int64[]': 'number-array',
      'Decimal128[]': 'decimal-array',
      'DateTime[]': 'datetime-array',
      'Date[]': 'datetime-array',
      'Code': 'code',
      'Mixed': 'code',

      'ImperialHeight': 'imperial-units',
      'ImperialWeightWithOz': 'imperial-units',

      'LookupObjectID': 'lookup',
      'LookupObjectID[]': 'lookup',
      'TreeSelector': 'tree-selector',
      'Html': 'html',
      'Grid': 'grid',

      'File': 'file',
      'Image': 'file',
      'Audio': 'file',
      'Video': 'file',
      'File[]': 'file',
      'Image[]': 'file',
      'Audio[]': 'file',
      'Video[]': 'file',

      'Recaptcha': 'recaptcha',

      'Boolean': 'boolean',
      'TriStateBoolean': 'tri-state-boolean',
      'Location': 'location',

      'List': 'list',
      'List[]': 'list',
      'FrontendList': 'list',
      'FrontendList[]': 'list',

      'CronExpression': 'cron-expression',
      'KeyVal': 'key-val',

      Password: 'password',
      Icon: 'Icon',
      RandomID: 'random-id',
      Rating: 'rating',
    })
    .constant('DX_CONTROLS', {
      String: ['String', 'Phone', 'Url', 'Email', 'PasswordAuth', 'ObjectID'],
      Number: ['Number', 'Double'],
      Decimal: ['Decimal128'],
      Int: ['Int32', 'Int64'],
      Date: ['Date', 'DateTime', 'Time'],
      Text: ['Text'],
      Currency: ['Currency'],
      Percent: ['Percent'],
      ImperialWeight: ['ImperialWeight'],
      Color: 'Color',
    })

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpFieldsService', AdpFieldsService);

  function AdpFieldsService(
    AdpSchemaService,
    APP_CONFIG,
    $http,
    $log,
    IMPERIAL_UNITS_DEFAULTS,
    AdpBrowserService,
    FIELDS_WITH_UNIQUE_WRAPPER
  ) {
    function getDirectiveType(field, action) {
      if (AdpSchemaService.isReadonly(field, action)) {
        return 'readonly';
      }

      if (field.formRender) {
        return 'default';
      }

      const isObjectComplex = ['Object', 'Array', 'AssociativeArray', 'KeyVal'].includes(field.type)
      if (isObjectComplex) {
        return 'complex';
      }

      const isComplex = FIELDS_WITH_UNIQUE_WRAPPER.includes(field.type);
      if (isComplex) {
        return _.kebabCase(field.type);
      }

      return 'default';
    }

    // public
    function getFormFields(fields) {
      return [{ fields: prepareFormFields(_.cloneDeep(fields)) }];
    }

    function getComplexObjectsFields(fields) {
      return prepareFormFields(_.cloneDeep(fields));
    }

    // Sort in following order: 0, 1, ... , 100000, undefined, -100000, ... , -1
    function fieldsSorter(a, b) {
      if (a >= 0) {
        if (b >= 0) {
          return a - b;
        }
        return -1;
      }

      if (a < 0) {
        if (b < 0) {
          return a - b;
        }
        return 1;
      }

      if (a === undefined) {
        if (b >= 0) {
          return 1;
        }
        if (b < 0) {
          return -1;
        }
        return 0;
      }
    }


    function prepareFormFields(fields) {
      return _(fields)
        .map(prepareData)
        .filter(function (field) {
          return AdpSchemaService.isField(field) &&
            !AdpSchemaService.isGroup(field) &&
            _isVisible(field);
        })
        .filter(AdpSchemaService.isReadable)
        .sort((f1, f2) => fieldsSorter(getFormOrder(f1), getFormOrder(f2)))
        .value();
    }

    function _isVisible(field) {
      return !!field.showInForm;
    }

    function prepareData(field) {
      if (!_.isString(field.required)) {
        field.required = !!field.required;
      }

      return field;
    }

    function getFormGroupFields(notGroupedFields) {
      const sortedAndProcessed = _.chain(notGroupedFields)
        .toArray()
        .sort((f1, f2) => fieldsSorter(getFormOrder(f1), getFormOrder(f2)))
        .value();

      const grouped = regroupFields(sortedAndProcessed);

      _.forEach(grouped, (fieldsOrGroups) => {
        if (fieldsOrGroups.fields) {
          fieldsOrGroups.fields = prepareFormFields(fieldsOrGroups.fields);
          return;
        }

        fieldsOrGroups.groups = _.transform(fieldsOrGroups.groups, (res, group, name) => {
          // visible or has permissions
          if (!group.showInForm || !AdpSchemaService.isReadable(group)) {
            return;
          }

          group.fields = prepareFormFields(group.fields);
          copyGroupPermissionsToChildField(group);
          res[name] = group;
        });
      });

      return grouped;
    }

    function regroupFields(notGroupedFields) {
      const result = {};
      let addIn = result;

      // move fields inside groups
      _.forEach(_.cloneDeep(notGroupedFields), (field) => {
        const { type, fieldName } = field;

        if (type === 'Group') {
          result[fieldName] = field;
          const groupFields = {};
          result[fieldName].fields = groupFields;
          addIn = groupFields;
          return;
        }

        if (type === 'GroupEnd') {
          addIn = result;
          return;
        }

        addIn[fieldName] = field;
      });

      // move fields inside its own groups
      const grouped = [];
      let groups = null;
      let fields = null;
      _.forEach(result, (field) => {
        const { type, fieldName } = field;

        if (type === 'Group') {
          fields = null;
          if (!groups) {
            groups = {};
            grouped.push({ groups })
          }

          groups[fieldName] = field;
        } else {
          groups = null;
          if (!fields) {
            fields = {};
            grouped.push({ fields })
          }
          fields[fieldName] = field;
        }
      });

      return grouped;
    }

    function copyGroupPermissionsToChildField(group) {
      var permissions = _.get(group, 'permissions', {});

      if (permissions.view && !permissions.create && !permissions.update) {
        _.each(group.fields, function (f) {
          f.permissions = _.clone(permissions);
        });
      }
    }

    function getUnitsList(field) {
      var units = getUnits(field);

      return units.map(function (unit) {
        var begin = unit.range[0]
        var end = unit.range[1]
        var unitRange = _.range(begin, end);

        return {
          list: _.map(unitRange, function (i) {
            return {value: i, label: i + unit.label}
          }),
          shortName: unit.shortName,
        }
      });
    }

    function getUnits(field) {
      var type = field.type;
      var units = _.cloneDeep(IMPERIAL_UNITS_DEFAULTS[type]);

      var isWeightField = type.includes('Weight');
      if (isWeightField) {
        setRangesFromParams(units, field);
      }

      return units;
    }

    function setRangesFromParams(units, field) {
      var imperialWeightUnit = _.find(units, function (unit) {
        return unit.label === 'lb';
      });

      imperialWeightUnit.range[0] = _.get(field, 'parameters.minLb', imperialWeightUnit.range[0]);
      imperialWeightUnit.range[1] = _.get(field, 'parameters.maxLb', imperialWeightUnit.range[1] + 1);
    }

    function autocompleteValue(field) {
      var fieldAutocomplete = field.autocomplete;

      if (fieldAutocomplete === 'disableMobile') {
        fieldAutocomplete = AdpBrowserService.isMobile() ? 'disable' : 'enable';
      }

      var autocompleteStd = {
        'enable': 'on',
        'disable': 'off',
      };

      if (_.isUndefined(autocompleteStd[fieldAutocomplete])) {
        return fieldAutocomplete;
      } else {
        return autocompleteStd[fieldAutocomplete];
      }
    }

    function getHeaderRenderer(args) {
      var renderFn = getHeaderRenderFn(args);

      if (renderFn) {
        var oldParamsForCompatibility = {
          fieldData: args.data,
          formData: args.row,
          fieldSchema: args.fieldSchema,
          index: args.index,
        };

        return renderFn.call(args, oldParamsForCompatibility);
      } else {
        return args.fieldSchema.fullName;
      }
    }

    function getHeaderRenderFn(args) {
      var renderNameOrExpression = _.get(args, 'fieldSchema.headerRender', null);
      var renderFn = _.get(window, 'appModelHelpers.HeaderRenderers.' + renderNameOrExpression, null);

      if (_.isFunction(renderFn)) {
        return renderFn;
      } else if (renderNameOrExpression) {
        return new Function('lookup, oldCompatibilityParams', 'return ' + renderNameOrExpression);
      } else {
        return null;
      }
    }

    function hasHeaderRenderer(fieldSchema) {
      return !!fieldSchema.headerRender;
    }

    function getFormOrder(field) {
      var val = Number(field.formOrder);

      return _.isNaN(val) ? undefined : val;
    }

    function configFromParameters(field, defaults = {}) {
      let parameters = _.get(field, 'parameters', {});
      parameters = _.omit(parameters, ['visible']);
      return _.merge({}, defaults, parameters);
    }

    function addOpenStatusBroadcast(scope, baseConfig) {
      const prevOpenHandler = baseConfig.onOpened;
      const prevCloseHandler = baseConfig.onClosed;

      baseConfig.onOpened = e => {
        prevOpenHandler && prevOpenHandler(e);
        _broadcastDropdownState(scope, true);
      };
      baseConfig.onClosed = e => {
        prevCloseHandler && prevCloseHandler(e);
        _broadcastDropdownState(scope, false);
      };

      return baseConfig;
    }

    function _broadcastDropdownState(scope, opened) {
      const uid = scope.$id;
      scope.$root && scope.$root.$broadcast('adpDropdownState', {opened, uid});
    }

    return {
      getUnits,
      getUnitsList,
      getDirectiveType,
      getFormFields,
      getComplexObjectsFields,
      getFormGroupFields,
      autocompleteValue,
      getHeaderRenderer,
      hasHeaderRenderer,
      configFromParameters,
      addOpenStatusBroadcast,
      fieldsSorter
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpFormService', AdpFormService);

  function AdpFormService(
    $q,
    AdpFormIteratorUtils,
    ShowExpression,
    RequiredExpression,
    AdpUnifiedArgs,
    UploadError
  ) {
    function getGroupingType(args) {
      var group = _.get(args, 'modelSchema.parameters.groupingType') || '';
      return group.toLowerCase();
    }

    function _forEachAngularFormField(form, callback) {
      if (_.isEmpty(form)) {
        return;
      }

      angular.forEach(form.$getControls(), function(field) {
        var isForm = !!field.$$controls;

        if (isForm) {
          _forEachAngularFormField(field, callback);
        } else {
          callback(field);
        }
      });
    }

    function forceValidation(form) {
      _forEachAngularFormField(form, function (field) {
        field.$validate();
      });
    }

    function groupHasErrors(fieldGroup, form) {
      if (!form.$submitted) {
        return false;
      }

      const errorField = _.find(fieldGroup, (fieldSchema) => {
        var formControl = form[fieldSchema.fieldName];
        if (!formControl) return false;

        return formControl.$invalid;
      });

      return !!errorField;
    }

    function groupCompleted(fieldGroup, form) {
      if (!form.$submitted) {
        return false;
      }

      var completed = false;

      _.each(fieldGroup, function (fieldSchema) {
        var field = form[fieldSchema.fieldName];
        if (!field || completed) return;

        completed = field.$dirty && _.isEmpty(field.$error);
      });

      return completed;
    }

    function setGroupDirty(fieldGroup, form) {
      _.each(fieldGroup, function (field) {
        if (!form[field.fieldName]) return;

        if (field.type === 'Date') {
          form[field.fieldName].$touched = true;
        }
        form[field.fieldName].$setDirty();
      });
    }

    function handleOnGroupActivateBegin(fieldGroup, scope) {
      const helperString = _.get(fieldGroup, 'events.onGroupActivateBegin');
      return _callFormEvent(scope, helperString, {fieldSchema: fieldGroup});
    }

    function handleOnGroupActivateEnd(fieldGroup, scope) {
      const helperString = _.get(fieldGroup, 'events.onGroupActivateEnd');
      return _callFormEvent(scope, helperString, {fieldSchema: fieldGroup});
    }

    function _callFormEvent(scope, helperString, contextPart = {}) {
      if (!helperString) {
        return;
      }
      const { args } = scope;
      const helpers = _.get(window, 'appModelHelpers.FormEvents') || {};
      const fn = new Function(`return ${helperString}`);
      const ctx = {
        ...helpers,
        ...args,
        scope,
        ...contextPart
      };

      return fn.call(ctx);
    }

    function countErrors(form, counterArg) {
      if (_.isEmpty(form)) {
        return;
      }
      var counter = counterArg || { cnt: 0 };

      angular.forEach(form.$getControls(), function(field) {
        var isForm = !!field.$$controls;

        if (isForm) {
          var nextCounter = { cnt: 0 };
          counter[field.$name] = countErrors(field, nextCounter);
          counter.cnt += counter[field.$name].cnt;
          return;
        }

        counter.cnt += field.$invalid;
      });

      return counter;
    }

    function countGroupErrors(form, groupArgs, errorsCount) {
      let counter = 0;
      if (_.isEmpty(form)) {
        return counter;
      }

      angular.forEach(groupArgs.fieldSchema.fields, function(field) {
        const formControl = form[field.fieldName];
        if (!formControl) {
          return;
        }

        const isForm = !!field.$$controls;
        if (isForm) {
          const { type, fieldName } = field;
          const isArray = ['Array', 'AssociativeArray'].includes(type);
          if (isArray) {
            const arrayData = _.get(groupArgs, `row[${fieldName}]`);
            _.reduce(arrayData, (acc, item, index) => {
              acc += errorsCount[`${fieldName}[${index}]`];
              return acc;
            }, counter);
          }
          counter += errorsCount[fieldName];
        } else {
          counter += formControl.$invalid;
        }
      });

      return counter;
    }

    function setFormDirty(form) {
      _forEachAngularFormField(form, function (field) {
        field.$setDirty();
      });
    }

    function getErrorCounter(errorCntObj, args, index) {
      var path = _.isNumber(index) ?
        args.path + '[' + index + ']' :
        args.path;

      var formPath = path.split('.');
      formPath.push('cnt');

      return _.get(errorCntObj, formPath, 0);
    }

    function addDefaultValuesForInvisibleFields(originalArgs) {
      var argsCopy = _.cloneDeep(originalArgs);

      AdpFormIteratorUtils.traverseFormDataPostOrder(argsCopy, function (currArgs) {
        var type = currArgs.fieldSchema.type;
        var skipComplex = ['Object', 'Array', 'AssociativeArray'].includes(type);
        if (skipComplex) {
          return;
        }

        _setDefaultValue(argsCopy, currArgs);
      });

      return argsCopy;
    }

    function _setDefaultValue(rootArgs, fieldArgs) {
      if (!_.get(fieldArgs, 'fieldSchema.showInGraphql')) {
        return;
      }
      const isVisible = ShowExpression.evalShowForField(fieldArgs);
      if (isVisible) {
        return;
      }

      const isRequired = RequiredExpression.evalExpr(fieldArgs);
      if (!isRequired) {
        return;
      }

      var defaultValue = _.get(fieldArgs, 'fieldSchema.default');
      if (_.isUndefined(defaultValue)) {
        return;
      }

      _.set(rootArgs.row, fieldArgs.path, defaultValue);
    }

    function getDefaultsForFields(args) {
      const row = {};
      const { fields } = args.fieldSchema;

      _.each(fields, (field, name) => {
        const nextArgs = AdpUnifiedArgs.next(args, name);
        const isVisible = ShowExpression.evalShowForField(nextArgs);
        const isArray = ['Array', 'AssociativeArray'].includes(field.type);

        if (field.type === 'Object') {
          row[name] = getDefaultsForFields(nextArgs);
          return;
        }

        // skipping array, as this function called inside array control
        if (_.isUndefined(args.data) || isArray || !isVisible || field.default === undefined) {
          return;
        }

        row[name] = field.default;
      });

      return row;
    }

    function handleFileUpload(scope) {
      if (scope.uploaderCnt === 0) {
        return $q.when();
      }

      var uploadersFinished = 0;

      return $q(function (resolve, reject) {
        var removeEndListenerFn = scope.$on('adpFileUploadComplete', onUploadComplete);
        var removeErrorListenerFn = scope.$on('adpFileUploadError', onUploadError);
        scope.$broadcast('adpFileUploadStart');

        function onUploadComplete() {
          uploadersFinished++;

          if (uploadersFinished >= scope.uploaderCnt) {
            removeListeners();
            resolve();
          }
        }

        function onUploadError(_e, response) {
          removeListeners();
          reject(new UploadError(response.message));
        }

        function removeListeners() {
          removeEndListenerFn();
          removeErrorListenerFn();
        }
      });
    }

    function scrollToError(form) {
      setFormDirty(form);
      const firstFieldWithError = document.querySelector('.ng-invalid[ng-model]');
      const $errorNode = $(firstFieldWithError).closest('adp-form-field-container');
      const $ngForm = $($errorNode).closest('ng-form');
      let $scrollTarget;

      $scrollTarget = $ngForm.length > 0 ? $ngForm : $errorNode;

      let $scrollContainer = $('[uib-modal-window="modal-window"]');
      let scrollPos;

      if ($scrollContainer.length === 0) {
        scrollPos = $scrollTarget.offset().top;
        $scrollContainer = $('html, body');
      } else {
        scrollPos = $scrollTarget.offset().top - $scrollContainer.offset().top + $scrollContainer.scrollTop()
      }

      $($scrollContainer).animate({
        scrollTop: scrollPos
      }, 300);
    }

    return {
      getGroupingType,
      groupHasErrors,
      groupCompleted,
      setGroupDirty,
      handleOnGroupActivateEnd,
      handleOnGroupActivateBegin,
      forceValidation,
      countErrors,
      setFormDirty,
      getErrorCounter,
      addDefaultValuesForInvisibleFields,
      getDefaultsForFields,
      countGroupErrors,
      handleFileUpload,
      scrollToError,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpListsService', AdpListsService);

  function AdpListsService(
    ErrorHelpers,
    APP_CONFIG,
    AdpPath,
    $http,
    AdpNotificationService
  ) {
    function getDataSource(args, skipFirstLoad) {
      if (isAsync(args)) {
        return getAsyncListDataSource(args, skipFirstLoad);
      }

      var list = _.get(args, 'fieldSchema.list.values');
      return formatList(list, args);
    }

    function isAsync(args) {
      return isFrontendList(args) || isDynamic(args);
    }

    function isFrontendList(args) {
      return ['FrontendList', 'FrontendList[]'].includes(args.fieldSchema.type);
    }

    function isDynamic(args) {
      return !!args.fieldSchema.list.dynamic;
    }

    function isGrouped(args) {
      return _.get(args, 'fieldSchema.list.advanced.grouped');
    }

    function getAsyncListDataSource(args, skipFirstLoad) {
      let isFirstLoad = true;

      const dsConfig = {
        load(loadOptions) {
          // WORKAROUND: dx for some reason is making request after instanciating dxTagBox
          // so no to break our control we need to skip first load
          if (skipFirstLoad && isFirstLoad) {
            isFirstLoad = false;
            return Promise.resolve(ds.items());
          }

          const paginated = !!_.get(args, 'fieldSchema.list.advanced.paginate');
          const pageParams = paginated ? getPageParams(loadOptions) : null;
          return Promise.resolve(requestAsyncList(args, pageParams))
            .then(list => {
              const loadedList = formatList(list, args);
              const { searchValue } = loadOptions;

              if (searchValue) {
                return searchInList(searchValue, loadedList, args)
              }

              return loadedList;
            })
            .catch(error => {
              ErrorHelpers.handleError(error, 'Error trying to get list value from remote.');
            });
        },
      };
      dsConfig.paginate = !!_.get(args, 'fieldSchema.list.advanced.paginate');
      const perPage = _.get(args, 'fieldSchema.list.advanced.perPage');

      if (perPage) {
        dsConfig.pageSize = perPage;
      }

      const ds = new DevExpress.data.DataSource(dsConfig);

      return ds;
    }

    function getPageParams(loadOptions) {
      const { perPage } = loadOptions;
      const getPage = (params) => {
        const page = Math.floor(params.skip / params.take) + 1;
        return _.isNaN(page) ? 1 : page;
      }

      return {
        page: getPage(loadOptions),
        perPage: perPage,
      };
    }

    function requestAsyncList(args, loadOptions) {
      if (isFrontendList(args)) {
        return callFrontendListFn(args, loadOptions);
      }

      return requestDynamicList(args, loadOptions);
    }

    function callFrontendListFn(args, loadOptions) {
      const listName = args.fieldSchema.list.name;
      const fn = _.get(window.appModelHelpers, ['FrontendLists', listName]);
      const helperArgs = { loadOptions, ...args };

      try {
        return fn.call(helperArgs);
      } catch (e) {
        ErrorHelpers.handleError(e, 'Error trying to call FrontendLists for: ', args);
      }
    }

    function requestDynamicList(args, loadOptions) {
      return requestList(endpointWithParams(args, loadOptions));
    }

    function requestList(endpoint) {
      return $http.get(endpoint)
        .then(function (res) {
          return _.get(res, 'data.data', {});
        });
    }

    function endpointWithParams(args, loadOptions) {
      var schemaPath = AdpPath.schemaPath(args.path, args.modelSchema);
      var fullSchemaPath = args.modelSchema.schemaName + '.fields.' + schemaPath;

      var action = args.action;

      return [endpoint(fullSchemaPath, action), evalListParams(args, loadOptions)].join('&');
    }

    function endpoint(schemaPath, action) {
      var queryParams = { listFieldPath: schemaPath, action: action };
      return [APP_CONFIG.apiUrl, 'getList'].join('/') + '?' + objToQueryString(queryParams);
    }

    function objToQueryString(obj) {
      return _.entries(obj)
        .map(function (entry) {
          return entry.join('=');
        })
        .join('&');
    }

    function evalListParams(args, loadOptions) {
      var paramsString = _.get(args, 'fieldSchema.list.dynamic.params', null);
      var unified = Object.assign({ loadOptions }, args);
      if (paramsString) {
        try {
          var urlPart = ejs.render(paramsString, { context: unified });
          return 'listParams'.concat('=', encodeURIComponent(urlPart));
        } catch (e) {
          console.error('Error while try evaluate .ejs template params for list with args: ', unified, e);
        }
      }
    }

    function formatList(list, args) {
      if (!hasCorrectFormat(list, args)) {
        notifyIncorrectFormat(args);
        return [];
      }

      if (isGrouped(args)) {
        return formatGroupedList(list, args);
      }

      return formatListOfStrings(list, args);
    }

    function hasCorrectFormat(list, args) {
      if (_.isEmpty(list)) {
        return true;
      }

      if (isGrouped(args) && _.some(list, _.negate(_.isPlainObject))) {
        return false;
      }

      return true;
    }

    function notifyIncorrectFormat(args) {
      AdpNotificationService.notifyError('Incorrect list format for field by path: ', args.path);
    }

    function formatGroupedList(list) {
      return _.chain(list)
        .map(function(item, key) {
          return _.merge({ value: key }, item);
        })
        .groupBy('group')
        .map(function (item, groupName) {
          return { key: groupName, items: item };
        })
        .value();
    }

    function formatListOfStrings(list, args) {
      var listMapper = (value, key) => ({ value: key, label: value });
      return _.map(list, listMapper);
    }

    function getListValueByLabel(values, list) {
      var valuesToSearch = _.isArray(values) ? values : [values];

      var foundLabels = _.map(valuesToSearch, function (value) {
        return _.findKey(list, function (item) {
          return item === value;
        })
      });

      return _.compact(foundLabels);
    }

    function searchInList(query = '', list = [], args) {
      const searchHelper = (searchQuery, listToSearch) => _.filter(listToSearch, ({ label = '' }) => {
        const loweredLabel = label.toLowerCase();
        const loweredQuery = searchQuery.toLowerCase();
        return _.includes(loweredLabel, loweredQuery);
      });

      if (isGrouped(args)) {
        const filtered = _.map(list, ({ items, key }) => {
          return { key, items: searchHelper(query, items) };
        });

        return _.filter(filtered, ({ items }) => items.length);
      }

      return searchHelper(query, list);
    }

    return {
      getDataSource: getDataSource,
      requestDynamicList: requestDynamicList,
      getListValueByLabel: getListValueByLabel,
      isAsync: isAsync,
      isGrouped: isGrouped,
      formatList: formatList,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpRecordMeta', AdpRecordMeta);

  function AdpRecordMeta() {
    function set(args, path, value) {
      var _meta = _.get(args, 'row._meta') || {};
      _.set(args, 'row._meta', _meta);
      _.set(_meta, path, value);
    }

    function get(args, path) {
      var _meta = _.get(args, 'row._meta') || {};
      return _.get(_meta, path);
    }

    function unset(args, path) {
      _.unset(args, path);
    }

    function unsetArrayItem(args, path, index) {
      const arraysMeta = get(args, path);
      arraysMeta && arraysMeta.splice(index, 1);
    }

    return {
      set,
      get,
      unset,
      unsetArrayItem,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ControlSetterGetter', ControlSetterGetter);

  function ControlSetterGetter() {
    return function (args) {
      return function (val) {
        if (arguments.length) {
          setData(args, val);
        }

        return getData(args);
      }
    }

    function setData(args, value) {
      _.set(args.row, args.path, value);
      // args.data ref to args.row should became stale, because args.row mutated on every change
      // updating args.data to keep it fresh
      args.data = getData(args);
      handleOnValueChange(args);
    }

    function getData(args) {
      return _.get(args.row, args.path);
    }

    function handleOnValueChange(args) {
      const helpers = _.get(window, 'appModelHelpers.OnValueChanged') || {};
      const helperString = _.get(args, 'fieldSchema.events.onValueChanged');
      if (!helperString) {
        return;
      }
      const onValueChanged = new Function(helperString);
      const ctx = {
        set(path, val) {
          _.set(args.row, path, val);
        },
        ...helpers,
        ...args,
      };

      onValueChanged.call(ctx);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('RequiredExpression', RequiredExpression);

    function RequiredExpression(
    AdpValidationUtils,
    AdpFormIteratorUtils,
    AdpFormDataUtils,
    AdpUnifiedArgs,
    AdpPath
  ) {
    return {
      eval: evaluateRequiredStatus,
      evalExpr: evalRequiredExpr,
    }

    function evaluateRequiredStatus(options) {
      const args = options.args;
      const form = options.form;
      const requiredMap = options.requiredMap;

      const argsWithCleanedRow = AdpFormDataUtils.cleanFormDataAndKeepArraysPositions(args);

      AdpFormIteratorUtils.traverseFormDataPostOrder(args, (currArgs) => {
        const { type } = currArgs.fieldSchema;
        if (type === 'Schema') {
          return;
        }

        const currentArgsForRequired = getArgsForStep(argsWithCleanedRow, currArgs);
        _evalRequiredStatus(currentArgsForRequired, requiredMap);
      });

      const originalRow = _.cloneDeep(args.row);
      const formRequiredState = _.clone(requiredMap);
      AdpFormIteratorUtils.traverseFormDataInOrder(args, (currArgs, isArrayRoot) => {
        const currentArgsForRequired = getArgsForStep(argsWithCleanedRow, currArgs);
        currentArgsForRequired.originalRow = originalRow;

        if (isArrayRoot) {
          setRequiredStatusForArrayRoot(currentArgsForRequired, requiredMap)
          return;
        }

        const { type } = currentArgsForRequired.fieldSchema;
        const isComplex = ['Array', 'Object', 'AssociativeArray'].includes(type);

        if (isComplex) {
          _evalRequiredStatusForObjectChildren(currentArgsForRequired, form, requiredMap, formRequiredState);
        }
      });
    }

    function getArgsForStep(argsWithCleanedRow, currArgs) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        formData: argsWithCleanedRow.row,
        schema: currArgs.modelSchema,
        path: currArgs.path,
        action: currArgs.action,
      });
    }

    function _evalRequiredStatus(args, requiredMap) {
      var requiredFn = AdpValidationUtils.getRequiredFn(args);

      try {
        requiredMap[args.path] = requiredFn();
      } catch (e) {
        requiredMap[args.path] = false;
        console.error('Error while evaluating required condition for: ', args, e);
      }
    }

    function evalRequiredExpr(args) {
      var fn = AdpValidationUtils.getRequiredFn(args);

      try {
        return !!fn();
      } catch (e) {
        console.error('Failed to eval required condition for: ', args, e);
        return false;
      }
    }

    function _evalRequiredStatusForObjectChildren(objArgs, form, requiredMap, formRequiredState) {
      const isObjectRequired = formRequiredState[objArgs.path];
      const isFirstLevelObject = objArgs.path.split('.').length === 1;

      const updateRequiredState = (args, updateCb) => {
        forEachObjectField(args, (objFieldArgs) => {
          const { fieldSchema: { type } } = objFieldArgs;
          if (['Array', 'AssociativeArray', 'Object'].includes(type)) {
            updateCb(objFieldArgs);
          }
        });
      }

      if (isFirstLevelObject && isObjectRequired) {
        return;
      }

      setKeyFieldRequiredStatus(objArgs, form, formRequiredState);

      if (isObjectRequired && _hasRequiredFieldsInObject(objArgs, formRequiredState)) {
         updateRequiredState(objArgs, ({ path }) => {
           formRequiredState[path] = true;
         });

         return;
      }

      if (_hasRequiredFieldsInObject(objArgs, requiredMap) && objArgs.data) {
        // not empty and has required child
        updateRequiredState(objArgs, ({ path }) => {
          formRequiredState[path] = requiredMap[path];
        });
      }

      if (_.isNil(objArgs.data)) {
        _skipRequiredValidationForChildFields(objArgs, form);
        updateRequiredState(objArgs, ({ path }) => {
          formRequiredState[path] = false;
        });
      }
    }

    function _hasRequiredFieldsInObject(args, formRequiredState = {}) {
      const { fieldSchema: { fields } } = args;

      const result = _.find(fields, (field, name) => {
        const nextPath = AdpPath.next(args.path, name);
        return formRequiredState[nextPath];
      });

      return Boolean(result);
    }

    function _skipRequiredValidationForChildFields(args, form) {
      forEachObjectField(args, (fieldArgs) => {
        setFieldRequiredValidity(fieldArgs, form);
      });
    }

    function forEachObjectField(objArgs, callback) {
      const forEachField = (args, cb) => {
        _.each(args.fieldSchema.fields, (field, fieldName) => {
          const childArgs = AdpUnifiedArgs.next(args, fieldName);
          cb(childArgs);
        });
      }

      const { fieldSchema: { type } } = objArgs;
      if (type === 'Object') {
        forEachField(objArgs, callback);
      } else if (['Array', 'AssociativeArray'].includes(type)) {
        forEachField(objArgs, (childArgs) => {
          const childType = childArgs.fieldSchema.type;
          if (['Array', 'AssociativeArray'].includes(childType)) {
            const arrayData = _.get(objArgs.originalRow, childArgs.path, [{}]);
            _.each(arrayData, (_d, index) => {
              const path = `${childArgs.path}[${index}]`;
              const arrayChildArgs = _.assign({}, childArgs, { path });
              arrayChildArgs.data = _.get(arrayChildArgs.row, arrayChildArgs.path);

              callback(arrayChildArgs);
            });
          } else {
            callback(childArgs);
          }
        });
      }
    }

    function setFieldRequiredValidity(args, form, validity = true) {
      const formField = _.get(form, args.path.split('.'), null);
      const notInDOM = formField === null;

      if (notInDOM) {
        return;
      }

      formField.$setValidity('required', validity);
    }

    function setKeyFieldRequiredStatus(args, form, formRequiredState) {
      if (args.fieldSchema.type !== 'AssociativeArray') {
        return;
      }

      const isParentRequired = formRequiredState[args.path];
      if (isParentRequired) {
        return;
      }

      var fieldPathInForm = args.path.split('.').concat('$key');
      var formField = _.get(form, fieldPathInForm, null);

      var notInDOM = formField === null;
      if (notInDOM) {
        return;
      }

      if (formField.$viewValue) {
        formField.$setValidity('required', true);
        return;
      }

      formField.$setValidity('required', _.isNil(args.data));
    }

    function setRequiredStatusForArrayRoot(args, formRequiredState) {
      let fields = args.fieldSchema.fields;
      if (args.fieldSchema.type === 'KeyVal') {
        const { _key, _value } = args.fieldSchema;
        fields = { _key, _value };
      }
      const isRootRequired = formRequiredState[args.path];

      const hasRequiredChildren = _.find(fields, (field, fieldName) => {
        const childArgs = AdpUnifiedArgs.next(args, fieldName);
        return evalRequiredExpr(childArgs);
      });

      formRequiredState[args.path] = isRootRequired && !!hasRequiredChildren;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ShowExpression', ShowExpression);

  function ShowExpression() {
    return {
      evalShowForField,
    }

    function evalShowForField(args) {
      const expr = args.fieldSchema.showInForm || args.fieldSchema.show;
      if (expr === true) {
        return true;
      }

      try {
        const showFn = _createShowFnByPath(expr, args);
        return !!showFn();
      } catch (e) {
        console.error('Failed to call show expression with err ', e, 'for field ', args);
        return false;
      }
    }

    function _createShowFnByPath(expr, args) {
      // DEPRECATION NOTICE
      // functions arguments are provided to ShowExpression as context params available as this.argName
      // other arguments provided for compatibility reasons, DO NOT USE THEM: will obsolete soon
      return new Function('data, row, fieldSchema, $action', 'return ' + expr)
        .bind(args, args.data, args.row, args.fieldSchema, args.action);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpFieldFormatUtil', AdpFieldFormatUtil);

  // DEPRECATED
  function AdpFieldFormatUtil() {
    // public
    function formatSelectLabel(state) {
      // if option group
      if (!state.id) return state.text;

      var parsedState = state.text;

      return _.isObject(parsedState.label) ? getFormattedLabel(parsedState.label) : parsedState.label;
    }

    // public
    function formatSelectSelection(state) {
      var parsedState = JSON.parse(state.text);
      return _.isObject(parsedState.label) ? parsedState.label.name : parsedState.label;
    }

    function getFormattedLabel(label) {
      return [
        _labelNameTpl(label),
        _definitionTpl(label)
      ].join('');
    }

    function _labelNameTpl(label) {
      return ['<span>', label.name, '</span>'].join('')
    }

    function _definitionTpl(label) {
      return label.definition ? [
        '<br>',
        '<small>' + label.definition + '</small>'
      ].join('') : '';
    }

    return {
      formatSelectLabel: formatSelectLabel,
      formatSelectSelection: formatSelectSelection
    };
  }
})();;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpFormDataUtils', AdpFormDataUtils);

  function AdpFormDataUtils(
    AdpFormIteratorUtils,
    ArrayColorUtil,
    $injector
  ) {
    return {
      transformDataBeforeSending,
      cleanFormDataAndKeepArraysPositions,
    };

    function transformDataBeforeSending(rootArgs) {
      var cleanUpStrategies = {
        'Object': _cleanObjectBeforeSending,
        'Array': _cleanArrayItemBeforeSending,
        'AssociativeArray': _cleanAssociativeArrayItemBeforeSending,
        'AssociativeArrayRoot': _cleanAssociativeArrayRootBeforeSending,
        'ArrayRoot': _cleanArrayRootBeforeSending,
        'KeyVal': _cleanKeyVal,
        'Schema': _cleanObjectInPlace,
        'TreeSelector': _cleanTreeSelectorBeforeSending,
        'LookupObjectID': _cleanLookup,
        'LookupObjectID[]': _cleanLookupMulti,
        'Location': _transformLocation,
        'default': _cleanPrimitiveValue,
      };

      return cleanFormData(rootArgs, cleanUpStrategies);
    }

    // using option clearEmptyOnly to keep items in positions
    // example
    // real data: { array: [{...}, {object: {...}}, {...}] }
    // cleaned copy: { array: [null, null, {}] }
    // to check if item in path 'array[2]' is empty, we need to keep empty items in its positions
    function cleanFormDataAndKeepArraysPositions(rootArgs) {
      var cleanUpStrategies = {
        'Object': _cleanObject,
        'Array': _cleanArrayItem,
        'ArrayRoot': _cleanArrayRoot,
        'AssociativeArray': _cleanAssociativeArrayItem,
        'AssociativeArrayRoot': _cleanArrayRoot,
        'Schema': _cleanObjectInPlace,
        'TreeSelector': _cleanTreeSelector,
        'Location': _transformLocation,
        'default': _cleanPrimitiveValue,
      };

      return cleanFormData(rootArgs, cleanUpStrategies);
    }

    function cleanFormData(rootArgs, cleanUpStrategies) {
      if (_.isNil(rootArgs.row)) {
        return;
      }

      var rootArgsCopy = _.assign({}, rootArgs, { row: _.cloneDeep(rootArgs.row) });
      var RequiredExpression = $injector.get('RequiredExpression');

      var cleanUpCb = function (currArgs, isArrayRoot) {
        var type = currArgs.fieldSchema.type;
        var cleanupStrategy = isArrayRoot && (type === 'Array' || type === 'AssociativeArray') ?
          cleanUpStrategies[type + 'Root'] :
          (cleanUpStrategies[type] || cleanUpStrategies.default);

        var isRequired = RequiredExpression.evalExpr(currArgs);
        cleanupStrategy && cleanupStrategy(currArgs, isRequired, isArrayRoot);
      };

      AdpFormIteratorUtils.traverseFormDataPostOrder(rootArgsCopy, cleanUpCb);

      return rootArgsCopy;
    }

    function _cleanObjectBeforeSending(args, isRequired) {
      _cleanObjectInPlaceBeforeSending(args, isRequired);
      const data = _.get(args.row, args.path) || {};
      if (!_.isEmpty(data)) {
        return;
      }

      const isFirstLevel = args.path.split('.').length === 1;
      if (isFirstLevel && isRequired) {
        _.set(args.row, args.path, {});
      } else {
        _.unset(args.row, args.path);
      }
    }

    function _cleanObject(args) {
      _cleanObjectInPlace(args);
      const data = _.get(args.row, args.path) || {};

      if (_.isEmpty(data)) {
        _.set(args.row, args.path, null);
      }
    }

    function _cleanArrayItem(args) {
      _cleanObjectInPlace(args);
      const data = _.get(args.row, args.path) || {};
      const dataWithoutId = _.omit(data, ['_id']);

      if (_.isEmpty(dataWithoutId)) {
        _.set(args.row, args.path, null);
      }
    }

    function _cleanArrayItemBeforeSending(args) {
      _cleanObjectInPlaceBeforeSending(args);
      const data = _.get(args.row, args.path) || {};
      const { _id, ...dataWithoutId} = data;

      if (_.isEmpty(dataWithoutId)) {
        _.set(args.row, args.path, null);
      }
    }

    function _cleanAssociativeArrayItem(args) {
      _.unset(args.row, args.path + '._id');
      _.unset(args.row, args.path + '.$key');
      _cleanObjectInPlace(args);

      const data = _.get(args.row, args.path) || {};
      const isEmpty =_.isEmpty(data);
      isEmpty && _.set(args.row, args.path, null);
    }

    function _cleanAssociativeArrayItemBeforeSending(args) {
      _cleanObjectBeforeSending(args);

      const data = _.get(args.row, args.path) || {};
      const { _id, $key, ...dataWithoutIdAndKey} = data;

      if (_.isEmpty(dataWithoutIdAndKey)) {
        _.set(args.row, args.path, null);
      }
    }

    function _cleanArrayRootBeforeSending(args, isRequired) {
      const arrayFormData = pullEmptyItemsFromArray(args);

      if (!_.isEmpty(arrayFormData)) {
        return;
      }

      const isFirstLevel = args.path.split('.').length === 1;
      if (isFirstLevel && isRequired) {
        _.set(args.row, args.path, [{}]);
      } else {
        _.unset(args.row, args.path);
      }
    }

    function pullEmptyItemsFromArray(args) {
      const arrayPath = getArrayPath(args.path);
      const arrayFormData = _.get(args.row, arrayPath);

      const indexesToRemove = _.reduce(arrayFormData, (indexes, val, idx) => {
        if (val === null) {
          indexes.push(idx);
        }

        return indexes;
      }, []);
      _.pullAt(arrayFormData, indexesToRemove);

      if (args.action !== 'apply') {
        const colors = _.get(args.row, ArrayColorUtil.getPathToColor(args.path));
        _.pullAt(colors, indexesToRemove);
      }

      return arrayFormData;
    }

    function _cleanKeyVal(args, isRequired, isRoot) {
      if (!isRoot) {
        return;
      }
      const data = _.get(args.row, args.path) || [];
      if (_.isEmpty(data)) {
        if (!isRequired) {
          _.unset(args.row, args.path);
        }
        return;
      }
      const keyValData = {};
      _.each(data, ({ _key, _value = null }) => {
        _key && (keyValData[_key] = _value);
      });
      _.set(args.row, args.path, keyValData);
    }

    function _cleanArrayRoot(args) {
      var arrayPath = getArrayPath(args.path);
      var arrayFormData = _.get(args.row, arrayPath);

      var containsNullsOnly = _.every(arrayFormData, _.isNull);
      containsNullsOnly && _.set(args.row, arrayPath, null);
    }

    function _cleanAssociativeArrayRootBeforeSending(args, isRequired) {
      const arrayData = pullEmptyItemsFromArray(args);
      const arrayPath = getArrayPath(args.path);

      if (_.isEmpty(arrayData)) {
        const isFirstLevel = args.path.split('.').length === 1;
        const emptyValue = (isRequired && isFirstLevel) ? {} : null;
        _.set(args.row, arrayPath, emptyValue);
      } else {
        var result = {};
        _.each(arrayData, function (item, key) {
          var itemKey = item.$key || key;
          result[itemKey] = _.omit(item, ['$key']);
        });

        _.set(args.row, arrayPath, result);
      }
    }

    function _cleanTreeSelectorBeforeSending(args) {
      var value = _.filter(args.data, function (v) {
        return !_.isEmpty(v);
      });

      var valueToSet = value.length ? value : null;
      args.parentData && _.set(args.row, args.path, valueToSet);
    }

    function _cleanTreeSelector(args) {
      var valueToSet = _.last(args.data).isLeaf ? args.data : null;
      args.parentData && _.set(args.row, args.path, valueToSet);
    }

    function _cleanLookupMulti(args) {
      const data = _.get(args.row, args.path) || [];
      const isEmpty = _.every(data, _.isEmpty);
      isEmpty && _.unset(args.row, args.path);
    }

    function _cleanLookup(args) {
      const data = _.get(args.row, args.path) || {};
      _.isEmpty(data) && _.unset(args.row, args.path);
    }

    function _cleanPrimitiveValue(args) {
      var mediaTypes = ['File', 'Image', 'Audio', 'Video', 'File[]', 'Image[]', 'Audio[]', 'Video[]'];
      var isMedia = _.includes(mediaTypes, args.fieldSchema.type);

      var isEmpty = isMedia ?
        _.isEmpty(args.data) :
        _.isNil(args.data) || args.data === '';

      (isEmpty && args.parentData) && _.set(args.row, args.path, null);
    }

    function _transformLocation(args) {
      const coordinates = _.get(args, 'data.coordinates') || [];
      if (_.isEmpty(coordinates)) {
        _.set(args.row, args.path, null);
        return;
      }
    }

    function _cleanObjectInPlace(args) {
      const object = _.get(args.row, args.path, args.row);
      const { type } = args.fieldSchema;
      const shouldUnset = (v) => {
        return _.isNull(v) || (type !== 'Schema' && v === false);
      }
      _.each(object, (v, k) => {
        shouldUnset(v) && _.unset(object, k);
      });
    }

    function _cleanObjectInPlaceBeforeSending(args) {
      const original = _.get(args.row, args.path) || {};
      const dataWithoutIdAndKey = _.filter(original, (v, key) => {
        return key !== '_id' && key !== '$key' && v !== null;
      });

      const hasOnlyFalseValues = _.every(dataWithoutIdAndKey, v => v === false);
      const shouldUnset = hasOnlyFalseValues ?
        (v) => v === null || v === false :
        (v) => v === null;

      _.each(original, (v, k) => {
        shouldUnset(v) && _.unset(original, k);
      });
    }

    function getArrayPath(path) {
      var indexRe = /\[\d+\]$/;
      return path.replace(indexRe, '');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpFormIteratorUtils', AdpFormIteratorUtils);

  function AdpFormIteratorUtils(
    AdpUnifiedArgs
  ) {
    function traverseFormDataPostOrder(args, callback) {
      _.each(args.fieldSchema.fields, (currentField) => {
        const currArgs = AdpUnifiedArgs.next(args, currentField.fieldName);
        const { type } = currArgs.fieldSchema;

        if (_typeOfObject(type)) {
          traverseFormDataPostOrder(currArgs, callback);
        } else if (_typeOfArray(type)) {
          _.each(currArgs.data, (_d, index) => {
            const path = `${currArgs.path}[${index}]`;
            const currArrayArgs = _.assign({}, currArgs, { path });
            currArrayArgs.data = _.get(currArrayArgs.row, currArrayArgs.path);

            traverseFormDataPostOrder(currArrayArgs, callback);
          });

          callback(currArgs, true);
        } else {
          callback(currArgs);
        }
      });

      callback(args);
    }

    function traverseFormDataInOrder(args, callback) {
      // root
      callback(args);

      _.each(args.fieldSchema.fields, ({ fieldName }) => {
        const currArgs = AdpUnifiedArgs.next(args, fieldName);
        const { type } = currArgs.fieldSchema;
        const isComplex = _typeOfObject(type) || _typeOfArray(type);
        if (!isComplex) {
          callback(currArgs, _typeOfArray(type));
        }

        if (_typeOfObject(type)) {
          traverseFormDataInOrder(currArgs, callback);
        } else if (_typeOfArray(type)) {
          _.each(currArgs.data, (_d, index) => {
            const path = `${currArgs.path}[${index}]`;
            const currArrayArgs = _.assign({}, currArgs, { path });
            currArrayArgs.data = _.get(currArrayArgs.row, currArrayArgs.path);

            traverseFormDataInOrder(currArrayArgs, callback);
          });

          callback(currArgs, true);
        }
      });
    }

    function _typeOfObject(type) {
      return type === 'Object';
    }

    function _typeOfArray(type) {
      return ['Array', 'AssociativeArray', 'KeyVal'].includes(type);
    }

    return {
      traverseFormDataPostOrder,
      traverseFormDataInOrder,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpPath', AdpPath);

  function AdpPath() {
    function next(path, key, index) {
      if (path) {
        var _path = _.isNil(index) ? path : path + '[' + index + ']';

        return [_path, key].join('.');
      } else {
        return key;
      }
    }

    function schemaPath(dataPath, schema) {
      var strPath = _.isArray(dataPath) ? dataPath.join('.') : dataPath;
      var path = strPath.replace(/\[\d+\]/g, '')
        .split('.')
        .filter(function (v) {
          return !!v;
        });

      // Objects and KeyVal both may have path ending with '_key' or '_val'
      // So we need to find out which path to return: 'prePath.fields._key' (for Object) or 'prePath._key' (for KeyVal)
      var lastField = _.last(path);
      var isPossibleKeyValPath = ['_key', '_value'].includes(lastField);
      if (isPossibleKeyValPath) {
        var pathWithoutLast = _.dropRight(path, 1).join('.fields.');
        var schemaPathToKeyVal = 'fields.' + pathWithoutLast + '.type';
        if (_.get(schema, schemaPathToKeyVal) === 'KeyVal') {
          return pathWithoutLast + '.' + lastField;
        }
      }

      return path.join('.fields.');
    }

    /**
     * Get parent path from current
     * @param fieldSchema
     * @param path
     *
     * Examples:
     * Arrays
     * a1[0].a2[0].a3[0].s3 => a1[0].a2[0].a3[0]
     * a1[0].a2[0].a3[0] => a1[0].a2[0]
     * a1[0].s1 => a1[0]
     *
     * Object
     * a1[0].o2.s3 => a1[0].o3
     *
     * @returns {String|null}
     */
    function parent({ fieldSchema, path }) {
      if (_.isNull(path)) {
        return null;
      }

      var parentPath = _.dropRight(path.split('.'), 1);

      if (_.isEmpty(parentPath)) {
        return null;
      }

      return parentPath.join('.');
    }

    return {
      next: next,
      parent: parent,
      schemaPath: schemaPath,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpQueryParams', AdpQueryParams);

  function AdpQueryParams(
    AdpFieldsService,
    AdpListsService,
    AdpValidationUtils
  ) {
    var typeResolvers = {
      'String': _string,
      'String[]': _string,
      'Text': _string,
      'Email': _string,
      'Phone': _string,
      'List[]': _list,
      'List': _list,
      'Number': function (item) {
        var parsed = Number(item);

        return _.isNaN(parsed) ? null : parsed;
      },
      'Boolean': function (item) {
        if (item === '1' || item === 'true') {
          return true;
        } else if (item === '0' || item === 'false') {
          return false;
        } else {
          return null;
        }
      },
      'Date': _date,
      'DateTime': _date,
      'Time': _date,
      'ImperialHeight': _imperialUnit,
      'ImperialWeight': function (item, field) {
        var val = _imperialUnit(item, field);
        return _.isNil(val) ? val : val[0];
      },
      'ImperialWeightWithOz': _imperialUnit
    };

    function _string(item, field) {
      return field.list ? _list(item, field) : item;
    }

    function _list(item, field) {
      var values = AdpListsService.getListValueByLabel(item, field.list.values);
      if (_.isEmpty(values)) {
        return null;
      }

      return _.endsWith(field.type, '[]') ? values : values[0];
    }

    function _date(item, field) {
      var dateFormat = AdpValidationUtils.getDateFormat(field.type);

      if (AdpValidationUtils.isValidDate(item, field.type)) {
        return dayjs(item, dateFormat).toDate();
      } else {
        return null;
      }
    }

    function _imperialUnit(item, field) {
      var value = item.split('.').map(Number);

      var isValidNumbers = !value.includes(NaN);
      if (!isValidNumbers) {
        return null;
      }

      var units = AdpFieldsService.getUnits(field);
      var firstNotInRange = !_.inRange(value[0], 0, units[0].range[1]);

      if (firstNotInRange) {
        return null;
      }

      if (value[1])  {
        if (_.isUndefined(units[1])) {
          return null;
        }
        var secondNotInRange = !_.inRange(value[1], 0, units[1].range[1]);

        if (secondNotInRange) {
          return null;
        }
      }

      return value;
    }

    function _filterQueryData(schema, data) {
      var typeDefinition = [
        'String',
        'String[]',
        'Boolean',
        'Number',
        'Date',
        'DateTime',
        'Time',
        'ImperialHeight',
        'ImperialWeight',
        'ImperialWeightWithOz',
        'Text',
        'Email',
        'Phone',
        'List',
        'List[]'
      ];

      var skip = function (field, key) {
        if (_.isUndefined(field)) {
          return true;
        }

        if (key === 'action') {
          return true;
        }

        // TODO: add permissions check
        if (!_isVisible(field)) {
          return true;
        }

        var exlusions = ['Password', 'PasswordAuth'];
        var exclude = field.type && exlusions.includes(field.type);

        if (exclude) {
          return false;
        }

        return false;
      };

      var result = {};

      _.each(data,function (item, key) {
        var path = _keyToSchemaPath(key);
        var field = _.get(schema.fields, path);

        if (skip(field, key)) {
          return;
        }

        if (typeDefinition.includes(field.type)) {
          result[key] = item;
        }
      });

      return result;
    }

    function _parseQueryParams(data, schema) {
      return _.mapValues(data, function (item, key) {
        var path = _keyToSchemaPath(key);
        var field = _.get(schema.fields, path);

        return _parseByType(item, field);
      });
    }

    function _keyToSchemaPath(key) {
      return key.replace(/\[.+\]/, '').split('.').join('.fields.')
    }

    function _parseByType(value, field) {
      var resolvedValue = _resolveArrayValue(value, field);
      var conversionFn = typeResolvers[field.subtype] || typeResolvers[field.type];

      if (_.isUndefined(conversionFn)) {
        return resolvedValue;
      } else {
        return conversionFn(resolvedValue, field);
      }
    }

    function _resolveArrayValue(value, field) {
      var typeOfArray = field.type.includes('[]');

      if (typeOfArray && !_.isArray(value)) {
        return [value];
      }

      if (!typeOfArray && _.isArray(value)) {
        return value[0];
      }

      return value;
    }

    function _isVisible(field) {
      return 'showInForm' in field ?
        field.showInForm : field.visible;
    }

    function getDataFromQueryParams(schema, dataFromQuery) {
      var parsedData = _filterQueryData(schema, dataFromQuery);
      parsedData = _parseQueryParams(parsedData, schema);

      if (_.isEmpty(parsedData)) {
        return;
      }

      var result = {};
      _.each(parsedData, function (item, key) {
        _.set(result, key, item);
      });

      return result;
    }

    return {
      getDataFromQueryParams: getDataFromQueryParams
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('visibilityUtils', visibilityUtils);

  function visibilityUtils() {
    function arrayHasVisibleChild(args, formContext) {
      var arrayData = _.get(args.row, args.path);
      if (!_.isArray(arrayData)) {
        return false;
      }

      var found = _.find(formContext.visibilityMap, function (visibility, arrayItemPath) {
        return isArrayItem(args.path, arrayItemPath) ? visibility : false;
      });

      return !!found;
    }

    function isArrayItem(currentArrayPath, arrayPathToCompare) {
      var re = new RegExp('^' + _.escapeRegExp(currentArrayPath) + '\\[\\d+\\]$');
      return re.test(arrayPathToCompare);
    }

    return {
      arrayHasVisibleChild: arrayHasVisibleChild
    };
  }
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpGenerator')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController(AdpSchemaService) {
    var vm = this;
    vm.pageParams = AdpSchemaService.getPageParams();
  }
})();
;(function () {
  "use strict";

  angular
    .module("app.adpGenerator")
    .controller("DatasetController", DatasetController);

  /** @ngInject */
  function DatasetController(
    GraphqlRequest,
    GraphqlCollectionFields,
    MultiRecordPageService,
    AdpSchemaService,
    ResponseError,
    $location,
    $stateParams,
    GraphqlSingleDatasetQuery,
    AdpTitleHelper,
    $scope
  ) {
    var vm = this;
    vm.schema = null;
    vm.loaded = false;
    vm.success = false;

    $scope.$on('datasetSchemaUpdate', function () {
      init();
    });

    init();

    function init() {
      vm.loaded = false;

      GraphqlSingleDatasetQuery($stateParams._id)
        .then(function (schema) {
          vm.success = true;
          vm.schema = _.cloneDeep(schema);
          vm.schema.schemaName = "_ds_" + $stateParams._id;

          const INTERFACE = window.adpAppStore.appInterface();
          AdpTitleHelper.setTitle(`${vm.schema.fullName} | ${INTERFACE.app.title}`);

          MultiRecordPageService(vm.schema, $location.search());
        })
        .catch(function (error) {
          if (error instanceof ResponseError) {
            vm.errorMessage = error.message;
          } else {
            vm.errorMessage = ResponseError.RECORD_NOT_FOUND;
          }
          vm.success = false;
          console.error(error);
        })
        .finally(function () {
          vm.loaded = true;
        });
    }
  }
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpGenerator')
    .controller('MultiRecordController', MultiRecordController);

  /** @ngInject */
  function MultiRecordController(
    MultiRecordPageService,
    AdpSchemaService,
    $location
  ) {
    var vm = this;
    vm.schema = AdpSchemaService.getCurrentSchema();
    MultiRecordPageService(vm.schema, $location.search());
  }
})();
;;(function () {
  "use strict";

  angular
    .module('app.adpGenerator')
    .controller('SingleRecordController', SingleRecordController);

  /** @ngInject */
  function SingleRecordController(
    AdpSchemaService,
    ACTIONS,
    $state,
    $location,
    AdpQueryParams,
    GraphqlCollectionQuery,
    ErrorHelpers,
    AdpUnifiedArgs
  ) {
    var vm = this;
    (function init() {
      vm.ACTIONS = ACTIONS;

      vm.editing = false;
      vm.loading = true;

      setTemplateMethods();

      const schema = AdpSchemaService.getCurrentSchema();
      getPageData(schema)
        .then(() => {
          const isActionFromQueryPerformed = callActionFromQuery();
          if (isActionFromQueryPerformed) {
            return;
          }
          const startInEditMode = _.get(schema, 'parameters.openInEditMode');
          if (startInEditMode) {
            vm.enterEditMode();
          }
        })
    })();

    vm.formOptions = {
      schemaActionsStrategy: {
        onComplete: afterFormUpdate,
        onCancel: afterFormUpdate,
      },
      disableFullscreen: true,
    };

    function afterFormUpdate() {
      getPageData(vm.args.modelSchema)
        .then(vm.cancelEditMode);
    }

    function getPageData(schema) {
      return GraphqlCollectionQuery(schema)
        .then(function (data) {
          return data.items[0] || {};
        })
        .then(updatePageParams)
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error trying to data for query params');
        });
    }

    function updatePageParams(data) {
      vm.formParams = _.get(vm.schema, 'parameters', {});

      var action = _.isEmpty(data) ? ACTIONS.CREATE : ACTIONS.UPDATE;
      vm.args = getArgs(data, action);

      vm.loading = false;
    }

    function getArgs(data, action) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: action,
        formData: data || {},
        schema: _.cloneDeep(AdpSchemaService.getCurrentSchema()),
      });
    }

    function setTemplateMethods() {
      vm.enterEditMode = function () {
        vm.editArgs = _.cloneDeep(vm.args);
        vm.editing = true;
      };

      vm.cancelEditMode = function () {
        vm.editArgs = null;
        vm.editing = false;
      };

      vm.showButton = function(actionToShow) {
        var hasPermission = _.hasIn(vm.args.modelSchema, 'actions.fields.' + actionToShow);
        if (!hasPermission) {
          return false;
        }

        return vm.args.action === actionToShow;
      };
    }

    function callActionFromQuery() {
      var actionFromQuery = $state.params.action;
      if (!actionPermitted(actionFromQuery, vm.args.modelSchema)) {
        return;
      }

      callAction(actionFromQuery, vm.args.modelSchema);
      return true;
    }

    function actionPermitted(name, schema) {
      var pageActions = [ACTIONS.UPDATE, ACTIONS.CREATE];
      var permittedActions = schema.actions.fields || {};

      return pageActions.includes(name) && !!permittedActions[name];
    }

    function callAction(name, schema) {
      var dataFromQuery = AdpQueryParams.getDataFromQueryParams(schema, $location.search());
      vm.editArgs = _.merge({}, vm.args, { row: dataFromQuery });
      vm.editing = true;
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpGenerator')
    .factory('AdpAppModel', AdpAppModel);

  /** @ngInject */
  function AdpAppModel(
    $http,
    $stateRegistry,
    AppGenerator,
    APP_CONFIG,
    AdpLayoutConfigService
  ) {
    return {
      getAppModel: getAppModel
    };

    function getAppModel(userData) {
      var token = userData && userData.token;

      return _request(token)
        .then(function (res) {
          return res.data.data;
        })
        .then(_regenerateApp);
    }

    function _request(token) {
      var endpoint = lsService.isGuest() ? 'build-app-model' : 'app-model';

      var req = {
        method: 'GET',
        url: [APP_CONFIG.apiUrl, endpoint].join('/')
      };

      if (token) {
        req.headers = {
          'Authorization': 'JWT ' + token
        };
      }

      return $http(req);
    }

    function _regenerateApp(data) {
      _.each($stateRegistry.states, function (state) {
        if (_.startsWith(state.name, 'app.')) {
          $stateRegistry.deregister(state.name);
        }
      });

      window.adpAppStore.appModel(data.models);
      window.adpAppStore.appInterface(data.interface);
      window.adpAppStore.mimeTypes(data.mimeTypes);

      setTheme(data);
      AdpLayoutConfigService.updateThemeUI();

      AppGenerator.generateApp();

      return data;
    }

    function setTheme(appModel) {
      const devextremeTheme = _.get(appModel, 'interface.devextremeTheme');

      try {
        DevExpress.ui.themes.current(devextremeTheme);
      } catch (e) {
        console.error('Error while setting dx theme, switching back to default :', e);
        DevExpress.ui.themes.current('generic.light');
      }
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpGenerator')
    .factory('AdpDataService', AdpDataService);

  /** @ngInject */
  function AdpDataService (
    AdpSessionService,
    $http,
    APP_CONFIG
  ) {
    return {
      getDashboardData: getDashboardData,
    };

    // TODO update action for single page controller
    // function getSingleRecordData(params) {
    //   var getUrl = getResourceUrl(params.link);
    //
    //   return $http.get(getUrl)
    //     .then(function (response) {
    //       var data = _.isArray(response.data.data) ? response.data.data[0] : response.data.data;
    //       return data || {};
    //     })
    //     .then(function (data) {
    //       return appDb.schema.set(params.fieldName, data)
    //         .then(function () {
    //           return data;
    //         });
    //     })
    //     .catch(function (err) {
    //       console.warn('Data for fetch ' + params.fieldName + ' failed. Falling back to cache', err);
    //       return appDb.schema.get(params.fieldName)
    //     });
    // }

    // TODO: move to dashboard module
    function getDashboardData (dashboardName) {
      var getUrl = getDashboardUrl(dashboardName);

      return $http.get(getUrl)
        .then(function (res) {
          return res.data.data;
        });
    }

    // TODO: move to dashboard module
    function getDashboardUrl (dashboardName) {
      return APP_CONFIG.apiUrl + '/dashboards/' + dashboardName + '/data';
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpGenerator')
    .factory('AdpGeneratorModalService', AdpGeneratorModalService);

  /** @ngInject */
  function AdpGeneratorModalService(AdpModalService, $timeout) {
    return {
      formModal: formModal,
      formNestedModal: formNestedModal,
      detailsModal: detailsModal,
      defaultActionModal: defaultActionModal,
      showLoader: showLoader,
      hideLoader: hideLoader,
    };

    // Available options
    // options = {
    //   actionTypes: 'create' || 'update',
    //   fields: fields,
    //   data: data,
    //   link: link
    // }
    function formModal(options) {
      var schemaName =  _.get(options, 'args.modelSchema.schemaName', null);
      var formClassName = `adp-model-${schemaName}-form-modal`;
      var loaderId = schemaName ? 'loader-for-form-' + schemaName : null;
      showLoader(loaderId);

      options.windowClass = formClassName;

      return $timeout(function() {
        return AdpModalService.createModal('adpRecordFormModal', options);
      }, 30).then(function (modalInstance) {
        modalInstance.rendered.then(function(res) {
          hideLoader(loaderId);
          makeDraggable();
          setDialogWidth(options.args.modelSchema.dialogWidth);
        });

        return modalInstance.result;
      });
    }

    // Available options
    // options = {
    //   actionTypes: 'create' || 'update',
    //   fields: fields,
    //   data: data,
    //   link: link
    // }
    function formNestedModal(options) {
      var modalInstance = AdpModalService.createModal(
        'adpRecordNestedFormModal',
        _.extend({actionType: 'form'}, options)
      );

      return modalInstance.result;
    }

    // Available options
    // options = {
    //   actionTypes: String,
    //    schema: {}
    //    itemData: {}
    // }
    function detailsModal(options) {
      var modalInstance = AdpModalService.createModal(
        'adpRecordDetailsModal',
        _.extend({actionType: 'view-details'}, options)
      );

      return modalInstance.result;
    }

    function defaultActionModal(options) {
      var modalInstance = AdpModalService.createModal(
        'adpDefaultActionModal',
        _.extend({actionType: 'default-action'}, options)
      );

      return modalInstance.result;
    }

    function showLoader(loaderId, parentContainer) {
      if (!loaderId) {
        return;
      }

      var backdrop = $('<div class="loader-overlay" modal-loader-id="' + loaderId + '">');
      var loader = $('<div class="fa fa-gear fa-spin fa-5x">');
      loader.css({
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      });

      backdrop.append(loader);
      $(parentContainer || document.body).prepend(backdrop);
    }

    function hideLoader(loaderId) {
      if (!loaderId) {
        return;
      }

      var loader = document.querySelector('[modal-loader-id="' + loaderId + '"]');
      loader && $(loader).remove();
    }
  }

  function makeDraggable() {
    const modalContainer = $('[uib-modal-window="modal-window"]').first();
    const modalDialog = modalContainer.find('.modal-content');
    const handle = modalContainer.find('.smart-form-header');
    // todo: add handle class
    // todo: change size of record modal

    modalDialog.resizable({ handles: 'e, w' });
    modalDialog.draggable({
      containment: modalContainer,
      handle,
    });
  }

  function setDialogWidth(dialogWidth) {
    const modalContainer = $('[uib-modal-window="modal-window"] .modal-dialog').first();
    modalContainer.css({ width: dialogWidth });
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpGenerator')
    .factory('MultiRecordPageService', MultiRecordPageService);

  /** @ngInject */
  function MultiRecordPageService(
    GraphqlCollectionQuery,
    ActionsHandlers,
    AdpQueryParams,
    ResponseError,
    ACTIONS,
    $q
  ) {
    return function (schema, queryData) {
      if (!actionPermitted(schema, queryData.action)) {
        return;
      }

      callAction(schema, queryData);
    }

    function actionPermitted(schema, actionName) {
      var pageActions = [
        ACTIONS.VIEW_DETAILS, ACTIONS.UPDATE, ACTIONS.CREATE, ACTIONS.CLONE, ACTIONS.DELETE
      ];

      if (!pageActions.includes(actionName)) {
        return false;
      }

      var permittedActions = schema.actions.fields || {};
      return !!permittedActions[actionName];
    }

    function callAction(schema, queryData) {
      var promise = !!queryData._id ? getRecordById : $q.when;

      promise(queryData._id, schema)
        .then(function (record) {
          callActionByName(schema, queryData, record);
        });
    }

    function getRecordById(id, schema) {
      return GraphqlCollectionQuery(schema, { filter: ['_id', '=', id] })
        .then(function (data) {
          if (_.isNull(data)) {
            throw new ResponseError(ResponseError.RECORD_NOT_FOUND);
          }
          return data.items[0];
        })
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error trying to data for query params');
        });
    }

    function callActionByName(schema, queryData, record) {
      if (queryData.action === ACTIONS.VIEW_DETAILS) {
        ActionsHandlers.viewDetails(schema, record);
      } else {
        callActionForForm(schema, queryData, record);
      }
    }

    function callActionForForm(schema, queryData, record) {
      var dataFromQuery = AdpQueryParams.getDataFromQueryParams(schema, queryData);
      var record = record || {};
      var formData = _.merge({}, record, dataFromQuery);

      ActionsHandlers[queryData.action](schema, formData);
    }
  }
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .factory('AdpAudioTypesService', AdpAudioTypesService);

  var MP3_DEFAULTS = {
    plugins: {
      record: {
        audioEngine: 'lamejs',
        audioWorkerURL: '../workers/lame.worker.js'
      }
    }
  };

  var WEBM_DEFAULTS = {
    plugins: {
      record: {
        audioEngine: 'recordrtc',
        audioWorkerURL: ''
      }
    }
  };

// Javascript ogg vorbis encoder.
  var LIBVORBIS_DEFAULTS = {
    plugins: {
      record: {
        audioEngine: 'libvorbis.js',
        audioWorkerURL: ''
      }
    }
  };

  var WAV_DEFAULTS = {
    plugins: {
      record: {
        audioEngine: 'recorder.js',
        audioWorkerURL: ''
      }
    }
  };

  var TYPE_MAP = {
    'webm': WEBM_DEFAULTS,
    'mp3': MP3_DEFAULTS,
    'ogg': LIBVORBIS_DEFAULTS,
    'wav': WAV_DEFAULTS
  };

  var MIME_TYPES = {
    'webm': ['audio/webm'],
    'mp3': ['audio/mpeg'],
    'ogg': ['audio/ogg'],
    'wav': ['audio/x-wav', 'audio/wav']
  };

  function AdpAudioTypesService(AdpBrowserService) {
    return {
      getSupportedTypes: getSupportedTypes,
      getSupportedTypesNames: getSupportedTypesNames
    };

    function getSupportedTypesNames() {
      return _.keys(getSupportedTypes());
    }

    function getSupportedTypes() {
      var results = {};
      _.each(TYPE_MAP, function (type, key) {
        var supported = MIME_TYPES[key].map(function (type) {
          return AdpBrowserService.isMediaTypeSupported(type);
        });

        if (supported.length) {
          results[key] = TYPE_MAP[key];
        }
      });

      return results;
    }
  }
})();;;(function () {
  angular
    .module('app.adpRecorders')
    .value('AdpAudioRecorderOptions', {
      controls: true,
      width: 640,
      height: 480,
      fluid: true,
      plugins: {
        wavesurfer: {
          src: 'live',
          waveColor: 'red',
          progressColor: '#2E732D',
          debug: true,
          cursorWidth: 1,
          msDisplayMax: 20,
          hideScrollbar: true
        },
        record: {
          audio: true,
          video: false,
          maxLength: 30,
          debug: true,
          audioEngine: 'recordrtc',
          audioWorkerURL: ''
        }
      }
    });
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .value('AdpPhotoRecorderOptions', {
      width: 800,
      height: 600,
      options: {
        controls: true,
        // width, height and aspect ratio  attributes are set in directive depending of screen size
        fluid: true,
        controlBar: {
          volumeMenuButton: false,
          fullscreenToggle: false
        },
        plugins: {
          record: {
            image: true,
            debug: true
          }
        }
      }
    });
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .value('AdpVideoRecorderOptions', {
      controls: true,
      width: 640,
      height: 480,
      fluid: true,
      controlBar: {
        volumeMenuButton: false
      },
      plugins: {
        record: {
          audio: true,
          video: true,
          maxLength: 5
        }
      }
    });
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpUi')
    .directive('adpAccordion', function ($timeout) {
    return {
      restrict: 'A',
      scope: {
        adpAccordionOptions: '='
      },
      link: function (scope, element) {
        var defaults = {
          header: '.adp-form-group-head',
          icons: {
            header: 'fa fa-plus',
            activeHeader: 'fa fa-minus'
          },
          animate : 300,
          fillSpace: false,
          heightStyle: 'auto',
          multiple: true,
        };

        $timeout(function() {
          var options = _.merge(defaults, scope.adpAccordionOptions);
          element.accordion(options);
        });
      }
    }
  });

})();
;;(function () {
  'use strict';

  angular.module('app.adpUi')
    .directive('adpActivitiesDropdownToggle', function() {
      return{
        restrict:'EA',
        link: function($scope, $element){
          var ajax_dropdown = null;

          $element.on('click',function(){
            var badge = $(this).find('.badge');

            if (badge.hasClass('bg-color-red')) {
              badge.removeClass('bg-color-red').text(0);
            }

            ajax_dropdown = $(this).next('.ajax-dropdown');

            if (!ajax_dropdown.is(':visible')) {
              ajax_dropdown.fadeIn(150);
              $(this).addClass('active');
            } else {
              ajax_dropdown.fadeOut(150);
              $(this).removeClass('active');
            }
          });

          $(document).mouseup(function(e) {
            if (ajax_dropdown && !ajax_dropdown.is(e.target) && ajax_dropdown.has(e.target).length === 0) {
              ajax_dropdown.fadeOut(150);
              $element.removeClass('active');
            }
          });
        }
      }
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpHandleHotKeys', adpHandleHotKeys);

  function adpHandleHotKeys(
    AdpModalService
  ) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, element, attrs) {
        const modalDialogSelector = 'div.modal[role=\'dialog\']';
        const isFormButtons = attrs.adpHandleHotKeys === 'form';
        let isDropdownOpened = {};

        $(window).on('keydown', onKeyDown);
        scope.$on('$destroy', () => $(window).off('keydown', onKeyDown));

        if (isFormButtons) {
          scope.$on('adpDropdownState', (event, payload) => {
            const {opened, uid} = payload;
            const key = `id${uid}`;
            if (opened) {
              isDropdownOpened[key] = true;
            } else {
              delete isDropdownOpened[key];
            }
          });
        }

        function onKeyDown(e) {
          const activeElem = document.activeElement;
          const keyCode = e.code;

          if (!_.includes(['Escape', 'Enter'], keyCode)) {
            // This optimization will block extend of supported keys list
            return true;
          }

          const candidateButton = $(element).find(`[adp-hot-key="${keyCode}"]`);

          if (!candidateButton.length) {
            return true;
          }

          if (!isActiveElementCorrect(activeElem, element, true)) {
            return true;
          }

          if (isFormButtons && _.values(isDropdownOpened).length) {
            return true;
          }

          if (keyCode === 'Escape') {
            const cancelButtonClicker = () => pressButton(candidateButton, e);

            if (isFormButtons && isDirtyForm()) {
              const message = 'Are you sure you want to close this dialog and lose all data you entered?';
              AdpModalService.confirm({ message })
                .then(cancelButtonClicker)
                .catch(err => {
                  err && console.error(err);
                });
            } else {
              cancelButtonClicker();
            }
          }

          if (keyCode === 'Enter' && !ignoreEnterForThisElement(activeElem)) {
            pressButton(candidateButton, e);
          }

          return true;
        }

        function pressButton(buttonElem, e) {
          e.stopPropagation();
          e.preventDefault();

          $(buttonElem).trigger('click');
        }

        function isActiveElementCorrect(activeElem, element, checkUpwards) {
          let correspondingModalDialog;
          if (checkUpwards) {
            correspondingModalDialog = $(activeElem).closest(modalDialogSelector);
          } else {
            correspondingModalDialog = $(activeElem);
          }

          const isModalContainsTheElement = correspondingModalDialog.is(modalDialogSelector)
            && correspondingModalDialog.find(element).length;

          return isModalContainsTheElement;
        }

        function ignoreEnterForThisElement(activeElem) {
          const { tagName } = activeElem
          const tagsToIgnoreEnterKey = ['TEXTAREA'];
          const isTagToIgnore = tagsToIgnoreEnterKey.indexOf(tagName) >= 0;
          if (isTagToIgnore) {
            return true;
          }
          const isDxTagBox = $(activeElem).parent().is('.dx-tag-container');

          return isDxTagBox;
        }

        function isDirtyForm() {
          let curScope = scope;
          while (!curScope.form && curScope.$parent) {
            curScope = scope.$parent;
          }

          return curScope.form && curScope.form.$dirty;
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular.module('app')
    .directive('adpUserMenuToggle', adpUserMenuToggle);

  function adpUserMenuToggle($timeout) {
    var INTERFACE = window.adpAppStore.appInterface();

    function initDomEvents($element) {
      var shortcut_dropdown = $('#adp-user-menu');

      $element.on('click', function () {
        if (shortcut_dropdown.is(":visible")) {
          shortcut_buttons_hide();
        } else {
          shortcut_buttons_show();
        }
      });

      shortcut_dropdown.find('a').click(function (e) {
        e.preventDefault();
        window.location = $(this).attr('href');
        setTimeout(shortcut_buttons_hide, 300);
      });


      // SHORTCUT buttons goes away if mouse is clicked outside of the area
      $(document).mouseup(function (e) {
        if (shortcut_dropdown && !shortcut_dropdown.is(e.target) && shortcut_dropdown.has(e.target).length === 0) {
          shortcut_buttons_hide();
        }
      });

      // SHORTCUT ANIMATE HIDE
      function shortcut_buttons_hide() {
        shortcut_dropdown.animate({
          height: "hide"
        }, 300, "easeOutCirc");
        $('body').removeClass('shortcut-on');
      }

      // SHORTCUT ANIMATE SHOW
      function shortcut_buttons_show() {
        shortcut_dropdown.animate({
          height: "show"
        }, 200, "easeOutCirc");
        $('body').addClass('shortcut-on');
      }
    }

    return {
      restrict: 'EA',
      link: function ($scope, $element) {
        if (!INTERFACE.header.components.userMenu) return;

        $timeout(function () {
          initDomEvents($element);
        });
      }
    }
  }
})();;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .factory('AdpChartService', AdpChartService);

  /** @ngInject */
  function AdpChartService (
    APP_CONFIG,
    $q,
    $http
  ){
    function fetchData(data) {
      return data.type === 'url' ?
        _request(data) :
        $q.when(data);
    }

    function _request(params) {
      var req = {
        method: params.method.toUpperCase(),
        url: APP_CONFIG.apiUrl + params.link
      };

      return $http(req)
        .then(function (res) {
          return res.data.data;
        });
    }

    function evalOptions(options, dataset, chartIndex) {
      _.each(options, function (option, key) {
        var isObject = _.isObject(option);

        if (isObject && option.type === 'function') {
          var args = option.arguments || [];
          options[key] = new Function(args.join(','), option.code);
        }

        if (isObject && option.type === 'code') {
          options[key] = new Function(
            ['chartIndex', 'dataset'],
            'return ' + option.code
          )(chartIndex, dataset);
        }

        if (isObject || _.isArray(option)) {
          evalOptions(option, dataset, chartIndex);
        }
      });

      return options;
    }

    return {
      fetchData: fetchData,
      evalOptions: evalOptions,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .factory('AdpFullscreenService', AdpFullscreenService);

  /** @ngInject */
  function AdpFullscreenService ($rootScope){
    var registeredElements = [];

    return {
      requestFullscreen: requestFullscreen,
      exitFullscreen: exitFullscreen,
      fullscreenEnabled: fullscreenEnabled,
      toggleFullscreen: toggleFullscreen,
      forceFullscreen: forceFullscreen,
      registerFullScreenElement: registerFullScreenElement,
      unregisterFullScreenElement: unregisterFullScreenElement
    };

    function requestFullscreen( _elem ) {
      if( fullscreenEnabled() ) {
        return;
      }

      var element = registeredElements.length ? registeredElements[registeredElements.length-1] : _elem;

      forceFullscreen(element);
    }

    function forceFullscreen(element) {
      const possibleMethods = ['requestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullscreen', 'msRequestFullscreen'];
      const methodName = _.find(possibleMethods, n => element[n]);
      const methodPrefix = methodName.substring(0, methodName.length - possibleMethods[0].length);
      const eventName = `${methodPrefix}fullscreenchange`;
      const closureElement = element;

      return new Promise((resolve)=>{
        element[methodName]();
        const handler = function() {
          if (!fullscreenEnabled()) {
            $(document).off(eventName, handler);
            toggleFullScreenClass(closureElement, false);
            resolve();
          }
        };
        $(document).on(eventName, handler);
      });
    }

    function exitFullscreen() {
      if (!fullscreenEnabled()) {
        return Promise.resolve();
      }

      if(document.exitFullscreen) {
        return  document.exitFullscreen().then(exitFullscreen);
      } else if(document.mozCancelFullScreen) {
        return document.mozCancelFullScreen().then(exitFullscreen);
      } else if(document.webkitExitFullscreen) {
        do {
          document.webkitExitFullscreen();
        } while(fullscreenEnabled());
        return Promise.resolve();
      } else if(document.msExitFullscreen) {
        do {
          document.msExitFullscreen();
        } while(fullscreenEnabled());
        return Promise.resolve();
      }
    }

    function fullscreenEnabled() {
      return !!getFullscreenElement();
    }

    function getFullscreenElement(){
      return document.fullscreenElement
      || document.mozFullScreenElement
      || document.webkitFullscreenElement
      || document.msFullscreenElement;
    }

    function toggleFullscreen(element) {
      if (fullscreenEnabled()) {
        const fullScreenElement = getFullscreenElement();
        return exitFullscreen().then(()=>{
          toggleFullScreenClass(fullScreenElement, false);
        })
      } else {
        toggleFullScreenClass(element, true);
        return forceFullscreen(element);
      }
    }

    function registerFullScreenElement(el){
      registeredElements.push(el);
    }

    function unregisterFullScreenElement(el){
      var index = registeredElements.indexOf(el);

      if (index >= 0) {
        registeredElements.splice(index, 1);
      }

      // make sure isFullscreen is false if fullscreened element was destroyed before FS mode exit
      if (!getFullscreenElement()) {
        $rootScope.isFullscreen = false;
      }
    }

    function toggleFullScreenClass(element, toggle) {
      $(element).toggleClass('adp-fullscreen-element', toggle);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .factory('AdpMenuService', AdpMenuService);

  $.fn.smartCollapseToggle = function () {
    return this.each(function () {
      const $body = $('body');
      const $this = $(this);

      // only if not  'menu-on-top'
      if (!$body.hasClass('menu-on-top')) {
        // toggle open
        $this.toggleClass('open');
        if ($body.hasClass('mobile-view-activated')) return;

        // for minified menu collapse only second level
        if ($body.hasClass('minified')) {
          if ($this.closest('nav ul ul').length) {
            $this.find('ul:first').slideToggle(appConfig.menu_speed || 200);
          }
        } else {
          // toggle expand item
          $this.find('ul:first').slideToggle(appConfig.menu_speed || 200);
        }
      }
    });
  };

  /** @ngInject */
  function AdpMenuService(
    $rootScope,
    $sce,
    $transitions,
    $location,
    $timeout,
    AdpUnifiedArgs,
    AdpIconsHelper,
    AdpStateGenerator,
    AdpSchemaService,
    $state,
    $urlMatcherFactory,
  ) {

    const renewMenu = (ds) => {
      const copy = _.clone(ds || $rootScope.menu);
      if (!_.isEmpty(copy)) {
        // Main menu directive watches this, assign value to dxMenu component
        $rootScope.menu = copy;
      }
    }

    $transitions.onSuccess(null, () => {
      $timeout(() => {
        let activeItem = _traverseRemoveAndFindItemByHref($rootScope.menu || [], $location.path());
        if (!activeItem) {
          return;
        }
        activeItem.activeState = 'current';
        activeItem = activeItem.parent;
        while (activeItem) {
          activeItem.activeState = 'containsCurrent';
          activeItem = activeItem.parent;
        }
        renewMenu();
      }, 20)
    });

    return {
      generateMenu,
    };

    function generateMenu() {
      const INTERFACE = window.adpAppStore.appInterface();
      const menu = _.cloneDeep(INTERFACE.mainMenu);
      _createMenuDataSource({
        menuItems: menu.fields,
        level: 0,
        path: '',
      })
        .then(renewMenu)
    }

    function _createMenuDataSource({menuItems, level, path}) {
      if (!_.isObject(menuItems)) {
        return Promise.resolve([]);
      }
      const items = _.map(menuItems, (field, key) => Object.assign({fieldName: key}, field));
      items.sort(AdpSchemaService.getSorter('menuOrder'))

      const allPromises = _.map(items, item => _createMenuItem({item, level, path}));

      return Promise.all(allPromises).then(res => _.compact(res));
    }

    function _createMenuItem({item, level, path}) {
      // ToDo: make sure cssClass is supported - was demolished on refactor
      const {type: itemType} = item;
      if (!itemType) {
        return Promise.resolve();
      }

      if (itemType === "MenuSeparator") {
        item.disabled = true;
      }

      let itemSubmenuSchema = item.fields;

      item.currentPath = path + (path ? '.' : '') + item.fieldName;
      item.level = level;

      if (_.isObject(item.disabled)) {
        const menuItemDisabledFn = _.get(appModelHelpers, 'MenuRenderers.' + item.disabled.link);

        if (_.isFunction(menuItemDisabledFn)) {
          const unifiedParams = AdpUnifiedArgs.getHelperParamsWithConfig({
            path: item.currentPath,
            formData: null,
            schema: item,
          });
          const isItemDisabled = () => menuItemDisabledFn.call(Object.assign({}, unifiedParams));
          item.disabled = isItemDisabled();
          $transitions.onSuccess(null, () => {
            const newValue = isItemDisabled();
            if (item.disabled !== newValue) {
              const currentMenu = $rootScope.menu;
              const pathArr = item.currentPath.split('.');
              _mutateDisabledStateByPath(currentMenu, pathArr, newValue);
              renewMenu(currentMenu);
            }
          });
        } else {
          item.disabled = true;
        }
      }

      if (!_.isUndefined(item.render)) {
        if (item.render.renderTarget === 'submenu') {
          const menuItemSubmenuSchemaFn = _.get(appModelHelpers, 'MenuRenderers.' + item.render.link);

          if (_.isFunction(menuItemSubmenuSchemaFn)) {
            const unifiedParams = AdpUnifiedArgs.getHelperParamsWithConfig({
              path: item.currentPath,
              formData: null,
              schema: item,
            });
            itemSubmenuSchema = menuItemSubmenuSchemaFn.call(Object.assign({}, unifiedParams, {action: 'submenuRender'}));
          }
        }
      }

      const { link, target } = item;
      if (link) {
        if (_isState(item)) {
          let { linkParams } = item;
          const stateName = _findStateNameByLink(link);
          const state = $state.get(stateName);
          if (state && _.isEmpty(linkParams)) {
            linkParams = _extractLinkParamsFromUrl(state, link);
          }
          const params = _.isEmpty(linkParams) ? '' : '(' + JSON.stringify(linkParams) + ')';
          item.href = state && $state.href(state, linkParams)
          item.uiSref = stateName + params;
        } else {
          item.href = link;
          item.target = target || '_self';
        }
      }

      if (itemSubmenuSchema) {
        let submenuCreatorPromise;

        if (_.isFunction(itemSubmenuSchema.then)) {
          submenuCreatorPromise = Promise.resolve([]); // tmp resolver to let menu appear quickly;
          itemSubmenuSchema
            .then(
              (menuItems) => _createMenuDataSource({menuItems, level: level + 1, path: item.currentPath})
            ).then(submenuDs => {
              item.items = submenuDs;
              renewMenu();
            })
            .catch(function (err) {
              console.error('Menu subset generation is failed', err);
              submenuCreatorPromise = Promise.resolve();
            });
        } else {
          submenuCreatorPromise = _createMenuDataSource({
            menuItems: itemSubmenuSchema,
            level: level + 1,
            path: item.currentPath
          });
        }

        return submenuCreatorPromise.then(subItems => {
          item.items = subItems;
          _.each(subItems, one=> one.parent = item);
          return item;
        });
      }

      return Promise.resolve(item);
    }

    function _isState(menuItem) {
      return !_.get(menuItem, 'external', false);
    }

    function _findStateNameByLink(link) {
      const foundState = _.find($state.get(), (state) => {
        const {url} = state.$$state();
        return url && url.exec(link);
      });
      const {name} = foundState || {name: AdpStateGenerator.linkToState(link)};

      return name;
    }

    function _extractLinkParamsFromUrl(state, link) {
      const urlMatcher = $urlMatcherFactory.compile(state.url);
      return _.compact(urlMatcher.exec(link, {}));
    }

    function _traverseRemoveAndFindItemByHref(items, href) {
      let result;
      _.each(items, (item) => {
        if (item.href === href) {
          result = item;
        }
        item.activeState = 0;
        const child = item.items && _traverseRemoveAndFindItemByHref(item.items, href);
        if (child) {
          result = child;
        }
      });

      return result;
    }

    function _mutateDisabledStateByPath(menu, pathArr, newValue) {
      let curMenu = menu;
      let mItem;
      while (!_.isEmpty(pathArr)) {
        const fieldName = pathArr.shift();
        mItem = _.find(curMenu, x => x.fieldName === fieldName);
        if (!mItem) {
          break;
        }
        curMenu = mItem.items;
      }

      if (mItem) {
        mItem.disabled = newValue;
      }
    }
  }
})();
;"use strict";

angular.module('SmartAdmin.Layout').directive('resetWidgets', function($state){

    return {
        restrict: 'A',
        link: function(scope, element){
            element.on('click', function(){
                $.SmartMessageBox({
                    title : "<i class='fa fa-refresh' style='color:green'></i> Clear Local Storage",
                    content : "Would you like to RESET all your saved widgets and clear LocalStorage?1",
                    buttons : '[No][Yes]'
                }, function(ButtonPressed) {
                    if (ButtonPressed == "Yes" && localStorage) {
                        localStorage.clear();
                        location.reload()
                    }
                });

            });
        }
    }

});
;'use strict';

angular.module('SmartAdmin.Layout').directive('searchMobile', function () {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('search-mobile data-search-mobile');

            element.on('click', function (e) {
                $('body').addClass('search-mobile');
                e.preventDefault();
            });

            $('#cancel-search-js').on('click', function (e) {
                $('body').removeClass('search-mobile');
                e.preventDefault();
            });
        }
    }
});;'use strict';

angular.module('SmartAdmin.Layout').directive('bigBreadcrumbs', function () {
    return {
        restrict: 'EA',
        replace: true,
        template: '<div><h1 class="page-title txt-color-blueDark"></h1></div>',
        scope: {
            items: '=',
            icon: '@'
        },
        link: function (scope, element) {
            var first = _.first(scope.items);

            var icon = scope.icon || 'home';
            element.find('h1').append('<i class="fa-fw fa fa-' + icon + '"></i> ' + first);
            _.tail(scope.items).forEach(function (item) {
                element.find('h1').append(' <span>> ' + item + '</span>')
            })
        }
    }
});
;'use strict';

angular.module('SmartAdmin.Layout').directive('dismisser', function () {
    return {
        restrict: 'A',
        compile: function (element) {
            element.removeAttr('dismisser data-dissmiser')
            var closer = '<button class="close">&times;</button>';
            element.prepend(closer);
            element.on('click', '>button.close', function(){
                element.fadeOut('fast',function(){ $(this).remove(); });

            })
        }
    }
});;'use strict';

angular.module('SmartAdmin.Layout').directive('hrefVoid', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            element.attr('href','#');
            element.on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
            })
        }
    }
});;'use strict';

/*
* Directive for toggling a ng-model with a button
* Source: https://gist.github.com/aeife/9374784
*/

angular.module('SmartAdmin.Layout').directive('radioToggle', function ($log) {
    return {
        scope: {
            model: "=ngModel",
            value: "@value"
        },
        link: function(scope, element, attrs) {

            element.parent().on('click', function() {
                scope.model = scope.value;
                scope.$apply();
            });
        }
    }
});;;(function() {
  'use strict';

  /**
   * DETECT MOBILE DEVICES
   * Description: Detects mobile device - if any of the listed device is
   *
   * detected class is inserted to <tElement>.
   *
   *  (so far this is covering most hand held devices)
   */
  angular
    .module('SmartAdmin.Layout')
    .directive('smartDeviceDetect', function (AdpBrowserService) {
      return {
        restrict: 'A',
        compile: function (tElement) {
          tElement.removeAttr('smart-device-detect data-smart-device-detect');

          var isMobile = AdpBrowserService.isMobile();

          tElement.toggleClass('desktop-detected', !isMobile);
          tElement.toggleClass('mobile-detected', isMobile);
        }
      }
    });
})();;/**
 *
 * Description: Directive utilizes FastClick library.
 *
 *
 * FastClick is a simple, easy-to-use library for eliminating the
 * 300ms delay between a physical tap and the firing of a click event on mobile browsers.
 * FastClick doesn't attach any listeners on desktop browsers.
 * @link: https://github.com/ftlabs/fastclick
 *
 * On mobile devices 'needsclick' class is attached to <tElement>
 *
 */


'use strict';

angular.module('SmartAdmin.Layout').directive('smartFastClick', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-fast-click data-smart-fast-click');

            FastClick.attach(tElement);

            if(!FastClick.notNeeded())
                tElement.addClass('needsclick')
        }
    }
});
;;(function () {
  'use strict';

  angular
    .module('SmartAdmin.Layout')
    .directive('smartInclude', function () {
      return {
        replace: true,
        restrict: 'A',
        templateUrl: function (element, attr) {
          return attr.smartInclude;
        },
        compile: function(element){
          element[0].className = element[0].className.replace(/placeholder[^\s]+/g, '');
        }
      };
    }
  );
})();;
'use strict';

angular.module('SmartAdmin.Layout').directive('smartLayout', function (
  $rootScope,
  $timeout,
  $interval,
  $transitions,
  $q,
  SmartCss,
  AdpLayoutConfigService
) {

    // const _debug = 0;
    //
    // function getDocHeight() {
    //     const D = document;
    //     return Math.max(
    //         D.body.scrollHeight, D.documentElement.scrollHeight,
    //         D.body.offsetHeight, D.documentElement.offsetHeight,
    //         D.body.clientHeight, D.documentElement.clientHeight
    //     );
    // }

    let initialized = false;
    const initializedResolver = $q.defer();
    initializedResolver.promise.then(function () {
        initialized = true;
    });

    const //$window = $(window),
        // $document = $(document),
        $html = $('html'),
        $body = $('body');
        let $navigation ,
        $menu,
        $footer
        // $contentAnimContainer
        ;


    (function cacheElements() {
        $navigation = $('#header');
        $menu = $('#left-panel');
        $footer = $('.page-footer');
        if (_.every([$menu, $footer], function ($it) {
            return angular.isNumber($it.height())
        })) {
            initializedResolver.resolve();
        } else {
            $timeout(cacheElements, 0);
        }
    })();

    $interval(_.noop, 150);

    (function applyConfigSkin(){
      $body.removeClass(_.map(window.appConfig.skins, 'name').join(' '));
      $body.addClass(AdpLayoutConfigService.getSkin());
      AdpLayoutConfigService.applyThemeClasses();
    })();

  (function defineLayoutParams() {
    const classes = AdpLayoutConfigService.layoutClass();
    const bg = AdpLayoutConfigService.get('background');

    $body.addClass(classes);

    if (bg) {
      $html.css('background-image', bg);
    }
  })();


    return {
        priority: 2014,
        restrict: 'A',
        compile: function (tElement) {
            tElement.removeAttr('smart-layout data-smart-layout');

            // const appViewHeight = 0 ,
            //     appViewWidth = 0,
            //     calcWidth,
            //     calcHeight,
            //     deltaX,
            //     deltaY;

            let forceResizeTrigger = false;

            // function resizeListener() {
            // }
            
            let looping = false;
            const debouncedRun = _.debounce(function () {
                run(300)
            }, 300);

            function run(delay) {
                initializedResolver.promise.then(function () {
                    attachOnResize(delay);
                });
            }
            run(10);

            // function detachOnResize() {
            //     looping = false;
            // }

            function attachOnResize(delay) {
                $timeout(function () {
                    looping = true;
                }, delay);
            }

            // function loop() {
            //     $body.toggleClass('mobile-view-activated', $window.width() < 979);
            //
            //     if ($window.width() < 979)
            //         $body.removeClass('minified');
            //
            //     resizeListener();
            // }

            function handleHtmlId(toState) {
                if (toState.data && toState.data.htmlId) {
                  $html.attr('id', toState.data.htmlId);
                } else {
                  $html.removeAttr('id');
                }
            }

          function handleBodyClasses(state) {
            const CLASS_PREFIX = 'page-';
            let pageClasses = [];
            const regex = new RegExp('(^|\\s)' + CLASS_PREFIX + '\\S+', 'g');
            const roles = _.get(lsService.getUser(), 'roles');

            $body.removeClass(function(index, className) {
              return (className.match(regex) || []).join(' ').trim();
            });

            if (state.data.cssClass) {
              pageClasses = _.compact(state.data.cssClass.split(' '));
            }

            pageClasses.push(state.name.replace(/\./g, '-'));
            pageClasses = _.map(pageClasses, (className) => CLASS_PREFIX + className);

            _.each(roles, role => pageClasses.push(`user-role-${role}`))

            $body.addClass(pageClasses);
          }

            $transitions.onStart(null, function(trans) {
                const toState = trans.to();
                handleBodyClasses(toState);
                handleHtmlId(toState);

                trans.promise.finally(function () {
                    forceResizeTrigger = true;
                });
            });

            // initialized with 1 because we came here with one $viewContentLoading request
            let viewContentLoading = 1;
            $rootScope.$on('$viewContentLoading', function () {
                //console.log(2, '$viewContentLoading', event, viewConfig);
                viewContentLoading++;
            });

            $rootScope.$on('$viewContentLoaded', function () {
                //console.log(4, '$viewContentLoaded', event);
                viewContentLoading--;

                if (viewContentLoading === 0 && initialized) {
                    debouncedRun();
                }
            });
        }
    }
});
;

'use strict';

angular
    .module('SmartAdmin.Layout')
    .directive('smartPageTitle', function (
        $rootScope,
        AdpTitleHelper,
        $transitions
    ) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-page-title data-smart-page-title');

            var defaultTitle = attributes.smartPageTitle;

            var listener = function(transition) {
                var toState = transition.to();
                var title = defaultTitle;

                if (toState.data && toState.data.title) {
                    title = toState.data.title + ' | ' + title;
                }

                AdpTitleHelper.setTitle(title);
            };

            $transitions.onStart(null, listener);
        }
    }
});
;'use strict';

angular
    .module('SmartAdmin.Layout')
    .directive('smartRouterAnimationWrap', function (
        $rootScope,
        $timeout,
        $transitions
    ) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-router-animation-wrap data-smart-router-animation-wrap wrap-for data-wrap-for');

            element.addClass('router-animation-container');


            var $loader = $('<div class="router-animation-loader"><i class="fa fa-gear fa-4x fa-spin"></i></div>')
                .css({
                    position: 'absolute',
                    top: 50,
                    left: 10
                }).hide().appendTo(element);


            var animateElementSelector = attributes.wrapFor;
            var viewsToMatch = attributes.smartRouterAnimationWrap.split(/\s/);

            var needRunContentViewAnimEnd = false;
            function contentViewAnimStart() {
                needRunContentViewAnimEnd = true;
                element.css({
                    height: element.height() + 'px',
                    overflow: 'hidden'
                }).addClass('active');
                $loader.fadeIn();

                $(animateElementSelector).addClass('animated faster fadeOutDown');
            }

            function contentViewAnimEnd() {
                if(needRunContentViewAnimEnd){
                    element.css({
                        height: 'auto',
                        overflow: 'visible'
                    }).removeClass('active');


                    $(animateElementSelector).addClass('animated faster fadeInUp');

                    needRunContentViewAnimEnd = false;

                    $timeout(function(){
                        $(animateElementSelector).removeClass('animated');
                    },10);
                }
                $loader.fadeOut();
            }


            var destroyForStart = $transitions.onStart(null, function (transition) {
                var toState = transition.to();
                var fromState = transition.from();
                if (toState.name === fromState.name) {
                    return;
                }

                var isAnimRequired = _.some(viewsToMatch, function(view){
                    return _.has(toState.views, view) || _.has(fromState.views, view);
                });
                if(isAnimRequired){
                    contentViewAnimStart()
                }
            });

            var destroyForEnd = $rootScope.$on('$viewContentLoaded', function (event) {
                contentViewAnimEnd();
            });

            element.on('$destroy', function(){
                destroyForStart();
                destroyForEnd();
            });



        }
    }
});
;angular.module('SmartAdmin.Layout').directive('speechRecognition', function ($log) {
	'use strict';

	$.root_ = $('body');
	var root, commands;

    root = window;
    window.appConfig = window.appConfig || {};

	if (appConfig.voice_command) {
		commands = appConfig.commands;
	}


	/*
	 * SMART VOICE
	 * Author: MyOrange | @bootstraphunt
	 * http://www.myorange.ca
	 */

	var SpeechRecognition = root.SpeechRecognition || root.webkitSpeechRecognition || root.mozSpeechRecognition || root.msSpeechRecognition || root.oSpeechRecognition;

// ref: http://updates.html5rocks.com/2013/01/Voice-Driven-Web-Apps-Introduction-to-the-Web-Speech-API


// function
	$.speechApp = (function(speech) {

		speech.start = function() {

			// Add our commands to smartSpeechRecognition
			smartSpeechRecognition.addCommands(commands);

			if (smartSpeechRecognition) {
				// activate plugin
				smartSpeechRecognition.start();
				// add btn class
				$.root_.addClass("voice-command-active");
				// play sound
				$.speechApp.playON();
				// set localStorage when switch is on manually
				if (appConfig.voice_localStorage) {
					localStorage.setItem('sm-setautovoice', 'true');
				}

			} else {
				// if plugin not found
				alert("speech plugin not loaded");
			}

		};
		speech.stop = function() {

			if (smartSpeechRecognition) {
				// deactivate plugin
				smartSpeechRecognition.abort();
				// remove btn class
				$.root_.removeClass("voice-command-active");
				// sound
				$.speechApp.playOFF();
				// del localStorage when switch if off manually
				if (appConfig.voice_localStorage) {
					localStorage.setItem('sm-setautovoice', 'false');
				}
				// remove popover if visible
				if ($('#speech-btn .popover').is(':visible')) {
					$('#speech-btn .popover').fadeOut(250);
				}
			}

		};

		// play sound
		speech.playON = function() {

			var audioElement = document.createElement('audio');

			if (navigator.userAgent.match('Firefox/'))
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_on' + ".ogg");
			else
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_on' + ".mp3");

			//$.get();
			audioElement.addEventListener("load", function() {
				audioElement.play();
			}, true);

			if (appConfig.sound_on) {
				audioElement.pause();
				audioElement.play();
			}
		};

		speech.playOFF = function() {

			var audioElement = document.createElement('audio');

			if (navigator.userAgent.match('Firefox/'))
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_off' + ".ogg");
			else
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_off' + ".mp3");

			$.get();
			audioElement.addEventListener("load", function() {
				audioElement.play();
			}, true);

			if (appConfig.sound_on) {
				audioElement.pause();
				audioElement.play();
			}
		};

		speech.playConfirmation = function() {

			var audioElement = document.createElement('audio');

			if (navigator.userAgent.match('Firefox/'))
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_alert' + ".ogg");
			else
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_alert' + ".mp3");

			$.get();
			audioElement.addEventListener("load", function() {
				audioElement.play();
			}, true);

			if (appConfig.sound_on) {
				audioElement.pause();
				audioElement.play();
			}
		};

		return speech;

	})({});



	/*
	 * SPEECH RECOGNITION ENGINE
	 * Copyright (c) 2013 Tal Ater
	 * Modified by MyOrange
	 * All modifications made are hereby copyright (c) 2014 MyOrange
	 */

	(function(undefined) {"use strict";

		// Check browser support
		// This is done as early as possible, to make it as fast as possible for unsupported browsers
		if (!SpeechRecognition) {
			root.smartSpeechRecognition = null;
			return undefined;
		}

		var commandsList = [], recognition, callbacks = {
				start : [],
				error : [],
				end : [],
				result : [],
				resultMatch : [],
				resultNoMatch : [],
				errorNetwork : [],
				errorPermissionBlocked : [],
				errorPermissionDenied : []
			}, autoRestart, lastStartedAt = 0,
		//debugState = false, // decleared in app.appConfig.js
		//appConfig.debugStyle = 'font-weight: bold; color: #00f;', // decleared in app.appConfig.js

		// The command matching code is a modified version of Backbone.Router by Jeremy Ashkenas, under the MIT license.
			optionalParam = /\s*\((.*?)\)\s*/g, optionalRegex = /(\(\?:[^)]+\))\?/g, namedParam = /(\(\?)?:\w+/g, splatParam = /\*\w+/g, escapeRegExp = /[\-{}\[\]+?.,\\\^$|#]/g, commandToRegExp = function(command) {
				command = command.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function(match, optional) {
					return optional ? match : '([^\\s]+)';
				}).replace(splatParam, '(.*?)').replace(optionalRegex, '\\s*$1?\\s*');
				return new RegExp('^' + command + '$', 'i');
			};

		// This method receives an array of callbacks to iterate over, and invokes each of them
		var invokeCallbacks = function(callbacks) {
			callbacks.forEach(function(callback) {
				callback.callback.apply(callback.context);
			});
		};

		var initIfNeeded = function() {
			if (!isInitialized()) {
				root.smartSpeechRecognition.init({}, false);
			}
		};

		var isInitialized = function() {
			return recognition !== undefined;
		};

		root.smartSpeechRecognition = {
			// Initialize smartSpeechRecognition with a list of commands to recognize.
			// e.g. smartSpeechRecognition.init({'hello :name': helloFunction})
			// smartSpeechRecognition understands commands with named variables, splats, and optional words.
			init : function(commands, resetCommands) {

				// resetCommands defaults to true
				if (resetCommands === undefined) {
					resetCommands = true;
				} else {
					resetCommands = !!resetCommands;
				}

				// Abort previous instances of recognition already running
				if (recognition && recognition.abort) {
					recognition.abort();
				}

				// initiate SpeechRecognition
				recognition = new SpeechRecognition();

				// Set the max number of alternative transcripts to try and match with a command
				recognition.maxAlternatives = 5;
				recognition.continuous = true;
				// Sets the language to the default 'en-US'. This can be changed with smartSpeechRecognition.setLanguage()
				recognition.lang = appConfig.voice_command_lang || 'en-US';

				recognition.onstart = function() {
					invokeCallbacks(callbacks.start);
					//debugState
					if (appConfig.debugState) {
						root.console.log('%c ✔ SUCCESS: User allowed access the microphone service to start ', appConfig.debugStyle_success);
						root.console.log('Language setting is set to: ' + recognition.lang, appConfig.debugStyle);
					}
					$.root_.removeClass("service-not-allowed");
					$.root_.addClass("service-allowed");
				};

				recognition.onerror = function(event) {
					invokeCallbacks(callbacks.error);
					switch (event.error) {
						case 'network':
							invokeCallbacks(callbacks.errorNetwork);
							break;
						case 'not-allowed':
						case 'service-not-allowed':
							// if permission to use the mic is denied, turn off auto-restart
							autoRestart = false;
							$.root_.removeClass("service-allowed");
							$.root_.addClass("service-not-allowed");
							//debugState
							if (appConfig.debugState) {
								root.console.log('%c WARNING: Microphone was not detected (either user denied access or it is not installed properly) ', appConfig.debugStyle_warning);
							}
							// determine if permission was denied by user or automatically.
							if (new Date().getTime() - lastStartedAt < 200) {
								invokeCallbacks(callbacks.errorPermissionBlocked);
							} else {
								invokeCallbacks(callbacks.errorPermissionDenied);
								//console.log("You need your mic to be active")
							}
							break;
					}
				};

				recognition.onend = function() {
					invokeCallbacks(callbacks.end);
					// smartSpeechRecognition will auto restart if it is closed automatically and not by user action.
					if (autoRestart) {
						// play nicely with the browser, and never restart smartSpeechRecognition automatically more than once per second
						var timeSinceLastStart = new Date().getTime() - lastStartedAt;
						if (timeSinceLastStart < 1000) {
							setTimeout(root.smartSpeechRecognition.start, 1000 - timeSinceLastStart);
						} else {
							root.smartSpeechRecognition.start();
						}
					}
				};

				recognition.onresult = function(event) {
					invokeCallbacks(callbacks.result);

					var results = event.results[event.resultIndex], commandText;

					// go over each of the 5 results and alternative results received (we've set maxAlternatives to 5 above)
					for (var i = 0; i < results.length; i++) {
						// the text recognized
						commandText = results[i].transcript.trim();
						if (appConfig.debugState) {
							root.console.log('Speech recognized: %c' + commandText, appConfig.debugStyle);
						}

						// try and match recognized text to one of the commands on the list
						for (var j = 0, l = commandsList.length; j < l; j++) {
							var result = commandsList[j].command.exec(commandText);
							if (result) {
								var parameters = result.slice(1);
								if (appConfig.debugState) {
									root.console.log('command matched: %c' + commandsList[j].originalPhrase, appConfig.debugStyle);
									if (parameters.length) {
										root.console.log('with parameters', parameters);
									}
								}
								// execute the matched command
								commandsList[j].callback.apply(this, parameters);
								invokeCallbacks(callbacks.resultMatch);

								// for commands "sound on", "stop" and "mute" do not play sound or display message
								//var myMatchedCommand = commandsList[j].originalPhrase;

								var ignoreCallsFor = ["sound on", "mute", "stop"];

								if (ignoreCallsFor.indexOf(commandsList[j].originalPhrase) < 0) {
									// play sound when match found
									console.log(2);
									toastr.success("loading...", commandsList[j].originalPhrase);

									if ($('#speech-btn .popover').is(':visible')) {
										$('#speech-btn .popover').fadeOut(250);
									}
								}// end if

								return true;
							}
						} // end for
					}// end for

					invokeCallbacks(callbacks.resultNoMatch);
					//console.log("no match found for: " + commandText)
					toastr.error(
						"Please speak clearly into the microphone", "Error: <strong> \" " + commandText + " \" </strong> no match found!"
					);
					if ($('#speech-btn .popover').is(':visible')) {
						$('#speech-btn .popover').fadeOut(250);
					}
					return false;
				};

				// build commands list
				if (resetCommands) {
					commandsList = [];
				}
				if (commands.length) {
					this.addCommands(commands);
				}
			},

			// Start listening (asking for permission first, if needed).
			// Call this after you've initialized smartSpeechRecognition with commands.
			// Receives an optional options object:
			// { autoRestart: true }
			start : function(options) {
				initIfNeeded();
				options = options || {};
				if (options.autoRestart !== undefined) {
					autoRestart = !!options.autoRestart;
				} else {
					autoRestart = true;
				}
				lastStartedAt = new Date().getTime();
				recognition.start();
			},

			// abort the listening session (aka stop)
			abort : function() {
				autoRestart = false;
				if (isInitialized) {
					recognition.abort();
				}
			},

			// Turn on output of debug messages to the console. Ugly, but super-handy!
			debug : function(newState) {
				if (arguments.length > 0) {
					appConfig.debugState = !!newState;
				} else {
					appConfig.debugState = true;
				}
			},

			// Set the language the user will speak in. If not called, defaults to 'en-US'.
			// e.g. 'fr-FR' (French-France), 'es-CR' (Español-Costa Rica)
			setLanguage : function(language) {
				initIfNeeded();
				recognition.lang = language;
			},

			// Add additional commands that smartSpeechRecognition will respond to. Similar in syntax to smartSpeechRecognition.init()
			addCommands : function(commands) {
				var cb, command;

				initIfNeeded();

				for (var phrase in commands) {
					if (commands.hasOwnProperty(phrase)) {
						cb = root[commands[phrase]] || commands[phrase];
						if ( typeof cb !== 'function') {
							continue;
						}
						//convert command to regex
						command = commandToRegExp(phrase);

						commandsList.push({
							command : command,
							callback : cb,
							originalPhrase : phrase
						});
					}
				}
				if (appConfig.debugState) {
					root.console.log('Commands successfully loaded: %c' + commandsList.length, appConfig.debugStyle);
				}
			},

			// Remove existing commands. Called with a single phrase, array of phrases, or methodically. Pass no params to remove all commands.
			removeCommands : function(commandsToRemove) {
				if (commandsToRemove === undefined) {
					commandsList = [];
					return;
				}
				commandsToRemove = Array.isArray(commandsToRemove) ? commandsToRemove : [commandsToRemove];
				commandsList = commandsList.filter(function(command) {
					for (var i = 0; i < commandsToRemove.length; i++) {
						if (commandsToRemove[i] === command.originalPhrase) {
							return false;
						}
					}
					return true;
				});
			},

			// Lets the user add a callback of one of 9 types:
			// start, error, end, result, resultMatch, resultNoMatch, errorNetwork, errorPermissionBlocked, errorPermissionDenied
			// Can also optionally receive a context for the callback function as the third argument
			addCallback : function(type, callback, context) {
				if (callbacks[type] === undefined) {
					return;
				}
				var cb = root[callback] || callback;
				if ( typeof cb !== 'function') {
					return;
				}
				callbacks[type].push({
					callback : cb,
					context : context || this
				});
			}
		};

	}).call(this);

	var autoStart = function() {

		smartSpeechRecognition.addCommands(commands);

		if (smartSpeechRecognition) {
			// activate plugin
			smartSpeechRecognition.start();
			// add btn class
			$.root_.addClass("voice-command-active");
			// set localStorage when switch is on manually
			if (appConfig.voice_localStorage) {
				localStorage.setItem('sm-setautovoice', 'true');
			}

		} else {
			// if plugin not found
			alert("speech plugin not loaded");
		}
	}
// if already running with localstorage
	if (SpeechRecognition && appConfig.voice_command && localStorage.getItem('sm-setautovoice') == 'true') {
		autoStart();
	}

// auto start
	if (SpeechRecognition && appConfig.voice_command_auto && appConfig.voice_command) {
		autoStart();
	}


	var link = function(scope, element) {


		if (SpeechRecognition && appConfig.voice_command) {

			// create dynamic modal instance
			var modal = $('<div class="modal fade" id="voiceModal" tabindex="-1" role="dialog" aria-labelledby="remoteModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"></div></div></div>');
			// attach to body
			modal.appendTo("body");

			element.on("click", function(e) {

            	if ($.root_.hasClass("voice-command-active")) {
					$.speechApp.stop();
					//$('#speech-btn > span > a > i').removeClass().addClass('fa fa-microphone-slash');
				} else {
					$.speechApp.start();
					//add popover
					$('#speech-btn .popover').fadeIn(350);
					//$('#speech-btn > span > a > i').removeClass().addClass('fa fa-microphone')

				}

				e.preventDefault();

            });

			//remove popover
			$(document).mouseup(function(e) {
				if (!$('#speech-btn .popover').is(e.target) && $('#speech-btn .popover').has(e.target).length === 0) {
					$('#speech-btn .popover').fadeOut(250);
				}
			});


			$("#speech-help-btn").on("click", function() {
				commands.help();
			});

		}
		else {
			$("#speech-btn").addClass("display-none");
		}


	}



    return {
        restrict: 'AE',
        link: link
    }
});
;'use strict';

angular.module('SmartAdmin.Layout').factory('SmartCss', function ($rootScope, $timeout) {

    var sheet = (function () {
        // Create the <style> tag
        var style = document.createElement("style");

        // Add a media (and/or media query) here if you'd like!
        // style.setAttribute("media", "screen")
        // style.setAttribute("media", "@media only screen and (max-width : 1024px)")

        // WebKit hack :(
        style.appendChild(document.createTextNode(""));

        // Add the <style> element to the page
        document.head.appendChild(style);

        return style.sheet;
    })();

    var _styles = {};


    var SmartCss = {
        writeRule: function(selector){
            SmartCss.deleteRuleFor(selector);
            if(_.has(_styles, selector)){
                var css = selector + '{ ' + _.map(_styles[selector], function(v, k){
                    return  k + ':' +  v + ';'
                }).join(' ') +'}';
                sheet.insertRule(css, _.size(_styles) - 1);
            }
        },
        add: function (selector, property, value, delay) {
            if(!_.has(_styles, selector))
                _styles[selector] = {};

            if(value == undefined || value == null || value == '')
                delete _styles[selector][property];
            else
                _styles[selector][property] = value;


            if(_.keys(_styles[selector]).length == 0)
                delete _styles[selector];

            if(!delay)
                delay = 0;
            $timeout(function(){
                SmartCss.writeRule(selector);
            }, delay);

        },
        remove: function(selector, property, delay){
            SmartCss.add(selector, property, null, delay);
        },
        deleteRuleFor: function (selector) {
            _(sheet.rules).forEach(function (rule, idx) {
                if (rule.selectorText == selector) {
                    sheet.deleteRule(idx);
                }
            });
        },
        appViewSize: null
    };

    $rootScope.$on('$smartContentResize', function (event, data) {
        SmartCss.appViewSize = data;
    });

    return SmartCss;

});



;;(function () {
  'use strict';

  angular
    .module('SmartAdmin.Layout')
    .factory('AdpTitleHelper', AdpTitleHelper);

  /** @ngInject */
  function AdpTitleHelper($timeout) {
    return {
      setTitle
    };

    function setTitle(title) {
      // Set asynchronously so page changes before title does
      $timeout(function() {
        $('html head title').text(title);
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('SmartAdmin.Layout')
    .factory('AdpUiActionsService', AdpUiActionsService);

  /** @ngInject */
  function AdpUiActionsService() {
    return {
      toggleMenu: toggleMenu
    };

    function toggleMenu(){
      var $body = $('body');

      if (!$body.hasClass('menu-on-top')){
        $('html').toggleClass('hidden-menu-mobile-lock');
        $body.toggleClass('hidden-menu');
        $body.removeClass('minified');
      }

      if ($body.hasClass('menu-on-top') && $body.hasClass('mobile-view-activated')) {
        $('html').toggleClass('hidden-menu-mobile-lock');
        $body.toggleClass('hidden-menu');
        $body.removeClass('minified');
      }
    }
  }
})();
;(function () {
  "use strict";

  angular
    .module("app.adpApi")
    .factory("AdpSocketIoService", AdpSocketIoService);

  /** @ngInject */
  function AdpSocketIoService(
    APP_CONFIG,
    $http,
    $state,
    $timeout,
    $location,
    AdpSessionHelper,
    AdpModalService,
    AdpNotificationService,
    $log
  ) {
    let activeSocket = null;
    let reconnectionCounter = 0;
    let tokenIsRefreshingNow = false;
    const messageProcessors = [{ processor: defaultMessageProcessor }];
    const standardMessageHandlers = {
      message: defaultHandlerTypeMessage,
      logoutNotification: logoutHandler,
      backgroundJobs: simpleBackgroundJobsHandler,
    };
    const subscribedWidgetIds = new Set();

    function doLogin() {
      if (!io) {
        socketLog("API not found");
        return;
      }

      connectSocket();
    }

    function setupSocketHandlers(socket) {
      socket.on("unauthenticated", function () {
        socketLog("Auth error");
        if (!tokenIsRefreshingNow) {
          socket.close();
          socketLog("Finally disconnected");
          lsService.removeUserData();
          $state.go("auth.login");
        } else {
          socketLog("Waiting token to refresh");
        }
      });

      socket.on("connected", function (data = {}) {
        socketLog(`Successfully ${data.authenticated ? 'authenticated' : 'connected without auth'}`);
        reconnectionCounter = 0;
        resubscribeWidgets();
      });

      socket.on("message", applyProcessorQueueToMessage);

      socket.on("disconnect", function (reason) {
        socketLog("Disconnected");

        const isDisconnectForcedByClient = reason !== "io client disconnect";
        if (isDisconnectForcedByClient) {
          socketLog("Reconnecting...");
          connectSocket();
        }
      });

      socket.on("connect_error", () => {
        const reconnectTimeout = Math.min(120, Math.pow(2, reconnectionCounter)) * 1000;
        socketLog(`Connect error. Reconnect in ${ reconnectTimeout/1000 }s`);
        if (socket.io.opts.auth) {
          socket.io.opts.auth.token = getAuthString();
        }

        $timeout(connectSocket, reconnectTimeout);
        reconnectionCounter++;
      });

      socket.on("error", function (error) {
        socketLog("Error: " + error);
      });

      socket.io.once("reconnect", function () {
        socketLog("Reconnected");
        if (!socket.io.opts.auth) {
          resubscribeWidgets();
          return;
        }
        socketLog("Token refresh start.");
        socket.close();
        tokenIsRefreshingNow = true;
        AdpSessionHelper.setTokenRefreshTimeout(true)
          .then(connectSocket)
          .then(resubscribeWidgets)
          .finally(function () {
            tokenIsRefreshingNow = false;
          });
      });
    }

    function getAuthString() {
      const token = lsService.getToken();
      if (!token) {
        return;
      }
      return `JWT ${token}`;
    }

    function connectSocket() {
      if (activeSocket && activeSocket.connected) {
        activeSocket.close();
        socketLog("Closing currently active socket");
      }

      socketLog("Connect attempt...");

      const socketPath = _.compact([
        APP_CONFIG.appSuffix,
        APP_CONFIG.apiPrefix,
      ]).join("");
      const params = {
        path: socketPath + "/socket.io",
        reconnection: false,
        reconnectionDelayMax: 64000,
        forceNew: true,
      };
      const token = getAuthString();
      if (token) {
        params.auth = {token};
      }
      activeSocket = io(APP_CONFIG.serverBaseUrl, params);

      if (activeSocket) {
        setupSocketHandlers(activeSocket);
      } else {
        socketLog("Initialization failed");
      }
    }

    function resubscribeWidgets() {
      if (!subscribedWidgetIds.size) {
        return
      }
      const widgetIds = Array.from(subscribedWidgetIds);
      emit('message', {type: 'widgetUpdates', data: {subscribeWidgetIds: widgetIds}});
      socketLog(`Re-subscribed ${widgetIds.length} widgets`);
    }

    function socketLogout() {
      if (activeSocket) {
        activeSocket.close();
      }
    }

    function emit(event, data) {
      if (activeSocket) {
        activeSocket.emit(event, data);
      }
    }

    function getSocket() {
      return activeSocket;
    }

    function subscribeWidget(widgetId) {
      subscribedWidgetIds.add(widgetId);
      emit('message', { type: 'widgetUpdates', data: { subscribeWidgetIds: [widgetId] } });
      socketLog(`Widget ${widgetId} is subscribed`);
    }

    function unSubscribeWidget(widgetId) {
      subscribedWidgetIds.delete(widgetId);
      emit({ type: 'widgetUpdates', data: { unsubscribeWidgetIds: [widgetId] } });
      socketLog(`Widget ${widgetId} is UNsubscribed`);
    }

    function defaultMessageProcessor(data) {
      const standardTypeHandler = standardMessageHandlers[data.type];

      if (_.isFunction(standardTypeHandler)) {
        standardTypeHandler(data);
      }
    }

    function defaultHandlerTypeMessage(data) {
      const notifyType = _.get(data, "data.msgType", "success");
      const notificationTypes = {
        success: "notifySuccess",
        error: "notifyError",
      };
      AdpNotificationService[
        notificationTypes[notifyType] || notificationTypes.success
      ](data.data.msgText || "[Empty message]", data.data.msgTitle);
    }

    function logoutHandler() {
      AdpSessionHelper.doLogout();
    }

    function simpleBackgroundJobsHandler(data) {
      const notificationMethod =
        _.get(data, "level") === "error" ? "notifyError" : "notifySuccess";

      AdpNotificationService[notificationMethod](
        data.message,
        "Background jobs"
      );
    }

    function applyProcessorQueueToMessage(data) {
      let i = 0;

      while (i < messageProcessors.length) {
        const item = messageProcessors[i];
        const processor = item.processor;

        if (processor) {
          const processorResult = processor(data, item.params);

          if (processorResult === false) {
            break;
          } else {
            i++;
          }
        }
      }
    }

    function registerMessageProcessor(processor, params) {
      const item = { processor: processor };

      if (params) {
        item.params = params;
      }

      messageProcessors.unshift(item);
    }

    function unRegisterMessageProcessor(processor) {
      const index = _.findIndex(messageProcessors, function (item) {
        return item.processor === processor;
      });

      if (index >= 0) {
        messageProcessors.splice(index, 1);
      }
    }

    function socketLog(message) {
      $log.debug("SocketIO: ", message);
    }

    return {
      doLogin,
      socketLogout,
      registerMessageProcessor,
      unRegisterMessageProcessor,
      getSocket,
      subscribeWidget,
      unSubscribeWidget,
      emit,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .component('adpLastLoginDataModal', {
      templateUrl: 'app/adp-auth/directives/last-login-data-modal/last-login-data-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpLastLoginDataModalController',
      controllerAs: 'vm',
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .controller('AdpLastLoginDataModalController', AdpLastLoginDataModalController);

  /** @ngInject */
  function AdpLastLoginDataModalController() {
    var vm = this;

    vm.$onInit = function () {
      vm.lastLoginData = vm.resolve.lastLoginData;
    };

    vm.toData = function (date) {
      return new Date(date).toString();
    }

    vm.confirm = function () {
      vm.close({ confirmed: true });
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpAuth')
    .directive('loginInfo', LoginInfoDirective);

  function LoginInfoDirective(APP_CONFIG) {
    return {
      restrict: 'E',
      templateUrl: 'app/adp-auth/directives/login-info/login-info.template.html',
      link: function(scope) {
        var INTERFACE = window.adpAppStore.appInterface();
        scope.user = lsService.getUser();
        scope.disabled = !INTERFACE.header.components.userMenu;
        scope.baseUrl = APP_CONFIG.appSuffix;
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .component('adpAlertModal', {
      templateUrl: 'app/adp-common/directives/adp-alert-modal/adp-alert-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controllerAs: 'vm',
      controller: function AdpConfirmDialogModalController() {
        var vm = this;

        vm.$onInit = function () {
          vm.options = vm.resolve.options;
        };

        vm.cancel = function () {
          vm.dismiss({ confirmed: false });
        };
      }
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .directive('adpAppLogo', adpAppLogo);

  function adpAppLogo(APP_CONFIG) {
    return {
      restrict: 'E',
      templateUrl: 'app/adp-common/directives/adp-app-logo/adp-app-logo.html',
      replace: true,
      link: function(scope) {
        var INTERFACE = window.adpAppStore.appInterface();

        scope.logoSrc = INTERFACE.app.header.components.logo ? INTERFACE.app.logo.small : '';
        scope.logoUrl = APP_CONFIG.resourceUrl + scope.logoSrc;

        scope.title = INTERFACE.app.title;
      }
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .component('adpConfirmDialogModal', {
      templateUrl: 'app/adp-common/directives/adp-confirm-dialog-modal/adp-confirm-dialog-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpConfirmDialogModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .controller('AdpConfirmDialogModalController', AdpConfirmDialogModalController);

  /** @ngInject */
  function AdpConfirmDialogModalController() {
    var vm = this;

    vm.$onInit = function () {
      vm.options = vm.resolve.options;
    };

    vm.confirm = function () {
      vm.close({ confirmed: true });
    };

    vm.extra = function() {
      vm.options.extraButtonCb();
      vm.dismiss({ confirmed: false });
    }

    vm.cancel = function () {
      vm.dismiss({ confirmed: false });
    };
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpCommon")
    .component("adpPromptDialogModal", {
      templateUrl: "app/adp-common/directives/adp-prompt-dialog-modal/adp-prompt-dialog-modal.html",
      bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
      },
      controllerAs: "vm",
      controller: function () {
        const vm = this;

        vm.$onInit = function () {
          vm.options = vm.resolve.options;
          vm.config = {
            value: vm.options.value,
            onValueChanged(e) {
              vm.error = validate(vm.value);
              if (e.value && !vm.error && e.event.keyCode === 13) {
                e.stopPropagation();
                vm.save();
              }
            },
            onInitialized(e) {
              setTimeout(() => {
                e.component.focus();
              }, 0);
            },
            valueChangeEvent: 'input',
          }

          vm.text =  vm.options.text || "";
          vm.saveButtonText = vm.options.saveButtonText || "Save";
          vm.isRequired = vm.options.isRequired || true;
          vm.error = validate(vm.value);
        };

        vm.save = function () {
          vm.close({ $value: vm.value });
        };

        vm.cancel = () => vm.dismiss();

        function validate() {
          if (vm.isRequired && !vm.value) {
            return "Required";
          }

          if (vm.options.validate) {
            return vm.options.validate(vm.value);
          }

          return "";
        }
      }
    });
})();
;;(function () {
  "use strict";

  var NO_FILE_SELECTED_ERROR = "Please select file to readFile";

  angular
    .module("app.adpCommon")
    .directive("selectNgFile", function () {
      return {
        require: "ngModel",
        link: function postLink(scope, elem, attrs, ngModel) {
          elem.on("change", function (e) {
            var files = elem[0].files;
            ngModel.$setViewValue(files);
          })
        }
      }
    })
    .component("adpReadFileDialogModal", {
      templateUrl: "app/adp-common/directives/adp-read-file-dialog-modal/adp-read-file-dialog-modal.html",
      bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
      },
      controllerAs: "vm",
      controller: function (
        $element,
        AdpFileDropzoneHelper
      ) {
        var vm = this;
        vm.fileArray = [];
        vm.selectedFilesText = "";

        vm.$onInit = function () {
          vm.options = _.extend(
            {
              uploadButtonText: "Upload",
              outputFormat: "text",
              autoOpenFileDialog: false,
              readFile: true,
              validate: function () {
                return ""
              },
            },
            vm.resolve.options);

          vm.error = NO_FILE_SELECTED_ERROR;
        };

        vm.$postLink = function () {
          initDropZone();

          if (vm.options.autoOpenFileDialog) {
            vm.onInput();
          }
        };

        vm.onInput = function () {
          $("input", $element).click();
        };

        vm.onChange = function () {
          vm.error = validate();
          vm.selectedFilesText = vm.error ? "" : _.map(vm.fileArray, function (file) {
            return file.name
          }).join(", ");
        };

        vm.onReadFile = function () {
          readIfNotEmpty();
        };

        vm.cancel = function () {
          destroyDropZone()
          vm.dismiss();
        };

        function readIfNotEmpty() {
          if (!vm.fileArray.length) {
            vm.error = NO_FILE_SELECTED_ERROR;
          } else {
            readFile();
          }
        }

        function readFile() {
          if (vm.options.readFile) {
            var reader = new FileReader();
            var readerMethod = "readAs" + vm.options.outputFormat.substr(0, 1)
                                            .toUpperCase() + vm.options.outputFormat.substr(1);

            if (reader[readerMethod]) {
              reader.onload = function (event) {
                var result = _.assign(
                  {},
                  getFileProps(vm.fileArray[0]),
                  {contents: event.target.result});

                vm.close({$value: result});
              };
              reader[readerMethod](vm.fileArray[0]);
            }
          } else {
            vm.close({$value: vm.fileArray[0]});
          }
        }

        function getFileProps(file) {
          return _.pick(file, "name", "size", "type", "lastModified");
        }

        function validate() {
          return vm.options.validate(vm.fileArray[0]);
        }

        function initDropZone() {
          var $dropZone = $(".drop-zone", $element);

          AdpFileDropzoneHelper.bindEvents($dropZone, {
            onDrop: function (e) {
              vm.fileArray = [e.originalEvent.dataTransfer.files[0]];
              vm.onChange();
            }
          })
        }

        function destroyDropZone() {
          var $dropZone = $(".drop-zone", $element);

          AdpFileDropzoneHelper.getUnbindEvents($dropZone)();
        }
      }
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('ActionsHandlers', ActionsHandlers);

  /** @ngInject */
  function ActionsHandlers(
    AdpGeneratorModalService,
    AdpNotificationService,
    AdpModalService,
    AdpModalFormService,
    ACTIONS,
    ActionMessages,
    GraphqlCollectionMutator,
    ErrorHelpers,
    GridOptionsHelpers,
    AdpUnifiedArgs,
    AdpRtcActions,
  ) {
    return {
      create: createAction,
      update: updateAction,
      viewDetails: viewDetails,
      delete: deleteRecord,
      clone: cloneAction,
    };

    function createAction(schema, data, actionParams) {
      var modalOptions = getActionsOptions(ACTIONS.CREATE, schema, data, actionParams);
      return showFormModal(modalOptions, actionParams);
    }

    function updateAction(schema, data, actionParams) {
      var modalOptions = getActionsOptions(ACTIONS.UPDATE, schema, data, actionParams);
      return showFormModal(modalOptions, actionParams);
    }

    function cloneAction(schema, data, actionParams) {
      var modalOptions = cloneOptions(schema, data);
      return showFormModal(modalOptions, actionParams);
    }

    function cloneOptions(schema, data) {
      const clonedData = _.cloneDeep(data);
      delete clonedData._id;
      delete clonedData._actions;
      removeArrayIds(schema, clonedData);

      return getActionsOptions(ACTIONS.CLONE, schema, clonedData);
    }

    function removeArrayIds(schema, data) {
      const {fields, type} = schema;
      if (!data || !fields) {
        return;
      }
      if (type === 'Array') {
        _.each(data, item => {
          delete item._id;
        })
      }
      _.each(fields, (fieldSchema, fieldName) => {
        removeArrayIds(fieldSchema, data[fieldName]);
      })
    }

    function deleteRecord(schema, data, actionParams) {
      var modalOptions = {
        message: 'Are you sure that you want to delete this record?',
        schema: schema,
        actionType: ACTIONS.DELETE,
      };

      return AdpModalService.confirm(modalOptions)
        .then(function () {
          var result = GraphqlCollectionMutator.delete(schema, data);
          AdpRtcActions.addInfoAboutRecordMutation(ACTIONS.DELETE, schema, data);
          return result;
        })
        .then(function () {
          var gridInstance = _.get(actionParams, "gridInstance");

          AdpNotificationService.notifySuccess(ActionMessages[ACTIONS.DELETE](schema));
          gridInstance && GridOptionsHelpers.refreshGrid(gridInstance);
        })
        .catch(function (error) {
          ErrorHelpers.handleError(error, 'Unknown error, while trying to delete record.');
        });
    }

    function viewDetails(schema, data) {
      var options = {
        schema: schema,
        data: data
      };

      return AdpGeneratorModalService.detailsModal(options);
    }

    function getActionsOptions($action, schema, data, actionParams) {
      var args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: $action,
        formData: data || {},
        schema: schema,
      });

      if (actionParams && actionParams.customData) {
        args.customData = actionParams.customData;
      }

      if ($action === ACTIONS.CLONE && schema.schemaName === 'datasets') {
        args.action = ACTIONS.CLONE_DATASET;
      }

      return { args: args };
    }

    function showFormModal(modalOptions, actionParams) {
      const opts = {
        schema: _.get(modalOptions, 'args.modelSchema'),
        recordId: _.get(modalOptions, 'args.row._id'),
        formData: _.get(modalOptions, 'args.row'),
        action: _.get(modalOptions, 'args.action'),
      };
      const customData = _.get(modalOptions, 'args.customData');

      if (customData) {
        opts.customData = customData;
      }

      return AdpModalFormService.openForm(opts)
        .then(function (res) {
          if (!res) {
            return;
          }

          const gridInstance = _.get(actionParams, 'gridInstance');
          gridInstance && GridOptionsHelpers.refreshGrid(gridInstance);

          return res;
        });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('NumberArrayEditorConfig', NumberArrayEditorConfig);

  /** @ngInject */
  function NumberArrayEditorConfig(StringArrayEditorConfig) {
    return function (args, initialValue, onValueChangeCb) {
      const baseConfig = StringArrayEditorConfig(args, initialValue, onValueChangeCb);

      const prevCb = baseConfig.onValueChanged;
      baseConfig.onValueChanged = function (e) {
        prevCb(e);
        setComponentClass(e);
      }

      const numberEditorConfig = {
        onInitialized: setComponentClass,
        customItemCreateEvent: 'change focusout',
      };

      return _.merge(baseConfig, numberEditorConfig);
    }

    function setComponentClass(e) {
      var value = e.component.option('value');
      e.element.toggleClass('not-empty', !_.isEmpty(value));
    }
  }
})();
;
;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('StringArrayEditorConfig', StringArrayEditorConfig);

  /** @ngInject */
  function StringArrayEditorConfig() {
    return function (args, initialValue, onValueChangeCb) {
      var fieldData = initialValue || [];

      // how it works:
      // main purpose of this code is to allow custom tags with duplicates inside tagBox
      // all component data is stored in multiple presentation
      // tagBox values is indexes of dataSource
      // dataSource is store Array of { id, label }, where id is index and label is data
      // order:
      // when use add new tag onCustomItemCreating triggered. new item added into dataSource
      // then onValueChanged triggered, where dataSource is mapped by 'label'
      // result passed to onValueChangeCb, which updates form model
      // that where real data is stored
      return {
        showClearButton: true,
        customItemCreateEvent: 'change focusout',
        elementAttr: { class: 'adp-select-box adp-string-array' },
        inputAttr: { 'test-field-control-id': args.path },
        acceptCustomValue: true,
        placeholder: 'Type in new value and press Enter',
        openOnFieldClick: false,
        displayExpr: 'label',
        valueExpr: 'id',
        value: _.range(0, fieldData.length),
        dataSource: fieldData.map((item, index) => ({ label: item, id: index })),
        onCustomItemCreating: onItemCreating,
        onValueChanged: function (e) {
          onValueChanged(e);
          const value = getValueForControl(e.component.option('dataSource'));
          onValueChangeCb({ value });
        },
        tagTemplate(data, tagElement) {
          var component = this;
          var removeBtn = $('<div class="dx-tag-remove-button"><span class="dx-icon dx-icon-clear"></span></div>');

          removeBtn.on('click', function () {
            var ids = component.option('value').slice();
            _.pull(ids, data.id);

            component.option('value', ids);
            removeBtn.off('click');
          });

          $('<div class="dx-tag-content">')
            .attr('adp-qaid-field-tag', args.path)
            .append('<span>' + _.escape(data.label) + '</span>', removeBtn)
            .appendTo(tagElement);
        }
      };
    }

    function onItemCreating(data) {
      if(!data.text) {
        data.customItem = null;
        return;
      }

      var currentItems = data.component.option('dataSource');
      var itemWithMaxId = currentItems.length ?
        currentItems[currentItems.length - 1] :
        { id: -1 };

      var newItem = { label: data.text, id: itemWithMaxId.id + 1 };
      currentItems.push(newItem);

      data.component.option('dataSource', currentItems);
      data.customItem = newItem;
    }

    function onValueChanged(e) {
      const dataSource = e.component.option('dataSource').slice(0);
      _.remove(dataSource, item => !_.includes(e.value, item.id));
      e.component.option('dataSource', dataSource);
    }

    function getValueForControl(valueList) {
      return _.isEmpty(valueList) ? null : _.map(valueList, 'label');
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('ClientError', ClientError);

  /** @ngInject */
  function ClientError() {
    function _ClientError(message) {
      Error.call(this, message) ;
      this.name = "_ClientError";

      this.message = message;

      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, _ClientError);
      } else {
        this.stack = (new Error()).stack;
      }

    }

    _ClientError.prototype = Object.create(Error.prototype);

    return _ClientError;
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('ErrorHelpers', ErrorHelpers);

  /** @ngInject */
  function ErrorHelpers(
    ServerError,
    ResponseError,
    UploadError,
    ClientError,
    AdpNotificationService
  ) {
    return {
      handleError: function (error, defaultMessage) {
        var shouldDisplayToUser = (error instanceof UploadError) || (error instanceof ResponseError)|| (error instanceof ClientError);

        if (shouldDisplayToUser) {
          AdpNotificationService.notifyError(error.message);
        } else if (error instanceof ServerError) {
          var messages = Array.isArray(error.message) ? error.message : [error.message];

          AdpNotificationService.notifyError(messages.join('<br/>'), 'Server error');
        } else if (error.status < 0) {
          AdpNotificationService.notifyError('Unable to connect to the server. Please try again later');
        } else {
          console.error(defaultMessage, error);
        }
      }
    }
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('ResponseError', ResponseError);

  /** @ngInject */
  function ResponseError() {
    function _ResponseError(message) {
      Error.call(this, message) ;
      this.name = "_ResponseError";

      this.message = message;

      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, _ResponseError);
      } else {
        this.stack = (new Error()).stack;
      }

    }

    _ResponseError.prototype = Object.create(Error.prototype);
    _ResponseError.RECORD_NOT_FOUND = 'Record not found';
    _ResponseError.SCHEMA_IS_EMPTY = 'Scheme is empty';

    return _ResponseError;
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('ServerError', ServerError);

  /** @ngInject */
  function ServerError() {
    function _ServerError(message) {
      Error.call(this, message) ;
      this.name = "_ServerError";

      this.message = message;

      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, _ServerError);
      } else {
        this.stack = (new Error()).stack;
      }

    }

    _ServerError.prototype = Object.create(Error.prototype);

    _ServerError.UNABLE_SEND = 'Unable to send data.'
    _ServerError.UNABLE_TO_GET_DATA = 'Unable to get data.'

    return _ServerError;
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpCommon')
    .service('UploadError', UploadError);

  /** @ngInject */
  function UploadError() {
    function _UploadError(message) {
      Error.call(this, message) ;
      this.name = "_UploadError";

      this.message = message;

      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, _UploadError);
      } else {
        this.stack = (new Error()).stack;
      }

    }

    _UploadError.prototype = Object.create(Error.prototype);

    return _UploadError;
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .component('adpDataGrid', {
      templateUrl: 'app/adp-data-grid/components/adp-data-grid/adp-data-grid.template.html',
      bindings: {
        schema: '<',
        options: '<',
      },
      controller: 'adpDataGridController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .controller('adpDataGridController', adpDataGridController);

  /** @ngInject */
  function adpDataGridController(
    GridOptions,
    $element
  ) {
    var vm = this;
    vm.dataGridOptions = null;

    vm.$onInit = function () {
      vm.dataGridOptions = getOptions(vm.schema, vm.options);
      vm.gridOptions = {
        position: 'right',
        maxHeight: '30vh',
        maxWidth: '30vw',
        height: 'auto',
        showEvent: {
          delay: 0
        },
      };
    };

    vm.$onChanges = function (changeObj) {
      var prevSchema = _.get(changeObj, 'schema.previousValue', null);
      var currentSchema = _.get(changeObj, 'schema.currentValue', null);
      var isSchemaEmpty = !_.keys(prevSchema).length;

      if (isSchemaEmpty || prevSchema === currentSchema) {
        return;
      }

      updateGridOptions(vm.schema, vm.options);
    }

    function updateGridOptions(schema, options) {
      const gridInstance = $element.find('[dx-data-grid]').dxDataGrid('instance');
      vm.dataGridOptions = getOptions(schema, options);
      gridInstance && gridInstance.option(vm.dataGridOptions);
    }

    function getOptions(schema, options) {
      return _.merge({}, GridOptions.create(schema), options);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .component('adpRecordDetails', {
      templateUrl: 'app/adp-data-grid/components/adp-record-details/adp-record-details.template.html',
      bindings: {
        schema: '<',
        data: '<'
      },
      controller: 'adpRecordDetailsController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .controller('adpRecordDetailsController', adpRecordDetailsController);

  /** @ngInject */
  function adpRecordDetailsController(
    AdpUnifiedArgs,
    HtmlCellRenderer,
    GridSchema,
    ACTIONS,
    EvalShowIn
  ) {
    var vm = this;
    vm.$onInit = function onInit() {
      const fields = GridSchema.getFieldsForDetailedView(vm.schema);
      const recordData = presetRecordWithNull(vm.data, fields);
      vm.args = unifiedArgs(recordData);
      vm.filteredRecord = EvalShowIn.forViewDetails(vm.args);
      vm.fields = GridSchema.groupFieldsIntoViewDetailsGroups(fields, vm.filteredRecord);
    };

    vm.selectColumnClass = function (field) {
      var fieldWidth = field.formWidth || 12;
      return ['adp-col', 'adp-col-' + fieldWidth];
    }

    vm.showValue = function (field) {
      return field.type === 'Blank' || !_.isUndefined(vm.filteredRecord[field.fieldName]);
    }

    function presetRecordWithNull(data, fields) {
      return _.transform(fields, function (result, field) {
        var fieldName = field.fieldName;
        result[fieldName] = _.isUndefined(data[fieldName]) ? null : data[fieldName];
      }, {});
    }

    function unifiedArgs(recordData) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        formData: recordData,
        schema: vm.schema,
        action: ACTIONS.VIEW_DETAILS,
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .directive('adpViewDetailsTooltip', adpViewDetailsTooltip);

  function adpViewDetailsTooltip($timeout) {
    const template = `
    <span ng-show="::hasDescription">
      <b class="adp-tooltip-trigger fa fa-question-circle"></b>
      <span dx-tooltip="::tooltipOptions"></span>
    </span>`;

    return {
      restrict: 'E',
      scope: {
        field: '<',
      },
      replace: true,
      template,
      link: function (scope, element) {
        $timeout(function () {
          scope.hasDescription = !_.isUndefined(scope.field.description);
          if (!scope.hasDescription) {
            return;
          }

          scope.tooltipOptions = {
            target: element.find('.adp-tooltip-trigger'),
            position: 'right',
            showEvent: 'click',
            maxWidth: '400px',
            contentTemplate(data) {
              data.html(scope.field.description);
            },
          };
        });
      }
    }
  }
})();
;;(function () {
  'use strict';
  var ROW_POSITION_SIGNATURE = "grid.row";

  angular
    .module('app.adpDataGrid')
    .factory('ActionsHelpers', ActionsHelpers);

  /** @ngInject */
  function ActionsHelpers(
    APP_CONFIG,
    AdpIconsHelper,
    AdpSchemaService,
    AdpUnifiedArgs,
    ActionsHandlers
  ) {
    function getActionsByPosition(schema, pickFunction) {
      var actions = _.chain(schema)
                     .get('actions.fields', {})
                     .pickBy(pickFunction || _.noop)
                     .map(function (action, name) {
                       action.actionName = name;
                       return action;
                     })
                     .value();

      return actions.sort(AdpSchemaService.getSorter('actionOrder'));
    }

    function isActionAllowed(action, allowedPositions){
      const position = _.get(action, 'position', '');
      return _.intersection(_.flatten([position]), _.flatten([allowedPositions])).length;
    }

    function getForHelperType(action) {
      var actionName = _.get(action, "action.link", "")
      var helperAction = _.get(appModelHelpers, 'CustomActions.' + actionName);

      if (helperAction) {
        return helperAction;
      }
    }

    function getForModuleType(action) {
      var moduleName = _.get(action, "action.link", "")
      var injector = angular.element(document).injector();

      if (injector.has(moduleName)) {
        var methodName = _.get(action, 'action.method');
        var moduleReturn = injector.get(moduleName);

        if (methodName) {
          return moduleReturn[methodName];
        } else {
          return moduleReturn;
        }
      } else {
        console.error('No module found for action:', moduleName);
      }
    }

    function evalDisabledAttr(actionItem, recordData, schema) {
      // Method seems to be called evalEnabled but kept within old name for less refactoring effort
      return !evalAttribute('enabled', actionItem, recordData, schema);
    }

    function evalVisibleAttr(actionItem, recordData, schema) {
      return evalAttribute('visible', actionItem, recordData, schema);
    }

    function evalAttribute(attrName, actionItem, recordData, schema) {
      const val = actionItem[attrName];

      if (_.isNil(val)) {
        return true;
      }

      if (_.isString(val)) {
        var args = AdpUnifiedArgs.getHelperParamsWithConfig({
          path: '',
          action: actionItem.actionName,
          formData: recordData || {},
          schema,
        });

        try {
          var fn = new Function('return ' + val);
          return fn.call(args);
        } catch (e) {
          console.error(`Error while trying to eval "${attrName}" attribute for: `, args);
        }
      }

      return val;
    }

    function pickTableActions(schema) {
      return _.pickBy(schema.actions.fields,  (action) => isActionAllowed(action, ROW_POSITION_SIGNATURE));
    }

    function actionsIsEmpty(actions) {
      var actionNames = _.keys(actions);
      var hasOnlyViewsKey = actionNames.length === 1 && actionNames[0] === 'view';
      return _.isEmpty(actions) || hasOnlyViewsKey;
    }

    function getActionTemplate(actionItem, params) {
      var types = {
        action: _buttonTemplate,
        link: _linkTemplate,
        module: _buttonTemplate,
      };

      var actionType = _.get(actionItem, "action.type");
      var templateFn = types[actionType];

      if (_.isUndefined(templateFn)) {
        throw new Error("Unknown action type in " + actionType);
      }

      return templateFn(actionItem, params);
    }

    function handleActionClick(actionItem, params) {
      var actionType = actionItem.action.type;

      if (actionType === 'module') {
        return _callModuleAction(actionItem, params);
      } else {
        var actionFnName = _getActionCallbackName(actionItem);
        var hasCustomAction = _.hasIn(appModelHelpers.CustomActions, actionFnName);
        if (hasCustomAction) {
          return _callCustomAction(actionItem, params);
        }

        if (_.hasIn(ActionsHandlers, actionFnName)) {
          return _callBuiltInAction(actionItem, params);
        }
      }
    }

    function getLinkActionUrl(actionItem, params) {
      var URL_PARAMS_REGEX = /\/:([^\/\n\r]+)/g;
      var link = actionItem.action.link.replace(URL_PARAMS_REGEX, function (_0, key) {
        return '/' + _.get(params.row, key);
      });

      if (!_isActionExternal(actionItem)) {
        link = APP_CONFIG.appSuffix + link;
      }

      return link;
    }

    function _buttonTemplate(actionItem, params) {
      var btnClass = _.compact(["adp-grid-action table-action", actionItem.className]).join(" ");

      return $("<button>")
        .dxButton({
          elementAttr: {
            class: btnClass,
            "data-action-name": actionItem.actionName,
            style: _addStyles(actionItem),
            type: 'button',
          },
          disabled: evalDisabledAttr(actionItem, params.row, params.schema),
          hint: actionItem.description,
          onClick: handleActionClick(actionItem, params),
          template: _createContents(actionItem),
        });
    }

    function _linkTemplate(actionItem, params) {
      var linkClass = _.compact(["table-action", actionItem.className]).join(" ");
      var link = getLinkActionUrl(actionItem, params);
      var target = _isActionExternal(actionItem) ? _.get(actionItem, "action.target", '_self') : '';
      var contents = _createContents(actionItem);
      var html = contents.length ? contents[0].outerHTML : '---';
      var hint = actionItem.description;

      return `
        <a 
          href="${link}"
          style="${_addStyles(actionItem)}"
          class="${linkClass}"
          ${hint ? `title="${hint}"` : ''}
          adp-row-${params.row._id}
          data-action="${actionItem.action.link}"
          data-action-name=${actionItem.actionName}
        >
            <span>${html}</span>
        </a>
      `
    }

    function _addStyles(params) {
      var styles = _.pick(params, ["backgroundColor", "borderColor", "textColor"]);
      if (_.isEmpty(styles)) {
        return "";
      }

      return _.map(styles, function (value, key) {
        return [_.kebabCase(key === "textColor" ? "color" : key), ":", value, "!important"].join("");
      }).join(";");
    }

    function _createContents(actionItem) {
      if (_.isUndefined(actionItem.icon)) {
        return actionItem.fullName;
      } else {
        return AdpIconsHelper.getIconHtml(actionItem.icon);
      }
    }

    function _callCustomAction(actionItem, params) {
      return function () {
        var actionFnArgs = AdpUnifiedArgs.getHelperParamsWithConfig({
          path: "",
          formData: params.row,
          action: actionItem.actionName,
          schema: params.schema,
        });

        var actionCallbackName = _getActionCallbackName(actionItem);
        var customActionFn = _.get(appModelHelpers, "CustomActions." + actionCallbackName);
        customActionFn.call(actionFnArgs, params.row);
      }
    }

    function _callBuiltInAction(actionItem, params) {
      return function () {
        var actionFnName = _getActionCallbackName(actionItem);
        var gridInstance = _.get(params, 'customGridOptions.gridComponent');

        ActionsHandlers[actionFnName](params.schema, params.row, {gridInstance: gridInstance});
      }
    }

    function _callModuleAction(actionItem, params) {
      return function () {
        var injector = angular.element(document).injector();
        var actionFnArgs = AdpUnifiedArgs.getHelperParamsWithConfig({
          path: "",
          formData: params.row,
          action: actionItem.actionName,
          schema: params.schema,
        });
        var actionCallback = _getActionCallbackName(actionItem).split(".");
        var actionModule = actionCallback[0];
        var actionMethod = actionCallback[1];

        if (injector.has(actionModule)) {
          var customActionFn = injector.get(actionModule);

          if (actionMethod) {
            customActionFn = customActionFn[actionMethod];
          }

          if (_.isFunction(customActionFn)) {
            customActionFn.apply(actionFnArgs, [params.row, params.customGridOptions.gridComponent]);
          }
        }
      }
    }

    function _getActionCallbackName(actionItem) {
      return actionItem.action.link +
        (actionItem.action.type === "module" && actionItem.action.method ? "." + actionItem.action.method : "");
    }

    function _isActionExternal(actionItem) {
      return !!_.get(actionItem, "action.external");
    }

    return {
      getActionsByPosition,
      isActionAllowed,
      getForHelperType,
      getForModuleType,
      evalDisabledAttr,
      evalVisibleAttr,
      pickTableActions,
      actionsIsEmpty,
      getActionTemplate,
      handleActionClick,
      getLinkActionUrl,
    };
  }
})()
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridModalEditors', GridModalEditors);

  /** @ngInject */
  function GridModalEditors(
    AdpIconControlService,
    AdpModalService,
    AdpUnifiedArgs
  ) {
    return {
      call: call,
      isModalEditor: isModalEditor,
    }

    function call(options, afterSubmit, onCancel) {
      const field = options.args.fieldSchema;

      if (field.type === 'Password') {
        AdpModalService.passwordUpdate(field)
          .then(afterSubmit)
          .catch(onCancel);
      } else if (field.type === 'Icon') {
        return AdpIconControlService.modal()
          .then(afterSubmit)
          .catch(onCancel);
      } else {
        return formModal({ args: getArgsSlice(options.args) })
          .then(function (formData) {
            var v = formData[options.args.fieldSchema.fieldName];
            return afterSubmit(_.isEmpty(v) ? null : v);
          })
          .catch(onCancel);
      }
    }

    function formModal(modalOptions) {
      var modalInstance = AdpModalService.createModal('adpCellEditorModal', modalOptions);
      return modalInstance.result;
    }

    function getArgsSlice(args) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: 'cell-editing-' + args.action,
        formData: getDataSlice(args) || {},
        schema: getSchemaSchema(args),
      });
    }

    function getSchemaSchema(args) {
      var field = args.fieldSchema;
      var fields = {};
      fields[field.fieldName] = field;

      return {
        type: "Schema",
        fields: fields,
        schemaName: args.modelSchema.schemaName,
        fullName: args.modelSchema.fullName,
      }
    }

    function getDataSlice(args) {
      var data = {};
      data[args.fieldSchema.fieldName] = _.cloneDeep(args.data);

      return data;
    }

    function isModalEditor(type) {
      var object = ['Object', 'Array', 'AssociativeArray', 'KeyVal'];
      var media = ['File', 'Image', 'Audio', 'Video', 'File[]', 'Image[]', 'Audio[]', 'Video[]'];
      var other = ['Location', 'Code', 'Html', 'Password', 'Mixed', 'Icon'];

      var modalEditors = object.concat(media, other);
      return _.includes(modalEditors, type);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('CellEditorsValidationService', CellEditorsValidationService);

  /** @ngInject */
  function CellEditorsValidationService(
    AdpValidationMessages,
    AdpValidationRules,
    AdpUnifiedArgs,
    ACTIONS
  ) {
    var requiredValidator = { type: 'required' };

    return {
      getValidators: getValidators,
      getMessage: getMessage,
    }

    function getValidators(schema, fieldName) {
      var field = schema.fields[fieldName];
      var rules = [];
      if (field.required === true) {
        rules.push(requiredValidator);
      }

      if (field.type === 'Decimal128') {
        var DECIMAL_REGEX = /^[+-]?(\d+)?\.?(\d+)?([Ee][+-]?(\d+))?$/;

        rules.push({
          type: 'pattern',
          pattern: DECIMAL_REGEX,
          message: 'Please enter correct decimal value'
        });
      }

      (field.validate || []).forEach(function (validatorRule) {
        if (!AdpValidationRules[validatorRule.validator]) {
          return;
        }

        rules.push({
          type: 'custom',
          ignoreEmptyValue: true,
          reevaluate: true,
          validationCallback: function (e) {
            e.rule.message = AdpValidationMessages.update(e.value, field, validatorRule);
            var args = getArgs(field.fieldName, schema, e.data, validatorRule);
            return AdpValidationRules[validatorRule.validator](args);
          }
        });
      });

      return rules;
    }

    function getMessage(value, field, validatorRule) {
      if (validatorRule.validator === 'required') {
        return '"' + field.fullName + '" is required.';
      }

      return AdpValidationMessages.update(value, field, validatorRule);
    }

    function getArgs(fieldName, schema, row, validationRule) {
      var args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: fieldName,
        formData: row,
        action: ACTIONS.UPDATE,
        schema: schema,
      });
      args.validationRule = validationRule;

      return args;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridEditorsFactory', GridEditorsFactory);

  /** @ngInject */
  function GridEditorsFactory(
    NumberEditor,
    DateEditor,
    ListEditorFactory,
    StringEditor,
    BooleanEditor,
    ImperialUnitSingleEditor,
    ImperialUnitMultipleEditor,
    LookupEditor,
    TextEditor,
    StringMultipleEditor,
    IntEditor,
    DecimalEditor,
    CurrencyEditor,
    PercentEditor,
    NumberMultipleEditor,
    DecimalMultipleEditor,
    ColorEditor,
    RandomIdEditor
  ) {
    var editorsByType = {
      String: StringEditor,
      Phone: StringEditor,
      Url: StringEditor,
      Email: StringEditor,
      Number: NumberEditor,
      Double: NumberEditor,
      Text: TextEditor,
      Boolean: BooleanEditor,
      TriStateBoolean: BooleanEditor,

      List: ListEditorFactory.single,
      'List[]': ListEditorFactory.multiple,
      FrontendList: ListEditorFactory.single,
      'FrontendList[]': ListEditorFactory.multiple,

      ImperialHeight: ImperialUnitMultipleEditor,
      ImperialWeightWithOz: ImperialUnitMultipleEditor,
      ImperialWeight: ImperialUnitSingleEditor,

      Date: DateEditor,
      Time: DateEditor,
      DateTime: DateEditor,

      LookupObjectID: LookupEditor.single,
      'LookupObjectID[]': LookupEditor.multiple,
      Int32: IntEditor,
      Int64: IntEditor,
      Decimal128: DecimalEditor,
      Currency: CurrencyEditor,
      Percent: PercentEditor,

      'String[]': StringMultipleEditor,
      'Decimal128[]': DecimalMultipleEditor,
      'Number[]': NumberMultipleEditor,
      'Double[]': NumberMultipleEditor,
      'Int32[]': NumberMultipleEditor,
      'Int64[]': NumberMultipleEditor,
      Color: ColorEditor,
      RandomID: RandomIdEditor,
    };

    return function (options) {
      const field = _.get(options, 'args.fieldSchema')
      const type = _.get(options, 'args.fieldSchema.type');

      let componentMethod;
      if (field.list) {
        var isMultiple = type.includes('[]');
        componentMethod = isMultiple ? editorsByType['List[]'] : editorsByType['List'];
      } else {
        componentMethod = editorsByType[type];
      }

      if (!componentMethod) {
        return;
      }

      const newEditorComponent = componentMethod(true);
      newEditorComponent.create(options);
      return newEditorComponent.getElement();
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('CellEditorsService', CellEditorsService);

  /** @ngInject */
  function CellEditorsService(
    GridOptionsHelpers,
    GridEditorsFactory,
    AdpSchemaService,
    AdpUnifiedArgs,
    CellEditorsValidationService,
    GridModalEditors,
    ACTIONS
  ) {
    return function (options, schema) {
      if (!editingEnabled(schema)) {
        return;
      }

      var permissions = getPermissions(schema.actions);
      _.set(options, 'toolbar.items', ['addRowButton']);
      options.editing = {
        mode: 'cell',
        refreshMode: 'reshape',
        allowAdding: permissions.allowAdding,
        allowUpdating: permissions.allowUpdating,
      };

      setupColumns(options.columns, schema);

      GridOptionsHelpers.onEditorPreparing(options, function (event) {
        var isDataRow = event.parentType === 'dataRow';
        var isSelectionCell = event.type === 'selection';

        if (!isDataRow || isSelectionCell) {
          return;
        }

        var options = getOptions(event, schema);
        if (GridModalEditors.isModalEditor(options.args.fieldSchema.type)) {
          enableModalEditor(event, options);
        } else {
          enableEditor(event.editorElement, options);
        }
      });

      GridOptionsHelpers.onRowPrepared(options, event => {
        event.isNewRow && appendRowCancelBlock(event);
      });

      return options;
    };

    function appendRowCancelBlock({ rowElement, component }) {
      if (rowElement.find(".adp-row-insert-cancel").length) {
        return;
      }

      rowElement
        .append(
          $('<td style="width: 0"><div class="adp-row-insert-cancel">Cancel row insertion (Esc)</div></td>')
            .click(() => component.cancelEditData())
        )
    }

    function editingEnabled(schema) {
      var editingEnabled = _.get(schema, 'parameters.enableInCellEditing');
      if (!editingEnabled) { return false; }

      var permissions = getPermissions(schema.actions);
      if (!permissions.allowAdding && !permissions.allowUpdating) {
        return false;
      }
      return true;
    }

    function getPermissions(actions) {
      return {
        allowAdding: _.hasIn(actions, 'fields.create'),
        allowUpdating: _.hasIn(actions, 'fields.update'),
      };
    }

    function setupColumns(columns, schema) {
      columns.forEach(function (column) {
        var field = schema.fields[column.dataField];

        if (_.isNil(field)) {
          return;
        }

        column.allowEditing = isFieldEditable(field);
        if (column.allowEditing) {
          column.validationRules = CellEditorsValidationService.getValidators(schema, field.fieldName);
        }
      });
    }

    function isFieldEditable(field) {
      var checks = {
        enabled: function () {
          return !_.get(field, 'parameters.enableInCellEditing');
        },
        hasDynamicDependency: function () {
          return _.isString(field.show) || _.isString(field.required);
        },
        isSyntheticField: function () {
          return !!field.synthesize || !!field.formRender;
        },
        unReadable: function () {
          return !_.get(field, 'showInDatatable') && !AdpSchemaService.isReadable(field);
        }
      }

      var failed = _.some(checks, function (fn) { return fn() });

      return !failed;
    }

    function enableEditor(element, options) {
      const editorElement = GridEditorsFactory(options);
      if (editorElement) {
        element.replaceWith(editorElement);
      }
    }

    function enableModalEditor(event, options) {
      event.editorElement.replaceWith('editing');

      if (event.row.isNewRow) {
        return insertWithModal(event, options);
      } else {
        return editWithModal(event, options);
      }
    }

    function insertWithModal(event, options) {
      event.component.cancelEditData();

      function afterSubmit(newValue) {
        var data = {};
        data[options.args.fieldSchema.fieldName] = newValue;

        saveData(data);
      }

      function onCancel() {
        saveData({});
      }

      function saveData(data) {
        event.component.getDataSource().store().insert(data)
          .then(function () {
            event.component.refresh(true);
          });
      }

      return GridModalEditors.call(options, afterSubmit, onCancel);
    }

    function editWithModal(event, options) {
      function afterSubmit(newValue) {
        event.setValue(newValue);
        event.component.saveEditData();
      }

      function onCancel() {}

      return GridModalEditors.call(options, afterSubmit, onCancel);
    }

    function getOptions(event, schema) {
      return {
        args: unifiedApproachArgs(event, schema),
        onValueChanged: function (editorEvent) {
          var isEmpty = _.isArray(editorEvent.value) ?
            _.isEmpty(editorEvent.value) :
            _.isNil(editorEvent.value);

          event.setValue(isEmpty ? null : editorEvent.value);
        }
      };
    }

    function unifiedApproachArgs(event, schema) {
      var fieldName = event.dataField;

      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: fieldName,
        formData: event.row.data,
        action: ACTIONS.UPDATE,
        schema: schema,
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridColumnsHelpers', GridColumnsHelpers);

  /** @ngInject */
  function GridColumnsHelpers(
    HtmlCellRenderer,
    AdpUnifiedArgs,
    ACTIONS
  ) {
    return {
      setWidthToColumns,
      getTemplateForField,
      getTextTemplateForField,
      setDatatypeToColumns,
      isGridStateConformsSchema,
    };

    function setWidthToColumns(options, schema) {
      options.columns.forEach(function (column) {
        var fieldName = column.dataField;
        var field = column.name === 'actions' ?
          schema.actions :
          schema.fields[fieldName];

        setWidthToColumn(column, field);
      });
    }

    function setWidthToColumn(column, field) {
      if (!field) { return; }

      function parseWidth(value) {
        var percentRe = /^(\d+)%$/;
        if (percentRe.test(value)) {
          return value;
        }

        var pixelsRe = /^(\d+)px$/;
        var parsedValue;
        if (pixelsRe.test(value)) {
          parsedValue = value.match(/^(\d+)px$/)[1]
          return parseInt(parsedValue, 10);
        }

        return parseInt(value, 10);
      }

      var width = parseWidth(field.width);
      if (!_.isNaN(width)) {
        column.width = width;
      }

      var minWidth = parseWidth(_.get(field, 'parameters.minWidth'));
      if (!_.isNaN(minWidth) && (typeof minWidth === 'number')) {
        column.minWidth = minWidth;
      } else if (!_.isNaN(width) && (typeof width === 'number')) {
        column.minWidth = width;
      }
    }

    function getTemplateForField(field, schema, rowData) {
      var args = getTemplateArguments(field, schema, rowData);
      return HtmlCellRenderer(args);
    }

    function getTextTemplateForField(field, schema, rowData) {
      var args = getTemplateArguments(field, schema, rowData);
      args.params = { asText: true };
      return HtmlCellRenderer(args);
    }

    function getTemplateArguments(field, schema, recordData) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: field.fieldName,
        formData: recordData,
        action: ACTIONS.VIEW,
        schema: schema,
      });
    }

    function setDatatypeToColumns(options, schema) {
      options.columns.forEach(function (column) {
        const fieldName = column.dataField;
        const field = schema.fields[fieldName];
        const type = _.get(field, 'type');
        if (column.type === 'selection') {
          return;
        }

        column.dataType = _dxDatatypeFromSchemaType(type);
      });
    }

    function isGridStateConformsSchema(state, schema) {
      const {columns} = state;
      const {fields} = schema;
      const hasBadColumn = _.find(columns, column => {
        const {dataField, dataType, name} = column;
        if (_.includes(['_action', 'actions'], name)) {
          return false; // actions column is always fine;
        }

        const field = _.get(fields, dataField);
        if (!field) {
          return true; // column which is absent  in schema, is found;
        }

        const columnTypeAssumed = _dxDatatypeFromSchemaType(field.type);
        if (columnTypeAssumed !== dataType) {
          return true;
        }
      });

      return !hasBadColumn;
    }

    function _dxDatatypeFromSchemaType(type) {
      const columnTypes = {
        string: ['String', 'Html', 'Code', 'Password', 'Email', 'Phone', 'Url', 'Text', 'Currency', 'List', 'FrontendList', 'Color', 'Decimal128', 'ObjectID'],
        number: ['Number', 'Double', 'Int32', 'Int64'],
        datetime: ['DateTime', 'Time'],
        date: ['Date'],
        boolean: ['Boolean', 'TriStateBoolean'],
      };
      const jsFieldType = _.findKey(columnTypes, types => _.includes(types, type));

      return jsFieldType || 'object';
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridColumns', GridColumns);

  /** @ngInject */
  function GridColumns(
    AdpSchemaService,
    GridSchema,
    GridFilterHelpers,
    CustomFilterExpression,
    FilterOperation,
    GRID_FORMAT,
    GridTableActions,
    GridColumnsHelpers,
    GridSorting,
    EvalShowIn,
    Guid
  ) {
    return function (options, schema, customGridOptions) {
      var gridFields = GridSchema.getFieldsForGrid(schema);

      options.columns = schemaToColumn(gridFields, schema, customGridOptions);
      GridTableActions(options, schema, customGridOptions);

      GridColumnsHelpers.setWidthToColumns(options, schema);
      GridColumnsHelpers.setDatatypeToColumns(options, schema);
      GridSorting.setSortingOptions(options, schema);

      return options;
    }

    function schemaToColumn(gridFields, schema, customGridOptions) {
      var ShowInEvaluator = EvalShowIn.createFilterMemoizedFunction();
      customGridOptions.handlers.destroy = function () {
        EvalShowIn.removeMemoizedFunction(ShowInEvaluator);
      };

      const columns = gridFields.map(field => {
        var column = createColumn(field, schema, ShowInEvaluator);
        injectColumnOptionsFromSchema(column, field.parameters);

        return column;
      });

      const shouldShowSelectionColumn = _.get(schema, 'parameters.selection.mode') === 'multiple'
        && _.get(schema, 'parameters.selection.showCheckBoxesMode') !== 'none';

      if (shouldShowSelectionColumn) {
        columns.unshift({
          name: Guid.create(),
          type: 'selection',
          allowHiding: false,
          caption: 'Selection',
          width: 30,
        });
      }

      return columns;
    }

    function injectColumnOptionsFromSchema(column, parameters) {
      var helpersPaths = ['headerFilter.dataSource', 'calculateFilterExpression', 'visible'];
      var parametersToMerge = _.omit(parameters, helpersPaths);
      _.merge(column, parametersToMerge);
    }

    function createColumn(field, schema, ShowInEvaluator) {
      var isFilteringAllowed = GridFilterHelpers.filteringAllowedForField(field);
      var columnHidingEnabled = _.get(schema, 'parameters.columnHidingEnabled');
      const allowSorting = _.get(field, 'parameters.allowSorting') !== false;
      const allowFiltering = _.get(field, 'parameters.allowFiltering') !== false && field.showInDatatable && isFilteringAllowed;

      var column = {
        cssClass: ['name-' + field.fieldName, 'adp-grid-cell-' + _.kebabCase(field.type)].join(' '),
        caption: field.fullName || field.fieldName,
        dataField: field.fieldName,
        visible: field.showInDatatable && _.get(field, 'parameters.visible', false),
        showInColumnChooser: field.showInDatatable,
        hidingPriority: columnHidingEnabled ? field.responsivePriority : null,
        allowSorting,
        allowFiltering,
        filterOperations: FilterOperation.get(field),
        calculateFilterExpression: CustomFilterExpression(field, schema),
        selectedFilterOperation:  FilterOperation.getSelected(field),
        cellTemplate: function (container, cellInfo) {
          let filteredData = cellInfo.data;
          if (['Array', 'Object', 'AssociativeArray'].includes(field.type)) {
            filteredData = ShowInEvaluator(schema, cellInfo.data);
          }
          container.append(GridColumnsHelpers.getTemplateForField(field, schema, filteredData));
        },
        groupCellTemplate: function (container, cellInfo) {
          // refactor: it's too complex, better to keep inside some service
          var summaryText = "";
          var findFormat = function (columnName) {
            var summaryItem = _.find(cellInfo.summaryItems, function (item) {
              return columnName === item.column;
            });

            return _.get(summaryItem, 'valueFormat', null);
          };

          var formatValue = function (val, columnName) {
            var fieldSchema = schema.fields[columnName];
            var format = findFormat(columnName) || 'currency';

            if (fieldSchema.type === 'Currency') {
              var formatted = DevExpress.localization.formatNumber(val, format);
              return _.isNil(formatted) ? GRID_FORMAT.EMPTY_VALUE : formatted;
            }

            var rowData = {};
            rowData[fieldSchema.fieldName] = val;
            var argsArray = [fieldSchema, schema, rowData];

            return GridColumnsHelpers.getTextTemplateForField.apply(null, argsArray);
          };

          if (cellInfo.summaryItems) {
            summaryText = _.map(cellInfo.summaryItems,
              function (item) {
                if (item.displayFormat) {
                  return item.displayFormat.replace("{0}", formatValue(item.value, item.column));
                } else {
                  return _.startCase(item.summaryType) + " of "
                    + item.columnCaption + ": " + formatValue(item.value, item.column);
                }
              })
              .join(", ");
          }

          var tpl = "<p>" + field.fullName + ": " + formatValue(cellInfo.data.key, cellInfo.column.dataField) +
            (summaryText ? ". " + summaryText : "") + " </p>";

          if (cellInfo.data.isContinuationOnNextPage) {
            tpl += "<p>(Continues on the next page)</p>";
          }

          container.append(tpl);
        },
        customizeText: function (event) {
          if (
            (FilterOperation.hasBetweenOperation(field.type) && event.target === 'filterRow')
            || _.includes(['filterPanel', 'filterBuilder'], event.target)
          ) {
            var rowData = {};
            rowData[field.fieldName] = event.value;
            var filterContent = GridColumnsHelpers.getTextTemplateForField(field, schema, rowData);

            return filterContent === GRID_FORMAT.EMPTY_VALUE ?
              GRID_FORMAT.NOT_SET_FILTER_VALUE :
              filterContent;
          } else {
            return event.value;
          }
        },
      };

      return column;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridSchema', GridSchema);

  /** @ngInject */
  function GridSchema(GridOptionsHelpers, AdpFieldsService) {
    function getFieldsForGrid(schema) {
      const orderGetter = (field) => getOrder(field, 'datagridOrder');

      return filterFields(schema.fields, [
        _.toArray,
        getReadableFields,
        removeFieldsThatNotForGrid,
        addIdAndPermissionsColumns,
        fields => sortFieldsForViewDetails(fields, orderGetter),
        groupFieldsForDetailedView,
        flattenGroup,
      ]);
    }

    function getFieldsForDetailedView(schema) {
      const orderGetter = (field) => {
        return getOrder(field, 'detailedViewOrder') || getOrder(field, 'formOrder');
      };

      return filterFields(schema.fields, [
        _.toArray,
        getReadableFields,
        fields => sortFieldsForViewDetails(fields, orderGetter),
        groupFieldsForDetailedView,
        flattenGroup,
      ]);
    }

    function getOrder(field, property) {
      const val = Number(field[property]);
      return _.isNaN(val) ? undefined : val;
    }

    function filterFields(fields, pipeFunctions) {
      var pipe = _.flow(pipeFunctions);
      return pipe(fields);
    }

    function getReadableFields(fields) {
      var lastFoundGroup = null;

      return fields.filter(function (field) {
        if (isGroup(field)) {
          lastFoundGroup = field;
        }

        var useParentGroupPermissionForChildField = !_.isNull(lastFoundGroup);
        if (useParentGroupPermissionForChildField) {
          return hasReadPermission(lastFoundGroup);
        }

        return hasReadPermission(field);
      });
    }

    function hasReadPermission(field) {
      return _.get(field, 'permissions.view', true);
    }

    function removeFieldsThatNotForGrid(fields) {
      _.remove(fields, fieldTypesNeverAppearInDataGrid);

      return fields;
    }

    // adding columns that not specified in schema
    // _id - for sorting and record identification
    // _actions - individual records permissions
    function addIdAndPermissionsColumns(fields) {
      var permissionsColumns = {
        type: '_Action',
        fieldName: '_action',
        allowSearch: false,
        showInDatatable: false,
      };

      return fields.concat(permissionsColumns);
    }

    function sortFieldsForViewDetails(fields, orderGetter) {
      const sorted = fields.sort((f1, f2) => AdpFieldsService.fieldsSorter(orderGetter(f1), orderGetter(f2)));

      _.forEach(sorted, (f) => {
        if (_.isArray(f.fields)) {
          f.fields = f.fields.sort((f1, f2) => AdpFieldsService.fieldsSorter(orderGetter(f1), orderGetter(f2)));
        } else if (f.fields) {
          f.fields = sortObjectFields(f.fields, orderGetter);
        }
      });

      return sorted;
    }

    function groupFieldsForDetailedView(fields) {
      var groupedFields = [];
      var lastGroupFields = null;

      _.forEach(fields, function (field) {
        var isGroup = field.type === 'Group';
        if (isGroup) {
          var newGroup = field;
          newGroup.fields = [];
          lastGroupFields = newGroup.fields;
        }

        if (lastGroupFields === null || isGroup) {
          groupedFields.push(field);
        } else {
          lastGroupFields.push(field);
        }
      });

      return groupedFields;
    }

    function groupFieldsIntoViewDetailsGroups(notGroupedFields, groupedRow) {
      const result = {};
      let addIn = result;

      // move fields inside groups
      _.forEach(_.cloneDeep(notGroupedFields), (field) => {
        const { type, fieldName } = field;

        if (type === 'Group') {
          result[fieldName] = field;
          const groupFields = {};
          result[fieldName].fields = groupFields;
          addIn = groupFields;
          return;
        }

        if (type === 'GroupEnd') {
          addIn = result;
          return;
        }

        addIn[fieldName] = field;
      });

      const grouped = [];
      let groups = null;
      let fields = null;
      _.forEach(result, (field) => {
        const { type, fieldName } = field;

        if (type === 'Group') {
          fields = null;
          if (!groups) {
            groups = {};
            grouped.push({ groups })
          }
          groups[fieldName] = field;
        } else {
          groups = null;
          if (!fields) {
            fields = {};
            grouped.push({ fields })
          }
          fields[fieldName] = field;
        }
      });

      // filter not visible groups
      _.forEach(grouped, (fieldOrGroup) => {
        if (fieldOrGroup.fields) {
          return;
        }

        fieldOrGroup.groups = _.filter(fieldOrGroup.groups, group => {
          const isGroupVisible = groupedRow[group.fieldName] !== undefined;
          return isGroupVisible;
        });
      });

      return grouped;
    }

    function flattenGroup(fields) {
      var result = [];

      _.forEach(fields, function (field) {
        result.push(field);

        if (field.type === 'Group') {
          _.forEach(field.fields, function (f) {
            result.push(f);
          });
        }
      });

      return result;
    }

    function sortObjectFields(objectFields, orderGetter) {
      var sortedKeys = _.keys(objectFields).sort(function (key1, key2) {
        var f1 = _.get(objectFields, key1);
        var f2 = _.get(objectFields, key2);
        return AdpFieldsService.fieldsSorter(orderGetter(f1), orderGetter(f2));
      });

      var sortedFields = {};
      _.forEach(sortedKeys, function (key) {
        var currentField = objectFields[key];
        if (currentField.fields) {
          currentField.fields = sortObjectFields(currentField.fields, orderGetter);
        }

        sortedFields[key] = objectFields[key];
      });

      return sortedFields;
    }

    function isGroup(field) {
      return field.type === 'Group';
    }

    function fieldTypesNeverAppearInDataGrid(field) {
      return ([
        'Group', 'GroupEnd', 'Grid', 'FormSeparator', 'Blank'
      ]).includes(field.type);
    }

    function getSchemaForVisibleColumns(schema, gridInstance) {
      var visibleColumns = GridOptionsHelpers.getVisibleColumnNames(gridInstance);
      var resultSchema = _.cloneDeep(schema);

      resultSchema.fields = {};
      visibleColumns.forEach(function (name) {
        resultSchema.fields[name] = schema.fields[name];
      });

      return resultSchema;
    }

    return {
      getFieldsForGrid,
      getFieldsForDetailedView,
      getSchemaForVisibleColumns,
      groupFieldsIntoViewDetailsGroups,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('HtmlCellRenderer', HtmlCellRenderer);

  /** @ngInject */
  function HtmlCellRenderer(
    AdpSchemaService,
    BasicTypesCellRenderer,
    DateTypesCellRenderer,
    LookupTypesCellRenderer,
    MediaTypesCellRenderer,
    LocationCellRenderer,
    ImperialTypesCellRenderer,
    ListTypesCellRenderer,
    ComplexTypesCellRenderer,
    GridTypeCellRenderer,
    MixedTypeTabbedView,
    GRID_FORMAT,
    AdpAttrs,
    FormattersHelper
  ) {
    var htmlCellRenderers = {
      'Phone': BasicTypesCellRenderer.phone,
      'Password': BasicTypesCellRenderer.password,
      'String[]': BasicTypesCellRenderer.stringArray,
      'Int32[]': BasicTypesCellRenderer.stringArray,
      'Int64[]': BasicTypesCellRenderer.stringArray,
      'Number[]': BasicTypesCellRenderer.stringArray,
      'Double[]': BasicTypesCellRenderer.stringArray,
      'Decimal128[]': BasicTypesCellRenderer.stringArray,
      'Number': BasicTypesCellRenderer.number,
      'Currency': BasicTypesCellRenderer.currency,
      'Boolean': BasicTypesCellRenderer.boolean,
      'TriStateBoolean': BasicTypesCellRenderer.trisStateBoolean,

      'Date': DateTypesCellRenderer.date,
      'Time': DateTypesCellRenderer.date,
      'DateTime': DateTypesCellRenderer.date,
      'Date[]': DateTypesCellRenderer.dateArray,
      'DateTime[]': DateTypesCellRenderer.dateArray,

      'LookupObjectID': LookupTypesCellRenderer.single,
      'LookupObjectID[]': LookupTypesCellRenderer.multiple,

      'File': MediaTypesCellRenderer.fileList,
      'Image': MediaTypesCellRenderer.fileList,
      'Audio': MediaTypesCellRenderer.fileList,
      'Video': MediaTypesCellRenderer.fileList,
      'File[]': MediaTypesCellRenderer.fileList,
      'Image[]': MediaTypesCellRenderer.fileList,
      'Audio[]': MediaTypesCellRenderer.fileList,
      'Video[]': MediaTypesCellRenderer.fileList,

      'Location' : LocationCellRenderer.render,

      // imperial units
      'ImperialHeight': ImperialTypesCellRenderer.multiple,
      'ImperialWeightWithOz': ImperialTypesCellRenderer.multiple,
      'ImperialWeight': ImperialTypesCellRenderer.single,

      // lists
      'List': ListTypesCellRenderer,
      'List[]': ListTypesCellRenderer,

      'Object': complexType,
      'Array': complexType,
      'AssociativeArray': complexType,
      'KeyVal': keyVal,

      'Mixed': mixedType,
      'TreeSelector': complexType,
      'Html': BasicTypesCellRenderer.escapedHtmlOrRawHtml,
      'String': BasicTypesCellRenderer.stringOrHtml,
      'Grid': GridTypeCellRenderer.render,
      'Icon': BasicTypesCellRenderer.icon,
      'custom': CustomRender,
    };

    function CellRenderer(args, options) {
      var t = getRendererType(args);
      var renderFn = htmlCellRenderers[t];
      var content = renderFn(args, options);

      var asHtml = !FormattersHelper.asText(args);
      if (asHtml) {
        return wrapContent(content, args, t);
      }

      return content;
    }

    function getRendererType(args) {
      if (hasCustomRenderer(args)) {
        return 'custom';
      }

      var fieldType = AdpSchemaService.getFieldType(args.fieldSchema);
      var fallbackCellRenderer = 'String';

      return !!htmlCellRenderers[fieldType] ? fieldType : fallbackCellRenderer;
    }

    function wrapContent(content, args, renderType) {
      var maxDatagridCellHeight = _.get(args, 'fieldSchema.parameters.maxDatagridCellHeight', 'auto');
      var $container = $('<div class="adp-datagrid-cell-container"></div>');
      $container.css({ maxHeight: args.action === 'view' ? maxDatagridCellHeight : 'auto' });

      (renderType === 'custom') && $container.addClass('adp-datagrid-cell-container-custom-render');

      $container.append(content);

      AdpAttrs($container[0], args);

      return $container;
    }

    function complexType(args) {
      var isEmpty = _.isObject(args.data) ? _.isEmpty(args.data) : _.isNil(args.data);
      if (isEmpty) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      return ComplexTypesCellRenderer(args, CellRenderer);
    }

    function mixedType(args, options) {
      if (_.isNil(args.data)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      if (typeof args.data !== 'object') {
        return args.data;
      }

      return args.action === 'viewDetails' ?
        MixedTypeTabbedView(args, complexType, options) :
        complexType(args);
    }

    function keyVal(args) {
      const { data } = args;
      if (_.isNil(data) || _.isEmpty(data)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      let yaml = null;
      try {
        yaml = window.jsyaml.safeDump(data, { skipInvalid: true });
      } catch (e) {
        if (e instanceof window.jsyaml.YAMLException) {
          console.error('Error trying to format data to yaml: ', data, e);
        } else {
          throw e;
        }
      }

      const container = $('<div class="adp-grid-scroll-container">');
      container.append(yaml);

      return container;
    }

    function CustomRender(args) {
      var renderFn = _.get(appModelHelpers, customRendererPath(args));
      var argsForBackwardCompatibility = [args.data, args.fieldSchema.type, args.row];
      var content = renderFn.apply(args, argsForBackwardCompatibility);

      var isEmpty = _.isObject(args.data) ? _.isEmpty(args.data) : _.isNil(args.data);
      return (isEmpty && !content) ? GRID_FORMAT.EMPTY_VALUE : content;
    }

    function hasCustomRenderer(args) {
      var rendererPath = customRendererPath(args);
      return _.hasIn(appModelHelpers, rendererPath);
    }

    function customRendererPath(args) {
      var rendererType = args.action === 'export' ? 'exportRender' : 'render';
      var rendererName = _.get(args, 'fieldSchema.' + rendererType);

      return 'Renderers.' + rendererName;
    }

    return CellRenderer;
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('BooleanEditor', BooleanEditor);

  /** @ngInject */
  function BooleanEditor(
    AdpFieldsService,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxSelectBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }

    function getOptions(init) {
      var fieldData = init.args.data;
      var fieldType = init.args.fieldSchema.type;
      var initialValue = getInitialValue(fieldData, fieldType);

      var defaults = {
        elementAttr: {
          class: 'adp-select-box',
          id: 'cell_list_id_' + init.args.fieldSchema.fieldName,
        },
        value: initialValue,
        displayExpr: 'label',
        valueExpr: 'value',
        items: getDataSource(fieldType),
        onValueChanged: init.onValueChanged,
        valueChangeEvent: 'change',
        showClearButton: fieldType === 'TriStateBoolean',
      };

      return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
    }

    function getInitialValue(val, type) {
      if (type === 'Boolean') {
        return val === false ? null : val;
      }

      return val;
    }

    function getDataSource(type) {
      if (type === 'Boolean') {
        return [
          { label: 'Yes', value: true },
          { label: 'No', value: null },
        ];
      }

      return [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ];
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ColorEditor', ColorEditor);

  /** @ngInject */
  function ColorEditor(
    AdpFieldsService,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxColorBox',

        create(init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }

    function getOptions(init) {
      const fieldData = init.args.data;
      const defaults = {
        value: fieldData || '',
        onValueChanged: init.onValueChanged,
      };

      return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('CurrencyEditor', CurrencyEditor);

  /** @ngInject */
  function CurrencyEditor(
    DX_ACCOUNTING_FORMAT,
    AdpFieldsService,
    DxEditorMixin,
    DxNumberHelper
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions(init));
        },

        getOptions: function (init) {
          var preventWheelCb = DxNumberHelper.preventMouseWheel();

          var defaults = {
            onValueChanged: function (e) {
              if (preventWheelCb(e) !== undefined) {
                return false;
              }

              if (e.value === 0 && _.isNumber(e.previousValue)) {
                // update on next change event fired
                e.component.option('value', null);
              } else {
                init.onValueChanged(e);
              }
            },
            value: init.args.data,
            valueChangeEvent: 'blur input',
            placeholder: init.placeholder,
            inputAttr: {
              autocomplete: AdpFieldsService.autocompleteValue(init.args.fieldSchema),
            },
            showSpinButtons: true,
            format: DX_ACCOUNTING_FORMAT,
          };

          return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
        },
      });
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DateEditor', DateEditor);

  /** @ngInject */
  function DateEditor(
    AdpSchemaService,
    AdpFieldsService,
    DxEditorMixin,
    AdpValidationUtils
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxDateBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](getOptions(init));
        },
      });
    };

    function getOptions(init) {
      var field = init.args.fieldSchema;
      var fieldType = field.type;
      var momentFormat = AdpValidationUtils.getDateFormat(fieldType);

      var formatForDx = momentFormat
        .replace(/D/g, 'd')
        .replace(/Y/g, 'y');

      var defaults = {
        type: fieldType.toLowerCase(),
        placeholder: momentFormat,
        displayFormat: formatForDx,
        showAnalogClock: false,
        onValueChanged,
        value: init.args.data,
        valueChangeEvent: 'change keyup',
        useMaskBehavior: true,
        showClearButton: true,
      };

      if (notInFuture(field)) {
        defaults.max = today();
      }

      if (notInPast(field)) {
        defaults.min = today();
      }

      return AdpFieldsService.configFromParameters(field, defaults);

      function onValueChanged(event) {
        if (fieldType === 'Time') {
          // type:Time base date is 2000-02-02. Check docs for explanation
          // https://outline.craftus.com/doc/handling-dates-and-time-in-different-timezones-dfagbWEqrt#h-time
          const dj = dayjs(event.value,).set('year', 2000).set('month', 1).set('date', 2);
          event.value = dj.format("YYYY-MM-DDTHH:mm:ss.000Z");
        }
        return init.onValueChanged(event);
      }
    }

    function today() {
      var todaySinceMidnight = new Date();
      return todaySinceMidnight.setHours(0,0,0,0);
    }

    function notInFuture(field) {
      return _.find(field.validate, function (validator) {
        return validator.validator === 'notInFuture';
      });
    }

    function notInPast(field) {
      return _.find(field.validate, function (validator) {
        return validator.validator === 'notInPast';
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DecimalEditor', DecimalEditor);

  /** @ngInject */
  function DecimalEditor(
    DxEditorMixin,
    AdpFieldsService
  ) {
    function getOptions(init) {
      var defaults = {
        mode: 'text',
        onValueChanged: init.onValueChanged,
        value: init.args.data,
        valueChangeEvent: 'blur input',
        showSpinButtons: true,
        onKeyPress: function(e) {
          var isDecimalChar = /(\+|-|\.|(\d|e))/.test(e.event.key);
          if (!isDecimalChar) {
            e.event.preventDefault();
          }
        },
        onPaste: function (e) {
          e.event.preventDefault();
          var pasteText = e.event.originalEvent.clipboardData.getData('text');
          this.option('value', pasteText.replace(/[^0-9.\-+]/g, ''));
        }
      };

      return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
    }

    return function () {
      return DxEditorMixin({
        editorName: 'dxTextBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DecimalMultipleEditor', DecimalMultipleEditor);

  /** @ngInject */
  function DecimalMultipleEditor(
    NumberArrayEditorConfig,
    DxEditorMixin,
    AdpFieldsService
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxTagBox',

        create: function (init) {
          this.init = init;
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions());
        },

        getOptions: function () {
          var fieldData = this.init.args.data;
          var fieldSchema = this.init.args.fieldSchema;
          var defaults = NumberArrayEditorConfig(this.init.args, fieldData, this.init.onValueChanged);

          var editorConfig = _.merge(defaults, {
            fieldTemplate: fieldTemplate,
            elementAttr: { class: 'adp-select-box adp-number-array' },
          });

          return AdpFieldsService.configFromParameters(fieldSchema, editorConfig);
        }
      });
    }

    function fieldTemplate(data, container) {
      var textBox = $('<div class="adp-text-box">')
        .dxTextBox(fieldConfig());

      container.append(textBox);
    }

    function fieldConfig() {
      return {
        placeholder: 'Type in new value and press Enter',
        mode: 'text',
        valueChangeEvent: 'blur input',
        onKeyPress: function (e) {
          var isDecimalChar = /(\+|-|\.|(\d|e))/.test(e.event.key);
          if (!isDecimalChar) {
            e.event.preventDefault();
          }
        },
        onPaste: function (e) {
          e.event.preventDefault();
          var pasteText = e.event.originalEvent.clipboardData.getData('text');
          this.option('value', pasteText.replace(/[^0-9.\-+]/g, ''));
        },
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DxEditorMixin', DxEditorMixin);

  /** @ngInject */
  function DxEditorMixin() {
    return function (options) {
      var mixinObject = {
        reset: function() {
          const instance = this.getInstance();
          instance.option('value', this.emptyValue || '');
        },

        getInstance: function () {
          return $(this.element)[this.editorName]('instance');
        },

        getElement: function () {
          return this.element;
        },

        getValue: function () {
          return this.getInstance().option('value');
        }
      };

      return _.assign(mixinObject, options);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('IntEditor', IntEditor);

  /** @ngInject */
  function IntEditor(
    DxEditorMixin,
    AdpFieldsService,
    DxNumberHelper
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create(init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    };

    function getOptions(init) {
      const { args, placeholder } = init;
      const preventMouseWheelCb = DxNumberHelper.preventMouseWheel();

      const defaults = {
        mode: 'number',
        value: args.data,
        valueChangeEvent: 'blur input',
        placeholder,
        format: '#0',
        showSpinButtons: true,
        showClearButton: true,
        onValueChanged(e) {
          if (preventMouseWheelCb(e) !== undefined) {
            return;
          }

          init.onValueChanged(e);
        },
      };

      return AdpFieldsService.configFromParameters(args.fieldSchema, defaults);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ListEditorFactory', ListEditorFactory);

  /** @ngInject */
  function ListEditorFactory(
    AdpFieldsService,
    AdpListsService,
    DxEditorMixin,
    AdpAsyncListsService
  ) {
    function getOptions(init, isCellEditor) {
      const idPrefix = isCellEditor ? 'cell_list_id_' : 'filter_cell_list_id_';

      const defaults = {
        value: init.args.data,
        grouped: AdpListsService.isGrouped(init.args),
        showSelectionControls: AdpListsService.isGrouped(init.args),
        valueExpr: 'value',
        displayExpr: 'label',
        elementAttr: {
          class: 'adp-select-box',
          id: idPrefix + init.args.fieldSchema.fieldName,
        },
        dataSource: AdpListsService.getDataSource(init.args),
        onValueChanged: function (e) {
          AdpAsyncListsService.setDynamicListLabel(init.args, e);
          init.onValueChanged(e);
        },
        showClearButton: true,
        onInitialized: function(e) {
          AdpAsyncListsService.addLabelForDynamicList(init.args, e.component);
        },
        onOpened: function (e) {
          AdpAsyncListsService.clearDs(init.args, e.component);
        },
        tagTemplate(data, tagElement) {
          var component = this;
          var removeBtn = $('<div class="dx-tag-remove-button"><span class="dx-icon dx-icon-clear"></span></div>');

          removeBtn.on('click', function () {
            var ids = component.option('value').slice();
            _.pull(ids, data.value);

            component.option('value', ids);
            removeBtn.off('click');
          });

          $('<div class="dx-tag-content">')
            .attr('adp-qaid-field-tag', init.args.path)
            .append('<span class="dx-tag-text">' + data.label + '</span>', removeBtn)
            .appendTo(tagElement);
        },
      };

      return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
    }

    function factory(multiple, isCellEditor) {
      return DxEditorMixin({
        create: function (init) {
          var options = getOptions(init, isCellEditor);

          this.element = $('<div>');
          this.editorName = multiple ? 'dxTagBox' : 'dxSelectBox';
          this.element[this.editorName](options);
        }
      });
    }

    return {
      single(isCellEditor) {
        return factory(false, isCellEditor)
      },

      multiple(isCellEditor) {
        return factory(true, isCellEditor)
      },
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('NumberEditor', NumberEditor);

  /** @ngInject */
  function NumberEditor(
    DxEditorMixin,
    AdpFieldsService,
    DxNumberHelper
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions(init));
        },

        getOptions: function (init) {
          var self = this;
          var preventWheelCb = DxNumberHelper.preventMouseWheel();

          var defaults = {
            onKeyDown: function (e) {
              // WORKAROUND: to allow removing zero from input
              if (changedToNull(e.event)) {
                self.reset();
              }
            },
            onValueChanged: function (e) {
              if (preventWheelCb(e) !== undefined) {
                return;
              }
              init.onValueChanged(e);
            },
            value: init.args.data,
            valueChangeEvent: 'blur input',
            placeholder: init.placeholder,
            showSpinButtons: true,
          }

          return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
        },
      });
    };

    function changedToNull(e) {
      if (e.key !== 'Backspace') {
        return false;
      }

      var input = e.target;
      var hasSingleChar = input.value.length === 1 && input.selectionStart === 1;
      var hasSingleNegativeChar = /\-\d/.test(input.value) && input.selectionStart === 2;
      var allTextSelected = input.value.length === (input.selectionEnd - input.selectionStart);

      return hasSingleChar || hasSingleNegativeChar || allTextSelected;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('NumberMultipleEditor', NumberMultipleEditor);

  /** @ngInject */
  function NumberMultipleEditor(
    NumberArrayEditorConfig,
    DxEditorMixin,
    AdpFieldsService
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxTagBox',

        create: function (init) {
          this.init = init;
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions());
        },

        getOptions: function () {
          var fieldData = this.init.args.data;
          var fieldSchema = this.init.args.fieldSchema;

          var self = this;
          var defaults = NumberArrayEditorConfig(this.init.args, fieldData, function (e) {
            self.init.onValueChanged({ value: (e.value || []).map(_.toNumber) })
          });

          var editorConfig = _.merge(defaults, {
            fieldTemplate: _.partial(fieldTemplate, fieldSchema),
            elementAttr: { class: 'adp-select-box adp-number-array' },
          });

          return AdpFieldsService.configFromParameters(fieldSchema, editorConfig);
        }
      });
    }

    function fieldTemplate(fieldSchema, data, container) {
      var numberBox = $('<div class="adp-text-box">')
        .dxNumberBox(getNumberBoxConfig());

      function getNumberBoxConfig() {
        var isInt = _.includes(['Int32[]', 'Int64[]'], fieldSchema);

        return {
          value: null,
          placeholder: 'Type in new value and press Enter',
          mode: 'number',
          valueChangeEvent: 'blur keyup change',
          format: isInt ? '#' : '',
        };
      }

      container.append(numberBox);
    }

  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('PercentEditor', PercentEditor);

  /** @ngInject */
  function PercentEditor(
    DX_PERCENT_FORMAT,
    AdpFieldsService,
    DxEditorMixin,
    DxNumberHelper
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions(init));
        },

        getOptions: function (init) {
          var preventWheelCb = DxNumberHelper.preventMouseWheel();

          var defaults = {
            onValueChanged: function (e) {
              if (preventWheelCb(e) !== undefined) {
                return false;
              }

              if (e.value === 0 && _.isNumber(e.previousValue)) {
                // update on next change event fired
                e.component.option('value', null);
              } else {
                init.onValueChanged(e);
              }
            },
            value: init.args.data,
            valueChangeEvent: 'blur input',
            placeholder: init.placeholder,
            inputAttr: {
              autocomplete: AdpFieldsService.autocompleteValue(init.args.fieldSchema),
            },
            showSpinButtons: true,
            format: DX_PERCENT_FORMAT,
          };

          return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
        },
      });
    };
  }
})();
;;(function () {
    'use strict';

    angular
        .module('app.adpDataGrid')
        .factory('RandomIdEditor', RandomIdEditor);

    /** @ngInject */
    function RandomIdEditor(
        DxEditorMixin,
        RandomIdConfig
    ) {
        return function () {
            return DxEditorMixin({
                editorName: 'dxTextBox',

                create({ onValueChanged, args }) {
                    const options = RandomIdConfig({ onValueChanged, args, value: args.data });
                    this.element = $('<div>');

                    this.element[this.editorName](options);
                },
            });
        }
    }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('StringEditor', StringEditor);

  /** @ngInject */
  function StringEditor(
    DxEditorMixin,
    AdpFieldsService
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxTextBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }

    function getOptions(init) {
      var type = init.args.fieldSchema.type;
      var opts = {
        mode: getTextMode(type),
        onValueChanged: init.onValueChanged,
        value: init.args.data,
        valueChangeEvent: 'change keyup blur',
      };

      enableMask(type, opts);

      return AdpFieldsService.configFromParameters(init.args.fieldSchema, opts);
    }

    function getTextMode(type) {
      var types = {
        'Email': 'email',
        'PasswordAuth': 'password',
        'Url': 'url',
      };

      return types[type] || 'text';
    }

    function enableMask(type, config) {
      if (type !== 'Phone') {
        return;
      }

      _.assign(config, {
        mask: 'X00-X00-0000',
        maskRules: { X: /[02-9]/ },
        maskChar: 'x',
        maskInvalidMessage: false,
        showMaskMode: 'onFocus',
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('StringMultipleEditor', StringMultipleEditor);

  /** @ngInject */
  function StringMultipleEditor(
    StringArrayEditorConfig,
    DxEditorMixin,
    AdpFieldsService
  ) {
    function getOptions(init) {
      var fieldData = init.args.data;
      var defaults = StringArrayEditorConfig(init.args, fieldData, init.onValueChanged);
      return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
    }

    return function () {
      return DxEditorMixin({
        editorName: 'dxTagBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');
          this.element[this.editorName](options);
        },
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('TextEditor', TextEditor);

  /** @ngInject */
  function TextEditor(
    DxEditorMixin,
    AdpFieldsService
  ) {
    function getOptions(init) {
      var defaults = {
        mode: 'text',
        onValueChanged: init.onValueChanged,
        value: init.args.data,
        valueChangeEvent: 'change input',
      };

      return AdpFieldsService.configFromParameters(init.args.fieldSchema, defaults);
    }

    return function () {
      return DxEditorMixin({
        editorName: 'dxTextArea',

        create(init) {
          const options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('CustomFilterExpression', CustomFilterExpression);

  /** @ngInject */
  function CustomFilterExpression(AdpUnifiedArgs) {
    var expressions = {
      Boolean: calculateExprForBoolean,
      TriStateBoolean: calculateExprForTriStateBoolean,
      DateTime: transformBetweenToNonStrictRange,
      Date: transformBetweenToNonStrictRange,
      Time: transformBetweenToNonStrictRange,
      'Number[]': transformBetweenToNonStrictRange,
      'Double[]': transformBetweenToNonStrictRange,
      'Int32[]': transformBetweenToNonStrictRange,
      'Int64[]': transformBetweenToNonStrictRange,
      'Decimal128[]': transformBetweenToNonStrictRange,
      Currency: transformBetweenToNonStrictRange,
      Number: transformBetweenToNonStrictRange,
      Double: transformBetweenToNonStrictRange,
      Int32: transformBetweenToNonStrictRange,
      Int64: transformBetweenToNonStrictRange,
      Decimal128: transformBetweenToNonStrictRange,

      ImperialWeightWithOz: imperialUnitMultipeExpr,
      ImperialHeight: imperialUnitMultipeExpr,
      LookupObjectID: transformLookup,
      'LookupObjectID[]': transformLookup,
    };

    return function (field, schema) {
      if (hasCustomFilterExpr(field)) {
        return getCustomFilterExpr(field, schema);
      }

      return expressions[field.type] || defaultFilterExpression;
    };

    function defaultFilterExpression(filterValue, selectedFilterOperation) {
      var selectedOperation = selectedFilterOperation || this.defaultSelectedFilterOperation;
      return [this.dataField, selectedOperation, filterValue];
    }

    function calculateExprForBoolean(filter, selectedFilterOperation, fieldType) {
      const valueMap = {
        TRUE_VALUE: true,
        FALSE_VALUE: null,
      };
      const filterValue = filter.value || filter;
      const val = valueMap[filterValue];

      if (_.isUndefined(val)) {
        return this.defaultCalculateFilterExpression.apply(this, arguments);
      }

      if (filterValue === 'FALSE_VALUE') {
        return [
          [this.dataField, selectedFilterOperation, null],
          'or',
          [this.dataField, selectedFilterOperation, false],
        ];
      }

      return [this.dataField, selectedFilterOperation, true];
    }

    function calculateExprForTriStateBoolean(filter, selectedFilterOperation) {
      var valueMap = {
        'TRUE_VALUE': true,
        'FALSE_VALUE': false,
      };
      var filterValue = filter.value || filter;
      var val = valueMap[filterValue];

      return _.isUndefined(val) ?
        this.defaultCalculateFilterExpression.apply(this, arguments) :
        [this.dataField, selectedFilterOperation, val];
    }

    function imperialUnitMultipeExpr(filterValue, selectedFilterOperation) {
      var mapToNumbers = function (v) {
        return _.isNil(v) ? v :  v.split('.').map(Number);
      }
      var val = _.isArray(filterValue) ?
        filterValue.map(mapToNumbers) :
        mapToNumbers(filterValue);

      return transformBetweenToNonStrictRange.call(this, val, selectedFilterOperation);
    }

    function transformBetweenToNonStrictRange(filterValue, selectedFilterOperation) {
      if (selectedFilterOperation === 'between') {
        var bothValuesAreNil = _.compact(filterValue).length === 0;

        if (bothValuesAreNil) {
          return null;
        } else if (_.isNil(filterValue[0])) {
          return [this.dataField, '<=', filterValue[1]];
        } else if (_.isNil(filterValue[1])) {
          return [this.dataField, '>=', filterValue[0]];
        } else {
          return [[this.dataField, '>=', filterValue[0]],'and',[this.dataField, '<=', filterValue[1]]]
        }
      }

      return [this.dataField, selectedFilterOperation, filterValue];
    }

    function transformLookup(filterValue, selectedFilterOperation) {
      var selectedOperation = selectedFilterOperation || this.defaultSelectedFilterOperation;
      return [this.dataField, selectedOperation, filterValue];
    }

    function getCustomFilterExpr(field, schema) {
      return function (filterValue, selectedFilterOperation, target) {
        var customDataSourceName = _.get(field, 'parameters.calculateFilterExpression', null);
        var exprFn = _.get(window, 'appModelHelpers.DxCalculateFilterExpression.' + customDataSourceName, null);

        var args = getUnifiedArgs(field, schema);
        args.filterValue = filterValue;
        args.selectedFilterOperation = selectedFilterOperation;
        args.target = target;

        return exprFn.call(args);
      };
    }

    function hasCustomFilterExpr(field) {
      return _.hasIn(field, 'parameters.calculateFilterExpression');
    }

    function getUnifiedArgs(field, schema) {
      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: field.fieldName,
        formData: null,
        action: 'filterExpression',
        schema: schema,
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('FilterOperation', FilterOperation);

  /** @ngInject */
  function FilterOperation(AdpSchemaService) {
    var commonOperations = {
      equality: ['=', '<>'],
      equalityOnly: ['='],
      string: ['contains', 'notcontains', 'startswith', 'endswith', '=', '<>'],
      numeric: ['=', '<>', '<', '>', '<=', '>=', 'between'],
    };

    var operationsByType = {
      String: commonOperations.string,
      'String[]': commonOperations.string,
      'Int32[]': commonOperations.numeric,
      'Int64[]': commonOperations.numeric,
      'Number[]': commonOperations.numeric,
      'Double[]': commonOperations.numeric,
      'Decimal128[]': commonOperations.numeric,
      Email: commonOperations.string,
      Phone: commonOperations.string,
      Text: commonOperations.string,
      Url: commonOperations.string,
      Currency: commonOperations.numeric,
      Percent: commonOperations.numeric,
      Number: commonOperations.numeric,
      Double: commonOperations.numeric,
      Int32: commonOperations.numeric,
      Int64: commonOperations.numeric,
      Decimal128: commonOperations.numeric,
      Rating: commonOperations.numeric,

      Date: commonOperations.numeric,
      DateTime: commonOperations.numeric,
      Time: commonOperations.numeric,

      List: commonOperations.equality,
      'List[]': commonOperations.equality,
      FrontendList: commonOperations.equality,
      'FrontendList[]': commonOperations.equality,

      Boolean: commonOperations.equalityOnly,
      TriStateBoolean: commonOperations.equalityOnly,

      File: commonOperations.string,
      Image: commonOperations.string,
      Audio: commonOperations.string,
      Video: commonOperations.string,
      'File[]': commonOperations.string,
      'Image[]': commonOperations.string,
      'Audio[]': commonOperations.string,
      'Video[]': commonOperations.string,
      Location: commonOperations.string,
      Icon: commonOperations.string,

      ObjectID: commonOperations.equality,
      ImperialWeight: commonOperations.numeric,
      ImperialWeightWithOz: commonOperations.numeric,
      ImperialHeight: commonOperations.numeric,

      LookupObjectID: commonOperations.equality,
      'LookupObjectID[]': commonOperations.equality,
      Html: commonOperations.string,
      Code: commonOperations.string,
      Color: commonOperations.string,
      RandomID: commonOperations.string,
    };

    function get(field) {
      var type = AdpSchemaService.getFieldType(field);
      return operationsByType[type];
    }

    function getValidOperation(operation, field) {
      if (validForType(operation, field.type)) {
        return operation;
      } else {
        return getSelected(field);
      }
    }

    function validForType(operation, type) {
      var operations = operationsByType[type];

      return operations.includes(operation);
    }

    function getSelected(field) {
      var operations = get(field);

      if (_.isNil(operations)) {
        return;
      }

      return operations[0];
    }

    function encode(operation) {
      var codings = {
        '=': 'equals',
        '<>': 'notequals',
        '<': 'less',
        '>': 'more',
        '<=': 'lessorequal',
        '>=': 'moreorequal',
      };

      return codings[operation] || operation;
    }

    function decode(operation) {
      var codings = {
        'equals': '=',
        'notequals': '<>',
        'less': '<',
        'more': '>',
        'lessorequal': '<=',
        'moreorequal': '>=',
      };

      return codings[operation] || operation;
    }

    function supportedTypes() {
      return Object.keys(operationsByType);
    }

    function hasBetweenOperation(type) {
      var operations = operationsByType[type] || [];
      return operations.includes('between');
    }

    return {
      supportedTypes: supportedTypes,
      get: get,
      getSelected: getSelected,
      encode: encode,
      decode: decode,
      getValidOperation: getValidOperation,
      hasBetweenOperation: hasBetweenOperation,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridFiltersFactory', GridFiltersFactory);

  /** @ngInject */
  function GridFiltersFactory(
    GridFilterHelpers,
    AdpSchemaService,
    NumberFilter,
    DateFilter,
    ListEditorFactory,
    StringFilter,
    BooleanFilter,
    ImperialUnitSingleFilter,
    ImperialUnitMultipleFilter,
    LookupFilter,
    DecimalFilter,
    CurrencyFilter,
    PercentFilter,
    RelativeDateFilter,
    MongoExpressionFilter,
    DatabaseFieldFilter
  ) {
    var filtersMap = {
      list: ListEditorFactory.multiple,
      dynamicList: ListEditorFactory.multiple,
      string: StringFilter,
      number: NumberFilter,
      double: NumberFilter,
      decimal128: DecimalFilter,
      date: DateFilter,
      time: DateFilter,
      dateTime: DateFilter,
      boolean: BooleanFilter,
      triStateBoolean: BooleanFilter,
      imperialWeight: ImperialUnitSingleFilter,
      imperialWeightWithOz: ImperialUnitMultipleFilter,
      imperialHeight: ImperialUnitMultipleFilter,
      lookupObjectId: LookupFilter,
      objectId: StringFilter,
      currency: CurrencyFilter,
      percent: PercentFilter,
      relativeDate: RelativeDateFilter,
      mongoExpression: MongoExpressionFilter,
      databaseField: DatabaseFieldFilter,
    };

    function create(options) {
      var filterRenderer = resolveFilterRenderer(options);
      if (!filterRenderer) {
        return;
      }

      return createFilter(filterRenderer, options);
    }

    function formatValue(options) {
      var filterRenderer = resolveFilterRenderer(options);

      if (!filterRenderer) {
        return options.args.data;
      }

      var filterComponent = filterRenderer();

      if (!filterComponent.formatValue) {
        return options.args.data;
      }

      return filterComponent.formatValue(options);
    }

    function createFilter(filterByType, options) {
      var newFilterComponent = filterByType();
      assertFilterHasRequiredFields(newFilterComponent, options);
      newFilterComponent.create(options);

      postCreateActions(newFilterComponent);

      return newFilterComponent;
    }

    var shouldImplement = ['create', 'getElement', 'reset'];
    function assertFilterHasRequiredFields(filterComponent, options) {
      if (hasNotImplementedMethods(filterComponent)) {
        throw new Error(assertionMessage(options.args.modelSchema.fieldName));
      }
    }

    function assertionMessage(fieldName) {
      return [
        'Filter component must implement required methods: "',
        shouldImplement.join(', '),
        '" for field',
        fieldName
      ].join(' ');
    }

    function hasNotImplementedMethods(filterComponent) {
      var filterCondition = function (methodName) {
        return !_.isFunction(filterComponent[methodName]);
      };

      var notImplemented = shouldImplement.filter(filterCondition);

      return notImplemented.length > 0;
    }

    function postCreateActions(filterComponent) {
      GridFilterHelpers.saveFilterInstanceToDom(filterComponent);
      addUniqueClassToFilter(filterComponent);
    }

    function addUniqueClassToFilter(component) {
      var element = component.getElement();
      var classToAdd = GridFilterHelpers.filterClass();
      $(element).addClass(classToAdd);
    }

    function resolveFilterRenderer(options) {
      var field = options.args.fieldSchema;
      var filterRenderer = GridFilterHelpers.getFilterRenderer(field);

      if (!filterRenderer) {
        return;
      }

      return filtersMap[filterRenderer.value];
    }

    return {
      create: create,
      formatValue: formatValue,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridFilterHelpers', GridFilterHelpers);

  /** @ngInject */
  function GridFilterHelpers(
    AdpValidationUtils,
    AdpSchemaService,
    FilterOperation
  ) {
    var FILTER_DOM_NAME = 'adpFilterInstance';
    var FILTER_CLASS_PREFIX = 'adp-custom-filter';

    function filterClass() {
      return FILTER_CLASS_PREFIX;
    }

    function getFilterInstancesByElements($filterElements) {
      return _.map($filterElements, function (el) {
        return $(el).data(FILTER_DOM_NAME)
      });
    }

    function saveFilterInstanceToDom(component) {
      var element = component.getElement();
      $(element).data(FILTER_DOM_NAME, component);
    }

    function filteringAllowedForField(field) {
      var type = AdpSchemaService.getFieldType(field);

      return FilterOperation.supportedTypes().includes(type);
    }

    function getFilterRenderer(field) {
      if (!field.filter) {
        return;
      }
      var filterName = field.filter;
      var metaschema = window.adpAppStore.metaschema().filters;
      var currentRenderer = metaschema[filterName].renderer;

      while (currentRenderer.type === 'reference') {
        filterName = currentRenderer.value;
        currentRenderer = metaschema[filterName].renderer;
      }

      return currentRenderer;
    }

    function isFilterRangeStart(editorElement) {
      var RANGE_START_CLASS = 'dx-datagrid-filter-range-start';
      return editorElement.closest('.dx-editor-container').hasClass(RANGE_START_CLASS);
    }

    function getTextForBetweenPlaceholder(editorElement, field) {
      var RANGE_PLACEHOLDER = {
        START: 'More Than', END: 'Less Than',
      };

      if (AdpSchemaService.isDate(field.type)) {
        _.each(RANGE_PLACEHOLDER, function (value, key) {
          RANGE_PLACEHOLDER[key] += ' ' + AdpValidationUtils.getDateFormat(field.type);
        });
      }


      return isFilterRangeStart(editorElement) ?
        RANGE_PLACEHOLDER.START :
        RANGE_PLACEHOLDER.END;
    }

    function resetFilterByColumn(e) {
      var columnOptionName = e.fullName.split('.')[0];
      var columnName = e.component.option(columnOptionName).dataField;

      var filtersSelector = [
        '.dx-datagrid-filter-row',
        '.name-' + columnName,
        '.' + FILTER_CLASS_PREFIX
        ].join(' ');

      var components = getFilterInstancesByElements($(filtersSelector));
      _.each(components, function (cmp) {
        cmp.reset();
      });
    }

    return {
      filterClass: filterClass,
      saveFilterInstanceToDom: saveFilterInstanceToDom,
      filteringAllowedForField: filteringAllowedForField,
      resetFilterByColumn: resetFilterByColumn,
      getFilterRenderer: getFilterRenderer,
      getTextForBetweenPlaceholder: getTextForBetweenPlaceholder,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridFilters', GridFilters);

  /** @ngInject */
  function GridFilters(
    AdpSchemaService,
    GridFiltersFactory,
    AdpUnifiedArgs,
    GridFilterHelpers,
    GridOptionsHelpers,
    filterUrlMapper,
    FilterUrlParser
  ) {
    function create(options, schema) {
      if (!_.get(options, 'filterRow.visible', false)) {
        return;
      }

      GridOptionsHelpers.onEditorPreparing(options, function (event) {
        var isFilterRow = event.parentType === 'filterRow';
        if (!isFilterRow) {
          return;
        }

        setFilterComponent(event, schema);
      });

      GridOptionsHelpers.onOptionChanged(options, function (e) {
        if (e.name === 'hoveredElement') {
          return;
        }
        const filterValueChanged = e.fullName.includes('filterValue') && e.name !== 'filterValue';
        const filterValueChangedToEmpty = filterValueChanged && filterValueEmpty(e.value);

        if (filterValueChangedToEmpty) {
          GridFilterHelpers.resetFilterByColumn(e);
        } else {
          if (isOptionChangedOnlyCase(e)) {
            e.component.getDataSource().reload();
          }
        }

        const filterOperationChanged = e.fullName.includes('selectedFilterOperation');
        const searchValueChanged = e.fullName === 'searchPanel.text';
        if (filterValueChanged || filterOperationChanged || searchValueChanged) {
          filterUrlMapper(e.component, schema);
        }
      });

      return options;
    }

    function isOptionChangedOnlyCase( e ) {
      return e.value &&
        e.previousValue &&
        e.value.toLowerCase &&
        (e.fullName ==="searchPanel.text" || e.fullName .match(/columns\[\d+\]\.filterValue/)) &&
        e.value.toLowerCase() === e.previousValue.toLowerCase();
    }

    function setFilterComponent(event, schema) {
      var field = schema.fields[event.dataField];
      var isFilteringAllowed = field && GridFilterHelpers.filteringAllowedForField(field);

      if (!isFilteringAllowed) {
        return;
      }

      event.cancel = true; // Cancels creating the default editor
      var filterComponent = createFilterComponent(event, schema);
      filterComponent.getElement().appendTo(event.editorElement);
    }

    function createFilterComponent(event, schema) {
      var options = {
        args: unifiedApproachArgs(event, schema),
        onValueChanged: function (filterOptions) {
          filterChangeHandler(filterOptions, event);
        },
        placeholder: getPlaceholder(event, schema),
        parentType: event.parentType,
      };

      return GridFiltersFactory.create(options);
    }

    function getPlaceholder(event, schema) {
      if (event.selectedFilterOperation === 'between') {
        var field = schema.fields[event.dataField];
        return GridFilterHelpers.getTextForBetweenPlaceholder(event.editorElement, field);
      } else {
        return '';
      }
    }

    function unifiedApproachArgs(event, schema) {
      var fieldName = event.dataField;
      var value = event.value;

      var wrapIntoFormData = function (event) {
        var data = {};
        data[event.dataField] = value;

        return data;
      }

      var formData = _.isNil(value) ? null : wrapIntoFormData(event);

      return AdpUnifiedArgs.getHelperParamsWithConfig({
        path: fieldName,
        formData: formData,
        action: 'view',
        schema: schema,
      });
    }

    function filterChangeHandler(filterOptions, event) {
      if (filterValueEmpty(filterOptions.value)) {
        event.setValue();
      } else {
        event.setValue(filterOptions.value);
      }
    }

    function filterValueEmpty(val) {
      var isEmptyFn = _.isArray(val) ? _.isEmpty : _.isNil;
      return isEmptyFn(val);
    }

    function setFiltersFromUrl(options, schema, customGridOptions) {
      const { filters, search, showHiddenFields } = FilterUrlParser(schema);

      if (search) {
        _.set(options, 'searchPanel.text', search);
      }

      const filterBuilder = customGridOptions.value('filterBuilder');

      mapFilterValuesToColumns(options.columns, filters, showHiddenFields);

      if (!_.get(options, 'stateStoring.enabled')) {
        return;
      }

      const lsKey = GridOptionsHelpers.generateGridLsKey(options.stateStoring.storageKey, schema.schemaName);
      const stateFromLs = getGridStateFromLs(lsKey) || {};

      if (!_.isEmpty(filterBuilder)) {
        _.set(stateFromLs, '_customOptions.filterBuilder', filterBuilder);
      }

      if (!_.isEmpty(filters)) {
        mapFilterValuesToColumns(stateFromLs.columns, filters);
      }

      localStorage.setItem(lsKey, JSON.stringify(stateFromLs));
    }

    function mapFilterValuesToColumns(columns, filters, showHiddenFields = false) {
      (columns || []).forEach(column => {
        addFilterValues(column, filters, showHiddenFields);
      });
    }

    function getGridStateFromLs(lsKey) {
      var curStateJson = localStorage.getItem(lsKey);
      var cur_state;

      try {
        cur_state = JSON.parse(curStateJson)
      } catch (e) {}

      return cur_state;
    }

    function addFilterValues(column, filters, showColumn = false) {
      const { dataField } = column
      const filter = filters[dataField];

      if (!filter) {
        column.filterValue = undefined;
      } else {
        const { value, operation } = filter;
        column.filterValue = value;

        if (showColumn) {
          column.visible = true
          column.showInColumnChooser = true
        }
        operation && (column.selectedFilterOperation = operation);
      }
    }

    return {
      create,
      setFiltersFromUrl,
      addFilterValues,
      setFilterComponent,
      unifiedApproachArgs,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridHeaderFilters', GridHeaderFilters);

  /** @ngInject */
  function GridHeaderFilters(AdpUnifiedArgs, GridOptionsHelpers) {
    return function setHeaderFilters(options, schema) {
      if (!_.get(options, 'headerFilter.visible', false)) {
        return;
      }

      addSelectAllWorkaround(options);
      setHeaderFiltersToColumns(options.columns, schema);
    }

    // https://supportcenter.devexpress.com/ticket/details/t891118/datagrid-filter-is-empty-after-the-select-all-check-box-is-clicked
    function addSelectAllWorkaround(options) {
      GridOptionsHelpers.onOptionChanged(options, function (e) {
        var path = e.fullName.split('.');
        var optionName = path.pop();

        if (optionName === 'filterType' && e.value === 'exclude') {
          setTimeout(function () {
            var index = parseInt(path[0].split('[')[1]);
            var filterValues = e.component.columnOption(index, 'headerFilter.dataSource').map(function (d) {
              return d.value;
            });
            e.component.columnOption(index, { filterType: 'include', filterValues: filterValues });
            e.component.refresh();
          });
        }
      });
    }

    function setHeaderFiltersToColumns(columns, schema) {
      columns.forEach(function (column) {
        var field = schema.fields[column.dataField];

        if (!field || !column.allowHeaderFiltering) {
          column.allowHeaderFiltering = false;
          return;
        }

        column.headerFilter = {};
        var customDataSource = getCustomFilterDataSource(field, schema);

        if (customDataSource) {
          _.set(column, 'headerFilter.dataSource', customDataSource);
        } else {
          var dataSource = getDataSourceForOperations(['undefined', 'notUndefined'], field);
          dataSource = _.concat(dataSource, getStringBasedOperations(field));

          _.set(column, 'headerFilter.dataSource', dataSource);
        }
      });
    }

    function getCustomFilterDataSource(field, schema) {
      var customDataSourceName = _.get(field, 'parameters.headerFilter.dataSource', null);
      var customDataSource = _.get(window, 'appModelHelpers.DxDataSources.' + customDataSourceName, null);

      if (_.isNil(customDataSource)) {
        return;
      }

      var args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: field.fieldName,
        formData: null,
        action: 'headerFilterDataSource',
        schema: schema,
      });

      return customDataSource.call(args);
    }

    function getDataSourceForOperations(operations, field) {
      return operations.map(function (op) {
        return getHeaderFilterItem(op, field);
      });
    }

    function getHeaderFilterItem(operation, field) {
      return {
        text: _.startCase(operation),
        value: [field.fieldName, operation],
      }
    }

    function getStringBasedOperations(field) {
      var isStringBased = _.includes(
        ['String', 'Phone', 'Url', 'Email', 'Password', 'Text', 'Code', 'Html'],
        field.type
      );

      if (field.list || !isStringBased) {
        return [];
      }

      return getDataSourceForOperations(['empty', 'notEmpty'], field);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .component('adpAudioModal', {
      templateUrl: 'app/adp-file-uploader/components/adp-audio-modal/adp-audio-modal.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpAudioModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpAudioModalController', AdpAudioModalController);

  /** @ngInject */
  function AdpAudioModalController($q, AdpModalService) {
    var vm = this;

    vm.$onInit = function () {
      vm.resultFile = {};
      vm.audioOptions = {};
      vm.uploader = vm.resolve.uploader;

      var audioOptions = vm.resolve.uploader.getOptions().audioRecordOptions;

      vm.options = {
        plugins: {
          record: {}
        }
      };

      if (audioOptions && audioOptions.maxLength) {
        vm.options.plugins.record.maxLength = audioOptions.maxLength;
      }
    };

    vm.cancel = function () {
      var promise;
      if (vm.isEmpty()) {
        promise = $q.when();
      } else {
        promise = AdpModalService.confirm({
          message: 'Are you sure you want to close this window? All unsaved progress will be lost.',
          actionType: 'confirm-close'
        });
      }

      promise
        .then(function () {
          vm.dismiss({$value: 'cancel'});
        });
    };

    vm.isEmpty = function () {
      return _.isEmpty(vm.resultFile)
    };

    vm.save = function () {
      return vm.close({$value: vm.resultFile});
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .component('adpPhotoModal', {
      templateUrl: 'app/adp-file-uploader/components/adp-photo-modal/adp-photo-modal.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpPhotoModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpPhotoModalController', AdpPhotoModalController);

  /** @ngInject */
  function AdpPhotoModalController(
    AdpFileManagerService,
    AdpModalService,
    $q
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.player = null;
      vm.resultFile = {};
      vm.uploader = vm.resolve.uploader;
    };

    vm.cancel = function () {
      var promise;
      if (vm.isEmpty()) {
        promise = $q.when();
      } else {
        promise = AdpModalService.confirm({
          message: 'Are you sure you want to close this window? All unsaved progress will be lost.',
          actionType: 'confirm-close'
        });
      }

      promise
        .then(function () {
          vm.dismiss({$value: 'cancel'});
        });
    };

    vm.capturePhoto = function () {
      vm.player.record().createSnapshot();
    };

    vm.retryPhoto = function () {
      vm.resultFile = {};
      vm.player.record().retrySnapshot();
    };

    vm.isEmpty = function () {
      return _.isEmpty(vm.resultFile)
    };

    vm.save = function () {
      var blob = AdpFileManagerService.dataURItoFile(vm.resultFile);
      return vm.close({$value: blob});
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .component('adpCropModal', {
      templateUrl: 'app/adp-file-uploader/components/adp-crop-modal/adp-crop-modal.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpCropModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpCropModalController', AdpCropModalController);

  /** @ngInject */
  function AdpCropModalController(
    AdpModalService,
    AdpMediaTypeHelper,
    $q
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.uploader = vm.resolve.uploader;
      vm.options = vm.uploader.getOptions();
      vm.aspectRatio = vm.options.aspectRatio || '';
      vm.items = vm.resolve.items;

      vm.inputImage = '';
      vm.outputImage = '';
      vm.currentItemCropParams = {};
      vm.resultCropParams = [];
      vm.resultCropSources = [];

      prepareNextImage()
        .then(function (src) {
          vm.inputImage = src;
        });
    };

    function prepareNextImage() {
      vm.current = vm.items.pop();
      resetCurrentItemParams();

      if (!vm.current._file.isDummyFile) {
        return Promise.resolve(URL.createObjectURL(vm.current._file));
      }

      return AdpMediaTypeHelper.getFileLink(vm.current._file)
        .then(function (imgSrc) {
          return fetch(imgSrc, { credentials: 'include' })
            .then(function (r) { return r.blob(); });
        });
    }

    vm.cancel = function () {
      var promise;
      if (vm.resultCropParams.length) {
        promise = AdpModalService.confirm({
          message: 'Are you sure you want to close this window? All unsaved progress will be lost.',
          actionType: 'confirm-close'
        })
      } else {
        promise = $q.when();
      }

      promise
        .then(function () {
          vm.dismiss({$value: 'cancel'});
        });
    };

    vm.next = function () {
      cacheProgress();
      URL.revokeObjectURL(vm.inputImage);

      prepareNextImage()
        .then(function (src) {
          vm.inputImage = src;
        });
    };

    vm.save = function () {
      cacheProgress();
      _.each(vm.uploader.queue, updateFileItemData);

      return vm.close();
    };

    function updateFileItemData(fileItem) {
      var fileToUpdate = _.find(vm.resultCropParams, function (cropData) {
        return cropData.id === fileItem._file.id;
      });

      if (!fileToUpdate) {
        return;
      }

      fileItem.formData[0] = fileItem.formData[0] || {};
      fileItem.formData[0].cropParams = fileToUpdate.params;

      fileItem._file.cropSrc = fileToUpdate.src;
    }

    function resetCurrentItemParams() {
      delete vm.currentItemCropParams;
      vm.currentItemCropParams = {};
    }

    function cacheProgress() {
      if (vm.current._file.isDummyFile) {
        vm.currentItemCropParams.id = vm.current._file.id;

        vm.current.progress = 0;
        vm.current.isUploaded = false;
        vm.current.isSuccess = false;
      }

      vm.resultCropParams.push({
        id: vm.current._file.id,
        params: JSON.stringify(vm.currentItemCropParams),
        src: vm.outputImage
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .component('adpVideoModal', {
      templateUrl: 'app/adp-file-uploader/components/adp-video-modal/adp-video-modal.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpVideoModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpVideoModalController', AdpVideoModalController);

  /** @ngInject */
  function AdpVideoModalController($q, AdpModalService) {
    var vm = this;

    vm.$onInit = function () {
      vm.resultFile = {};
      vm.uploader = vm.resolve.uploader;
      var videoOptions = vm.uploader.getOptions().videoRecordOptions;

      vm.options = {
        plugins: {
          record: {
            video: { mandatory: {} }
          }
        }
      };

      if (videoOptions && cvideoOptions.maxLength) {
        vm.options.plugins.record.maxLength = videoOptions.maxLength;
      }
    };

    vm.cancel = function () {
      var promise;
      if (vm.isEmpty()) {
        promise = $q.when();
      } else {
        promise = AdpModalService.confirm({
          message: 'Are you sure you want to close this window? All unsaved progress will be lost.',
          actionType: 'confirm-close'
        });
      }

      promise
        .then(function () {
          vm.dismiss({$value: 'cancel'});
        });
    };

    vm.isEmpty = function () {
      return _.isEmpty(vm.resultFile);
    };

    vm.save = function () {
      return vm.close({$value: vm.resultFile});
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .directive('adpFileUploader', adpFileUploader);

  /** @ngInject */
  function adpFileUploader(
    AdpFileUploaderModalService,
    AdpFileUploaderService,
    AdpUploaderMessages,
    Guid,
    AdpMimeService
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        ngModel: '=ngModel',
        fileRequired: '<',
      },
      require: '^^form',
      templateUrl: 'app/adp-file-uploader/directives/adp-file-uploader/adp-file-uploader.template.html',
      link: function ($scope, el, attrs, form) {
        var unbind = $scope.$watch('args', function () {
          init();
          unbind();
        });

        function init() {
          $scope.field = $scope.args.fieldSchema;
          $scope.data = $scope.ngModel();

          const isFilesCollection = $scope.args.modelSchema.schemaName === '_files';
          if (isFilesCollection) {
            $scope.uploader = AdpFileUploaderService.createForFilesCollection($scope.field, $scope.data, $scope.args);
            changeFileType($scope.args);

            const control = form[$scope.field.fieldName];
            control.$validators.fileType = () => {
              const [fileItem] = $scope.uploader.queue || [];
              if (!fileItem) {
                return true;
              }

              const { mimeTypePreset } = $scope.uploader.getOptions();
              return AdpMimeService.validate(fileItem._file, mimeTypePreset);
            }

            $scope.uploader.onAfterAddingFile = validate;
            $scope.$watch('args.row.fileType', function (newV, oldV) {
              if (newV === oldV) {
                return;
              }

              changeFileType($scope.args);
              validate();
            });
          } else {
            $scope.uploader = AdpFileUploaderService.create($scope.field, $scope.data);
          }

          $scope.options = $scope.uploader.getOptions();

          $scope.$emit('adpFileUploaderInit');
          addFilesToFormContext();
          bindEvents();
          addRequiredValidator();
        }

        function bindEvents() {
          $scope.uploader.onSuccessItem = onSuccessFileUpload;
          $scope.uploader.onCompleteAll = onUploadCompleteAll;
          $scope.uploader.onErrorItem = function (item, response, status, headers) {
            console.error('Error while fle upload', item, response, status, headers);
            $scope.$emit('adpFileUploadError', response);
          };

          $scope.$on('adpFileUploadStart', startUpload);
          $scope.$watch(() => $scope.uploader.queue.length, (n, o) => {
            (n !== o) && addFilesToFormContext();
          });
          $scope.$on('$destroy', () => {
            $scope.$emit('adpFileUploaderDestroy');
          });
        }

        function addRequiredValidator() {
          var control = form[$scope.field.fieldName];

          $scope.$watch(() => $scope.uploader.queue.length, (n, o) => {
            (n !== o) && control.$validate();
          });

          control.$validators.required = function () {
            if (!$scope.fileRequired) {
              return true;
            }
            return _.get($scope, 'uploader.queue.length', 0) > 0;
          };
          control.$validators.required();
        }

        function startUpload() {
          const filesToUpload = $scope.uploader.getNotUploadedItems().filter(item => !item.isUploading);

          if ($scope.uploader.queue.length === 0 || filesToUpload.length === 0) {
            $scope.$emit('adpFileUploadComplete');
            return;
          }
          $scope.uploader.uploadAll();
        }

        function onSuccessFileUpload(item, response) {
          if (!response.success) {
            item.isSuccess = false;
            item.isUploaded = false;
            return $scope.$emit('adpFileUploadError', response);
          }

          if (Guid.isGuid(item._file.id)) {
            create(item, response);
          } else {
            update(item, response);
          }
        }

        function create(item, response) {
          var fileItem = {
            name: item.file.name,
            size: item.file.size,
            type: item.file.type,
            id: response.data[0].id,
            cropped: response.data[0].cropped
          };

          $scope.data.push(fileItem);
          $scope.ngModel($scope.data);
        }

        function update(item, response) {
          if ($scope.uploader.isFileCollection) {
            $scope.data.shift();
            create(item, response);
            return;
          }

          const itemToUpdate = _.find($scope.ngModel(), fileItem => fileItem.id === item._file.id);
          itemToUpdate.cropped = response.data[0].cropped;
        }

        function onUploadCompleteAll() {
          $scope.$emit('adpFileUploadComplete');
        }

        $scope.callAudioModal = callModal.bind(this, 'audioModal');
        $scope.callVideoModal = callModal.bind(this, 'videoModal');
        $scope.callPhotoModal = callModal.bind(this, 'photoModal');

        function callModal(name) {
          if (AdpFileUploaderService.isFileAmountLimit($scope.uploader)) {
            return AdpUploaderMessages.showErrorMessage('queueLimit', $scope.uploader);
          }

          AdpFileUploaderModalService[name]($scope.uploader)
            .then(function(blob) {
              return new File([blob], blob.name, {type: blob.type})
            })
            .then($scope.uploader.addFiles.bind($scope.uploader));
        }

        function addFilesToFormContext() {
          const files = _.map($scope.uploader.queue, ({ _file }) => _file);
          _.set($scope.formContext, $scope.args.path, files);
        }

        function changeFileType(args) {
          const newOptions = {
            File: {
              mimeTypePreset: 'any',
              enablePhotoCapture: false,
              enableCropper: false,
              enableMicrophone: false,
              enableWebcam: false,
            },
            Audio: {
              mimeTypePreset: 'audio',
              enablePhotoCapture: false,
              enableCropper: false,
              enableMicrophone: true,
              enableWebcam: false,
            },
            Image: {
              mimeTypePreset: 'images',
              enablePhotoCapture: true,
              enableCropper: true,
              enableMicrophone: false,
              enableWebcam: false,
            },
            Video: {
              mimeTypePreset: 'video',
              enablePhotoCapture: false,
              enableCropper: false,
              enableMicrophone: false,
              enableWebcam: true,
            },
          };

          const fileType = args.row.fileType;
          $scope.uploader.updateFileInfo(args);
          $scope.uploader.updateOptions(newOptions[fileType]);
        }

        function validate() {
          const control = form[$scope.field.fieldName];
          control.$validate();
        }
      }
    }
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpUploader")
    .factory("AdpFileDropzoneHelper", adpFileDropzoneHelper);

  /** @ngInject */
  function adpFileDropzoneHelper() {
    var eventNamespace = "adpFileDropZone";
    var dragOverClassName = "adp-file-uploader-over";
    var events = {
      "dragover": "dragover." + eventNamespace,
      "dragenter": "dragenter." + eventNamespace,
      "dragcancel": ["dragleave." + eventNamespace, "dragend." + eventNamespace].join(" "),
      "drop": "drop." + eventNamespace
    };

    function bindEvents(dropzone, handlers) {
      $(window)
        .on(events.dragover, preventDefault);
      $(window)
        .on(events.drop, preventDefault);

      // allow drop by preventDefault behavior on drop
      dropzone.on(events.dragover, preventDefault);
      dropzone.on(events.dragenter, function (e) {
        preventDefault(e);
        dropzone.addClass(dragOverClassName);
      });
      dropzone.on(events.dragcancel, function (e) {
        preventDefault(e);
        dropzone.removeClass(dragOverClassName);
      });
      dropzone.on(events.drop, function (e) {
        if (_.isFunction(handlers.onDrop)) {
          preventDefault(e);
          handlers.onDrop(e);
        }

        dropzone.removeClass(dragOverClassName);
      });
    }

    function getUnbindEvents(dropzone) {
      return function () {
        dropzone.off(events.dragover);
        dropzone.off(events.dragenter);
        dropzone.off(events.dragcancel);
        dropzone.off(events.drop);

        $(window)
          .off(events.dragover);
        $(window)
          .off(events.drop);
      }
    }

    function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    return {
      bindEvents: bindEvents,
      getUnbindEvents: getUnbindEvents,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .directive('adpFileUploaderDropzone', adpFileUploaderDropzone);

  /** @ngInject */
  function adpFileUploaderDropzone(
    AdpFileUploaderService,
    AdpNotificationService,
    AdpUploaderMessages,
    AdpFileDropzoneHelper
  ) {
    return {
      restrict: 'A',
      scope: {
        uploader: '=',
        data: '='
      },
      link: function ($scope, $element) {
        $scope.options = $scope.uploader.getOptions();

        if ($scope.options.enableDragAndDrop) {
          AdpFileDropzoneHelper.bindEvents($element, {
            onDrop: function (e) {
              var uploader = $scope.uploader;

              if (AdpFileUploaderService.isFileAmountLimit(uploader)) {
                return AdpUploaderMessages.showErrorMessage('queueLimit', uploader);
              }

              $scope.uploader.addFiles(e.originalEvent.dataTransfer.files);
            }
          });

          $scope.$on('$destroy', AdpFileDropzoneHelper.getUnbindEvents($element));
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .directive('adpFileUploaderList', adpFileUploaderList);

  /** @ngInject */
  function adpFileUploaderList(
    AdpFileUploaderModalService,
    AdpMimeService
  ) {
    return {
      restrict: 'E',
      scope: {
        uploader: '=',
        data: '='
      },
      templateUrl: 'app/adp-file-uploader/directives/adp-file-uploader-list/adp-file-uploader-list.template.html',
      link: function ($scope) {
        $scope.options = $scope.uploader.getOptions();

        $scope.crop = function (item) {
          AdpFileUploaderModalService.cropModal([item]);
        };

        $scope.isCropEnabled = function (item) {
          return $scope.isImage(item) && $scope.options.enableCropper;
        };

        $scope.isImage = function(item) {
          return AdpMimeService.isImage(item.file);
        };

        $scope.remove = function (item) {
          if (item._file.id) {
            _.remove($scope.data, function (itemData) {
              return itemData.id === item._file.id;
            });
          }

          item.remove();
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUploader')
    .directive('adpUploaderErrors', adpUploaderErrors);

  /** @ngInject */
  function adpUploaderErrors() {
    return {
      restrict: 'E',
      scope: {
        uploader: '='
      },
      templateUrl: 'app/adp-file-uploader/directives/adp-uploader-errors/adp-uploader-errors.template.html',
      link: function ($scope) {
        $scope.hide = function () {
          $scope.uploader.clearErrors();
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormIterator', adpFormIterator);

  const template = `
      <div ng-repeat="fieldOrGroup in ::topScopeFields track by $index">
        <fieldset ng-if="::fieldOrGroup.fields">
          <div class="adp-form-fieldset">
            <adp-form-field-factory
              ng-repeat="field in ::fieldOrGroup.fields track by $index"
              args="::args"
              field-name="::field.fieldName"
              form-context="::formContext"
            ></adp-form-field-factory>
          </div>
        </fieldset>
        
        <div
          ng-if="::fieldOrGroup.groups"
          ng-switch="::groupingType"
          class="adp-form-body"
        >
          <div 
            class="adp-form-group-body"
            ng-switch-when="accordion"
          >
            <adp-form-group-accordion-or-grouping
              groups="::fieldOrGroup.groups"
              args="::args"
              form-context="::formContext"
            ></adp-form-group-accordion-or-grouping>
          </div>
      
          <div ng-switch-when="wizard">
            <adp-form-group-wizard
              groups="::fieldOrGroup.groups"
              args="::args"
              form-context="::formContext"
            ></adp-form-group-wizard>
          </div>
      
          <div 
            ng-switch-when="grouping"
            class="adp-form-group-body"
          >
            <adp-form-group-accordion-or-grouping
              groups="::fieldOrGroup.groups"
              args="::args"
              form-context="::formContext"
            ></adp-form-group-accordion-or-grouping>
          </div>
          
        </div>
      </div>`;

  function adpFormIterator() {
    return {
      restrict: 'E',
      scope: false,
      template,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpForm', adpForm);

  /**
   * @typedef {Object} schemaActionsStrategy
   * adpForm directive provides different types of providing Submit and other actions.
   * schemaActionsStrategy allows to specify these action from Schema.
   * However sometimes outer form environment requires some action to call to
   * close modal, for example, or cancel editing and rollback data.
   *
   * Such actions are optional and should be provided in formOptions.
   *
   * If such options provided, than actions template is built inside form based on schema.
   *
   * @property {Function} [onComplete] - called after form successfully submitted
   * @property {Function} [onCancel] - called if data editing was canceled
   */

  /**
   * @typedef {Object} localActionsStrategy
   * adpForm directive provides different types of providing Submit and other actions.
   * localActionsStrategy allows to specify these action from formOptions.
   * Any outer actions are handled outside adpForm.
   *
   * If such options provided, than actions template is built based outside of form.

   * @property {Function} submit - async function for api request
   */

  /**
   * @ngdoc directive
   * @module app.adpForms
   * @name app.adpForms:adpForm
   *
   * @param {Object} args - Unified args
   * @param {Object} formOptions
   * @param {Boolean} formOptions.disableFullscreen - allows to disable fullScreen
   * @param {Object} formOptions.schemaActionsStrategy
   * @param {Object} formOptions.localActionsStrategy
   */
  function adpForm(
    AdpFieldsService,
    AdpFormService,
    RequiredExpression,
    UploadError,
    ErrorHelpers,
    AdpFormActionHandler,
    $cacheFactory
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formOptions: '<',
      },
      transclude: {
        'header': '?formHeader',
        'body': '?formBody',
        'footer': '?formFooter',
      },
      templateUrl: 'app/adp-forms/directives/adp-form/adp-form.html',
      link(scope, element) {
        init();

        function init() {
          scope.args.row = _.cloneDeep(scope.args.row) || {};

          scope.groupingType = AdpFormService.getGroupingType(scope.args);
          scope.topScopeFields = scope.groupingType ?
            AdpFieldsService.getFormGroupFields(scope.args.fieldSchema.fields) :
            AdpFieldsService.getFormFields(scope.args.fieldSchema.fields);

          scope.loading = true;
          setDisabledStated(scope.loading);

          scope.uploaderCnt = 0;
          scope.hasFooter = _.hasIn(scope, 'formOptions.submitCb');

          scope.formContext = {
            requiredMap: {},
            errorCount: {},
            rootForm: scope.form,
            rootFormScope: scope,
            triggerEvent(name) {
              scope.$broadcast(name);
            }
          };

          applyActionClass(scope.args.action);
          bindEvents();

          _.defer(() => {
            triggerFormEvent('onFormRender');
            scope.loading = false;
            setDisabledStated(scope.loading);
            setFirstElementFocus();
          });
        }

        function setFirstElementFocus() {
          const firstFocusable = scope.form.$$element.find('fieldset input:focusable, fieldset textarea:focusable').first();
          firstFocusable.focus({preventScroll: true});
        }

        function applyActionClass(action) {
          if (!action) {
            return;
          }

          scope.formActionClass = 'form-action-' + action;
        }

        function triggerFormEvent(eventName) {
          const {args} = scope;
          const fnName = _.get(args, `modelSchema.events.${eventName}`);
          const fn = _.get(window.appModelHelpers, ['FormEvents', fnName]);

          if (!_.isFunction(fn)) {
            return;
          }

          try {
            return fn.call(args);
          } catch (e) {
            ErrorHelpers.handleError(e, `Error trying to call ${eventName} for:`, args);
          }
        }

        // there are two functions to bind events:
        // the second one is for avoiding error for form when nested form are not rendered
        // the first one keep order of event triggered by child directives
        function bindEvents() {
          scope.$on('adpFileUploaderInit', () => {
            scope.uploaderCnt++;
          });

          scope.$on('adpFileUploaderDestroy', () => {
            scope.uploaderCnt--;
          });

          scope.$watch('[loading]', updateDisabledState);
          const watchExpr = _.throttle(() => angular.toJson(scope.form), 100)
          scope.$watch(watchExpr, onFormUpdate);

          scope.$on('$destroy', () => {
            const httpCache = $cacheFactory.get('$http');
            httpCache.removeAll();
            $('body').removeClass('adp-form-fullscreen');
            triggerFormEvent('onFormDestroy');
          });

          initActionsStrategy();
        }

        function initActionsStrategy() {
          scope.submit = submit;
          var schemaStrategy = _.hasIn(scope, 'formOptions.schemaActionsStrategy');
          if (schemaStrategy) {
            setSchemaActionsStrategy();
          } else {
            scope.submitAction = _.get(scope, 'formOptions.localActionsStrategy.submit');
          }
        }

        function setSchemaActionsStrategy() {
          scope.formHooks = {
            onCancel: _.get(scope, 'formOptions.schemaActionsStrategy.onCancel', null),
            onComplete: _.get(scope, 'formOptions.schemaActionsStrategy.onComplete', null),
            triggerEvent(name) {
              scope.$broadcast(name);
            },
          };

          scope.execFormAction = function (action, name) {
            var actionCb = AdpFormActionHandler(action, name);

            var type = _.get(action, 'htmlAttributes.type', 'button');
            if (type === 'submit') {
              scope.subminActionName = name;
              scope.submitAction = actionCb;
            } else {
              const argsForAction = _.assign({}, scope.args, {action: name});
              const applyResult = actionCb.apply(argsForAction, [argsForAction, scope.formHooks, scope.formContext, scope]);

              if (applyResult && applyResult.finally) {
                scope.loading = true;
                applyResult.finally(() => {
                  _.defer(() => {
                    scope.loading = false;
                  });
                });
              }
            }
          }
        }

        function submit(args) {
          if (scope.form.$invalid) {
            AdpFormService.scrollToError(scope.form);
            return;
          }

          scope.loading = true;

          return AdpFormService.handleFileUpload(scope)
            .then(function () {
              return scope.submitAction.apply(args, [args, scope.formHooks, scope.subminActionName]);
            })
            .catch(function (error) {
              ErrorHelpers.handleError(error, 'Unknown error in form');
            })
            .finally(() => {
              scope.loading = false;
            });
        }

        function updateDisabledState(values) {
          if (!element || !element.find('[type="submit"]').length) {
            return;
          }
          const [loading] = values;
          setDisabledStated(loading)
        }

        function setDisabledStated(status) {
          element.toggleClass('adp-disabled-form', status);

          element.find('[type="submit"]')
            .prop('disabled', status);
        }

        function onFormUpdate(newVal, oldVal) {
          if (newVal === oldVal || !scope.form) {
            return;
          }
          AdpFormService.forceValidation(scope.form);
          RequiredExpression.eval({
            args: scope.args,
            requiredMap: scope.formContext.requiredMap,
            form: scope.form,
          });

          if (scope.form.$submitted) {
            scope.errorCount = AdpFormService.countErrors(scope.form);
            scope.formContext.errorCount = scope.errorCount;
          }

          scope.$broadcast('formChanged', 'root');
          triggerFormEvent('onFormUpdate');
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldContainer', adpFormFieldContainer);

  function adpFormFieldContainer(AdpAttrs) {
    return {
      restrict: 'E',
      scope: false,
      templateUrl: 'app/adp-forms/directives/adp-form-field-container/adp-form-field-container.html',
      require: '^^form',
      transclude: true,
      link(scope, el) {
        AdpAttrs(el.find('.input-container')[0], scope.args);
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldComplex', adpFormFieldComplex);

  function adpFormFieldComplex(
    ComplexObjectUtil,
    AdpValidationUtils,
    $compile
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      require: '^^form',
      compile() {
        return (scope, element, attrs, form) => {
          scope.form = form;
          const frameType = ComplexObjectUtil.getFrameType(scope.args);
          const { type } = scope.args.fieldSchema;
          const fieldType = ({
            'Object': 'object',
            'KeyVal': 'key-val',
          })[type] || 'array';

          const controlPostfix = getFrameTypePrefix(fieldType, frameType);
          const isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
          const isArray = fieldType === 'array';
          const isKeyVal = fieldType === 'key-val';
          (isArray || isKeyVal) && scope.$on('formChanged', function () {
            const { data = [] } = scope.args;
            let invalid;

            if (_.isEmpty(data)) {
              invalid = isRequired();
            } else {
              invalid = _.some(data, (item, index) => {
                const formName = `${scope.args.fieldSchema.fieldName}[${index}]`;
                return _.get(form, [formName, '$error', 'required']);
              });
            }

            const formField = form[scope.args.fieldSchema.fieldName];
            formField && formField.$setValidity('required', !invalid);
          });

          const template = `
            <adp-form-field-container
              ng-attr-field-container="{{::args.fieldSchema.fieldName}}"
              args="::args"
            >
              <label
                ng-attr-adp-qaid-field-label="{{args.path}}"
                class="label"
                ng-if="::args.fieldSchema.showFormLabel"
              >
                {{::args.fieldSchema.fullName}}
            
                <adp-required-mark></adp-required-mark>
                <adp-tooltip></adp-tooltip>
              </label>
              
              ${(isArray  || isKeyVal) ? `<div 
                class="input-container state-error"
                ng-if="form.$submitted && form[args.fieldSchema.fieldName].$error.required"
              >
                <div class="note note-error">{{::args.fieldSchema.fullName}} is required</div>
              </div>` : ''}
            
              <${fieldType}-control${controlPostfix}
                args="::args"
                form-context="::formContext"
              ></${fieldType}-control${controlPostfix}>
            </adp-form-field-container>`;

          element.append($compile(template)(scope));
        }
      }
    }

    function getFrameTypePrefix(fieldType, frameType) {
      if (frameType === 'grid') {
        return '-grid';
      }

      if (fieldType === 'array' && _.includes(['tree', 'forest', 'array'], frameType)) {
        return '-tree';
      }

      return '';
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldFactory', adpFormFieldFactory);

  function adpFormFieldFactory(
    $compile,
    AdpFieldsService,
    AdpPath,
    AdpUnifiedArgs,
    ShowExpression,
    $rootScope,
    $timeout,
    ArrayKeyArgs,
    APP_CONFIG
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
        fieldName: '<?',
        index: '=?',
        isKey: '=?',
      },
      compile: function () {
        return function (scope, element) {
          if (scope.isKey) {
            scope.nextArgs = ArrayKeyArgs(scope.args, scope.index);
            scope.formContext.requiredMap[scope.nextArgs.path] = true;
          } else {
            scope.nextArgs = AdpUnifiedArgs.next(
              scope.args,
              scope.fieldName,
              scope.index,
            );
          }

          scope.spinner = false;
          scope.isVisible = ShowExpression.evalShowForField(scope.nextArgs);
          scope.$on('formChanged', function () {
            var newVal = ShowExpression.evalShowForField(scope.nextArgs);
            var oldVal = scope.isVisible;

            if (shouldShowSpinner(oldVal, newVal)) {
              onShowSpinner();
            } else {
              scope.isVisible = newVal;
            }
          });

          function shouldShowSpinner(oldShow, newShow) {
            const isComplex = ['Object', 'Array', 'AssociativeArray', 'KeyVal'].includes(scope.nextArgs.fieldSchema.type);
            if (!isComplex) {
              return false;
            }

            const changedToVisible = (oldShow === false) && (newShow === true);
            return changedToVisible;
          }

          // IMPORTANT: keep order
          function onShowSpinner() {
            // suspending scope allows to show spiner
            // otherwise execution stack is too busy to run any code
            $rootScope.$suspend();
            scope.spinner = true;

            // applying new visibility inside evalAsync
            // allow to show spinner, but not piecies of broken, not yet rendered form
            scope.$evalAsync(function () {
              scope.isVisible = true;
            });

            // called at the end of compilation, when dom is ready
            $timeout(function () {
              scope.spinner = false;
              $rootScope.$resume();
            });
          }

          if (scope.args.action === 'create') {
            var unbind = scope.$watch('args.action', function (newVal) {
              if (newVal !== 'update') {
                return;
              }

              scope.nextArgs.action = scope.args.action;
              unbind();
            });

            setDefaultValue();
          }

          const updateArgs = () => {
            if (scope.isKey) {
              Object.assign(scope.nextArgs, ArrayKeyArgs(scope.args, scope.index));
              scope.formContext.requiredMap[scope.nextArgs.path] = true;
            } else {
              Object.assign(scope.nextArgs, AdpUnifiedArgs.next(
                scope.args,
                scope.fieldName,
                scope.index
              ));
            }
          }
          scope.$watch('index', (newIndex, oldIndex) => {
            if (newIndex === oldIndex) {
              return;
            }

            const oldPath = scope.nextArgs.path;
            updateArgs();
            const newPath = scope.nextArgs.path;
            scope.$broadcast('pathChanged', { oldPath, newPath });
          });
          scope.$on('pathChanged', updateArgs);

          const className = (() => {
            const fieldWidth = _.get(scope, 'nextArgs.fieldSchema.formWidth', 12);
            return `form-control-wrapper col col-${fieldWidth}`;
          })();

          const directiveType = AdpFieldsService.getDirectiveType(scope.nextArgs.fieldSchema, scope.args.action);
          const { removeTestAttributes } = APP_CONFIG;
          const qaAttribute = removeTestAttributes ? '' : 'ng-attr-adp-qaid-field="{{nextArgs.path}}"'

          const template = `
            <div ng-if="spinner" style="margin-left: 20px;">
              <i class="fa fa-gear fa-4x fa-spin"></i>
            </div>
            <adp-form-field-${directiveType}
              class="${className}"
              ng-if="isVisible"
              args="::nextArgs"
              form-context="::formContext"
              ${qaAttribute}
              form-control-path="{{nextArgs.path}}"
            ></adp-form-field-${directiveType}>
          `;

          element.replaceWith($compile(template)(scope));

          function setDefaultValue() {
            if (scope.nextArgs.data) {
              return;
            }

            const defaultValue = _.get(scope, 'nextArgs.fieldSchema.default');
            if (_.isNil(defaultValue)) {
              return;
            }

            _.set(scope.nextArgs.row, scope.nextArgs.path, defaultValue);
            scope.nextArgs.data = defaultValue;
          }
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ArrayKeyArgs', ArrayKeyArgs);

  /** @ngInject **/
  function ArrayKeyArgs() {
    return function (arrayArgs, index) {
      const keyFieldSchema = _.get(arrayArgs, 'fieldSchema._key') || {};
      const fieldSchema = _.merge({
        type: 'String',
        fullName: 'Key',
        fieldName: '$key',
        validate: [{
          validator: 'associativeArrayKeyUnique',
          errorMessages: { default: 'The "key" must be unique' }
        }, {
          validator: 'schemaKeyRegExp',
          errorMessages: {
            default: 'Key must start from latin letter or underscore. Other Key characters must contain latin letters, numbers and underscores only.',
          }
        }],
      }, keyFieldSchema);

      const { row, action } = arrayArgs;
      return {
        fieldSchema, row, action,
        path: arrayArgs.path + '[' + index + '].$key',
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
      .module('app.adpForms')
      .directive('adpFormGroupMessages', adpFormGroupMessages);

  function adpFormGroupMessages() {
    return {
      restrict: 'E',
      scope: {
        argsList: '='
      },
      require: '^^form',
      templateUrl: 'app/adp-forms/directives/adp-form-group-messages/adp-form-group-messages.html'
    }
  }
})();
;;(function () {
  'use strict';

  angular
      .module('app.adpForms')
      .directive('adpMessages', adpMessages);

  function adpMessages(AdpValidationMessages, $timeout) {
    return {
      restrict: 'E',
      scope: {
        args: '=',
      },
      require: '^^form',
      templateUrl: 'app/adp-forms/directives/adp-messages/adp-messages.html',
      link: function (scope, el, attrs, form) {
        var unbind = scope.$watch('args', function () {
          $timeout(init);
          unbind();
        });

        function init() {
          scope.field = scope.args.fieldSchema;
          var validationDisabled = _.isEmpty(scope.field.validate) && scope.field.required === false;

          if (validationDisabled) {
            return;
          }

          scope.fieldModel = form[scope.field.fieldName];
          scope.$watch('fieldModel.$viewValue', updateMessages);
        }

        function updateMessages(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }

          scope.messages = AdpValidationMessages.updateAll(scope.field, getFormData());
        }

        function getFormData() {
          return _.transform(form.$getControls(), function (result, control) {
            result[control.$name] = control.$viewValue;
          }, {});
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpValidationMessages', AdpValidationMessages);

  function AdpValidationMessages(
    AdpSchemaService,
    AdpValidationUtils
  ) {
    function updateAll(field, formData) {
      var messages = {};
      var validatorWithMessages = (field.validate || []).filter(function (validationRule) {
        return !_.isNil(validationRule.errorMessages)
      });

      validatorWithMessages.forEach(function (validationRule) {
        var value = formData[field.fieldName];
        var message = update(value, field, validationRule, formData);
        if (message) {
          messages[validationRule.validator] = message;
        }
      });

      return messages;
    }

    function update(value, field, validationRule, formData) {
      var TEMPLATE_REGEX = {
        VAL: /(\$val)/,
        ARG_VAL: /\$(\w+)/,
        FULL_NAME: /@(\w+)/,
        MATCHED_VAL: /#(\w+)/,
      };

      var message = _getMessage(field, validationRule);

      return message
        .replace(TEMPLATE_REGEX.VAL, function () {
          return _replaceByValue(value, field);
        })
        .replace(TEMPLATE_REGEX.ARG_VAL, function (argNameWithPrefix, argName) {
          return _replaceByValueArg(validationRule, argName);
        })
        .replace(TEMPLATE_REGEX.MATCHED_VAL, function (argNameWithPrefix, argName) {
          return _replaceByMatchedValue(validationRule, field, argName, formData);
        })
        .replace(TEMPLATE_REGEX.FULL_NAME, function (argNameWithPrefix, argName) {
          return _replaceByFullName(validationRule, field, argName);
        })
        .replace(/@@/g, '@')
        .replace(/\$\$/g, '$');
    }

    function _getMessage(field, validator) {
      var messageName;

      if (_isDate(field.type, validator)) {
        messageName = field.type.toLowerCase();
      }

      var message = validator.errorMessages[messageName] || validator.errorMessages['default'];

      return message;
    }

    function _replaceByValue(value, field) {
      if (_isDate(field.type)) {
        return AdpValidationUtils.formatDate(value, field);
      }

      return value;
    }

    function _replaceByValueArg(validationRule, argName) {
      return validationRule.arguments[argName] || argName;
    }

    function _replaceByMatchedValue(validationRule, field, argName, formData) {
      var argument = validationRule.arguments[argName];

      if (argument[0] === '$') {
        var matchedFieldName = validationRule.arguments[argName].slice(1);
        var value = formData[matchedFieldName];

        return _isDate(field.type) ?
          AdpValidationUtils.formatDate(argument, field) :
          value;
      } else {
        return _isDate(field.type) ?
          AdpValidationUtils.formatDate(argument, field) :
          argument;
      }
    }

    function _replaceByFullName(validationRule, field, argName) {
      var argument = validationRule.arguments[argName];

      if (argument[0] === '$') {
        var matchedFieldName = validationRule.arguments[argName].slice(1);
        var fields = AdpSchemaService.getCurrentSchema().fields;

        return fields[matchedFieldName].fullName;
      } else {
        return _isDate(field.type) ?
          AdpValidationUtils.formatDate(argument, field) :
          argument;
      }
    }

    function _isDate(type) {
      return type.includes('Date') || type.includes('Time');
    }

    return {
      updateAll: updateAll,
      update: update,
    };
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpValidationRules', AdpValidationRules);

  function AdpValidationRules(AdpValidationUtils) {
    // noop(), always valid
    function noopValidator() { return true; }

    var minMaxValidators = {
      minString: function (args) {
        var limitStr = _.get(args, 'validationRule.arguments.limit');
        var limit = parseInt(limitStr);
        return AdpValidationUtils.minString(args.data, limit);
      },

      maxString: function (args) {
        var limitStr = _.get(args, 'validationRule.arguments.limit');
        var limit = parseInt(limitStr);
        return AdpValidationUtils.maxString(args.data, limit);
      },

      minNumber: function (args) {
        var limitStr = _.get(args, 'validationRule.arguments.limit');
        var limit = parseFloat(limitStr);

        return args.data >= limit;
      },

      maxNumber: function (args) {
        var limitStr = _.get(args, 'validationRule.arguments.limit');
        var limit = parseFloat(limitStr);

        return args.data <= limit;
      },

      minInt32: function (args) {
        var limitStr = _.get(args, 'validationRule.arguments.limit');
        var limit = parseInt(limitStr);

        return args.data >= limit;
      },

      maxInt32: function (args) {
        var limitStr = _.get(args, 'validationRule.arguments.limit');
        var limit = parseInt(limitStr);

        return args.data <= limit;
      },

      minDate: function (args) {
        var dates = prepareDateForComparison(args);
        if (_.isNil(dates)) {
          return true;
        }

        return dayjs(dates.value).isSameOrAfter(dates.comparisonDate, 'day');
      },

      maxDate: function (args) {
        var dates = prepareDateForComparison(args);
        if (_.isNil(dates)) {
          return true;
        }

        return dayjs(dates.value).isSameOrBefore(dates.comparisonDate, 'day');
      },

      minTime: function (args) {
        var dates = prepareDateForComparison(args);
        if (_.isNil(dates)) {
          return true;
        }

        var lhs = AdpValidationUtils.getMinutesOfDay(dates.value);
        var rhs = AdpValidationUtils.getMinutesOfDay(dates.comparisonDate);

        return lhs >= rhs;
      },

      maxTime: function (args) {
        var dates = prepareDateForComparison(args);
        if (_.isNil(dates)) {
          return true;
        }

        var lhs = AdpValidationUtils.getMinutesOfDay(dates.value);
        var rhs = AdpValidationUtils.getMinutesOfDay(dates.comparisonDate);

        return lhs <= rhs;
      },

      minDateTime: function (args) {
        var dates = prepareDateForComparison(args);
        if (_.isNil(dates)) {
          return true;
        }

        return dayjs(dates.value).isSameOrAfter(dates.comparisonDate);
      },

      maxDateTime: function (args) {
        var dates = prepareDateForComparison(args);
        if (_.isNil(dates)) {
          return true;
        }

        return dates.value.isSameOrBefore(dates.comparisonDate);
      },
      minImperialHeight: noopValidator,
      minImperialWeightWithOz: noopValidator,
      minImperialWeight: noopValidator,
      maxImperialHeight: noopValidator,
      maxImperialWeightWithOz: noopValidator,
      maxImperialWeight: noopValidator,
      boolean: noopValidator,
      triStateBoolean: noopValidator,
    };

    function validateNumberRange(args) {
      var isMultiple = args.fieldSchema.type.includes('[]');
      var range = selectRange(args.validationRule);

      return isMultiple ?
        validateNumberRangeMultiple(args.data, range) :
        validateNumberRangeSingle(args.data, range);
    }

    function selectRange(validationRule) {
      return ({
        int32: { begin: 0x7fffffff, end: -0x80000000 },
        int64: { begin: Number.MIN_SAFE_INTEGER, end: Number.MAX_SAFE_INTEGER },
      })[validationRule.validator];
    }

    function validateNumberRangeSingle(value, range) {
      var num = Number(value);
      return _.inRange(num, range.begin, range.end);
    }

    function validateNumberRangeMultiple(value, range) {
      var inRangeValues = value.filter(function (v) {
        return validateNumberRangeSingle(v, range);
      });

      return value.length === inRangeValues.length;
    }

    return {
      regex: function (args) {
        var regexPart = _.get(args, 'validationRule.arguments.regex');
        var regexOptionsPart = _.get(args, 'validationRule.arguments.regexOptions');
        var regex = new RegExp(regexPart, regexOptionsPart);

        return regex.test(args.data);
      },

      maxLength: function (args) {
        var limit = parseInt(args.validationRule.arguments.length);
        return AdpValidationUtils.maxString(args.data.length, limit);
      },

      minLength: function (args) {
        var limit = parseInt(args.validationRule.arguments.length);
        return AdpValidationUtils.minString(args.data.length, limit);
      },

      passwordMatch: function(args) {
        var matchedFieldName = args.validationRule.arguments.matchedField;
        var matchedValue = args.formData[matchedFieldName];

        return args.data === matchedValue;
      },

      min: function (args) {
        const ruleName = 'min' + args.fieldSchema.type;
        const method = minMaxValidators[ruleName] || minMaxValidators.minNumber;
        return method.apply(null, arguments);
      },

      max: function (args) {
        const ruleName = 'max' + args.fieldSchema.type;
        const method = minMaxValidators[ruleName] || minMaxValidators.minNumber;
        return method.apply(null, arguments);
      },

      notInFuture: function(args) {
        var dates = prepareDateForComparison(args, today());
        if (_.isNil(dates)) {
          return true;
        }

        return dayjs(dates.value).isSameOrBefore(dates.comparisonDate);
      },

      notInPast: function(args) {
        var dates = prepareDateForComparison(args, today());
        if (_.isNil(dates)) {
          return true;
        }

        return dayjs(dates.value).isSameOrAfter(dates.comparisonDate);
      },
      int32: validateNumberRange,
      int64: validateNumberRange,
      imperialHeightRange: noopValidator,
      decimal128: noopValidator,
      string: noopValidator,

      associativeArrayKeyUnique(args) {
        const $parts = args.path.match(/(.+)\[\d+\].\$key$/) || [];
        const _parts = args.path.match(/(.+)\[\d+\]._key$/) || [];
        const arrayPath = $parts[1] || _parts[1];
        const arrayData = _.get(args.row, arrayPath) || [];
        const duplicateKeys = _.filter(arrayData, (({ $key, _key }) => $key === args.data || _key === args.data));
        return duplicateKeys.length <= 1;
      },

      schemaKeyRegExp(args) {
        const keyRegex = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
        return keyRegex.test(args.data);
      },
    };

    /**
     * @return {null|{value: dayjs.dayjs, comparisonDate: String}}
     */
    function prepareDateForComparison(args, comparisonDate) {
      var format = AdpValidationUtils.getDateFormat(args.fieldSchema.type);
      var limitDate = comparisonDate ?
        dayjs(comparisonDate) :
        dayjs(args.validationRule.arguments.limit, format);

      var dates = {
        value: dayjs(args.data).startOf('minute'),
        comparisonDate: limitDate.startOf('minute'),
      };

      if (!dates.value.isValid() || !dates.comparisonDate.isValid()) {
        return null;
      }

      return dates;
    }

    function today() {
      var todaySinceMidnight = new Date();
      return todaySinceMidnight.setHours(0,0,0,0);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpValidationUtils', AdpValidationUtils);

  function AdpValidationUtils(
    DATE_FORMAT,
    DATE_TIME_FORMAT,
    TIME_FORMAT
  ) {
    var dateFormats = {
      Date: DATE_FORMAT,
      DateTime: DATE_TIME_FORMAT,
      Time: TIME_FORMAT,
    };

    return {
      getMinutesOfDay: getMinutesOfDay,
      minString: minString,
      maxString: maxString,
      isValidDate: isValidDate,
      getDateFormat: getDateFormat,
      formatDate: formatDate,
      isRequired: isRequired,
      getRequiredFn: getRequiredFn,
    }

    function getMinutesOfDay(m) {
      return m.minute() + m.hour() * 60;
    }

    function minString(length, limit) {
      return length >= limit;
    }

    function maxString(length, limit) {
      return length <= limit;
    }

    function isValidDate(value, type) {
      var dateFormat = getDateFormat(type);

      return dayjs(value, dateFormat).isValid();
    }

    function getDateFormat(type) {
      return dateFormats[type];
    }

    function formatDate(value, field) {
      var format = getDateFormat(field.type);
      var dayjsInstance = typeof value === 'string' ?
        dayjs(value, format) : dayjs(value);

      return dayjsInstance.format(format);
    }

    function isRequired(path, requiredMap) {
      return function () {
        return requiredMap[path] || false;
      }
    }

    function getRequiredFn(args) {
      var requiredRule = args.fieldSchema.required;

      if (_.isString(requiredRule)) {
        return _createConditionalRequiredFn(args);
      } else {
        return function () {
          return !!requiredRule;
        };
      }
    }

    function _createConditionalRequiredFn(args) {
      var required = args.fieldSchema.required;
      var isMultilineRequired = required.includes('\n');
      var code = isMultilineRequired ? required : 'return ' + required;
      return new Function('data, row, modelSchema, $action', code).bind(args, args.data, args.row, args.modelSchema, args.action);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .component('adpCellEditorModal', {
      templateUrl: 'app/adp-generator/directives/adp-cell-editor-modal/adp-cell-editor-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpCellEditorModalController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpCellEditorModalController', AdpCellEditorModalController);

  /** @ngInject */
  function AdpCellEditorModalController(
    ACTIONS,
    $q
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.args = vm.resolve.options.args;

      vm.formOptions = {
        localActionsStrategy: {
          submit: function (args) {
            return $q.resolve()
              .then(function () {
                vm.close({ $value: args.row });
              });
          },
        },
      };

      vm.cancel = function () {
        vm.dismiss({ $value: 'cancel' });
      };

      vm.actionText = selectActionText(vm.args.action);

      function selectActionText(action) {
        var actionName = action.replace('cell-editing-', '');
        var texts = {};
        texts[ACTIONS.CREATE] = 'Add';
        texts[ACTIONS.CLONE] = 'Add';
        texts[ACTIONS.CLONE_DATASET] = 'Add';
        texts[ACTIONS.UPDATE] = 'Update';

        return texts[actionName];
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .component('adpDefaultActionModal', {
      templateUrl: 'app/adp-generator/directives/adp-default-action-modal/adp-default-action-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'adpDefaultActionModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('adpDefaultActionModalController', adpDefaultActionModalController);

  /** @ngInject */
  function adpDefaultActionModalController() {
    var vm = this;

    vm.$onInit = function () {
      vm.itemData = vm.resolve.options.itemData;
    };

    vm.close = function () {
      vm.dismiss({$value: 'cancel'});
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .component('adpRecordDetailsModal', {
      templateUrl: 'app/adp-generator/directives/adp-record-details-modal/adp-record-details-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpRecordDetailsModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpRecordDetailsModalController', AdpRecordDetailsModalController);

  /** @ngInject */
  function AdpRecordDetailsModalController($scope) {
    var vm = this;

    vm.$onInit = function () {
      vm.schema = vm.resolve.options.schema;
      vm.data = vm.resolve.options.data;
    };

    vm.close = function () {
      vm.dismiss({$value: 'cancel'});
    };

    $scope.$on('$destroy', () => {
      $('body').removeClass('adp-form-fullscreen');
    })
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .component('adpRecordFormModal', {
      templateUrl: 'app/adp-generator/directives/adp-record-form-modal/adp-record-form-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: 'AdpRecordModalController',
      controllerAs: 'vm'
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpGenerator')
    .controller('AdpRecordModalController', AdpRecordModalController);

  /** @ngInject */
  function AdpRecordModalController(ACTIONS, AdpSchemaService) {
    var vm = this;

    vm.$onInit = function () {
      const formOptions = _.get(vm, 'resolve.options.formOptions', {});
      vm.args = vm.resolve.options.args;
      vm.formOptions = _.assign(formOptions, {
        schemaActionsStrategy: {
          onComplete: function (args, data) {
            return vm.close({ $value: { args: args, data: data }});
          },
          onCancel: function () {
            vm.close();
          },
        },
      });

      const { formHeaderText } = formOptions;

      if (formHeaderText) {
        vm.formHeaderText = formHeaderText;
      } else {
        const formName = AdpSchemaService.getSingularForm(vm.args.fieldSchema.fullName);
        const headerText = selectHeaderText(vm.args.action);
        vm.formHeaderText = `${ headerText } "${ formName }"`;
      }

      function selectHeaderText(action) {
        var actionName = action.replace('cell-editing-', '');
        var texts = {};
        texts[ACTIONS.CREATE] = 'Add';
        texts[ACTIONS.CLONE] = 'Add';
        texts[ACTIONS.CLONE_DATASET] = 'Add';
        texts[ACTIONS.UPDATE] = 'Update';

        return texts[actionName];
      }
    };
  }
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .directive('adpAudioRecorder', AdpAudioRecorder);

  function AdpAudioRecorder(
    AdpAudioRecorderOptions,
    AdpAudioTypesService,
    AdpRecorderFactory
  ) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        resultFile: '=',
        player: '=?'
      },
      templateUrl: 'app/adp-recorders/directives/adp-audio-recorder/adp-audio-recorder.template.html',

      link: function ($scope, $element) {
        AdpRecorderFactory.mix($scope, $element, 'audio').then(
          () => {

            $scope.engines = AdpAudioTypesService.getSupportedTypesNames();
            $scope.currentEngine = $scope.engines[0];
            $scope.typesMap = AdpAudioTypesService.getSupportedTypes();

            $scope.init(AdpAudioRecorderOptions);

            $scope.setEngine = function () {
              $scope.options = _.merge($scope.options, $scope.typesMap[$scope.currentEngine]);
              $scope.reInit();
            };
          });
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .directive('adpPhotoRecorder', adpPhotoRecorder);

  function adpPhotoRecorder(
    AdpPhotoRecorderOptions,
    AdpRecorderFactory
  ) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        resultFile: '=',
        player: '=?'
      },
      templateUrl: 'app/adp-recorders/directives/adp-photo-recorder/adp-photo-recorder.template.html',
      link: function ($scope, $element) {
        AdpRecorderFactory.mix($scope, $element, 'image').then(
          () => {

            var options = AdpPhotoRecorderOptions.options;
            var isVertical = $(window).width() < $(window).height();
            var bigSide = AdpPhotoRecorderOptions.width;
            var smallSide = AdpPhotoRecorderOptions.height;
            var width = isVertical ? smallSide : bigSide;
            var height = isVertical ? bigSide : smallSide;

            options.width = width;
            options.height = height;
            options.aspectRatio = width + ":" + height;

            $scope.init(options);
          });
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpRecorders')
    .directive('adpVideoRecorder', adpVideoRecorder);

  function adpVideoRecorder(
    AdpVideoRecorderOptions,
    AdpBrowserService,
    AdpRecorderFactory
  ) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        resultFile: '=',
        player: '=?'
      },
      templateUrl: 'app/adp-recorders/directives/adp-video-recorder/adp-video-recorder.template.html',

      link: function ($scope, $element) {
        AdpRecorderFactory.mix($scope, $element, 'video').then(
          () => {
            // override factory method
            $scope.setup = function () {
              $scope.options = _.merge($scope.DEFAULTS, $scope.options);
              $scope.options.plugins.record.videoMimeType = AdpBrowserService.isChrome() ?
                'video/webm;codecs=H264' :
                'video/mp4'
            };

            $scope.init(AdpVideoRecorderOptions);
          }
        );
      }
    }
  }
})();
;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-activities-dropdown/adp-activities-dropdown.template.html',
    bindings: {
      projects: '<'
    },
    controllerAs: 'vm',
    controller: Controller
  };

  function Controller(ActivityMockService){
    var vm = this;

    vm.activeTab = 'default';
    vm.currentActivityItems = [];

    // MOCKS
    ActivityMockService.get()
      .then(function (response) {
        vm.activities = response.data.activities;
      });

    vm.isActive = function(tab){
      return vm.activeTab === tab;
    };

    vm.setTab = function(activityType){
      vm.activeTab = activityType;

      ActivityMockService.getByType(activityType)
        .then(function (response) {
          vm.currentActivityItems = response.data.data;
        });
    };
  }


  angular.module('app.adpUi')
    .component('adpActivitiesDropdown', componentDefinition);
})();;;(function () {
  'use strict';

  angular.module('app.adpUi')
    .factory('ActivityMockService', ActivityMockService);

  function ActivityMockService($http) {
    return {
      get: get,
      getByType: getByType
    };

    // METHODS
    function get() {
      return $http.get('/api/activities/activity.json');
    }

    function getByType(type) {
      return $http.get('/api/activities/activity-' + type + '.json');
    }
  }
})();;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-content-container/adp-content-container.template.html',
    bindings: {
      loading: '<'
    },
    transclude: true
  };

  angular.module('app.adpUi')
    .component('adpContentContainer', componentDefinition);
})();;;(function () {
  'use strict';

  angular.module('app.adpUi')
    .factory('AdpLanguageMockService', AdpLanguageMockService);

  function AdpLanguageMockService($http, APP_CONFIG) {
    return {
      getAll: getAll,
      getByType: getByType
    };

    // METHODS.en
    function getByType(type) {
      return $http.get(getUrl() + '/langs/' + type + '.json');
    }

    function getAll() {
      return $http.get(getUrl() + '/languages.json')
    }

    function getUrl() {
      var smartAdminApiRoot = '/api'
      return APP_CONFIG.appSuffix + smartAdminApiRoot;
    }
  }
})();
;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-language-selector/adp-language-selector.template.html',
    controllerAs: 'vm',
    controller: Controller
  };

  /** @ngInject */
  function Controller($rootScope, AdpLanguageMockService, APP_CONFIG){
    var vm = this;

    // TODO: don't use it, please. Rewrite with ng-translate
    $rootScope.lang = {};
    vm.baseUrl = APP_CONFIG.appSuffix;

    AdpLanguageMockService.getAll()
      .then(function(response){
        $rootScope.currentLanguage = response.data[0];
        $rootScope.languages = response.data;

        return AdpLanguageMockService.getByType($rootScope.currentLanguage.key);
      })
      .then(function (response) {
        $rootScope.lang = response.data;
      });

    vm.selectLanguage = function(language){
      $rootScope.currentLanguage = language;

      AdpLanguageMockService.getByType(language.key)
        .then(function (response) {
          $rootScope.lang = response.data;
        });
    };

    $rootScope.getWord = function(key){
      if(angular.isDefined($rootScope.lang[key])){
        return $rootScope.lang[key];
      }
      else {
        return key;
      }
    }
  }


  angular.module('app.adpUi')
    .component('adpLanguageSelector', componentDefinition);
})();
;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-page-description/adp-page-description.template.html',
    bindings: {
      schema: '<'
    },
    controller: Controller
  };

  /** @ngInject */
  function Controller($sce, APP_CONFIG, $rootScope) {
    var vm = this;
    vm.isEmpty = true;

    vm.$onInit = function () {
      var converter = new showdown.Converter();

      vm.isEmpty = !vm.schema.description;

      if (vm.isEmpty) {
        return;
      }

      var html = ejs.render(vm.schema.description, {
        APP_CONFIG: APP_CONFIG,
        REQUEST: $rootScope.lastApiRequest || {}
      });
      var md = converter.makeHtml(html);

      vm.description = $sce.trustAsHtml(md);
    }
  }

  angular.module('app.adpUi')
    .component('adpPageDescription', componentDefinition);
})();
;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-page-title/adp-page-title.template.html',
    bindings: {
      loading: '<',
      pageTitle: '@'
    },
    transclude: true,
  };

  angular.module('app.adpUi')
    .component('adpPageTitle', componentDefinition);
})();
;;(function () {
  'use strict';

  angular.module('app.adpUi')
    .factory('AdpProjectMockService', AdpProjectMockService);

  function AdpProjectMockService($http) {
    return {
      list: $http.get.bind(this, '/api/projects.json')
    }
  }
})();;;(function () {
  'use strict';

  var componentDefinition = {
    bindings: {
      projects: '<'
    },
    controllerAs: 'vm',
    templateUrl: 'app/adp-ui/components/adp-recent-projects/adp-recent-projects.template.html',
    controller: Controller
  };

  /** @ngInject */
  function Controller(AdpProjectMockService) {
    var vm = this;

    // MOCKS
    AdpProjectMockService.list()
      .then(function(response){
        vm.projects = response.data;
      });

    vm.clearProjects = function() {
      vm.projects = [];
    }
  }


  angular.module('app.adpUi')
    .component('adpRecentProjects', componentDefinition);
})();

;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-section-container/adp-section-container.template.html',
    transclude: true
  };

  angular.module('app.adpUi')
    .component('adpSectionContainer', componentDefinition);
})();;;(function () {
  'use strict';

  var componentDefinition = {
    templateUrl: 'app/adp-ui/components/adp-section-title/adp-section-title.template.html',
    bindings: {
      loading: '<'
    },
    transclude: true
  };

  angular.module('app.adpUi')
    .component('adpSectionTitle', componentDefinition);
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .directive('adpBreadcrumbs', adpBreadcrumbs);

  function adpBreadcrumbs(
    $transitions,
    $rootScope,
    $state
  ) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/adp-ui/directives/adp-breadcrumbs/adp-breadcrumbs.template.html',
      link: function (scope) {
        var flattenMenu = flattenMenuItems($rootScope.menu);

        function init() {
            scope.breadcrumbs = getBreadcrumbs($state.current);
            $transitions.onStart(null, onStateChangeStart);
        }
        init();

        function onStateChangeStart(transition) {
          var toState = transition.to();
          if (!lsService.getUser()) return;

          scope.breadcrumbs = getBreadcrumbs(toState);
        }

        function flattenMenuItems(menuItems, resultItems) {
          var result = resultItems || [];

          if (_.isArray(menuItems)) {
            menuItems.forEach(function (item) {
              result.push(item);

              if (item.items) {
                flattenMenuItems(item.items, result);
              }
            });
          }

          return result;
        }

        function getState(stateName, menuItem) {
          var state = $state.get(stateName);
          var user = lsService.getUser() || {};
          var breadcrumb = {
            content: menuItem.title ? menuItem.title : menuItem,
            stateName: menuItem.stateName
          };

          if (state) {
            breadcrumb.href = $state.href(state.name, user)
          }

          return breadcrumb;
        }

        function getBreadcrumbs(state) {
          var breadcrumbs = [];
          var currentMenuItem = _.find(flattenMenu, { stateName: state.name });
          var currentState;

          while (currentMenuItem) {
            currentState = getState(currentMenuItem.stateName, currentMenuItem);
            breadcrumbs.unshift(currentState);
            currentMenuItem = currentMenuItem.parent;
          }

          return breadcrumbs;
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .directive('adpChart', adpChart);

  /** @ngInject */
  function adpChart(
    AdpChartService,
    $compile,
    $q
  ) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        data: '=',
      },
      transclude: true,
      replace: true,
      link: function (scope, element) {
        var INTERFACE = window.adpAppStore.appInterface();
        var chartDefinition = INTERFACE.charts[scope.item.parameters.chartId];
        scope.chartOptions = chartDefinition.specification;

        var requestParams = chartDefinition.data;
        var type = chartDefinition.subtype.toLowerCase();

        var initPromise = requestParams ?
          AdpChartService.fetchData(requestParams) :
          $q.when(scope.data);

        scope.loading = true;
        initPromise
          .then(function (data) {
            scope.chartData = data;
            scope.loading = false;
          });

        var template = [
          '<adp-chart-' + type,
            ' ng-if=!loading',
            ' options=chartOptions',
            ' data=chartData',
          '>',
          '</adp-chart-' + type + '>',
        ].join('');

        element.replaceWith($compile(template)(scope));
      }
    };
  }
})();
;;(function() {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .directive('adpClipboardButton', function ($timeout) {
      return {
        restrict: 'E',
        templateUrl: 'app/adp-ui/directives/adp-clipboard-button/adp-clipboard-button.template.html',
        scope: false,
        link: function (scope, element) {
          var tooltipCmp;
          scope.showClipboardBtn = ['Code', 'Html', 'Mixed', 'Text'].includes(scope.args.fieldSchema.type);

          if (!scope.showClipboardBtn) {
            return;
          }

          $timeout(function init() {
            scope.menuOptions = {
              cssClass: 'adp-clipboard-btn',
              dataSource: getDataSource(scope.args.fieldSchema.type),
              onItemClick: function(e) {
                var data = e.itemData;

                if (!data.clickable) {
                  return;
                }

                copyToClipboard(data)
                  .then(showTooltip)
                  .catch(function (err) {
                    console.error('Error while writing to clipboard: ', err);
                  });
              },
            };

            scope.tooltipOptions = {
              target: element.find('[dx-menu]'),
              position: 'top',
              onInitialized: function (e) {
                tooltipCmp = e.component;
              }
            };
          });

          function copyToClipboard(data) {
            var itemContents = {};
            var dataToCopy = getClipboardData(data.stripHtml);
            itemContents[data.mime] = new Blob([dataToCopy], { type: data.mime });

            var ClipboardAPI = window.clipboard;
            var copyItem = new ClipboardAPI.ClipboardItem(itemContents);

            return ClipboardAPI.write([copyItem]);
          }

          function getClipboardData(stripHtml) {
            var result = _.get(scope, 'args.data');
            if (!result) {
              return '';
            }

            if (_.get(scope, 'args.fieldSchema.type') === 'Mixed') {
              return getMixedTypeData(result);
            }

            if (stripHtml) {
              return stripHtmlString(result);
            }

            return result;
          }

          function getMixedTypeData(rawData) {
            var isJsonSelected = isJsonTabSelected();

            if (_.isObject(rawData)) {
              return isJsonSelected ?
                JSON.stringify(rawData, null, 2) :
                window.jsyaml.safeDump(rawData, { skipInvalid: true });
            }

            return rawData;
          }

          function isJsonTabSelected() {
            // previously hardcoded, bind to viewDetails only, later added option to pass selector (used in viewRawData action)
            var selector = _.get(scope.args, 'customData.dataTypeTabSelector', [
              '.' + scope.args.modelSchema.schemaName,
              '.name-' + scope.args.fieldSchema.fieldName,
              '.dx-tab-selected .dx-tab-text',
            ].join(' '));

            return $(document).find(selector).text() === 'JSON';
          }

          function showTooltip() {
            tooltipCmp.show()
              .then(function () {
                tooltipCmp.hide();
              });
          }

          function stripHtmlString(data) {
            var el = '<div>' + data.trim() + '</div>';
            return $(el).text();
          }

          function getDataSource(type) {
            if (type === 'Html') {
              return [{
                icon: 'fa fa-clipboard',
                items: [{
                  text: 'Copy HTML Markup',
                  mime: 'text/plain',
                  clickable: true,
                }, {
                  text: 'Copy as Plain Text',
                  stripHtml: true,
                  mime: 'text/plain',
                  clickable: true,
                }, {
                  text: 'Copy as Rich Text',
                  mime: 'text/html',
                  clickable: true,
                }]
              }]
            }

            return [{
              icon: 'fa fa-clipboard',
              clickable: true,
              mime: 'text/plain',
            }];
          }
        }
      }
    });

})();
;;(function () {
  'use strict';

  angular.module('app')
    .directive('adpFullscreenButton', adpFullscreenButton);

  function adpFullscreenButton() {
    return {
      restrict: 'E',
      templateUrl: 'app/adp-ui/directives/adp-fullscreen/adp-fullscreen-button.html',
      link(scope) {
        scope.toggleFullScreen = () => {
          $('body').toggleClass('adp-form-fullscreen');
        };
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular.module('app')
    .directive('adpFullscreen', adpFullscreen);

  function adpFullscreen(AdpFullscreenService) {
    return {
      restrict: 'EA',
      link: function (scope, element) {
        AdpFullscreenService.registerFullScreenElement(element[0]);

        scope.$on('$destroy', function () {
          AdpFullscreenService.unregisterFullScreenElement(element[0]);
        });
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .value('jarvisWidgetsDefaults', {
      grid: '.jarviswidget-grid',
      widgets: '.jarviswidget',
      localStorage: false,
      toggleButton: true,
      toggleClass: 'fa fa-plus | fa fa-minus',
      toggleSpeed: 200,
      deleteButton: false,
      editButton: false,
      colorButton: false,
      fullscreenButton: false,
      customButton: false
    });
})();;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .directive('adpJarvisWidgets', adpJarvisWidgets);

  function adpJarvisWidgets($timeout, jarvisWidgetsDefaults) {
    return {
      restrict: 'EA',
      template: '<div ng-transclude class="adp-jarwidget-grid jarviswidget-grid clearfix"></div>',
      transclude: true,
      link: function (scope, element) {
        function init() {
          var options = _.defaults(jarvisWidgetsDefaults, {});

          $timeout(function () {
            element.jarvisWidgets(options);
          }, 0);
        }

        scope.$watch(
          function () {
            var items = element[0].querySelectorAll('.adp-form-fieldset');
            return items.length;
          },
          function (newValue, oldValue) {
            if (newValue !== oldValue) {
              init();
            }
          }
        );
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app')
    .directive('adpMainMenu', adpMainMenu);

  function adpMainMenu(
    AdpBrowserService,
    AdpStateGenerator,
    AdpUnifiedArgs,
    AdpIconsHelper,
    AdpMenuService,
    $rootScope,
  ) {
    return {
      restrict: 'A',
      replace: true,
      link(scope, element) {
        const INTERFACE = window.adpAppStore.appInterface();
        const layoutConfig = INTERFACE.layout;
        const {menuPosition, hideRootMenuLabels, hideRootMenuIcons} = layoutConfig;
        const isMobile = AdpBrowserService.isMobile();
        const orientation = menuPosition === 'top' || isMobile ? 'horizontal' : 'vertical';
        let menuWatcherUnreg;
        let avatarWatcherUnreg;

        initMenu();

        function initMenu() {
          element.dxMenu({
            hideSubmenuOnMouseLeave: true,
            showFirstSubmenuMode: 'onHover',
            displayExpr: 'fullName',
            orientation,
            elementAttr: {
              class: "adp-main-menu"
            },
            adaptivityEnabled: true,
            itemTemplate,
            onItemClick,
            onInitialized,
          })
          scope.$on('$destroy', () => {
            $(element).dxMenu("dispose");
            menuWatcherUnreg && menuWatcherUnreg();
            avatarWatcherUnreg && avatarWatcherUnreg();
          })
        }

        function onInitialized() {
          const debouncedAssigner = _.debounce(assignMenu, 250)
          // ToDo: theoretically menu may be set before initialization, so we need to implement kind of caching prior initialization...
          menuWatcherUnreg = $rootScope.$watch('menu', debouncedAssigner);
          avatarWatcherUnreg = $rootScope.$watch('avatar.id', ()=>AdpMenuService.generateMenu());
        }

        function itemTemplate(item, index, element) {
          const {type: itemType, items: subItems, activeState, cssClass} = item;
          const classNames = [
            'adp-main-menu-item',
            cssClass || '',
            activeState ? `adp-main-menu-item-${ activeState }` : ``,
          ];
          // We attach class to item root <li> tag for better control over appearance
          element.parent().parent().addClass(_.compact(classNames));
          if (item.level === 0) {
            element.addClass('adp-level0');
          }
          element.attr('title', item.description || item.fullName || '');
          if (itemType === 'MenuSeparator') {
            element.append('<div class="menu-item-separator-body">').addClass('menu-item-separator');
            return;
          } else if (itemType === 'MenuItem') {
            element.attr({
              'data-state-name': item.link && AdpStateGenerator.linkToState(item.link)
            });
          } else {
            const className = _.get(item, 'htmlAttributes.className');
            if (className) {
              // ToDo: make sure space-separated classes list is also supported
              element.addClass(className);
            }
          }

          const itemIsNotInteractive = !item.link && !item.action;
          if (itemIsNotInteractive) {
            element.closest('.dx-menu-item').addClass('non-interactive');
          }

          let itemBody;
          const isItemCustomRendered = !_.isUndefined(item.render) && item.render.renderTarget !== 'submenu';
          if (isItemCustomRendered) {
            const menuActionFn = _.get(appModelHelpers, 'MenuRenderers.' + item.render.link);

            if (_.isFunction(menuActionFn)) {
              const unifiedParams = AdpUnifiedArgs.getHelperParamsWithConfig({
                path: item.currentPath,
                formData: null,
                schema: item,
              });
              const fnResult = menuActionFn.call(Object.assign({}, unifiedParams, {action: 'menuRender'}));
              if (fnResult.then) {
                itemBody = $('<span/>');
                fnResult.then((body) => itemBody.append(body))
                  .catch(e => {
                    itemBody.text = e.message || e;
                  })
              } else {
                itemBody = fnResult;
              }
            }
          }

          const isCustomRendered = !!itemBody;
          const {link, target, href, uiSref} = item;
          const a = !link && isCustomRendered ? $('<span />') : $('<a />');
          if (link) {
            if (uiSref) {
              a.attr('href', href);
              a.attr('ui-sref', uiSref);
            } else {
              a.attr('href', link);
              a.attr('target', target || '_self');
            }
          }

          const hideRootIcon = (hideRootMenuIcons && item.level === 0);
          if (item.icon && !hideRootIcon) {
            const i = AdpIconsHelper.getIconHtml(item.icon);
            a.append(i);
          }

          const hideLabel = (hideRootMenuLabels && item.level === 0);
          itemBody = itemBody || (!hideLabel && item.fullName) || '';

          if (itemBody) {
            a.append(
              $('<span>')
                .addClass(isCustomRendered ? "menu-item-body-custom" : "menu-item-body")
                .append(itemBody)
            );
          }

          if (!_.isEmpty(subItems)) {
            a.append('<b class="collapse-sign"><em class="fa collapse-icon"></em></b>');
          }

          element.append(a);
        }

        function onItemClick(data) {
          const item = data.itemData;

          if (item.action) {
            const menuActionFn = _.get(appModelHelpers, 'MenuActions.' + item.action.link);

            if (_.isFunction(menuActionFn)) {
              const unifiedParams = AdpUnifiedArgs.getHelperParamsWithConfig({
                path: item.currentPath,
                formData: null,
                schema: item,
              });
              const actionFnParams = Object.assign({}, unifiedParams, {action: 'menuClick'});
              menuActionFn.call(actionFnParams);
            }
          }
        }

        function assignMenu(dataSource) {
          element.dxMenu('option', 'dataSource', dataSource || []);
        }
      },
      scope: {
        adpMainMenu: '=',
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app')
    .directive('adpMobilePageTitle', adpMobilePageTitle);

  function adpMobilePageTitle($state) {
    return {
      restrict: 'A',
      replace: true,
      scope: {},
      link(scope, element) {
        scope.$watch(() => $state.$current, (newVal) => {
          const title = _.get(newVal, 'data.title');
          element.text(title);
        })
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular.module('app.adpUi')
    .directive('adpPageLoader', adpPageLoader);

  function adpPageLoader() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/adp-ui/directives/adp-page-loader/adp-page-loader.template.html',
      scope: {
        loading: '<',
        style: '@'
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .directive('adpTooltip', adpTooltip);

  function adpTooltip($timeout) {
    return {
      restrict: 'E',
      scope: false,
      replace: true,
      templateUrl: 'app/adp-ui/directives/adp-tooltip/adp-tooltip.template.html',
      link: function (scope, element) {
        const adpField = scope.tooltipField || scope.args.fieldSchema;
        $timeout(function () {
          scope.hasDescription = !_.isUndefined(adpField.description);
          if (!scope.hasDescription) {
            return;
          }

          scope.tooltipOptions = {
            target: element.find('.adp-tooltip-trigger'),
            position: 'right',
            showEvent: 'click',
            maxWidth: '400px',
            contentTemplate(data) {
              data.html(adpField.description);
            },
          };
        });
      }
    }
  }
})();
;;(function () {
  "use strict";

  angular.module('app.adpUi')
    .directive('adpDatepicker', adpDatepicker);

  function adpDatepicker($timeout) {
    return {
      restrict: 'A',
      scope: {
        options: '='
      },
      link: function (scope, element, attributes) {

        var onSelectCallbacks = [];
        if (attributes.minRestrict) {
          onSelectCallbacks.push(function (selectedDate) {
            $(attributes.minRestrict).datepicker('option', 'minDate', selectedDate);
          });
        }
        if (attributes.maxRestrict) {
          onSelectCallbacks.push(function (selectedDate) {
            $(attributes.maxRestrict).datepicker('option', 'maxDate', selectedDate);
          });
        }

        //Let others know about changes to the data field
        onSelectCallbacks.push(function (selectedDate) {
          //CVB - 07/14/2015 - Update the scope with the selected value
          element.triggerHandler("change");

          //CVB - 07/17/2015 - Update Bootstrap Validator
          var form = element.closest('form');

          if (typeof form.bootstrapValidator == 'function') {
            form.bootstrapValidator('revalidateField', element.attr('name'));
          }
        });

        var options = _.extend({
          prevText: '<i class="fa fa-chevron-left"></i>',
          nextText: '<i class="fa fa-chevron-right"></i>',
          // FIXME: disabled boostrap valdation
          // onSelect: function (selectedDate) {
          //   angular.forEach(onSelectCallbacks, function (callback) {
          //     callback.call(this, selectedDate)
          //   })
          // }
        }, scope.options || {});


        if (attributes.numberOfMonths) options.numberOfMonths = parseInt(attributes.numberOfMonths);

        if (attributes.dateFormat) options.dateFormat = attributes.dateFormat;

        if (attributes.defaultDate) options.defaultDate = attributes.defaultDate;

        if (attributes.changeMonth) options.changeMonth = attributes.changeMonth == "true";

        // FIXME
        $timeout(function () {
          var $el = element.datepicker(options);

          if (scope.options.showOn === 'button') {
            $el.next('button')
              .button({
                icons: {
                  primary: 'fa-calendar'
                },
                text: true
              });
          }
        });
      }
    }
  }
})();;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionFields', GraphqlCollectionFields);

  /** @ngInject */
  function GraphqlCollectionFields(
    GraphqlTreeSelectorField,
    GraphqlLookupField,
    GraphqlLocationField,
    GraphqlIconField,
    GraphqlHelper
  ) {
    return {
      get: get
    };

    function get(schema, defaultItemsName) {
      var schemaForQuery = _.cloneDeep(schema);
      if (schema.schemaName !== 'datasetSingle') {
        addIdAndPermissionFields(schemaForQuery);
      }

      return fieldsForQuery(schemaForQuery, defaultItemsName);
    }

    function addIdAndPermissionFields(schema) {
      if (schema.schemaName !== 'backgroundJobs') {
        schema.fields['_id'] = { type: 'id', showInGraphql: true };
      }

      schema.fields['_actions'] = { type: '_actions', showInGraphql: true };
    }

    function fieldsForQuery(field, _name) {
      const name = _name || 'items';

      if (field.type !== 'Schema' && !field.showInGraphql) {
        return null;
      }
      if (hasChildren(field)) {
        return iteratee(field, name);
      }
      if (isLookup(field)) {
        return GraphqlLookupField.get(field, name);
      }
      if (isTreeSelector(field)) {
        return GraphqlTreeSelectorField.get(field, name);
      }
      if (isLocation(field)) {
        return GraphqlLocationField.get(field, name);
      }
      if (isIcon(field)) {
        return GraphqlIconField.get(field, name);
      }
      return getFieldForQuery(field, name);
    }

    function iteratee(field, name) {
      const fields = _.chain(field.fields)
        .map(fieldsForQuery)
        .compact()
        .value();

      const isArrayType = ['Array', 'AssociativeArray'].includes(field.type);
      if (fields.length && isArrayType) {
        fields.unshift('_id');
      }

      const fieldsString = fields.join('\n');

      return GraphqlHelper.wrapFieldString(fieldsString, name);
    }

    function getFieldForQuery(field, name) {
      if (field.type === 'Group' || !field.showInGraphql) {
        return null;
      }

      return name;
    }

    function hasChildren(field) {
      return field.type === 'Object' || field.type === 'Array' || field.type === 'Schema';
    }

    function isLookup(field) {
      return field.type.includes('LookupObjectID');
    }

    function isTreeSelector(field) {
      return field.type.includes('TreeSelector');
    }

    function isLocation(field) {
      return field.type === 'Location';
    }

    function isIcon(field) {
      return field.type === 'Icon';
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlHelper', GraphqlHelper);

  /** @ngInject */
  function GraphqlHelper(AdpTime) {
    function wrapFieldString(fieldsString, name) {
      return [
        name,
        '{',
        fieldsString,
        '}',
      ].join('\n');
    }

    function collectionQueryName(schema, params) {
      return schema.schemaName + 'Dx' + (params.group ? 'Group' : '');
    }

    var typeProcessors = {
      mongoExpression: function (filter) {
        return {type: 'Mongo Expression', expression: filter[2].value}
      },
      relativeDate: function (filter) {
        return {
          type: 'Relative Date',
          expression: {
            fieldPath: filter[0],
            operation: filter[1],
            value: filter[2].value,
            timezone: AdpTime.guessTimeZone(),
          }
        };
      },
      databaseField: function (filter) {
        return {type: 'Database Field', expression: [filter[0], filter[1], filter[2].value]}
      },
      default: function (filter) {
        return [filter[0], filter[1], filter[2].value];
      },
    }

    function processCustomTypedValues(schema, filter) {
      if (!filter || _.isString(filter)) {
        return filter;
      }

      if (filter[0] === '!') {
        return ['!', processCustomTypedValues(schema, filter[1])];
      } else if (_.isString(filter[0])) {
        var value = filter[2];

        if (_.isObject(value) && value.type) {
          return processValueByType(schema, filter, value.type);
        } else {
          return filter;
        }
      } else {
        return _.map(filter, function (x) {
          return processCustomTypedValues(schema, x);
        })
      }
    }

    function processValueByType(schema, filter, type) {
      var typeProcessor = typeProcessors[type];

      return typeProcessor ? typeProcessor(filter, schema) : filter;
    }

    function combineFilters(schema, filter, buildFilter) {
      if (buildFilter && buildFilter.length) {
        buildFilter = processCustomTypedValues(schema, buildFilter);
        return filter ? [filter, 'and', buildFilter] : buildFilter;
      } else {
        return filter;
      }
    }

    return {
      wrapFieldString: wrapFieldString,
      collectionQueryName: collectionQueryName,
      combineFilters: combineFilters,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlRequest', GraphqlRequest);

  /** @ngInject */
  function GraphqlRequest(
    ServerError,
    APP_CONFIG,
    AdpUserActivityHelper,
    $http
  ) {
    function endpoint() {
      return [APP_CONFIG.apiUrl, 'graphql'].join('/')
    }

    return function (requestParams) {
      var body = {
        query: requestParams.query,
        variables: requestParams.variables,
      };

      return $http.post(endpoint(), body)
        .then(function (res) {
          var resData = _.get(res.data, 'data.' + requestParams.name);
          if (!_.isNil(resData) && hasGraphqlError(res)) {
            warnErrors(res, requestParams.name);
            return resData;
          }

          if (hasGraphqlError(res)) {
           throwIfErrors(res);
          }

          AdpUserActivityHelper.resetUserActivityTimer();

          var dataField = _.get(res, 'data.data');
          var name = _.keys(dataField)[0];
          return dataField[name];
        })
        .catch(function (err) {
          if (hasGraphqlError(err)) {
            throwIfErrors(err);
          }

          throw err;
        });
    }

    function throwIfErrors(res) {
      var errorsMessages = res.data.errors.map(function (err) {
        return err.message;
      });

      throw new ServerError(errorsMessages);
    }

    function warnErrors(res) {
      var errorsMessages = res.data.errors.map(function (err) {
        return err.message;
      }).join('\n');

      console.error('Server Error: ' + errorsMessages);
    }

    function hasGraphqlError(res) {
      return _.hasIn(res, 'data.errors');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlMultipleSchemasQuery', GraphqlMultipleSchemasQuery);

  /** @ngInject */
  function GraphqlMultipleSchemasQuery(
    GraphqlCollectionQueryWithMongoFilter,
    AdpUnifiedArgs,
    $q
  ) {
    return function (tableDefinitions, params) {
      var params = params || {};
      var promises = _.map(tableDefinitions, function (table, name) {
        return requestSingleCollectionData(table, name, params);
      });

      return $q.all(promises)
        .then(function (results) {
          return results.reduce(function (acc, item) {
            acc[item[0]] = item[1];
            return acc;
          }, {});
        })
    };

    function requestSingleCollectionData(table, name, params) {
      var requestSchema = getRequestSchema(table, name);
      var requestParams = _.assign({}, params, {
        mongoQuery: evalWhereCondition({
          schema: requestSchema,
          row: params.row,
          action: params.action,
          condition: table.where,
        }),
      });

      return GraphqlCollectionQueryWithMongoFilter(requestSchema, requestParams)
        .then(function (result) {
          return [name, result.items];
        });
    }

    function getRequestSchema(table, name) {
      var APP_MODEL = window.adpAppStore.appModel();
      var schema = APP_MODEL[name];
      return _.clone(schema);
    }

    function evalWhereCondition(params) {
      var args = AdpUnifiedArgs.getHelperParamsWithConfig({
        path: '',
        action: params.action,
        formData: params.row,
        schema: params.schema,
      });

      var evaluatedCondition;
      try {
        evaluatedCondition = new Function('return ' + params.condition).call(args);
      } catch (e) {
        console.error('Error while trying to evaluate condition "' + params.condition + '": ', e);
        evaluatedCondition = {};
      }
      return JSON.stringify(evaluatedCondition);
    }
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpApi")
    .factory("CustomFilterTypesValidatorService", CustomFilterTypesValidatorService);

  /** @ngInject */
  function CustomFilterTypesValidatorService(
    GraphqlRequest, AdpTime
  ) {
    var queryTypes = {
      "Mongo Expression": MongoExpression,
      "Relative Date": RelativeDate,
      "Database Field": DatabaseField,
    }
    var filterValidatorDebounced = _.debounce(filterValidator, 1000);
    var promiseCache = new CachedPromiseHelper();

    return function (modelName, filterType, filterValue, validationRule) {
      var callback = function (isValid, message) {
        validationRule.message = message;

        promiseCache.resolveAndRefresh(isValid);
      }

      filterValidatorDebounced(modelName, filterType, filterValue, callback);

      return promiseCache.getPromise();
    }

    function CachedPromiseHelper() {
      this.resolveAndRefresh = function (result) {
        var self = this;

        this.resolverFunction && this.resolverFunction(result);

        this.cachedPromise = new Promise(function (resolve) {
          self.resolverFunction = resolve;
        });
      }

      this.getPromise = function () {
        return this.cachedPromise;
      }

      this.resolverFunction = null;

      this.resolveAndRefresh();
    }

    function filterValidator(modelName, filterType, filterValue, cb) {
      var query = getQuery();
      var expressionGetter = getExpressionBuilder(filterType);
      var request;

      if (!expressionGetter) {
        cb(false, "Unsupported query type");
      } else {
        var variables = {expression: expressionGetter(filterValue), modelName: modelName};
        request = validationQuery(query, variables)
      }

      request.then(function (data) {
        cb(data.isValidFilter, data.errors);
      })
    }

    function validationQuery(query, variables) {
      return GraphqlRequest({
        name: "validateFilter",
        query: query,
        variables: variables,
      });
    }

    function getExpressionBuilder(filterType) {
      var queryGenerator = queryTypes[filterType];

      if (!queryGenerator) {
        return null;
      }

      return queryGenerator;
    }

    function getQuery() {
      return [
        "query",
        "q($expression:String!, $modelName:String!)",
        "{",
        "validateFilter(",
        "filter: {dxQuery: $expression},",
        "modelName: $modelName",
        ")",
        "{isValidFilter errors}",
        "}"
      ].join(" ");
    }

    function MongoExpression(filterValue) {
      return filterValue ? "{ type: 'Mongo Expression', expression: " + filterValue + "}" : "";
    }

    function RelativeDate(filterValue) {
      return "{type:'Relative Date', expression:{fieldPath:'" + filterValue[0]
        +"',operation:'" + filterValue[1] + "',value:'" + filterValue[2] + "',timezone:'" + AdpTime.guessTimeZone() + "'}}";

      //['date', '=', '2 day ago']
      //{ type: "Relative Date", expression: { fieldPath: "date", operation: "=", value: "1 day ago", timezone: "Europe/Moscow" } }
    }

    function DatabaseField(filterValue) {
      return "{ type: 'Database Field', expression: " + JSON.stringify(filterValue) + " }";
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('AdpLookupHelpers', AdpLookupHelpers);

  function AdpLookupHelpers() {
    function lookupItemTemplate(data, args) {
      var container = $('<div class="adp-lookup-drop-down-item">');
      container.append(createLabel(data, args));

      return container;
    }

    function createLabel(lookupData, args) {
      var labelHtml = [
        '<div ',
        'class="adp-lookup-item-label"',
        'adp-qaid-control-dropdown-item="' + args.path + '"',
        '>'
      ].join(' ');

      return $(labelHtml).append(formatLabel(lookupData, args));
    }

    function formatLabel(lookupData, args) {
      var labelFromExpr = evalLabelExpr(lookupData, args);
      return labelFromExpr || lookupData.label;
    }

    function selectionLabel(lookupData, args) {
      var label = evalLabelExpr(lookupData, args);
      if (!_.isNull(label)) {
        return label;
      }

      var isMultipleTable = _.keys(args.fieldSchema.lookup.table).length > 1;
      return isMultipleTable ?
        [_.startCase(lookupData.table), lookupData.label].join(' | ') :
        lookupData.label;
    }

    function evalLabelExpr(lookupData, unifiedArgs) {
      var args = _.assign({}, unifiedArgs, { lookup: lookupData });
      var labelRenderer = getLabelRenderFn(args);
      if (_.isNull(labelRenderer)) {
        return null;
      }

      var compatibilityArgs = [args.lookup, args.data, args.row, args.fieldSchema];
      try {
        return labelRenderer.apply(args, compatibilityArgs);
      } catch (e) {
        console.log('Error executing lookup label expression', e);
      }
    }

    function getLabelRenderFn(args) {
      var renderNameOrExpression = _.get(args, 'fieldSchema.lookupLabelRender', null);
      var renderFn = _.get(window, 'appModelHelpers.LookupLabelRenderers.' + renderNameOrExpression, null);

      if (_.isFunction(renderFn)) {
        return renderFn;
      } else if (renderNameOrExpression) {
        return new Function('lookup, fieldData, formData, fieldSchema', 'return ' + renderNameOrExpression);
      } else {
        return null;
      }
    }

    function tablesList(schema) {
      return schema.lookup && schema.lookup.table ? _.keys(schema.lookup.table) : [];
    }

    return {
      selectionLabel: selectionLabel,
      formatLabel: formatLabel,
      lookupItemTemplate: lookupItemTemplate,
      tablesList: tablesList,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('LookupBtns', LookupBtns);

  /** @ngInject */
  function LookupBtns(
    GraphqlCollectionQuery,
    AdpSchemaService,
    ActionsHandlers,
    GraphqlLookupQuery,
    AdpGeneratorModalService
  ) {
    return {
      getFieldButtons: getFieldButtons,
      updateMenuItemButton: updateMenuItemButton,
      updateAction: updateAction,
    }

    function getFieldButtons(opts) {
      const {selectedTableName, args} = opts;
      const schema = AdpSchemaService.getSchemaByName(selectedTableName);
      const buttons = [];
      const isCreatePermitted = !!schema?.actions?.fields?.create;
      const isUpdatePermitted = !!schema?.actions?.fields?.update;
      if (isCreatePermitted) {
        buttons.push({
          name: 'create-record',
          options: {
            icon: 'plus',
            elementAttr: {
              class: 'adp-lookup-button adp-lookup-button-create',
              'lookup-action': 'create',
            },
            onClick() {
              createAction(args, selectedTableName);
            },
          }
        })
      }
      if (isUpdatePermitted) {
        buttons.push({
          name: 'update-record',
          options: {
            icon: 'edit',
            elementAttr: {
              class: 'adp-lookup-button adp-lookup-button-update',
              'lookup-action': 'update',
            },
            onInitialized({component}) {
              const updateVisible = args.fieldSchema.type === 'LookupObjectID' && args.data;
              component.option('visible', updateVisible);
            },
            onClick() {
              const {data} = args;
              updateAction(args, data);
            },
          }
        })
      }
      buttons.push('clear', 'dropDown');

      return buttons;
    }

    function createAction(args, selectedTableName) {
      var schema = AdpSchemaService.getSchemaByName(selectedTableName);
      var lookupInstance = getLookupInstance(args);
      var actionParams = {};

      lookupInstance.close();

      if (args.customData) {
        actionParams.customData = args.customData;
      }

      const loaderId = 'loader-for-form-' + selectedTableName;
        ActionsHandlers.create(schema, {}, actionParams)
        .then((resp) => {
          AdpGeneratorModalService.showLoader(loaderId);
          return getDataSource(args)
            .reload()
            .then(() => resp && resp.data);
        })
        .then((respData) => respData && updateLookupValue(args, { _id: respData._id, table: schema.schemaName }))
        .finally(() => {
          AdpGeneratorModalService.hideLoader(loaderId);
        });
    }

    function updateMenuItemButton(data, args) {
      const button = $('<button type="button" lookup-action="update" lookup-item-button class="btn btn-sm"><i class="fa fa-edit"></i></button>');

      button.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();


        updateAction(args, data);
      });

      return button;
    }

    function updateAction(args, data) {
      const loaderId = 'loader-for-form-' + data.table;

      return updateLookupHandler(args, data)
        .then(() => {
          AdpGeneratorModalService.showLoader(loaderId);

          const lookupInstance = getLookupInstance(args);
          lookupInstance.close();
          getDataSource(args).reload();
        })
        .then(() => {
          if (!inSelectedValue(args, data)) {
            return;
          }

          updateLookupValue(args, data);
        })
        .finally(() => {
          AdpGeneratorModalService.hideLoader(loaderId);
        });
    }

    function updateLookupHandler(args, data) {
      var schema = AdpSchemaService.getSchemaByName(data.table);

      return GraphqlCollectionQuery(schema, { filter: ['_id', '=', data._id] })
        .then(function (records) {
          var actionParams = {};

          if (args.customData) {
            actionParams.customData = args.customData;
          }

          return ActionsHandlers.update(schema, records.items[0], actionParams);
        });
    }

    function getLookupInstance(args) {
      var instanceName = args.fieldSchema.type === 'LookupObjectID[]' ? 'dxTagBox' : 'dxSelectBox';

      var lookupSelector = [
        'form.' + args.modelSchema.schemaName,
        '[form-control-path="' + args.path + '"]',
        '[lookup-selector]'
      ].join(' ');

      var el = $(lookupSelector);
      return el[instanceName]('instance');
    }

    function getDataSource(args) {
      return getLookupInstance(args).option('dataSource');
    }

    function updateLookupValue(args, data) {
      var requestParams = {
        selectedTable: args.fieldSchema.lookup.table[data.table],
        dxQuery: ['_id', '=', data._id],
      }

      return GraphqlLookupQuery(args, requestParams)
        .then(records => setLookupValue(records.items[0], args));
    }

    function inSelectedValue(args, data) {
      var listOfValues = getLookupValue(args);
      return !!_.find(listOfValues, ['_id', data._id]);
    }

    function getLookupValue(args) {
      var lookupInstance = getLookupInstance(args);
      var value = lookupInstance.option('value');
      return _.isArray(value) ? value : [value];
    }

    function setLookupValue(newValue, args) {
      var lookupInstance = getLookupInstance(args);

      if (args.fieldSchema.type === 'LookupObjectID') {
        lookupInstance.option('value', newValue);
      } else {
        var prevValue = getLookupValue(args);
        var updateIndex = _.findIndex(prevValue, ['_id', newValue._id]);

        if (updateIndex < 0) {
          prevValue.push(newValue);
        } else {
          prevValue[updateIndex] = newValue;
        }

        lookupInstance.option('value', prevValue);
      }

      setTimeout(() => {
        lookupInstance.repaint();
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('LookupDataSource', LookupDataSource);

  /** @ngInject */
  function LookupDataSource(
    GraphqlLookupQuery,
    ErrorHelpers
  ) {
    return function (args, selectedTableName) {
      var selectedTable = args.fieldSchema.lookup.table[selectedTableName];
      var options = getOptions(args, selectedTable);

      return new DevExpress.data.DataSource(options);
    };

    function getOptions(args, selectedTable) {
      var options = {
        paginate: true,
        requireTotalCount: true,
        pageSize: 15,
        load: setFetchFn(args, selectedTable),
        key: '_id',
        byKey: function (key) {
          return Promise.resolve(selectItemByKey(args.data, key));
        }
      };

      return options;
    }

    function selectItemByKey(data, key) {
      if (_.isArray(data)) {
        return _.find(data, function (i) {
          return key === i._id;
        });
      } else {
        return data;
      }
    }

    function setFetchFn(args, selectedTable) {
      return function (loadOptions) {
        var queryParams = _.assign({ selectedTable: selectedTable }, loadOptions);

        return GraphqlLookupQuery(args, queryParams)
          .then(function (data) {
            return { data: data.items, totalCount: data.count };
          })
          .catch(function (error) {
            ErrorHelpers.handleError(error, 'Error trying to get lookup value.');
          });
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpCommon')
    .factory('LookupDxConfig', LookupDxConfig);

  /** @ngInject */
  function LookupDxConfig(
    AdpLookupHelpers,
    LookupDataSource,
    LookupBtns,
    ListControlSortable
  ) {
    return {
      single: singleLookupConfig,
      multiple: multipleLookupConfig,
      tableSelector: tableSelectorConfig,
      gridEditorSingle: gridEditorSingle,
      gridEditorMultiple: gridEditorMultiple,
    };

    function singleLookupConfig(options) {
      var defaultsConfig = defaults(options);

      var lookupSingleConfig = {
        elementAttr: {
          'class': 'adp-select-box adp-lookup-selector',
          'lookup-selector': true,
        },
        onOpened(event) {
          reloadLookupWithFormFilter(options, event.component);
          const input = event.element.find('[adp-qaid-lookup-input]')[0];
          input.focus();
        },
        itemTemplate: function (lookupData) {
          return createLabelForFormLookup(lookupData, options.args);
        },
        fieldTemplate: function (data, container) {
          fieldTemplate({
            data: data,
            args: options.args,
            container: container,
            component: this,
          });
        },
      };

      return _.assign(defaultsConfig, lookupSingleConfig);
    }

    function multipleLookupConfig(options, onInit) {
      const lookupMultipleConfig = {
        elementAttr: {
          'class': 'adp-select-box adp-lookup-selector',
          'lookup-selector': true,
          'adp-qaid-field-control': options.args.path,
        },
        inputAttr: {
          'adp-qaid-lookup-input': options.args.path,
        },
        itemTemplate: function (lookupData) {
          return createLabelForFormLookup(lookupData, options.args);
        },
        tagTemplate: function (lookupData, tagElement) {
          return tagTemplate({
            lookupData: lookupData,
            tagElement: tagElement,
            args: options.args,
            component: this,
          });
        },
        onOpened(e) {
          reloadLookupWithFormFilter(options, e.component);
        }
      };

      if (onInit) {
        lookupMultipleConfig.onInitialized = onInit;
      }

      const defaultsConfig = defaults(options);
      return _.assign(defaultsConfig, lookupMultipleConfig);
    }

    function gridEditorMultiple(options) {
      var defaultsConfig = defaults(options);

      var filterConfig = {
        elementAttr: {
          'class': 'adp-select-box adp-lookup-selector',
          'adp-qaid-field-control': options.args.path,
        },
        inputAttr: {
          'adp-qaid-lookup-input': options.args.path,
        },
        itemTemplate: function (lookupData) {
          return AdpLookupHelpers.lookupItemTemplate(lookupData, options.args);
        },
        tagTemplate: function (lookupData, tagElement) {
          return tagTemplate({
            lookupData: lookupData,
            tagElement: tagElement,
            args: options.args,
            component: this,
          });
        },
      };

      return _.assign(defaultsConfig, filterConfig);
    }

    function gridEditorSingle(options) {
      var defaultsConfig = defaults(options);

      var filterConfig = {
        elementAttr: {
          'class': 'lookup_cell_editor adp-select-box adp-lookup-selector adp-filter-lookup-selector'
        },
        itemTemplate: function (lookupData) {
          return AdpLookupHelpers.lookupItemTemplate(lookupData, options.args);
        },
        onOpened: function (event) {
          // WORKAROUND to set focus on select when dropdown is shown
          event.element.find('.adp-text-box input').focus();
        },
        fieldTemplate: function (data, container) {
          fieldTemplate({
            data: data,
            args: options.args,
            container: container,
            component: this,
          });

          setTimeout(function () {
            fixFocusForEditor(container);
          })
        },
      };

      return _.assign(defaultsConfig, filterConfig);
    }

    function tableSelectorConfig(options) {
      var items = getNamesForTables(options.args.fieldSchema.lookup);
      var hasSingleTable = items.length === 1;

      return {
        elementAttr: {
          'table-selector': true,
          'class': hasSingleTable ? ' hidden' : '',
        },
        inputAttr: {
          'adp-qaid-lookup-table-selector': options.args.path,
        },
        itemTemplate: function (data, index, element) {
          element.attr('adp-qaid-lookup-table-selector-item', options.args.path);
          return data.label;
        },
        value: items[0].value,
        items: items,
        valueExpr: 'value',
        displayExpr: 'label',
        onValueChanged: options.onTableChanged,
      };

      function getNamesForTables(lookup) {
        return _.map(lookup.table, function (table) {
          return {
            value: table.table,
            label: table.fullName || _.startCase(table.table),
          }
        });
      }
    }

    function tagTemplate({ component, args, lookupData, tagElement }) {
      const removeBtn = $('<div class="dx-tag-remove-button"><span class="dx-icon dx-icon-clear"></span></div>');
      const tagContentElements = [removeBtn];

      removeBtn.on('click', function () {
        const val = component.option('value').slice();
        _.remove(val, ['_id', lookupData._id]);
        component.option('value', val);

        removeBtn.off('click');
      });

      if (args.action !== 'view') {
        const updateBtn = $(`
          <div class="dx-tag-update-button">
            <span class="dx-icon dx-icon-edit"></span>
          </div>
        `);
        updateBtn.on('click', (e) => {
          e.stopPropagation();
          LookupBtns.updateAction(args, lookupData);
        })
        tagContentElements.push(updateBtn);
      }


      const content = $('<span class="dx-tag-text">')
        .html(AdpLookupHelpers.selectionLabel(lookupData, args));
      tagContentElements.push(content)

      const tagContentRoot = $('<div class="dx-tag-content">')
        .attr('draggable', ListControlSortable.isReorderingAllowed(args))
        .attr('adp-qaid-field-tag', args.path)
        .appendTo(tagElement);

      tagContentRoot.append(tagContentElements);
    }

    function fieldTemplate(templateConf) {
      var data = templateConf.data;
      var args = templateConf.args;
      var container = templateConf.container;
      var placeholder = templateConf.component.option('placeholder');

      var label = _.isNil(data) ?
        '<div class="adp-text-box-label-empty">' + placeholder + '</div>' :
        AdpLookupHelpers.selectionLabel(data, args);

      var labelText = $('<div>').append(label).text();

      var tpl = $('<div class="adp-text-box-label">')
        .attr('adp-qaid-field-control', templateConf.args.path)
        .append(label);

      var textBox = $('<div class="adp-text-box">')
        .dxTextBox({
          placeholder: placeholder,
          value: _.isNil(data) ? '' : labelText,
          inputAttr: {
            'adp-qaid-lookup-input': templateConf.args.path
          }
        });

      container.append(tpl, textBox);
    }

    function createLabelForFormLookup(lookupData, args) {
      var item = AdpLookupHelpers.lookupItemTemplate(lookupData, args);
      item.append(LookupBtns.updateMenuItemButton(lookupData, args));

      return item;
    }

    function defaults({ args, selectedTableName, onValueChanged }) {
      return {
        elementAttr: {
          'class': 'adp-select-box adp-lookup-selector'
        },
        value: args.data || null,
        showClearButton: true,
        searchEnabled: true,
        dataSource: LookupDataSource(args, selectedTableName),
        valueExpr: 'this',
        onValueChanged(e) {
          onValueChanged(e);

          const { type } = args.fieldSchema;
          if (type === 'LookupObjectID') {
            const updateBtn = e.component.getButton('update-record');
            updateBtn.option('visible', !!e.value);
          }
        },
        multiline: true,
        wrapItemText: true,
      }
    }

    // fixes focus for lookup editor, allow to use tab navigation while editing
    function fixFocusForEditor(container) {
      var gridCell = container.closest('.dx-editor-cell');
      var gridInstance = container.closest('[dx-data-grid]').dxDataGrid('instance');
      gridInstance && gridInstance.focus(gridCell);
    }

    function reloadLookupWithFormFilter(options, gridInstance) {
      var selectedTable = options.args.fieldSchema.lookup.table[options.selectedTableName];
      var hasFormFilter = !!selectedTable.where;

      if (hasFormFilter) {
        gridInstance.getDataSource().reload();
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .directive('recordDetailsValueRow', recordDetailsValueRow);

  function recordDetailsValueRow(AdpUnifiedArgs, ACTIONS) {
    return {
      restrict: 'E',
      scope: {
        field: '<',
        schema: '<',
        filteredRecord: '<',
        args: '<',
      },
      templateUrl: 'app/adp-data-grid/components/adp-record-details/record-details-value-row/record-details-value-row.template.html',
      replace: true,
      link: function (scope) {
        scope.valueRowClass = [
          'view-details-row',
          'view-details-row-' + scope.field.fieldName,
          'view-details-row-' + _.toLower(scope.field.type),
        ];

        scope.args = AdpUnifiedArgs.getHelperParamsWithConfig({
          path: scope.field.fieldName,
          formData: scope.args.row,
          schema: scope.schema,
          action: ACTIONS.VIEW_DETAILS,
        });
      }
    }
  }
})();
;;(function () {
  'use strict';
  var ACTIONS_POSITION_SIGNATURE = 'grid.lifecycle';

  angular
    .module('app.adpDataGrid')
    .factory('GridLifecycleActions', GridLifecycleActions);

  /** @ngInject */
  function GridLifecycleActions(
    ActionsHelpers
  ) {
    var actionFactoriesByType = {
      'action': ActionsHelpers.getForHelperType,
      'link': getForLinkType,
      'module': ActionsHelpers.getForModuleType,
    };

    var lifecycleStages = {
      init: {
        eventName: 'onInitialized',
        defaultAction: function (event, gridOptions, schema, customGridOptions) {
          customGridOptions.setGridComponent(event.component);
        }
      },
      dispose: {
        eventName: 'onDisposing',
      },
    };

    return function (gridOptions, schema, customGridOptions) {
      var actions = ActionsHelpers.getActionsByPosition(
        schema, (action) => ActionsHelpers.isActionAllowed(action, ACTIONS_POSITION_SIGNATURE));

      _.each(lifecycleStages, function (stage, stageName) {
        var eventName = stage.eventName;
        var defaultAction = stage.defaultAction || _.noop;
        var prevHandler = gridOptions[eventName];

        gridOptions[eventName] = function (event) {
          if (prevHandler) {
            prevHandler(event);
          }

          defaultAction(event, gridOptions, schema, customGridOptions);

          _.each(actions, function (action) {
            var actionType = _.get(action, 'action.type', '')
            var actionLink = _.get(action, 'action.link', '')
            var actionFactory = actionFactoriesByType[actionType];
            var actionMethod = actionFactory(actionLink, action);

            if (_.isFunction(actionMethod)) {
              var context = {
                schema: schema,
                customGridOptions: customGridOptions,
                gridOptions: gridOptions,
              };

              actionMethod.call(context, stageName, event);
            }
          })
        }
      });
    }

    function getForLinkType(linkUrl) {
      return null; // link action is not applicable for lifecycle actions
    }
  }
})();
;;(function () {
    'use strict';
    var ACTIONS_POSITION_SIGNATURE = 'rtc';

    angular
      .module('app.adpDataGrid')
      .factory('GridRtcActions', GridRtcActions);

    /** @ngInject */
    function GridRtcActions(
      ActionsHelpers,
      AdpUnifiedArgs,
      AdpSocketIoService
    ) {
      var actionFactoriesByType = {
        'action': ActionsHelpers.getForHelperType,
        'module': ActionsHelpers.getForModuleType,
      };

      return function (gridOptions, schema, customGridOptions) {
        var actions = ActionsHelpers.getActionsByPosition(
          schema,(action) => ActionsHelpers.isActionAllowed(action, ACTIONS_POSITION_SIGNATURE));
        var methodsCache = [];

        _.each(actions, function (action) {
          var actionType = _.get(action, 'action.type', '')
          var actionFactory = actionFactoriesByType[actionType];
          var actionMethod = actionFactory && actionFactory(action);

          if (_.isFunction(actionMethod)) {
            var context = AdpUnifiedArgs.getHelperParamsWithConfig({
              path: '',
              formData: null,
              action: 'rtcAction',
              schema: schema,
            });

            context.fieldSchema = action;
            context.customGridOptions = customGridOptions;
            context.gridOptions = gridOptions;

            var item = {
              processor: actionMethod.call(context)
            }

            if (_.isFunction(actionMethod.onUnsubscribe)) {
              item.destructor = actionMethod.onUnsubscribe;
              item.context = context;
            }

            methodsCache.push(item);
          }
        })

        if (actions.length) {
          var stages = {
            onInitialized: function () {
              _.each(methodsCache, function (item) {
                AdpSocketIoService.registerMessageProcessor(item.processor);
              })
            },
            onDisposing: function () {
              _.each(methodsCache, function (item) {
                AdpSocketIoService.unRegisterMessageProcessor(item.processor);
                if (_.isFunction(item.destructor)) {
                  item.destructor.call(item.context);
                }
              })
            },
          };

          _.each(stages, function (eventAction, eventName) {
            var prevHandler = gridOptions[eventName];

            gridOptions[eventName] = function (event) {
              if (prevHandler) {
                prevHandler(event);
              }
              eventAction();
            }
          });
        }
      }
    }
  }
)();
;;(function () {
  'use strict';

  angular
    .module("app.adpDataGrid")
    .factory("ActionMessages", ActionMessages);

  /** @ngInject **/
  function ActionMessages(ACTIONS) {
    var MESSAGES = {};

    MESSAGES[ACTIONS.CREATE] = function (schema) {
      return getSingleRecordTitle(schema) + " has been added.";
    };

    MESSAGES[ACTIONS.CLONE] = MESSAGES[ACTIONS.CREATE];
    MESSAGES[ACTIONS.CLONE_DATASET] = MESSAGES[ACTIONS.CREATE];

    MESSAGES[ACTIONS.UPDATE] = function (schema) {
      return getSingleRecordTitle(schema) + " has been updated.";
    };

    MESSAGES[ACTIONS.DELETE] = function (schema) {
      return getSingleRecordTitle(schema) + " has been deleted.";
    };

    return MESSAGES;

    function getSingleRecordTitle(schema) {
      if (schema.singleRecordName) {
        return schema.singleRecordName;
      } else {
        var name = schema.fullName || schema.schemaName;
        return pluralize.singular(name) || (name + " record");
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridActionsTemplate', GridActionsTemplate);

  /** @ngInject */
  function GridActionsTemplate(
    APP_CONFIG,
    AdpIconsHelper,
    ActionsHandlers,
    AdpUnifiedArgs,
    GridOptionsHelpers,
    AdpSchemaService,
    ActionsHelpers
  ) {
    var layoutFactories = {
      menu: menuTemplate,
      spread: spreadButtonsTemplate,
    }

    return function (actions, row, schema, customGridOptions) {
      // HOTFIX: until UNI-892 completed
      delete actions.listFilter;

      var layoutName = _.get(schema, 'recordActionsLayout', 'spread');
      var layoutFactory = layoutFactories[layoutName] || spreadButtonsTemplate;
      var sortedActions = _.map(actions, function (action, name) {
        action.actionName = name;

        return action;
      }).sort(AdpSchemaService.getSorter('actionOrder'));
      var element = layoutFactory({
        actions: sortedActions,
        row: row,
        schema: schema,
        customGridOptions: customGridOptions
      });

      return $("<div class='actions-column-container actions-layout-"+layoutName+"' adp-"+row._id+">").append(element);
    }

    function menuTemplate(params) {
      var actionItems = _.map(params.actions, function (action) {
        const icon = _.isUndefined(action.icon) ? menuEmptyIconSpace() : AdpIconsHelper.getIconHtml(action.icon);
        const title = action.fullName || action.description;
        const row = params.row;
        const target = !!_.get(action, 'action.external') ? _.get(action, 'action.target', '_self') : '';
        let itemHtml;

        if (action.action.type === 'link') {
          itemHtml = `
            <a 
              href="${ActionsHelpers.getLinkActionUrl(action, params)}"
              target="${target}"
            ></a>
          `;
        } else {
          itemHtml = '<div>';
        }

        return {
          disabled: ActionsHelpers.evalDisabledAttr(action, row, params.schema),
          template: $(itemHtml).attr('data-action-name', action.actionName).append(icon).append(title),
          action: action.actionName,
        };
      });

      var menuDataSource = [{
        template: "<button class='adp-action-b-tertiary'><i class='fa fa-sort-desc'></i></button>",
        items: actionItems,
      }];

      return $("<div>").dxMenu({
        dataSource: menuDataSource,
        onItemClick: function (event) {
          var actionItem = event.itemData && _.find(params.actions, function (item) {
            return item.actionName === event.itemData.action && item.action.type !== 'link'
          });

          actionItem && ActionsHelpers.handleActionClick(actionItem, params)();
        },
        cssClass: "adp-table-actions-menu",
        elementAttr: {
          class: "adp-" + params.row._id,
        },
      });
    }

    function menuEmptyIconSpace() {
      return "<i class='adp-empty-icon'></i>";
    }

    function spreadButtonsTemplate(params) {
      return _.map(params.actions, function (action) {
        return $(ActionsHelpers.getActionTemplate(action, params));
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('GridTableActions', GridTableActions);

  /** @ngInject */
  function GridTableActions(
    GridActionsTemplate,
    ActionsHelpers
  ) {
    return function (options, schema, customGridOptions) {
      var tableActions = ActionsHelpers.pickTableActions(schema);

      if (ActionsHelpers.actionsIsEmpty(tableActions)) {
        return;
      }

      options.columns.push({
        caption: getColumnCaption(schema),
        name: 'actions',
        cssClass: 'actions-column',
        cellTemplate: actionsTemplate(tableActions, schema, customGridOptions),
        allowExporting: false,
        allowEditing: false,
        hidingPriority: schema.actions.responsivePriority,
        visible: true,
        showInColumnChooser: true,
      });
    }

    function getColumnCaption(schema) {
      var DEFAULT_COLUMN_CAPTION = 'Actions';
      return schema.actions.title || DEFAULT_COLUMN_CAPTION;
    }

    function actionsTemplate(tableActions, schema, customGridOptions) {
      return function (container, cellInfo) {
        const row = _.get(cellInfo, "data", {});
        const actionPermissionsForRecord = row._actions;

        var permittedActions = _.pickBy(tableActions, function (actionItem, name) {
          const isVisible = ActionsHelpers.evalVisibleAttr(actionItem, row, schema);
          return isVisible && _.get(actionPermissionsForRecord, name, false);
        });

        var template = GridActionsTemplate(permittedActions, row, schema, customGridOptions);
        container.append(template);
      }
    }
  }
})();
;;(function () {
  "use strict";
  var TOOLBAR_POSITION_SIGNATURE = "grid.top";

  angular
    .module("app.adpDataGrid")
    .factory("GridToolbarActions", GridToolbarActions);

  /** @ngInject */
  function GridToolbarActions(
    $location,
    AdpClientCommonHelper,
    ActionsHandlers,
    AdpUnifiedArgs,
    ActionsHelpers,
    GridOptionsHelpers
  ) {
    var actionFactoriesByType = {
      "action": getForHelperType,
      "link": getForLinkType,
      "module": ActionsHelpers.getForModuleType,
    };
    var toolbarActions = {
      "create": createAddAction,
      "group": assignGroupingToColumns,
      "search": searchAddAction,
    };

    return function (gridOptions, schema, customGridOptions) {
      const actions = ActionsHelpers.getActionsByPosition(schema, (action) => {
        if (ActionsHelpers.isActionAllowed(action, ['grid.top.left', 'grid.top.right'])) {
          return ActionsHelpers.evalVisibleAttr(action, null, schema);
        }
        return false;
      });

      const { gridComponent } = customGridOptions;
      removeUnnecessary(gridComponent);

      gridComponent.beginUpdate();
      const originalToolbarItems = (gridComponent.option('toolbar.items') || []).slice(0);
      gridComponent.option('toolbar.items', []);
      _.each(actions, function (action) {
        var actionType = _.get(action, "action.type", "")
        var actionFactory = actionFactoriesByType[actionType];
        var actionMethod = actionFactory && actionFactory(action);

        if (_.isFunction(actionMethod)) {
          var actionOptions = {
            title: action.fullName || "",
            description: action.description || "",
            location: getLocalPosition(action.position),
            sortIndex: action.actionOrder,
            icon: action.icon,
            className: action.className,
            locateInMenu: action.locateInMenu || "auto",
            table: action.table,
            params: action.params,
          };
          var context = AdpUnifiedArgs.getHelperParamsWithConfig({
            path: "",
            formData: null,
            action: "toolbarAction",
            schema: schema,
          });

          context.fieldSchema = action;
          context.customGridOptions = customGridOptions;
          context.gridOptions = gridOptions;
          context.actionOptions = actionOptions;

          actionMethod.call(context, getWidgetRegistrator(context));
        }
      });

      const toolbarItems = gridComponent.option('toolbar.items');
      gridComponent.option('toolbar.items', toolbarItems.concat(originalToolbarItems));
      gridComponent.endUpdate();
    }

    function getWidgetRegistrator(widgetArgs) {
      const { actionOptions, modelSchema } = widgetArgs;
      const customGridOptions = widgetArgs.customGridOptions;
      const action = widgetArgs.fieldSchema;
      const setToolbarOption = (widgetOptions, gridComponent) => {
        const toolbarItems = gridComponent.option('toolbar.items') || [];
        toolbarItems.push(widgetOptions);
        gridComponent.option('toolbar.items', toolbarItems);
      }

      return (getWidgetOptions) => {
        const { gridComponent } = customGridOptions;
        const itemOptions = getWidgetOptions(gridComponent);

        if (!itemOptions) {
          return;
        }

        const widgetOptions = Object.assign(itemOptions, actionOptions);

        widgetOptions.cssClass = (widgetOptions.cssClass || "") + " adp-toolbar-action-" + action.actionName;

        if (widgetOptions.options) {
          widgetOptions.options.disabled = ActionsHelpers.evalDisabledAttr(action, null, modelSchema);
        }

        setToolbarOption(widgetOptions, gridComponent);
      }
    }

    function getForHelperType(action) {
      var actionName = _.get(action, "action.link", "");
      var actionMethod = toolbarActions[actionName];

      if (actionMethod) {
        return actionMethod;
      }

      actionMethod = ActionsHelpers.getForHelperType(action);

      if (actionMethod) {
        return getHelperButtonFactory(actionMethod);
      }
    }

    function getForLinkType(action) {
      return function (widgetRegistator) {
        var linkUrl = _.get(action, "action.link", "");
        var actionOptions = this.actionOptions;
        var className = "adp-toolbar-menu grid-view-menu " + (actionOptions.className || "");
        var buttonSpec;

        if (actionOptions.icon) {
          buttonSpec = {template: AdpClientCommonHelper.getMenuItemTemplate(actionOptions, {className: className})};
        } else {
          buttonSpec = {text: actionOptions.title}
        }

        return widgetRegistator(function () {
          return {
            widget: "dxMenu",
            options: {
              dataSource: [buttonSpec],
              cssClass: className,
              onItemClick: function () {
                $location.path(linkUrl);
              }
            }
          }
        });
      }
    }

    function createAddAction(toolbarWidgetRegister) {
      var schema = this.modelSchema;
      var actionOptions = this.actionOptions;
      var buttonText = actionOptions.title || "Create New";
      var className = "btn page-action btn-primary " + (actionOptions.className || "");
      var customOptions = this.customGridOptions;
      var row = this.row;
      var actionItem = this.fieldSchema;
      var disabled = ActionsHelpers.evalDisabledAttr(actionItem, row, schema) ? ' disabled' : '';

      return toolbarWidgetRegister(() => {
        return {
          name: 'createButton',
          widget: 'dxButton',
          template: '<button type="button" class="' + className + '" ' + disabled + '>' + buttonText + '</button>',
          onClick: function () {
            ActionsHandlers.create(schema)
              .then(function () {
                GridOptionsHelpers.refreshGrid(customOptions.gridComponent);
              });
          },
        }
      })
    }

    function getHelperButtonFactory(actionCb) {
      return function (toolbarWidgetRegister) {
        var self = this;

        return toolbarWidgetRegister(function () {
          return {
            widget: "dxMenu",
            options: {
              dataSource: [{template: AdpClientCommonHelper.getMenuItemTemplate(self.actionOptions)}],
              cssClass: "adp-toolbar-menu grid-view-menu",
              onItemClick: function () {
                actionCb.call(self)
              },
            },
          };
        });
      }
    }

    function assignGroupingToColumns(toolbarWidgetRegister) {
      const gridComponent = this.customGridOptions.gridComponent;
      const columns = gridComponent.option('columns');

      columns.forEach((column) => {
        const field = this.modelSchema.fields[column.dataField];
        if (!field) {
          return;
        }

        const grp = _.get(field, "parameters.grouping", {});
        _.assign(column, grp);
      });
      gridComponent.option('columns', columns);

      const groupPanel = { visible: true };
      if (this.actionOptions.title) {
        groupPanel.emptyPanelText = this.actionOptions.title;
      }
      gridComponent.option('groupPanel', groupPanel);

      return toolbarWidgetRegister(() => ({ name: 'groupPanel' }));
    }

    function searchAddAction(toolbarWidgetRegister) {
      const gridComponent = this.customGridOptions.gridComponent;
      gridComponent.option('searchPanel.visible', true);
      gridComponent.option('searchPanel.placeholder', this.actionOptions.title || "Search...");

      return toolbarWidgetRegister(() => ({ name: 'searchPanel' }));
    }

    function getLocalPosition(position) {
      var setting = position.substring(TOOLBAR_POSITION_SIGNATURE.length + 1);
      var location = {left: "before", center: "center"}[setting];

      return location || "after";
    }

    function removeUnnecessary(gridComponent) {
      // we have to remove columnChooser from toolbar because we add custom one.
      // Disabling columnChooser by grid config is not an option!

      const toolBarItems = gridComponent.option('toolbar.items');
      const newItems =_.filter(toolBarItems, i => i.name !== "columnChooserButton");
      gridComponent.option('toolbar.items', newItems);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ComplexTypesDataTransformer', ComplexTypesDataTransformer);

  /** @ngInject */
  function ComplexTypesDataTransformer(
    FormattersHelper
  ) {
    return function transformDataForYaml(args, CellRenderer) {
      if (isObject(args)) {
        return transformObject(args, CellRenderer);
      } else if (isArray(args)) {
        return transformArray(args, CellRenderer);
      } else if (args.fieldSchema.type === 'Mixed') {
        return args.data;
      } else {
        return leaf(args, CellRenderer);
      }

      function transformObject(args, CellRenderer) {
        var objVal = _.transform(args.data, function (result, value, key) {
          var nextArgs = nextObjItemArgs(args, value, key);
          const { fieldSchema } = nextArgs;
          if (!fieldSchema) {
            return;
          }

          result[fieldSchema.fullName] = transformDataForYaml(nextArgs, CellRenderer);
        }, {});

        return _.isEmpty(objVal) ? null : objVal;
      }

      function transformArray(args, CellRenderer) {
        var transformResult = args.fieldSchema.type === 'AssociativeArray' ? {} : [];

        var arrayValue = _.transform(args.data, function (result, value, index) {
          var arrayItemArgs = nextArrayItemArgs(args, value, index);
          result[index] = transformDataForYaml(arrayItemArgs, CellRenderer);
        }, transformResult);

        return _.isEmpty(arrayValue) ? null : arrayValue;
      }
    }

    function shallowCopyWith(obj, mixObject) {
      return _.assign({}, obj, mixObject);
    }

    function nextObjItemArgs(args, value, key) {
      return shallowCopyWith(args, {
        data: value,
        fieldSchema: args.fieldSchema.fields[key],
        schemaPath: args.schemaPath.concat('.', key),
        path: args.path.concat('.', key),
      });
    }

    function nextArrayItemArgs(args, value, index) {
      // little trick: transforming array fieldSchema copy to Object type
      // because processing for array items are the same as for object item
      var field = shallowCopyWith(args.fieldSchema, { type: 'Object' });
      return shallowCopyWith(args, {
        data: value,
        fieldSchema: field,
        path: args.path.concat('.', index),
      });
    }

    function leaf(leafArgs, CellRenderer) {
      if (leafArgs.fieldSchema.type === 'TreeSelector') {
        return transformTreeSelector(leafArgs);
      }

      _.set(leafArgs, 'params.asText', true);
      return CellRenderer(leafArgs);
    }

    function isObject(args) {
      return args.fieldSchema.type === 'Object';
    }

    function isArray(args) {
      return _.includes(['Array', 'AssociativeArray'], args.fieldSchema.type);
    }

    function transformTreeSelector(args) {
      if (args.data)
      return FormattersHelper.asText(args) ?
        transformTreeSelectorToText(args) :
        transformTreeSelectorForHtml(args);
    }

    function transformTreeSelectorForHtml(args) {
      var current = [];
      var result = current;

      _.each(args.data, function (value, index) {
        current.push(value.label);

        var isLast = args.data.length - 1 === index;
        if (isLast) {
          return;
        }

        current.push([]);
        current = current[1];
      });

      return result;
    }

    function transformTreeSelectorToText(args) {
      var result = {};
      var current = result;

      _.each(args.data, function (value, index) {
        current[value.label] = {};

        var isLast = args.data.length - 1 === index;
        if (isLast) {
          return;
        }

        current = current[value.label];
      });

      return result;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('FormattersHelper', FormattersHelper);

  /** @ngInject */
  function FormattersHelper() {
    return {
      asText: function(args) {return _.get(args, "params.asText", false);},
      commaDotSeparator: function(args) {return _.get(args, "params.commaDotSeparator");},
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('BasicTypesCellRenderer', BasicTypesCellRenderer);

  /** @ngInject */
  function BasicTypesCellRenderer(
    AdpIconControlService,
    FormattersHelper,
    GRID_FORMAT
  ) {
    function password() {
      return '********';
    }

    function stringArray(args) {
      var value = args.data;
      var isEmptyArray = _.isArray(value) && value.length === 0;

      if (value === null || isEmptyArray)  {
        return GRID_FORMAT.EMPTY_VALUE;
      }
      if (!_.isArray(value)) {
        return _.escape(value);
      }
      return value.map(_.escape).join(', ');
    }

    function number(args) {
      var value = args.data;
      var number = parseFloat(value);

      return _.isNaN(number) ? GRID_FORMAT.EMPTY_VALUE : number;
    }

    function boolean(args) {
      return FormattersHelper.asText(args) ?
        booleanText(args.data) :
        booleanHtml(args.data);
    }

    function booleanText(value) {
      if (value === true || value === 'TRUE_VALUE') {
        return 'true';
      } else {
        return 'false';
      }
    }

    function booleanHtml(value) {
      var iconName;
      if (value === true) {
        iconName = 'check-square-o';
      } else {
        iconName = 'square-o';
      }

      return '<div class="adp-boolean-cell"><i class="fa fa-' + iconName + '"></i></div>';
    }

    function trisStateBoolean(args) {
      if (args.data === null) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      return boolean(args);
    }

    function string(args) {
      var value = args.data;
      return (_.isNil(value) || value === '') ? GRID_FORMAT.EMPTY_VALUE : _.escape(value);
    }

    function phone(args) {
      var value = args.data;

      if (_.isNil(value) || value === '') {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      return FormattersHelper.asText(args) ?
        value :
        [value.slice(0, 3), value.slice(3,6), value.slice(6, 10)].join('-');
    }

    function stringOrHtml(args) {
      var rawValue = args.data;
      if (_.isNil(rawValue) || rawValue === '') {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      if (FormattersHelper.asText(args)) {
        return rawValue;
      } else {
        var renderAsHtml = _.get(args, 'fieldSchema.parameters.renderAsHtml', false);
        return renderAsHtml ? rawValue : _.escape(rawValue);
      }
    }

    function escapedHtmlOrRawHtml(args) {
      var rawValue = args.data;
      if (_.isNil(rawValue) || rawValue === '') {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      if (FormattersHelper.asText(args)) {
        return args.action === 'export' ? rawValue.replace(/\n+/g, ' ').trim() : rawValue;
      }

      if (args.action === 'viewDetails') {
        return args.data;
      }

      var renderAsHtml = _.get(args, 'fieldSchema.parameters.renderAsHtml', false);

      return renderAsHtml ?
        $('<data>' + args.data + '</data>') :
        stripHtml(rawValue);
    }

    function stripHtml(html) {
      var tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      var stripped = (tmp.textContent || tmp.innerText).trim() || "";

      if (!stripped) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      return getSubstr(stripped);
    }

    function getSubstr(str) {
      var maxStrLen = 100;
      return str.length > maxStrLen ? str.substring(0, maxStrLen) + '...' : str;
    }

    function icon(args) {
      if (!args.data) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      const tpl = AdpIconControlService.template(args.data);
      return [tpl, _.escape(tpl)].join(' - ');
    }

    return {
      password,
      number,
      stringArray,
      boolean,
      trisStateBoolean,
      string,
      phone,
      stringOrHtml,
      escapedHtmlOrRawHtml,
      icon,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ComplexTypesCellRenderer', ComplexTypesCellRenderer);

  /** @ngInject */
  function ComplexTypesCellRenderer(
    FormattersHelper,
    ComplexTypesDataTransformer
  ) {
    return function (args, CellRenderer) {
      var data = ComplexTypesDataTransformer(args, CellRenderer);

      return FormattersHelper.asText(args) ?
        getComplexTypeAsText(data, _.get(args, 'fieldSchema.fieldName')) :
        getComplexTypeAsYaml(data);
    }

    function getComplexTypeAsText(data, name) {
      var textValues = _.isObject(data) ? _.map(data, getComplexTypeAsText).join('; ') : '';
      var finalValue = _.isObject(data) && !textValues ? '{}' : data;

      return name + ': ' + (textValues ? '{ ' + textValues + ' }' : finalValue);
    }

    function getComplexTypeAsYaml(data) {
      var yaml = null;
      try {
        yaml = window.jsyaml.safeDump(data, { skipInvalid: true });
      } catch (e) {
        if (e instanceof window.jsyaml.YAMLException) {
          console.error('Error trying to format data to yaml: ', data, e);
        } else {
          throw e;
        }
      }

      return htmlContent(yaml);
    }

    function htmlContent(yaml) {
      var container = $('<div class="adp-grid-scroll-container">');
      container.append(yaml);

      return container;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DateTypesCellRenderer', DateTypesCellRenderer);

  /** @ngInject */
  function DateTypesCellRenderer(
    GRID_FORMAT,
    DATE_FORMAT,
    DATE_TIME_FORMAT,
    TIME_FORMAT
  ) {
    function date(args) {
      var type = _.get(args, 'fieldSchema.type');
      var dateFormat = getDateFormat(type);
      var value = args.data;

      return _.isNil(value) ? GRID_FORMAT.EMPTY_VALUE : dayjs(value).format(dateFormat);
    }

    function getDateFormat(type) {
      var dateFormats = {
        Date: DATE_FORMAT,
        Time: TIME_FORMAT,
        DateTime: DATE_TIME_FORMAT
      };

      return dateFormats[type];
    }

    function dateArray(args) {
      if (_.isNil(args.data) || _.isEmpty(args.data)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      var type = _.get(args, 'fieldSchema.type').replace('[]', '');
      var format = getDateFormat(type);

      return args.data.map(function (v) {
        return dayjs(v).format(format);
      }).join(', ');
    }

    return {
      date: date,
      dateArray: dateArray,
    }
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpDataGrid")
    .factory("GridTypeCellRenderer", GridTypeCellRenderer);

  var GridColumnsHelpers; //initialised on first use to workaround circular dependency

  /** @ngInject */
  function GridTypeCellRenderer(
    $injector,
    GRID_FORMAT,
    GridControlHelper
  ) {
    return {
      render: render,
    };

    function render(args) {
      var $elem = $("<div>");

      GridControlHelper
        .getMergedData(args.fieldSchema.table, args.row, args.action)
        .then(function (data) {
          renderReadonlyTable($elem, data.data, args.fieldSchema)
        })

      return $elem;

      function renderReadonlyTable($elem, data) {
        if (_.isNil(data) || _.isEmpty(data)) {
          $elem.text( GRID_FORMAT.EMPTY_VALUE );
          return;
        }

        var mergedSchema = GridControlHelper.mergeSchema(args.fieldSchema, args.modelSchema);
        var columnsToRender = getVisibleColumns(mergedSchema);
        var $thead = $("<thead>");
        var $tbody = $("<tbody>");

        if (!GridColumnsHelpers) { GridColumnsHelpers = $injector.get('GridColumnsHelpers'); }

        $thead.append("<th>" + _.map(columnsToRender, function (field) {
          return field.fullName
        }).join("</th><th>") + "</th>");

        _.each(data, function (row) {
          var $tr = $("<tr>");

          _.each(columnsToRender, function (field) {
            var $td = $("<td>");

            $td.append(GridColumnsHelpers.getTextTemplateForField(field, mergedSchema, row));
            $tr.append($td);
          })

          $tbody.append($tr);
        })

        $elem.append($("<table class='adp-grid-control-table'>").append($thead).append($tbody));
      }

      function getVisibleColumns(schema) {
        return _.filter(schema.fields, function(field) { return field.showInDatatable});
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialTypesCellRenderer', ImperialTypesCellRenderer);

  /** @ngInject */
  function ImperialTypesCellRenderer(
    AdpFieldsService,
    GRID_FORMAT
  ) {
    return {
      single: single,
      multiple: multiple,
    };

    function single(args) {
      var value = args.data;
      if (_.isNil(value) || value === 0) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      var unit = AdpFieldsService.getUnits(args.fieldSchema)[0];
      return value + unit.label
    }

    function multiple(args) {
      var value = unwrapValue(args.data);

      if (_.isNil(value)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      var units = AdpFieldsService.getUnits(args.fieldSchema);

      var valueWithUnits = _.map(units, function(unit, index) {
        return value[index] + unit.label
      });

      return valueWithUnits.join(' ');
    }

    function unwrapValue(value) {
      return _.isString(value) ? value.split('.').map(Number) : value;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ListTypesCellRenderer', ListTypesCellRenderer);

  /** @ngInject */
  function ListTypesCellRenderer(
    GRID_FORMAT,
    AdpListsService,
    AdpRecordMeta
  ) {
    return function cellRenderer(args) {
      var isEmpty = _.isObject(args.data) ? _.isEmpty(args.data) : _.isNil(args.data);
      if (isEmpty) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      if (AdpListsService.isAsync(args)) {
        return getAsyncList(args)
      }

      var list = args.fieldSchema.list.values;
      return _.isArray(args.data) ?
        getMultipleValues(list, args.data) :
        getSingleValueForList(list, args.data);
    }

    function getAsyncList(args) {
      var labels = AdpRecordMeta.get(args, args.path + '.label');
      return _.isArray(labels) ? labels.join(', ') : labels;
    }

    function getSingleValueForList(list, value) {
      return _.get(list, [value, 'label']) || _.get(list, value) || value;
    }

    function getMultipleValues(list, value) {
      return _.map(value, _.partial(getSingleValueForList, list)).join(', ')
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LocationCellRenderer', LocationCellRenderer);

  /** @ngInject */
  function LocationCellRenderer(
    GRID_FORMAT
  ) {
    return {
      render: render,
    };

    function render(args) {
      var data = args.data;

      if (_.isEmpty(args.data) || _.isNil(data.label)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      return data.label;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupTypesCellRenderer', LookupTypesCellRenderer);

  /** @ngInject */
  function LookupTypesCellRenderer(
    GRID_FORMAT,
    FormattersHelper,
    AdpLookupHelpers
  ) {
    function single(args) {
      var id = _.get(args, 'data._id', null);
      if (_.isEmpty(args.data) && _.isNull(id)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      return lookupLabel(args.data, args);
    }

    function multiple(args) {
      if (_.isPlainObject(args.data)) {
        return  single(args);
      }
      if (!_.isArray(args.data) || _.isEmpty(args.data)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      var separator = FormattersHelper.asText(args) ? (FormattersHelper.commaDotSeparator(args) || '; ') : '</br>';

      return args.data.map(function (v) {
        return lookupLabel(v, args);
      }).join(separator);
    }

    function lookupLabel(value, args) {
      var separator = ' | ';
      var formattedValue = AdpLookupHelpers.formatLabel(value, args);

      if (AdpLookupHelpers.tablesList(args.fieldSchema).length > 1) {
        return [getTableFullName(value.table, args), formattedValue + '\n'].join(separator);
      } else {
        return formattedValue;
      }
    }

    function getTableFullName(tableName, args) {
      var fullName = _.get(args, ['fieldSchema', 'lookup', 'table', tableName, 'fullName']);
      return fullName || _.startCase(tableName);
    }

    return {
      multiple: multiple,
      single: single,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('MediaTypesCellRenderer', MediaTypesCellRenderer);

  /** @ngInject */
  function MediaTypesCellRenderer(
    FormattersHelper,
    GRID_FORMAT,
    AdpMediaTypeHelper
  ) {
    function fileList(args) {
      var files = args.data;
      if (_.isEmpty(files)) {
        return GRID_FORMAT.EMPTY_VALUE;
      }

      if (FormattersHelper.asText(args)) {
        return files.map(function(file) {
          return file.name;
        }).join(', ');
      }

      var listItemTpl = function (fileItem, src) {
        return [
          '<li>',
            '<a class="datatable-thumb-url" href data-file-id="' + fileItem.id + '">',
              '<img src="' + src + '" class="img-responsive"> ' + fileItem.name,
            '</a>',
          '</li>',
        ].join('');
      }

      var ul = $('<ul class="datatable-thumb-list"></ul>');
      ul.on('click', function (e) {
        if (e.target.classList.contains('datatable-thumb-url')) {
          e.preventDefault();

          var fileId = e.target.getAttribute('data-file-id');
          var file = _.find(files, ['id', fileId]);

          AdpMediaTypeHelper.downloadWithSaveDialog(file);
        }
      });

      Promise.all(files.map((fileItem) => AdpMediaTypeHelper.getThumbImgLink(fileItem)
        .then((src) => ({src, fileItem}))
      ))
        .then((fileItems) => {
          const listItems = fileItems.map((file) => $(listItemTpl(file.fileItem, file.src)));
          ul.append(listItems);
        });

      return ul;
    }

    return { fileList: fileList };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialUnitsEditorsHelpers', ImperialUnitsEditorsHelpers);

  /** @ngInject */
  function ImperialUnitsEditorsHelpers(
    AdpFieldsService
  ) {
    function createFilterComponent(options) {
      var editorName = 'dxSelectBox';
      var defaults = {
        value: options.value,
        valueExpr: 'value',
        displayExpr: 'label',
        dataSource: options.unit.list,
        onValueChanged: options.onValueChanged,
        placeholder: 'Select ' + options.unit.shortName,
        showClearButton: true,
        elementAttr: {
          class: 'adp-select-box adp-imperial-units-multiple',
          id: options.attrId,
        },
      };

      var editorOptions = AdpFieldsService.configFromParameters(options.fieldSchema, defaults);
      return options.element[editorName](editorOptions);
    }

    function getUnits(fieldSchema) {
      return AdpFieldsService.getUnitsList(fieldSchema);
    }

    function createRangePlaceholderElement(placeholder) {
      return $('<div class="imperial-unit-range-text">' + placeholder + '</div>');
    }

    return {
      getUnits: getUnits,
      createFilterComponent: createFilterComponent,
      createRangePlaceholderElement: createRangePlaceholderElement,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialUnitMultipleEditor', ImperialUnitMultipleEditor);

  /** @ngInject */
  function ImperialUnitMultipleEditor(ImperialUnitsEditorsHelpers) {
    return function () {
      return {
        element: $('<div>'),

        create: function (init) {
          this.options = init;
          this.units = ImperialUnitsEditorsHelpers.getUnits(this.options.args.fieldSchema);

          this.init();
        },

        init: function() {
          var initialValue = this.options.args.data || [0, 0]
          this.value = initialValue;

          this.elements = this.units.map(function (unit, index) {
            return this.createSelectBox(unit, index, initialValue[index]);
          }, this);
          this.element.append(this.elements);

          this.addRangeText(this.options.placeholder);
        },

        addRangeText: function (placeholder) {
          if (!placeholder) {
            return;
          }

          var el = ImperialUnitsEditorsHelpers.createRangePlaceholderElement(placeholder);
          this.element.prepend(el);
        },

        createSelectBox: function (unit, position, value) {
          var self = this;

          return ImperialUnitsEditorsHelpers.createFilterComponent({
            unit: unit,
            element: $('<div>'),
            onValueChanged: function (e) {
              self.setValue(e.value, position);
              self.options.onValueChanged({ value: self.getValue() });
            },
            value: value,
            attrId: 'cell_list_id_' + this.options.args.fieldSchema.fieldName + '_' + position,
          });
        },

        setValue: function (value, position) {
          if (_.isNull(value) && _.isNil(position)) {
            this.value = null;
          }

          this.value = this.value || [0, 0];
          this.value[position] = _.isNil(value) ? 0 : value;
          this.value = _.isEmpty(_.compact(this.value)) ? null : this.value;
        },

        getValue: function() {
          return _.isNull(this.value) ? null : this.value.slice();
        },

        reset: function () {
          this.elements.forEach(function (el) {
            // WORKAROUND: dx grid somehow manages to dispose second filter before first while
            // filter operation changed from any to 'between'
            // dxGrid throws error: 'dxSelectBox' is not init for this element
            // this code attempts to reset filter if element exist, if not just pass through
            try {
              var filterInstance = el.dxSelectBox('instance');
              filterInstance.reset();
            } catch (e) {}
          });
          this.setValue(null);
          this.options.onValueChanged({ value: null });
        },

        getElement: function () {
          return this.element;
        }
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialUnitSingleEditor', ImperialUnitSingleEditor);

  /** @ngInject */
  function ImperialUnitSingleEditor(
    ImperialUnitsEditorsHelpers,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxSelectBox',
        element: $('<div>'),

        create: function (init) {
          this.createEditor(init);
          this.addRangeText(init.placeholder);
        },

        createEditor: function(init) {
          var units = ImperialUnitsEditorsHelpers.getUnits(init.args.fieldSchema);

          ImperialUnitsEditorsHelpers.createFilterComponent({
            fieldSchema: init.args.fieldSchema,
            unit: units[0],
            element: this.element,
            onValueChanged: init.onValueChanged,
            value: init.args.data,
            attrId: 'cell_list_id_' + init.args.fieldSchema.fieldName,
          });
        },

        addRangeText: function (placeholder) {
          if (!placeholder) {
            return;
          }

          var el = ImperialUnitsEditorsHelpers.createRangePlaceholderElement(placeholder);
          this.element.prepend(el);
        }
      });
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupEditor', LookupEditor);

  /** @ngInject */
  function LookupEditor(
    LookupSelector,
    LookupTableSelector
  ) {
    return {
      single: createEditor.bind(null, false),
      multiple: createEditor.bind(null, true),
    }

    function createEditor(multiple) {
      return {
        element: $('<div class="adp-lookup-filter-container">'),
        lookupOptions: null,
        tableSelector: null,
        selectedTableName: null,
        lookupEditor: null,
        value: null,

        create: function (init) {
          this.lookupOptions = init;
          this.multiple = multiple;
          this.init();
        },

        init: function () {
          this.setClassToContainer(this.lookupOptions.args.fieldSchema.fieldName);
          this.createTableSelector();
          this.createLookupSelector();
        },

        setClassToContainer: function(fieldName) {
          this.element.addClass('lookup-name-' + fieldName);
        },

        createTableSelector: function () {
          var self = this;
          this.tableSelector = LookupTableSelector({
            args: this.lookupOptions.args,
            onTableChanged: function (e) {
              self.lookupEditor.updateDataSource(e.value);
            },
          });

          this.appendToRoot(this.tableSelector);
        },

        createLookupSelector: function () {
          var opts = {
            args: this.lookupOptions.args,
            onValueChanged: this.lookupOptions.onValueChanged,
            selectedTableName: this.tableSelector.getValue(),
          };

          this.lookupEditor = this.multiple ?
            LookupSelector.multiple(opts) :
            LookupSelector.single(opts);

          this.appendToRoot(this.lookupEditor);
        },

        reset: function () {
          this.lookupEditor.reset();
        },

        getElement: function () {
          return this.element;
        },

        appendToRoot: function(component) {
          this.element.append(component.getElement());
        },
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupSelector', LookupSelector);

  /** @ngInject */
  function LookupSelector(
    LookupDataSource,
    DxEditorMixin,
    LookupDxConfig,
    AdpFieldsService
  ) {
    return {
      single: function (options) {
        return createEditor(options, false);
      },
      multiple: function (options) {
        return createEditor(options, true);
      }
    }

    function createEditor(options, multiple) {
      var $component = DxEditorMixin({
        element: $('<div>'),

        create: function (parentOptions) {
          this.multiple = multiple;
          this.args = parentOptions.args;
          this.setEditorsOptions(parentOptions);

          this.editorName = this.multiple ? 'dxTagBox' : 'dxSelectBox';
          this.element[this.editorName](this.editorOptions);
        },

        updateDataSource: function (tableName) {
          var dataSource = LookupDataSource(this.args, tableName);
          this.getInstance().option('dataSource', dataSource);
        },

        setEditorsOptions: function(parentOptions) {
          var defaults = this.multiple ?
            LookupDxConfig.gridEditorMultiple(parentOptions) :
            LookupDxConfig.gridEditorSingle(parentOptions);

          this.editorOptions = AdpFieldsService.configFromParameters(
            parentOptions.args.fieldSchema,
            defaults
          );

          this.setChangeHandler(parentOptions.onValueChanged);
        },

        setChangeHandler: function (changeHandler) {
          var self = this;
          this.editorOptions.onValueChanged = function (e) {
            if (_.isNil(e.value) || _.isEmpty(e.value)) {
              changeHandler({ value: null });
              return;
            }
            var value = self.multiple ?
              e.value.map(toLookupValue) :
              toLookupValue(e.value);

            changeHandler({ value: value });
          };
        }
      });

      $component.create(options);

      return $component;
    }

    function toLookupValue(lookup) {
      return {
        _id: lookup._id,
        table: lookup.table,
        label: lookup.label,
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupTableSelector', LookupTableSelector);

  /** @ngInject */
  function LookupTableSelector(
    DxEditorMixin,
    LookupDxConfig
  ) {
    return function (options) {
      var component = DxEditorMixin({
        editorName: 'dxSelectBox',
        element: $('<div>'),

        create: function (options) {
          this.editorOptions = LookupDxConfig.tableSelector(options);
          this.element[this.editorName](this.editorOptions);
        },
      });

      component.create(options);

      return component;
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('filterUrlMapper', filterUrlMapper);

  /** @ngInject */
  function filterUrlMapper(
    GridFilterHelpers,
    FilterOperation,
    urlMappingRules,
    $state,
    $location
  ) {
    return function (gridInstance, schema) {
      const filters = getFiltersFromGrid(gridInstance, schema);
      const result = [];

      _.each(filters, (filter) => {
        const mapperFn = getMapperFunction(filter);
        if (!mapperFn) {
          return;
        }

        const stringValuePair = mapperFn(filter);
        if (!stringValuePair) {
          return;
        }

        result.push(stringValuePair);

        if (filter.operation) {
          const stringOperationPair = `${filter.fieldName}Operation=${filter.operation}`;
          result.push(stringOperationPair);
        }
      });

      const searchValue = gridInstance.option('searchPanel.text');

      makeTransitionToUrl(result, searchValue);
    };

    function getFiltersFromGrid(gridInstance, schema) {
      var result = [];

      for(var i = 0; i < gridInstance.columnCount(); i++) {
        var fieldName = gridInstance.columnOption(i, 'dataField');
        var operation = gridInstance.columnOption(fieldName, 'selectedFilterOperation');
        var filterValue = gridInstance.columnOption(fieldName, 'filterValue');

        if (_.isNil(filterValue) || filterValue === '') {
          continue;
        }

        result.push({
          fieldName: fieldName,
          field: _.get(schema, 'fields.' + fieldName),
          value: filterValue,
          operation: FilterOperation.encode(operation),
        });
      }

      return result;
    }

    function getMapperFunction(filter) {
      var filterRenderer = GridFilterHelpers.getFilterRenderer(filter.field);
      if (!filterRenderer) {
        return;
      }
      return urlMappingRules[filterRenderer.value];
    }

    function makeTransitionToUrl(result, searchValue) {
      const currentParams = $location.search();
      const filterStringParam = encodeURIComponent(result.join('&'));

      if (filterStringParam) {
        currentParams.filter = encodeURIComponent(result.join('&'));
      } else {
        _.unset(currentParams, 'filter');
      }

      if (searchValue) {
        currentParams.gridSearch = encodeURIComponent(searchValue);
      } else {
        _.unset(currentParams, 'gridSearch');
      }

      $location.search(currentParams);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('urlMappingRules', urlMappingRules);

  /** @ngInject */
  function urlMappingRules(
    BOOLEAN_FILTER_VALUES,
    AdpValidationUtils
  ) {
    // REFACTOR: apply same pattern as to transformers
    // REFACTOR: for [filter.fieldName, filter.value] filter.fieldName to reusable function and map with function value only
    function getRangeValue(values, fieldName) {
      var result = [];
      if (!_.isNil(values[0])) {
        result.push([fieldName + 'From', values[0]].join('='));
      }

      if (!_.isNil(values[1])) {
        result.push(([fieldName + 'To', values[1]].join('=')));
      }

      return result.join('&');
    }

    function numberMapper(filter) {
      if (filter.operation === 'between') {
        return getRangeValue(filter.value, filter.fieldName);
      } else {
        return [filter.fieldName, filter.value].join('=');
      }
    }

    function datetimeMapper(filter) {
      if (filter.operation === 'between') {
        return getRangeValue(filter.value, filter.fieldName);
      } else {
        return [filter.fieldName, dayjs(filter.value).format(AdpValidationUtils.getDateFormat(filter.field.type))].join('=');
      }
    }

    function listMapper(filter) {
      const list = _.get(filter, 'field.list.values');
      // TEMP: until solution to set async values found
      if (_.isNil(list)) {
        return null;
      }

      return _.map(filter.value, (listKey) => {
        const listLabel = list[listKey];
        const listValue = filter.fieldName;
        return [listValue, listLabel].join('=');
      }).join('&');
    }

    function mapToImperialUnitMultiplePositions(filter) {
      if (filter.operation === 'between') {
        // temp workaround, when switching from any operation with filterValue
        // dx triggers change with wrong value
        // just skip and proceed with correct value
        if (_.isString(filter.value)) {
          return '';
        }

        var val = filter.value.map(function (v) {
          return _.isString(v) ? v : null;
        });

        return getRangeValue(val, filter.fieldName);
      } else {
        return [filter.fieldName, filter.value].join('=');
      }
    }

    function booleanMapper(filter) {
      var valueMap = {};
      valueMap[BOOLEAN_FILTER_VALUES.TRUE] = 'true';
      valueMap[BOOLEAN_FILTER_VALUES.FALSE] = 'false';

      var filterValueToSet = valueMap[filter.value];
      return [filter.fieldName, filterValueToSet].join('=');
    }

    function stringMapper(filter) {
      return [filter.fieldName, filter.value].join('=');
    }

    return {
      string: stringMapper,
      objectId: stringMapper,
      list: listMapper,
      dynamicList: listMapper,
      boolean: booleanMapper,
      triStateBoolean: booleanMapper,
      currency: numberMapper,
      percent: numberMapper,
      number: numberMapper,
      date: datetimeMapper,
      time: datetimeMapper,
      dateTime: datetimeMapper,
      imperialWeight: numberMapper,
      imperialWeightWithOz: mapToImperialUnitMultiplePositions,
      imperialHeight: mapToImperialUnitMultiplePositions,
      lookupObjectId: function (filter) {
        var fieldName = filter.field.fieldName;
        return filter.value.reduce(function (result, lookup) {
          result.push([fieldName + 'Table', lookup.table].join('='));
          result.push([fieldName + 'Id', lookup._id].join('='));
          result.push([fieldName + 'Label', lookup.label].join('='));

          return result;
        }, []).join('&');
      },
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('FilterUrlParser', FilterUrlParser);

  /** @ngInject */
  function FilterUrlParser(
    GridFilterHelpers,
    AdpFieldsService,
    AdpSchemaService,
    FilterOperation,
    $state,
    transformFilterValueFromUrl
  ) {
    return function (schema) {
      const parsedFilters = parseFilterFromUrl();

      return {
        filters: transformToFilters(parsedFilters, schema),
        search: $state.params.gridSearch ? decodeURIComponent($state.params.gridSearch) : '',
        showHiddenFields: Boolean($state.params.noLsFilter),
      };
    };

    function parseFilterFromUrl() {
      var decodedFilterKeyValPairs = (decodeURIComponent($state.params.filter) || '').split('&');
      var result = {};

      _.each(decodedFilterKeyValPairs, function (keyVal) {
        var keyValPair = keyVal.split('=');
        var key = keyValPair[0];
        var val = keyValPair[1];

        if (_.isNil(val)) {
          return;
        }

        var current = result[key];
        if (_.isNil(current)) {
          result[key] = val;
        } else {
          if (!_.isArray(current)) {
            result[key] = [current];
          }
          result[key].push(val);
        }
      });

      return result;
    }

    function transformToFilters(parsedFilters, schema) {
      var result = {};

      _.each(schema.fields, function (field) {
        if (!field.showInDatatable) {
          return;
        }

        var fieldName = field.fieldName;
        var operation = parseAndValidateOperation(parsedFilters[fieldName + 'Operation'], field);
        var filterValue = getFilterValue(parsedFilters, operation, field);

        if (!filterValue) {
          return;
        }

        var transformedValue = transformFilterValueFromUrl(filterValue, operation, field);
        if (_.isNil(transformedValue)) {
          return;
        }

        result[fieldName] = { value: transformedValue };

        if (!_.isNil(operation)) {
          result[fieldName].operation = operation;
        }
      });

      return result;
    }

    function getFilterValue(filters, operation, field) {
      var fieldName = field.fieldName;

      if (operation === 'between') {
        return getRangeValue(filters, fieldName);
      } else if (AdpSchemaService.isLookup(field.type)) {
        return getLookupValue(filters, fieldName);
      } else {
        return getSingleValue(filters, field);
      }
    }

    function getRangeValue(filters, fieldName) {
      var result = [undefined, undefined];

      var rangeStart = unwrapArray(filters[fieldName + 'From']);
      rangeStart && (result[0] = rangeStart);

      var rangeEnd = unwrapArray(filters[fieldName + 'To']);
      rangeEnd && (result[1] = rangeEnd);

      return result;
    }

    function getSingleValue(filters, field) {
      var value = filters[field.fieldName];

      if (arrayExpected(field)) {
        return wrapArray(value);
      } else {
        return unwrapArray(value);
      }
    }

    function getLookupValue(filters, fieldName) {
      var tables = wrapArray(filters[fieldName + 'Table']);
      var ids = wrapArray(filters[fieldName + 'Id']);
      var labels = wrapArray(filters[fieldName + 'Label']);

      return tables.map(function (table, index) {
        return {
          table: table,
          _id: ids[index],
          label: labels[index],
        }
      });
    }

    function arrayExpected(field) {
      if (field.list) {
        return true;
      }

      return false;
    }

    function unwrapArray(value) {
      if (_.isArray(value)) {
        return _.first(value);
      }

      return value;
    }

    function wrapArray(value) {
      if (_.isArray(value)) {
        return value;
      }

      return [value];
    }

    function parseAndValidateOperation(operation, field) {
      if (!operation) {
        return null;
      }
      var decodedOperation = FilterOperation.decode(operation);

      return FilterOperation.getValidOperation(decodedOperation, field);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('transformFilterValueFromUrl', transformFilterValueFromUrl);

  /** @ngInject */
  function transformFilterValueFromUrl(
    BOOLEAN_FILTER_VALUES,
    GridFilterHelpers,
    AdpFieldsService,
    AdpListsService,
    AdpValidationUtils
  ) {
    var transformers = {
      currency: [transformToNumber],
      percent: [transformToNumber],
      number: [transformToNumber],
      date: [transformToDate],
      time: [transformToTime],
      dateTime: [transformToDate],
      imperialWeight: [
        transformToNumber,
        function (value, field) {
          var units = AdpFieldsService.getUnits(field);
          if (!isValidForRange(value, units[0].range)) {
            return null;
          }

          return value;
        }
      ],
      string: [transformToString],
      objectId: [transformToString],
      boolean: [transformToBoolean],
      triStateBoolean: [transformToBoolean],
      list: [transformToList],
      dynamicList: [transformToList],
      imperialHeight: [
        transformToImperialUnitMultiplePositions,
        validateRangeImperialUnitMultiplePositions,
      ],
      imperialWeightWithOz: [
        transformToImperialUnitMultiplePositions,
        validateRangeImperialUnitMultiplePositions,
      ],
      lookupObjectId: [validateLookupValues],
    };

    return function (value, operation, field) {
      if (operation === 'between') {
        var result = value.map(function (val) {
          return runTransformersPipe(val, field);
        });

        return _.compact(result).length === 0 ? null : result;
      } else {
        return runTransformersPipe(value, field);
      }
    };

    function runTransformersPipe(value, field) {
      var transformers = getTransformers(field);

      var transformedValue = value;
      for (var i = 0; i < transformers.length; i++) {
        transformedValue = transformers[i](transformedValue, field);

        if (_.isNil(transformedValue)) {
          return null;
        }
      }

      return transformedValue
    }

    function getTransformers(field) {
      var filterRenderer = GridFilterHelpers.getFilterRenderer(field);
      if (!filterRenderer) {
        return [];
      }
      return transformers[filterRenderer.value] || [];
    }

    function transformToNumber(value) {
      var result = Number(value);
      return _.isNaN(result) ? null : result;
    }

    function transformToList(value, field) {
      var valuesByLabel = AdpListsService.getListValueByLabel(value, field.list.values);
      return valuesByLabel.length === 0 ? null : valuesByLabel;
    }

    function transformToDate(value, field) {
      var format = AdpValidationUtils.getDateFormat(field.type);
      var result = dayjs(value, format).toDate();

      return !result.getTime() ? null : result;
    }

    function transformToTime(value, field) {
      const format = AdpValidationUtils.getDateFormat(field.type);
      // type:Time base date is 2000-02-02. Check docs for explanation
      // https://outline.craftus.com/doc/handling-dates-and-time-in-different-timezones-dfagbWEqrt#h-time
      const dj = dayjs(value, format).set('year', 2000).set('month', 1).set('date', 2);
      if (!dj.isValid()) {
        return null;
      }

      return dj.format("YYYY-MM-DDTHH:mm:ss.000Z");
    }

    function isValidForRange(value, range) {
      // TODO: should set from service
      // filter zero value is allowed
      var begin = 0;
      var end = range[1];

      return value >= begin && value <= end;
    }

    function transformToImperialUnitMultiplePositions(value) {
      var result = (value || '').split('.').map(transformToNumber);
      var filtered = _.filter(result, _.isNumber);
      var atLeastOneInvalid = filtered.length !== 2;

      return atLeastOneInvalid ? null : value;
    }

    function validateRangeImperialUnitMultiplePositions(value, field) {
      var units = AdpFieldsService.getUnits(field);
      var valueAsNumbers = value.split('.');

      var filtered = units.filter(function (unit, index) {
        return isValidForRange(valueAsNumbers[index], unit.range);
      });

      return filtered.length === 2 ? value : null;
    }

    function transformToBoolean(value) {
      var allowedTruthyValues = ['1', 'true'];
      var allowedFalsyValue = ['0', 'false'];

      if (allowedTruthyValues.includes(value)) {
        return BOOLEAN_FILTER_VALUES.TRUE;
      } else if (allowedFalsyValue.includes(value)) {
        return BOOLEAN_FILTER_VALUES.FALSE;
      } else {
        return null;
      }
    }

    function transformToString(value) {
      return !!value ? value : null;
    }

    function validateLookupValues(value, field) {
      var ID_REGEX = /^[a-f\d]{24}$/i;

      var results = [];
      value.forEach(function (lookup) {
        if (!ID_REGEX.test(lookup._id)) {
          return;
        }

        if (invalidTable(lookup.table, field)){
          return;
        }

        if (!lookup.label) {
          return;
        }

        results.push(lookup);
      });

      return results.length > 0 ? results : null;
    }

    function invalidTable(table, field) {
      var tableNames = Object.keys(field.lookup.table);

      return !tableNames.includes(table);
    }
  }
})();
;;(function () {
  angular
    .module('app.adpDataGrid')
    .constant('NOT_SET_FILTER_VALUE', '<not set>')
    .constant('BOOLEAN_FILTER_VALUES', {
      'TRUE': 'TRUE_VALUE',
      'FALSE': 'FALSE_VALUE',
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('BooleanFilter', BooleanFilter);

  /** @ngInject */
  function BooleanFilter(
    DxEditorMixin,
    BasicTypesCellRenderer,
    BOOLEAN_FILTER_VALUES
  ) {
    function getOptions(init) {
      return {
        elementAttr: {
          class: 'adp-select-box',
          id: 'list_id_' + init.args.fieldSchema.fieldName,
        },
        value: init.args.data,
        displayExpr: 'label',
        valueExpr: 'value',
        placeholder: '(All)',
        items: getDataSource(),
        onValueChanged: init.onValueChanged,
        valueChangeEvent: 'change',
        showClearButton: true,
      };
    }

    function getDataSource() {
      return [
        { label: 'Yes', value: BOOLEAN_FILTER_VALUES.TRUE },
        { label: 'No', value: BOOLEAN_FILTER_VALUES.FALSE },
      ];
    }

    return function () {
      return DxEditorMixin({
        editorName: 'dxSelectBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },

        formatValue: function(params){
          return BasicTypesCellRenderer.boolean(params.args);
        }
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('CurrencyFilter', CurrencyFilter);

  /** @ngInject */
  function CurrencyFilter(
    DX_ACCOUNTING_FORMAT,
    AdpFieldsService,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions(init));
        },

        getOptions: function (init) {
          var changeHandler = _.debounce(init.onValueChanged, 300);

          return {
            onValueChanged: function (e) {
              if (e.value === 0 && _.isNumber(e.previousValue)) {
                // update on next change event fired
                e.component.option('value', null);
              } else {
                changeHandler(e);
              }
            },
            value: init.args.data,
            valueChangeEvent: 'blur input',
            placeholder: init.placeholder,
            inputAttr: {
              autocomplete: AdpFieldsService.autocompleteValue(init.args.fieldSchema),
            },
            showSpinButtons: true,
            format: _.get(init, 'args.fieldSchema.parameters.format', DX_ACCOUNTING_FORMAT),
          }
        },
      });
    };
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpDataGrid")
    .factory("DatabaseFieldFilter", DatabaseFieldFilter);

  /** @ngInject */
  function DatabaseFieldFilter(
    AdpFieldsService,
    DxEditorMixin,
    CustomFilterTypesValidatorService
  ) {
    return function () {
      return DxEditorMixin({
        editorName: "dxSelectBox",

        create: function (params) {
          var options = getOptions(params);

          this.element = $("<div>");
          this.element[this.editorName](options)
            .dxValidator({
              validationRules: getValidators(params)
            });
        },
      });
    };

    function getOptions(params) {
      var items = params.args.modelSchema.fields;

      items = _.filter(items, function (item) {
        return item.showInDatatable && item.fieldName !== params.dataField
      });
      items = _.map(items, function (item) {
        return {
          value: item.fieldName,
          text: item.fullName
        }
      })

      return {
        items: items,
        onValueChanged: params.onValueChanged,
        value: params.args.data,
        valueExpr: "value",
        displayExpr: "text",
        valueChangeEvent: "blur input",
        placeholder: params.placeholder,
        elementAttr: {
          class: "adp-custom-type-value-controller adp-database-field-text-box"
        },
      }
    }

    function getValidators(params) {
      return [{
        type: "async",
        message: "",
        validationCallback: function (event) {
          var valueToValidate = [params.dataField, params.filterOperation, event.value];

          return CustomFilterTypesValidatorService(params.args.modelSchema.schemaName, "Database Field", valueToValidate, event.rule);
        }
      }]
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DateFilter', DateFilter);

  /** @ngInject */
  function DateFilter(
    AdpSchemaService,
    DxEditorMixin,
    DateTypesCellRenderer,
    AdpValidationUtils
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxDateBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](getOptions(init));
        },

        formatValue: function(params) {
          return DateTypesCellRenderer.date(params.args);
        },
      });
    };

    function momentToDxFormatConvert(format) {
      return format
        .replace(/D/g, 'd')
        .replace(/Y/g, 'y');
    }

    function getOptions(init) {
      var fieldType = init.args.fieldSchema.type;
      var momentFormat = AdpValidationUtils.getDateFormat(fieldType);
      var INPUT_TIMEOUT = 1500; //Have to be long enough to let user enter full date/time w/o onValueChanged called

      return {
        type: fieldType.toLowerCase(),
        placeholder: init.placeholder || momentFormat,
        displayFormat: momentToDxFormatConvert(momentFormat),
        showAnalogClock: false,
        tabIndex: 0,
        value: init.args.data,
        valueChangeEvent: 'change keyup input blur',
        useMaskBehavior: true,
        onValueChanged: init.parentType === 'filterBuilder' ?
          onValueChanged :
          _.debounce(onValueChanged, INPUT_TIMEOUT),
        pickerType: _.get(init, 'args.fieldSchema.parameters.pickerType'),
        openOnFieldClick: _.get(init, 'args.fieldSchema.parameters.openOnFieldClick', false)
      };

      function onValueChanged(e) {
        if (e.value) {
          let dj = dayjs(e.value);
          if (fieldType === 'Time') {
            // type:Time base date is 2000-02-02. Check docs for explanation
            // https://outline.craftus.com/doc/handling-dates-and-time-in-different-timezones-dfagbWEqrt#h-time
            dj = dj.set('year', 2000).set('month', 1).set('date', 2);
          } else {
            dj = dayjs(dj.format(momentFormat), momentFormat);
          }
          e.value = dj.format("YYYY-MM-DDTHH:mm:ss.000Z"); // Format have to contain timezone info for correct type:Time filtration
        }

        init.onValueChanged(e);
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('DecimalFilter', DecimalFilter);

  /** @ngInject */
  function DecimalFilter(DxEditorMixin) {
    function getOptions(init) {
      return {
        mode: 'text',
        onValueChanged: _.debounce(init.onValueChanged, 300),
        value: init.args.data,
        valueChangeEvent: 'blur input',
        onKeyPress: function(e) {
          var isDecimalChar = /(\+|-|\.|\d)/.test(e.event.key);
          if (!isDecimalChar) {
            e.event.preventDefault();
          }
        },
        onPaste: function (e) {
          e.event.preventDefault();
          var pasteText = e.event.originalEvent.clipboardData.getData('text');
          this.option('value', pasteText.replace(/[^0-9.\-+]/g, ''));
        }
      };
    }

    return function () {
      return DxEditorMixin({
        editorName: 'dxTextBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }
  }
})();
;;(function () {
  'use strict';

  window.ace.require('mongodb-ace-mode/index');
  window.ace.require('mongodb-ace-theme');

  angular
    .module('app.adpDataGrid')
    .factory('MongoExpressionFilter', MongoExpressionFilter);

  /** @ngInject */
  function MongoExpressionFilter(
    AdpFieldsService,
    DxEditorMixin,
    CustomFilterTypesValidatorService,
    MongoMode
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxTextArea',

        create(params) {
          const options = {
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            maxLines: 10,
            minLines: 4,
            theme: 'ace/theme/mongodb',
          };

          const initialValue = params.args.data;
          const $editorEl = $('<div class="adp-mongo-editor">').text(initialValue);
          const $validationEl = $('<div class=adp-mongo-validation">');
          const aceEditor = window.ace.edit($editorEl[0]);

          this.element = $('<div class="adp-custom-type-value-controller adp-mongo-expression-box">')
            .on('remove', () => {
              aceEditor && aceEditor.destroy();
            })
            .append($editorEl, $validationEl);

          aceEditor.setOptions(options);
          aceEditor.session.setMode(new MongoMode());

          initialValue && doValidation($validationEl, initialValue);

          function doValidation($elem, value) {
            const rule = { message: '' };

            if (!value) {
              return;
            }

            CustomFilterTypesValidatorService(params.args.modelSchema.schemaName, 'Mongo Expression', value, rule)
              .then((isValid) => {
                $elem.text(rule.message)
                  .toggleClass('adp-is-invalid', !isValid)
              })
          }

          aceEditor.session.on('change', () => {
            const value = aceEditor.getValue();
            const fakeEvent = { value };

            doValidation($validationEl, value);
            params.onValueChanged(fakeEvent);
          });

          $editorEl.on('keyup', (e) => {
            const { keyCode } = e;
            if (keyCode === 13) {
              e.stopPropagation();
              e.preventDefault();
            }
          });
        }
      });
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('NumberFilter', NumberFilter);

  /** @ngInject */
  function NumberFilter(
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions(init));
        },

        getOptions: function (init) {
          var self = this;

          return {
            onKeyDown: function (e) {
              // WORKAROUND: to allow removing zero from input
              if (changedToNull(e.event)) {
                self.reset();
              }
            },
            onValueChanged: _.debounce(init.onValueChanged, 300),
            value: init.args.data,
            valueChangeEvent: 'blur input',
            placeholder: init.placeholder,
            format: {
              type: 'decimal'
            },
          }
        },
      });
    };

    function changedToNull(e) {
      if (e.key !== 'Backspace') {
        return false;
      }

      var input = e.target;
      var hasSingleChar = input.value.length === 1 && input.selectionStart === 1;
      var hasSingleNegativeChar = /\-\d/.test(input.value) && input.selectionStart === 2;
      var allTextSelected = input.value.length === (input.selectionEnd - input.selectionStart);

      return hasSingleChar || hasSingleNegativeChar || allTextSelected;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('PercentFilter', PercentFilter);

  /** @ngInject */
  function PercentFilter(
    DX_PERCENT_FORMAT,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxNumberBox',

        create: function (init) {
          this.element = $('<div>');
          this.element[this.editorName](this.getOptions(init));
        },

        getOptions: function (init) {
          var self = this;

          return {
            onKeyDown: function (e) {
              // WORKAROUND: to allow removing zero from input
              if (changedToNull(e.event)) {
                self.reset();
              }
            },
            onValueChanged: _.debounce(init.onValueChanged, 300),
            value: init.args.data,
            valueChangeEvent: 'blur input',
            placeholder: init.placeholder,
            format: DX_PERCENT_FORMAT,
          }
        },
      });
    };

    function changedToNull(e) {
      if (e.key !== 'Backspace') {
        return false;
      }

      var input = e.target;
      var hasSingleChar = input.value.length === 1 && input.selectionStart === 1;
      var hasSingleNegativeChar = /\-\d/.test(input.value) && input.selectionStart === 2;
      var allTextSelected = input.value.length === (input.selectionEnd - input.selectionStart);

      return hasSingleChar || hasSingleNegativeChar || allTextSelected;
    }
  }
})();
;;(function () {
  "use strict";

  angular
    .module("app.adpDataGrid")
    .factory("RelativeDateFilter", RelativeDateFilter);

  /** @ngInject */
  function RelativeDateFilter(
    AdpFieldsService,
    CustomFilterTypesValidatorService,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: "dxTextBox",

        create: function (params) {
          var options = getOptions(params);

          this.element = $("<div>");
          this.element[this.editorName](options)
            .dxValidator({
              validationRules: getValidators(params)
            });
        },
      });
    };

    function getOptions(params) {
      return {
        onValueChanged: params.onValueChanged,
        value: params.args.data,
        valueChangeEvent: "blur input",
        placeholder: params.placeholder,
        elementAttr: {
          class: "adp-custom-type-value-controller adp-relative-date-text-box"
        },
      }
    }

    function getValidators(params) {
      return [{
        type: "async",
        message: "",
        validationCallback: function (event) {
          var valueToValidate = [params.dataField, params.filterOperation, event.value];

          return CustomFilterTypesValidatorService(params.args.modelSchema.schemaName, "Relative Date", valueToValidate, event.rule);
        }
      }]
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('StringFilter', StringFilter);

  /** @ngInject */
  function StringFilter(DxEditorMixin) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxTextBox',

        create: function (init) {
          var options = getOptions(init);
          this.element = $('<div>');

          this.element[this.editorName](options);
        },
      });
    }

    function getOptions(init) {
      var INPUT_TIMEOUT = 300;
      var type = init.args.fieldSchema.type;
      return {
        mode: getTextMode(type),
        onValueChanged: _.debounce(init.onValueChanged, INPUT_TIMEOUT),
        value: init.args.data,
        valueChangeEvent: 'change input',
      };
    }

    function getTextMode(type) {
      var types = {
        'Email': 'email',
        'PasswordAuth': 'password',
        'Url': 'url',
      };

      return types[type] || 'text';
    }}
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormActions', adpFormActions);

  function adpFormActions(AdpIconsHelper, ActionsHelpers) {
    return {
      restrict: 'E',
      scope: false,
      templateUrl: 'app/adp-forms/directives/adp-form/adp-form-actions/adp-form-actions.html',
      link: function (scope) {
        scope.actions = {};

        setActionsToScope();

        function setActionsToScope() {
          scope.actions = _
            .chain(scope)
            .get('args.modelSchema.actions.fields')
            .pickBy(action => ActionsHelpers.isActionAllowed(action, 'form.bottom'))
            .mapValues(evalAction)
            .entries()
            .orderBy(['[1].actionOrder'], ['asc'])
            .fromPairs()
            .value();
        }

        function evalAction(action) {
          const evaledAction = _.cloneDeep(action);
          const btnType = _.get(evaledAction, 'htmlAttributes.type', 'button');
          let className = _.get(evaledAction, 'htmlAttributes.className');

          _.set(evaledAction, 'htmlAttributes.type', btnType);
          _.set(evaledAction, 'htmlAttributes.style', getActionStyles(evaledAction));

          if (_.isNil( className )) {
             className = action.action.type === 'link' ? 'btn form-footer-link' : 'adp-action-b-tertiary';
          }

          _.set(evaledAction, 'className', className);

          return evaledAction;
        }

        scope.fullNameGetter = function fullNameGetter(action) {
          return action.fullName.type === 'function' ?
            evalProperty(action, 'fullName.code', 'Action') :
            action.fullName;
        }

        scope.visibleGetter = function visibleGetter(action) {
          return _.isString(action.visible) ?
            evalProperty(action, 'visible', false) :
            action.visible || true;
        }

        scope.disabledState = function (action) {
          return ActionsHelpers.evalDisabledAttr(action, scope.args.row, scope.args.modelSchema);
        }

        scope.evalLink = (action) => {
          if (scope.disabledState(action)) {
            return '';
          }

          const link = _.get(action, 'action.link') || '';
          const dataRow = _.get(scope, 'args.row', {});
          return link.replace(/:([^\/]+)/g, (match, p1) => _.get(dataRow, p1));
        }

        function evalProperty(action, propertyPath, defaultValue) {
          try {
            var fn = new Function('return ' + _.get(action, propertyPath));
            return fn.call(scope.args);
          } catch (e) {
            console.error('Error evaluating "' + propertyPath + '"', e);
            if (_.isNil(defaultValue)) {
              return defaultValue;
            }
          }
        }

        scope.hasIcon = action => !_.isNil(action.icon);
        scope.getIcon = icon => _.get(AdpIconsHelper.getIconHtml(icon), '0.outerHTML', '');
        scope.hasFullName = action => !_.isNil(action.fullName);

        function getActionStyles(action) {
          var styles = _.pick(action, ['backgroundColor', 'borderColor', 'textColor']);

          return _.reduce(styles, function (result, value, key) {
            var objKey = key === 'textColor' ? 'color' : _.kebabCase(key);
            result += objKey + ': ' + value + ' !important;';

            return result;
          }, '');
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpFormActionHandler', AdpFormActionHandler);

  /** @ngInject */
  function AdpFormActionHandler(
    ClientError,
    $injector,
    ACTIONS,
    $q
  ) {
    return function (action) {
      try {
        return findAction(action);
      } catch (e) {
        if (e instanceof ClientError) {
          console.error(e);
          return defaultAction(action.type);
        } else {
          throw e;
        }
      }
    }

    function findAction(action) {
      var type = _.get(action, 'action.type');

      if (!_.includes(['module', 'action'], type)) {
        throw new ClientError('Unknown action type in action\n' + logAction(action));
      }

      var actionHandler = {
        module: selectModuleHandler,
        action: selectHelpersAction,
      };

      return actionHandler[type](action);
    }

    function selectModuleHandler(action) {
      var moduleName = _.get(action, 'action.link', null);
      if (!$injector.has(moduleName)) {
        throw new ClientError('Module not found: ' + moduleName + '\n' + logAction(action));
      }

      var module = $injector.get(moduleName);
      var methodName = _.get(action, 'action.method', null);
      var method = module[methodName];
      if (methodName && _.isNil(method)) {
        throw new ClientError('Method not found in module: ' + moduleName + '\n' + logAction(action));
      }

      return method || module;
    }

    function selectHelpersAction(action) {
      var handler = _.get(window, 'appModelHelpers.CustomActions.' + action.action.link);
      if (_.isNil(handler)) {
        throw new ClientError('CustomActionHelper not found for action: \n' + logAction(action));
      }

      return handler;
    }

    function logAction(action) {
      return JSON.stringify(action, null, 2);
    }

    function defaultAction(type) {
      if (type === 'module') {
        return $q.resolve;
      } else if (type === 'action') {
        return _.noop;
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('booleanControl', booleanControl);

  function booleanControl(
    AdpValidationUtils,
    ControlSetterGetter,
    $timeout
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/boolean-control/boolean-control.html',
      require: '^^form',
      link: function (scope, el, attr, formCtrl) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.controlId = scope.$id + scope.args.fieldSchema.fieldName;

        (function init() {
          overrideRequiredValidator();
          const field = scope.args.fieldSchema;
          const value = !!getterSetterFn();
          getterSetterFn(value);

          const widgetConfig = {
            value,
            switchedOnText: 'YES',
            switchedOffText: 'NO',
            onInitialized: function (e) {
              scope.instance = e.component;
            },
            onValueChanged: function (e) {
              mapValueToModel(e.value);
            },
            elementAttr: {
              class: 'adp-switch',
              'field-name-input': field.fieldName,
              id: field.fieldName,
              'adp-qaid-field-control': scope.args.path,
              'dx-switch': field.fieldName,
            }
          };
          el.find('div').dxSwitch(widgetConfig);

          scope.$on('$destroy', function () {
            scope.instance.dispose();
          });

          $timeout(() => {
            const fieldModel = formCtrl[scope.args.fieldSchema.fieldName];
            fieldModel.$render = () => {
              const val = _.get(scope.args.row, scope.args.path);
              scope.instance.option('value', val);
            }
          });
        })();

        function overrideRequiredValidator() {
          const control = formCtrl[scope.args.fieldSchema.fieldName];
          control.$isEmpty = v => v !== true;
        }

        function mapValueToModel(value) {
          getterSetterFn(!!value);
        }
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('adpAceJshintOptions', {
      esversion: 11,
      moz: true,
      devel: true,
      browser: true,
      node: true,
      laxcomma: true,
      laxbreak: true,
      lastsemic: true,
      onevar: false,
      passfail: false,
      maxerr: 100,
      expr: true,
      multistr: true,
      globalstrict: true,
      debug: true,
      asi: true
    });
})();
;(function () {
  "use strict";

  angular
    .module('app.adpForms')
    .directive('adpAce', adpAce);

  function adpAce(
    PythonEditorMode,
    Json5onEditorMode,
    MongoMode,
    adpAceJshintOptions
  ) {
    return {
      restrict: 'E',
      scope: {
        editorsConfig: '=',
        editorId: '=',
      },
      require: 'ngModel',
      link(scope, element, attrs, ngModel) {
        function getEditor() {
          return editorsInstance;
        }

        var editorsInstance = null;
        scope.$watch('editorsConfig', initEditor);

        function initEditor(config) {
          if (editorsInstance !== null) {
            editorsInstance.destroy();
          }

          setHtmlForEditor();
          editorsInstance = enableEditor();
          setOptions(editorsInstance, config);
          bindEvents(config.mode);
          scope.selectedMode = setMode(config.mode);
          scope.isAlwaysValid = !['ace/mode/json5', 'ace/mode/mongodb', 'ace/mode/sql'].includes(scope.selectedMode);

          if (isJsonMode(config.mode)) {
            (ngModel.$viewValue !== '') && editorsInstance.session.setValue(JSON5.stringify(ngModel.$viewValue, null, 4));
          } else {
            editorsInstance.session.setValue(ngModel.$viewValue);
          }
        }

        function setHtmlForEditor() {
          element[0].innerHTML = '<div adp-qaid-field-control="' + scope.editorId + '" adp-editor-id="' + scope.editorId + '"></div>';
        }

        function enableEditor() {
          var editorElement = element[0].querySelector('[adp-editor-id="' + scope.editorId + '"]');
          return window.ace.edit(editorElement);
        }

        function setOptions(editor, userConfig) {
          const defaults = {
            enableBasicAutocompletion: false,
            enableSnippets: true,
            enableLiveAutocompletion: true,
            maxLines: 30,
            minLines: 10,
            useSoftTabs: true,
            autoScrollEditorIntoView: true,
          };

          const { aceTheme } = window.forcedThemes || window.adpAppStore.appInterface();
          const themeConfig = aceTheme ? { theme: 'ace/theme/' + aceTheme } : {};

          const opts = _.assign({},
            defaults,
            themeConfig,
            userConfig
          );
          _.unset(opts, 'mode');
          editor.setOptions(opts);
        }

        function setMode(editorsMode) {
          var mode = editorsMode || 'ace/mode/python';

          var modes = {
            'ace/mode/python': PythonEditorMode,
            'ace/mode/json5': Json5onEditorMode,
            'ace/mode/mongodb': MongoMode,
          };

          // ace caches session, { path, v } allows to force set mode
          // details: https://stackoverflow.com/a/22175976/4575370
          var defaultMode = { path: mode, v: Date.now() };

          var selectedMode = !!modes[mode] ? (new modes[mode]()) : defaultMode;
          editorsInstance.session.setMode(selectedMode);
          return selectedMode;
        }

        function bindEvents(mode) {
          var editor = getEditor();
          var session = editor.session;

          session.on('change', function () {
            var newValue = session.getValue();

            if (ngModel && newValue !== ngModel.$viewValue &&
              // HACK make sure to only trigger the apply outside of the
              // digest loop 'cause ACE is actually using this callback
              // for any text transformation !
              !scope.$$phase && !scope.$root.$$phase) {
              scope.$evalAsync(function () {
                isJsonMode(mode) ?
                  setJsonValue(newValue) :
                  ngModel.$setViewValue(newValue);
              });
            }
          });

          // https://stackoverflow.com/a/10667290/4575370
          session.on('changeAnnotation', () => {
            const annotations = editor.getSession().getAnnotations();

            if (scope.isAlwaysValid) {
              ngModel.$setValidity('syntaxCodeEditorError', true);
              return
            }
            const isValid = !_.find(annotations, ({ type }) => type === 'error');
            ngModel.$setValidity('syntaxCodeEditorError', isValid);
          });

          scope.$on('$destroy', function () {
            editor.destroy();
          });

          session.on('changeMode', function () {
            const mode = session.getMode().$id;
            if ('ace/mode/javascript' !== mode) {
              return;
            }

            session.$worker && session.$worker.send('setOptions', [adpAceJshintOptions]);
          });
        }

        function isJsonMode(mode) {
          return mode === 'ace/mode/json5';
        }

        function setJsonValue(value) {
          if (!value) {
            ngModel.$setViewValue(null);
            return;
          }

          var parsed = _.attempt(JSON5.parse, value);
          if (_.isError(parsed)) {
            return;
          }

          ngModel.$setViewValue(parsed);
        }
      }
    };
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('codeControl', codeControl);

  function codeControl(
    AdpValidationUtils,
    ControlSetterGetter,
    Guid
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/code-control/code-control.html',
      require: '^^form',
      link: function (scope, el, attr, formCtrl) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;
        if (_.isNil(getterSetterFn())) {
          getterSetterFn('');
        }

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.editorsConfig = _.get(scope, 'args.fieldSchema.parameters.codeEditor', {});
        scope.editorId = [scope.args.fieldSchema.fieldName, scope.$id, Guid.create()].join('_');

        if (scope.args.fieldSchema.type === 'Mixed') {
          scope.editorsConfig.mode = 'ace/mode/json5';
        }

        const fieldModel = formCtrl[scope.args.fieldSchema.fieldName];
        fieldModel.$render = function () {
          const aceEl = document.querySelector(`[adp-editor-id="${scope.editorId}"]`);
          const aceInstance = window.ace.edit(aceEl);
          const val = _.get(scope.args.row, scope.args.path);

          const isJsonMode = scope.editorsConfig.mode === 'ace/mode/json5';
          if (isJsonMode) {
            const valueForJson = val === '' ? val : JSON5.stringify(val, null, 4);
            aceInstance.session.setValue(valueForJson);
          } else {
            aceInstance.session.setValue(val);
          }
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ArrayColorUtil', ArrayColorUtil);

  /** @ngInject **/
  function ArrayColorUtil(
    COLOR_FIELD_NAME_IN_META,
    AdpRecordMeta
  ) {
    const getPathToColor = (path) => `${COLOR_FIELD_NAME_IN_META}.${path}`;
    const getColorForArrayItem = (args) => AdpRecordMeta.get(args, getPathToColor(args.path));
    const setColorForArrayItem = (color, args) => {
      const colorToSet = color ?? null;
      AdpRecordMeta.set(args, getPathToColor(args.path), colorToSet);
      return colorToSet;
    };

    const getColorsForPicker = () => {
      const lightColor = [
        '#f5d7be',
        '#ffb74e',
        '#e1bf9c',
        '#f9d8a2',
        '#d9cfc6',
        '#b8b0d5',
        '#ff874f',
        '#b8dbec',
        '#fff078',
        '#f7f4e3',
        '#c4d240',
      ];

      const darColorsRgbs = [
        [0, 0, 0],
        [171, 150, 133],
        [178, 128, 54],
        [157, 133, 109],
        [174, 151, 113],
        [151, 144, 138],
        [128, 123, 149],
        [178, 94, 55],
        [128, 153, 165],
        [178, 168, 84],
        [172, 170, 158],
        [137, 147, 44],
      ]

      return [
        null,
        ...lightColor,
        ...darColorsRgbs.map(([red, green, blue]) => `rgba(${red}, ${green}, ${blue})`)
      ];
    };

    return {
      getColor: getColorForArrayItem,
      setColor: setColorForArrayItem,
      getColorsForPicker,
      getPathToColor
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .controller('ArrayCommonController', ArrayCommonController);

  /** @ngInject */
  function ArrayCommonController(
    $scope,
    ControlSetterGetter,
    ObjectId,
    visibilityUtils,
    AdpFieldsService,
    AdpFormService,
    ComplexObjectUtil,
    COLOR_FIELD_NAME_IN_META,
    ArrayColorUtil,
    AdpRecordMeta
  ) {
    $scope.arrayFields = AdpFieldsService.getComplexObjectsFields($scope.args.fieldSchema.fields);
    $scope.getterSetter = ControlSetterGetter($scope.args);
    $scope.visibilityStatus = [];
    $scope.isArray = _.includes(['Array', 'AssociativeArray'], $scope.args.fieldSchema.type);

    $scope.setData = setData;
    $scope.getData = getData;
    $scope.isEmpty = isEmpty;
    $scope.addArrayItem = addArrayItem;
    $scope.cloneItem = cloneItem;
    $scope.remove = remove;
    $scope.isRemoveDisabled = isRemoveDisabled;
    $scope.disableMoveToTop = disableMoveToTop;
    $scope.disableMoveToBottom = disableMoveToBottom;
    $scope.moveToTop = moveToTop;
    $scope.moveToBottom = moveToBottom;
    $scope.hasVisibleItems = hasVisibleItems;
    $scope.toggle = toggle;
    $scope.toArray = function () {
      setKeysToAssociativeArray();
      setIdsToData();
    };

    $scope.init = function () {
      $scope.toArray();

      if (isEmpty()) {
        setData([]);
      } else {
        $scope.visibilityStatus = getData().map(() => ComplexObjectUtil.isExpanded($scope.args));
      }

      // WORKAROUND or HACK: updating $scope.arrayData reference on external array data change
      $scope.$on('afterCopyPasteAction', () => {
        const currentArrayData = getData();
        setData(currentArrayData);
      });
    }

    function getData() {
      // keeping reference, required for ng-repeat to
      $scope.arrayData = $scope.getterSetter();
      return $scope.arrayData;
    }

    function setData(value) {
      return $scope.getterSetter(value);
    }

    function isEmpty() {
      var data = getData();
      return _.isNil(data) || _.isEmpty(data);
    }

    function addArrayItem() {
      const fieldData = getData();
      const data = AdpFormService.getDefaultsForFields($scope.args);
      data._id = ObjectId();
      fieldData.push(data);
      $scope.visibilityStatus.push(true);
    }

    function cloneItem(event, index) {
      event.preventDefault();
      event.stopPropagation();

      const newItem = _.cloneDeep($scope.arrayData[index]);
      newItem._id = ObjectId();
      const insertItem = (index, targetArray, newItem) => {
        targetArray.splice(index, 0, newItem);
      };

      insertItem(index, $scope.arrayData, newItem);
      insertItem(index, $scope.visibilityStatus, false);
      const colors = ArrayColorUtil.getColor($scope.args);
      insertItem(index, colors, colors[index]);
    }

    function remove(event, index) {
      event.preventDefault();
      event.stopPropagation();

      getData().splice(index, 1);
      $scope.visibilityStatus.splice(index,  1);
      AdpRecordMeta.unsetArrayItem($scope.args, $scope.args.path, index);
      unsetArrayItemColor(index);
    }

    function unsetArrayItemColor(index) {
      const pathToColors = `${COLOR_FIELD_NAME_IN_META}.${$scope.args.path}`;
      AdpRecordMeta.unsetArrayItem($scope.args, pathToColors, index);
    }

    function isRemoveDisabled() {
      // kind of hack: checking if first element is required
      const requiredMap = $scope.formContext.requiredMap;
      const path = $scope.args.path + '[0]';
      const isFirstRequired = requiredMap[path];
      const hasOneItem = getData().length === 1;

      return isFirstRequired && hasOneItem;
    }

    function setKeysToAssociativeArray() {
      const { type } = $scope.args.fieldSchema;

      if (type === 'AssociativeArray') {
        const data = _.map(getData(), (item, key) => ({ $key: key, ...item }));
        setData(data);
      }
    }

    function setIdsToData() {
      const arrayValue = getData() || [];
      const data = _.map(arrayValue, (item) => {
        const { _id } = item;
        return !!_id ? item : { ...item, _id: ObjectId() };
      });

      setData(data);
    }

    function disableMoveToTop(index) {
      return getData().length === 1 || index === 0;
    }

    function disableMoveToBottom(index) {
      return getData().length === 1 || index === getData().length - 1;
    }

    function moveToTop(event, index) {
      event.preventDefault();
      event.stopPropagation();

      moveToFirstPosition(getData());
      moveToFirstPosition($scope.visibilityStatus);

      function moveToFirstPosition(list) {
        var itemToMove = list.splice(index, 1)[0];
        list.unshift(itemToMove);
      }
    }

    function moveToBottom(event, index) {
      event.preventDefault();
      event.stopPropagation();

      moveToLastPosition(getData());
      moveToLastPosition($scope.visibilityStatus);

      function moveToLastPosition(list) {
        var itemToMove = list.splice(index, 1)[0];
        list.push(itemToMove);
      }
    }

    function hasVisibleItems() {
      return visibilityUtils.arrayHasVisibleChild($scope.args, $scope.formContext);
    }

    function toggle(event, index) {
      event.preventDefault();
      event.stopPropagation();

      $scope.visibilityStatus[index] = !$scope.visibilityStatus[index];
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ComplexObjectUtil', ComplexObjectUtil);

  /** @ngInject **/
  function ComplexObjectUtil() {
    const getFrameType = (args) => {
      return _.get(args, 'fieldSchema.parameters.frameType');
    };
    const getFrameClass = (args) => {
      const frameType = getFrameType(args);
      return `subform-frame-${frameType}`;
    };

    const isExpanded = (args) => {
      var frameType = _.get(args, 'fieldSchema.parameters.frameType');
      if (['none', 'border'].includes(frameType)) {
        return true;
      }

      return _.get(args, 'fieldSchema.parameters.expanded');
    };

    const getFrameContentClass = args => {
      return _.get(args, 'fieldSchema.parameters.frameType') === 'none' ? 'remove-padding' : '';
    }

    const addKeyValidators = args => {
      const keyValidators = {
        associativeArrayKeyUnique: {
          validator: 'associativeArrayKeyUnique',
          errorMessages: { default: 'The "key" must be unique' }
        },
      };
      const add = (name, validators) => {
        const hasValidator = validators.find(({ validator }) => validator === name);
        !hasValidator && validators.push(keyValidators[name]);
      }

      const validate = _.get(args, 'fieldSchema.fields._key.validate') || [];
      _.keys(keyValidators).forEach(vName => add(vName, validate));
      _.set(args, 'fieldSchema.fields._key.validate', validate);
    }

    return {
      getFrameType,
      getFrameClass,
      isExpanded,
      getFrameContentClass,
      addKeyValidators,
    };
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('cronExpressionControl', cronExpressionControl);

  function cronExpressionControl(
    AdpValidationUtils,
    ControlSetterGetter,
    AdpFieldsService
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/cron-expression-control/cron-expression-control.html',
      require: '^^form',
      link: function (scope, el, attrs, formCtrl) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        var templateDivs = $('.adp-form-fieldset>div', el);
        var $componentEl = $(templateDivs[0]);
        var $humanTextEl = $(templateDivs[1]);

        scope.getterSetter = getterSetterFn;
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.controlId = scope.$id + scope.args.fieldSchema.fieldName;

        scope.$on('$destroy', function () {
          getInstance().dispose();
        });

        $componentEl.dxTextBox(getConfig(scope.args));

        function getConfig(args) {
          var field = args.fieldSchema;
          var validateRegexp = getFieldValidationRegexp(field);
          var formField = formCtrl[field.fieldName];

          return {
            value: getterSetterFn() || null,
            onInitialized: function (e) {
              scope.instance = e.component;
              updateHumanReadableText(getterSetterFn());
            },
            onValueChanged: function (e) {
              getterSetterFn(e.value);
              setAngularFormProps(formField);
              updateHumanReadableText(e.value);
            },
            onInput: function (e) {
              updateHumanReadableText(e.event.target.value);
            },
            inputAttr: {
              autocomplete: AdpFieldsService.autocompleteValue(field),
              'field-name-input': field.fieldName,
              id: field.fieldName,
              'adp-qaid-field-control': args.path,
            },
            valueChangeEvent: 'input blur',
          };

          function updateHumanReadableText(value) {
            var isEmpty = !value;
            var humanReadable = 'Incorrect cron expression';

            if (isEmpty) {
              humanReadable = '';
            } else {
              var isValid = !validateRegexp  || !!value.match(validateRegexp);

              if (isValid) {
                try {
                  humanReadable = cronstrue.toString(value);
                } catch(e) {
                }
              }
            }

            $humanTextEl.text(humanReadable);
          }
        }

        function getInstance() {
          return scope.instance;
        }

        function setAngularFormProps(formField) {
          !formField.$dirty && formField.$setDirty();
          !formField.$touched && formField.$setTouched();
        }

        function getFieldValidationRegexp(field) {
          var validateRule = _.find(field.validate, function (rule) {
            return rule.validator === 'regex'
          });

          if (!validateRule) {
            return null;
          }

          var regex = _.get(validateRule, 'arguments.regex');
          var regexOptions = _.get(validateRule, 'arguments.regexOptions');

          if (regex) {
            return new RegExp(regex, regexOptions);
          }

          return null;
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('datetimeArrayControl', datetimeArrayControl);

  function datetimeArrayControl(
    StringArrayEditorConfig,
    DxDateConfig,
    AdpValidationUtils,
    AdpFieldsService,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/datetime-control/datetime-control.html',
      require: '^^form',
      link: function (scope) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = function (e) {
          if (arguments.length) {
            getterSetterFn(e.value);
          }
          return getterSetterFn();
        };

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.config = getFieldConfig();

        function getFieldConfig() {
          var fieldData = scope.getterSetter();
          var tagBoxConfig = getTagBoxConfig(scope.args, fieldData, scope.getterSetter);

          return AdpFieldsService.configFromParameters(scope.args.fieldSchema, tagBoxConfig);
        }

        var cmp;
        function getTagBoxConfig(args, fieldData, valueSetter) {
          var tagBoxConfig = StringArrayEditorConfig(args, fieldData, valueSetter);
          tagBoxConfig.onInitialized = function (e) {
            cmp = e.component;
          }
          tagBoxConfig.fieldTemplate = fieldTemplate;

          var tagTemplate = tagBoxConfig.tagTemplate;
          tagBoxConfig.tagTemplate = function (data, tagEl) {
            var dateTimeData = _.clone(data);
            dateTimeData.label = formatDate(dateTimeData.label, scope.args.fieldSchema.type);
            tagTemplate.call(this, dateTimeData, tagEl);
          }

          return tagBoxConfig;
        }


        function fieldTemplate(data, container) {
          var cfg = getFieldTemplateOptions(scope.args);
          var dateBox = $('<div class="adp-text-box">').dxDateBox(cfg);

          container.append(dateBox);
        }

        function getFieldTemplateOptions(args) {
          var fieldType = args.fieldSchema.type.replace('[]', '');
          var momentFormat = AdpValidationUtils.getDateFormat(fieldType);
          var dxFormat = momentFormat
            .replace(/D/g, 'd')
            .replace(/Y/g, 'y');

          return {
            type: fieldType.toLowerCase(),
            placeholder: momentFormat,
            displayFormat: dxFormat,
            showAnalogClock: false,
            valueChangeEvent: 'blur',
            useMaskBehavior: true,
            onFocusOut: setValueForTagComponent,
            showDropDownButton: false,
            openOnFieldClick: true,
          };
        }

        function formatDate(date, type) {
          var dateType = type.replace('[]', '');
          var format = AdpValidationUtils.getDateFormat(dateType);

          return dayjs(date).format(format);
        }

        function setValueForTagComponent(e) {
          // patch, which allows to trigger on value change for parent component - tagBox
          // refer to StringArrayEditorConfig comment for details
          var value = e.component.option('value');
          if (!value) {
            return;
          }

          var dataSource = cmp.option('dataSource');
          var itemWithMaxId = dataSource.length ?
            dataSource[dataSource.length - 1] :
            { id: -1 };

          dataSource.push({
            label: value,
            id: itemWithMaxId.id + 1,
          });

          cmp.option('dataSource', dataSource);
          cmp.option('value', _.range(0, dataSource.length));
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('decimalArrayControl', decimalArrayControl);

  function decimalArrayControl(
    AdpValidationUtils,
    AdpFieldsService,
    NumberArrayEditorConfig,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/decimal-array-control/decimal-array-control.html',
      require: '^^form',
      link(scope, element) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = function (e) {
          if (arguments.length) {
            getterSetterFn(e.value);
          }

          return getterSetterFn();
        };

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.config = getConfig(scope.args.fieldSchema);
        scope.$on('afterCopyPasteAction', () => {
          const currentArrayData = scope.getterSetter();
          const newDataSource = currentArrayData.map((item, index) => ({ label: item, id: index, }));
          const newValue = newDataSource.map((v, i) => i);

          const component = DevExpress.ui.dxTagBox.getInstance(element.find('div'));
          component.option('dataSource', newDataSource);
          component.option('value', newValue);
        });

        function getConfig(field) {
          var fieldData = scope.getterSetter();
          var baseConfig = NumberArrayEditorConfig(scope.args, fieldData, scope.getterSetter);
          AdpFieldsService.addOpenStatusBroadcast(scope, baseConfig);
          baseConfig.fieldTemplate = fieldTemplate;

          return AdpFieldsService.configFromParameters(field, baseConfig);
        }

        function fieldTemplate(data, container) {
          var textBox = $('<div class="adp-text-box">')
            .dxTextBox({
              placeholder: 'Type in new value and press Enter',
              mode: 'text',
              valueChangeEvent: 'keyup input change focusout',
              inputAttr: {
                'adp-qaid-field-control': scope.args.path,
              },
              onKeyPress: function (e) {
                var isDecimalChar = /(\+|-|\.|(\d|e))/.test(e.event.key);
                if (!isDecimalChar) {
                  e.event.preventDefault();
                }
              },
              onPaste: function (e) {
                e.event.preventDefault();
                var pasteText = e.event.originalEvent.clipboardData.getData('text');
                this.option('value', pasteText.replace(/[^0-9.\-+]/g, ''));
              },
            });

          container.append(textBox);
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('dxFieldControl', dxFieldControl);

  function dxFieldControl(
    AdpValidationUtils,
    AdpFieldsService,
    AdpUnifiedArgs,
    $injector,
    ControlSetterGetter,
    DX_CONTROLS,
    $timeout
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/dx-control-factory/dx-control-factory.html',
      require: '^^form',
      link: function (scope, el, attr, formCtrl) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);

        (function init(args) {
          const widgetType = getWidgetType(args);
          const widgetConfig = getWidgetConfig(widgetType, args);
          const widgetOptions = getConfig(args, widgetConfig.options);
          const { transformIn } = widgetOptions;
          el.find('div')[widgetConfig.widgetName](widgetOptions);

          scope.$on('$destroy', function () {
            getInstance().dispose();
          });

          $timeout(() => {
            const fieldModel = formCtrl[scope.args.fieldSchema.fieldName];
            fieldModel.$render = () => {
              let val = _.get(scope.args.row, scope.args.path);
              if (transformIn) {
                val = transformIn(val);
              }
              scope.instance.option('value', val);
            }
          });
        })(scope.args);

        function getConfig(args, widgetOptions) {
          const cfg = _.merge(getDefaults(args, widgetOptions), widgetOptions);
          const { transformOut } = widgetOptions;

          cfg.onValueChanged = function (e) {
            // WORKAROUND: skipping initial change event, in case browser autofill fields
            // details https://github.com/vuejs/vue/issues/7058#issuecomment-441322358
            if (e.previousValue === null && e.value === '') {
              return
            }

            if (widgetOptions.onValueChanged) {
              var shouldPreventChange = widgetOptions.onValueChanged(e) !== undefined;
              if (shouldPreventChange) {
                return;
              }
            }

            const valueToSet = transformOut ? transformOut(e.value) : e.value;

            getterSetterFn(valueToSet);
            setAngularFormProps(args.fieldSchema);
          }

          return AdpFieldsService.configFromParameters(args.fieldSchema, cfg);
        }

        function getDefaults(args, widgetOptions) {
          const { transformIn } = widgetOptions;
          const field = args.fieldSchema;
          const initVal = getterSetterFn();
          const initialValue = transformIn ? transformIn(initVal) : initVal;

          return {
            value: _.isNil(initialValue) ? null : initialValue,
            onInitialized: function (e) {
              scope.instance = e.component;
            },
            inputAttr: {
              autocomplete: AdpFieldsService.autocompleteValue(field),
              'field-name-input': field.fieldName,
              id: field.fieldName,
              'adp-qaid-field-control': scope.args.path,
            },
            valueChangeEvent: 'input blur',
          };
        }

        function getWidgetType(args) {
          return _.findKey(DX_CONTROLS, val => val.includes(args.fieldSchema.type));
        }

        function getWidgetConfig(widgetType, args) {
          var name = 'Dx' + widgetType + 'Config';
          return $injector.get(name)(args);
        }

        function getInstance() { return scope.instance; }

        function setAngularFormProps(field) {
          var formField = formCtrl[field.fieldName];

          !formField.$dirty && formField.$setDirty();
          !formField.$touched && formField.$setTouched();
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('fileControl', fileControl);

  function fileControl(
    AdpValidationUtils,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/file-control/file-control.html',
      require: '^^form',
      link: function (scope, el, attrs, formCtrl) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;
        scope.form = formCtrl;
        scope.fakeModel = null;
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);

        (function init() {
          var controlOptions = _.get(scope, 'args.fieldSchema.arguments', {});
          if (_.isNil(controlOptions)) {
            _.set(scope, 'args.fieldSchema.arguments', {});
          }

          _.set(scope, 'args.fieldSchema.arguments.multiple', scope.args.fieldSchema.type.includes('[]'));

          if (_.isNil(getterSetterFn())) {
            getterSetterFn([]);
          }
        })();
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('formRenderControl', formRenderControl);

  function formRenderControl(
    AdpValidationUtils,
    $sce,
    ControlSetterGetter,
    $compile,
    $timeout
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/form-render-control/form-render-control.html',
      require: '^^form',
      link: function (scope, el) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;

        if (_.isUndefined(getterSetterFn())) {
          getterSetterFn(null);
        }

        (function init() {
          $timeout(renderField);
          const observablePaths = _.get(scope, 'args.fieldSchema.formRender.watch') || [];
          if (_.isEmpty(observablePaths)) {
            return;
          }

          const watchExpr = () => _.map(observablePaths, path => getViewValueFn(path, scope.args));

          scope.$watchCollection(watchExpr, function (newValues = [], oldValues = []) {
            const changed = _.some(newValues, (newVal, index) => newVal !== oldValues[index]);
            if (!changed) {
              return;
            }

            renderField();
          });
        })();

        function renderField() {
          const field = scope.args.fieldSchema;
          const renderName = _.get(field, 'formRender.formRenderer');
          const renderFn = _.get(window, 'appModelHelpers.FormRenderers.' + renderName);

          const compatibilityArgs = [scope.args.data, scope.args.row, scope.args.modelSchema];
          const renderedContent = renderFn.apply({...scope.args, scope}, compatibilityArgs);
          const asTemplate = renderFn.asTemplate || _.get(field, 'formRender.asTemplate');
          let contents;
          if (asTemplate && _.isString(renderedContent)) {
            contents = $compile(renderedContent)(scope);
          } else {
            contents = renderedContent;
          }
          const wrappedContents = $('<div class="render-content">').append(contents);
          const contentEl = el.find('.render-content');
          if (contentEl.length) {
            contentEl.replaceWith(wrappedContents);
          } else {
            const container = el.find('[form-render-view="' + scope.args.path + '"]');
            container.empty();
            container.append(wrappedContents);
          }
        }

        function getViewValueFn(watchPath, args) {
          const formPath = toFormPath(watchPath, args);
          if (formPath[0] === 'args' && formPath[1] === 'row') { // ToDo: this is dirty hack and required to be replaced. But we need a way to watch args.row ASAP
            return _.get(scope.args.row, formPath.slice(2)) || null;
          }
          return _.get(scope.formContext.rootForm, [...formPath, '$viewValue']) || null;
        }

        function toFormPath(watchPath, args) {
          let path = '';
          try {
            path = ejs.render(watchPath, { context: args });
          } catch (e) {
            console.log('Error while evaluating watch expression for args ', args, e);
          }

          return path.split('.');
        }
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('GRID_CONTROL_ACTIONS', {
  /*    'view': {
      },
      'group': {
        'position': 'grid.top.left',
        'action': {
          'type': 'action',
          'link': 'group'
        },
        'actionName': 'group'
      },
      'search': {
        'position': 'grid.top.right',
        'fullName': 'Search....',
        'action': {
          'type': 'action',
          'link': 'search'
        },
        'actionName': 'search'
      },
      'syntheticGenerate': {
        'position': 'grid.top.right',
        'description': 'Synthetic content generator',
        'icon': {
          'type': 'font-awesome',
          'link': 'magic'
        },
        'action': {
          'type': 'module',
          'link': 'AdpSyntheticGenerate'
        },
        'actionName': 'syntheticGenerate'
      },*/
      'export': {
        'position': 'grid.top.right',
        'description': 'Export collection',
        'icon': {
          'type': 'font-awesome',
          'link': 'download'
        },
        'action': {
          'type': 'module',
          'link': 'AdpDataExport'
        },
        'actionName': 'export'
      },
      'chooseColumns': {
        'position': 'grid.top.right',
        'description': 'Configure grid columns',
        'icon': {
          'link': 'columns'
        },
        'action': {
          'type': 'module',
          'link': 'AdpGridColumnChooser'
        },
        'actionName': 'chooseColumns'
      },
      'gridControlEdit': {
        'position': 'grid.row',
        'permissions': 'accessAsUser',
        'description': 'Update record',
        'fullName': 'Update',
        'icon': {
          'link': 'pencil'
        },
        'action': {
          'type': 'module',
          'link': 'AdpGridControlActions',
          'method': 'edit'
        }
      },
 /*     "gridControlDelete": {
        "description": "Delete record",
        "position": "grid.row",
        "backgroundColor": "#F44336",
        "borderColor": "#f32c1e",
        "textColor": "white",
        "icon": {
          "link": "trash"
        },
        "action": {
          "type": "action",
          "link": "delete"
        },
        "actionOrder": 2
      },
      "gridControlClone": {
        "description": "Clone record",
        "position": "grid.row",
        "backgroundColor": "#4CAF50",
        "borderColor": "#388E3C",
        "textColor": "white",
        "icon": {
          "link": "clone"
        },
        "action": {
          "type": "action",
          "link": "clone"
        },
        "actionOrder": 3
      },*/
      'gridCreateControl': {
        'actionOrder': 1,
        'backgroundColor': '#2196F3',
        'borderColor': '#0c7cd5',
        'description': 'Create new record',
        'fullName': 'Create Record',
        'position': 'grid.top.left',
        'textColor': 'white',
        'icon': {
          'link': 'columns'
        },
        'action': {
          'type': 'module',
          'link': 'AdpGridControlActions',
          'method': 'create'
        },
        'actionName': 'create',
      }
    });
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('gridControl', gridControl);

  function gridControl(
    AdpUnifiedArgs,
    GraphqlMultipleSchemasQuery,
    GridControlHelper,
    GRID_CONTROL_ACTIONS,
    ACTIONS,
    $compile,
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/grid-control/grid-control.html',
      require: '^^form',
      link: function (scope, element) {
        const fieldSchema = scope.args.fieldSchema;
        createSchema();
        addWatcherForAction();

        scope.options = {
          dataSource: {
            store: new DevExpress.data.CustomStore({
              load: () => GridControlHelper.getMergedData(fieldSchema.table, scope.args.row, scope.args.action)
            })
          }
        };

        function createSchema() {
          scope.modelSchemaForGrid = GridControlHelper.mergeSchema(fieldSchema, scope.args.modelSchema);

          setParametersToSchema(fieldSchema, scope.modelSchemaForGrid);
          addActions(scope.modelSchemaForGrid, fieldSchema.table);
          showHideHeader(fieldSchema.showHeader, scope.modelSchemaForGrid);
        }

        function addWatcherForAction() {
          if (scope.args.action !== 'create') {
            return;
          }

          const unbind = scope.$watch('args.action', (newValue) => {
            if (newValue !== 'update') {
              return;
            }
            $compile(element)(scope);
            unbind();
          });
        }

        function setParametersToSchema(field, schema) {
          const defaults = {
            remoteOperations: {
              grouping: false,
              groupPaging: false,
              sorting: false,
            },
            stateStoring: {enabled: false},
            filterRow: {visible: false},
            pager: {visible: false},
            paging: {enabled: false},
            height: 200,
          };

          schema.parameters = _.merge({}, defaults, field.parameters);
        }

        function showHideHeader(showHeader, schema) {
          if (showHeader) {
            return;
          }

          _.forEach(schema.actions.fields, (action, name) => {
            _.startsWith(action.position, 'grid.top.') && _.unset(schema.actions.fields, name);
          });
        }

        function addActions(schema, tables) {
          schema.actions.fields = _.cloneDeep(GRID_CONTROL_ACTIONS);
          schema.actions.fields.gridCreateControl.table = tables;

          const createDataGetter = (schemaName) => preparePresetData(tables[schemaName].create || {});

          if (schema.actions.fields.gridCreateControl) {
            const newRecordsAllowed = scope.args.action === 'update';
            schema.actions.fields.gridCreateControl.params = {
              createDataGetter,
              disabled: !newRecordsAllowed,
            }
          }
        }

        function preparePresetData(fields) {
          const args = AdpUnifiedArgs.getHelperParamsWithConfig({
            path: scope.args.path,
            formData: scope.args.row,
            schema: scope.modelSchemaForGrid,
            action: ACTIONS.CREATE,
          });

          return _.mapValues(fields, (field) => getPresetFieldValue(field, args))
        }

        function getPresetFieldValue(expression, args) {
          try {
            return new Function("return " + expression).call(args);
          } catch (e) {
            console.error('Error while trying to evaluate create preset expression "' + expression + '": ', e);
            return expression;
          }
        }
      }
    }
  }
})();
;(function () {
  "use strict";

  angular
    .module("app.adpForms")
    .factory("GridControlHelper", GridControlHelper);

  function GridControlHelper(GraphqlMultipleSchemasQuery) {
    return {
      getMergedData: getMergedData,
      mergeSchema: mergeSchema,
    };

    function getMergedData(table, row, action) {
      return GraphqlMultipleSchemasQuery(table, {
        row: _.cloneDeep(row),
        action: action,
      })
        .then(function (data) {
          return mergeGridData(data, table);
        })
        .then(function (mergeData) {
          return {
            data: mergeData,
            totalCount: mergeData.length,
          };
        })
    }

    function mergeSchema(fieldSchema, initialSchema) {
      var tableDefinition = fieldSchema.table;
      var resultedSchema = initialSchema ? _.cloneDeep(initialSchema) : {};
      resultedSchema.fullName = fieldSchema.fullName;
      resultedSchema.schemaName = fieldSchema.fieldName;

      resultedSchema.fields = {
        $meta_table: {
          type: 'String',
          description: 'Service column. Holds original modelSchemaForGrid name.',
          showInDatatable: false,
          fieldName: '$meta_table',
        }
      };

      var tablesList = getUniqueTablesList(tableDefinition);

      if (_.includes(tablesList, '_tableLabel')) {
        resultedSchema.fields._tableLabel = { type: 'String', fullName: '_tableLabel', fieldName: '_tableLabel' };
      }

      if (_.includes(tablesList, '_table')) {
        resultedSchema.fields._table =  { type: 'String', fullName: '_table', fieldName: '_table' };
      }

      _.keys(tableDefinition).forEach(function (tableName) {
        var schema = getSchemaByName(tableName);
        _.merge(resultedSchema.fields, schema.fields);
      });

      _.each(resultedSchema.fields, function (field, fieldName) {
        field.showInDatatable = _.includes(tablesList, fieldName);
      });

      return resultedSchema;
    }

    function mergeGridData(data, tables) {
      _.each(tables, function (table, schemaName) {
        var hasTable = _.includes(table.fields, "_table");
        var hasTableLabel = _.includes(table.fields, "_tableLabel");

        data[schemaName].forEach(function (item) {
          hasTableLabel && (item._tableLabel = table.tableLabel || _.startCase(schemaName));
          hasTable && (item._table = schemaName);
          item.$meta_table = schemaName;
          item._actions = _.assign(data._actions, {gridControlEdit: true});
        });
      });

      return _.flow(_.toArray, _.flatten)(data);
    }

    function getSchemaByName(name) {
      var APP_MODEL = window.adpAppStore.appModel();
      return _.cloneDeep(APP_MODEL[name]);
    }

    function getUniqueTablesList(tableDef) {
      return _.flow(
        function (defObj) {
          return _.map(defObj, function (item) {
            return item.fields;
          });
        },
        _.flatten,
        _.uniq
      )(tableDef);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .constant('CKEDITOR_TOOLBAR', [
      { name: 'previewGroup', items: ['Preview', 'PasteFromWord'] },
      { name: 'historyGroup', items: ['Undo', 'Redo'] },
      { name: 'textGroup', items: ['Bold', 'Italic', 'Underline'] },
      { name: 'listGroup', items: ['NumberedList', 'BulletedList'] },
      { name: 'linkGroup', items: ['Link', 'Unlink', 'Table', 'Image', 'Outdent', 'Indent', 'Collapse'] },
      '/',
      { name: 'document', items: [ 'Source', 'Save', 'NewPage', 'Print', 'Templates' ] },
      { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText' ] },
      { name: 'editing', items: [ 'Find', 'Replace', 'SelectAll', 'Scayt' ] },
      { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton',] },
      '/',
      { name: 'basicstyles', items: [ 'Strike', 'Subscript', 'Superscript', 'CopyFormatting', 'RemoveFormat' ] },
      { name: 'paragraph', items: ['Blockquote', 'CreateDiv', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'BidiLtr', 'BidiRtl', 'Language' ] },
      { name: 'links', items: [ 'Anchor' ] },
      { name: 'insert', items: [ 'Flash', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },
      '/',
      { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
      { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
      { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
    ]);
})();
;(function () {
  "use strict";

  angular
    .module('app.adpForms')
    .directive('adpCkeditor', adpCkeditor);

  function adpCkeditor($timeout, CKEDITOR_TOOLBAR) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=ngModel',
        disabled: '=',
        editorsConfig: '=',
        editorId: '=',
      },
      link: function (scope, elem) {
        const escapedEditorId = scope.editorId
          .replaceAll('.', '-')
          .replace(/\[|\]/g, '_');

        const editorHeight = 150;
        const toolbarHeightDiff = 72;
        elem[0].innerHTML = `
          <div
            class="adp-html-editor form-control clearfix"
            style="height: ${editorHeight + toolbarHeightDiff}px; overflow: hidden;"
            contenteditable="true"
            id="${escapedEditorId}"
            adp-qaid-field-control="${scope.editorId}"
          ></div>`;

        scope.$watch('editorsConfig', initEditor);

        function initEditor(config) {
          if (!config) {
            return;
          }

          var oldInstance = getEditorInstance();
          if (oldInstance) {
            oldInstance.destroy();
          }

          var editor = createEditor(config);
          editor.on('instanceReady', function () {
            $('.cke_button__sourcedialog_label').hide();
            editor.setData(scope.ngModel() || '');

            bindEvents(editor);
            setStylesForEditor(config);
            getEditorElement().css(scope.editorStyles);
          });
        }

        function createEditor(editorElem, userConfig) {
          const editorsDefaults = {
            readOnly: scope.disabled,
            resize_enabled: true,
            toolbarCanCollapse: true,
            toolbarStartupExpanded: true,
            removePlugins: 'flash',
            extraPlugins: 'collapse,divarea,sourcearea',
            resize_dir: 'both',
            toolbar: CKEDITOR_TOOLBAR,
            height: editorHeight,
          };

          const editorReplaceNode = elem.find('.adp-html-editor')[0];
          const { ckeditorTheme } = window.forcedThemes || window.adpAppStore.appInterface();
          const themeSettings = ckeditorTheme ? { skin: ckeditorTheme } : {};

          const opts = _.assign({},
            editorsDefaults,
            themeSettings,
            userConfig,
          );
          return CKEDITOR.replace(editorReplaceNode, opts);
        }

        function getEditorElement() {
          return elem.find('.cke');
        }

        function getEditorInstance() {
          return CKEDITOR.instances[escapedEditorId];
        }

        function bindEvents(editor) {
          var editorEl = getEditorElement();

          var inputEvents = ['input.ckeditor' + escapedEditorId].join(' ');
          editorEl.on(inputEvents, function (e) {
            const val = editor.mode === 'source' ? $(e.target).val() : $(e.target).html();
            scope.ngModel(val);
          });

          editor.on('change', function () {
            scope.ngModel(editor.getData());
          });

          editor.on('paste', function (e) {
            scope.ngModel(e.data.dataValue);
          });

          editor.on('blur', function (e) {
            scope.ngModel(e.editor.getData());
          });

          editor.on('afterSetData', function (e) {
            scope.ngModel(e.data.dataValue);
          })

          scope.$on('$destroy', function () {
            editor.destroy();
            editorEl.off(inputEvents);
          });
        }

        function setStylesForEditor(config) {
          scope.editorStyles = {};
          if (_.isNumber(config.resize_minHeight)) {
            scope.editorStyles.minHeight = config.resize_minHeight + 'px';
          }

          if (_.isNumber(config.resize_maxHeight)) {
            scope.editorStyles.maxHeight = config.resize_maxHeight + 'px';
          }
        }
      }
    };
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('htmlControl', htmlControl);

  function htmlControl(
    AdpValidationUtils,
    ControlSetterGetter,
    $timeout
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/html-control/html-control.html',
      require: '^^form',
      link: function (scope) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);

        $timeout(function () {
          if (_.isNil(getterSetterFn())) {
            getterSetterFn(null);
          }
          setOptions();
        });

        function setOptions() {
          scope.editorsConfig = _.get(scope, 'args.fieldSchema.parameters.editor', {});
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('iconControl', iconEditor);

  function iconEditor(
    ControlSetterGetter,
    AdpIconControlService,
    AdpValidationUtils
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/icon-control/icon-control.html',
      require: '^^form',
      link(scope, el, attrs, formControl) {
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.getterSetter = ControlSetterGetter(scope.args);
        scope.hasValue = !!scope.getterSetter();
        scope.iconTpl = AdpIconControlService.template(scope.getterSetter());

        scope.clearValue = () => {
          scope.getterSetter(null);
          scope.iconTpl = null;
          scope.hasValue = false;
        }

        function setValueToForm() {
          const formField = formControl[scope.args.fieldSchema.fieldName];

          !formField.$dirty && formField.$setDirty();
          !formField.$touched && formField.$setTouched();
        }

        scope.showModal = () => AdpIconControlService.showModal(({ icon, tpl }) => {
          if (!icon) {
            return;
          }

          scope.getterSetter(icon);
          scope.iconTpl = tpl;
          scope.hasValue = true;
          setValueToForm();
        });
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpIconControlService', AdpIconControlService);

  function AdpIconControlService(AdpModalService) {
    const iconTemplates = {
      fa(icon) {
        return `<i class="fa fa-${icon.name}"></i>`;
      },
      dx(icon) {
        return `<i class="dx-icon-${icon.name}"></i>`;
      },
    }

    const getIconTemplate = icon => {
      if (!icon) {
        return null;
      }

      return iconTemplates[icon.family](icon);
    };

    const callModal = () => {
      const { result, closed } = AdpModalService.createModal('select-icon-modal', {});

      closed.then((err) => {
        err && console.error(err);
      });

      return result;
    };

    return {
      template: getIconTemplate,
      showModal(onValueChange) {
        return callModal()
          .then((icon) => {
            if (!icon) {
              return;
            }

            const tpl = getIconTemplate(icon);
            onValueChange({ icon, tpl });
          });
      }
    };
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('imperialUnitsControl', imperialUnitsControl);

  function imperialUnitsControl(
    AdpValidationUtils,
    AdpFieldsService,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/imperial-units-control/imperial-units-control.html',
      require: '^^form',
      link: function (scope) {
        var field = scope.args.fieldSchema;
        var units = AdpFieldsService.getUnitsList(field);
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);

        scope.configFirstUnit = createConfig(units[0], 0);
        scope.configSecondUnit = createConfig(units[1], 1);

        function createConfig(unit, position) {
          var defaults = {
            value: getData(position),
            valueExpr: 'value',
            displayExpr: 'label',
            dataSource: unit.list,
            placeholder: 'Select ' + unit.shortName,
            showClearButton: true,
            onValueChanged: function (e) {
              setData(e.value, position);
            },
            elementAttr: {
              class: 'adp-select-box',
              id: 'list_id_' + field.fieldName + '_' + position,
            },
            inputAttr: {
              'adp-qaid-imperial-unit-control': scope.args.path + '_' + position,
            },
            itemTemplate: function (data, index, element) {
              element.attr('adp-qaid-control-dropdown-item', scope.args.path + '_' + position);
              return data.label;
            },
          }

          return AdpFieldsService.configFromParameters(field, defaults);
        }

        function getData(position) {
          var val = getterSetterFn();
          if (_.isEmpty(val)) {
            return null;
          }

          return val[position];
        }

        function setData(value, position) {
          var val = getterSetterFn();
          var valueList = _.isEmpty(val) ? [0, 0] : val;

          valueList[position] = value;
          var newVal = _.isEmpty(_.compact(valueList)) ? null : valueList;
          getterSetterFn(newVal);
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('listControl', listControl);

  function listControl(
    AdpValidationUtils,
    AdpFieldsService,
    AdpListsService,
    ControlSetterGetter,
    AdpRecordMeta,
    AdpAsyncListsService,
    ListControlSortable
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/list-control/list-control.html',
      require: '^^form',
      link: function (scope, element, attrs, formCtrl) {
        const getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;

        const getValueAsString = () => {
          let value = _.get(scope.args.row, scope.args.path);

          if (_.isNumber(value)) {
            value = _.toString(value);
          }

          return value;
        }

        (function init() {
          scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
          scope.isMultiple = scope.args.fieldSchema.type.includes('[]');

          bindWatcher(scope.args.fieldSchema);

          (function init() {
            var config = getConfig(scope.args);
            getListElement()[getWidgetName()](config);
            setupSortable();

            scope.$on('$destroy', () => scope.instance.dispose());
            scope.$on('pathChanged', () => {
              const value = scope.instance.option('value');
              AdpAsyncListsService.setDynamicListLabel(scope.args, { component: scope.instance, value });
            });

            scope.$on('afterCopyPasteAction', () => {
              const value = getValueAsString();
              getterSetterFn(value);

              const ds = scope.instance.option('dataSource');
              const promise = ds.load ? ds.load() : Promise.resolve();
              AdpAsyncListsService.clearDs(scope.args, scope.instance);

              promise
                .then(() => {
                  AdpAsyncListsService.setDynamicListLabel(scope.args, { component: scope.instance, value });
                  scope.instance.repaint();
                })
            });

            // $render handler external changes
            const fieldModel = formCtrl[scope.args.fieldSchema.fieldName];
            fieldModel.$render = function () {
              let value = getValueAsString();
              scope.instance.option('value', value);
            }
          })();
        })();

        function getConfig(args) {
          var defaults = getDefaults(args);
          AdpFieldsService.addOpenStatusBroadcast(scope, defaults);
          return AdpFieldsService.configFromParameters(args.fieldSchema, defaults);
        }

        function setupSortable() {
          ListControlSortable.setupTagsReordering({
            element: element.find('.adp-list-control-sortable-wrapper'),
            onDrop(e) {
              const items = scope.instance.option('value');
              ListControlSortable.swapItems(e, items);
              scope.instance.option('value', items);
              setTimeout(() => {
                scope.instance.repaint();
              });
            },
            args: scope.args,
          });
        }

        function getDefaults(args) {
          return {
            value: getValueAsString() || null,
            grouped: AdpListsService.isGrouped(args),
            showSelectionControls: scope.isMultiple && AdpListsService.isGrouped(args),
            onInitialized(e) {
              scope.instance = e.component;
              // adding ds items to show label if initial items
              AdpAsyncListsService.addLabelForDynamicList(scope.args, scope.instance);
            },
            valueExpr: 'value',
            displayExpr: 'label',
            elementAttr: {
              class: 'adp-select-box',
              id: 'list_id_' + args.fieldSchema.fieldName,
            },
            inputAttr: { 'adp-qaid-field-control': scope.args.path },
            itemTemplate(data, index, element) {
              element
                .attr('adp-qaid-control-dropdown-item', scope.args.path)
                .attr('list-control-item', scope.args.path); // deprecated

              return data.label;
            },
            showClearButton: true,
            dataSource: AdpListsService.getDataSource(args, !!getterSetterFn()),
            onOpened(e) {
              //clearing ds to empty it before async ds is loaded
              AdpAsyncListsService.clearDs(scope.args, e.component);
            },
            onValueChanged(e) {
              getterSetterFn(e.value);
              // updating meta by rewriting it
              AdpAsyncListsService.setDynamicListLabel(scope.args, e);
              setAngularFormProps();
            },
            tagTemplate(data, tagElement) {
              var component = this;
              var removeBtn = $('<div class="dx-tag-remove-button"><span class="dx-icon dx-icon-clear"></span></div>');

              removeBtn.on('click', function () {
                var ids = component.option('value').slice();
                _.pull(ids, data.value);

                component.option('value', ids);
                removeBtn.off('click');
              });

              $('<div class="dx-tag-content">')
                .attr('draggable', ListControlSortable.isReorderingAllowed(scope.args))
                .attr('adp-qaid-field-tag', args.path)
                .append('<span class="dx-tag-text">' + data.label + '</span>', removeBtn)
                .appendTo(tagElement);
            },
          };
        }

        function getListElement() {
          return element.find('.adp-list-control');
        }

        function getWidgetName() {
          return scope.isMultiple ? 'dxTagBox' : 'dxSelectBox';
        }

        function setAngularFormProps() {
          var formField = formCtrl[scope.args.fieldSchema.fieldName];

          !formField.$dirty && formField.$setDirty();
          !formField.$touched && formField.$setTouched();
        }

        function bindWatcher(field) {
          if (field.dynamicList) {
            return;
          }

          const unbindWatcher = scope.$watch(
            scope.isRequired,
            function (newVal) {
              const entries = _.entries(field.list.values);
              if (entries.length && entries.length > 1) {
                unbindWatcher();
              }

              const hasSingleValue = entries.length === 1;
              if (newVal && hasSingleValue) {
                const [[value]] = entries;
                const valueToAssign = scope.isMultiple ? [value] : value;

                scope.instance.option('value', valueToAssign);
              }
            }
          );
        }
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('LOCATION_DARK_THEME', [
      { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#263c3f' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6b9a76' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#38414e' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#212a37' }],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9ca5b3' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#746855' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#1f2835' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#f3d19c' }],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#2f3948' }],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#17263c' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#515c6d' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#17263c' }],
      },
    ]);
})();;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('locationControl', locationControl);

  function locationControl(
    AdpValidationUtils,
    ControlSetterGetter,
    AdpLocationControlService,
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/location-control/location-control.html',
      require: '^^form',
      link: function (scope, el, attrs, formCtrl) {
        const getterSetterFn = ControlSetterGetter(scope.args);
        const params = _.get(scope, 'args.fieldSchema.parameters');

        scope.form = formCtrl;
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);

        AdpLocationControlService.locationController({scope, el, getterSetterFn, setValidity, params});

        function setValidity(status) {
          var fieldName = scope.args.fieldSchema.fieldName;
          scope.form[fieldName].$setValidity('location', status);
          scope.form[fieldName].$setDirty();
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('AdpLocationControlService', AdpLocationControlService);

  function AdpLocationControlService(
    AdpGeoLocationService,
    NgMap,
    $q,
    $timeout,
    LOCATION_DARK_THEME
  ) {
    function locationController({scope, el, getterSetterFn, setValidity, params = {}}) {
      scope.getterSetter = getterSetterFn;
      scope.addressLabel = '';
      const { googleMapsTheme } = window.forcedThemes || window.adpAppStore.appInterface();
      if (googleMapsTheme === 'dark') {
        scope.mapStyles = LOCATION_DARK_THEME;
      }
      scope.css = {}
      if (params.mapHeight) {
        scope.css.height = params.mapHeight + 'px';
      }

      if (!isEmpty()) {
        const { label, coordinates: [long, lat] } = getterSetterFn();
        setData({ label, coordinates: [long, lat] });
        scope.addressLabel = label;
      }

      scope.fieldParams = params;
      scope.isMapVisible = params.showMap;
      scope.detecting = false;
      scope.isReady = false;
      scope.map = {};
      scope.mapId = scope.$id;

      function getData() {
        return getterSetterFn() || {};
      }

      function isEmpty() {
        return _.isEmpty(getData());
      }

      function setInitialValuePromise() {
        const { coordinates } = getData();

        if (!isEmpty()) {
          return coordsToAddress({ lng: coordinates[0], lat: coordinates[1] })
            .then(setCenter);
        }

        if (params.autodetect) {
          return detect();
        }

        return $q.when();
      }

      function setupPlacesInput() {
        $timeout(() => {
          const autocomplete = el.find('[on-place-changed]');
          if (!autocomplete.length) {
            return;
          }
          autocomplete.on('keypress', preventSubmitOnEnter);
          autocomplete.on('keydown', preventSubmitOnEnter);
          autocomplete.on('focus', onFocus);
        });
      }

      function setupMap() {
        const initialPoint = getterSetterFn();
        const lat = _.get(initialPoint, 'coordinates.1', 37.753344);
        const lng = _.get(initialPoint, 'coordinates.0', -122.409668);
        const mapDefaults = {
          center: [lat, lng],
          zoom: scope.fieldParams.mapZoom || 16,
          markerPosition: [lat, lng],
        };
        scope.map = _.clone(mapDefaults);

        return NgMap.getMap({ id: scope.mapId })
          .then((map) => {
            scope.mapInstance = map;
            scope.marker = map.markers[0];
          });
      }

      function detect() {
        onDetectStart();

        return AdpGeoLocationService.getLocation()
          .then(coords => coordsToAddress({ lng: coords[0], lat: coords[1] }))
          .then(setCenter)
          .then(setValidity.bind(this, true))
          .catch(function (err) {
            console.log(err);
          })
          .finally(() => {
            scope.detecting = false;
          });
      }

      function onDetectStart() {
        scope.detecting = true;
      }

      function coordsToAddress({lng, lat}) {
        onDetectStart();

        return AdpGeoLocationService.reverseGeocode({lng, lat})
          .then((label) => {
            setData({ label, coordinates:[lng, lat] });
          })
          .finally(() => {
            scope.detecting = false;
          });
      }

      function setData({ label, coordinates: [lng, lat] }) {
        getterSetterFn({
          label,
          coordinates: [lng, lat],
        });
        scope.addressLabel = label;
      }

      function setCenter() {
        const { coordinates } = getData();
        if (!coordinates) {
          return
        }
        scope.map.center = coordinates;
        scope.map.markerPosition = _.clone(scope.map.center);

        const [lng, lat] = coordinates;
        const latLng = new google.maps.LatLng(lat, lng);
        scope.marker && scope.marker.setPosition(latLng);
        scope.mapInstance && scope.mapInstance.setCenter(latLng);
      }

      // events
      scope.detect = detect;

      scope.onClick = function (e) {
        e.domEvent.preventDefault();
        e.domEvent.stopPropagation();

        const lng = e.latLng.lng();
        const lat = e.latLng.lat();
        scope.map.center = [ lat, lng ];
        scope.map.markerPosition = _.clone(scope.map.center);

        coordsToAddress({ lng, lat })
          .then(setCenter);
      };

      // sync input with map
      scope.placeChanged = function () {
        const place = this.getPlace();
        if (!place?.name) {  // Empty address input
          getterSetterFn(null);
          return;
        }

        const promise = !!place.geometry ? $q.when(place) : AdpGeoLocationService.geocode(place);

        promise
          .then(function (place) {
            const isValid = !!(place && place.geometry);

            if (isValid) {
              setData({
                label: place.formatted_address,
                coordinates: [place.geometry.location.lng(), place.geometry.location.lat()]
              })
              setCenter();
            }

            setValidity(isValid);
          })
          .catch(err => {
            console.log(err);
          });
      };

      function preventSubmitOnEnter(e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          return false;
        }
      }

      function onFocus(e) {
        const pacContainer = $('.pac-container');

        const insideForm = pacContainer.closest('location-control')
          .is(el);
        if (!insideForm) {
          $(el)
            .append(pacContainer);
        }
      }

      scope.toggleMapVisibility = () => {
        scope.isMapVisible = !scope.isMapVisible;

        if (!scope.isMapVisible) {
          return;
        }

        setupMap()
          .then(setCenter)
          .catch(err => {
            console.log(err)
          });
      }

      const setupMapPromise = scope.isMapVisible ? setupMap : $q.when;

      return AdpGeoLocationService.isReady()
        .then(() => {
          scope.isReady = true;
        })
        .then(setupPlacesInput)
        .then(setupMapPromise)
        .then(setInitialValuePromise)
        .catch(err => {
          console.log(err)
        });
    }

    return {
      locationController
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('lookupControl', lookupControl);

  function lookupControl(
    AdpSchemaService,
    AdpValidationUtils,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/lookup-control/lookup-control.html',
      require: '^^form',
      link: function (scope) {
        (function init() {
          scope.getterSetter = ControlSetterGetter(scope.args);
          scope.props = {
            args: scope.args,
            onValueChanged(e) {
              scope.getterSetter(e.value);
            },
            onTableChanged(e) {
              scope.props.selectedTableName = e.value;
            },
            selectedTableName: initialTableName(),
          };

          scope.multiple = scope.args.fieldSchema.type.includes('[]');
          setContainerClasses();
        })();

        function initialTableName() {
          var tables = getLookupTables();
          return _.toArray(tables)[0].table;
        }

        function setContainerClasses() {
          var hasSingleTable = Object.keys(getLookupTables()).length === 1;

          scope.fieldNameClass = 'lookup-name-' + scope.args.fieldSchema.fieldName;
          scope.columnClass = hasSingleTable ? 'single-column' : '';
        }

        function getLookupTables() {
          return _.get(scope, 'args.fieldSchema.lookup.table');
        }

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('numberArrayControl', numberArrayControl);

  function numberArrayControl(
    AdpValidationUtils,
    AdpFieldsService,
    NumberArrayEditorConfig,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/number-array-control/number-array-control.html',
      require: '^^form',
      link: function (scope, element) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = function (val) {
          if (arguments.length) {
            var formattedVal = (val.value || []).map(_.toNumber);
            getterSetterFn(formattedVal);
          }

          return getterSetterFn();
        }

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.config = getConfig(scope.args.fieldSchema);

        scope.$on('afterCopyPasteAction', () => {
          const currentArrayData = scope.getterSetter();
          const newDataSource = currentArrayData.map((item, index) => ({ label: item, id: index, }));
          const newValue = newDataSource.map((v, i) => i);

          const component = DevExpress.ui.dxTagBox.getInstance(element.find('div'));
          component.option('dataSource', newDataSource);
          component.option('value', newValue);
        });

        function getConfig(field) {
          var fieldData = scope.getterSetter();
          var baseConfig = NumberArrayEditorConfig(scope.args, fieldData, scope.getterSetter);
          baseConfig.fieldTemplate = fieldTemplate;

          AdpFieldsService.addOpenStatusBroadcast(scope, baseConfig);
          return AdpFieldsService.configFromParameters(field, baseConfig);
        }

        function fieldTemplate(data, container) {
          var numberBox = $('<div class="adp-text-box">')
            .dxNumberBox(getNumberBoxConfig());

          container.append(numberBox);
        }

        function getNumberBoxConfig() {
          var isInt = _.includes(['Int32[]', 'Int64[]'], scope.args.fieldSchema.type);

          return {
            value: null,
            placeholder: 'Type in new value and press Enter',
            format: isInt ? '#' : '',
            valueChangeEvent: 'blur keyup change focusout',
            inputAttr: {
              'adp-qaid-field-control': scope.args.path,
            }
          };
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .component('adpPasswordModal', {
      templateUrl: 'app/adp-forms/directives/adp-form-controls/password-control/adp-password-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: function AdpRecordModalController(
        AdpUnifiedArgs,
        AdpAuthSchemas,
        $q
      ) {
        var vm = this;

        vm.$onInit = function () {
          vm.passwordArgs = vm.resolve.options.args;
          vm.args = AdpAuthSchemas.passwordUpdateArgs();

          vm.args.modelSchema.schemaName = [
            'updatePassword',
            vm.passwordArgs.modelSchema.schemaName,
            vm.passwordArgs.fieldSchema.fieldName,
          ].join('.');
        };

        vm.onCancel = function () {
          return vm.dismiss({ $value: 'cancel' });
        };

        vm.formOptions = {
          localActionsStrategy: {
            submit: function (args) {
              return $q.resolve()
                .then(function () {
                  vm.close({ $value: args.row[vm.passwordArgs.fieldSchema.fieldName] });
                  return args.row;
                });
            },
          },
          disableFullscreen: true,
        };
      },
      controllerAs: 'vm'
    });
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('passwordControl', PasswordControl);

  function PasswordControl(
    AdpModalService,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '=',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/password-control/password-control.html',
      link: function (scope) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.onClick = function (e) {
          e.preventDefault();
          showModal();
        };

        function showModal() {
          AdpModalService.passwordUpdate(scope.args)
            .then(getterSetterFn);
        }
      }
    }
  }
})();
;;(function () {
    'use strict';

    angular
        .module('app.adpForms')
        .factory('RandomIdConfig', RandomIdConfig);

    /** @ngInject */
    function RandomIdConfig(
        AdpFieldsService
    ) {
        return function ({ onValueChanged, onInitialized, args, value }) {
            const initialValue = value || generateId(args);
            onValueChanged({ value: initialValue });
            const { fieldSchema, path } = args;
            let component;

            const widgetConfig = {
                value: initialValue,
                elementAttr: {
                    'adp-qaid-field-control': path,
                },
                inputAttr: {
                    autocomplete: AdpFieldsService.autocompleteValue(fieldSchema),
                    'field-name-input': fieldSchema.fieldName,
                    id: fieldSchema.fieldName,
                    'adp-qaid-field-control': path,
                },
                onValueChanged,
                onInitialized(e) {
                    component = e.component;
                    onInitialized && onInitialized(e);
                },
                valueChangeEvent: 'change blur',
                buttons: [{
                    name: 'generate-random-id',
                    options: {
                        icon: 'fa fa-refresh',
                        onClick() {
                            const newId = generateId(args);
                            onValueChanged({ value: newId });
                            component.option('value', newId);
                        },
                    }
                }],
            };

            return AdpFieldsService.configFromParameters(fieldSchema, widgetConfig);
        }

        function generateId(args) {
            const { charset, length } = _.get(args, 'fieldSchema.parameters');
            let val = '';
            for (let i = 0; i < length; ++i) {
                val += charset[Math.floor(Math.random() * charset.length)];
            }

            return val;
        }
    }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('randomIdControl', randomIdControl);

  function randomIdControl(
    AdpValidationUtils,
    ControlSetterGetter,
    RandomIdConfig,
    $timeout
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/boolean-control/boolean-control.html',
      require: '^^form',
      link(scope, el, attr, formCtrl) {
        const getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = getterSetterFn;
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.controlId = scope.$id + scope.args.fieldSchema.fieldName;

        initControl();
        bindEvents();

        function initControl() {
          const config = RandomIdConfig({
            onValueChanged({ value }) {
              getterSetterFn(value);
            },
            args: scope.args,
            value: getterSetterFn(),
            onInitialized({ component }) {
              scope.instance = component;
            }
          });

          el.find('div').dxTextBox(config);
        }

        function bindEvents() {
          scope.$on('$destroy', () => scope.instance.dispose());

          $timeout(() => {
            const fieldModel = formCtrl[scope.args.fieldSchema.fieldName];
            fieldModel.$render = () => {
              const val = _.get(scope.args.row, scope.args.path);
              if (val) {
                scope.instance.option('value', val);
              } else {
                scope.instance.reset();
              }
            }
          });
        }
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('ADP_STAR_RATING_STYLING', {
      strokeWidth: 0,
      useGradient: false,
      emptyColor: 'lightgray',
      hoverColor: 'salmon',
      activeColor: 'cornflowerblue',
      starSize: 32,
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpStarRating', adpStarRating);

  function adpStarRating(
    ADP_STAR_RATING_STYLING,
    $timeout
  ) {
    const template = `
      <div class="adp-rating">
        <div class="adp-rating-out-of-range"></div>
        <div class="adp-rating-element"></div>
        <div class="adp-rating-label">{{label}}</div>
      </div>`;

    return {
      restrict: 'E',
      scope: {
        config: '<',
      },
      template,
      require: 'ngModel',
      link(scope, element, attrs, ngModel) {
        const { minRating, numberOfStars, showHalfStars } = scope.config;
        const getEl = () => $(element).find('.adp-rating-element');
        const getElOutOfBound = () => $(element).find('.adp-rating-out-of-range');

        $timeout().then(init);
        function init() {
          scope.label = getFullRatingFromModel();

          if (minRating > 0) {
            initOutBoundRange(ADP_STAR_RATING_STYLING);
          }
          initRating(ADP_STAR_RATING_STYLING);

          scope.$on('$destroy', function () {
            getElOutOfBound().off('mouseenter');
            getElOutOfBound().off('mouseleave');
          });
        }

        function getFullRatingFromModel() {
          const rating = ngModel.$viewValue || null;

          if (rating === null) {
            ngModel.$setViewValue(minRating);
            return minRating;
          }

          return rating;
        }

        function initOutBoundRange(styling) {
          getElOutOfBound().starRating({
            totalStars: minRating,
            initialRating: minRating,
            readOnly: true,
            ...styling,
          });

          getElOutOfBound().on('mouseenter', function () {
            getEl().starRating('setRating', 0);
          });
          getElOutOfBound().on('mouseleave', function () {
            getEl().starRating('setRating', scope.rating);
          })
        }

        function initRating(styling) {
          getEl().starRating({
            totalStars: numberOfStars - minRating,
            initialRating: getFullRatingFromModel() - minRating,
            useFullStars: !showHalfStars,
            disableAfterRate: false,
            callback: function(currentRating){
              ngModel.$setViewValue(currentRating + minRating);
              scope.label = currentRating + minRating;
            },
            ...styling,
          });
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('ratingControl', ratingControl);

  function ratingControl(
    AdpValidationUtils,
    ControlSetterGetter,
    AdpFieldsService
  ) {
    const template = `
      <adp-star-rating
        ng-required="isRequired()"
        name="{{::args.fieldSchema.fieldName}}"
        ng-model="getterSetter"
        ng-model-options="{ debounce: 30, getterSetter: true }"
        config="config"
        ng-if="config"
      ></adp-star-rating>`;

    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      template,
      link(scope) {
        scope.getterSetter = ControlSetterGetter(scope.args);
        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.config = AdpFieldsService.configFromParameters(scope.args.fieldSchema);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('readonlyControl', readonlyControl);

  function readonlyControl() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/readonly-control/readonly-control.html',
      require: '^^form'
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('recaptchaControl', recaptchaControl);

  function recaptchaControl (APP_CONFIG) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/recaptcha-control/recaptcha-control.html',
      require: '^^form',
      link: function (scope) {
        scope.key = APP_CONFIG.reCaptchaKey;
        scope.reCaptchaSecret = APP_CONFIG.reCaptchaSecret;
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('staticHtmlControl', staticHtmlControl);

  function staticHtmlControl() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
      },
      template: '',
      require: '^^form',
      link: function (scope, element) {
         element[0].innerHTML = _.get(scope, 'args.fieldSchema.template.link', '');
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('stringArrayControl', stringArrayControl);

  function stringArrayControl(
    StringArrayEditorConfig,
    AdpValidationUtils,
    AdpFieldsService,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/string-array-control/string-array-control.html',
      require: '^^form',
      link(scope, element) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.getterSetter = function (e) {
          if (arguments.length) {
            getterSetterFn(e.value);
          }
          return getterSetterFn();
        };

        scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        scope.config = getConfig(scope.field);

        scope.$on('afterCopyPasteAction', () => {
          const currentArrayData = scope.getterSetter();
          const newDataSource = currentArrayData.map((item, index) => ({ label: item, id: index, }));
          const newValue = newDataSource.map((v, i) => i);

          const component = DevExpress.ui.dxTagBox.getInstance(element.find('div'));
          component.option('dataSource', newDataSource);
          component.option('value', newValue);
        });


        function getConfig(field) {
          var fieldData = getterSetterFn();
          var defaults = StringArrayEditorConfig(scope.args, fieldData, scope.getterSetter);
          AdpFieldsService.addOpenStatusBroadcast(scope, defaults);

          return AdpFieldsService.configFromParameters(field, defaults);
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('treeSelectorControl', treeSelectorControl);

  function treeSelectorControl(
    GraphqlTreeSelectorQuery,
    AdpUnifiedArgs,
    AdpValidationUtils,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/tree-selector-control/tree-selector-control.html',
      require: '^^form',
      link: function (scope) {
        (function init() {
          var getterSetterFn = ControlSetterGetter(scope.args);
          scope.getterSetter = getterSetterFn;
          var val = getterSetterFn();
          if (_.isNil(val)) {
            getterSetterFn([]);
          }

          scope.isRequired = AdpValidationUtils.isRequired(scope.args.path, scope.formContext.requiredMap);
        })();
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('treeSelectorRequired', treeSelectorRequired);

  function treeSelectorRequired() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, el, attrs, ctrl) {
        var isRequired = false;
        addValidator();

        scope.$watch(attrs.treeSelectorRequired, function(newStatus) {
          isRequired = newStatus;
          ctrl.$validate();
        });

        function addValidator() {
          ctrl.$validators.required = function(modelValue) {
            if (isRequired === false) {
              return true;
            }

            return !_.isEmpty(_.last(modelValue));
          };
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('triStateBooleanControl', triStateBooleanControl);

  function triStateBooleanControl(
    AdpFieldsService,
    ControlSetterGetter
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/tri-state-boolean-control/tri-state-boolean-control.html',
      require: '^^form',
      link: function (scope) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.config = AdpFieldsService.configFromParameters(scope.args.fieldSchema, getDefaultSettings());

        function getDefaultSettings() {
          var initialValue = initialState();
          return {
            onInitialized: function (e) {
              if (e.component.option('value') === false) {
                e.component.setUndefinedNextTime = true;
              }
            },
            value: initialValue,
            onValueChanged: function (e) {
              if (e.component.skipOnValueChanged) {
                e.component.skipOnValueChanged = false;
                return;
              }

              if (e.component.setUndefinedNextTime) {
                e.component.setUndefinedNextTime = false;
                e.component.skipOnValueChanged = true;
                e.component.option('value', undefined);
                setValueToModel(undefined);
                return;
              }

              if (e.value === false) {
                e.component.setUndefinedNextTime = true;
              }
              setValueToModel(e.value);
            }
          }
        }


        function setValueToModel(val) {
          getterSetterFn(_.isUndefined(val) ? null : val);
        }

        function initialState() {
          return _.isNil(scope.args.data) ? undefined : scope.args.data;
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldBlank', adpFormFieldBlank);

  function adpFormFieldBlank() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-fields/adp-form-field-blank/adp-form-field-blank.html'
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldDefault', adpFormFieldDefault);

  function adpFormFieldDefault() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-fields/adp-form-field-default/adp-form-field-default.html',
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('defaultControlFactory', defaultControlFactory);

  function defaultControlFactory(
    DX_CONTROLS,
    OTHER_FIELDS,
    $compile
  ) {
    return {
      restrict: 'E',
      scope: false,
      compile() {
        return function(scope, iElement) {
          var directiveType;
          var field = scope.args.fieldSchema;
          var isDxControl = _.flatten(_.values(DX_CONTROLS)).includes(field.type);

          if (field.formRender) {
            directiveType = 'form-render';
          } else if (field.list && !['FrontendLists', 'FrontendLists[]'].includes(field)) {
            directiveType = OTHER_FIELDS.List;
          } else if (isDxControl) {
            directiveType = 'dx-field';
          } else {
            directiveType = OTHER_FIELDS[field.type];
          }

          var tpl = [
            '<' + directiveType + '-control',
              'args="::args"',
              'form-context="::formContext">',
            '</' + directiveType + '-control>',
          ].join(' ');

          iElement.replaceWith($compile(tpl)(scope));
        };
      },
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldFormSeparator', adpFormFieldFormSeparator);

  function adpFormFieldFormSeparator() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-fields/adp-form-field-form-separator/adp-form-field-form-separator.html'
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormSeparator', adpFormSeparator);

  function adpFormSeparator() {
    return {
      restrict: 'E',
      scope: {
        fieldSchema: '<',
      },
      template: '<div class="adp-form-separator-container" style="{{separatorContainerStyleString}}">' +
        '<div class="adp-form-separator-line" style="{{separatorLineStyleString}}"></div>' +
        '</div>',
      link: function (scope) {
        var styleAttributes = {
          lineWidth: 'border-top-width',
          lineColor: 'border-color',
          lineStyle: 'border-style',
        }
        var parameters = scope.fieldSchema.parameters;
        var lineStyle = getLineStyle(parameters);
        var containerStyle = {};

        if (parameters.height) {
          containerStyle.height = parameters.height;
        }

        scope.separatorLineStyleString = transformStyleToString(lineStyle);
        scope.separatorContainerStyleString = transformStyleToString(containerStyle);

        function getLineStyle(params) {
          var style = {};

          _.each(styleAttributes, function (cssName, attrName) {
            if (params[attrName]) {
              style[cssName] = params[attrName];
            }
          })

          return style;
        }

        function transformStyleToString(styleObj) {
          return _.reduce(styleObj,
            function (result, value, key) {
              return result + key + ':' + transformStyleValue(value) + ';';
            }, '');

          function transformStyleValue(val) {
            return _.isNumber(val) ? val + 'px' : val;
          }
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldReadonly', adpFormFieldReadonly);

  function adpFormFieldReadonly() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-fields/adp-form-field-readonly/adp-form-field-readonly.html',
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldRecaptcha', adpFormFieldRecaptcha);

  function adpFormFieldRecaptcha(
    APP_CONFIG,
    $state
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-fields/adp-form-field-recaptcha/adp-form-field-recaptcha.html',
      require: '^^form',
      link: function (scope) {
        const states = {
          'auth.login': 'loginCaptchaEnabled',
          'auth.register': 'signupCaptchaEnabled',
        }

        const captchaPage = states[$state.current.name];
        scope.showCaptcha = APP_CONFIG[captchaPage];
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormFieldStaticHtml', adpFormFieldStaticHtml);

  function adpFormFieldStaticHtml() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-fields/adp-form-field-static-html/adp-form-field-static-html.html',
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormGroupAccordionOrGrouping', adpFormGroupAccordionOrGrouping);

    function adpFormGroupAccordionOrGrouping(
      AdpFieldsService,
      AdpFormService,
      AdpUnifiedArgs,
      ShowExpression
    ) {
    return {
      restrict: 'E',
      scope: {
        groups: '<',
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-group/adp-form-group-accordion-or-grouping/adp-form-group-accordion-or-grouping.html',
      require: '^^form',
      link(scope, el, attrs, form) {
        scope.groupingType = AdpFormService.getGroupingType(scope.args);
        scope.groupHasErrors = fields => AdpFormService.groupHasErrors(fields, form);
        scope.groupCompleted = fields => AdpFormService.groupCompleted(fields, form);
        scope.formParams = _.assign(
          {},
          _.get(scope, 'args.modelSchema.parameters', {}),
          { heightStyle: 'content', collapsible: true }
        );

        scope.groupsContentVisibility = _.mapValues(
          scope.groups,
          group => _.get(group, 'parameters.expanded')
        );

        scope.toggle = (event, groupName) => {
          const toggler = {
            accordion(name) {
              const isClickedVisible = scope.groupsContentVisibility[name];
              if (isClickedVisible) {
                scope.groupsContentVisibility[name] = false;
                return;
              }

              _.each(scope.groupsContentVisibility, (name, key) => {
                scope.groupsContentVisibility[key] = false;
              });
              scope.groupsContentVisibility[name] = true;
            },
            grouping(name) {
              scope.groupsContentVisibility[name] = !scope.groupsContentVisibility[name];
            }
          }

          toggler[scope.groupingType](groupName);
        }

        scope.listOfFieldsForEachGroup = _.mapValues(scope.groups, ({ fields }) => {
          return fields.map(field => AdpUnifiedArgs.next(scope.args, field.fieldName));
        });

        scope.argsForGroups = _.mapValues(scope.groups, group => AdpUnifiedArgs.getArgsForGroup(group, scope.args));

        scope.getHeader = (group) => {
          const args = scope.argsForGroups[group.fieldName];
          return AdpFieldsService.getHeaderRenderer(args);
        };

        scope.isVisible = evalVisibilityForGroups();

        scope.$on('formChanged', _.debounce(() => {
          scope.isVisible = evalVisibilityForGroups();

          scope.errorCnt = _.mapValues(
            scope.argsForGroups,
            (args) => AdpFormService.countGroupErrors(form, args, scope.formContext.errorCounter)
          );
        }, 200));

        function evalVisibilityForGroups() {
          return _.mapValues(scope.argsForGroups, ShowExpression.evalShowForField);
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('adpFormGroupWizard', adpFormGroupWizard);

  function adpFormGroupWizard(
    AdpFieldsService,
    AdpFormService,
    AdpUnifiedArgs,
    ShowExpression
  ) {
    return {
      restrict: 'E',
      scope: {
        groups: '<',
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-group/adp-form-group-wizard/adp-form-group-wizard.html',
      require: '^^form',
      link: function (scope, el, attrs, form) {
        (function init() {
          scope.form = form;
          scope.groupHasErrors = (groupFields) => AdpFormService.groupHasErrors(groupFields, form);
          scope.groupCompleted = (groupFields) =>  AdpFormService.groupCompleted(groupFields, form);

          scope.argsForGroups = _.mapValues(scope.groups, group => AdpUnifiedArgs.getArgsForGroup(group, scope.args));
          scope.isVisible = evalVisibilityForGroups();
          scope.wizardGroups = getGroups();
          scope.names = getNames();

          scope.currentName = getInitialCurrent();

          scope.$on('formChanged', _.debounce(function () {
            scope.isVisible = evalVisibilityForGroups();
          }, 150));

          scope.$watch(namesString, onUpdate);
        })();

        function namesString() {
          var names = getNames();
          return names.join(';');
        }

        function onUpdate(newValue, oldValue) {
          if (newValue === oldValue) {
            return;
          }

          scope.wizardGroups  = getGroups();
          scope.names = getNames();

          var currentNameIsNull = scope.names.indexOf(scope.currentName) === -1;

          if (currentNameIsNull) {
            scope.currentName = getInitialCurrent();
          }
        }

        function getGroups() {
          return _.map(scope.groups, function (group) {
            return scope.isVisible[group?.fieldName] ? group : null;
          });
        }

        function getNames() {
          return _.reduce(scope.groups, function (acc, group) {
            scope.isVisible[group?.fieldName] && acc.push(group.fieldName);
            return acc;
          }, []);
        }

        function getInitialCurrent() {
          return scope.names[0];
        }

        scope.isEmpty = function() {
          return _.isEmpty(scope.names);
        };

        scope.setCurrent = function (name) {
          if (name === scope.currentName) return;
          const fieldGroup = _.find(scope.wizardGroups, ['fieldName', name]);

          const beginResult = AdpFormService.handleOnGroupActivateBegin(fieldGroup, scope);

          if (beginResult?.then) {
            beginResult.then(res => {
              if (res !== false) {
                _setCurrent();
              }
            }).catch(_.noop)
          } else if (beginResult !== false) {
            _setCurrent();
          }

          function _setCurrent() {
            AdpFormService.setGroupDirty(fieldGroup, scope.form);
            AdpFormService.handleOnGroupActivateEnd(fieldGroup, scope);

            scope.currentName = name;
          }
        };

        scope.next = function () {
          const currentIndex = scope.names.indexOf(scope.currentName);
          const nextName = scope.names[currentIndex + 1];

          scope.setCurrent(nextName);
        };

        scope.prev = function () {
          const currentIndex = scope.names.indexOf(scope.currentName);
          const prevName = scope.names[currentIndex - 1];

          scope.setCurrent(prevName);
        };

        scope.isFirst = function () {
          return scope.names.indexOf(scope.currentName) === 0;
        };

        scope.isLast = function () {
          return scope.names.indexOf(scope.currentName) === scope.names.length - 1;
        };

        scope.getHeader = (group) => {
          if (!group) {
            return '';
          }
          const args = scope.argsForGroups[group.fieldName];
          return AdpFieldsService.getHeaderRenderer(args);
        };

        function evalVisibilityForGroups() {
          return _.mapValues(scope.argsForGroups, ShowExpression.evalShowForField);
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  /**
   * options description
   * format:String { 'original', 'crop' , 'thumb' } - in case image is not cropped, original is used, defaults to
   * width - Number
   * height - Number
   */
  angular
    .module('app.adpUi')
    .component('adpThumb', {
      templateUrl: 'app/adp-ui/components/adp-images/adp-image/adp-image.template.html',
      bindings: {
        fileItem: '<',
        options: '<',
      },
      controller: 'AdpThumbController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .controller('AdpImageController', AdpImageController);

  /** @ngInject */
  function AdpImageController(
    AdpFileManagerService,
    AdpMimeService,
    AdpMediaTypeHelper
  ) {
    var vm = this;
    var currentCropSrc;

    vm.$onInit = function () {
      vm.fileType = AdpMimeService.getFileMimeTypePreset(vm.fileItem.name);
      if (vm.fileType !== 'images') {
        return;
      }

      vm.src = '';
      vm.isUploaded = !!vm.fileItem.isDummyFile;
      vm.format = vm.format || 'original';

      vm.$doCheck = doCheck;

      getImageSource(vm.fileItem)
        .then((dataURI) => {
          vm.src = dataURI;
          vm.fileItem.cropSrc = vm.src;
          currentCropSrc = vm.src;
        });
    };

    vm.getImgLink = function (fileItem) {
      if (vm.isUploaded) {
        return AdpMediaTypeHelper.getImgLink(fileItem);
      }

      return AdpFileManagerService.imgFileObjectToDataURI(fileItem);
    }

    vm.getThumbImgLink = function (fileItem) {
      if (vm.isUploaded) {
        return AdpMediaTypeHelper.getThumbImgLink(fileItem);
      }

      return AdpFileManagerService.imgFileObjectToDataURI(fileItem);
    }

    vm.getCroppedImgLink = function (fileItem) {
      if (vm.isUploaded) {
        return fileItem.cropped ?
          AdpMediaTypeHelper.getCroppedImgLink(fileItem) :
          AdpMediaTypeHelper.getThumbImgLink(fileItem);
      }

      if (fileItem.cropSrc) {
        return fileItem.cropSrc;
      }

      return AdpFileManagerService.imgFileObjectToDataURI(fileItem);
    }

    function doCheck() {
      if (currentCropSrc !== vm.fileItem.cropSrc) {
        currentCropSrc = vm.fileItem.cropSrc;
        vm.src = vm.fileItem.cropSrc;
      }
    }

    function getImageSource(fileItem) {
      const formats = {
        original: 'getImgLink',
        crop: 'getCroppedImgLink',
        thumb: 'getThumbImgLink',
      };

      const formatFnName = formats[vm.format];
      return vm[formatFnName](fileItem);
    }
  }
})();
;;(function () {
  'use strict';

  /**
   * options - Object
   *   format { 'original', 'crop' , 'thumb' } - in case image is not cropped, original is used
   *   width - Number
   *   height - Number
   */
  angular
    .module('app.adpUi')
    .component('adpImage', {
      templateUrl: 'app/adp-ui/components/adp-images/adp-image/adp-image.template.html',
      bindings: {
        fileItem: '<',
        format: '<',
        width: '<',
        height: '<',
      },
      controller: 'AdpImageController',
      controllerAs: 'vm'
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .controller('AdpThumbController', AdpThumbController);

  /** @ngInject */
  function AdpThumbController(
    AdpFileManagerService,
    AdpMimeService,
    AdpMediaTypeHelper
  ) {
    var vm = this;
    var currentCropSrc;

    vm.$onInit = function () {
      vm.fileType = AdpMimeService.getFileMimeTypePreset(vm.fileItem);
      if (vm.fileType !== 'images') {
        return;
      }
      vm.src = '';
      vm.$doCheck = doCheck;

      getImageSource(vm.fileItem)
        .then(function (dataURI) {
          vm.src = dataURI;
          vm.fileItem.cropSrc = vm.src;
          currentCropSrc = vm.src;
        });
    };

    function doCheck() {
      if (currentCropSrc !== vm.fileItem.cropSrc) {
        currentCropSrc = vm.fileItem.cropSrc;
        vm.src = vm.fileItem.cropSrc;
      }
    }

    function getImageSource(fileItem) {
      var croppedOnClient = !!vm.fileItem.cropSrc;
      if (croppedOnClient) {
        return vm.fileItem.cropSrc;
      }

      var fileUploaded = !!fileItem.isDummyFile;
      if (fileUploaded) {
        var fnName = fileItem.cropped ? 'getCroppedImgLink' : 'getThumbImgLink';
        return AdpMediaTypeHelper[fnName](fileItem);
      }

      return AdpFileManagerService.imgFileObjectToDataURI(fileItem);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpUi')
    .directive('adpChartEcharts', adpChartEcharts);

  /** @ngInject */
  function adpChartEcharts(
    AdpChartService,
    $timeout
  ) {
    return {
      restrict: 'E',
      template: '<div style="width: 100%; height: 100%;" class="adp-charts-container"></div>',
      scope: {
        options: '=',
        data: '=',
      },
      replace: true,
      link: function (scope, element) {
        $timeout(init);

        function init() {
          var chart = echarts.init(element[0]);
          var chartOptions = AdpChartService.evalOptions(scope.options);
          var dataFromOptions = _.get(chartOptions, 'dataset.source', scope.data);

          if (scope.data) {
            if (_.isEmpty(dataFromOptions)) {
              scope.options = setNoDataMessageOptions(chartOptions.title.text);
            } else {
              _.set(chartOptions, 'dataset.source', scope.data);
            }
          }

          chart.setOption(chartOptions);
          chart.resize();
          bindEvents(chart);
        }

        function bindEvents(chart) {
          $(window).on('resize.echarts', _.debounce(function () {
            chart.resize();
          }, 200));

          scope.$watch(
            function () {
              return element.parent().width()
            },
            function (newVal, oldVal) {
              if (newVal !== oldVal) {
                chart.resize();
              }
            }
          );

          scope.$on('$destroy', function () {
            chart.dispose();
            $(window).off('resize.echarts');
          });
        }

        function setNoDataMessageOptions(title) {
          var title = title || '';

          var opts = {
            title: {
              show: true,
              textStyle: {
                color: '#bcbcbc',
                lineHeight: 32,
              },
              text: 'No Data Available for \n "' + title + '"',
              left: 'center',
              top: 'center'
            }
          };

          return opts;
        }
      }
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionMutationBuilder', GraphqlCollectionMutationBuilder);

  /** @ngInject */
  function GraphqlCollectionMutationBuilder() {
    return {
      create: create,
      update: update,
      delete: deleteRecord,
      importDataSet: importDataSet,
    };

    function create(mutationName, schema) {
      var recordType = getRecordType(schema.schemaName);

      return [
        'mutation m(',
          '$record: ' + recordType,
        ') {',
          mutationName + ' (record: $record) { _id }',
        '}',
      ].join('\n');
    }

    function update(mutationName, schema, updatePaths) {
      const recordType = getRecordType(schema.schemaName);
      const updatePathsParam = _.isEmpty(updatePaths) ? '' : `, updatePaths: [${updatePaths.map((p) => `"${p}"`)
        .join(', ')}]`;

      return [
        'mutation m(',
        '$record: ' + recordType,
        '$filter: MongoIdInput!',
        ') {',
        mutationName + ' (record: $record, filter: $filter',
        updatePathsParam,
        ') { _id }',
        '}'
      ].join('\n');
    }

    function deleteRecord(mutationName) {
      return [
        'mutation m($filter: MongoIdInput!) {',
          mutationName + ' (filter: $filter) { deletedCount }',
        '}',
      ].join('\n');
    }

    function importDataSet(mutationName) {
      return [
        'mutation m(',
          '$fileId: String!',
          '$modelName: String!',
          '$updateSchemaByFileContent: Boolean',
        ') {',
          mutationName + ' (',
            'fileId: $fileId, modelName: $modelName, updateSchemaByFileContent: $updateSchemaByFileContent',
          ') { importedRowsNumber errors }',
        '}',
      ].join('\n');
    }

    function getRecordType(schemaName) {
      return schemaName + 'InputWithoutId';
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionMutator', GraphqlCollectionMutator);

  /** @ngInject */
  function GraphqlCollectionMutator(
    GraphqlCollectionMutationBuilder,
    GraphqlRequest
  ) {
    return {
      create: create,
      clone: create,
      update: update,
      delete: deleteRecord,
      cloneDataSet: cloneDataSet,
      importDataSet: importDataSet,
    };

    function create(schema, record) {
      var mutatorName = schema.schemaName + 'Create';

      return GraphqlRequest({
        name: mutatorName,
        query: GraphqlCollectionMutationBuilder.create(mutatorName, schema),
        variables: { record: record },
      });
    }

    function update(schema, record, updatePaths = [], customMutatorName) {
      var mutatorName = customMutatorName ? customMutatorName : schema.schemaName + 'UpdateOne';
      var recordWithoutId = _.cloneDeep(record);
      _.unset(recordWithoutId, '_id');
      _.unset(recordWithoutId, '_actions');

      return GraphqlRequest({
        name: mutatorName,
        query: GraphqlCollectionMutationBuilder.update(mutatorName, schema, updatePaths),
        variables: {
          record: recordWithoutId,
          filter: { _id: record._id },
        },
      });
    }

    function deleteRecord(schema, record) {
      var mutatorName = schema.schemaName + 'DeleteOne';

      return GraphqlRequest({
        name: mutatorName,
        query: GraphqlCollectionMutationBuilder.delete(mutatorName),
        variables: {
          filter: { _id: record._id },
        },
      });
    }

    function cloneDataSet(schema, record) {
      var mutatorName = 'datasetsClone';

      return GraphqlRequest({
        name: mutatorName,
        query: GraphqlCollectionMutationBuilder.create(mutatorName, schema),
        variables: { record: record },
      });
    }

    function importDataSet(schema, uploadedFile, updateSchemaByFileContent) {
      var mutatorName = 'universalImportData';

      return GraphqlRequest({
        name: mutatorName,
        query: GraphqlCollectionMutationBuilder.importDataSet(mutatorName),
        variables: {
          fileId: uploadedFile.id,
          modelName: schema.schemaName,
          updateSchemaByFileContent,
        },
      });
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionQueryBuilder', GraphqlCollectionQueryBuilder);

  /** @ngInject */
  function GraphqlCollectionQueryBuilder(GraphqlCollectionFields) {
    return function (queryName, schema, options) {
      var isQf = options.customOptions && options.customOptions.quickFilterId;
      var qfType = isQf ? ", $quickFilterId: MongoId" : "";
      var qfValue = isQf ? ", quickFilterId: $quickFilterId" : "";

      if (options.group) {
        return [
          'query q($dxQuery: String! ',qfType,', $group: [dxGroupInput], $groupSummary: [dxSummaryInput], $totalSummary: [dxSummaryInput], $skip: Int, $take: Int) {',
            queryName,
            '(',
              'filter: { dxQuery: $dxQuery ', qfValue, ' },',
              'group: $group,',
              'groupSummary: $groupSummary,',
              'totalSummary: $totalSummary,',
              'requireTotalCount: ' + !!options.requireTotalCount + ',',
              'requireGroupCount: ' + !!options.requireGroupCount + ',',
              'skip: $skip,',
              'take: $take,',
            ') {',
              'data',
              options.requireTotalCount ? 'totalCount' : '',
              options.requireGroupCount ? 'groupCount' : '',
              options.groupSummary || options.totalSummary ? 'summary' : '',
            '}',
          '}',
        ].join('\n');
      } else {
        var items = GraphqlCollectionFields.get(schema);
        return [
          'query q($sort: String, $page: Int, $perPage: Int, $dxQuery: String!',qfType,', $isGroupFilter: Boolean) {',
            queryName,
            '(',
              'sort: $sort,',
              'page: $page,',
              'perPage: $perPage,',
              'filter: { dxQuery: $dxQuery', qfValue, '},',
              'isGroupFilter: $isGroupFilter',
            ') {',
              'count',
              items,
            '}',
          '}',
        ].join('\n');
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionQueryVariables', GraphqlCollectionQueryVariables);

  /** @ngInject */
  function GraphqlCollectionQueryVariables(GraphqlHelper) {
    return function (schema, params) {
      var ret;

      if (params.group) {
        ret = {
          group: params.group || [],
          groupSummary: params.groupSummary || [],
          totalSummary: params.totalSummary || [],
          dxQuery: dxQuery(schema, params),
          skip: params.skip,
          take: params.take,
        };
      } else {
        ret = {
          sort: sort(params.sort),
          dxQuery: dxQuery(schema, params),
          isGroupFilter: params.isGroupFilter,
        };

        if (params.take) {
          ret.page = page(params);
          ret.perPage = perPage(params.take);
        }
      }

      if (params.customOptions && params.customOptions.quickFilterId) {
        ret.quickFilterId = params.customOptions.quickFilterId;
      }

      return ret;
    };

    function sort(sort) {
      var fieldNameToSortBy = 'selector';
      var sortObject = _.keyBy(sort, fieldNameToSortBy);
      var sortParams = _.mapValues(sortObject, function (val) {
        return val.desc ? -1 : 1;
      });

      sortParams = _.map(sortParams, function (value, key) {
        return [key, value].join(':')
      });

      return '{' + sortParams.join(', ') + '}';
    }

    function dxQuery(schema, params) {
      var buildFilter = params.customOptions && _.clone(params.customOptions.filterBuilder);
      var filter = GraphqlHelper.combineFilters(schema, params.filter, buildFilter);

      if (!filter) {
        return '';
      }

      return JSON.stringify(filter);
    }

    function page(params) {
      var page = Math.floor(params.skip / params.take) + 1;

      if (_.isNaN(page)) {
        return 1;
      }

      return page;
    }

    function perPage(perPage) {
      if (!perPage) {
        return 10;
      }

      return perPage;
    }

  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionQueryWithMongoFilter', GraphqlCollectionQueryWithMongoFilter);

  /** @ngInject */
  function GraphqlCollectionQueryWithMongoFilter(
    GraphqlCollectionFields,
    GraphqlRequest
  ) {
    return function (schema, params) {
      var params = params || {};

      return GraphqlRequest({
        name: getQueryName(schema),
        query: getQuery(schema),
        variables: _.pick(params, ['sort', 'mongoQuery', 'page', 'perPage']),
      });
    };

    function getQuery(schema) {
      var items = GraphqlCollectionFields.get(schema);

      return [
        'query q($sort: String, $page: Int, $perPage: Int, $mongoQuery: String) {',
          getQueryName(schema),
        '(',
          'sort: $sort,',
          'page: $page,',
          'perPage: $perPage,',
          'filter: { mongoQuery: $mongoQuery },',
        ') {',
            'count',
            items,
          '}',
        '}',
      ].join('\n');
    }

    function getQueryName(schema) {
      return schema.schemaName;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlCollectionQuery', GraphqlCollectionQuery);

  /** @ngInject */
  function GraphqlCollectionQuery(
    GraphqlCollectionQueryBuilder,
    GraphqlCollectionQueryVariables,
    GraphqlRequest,
    GraphqlHelper
  ) {
    return function (schema, params) {
      var params = params || {};
      var queryName = GraphqlHelper.collectionQueryName(schema, params);

      return GraphqlRequest({
        name: queryName,
        query: GraphqlCollectionQueryBuilder(queryName, schema, params),
        variables: GraphqlCollectionQueryVariables(schema, params),
      });
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlSingleDatasetQuery', GraphqlSingleDatasetQuery);

  /** @ngInject */
  function GraphqlSingleDatasetQuery(
    GraphqlCollectionQueryBuilder,
    GraphqlCollectionFields,
    GraphqlRequest,
    ResponseError
  ) {
    return function (id) {
      var queryName = 'getSingleDataset';
      var dataSetSchema = window.adpAppStore.appModel().datasets;

      var schemaForQuery = {
        type: 'Schema',
        schemaName: 'datasetSingle',
        fields: dataSetSchema.fields.scheme.fields,
      };
      var schemeItems = GraphqlCollectionFields.get(schemaForQuery, 'scheme');

      return GraphqlRequest({
        name: queryName,
        query: [
          "query q($id: MongoId!) {",
            "getSingleDataset(filter: { _id: $id }) {",
              schemeItems,
            "}",
          "}",
        ].join("\n"),
        variables: { id: id },
      })
      .then(handleResponseData);
    };

    function handleResponseData(data) {
      if (_.isNil(data)) {
        throw new ResponseError(ResponseError.RECORD_NOT_FOUND);
      }

      var scheme = _.get(data, "scheme", null);
      if (scheme === null) {
        throw new ResponseError(ResponseError.SCHEMA_IS_EMPTY);
      }

      return scheme;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlIconField', GraphqlIconField);

  /** @ngInject */
  function GraphqlIconField(GraphqlHelper) {
    return {
      get: get
    };

    function get(field, name) {
      var fieldsString = ['family', 'name'].join('\n');
      return GraphqlHelper.wrapFieldString(fieldsString, name);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlLocationField', GraphqlLocationField);

  /** @ngInject */
  function GraphqlLocationField(GraphqlHelper) {
    return {
      get: get
    };

    function get(field, name) {
      var fieldsString = locationItems();
      return GraphqlHelper.wrapFieldString(fieldsString, name);
    }

    function locationItems() {
      var fields = [
        'coordinates',
        'label',
      ];

      return fields.join('\n');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlLookupField', GraphqlLookupField);

  /** @ngInject */
  function GraphqlLookupField(GraphqlHelper) {
    return {
      get: get
    };

    function get(field, name) {
      var fieldsString;

      if (lookupHasMultipleTable(field)) {
        fieldsString = getLookupFieldsWithMultipleTables(field);
      } else {
        fieldsString = getLookupFieldsWithSingTables(field);
      }

      return GraphqlHelper.wrapFieldString(fieldsString, name);
    }

    function lookupHasMultipleTable(field) {
      return _.values(field.lookup.table).length > 1;
    }

    function getLookupFieldsWithMultipleTables(field) {
      var tables = _.values(field.lookup.table);

      return tables.map(function (table) {
        var enumName = lookupEnumName(field, table);
        var fieldsString = lookupItems(table);

        return GraphqlHelper.wrapFieldString(fieldsString, enumName);
      }).join('\n');
    }

    function lookupEnumName(field, table) {
      return '... on ' + ['Lookup', field.lookup.id, table.table].join('_');
    }

    function getLookupFieldsWithSingTables(field) {
      var table = _.values(field.lookup.table)[0];
      return lookupItems(table);
    }

    function lookupItems(table) {
      var fields = [
        '_id',
        'label',
        'table',
      ];

      if (table.data) {
        fields.push(getDataFieldsForLookup(table));
      }

      return fields.join('\n');
    }

    function getDataFieldsForLookup(table) {
      var dataFields = Object.keys(table.data).join('\n');
      return GraphqlHelper.wrapFieldString(dataFields, 'data');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlTreeSelectorField', GraphqlTreeSelectorField);

  /** @ngInject */
  function GraphqlTreeSelectorField(
    GraphqlHelper
  ) {
    return {
      get: get
    };

    function get(field, name) {
      var fieldsString = treeSelectorItems();
      return GraphqlHelper.wrapFieldString(fieldsString, name);
    }

    function treeSelectorItems() {
      var fields = [
        '_id',
        'label',
        'table',
        'isLeaf',
      ];

      return fields.join('\n');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlLookupQueryBuilder', GraphqlLookupQueryBuilder);

  /** @ngInject */
  function GraphqlLookupQueryBuilder() {
    return function (queryName, tableDef, lookupId) {
      return ['query (',
          typeDefinitions(tableDef, lookupId),
        ') {',
        queryName,
        '(',
          'filter: $filter',
          'page: $page,',
          'perPage: $perPage,',
        ')',
        '{',
          'count',
          'items { ',
            lookupItems(tableDef),
          '}',
        '}',
        '}'].join('\n');
    };

    function typeDefinitions(tableDef, lookupId) {
      var types = [
        '$page: Int',
        '$perPage: Int',
        '$filter: ' + filterType(tableDef, lookupId),
      ];

      return types.join(', ');
    }

    function filterType(tableDef, lookupId) {
      return tableDef.where ?
        `lookupFilter_${ lookupId }_${ tableDef.table }`:
        `lookupFilter`;
    }

    function lookupItems(table) {
      var fields = [
        '_id',
        'label',
        'table',
      ];

      if (table.data) {
        fields.push(getDataFieldsForLookup(table));
      }

      return fields.join('\n');
    }

    function getDataFieldsForLookup(table) {
      var dataFields = Object.keys(table.data).join('\n');
      return 'data {'.concat(dataFields, '}') ;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlLookupQueryVariables', GraphqlLookupQueryVariables);

  /** @ngInject */
  function GraphqlLookupQueryVariables() {
    return function getQueryParams(params, args) {
      var variables = {
        page: page(params),
        perPage: params.perPage || 15,
        filter: filterParam(params, args),
      };

      return variables;
    };

    function page(params) {
      var page = (params.skip / params.take) + 1;

      if (_.isNaN(page)) {
        return 1;
      }

      return page;
    }

    function filterParam(params, args) {
      var filter = {};
      if (params.searchValue) {
        filter.q = params.searchValue || '';
      } else {
        filter.dxQuery = JSON.stringify(params.dxQuery);
      }

      if (params.selectedTable.where) {
        setFormDataToFilter(filter, args.row);
      }

      return filter;
    }

    function setFormDataToFilter(filter, formData) {
      filter.form = _.cloneDeep(formData);

      _.unset(filter.form, '_id');
      _.unset(filter.form, '_actions');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlLookupQuery', GraphqlLookupQuery);

  /** @ngInject */
  function GraphqlLookupQuery(
    GraphqlLookupQueryBuilder,
    GraphqlLookupQueryVariables,
    GraphqlRequest
  ) {
    return function (args, params) {
      var queryName = lookupQueryName(args.fieldSchema, params.selectedTable);
      var lookupId = args.fieldSchema.lookup.id;

      return GraphqlRequest({
        name: queryName,
        query: GraphqlLookupQueryBuilder(queryName, params.selectedTable, lookupId),
        variables: GraphqlLookupQueryVariables(params, args),
      });
    };

    function lookupQueryName(field, table) {
      return ['Lookup', field.lookup.id, table.table].join('_');
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpApi')
    .factory('GraphqlTreeSelectorQuery', GraphqlTreeSelectorQuery);

  /** @ngInject */
  function GraphqlTreeSelectorQuery(
    GraphqlLookupQueryBuilder,
    GraphqlLookupQueryVariables,
    GraphqlRequest
  ) {
    return function (args, params) {
      var queryName = getQueryName(args.fieldSchema);

      return GraphqlRequest({
        name: queryName,
        query: queryBody(queryName),
        variables: queryVars(params),
      });
    };

    function getQueryName(field) {
      var tableName = _.keys(field.table)[0];
      var tableId = field.table.id;

      return ['Treeselector', tableId, tableName].join('_');
    }

    function queryBody(queryName) {
      return [
        'query q($filter: treeselectorFilter, $page: Int, $perPage: Int, ) {',
          queryName + ' (filter: $filter, page: $page, perPage: $perPage) {',
          'items {',
            '_id',
            'label',
            'table',
            'isLeaf',
          '}',
          'count',
          '}',
        '}',
      ].join('\n')
    }

    function queryVars(params) {
      return {
        filter: {
          q: params.searchValue,
          foreignKeyVal: params.foreignKeyVal,
        },
        page: page(params),
        perPage: params.take || 20,
      }
    }

    function page(params) {
      var page = Math.floor(params.skip / params.take) + 1;

      if (_.isNaN(page)) {
        return 1;
      }

      return page;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .directive('recordDetailsGrouping', recordDetailsGrouping);

  function recordDetailsGrouping() {
    return {
      restrict: 'E',
      scope: {
        groups: '<',
        schema: '<',
        filteredRecord: '<',
        args: '<',
      },
      templateUrl: 'app/adp-data-grid/components/adp-record-details/groups/record-details-grouping/record-details-grouping.template.html',
      replace: true,
      link(scope) {
        const removeWatcher = scope.$watchGroup(['groups', 'filteredRecord'], (val) => {
          if (_.every(val, _.isNil)) {
            return;
          }

          scope.accordionOptions = {
            collapsible: true,
            multiple: true,
            items: _.map(scope.groups),
            itemTemplate: 'group',
          };
          removeWatcher();
        });

        scope.selectColumnClass = function (field) {
          var fieldWidth = field.formWidth || 12;
          return ['adp-col', 'adp-col-' + fieldWidth];
        }

        scope.showValue = function (field) {
          return field.type === 'Blank' || !_.isUndefined(scope.filteredRecord[field.fieldName]);
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ShowInDataFiltrationHelper', ShowInDataFiltrationHelper);

  /** @ngInject */
  function ShowInDataFiltrationHelper(AdpUnifiedArgs) {
    return function (rootArgs, cb) {
      var rootArgsCopy = _.cloneDeep(rootArgs);
      rootArgsCopy.data = rootArgsCopy.row;

      return evalShownIn(rootArgsCopy);

      function evalShownIn(curArgs) {
        var field = curArgs.fieldSchema;

        if (isArray(field)) {
          return filterArray(curArgs);
        } else if (isObject(field) || isSchema(field)) {
          return filterObject(curArgs);
        } else {
          return curArgs.data;
        }

        function filterArray(arrayArgs) {
          var dest = arrayArgs.fieldSchema.type === 'Array' ? [] : {};

          return  _(arrayArgs.data)
            .transform(function (result, arrayItem, arrayIndexOrKey) {
              result[arrayIndexOrKey] = filterArrayItem(arrayArgs, arrayItem, arrayIndexOrKey);
            }, dest)
            .pull(undefined)
            .value();
        }

        function filterArrayItem(arrayArgs, arrayItem, arrayIndexOrKey) {
          var arrayItemArgs = getArrayArgs(arrayArgs, arrayItem, arrayIndexOrKey);
          var shouldShow = cb(arrayItemArgs);

          if (!shouldShow) {
            return;
          }

          return filterObject(arrayItemArgs);
        }

        function filterObject(curArgs) {
          return _.transform(curArgs.data, function (acc, val, name) {
            var newVal = iteratee(curArgs, val, name);
            (newVal !== undefined) && (_.set(acc, name, newVal));
          }, {});
        }

        function iteratee(curArgs, val, name) {
          var nextArgs = getNextArgs(curArgs, name);
          var shouldShow = cb(nextArgs);

          if (!shouldShow) {
            return;
          }

          return evalShownIn(nextArgs, val);
        }

        function isObject(field) {
          return field.type === 'Object';
        }

        function isSchema(field) {
          return field.type === 'Schema';
        }

        function isArray(field) {
          return field.type === 'Array' || field.type === 'AssociativeArray';
        }

        function getArrayArgs(arrayArgs, arrayItem, arrayIndexOrKey) {
          var isAssocArray = _.isString(arrayIndexOrKey);

          if (isAssocArray) {
            return _.assign({}, arrayArgs, {
              data: arrayArgs.data[arrayIndexOrKey]
            });
          } else {
            return AdpUnifiedArgs.getHelperParams({
              path: arrayArgs.path + '[' + arrayIndexOrKey + ']',
              formData: arrayArgs.row,
              action: arrayArgs.action,
              schema: arrayArgs.modelSchema,
            });
          }
        }

        function getNextArgs(args, name) {
          var nextArgs = AdpUnifiedArgs.next(args, name);

          if (args.fieldSchema.type === 'AssociativeArray') {
            return _.assign({}, nextArgs, {
              data: _.get(args.data, name),
            });
          }

          return nextArgs;
        }

      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('EvalShowIn', EvalShowIn);

  /** @ngInject */
  function EvalShowIn(ShowInDataFiltrationHelper, AdpUnifiedArgs, ACTIONS) {
    var functionCacheStore = [];

    return {
      forViewDetails: evalForViewDetails,
      createFilterMemoizedFunction: createFilterMemoizedFunction,
      removeMemoizedFunction: removeMemoizedFunction,
    };

    function evalForViewDetails(args) {
      var argsWithFilteredData = evalShowInForGroup(args);
      return ShowInDataFiltrationHelper(argsWithFilteredData, evalShowExpr);
    }

    function evalShowInForGroup(args) {
      var hasGroup = !!_.get(args, 'modelSchema.parameters.groupingType');

      if (!hasGroup) {
        return args;
      }

      var lastGroup = null;
      var groups = _.transform(args.modelSchema.fields, function (result, field) {
        if (field.type === 'Group') {
          lastGroup = _.clone(field);
          result[field.fieldName] = lastGroup;
        } else if (lastGroup) {
          lastGroup.fields = lastGroup.fields || {};
          lastGroup.fields[field.fieldName] = field;
        } else {
          result[field.fieldName] = field;
        }
      }, {});

      _.forEach(groups, function(group) {
        var groupArgs = AdpUnifiedArgs.getArgsForGroup(group, args);
        var shouldShow = evalShowExpr(groupArgs);

        if (shouldShow) {
          return;
        }

        _.forEach(groupArgs.data, function (val, key) {
          _.unset(args.row, key);
        });
        _.unset(args.row, groupArgs.path);
      });

      return args;
    }

    function createFilterMemoizedFunction() {
      const func = function (schema, row) {
        const args = AdpUnifiedArgs.getHelperParamsWithConfig({
          path: '',
          formData: row,
          action: ACTIONS.VIEW,
          schema: schema,
        });

        return ShowInDataFiltrationHelper(args, evalShowExpr);
      };

      const memoized = _.memoize(func, (schema, row) => row);
      functionCacheStore.push(memoized);

      return memoized;
    }

    function removeMemoizedFunction(fn) {
      var indexOfFn = _.indexOf(functionCacheStore, fn);
      if (indexOfFn < 0) {
        return;
      }

      var fnToRemove = functionCacheStore[indexOfFn];
      fnToRemove.cache = null;

      functionCacheStore.splice(indexOfFn, 1);
    }

    function evalShowExpr(args) {
      var showPropertyName = ({
        viewDetails: 'showInViewDetails',
        view: 'showInDatatable'
      })[args.action];

      var showIn = _.get(args, 'fieldSchema.' + showPropertyName);

      try {
        return new Function('return ' + showIn).call(args);
      } catch (e) {
        console.error('Error while evaluating show attribute for: ', e, args.path);
        return true;
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('MixedTypeTabbedView', MixedTypeTabbedView);

  /** @ngInject */
  function MixedTypeTabbedView(TreeViewWidget) {
    return function (args, complexTypeRenderer, { height = 400 } = {}) {
      var YAML = complexTypeRenderer(args);

      var tabsEl = $('<div>');
      var treeViewWidget;
      setTimeout(function () {
        var tabsInstance = tabsEl.dxTabPanel({
          selectedIndex: 0,
          height,
          items: [{
            title: 'Tree View',
            template: function (data, index, element) {
              var wrapper = $('<div class="adp-tab-content">');
              treeViewWidget = TreeViewWidget(args.data)
                .appendTo(wrapper);

              element.append(treeViewWidget);
            },
          }, {
            title: 'YAML',
            html: tabContent(!!YAML.html ? YAML.html() : YAML),
          }, {
            title: 'JSON',
            html: tabContent(JSON.stringify(args.data, null, 4)),
          }],
          scrollingEnabled: true,
        }).dxTabPanel('instance');

        tabsEl.on('remove', function () {
          treeViewWidget.dispose();
          tabsInstance.dispose();
        })
      }, 0);

      return tabsEl;
    }

    function tabContent(contentStr) {
      return `<div class="adp-tab-content"><div>${_.escape(contentStr)}</div></div>`;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('TreeViewDataMapper', TreeViewDataMapper);

  /** @ngInject */
  function TreeViewDataMapper() {
    return function (data) {
      var mapped = mapDataToTreeView(data);
      return mapped.items;
    }

    function mapDataToTreeView(data, name) {
      if (_.isArray(data)) {
        return {
          text: nameTpl(name),
          items: mapToArray(data),
        };
      } else if (_.isObject(data)) {
        return {
          text: nameTpl(name),
          items: mapToObject(data),
        };
      } else {
        return { text: nameTpl(name) + _.escape(data) };
      }

      function mapToArray(array) {
        return _.chain(array)
          .compact()
          .map(mapDataToTreeView)
          .value();
      }

      function mapToObject(object) {
        return _.chain(object)
          .map(mapDataToTreeView)
          .compact()
          .value();
      }
    }

    function nameTpl(name) {
      return '<b>' + name + '</b>: ';
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('TreeViewWidget', TreeViewWidget);

  /** @ngInject */
  function TreeViewWidget(TreeViewDataMapper) {
    return (data) => {
      const treeViewData = TreeViewDataMapper(data);
      const td = $('<div>');
      if (treeViewData.length === 1) {
        treeViewData[0].expanded = true;
      }

      td.dxTreeView({
        animationEnabled: false,
        expandEvent: 'click',
        items: treeViewData,
        focusStateEnabled: false,
        itemTemplate({ text }) {
          return text;
        }
      });
      return td;
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialUnitsFilterHelpers', ImperialUnitsFilterHelpers);

  /** @ngInject */
  function ImperialUnitsFilterHelpers(
    AdpFieldsService
  ) {
    function createFilterComponent(options) {
      var editorName = 'dxSelectBox';
      var editorOptions = {
        value: options.value,
        valueExpr: 'value',
        displayExpr: 'label',
        dataSource: options.unit.list,
        onValueChanged: options.onValueChanged,
        placeholder: 'Select ' + options.unit.shortName,
        showClearButton: true,
        elementAttr: {
          class: 'adp-select-box adp-imperial-units-multiple',
        },
      };

      return options.element[editorName](editorOptions);
    }

    function getUnits(fieldSchema) {
      return AdpFieldsService.getUnitsList(fieldSchema);
    }

    function createRangePlaceholderElement(placeholder) {
      return $('<div class="imperial-unit-range-text">' + placeholder + '</div>');
    }

    return {
      getUnits: getUnits,
      createFilterComponent: createFilterComponent,
      createRangePlaceholderElement: createRangePlaceholderElement,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialUnitMultipleFilter', ImperialUnitMultipleFilter);

  /** @ngInject */
  function ImperialUnitMultipleFilter(ImperialUnitsEditorsHelpers) {
    return function () {
      return {
        element: $('<div>'),

        create: function (init) {
          this.options = init;
          this.units = ImperialUnitsEditorsHelpers.getUnits(this.options.args.fieldSchema);

          this.init();
        },

        init: function () {
          this.value = this.getInitialValue(this.options.args.data);

          this.elements = this.units.map(function (unit, index) {
            return this.createSelectBox(unit, index, this.value[index]);
          }, this);
          this.element.append(this.elements);

          this.addRangeText(this.options.placeholder);
        },

        getInitialValue: function (v) {
          return typeof v === 'string' ? v.split('.').map(Number) : [null, null];
        },

        addRangeText: function (placeholder) {
          if (!placeholder) {
            return;
          }

          var el = ImperialUnitsEditorsHelpers.createRangePlaceholderElement(placeholder);
          this.element.prepend(el);
        },

        createSelectBox: function (unit, position, value) {
          var self = this;

          return ImperialUnitsEditorsHelpers.createFilterComponent({
            unit: unit,
            element: $('<div>'),
            onValueChanged: function (e) {
              self.setValue(e.value, position);
              self.options.onValueChanged({ value: self.getValue() });
            },
            value: value,
          });
        },

        setValue: function (value, position) {
          if (_.isNull(value) && _.isNil(position)) {
            this.value = null;
          }

          this.value = this.value || [null, null];
          this.value[position] = _.isNil(value) ? null : value;
          this.value = _.isEmpty(_.compact(this.value)) ? null : this.value;
        },

        getValue: function() {
          return _.isNull(this.value) ? null : this.value.join('.');
        },

        reset: function () {
          this.elements.forEach(function (el) {
            // WORKAROUND: dx grid somehow manages to dispose second filter before first while
            // filter operation changed from any to 'between'
            // dxGrid throws error: 'dxSelectBox' is not init for this element
            // this code attempts to reset filter if element exist, if not just pass through
            try {
              var filterInstance = el.dxSelectBox('instance');
              filterInstance.reset();
            } catch (e) {}
          });
          this.setValue(null);
          this.options.onValueChanged({ value: null });
        },

        getElement: function () {
          return this.element;
        }
      };
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('ImperialUnitSingleFilter', ImperialUnitSingleFilter);

  /** @ngInject */
  function ImperialUnitSingleFilter(
    ImperialUnitsEditorsHelpers,
    DxEditorMixin
  ) {
    return function () {
      return DxEditorMixin({
        editorName: 'dxSelectBox',
        element: $('<div>'),

        create: function (init) {
          this.createEditor(init);
          this.addRangeText(init.placeholder);
        },

        createEditor: function(init) {
          var units = ImperialUnitsEditorsHelpers.getUnits(init.args.fieldSchema);

          ImperialUnitsEditorsHelpers.createFilterComponent({
            unit: units[0],
            element: this.element,
            onValueChanged: init.onValueChanged,
            value: init.args.data,
          });
        },

        addRangeText: function (placeholder) {
          if (!placeholder) {
            return;
          }

          var el = ImperialUnitsEditorsHelpers.createRangePlaceholderElement(placeholder);
          this.element.prepend(el);
        }
      });
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupFilterSelector', LookupFilterSelector);

  /** @ngInject */
  function LookupFilterSelector(
    LookupDataSource,
    AdpLookupHelpers,
    DxEditorMixin,
    LookupDxConfig
  ) {
    return function (options) {
      var $component = DxEditorMixin({
        element: $('<div>'),

        create: function (parentOptions) {
          this.multiple = true;
          this.args = parentOptions.args;
          this.setEditorsOptions(parentOptions);

          this.editorName = 'dxTagBox';
          this.element[this.editorName](this.editorOptions);
        },

        updateDataSource: function (tableName) {
          var dataSource = LookupDataSource(this.args, tableName);
          this.getInstance().option('dataSource', dataSource);
        },

        setEditorsOptions: function(parentOptions) {
          this.editorOptions = LookupDxConfig.gridEditorMultiple(parentOptions);
          this.editorOptions.showSelectionControls = true;

          this.setChangeHandler(parentOptions.onValueChanged);
        },

        setChangeHandler: function (changeHandler) {
          this.editorOptions.onValueChanged = function (e) {
            if (_.isNil(e.value) || _.isEmpty(e.value)) {
              changeHandler({ value: null });
              return;
            }
            var value = e.value.map(toLookupValue);

            changeHandler({ value: value });
          };
        }
      });

      $component.create(options);

      return $component;
    }

    function toLookupValue(lookup) {
      return {
        _id: lookup._id,
        table: lookup.table,
        label: lookup.label,
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupFilter', LookupFilter);

  /** @ngInject */
  function LookupFilter(
    LookupFilterSelector,
    LookupTypesCellRenderer,
    LookupFilterTableSelector
  ) {
    return function () {
      return {
        element: $('<div class="adp-lookup-filter-container">'),
        lookupOptions: null,
        tableSelector: null,
        selectedTableName: null,
        lookupEditor: null,
        value: null,

        create: function (init) {
          this.lookupOptions = init;
          this.init();
        },

        formatValue: function(params) {
          return LookupTypesCellRenderer.multiple(params.args);
        },

        init: function () {
          this.setClassToContainer(this.lookupOptions.args.fieldSchema.fieldName);
          this.createTableSelector();
          this.createLookupSelector();
        },

        setClassToContainer: function(fieldName) {
          this.element.addClass('lookup-name-' + fieldName);
        },

        createTableSelector: function () {
          var self = this;
          this.tableSelector = LookupFilterTableSelector({
            args: this.lookupOptions.args,
            onTableChanged: function (e) {
              self.lookupEditor.updateDataSource(e.value);
            },
          });

          this.appendToRoot(this.tableSelector);
        },

        createLookupSelector: function () {
          var opts = {
            args: this.lookupOptions.args,
            onValueChanged: this.lookupOptions.onValueChanged,
            selectedTableName: this.tableSelector.getValue(),
          };

          this.lookupEditor = LookupFilterSelector(opts);
          this.appendToRoot(this.lookupEditor);
        },

        reset: function () {
          this.lookupEditor.reset();
        },

        getElement: function () {
          return this.element;
        },

        appendToRoot: function(component) {
          this.element.append(component.getElement());
        },
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpDataGrid')
    .factory('LookupFilterTableSelector', LookupFilterTableSelector);

  /** @ngInject */
  function LookupFilterTableSelector(
    DxEditorMixin,
    LookupDxConfig
  ) {
    return function (options) {
      var component = DxEditorMixin({
        editorName: 'dxSelectBox',
        element: $('<div>'),

        create: function (options) {
          this.editorOptions = LookupDxConfig.tableSelector(options);
          this.element[this.editorName](this.editorOptions);
        },
      });

      component.create(options);

      return component;
    };
  }
})();
;(function () {
  'use strict'

  var WorkerClient = ace.require('ace/worker/worker_client').WorkerClient;
  var Json5de = ace.require('ace/mode/python').Mode;

  function Json5deWithWorker() {
    Json5de.apply(this, arguments);
  }

  Json5deWithWorker.prototype = Object.create(Json5de.prototype);

  Json5deWithWorker.prototype.createWorker = function (session) {
    var worker = new WorkerClient(['ace'], 'ace/mode/json5_worker', 'WorkerModule')
    worker.attachToDocument(session.getDocument())

    worker.on('annotate', function (results) {
      session.setAnnotations(results.data);
    });

    worker.on('terminate', function () {
      session.clearAnnotations();
    });

    return worker;
  };

  angular
    .module('app.adpForms')
    .factory('Json5onEditorMode', function () {
      return Json5deWithWorker;
    });
})();
;(function () {
  'use strict'

  const MongoMode = ace.require('ace/mode/mongodb').Mode;
  function MongoModeWithWorker() {
    MongoMode.apply(this, arguments);
  }

  MongoModeWithWorker.prototype = Object.create(MongoMode.prototype);

  MongoModeWithWorker.prototype.createWorker = function (session) {
    const { WorkerClient } = ace.require('ace/worker/worker_client');
    const worker = new WorkerClient(
      ['ace'],
      'ace/mode/json5_worker',
      'WorkerModule'
    );
    worker.attachToDocument(session.getDocument());

    worker.on('annotate', function(results) {
      session.setAnnotations(results.data);
    });

    worker.on('terminate', function() {
      session.clearAnnotations();
    });

    return worker;
  };

  angular
    .module('app.adpForms')
    .factory('MongoMode', () => MongoModeWithWorker);
})();
;(function () {
  'use strict'

  var WorkerClient = ace.require('ace/worker/worker_client').WorkerClient;
  var PythonMode = ace.require('ace/mode/python').Mode;

  function PythonModeWithWorker() {
    PythonMode.apply(this, arguments);
  }

  PythonModeWithWorker.prototype = Object.create(PythonMode.prototype);

  PythonModeWithWorker.prototype.createWorker = function (session) {
    var worker = new WorkerClient(['ace'], 'ace/mode/python_worker', 'WorkerModule')
    worker.attachToDocument(session.getDocument())

    worker.on('annotate', function (results) {
      session.setAnnotations(results.data);
    });

    worker.on('terminate', function () {
      session.clearAnnotations()
    })

    return worker
  };

  angular
    .module('app.adpForms')
    .factory('PythonEditorMode', function () {
      return PythonModeWithWorker;
    });
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('arrayControlColorDropdown', arrayControlColorDropdown);

  function arrayControlColorDropdown(
    ArrayColorUtil
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        index: '<',
      },
      template: `<div ng-if="::colorDropDownCfg" dx-drop-down-button="::colorDropDownCfg" ng-click="stopPropagation($event)"></div>`,
      require: '^^form',
      link: function (scope, element) {
        const updateArrayItemArgs = () => _.assign({}, scope.args, {
          index: scope.index,
          path: `${scope.args.path}[${scope.index}]`,
        });
        let arrayItemArgs = updateArrayItemArgs();

        let colorBoxComponent;
        const getColorFromComponent = () => colorBoxComponent && colorBoxComponent.option('value');
        scope.stopPropagation = (e) => e.stopPropagation();
        scope.colorDropDownCfg = getColorBoxConfig();

        const onUpdate = function () {
          arrayItemArgs = updateArrayItemArgs();
          const currentColor = getColorFromComponent();
          ArrayColorUtil.setColor(currentColor, arrayItemArgs);
        };

        scope.$on('pathChanged', onUpdate);
        scope.$watch('index', onUpdate);
        // todo: after copypaste

        function getColorBoxConfig() {
          const colors = ArrayColorUtil.getColorsForPicker();

          applyBgColorToHeader();
          return {
            value: ArrayColorUtil.getColor(arrayItemArgs),
            items: colors,
            icon: 'fa fa-eyedropper ',
            stylingMode: 'text',
            showArrowIcon: false,
            onInitialized({ component }) {
              colorBoxComponent = component;
              const currentColor = getColorFromComponent();
              ArrayColorUtil.setColor(currentColor, arrayItemArgs);
            },
            dropDownOptions: {
              width: 150,
              height: 105,
            },
            dropDownContentTemplate(data, $container) {
              const $colorPicker = $('<div>').addClass('adp-array-color-picker').appendTo($container);

              data.forEach((color) => {
                const btnType = color === null ? 'fa fa-square-o reset-btn' : 'dx-icon dx-icon-square';

                const $button = $('<i>')
                  .addClass(`color ${btnType}`)
                  .on('dxclick', () => {
                    this.close();
                    ArrayColorUtil.setColor(color, arrayItemArgs);
                    applyBgColorToHeader();
                  });

                $button.css({
                  color,
                  cursor: 'pointer',
                });
                $colorPicker.append($button);
              });
            },
          };
        }

        function applyBgColorToHeader() {
          const color = ArrayColorUtil.getColor(arrayItemArgs);
          applyColorToHeader(color);
        }

        function applyColorToHeader(color) {
          const header = element.closest('.subform-frame__title');
          const STYLE_NAME = 'background-color';

          if (_.isString(color)) {
            header.css(STYLE_NAME, color);
          } else {
            header.css(STYLE_NAME, '');
          }
        }

      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('complexItemGridCell', complexItemGridCell);
  const template = `
    <div class="complex-grid-control-cell-content">
      <adp-form-field-factory
        args="::args"
        form-context="::formContext"
        is-key="isKey"
        field-name="::fieldName"
        index="index"
      ></adp-form-field-factory>

      <complex-item-required-mark
        args="::args"
        form-context="::formContext"
        is-key="isKey"
        field-name="::fieldName"
        index="index"
      ></complex-item-required-mark>
    </div>`;

  function complexItemGridCell() {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
        fieldName: '<?',
        index: '=?',
        isKey: '=?',
      },
      require: '^^form',
      template,
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('complexItemRequiredMark', complexItemRequiredMark);

  function complexItemRequiredMark(
    AdpValidationUtils,
    AdpUnifiedArgs,
    ArrayKeyArgs
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
        fieldName: '<?',
        index: '=?',
        isKey: '=?',
      },
      template: '<span class="text-danger" ng-show="isRequired()">&nbsp;*</span>',
      require: '^^form',
      link(scope) {
        scope.currArgs = getArgs();
        scope.isRequired = AdpValidationUtils.isRequired(scope.currArgs.path, scope.formContext.requiredMap);

        scope.$watch('index', (newVal, oldVal) => {
          if (newVal === oldVal) {
            return;
          }

          scope.currArgs = getArgs();
          scope.isRequired = AdpValidationUtils.isRequired(scope.currArgs.path, scope.formContext.requiredMap);
        });

        function getArgs() {
          if (scope.isKey) {
            return ArrayKeyArgs(scope.args, scope.index);
          } else {
            return AdpUnifiedArgs.next(
              scope.args,
              scope.fieldName,
              scope.index,
            );
          }
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxColorConfig', DxColorConfig);

  /** @ngInject */
  function DxColorConfig() {
    return function () {
      return {
        widgetName: 'dxColorBox',
        options: {},
      };
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxDateConfig', DxDateConfig);

  /** @ngInject */
  function DxDateConfig(AdpValidationUtils) {
    return function (args) {
      return {
        options: getOptions(args),
        widgetName: 'dxDateBox',
      };
    }

    function getOptions(args) {
      var field = args.fieldSchema;
      var fieldType = args.fieldSchema.type;
      var momentFormat = AdpValidationUtils.getDateFormat(fieldType);
      var dxFormat = momentFormat
        .replace(/D/g, 'd')
        .replace(/Y/g, 'y');

      var options = {
        type: fieldType.toLowerCase(),
        placeholder: momentFormat,
        displayFormat: dxFormat,
        showAnalogClock: false,
        valueChangeEvent: 'change keyup blur',
        useMaskBehavior: true,
        showClearButton: true,
      };

      if (fieldType === 'Time') {
        options.transformOut = x => {
          if (!x) {
            return x;
          }
          const d = new Date(x);
          // type:Time base date is 2000-02-02. Check docs for explanation
          // https://outline.craftus.com/doc/handling-dates-and-time-in-different-timezones-dfagbWEqrt#h-time
          d.setFullYear(2000, 1 /*this is February!*/, 2);
          return d;
        }
      }

      if (hasValidator(field, 'notInFuture' )) {
        options.max = today();
      }

      if (hasValidator(field, 'notInPast' )) {
        options.min = today();
      }

      return options;
    }

    function today() {
      var todaySinceMidnight = new Date();
      return todaySinceMidnight.setHours(0,0,0,0);
    }

    function hasValidator(field, validatorName) {
      return !!_.find(field.validate, { validator: validatorName })
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxImperialWeightConfig', DxImperialWeightConfig);

  /** @ngInject */
  function DxImperialWeightConfig(AdpFieldsService) {
    return function (args) {
      var unit = AdpFieldsService.getUnitsList(args.fieldSchema)[0];

      return {
        options: {
          valueExpr: 'value',
          displayExpr: 'label',
          items: unit.list,
          placeholder: 'Select ' + unit.shortName,
          showClearButton: true,
          elementAttr: {
            class: 'adp-select-box',
            id: 'list_id_' + args.fieldSchema.fieldName,
          },
          inputAttr: {
            'adp-qaid-field-control': args.path,
          },
          itemTemplate: function (data, index, element) {
            element.attr('adp-qaid-control-dropdown-item', args.path);
            return data.label;
          },
        },
        widgetName: 'dxSelectBox',
      };
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxStringConfig', DxStringConfig);

  /** @ngInject */
  function DxStringConfig() {
    return function (args) {
      var type = args.fieldSchema.type;
      var cfg = { mode: getInputType(args.fieldSchema.type) };

      if (type === 'Phone') {
        _.assign(cfg, {
          mask: 'X00-X00-0000',
          maskRules: { X: /[02-9]/ },
          maskChar: 'x',
          maskInvalidMessage: false,
          showMaskMode: 'onFocus',
        })
      }

      return {
        options: cfg,
        widgetName: 'dxTextBox',
      };
    }

    function getInputType(type) {
      var types = {
        'Email': 'email',
        'PasswordAuth': 'password',
        'Url': 'url',
      };

      return types[type] || 'text';
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxTextConfig', DxTextConfig);

  /** @ngInject */
  function DxTextConfig() {
    return function () {
      return {
        options: {
          minHeight: '80px',
          autoResizeEnabled: true,
          valueChangeEvent: 'input blur',
        },
        widgetName: 'dxTextArea',
      };
    }
  }

})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('FONT_AWESOME_ICONS_LIST', [
      'envelope-o',
      'th-large',
      'th-list',
      'check',
      'remove',
      'close',
      'search-plus',
      'search-minus',
      'power-off',
      'signal',
      'gear',
      'trash-o',
      'clock-o',
      'download',
      'arrow-circle-o-down',
      'arrow-circle-o-up',
      'play-circle-o',
      'rotate-right',
      'refresh',
      'list-alt',
      'headphones',
      'volume-off',
      'volume-down',
      'volume-up',
      'barcode',
      'bookmark',
      'text-height',
      'text-width',
      'align-left',
      'align-center',
      'align-right',
      'align-justify',
      'list',
      'dedent',
      'outdent',
      'video-camera',
      'photo',
      'image',
      'picture-o',
      'map-marker',
      'tint',
      'edit',
      'pencil-square-o',
      'share-square-o',
      'check-square-o',
      'step-backward',
      'fast-backward',
      'backward',
      'forward',
      'fast-forward',
      'step-forward',
      'chevron-left',
      'chevron-right',
      'plus-circle',
      'minus-circle',
      'times-circle',
      'check-circle',
      'question-circle',
      'info-circle',
      'crosshairs',
      'times-circle-o',
      'check-circle-o',
      'arrow-left',
      'arrow-right',
      'arrow-up',
      'arrow-down',
      'mail-forward',
      'compress',
      'asterisk',
      'exclamation-circle',
      'eye-slash',
      'warning',
      'exclamation-triangle',
      'calendar',
      'comment',
      'chevron-up',
      'chevron-down',
      'retweet',
      'shopping-cart',
      'folder-open',
      'arrows-v',
      'arrows-h',
      'bar-chart-o',
      'bar-chart',
      'twitter-square',
      'facebook-square',
      'camera-retro',
      'key',
      'gears',
      'comments',
      'thumbs-o-up',
      'thumbs-o-down',
      'star-half',
      'heart-o',
      'sign-out',
      'linkedin-square',
      'thumb-tack',
      'external-link',
      'sign-in',
      'github-square',
      'lemon-o',
      'square-o',
      'bookmark-o',
      'phone-square',
      'twitter',
      'facebook-f',
      'facebook',
      'credit-card',
      'feed',
      'bullhorn',
      'certificate',
      'hand-o-right',
      'hand-o-left',
      'hand-o-up',
      'hand-o-down',
      'arrow-circle-left',
      'arrow-circle-right',
      'arrow-circle-up',
      'arrow-circle-down',
      'briefcase',
      'arrows-alt',
      'group',
      'users',
      'chain',
      'flask',
      'cut',
      'scissors',
      'copy',
      'files-o',
      'paperclip',
      'save',
      'floppy-o',
      'square',
      'navicon',
      'reorder',
      'list-ul',
      'list-ol',
      'strikethrough',
      'underline',
      'pinterest',
      'pinterest-square',
      'google-plus-square',
      'google-plus',
      'caret-down',
      'caret-up',
      'caret-left',
      'caret-right',
      'columns',
      'unsorted',
      'sort',
      'sort-down',
      'sort-desc',
      'sort-up',
      'sort-asc',
      'envelope',
      'linkedin',
      'rotate-left',
      'undo',
      'legal',
      'gavel',
      'dashboard',
      'tachometer',
      'comment-o',
      'comments-o',
      'flash',
      'sitemap',
      'umbrella',
      'paste',
      'clipboard',
      'lightbulb-o',
      'exchange',
      'cloud-download',
      'cloud-upload',
      'user-md',
      'stethoscope',
      'suitcase',
      'cutlery',
      'file-text-o',
      'building-o',
      'hospital-o',
      'ambulance',
      'fighter-jet',
      'h-square',
      'plus-square',
      'angle-double-left',
      'angle-double-right',
      'angle-double-up',
      'angle-double-down',
      'angle-left',
      'angle-right',
      'angle-up',
      'angle-down',
      'desktop',
      'tablet',
      'mobile-phone',
      'circle-o',
      'quote-left',
      'quote-right',
      'spinner',
      'circle',
      'mail-reply',
      'github-alt',
      'folder-o',
      'folder-open-o',
      'smile-o',
      'frown-o',
      'gamepad',
      'keyboard-o',
      'flag-checkered',
      'terminal',
      'code',
      'mail-reply-all',
      'reply-all',
      'star-half-empty',
      'star-half-full',
      'star-half-o',
      'location-arrow',
      'code-fork',
      'unlink',
      'chain-broken',
      'question',
      'exclamation',
      'superscript',
      'subscript',
      'puzzle-piece',
      'microphone',
      'microphone-slash',
      'calendar-o',
      'fire-extinguisher',
      'chevron-circle-left',
      'chevron-circle-right',
      'chevron-circle-up',
      'chevron-circle-down',
      'unlock-alt',
      'bullseye',
      'ellipsis-h',
      'ellipsis-v',
      'rss-square',
      'play-circle',
      'minus-square',
      'minus-square-o',
      'level-up',
      'level-down',
      'check-square',
      'pencil-square',
      'external-link-square',
      'share-square',
      'compass',
      'toggle-down',
      'caret-square-o-down',
      'toggle-up',
      'caret-square-o-up',
      'toggle-right',
      'caret-square-o-right',
      'euro',
      'gbp',
      'dollar',
      'usd',
      'rupee',
      'inr',
      'cny',
      'rmb',
      'yen',
      'jpy',
      'ruble',
      'rouble',
      'rub',
      'won',
      'krw',
      'bitcoin',
      'file-text',
      'sort-alpha-asc',
      'sort-alpha-desc',
      'sort-amount-asc',
      'sort-amount-desc',
      'sort-numeric-asc',
      'sort-numeric-desc',
      'thumbs-up',
      'thumbs-down',
      'youtube-square',
      'youtube',
      'xing-square',
      'youtube-play',
      'dropbox',
      'stack-overflow',
      'instagram',
      'bitbucket',
      'bitbucket-square',
      'tumblr-square',
      'long-arrow-down',
      'long-arrow-up',
      'long-arrow-left',
      'long-arrow-right',
      'windows',
      'android',
      'dribbble',
      'foursquare',
      'male',
      'gittip',
      'gratipay',
      'archive',
      'pagelines',
      'stack-exchange',
      'arrow-circle-o-right',
      'arrow-circle-o-left',
      'toggle-left',
      'caret-square-o-left',
      'dot-circle-o',
      'wheelchair',
      'vimeo-square',
      'turkish-lira',
      'plus-square-o',
      'space-shuttle',
      'envelope-square',
      'wordpress',
      'openid',
      'institution',
      'bank',
      'university',
      'mortar-board',
      'graduation-cap',
      'reddit-square',
      'stumbleupon-circle',
      'stumbleupon',
      'delicious',
      'pied-piper-pp',
      'pied-piper-alt',
      'language',
      'building',
      'behance',
      'behance-square',
      'steam-square',
      'recycle',
      'automobile',
      'car',
      'cab',
      'spotify',
      'deviantart',
      'soundcloud',
      'database',
      'file-pdf-o',
      'file-word-o',
      'file-excel-o',
      'file-powerpoint-o',
      'file-photo-o',
      'file-picture-o',
      'file-image-o',
      'file-zip-o',
      'file-archive-o',
      'file-sound-o',
      'file-audio-o',
      'file-movie-o',
      'file-video-o',
      'file-code-o',
      'codepen',
      'jsfiddle',
      'life-bouy',
      'life-buoy',
      'life-saver',
      'support',
      'life-ring',
      'circle-o-notch',
      'ra',
      'resistance',
      'rebel',
      'ge',
      'git-square',
      'git',
      'y-combinator-square',
      'yc-square',
      'hacker-news',
      'tencent-weibo',
      'qq',
      'wechat',
      'weixin',
      'send',
      'paper-plane',
      'send-o',
      'paper-plane-o',
      'history',
      'circle-thin',
      'paragraph',
      'sliders',
      'share-alt',
      'share-alt-square',
      'bomb',
      'soccer-ball-o',
      'futbol-o',
      'binoculars',
      'slideshare',
      'newspaper-o',
      'calculator',
      'google-wallet',
      'cc-visa',
      'cc-mastercard',
      'cc-discover',
      'cc-amex',
      'cc-paypal',
      'cc-stripe',
      'bell-slash',
      'bell-slash-o',
      'copyright',
      'eyedropper',
      'paint-brush',
      'birthday-cake',
      'area-chart',
      'pie-chart',
      'line-chart',
      'lastfm-square',
      'toggle-off',
      'toggle-on',
      'bicycle',
      'ioxhost',
      'angellist',
      'cc',
      'shekel',
      'sheqel',
      'meanpath',
      'buysellads',
      'connectdevelop',
      'dashcube',
      'forumbee',
      'leanpub',
      'shirtsinbulk',
      'simplybuilt',
      'skyatlas',
      'cart-plus',
      'cart-arrow-down',
      'diamond',
      'user-secret',
      'motorcycle',
      'street-view',
      'heartbeat',
      'mercury',
      'intersex',
      'transgender',
      'transgender-alt',
      'venus-double',
      'mars-double',
      'venus-mars',
      'mars-stroke',
      'mars-stroke-v',
      'mars-stroke-h',
      'genderless',
      'facebook-official',
      'pinterest-p',
      'whatsapp',
      'user-plus',
      'user-times',
      'hotel',
      'viacoin',
      'medium',
      'yc',
      'y-combinator',
      'optin-monster',
      'opencart',
      'expeditedssl',
      'battery-4',
      'battery',
      'battery-full',
      'battery-3',
      'battery-three-quarters',
      'battery-2',
      'battery-half',
      'battery-1',
      'battery-quarter',
      'battery-0',
      'battery-empty',
      'mouse-pointer',
      'i-cursor',
      'object-group',
      'object-ungroup',
      'sticky-note',
      'sticky-note-o',
      'cc-diners-club',
      'balance-scale',
      'hourglass-o',
      'hourglass-1',
      'hourglass-start',
      'hourglass-2',
      'hourglass-half',
      'hourglass-3',
      'hourglass-end',
      'hourglass',
      'hand-grab-o',
      'hand-rock-o',
      'hand-stop-o',
      'hand-paper-o',
      'hand-scissors-o',
      'hand-lizard-o',
      'hand-spock-o',
      'hand-pointer-o',
      'hand-peace-o',
      'trademark',
      'registered',
      'creative-commons',
      'gg-circle',
      'tripadvisor',
      'odnoklassniki',
      'odnoklassniki-square',
      'get-pocket',
      'wikipedia-w',
      'firefox',
      'internet-explorer',
      'tv',
      'television',
      'calendar-plus-o',
      'calendar-minus-o',
      'calendar-times-o',
      'calendar-check-o',
      'industry',
      'map-pin',
      'map-signs',
      'commenting',
      'commenting-o',
      'black-tie',
      'fonticons',
      'reddit-alien',
      'credit-card-alt',
      'codiepie',
      'fort-awesome',
      'product-hunt',
      'mixcloud',
      'pause-circle',
      'pause-circle-o',
      'stop-circle',
      'stop-circle-o',
      'shopping-bag',
      'shopping-basket',
      'hashtag',
      'bluetooth',
      'bluetooth-b',
      'percent',
      'wpbeginner',
      'wpforms',
      'universal-access',
      'wheelchair-alt',
      'question-circle-o',
      'audio-description',
      'volume-control-phone',
      'braille',
      'assistive-listening-systems',
      'asl-interpreting',
      'american-sign-language-interpreting',
      'deafness',
      'hard-of-hearing',
      'glide-g',
      'signing',
      'sign-language',
      'low-vision',
      'viadeo-square',
      'snapchat',
      'snapchat-ghost',
      'snapchat-square',
      'pied-piper',
      'first-order',
      'themeisle',
      'google-plus-circle',
      'google-plus-official',
      'fa',
      'font-awesome',
      'handshake-o',
      'envelope-open',
      'envelope-open-o',
      'address-book',
      'address-book-o',
      'vcard',
      'address-card',
      'vcard-o',
      'address-card-o',
      'user-circle',
      'user-circle-o',
      'id-badge',
      'drivers-license',
      'id-card',
      'drivers-license-o',
      'id-card-o',
      'free-code-camp',
      'telegram',
      'thermometer-4',
      'thermometer',
      'thermometer-full',
      'thermometer-3',
      'thermometer-three-quarters',
      'thermometer-2',
      'thermometer-half',
      'thermometer-1',
      'thermometer-quarter',
      'thermometer-0',
      'thermometer-empty',
      'shower',
      'bathtub',
      's15',
      'podcast',
      'window-maximize',
      'window-minimize',
      'window-restore',
      'times-rectangle',
      'window-close',
      'times-rectangle-o',
      'window-close-o',
      'bandcamp',
      'ravelry',
      'eercast',
      'microchip',
      'snowflake-o',
      'superpowers',
      'wpexplorer',
      'meetup'
    ])
    .constant('DX_ICONS_LIST', [
      'plus',
      'overflow',
      'add',
      'airplane',
      'arrowleft',
      'arrowdown',
      'arrowright',
      'arrowup',
      'bookmark',
      'box',
      'car',
      'card',
      'cart',
      'chart',
      'clock',
      'close',
      'comment',
      'doc',
      'download',
      'edit',
      'email',
      'event',
      'eventall',
      'favorites',
      'find',
      'folder',
      'food',
      'gift',
      'globe',
      'group',
      'help',
      'home',
      'image',
      'info',
      'key',
      'like',
      'map',
      'menu',
      'money',
      'music',
      'percent',
      'photo',
      'preferences',
      'product',
      'refresh',
      'remove',
      'runner',
      'tags',
      'tel',
      'tips',
      'todo',
      'toolbox',
      'user',
      'save',
      'clear',
      'search',
      'bold',
      'italic',
      'underline',
      'strike',
      'indent',
      'fontsize',
      'growfont',
      'shrinkfont',
      'color',
      'background',
      'superscript',
      'subscript',
      'header',
      'blockquote',
      'formula',
      'codeblock',
      'orderedlist',
      'bulletlist',
      'increaseindent',
      'decreaseindent',
      'alignleft',
      'alignright',
      'aligncenter',
      'alignjustify',
      'link',
      'video',
      'mention',
      'variable',
      'clearformat',
      'undo',
      'redo',
      'checklist',
      'verticalaligntop',
      'verticalaligncenter',
      'verticalalignbottom',
      'rowproperties',
      'columnproperties',
      'cellproperties',
      'tableproperties',
      'splitcells',
      'mergecells',
      'removerow',
      'removecolumn',
      'addrowabove',
      'addrowbelow',
      'addcolumnleft',
      'addcolumnright',
      'addtable',
      'removetable',
      'bell'
    ])
})()
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .component('selectIconModal', {
      templateUrl: 'app/adp-forms/directives/adp-form-controls/icon-control/select-icon-modal/select-icon-modal.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller(
        FONT_AWESOME_ICONS_LIST,
        DX_ICONS_LIST,
        AdpIconControlService
      ) {
        const vm = this;

        vm.$onInit = function () {
          vm.selected = null;
          vm.hasError = false;

          const iconList = [
            {
              title: 'Font Awesome',
              family: 'fa',
              items: FONT_AWESOME_ICONS_LIST,
            },
            {
              title: 'DevExtreme',
              family: 'dx',
              items: DX_ICONS_LIST,
            }
          ];

          vm.query = _.reduce(iconList, (res, { family }) => {
            res[family] = '';
            return res;
          }, {});

          vm.tabPanelOptions = {
            height: 420,
            dataSource: iconList,
            scrollByContent: false,
          };

          vm.filterInputConfig = {
            valueChangeEvent: 'input blur',
            placeholder: 'Filter icon by name',
            showClearButton: true,
            buttons: ['clear'],
          }
        };

        vm.confirm = function () {
          if (!vm.selected) {
            vm.hasError = true;
            return;
          }
          return vm.close({ $value: vm.selected });
        };

        vm.cancel = function () {
          return vm.dismiss({ $value: 'cancel' });
        }

        vm.toStartCase = _.startCase;

        vm.select = (name, family) => {
          vm.selected = { name, family };
        }

        vm.template = () => {
          if (!vm.selected) {
            return 'none';
          }

          const tpl = AdpIconControlService.template(vm.selected);
          return `${tpl} ${_.escape(tpl)}`;
        }

      },
      controllerAs: 'vm',
    });
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('lookupSelectorMultiple', lookupSelectorMultiple);

  function lookupSelectorMultiple(
    LookupDxConfig,
    LookupDataSource,
    LookupBtns,
    AdpFieldsService,
    ListControlSortable
  ) {
    const template = `
      <div class="adp-list-control-sortable-wrapper">
        <div ng-if="::config" dx-tag-box="::config"></div>
      </div>`;

    return {
      restrict: 'AE',
      scope: {
        props: '=',
      },
      replace: true,
      template,
      link: function (scope, element) {
        (function init() {
          scope.instance = null;
          const onInit = function (e) {
            scope.instance = e.component;
          };
          scope.config = AdpFieldsService.configFromParameters(
            scope.props.args.fieldSchema,
            LookupDxConfig.multiple(scope.props, onInit),
          );

          AdpFieldsService.addOpenStatusBroadcast(scope, scope.config);

          addTableWatcher(scope.props);
          setupSortable();

          scope.$on('afterCopyPasteAction', () => {
            const { args } = scope.props;
            const val = _.get(args.row, args.path);

            scope.instance.option('value', val);
            scope.instance.repaint();
          });
        })();

        function addTableWatcher(props) {
          scope.$watch('props.selectedTableName', function (tableName) {
            if (scope.instance && tableName) {
              scope.instance.option('dataSource', LookupDataSource(props.args, props.selectedTableName));
              scope.instance.option('buttons', LookupBtns.getFieldButtons(props));
            }
          });
        }

        function setupSortable() {
          ListControlSortable.setupTagsReordering({
            element,
            onDrop(e) {
              const items = scope.instance.option('value');
              ListControlSortable.swapItems(e, items);
              scope.instance.option('value', items);

              setTimeout(() => {
                scope.instance.repaint();
              });
            },
            args: scope.props.args,
          });
        }

      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('lookupSelectorSingle', lookupSelectorSingle);

  function lookupSelectorSingle(
    LookupDataSource,
    LookupBtns,
    LookupDxConfig,
    AdpFieldsService
  ) {
    return {
      restrict: 'AE',
      scope: {
        props: '=',
      },
      replace: true,
      template: '<div dx-select-box="config"></div>',
      link: function (scope, element) {
        (function init() {
          scope.config = AdpFieldsService.configFromParameters(
            scope.props.args.fieldSchema,
            LookupDxConfig.single(scope.props)
          );
          AdpFieldsService.addOpenStatusBroadcast(scope, scope.config);

          addTableWatcher(scope.props);

          scope.$on('afterCopyPasteAction', () => {
            const { args } = scope.props;
            const val = _.get(args.row, args.path);
            const instance = element.dxSelectBox('instance');

            instance.option('value', val);
            instance.repaint();
          });
        })();

        function addTableWatcher(props) {
          scope.$watch('props.selectedTableName', function (tableName) {
            var instance = element.dxSelectBox('instance');
            if (instance && tableName) {
              instance.option('dataSource', LookupDataSource(props.args, tableName));
              instance.option('buttons', LookupBtns.getFieldButtons(props));
            }
          });
        }
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('lookupTableSelector', lookupTableSelector);

  function lookupTableSelector(AdpFieldsService, LookupDxConfig) {
    return {
      restrict: 'E',
      scope: {
        props: '=',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/lookup-control/lookup-table-selector/lookup-table-selector.html',
      replace: true,
      link: function (scope, element) {
       var removeWatcher = scope.$watch('props', function (props) {
          if (_.isNil(props)) {
            return;
          }
          scope.config = LookupDxConfig.tableSelector(scope.props);
          AdpFieldsService.addOpenStatusBroadcast(scope, scope.config);
          removeWatcher();
        });
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('treeSelector', treeSelector);

  function treeSelector(
    GraphqlTreeSelectorQuery,
    AdpUnifiedArgs,
    AdpValidationUtils,
    AdpFieldsService,
    APP_CONFIG,
    $compile,
    $timeout
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '=',
        formData: '=',
        indexOfLevel: '='
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/tree-selector-control/selector/tree-selector.html',
      require: '^^form',
      link: function (scope, element) {
        var childScope;
        (function init() {
          scope.rootData = _.get(scope.args.row, scope.args.path);
          scope.rootData[scope.indexOfLevel] = scope.rootData[scope.indexOfLevel] || {};
          setConfig();
        })();

        function setConfig() {
          var initialData = _.clone(scope.rootData[scope.indexOfLevel]) || {};

          var defaults = {
            elementAttr: { 'class': 'adp-select-box' },
            showClearButton: true,
            searchEnabled: true,
            dataSource:  new DevExpress.data.DataSource({
              paginate: true,
              requireTotalCount: true,
              pageSize: 15,
              load: function (loadOptions) {
                var params = _.cloneDeep(loadOptions);
                if (scope.indexOfLevel > 0) {
                  params.foreignKeyVal = scope.rootData[scope.indexOfLevel - 1]._id;
                }

                return GraphqlTreeSelectorQuery(scope.args, params)
                  .then(function (res) {
                    return {
                      data: _.get(res, 'items', []),
                      totalCount: _.get(res, 'count', 0),
                    }
                  });
              },
              key: '_id',
              byKey: function () { return Promise.resolve(initialData); },
            }),
            valueExpr: 'this',
            displayExpr: 'label',
            onInitialized: function (e) {
              // place to trigger change event, if initiated with
              if (!_.isEmpty(initialData)) {
                $timeout(function () {
                  e.component.option('value', initialData);
                });
              }
            },
            onValueChanged: onChange,
            multiline: true,
            wrapItemText: true,
            inputAttr: {
              'adp-qaid-field-control': scope.args.path + '_' + scope.indexOfLevel
            },
            itemTemplate: function (data, index, element) {
              element.attr('adp-qaid-tree-selector-item', scope.args.path + '_' + scope.indexOfLevel);
              return data.label;
            },
          };

          AdpFieldsService.addOpenStatusBroadcast(scope, defaults);
          scope.config = AdpFieldsService.configFromParameters(scope.args.fieldSchema, defaults);
        }

        function onChange(e) {
          var isRemoved = _.isNull(e.value) && e.event;

          if (isRemoved) {
            removeData();
          } else if (e.value) {
            setData(e.value);
            renderNext(e.value);
          }
        }

        function setData(value) {
          _.assign(scope.rootData[scope.indexOfLevel], value);
        }

        function removeData() {
          destroyChildScope();

          scope.rootData[scope.indexOfLevel] = {};
        }

        function renderNext(value) {
          if (_.isEmpty(value)) return;
          if (value.isLeaf) return;

          destroyChildScope();

          childScope = scope.$new(true);
          childScope.args = scope.args;
          childScope.formData = scope.formData;
          childScope.indexOfLevel = scope.indexOfLevel + 1;

          var template = [
            '<tree-selector',
            "args=args",
            "form-data=formData",
            "index-of-level=indexOfLevel",
            'data-child',
            '></tree-selector>',
          ].join('\n');

          element.find('> div').append($compile(template)(childScope));
        }

        function destroyChildScope() {
          if (_.isNil(childScope)) {
            return;
          }
          scope.rootData.length = scope.indexOfLevel + 1;

          var childNode = element.find('[data-child]');
          childScope.$destroy();
          childNode.remove();
        }
      }
    }
  }
})();
;;(function () {
  angular
    .module('app.adpForms')
    .constant('COLOR_FIELD_NAME_IN_META', '_arrayColors');
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('arrayControl', arrayControl);

  function arrayControl(
    AdpSchemaService,
    ComplexObjectUtil
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/array/array-control/array-control.html',
      require: '^^form',
      controller: 'ArrayCommonController',
      link($scope, element, attrs, formCtrl) {
        $scope.form = formCtrl;
        $scope.rootForm = $scope.formContext.rootForm;
        $scope.frameClass = ComplexObjectUtil.getFrameClass($scope.args);
        $scope.frameContentClass = ComplexObjectUtil.getFrameContentClass($scope.args);
        $scope.addNewBtnName = AdpSchemaService.getSingularForm($scope.args.fieldSchema.fullName);
        $scope.isAssociative = $scope.args.fieldSchema.type === 'AssociativeArray';

        $scope.sortableCfg = {
          axis: 'y',
          'ui-floating': false,
          handle: '> .subform-frame > .subform-frame__title',
          start: function (event, ui) {
            $(this).attr('data-previndex', ui.item.index());

            ui.item.addClass('draggable-mirror');
            ui.placeholder.css({ display: 'block' });
          },
          stop: function (event, ui) {
            var newIndex = ui.item.index();
            var oldIndex = $(this).attr('data-previndex');

            var list = $scope.visibilityStatus;
            var b = list[newIndex];
            list[newIndex] = list[oldIndex];
            list[oldIndex] = b;

            $(this).removeAttr('data-previndex');

            ui.item.removeClass('draggable-mirror');
            ui.placeholder.remove();
          },
        };

        $scope.init();
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ArrayControlTreeItem', ArrayControlTreeItem);

  /** @ngInject **/
  function ArrayControlTreeItem() {
    return function (rawArrayItem, { displayExpr, parentIdExpr, keyExpr }) {
      const valueByExpressions = _.pick(rawArrayItem, [keyExpr, parentIdExpr, displayExpr]);

      return {
        $_expressions: { displayExpr, parentIdExpr, keyExpr },
        expanded: true,
        $_row: rawArrayItem,
        ...valueByExpressions,

        $_id(val) {
          const { keyExpr } = this.$_expressions;

          if (arguments.length) {
            this[keyExpr] = val;
            this.$_row[keyExpr] = val;
          }

          return this[keyExpr];
        },

        $_parentId(val) {
          const { parentIdExpr } = this.$_expressions;

          if (arguments.length) {
            this[parentIdExpr] = val;
            this.$_row[parentIdExpr] = val;
          }

          return this[parentIdExpr];
        },

        $_displayValue(val) {
          const { displayExpr } = this.$_expressions;

          if (arguments.length) {
            this[displayExpr] = val;
            this.$_row[displayExpr] = val;
          }

          return this[displayExpr];
        },
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ArrayControlTreeSortable', ArrayControlTreeSortable);

  /** @ngInject **/
  function ArrayControlTreeSortable(ArrayControlTreeHelpers) {
    return function enableSortable({ element, treeComponent, frameType, onDragEndCb }) {
      const sortComponentOptions = {
        filter: '.dx-treeview-item',
        allowDropInsideItem: frameType !== 'array',
        allowReordering: true,
        autoScroll: true,
        onDragChange,
        onDragEnd,
      };

      const TREE_CONTAINER_SELECTOR = '.treeBox';
      $(TREE_CONTAINER_SELECTOR, element).dxSortable(sortComponentOptions);

      function onDragEnd(e) {
        const cancerDropIfTreeRoot = frameType === 'tree' && e.toIndex === 0 && !e.dropInsideItem;
        if (cancerDropIfTreeRoot) {
          return;
        }

        if (e.fromIndex === e.toIndex) {
          return;
        }

        const fromNode = findNode(treeComponent, e.fromIndex);
        const toNode = findNode(treeComponent, calculateToIndex(e));

        const treeItems = treeComponent.option('items');
        moveNode(fromNode, toNode, treeItems, e.dropInsideItem);

        // ToDo: not sure if we need this (copied from dx component example)
        //treeComponent.scrollToItem(topVisibleNode); // ????

        treeComponent.option('items', treeItems);
        onDragEndCb(treeItems);
      }

      function moveNode(fromNode, toNode, treeItems, isDropInsideItem) {
        const fromIndex = findIndex(treeItems, fromNode);
        treeItems.splice(fromIndex, 1);

        const toIndex = toNode === null || isDropInsideItem ?
          treeItems.length : findIndex(treeItems, toNode);

        treeItems.splice(toIndex, 0, fromNode.itemData);

        let newParentId;
        if (isDropInsideItem) {
          newParentId = toNode.itemData.$_id();
        } else {
          newParentId = toNode != null ? toNode.itemData.$_parentId() : undefined;
        }

        fromNode.itemData.$_parentId(newParentId);
      }
    }

    function onDragChange(e) {
      if (e.fromComponent === e.toComponent) {
        const $nodes = e.element.find('.dx-treeview-node');
        const isDragIntoChild = $nodes.eq(e.fromIndex)
          .find($nodes.eq(e.toIndex)).length > 0;

        if (isDragIntoChild) {
          e.cancel = true;
        }
      }
    }

    function findNode(treeView, index) {
      const nodeElement = treeView.element()
        .find('.dx-treeview-node')[index];
      if (nodeElement) {
        return ArrayControlTreeHelpers.findNodeById(treeView.getNodes(), nodeElement.getAttribute('data-item-id'));
      }
      return null;
    }

    function calculateToIndex(e) {
      if (e.fromComponent !== e.toComponent || e.dropInsideItem) {
        return e.toIndex;
      }

      return e.fromIndex >= e.toIndex
        ? e.toIndex
        : e.toIndex + 1;
    }

    function findIndex(array, node) {
      const id = node.itemData.$_id();
      return _.findIndex(array, item => item.$_id() === id);
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('arrayControlTree', arrayControlTree);

  function arrayControlTree(
    AdpFieldsService,
    AdpFormService,
    ObjectId,
    ControlSetterGetter,
    AdpModalService,
    ArrayControlTreeSortable,
    ArrayControlTreeItem,
    ArrayControlTreeHelpers,
    AdpSchemaService
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<'
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/array/array-control-tree/array-control-tree.html',
      require: '^^form',
      link: function (scope, element, attr, formControl) {
        scope.form = formControl;
        const getterSetter = ControlSetterGetter(scope.args);
        let treeComponent;

        (function init() {
          hideKeyAndParentFields();
          setupFormStyles();
          scope.addNewBtnName = AdpSchemaService.getSingularForm(scope.args.fieldSchema.fullName);
          scope.arrayFields = AdpFieldsService.getComplexObjectsFields(scope.args.fieldSchema.fields);
          scope.frameType = _.get(scope.args, 'fieldSchema.parameters.frameType');
          scope.initialized = false;
          scope.selectedIndex = 0;
          scope.addArrayItem = addArrayItem;

          if (isEmpty()) {
            setData([createModelItem()]);
          }

          setIdsToData();
          resetOrphanBranches();

          initTreeView();

          scope.$on('afterCopyPasteAction', () => {
            const currentArrayData = getData();
            setData(currentArrayData);
          });

          scope.$watch(
            () => {
              const { displayExpr } = getExpressions();
              return _.get(getData(), [scope.selectedIndex, displayExpr]);
            },
            function (newVal, oldVal) {
              if (oldVal === newVal) {
                return;
              }

              updateTitleFromForm(scope.selectedIndex);
              const { keyExpr } = getExpressions();
              const id = _.get(getData(), [scope.selectedIndex, keyExpr]);

              const textNode = element.find(`.dx-treeview-node[data-item-id="${id}"] > .dx-item .adp-array-tree-item-text`);
              textNode.text(newVal ||  '-- no title --');
            }
          );

          scope.$on('formChanged', function () {
            if (!scope.formContext.rootForm.$submitted) {
              return;
            }
            const { keyExpr } = getExpressions();
            const selectorsOfItemsWithErrors = _.reduce(getData(), (acc, value, index) => {
              const formName = `${scope.args.fieldSchema.fieldName}[${index}]`;
              const invalid = _.get(scope.form, [formName, '$invalid']);

              if (invalid) {
                const itemSelect = `.dx-treeview-node[data-item-id="${value[keyExpr]}"] > .dx-item`;
                acc.push(itemSelect);
              }

              return acc;
            }, []);

            const allTreeNodes = element.not('.dx-treeview-node[data-item-id] > .dx-item')
            allTreeNodes.removeClass('has-errors');

            const treeNodes = element.find(selectorsOfItemsWithErrors.join(', '));
            treeNodes.addClass('has-errors');
          });
        })();

        function hideKeyAndParentFields() {
          const { parentIdExpr, keyExpr } = getExpressions();
          const arrayFields = scope.args.fieldSchema.fields;
          arrayFields[parentIdExpr] && (arrayFields[parentIdExpr].showInForm = false);
          arrayFields[keyExpr] && (arrayFields[keyExpr].showInForm = false);
        }

       function setupFormStyles() {
         scope.treeViewStyle = {};
         scope.treeViewStyle.minHeight = _.get(scope.args, 'fieldSchema.parameters.minHeight');
         scope.treeViewStyle.maxHeight = _.get(scope.args, 'fieldSchema.parameters.maxHeight');
       }

        function initTreeView() {
          const { parentIdExpr, keyExpr } = getExpressions();

          const treeComponentOptions = {
            items: getTreeItems(),
            itemTemplate,
            onItemClick: onTreeItemClick,
            onInitialized(e) {
              treeComponent = e.component;
              scope.initialized = true;

              ArrayControlTreeSortable({
                element,
                treeComponent,
                frameType: scope.frameType,
                onDragEndCb: updateArrayDataFromTree,
              });
            },
            expandNodesRecursive: false,
            dataStructure: 'plain',
            height: '100%',
            selectionMode: 'single',
            animationEnabled: false,
            parentIdExpr,
            keyExpr,
          };

          const TREE_CONTAINER_SELECTOR = '.treeBox';
          $(TREE_CONTAINER_SELECTOR, element).dxTreeView(treeComponentOptions);
        }

        function itemTemplate(item) {
          const removeBtn = $('<div class="adp-array-tree-item-delete"><i class="fa fa-trash"></i></div>')
            .click(() => removeTreeNode(item));

          const title = item.$_displayValue() || '-- no title --';

          return $('<div class="adp-array-tree-item">')
            .append(`<div class="adp-array-tree-item-text">${title}</div>`)
            .append(removeBtn);
        }

        function getData() {
          // keeping reference, required for ng-repeat to
          scope.arrayData = getterSetter();
          return scope.arrayData;
        }

        function setData(value) {
          scope.arrayData = value;
          getterSetter(value);
        }

        function isEmpty() {
          var data = getData();
          return _.isNil(data) || _.isEmpty(data);
        }

        function getTreeItems() {
          const data = getData();
          return _.map(data, createTreeItem);
        }

        function createTreeItem(item) {
          return ArrayControlTreeItem(item, getExpressions());
        }

        function getExpressions() {
          const fieldSchemaParams = _.get(scope, 'args.fieldSchema.parameters') || {};
          const {
            displayExpr = 'text',
            parentIdExpr = 'parentId',
            keyExpr = '_id',
          } = fieldSchemaParams;

          return { displayExpr, parentIdExpr, keyExpr };
        }

        function onTreeItemClick({ itemData }) {
          const { keyExpr } = getExpressions();
          const currentId = _.get(getData(), [scope.selectedIndex, keyExpr]);

          if (currentId === itemData.$_id()) {
            return;
          }

          updateTitleFromForm(scope.selectedIndex);
          setSelectedItem(itemData);
        }

        function updateTitleFromForm(index) {
          if (_.isNil(index)) {
            return;
          }

          const { displayExpr } = getExpressions();
          const treeItems = treeComponent.option('items');
          const currentTitle = _.get(treeItems, [index, '$_row', displayExpr]);
          treeComponent.option(`items[${index}][${displayExpr}]`, currentTitle);
        }

        function setSelectedItem(rowData) {
          scope.selectedIndex = _.findIndex(getData(), rowData.$_row);
        }

        function resetSelectedItem() {
          scope.selectedIndex = -1;
        }

        function updateArrayDataFromTree(itemsFromTree) {
          const newModelData = _.map(itemsFromTree, item => item.$_row);
          setData(newModelData);
        }

        function addArrayItem() {
          const selectedIndex = scope.selectedIndex;
          const { keyExpr } = getExpressions();
          const treeItems = treeComponent.option('items');

          const currentNodeId = _.get(treeItems, `${selectedIndex}.${keyExpr}`);
          const data = createModelItem(currentNodeId);
          const newTreeItem = createTreeItem(data);
          const hasNoSelection = _.isNil(selectedIndex) || selectedIndex === -1;

          if (scope.frameType === 'array') {
            newTreeItem.$_parentId(null);
            treeItems.push(newTreeItem);
          } else if (scope.frameType === 'forest') {
            treeItems.push(newTreeItem);
          } else if (scope.frameType === 'tree') {
            const root = treeItems[0];
            if (hasNoSelection && root) {
              newTreeItem.$_parentId(root.$_id());
              treeItems.splice(1, 0, newTreeItem);
            } else {
              treeItems.push(newTreeItem);
            }
          }

          treeComponent.option('items', treeItems);
          updateArrayDataFromTree(treeItems);
          setSelectedItem(newTreeItem);
        }

        function createModelItem(parentId) {
          const _id = ObjectId();
          const { keyExpr, parentIdExpr } = getExpressions();

          return {
            ...AdpFormService.getDefaultsForFields(scope.args),
            _id,
            [keyExpr]: _id,
            [parentIdExpr]: parentId,
          };
        }

        function removeTreeNode(item) {
          const nodesCnt = ArrayControlTreeHelpers.countNodes(item.$_id(), treeComponent);
          const childrenCnt = nodesCnt - 1;
          let message;
          if (childrenCnt > 0) {
            message = `Are you sure you want to remove '${item.$_displayValue()}' element and ${childrenCnt} children?`;
          } else {
            message = `Are you sure you want to remove '${item.$_displayValue()}'?`;
          }

          AdpModalService.confirm({ message })
            .then(() => {
              resetSelectedItem();
              ArrayControlTreeHelpers.removeBranchById(item.$_id(), treeComponent, updateArrayDataFromTree);
              treeComponent.repaint();
            })
            .catch((error) => {
              console.error('Error while removing array item in tree', scope.args, error);
            });
        }

        function setIdsToData() {
          const arrayValue = getData() || [];
          const data = _.map(arrayValue || [], item => ({ _id: ObjectId(), ...item }));
          setData(data);
        }

        function resetOrphanBranches() {
          const { keyExpr, parentIdExpr } = getExpressions();
          const data = getData() || [];
          const existingIds = _.map(data, item => item[keyExpr]);

          _.each(data || [], item => {
            const parent = item[parentIdExpr];
            if (!_.includes(existingIds, parent)) {
              item[parentIdExpr] = null;
            }
          });

          setData(data);
        }
      },
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('ArrayControlTreeHelpers', ArrayControlTreeHelpers);

  /** @ngInject **/
  function ArrayControlTreeHelpers() {
    function findNodeById(nodes, id) {
      for (let i = 0; i < nodes.length; i += 1) {
        if (nodes[i].itemData.$_id() === id) {
          return nodes[i];
        }
        if (nodes[i].children) {
          const node = findNodeById(nodes[i].children, id);
          if (node != null) {
            return node;
          }
        }
      }
      return null;
    }

    function countNodes(id, treeComponent) {
      const nodes = treeComponent.getNodes()
      const foundNode = findNodeById(nodes, id);
      if (!foundNode) {
        return [];
      }

      const ids = findChildrenIds(foundNode)

      return ids.length;
    }

    function findChildrenIds(parentNode = []) {
      const result = [parentNode.itemData.$_id()];
      const helper = (nodes = []) => {
        _.forEach(nodes, ({ itemData, children }) => {
          if (children.length) {
            helper(children, result)
          }

          result.push(itemData.$_id());
        });
      };

      helper(parentNode.children);

      return result;
    }

    function removeBranchById(id, treeComponent, updateModel) {
      const nodes = treeComponent.getNodes();
      const foundNode = findNodeById(nodes, id);
      if (!foundNode) {
        return null;
      }

      const idsToDelete = findChildrenIds(foundNode, treeComponent);
      const treeItems = treeComponent.option('items');

      _.forEach(idsToDelete, (id) => {
        const index = _.findIndex(treeItems, i => i.$_id() === id);
        treeItems.splice(index, 1);
      });

      treeComponent.option('items', treeItems);
      updateModel(treeItems);
    }

    return {
      findNodeById,
      countNodes,
      removeBranchById,
    };
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('arrayControlGrid', arrayControlGrid);

  function arrayControlGrid(
    AdpValidationUtils,
    AdpFieldsService
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/array/array-control-grid/array-control-grid.html',
      require: '^^form',
      controller: 'ArrayCommonController',
      link(scope, element, attrs, formCtrl) {
        scope.arrayFields = AdpFieldsService.getComplexObjectsFields(scope.args.fieldSchema.fields);
        scope.isAssociative = scope.args.fieldSchema.type === 'AssociativeArray';

        scope.form = formCtrl;
        scope.rootForm = scope.formContext.rootForm;

        scope.sortableCfg = {
          axis: 'y',
          'ui-floating': false,
          handle: '> .js-grid-handler',
          start(event, ui) {
            ui.item.addClass('draggable-mirror');
            ui.item.css({ width: ui.placeholder.width() });
            ui.placeholder.css('height', ui.item.height());
          },
          stop(event, ui) {
            ui.item.removeAttr('style');
            ui.item.removeClass('draggable-mirror');
            ui.placeholder.remove();
          },
        };

        scope.init();
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('complexItemHeader', complexItemHeader);

  function complexItemHeader(
    AdpFieldsService,
    $compile
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '=',
        index: '=',
        formContext: '=',
      },
      replace: true,
      link(scope, element) {
        const arrayArgs = scope.args;
        let childScope;
        let directiveElement = element;

        let arrayItemArgs = _.assign({}, arrayArgs, {
          index: scope.index,
          path: getPath(),
        });

        (function init() {
          setChildScope();
          const cmpHeaderName = _.get(arrayArgs, 'fieldSchema.headerRender.component');
          if (cmpHeaderName) {
            renderComponent(cmpHeaderName)
          } else {
            renderStatic();
            scope.$on('formChanged', _.throttle(renderStatic, 200));
          }

          scope.$on('pathChanged', () => {
            _.assign(arrayItemArgs, { index: scope.index, path: getPath() });
          });
          scope.$watch('index', () => {
            _.assign(arrayItemArgs, { index: scope.index, path: getPath() });
          });
        })();

        function getPath() {
          const { type } = scope.args.fieldSchema;
          const indexPart = type === 'Object' ? '' : '[' + scope.index + ']';
          return scope.args.path + indexPart;
        }

        function renderComponent(cmpHeaderName) {
          const cmp = `
            <${cmpHeaderName}
              args="::args"
              form-context="::formContext"
              ng-attr-adp-qaid-complex-field-header-text="${getPath()}"
              class="subform-frame__header-text"
            ></${cmpHeaderName}>
          `;

          compile(cmp);
        }

        function renderStatic() {
          const root = $('<div>', {
            'ng-attr-adp-qaid-complex-field-header-text': getPath(),
            'class': 'subform-frame__header-text',
          });

          root.append(getStaticHeader());
          compile(root);
        }

        function getStaticHeader() {
          const { headerRender, fullName, type } = scope.args.fieldSchema;

          if (type === 'Object' && headerRender) {
            return `<div>${fullName}<adp-tooltip></adp-tooltip></div>`;
          }

          if (type === 'Group') {
            return `<div>${fullName}<adp-tooltip></adp-tooltip></div>`;
          }

          return AdpFieldsService.getHeaderRenderer(arrayItemArgs);
        }

        function compile(el) {
          const newDirectiveElement = $compile(el)(childScope);
          directiveElement.replaceWith(newDirectiveElement);
          directiveElement = newDirectiveElement;
        }

        function setChildScope() {
          childScope = scope.$new(true);
          childScope.args = arrayItemArgs;
          childScope.formContext = scope.formContext;
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('errorCounter', errorCounter);

  function errorCounter(AdpFormService) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
        index: '<?',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/components/error-counter/error-counter.html',
      require: '^^form',
      replace: true,
      link: function (scope) {
        const getCnt = () => {
          scope.errorCnt = AdpFormService.getErrorCounter(
            scope.formContext.errorCount,
            scope.args,
            scope.index
          );
            scope.submitted = scope.formContext.rootForm.$submitted;
        }

        getCnt();
        scope.$on('formChanged', getCnt);
      }
    }
  }
})();
;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('keyValControl', keyValControl);

  function keyValControl(
    ControlSetterGetter,
    ComplexObjectUtil,
    AdpSchemaService,
    ObjectId
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/key-val/key-val-control/key-val-control.html',
      require: '^^form',
      controller: 'ArrayCommonController',
      link(scope, el, attrs, formCtrl) {
        scope.args.fieldSchema.fields = {
          _key: scope.args.fieldSchema._key,
          _value: scope.args.fieldSchema._value,
        };

        ComplexObjectUtil.addKeyValidators(scope.args);
        scope.form = formCtrl;
        scope.rootForm = scope.formContext.rootForm;
        scope.frameClass = ComplexObjectUtil.getFrameClass(scope.args);
        scope.frameContentClass = ComplexObjectUtil.getFrameContentClass(scope.args);
        scope.addNewBtnName = AdpSchemaService.getSingularForm(scope.args.fieldSchema.fullName);
        scope.toArray = toArray;

        scope.sortableCfg = {
          axis: 'y',
          'ui-floating': false,
          handle: '> .subform-frame > .subform-frame__title',
          start: function (event, ui) {
            $(this).attr('data-previndex', ui.item.index());

            ui.item.addClass('draggable-mirror');
            ui.placeholder.css({ display: 'block' });
          },
          stop: function (event, ui) {
            var newIndex = ui.item.index();
            var oldIndex = $(this).attr('data-previndex');

            var list = scope.visibilityStatus;
            var b = list[newIndex];
            list[newIndex] = list[oldIndex];
            list[oldIndex] = b;

            $(this).removeAttr('data-previndex');

            ui.item.removeClass('draggable-mirror');
            ui.placeholder.remove();
          },
        };

        scope.toArray();
        scope.init();

        function toArray() {
          const data = _.map(scope.getData(), (value, key) => {
            const { _key, _id } = value || {};
            if (_key && _id) {
              return value;
            }

            return {
              _key: key,
              _value: value,
              _id: ObjectId(),
            }
          });

          scope.setData(data);
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('keyValControlGrid', keyValControlGrid);

  function keyValControlGrid(
    AdpValidationUtils,
    AdpFieldsService,
    AdpFormService,
    visibilityUtils,
    ControlSetterGetter,
    ComplexObjectUtil,
    AdpRecordMeta,
    ObjectId
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/key-val/key-val-grid/key-val-grid.html',
      require: '^^form',
      controller: 'ArrayCommonController',
      link(scope, element, attrs, formCtrl) {
        scope.args.fieldSchema.fields = {
          _key: scope.args.fieldSchema._key,
          _value: scope.args.fieldSchema._value,
        };
        ComplexObjectUtil.addKeyValidators(scope.args);

        scope.form = formCtrl;
        scope.rootForm = scope.formContext.rootForm;

        scope.sortableCfg = {
          axis: 'y',
          'ui-floating': false,
          handle: '> .js-grid-handler',
          start(event, ui) {
            ui.item.addClass('draggable-mirror');
            ui.item.css({ width: ui.placeholder.width() });
            ui.placeholder.css('height', ui.item.height());
          },
          stop(event, ui) {
            ui.item.removeAttr('style');
            ui.item.removeClass('draggable-mirror');
            ui.placeholder.remove();
          },
        };

        scope.addArrayItem = addArrayItem;
        scope.toArray = toArray;
        scope.init();

        function addArrayItem() {
          const fieldData = scope.getData();
          const data = AdpFormService.getDefaultsForFields(scope.args);
          fieldData.push({ _id: ObjectId(), ...data });
        }

        function toArray() {
          const data = _.map(scope.getData(), (value = {}, key) => {
            const { _key, _id } = value;
            if (_key && _id) {
              return value;
            }

            return {
              _key: key,
              _value: value,
              _id: ObjectId(),
            }
          });

          scope.setData(data);
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('objectControl', objectControl);

  function objectControl(
    AdpValidationUtils,
    AdpFieldsService,
    ControlSetterGetter,
    ComplexObjectUtil
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/object/object-control/object-control.html',
      require: '^^form',
      link: function (scope, element, attrs, formCtrl) {
        var getterSetterFn = ControlSetterGetter(scope.args);
        scope.fields = AdpFieldsService.getComplexObjectsFields(scope.args.fieldSchema.fields);
        scope.form = formCtrl;
        scope.rootForm = scope.formContext.rootForm;
        scope.fieldName = _.get(scope, 'args.fieldSchema.fieldName');
        scope.isVisible = ComplexObjectUtil.isExpanded(scope.args);
        scope.frameClass = ComplexObjectUtil.getFrameClass(scope.args);
        scope.frameContentClass = ComplexObjectUtil.getFrameContentClass(scope.args);

        scope.objData = getterSetterFn();
        const isEmpty = _.isNil(scope.objData) || _.isEmpty(scope.objData);
        if (isEmpty) {
          getterSetterFn({});
        }

        scope.toggle = function () {
          scope.isVisible = !scope.isVisible;
        };
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .directive('objectControlGrid', objectControlGrid);

  function objectControlGrid(
    AdpValidationUtils,
    AdpFieldsService,
    ControlSetterGetter,
    ComplexObjectUtil
  ) {
    return {
      restrict: 'E',
      scope: {
        args: '<',
        formContext: '<',
      },
      templateUrl: 'app/adp-forms/directives/adp-form-controls/complex/object/object-control-grid/object-control-grid.html',
      require: '^^form',
      link(scope, element, attrs, formCtrl) {
        const getterSetterFn = ControlSetterGetter(scope.args);
        scope.fields = AdpFieldsService.getComplexObjectsFields(scope.args.fieldSchema.fields);
        scope.form = formCtrl;
        scope.rootForm = scope.formContext.rootForm;
        scope.fieldName = _.get(scope, 'args.fieldSchema.fieldName');
        scope.isVisible = ComplexObjectUtil.isExpanded(scope.args);
        scope.frameClass = ComplexObjectUtil.getFrameClass(scope.args);

        scope.objData = getterSetterFn();
        const isEmpty = _.isNil(scope.objData) || _.isEmpty(scope.objData);

        if (isEmpty) {
          getterSetterFn({});
        }
      }
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxCurrencyConfig', DxCurrencyConfig);

  /** @ngInject */
  function DxCurrencyConfig(DX_ACCOUNTING_FORMAT, DxNumberHelper) {
    return function (args) {
      return {
        options: getOptions(args),
        widgetName: 'dxNumberBox',
      };
    }

    function getOptions(args) {
      var field = args.fieldSchema;
      var preventWheelCb = DxNumberHelper.preventMouseWheel();

      return {
        valueChangeEvent: 'blur keyup change',
        onValueChanged: function (e) {
          var shouldPrevent = preventWheelCb(e) !== undefined;
          if (shouldPrevent) {
            return false;
          }

          if (e.value === 0 && _.isNumber(e.previousValue)) {
            // update fired on next change event
            e.component.option('value', null);
          }
        },
        inputAttr: {
          'field-name-input': field.fieldName,
          id: field.fieldName,
        },
        showSpinButtons: true,
        format: DX_ACCOUNTING_FORMAT,
      };
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxDecimalConfig', DxDecimalConfig);

  /** @ngInject */
  function DxDecimalConfig() {
    return function () {
      return {
        options: {
          mode: 'text',
          showSpinButtons: true,
          onKeyPress: function (e) {
            var isDecimalChar = /(\+|-|\.|(\d|e))/.test(e.event.key);
            if (!isDecimalChar) {
              e.event.preventDefault()
            }
          },
          onPaste: function (e) {
            e.event.preventDefault();
            var pasteText = e.event.originalEvent.clipboardData.getData('text');
            this.option('value', pasteText.replace(/[^0-9.\-+]/g, ''));
          },
        },
        widgetName: 'dxTextBox',
      };
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxIntConfig', DxIntConfig);

  /** @ngInject */
  function DxIntConfig(DxNumberHelper) {
    return function () {
      const preventMouseWheelCb = DxNumberHelper.preventMouseWheel();

      return {
        options: {
          showSpinButtons: true,
          showClearButton: true,
          format: '#0',
          onValueChanged(e) {
            const eventType = _.get(e, 'event.type');
            if (eventType === 'dxmousewheel') {
              return preventMouseWheelCb(e);
            }
          },
        },
        widgetName: 'dxNumberBox',
      };
    }
  }
})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxNumberConfig', DxNumberConfig);

  /** @ngInject */
  function DxNumberConfig(DxNumberHelper) {
    return function () {
      return {
        options: {
          showSpinButtons: true,
          onValueChanged: DxNumberHelper.preventMouseWheel(),
        },
        widgetName: 'dxNumberBox',
      };
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxNumberHelper', DxNumberHelper);

  /** @ngInject */
  function DxNumberHelper() {
    return {
      preventMouseWheel,
    };

    function preventMouseWheel() {
      var suspendValueChanged;

      return function (e) {
        const eventType = _.get(e, 'event.type');
        if (eventType === 'dxmousewheel') {
          if (suspendValueChanged) {
            suspendValueChanged = false;
            return false;
          }

          suspendValueChanged = true;
          e.component.option('value', e.previousValue);
          return false;
        }
      }
    }
  }

})();
;;(function () {
  'use strict';

  angular
    .module('app.adpForms')
    .factory('DxPercentConfig', DxPercentConfig);

  /** @ngInject */
  function DxPercentConfig(DX_PERCENT_FORMAT, DxNumberHelper) {
    return function (args) {
      return {
        options: getOptions(args),
        widgetName: 'dxNumberBox',
      };
    }

    function getOptions(args) {
      const field = args.fieldSchema;
      const preventWheelCb = DxNumberHelper.preventMouseWheel();

      return {
        valueChangeEvent: 'blur keyup change',
        onValueChanged: function (e) {
          const shouldPrevent = preventWheelCb(e) !== undefined;
          if (shouldPrevent) {
            return false;
          }

          if (e.value === 0 && _.isNumber(e.previousValue)) {
            // update fired on next change event
            e.component.option('value', null);
          }
        },
        inputAttr: {
          'field-name-input': field.fieldName,
          id: field.fieldName,
        },
        showSpinButtons: true,
        step: 0.01,
        format: DX_PERCENT_FORMAT,
      };
    }
  }

})();
